(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888],{

/***/ 19985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yl": function() { return /* binding */ flush; },
  "S1": function() { return /* binding */ init; }
});

// UNUSED EXPORTS: close, defaultIntegrations, forceLoad, lastEventId, onLoad, showReportDialog, wrap

// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/scope.js
var esm_scope = __webpack_require__(46769);
// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/hub.js
var esm_hub = __webpack_require__(38641);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var esm_logger = __webpack_require__(12343);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integration.js



var installedIntegrations = [];

/** Map of integrations assigned to a client */

/**
 * @private
 */
function filterDuplicates(integrations) {
  return integrations.reduce((acc, integrations) => {
    if (acc.every(accIntegration => integrations.name !== accIntegration.name)) {
      acc.push(integrations);
    }
    return acc;
  }, [] );
}

/** Gets integration to install */
function getIntegrationsToSetup(options) {
  var defaultIntegrations = (options.defaultIntegrations && [...options.defaultIntegrations]) || [];
  var userIntegrations = options.integrations;

  let integrations = [...filterDuplicates(defaultIntegrations)];

  if (Array.isArray(userIntegrations)) {
    // Filter out integrations that are also included in user options
    integrations = [
      ...integrations.filter(integrations =>
        userIntegrations.every(userIntegration => userIntegration.name !== integrations.name),
      ),
      // And filter out duplicated user options integrations
      ...filterDuplicates(userIntegrations),
    ];
  } else if (typeof userIntegrations === 'function') {
    integrations = userIntegrations(integrations);
    integrations = Array.isArray(integrations) ? integrations : [integrations];
  }

  // Make sure that if present, `Debug` integration will always run last
  var integrationsNames = integrations.map(i => i.name);
  var alwaysLastToRun = 'Debug';
  if (integrationsNames.indexOf(alwaysLastToRun) !== -1) {
    integrations.push(...integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1));
  }

  return integrations;
}

/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(integrations) {
  var integrationIndex = {};

  integrations.forEach(integration => {
    integrationIndex[integration.name] = integration;

    if (installedIntegrations.indexOf(integration.name) === -1) {
      integration.setupOnce(esm_scope/* addGlobalEventProcessor */.c, esm_hub/* getCurrentHub */.Gd);
      installedIntegrations.push(integration.name);
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`Integration installed: ${integration.name}`);
    }
  });

  return integrationIndex;
}


//# sourceMappingURL=integration.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/sdk.js



/** A class object that can instantiate Client objects. */

/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */
function initAndBind(
  clientClass,
  options,
) {
  if (options.debug === true) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      esm_logger/* logger.enable */.kg.enable();
    } else {
      // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
  }
  var hub = (0,esm_hub/* getCurrentHub */.Gd)();
  var scope = hub.getScope();
  if (scope) {
    scope.update(options.initialScope);
  }

  var client = new clientClass(options);
  hub.bindClient(client);
}


//# sourceMappingURL=sdk.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(62844);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(57321);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/inboundfilters.js


// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];

/** Options for the InboundFilters integration */

/** Inbound filters configurable by the user */
class InboundFilters  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'InboundFilters';}

  /**
   * @inheritDoc
   */
   __init() {this.name = InboundFilters.id;}

   constructor(  _options = {}) {;this._options = _options;InboundFilters.prototype.__init.call(this);}

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    var eventProcess = (event) => {
      var hub = getCurrentHub();
      if (hub) {
        var self = hub.getIntegration(InboundFilters);
        if (self) {
          var client = hub.getClient();
          var clientOptions = client ? client.getOptions() : {};
          var options = _mergeOptions(self._options, clientOptions);
          return _shouldDropEvent(event, options) ? null : event;
        }
      }
      return event;
    };

    eventProcess.id = this.name;
    addGlobalEventProcessor(eventProcess);
  }
} InboundFilters.__initStatic();

/** JSDoc */
function _mergeOptions(
  internalOptions = {},
  clientOptions = {},
) {
  return {
    allowUrls: [...(internalOptions.allowUrls || []), ...(clientOptions.allowUrls || [])],
    denyUrls: [...(internalOptions.denyUrls || []), ...(clientOptions.denyUrls || [])],
    ignoreErrors: [
      ...(internalOptions.ignoreErrors || []),
      ...(clientOptions.ignoreErrors || []),
      ...DEFAULT_IGNORE_ERRORS,
    ],
    ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true,
  };
}

/** JSDoc */
function _shouldDropEvent(event, options) {
  if (options.ignoreInternal && _isSentryError(event)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`);
    return true;
  }
  if (_isIgnoredError(event, options.ignoreErrors)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`,
      );
    return true;
  }
  if (_isDeniedUrl(event, options.denyUrls)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  if (!_isAllowedUrl(event, options.allowUrls)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  return false;
}

function _isIgnoredError(event, ignoreErrors) {
  if (!ignoreErrors || !ignoreErrors.length) {
    return false;
  }

  return _getPossibleEventMessages(event).some(message =>
    ignoreErrors.some(pattern => (0,string/* isMatchingPattern */.zC)(message, pattern)),
  );
}

function _isDeniedUrl(event, denyUrls) {
  // TODO: Use Glob instead?
  if (!denyUrls || !denyUrls.length) {
    return false;
  }
  var url = _getEventFilterUrl(event);
  return !url ? false : denyUrls.some(pattern => (0,string/* isMatchingPattern */.zC)(url, pattern));
}

function _isAllowedUrl(event, allowUrls) {
  // TODO: Use Glob instead?
  if (!allowUrls || !allowUrls.length) {
    return true;
  }
  var url = _getEventFilterUrl(event);
  return !url ? true : allowUrls.some(pattern => (0,string/* isMatchingPattern */.zC)(url, pattern));
}

function _getPossibleEventMessages(event) {
  if (event.message) {
    return [event.message];
  }
  if (event.exception) {
    try {
      const { type = '', value = '' } = (event.exception.values && event.exception.values[0]) || {};
      return [`${value}`, `${type}: ${value}`];
    } catch (oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(`Cannot extract message for event ${(0,misc/* getEventDescription */.jH)(event)}`);
      return [];
    }
  }
  return [];
}

function _isSentryError(event) {
  try {
    // @ts-ignore can't be a sentry error if undefined
        return event.exception.values[0].type === 'SentryError';
  } catch (e) {
    // ignore
  }
  return false;
}

function _getLastValidUrl(frames = []) {
  for (let i = frames.length - 1; i >= 0; i--) {
    var frame = frames[i];

    if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') {
      return frame.filename || null;
    }
  }

  return null;
}

function _getEventFilterUrl(event) {
  try {
    let frames;
    try {
      // @ts-ignore we only care about frames if the whole thing here is defined
      frames = event.exception.values[0].stacktrace.frames;
    } catch (e) {
      // ignore
    }
    return frames ? _getLastValidUrl(frames) : null;
  } catch (oO) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(`Cannot extract url for event ${(0,misc/* getEventDescription */.jH)(event)}`);
    return null;
  }
}


//# sourceMappingURL=inboundfilters.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(20535);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/functiontostring.js


let originalFunctionToString;

/** Patch toString calls to return proper name for wrapped functions */
class FunctionToString  {constructor() { FunctionToString.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'FunctionToString';}

  /**
   * @inheritDoc
   */
   __init() {this.name = FunctionToString.id;}

  /**
   * @inheritDoc
   */
   setupOnce() {
        originalFunctionToString = Function.prototype.toString;

        Function.prototype.toString = function ( ...args) {
      var context = (0,object/* getOriginalFunction */.HK)(this) || this;
      return originalFunctionToString.apply(context, args);
    };
  }
} FunctionToString.__initStatic();


//# sourceMappingURL=functiontostring.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/global.js
var esm_global = __webpack_require__(82991);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/stacktrace.js
var stacktrace = __webpack_require__(30360);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/supports.js
var supports = __webpack_require__(8823);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(96893);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__(9732);
// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/session.js
var esm_session = __webpack_require__(95771);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/error.js
/** An error emitted by Sentry SDKs and related utilities. */
class SentryError extends Error {
  /** Display name of this error instance. */
  

   constructor( message) {
    super(message);this.message = message;;

    this.name = new.target.prototype.constructor.name;
    Object.setPrototypeOf(this, new.target.prototype);
  }
}


//# sourceMappingURL=error.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/dsn.js


/** Regular expression used to parse a Dsn. */
var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;

function isValidProtocol(protocol) {
  return protocol === 'http' || protocol === 'https';
}

/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */
function dsn_dsnToString(dsn, withPassword = false) {
  const { host, path, pass, port, projectId, protocol, publicKey } = dsn;
  return (
    `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` +
    `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`
  );
}

/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents
 */
function dsnFromString(str) {
  var match = DSN_REGEX.exec(str);

  if (!match) {
    throw new SentryError(`Invalid Sentry Dsn: ${str}`);
  }

  const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
  let path = '';
  let projectId = lastPath;

  var split = projectId.split('/');
  if (split.length > 1) {
    path = split.slice(0, -1).join('/');
    projectId = split.pop() ;
  }

  if (projectId) {
    var projectMatch = projectId.match(/^\d+/);
    if (projectMatch) {
      projectId = projectMatch[0];
    }
  }

  return dsnFromComponents({ host, pass, path, projectId, port, protocol: protocol , publicKey });
}

function dsnFromComponents(components) {
  return {
    protocol: components.protocol,
    publicKey: components.publicKey || '',
    pass: components.pass || '',
    host: components.host,
    port: components.port || '',
    path: components.path || '',
    projectId: components.projectId,
  };
}

function validateDsn(dsn) {
  if (!(typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    return;
  }

  const { port, projectId, protocol } = dsn;

  var requiredComponents = ['protocol', 'publicKey', 'host', 'projectId'];
  requiredComponents.forEach(component => {
    if (!dsn[component]) {
      throw new SentryError(`Invalid Sentry Dsn: ${component} missing`);
    }
  });

  if (!projectId.match(/^\d+$/)) {
    throw new SentryError(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
  }

  if (!isValidProtocol(protocol)) {
    throw new SentryError(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
  }

  if (port && isNaN(parseInt(port, 10))) {
    throw new SentryError(`Invalid Sentry Dsn: Invalid port ${port}`);
  }

  return true;
}

/** The Sentry Dsn, identifying a Sentry instance and project. */
function dsn_makeDsn(from) {
  var components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);
  validateDsn(components);
  return components;
}


//# sourceMappingURL=dsn.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(67597);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/envelope.js


/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function createEnvelope(headers, items = []) {
  return [headers, items] ;
}

/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function addItemToEnvelope(envelope, newItem) {
  const [headers, items] = envelope;
  return [headers, [...items, newItem]] ;
}

/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 */
function forEachEnvelopeItem(
  envelope,
  callback,
) {
  var envelopeItems = envelope[1];
  envelopeItems.forEach((envelopeItem) => {
    var envelopeItemType = envelopeItem[0].type;
    callback(envelopeItem, envelopeItemType);
  });
}

function encodeUTF8(input, textEncoder) {
  var utf8 = textEncoder || new TextEncoder();
  return utf8.encode(input);
}

/**
 * Serializes an envelope.
 */
function serializeEnvelope(envelope, textEncoder) {
  const [envHeaders, items] = envelope;

  // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
  let parts = JSON.stringify(envHeaders);

  function append(next) {
    if (typeof parts === 'string') {
      parts = typeof next === 'string' ? parts + next : [encodeUTF8(parts, textEncoder), next];
    } else {
      parts.push(typeof next === 'string' ? encodeUTF8(next, textEncoder) : next);
    }
  }

  for (var item of items) {
    const [itemHeaders, payload] = item ;
    append(`\n${JSON.stringify(itemHeaders)}\n`);
    append(typeof payload === 'string' || payload instanceof Uint8Array ? payload : JSON.stringify(payload));
  }

  return typeof parts === 'string' ? parts : concatBuffers(parts);
}

function concatBuffers(buffers) {
  var totalLength = buffers.reduce((acc, buf) => acc + buf.length, 0);

  var merged = new Uint8Array(totalLength);
  let offset = 0;
  for (var buffer of buffers) {
    merged.set(buffer, offset);
    offset += buffer.length;
  }

  return merged;
}

/**
 * Creates attachment envelope items
 */
function createAttachmentEnvelopeItem(
  attachment,
  textEncoder,
) {
  var buffer = typeof attachment.data === 'string' ? encodeUTF8(attachment.data, textEncoder) : attachment.data;

  return [
    (0,object/* dropUndefinedKeys */.Jr)({
      type: 'attachment',
      length: buffer.length,
      filename: attachment.filename,
      content_type: attachment.contentType,
      attachment_type: attachment.attachmentType,
    }),
    buffer,
  ];
}

var ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
  session: 'session',
  sessions: 'session',
  attachment: 'attachment',
  transaction: 'transaction',
  event: 'error',
  client_report: 'internal',
  user_report: 'default',
};

/**
 * Maps the type of an envelope item to a data category.
 */
function envelopeItemTypeToDataCategory(type) {
  return ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}


//# sourceMappingURL=envelope.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(21170);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/memo.js
/**
 * Helper to decycle json objects
 */
function memoBuilder() {
  var hasWeakSet = typeof WeakSet === 'function';
  var inner = hasWeakSet ? new WeakSet() : [];
  function memoize(obj) {
    if (hasWeakSet) {
      if (inner.has(obj)) {
        return true;
      }
      inner.add(obj);
      return false;
    }
        for (let i = 0; i < inner.length; i++) {
      var value = inner[i];
      if (value === obj) {
        return true;
      }
    }
    inner.push(obj);
    return false;
  }

  function unmemoize(obj) {
    if (hasWeakSet) {
      inner.delete(obj);
    } else {
      for (let i = 0; i < inner.length; i++) {
        if (inner[i] === obj) {
          inner.splice(i, 1);
          break;
        }
      }
    }
  }
  return [memoize, unmemoize];
}


//# sourceMappingURL=memo.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/normalize.js





/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output..
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */
function normalize(input, depth = +Infinity, maxProperties = +Infinity) {
  try {
    // since we're at the outermost level, we don't provide a key
    return visit('', input, depth, maxProperties);
  } catch (err) {
    return { ERROR: `**non-serializable** (${err})` };
  }
}

/** JSDoc */
function normalizeToSize(
    object,
  // Default Node.js REPL depth
  depth = 3,
  // 100kB, as 200kB is max payload size, so half sounds reasonable
  maxSize = 100 * 1024,
) {
  var normalized = normalize(object, depth);

  if (jsonSize(normalized) > maxSize) {
    return normalizeToSize(object, depth - 1, maxSize);
  }

  return normalized ;
}

/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */
function visit(
  key,
  value,
  depth = +Infinity,
  maxProperties = +Infinity,
  memo = memoBuilder(),
) {
  const [memoize, unmemoize] = memo;

  // Get the simple cases out of the way first
  if (value === null || (['number', 'boolean', 'string'].includes(typeof value) && !(0,is/* isNaN */.i2)(value))) {
    return value ;
  }

  var stringified = stringifyValue(key, value);

  // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
  // Everything else will have already been serialized, so if we don't see that pattern, we're done.
  if (!stringified.startsWith('[object ')) {
    return stringified;
  }

  // From here on, we can assert that `value` is either an object or an array.

  // Do not normalize objects that we know have already been normalized. As a general rule, the
  // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
  // have already been normalized.
  if ((value )['__sentry_skip_normalization__']) {
    return value ;
  }

  // We're also done if we've reached the max depth
  if (depth === 0) {
    // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
  }

  // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
  if (memoize(value)) {
    return '[Circular ~]';
  }

  // If the value has a `toJSON` method, we call it to extract more information
  var valueWithToJSON = value ;
  if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') {
    try {
      var jsonValue = valueWithToJSON.toJSON();
      // We need to normalize the return value of `.toJSON()` in case it has circular references
      return visit('', jsonValue, depth - 1, maxProperties, memo);
    } catch (err) {
      // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
  }

  // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
  // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
  // property/entry, and keep track of the number of items we add to it.
  var normalized = (Array.isArray(value) ? [] : {}) ;
  let numAdded = 0;

  // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
  // properties are non-enumerable and otherwise would get missed.
  var visitable = (0,object/* convertToPlainObject */.Sh)(value );

  for (var visitKey in visitable) {
    // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
    if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
      continue;
    }

    if (numAdded >= maxProperties) {
      normalized[visitKey] = '[MaxProperties ~]';
      break;
    }

    // Recursively visit all the child nodes
    var visitValue = visitable[visitKey];
    normalized[visitKey] = visit(visitKey, visitValue, depth - 1, maxProperties, memo);

    numAdded += 1;
  }

  // Once we've visited all the branches, remove the parent from memo storage
  unmemoize(value);

  // Return accumulated values
  return normalized;
}

/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */
function stringifyValue(
  key,
  // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
  // our internal use, it'll do
  value,
) {
  try {
    if (key === 'domain' && value && typeof value === 'object' && (value )._events) {
      return '[Domain]';
    }

    if (key === 'domainEmitter') {
      return '[DomainEmitter]';
    }

    // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
    // which won't throw if they are not present.

    if (typeof __webpack_require__.g !== 'undefined' && value === __webpack_require__.g) {
      return '[Global]';
    }

        if (typeof window !== 'undefined' && value === window) {
      return '[Window]';
    }

        if (typeof document !== 'undefined' && value === document) {
      return '[Document]';
    }

    // React's SyntheticEvent thingy
    if ((0,is/* isSyntheticEvent */.Cy)(value)) {
      return '[SyntheticEvent]';
    }

    if (typeof value === 'number' && value !== value) {
      return '[NaN]';
    }

    // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
    if (value === void 0) {
      return '[undefined]';
    }

    if (typeof value === 'function') {
      return `[Function: ${(0,stacktrace/* getFunctionName */.$P)(value)}]`;
    }

    if (typeof value === 'symbol') {
      return `[${String(value)}]`;
    }

    // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
    if (typeof value === 'bigint') {
      return `[BigInt: ${String(value)}]`;
    }

    // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
    // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
    // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
    // we can make sure that only plain objects come out that way.
    return `[object ${(Object.getPrototypeOf(value) ).constructor.name}]`;
  } catch (err) {
    return `**non-serializable** (${err})`;
  }
}

/** Calculates bytes size of input string */
function utf8Length(value) {
    return ~-encodeURI(value).split(/%..|./).length;
}

/** Calculates bytes size of input object */
function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}


//# sourceMappingURL=normalize.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/api.js


var SENTRY_API_VERSION = '7';

/** Returns the prefix to construct Sentry ingestion API endpoints. */
function getBaseApiEndpoint(dsn) {
  var protocol = dsn.protocol ? `${dsn.protocol}:` : '';
  var port = dsn.port ? `:${dsn.port}` : '';
  return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}

/** Returns the ingest API endpoint for target. */
function _getIngestEndpoint(dsn) {
  return `${getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}

/** Returns a URL-encoded string with auth config suitable for a query string. */
function _encodedAuth(dsn, sdkInfo) {
  return (0,object/* urlEncode */._j)({
    // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    sentry_key: dsn.publicKey,
    sentry_version: SENTRY_API_VERSION,
    ...(sdkInfo && { sentry_client: `${sdkInfo.name}/${sdkInfo.version}` }),
  });
}

/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */
function getEnvelopeEndpointWithUrlEncodedAuth(
  dsn,
  // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
  // options: ClientOptions = {} as ClientOptions,
  tunnelOrOptions = {} ,
) {
  // TODO (v8): Use this code instead
  // const { tunnel, _metadata = {} } = options;
  // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;

  var tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
  var sdkInfo =
    typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;

  return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, sdkInfo)}`;
}

/** Returns the url to the report dialog endpoint. */
function api_getReportDialogEndpoint(
  dsnLike,
  dialogOptions

,
) {
  var dsn = makeDsn(dsnLike);
  var endpoint = `${getBaseApiEndpoint(dsn)}embed/error-page/`;

  let encodedOptions = `dsn=${dsnToString(dsn)}`;
  for (var key in dialogOptions) {
    if (key === 'dsn') {
      continue;
    }

    if (key === 'user') {
      var user = dialogOptions.user;
      if (!user) {
        continue;
      }
      if (user.name) {
        encodedOptions += `&name=${encodeURIComponent(user.name)}`;
      }
      if (user.email) {
        encodedOptions += `&email=${encodeURIComponent(user.email)}`;
      }
    } else {
      encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key] )}`;
    }
  }

  return `${endpoint}?${encodedOptions}`;
}


//# sourceMappingURL=api.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/baggage.js
var esm_baggage = __webpack_require__(99181);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/envelope.js


/** Extract sdk info from from the API metadata */
function getSdkMetadataForEnvelopeHeader(metadata) {
  if (!metadata || !metadata.sdk) {
    return;
  }
  const { name, version } = metadata.sdk;
  return { name, version };
}

/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/
function enhanceEventWithSdkInfo(event, sdkInfo) {
  if (!sdkInfo) {
    return event;
  }
  event.sdk = event.sdk || {};
  event.sdk.name = event.sdk.name || sdkInfo.name;
  event.sdk.version = event.sdk.version || sdkInfo.version;
  event.sdk.integrations = [...(event.sdk.integrations || []), ...(sdkInfo.integrations || [])];
  event.sdk.packages = [...(event.sdk.packages || []), ...(sdkInfo.packages || [])];
  return event;
}

/** Creates an envelope from a Session */
function createSessionEnvelope(
  session,
  dsn,
  metadata,
  tunnel,
) {
  var sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);
  var envelopeHeaders = {
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && { dsn: dsn_dsnToString(dsn) }),
  };

  var envelopeItem =
    'aggregates' in session ? [{ type: 'sessions' }, session] : [{ type: 'session' }, session];

  return createEnvelope(envelopeHeaders, [envelopeItem]);
}

/**
 * Create an Envelope from an event.
 */
function createEventEnvelope(
  event,
  dsn,
  metadata,
  tunnel,
) {
  var sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);
  var eventType = event.type || 'event';

  const { transactionSampling } = event.sdkProcessingMetadata || {};
  const { method: samplingMethod, rate: sampleRate } = transactionSampling || {};

  enhanceEventWithSdkInfo(event, metadata && metadata.sdk);

  var envelopeHeaders = createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);

  // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
  // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
  // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
  // of this `delete`, lest we miss putting it back in the next time the property is in use.)
  delete event.sdkProcessingMetadata;

  var eventItem = [
    {
      type: eventType,
      sample_rates: [{ id: samplingMethod, rate: sampleRate }],
    },
    event,
  ];
  return createEnvelope(envelopeHeaders, [eventItem]);
}

function createEventEnvelopeHeaders(
  event,
  sdkInfo,
  tunnel,
  dsn,
) {
  var baggage = event.sdkProcessingMetadata && event.sdkProcessingMetadata.baggage;
  var dynamicSamplingContext = baggage && (0,esm_baggage/* getSentryBaggageItems */.Hk)(baggage);

  return {
    event_id: event.event_id ,
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && { dsn: dsn_dsnToString(dsn) }),
    ...(event.type === 'transaction' &&
      dynamicSamplingContext && {
        trace: (0,object/* dropUndefinedKeys */.Jr)({ ...dynamicSamplingContext }) ,
      }),
  };
}


//# sourceMappingURL=envelope.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/baseclient.js






var ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";

/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */
class BaseClient {
  /** Options passed to the SDK. */
  

  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */
  

  /** Array of set up integrations. */
   __init() {this._integrations = {};}

  /** Indicates whether this client's integrations have been set up. */
   __init2() {this._integrationsInitialized = false;}

  /** Number of calls being processed */
   __init3() {this._numProcessing = 0;}

  /** Holds flushable  */
   __init4() {this._outcomes = {};}

  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
   constructor(options) {;BaseClient.prototype.__init.call(this);BaseClient.prototype.__init2.call(this);BaseClient.prototype.__init3.call(this);BaseClient.prototype.__init4.call(this);
    this._options = options;
    if (options.dsn) {
      this._dsn = dsn_makeDsn(options.dsn);
      var url = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options);
      this._transport = options.transport({
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...options.transportOptions,
        url,
      });
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('No DSN provided, client will not do anything.');
    }
  }

  /**
   * @inheritDoc
   */
     captureException(exception, hint, scope) {
    // ensure we haven't captured this very object before
    if ((0,misc/* checkOrSetAlreadyCaught */.YO)(exception)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    this._process(
      this.eventFromException(exception, hint)
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
        level,
    hint,
    scope,
  ) {
    let eventId = hint && hint.event_id;

    var promisedEvent = (0,is/* isPrimitive */.pt)(message)
      ? this.eventFromMessage(String(message), level, hint)
      : this.eventFromException(message, hint);

    this._process(
      promisedEvent
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint, scope) {
    // ensure we haven't captured this very object before
    if (hint && hint.originalException && (0,misc/* checkOrSetAlreadyCaught */.YO)(hint.originalException)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    this._process(
      this._captureEvent(event, hint, scope).then(result => {
        eventId = result;
      }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureSession(session) {
    if (!this._isEnabled()) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('SDK not enabled, will not capture session.');
      return;
    }

    if (!(typeof session.release === 'string')) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Discarded session because of missing or non-string release');
    } else {
      this.sendSession(session);
      // After sending, we set init false to indicate it's not the first occurrence
      (0,esm_session/* updateSession */.CT)(session, { init: false });
    }
  }

  /**
   * @inheritDoc
   */
   getDsn() {
    return this._dsn;
  }

  /**
   * @inheritDoc
   */
   getOptions() {
    return this._options;
  }

  /**
   * @inheritDoc
   */
   getTransport() {
    return this._transport;
  }

  /**
   * @inheritDoc
   */
   flush(timeout) {
    var transport = this._transport;
    if (transport) {
      return this._isClientDoneProcessing(timeout).then(clientFinished => {
        return transport.flush(timeout).then(transportFlushed => clientFinished && transportFlushed);
      });
    } else {
      return (0,syncpromise/* resolvedSyncPromise */.WD)(true);
    }
  }

  /**
   * @inheritDoc
   */
   close(timeout) {
    return this.flush(timeout).then(result => {
      this.getOptions().enabled = false;
      return result;
    });
  }

  /**
   * Sets up the integrations
   */
   setupIntegrations() {
    if (this._isEnabled() && !this._integrationsInitialized) {
      this._integrations = setupIntegrations(this._options.integrations);
      this._integrationsInitialized = true;
    }
  }

  /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   */
   getIntegrationById(integrationId) {
    return this._integrations[integrationId];
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    try {
      return (this._integrations[integration.id] ) || null;
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn(`Cannot retrieve integration ${integration.id} from the current Client`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   sendEvent(event, hint = {}) {
    if (this._dsn) {
      let env = createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);

      for (var attachment of hint.attachments || []) {
        env = addItemToEnvelope(
          env,
          createAttachmentEnvelopeItem(
            attachment,
            this._options.transportOptions && this._options.transportOptions.textEncoder,
          ),
        );
      }

      this._sendEnvelope(env);
    }
  }

  /**
   * @inheritDoc
   */
   sendSession(session) {
    if (this._dsn) {
      var env = createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);
      this._sendEnvelope(env);
    }
  }

  /**
   * @inheritDoc
   */
   recordDroppedEvent(reason, category) {
    if (this._options.sendClientReports) {
      // We want to track each category (error, transaction, session) separately
      // but still keep the distinction between different type of outcomes.
      // We could use nested maps, but it's much easier to read and type this way.
      // A correct type for map-based implementation if we want to go that route
      // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
      // With typescript 4.1 we could even use template literal types
      var key = `${reason}:${category}`;
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`Adding outcome: "${key}"`);

      // The following works because undefined + 1 === NaN and NaN is falsy
      this._outcomes[key] = this._outcomes[key] + 1 || 1;
    }
  }

  /** Updates existing session based on the provided event */
   _updateSessionFromEvent(session, event) {
    let crashed = false;
    let errored = false;
    var exceptions = event.exception && event.exception.values;

    if (exceptions) {
      errored = true;

      for (var ex of exceptions) {
        var mechanism = ex.mechanism;
        if (mechanism && mechanism.handled === false) {
          crashed = true;
          break;
        }
      }
    }

    // A session is updated and that session update is sent in only one of the two following scenarios:
    // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
    // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
    var sessionNonTerminal = session.status === 'ok';
    var shouldUpdateAndSend = (sessionNonTerminal && session.errors === 0) || (sessionNonTerminal && crashed);

    if (shouldUpdateAndSend) {
      (0,esm_session/* updateSession */.CT)(session, {
        ...(crashed && { status: 'crashed' }),
        errors: session.errors || Number(errored || crashed),
      });
      this.captureSession(session);
    }
  }

  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
   _isClientDoneProcessing(timeout) {
    return new syncpromise/* SyncPromise */.cW(resolve => {
      let ticked = 0;
      var tick = 1;

      var interval = setInterval(() => {
        if (this._numProcessing == 0) {
          clearInterval(interval);
          resolve(true);
        } else {
          ticked += tick;
          if (timeout && ticked >= timeout) {
            clearInterval(interval);
            resolve(false);
          }
        }
      }, tick);
    });
  }

  /** Determines whether this SDK is enabled and a valid Dsn is present. */
   _isEnabled() {
    return this.getOptions().enabled !== false && this._dsn !== undefined;
  }

  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */
   _prepareEvent(event, hint, scope) {
    const { normalizeDepth = 3, normalizeMaxBreadth = 1000 } = this.getOptions();
    var prepared = {
      ...event,
      event_id: event.event_id || hint.event_id || (0,misc/* uuid4 */.DM)(),
      timestamp: event.timestamp || (0,time/* dateTimestampInSeconds */.yW)(),
    };

    this._applyClientOptions(prepared);
    this._applyIntegrationsMetadata(prepared);

    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    let finalScope = scope;
    if (hint.captureContext) {
      finalScope = esm_scope/* Scope.clone */.s.clone(finalScope).update(hint.captureContext);
    }

    // We prepare the result here with a resolved Event.
    let result = (0,syncpromise/* resolvedSyncPromise */.WD)(prepared);

    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    if (finalScope) {
      // Collect attachments from the hint and scope
      var attachments = [...(hint.attachments || []), ...finalScope.getAttachments()];

      if (attachments.length) {
        hint.attachments = attachments;
      }

      // In case we have a hub we reassign it.
      result = finalScope.applyToEvent(prepared, hint);
    }

    return result.then(evt => {
      if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
        return this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
      }
      return evt;
    });
  }

  /**
   * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
   * Normalized keys:
   * - `breadcrumbs.data`
   * - `user`
   * - `contexts`
   * - `extra`
   * @param event Event
   * @returns Normalized event
   */
   _normalizeEvent(event, depth, maxBreadth) {
    if (!event) {
      return null;
    }

    var normalized = {
      ...event,
      ...(event.breadcrumbs && {
        breadcrumbs: event.breadcrumbs.map(b => ({
          ...b,
          ...(b.data && {
            data: normalize(b.data, depth, maxBreadth),
          }),
        })),
      }),
      ...(event.user && {
        user: normalize(event.user, depth, maxBreadth),
      }),
      ...(event.contexts && {
        contexts: normalize(event.contexts, depth, maxBreadth),
      }),
      ...(event.extra && {
        extra: normalize(event.extra, depth, maxBreadth),
      }),
    };

    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
      normalized.contexts.trace = event.contexts.trace;

      // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
      if (event.contexts.trace.data) {
        normalized.contexts.trace.data = normalize(event.contexts.trace.data, depth, maxBreadth);
      }
    }

    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) {
      normalized.spans = event.spans.map(span => {
        // We cannot use the spread operator here because `toJSON` on `span` is non-enumerable
        if (span.data) {
          span.data = normalize(span.data, depth, maxBreadth);
        }
        return span;
      });
    }

    return normalized;
  }

  /**
   *  Enhances event using the client configuration.
   *  It takes care of all "static" values like environment, release and `dist`,
   *  as well as truncating overly long values.
   * @param event event instance to be enhanced
   */
   _applyClientOptions(event) {
    var options = this.getOptions();
    const { environment, release, dist, maxValueLength = 250 } = options;

    if (!('environment' in event)) {
      event.environment = 'environment' in options ? environment : 'production';
    }

    if (event.release === undefined && release !== undefined) {
      event.release = release;
    }

    if (event.dist === undefined && dist !== undefined) {
      event.dist = dist;
    }

    if (event.message) {
      event.message = (0,string/* truncate */.$G)(event.message, maxValueLength);
    }

    var exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) {
      exception.value = (0,string/* truncate */.$G)(exception.value, maxValueLength);
    }

    var request = event.request;
    if (request && request.url) {
      request.url = (0,string/* truncate */.$G)(request.url, maxValueLength);
    }
  }

  /**
   * This function adds all used integrations to the SDK info in the event.
   * @param event The event that will be filled with all integrations.
   */
   _applyIntegrationsMetadata(event) {
    var integrationsArray = Object.keys(this._integrations);
    if (integrationsArray.length > 0) {
      event.sdk = event.sdk || {};
      event.sdk.integrations = [...(event.sdk.integrations || []), ...integrationsArray];
    }
  }

  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
   _captureEvent(event, hint = {}, scope) {
    return this._processEvent(event, hint, scope).then(
      finalEvent => {
        return finalEvent.event_id;
      },
      reason => {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn(reason);
        return undefined;
      },
    );
  }

  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
   _processEvent(event, hint, scope) {
    const { beforeSend, sampleRate } = this.getOptions();

    if (!this._isEnabled()) {
      return (0,syncpromise/* rejectedSyncPromise */.$2)(new SentryError('SDK not enabled, will not capture event.'));
    }

    var isTransaction = event.type === 'transaction';
    // 1.0 === 100% events are sent
    // 0.0 === 0% events are sent
    // Sampling for transaction happens somewhere else
    if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
      this.recordDroppedEvent('sample_rate', 'error');
      return (0,syncpromise/* rejectedSyncPromise */.$2)(
        new SentryError(
          `Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`,
        ),
      );
    }

    return this._prepareEvent(event, hint, scope)
      .then(prepared => {
        if (prepared === null) {
          this.recordDroppedEvent('event_processor', event.type || 'error');
          throw new SentryError('An event processor returned null, will not send event.');
        }

        var isInternalException = hint.data && (hint.data ).__sentry__ === true;
        if (isInternalException || isTransaction || !beforeSend) {
          return prepared;
        }

        var beforeSendResult = beforeSend(prepared, hint);
        return _ensureBeforeSendRv(beforeSendResult);
      })
      .then(processedEvent => {
        if (processedEvent === null) {
          this.recordDroppedEvent('before_send', event.type || 'error');
          throw new SentryError('`beforeSend` returned `null`, will not send event.');
        }

        var session = scope && scope.getSession();
        if (!isTransaction && session) {
          this._updateSessionFromEvent(session, processedEvent);
        }

        this.sendEvent(processedEvent, hint);
        return processedEvent;
      })
      .then(null, reason => {
        if (reason instanceof SentryError) {
          throw reason;
        }

        this.captureException(reason, {
          data: {
            __sentry__: true,
          },
          originalException: reason ,
        });
        throw new SentryError(
          `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`,
        );
      });
  }

  /**
   * Occupies the client with processing and event
   */
   _process(promise) {
    this._numProcessing += 1;
    void promise.then(
      value => {
        this._numProcessing -= 1;
        return value;
      },
      reason => {
        this._numProcessing -= 1;
        return reason;
      },
    );
  }

  /**
   * @inheritdoc
   */
   _sendEnvelope(envelope) {
    if (this._transport && this._dsn) {
      this._transport.send(envelope).then(null, reason => {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Error while sending event:', reason);
      });
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Transport disabled');
    }
  }

  /**
   * Clears outcomes on this client and returns them.
   */
   _clearOutcomes() {
    var outcomes = this._outcomes;
    this._outcomes = {};
    return Object.keys(outcomes).map(key => {
      const [reason, category] = key.split(':') ;
      return {
        reason,
        category,
        quantity: outcomes[key],
      };
    });
  }

  /**
   * @inheritDoc
   */
    

}

/**
 * Verifies that return value of configured `beforeSend` is of expected type.
 */
function _ensureBeforeSendRv(rv) {
  var nullErr = '`beforeSend` method has to return `null` or a valid event.';
  if ((0,is/* isThenable */.J8)(rv)) {
    return rv.then(
      event => {
        if (!((0,is/* isPlainObject */.PO)(event) || event === null)) {
          throw new SentryError(nullErr);
        }
        return event;
      },
      e => {
        throw new SentryError(`beforeSend rejected with ${e}`);
      },
    );
  } else if (!((0,is/* isPlainObject */.PO)(rv) || rv === null)) {
    throw new SentryError(nullErr);
  }
  return rv;
}


//# sourceMappingURL=baseclient.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/version.js
var version = __webpack_require__(40105);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/clientreport.js



/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */
function createClientReportEnvelope(
  discarded_events,
  dsn,
  timestamp,
) {
  var clientReportItem = [
    { type: 'client_report' },
    {
      timestamp: timestamp || (0,time/* dateTimestampInSeconds */.yW)(),
      discarded_events,
    },
  ];
  return createEnvelope(dsn ? { dsn } : {}, [clientReportItem]);
}


//# sourceMappingURL=clientreport.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/eventbuilder.js


/**
 * This function creates an exception from a JavaScript Error
 */
function exceptionFromError(stackParser, ex) {
  // Get the frames first since Opera can lose the stack if we touch anything else first
  var frames = parseStackFrames(stackParser, ex);

  var exception = {
    type: ex && ex.name,
    value: extractMessage(ex),
  };

  if (frames.length) {
    exception.stacktrace = { frames };
  }

  if (exception.type === undefined && exception.value === '') {
    exception.value = 'Unrecoverable error caught';
  }

  return exception;
}

/**
 * @hidden
 */
function eventFromPlainObject(
  stackParser,
  exception,
  syntheticException,
  isUnhandledRejection,
) {
  var event = {
    exception: {
      values: [
        {
          type: (0,is/* isEvent */.cO)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
          value: `Non-Error ${
            isUnhandledRejection ? 'promise rejection' : 'exception'
          } captured with keys: ${(0,object/* extractExceptionKeysForMessage */.zf)(exception)}`,
        },
      ],
    },
    extra: {
      __serialized__: normalizeToSize(exception),
    },
  };

  if (syntheticException) {
    var frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      // event.exception.values[0] has been set above
      (event.exception ).values[0].stacktrace = { frames };
    }
  }

  return event;
}

/**
 * @hidden
 */
function eventFromError(stackParser, ex) {
  return {
    exception: {
      values: [exceptionFromError(stackParser, ex)],
    },
  };
}

/** Parses stack frames from an error */
function parseStackFrames(
  stackParser,
  ex,
) {
  // Access and store the stacktrace property before doing ANYTHING
  // else to it because Opera is not very good at providing it
  // reliably in other circumstances.
  var stacktrace = ex.stacktrace || ex.stack || '';

  var popSize = getPopSize(ex);

  try {
    return stackParser(stacktrace, popSize);
  } catch (e) {
    // no-empty
  }

  return [];
}

// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var reactMinifiedRegexp = /Minified React error #\d+;/i;

function getPopSize(ex) {
  if (ex) {
    if (typeof ex.framesToPop === 'number') {
      return ex.framesToPop;
    }

    if (reactMinifiedRegexp.test(ex.message)) {
      return 1;
    }
  }

  return 0;
}

/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
function extractMessage(ex) {
  var message = ex && ex.message;
  if (!message) {
    return 'No error message';
  }
  if (message.error && typeof message.error.message === 'string') {
    return message.error.message;
  }
  return message;
}

/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */
function eventFromException(
  stackParser,
  exception,
  hint,
  attachStacktrace,
) {
  var syntheticException = (hint && hint.syntheticException) || undefined;
  var event = eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace);
  (0,misc/* addExceptionMechanism */.EG)(event); // defaults to { type: 'generic', handled: true }
  event.level = 'error';
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}

/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(
  stackParser,
  message,
    level = 'info',
  hint,
  attachStacktrace,
) {
  var syntheticException = (hint && hint.syntheticException) || undefined;
  var event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
  event.level = level;
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}

/**
 * @hidden
 */
function eventFromUnknownInput(
  stackParser,
  exception,
  syntheticException,
  attachStacktrace,
  isUnhandledRejection,
) {
  let event;

  if ((0,is/* isErrorEvent */.VW)(exception ) && (exception ).error) {
    // If it is an ErrorEvent with `error` property, extract it to get actual Error
    var errorEvent = exception ;
    return eventFromError(stackParser, errorEvent.error );
  }

  // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
  // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
  // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
  //
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
  // https://webidl.spec.whatwg.org/#es-DOMException-specialness
  if ((0,is/* isDOMError */.TX)(exception ) || (0,is/* isDOMException */.fm)(exception )) {
    var domException = exception ;

    if ('stack' in (exception )) {
      event = eventFromError(stackParser, exception );
    } else {
      var name = domException.name || ((0,is/* isDOMError */.TX)(domException) ? 'DOMError' : 'DOMException');
      var message = domException.message ? `${name}: ${domException.message}` : name;
      event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
      (0,misc/* addExceptionTypeValue */.Db)(event, message);
    }
    if ('code' in domException) {
      event.tags = { ...event.tags, 'DOMException.code': `${domException.code}` };
    }

    return event;
  }
  if ((0,is/* isError */.VZ)(exception)) {
    // we have a real Error object, do nothing
    return eventFromError(stackParser, exception);
  }
  if ((0,is/* isPlainObject */.PO)(exception) || (0,is/* isEvent */.cO)(exception)) {
    // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
    // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
    // group on any key/value change.
    var objectException = exception ;
    event = eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
    (0,misc/* addExceptionMechanism */.EG)(event, {
      synthetic: true,
    });
    return event;
  }

  // If none of previous checks were valid, then it means that it's not:
  // - an instance of DOMError
  // - an instance of DOMException
  // - an instance of Event
  // - an instance of Error
  // - a valid ErrorEvent (one with an error property)
  // - a plain Object
  //
  // So bail out and capture it as a simple message:
  event = eventFromString(stackParser, exception , syntheticException, attachStacktrace);
  (0,misc/* addExceptionTypeValue */.Db)(event, `${exception}`, undefined);
  (0,misc/* addExceptionMechanism */.EG)(event, {
    synthetic: true,
  });

  return event;
}

/**
 * @hidden
 */
function eventFromString(
  stackParser,
  input,
  syntheticException,
  attachStacktrace,
) {
  var event = {
    message: input,
  };

  if (attachStacktrace && syntheticException) {
    var frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      event.exception = {
        values: [{ value: input, stacktrace: { frames } }],
      };
    }
  }

  return event;
}


//# sourceMappingURL=eventbuilder.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(58464);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/severity.js
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.

var validSeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug'];

/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */
function severityFromString(level) {
  return severityLevelFromString(level) ;
}

/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */
function severityLevelFromString(level) {
  return (level === 'warn' ? 'warning' : validSeverityLevels.includes(level) ? level : 'log') ;
}


//# sourceMappingURL=severity.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/breadcrumbs.js



/** JSDoc */

var BREADCRUMB_INTEGRATION_ID = 'Breadcrumbs';

/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */
class Breadcrumbs  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = BREADCRUMB_INTEGRATION_ID;}

  /**
   * @inheritDoc
   */
   __init() {this.name = Breadcrumbs.id;}

  /**
   * Options of the breadcrumbs integration.
   */
  // This field is public, because we use it in the browser client to check if the `sentry` option is enabled.
  

  /**
   * @inheritDoc
   */
   constructor(options) {;Breadcrumbs.prototype.__init.call(this);
    this.options = {
      console: true,
      dom: true,
      fetch: true,
      history: true,
      sentry: true,
      xhr: true,
      ...options,
    };
  }

  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - Console API
   *  - DOM API (click/typing)
   *  - XMLHttpRequest API
   *  - Fetch API
   *  - History API
   */
   setupOnce() {
    if (this.options.console) {
      (0,instrument/* addInstrumentationHandler */.o)('console', _consoleBreadcrumb);
    }
    if (this.options.dom) {
      (0,instrument/* addInstrumentationHandler */.o)('dom', _domBreadcrumb(this.options.dom));
    }
    if (this.options.xhr) {
      (0,instrument/* addInstrumentationHandler */.o)('xhr', _xhrBreadcrumb);
    }
    if (this.options.fetch) {
      (0,instrument/* addInstrumentationHandler */.o)('fetch', _fetchBreadcrumb);
    }
    if (this.options.history) {
      (0,instrument/* addInstrumentationHandler */.o)('history', _historyBreadcrumb);
    }
  }
} Breadcrumbs.__initStatic();

/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */
function _domBreadcrumb(dom) {
    function _innerDomBreadcrumb(handlerData) {
    let target;
    let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;

    if (typeof keyAttrs === 'string') {
      keyAttrs = [keyAttrs];
    }

    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
      target = handlerData.event.target
        ? (0,browser/* htmlTreeAsString */.R)(handlerData.event.target , keyAttrs)
        : (0,browser/* htmlTreeAsString */.R)(handlerData.event , keyAttrs);
    } catch (e) {
      target = '<unknown>';
    }

    if (target.length === 0) {
      return;
    }

    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: `ui.${handlerData.name}`,
        message: target,
      },
      {
        event: handlerData.event,
        name: handlerData.name,
        global: handlerData.global,
      },
    );
  }

  return _innerDomBreadcrumb;
}

/**
 * Creates breadcrumbs from console API calls
 */
function _consoleBreadcrumb(handlerData) {
  var breadcrumb = {
    category: 'console',
    data: {
      arguments: handlerData.args,
      logger: 'console',
    },
    level: severityLevelFromString(handlerData.level),
    message: (0,string/* safeJoin */.nK)(handlerData.args, ' '),
  };

  if (handlerData.level === 'assert') {
    if (handlerData.args[0] === false) {
      breadcrumb.message = `Assertion failed: ${(0,string/* safeJoin */.nK)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
      breadcrumb.data.arguments = handlerData.args.slice(1);
    } else {
      // Don't capture a breadcrumb for passed assertions
      return;
    }
  }

  (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(breadcrumb, {
    input: handlerData.args,
    level: handlerData.level,
  });
}

/**
 * Creates breadcrumbs from XHR API calls
 */
function _xhrBreadcrumb(handlerData) {
  if (handlerData.endTimestamp) {
    // We only capture complete, non-sentry requests
    if (handlerData.xhr.__sentry_own_request__) {
      return;
    }

    const { method, url, status_code, body } = handlerData.xhr.__sentry_xhr__ || {};

    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: 'xhr',
        data: {
          method,
          url,
          status_code,
        },
        type: 'http',
      },
      {
        xhr: handlerData.xhr,
        input: body,
      },
    );

    return;
  }
}

/**
 * Creates breadcrumbs from fetch API calls
 */
function _fetchBreadcrumb(handlerData) {
  // We only capture complete fetch requests
  if (!handlerData.endTimestamp) {
    return;
  }

  if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
    // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
  }

  if (handlerData.error) {
    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: 'fetch',
        data: handlerData.fetchData,
        level: 'error',
        type: 'http',
      },
      {
        data: handlerData.error,
        input: handlerData.args,
      },
    );
  } else {
    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: 'fetch',
        data: {
          ...handlerData.fetchData,
          status_code: handlerData.response.status,
        },
        type: 'http',
      },
      {
        input: handlerData.args,
        response: handlerData.response,
      },
    );
  }
}

/**
 * Creates breadcrumbs from history API calls
 */
function _historyBreadcrumb(handlerData) {
  var global = (0,esm_global/* getGlobalObject */.R)();
  let from = handlerData.from;
  let to = handlerData.to;
  var parsedLoc = (0,misc/* parseUrl */.en)(global.location.href);
  let parsedFrom = (0,misc/* parseUrl */.en)(from);
  var parsedTo = (0,misc/* parseUrl */.en)(to);

  // Initial pushState doesn't provide `from` information
  if (!parsedFrom.path) {
    parsedFrom = parsedLoc;
  }

  // Use only the path component of the URL if the URL matches the current
  // document (almost all the time when using pushState)
  if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
    to = parsedTo.relative;
  }
  if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
    from = parsedFrom.relative;
  }

  (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb({
    category: 'navigation',
    data: {
      from,
      to,
    },
  });
}


//# sourceMappingURL=breadcrumbs.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/utils.js


var global = (0,esm_global/* getGlobalObject */.R)();
let cachedFetchImpl;

/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * var f = window.fetch;
 * window.fetch = function () {
 *   var p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */
function getNativeFetchImplementation() {
  if (cachedFetchImpl) {
    return cachedFetchImpl;
  }

  // Fast path to avoid DOM I/O
  if ((0,supports/* isNativeFetch */.Du)(global.fetch)) {
    return (cachedFetchImpl = global.fetch.bind(global));
  }

  var document = global.document;
  let fetchImpl = global.fetch;
    if (document && typeof document.createElement === 'function') {
    try {
      var sandbox = document.createElement('iframe');
      sandbox.hidden = true;
      document.head.appendChild(sandbox);
      var contentWindow = sandbox.contentWindow;
      if (contentWindow && contentWindow.fetch) {
        fetchImpl = contentWindow.fetch;
      }
      document.head.removeChild(sandbox);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
  }

  return (cachedFetchImpl = fetchImpl.bind(global));
  }

/**
 * Sends sdk client report using sendBeacon or fetch as a fallback if available
 *
 * @param url report endpoint
 * @param body report payload
 */
function sendReport(url, body) {
  var isRealNavigator = Object.prototype.toString.call(global && global.navigator) === '[object Navigator]';
  var hasSendBeacon = isRealNavigator && typeof global.navigator.sendBeacon === 'function';

  if (hasSendBeacon) {
    // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
    var sendBeacon = global.navigator.sendBeacon.bind(global.navigator);
    sendBeacon(url, body);
  } else if ((0,supports/* supportsFetch */.Ak)()) {
    var fetch = getNativeFetchImplementation();
    fetch(url, {
      body,
      method: 'POST',
      credentials: 'omit',
      keepalive: true,
    }).then(null, error => {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(error);
    });
  }
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/client.js






var globalObject = (0,esm_global/* getGlobalObject */.R)();

/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
class BrowserClient extends BaseClient {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
   constructor(options) {
    options._metadata = options._metadata || {};
    options._metadata.sdk = options._metadata.sdk || {
      name: 'sentry.javascript.browser',
      packages: [
        {
          name: 'npm:@sentry/browser',
          version: version/* SDK_VERSION */.J,
        },
      ],
      version: version/* SDK_VERSION */.J,
    };

    super(options);

    if (options.sendClientReports && globalObject.document) {
      globalObject.document.addEventListener('visibilitychange', () => {
        if (globalObject.document.visibilityState === 'hidden') {
          this._flushOutcomes();
        }
      });
    }
  }

  /**
   * @inheritDoc
   */
   eventFromException(exception, hint) {
    return eventFromException(this._options.stackParser, exception, hint, this._options.attachStacktrace);
  }

  /**
   * @inheritDoc
   */
   eventFromMessage(
    message,
        level = 'info',
    hint,
  ) {
    return eventFromMessage(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
  }

  /**
   * @inheritDoc
   */
   sendEvent(event, hint) {
    // We only want to add the sentry event breadcrumb when the user has the breadcrumb integration installed and
    // activated its `sentry` option.
    // We also do not want to use the `Breadcrumbs` class here directly, because we do not want it to be included in
    // bundles, if it is not used by the SDK.
    // This all sadly is a bit ugly, but we currently don't have a "pre-send" hook on the integrations so we do it this
    // way for now.
    var breadcrumbIntegration = this.getIntegrationById(BREADCRUMB_INTEGRATION_ID) ;
    if (
      breadcrumbIntegration &&
      // We check for definedness of `options`, even though it is not strictly necessary, because that access to
      // `.sentry` below does not throw, in case users provided their own integration with id "Breadcrumbs" that does
      // not have an`options` field
      breadcrumbIntegration.options &&
      breadcrumbIntegration.options.sentry
    ) {
      (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
        {
          category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
          event_id: event.event_id,
          level: event.level,
          message: (0,misc/* getEventDescription */.jH)(event),
        },
        {
          event,
        },
      );
    }

    super.sendEvent(event, hint);
  }

  /**
   * @inheritDoc
   */
   _prepareEvent(event, hint, scope) {
    event.platform = event.platform || 'javascript';
    return super._prepareEvent(event, hint, scope);
  }

  /**
   * Sends client reports as an envelope.
   */
   _flushOutcomes() {
    var outcomes = this._clearOutcomes();

    if (outcomes.length === 0) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('No outcomes to send');
      return;
    }

    if (!this._dsn) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('No dsn provided, will not send outcomes');
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('Sending outcomes:', outcomes);

    var url = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, this._options);
    var envelope = createClientReportEnvelope(outcomes, this._options.tunnel && dsn_dsnToString(this._dsn));

    try {
      sendReport(url, serializeEnvelope(envelope));
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(e);
    }
  }
}


//# sourceMappingURL=client.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/stack-parsers.js


// global reference to slice
var UNKNOWN_FUNCTION = '?';

var OPERA10_PRIORITY = 10;
var OPERA11_PRIORITY = 20;
var CHROME_PRIORITY = 30;
var WINJS_PRIORITY = 40;
var GECKO_PRIORITY = 50;

function createFrame(filename, func, lineno, colno) {
  var frame = {
    filename,
    function: func,
    // All browser frames are considered in_app
    in_app: true,
  };

  if (lineno !== undefined) {
    frame.lineno = lineno;
  }

  if (colno !== undefined) {
    frame.colno = colno;
  }

  return frame;
}

// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var chromeRegex =
  /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;

var chrome = line => {
  var parts = chromeRegex.exec(line);

  if (parts) {
    var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line

    if (isEval) {
      var subMatch = chromeEvalRegex.exec(parts[2]);

      if (subMatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = subMatch[1]; // url
        parts[3] = subMatch[2]; // line
        parts[4] = subMatch[3]; // column
      }
    }

    // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
    // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
    const [func, filename] = extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]);

    return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
  }

  return;
};

var chromeStackLineParser = [CHROME_PRIORITY, chrome];

// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var geckoREgex =
  /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;

var gecko = line => {
  var parts = geckoREgex.exec(line);

  if (parts) {
    var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    if (isEval) {
      var subMatch = geckoEvalRegex.exec(parts[3]);

      if (subMatch) {
        // throw out eval line/column and use top-most line number
        parts[1] = parts[1] || 'eval';
        parts[3] = subMatch[1];
        parts[4] = subMatch[2];
        parts[5] = ''; // no column when eval
      }
    }

    let filename = parts[3];
    let func = parts[1] || UNKNOWN_FUNCTION;
    [func, filename] = extractSafariExtensionDetails(func, filename);

    return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
  }

  return;
};

var geckoStackLineParser = [GECKO_PRIORITY, gecko];

var winjsRegex =
  /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;

var winjs = line => {
  var parts = winjsRegex.exec(line);

  return parts
    ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined)
    : undefined;
};

var winjsStackLineParser = [WINJS_PRIORITY, winjs];

var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;

var opera10 = line => {
  var parts = opera10Regex.exec(line);
  return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
};

var opera10StackLineParser = [OPERA10_PRIORITY, opera10];

var opera11Regex =
  / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;

var opera11 = line => {
  var parts = opera11Regex.exec(line);
  return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};

var opera11StackLineParser = [OPERA11_PRIORITY, opera11];

var defaultStackLineParsers = [chromeStackLineParser, geckoStackLineParser, winjsStackLineParser];

var defaultStackParser = (0,stacktrace/* createStackParser */.pE)(...defaultStackLineParsers);

/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */
var extractSafariExtensionDetails = (func, filename) => {
  var isSafariExtension = func.indexOf('safari-extension') !== -1;
  var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;

  return isSafariExtension || isSafariWebExtension
    ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`,
      ]
    : [func, filename];
};


//# sourceMappingURL=stack-parsers.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/exports.js
var esm_exports = __webpack_require__(92876);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/helpers.js



let ignoreOnError = 0;

/**
 * @hidden
 */
function shouldIgnoreOnError() {
  return ignoreOnError > 0;
}

/**
 * @hidden
 */
function ignoreNextOnError() {
  // onerror should trigger before setTimeout
  ignoreOnError += 1;
  setTimeout(() => {
    ignoreOnError -= 1;
  });
}

/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(
  fn,
  options

 = {},
  before,
  ) {
  // for future readers what this does is wrap a function and then create
  // a bi-directional wrapping between them.
  //
  // example: wrapped = wrap(original);
  //  original.__sentry_wrapped__ -> wrapped
  //  wrapped.__sentry_original__ -> original

  if (typeof fn !== 'function') {
    return fn;
  }

  try {
    // if we're dealing with a function that was previously wrapped, return
    // the original wrapper.
    var wrapper = fn.__sentry_wrapped__;
    if (wrapper) {
      return wrapper;
    }

    // We don't wanna wrap it twice
    if ((0,object/* getOriginalFunction */.HK)(fn)) {
      return fn;
    }
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    // Bail on wrapping and return the function as-is (defers to window.onerror).
    return fn;
  }

    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
  var sentryWrapped = function () {
    var args = Array.prototype.slice.call(arguments);

    try {
      if (before && typeof before === 'function') {
        before.apply(this, arguments);
      }

            var wrappedArguments = args.map((arg) => wrap(arg, options));

      // Attempt to invoke user-land function
      // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
      //       means the sentry.javascript SDK caught an error invoking your application code. This
      //       is expected behavior and NOT indicative of a bug with sentry.javascript.
      return fn.apply(this, wrappedArguments);
    } catch (ex) {
      ignoreNextOnError();

      (0,esm_exports/* withScope */.$e)((scope) => {
        scope.addEventProcessor((event) => {
          if (options.mechanism) {
            (0,misc/* addExceptionTypeValue */.Db)(event, undefined, undefined);
            (0,misc/* addExceptionMechanism */.EG)(event, options.mechanism);
          }

          event.extra = {
            ...event.extra,
            arguments: args,
          };

          return event;
        });

        (0,esm_exports/* captureException */.Tb)(ex);
      });

      throw ex;
    }
  };
  
  // Accessing some objects may throw
  // ref: https://github.com/getsentry/sentry-javascript/issues/1168
  try {
    for (var property in fn) {
      if (Object.prototype.hasOwnProperty.call(fn, property)) {
        sentryWrapped[property] = fn[property];
      }
    }
  } catch (_oO) {} 
  // Signal that this function has been wrapped/filled already
  // for both debugging and to prevent it to being wrapped/filled twice
  (0,object/* markFunctionWrapped */.$Q)(sentryWrapped, fn);

  (0,object/* addNonEnumerableProperty */.xp)(fn, '__sentry_wrapped__', sentryWrapped);

  // Restore original function name (not all browsers allow that)
  try {
    var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name') ;
    if (descriptor.configurable) {
      Object.defineProperty(sentryWrapped, 'name', {
        get() {
          return fn.name;
        },
      });
    }
      } catch (_oO) {}

  return sentryWrapped;
}

/**
 * All properties the report dialog supports
 */


//# sourceMappingURL=helpers.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/trycatch.js



var DEFAULT_EVENT_TARGET = [
  'EventTarget',
  'Window',
  'Node',
  'ApplicationCache',
  'AudioTrackList',
  'ChannelMergerNode',
  'CryptoOperation',
  'EventSource',
  'FileReader',
  'HTMLUnknownElement',
  'IDBDatabase',
  'IDBRequest',
  'IDBTransaction',
  'KeyOperation',
  'MediaController',
  'MessagePort',
  'ModalWindow',
  'Notification',
  'SVGElementInstance',
  'Screen',
  'TextTrack',
  'TextTrackCue',
  'TextTrackList',
  'WebSocket',
  'WebSocketWorker',
  'Worker',
  'XMLHttpRequest',
  'XMLHttpRequestEventTarget',
  'XMLHttpRequestUpload',
];

/** Wrap timer functions and event targets to catch errors and provide better meta data */
class TryCatch  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'TryCatch';}

  /**
   * @inheritDoc
   */
   __init() {this.name = TryCatch.id;}

  /** JSDoc */
  

  /**
   * @inheritDoc
   */
   constructor(options) {;TryCatch.prototype.__init.call(this);
    this._options = {
      XMLHttpRequest: true,
      eventTarget: true,
      requestAnimationFrame: true,
      setInterval: true,
      setTimeout: true,
      ...options,
    };
  }

  /**
   * Wrap timer functions and event targets to catch errors
   * and provide better metadata.
   */
   setupOnce() {
    var global = (0,esm_global/* getGlobalObject */.R)();

    if (this._options.setTimeout) {
      (0,object/* fill */.hl)(global, 'setTimeout', _wrapTimeFunction);
    }

    if (this._options.setInterval) {
      (0,object/* fill */.hl)(global, 'setInterval', _wrapTimeFunction);
    }

    if (this._options.requestAnimationFrame) {
      (0,object/* fill */.hl)(global, 'requestAnimationFrame', _wrapRAF);
    }

    if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) {
      (0,object/* fill */.hl)(XMLHttpRequest.prototype, 'send', _wrapXHR);
    }

    var eventTargetOption = this._options.eventTarget;
    if (eventTargetOption) {
      var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
      eventTarget.forEach(_wrapEventTarget);
    }
  }
} TryCatch.__initStatic();

/** JSDoc */
function _wrapTimeFunction(original) {
    return function ( ...args) {
    var originalCallback = args[0];
    args[0] = wrap(originalCallback, {
      mechanism: {
        data: { function: (0,stacktrace/* getFunctionName */.$P)(original) },
        handled: true,
        type: 'instrument',
      },
    });
    return original.apply(this, args);
  };
}

/** JSDoc */
function _wrapRAF(original) {
    return function ( callback) {
        return original.apply(this, [
      wrap(callback, {
        mechanism: {
          data: {
            function: 'requestAnimationFrame',
            handler: (0,stacktrace/* getFunctionName */.$P)(original),
          },
          handled: true,
          type: 'instrument',
        },
      }),
    ]);
  };
}

/** JSDoc */
function _wrapXHR(originalSend) {
    return function ( ...args) {
        var xhr = this;
    var xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];

    xmlHttpRequestProps.forEach(prop => {
      if (prop in xhr && typeof xhr[prop] === 'function') {
                (0,object/* fill */.hl)(xhr, prop, function (original) {
          var wrapOptions = {
            mechanism: {
              data: {
                function: prop,
                handler: (0,stacktrace/* getFunctionName */.$P)(original),
              },
              handled: true,
              type: 'instrument',
            },
          };

          // If Instrument integration has been called before TryCatch, get the name of original function
          var originalFunction = (0,object/* getOriginalFunction */.HK)(original);
          if (originalFunction) {
            wrapOptions.mechanism.data.handler = (0,stacktrace/* getFunctionName */.$P)(originalFunction);
          }

          // Otherwise wrap directly
          return wrap(original, wrapOptions);
        });
      }
    });

    return originalSend.apply(this, args);
  };
}

/** JSDoc */
function _wrapEventTarget(target) {
    var global = (0,esm_global/* getGlobalObject */.R)() ;
    var proto = global[target] && global[target].prototype;

    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
    return;
  }

  (0,object/* fill */.hl)(proto, 'addEventListener', function (original)

 {
    return function (
            
      eventName,
      fn,
      options,
    ) {
      try {
        if (typeof fn.handleEvent === 'function') {
          // ESlint disable explanation:
          //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
          //  introduce a bug here, because bind returns a new function that doesn't have our
          //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
          //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                    fn.handleEvent = wrap(fn.handleEvent, {
            mechanism: {
              data: {
                function: 'handleEvent',
                handler: (0,stacktrace/* getFunctionName */.$P)(fn),
                target,
              },
              handled: true,
              type: 'instrument',
            },
          });
        }
      } catch (err) {
        // can sometimes get 'Permission denied to access property "handle Event'
      }

      return original.apply(this, [
        eventName,
                wrap(fn , {
          mechanism: {
            data: {
              function: 'addEventListener',
              handler: (0,stacktrace/* getFunctionName */.$P)(fn),
              target,
            },
            handled: true,
            type: 'instrument',
          },
        }),
        options,
      ]);
    };
  });

  (0,object/* fill */.hl)(
    proto,
    'removeEventListener',
    function (
      originalRemoveEventListener,
          ) {
      return function (
                
        eventName,
        fn,
        options,
      ) {
        /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */
        var wrappedEventHandler = fn ;
        try {
          var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
          if (originalEventHandler) {
            originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
          }
        } catch (e) {
          // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
        }
        return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
      };
    },
  );
}


//# sourceMappingURL=trycatch.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/globalhandlers.js





/** Global handlers */
class GlobalHandlers  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'GlobalHandlers';}

  /**
   * @inheritDoc
   */
   __init() {this.name = GlobalHandlers.id;}

  /** JSDoc */
  

  /**
   * Stores references functions to installing handlers. Will set to undefined
   * after they have been run so that they are not used twice.
   */
   __init2() {this._installFunc = {
    onerror: _installGlobalOnErrorHandler,
    onunhandledrejection: _installGlobalOnUnhandledRejectionHandler,
  };}

  /** JSDoc */
   constructor(options) {;GlobalHandlers.prototype.__init.call(this);GlobalHandlers.prototype.__init2.call(this);
    this._options = {
      onerror: true,
      onunhandledrejection: true,
      ...options,
    };
  }
  /**
   * @inheritDoc
   */
   setupOnce() {
    Error.stackTraceLimit = 50;
    var options = this._options;

    // We can disable guard-for-in as we construct the options object above + do checks against
    // `this._installFunc` for the property.
        for (var key in options) {
      var installFunc = this._installFunc[key ];
      if (installFunc && options[key ]) {
        globalHandlerLog(key);
        installFunc();
        this._installFunc[key ] = undefined;
      }
    }
  }
} GlobalHandlers.__initStatic();

/** JSDoc */
function _installGlobalOnErrorHandler() {
  (0,instrument/* addInstrumentationHandler */.o)(
    'error',
        (data) => {
      const [hub, stackParser, attachStacktrace] = getHubAndOptions();
      if (!hub.getIntegration(GlobalHandlers)) {
        return;
      }
      const { msg, url, line, column, error } = data;
      if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
        return;
      }

      var event =
        error === undefined && (0,is/* isString */.HD)(msg)
          ? _eventFromIncompleteOnError(msg, url, line, column)
          : _enhanceEventWithInitialFrame(
              eventFromUnknownInput(stackParser, error || msg, undefined, attachStacktrace, false),
              url,
              line,
              column,
            );

      event.level = 'error';

      addMechanismAndCapture(hub, error, event, 'onerror');
    },
  );
}

/** JSDoc */
function _installGlobalOnUnhandledRejectionHandler() {
  (0,instrument/* addInstrumentationHandler */.o)(
    'unhandledrejection',
        (e) => {
      const [hub, stackParser, attachStacktrace] = getHubAndOptions();
      if (!hub.getIntegration(GlobalHandlers)) {
        return;
      }
      let error = e;

      // dig the object of the rejection out of known event types
      try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) {
          error = e.reason;
        }
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        else if ('detail' in e && 'reason' in e.detail) {
          error = e.detail.reason;
        }
      } catch (_oO) {
        // no-empty
      }

      if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
        return true;
      }

      var event = (0,is/* isPrimitive */.pt)(error)
        ? _eventFromRejectionWithPrimitive(error)
        : eventFromUnknownInput(stackParser, error, undefined, attachStacktrace, true);

      event.level = 'error';

      addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
      return;
    },
  );
}

/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */
function _eventFromRejectionWithPrimitive(reason) {
  return {
    exception: {
      values: [
        {
          type: 'UnhandledRejection',
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(reason)}`,
        },
      ],
    },
  };
}

/**
 * This function creates a stack from an old, error-less onerror handler.
 */
function _eventFromIncompleteOnError(msg, url, line, column) {
  var ERROR_TYPES_RE =
    /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;

  // If 'message' is ErrorEvent, get real message from inside
  let message = (0,is/* isErrorEvent */.VW)(msg) ? msg.message : msg;
  let name = 'Error';

  var groups = message.match(ERROR_TYPES_RE);
  if (groups) {
    name = groups[1];
    message = groups[2];
  }

  var event = {
    exception: {
      values: [
        {
          type: name,
          value: message,
        },
      ],
    },
  };

  return _enhanceEventWithInitialFrame(event, url, line, column);
}

/** JSDoc */
function _enhanceEventWithInitialFrame(event, url, line, column) {
  // event.exception
  var e = (event.exception = event.exception || {});
  // event.exception.values
  var ev = (e.values = e.values || []);
  // event.exception.values[0]
  var ev0 = (ev[0] = ev[0] || {});
  // event.exception.values[0].stacktrace
  var ev0s = (ev0.stacktrace = ev0.stacktrace || {});
  // event.exception.values[0].stacktrace.frames
  var ev0sf = (ev0s.frames = ev0s.frames || []);

  var colno = isNaN(parseInt(column, 10)) ? undefined : column;
  var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
  var filename = (0,is/* isString */.HD)(url) && url.length > 0 ? url : (0,browser/* getLocationHref */.l)();

  // event.exception.values[0].stacktrace.frames
  if (ev0sf.length === 0) {
    ev0sf.push({
      colno,
      filename,
      function: '?',
      in_app: true,
      lineno,
    });
  }

  return event;
}

function globalHandlerLog(type) {
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`Global Handler attached: ${type}`);
}

function addMechanismAndCapture(hub, error, event, type) {
  (0,misc/* addExceptionMechanism */.EG)(event, {
    handled: false,
    type,
  });
  hub.captureEvent(event, {
    originalException: error,
  });
}

function getHubAndOptions() {
  var hub = (0,esm_hub/* getCurrentHub */.Gd)();
  var client = hub.getClient();
  var options = (client && client.getOptions()) || {
    stackParser: () => [],
    attachStacktrace: false,
  };
  return [hub, options.stackParser, options.attachStacktrace];
}


//# sourceMappingURL=globalhandlers.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/linkederrors.js




var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;

/** Adds SDK info to an event. */
class LinkedErrors  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'LinkedErrors';}

  /**
   * @inheritDoc
   */
    __init() {this.name = LinkedErrors.id;}

  /**
   * @inheritDoc
   */
  

  /**
   * @inheritDoc
   */
  

  /**
   * @inheritDoc
   */
   constructor(options = {}) {;LinkedErrors.prototype.__init.call(this);
    this._key = options.key || DEFAULT_KEY;
    this._limit = options.limit || DEFAULT_LIMIT;
  }

  /**
   * @inheritDoc
   */
   setupOnce() {
    var client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
    if (!client) {
      return;
    }
    (0,esm_scope/* addGlobalEventProcessor */.c)((event, hint) => {
      var self = (0,esm_hub/* getCurrentHub */.Gd)().getIntegration(LinkedErrors);
      return self ? _handler(client.getOptions().stackParser, self._key, self._limit, event, hint) : event;
    });
  }
} LinkedErrors.__initStatic();

/**
 * @inheritDoc
 */
function _handler(
  parser,
  key,
  limit,
  event,
  hint,
) {
  if (!event.exception || !event.exception.values || !hint || !(0,is/* isInstanceOf */.V9)(hint.originalException, Error)) {
    return event;
  }
  var linkedErrors = _walkErrorTree(parser, limit, hint.originalException , key);
  event.exception.values = [...linkedErrors, ...event.exception.values];
  return event;
}

/**
 * JSDOC
 */
function _walkErrorTree(
  parser,
  limit,
  error,
  key,
  stack = [],
) {
  if (!(0,is/* isInstanceOf */.V9)(error[key], Error) || stack.length + 1 >= limit) {
    return stack;
  }
  var exception = exceptionFromError(parser, error[key]);
  return _walkErrorTree(parser, limit, error[key], key, [exception, ...stack]);
}


//# sourceMappingURL=linkederrors.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/dedupe.js


/** Deduplication filter */
class Dedupe  {constructor() { Dedupe.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'Dedupe';}

  /**
   * @inheritDoc
   */
   __init() {this.name = Dedupe.id;}

  /**
   * @inheritDoc
   */
  

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    var eventProcessor = currentEvent => {
      var self = getCurrentHub().getIntegration(Dedupe);
      if (self) {
        // Juuust in case something goes wrong
        try {
          if (dedupe_shouldDropEvent(currentEvent, self._previousEvent)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Event dropped due to being a duplicate of previously captured event.');
            return null;
          }
        } catch (_oO) {
          return (self._previousEvent = currentEvent);
        }

        return (self._previousEvent = currentEvent);
      }
      return currentEvent;
    };

    eventProcessor.id = this.name;
    addGlobalEventProcessor(eventProcessor);
  }
} Dedupe.__initStatic();

/** JSDoc */
function dedupe_shouldDropEvent(currentEvent, previousEvent) {
  if (!previousEvent) {
    return false;
  }

  if (_isSameMessageEvent(currentEvent, previousEvent)) {
    return true;
  }

  if (_isSameExceptionEvent(currentEvent, previousEvent)) {
    return true;
  }

  return false;
}

/** JSDoc */
function _isSameMessageEvent(currentEvent, previousEvent) {
  var currentMessage = currentEvent.message;
  var previousMessage = previousEvent.message;

  // If neither event has a message property, they were both exceptions, so bail out
  if (!currentMessage && !previousMessage) {
    return false;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
    return false;
  }

  if (currentMessage !== previousMessage) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

/** JSDoc */
function _isSameExceptionEvent(currentEvent, previousEvent) {
  var previousException = _getExceptionFromEvent(previousEvent);
  var currentException = _getExceptionFromEvent(currentEvent);

  if (!previousException || !currentException) {
    return false;
  }

  if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

/** JSDoc */
function _isSameStacktrace(currentEvent, previousEvent) {
  let currentFrames = _getFramesFromEvent(currentEvent);
  let previousFrames = _getFramesFromEvent(previousEvent);

  // If neither event has a stacktrace, they are assumed to be the same
  if (!currentFrames && !previousFrames) {
    return true;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
    return false;
  }

  currentFrames = currentFrames ;
  previousFrames = previousFrames ;

  // If number of frames differ, they are not the same
  if (previousFrames.length !== currentFrames.length) {
    return false;
  }

  // Otherwise, compare the two
  for (let i = 0; i < previousFrames.length; i++) {
    var frameA = previousFrames[i];
    var frameB = currentFrames[i];

    if (
      frameA.filename !== frameB.filename ||
      frameA.lineno !== frameB.lineno ||
      frameA.colno !== frameB.colno ||
      frameA.function !== frameB.function
    ) {
      return false;
    }
  }

  return true;
}

/** JSDoc */
function _isSameFingerprint(currentEvent, previousEvent) {
  let currentFingerprint = currentEvent.fingerprint;
  let previousFingerprint = previousEvent.fingerprint;

  // If neither event has a fingerprint, they are assumed to be the same
  if (!currentFingerprint && !previousFingerprint) {
    return true;
  }

  // If only one event has a fingerprint, but not the other one, they are not the same
  if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
    return false;
  }

  currentFingerprint = currentFingerprint ;
  previousFingerprint = previousFingerprint ;

  // Otherwise, compare the two
  try {
    return !!(currentFingerprint.join('') === previousFingerprint.join(''));
  } catch (_oO) {
    return false;
  }
}

/** JSDoc */
function _getExceptionFromEvent(event) {
  return event.exception && event.exception.values && event.exception.values[0];
}

/** JSDoc */
function _getFramesFromEvent(event) {
  var exception = event.exception;

  if (exception) {
    try {
      // @ts-ignore Object could be undefined
      return exception.values[0].stacktrace.frames;
    } catch (_oO) {
      return undefined;
    }
  }
  return undefined;
}


//# sourceMappingURL=dedupe.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/httpcontext.js



var httpcontext_global = (0,esm_global/* getGlobalObject */.R)();

/** HttpContext integration collects information about HTTP request headers */
class HttpContext  {constructor() { HttpContext.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'HttpContext';}

  /**
   * @inheritDoc
   */
   __init() {this.name = HttpContext.id;}

  /**
   * @inheritDoc
   */
   setupOnce() {
    (0,esm_scope/* addGlobalEventProcessor */.c)((event) => {
      if ((0,esm_hub/* getCurrentHub */.Gd)().getIntegration(HttpContext)) {
        // if none of the information we want exists, don't bother
        if (!httpcontext_global.navigator && !httpcontext_global.location && !httpcontext_global.document) {
          return event;
        }

        // grab as much info as exists and add it to the event
        var url = (event.request && event.request.url) || (httpcontext_global.location && httpcontext_global.location.href);
        const { referrer } = httpcontext_global.document || {};
        const { userAgent } = httpcontext_global.navigator || {};

        var headers = {
          ...(event.request && event.request.headers),
          ...(referrer && { Referer: referrer }),
          ...(userAgent && { 'User-Agent': userAgent }),
        };
        var request = { ...(url && { url }), headers };

        return { ...event, request };
      }
      return event;
    });
  }
} HttpContext.__initStatic();


//# sourceMappingURL=httpcontext.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/promisebuffer.js



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */
function makePromiseBuffer(limit) {
  var buffer = [];

  function isReady() {
    return limit === undefined || buffer.length < limit;
  }

  /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */
  function remove(task) {
    return buffer.splice(buffer.indexOf(task), 1)[0];
  }

  /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */
  function add(taskProducer) {
    if (!isReady()) {
      return (0,syncpromise/* rejectedSyncPromise */.$2)(new SentryError('Not adding Promise due to buffer limit reached.'));
    }

    // start the task and add its promise to the queue
    var task = taskProducer();
    if (buffer.indexOf(task) === -1) {
      buffer.push(task);
    }
    void task
      .then(() => remove(task))
      // Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
      // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
      // have promises, so TS has to polyfill when down-compiling.)
      .then(null, () =>
        remove(task).then(null, () => {
          // We have to add another catch here because `remove()` starts a new promise chain.
        }),
      );
    return task;
  }

  /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */
  function drain(timeout) {
    return new syncpromise/* SyncPromise */.cW((resolve, reject) => {
      let counter = buffer.length;

      if (!counter) {
        return resolve(true);
      }

      // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
      var capturedSetTimeout = setTimeout(() => {
        if (timeout && timeout > 0) {
          resolve(false);
        }
      }, timeout);

      // if all promises resolve in time, cancel the timer and resolve to `true`
      buffer.forEach(item => {
        void (0,syncpromise/* resolvedSyncPromise */.WD)(item).then(() => {
                    if (!--counter) {
            clearTimeout(capturedSetTimeout);
            resolve(true);
          }
        }, reject);
      });
    });
  }

  return {
    $: buffer,
    add,
    drain,
  };
}


//# sourceMappingURL=promisebuffer.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/ratelimit.js
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend

var DEFAULT_RETRY_AFTER = 60 * 1000; // 60 seconds

/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */
function parseRetryAfterHeader(header, now = Date.now()) {
  var headerDelay = parseInt(`${header}`, 10);
  if (!isNaN(headerDelay)) {
    return headerDelay * 1000;
  }

  var headerDate = Date.parse(`${header}`);
  if (!isNaN(headerDate)) {
    return headerDate - now;
  }

  return DEFAULT_RETRY_AFTER;
}

/**
 * Gets the time that given category is disabled until for rate limiting
 */
function disabledUntil(limits, category) {
  return limits[category] || limits.all || 0;
}

/**
 * Checks if a category is rate limited
 */
function isRateLimited(limits, category, now = Date.now()) {
  return disabledUntil(limits, category) > now;
}

/**
 * Update ratelimits from incoming headers.
 * Returns true if headers contains a non-empty rate limiting header.
 */
function updateRateLimits(
  limits,
  { statusCode, headers },
  now = Date.now(),
) {
  var updatedRateLimits = {
    ...limits,
  };

  // "The name is case-insensitive."
  // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
  var rateLimitHeader = headers && headers['x-sentry-rate-limits'];
  var retryAfterHeader = headers && headers['retry-after'];

  if (rateLimitHeader) {
    /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     */
    for (var limit of rateLimitHeader.trim().split(',')) {
      const [retryAfter, categories] = limit.split(':', 2);
      var headerDelay = parseInt(retryAfter, 10);
      var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
      if (!categories) {
        updatedRateLimits.all = now + delay;
      } else {
        for (var category of categories.split(';')) {
          updatedRateLimits[category] = now + delay;
        }
      }
    }
  } else if (retryAfterHeader) {
    updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
  } else if (statusCode === 429) {
    updatedRateLimits.all = now + 60 * 1000;
  }

  return updatedRateLimits;
}


//# sourceMappingURL=ratelimit.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/transports/base.js


var DEFAULT_TRANSPORT_BUFFER_SIZE = 30;

/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */
function createTransport(
  options,
  makeRequest,
  buffer = makePromiseBuffer(options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE),
) {
  let rateLimits = {};

  var flush = (timeout) => buffer.drain(timeout);

  function send(envelope) {
    var filteredEnvelopeItems = [];

    // Drop rate limited items from envelope
    forEachEnvelopeItem(envelope, (item, type) => {
      var envelopeItemDataCategory = envelopeItemTypeToDataCategory(type);
      if (isRateLimited(rateLimits, envelopeItemDataCategory)) {
        options.recordDroppedEvent('ratelimit_backoff', envelopeItemDataCategory);
      } else {
        filteredEnvelopeItems.push(item);
      }
    });

    // Skip sending if envelope is empty after filtering out rate limited events
    if (filteredEnvelopeItems.length === 0) {
      return (0,syncpromise/* resolvedSyncPromise */.WD)();
    }

        var filteredEnvelope = createEnvelope(envelope[0], filteredEnvelopeItems );

    // Creates client report for each item in an envelope
    var recordEnvelopeLoss = (reason) => {
      forEachEnvelopeItem(filteredEnvelope, (_, type) => {
        options.recordDroppedEvent(reason, envelopeItemTypeToDataCategory(type));
      });
    };

    var requestTask = () =>
      makeRequest({ body: serializeEnvelope(filteredEnvelope, options.textEncoder) }).then(
        response => {
          // We don't want to throw on NOK responses, but we want to at least log them
          if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
          }

          rateLimits = updateRateLimits(rateLimits, response);
        },
        error => {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Failed while sending event:', error);
          recordEnvelopeLoss('network_error');
        },
      );

    return buffer.add(requestTask).then(
      result => result,
      error => {
        if (error instanceof SentryError) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Skipped sending event due to full buffer');
          recordEnvelopeLoss('queue_overflow');
          return (0,syncpromise/* resolvedSyncPromise */.WD)();
        } else {
          throw error;
        }
      },
    );
  }

  return {
    send,
    flush,
  };
}


//# sourceMappingURL=base.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/fetch.js



/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */
function makeFetchTransport(
  options,
  nativeFetch = getNativeFetchImplementation(),
) {
  function makeRequest(request) {
    var requestOptions = {
      body: request.body,
      method: 'POST',
      referrerPolicy: 'origin',
      headers: options.headers,
      ...options.fetchOptions,
    };

    return nativeFetch(options.url, requestOptions).then(response => ({
      statusCode: response.status,
      headers: {
        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
        'retry-after': response.headers.get('Retry-After'),
      },
    }));
  }

  return createTransport(options, makeRequest);
}


//# sourceMappingURL=fetch.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/xhr.js



/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */
var XHR_READYSTATE_DONE = 4;

/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */
function makeXHRTransport(options) {
  function makeRequest(request) {
    return new syncpromise/* SyncPromise */.cW((resolve, reject) => {
      var xhr = new XMLHttpRequest();

      xhr.onerror = reject;

      xhr.onreadystatechange = () => {
        if (xhr.readyState === XHR_READYSTATE_DONE) {
          resolve({
            statusCode: xhr.status,
            headers: {
              'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
              'retry-after': xhr.getResponseHeader('Retry-After'),
            },
          });
        }
      };

      xhr.open('POST', options.url);

      for (var header in options.headers) {
        if (Object.prototype.hasOwnProperty.call(options.headers, header)) {
          xhr.setRequestHeader(header, options.headers[header]);
        }
      }

      xhr.send(request.body);
    });
  }

  return createTransport(options, makeRequest);
}


//# sourceMappingURL=xhr.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/sdk.js
















var defaultIntegrations = [
  new InboundFilters(),
  new FunctionToString(),
  new TryCatch(),
  new Breadcrumbs(),
  new GlobalHandlers(),
  new LinkedErrors(),
  new Dedupe(),
  new HttpContext(),
];

/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options = {}) {
  if (options.defaultIntegrations === undefined) {
    options.defaultIntegrations = defaultIntegrations;
  }
  if (options.release === undefined) {
    var window = (0,esm_global/* getGlobalObject */.R)();
    // This supports the variable that sentry-webpack-plugin injects
    if (window.SENTRY_RELEASE && window.SENTRY_RELEASE.id) {
      options.release = window.SENTRY_RELEASE.id;
    }
  }
  if (options.autoSessionTracking === undefined) {
    options.autoSessionTracking = true;
  }
  if (options.sendClientReports === undefined) {
    options.sendClientReports = true;
  }

  var clientOptions = {
    ...options,
    stackParser: (0,stacktrace/* stackParserFromStackParserOptions */.Sq)(options.stackParser || defaultStackParser),
    integrations: getIntegrationsToSetup(options),
    transport: options.transport || ((0,supports/* supportsFetch */.Ak)() ? makeFetchTransport : makeXHRTransport),
  };

  initAndBind(BrowserClient, clientOptions);

  if (options.autoSessionTracking) {
    startSessionTracking();
  }
}

/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options = {}, hub = getCurrentHub()) {
  // doesn't work without a document (React Native)
  var global = getGlobalObject();
  if (!global.document) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('Global document not defined in showReportDialog call');
    return;
  }

  const { client, scope } = hub.getStackTop();
  var dsn = options.dsn || (client && client.getDsn());
  if (!dsn) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('DSN not configured for showReportDialog call');
    return;
  }

  if (scope) {
    options.user = {
      ...scope.getUser(),
      ...options.user,
    };
  }

  if (!options.eventId) {
    options.eventId = hub.lastEventId();
  }

  var script = global.document.createElement('script');
  script.async = true;
  script.src = getReportDialogEndpoint(dsn, options);

  if (options.onLoad) {
        script.onload = options.onLoad;
  }

  var injectionPoint = global.document.head || global.document.body;
  if (injectionPoint) {
    injectionPoint.appendChild(script);
  } else {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('Not injecting report dialog. No injection point found in HTML');
  }
}

/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
  return getCurrentHub().lastEventId();
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
  // Noop
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
  callback();
}

/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function flush(timeout) {
  var client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
  if (client) {
    return client.flush(timeout);
  }
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Cannot flush events. No client defined.');
  return (0,syncpromise/* resolvedSyncPromise */.WD)(false);
}

/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function sdk_close(timeout) {
  var client = getCurrentHub().getClient();
  if (client) {
    return client.close(timeout);
  }
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Cannot flush events and disable SDK. No client defined.');
  return resolvedSyncPromise(false);
}

/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
function sdk_wrap(fn) {
  return wrap$1(fn)();
}

function startSessionOnHub(hub) {
  hub.startSession({ ignoreDuration: true });
  hub.captureSession();
}

/**
 * Enable automatic Session Tracking for the initial page load.
 */
function startSessionTracking() {
  var window = (0,esm_global/* getGlobalObject */.R)();
  var document = window.document;

  if (typeof document === 'undefined') {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
    return;
  }

  var hub = (0,esm_hub/* getCurrentHub */.Gd)();

  // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
  // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
  // pinned at the same version in package.json, but there are edge cases where it's possible. See
  // https://github.com/getsentry/sentry-javascript/issues/3207 and
  // https://github.com/getsentry/sentry-javascript/issues/3234 and
  // https://github.com/getsentry/sentry-javascript/issues/3278.
  if (!hub.captureSession) {
    return;
  }

  // The session duration for browser sessions does not track a meaningful
  // concept that can be used as a metric.
  // Automatically captured sessions are akin to page views, and thus we
  // discard their duration.
  startSessionOnHub(hub);

  // We want to create a session for every navigation as well
  (0,instrument/* addInstrumentationHandler */.o)('history', ({ from, to }) => {
    // Don't create an additional session for the initial route or if the location did not change
    if (!(from === undefined || from === to)) {
      startSessionOnHub((0,esm_hub/* getCurrentHub */.Gd)());
    }
  });
}


//# sourceMappingURL=sdk.js.map


/***/ }),

/***/ 40105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ SDK_VERSION; }
/* harmony export */ });
var SDK_VERSION = '7.8.0';


//# sourceMappingURL=version.js.map


/***/ }),

/***/ 92876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tb": function() { return /* binding */ captureException; },
/* harmony export */   "e": function() { return /* binding */ configureScope; },
/* harmony export */   "$e": function() { return /* binding */ withScope; }
/* harmony export */ });
/* unused harmony exports addBreadcrumb, captureEvent, captureMessage, setContext, setExtra, setExtras, setTag, setTags, setUser, startTransaction */
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38641);


// Note: All functions in this file are typed with a return value of `ReturnType<Hub[HUB_FUNCTION]>`,
// where HUB_FUNCTION is some method on the Hub class.
//
// This is done to make sure the top level SDK methods stay in sync with the hub methods.
// Although every method here has an explicit return type, some of them (that map to void returns) do not
// contain `return` keywords. This is done to save on bundle size, as `return` is not minifiable.

/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @param captureContext Additional scope data to apply to exception event.
 * @returns The generated eventId.
 */
function captureException(exception, captureContext) {
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().captureException(exception, { captureContext });
}

/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param Severity Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(
  message,
    captureContext,
) {
  // This is necessary to provide explicit scopes upgrade, without changing the original
  // arity of the `captureMessage(message, level)` method.
  var level = typeof captureContext === 'string' ? captureContext : undefined;
  var context = typeof captureContext !== 'string' ? { captureContext } : undefined;
  return getCurrentHub().captureMessage(message, level, context);
}

/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event, hint) {
  return getCurrentHub().captureEvent(event, hint);
}

/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().configureScope(callback);
}

/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
  getCurrentHub().addBreadcrumb(breadcrumb);
}

/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */
function setContext(name, context) {
  getCurrentHub().setContext(name, context);
}

/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
  getCurrentHub().setExtras(extras);
}

/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */
function setExtra(key, extra) {
  getCurrentHub().setExtra(key, extra);
}

/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
  getCurrentHub().setTags(tags);
}

/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */
function setTag(key, value) {
  getCurrentHub().setTag(key, value);
}

/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
  getCurrentHub().setUser(user);
}

/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().withScope(callback);
}

/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */
function startTransaction(
  context,
  customSamplingContext,
) {
  return getCurrentHub().startTransaction(
    {
      metadata: { source: 'custom' },
      ...context,
    },
    customSamplingContext,
  );
}


//# sourceMappingURL=exports.js.map


/***/ }),

/***/ 38641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gd": function() { return /* binding */ getCurrentHub; },
/* harmony export */   "cu": function() { return /* binding */ getMainCarrier; }
/* harmony export */ });
/* unused harmony exports API_VERSION, Hub, getHubFromCarrier, makeMain, setHubOnCarrier */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82991);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92448);
/* harmony import */ var _scope_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46769);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95771);




/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
var API_VERSION = 4;

/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
var DEFAULT_BREADCRUMBS = 100;

/**
 * A layer in the process stack.
 * @hidden
 */

/**
 * @inheritDoc
 */
class Hub  {
  /** Is a {@link Layer}[] containing the client and scope */
    __init() {this._stack = [{}];}

  /** Contains the last event id of a captured event.  */
  

  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */
   constructor(client, scope = new _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope */ .s(),   _version = API_VERSION) {;this._version = _version;Hub.prototype.__init.call(this);
    this.getStackTop().scope = scope;
    if (client) {
      this.bindClient(client);
    }
  }

  /**
   * @inheritDoc
   */
   isOlderThan(version) {
    return this._version < version;
  }

  /**
   * @inheritDoc
   */
   bindClient(client) {
    var top = this.getStackTop();
    top.client = client;
    if (client && client.setupIntegrations) {
      client.setupIntegrations();
    }
  }

  /**
   * @inheritDoc
   */
   pushScope() {
    // We want to clone the content of prev scope
    var scope = _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope.clone */ .s.clone(this.getScope());
    this.getStack().push({
      client: this.getClient(),
      scope,
    });
    return scope;
  }

  /**
   * @inheritDoc
   */
   popScope() {
    if (this.getStack().length <= 1) return false;
    return !!this.getStack().pop();
  }

  /**
   * @inheritDoc
   */
   withScope(callback) {
    var scope = this.pushScope();
    try {
      callback(scope);
    } finally {
      this.popScope();
    }
  }

  /**
   * @inheritDoc
   */
   getClient() {
    return this.getStackTop().client ;
  }

  /** Returns the scope of the top stack. */
   getScope() {
    return this.getStackTop().scope;
  }

  /** Returns the scope stack for domains or the process. */
   getStack() {
    return this._stack;
  }

  /** Returns the topmost scope layer in the order domain > local > process. */
   getStackTop() {
    return this._stack[this._stack.length - 1];
  }

  /**
   * @inheritDoc
   */
     captureException(exception, hint) {
    var eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)());
    var syntheticException = new Error('Sentry syntheticException');
    this._withClient((client, scope) => {
      client.captureException(
        exception,
        {
          originalException: exception,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
        level,
    hint,
  ) {
    var eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)());
    var syntheticException = new Error(message);
    this._withClient((client, scope) => {
      client.captureMessage(
        message,
        level,
        {
          originalException: message,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint) {
    var eventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)();
    if (event.type !== 'transaction') {
      this._lastEventId = eventId;
    }

    this._withClient((client, scope) => {
      client.captureEvent(event, { ...hint, event_id: eventId }, scope);
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   lastEventId() {
    return this._lastEventId;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, hint) {
    const { scope, client } = this.getStackTop();

    if (!scope || !client) return;

        const { beforeBreadcrumb = null, maxBreadcrumbs = DEFAULT_BREADCRUMBS } =
      (client.getOptions && client.getOptions()) || {};

    if (maxBreadcrumbs <= 0) return;

    var timestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dateTimestampInSeconds */ .yW)();
    var mergedBreadcrumb = { timestamp, ...breadcrumb };
    var finalBreadcrumb = beforeBreadcrumb
      ? ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .consoleSandbox */ .Cf)(() => beforeBreadcrumb(mergedBreadcrumb, hint)) )
      : mergedBreadcrumb;

    if (finalBreadcrumb === null) return;

    scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    var scope = this.getScope();
    if (scope) scope.setUser(user);
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    var scope = this.getScope();
    if (scope) scope.setTags(tags);
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    var scope = this.getScope();
    if (scope) scope.setExtras(extras);
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    var scope = this.getScope();
    if (scope) scope.setTag(key, value);
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    var scope = this.getScope();
    if (scope) scope.setExtra(key, extra);
  }

  /**
   * @inheritDoc
   */
     setContext(name, context) {
    var scope = this.getScope();
    if (scope) scope.setContext(name, context);
  }

  /**
   * @inheritDoc
   */
   configureScope(callback) {
    const { scope, client } = this.getStackTop();
    if (scope && client) {
      callback(scope);
    }
  }

  /**
   * @inheritDoc
   */
   run(callback) {
    var oldHub = makeMain(this);
    try {
      callback(this);
    } finally {
      makeMain(oldHub);
    }
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    var client = this.getClient();
    if (!client) return null;
    try {
      return client.getIntegration(integration);
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   startTransaction(context, customSamplingContext) {
    return this._callExtensionMethod('startTransaction', context, customSamplingContext);
  }

  /**
   * @inheritDoc
   */
   traceHeaders() {
    return this._callExtensionMethod('traceHeaders');
  }

  /**
   * @inheritDoc
   */
   captureSession(endSession = false) {
    // both send the update and pull the session from the scope
    if (endSession) {
      return this.endSession();
    }

    // only send the update
    this._sendSessionUpdate();
  }

  /**
   * @inheritDoc
   */
   endSession() {
    var layer = this.getStackTop();
    var scope = layer && layer.scope;
    var session = scope && scope.getSession();
    if (session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .closeSession */ .RJ)(session);
    }
    this._sendSessionUpdate();

    // the session is over; take it off of the scope
    if (scope) {
      scope.setSession();
    }
  }

  /**
   * @inheritDoc
   */
   startSession(context) {
    const { scope, client } = this.getStackTop();
    const { release, environment } = (client && client.getOptions()) || {};

    // Will fetch userAgent if called from browser sdk
    var global = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .getGlobalObject */ .R)();
    const { userAgent } = global.navigator || {};

    var session = (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .makeSession */ .Hv)({
      release,
      environment,
      ...(scope && { user: scope.getUser() }),
      ...(userAgent && { userAgent }),
      ...context,
    });

    if (scope) {
      // End existing session if there's one
      var currentSession = scope.getSession && scope.getSession();
      if (currentSession && currentSession.status === 'ok') {
        (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .updateSession */ .CT)(currentSession, { status: 'exited' });
      }
      this.endSession();

      // Afterwards we set the new session on the scope
      scope.setSession(session);
    }

    return session;
  }

  /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */
   shouldSendDefaultPii() {
    var client = this.getClient();
    var options = client && client.getOptions();
    return Boolean(options && options.sendDefaultPii);
  }

  /**
   * Sends the current Session on the scope
   */
   _sendSessionUpdate() {
    const { scope, client } = this.getStackTop();
    if (!scope) return;

    var session = scope.getSession();
    if (session) {
      if (client && client.captureSession) {
        client.captureSession(session);
      }
    }
  }

  /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */
   _withClient(callback) {
    const { scope, client } = this.getStackTop();
    if (client) {
      callback(client, scope);
    }
  }

  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
     _callExtensionMethod(method, ...args) {
    var carrier = getMainCarrier();
    var sentry = carrier.__SENTRY__;
    if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
      return sentry.extensions[method].apply(this, args);
    }
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn(`Extension method ${method} couldn't be found, doing nothing.`);
  }
}

/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/
function getMainCarrier() {
  var carrier = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .getGlobalObject */ .R)();
  carrier.__SENTRY__ = carrier.__SENTRY__ || {
    extensions: {},
    hub: undefined,
  };
  return carrier;
}

/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
  var registry = getMainCarrier();
  var oldHub = getHubFromCarrier(registry);
  setHubOnCarrier(registry, hub);
  return oldHub;
}

/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
  // Get main carrier (global for every environment)
  var registry = getMainCarrier();

  // If there's no hub, or its an old API, assign a new one
  if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
    setHubOnCarrier(registry, new Hub());
  }

  // Prefer domains over global if they are there (applicable only to Node environment)
  if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .isNodeEnv */ .KV)()) {
    return getHubFromActiveDomain(registry);
  }
  // Return hub that lives on a global object
  return getHubFromCarrier(registry);
}

/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */
function getHubFromActiveDomain(registry) {
  try {
    var sentry = getMainCarrier().__SENTRY__;
    var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;

    // If there's no active domain, just return global hub
    if (!activeDomain) {
      return getHubFromCarrier(registry);
    }

    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
      var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
      setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope.clone */ .s.clone(registryHubTopStack.scope)));
    }

    // Return hub that lives on a domain
    return getHubFromCarrier(activeDomain);
  } catch (_Oo) {
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
  }
}

/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
  return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}

/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .getGlobalSingleton */ .Y)('hub', () => new Hub(), carrier);
}

/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */
function setHubOnCarrier(carrier, hub) {
  if (!carrier) return false;
  var __SENTRY__ = (carrier.__SENTRY__ = carrier.__SENTRY__ || {});
  __SENTRY__.hub = hub;
  return true;
}


//# sourceMappingURL=hub.js.map


/***/ }),

/***/ 46769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ Scope; },
/* harmony export */   "c": function() { return /* binding */ addGlobalEventProcessor; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96893);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82991);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95771);



/**
 * Absolute maximum number of breadcrumbs added to an event.
 * The `maxBreadcrumbs` option cannot be higher than this value.
 */
var MAX_BREADCRUMBS = 100;

/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
class Scope  {
  /** Flag if notifying is happening. */
  

  /** Callback for client to receive scope changes. */
  

  /** Callback list that will be called after {@link applyToEvent}. */
  

  /** Array of breadcrumbs. */
  

  /** User */
  

  /** Tags */
  

  /** Extra */
  

  /** Contexts */
  

  /** Attachments */
  

  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  

  /** Fingerprint */
  

  /** Severity */
    

  /** Transaction Name */
  

  /** Span */
  

  /** Session */
  

  /** Request Mode Session Status */
  

   constructor() {
    this._notifyingListeners = false;
    this._scopeListeners = [];
    this._eventProcessors = [];
    this._breadcrumbs = [];
    this._attachments = [];
    this._user = {};
    this._tags = {};
    this._extra = {};
    this._contexts = {};
    this._sdkProcessingMetadata = {};
  }

  /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */
   static clone(scope) {
    var newScope = new Scope();
    if (scope) {
      newScope._breadcrumbs = [...scope._breadcrumbs];
      newScope._tags = { ...scope._tags };
      newScope._extra = { ...scope._extra };
      newScope._contexts = { ...scope._contexts };
      newScope._user = scope._user;
      newScope._level = scope._level;
      newScope._span = scope._span;
      newScope._session = scope._session;
      newScope._transactionName = scope._transactionName;
      newScope._fingerprint = scope._fingerprint;
      newScope._eventProcessors = [...scope._eventProcessors];
      newScope._requestSession = scope._requestSession;
      newScope._attachments = [...scope._attachments];
    }
    return newScope;
  }

  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */
   addScopeListener(callback) {
    this._scopeListeners.push(callback);
  }

  /**
   * @inheritDoc
   */
   addEventProcessor(callback) {
    this._eventProcessors.push(callback);
    return this;
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    this._user = user || {};
    if (this._session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_0__/* .updateSession */ .CT)(this._session, { user });
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getUser() {
    return this._user;
  }

  /**
   * @inheritDoc
   */
   getRequestSession() {
    return this._requestSession;
  }

  /**
   * @inheritDoc
   */
   setRequestSession(requestSession) {
    this._requestSession = requestSession;
    return this;
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    this._tags = {
      ...this._tags,
      ...tags,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this._tags = { ...this._tags, [key]: value };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    this._extra = {
      ...this._extra,
      ...extras,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    this._extra = { ...this._extra, [key]: extra };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setFingerprint(fingerprint) {
    this._fingerprint = fingerprint;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setLevel(
        level,
  ) {
    this._level = level;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTransactionName(name) {
    this._transactionName = name;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setContext(key, context) {
    if (context === null) {
            delete this._contexts[key];
    } else {
      this._contexts = { ...this._contexts, [key]: context };
    }

    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setSpan(span) {
    this._span = span;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSpan() {
    return this._span;
  }

  /**
   * @inheritDoc
   */
   getTransaction() {
    // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
    // have a pointer to the currently-active transaction.
    var span = this.getSpan();
    return span && span.transaction;
  }

  /**
   * @inheritDoc
   */
   setSession(session) {
    if (!session) {
      delete this._session;
    } else {
      this._session = session;
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSession() {
    return this._session;
  }

  /**
   * @inheritDoc
   */
   update(captureContext) {
    if (!captureContext) {
      return this;
    }

    if (typeof captureContext === 'function') {
      var updatedScope = (captureContext )(this);
      return updatedScope instanceof Scope ? updatedScope : this;
    }

    if (captureContext instanceof Scope) {
      this._tags = { ...this._tags, ...captureContext._tags };
      this._extra = { ...this._extra, ...captureContext._extra };
      this._contexts = { ...this._contexts, ...captureContext._contexts };
      if (captureContext._user && Object.keys(captureContext._user).length) {
        this._user = captureContext._user;
      }
      if (captureContext._level) {
        this._level = captureContext._level;
      }
      if (captureContext._fingerprint) {
        this._fingerprint = captureContext._fingerprint;
      }
      if (captureContext._requestSession) {
        this._requestSession = captureContext._requestSession;
      }
    } else if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isPlainObject */ .PO)(captureContext)) {
            captureContext = captureContext ;
      this._tags = { ...this._tags, ...captureContext.tags };
      this._extra = { ...this._extra, ...captureContext.extra };
      this._contexts = { ...this._contexts, ...captureContext.contexts };
      if (captureContext.user) {
        this._user = captureContext.user;
      }
      if (captureContext.level) {
        this._level = captureContext.level;
      }
      if (captureContext.fingerprint) {
        this._fingerprint = captureContext.fingerprint;
      }
      if (captureContext.requestSession) {
        this._requestSession = captureContext.requestSession;
      }
    }

    return this;
  }

  /**
   * @inheritDoc
   */
   clear() {
    this._breadcrumbs = [];
    this._tags = {};
    this._extra = {};
    this._user = {};
    this._contexts = {};
    this._level = undefined;
    this._transactionName = undefined;
    this._fingerprint = undefined;
    this._requestSession = undefined;
    this._span = undefined;
    this._session = undefined;
    this._notifyScopeListeners();
    this._attachments = [];
    return this;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, maxBreadcrumbs) {
    var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, MAX_BREADCRUMBS) : MAX_BREADCRUMBS;

    // No data has been changed, so don't notify scope listeners
    if (maxCrumbs <= 0) {
      return this;
    }

    var mergedBreadcrumb = {
      timestamp: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dateTimestampInSeconds */ .yW)(),
      ...breadcrumb,
    };
    this._breadcrumbs = [...this._breadcrumbs, mergedBreadcrumb].slice(-maxCrumbs);
    this._notifyScopeListeners();

    return this;
  }

  /**
   * @inheritDoc
   */
   clearBreadcrumbs() {
    this._breadcrumbs = [];
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   addAttachment(attachment) {
    this._attachments.push(attachment);
    return this;
  }

  /**
   * @inheritDoc
   */
   getAttachments() {
    return this._attachments;
  }

  /**
   * @inheritDoc
   */
   clearAttachments() {
    this._attachments = [];
    return this;
  }

  /**
   * Applies the current context and fingerprint to the event.
   * Note that breadcrumbs will be added by the client.
   * Also if the event has already breadcrumbs on it, we do not merge them.
   * @param event Event
   * @param hint May contain additional information about the original exception.
   * @hidden
   */
   applyToEvent(event, hint = {}) {
    if (this._extra && Object.keys(this._extra).length) {
      event.extra = { ...this._extra, ...event.extra };
    }
    if (this._tags && Object.keys(this._tags).length) {
      event.tags = { ...this._tags, ...event.tags };
    }
    if (this._user && Object.keys(this._user).length) {
      event.user = { ...this._user, ...event.user };
    }
    if (this._contexts && Object.keys(this._contexts).length) {
      event.contexts = { ...this._contexts, ...event.contexts };
    }
    if (this._level) {
      event.level = this._level;
    }
    if (this._transactionName) {
      event.transaction = this._transactionName;
    }

    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (this._span) {
      event.contexts = { trace: this._span.getTraceContext(), ...event.contexts };
      var transactionName = this._span.transaction && this._span.transaction.name;
      if (transactionName) {
        event.tags = { transaction: transactionName, ...event.tags };
      }
    }

    this._applyFingerprint(event);

    event.breadcrumbs = [...(event.breadcrumbs || []), ...this._breadcrumbs];
    event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;

    event.sdkProcessingMetadata = { ...event.sdkProcessingMetadata, ...this._sdkProcessingMetadata };

    return this._notifyEventProcessors([...getGlobalEventProcessors(), ...this._eventProcessors], event, hint);
  }

  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */
   setSDKProcessingMetadata(newData) {
    this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...newData };

    return this;
  }

  /**
   * This will be called after {@link applyToEvent} is finished.
   */
   _notifyEventProcessors(
    processors,
    event,
    hint,
    index = 0,
  ) {
    return new _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .SyncPromise */ .cW((resolve, reject) => {
      var processor = processors[index];
      if (event === null || typeof processor !== 'function') {
        resolve(event);
      } else {
        var result = processor({ ...event }, hint) ;

        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          processor.id &&
          result === null &&
          _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log(`Event processor "${processor.id}" dropped event`);

        if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isThenable */ .J8)(result)) {
          void result
            .then(final => this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve))
            .then(null, reject);
        } else {
          void this._notifyEventProcessors(processors, result, hint, index + 1)
            .then(resolve)
            .then(null, reject);
        }
      }
    });
  }

  /**
   * This will be called on every set call.
   */
   _notifyScopeListeners() {
    // We need this check for this._notifyingListeners to be able to work on scope during updates
    // If this check is not here we'll produce endless recursion when something is done with the scope
    // during the callback.
    if (!this._notifyingListeners) {
      this._notifyingListeners = true;
      this._scopeListeners.forEach(callback => {
        callback(this);
      });
      this._notifyingListeners = false;
    }
  }

  /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */
   _applyFingerprint(event) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint
      ? Array.isArray(event.fingerprint)
        ? event.fingerprint
        : [event.fingerprint]
      : [];

    // If we have something on the scope, then merge it with event
    if (this._fingerprint) {
      event.fingerprint = event.fingerprint.concat(this._fingerprint);
    }

    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) {
      delete event.fingerprint;
    }
  }
}

/**
 * Returns the global event processors.
 */
function getGlobalEventProcessors() {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .getGlobalSingleton */ .Y)('globalEventProcessors', () => []);
}

/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
  getGlobalEventProcessors().push(callback);
}


//# sourceMappingURL=scope.js.map


/***/ }),

/***/ 95771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RJ": function() { return /* binding */ closeSession; },
/* harmony export */   "Hv": function() { return /* binding */ makeSession; },
/* harmony export */   "CT": function() { return /* binding */ updateSession; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20535);


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */
function makeSession(context) {
  // Both timestamp and started are in seconds since the UNIX epoch.
  var startingTime = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();

  var session = {
    sid: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
    init: true,
    timestamp: startingTime,
    started: startingTime,
    duration: 0,
    status: 'ok',
    errors: 0,
    ignoreDuration: false,
    toJSON: () => sessionToJSON(session),
  };

  if (context) {
    updateSession(session, context);
  }

  return session;
}

/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */
function updateSession(session, context = {}) {
  if (context.user) {
    if (!session.ipAddress && context.user.ip_address) {
      session.ipAddress = context.user.ip_address;
    }

    if (!session.did && !context.did) {
      session.did = context.user.id || context.user.email || context.user.username;
    }
  }

  session.timestamp = context.timestamp || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();

  if (context.ignoreDuration) {
    session.ignoreDuration = context.ignoreDuration;
  }
  if (context.sid) {
    // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)();
  }
  if (context.init !== undefined) {
    session.init = context.init;
  }
  if (!session.did && context.did) {
    session.did = `${context.did}`;
  }
  if (typeof context.started === 'number') {
    session.started = context.started;
  }
  if (session.ignoreDuration) {
    session.duration = undefined;
  } else if (typeof context.duration === 'number') {
    session.duration = context.duration;
  } else {
    var duration = session.timestamp - session.started;
    session.duration = duration >= 0 ? duration : 0;
  }
  if (context.release) {
    session.release = context.release;
  }
  if (context.environment) {
    session.environment = context.environment;
  }
  if (!session.ipAddress && context.ipAddress) {
    session.ipAddress = context.ipAddress;
  }
  if (!session.userAgent && context.userAgent) {
    session.userAgent = context.userAgent;
  }
  if (typeof context.errors === 'number') {
    session.errors = context.errors;
  }
  if (context.status) {
    session.status = context.status;
  }
}

/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */
function closeSession(session, status) {
  let context = {};
  if (status) {
    context = { status };
  } else if (session.status === 'ok') {
    context = { status: 'exited' };
  }

  updateSession(session, context);
}

/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */
function sessionToJSON(session) {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dropUndefinedKeys */ .Jr)({
    sid: `${session.sid}`,
    init: session.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(session.started * 1000).toISOString(),
    timestamp: new Date(session.timestamp * 1000).toISOString(),
    status: session.status,
    errors: session.errors,
    did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
    duration: session.duration,
    attrs: {
      release: session.release,
      environment: session.environment,
      ip_address: session.ipAddress,
      user_agent: session.userAgent,
    },
  });
}


//# sourceMappingURL=session.js.map


/***/ }),

/***/ 62758:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ro": function() { return /* binding */ addExtensionMethods; },
  "lb": function() { return /* binding */ startIdleTransaction; }
});

// UNUSED EXPORTS: _addTracingExtensions

// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/hub.js
var hub = __webpack_require__(38641);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(12343);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/node.js + 1 modules
var node = __webpack_require__(92448);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__(9732);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/utils.js
var utils = __webpack_require__(63233);
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/errors.js



/**
 * Configures global error listeners
 */
function registerErrorInstrumentation() {
  (0,instrument/* addInstrumentationHandler */.o)('error', errorCallback);
  (0,instrument/* addInstrumentationHandler */.o)('unhandledrejection', errorCallback);
}

/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */
function errorCallback() {
  var activeTransaction = (0,utils/* getActiveTransaction */.x1)();
  if (activeTransaction) {
    var status = 'internal_error';
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] Transaction: ${status} -> Global error occured`);
    activeTransaction.setStatus(status);
  }
}


//# sourceMappingURL=errors.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/idletransaction.js
var idletransaction = __webpack_require__(16458);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/transaction.js
var esm_transaction = __webpack_require__(33391);
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/hubextensions.js
/* module decorator */ module = __webpack_require__.hmd(module);







/** Returns all trace headers that are currently on the top scope. */
function traceHeaders() {
  var scope = this.getScope();
  if (scope) {
    var span = scope.getSpan();
    if (span) {
      return {
        'sentry-trace': span.toTraceparent(),
      };
    }
  }
  return {};
}

/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * @param transaction: The transaction needing a sampling decision
 * @param options: The current client's options, so we can access `tracesSampleRate` and/or `tracesSampler`
 * @param samplingContext: Default and user-provided data which may be used to help make the decision
 *
 * @returns The given transaction with its `sampled` value set
 */
function sample(
  transaction,
  options,
  samplingContext,
) {
  // nothing to do if tracing is not enabled
  if (!(0,utils/* hasTracingEnabled */.zu)(options)) {
    transaction.sampled = false;
    return transaction;
  }

  // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
  if (transaction.sampled !== undefined) {
    transaction.setMetadata({
      transactionSampling: { method: 'explicitly_set' },
    });
    return transaction;
  }

  // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
  // work; prefer the hook if so
  let sampleRate;
  if (typeof options.tracesSampler === 'function') {
    sampleRate = options.tracesSampler(samplingContext);
    transaction.setMetadata({
      transactionSampling: {
        method: 'client_sampler',
        // cast to number in case it's a boolean
        rate: Number(sampleRate),
      },
    });
  } else if (samplingContext.parentSampled !== undefined) {
    sampleRate = samplingContext.parentSampled;
    transaction.setMetadata({
      transactionSampling: { method: 'inheritance' },
    });
  } else {
    sampleRate = options.tracesSampleRate;
    transaction.setMetadata({
      transactionSampling: {
        method: 'client_rate',
        // cast to number in case it's a boolean
        rate: Number(sampleRate),
      },
    });
  }

  // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
  // only valid values are booleans or numbers between 0 and 1.)
  if (!isValidSampleRate(sampleRate)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('[Tracing] Discarding transaction because of invalid sample rate.');
    transaction.sampled = false;
    return transaction;
  }

  // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
  if (!sampleRate) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.log */.kg.log(
        `[Tracing] Discarding transaction because ${
          typeof options.tracesSampler === 'function'
            ? 'tracesSampler returned 0 or false'
            : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'
        }`,
      );
    transaction.sampled = false;
    return transaction;
  }

  // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
  // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
  transaction.sampled = Math.random() < (sampleRate );

  // if we're not going to keep it, we're done
  if (!transaction.sampled) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.log */.kg.log(
        `[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(
          sampleRate,
        )})`,
      );
    return transaction;
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] starting ${transaction.op} transaction - ${transaction.name}`);
  return transaction;
}

/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */
function isValidSampleRate(rate) {
  // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    if ((0,is/* isNaN */.i2)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn(
        `[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
          rate,
        )} of type ${JSON.stringify(typeof rate)}.`,
      );
    return false;
  }

  // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
  if (rate < 0 || rate > 1) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
    return false;
  }
  return true;
}

/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */
function _startTransaction(
  
  transactionContext,
  customSamplingContext,
) {
  var client = this.getClient();
  var options = (client && client.getOptions()) || {};

  let transaction = new esm_transaction/* Transaction */.Y(transactionContext, this);
  transaction = sample(transaction, options, {
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    ...customSamplingContext,
  });
  if (transaction.sampled) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  return transaction;
}

/**
 * Create new idle transaction.
 */
function startIdleTransaction(
  hub,
  transactionContext,
  idleTimeout,
  finalTimeout,
  onScope,
  customSamplingContext,
) {
  var client = hub.getClient();
  var options = (client && client.getOptions()) || {};

  let transaction = new idletransaction/* IdleTransaction */.io(transactionContext, hub, idleTimeout, finalTimeout, onScope);
  transaction = sample(transaction, options, {
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    ...customSamplingContext,
  });
  if (transaction.sampled) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  return transaction;
}

/**
 * @private
 */
function _addTracingExtensions() {
  var carrier = (0,hub/* getMainCarrier */.cu)();
  if (!carrier.__SENTRY__) {
    return;
  }
  carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
  if (!carrier.__SENTRY__.extensions.startTransaction) {
    carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
  }
  if (!carrier.__SENTRY__.extensions.traceHeaders) {
    carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
  }
}

/**
 * @private
 */
function _autoloadDatabaseIntegrations() {
  var carrier = (0,hub/* getMainCarrier */.cu)();
  if (!carrier.__SENTRY__) {
    return;
  }

  var packageToIntegrationMapping = {
    mongodb() {
      var integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mongo') 

;
      return new integration.Mongo();
    },
    mongoose() {
      var integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mongo') 

;
      return new integration.Mongo({ mongoose: true });
    },
    mysql() {
      var integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mysql') 

;
      return new integration.Mysql();
    },
    pg() {
      var integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/postgres') 

;
      return new integration.Postgres();
    },
  };

  var mappedPackages = Object.keys(packageToIntegrationMapping)
    .filter(moduleName => !!(0,node/* loadModule */.$y)(moduleName))
    .map(pkg => {
      try {
        return packageToIntegrationMapping[pkg]();
      } catch (e) {
        return undefined;
      }
    })
    .filter(p => p) ;

  if (mappedPackages.length > 0) {
    carrier.__SENTRY__.integrations = [...(carrier.__SENTRY__.integrations || []), ...mappedPackages];
  }
}

/**
 * This patches the global object and injects the Tracing extensions methods
 */
function addExtensionMethods() {
  _addTracingExtensions();

  // Detect and automatically load specified integrations.
  if ((0,node/* isNodeEnv */.KV)()) {
    _autoloadDatabaseIntegrations();
  }

  // If an error happens globally, we should make sure transaction status is set to error.
  registerErrorInstrumentation();
}


//# sourceMappingURL=hubextensions.js.map


/***/ }),

/***/ 16458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mg": function() { return /* binding */ DEFAULT_FINAL_TIMEOUT; },
/* harmony export */   "nT": function() { return /* binding */ DEFAULT_IDLE_TIMEOUT; },
/* harmony export */   "io": function() { return /* binding */ IdleTransaction; }
/* harmony export */ });
/* unused harmony exports HEARTBEAT_INTERVAL, IdleTransactionSpanRecorder */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12343);
/* harmony import */ var _span_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55334);
/* harmony import */ var _transaction_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33391);




var DEFAULT_IDLE_TIMEOUT = 1000;
var DEFAULT_FINAL_TIMEOUT = 30000;
var HEARTBEAT_INTERVAL = 5000;

/**
 * @inheritDoc
 */
class IdleTransactionSpanRecorder extends _span_js__WEBPACK_IMPORTED_MODULE_0__/* .SpanRecorder */ .gB {
   constructor(
      _pushActivity,
      _popActivity,
     transactionSpanId,
    maxlen,
  ) {
    super(maxlen);this._pushActivity = _pushActivity;this._popActivity = _popActivity;this.transactionSpanId = transactionSpanId;;
  }

  /**
   * @inheritDoc
   */
   add(span) {
    // We should make sure we do not push and pop activities for
    // the transaction that this span recorder belongs to.
    if (span.spanId !== this.transactionSpanId) {
      // We patch span.finish() to pop an activity after setting an endTimestamp.
      span.finish = (endTimestamp) => {
        span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();
        this._popActivity(span.spanId);
      };

      // We should only push new activities if the span does not have an end timestamp.
      if (span.endTimestamp === undefined) {
        this._pushActivity(span.spanId);
      }
    }

    super.add(span);
  }
}

/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */
class IdleTransaction extends _transaction_js__WEBPACK_IMPORTED_MODULE_2__/* .Transaction */ .Y {
  // Activities store a list of active spans
   __init() {this.activities = {};}

  // Track state of activities in previous heartbeat
  

  // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
   __init2() {this._heartbeatCounter = 0;}

  // We should not use heartbeat if we finished a transaction
   __init3() {this._finished = false;}

    __init4() {this._beforeFinishCallbacks = [];}

  /**
   * Timer that tracks Transaction idleTimeout
   */
  

   constructor(
    transactionContext,
      _idleHub,
    /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */
      _idleTimeout = DEFAULT_IDLE_TIMEOUT,
    /**
     * The final value in ms that a transaction cannot exceed
     */
      _finalTimeout = DEFAULT_FINAL_TIMEOUT,
    // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
      _onScope = false,
  ) {
    super(transactionContext, _idleHub);this._idleHub = _idleHub;this._idleTimeout = _idleTimeout;this._finalTimeout = _finalTimeout;this._onScope = _onScope;IdleTransaction.prototype.__init.call(this);IdleTransaction.prototype.__init2.call(this);IdleTransaction.prototype.__init3.call(this);IdleTransaction.prototype.__init4.call(this);;

    if (_onScope) {
      // There should only be one active transaction on the scope
      clearActiveTransaction(_idleHub);

      // We set the transaction here on the scope so error events pick up the trace
      // context and attach it to the error.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`Setting idle transaction on scope. Span ID: ${this.spanId}`);
      _idleHub.configureScope(scope => scope.setSpan(this));
    }

    this._startIdleTimeout();
    setTimeout(() => {
      if (!this._finished) {
        this.setStatus('deadline_exceeded');
        this.finish();
      }
    }, this._finalTimeout);
  }

  /** {@inheritDoc} */
   finish(endTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)()) {
    this._finished = true;
    this.activities = {};

    if (this.spanRecorder) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);

      for (var callback of this._beforeFinishCallbacks) {
        callback(this, endTimestamp);
      }

      this.spanRecorder.spans = this.spanRecorder.spans.filter((span) => {
        // If we are dealing with the transaction itself, we just return it
        if (span.spanId === this.spanId) {
          return true;
        }

        // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
        if (!span.endTimestamp) {
          span.endTimestamp = endTimestamp;
          span.setStatus('cancelled');
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
            _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
        }

        var keepSpan = span.startTimestamp < endTimestamp;
        if (!keepSpan) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
            _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(
              '[Tracing] discarding Span since it happened after Transaction was finished',
              JSON.stringify(span, undefined, 2),
            );
        }
        return keepSpan;
      });

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] flushing IdleTransaction');
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] No active IdleTransaction');
    }

    // if `this._onScope` is `true`, the transaction put itself on the scope when it started
    if (this._onScope) {
      clearActiveTransaction(this._idleHub);
    }

    return super.finish(endTimestamp);
  }

  /**
   * Register a callback function that gets excecuted before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */
   registerBeforeFinishCallback(callback) {
    this._beforeFinishCallbacks.push(callback);
  }

  /**
   * @inheritDoc
   */
   initSpanRecorder(maxlen) {
    if (!this.spanRecorder) {
      var pushActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._pushActivity(id);
      };
      var popActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._popActivity(id);
      };

      this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanId, maxlen);

      // Start heartbeat so that transactions do not run forever.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('Starting heartbeat');
      this._pingHeartbeat();
    }
    this.spanRecorder.add(this);
  }

  /**
   * Cancels the existing idletimeout, if there is one
   */
   _cancelIdleTimeout() {
    if (this._idleTimeoutID) {
      clearTimeout(this._idleTimeoutID);
      this._idleTimeoutID = undefined;
    }
  }

  /**
   * Creates an idletimeout
   */
   _startIdleTimeout(endTimestamp) {
    this._cancelIdleTimeout();
    this._idleTimeoutID = setTimeout(() => {
      if (!this._finished && Object.keys(this.activities).length === 0) {
        this.finish(endTimestamp);
      }
    }, this._idleTimeout);
  }

  /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */
   _pushActivity(spanId) {
    this._cancelIdleTimeout();
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`[Tracing] pushActivity: ${spanId}`);
    this.activities[spanId] = true;
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
  }

  /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */
   _popActivity(spanId) {
    if (this.activities[spanId]) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`[Tracing] popActivity ${spanId}`);
            delete this.activities[spanId];
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
    }

    if (Object.keys(this.activities).length === 0) {
      // We need to add the timeout here to have the real endtimestamp of the transaction
      // Remember timestampWithMs is in seconds, timeout is in ms
      var endTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)() + this._idleTimeout / 1000;
      this._startIdleTimeout(endTimestamp);
    }
  }

  /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */
   _beat() {
    // We should not be running heartbeat if the idle transaction is finished.
    if (this._finished) {
      return;
    }

    var heartbeatString = Object.keys(this.activities).join('');

    if (heartbeatString === this._prevHeartbeatString) {
      this._heartbeatCounter += 1;
    } else {
      this._heartbeatCounter = 1;
    }

    this._prevHeartbeatString = heartbeatString;

    if (this._heartbeatCounter >= 3) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] Transaction finished because of no change for 3 heart beats');
      this.setStatus('deadline_exceeded');
      this.finish();
    } else {
      this._pingHeartbeat();
    }
  }

  /**
   * Pings the heartbeat
   */
   _pingHeartbeat() {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
    setTimeout(() => {
      this._beat();
    }, HEARTBEAT_INTERVAL);
  }
}

/**
 * Reset transaction on scope to `undefined`
 */
function clearActiveTransaction(hub) {
  var scope = hub.getScope();
  if (scope) {
    var transaction = scope.getTransaction();
    if (transaction) {
      scope.setSpan(undefined);
    }
  }
}


//# sourceMappingURL=idletransaction.js.map


/***/ }),

/***/ 55334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dr": function() { return /* binding */ Span; },
/* harmony export */   "gB": function() { return /* binding */ SpanRecorder; }
/* harmony export */ });
/* unused harmony export spanStatusfromHttpCode */
/* harmony import */ var _sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45375);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20535);



/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */
class SpanRecorder {
   __init() {this.spans = [];}

   constructor(maxlen = 1000) {;SpanRecorder.prototype.__init.call(this);
    this._maxlen = maxlen;
  }

  /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */
   add(span) {
    if (this.spans.length > this._maxlen) {
      span.spanRecorder = undefined;
    } else {
      this.spans.push(span);
    }
  }
}

/**
 * Span contains all data about a span
 */
class Span  {
  /**
   * @inheritDoc
   */
   __init2() {this.traceId = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)();}

  /**
   * @inheritDoc
   */
   __init3() {this.spanId = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)().substring(16);}

  /**
   * @inheritDoc
   */
  

  /**
   * Internal keeper of the status
   */
  

  /**
   * @inheritDoc
   */
  

  /**
   * Timestamp in seconds when the span was created.
   */
   __init4() {this.startTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();}

  /**
   * Timestamp in seconds when the span ended.
   */
  

  /**
   * @inheritDoc
   */
  

  /**
   * @inheritDoc
   */
  

  /**
   * @inheritDoc
   */
   __init5() {this.tags = {};}

  /**
   * @inheritDoc
   */
     __init6() {this.data = {};}

  /**
   * List of spans that were finalized
   */
  

  /**
   * @inheritDoc
   */
  

  /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */
   constructor(spanContext) {;Span.prototype.__init2.call(this);Span.prototype.__init3.call(this);Span.prototype.__init4.call(this);Span.prototype.__init5.call(this);Span.prototype.__init6.call(this);
    if (!spanContext) {
      return this;
    }
    if (spanContext.traceId) {
      this.traceId = spanContext.traceId;
    }
    if (spanContext.spanId) {
      this.spanId = spanContext.spanId;
    }
    if (spanContext.parentSpanId) {
      this.parentSpanId = spanContext.parentSpanId;
    }
    // We want to include booleans as well here
    if ('sampled' in spanContext) {
      this.sampled = spanContext.sampled;
    }
    if (spanContext.op) {
      this.op = spanContext.op;
    }
    if (spanContext.description) {
      this.description = spanContext.description;
    }
    if (spanContext.data) {
      this.data = spanContext.data;
    }
    if (spanContext.tags) {
      this.tags = spanContext.tags;
    }
    if (spanContext.status) {
      this.status = spanContext.status;
    }
    if (spanContext.startTimestamp) {
      this.startTimestamp = spanContext.startTimestamp;
    }
    if (spanContext.endTimestamp) {
      this.endTimestamp = spanContext.endTimestamp;
    }
  }

  /**
   * @inheritDoc
   */
   startChild(
    spanContext,
  ) {
    var childSpan = new Span({
      ...spanContext,
      parentSpanId: this.spanId,
      sampled: this.sampled,
      traceId: this.traceId,
    });

    childSpan.spanRecorder = this.spanRecorder;
    if (childSpan.spanRecorder) {
      childSpan.spanRecorder.add(childSpan);
    }

    childSpan.transaction = this.transaction;

    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && childSpan.transaction) {
      var opStr = (spanContext && spanContext.op) || '< unknown op >';
      var nameStr = childSpan.transaction.name || '< unknown name >';
      var idStr = childSpan.transaction.spanId;

      var logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
      childSpan.transaction.metadata.spanMetadata[childSpan.spanId] = { logMessage };
      _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log(logMessage);
    }

    return childSpan;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this.tags = { ...this.tags, [key]: value };
    return this;
  }

  /**
   * @inheritDoc
   */
     setData(key, value) {
    this.data = { ...this.data, [key]: value };
    return this;
  }

  /**
   * @inheritDoc
   */
   setStatus(value) {
    this.status = value;
    return this;
  }

  /**
   * @inheritDoc
   */
   setHttpStatus(httpStatus) {
    this.setTag('http.status_code', String(httpStatus));
    var spanStatus = spanStatusfromHttpCode(httpStatus);
    if (spanStatus !== 'unknown_error') {
      this.setStatus(spanStatus);
    }
    return this;
  }

  /**
   * @inheritDoc
   */
   isSuccess() {
    return this.status === 'ok';
  }

  /**
   * @inheritDoc
   */
   finish(endTimestamp) {
    if (
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      // Don't call this for transactions
      this.transaction &&
      this.transaction.spanId !== this.spanId
    ) {
      const { logMessage } = this.transaction.metadata.spanMetadata[this.spanId];
      if (logMessage) {
        _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log((logMessage ).replace('Starting', 'Finishing'));
      }
    }

    this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();
  }

  /**
   * @inheritDoc
   */
   toTraceparent() {
    let sampledString = '';
    if (this.sampled !== undefined) {
      sampledString = this.sampled ? '-1' : '-0';
    }
    return `${this.traceId}-${this.spanId}${sampledString}`;
  }

  /**
   * @inheritDoc
   */
   toContext() {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      data: this.data,
      description: this.description,
      endTimestamp: this.endTimestamp,
      op: this.op,
      parentSpanId: this.parentSpanId,
      sampled: this.sampled,
      spanId: this.spanId,
      startTimestamp: this.startTimestamp,
      status: this.status,
      tags: this.tags,
      traceId: this.traceId,
    });
  }

  /**
   * @inheritDoc
   */
   updateWithContext(spanContext) {
    this.data = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__/* ._nullishCoalesce */ .h)(spanContext.data, () => ( {}));
    this.description = spanContext.description;
    this.endTimestamp = spanContext.endTimestamp;
    this.op = spanContext.op;
    this.parentSpanId = spanContext.parentSpanId;
    this.sampled = spanContext.sampled;
    this.spanId = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__/* ._nullishCoalesce */ .h)(spanContext.spanId, () => ( this.spanId));
    this.startTimestamp = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__/* ._nullishCoalesce */ .h)(spanContext.startTimestamp, () => ( this.startTimestamp));
    this.status = spanContext.status;
    this.tags = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__/* ._nullishCoalesce */ .h)(spanContext.tags, () => ( {}));
    this.traceId = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__/* ._nullishCoalesce */ .h)(spanContext.traceId, () => ( this.traceId));

    return this;
  }

  /**
   * @inheritDoc
   */
   getTraceContext()

 {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      data: Object.keys(this.data).length > 0 ? this.data : undefined,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      trace_id: this.traceId,
    });
  }

  /**
   * @inheritDoc
   */
   toJSON()

 {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      data: Object.keys(this.data).length > 0 ? this.data : undefined,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      start_timestamp: this.startTimestamp,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      timestamp: this.endTimestamp,
      trace_id: this.traceId,
    });
  }
}

/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */
function spanStatusfromHttpCode(httpStatus) {
  if (httpStatus < 400 && httpStatus >= 100) {
    return 'ok';
  }

  if (httpStatus >= 400 && httpStatus < 500) {
    switch (httpStatus) {
      case 401:
        return 'unauthenticated';
      case 403:
        return 'permission_denied';
      case 404:
        return 'not_found';
      case 409:
        return 'already_exists';
      case 413:
        return 'failed_precondition';
      case 429:
        return 'resource_exhausted';
      default:
        return 'invalid_argument';
    }
  }

  if (httpStatus >= 500 && httpStatus < 600) {
    switch (httpStatus) {
      case 501:
        return 'unimplemented';
      case 503:
        return 'unavailable';
      case 504:
        return 'deadline_exceeded';
      default:
        return 'internal_error';
    }
  }

  return 'unknown_error';
}


//# sourceMappingURL=span.js.map


/***/ }),

/***/ 33391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ Transaction; }
/* harmony export */ });
/* harmony import */ var _sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45375);
/* harmony import */ var _sentry_hub__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38641);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20535);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99181);
/* harmony import */ var _span_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55334);





/** JSDoc */
class Transaction extends _span_js__WEBPACK_IMPORTED_MODULE_0__/* .Span */ .Dr  {
  

  /**
   * The reference to the current hub.
   */
  

   __init() {this._measurements = {};}

  /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   */
   constructor(transactionContext, hub) {
    super(transactionContext);Transaction.prototype.__init.call(this);;

    this._hub = hub || (0,_sentry_hub__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)();

    this._name = transactionContext.name || '';

    this.metadata = {
      ...transactionContext.metadata,
      spanMetadata: {},
    };

    this._trimEnd = transactionContext.trimEnd;

    // this is because transactions are also spans, and spans have a transaction pointer
    this.transaction = this;
  }

  /** Getter for `name` property */
   get name() {
    return this._name;
  }

  /** Setter for `name` property, which also sets `source` */
   set name(newName) {
    this._name = newName;
    this.metadata.source = 'custom';
  }

  /**
   * JSDoc
   */
   setName(name, source = 'custom') {
    this.name = name;
    this.metadata.source = source;
  }

  /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */
   initSpanRecorder(maxlen = 1000) {
    if (!this.spanRecorder) {
      this.spanRecorder = new _span_js__WEBPACK_IMPORTED_MODULE_0__/* .SpanRecorder */ .gB(maxlen);
    }
    this.spanRecorder.add(this);
  }

  /**
   * @inheritDoc
   */
   setMeasurement(name, value, unit = '') {
    this._measurements[name] = { value, unit };
  }

  /**
   * @inheritDoc
   */
   setMetadata(newMetadata) {
    this.metadata = { ...this.metadata, ...newMetadata };
  }

  /**
   * @inheritDoc
   */
   finish(endTimestamp) {
    // This transaction is already finished, so we should not flush it again.
    if (this.endTimestamp !== undefined) {
      return undefined;
    }

    if (!this.name) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
      this.name = '<unlabeled transaction>';
    }

    // just sets the end timestamp
    super.finish(endTimestamp);

    if (this.sampled !== true) {
      // At this point if `sampled !== true` we want to discard the transaction.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');

      var client = this._hub.getClient();
      if (client) {
        client.recordDroppedEvent('sample_rate', 'transaction');
      }

      return undefined;
    }

    var finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(s => s !== this && s.endTimestamp) : [];

    if (this._trimEnd && finishedSpans.length > 0) {
      this.endTimestamp = finishedSpans.reduce((prev, current) => {
        if (prev.endTimestamp && current.endTimestamp) {
          return prev.endTimestamp > current.endTimestamp ? prev : current;
        }
        return prev;
      }).endTimestamp;
    }

    var metadata = this.metadata;

    var transaction = {
      contexts: {
        trace: this.getTraceContext(),
      },
      spans: finishedSpans,
      start_timestamp: this.startTimestamp,
      tags: this.tags,
      timestamp: this.endTimestamp,
      transaction: this.name,
      type: 'transaction',
      sdkProcessingMetadata: {
        ...metadata,
        baggage: this.getBaggage(),
      },
      ...(metadata.source && {
        transaction_info: {
          source: metadata.source,
        },
      }),
    };

    var hasMeasurements = Object.keys(this._measurements).length > 0;

    if (hasMeasurements) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log(
          '[Measurements] Adding measurements to transaction',
          JSON.stringify(this._measurements, undefined, 2),
        );
      transaction.measurements = this._measurements;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log(`[Tracing] Finishing ${this.op} transaction: ${this.name}.`);

    return this._hub.captureEvent(transaction);
  }

  /**
   * @inheritDoc
   */
   toContext() {
    var spanContext = super.toContext();

    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      ...spanContext,
      name: this.name,
      trimEnd: this._trimEnd,
    });
  }

  /**
   * @inheritDoc
   */
   updateWithContext(transactionContext) {
    super.updateWithContext(transactionContext);

    this.name = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__/* ._nullishCoalesce */ .h)(transactionContext.name, () => ( ''));

    this._trimEnd = transactionContext.trimEnd;

    return this;
  }

  /**
   * @inheritdoc
   *
   * @experimental
   */
   getBaggage() {
    var existingBaggage = this.metadata.baggage;

    // Only add Sentry baggage items to baggage, if baggage does not exist yet or it is still
    // empty and mutable
    var finalBaggage =
      !existingBaggage || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .isBaggageMutable */ .Gp)(existingBaggage)
        ? this._populateBaggageWithSentryValues(existingBaggage)
        : existingBaggage;

    // Update the baggage stored on the transaction.
    this.metadata.baggage = finalBaggage;

    return finalBaggage;
  }

  /**
   * Collects and adds data to the passed baggage object.
   *
   * Note: This function does not explicitly check if the passed baggage object is allowed
   * to be modified. Implicitly, `setBaggageValue` will not make modification to the object
   * if it was already set immutable.
   *
   * After adding the data, the baggage object is set immutable to prevent further modifications.
   *
   * @param baggage
   *
   * @returns modified and immutable baggage object
   */
   _populateBaggageWithSentryValues(baggage = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .createBaggage */ .Hn)({})) {
    var hub = this._hub || (0,_sentry_hub__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)();
    var client = hub && hub.getClient();

    if (!client) return baggage;

    const { environment, release } = client.getOptions() || {};
    const { publicKey: public_key } = client.getDsn() || {};

    var rate = this.metadata && this.metadata.transactionSampling && this.metadata.transactionSampling.rate;
    var sample_rate =
      rate !== undefined
        ? rate.toLocaleString('fullwide', { useGrouping: false, maximumFractionDigits: 16 })
        : undefined;

    var scope = hub.getScope();
    const { segment: user_segment } = (scope && scope.getUser()) || {};

    var source = this.metadata.source;
    var transaction = source && source !== 'url' ? this.name : undefined;

    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .createBaggage */ .Hn)(
      (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
        environment,
        release,
        transaction,
        user_segment,
        public_key,
        trace_id: this.traceId,
        sample_rate,
        ...(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .getSentryBaggageItems */ .Hk)(baggage), // keep user-added values
      } ),
      '',
      false, // set baggage immutable
    );
  }
}


//# sourceMappingURL=transaction.js.map


/***/ }),

/***/ 63233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x1": function() { return /* binding */ getActiveTransaction; },
/* harmony export */   "zu": function() { return /* binding */ hasTracingEnabled; },
/* harmony export */   "XL": function() { return /* binding */ msToSec; }
/* harmony export */ });
/* unused harmony export secToMs */
/* harmony import */ var _sentry_hub__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38641);



/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */
function hasTracingEnabled(
  maybeOptions,
) {
  var client = (0,_sentry_hub__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().getClient();
  var options = maybeOptions || (client && client.getOptions());
  return !!options && ('tracesSampleRate' in options || 'tracesSampler' in options);
}

/** Grabs active transaction off scope, if any */
function getActiveTransaction(maybeHub) {
  var hub = maybeHub || (0,_sentry_hub__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
  var scope = hub.getScope();
  return scope && (scope.getTransaction() );
}

/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */
function msToSec(time) {
  return time / 1000;
}

/**
 * Converts from seconds to milliseconds
 * @param time time in seconds
 */
function secToMs(time) {
  return time * 1000;
}


//# sourceMappingURL=utils.js.map


/***/ }),

/***/ 99181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bU": function() { return /* binding */ BAGGAGE_HEADER_NAME; },
/* harmony export */   "Hn": function() { return /* binding */ createBaggage; },
/* harmony export */   "Hk": function() { return /* binding */ getSentryBaggageItems; },
/* harmony export */   "Gp": function() { return /* binding */ isBaggageMutable; },
/* harmony export */   "J8": function() { return /* binding */ mergeAndSerializeBaggage; },
/* harmony export */   "rg": function() { return /* binding */ parseBaggageSetMutability; }
/* harmony export */ });
/* unused harmony exports MAX_BAGGAGE_STRING_LENGTH, SENTRY_BAGGAGE_KEY_PREFIX, SENTRY_BAGGAGE_KEY_PREFIX_REGEX, getBaggageValue, getThirdPartyBaggage, isSentryBaggageEmpty, parseBaggageHeader, serializeBaggage, setBaggageImmutable, setBaggageValue */
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12343);



var BAGGAGE_HEADER_NAME = 'baggage';

var SENTRY_BAGGAGE_KEY_PREFIX = 'sentry-';

var SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;

/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */
var MAX_BAGGAGE_STRING_LENGTH = 8192;

/** Create an instance of Baggage */
function createBaggage(initItems, baggageString = '', mutable = true) {
  return [{ ...initItems }, baggageString, mutable];
}

/** Get a value from baggage */
function getBaggageValue(baggage, key) {
  return baggage[0][key];
}

/** Add a value to baggage */
function setBaggageValue(baggage, key, value) {
  if (isBaggageMutable(baggage)) {
    baggage[0][key] = value;
  }
}

/** Check if the Sentry part of the passed baggage (i.e. the first element in the tuple) is empty */
function isSentryBaggageEmpty(baggage) {
  return Object.keys(baggage[0]).length === 0;
}

/** Returns Sentry specific baggage values */
function getSentryBaggageItems(baggage) {
  return baggage[0];
}

/**
 * Returns 3rd party baggage string of @param baggage
 * @param baggage
 */
function getThirdPartyBaggage(baggage) {
  return baggage[1];
}

/**
 * Checks if baggage is mutable
 * @param baggage
 * @returns true if baggage is mutable, else false
 */
function isBaggageMutable(baggage) {
  return baggage[2];
}

/**
 * Sets the passed baggage immutable
 * @param baggage
 */
function setBaggageImmutable(baggage) {
  baggage[2] = false;
}

/** Serialize a baggage object */
function serializeBaggage(baggage) {
  return Object.keys(baggage[0]).reduce((prev, key) => {
    var val = baggage[0][key] ;
    var baggageEntry = `${SENTRY_BAGGAGE_KEY_PREFIX}${encodeURIComponent(key)}=${encodeURIComponent(val)}`;
    var newVal = prev === '' ? baggageEntry : `${prev},${baggageEntry}`;
    if (newVal.length > MAX_BAGGAGE_STRING_LENGTH) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _logger_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.warn */ .kg.warn(`Not adding key: ${key} with val: ${val} to baggage due to exceeding baggage size limits.`);
      return prev;
    } else {
      return newVal;
    }
  }, baggage[1]);
}

/**
 * Parse a baggage header from a string or a string array and return a Baggage object
 *
 * If @param includeThirdPartyEntries is set to true, third party baggage entries are added to the Baggage object
 * (This is necessary for merging potentially pre-existing baggage headers in outgoing requests with
 * our `sentry-` values)
 */
function parseBaggageHeader(
  inputBaggageValue,
  includeThirdPartyEntries = false,
) {
  // Adding this check here because we got reports of this function failing due to the input value
  // not being a string. This debug log might help us determine what's going on here.
  if ((!Array.isArray(inputBaggageValue) && !(0,_is_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .HD)(inputBaggageValue)) || typeof inputBaggageValue === 'number') {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      _logger_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.warn */ .kg.warn(
        '[parseBaggageHeader] Received input value of incompatible type: ',
        typeof inputBaggageValue,
        inputBaggageValue,
      );

    // Gonna early-return an empty baggage object so that we don't fail later on
    return createBaggage({}, '');
  }

  var baggageEntries = ((0,_is_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .HD)(inputBaggageValue) ? inputBaggageValue : inputBaggageValue.join(','))
    .split(',')
    .map(entry => entry.trim())
    .filter(entry => entry !== '' && (includeThirdPartyEntries || SENTRY_BAGGAGE_KEY_PREFIX_REGEX.test(entry)));

  return baggageEntries.reduce(
    ([baggageObj, baggageString], curr) => {
      const [key, val] = curr.split('=');
      if (SENTRY_BAGGAGE_KEY_PREFIX_REGEX.test(key)) {
        var baggageKey = decodeURIComponent(key.split('-')[1]);
        return [
          {
            ...baggageObj,
            [baggageKey]: decodeURIComponent(val),
          },
          baggageString,
          true,
        ];
      } else {
        return [baggageObj, baggageString === '' ? curr : `${baggageString},${curr}`, true];
      }
    },
    [{}, '', true],
  );
}

/**
 * Merges the baggage header we saved from the incoming request (or meta tag) with
 * a possibly created or modified baggage header by a third party that's been added
 * to the outgoing request header.
 *
 * In case @param headerBaggageString exists, we can safely add the the 3rd party part of @param headerBaggage
 * with our @param incomingBaggage. This is possible because if we modified anything beforehand,
 * it would only affect parts of the sentry baggage (@see Baggage interface).
 *
 * @param incomingBaggage the baggage header of the incoming request that might contain sentry entries
 * @param thirdPartyBaggageHeader possibly existing baggage header string or string[] added from a third
 *        party to the request headers
 *
 * @return a merged and serialized baggage string to be propagated with the outgoing request
 */
function mergeAndSerializeBaggage(incomingBaggage, thirdPartyBaggageHeader) {
  if (!incomingBaggage && !thirdPartyBaggageHeader) {
    return '';
  }

  var headerBaggage = (thirdPartyBaggageHeader && parseBaggageHeader(thirdPartyBaggageHeader, true)) || undefined;
  var thirdPartyHeaderBaggage = headerBaggage && getThirdPartyBaggage(headerBaggage);

  var finalBaggage = createBaggage((incomingBaggage && incomingBaggage[0]) || {}, thirdPartyHeaderBaggage || '');
  return serializeBaggage(finalBaggage);
}

/**
 * Helper function that takes a raw baggage string (if available) and the processed sentry-trace header
 * data (if available), parses the baggage string and creates a Baggage object
 * If there is no baggage string, it will create an empty Baggage object.
 * In a second step, this functions determines if the created Baggage object should be set immutable
 * to prevent mutation of the Sentry data.
 *
 * Extracted this logic to a function because it's duplicated in a lot of places.
 *
 * @param rawBaggageValue
 * @param sentryTraceHeader
 */
function parseBaggageSetMutability(
  rawBaggageValue,
  sentryTraceHeader,
) {
  var baggage = parseBaggageHeader(rawBaggageValue || '');

  // Because we are always creating a Baggage object by calling `parseBaggageHeader` above
  // (either a filled one or an empty one, even if we didn't get a `baggage` header),
  // we only need to check if we have a sentry-trace header or not. As soon as we have it,
  // we set baggage immutable. In case we don't get a sentry-trace header, we can assume that
  // this SDK is the head of the trace and thus we still permit mutation at this time.
  // There is one exception though, which is that we get a baggage-header with `sentry-`
  // items but NO sentry-trace header. In this case we also set the baggage immutable for now
  // but if smoething like this would ever happen, we should revisit this and determine
  // what this would actually mean for the trace (i.e. is this SDK the head?, what happened
  // before that we don't have a sentry-trace header?, etc)
  (sentryTraceHeader || !isSentryBaggageEmpty(baggage)) && setBaggageImmutable(baggage);

  return baggage;
}


//# sourceMappingURL=baggage.js.map


/***/ }),

/***/ 58464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ getLocationHref; },
/* harmony export */   "R": function() { return /* binding */ htmlTreeAsString; }
/* harmony export */ });
/* harmony import */ var _global_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82991);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);



/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(elem, keyAttrs) {
  

  // try/catch both:
  // - accessing event.target (see getsentry/raven-js#838, #768)
  // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
  // - can throw an exception in some circumstances.
  try {
    let currentElem = elem ;
    var MAX_TRAVERSE_HEIGHT = 5;
    var MAX_OUTPUT_LEN = 80;
    var out = [];
    let height = 0;
    let len = 0;
    var separator = ' > ';
    var sepLength = separator.length;
    let nextStr;

        while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
      nextStr = _htmlElementAsString(currentElem, keyAttrs);
      // bail out if
      // - nextStr is the 'html' element
      // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
      //   (ignore this limit if we are on the first iteration)
      if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
        break;
      }

      out.push(nextStr);

      len += nextStr.length;
      currentElem = currentElem.parentNode;
    }

    return out.reverse().join(separator);
  } catch (_oO) {
    return '<unknown>';
  }
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el, keyAttrs) {
  var elem = el 

;

  var out = [];
  let className;
  let classes;
  let key;
  let attr;
  let i;

  if (!elem || !elem.tagName) {
    return '';
  }

  out.push(elem.tagName.toLowerCase());

  // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
  var keyAttrPairs =
    keyAttrs && keyAttrs.length
      ? keyAttrs.filter(keyAttr => elem.getAttribute(keyAttr)).map(keyAttr => [keyAttr, elem.getAttribute(keyAttr)])
      : null;

  if (keyAttrPairs && keyAttrPairs.length) {
    keyAttrPairs.forEach(keyAttrPair => {
      out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
  } else {
    if (elem.id) {
      out.push(`#${elem.id}`);
    }

        className = elem.className;
    if (className && (0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(className)) {
      classes = className.split(/\s+/);
      for (i = 0; i < classes.length; i++) {
        out.push(`.${classes[i]}`);
      }
    }
  }
  var allowedAttrs = ['type', 'name', 'title', 'alt'];
  for (i = 0; i < allowedAttrs.length; i++) {
    key = allowedAttrs[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push(`[${key}="${attr}"]`);
    }
  }
  return out.join('');
}

/**
 * A safe form of location.href
 */
function getLocationHref() {
  var global = (0,_global_js__WEBPACK_IMPORTED_MODULE_1__/* .getGlobalObject */ .R)();
  try {
    return global.document.location.href;
  } catch (oO) {
    return '';
  }
}


//# sourceMappingURL=browser.js.map


/***/ }),

/***/ 45375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ _nullishCoalesce; }
/* harmony export */ });
/**
 * Polyfill for the nullish coalescing operator (`??`).
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */
function _nullishCoalesce(lhs, rhsFn) {
  // by checking for loose equality to `null`, we catch both `null` and `undefined`
  return lhs != null ? lhs : rhsFn();
}

// Sucrase version:
// function _nullishCoalesce(lhs, rhsFn) {
//   if (lhs != null) {
//     return lhs;
//   } else {
//     return rhsFn();
//   }
// }


//# sourceMappingURL=_nullishCoalesce.js.map


/***/ }),

/***/ 82991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getGlobalObject; },
/* harmony export */   "Y": function() { return /* binding */ getGlobalSingleton; }
/* harmony export */ });
/* harmony import */ var _node_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92448);


/** Internal */

var fallbackGlobalObject = {};

/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */
function getGlobalObject() {
  return (
    (0,_node_js__WEBPACK_IMPORTED_MODULE_0__/* .isNodeEnv */ .KV)()
      ? __webpack_require__.g
      : typeof window !== 'undefined'       ? window       : typeof self !== 'undefined'
      ? self
      : fallbackGlobalObject
  ) ;
}

/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `getGlobalObject`'s return value
 * @returns the singleton
 */
function getGlobalSingleton(name, creator, obj) {
  var global = (obj || getGlobalObject()) ;
  var __SENTRY__ = (global.__SENTRY__ = global.__SENTRY__ || {});
  var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
  return singleton;
}


//# sourceMappingURL=global.js.map


/***/ }),

/***/ 9732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ addInstrumentationHandler; }
/* harmony export */ });
/* harmony import */ var _global_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82991);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67597);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12343);
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20535);
/* harmony import */ var _stacktrace_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30360);
/* harmony import */ var _supports_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8823);







var global = (0,_global_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();

/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */

var handlers = {};
var instrumented = {};

/** Instruments given API */
function instrument(type) {
  if (instrumented[type]) {
    return;
  }

  instrumented[type] = true;

  switch (type) {
    case 'console':
      instrumentConsole();
      break;
    case 'dom':
      instrumentDOM();
      break;
    case 'xhr':
      instrumentXHR();
      break;
    case 'fetch':
      instrumentFetch();
      break;
    case 'history':
      instrumentHistory();
      break;
    case 'error':
      instrumentError();
      break;
    case 'unhandledrejection':
      instrumentUnhandledRejection();
      break;
    default:
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.warn */ .kg.warn('unknown instrumentation type:', type);
      return;
  }
}

/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addInstrumentationHandler(type, callback) {
  handlers[type] = handlers[type] || [];
  (handlers[type] ).push(callback);
  instrument(type);
}

/** JSDoc */
function triggerHandlers(type, data) {
  if (!type || !handlers[type]) {
    return;
  }

  for (var handler of handlers[type] || []) {
    try {
      handler(data);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .kg.error(
          `Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0,_stacktrace_js__WEBPACK_IMPORTED_MODULE_2__/* .getFunctionName */ .$P)(handler)}\nError:`,
          e,
        );
    }
  }
}

/** JSDoc */
function instrumentConsole() {
  if (!('console' in global)) {
    return;
  }

  _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .CONSOLE_LEVELS.forEach */ .RU.forEach(function (level) {
    if (!(level in global.console)) {
      return;
    }

    (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(global.console, level, function (originalConsoleMethod) {
      return function (...args) {
        triggerHandlers('console', { args, level });

        // this fails for some browsers. :(
        if (originalConsoleMethod) {
          originalConsoleMethod.apply(global.console, args);
        }
      };
    });
  });
}

/** JSDoc */
function instrumentFetch() {
  if (!(0,_supports_js__WEBPACK_IMPORTED_MODULE_4__/* .supportsNativeFetch */ .t$)()) {
    return;
  }

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(global, 'fetch', function (originalFetch) {
    return function (...args) {
      var handlerData = {
        args,
        fetchData: {
          method: getFetchMethod(args),
          url: getFetchUrl(args),
        },
        startTimestamp: Date.now(),
      };

      triggerHandlers('fetch', {
        ...handlerData,
      });

            return originalFetch.apply(global, args).then(
        (response) => {
          triggerHandlers('fetch', {
            ...handlerData,
            endTimestamp: Date.now(),
            response,
          });
          return response;
        },
        (error) => {
          triggerHandlers('fetch', {
            ...handlerData,
            endTimestamp: Date.now(),
            error,
          });
          // NOTE: If you are a Sentry user, and you are seeing this stack frame,
          //       it means the sentry.javascript SDK caught an error invoking your application code.
          //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
          throw error;
        },
      );
    };
  });
}

/** Extract `method` from fetch call arguments */
function getFetchMethod(fetchArgs = []) {
  if ('Request' in global && (0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isInstanceOf */ .V9)(fetchArgs[0], Request) && fetchArgs[0].method) {
    return String(fetchArgs[0].method).toUpperCase();
  }
  if (fetchArgs[1] && fetchArgs[1].method) {
    return String(fetchArgs[1].method).toUpperCase();
  }
  return 'GET';
}

/** Extract `url` from fetch call arguments */
function getFetchUrl(fetchArgs = []) {
  if (typeof fetchArgs[0] === 'string') {
    return fetchArgs[0];
  }
  if ('Request' in global && (0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isInstanceOf */ .V9)(fetchArgs[0], Request)) {
    return fetchArgs[0].url;
  }
  return String(fetchArgs[0]);
}

/** JSDoc */
function instrumentXHR() {
  if (!('XMLHttpRequest' in global)) {
    return;
  }

  var xhrproto = XMLHttpRequest.prototype;

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(xhrproto, 'open', function (originalOpen) {
    return function ( ...args) {
            var xhr = this;
      var url = args[1];
      var xhrInfo = (xhr.__sentry_xhr__ = {
                method: (0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isString */ .HD)(args[0]) ? args[0].toUpperCase() : args[0],
        url: args[1],
      });

      // if Sentry key appears in URL, don't capture it as a request
            if ((0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isString */ .HD)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) {
        xhr.__sentry_own_request__ = true;
      }

      var onreadystatechangeHandler = function () {
        if (xhr.readyState === 4) {
          try {
            // touching statusCode in some platforms throws
            // an exception
            xhrInfo.status_code = xhr.status;
          } catch (e) {
            /* do nothing */
          }

          triggerHandlers('xhr', {
            args,
            endTimestamp: Date.now(),
            startTimestamp: Date.now(),
            xhr,
          });
        }
      };

      if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
        (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(xhr, 'onreadystatechange', function (original) {
          return function (...readyStateArgs) {
            onreadystatechangeHandler();
            return original.apply(xhr, readyStateArgs);
          };
        });
      } else {
        xhr.addEventListener('readystatechange', onreadystatechangeHandler);
      }

      return originalOpen.apply(xhr, args);
    };
  });

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(xhrproto, 'send', function (originalSend) {
    return function ( ...args) {
      if (this.__sentry_xhr__ && args[0] !== undefined) {
        this.__sentry_xhr__.body = args[0];
      }

      triggerHandlers('xhr', {
        args,
        startTimestamp: Date.now(),
        xhr: this,
      });

      return originalSend.apply(this, args);
    };
  });
}

let lastHref;

/** JSDoc */
function instrumentHistory() {
  if (!(0,_supports_js__WEBPACK_IMPORTED_MODULE_4__/* .supportsHistory */ .Bf)()) {
    return;
  }

  var oldOnPopState = global.onpopstate;
  global.onpopstate = function ( ...args) {
    var to = global.location.href;
    // keep track of the current URL state, as we always receive only the updated state
    var from = lastHref;
    lastHref = to;
    triggerHandlers('history', {
      from,
      to,
    });
    if (oldOnPopState) {
      // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
      // https://github.com/getsentry/sentry-javascript/issues/3344
      // https://github.com/bugsnag/bugsnag-js/issues/469
      try {
        return oldOnPopState.apply(this, args);
      } catch (_oO) {
        // no-empty
      }
    }
  };

  /** @hidden */
  function historyReplacementFunction(originalHistoryFunction) {
    return function ( ...args) {
      var url = args.length > 2 ? args[2] : undefined;
      if (url) {
        // coerce to string (this is what pushState does)
        var from = lastHref;
        var to = String(url);
        // keep track of the current URL state, as we always receive only the updated state
        lastHref = to;
        triggerHandlers('history', {
          from,
          to,
        });
      }
      return originalHistoryFunction.apply(this, args);
    };
  }

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(global.history, 'pushState', historyReplacementFunction);
  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(global.history, 'replaceState', historyReplacementFunction);
}

var debounceDuration = 1000;
let debounceTimerID;
let lastCapturedEvent;

/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */
function shouldShortcircuitPreviousDebounce(previous, current) {
  // If there was no previous event, it should always be swapped for the new one.
  if (!previous) {
    return true;
  }

  // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
  if (previous.type !== current.type) {
    return true;
  }

  try {
    // If both events have the same type, it's still possible that actions were performed on different targets.
    // e.g. 2 clicks on different buttons.
    if (previous.target !== current.target) {
      return true;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
  // to which an event listener was attached), we treat them as the same action, as we want to capture
  // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
  return false;
}

/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */
function shouldSkipDOMEvent(event) {
  // We are only interested in filtering `keypress` events for now.
  if (event.type !== 'keypress') {
    return false;
  }

  try {
    var target = event.target ;

    if (!target || !target.tagName) {
      return true;
    }

    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
      return false;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  return true;
}

/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function makeDOMEventHandler(handler, globalListener = false) {
  return (event) => {
    // It's possible this handler might trigger multiple times for the same
    // event (e.g. event propagation through node ancestors).
    // Ignore if we've already captured that event.
    if (!event || lastCapturedEvent === event) {
      return;
    }

    // We always want to skip _some_ events.
    if (shouldSkipDOMEvent(event)) {
      return;
    }

    var name = event.type === 'keypress' ? 'input' : event.type;

    // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
    if (debounceTimerID === undefined) {
      handler({
        event: event,
        name,
        global: globalListener,
      });
      lastCapturedEvent = event;
    }
    // If there is a debounce awaiting, see if the new event is different enough to treat it as a unique one.
    // If that's the case, emit the previous event and store locally the newly-captured DOM event.
    else if (shouldShortcircuitPreviousDebounce(lastCapturedEvent, event)) {
      handler({
        event: event,
        name,
        global: globalListener,
      });
      lastCapturedEvent = event;
    }

    // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
    clearTimeout(debounceTimerID);
    debounceTimerID = global.setTimeout(() => {
      debounceTimerID = undefined;
    }, debounceDuration);
  };
}

/** JSDoc */
function instrumentDOM() {
  if (!('document' in global)) {
    return;
  }

  // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
  // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
  // we instrument `addEventListener` so that we don't end up attaching this handler twice.
  var triggerDOMHandler = triggerHandlers.bind(null, 'dom');
  var globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
  global.document.addEventListener('click', globalDOMEventHandler, false);
  global.document.addEventListener('keypress', globalDOMEventHandler, false);

  // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
  // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
  // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
  // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
  // guaranteed to fire at least once.)
  ['EventTarget', 'Node'].forEach((target) => {
        var proto = (global )[target] && (global )[target].prototype;
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
      return;
    }

    (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(proto, 'addEventListener', function (originalAddEventListener) {
      return function (
        
        type,
        listener,
        options,
      ) {
        if (type === 'click' || type == 'keypress') {
          try {
            var el = this ;
            var handlers = (el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {});
            var handlerForType = (handlers[type] = handlers[type] || { refCount: 0 });

            if (!handlerForType.handler) {
              var handler = makeDOMEventHandler(triggerDOMHandler);
              handlerForType.handler = handler;
              originalAddEventListener.call(this, type, handler, options);
            }

            handlerForType.refCount += 1;
          } catch (e) {
            // Accessing dom properties is always fragile.
            // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
          }
        }

        return originalAddEventListener.call(this, type, listener, options);
      };
    });

    (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(
      proto,
      'removeEventListener',
      function (originalRemoveEventListener) {
        return function (
          
          type,
          listener,
          options,
        ) {
          if (type === 'click' || type == 'keypress') {
            try {
              var el = this ;
              var handlers = el.__sentry_instrumentation_handlers__ || {};
              var handlerForType = handlers[type];

              if (handlerForType) {
                handlerForType.refCount -= 1;
                // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                if (handlerForType.refCount <= 0) {
                  originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                  handlerForType.handler = undefined;
                  delete handlers[type];                 }

                // If there are no longer any custom handlers of any type on this element, cleanup everything.
                if (Object.keys(handlers).length === 0) {
                  delete el.__sentry_instrumentation_handlers__;
                }
              }
            } catch (e) {
              // Accessing dom properties is always fragile.
              // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
            }
          }

          return originalRemoveEventListener.call(this, type, listener, options);
        };
      },
    );
  });
}

let _oldOnErrorHandler = null;
/** JSDoc */
function instrumentError() {
  _oldOnErrorHandler = global.onerror;

  global.onerror = function (msg, url, line, column, error) {
    triggerHandlers('error', {
      column,
      error,
      line,
      msg,
      url,
    });

    if (_oldOnErrorHandler) {
            return _oldOnErrorHandler.apply(this, arguments);
    }

    return false;
  };
}

let _oldOnUnhandledRejectionHandler = null;
/** JSDoc */
function instrumentUnhandledRejection() {
  _oldOnUnhandledRejectionHandler = global.onunhandledrejection;

  global.onunhandledrejection = function (e) {
    triggerHandlers('unhandledrejection', e);

    if (_oldOnUnhandledRejectionHandler) {
            return _oldOnUnhandledRejectionHandler.apply(this, arguments);
    }

    return true;
  };
}


//# sourceMappingURL=instrument.js.map


/***/ }),

/***/ 67597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TX": function() { return /* binding */ isDOMError; },
/* harmony export */   "fm": function() { return /* binding */ isDOMException; },
/* harmony export */   "kK": function() { return /* binding */ isElement; },
/* harmony export */   "VZ": function() { return /* binding */ isError; },
/* harmony export */   "VW": function() { return /* binding */ isErrorEvent; },
/* harmony export */   "cO": function() { return /* binding */ isEvent; },
/* harmony export */   "V9": function() { return /* binding */ isInstanceOf; },
/* harmony export */   "i2": function() { return /* binding */ isNaN; },
/* harmony export */   "PO": function() { return /* binding */ isPlainObject; },
/* harmony export */   "pt": function() { return /* binding */ isPrimitive; },
/* harmony export */   "Kj": function() { return /* binding */ isRegExp; },
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "Cy": function() { return /* binding */ isSyntheticEvent; },
/* harmony export */   "J8": function() { return /* binding */ isThenable; }
/* harmony export */ });
var objectToString = Object.prototype.toString;

/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
  switch (objectToString.call(wat)) {
    case '[object Error]':
    case '[object Exception]':
    case '[object DOMException]':
      return true;
    default:
      return isInstanceOf(wat, Error);
  }
}

function isBuiltin(wat, ty) {
  return objectToString.call(wat) === `[object ${ty}]`;
}

/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
  return isBuiltin(wat, 'ErrorEvent');
}

/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
  return isBuiltin(wat, 'DOMError');
}

/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
  return isBuiltin(wat, 'DOMException');
}

/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
  return isBuiltin(wat, 'String');
}

/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
  return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}

/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
  return isBuiltin(wat, 'Object');
}

/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
  return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}

/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
  return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}

/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
  return isBuiltin(wat, 'RegExp');
}

/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}

/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
  return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}

/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isNaN(wat) {
  return typeof wat === 'number' && wat !== wat;
}

/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
  try {
    return wat instanceof base;
  } catch (_e) {
    return false;
  }
}


//# sourceMappingURL=is.js.map


/***/ }),

/***/ 12343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RU": function() { return /* binding */ CONSOLE_LEVELS; },
/* harmony export */   "Cf": function() { return /* binding */ consoleSandbox; },
/* harmony export */   "kg": function() { return /* binding */ logger; }
/* harmony export */ });
/* harmony import */ var _global_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82991);


// TODO: Implement different loggers for different environments
var global = (0,_global_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();

/** Prefix for logging strings */
var PREFIX = 'Sentry Logger ';

var CONSOLE_LEVELS = ['debug', 'info', 'warn', 'error', 'log', 'assert', 'trace'] ;

/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
  var global = (0,_global_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();

  if (!('console' in global)) {
    return callback();
  }

  var originalConsole = global.console ;
  var wrappedLevels = {};

  // Restore all wrapped console methods
  CONSOLE_LEVELS.forEach(level => {
    // TODO(v7): Remove this check as it's only needed for Node 6
    var originalWrappedFunc =
      originalConsole[level] && (originalConsole[level] ).__sentry_original__;
    if (level in global.console && originalWrappedFunc) {
      wrappedLevels[level] = originalConsole[level] ;
      originalConsole[level] = originalWrappedFunc ;
    }
  });

  try {
    return callback();
  } finally {
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(level => {
      originalConsole[level] = wrappedLevels[level ];
    });
  }
}

function makeLogger() {
  let enabled = false;
  var logger = {
    enable: () => {
      enabled = true;
    },
    disable: () => {
      enabled = false;
    },
  };

  if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    CONSOLE_LEVELS.forEach(name => {
            logger[name] = (...args) => {
        if (enabled) {
          consoleSandbox(() => {
            global.console[name](`${PREFIX}[${name}]:`, ...args);
          });
        }
      };
    });
  } else {
    CONSOLE_LEVELS.forEach(name => {
      logger[name] = () => undefined;
    });
  }

  return logger ;
}

// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
let logger;
if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
  logger = (0,_global_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalSingleton */ .Y)('logger', makeLogger);
} else {
  logger = makeLogger();
}


//# sourceMappingURL=logger.js.map


/***/ }),

/***/ 62844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EG": function() { return /* binding */ addExceptionMechanism; },
/* harmony export */   "Db": function() { return /* binding */ addExceptionTypeValue; },
/* harmony export */   "YO": function() { return /* binding */ checkOrSetAlreadyCaught; },
/* harmony export */   "jH": function() { return /* binding */ getEventDescription; },
/* harmony export */   "en": function() { return /* binding */ parseUrl; },
/* harmony export */   "rt": function() { return /* binding */ stripUrlQueryAndFragment; },
/* harmony export */   "DM": function() { return /* binding */ uuid4; }
/* harmony export */ });
/* unused harmony exports addContextToFrame, parseSemver */
/* harmony import */ var _global_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82991);
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20535);




/**
 * Extended Window interface that allows for Crypto API usage in IE browsers
 */

/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
  var global = (0,_global_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)() ;
  var crypto = (global.crypto || global.msCrypto) ;

  if (crypto && crypto.randomUUID) {
    return crypto.randomUUID().replace(/-/g, '');
  }

  var getRandomByte =
    crypto && crypto.getRandomValues ? () => crypto.getRandomValues(new Uint8Array(1))[0] : () => Math.random() * 16;

  // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
  // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
  return (([1e7] ) + 1e3 + 4e3 + 8e3 + 1e11).replace(/[018]/g, c =>
        ((c ) ^ ((getRandomByte() & 15) >> ((c ) / 4))).toString(16),
  );
}

/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url)

 {
  if (!url) {
    return {};
  }

  var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  if (!match) {
    return {};
  }

  // coerce to undefined values to empty string so we don't get 'undefined'
  var query = match[6] || '';
  var fragment = match[8] || '';
  return {
    host: match[4],
    path: match[5],
    protocol: match[2],
    relative: match[5] + query + fragment, // everything minus origin
  };
}

function getFirstException(event) {
  return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}

/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
  const { message, event_id: eventId } = event;
  if (message) {
    return message;
  }

  var firstException = getFirstException(event);
  if (firstException) {
    if (firstException.type && firstException.value) {
      return `${firstException.type}: ${firstException.value}`;
    }
    return firstException.type || firstException.value || eventId || '<unknown>';
  }
  return eventId || '<unknown>';
}

/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
  var exception = (event.exception = event.exception || {});
  var values = (exception.values = exception.values || []);
  var firstException = (values[0] = values[0] || {});
  if (!firstException.value) {
    firstException.value = value || '';
  }
  if (!firstException.type) {
    firstException.type = type || 'Error';
  }
}

/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */
function addExceptionMechanism(event, newMechanism) {
  var firstException = getFirstException(event);
  if (!firstException) {
    return;
  }

  var defaultMechanism = { type: 'generic', handled: true };
  var currentMechanism = firstException.mechanism;
  firstException.mechanism = { ...defaultMechanism, ...currentMechanism, ...newMechanism };

  if (newMechanism && 'data' in newMechanism) {
    var mergedData = { ...(currentMechanism && currentMechanism.data), ...newMechanism.data };
    firstException.mechanism.data = mergedData;
  }
}

// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var SEMVER_REGEXP =
  /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;

/**
 * Represents Semantic Versioning object
 */

/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
  var match = input.match(SEMVER_REGEXP) || [];
  var major = parseInt(match[1], 10);
  var minor = parseInt(match[2], 10);
  var patch = parseInt(match[3], 10);
  return {
    buildmetadata: match[5],
    major: isNaN(major) ? undefined : major,
    minor: isNaN(minor) ? undefined : minor,
    patch: isNaN(patch) ? undefined : patch,
    prerelease: match[4],
  };
}

/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext = 5) {
  var lineno = frame.lineno || 0;
  var maxLines = lines.length;
  var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);

  frame.pre_context = lines
    .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
    .map((line) => snipLine(line, 0));

  frame.context_line = snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);

  frame.post_context = lines
    .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
    .map((line) => snipLine(line, 0));
}

/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */
function stripUrlQueryAndFragment(urlPath) {
    return urlPath.split(/[\?#]/, 1)[0];
}

/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */
function checkOrSetAlreadyCaught(exception) {
    if (exception && (exception ).__sentry_captured__) {
    return true;
  }

  try {
    // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
    // `ExtraErrorData` integration
    (0,_object_js__WEBPACK_IMPORTED_MODULE_1__/* .addNonEnumerableProperty */ .xp)(exception , '__sentry_captured__', true);
  } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
  }

  return false;
}


//# sourceMappingURL=misc.js.map


/***/ }),

/***/ 92448:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l$": function() { return /* binding */ dynamicRequire; },
  "KV": function() { return /* binding */ isNodeEnv; },
  "$y": function() { return /* binding */ loadModule; }
});

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/env.js
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */

/**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */
function isBrowserBundle() {
  return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}


//# sourceMappingURL=env.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/node.js
/* module decorator */ module = __webpack_require__.hmd(module);
/* provided dependency */ var process = __webpack_require__(83454);


/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
  // explicitly check for browser bundles as those can be optimized statically
  // by terser/rollup.
  return (
    !isBrowserBundle() &&
    Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]'
  );
}

/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
function dynamicRequire(mod, request) {
    return mod.require(request);
}

/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */
function loadModule(moduleName) {
  let mod;

  try {
    mod = dynamicRequire(module, moduleName);
  } catch (e) {
    // no-empty
  }

  try {
    const { cwd } = dynamicRequire(module, 'process');
    mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`) ;
  } catch (e) {
    // no-empty
  }

  return mod;
}


//# sourceMappingURL=node.js.map


/***/ }),

/***/ 20535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "xp": function() { return /* binding */ addNonEnumerableProperty; },
/* harmony export */   "Sh": function() { return /* binding */ convertToPlainObject; },
/* harmony export */   "Jr": function() { return /* binding */ dropUndefinedKeys; },
/* harmony export */   "zf": function() { return /* binding */ extractExceptionKeysForMessage; },
/* harmony export */   "hl": function() { return /* binding */ fill; },
/* harmony export */   "HK": function() { return /* binding */ getOriginalFunction; },
/* harmony export */   "$Q": function() { return /* binding */ markFunctionWrapped; },
/* harmony export */   "_j": function() { return /* binding */ urlEncode; }
/* harmony export */ });
/* unused harmony export objectify */
/* harmony import */ var _browser_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58464);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var _string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57321);




/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */
function fill(source, name, replacementFactory) {
  if (!(name in source)) {
    return;
  }

  var original = source[name] ;
  var wrapped = replacementFactory(original) ;

  // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
  // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
  if (typeof wrapped === 'function') {
    try {
      markFunctionWrapped(wrapped, original);
    } catch (_Oo) {
      // This can throw if multiple fill happens on a global object like XMLHttpRequest
      // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
  }

  source[name] = wrapped;
}

/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */
function addNonEnumerableProperty(obj, name, value) {
  Object.defineProperty(obj, name, {
    // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
    value: value,
    writable: true,
    configurable: true,
  });
}

/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */
function markFunctionWrapped(wrapped, original) {
  var proto = original.prototype || {};
  wrapped.prototype = original.prototype = proto;
  addNonEnumerableProperty(wrapped, '__sentry_original__', original);
}

/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */
function getOriginalFunction(func) {
  return func.__sentry_original__;
}

/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
  return Object.keys(object)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`)
    .join('&');
}

/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */
function convertToPlainObject(
  value,
)

 {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isError */ .VZ)(value)) {
    return {
      message: value.message,
      name: value.name,
      stack: value.stack,
      ...getOwnProperties(value),
    };
  } else if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isEvent */ .cO)(value)) {
    var newObj

 = {
      type: value.type,
      target: serializeEventTarget(value.target),
      currentTarget: serializeEventTarget(value.currentTarget),
      ...getOwnProperties(value),
    };

    if (typeof CustomEvent !== 'undefined' && (0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isInstanceOf */ .V9)(value, CustomEvent)) {
      newObj.detail = value.detail;
    }

    return newObj;
  } else {
    return value;
  }
}

/** Creates a string representation of the target of an `Event` object */
function serializeEventTarget(target) {
  try {
    return (0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isElement */ .kK)(target) ? (0,_browser_js__WEBPACK_IMPORTED_MODULE_1__/* .htmlTreeAsString */ .R)(target) : Object.prototype.toString.call(target);
  } catch (_oO) {
    return '<unknown>';
  }
}

/** Filters out all but an object's own properties */
function getOwnProperties(obj) {
  if (typeof obj === 'object' && obj !== null) {
    var extractedProps = {};
    for (var property in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, property)) {
        extractedProps[property] = (obj )[property];
      }
    }
    return extractedProps;
  } else {
    return {};
  }
}

/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
function extractExceptionKeysForMessage(exception, maxLength = 40) {
  var keys = Object.keys(convertToPlainObject(exception));
  keys.sort();

  if (!keys.length) {
    return '[object has no keys]';
  }

  if (keys[0].length >= maxLength) {
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .truncate */ .$G)(keys[0], maxLength);
  }

  for (let includedKeys = keys.length; includedKeys > 0; includedKeys--) {
    var serialized = keys.slice(0, includedKeys).join(', ');
    if (serialized.length > maxLength) {
      continue;
    }
    if (includedKeys === keys.length) {
      return serialized;
    }
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .truncate */ .$G)(serialized, maxLength);
  }

  return '';
}

/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */
function dropUndefinedKeys(inputValue) {
  // This map keeps track of what already visited nodes map to.
  // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
  // references as the input object.
  var memoizationMap = new Map();

  // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
  return _dropUndefinedKeys(inputValue, memoizationMap);
}

function _dropUndefinedKeys(inputValue, memoizationMap) {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .PO)(inputValue)) {
    // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
    var memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    var returnValue = {};
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    for (var key of Object.keys(inputValue)) {
      if (typeof inputValue[key] !== 'undefined') {
        returnValue[key] = _dropUndefinedKeys(inputValue[key], memoizationMap);
      }
    }

    return returnValue ;
  }

  if (Array.isArray(inputValue)) {
    // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
    var memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    var returnValue = [];
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    inputValue.forEach((item) => {
      returnValue.push(_dropUndefinedKeys(item, memoizationMap));
    });

    return returnValue ;
  }

  return inputValue;
}

/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */
function objectify(wat) {
  let objectified;
  switch (true) {
    case wat === undefined || wat === null:
      objectified = new String(wat);
      break;

    // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
    // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
    // an object in order to wrap it.
    case typeof wat === 'symbol' || typeof wat === 'bigint':
      objectified = Object(wat);
      break;

    // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
    case isPrimitive(wat):
            objectified = new (wat ).constructor(wat);
      break;

    // by process of elimination, at this point we know that `wat` must already be an object
    default:
      objectified = wat;
      break;
  }
  return objectified;
}


//# sourceMappingURL=object.js.map


/***/ }),

/***/ 30360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "pE": function() { return /* binding */ createStackParser; },
/* harmony export */   "$P": function() { return /* binding */ getFunctionName; },
/* harmony export */   "Sq": function() { return /* binding */ stackParserFromStackParserOptions; }
/* harmony export */ });
/* unused harmony exports nodeStackLineParser, stripSentryFramesAndReverse */


var STACKTRACE_LIMIT = 50;

/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */
function createStackParser(...parsers) {
  var sortedParsers = parsers.sort((a, b) => a[0] - b[0]).map(p => p[1]);

  return (stack, skipFirst = 0) => {
    var frames = [];

    for (var line of stack.split('\n').slice(skipFirst)) {
      for (var parser of sortedParsers) {
        var frame = parser(line);

        if (frame) {
          frames.push(frame);
          break;
        }
      }
    }

    return stripSentryFramesAndReverse(frames);
  };
}

/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */
function stackParserFromStackParserOptions(stackParser) {
  if (Array.isArray(stackParser)) {
    return createStackParser(...stackParser);
  }
  return stackParser;
}

/**
 * @hidden
 */
function stripSentryFramesAndReverse(stack) {
  if (!stack.length) {
    return [];
  }

  let localStack = stack;

  var firstFrameFunction = localStack[0].function || '';
  var lastFrameFunction = localStack[localStack.length - 1].function || '';

  // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
  if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
    localStack = localStack.slice(1);
  }

  // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
  if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
    localStack = localStack.slice(0, -1);
  }

  // The frame where the crash happened, should be the last entry in the array
  return localStack
    .slice(0, STACKTRACE_LIMIT)
    .map(frame => ({
      ...frame,
      filename: frame.filename || localStack[0].filename,
      function: frame.function || '?',
    }))
    .reverse();
}

var defaultFunctionName = '<anonymous>';

/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
  try {
    if (!fn || typeof fn !== 'function') {
      return defaultFunctionName;
    }
    return fn.name || defaultFunctionName;
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    return defaultFunctionName;
  }
}

function node(getModule) {
  var FILENAME_MATCH = /^\s*[-]{4,}$/;
  var FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+?):(\d+)(?::(\d+))?|([^)]+))\)?/;

    return (line) => {
    if (line.match(FILENAME_MATCH)) {
      return {
        filename: line,
      };
    }

    var lineMatch = line.match(FULL_MATCH);
    if (!lineMatch) {
      return undefined;
    }

    let object;
    let method;
    let functionName;
    let typeName;
    let methodName;

    if (lineMatch[1]) {
      functionName = lineMatch[1];

      let methodStart = functionName.lastIndexOf('.');
      if (functionName[methodStart - 1] === '.') {
                methodStart--;
      }

      if (methodStart > 0) {
        object = functionName.substr(0, methodStart);
        method = functionName.substr(methodStart + 1);
        var objectEnd = object.indexOf('.Module');
        if (objectEnd > 0) {
          functionName = functionName.substr(objectEnd + 1);
          object = object.substr(0, objectEnd);
        }
      }
      typeName = undefined;
    }

    if (method) {
      typeName = object;
      methodName = method;
    }

    if (method === '<anonymous>') {
      methodName = undefined;
      functionName = undefined;
    }

    if (functionName === undefined) {
      methodName = methodName || '<anonymous>';
      functionName = typeName ? `${typeName}.${methodName}` : methodName;
    }

    var filename = _optionalChain([lineMatch, 'access', _ => _[2], 'optionalAccess', _2 => _2.startsWith, 'call', _3 => _3('file://')]) ? lineMatch[2].substr(7) : lineMatch[2];
    var isNative = lineMatch[5] === 'native';
    var isInternal =
      isNative || (filename && !filename.startsWith('/') && !filename.startsWith('.') && filename.indexOf(':\\') !== 1);

    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    var in_app = !isInternal && filename !== undefined && !filename.includes('node_modules/');

    return {
      filename,
      module: _optionalChain([getModule, 'optionalCall', _4 => _4(filename)]),
      function: functionName,
      lineno: parseInt(lineMatch[3], 10) || undefined,
      colno: parseInt(lineMatch[4], 10) || undefined,
      in_app,
    };
  };
}

/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */
function nodeStackLineParser(getModule) {
  return [90, node(getModule)];
}


//# sourceMappingURL=stacktrace.js.map


/***/ }),

/***/ 57321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "zC": function() { return /* binding */ isMatchingPattern; },
/* harmony export */   "nK": function() { return /* binding */ safeJoin; },
/* harmony export */   "$G": function() { return /* binding */ truncate; }
/* harmony export */ });
/* unused harmony exports escapeStringForRegex, snipLine */
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);


/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */
function truncate(str, max = 0) {
  if (typeof str !== 'string' || max === 0) {
    return str;
  }
  return str.length <= max ? str : `${str.substr(0, max)}...`;
}

/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
  let newLine = line;
  var lineLength = newLine.length;
  if (lineLength <= 150) {
    return newLine;
  }
  if (colno > lineLength) {
        colno = lineLength;
  }

  let start = Math.max(colno - 60, 0);
  if (start < 5) {
    start = 0;
  }

  let end = Math.min(start + 140, lineLength);
  if (end > lineLength - 5) {
    end = lineLength;
  }
  if (end === lineLength) {
    start = Math.max(end - 140, 0);
  }

  newLine = newLine.slice(start, end);
  if (start > 0) {
    newLine = `'{snip} ${newLine}`;
  }
  if (end < lineLength) {
    newLine += ' {snip}';
  }

  return newLine;
}

/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
function safeJoin(input, delimiter) {
  if (!Array.isArray(input)) {
    return '';
  }

  var output = [];
    for (let i = 0; i < input.length; i++) {
    var value = input[i];
    try {
      output.push(String(value));
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }

  return output.join(delimiter);
}

/**
 * Checks if the value matches a regex or includes the string
 * @param value The string value to be checked against
 * @param pattern Either a regex or a string that must be contained in value
 */
function isMatchingPattern(value, pattern) {
  if (!(0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(value)) {
    return false;
  }

  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isRegExp */ .Kj)(pattern)) {
    return pattern.test(value);
  }
  if (typeof pattern === 'string') {
    return value.indexOf(pattern) !== -1;
  }
  return false;
}

/**
 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
 * `new RegExp()`.
 *
 * Based on https://github.com/sindresorhus/escape-string-regexp. Vendored to a) reduce the size by skipping the runtime
 * type-checking, and b) ensure it gets down-compiled for old versions of Node (the published package only supports Node
 * 12+).
 *
 * @param regexString The string to escape
 * @returns An version of the string with all special regex characters escaped
 */
function escapeStringForRegex(regexString) {
  // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
  // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
  return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}


//# sourceMappingURL=string.js.map


/***/ }),

/***/ 8823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Du": function() { return /* binding */ isNativeFetch; },
/* harmony export */   "Ak": function() { return /* binding */ supportsFetch; },
/* harmony export */   "Bf": function() { return /* binding */ supportsHistory; },
/* harmony export */   "t$": function() { return /* binding */ supportsNativeFetch; }
/* harmony export */ });
/* unused harmony exports supportsDOMError, supportsDOMException, supportsErrorEvent, supportsReferrerPolicy, supportsReportingObserver */
/* harmony import */ var _global_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82991);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12343);



/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
  try {
    new ErrorEvent('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
  try {
    // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
    // 1 argument required, but only 0 present.
    // @ts-ignore It really needs 1 argument, not 0.
    new DOMError('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
  try {
    new DOMException('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
  if (!('fetch' in (0,_global_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)())) {
    return false;
  }

  try {
    new Headers();
    new Request('');
    new Response();
    return true;
  } catch (e) {
    return false;
  }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
function isNativeFetch(func) {
  return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}

/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
  if (!supportsFetch()) {
    return false;
  }

  var global = (0,_global_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();

  // Fast path to avoid DOM I/O
    if (isNativeFetch(global.fetch)) {
    return true;
  }

  // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
  // so create a "pure" iframe to see if that has native fetch
  let result = false;
  var doc = global.document;
    if (doc && typeof (doc.createElement ) === 'function') {
    try {
      var sandbox = doc.createElement('iframe');
      sandbox.hidden = true;
      doc.head.appendChild(sandbox);
      if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
                result = isNativeFetch(sandbox.contentWindow.fetch);
      }
      doc.head.removeChild(sandbox);
    } catch (err) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.warn */ .kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
  }

  return result;
}

/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
  return 'ReportingObserver' in getGlobalObject();
}

/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
  // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
  // (see https://caniuse.com/#feat=referrer-policy),
  // it doesn't. And it throws an exception instead of ignoring this parameter...
  // REF: https://github.com/getsentry/raven-js/issues/1233

  if (!supportsFetch()) {
    return false;
  }

  try {
    new Request('_', {
      referrerPolicy: 'origin' ,
    });
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
  // NOTE: in Chrome App environment, touching history.pushState, *even inside
  //       a try/catch block*, will cause Chrome to output an error to console.error
  // borrowed from: https://github.com/angular/angular.js/pull/13945/files
  var global = (0,_global_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
      var chrome = (global ).chrome;
  var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;

  return !isChromePackagedApp && hasHistoryApi;
}


//# sourceMappingURL=supports.js.map


/***/ }),

/***/ 96893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cW": function() { return /* binding */ SyncPromise; },
/* harmony export */   "$2": function() { return /* binding */ rejectedSyncPromise; },
/* harmony export */   "WD": function() { return /* binding */ resolvedSyncPromise; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);


/** SyncPromise internal states */
var States; (function (States) {
  /** Pending */
  var PENDING = 0; States[States["PENDING"] = PENDING] = "PENDING";
  /** Resolved / OK */
  var RESOLVED = 1; States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
  /** Rejected / Error */
  var REJECTED = 2; States[States["REJECTED"] = REJECTED] = "REJECTED";
})(States || (States = {}));

// Overloads so we can call resolvedSyncPromise without arguments and generic argument

/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */
function resolvedSyncPromise(value) {
  return new SyncPromise(resolve => {
    resolve(value);
  });
}

/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */
function rejectedSyncPromise(reason) {
  return new SyncPromise((_, reject) => {
    reject(reason);
  });
}

/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
class SyncPromise {
   __init() {this._state = States.PENDING;}
   __init2() {this._handlers = [];}
  

   constructor(
    executor,
  ) {;SyncPromise.prototype.__init.call(this);SyncPromise.prototype.__init2.call(this);SyncPromise.prototype.__init3.call(this);SyncPromise.prototype.__init4.call(this);SyncPromise.prototype.__init5.call(this);SyncPromise.prototype.__init6.call(this);
    try {
      executor(this._resolve, this._reject);
    } catch (e) {
      this._reject(e);
    }
  }

  /** JSDoc */
   then(
    onfulfilled,
    onrejected,
  ) {
    return new SyncPromise((resolve, reject) => {
      this._handlers.push([
        false,
        result => {
          if (!onfulfilled) {
            // TODO: ¯\_(ツ)_/¯
            // TODO: FIXME
            resolve(result );
          } else {
            try {
              resolve(onfulfilled(result));
            } catch (e) {
              reject(e);
            }
          }
        },
        reason => {
          if (!onrejected) {
            reject(reason);
          } else {
            try {
              resolve(onrejected(reason));
            } catch (e) {
              reject(e);
            }
          }
        },
      ]);
      this._executeHandlers();
    });
  }

  /** JSDoc */
   catch(
    onrejected,
  ) {
    return this.then(val => val, onrejected);
  }

  /** JSDoc */
   finally(onfinally) {
    return new SyncPromise((resolve, reject) => {
      let val;
      let isRejected;

      return this.then(
        value => {
          isRejected = false;
          val = value;
          if (onfinally) {
            onfinally();
          }
        },
        reason => {
          isRejected = true;
          val = reason;
          if (onfinally) {
            onfinally();
          }
        },
      ).then(() => {
        if (isRejected) {
          reject(val);
          return;
        }

        resolve(val );
      });
    });
  }

  /** JSDoc */
    __init3() {this._resolve = (value) => {
    this._setResult(States.RESOLVED, value);
  };}

  /** JSDoc */
    __init4() {this._reject = (reason) => {
    this._setResult(States.REJECTED, reason);
  };}

  /** JSDoc */
    __init5() {this._setResult = (state, value) => {
    if (this._state !== States.PENDING) {
      return;
    }

    if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isThenable */ .J8)(value)) {
      void (value ).then(this._resolve, this._reject);
      return;
    }

    this._state = state;
    this._value = value;

    this._executeHandlers();
  };}

  /** JSDoc */
    __init6() {this._executeHandlers = () => {
    if (this._state === States.PENDING) {
      return;
    }

    var cachedHandlers = this._handlers.slice();
    this._handlers = [];

    cachedHandlers.forEach(handler => {
      if (handler[0]) {
        return;
      }

      if (this._state === States.RESOLVED) {
                handler[1](this._value );
      }

      if (this._state === States.REJECTED) {
        handler[2](this._value);
      }

      handler[0] = true;
    });
  };}
}


//# sourceMappingURL=syncpromise.js.map


/***/ }),

/***/ 21170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z1": function() { return /* binding */ browserPerformanceTimeOrigin; },
/* harmony export */   "yW": function() { return /* binding */ dateTimestampInSeconds; },
/* harmony export */   "ph": function() { return /* binding */ timestampInSeconds; },
/* harmony export */   "_I": function() { return /* binding */ timestampWithMs; }
/* harmony export */ });
/* unused harmony exports _browserPerformanceTimeOriginMode, usingPerformanceAPI */
/* harmony import */ var _global_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82991);
/* harmony import */ var _node_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92448);
/* module decorator */ module = __webpack_require__.hmd(module);



/**
 * An object that can return the current timestamp in seconds since the UNIX epoch.
 */

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */
var dateTimestampSource = {
  nowSeconds: () => Date.now() / 1000,
};

/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */

/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function getBrowserPerformance() {
  const { performance } = (0,_global_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
  if (!performance || !performance.now) {
    return undefined;
  }

  // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
  //
  // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
  // performance.now() gives a date arbitrarily in the past.
  //
  // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
  // undefined.
  //
  // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
  // interact with data coming out of performance entries.
  //
  // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
  // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
  // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
  // observed skews that can be as long as days, weeks or months.
  //
  // See https://github.com/getsentry/sentry-javascript/issues/2590.
  //
  // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
  // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
  // transactions of long-lived web pages.
  var timeOrigin = Date.now() - performance.now();

  return {
    now: () => performance.now(),
    timeOrigin,
  };
}

/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */
function getNodePerformance() {
  try {
    var perfHooks = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .dynamicRequire */ .l$)(module, 'perf_hooks') ;
    return perfHooks.performance;
  } catch (_) {
    return undefined;
  }
}

/**
 * The Performance API implementation for the current platform, if available.
 */
var platformPerformance = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .isNodeEnv */ .KV)() ? getNodePerformance() : getBrowserPerformance();

var timestampSource =
  platformPerformance === undefined
    ? dateTimestampSource
    : {
        nowSeconds: () => (platformPerformance.timeOrigin + platformPerformance.now()) / 1000,
      };

/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);

/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);

// Re-exported with an old name for backwards-compatibility.
var timestampWithMs = timestampInSeconds;

/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */
var usingPerformanceAPI = platformPerformance !== undefined;

/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */
let _browserPerformanceTimeOriginMode;

/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
var browserPerformanceTimeOrigin = (() => {
  // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
  // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
  // data as reliable if they are within a reasonable threshold of the current time.

  const { performance } = (0,_global_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
  if (!performance || !performance.now) {
    _browserPerformanceTimeOriginMode = 'none';
    return undefined;
  }

  var threshold = 3600 * 1000;
  var performanceNow = performance.now();
  var dateNow = Date.now();

  // if timeOrigin isn't available set delta to threshold so it isn't used
  var timeOriginDelta = performance.timeOrigin
    ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
    : threshold;
  var timeOriginIsReliable = timeOriginDelta < threshold;

  // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
  // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
  // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
  // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
  // Date API.
    var navigationStart = performance.timing && performance.timing.navigationStart;
  var hasNavigationStart = typeof navigationStart === 'number';
  // if navigationStart isn't available set delta to threshold so it isn't used
  var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
  var navigationStartIsReliable = navigationStartDelta < threshold;

  if (timeOriginIsReliable || navigationStartIsReliable) {
    // Use the more reliable time origin
    if (timeOriginDelta <= navigationStartDelta) {
      _browserPerformanceTimeOriginMode = 'timeOrigin';
      return performance.timeOrigin;
    } else {
      _browserPerformanceTimeOriginMode = 'navigationStart';
      return navigationStart;
    }
  }

  // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
  _browserPerformanceTimeOriginMode = 'dateNow';
  return dateNow;
})();


//# sourceMappingURL=time.js.map


/***/ }),

/***/ 49484:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var _global = (typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"OEi0IGRy1LlpIfeOOOoMZ"};

/***/ }),

/***/ 93238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgBoat = function SvgBoat(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M336 0c26.5 0 48 21.49 48 48v16h48c26.5 0 48 21.49 48 48v125.3l33.3 10.8c34.8 11.2 44.7 55.7 18.1 80.7l-88.5 82.9c-6.4 6-16.5 5.7-22.6-.8-6-6.4-5.7-16.5.8-22.6l88.4-82.9c8.9-8.3 5.6-23.1-6-26.9L304 213.1V384c0 8.8-7.2 16-16.9 16-7.9 0-16-7.2-16-16V213.1L72.53 278.5c-11.59 3.8-14.91 18.6-6.02 26.9l88.39 82.9c6.5 6.1 6.8 16.2.8 22.6-6.1 6.5-16.2 6.8-22.6.8l-88.47-82.9c-26.67-25-16.73-69.5 18.05-80.7l32.42-10.8V112c0-26.51 22.4-48 48-48h48V48c0-26.51 22.4-48 48-48H336zm16 64V48c0-8.84-7.2-16-16-16h-96.9c-7.9 0-16 7.16-16 16v16H352zM143.1 96c-7.9 0-16 7.2-16 16v114.9l146.1-47.8c9.6-2.2 20-2.2 29.6 0L448 226.9V112c0-8.8-7.2-16-16-16H143.1zm-9.3 362.8c16.5 11.2 37.3 20.3 57.3 20.3 21.8 0 42.5-9.1 59-20.3 9.8-6.7 18.1-14 26-21.9 6.5-6.5 17.2-6.5 23.7 0 8 7.9 15.3 15.2 26 21.9 16.5 11.2 37.3 20.3 57.3 20.3 21.8 0 42.5-9.1 59.1-20.3 9.7-6.7 18-14 25.9-21.9 6.5-6.5 17.2-6.5 23.7 0 8 7.9 15.3 15.2 26 21.9 12.8 8.7 28.1 16.6 44.1 19.8 7.7 1.5 14.1 7.8 14.1 15.6 0 9.8-8.9 17.9-17.7 16.2-23.1-3.9-43.6-15-58.5-25.2-8-5.4-14.7-10.8-20.7-16.1-4.3 5.3-11 10.7-18.9 16.1-18.7 12.7-45.9 25.9-77.1 25.9-29.4 0-56.7-13.2-75.3-25.9-8-5.4-14.7-10.8-20.7-16.1-4.3 5.3-11 10.7-18.9 16.1-18.7 12.7-45.9 25.9-77.1 25.9-29.4 0-56.7-13.2-75.3-25.9-8-5.4-14.7-10.8-19.84-16.1-5.14 5.3-11.84 10.7-19.77 16.1-14.94 10.2-35.38 21.3-58.5 25.2C8.015 512.1 0 504 0 494.2c0-7.8 6.421-14.1 14.13-15.6 15.94-3.2 31.25-11.1 44.03-19.8 9.78-6.7 18-14 25.91-21.9 6.57-6.5 17.23-6.5 23.73 0 8 7.9 16.3 15.3 26 21.9z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgBoat);

/***/ }),

/***/ 23364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgFPhone2 = function SvgFPhone2(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 450 500",
    style: {
      enableBackground: "new 0 0 450 500"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m424.5 305.6-80.9-80.9c-3.4-3.4-9-3.4-12.5 0l-52.6 52.5c-2.5 2.5-5.4 4.7-8.5 6.5-15.9 9.2-36.1 6.5-49.1-6.5L195 251.4c-13-13-15.7-33.2-6.5-49.1 1.8-3.1 3.9-5.9 6.5-8.4l52.6-52.5c3.4-3.4 3.4-9 0-12.5l-83.7-83.7-.6-.6C156.7 38 147.7 29 136 31.3c-8.6 1.7-14.1 8.2-18.4 13.5-1.4 1.7-2.7 3.2-4 4.5-7.2 7.2-13.8 15-19.6 23.3l-.1.1C88.4 80.5 83.6 88.5 79.5 97c-12.7 25.9-19.2 55.6-19 85.9.3 30 7.2 60.8 20.1 89.1 0 .1.1.1.1.2-24.8 15.2-41.3 42.5-41.3 73.6 0 47.5 38.7 86.2 86.3 86.2 31 0 58.2-16.4 73.4-41 .1.1.2.1.4.2 28.8 13.2 60.2 20.3 90.7 20.4h1c30.4 0 60.2-6.9 86.2-19.9 17-8.5 32.4-19.7 45.8-33.1 1.1-1.1 2.5-2.3 3.9-3.5 4.5-3.8 10.1-8.6 12.1-16 4-14.8-9.1-27.9-14.7-33.5zM126 61.8c1.8-1.8 3.5-3.8 5.1-5.7 2.9-3.4 5.8-7 8.4-7.5 2.5-.5 8.2 5.3 11.3 8.3l78.1 78-28.9 29-87.2-87.1c4.1-5.3 8.5-10.3 13.2-15zm-.4 352.6c-37.8 0-68.6-30.8-68.6-68.6s30.8-68.6 68.6-68.6 68.6 30.8 68.6 68.6-30.8 68.6-68.6 68.6zM369.3 376c-48 24.2-108.8 23.9-162.6-.8 3.3-9.2 5.2-19.1 5.2-29.4 0-47.5-38.7-86.2-86.3-86.2-10.2 0-20 1.8-29 5-24.3-53.5-24.7-111.8-1.2-159.9 2.2-4.6 4.7-9 7.3-13.3l84.9 84.8-5 5c-3.6 3.6-6.8 7.7-9.3 12.1-13.2 22.8-9.4 51.8 9.3 70.4l25.9 25.9c18.7 18.6 47.6 22.5 70.4 9.3 4.4-2.5 8.5-5.7 12.1-9.3l5-5 84.9 84.8c-3.8 2.5-7.6 4.6-11.6 6.6zm52.8-41.5c-.6 2.2-3.6 4.7-6.5 7.2-1.6 1.4-3.3 2.8-5 4.5-4.7 4.7-9.7 9.1-15 13.2l-87.2-87.1 28.9-28.8 74.7 74.6c7.6 7.6 11 13.1 10.1 16.4z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M162.5 313.2c-3.8-3-9.4-2.3-12.4 1.5l-35.4 45.1-12.9-16.7c-3-3.8-8.5-4.5-12.4-1.6-3.8 3-4.5 8.5-1.6 12.4l19.9 25.6c1.7 2.1 4.2 3.4 6.9 3.4s5.3-1.2 6.9-3.4l42.4-54c3.1-3.8 2.5-9.3-1.4-12.3z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgFPhone2);

/***/ }),

/***/ 31119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgTips = function SvgTips(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 612 612"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M306.001 23.596c-118.01 0-214.019 96.011-214.019 214.023 0 83.39 47.946 155.785 117.712 191.09v127.48c0 30.775 25.038 55.811 55.811 55.811h80.992c30.773 0 55.811-25.038 55.811-55.811V428.708c69.766-35.303 117.715-107.699 117.715-191.088 0-118.013-96.012-214.024-214.022-214.024zm16.645 390.976c-5.483.511-11.034.786-16.646.786-5.616 0-11.167-.275-16.65-.786 1.24-24.823.638-72.259-16.962-113.969h67.222c-17.599 41.711-18.201 89.148-16.964 113.969zm43.382 104.58H245.974v-76.096c19.053 5.577 39.194 8.582 60.027 8.582s40.974-3.004 60.027-8.582v76.096zm0 37.036c0 10.771-8.76 19.531-19.531 19.531h-80.992c-10.771 0-19.531-8.762-19.531-19.531v-.756h120.054v.756zm-7.311-148.811c-.842-27.958 1.487-79.666 26.262-114.374a18.141 18.141 0 0 0-14.766-28.679H241.787a18.139 18.139 0 0 0-14.762 28.679c24.775 34.711 27.101 86.424 26.259 114.374-72.347-22.513-125.022-90.1-125.022-169.759 0-98.007 79.731-177.743 177.739-177.743s177.742 79.736 177.742 177.743c0 79.66-52.679 147.247-125.026 169.759zM71.591 78.157a18.084 18.084 0 0 0 12.825 5.314c4.644 0 9.285-1.772 12.828-5.315 7.084-7.084 7.084-18.569 0-25.653L50.053 5.314c-7.085-7.085-18.571-7.085-25.655 0-7.082 7.085-7.082 18.569 0 25.653l47.193 47.19zm455.993 5.313c4.644 0 9.286-1.772 12.828-5.314l47.187-47.188c7.087-7.085 7.087-18.569 0-25.655s-18.571-7.084-25.655 0l-47.187 47.188c-7.087 7.085-7.087 18.571 0 25.655a18.089 18.089 0 0 0 12.827 5.314zm12.828 313.608c-7.084-7.085-18.568-7.087-25.654-.002-7.087 7.085-7.087 18.569 0 25.653l47.187 47.191a18.082 18.082 0 0 0 12.828 5.314c4.641 0 9.283-1.772 12.825-5.314 7.087-7.082 7.087-18.569 0-25.653l-47.186-47.189zm-468.821-.002-47.193 47.191c-7.082 7.084-7.082 18.569 0 25.655a18.086 18.086 0 0 0 12.828 5.314c4.641 0 9.286-1.77 12.825-5.314l47.193-47.191c7.084-7.085 7.084-18.569 0-25.655-7.082-7.085-18.569-7.085-25.653 0z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgTips);

/***/ }),

/***/ 63535:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var ArraySpeciesCreate = __webpack_require__(9572);
var FlattenIntoArray = __webpack_require__(83069);
var Get = __webpack_require__(1391);
var ToIntegerOrInfinity = __webpack_require__(751);
var ToLength = __webpack_require__(88305);
var ToObject = __webpack_require__(30821);

module.exports = function flat() {
	var O = ToObject(this);
	var sourceLen = ToLength(Get(O, 'length'));

	var depthNum = 1;
	if (arguments.length > 0 && typeof arguments[0] !== 'undefined') {
		depthNum = ToIntegerOrInfinity(arguments[0]);
	}

	var A = ArraySpeciesCreate(O, 0);
	FlattenIntoArray(A, O, sourceLen, 0, depthNum);
	return A;
};


/***/ }),

/***/ 16650:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(4289);
var callBind = __webpack_require__(55559);

var implementation = __webpack_require__(63535);
var getPolyfill = __webpack_require__(68981);
var polyfill = getPolyfill();
var shim = __webpack_require__(12131);

var boundFlat = callBind(polyfill);

define(boundFlat, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = boundFlat;


/***/ }),

/***/ 68981:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(63535);

module.exports = function getPolyfill() {
	return Array.prototype.flat || implementation;
};


/***/ }),

/***/ 12131:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(4289);
var shimUnscopables = __webpack_require__(97272);

var getPolyfill = __webpack_require__(68981);

module.exports = function shimFlat() {
	var polyfill = getPolyfill();

	define(
		Array.prototype,
		{ flat: polyfill },
		{ flat: function () { return Array.prototype.flat !== polyfill; } }
	);

	shimUnscopables('flat');

	return polyfill;
};


/***/ }),

/***/ 21924:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var callBind = __webpack_require__(55559);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),

/***/ 55559:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(58612);
var GetIntrinsic = __webpack_require__(40210);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),

/***/ 4289:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(82215);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var hasPropertyDescriptors = __webpack_require__(31044)();

var supportsDescriptors = origDefineProperty && hasPropertyDescriptors;

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value; // eslint-disable-line no-param-reassign
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),

/***/ 97272:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(17642);

var hasUnscopables = typeof Symbol === 'function' && typeof Symbol.unscopables === 'symbol';

var map = hasUnscopables && Array.prototype[Symbol.unscopables];

var $TypeError = TypeError;

module.exports = function shimUnscopables(method) {
	if (typeof method !== 'string' || !method) {
		throw new $TypeError('method must be a non-empty string');
	}
	if (!has(Array.prototype, method)) {
		throw new $TypeError('method must be on Array.prototype');
	}
	if (hasUnscopables) {
		map[method] = true;
	}
};


/***/ }),

/***/ 41503:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';

var isPrimitive = __webpack_require__(34149);
var isCallable = __webpack_require__(95320);
var isDate = __webpack_require__(18923);
var isSymbol = __webpack_require__(12636);

var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
	if (typeof O === 'undefined' || O === null) {
		throw new TypeError('Cannot call method on ' + O);
	}
	if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
		throw new TypeError('hint must be "string" or "number"');
	}
	var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
	var method, result, i;
	for (i = 0; i < methodNames.length; ++i) {
		method = O[methodNames[i]];
		if (isCallable(method)) {
			result = method.call(O);
			if (isPrimitive(result)) {
				return result;
			}
		}
	}
	throw new TypeError('No default value');
};

var GetMethod = function GetMethod(O, P) {
	var func = O[P];
	if (func !== null && typeof func !== 'undefined') {
		if (!isCallable(func)) {
			throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
		}
		return func;
	}
	return void 0;
};

// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
module.exports = function ToPrimitive(input) {
	if (isPrimitive(input)) {
		return input;
	}
	var hint = 'default';
	if (arguments.length > 1) {
		if (arguments[1] === String) {
			hint = 'string';
		} else if (arguments[1] === Number) {
			hint = 'number';
		}
	}

	var exoticToPrim;
	if (hasSymbols) {
		if (Symbol.toPrimitive) {
			exoticToPrim = GetMethod(input, Symbol.toPrimitive);
		} else if (isSymbol(input)) {
			exoticToPrim = Symbol.prototype.valueOf;
		}
	}
	if (typeof exoticToPrim !== 'undefined') {
		var result = exoticToPrim.call(input, hint);
		if (isPrimitive(result)) {
			return result;
		}
		throw new TypeError('unable to convert exotic object to primitive');
	}
	if (hint === 'default' && (isDate(input) || isSymbol(input))) {
		hint = 'string';
	}
	return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
};


/***/ }),

/***/ 34149:
/***/ (function(module) {

"use strict";


module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};


/***/ }),

/***/ 17648:
/***/ (function(module) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ 58612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(17648);

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 40210:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(41405)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(58612);
var hasOwn = __webpack_require__(17642);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/g, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 31884:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(4289);
var isSymbol = __webpack_require__(12636);

var globalKey = '__ global cache key __';
/* istanbul ignore else */
// eslint-disable-next-line no-restricted-properties
if (typeof Symbol === 'function' && isSymbol(Symbol('foo')) && typeof Symbol['for'] === 'function') {
	// eslint-disable-next-line no-restricted-properties
	globalKey = Symbol['for'](globalKey);
}

var trueThunk = function () {
	return true;
};

var ensureCache = function ensureCache() {
	if (!__webpack_require__.g[globalKey]) {
		var properties = {};
		properties[globalKey] = {};
		var predicates = {};
		predicates[globalKey] = trueThunk;
		define(__webpack_require__.g, properties, predicates);
	}
	return __webpack_require__.g[globalKey];
};

var cache = ensureCache();

var isPrimitive = function isPrimitive(val) {
	return val === null || (typeof val !== 'object' && typeof val !== 'function');
};

var getPrimitiveKey = function getPrimitiveKey(val) {
	if (isSymbol(val)) {
		return Symbol.prototype.valueOf.call(val);
	}
	return typeof val + ' | ' + String(val);
};

var requirePrimitiveKey = function requirePrimitiveKey(val) {
	if (!isPrimitive(val)) {
		throw new TypeError('key must not be an object');
	}
};

var globalCache = {
	clear: function clear() {
		delete __webpack_require__.g[globalKey];
		cache = ensureCache();
	},

	'delete': function deleteKey(key) {
		requirePrimitiveKey(key);
		delete cache[getPrimitiveKey(key)];
		return !globalCache.has(key);
	},

	get: function get(key) {
		requirePrimitiveKey(key);
		return cache[getPrimitiveKey(key)];
	},

	has: function has(key) {
		requirePrimitiveKey(key);
		return getPrimitiveKey(key) in cache;
	},

	set: function set(key, value) {
		requirePrimitiveKey(key);
		var primitiveKey = getPrimitiveKey(key);
		var props = {};
		props[primitiveKey] = value;
		var predicates = {};
		predicates[primitiveKey] = trueThunk;
		define(cache, props, predicates);
		return globalCache.has(key);
	},

	setIfMissingThenGet: function setIfMissingThenGet(key, valueThunk) {
		if (globalCache.has(key)) {
			return globalCache.get(key);
		}
		var item = valueThunk();
		globalCache.set(key, item);
		return item;
	}
};

module.exports = globalCache;


/***/ }),

/***/ 31044:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
			return true;
		} catch (e) {
			// IE 8 has a broken defineProperty
			return false;
		}
	}
	return false;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!hasPropertyDescriptors()) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

module.exports = hasPropertyDescriptors;


/***/ }),

/***/ 41405:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(55419);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ 55419:
/***/ (function(module) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 96410:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasSymbols = __webpack_require__(55419);

module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};


/***/ }),

/***/ 17642:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(58612);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(59864);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 95320:
/***/ (function(module) {

"use strict";


var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
	try {
		badArrayLike = Object.defineProperty({}, 'length', {
			get: function () {
				throw isCallableMarker;
			}
		});
		isCallableMarker = {};
		// eslint-disable-next-line no-throw-literal
		reflectApply(function () { throw 42; }, null, badArrayLike);
	} catch (_) {
		if (_ !== isCallableMarker) {
			reflectApply = null;
		}
	}
} else {
	reflectApply = null;
}

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
/* globals document: false */
var documentDotAll = typeof document === 'object' && typeof document.all === 'undefined' && document.all !== undefined ? document.all : {};

module.exports = reflectApply
	? function isCallable(value) {
		if (value === documentDotAll) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (typeof value === 'function' && !value.prototype) { return true; }
		try {
			reflectApply(value, null, badArrayLike);
		} catch (e) {
			if (e !== isCallableMarker) { return false; }
		}
		return !isES6ClassFn(value);
	}
	: function isCallable(value) {
		if (value === documentDotAll) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (typeof value === 'function' && !value.prototype) { return true; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr.call(value);
		return strClass === fnClass || strClass === genClass;
	};


/***/ }),

/***/ 18923:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = __webpack_require__(96410)();

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};


/***/ }),

/***/ 98420:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(21924);
var hasToStringTag = __webpack_require__(96410)();
var has;
var $exec;
var isRegexMarker;
var badStringifier;

if (hasToStringTag) {
	has = callBound('Object.prototype.hasOwnProperty');
	$exec = callBound('RegExp.prototype.exec');
	isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}
}

var $toString = callBound('Object.prototype.toString');
var gOPD = Object.getOwnPropertyDescriptor;
var regexClass = '[object RegExp]';

module.exports = hasToStringTag
	// eslint-disable-next-line consistent-return
	? function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}

		try {
			$exec(value, badStringifier);
		} catch (e) {
			return e === isRegexMarker;
		}
	}
	: function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return $toString(value) === regexClass;
	};


/***/ }),

/***/ 12636:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;
var hasSymbols = __webpack_require__(41405)();

if (hasSymbols) {
	var symToStr = Symbol.prototype.toString;
	var symStringRegex = /^Symbol\(.*\)$/;
	var isSymbolObject = function isRealSymbolObject(value) {
		if (typeof value.valueOf() !== 'symbol') {
			return false;
		}
		return symStringRegex.test(symToStr.call(value));
	};

	module.exports = function isSymbol(value) {
		if (typeof value === 'symbol') {
			return true;
		}
		if (toStr.call(value) !== '[object Symbol]') {
			return false;
		}
		try {
			return isSymbolObject(value);
		} catch (e) {
			return false;
		}
	};
} else {

	module.exports = function isSymbol(value) {
		// this environment does not support Symbols.
		return  false && 0;
	};
}


/***/ }),

/***/ 59740:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(30381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return de;

})));


/***/ }),

/***/ 30381:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    0
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match('^[^/\\\\]*$') != null;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            "object" !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = undefined;
                Object(function webpackMissingModule() { var e = new Error("Cannot find module 'undefined'"); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.4';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));


/***/ }),

/***/ 70300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jc": function() { return /* reexport */ appWithTranslation; },
  "$G": function() { return /* reexport */ useTranslation; }
});

// UNUSED EXPORTS: I18nContext, Trans, Translation, i18n, withTranslation

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(97685);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(15671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/unescape.js
var matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230);/g;
var htmlEntities = {
  '&amp;': '&',
  '&#38;': '&',
  '&lt;': '<',
  '&#60;': '<',
  '&gt;': '>',
  '&#62;': '>',
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&#34;': '"',
  '&nbsp;': ' ',
  '&#160;': ' ',
  '&copy;': '©',
  '&#169;': '©',
  '&reg;': '®',
  '&#174;': '®',
  '&hellip;': '…',
  '&#8230;': '…'
};

var unescapeHtmlEntity = function unescapeHtmlEntity(m) {
  return htmlEntities[m];
};

var unescape_unescape = function unescape(text) {
  return text.replace(matchHtmlEntity, unescapeHtmlEntity);
};
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/context.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true,
  unescape: unescape_unescape
};
var i18nInstance;
var I18nContext = (0,react.createContext)();
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
}
function getDefaults() {
  return defaultOptions;
}
var ReportNamespaces = function () {
  function ReportNamespaces() {
    (0,classCallCheck/* default */.Z)(this, ReportNamespaces);

    this.usedNamespaces = {};
  }

  (0,createClass/* default */.Z)(ReportNamespaces, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;

      namespaces.forEach(function (ns) {
        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);

  return ReportNamespaces;
}();
function setI18n(instance) {
  i18nInstance = instance;
}
function getI18n() {
  return i18nInstance;
}
var initReactI18next = {
  type: '3rdParty',
  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};
function composeInitialProps(ForComponent) {
  return function (ctx) {
    return new Promise(function (resolve) {
      var i18nInitialProps = getInitialProps();

      if (ForComponent.getInitialProps) {
        ForComponent.getInitialProps(ctx).then(function (componentsInitialProps) {
          resolve(_objectSpread(_objectSpread({}, componentsInitialProps), i18nInitialProps));
        });
      } else {
        resolve(i18nInitialProps);
      }
    });
  };
}
function getInitialProps() {
  var i18n = getI18n();
  var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
  var ret = {};
  var initialI18nStore = {};
  i18n.languages.forEach(function (l) {
    initialI18nStore[l] = {};
    namespaces.forEach(function (ns) {
      initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
    });
  });
  ret.initialI18nStore = initialI18nStore;
  ret.initialLanguage = i18n.language;
  return ret;
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/utils.js
function warn() {
  if (console && console.warn) {
    var _console;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);

    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  warn.apply(void 0, args);
}
function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, function () {
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized() {
        setTimeout(function () {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };

      i18n.on('initialized', initialized);
    }
  });
}

function oldI18nextHasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;

  var loadNotPending = function loadNotPending(l, n) {
    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
    return loadState === -1 || loadState === 2;
  };

  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}

function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!i18n.languages || !i18n.languages.length) {
    warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }

  var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;

  if (!isNewerI18next) {
    return oldI18nextHasLoadedNamespace(ns, i18n, options);
  }

  return i18n.hasLoadedNamespace(ns, {
    precheck: function precheck(i18nInstance, loadNotPending) {
      if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
}
function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js



function useTranslation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function useTranslation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { useTranslation_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { useTranslation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var usePrevious = function usePrevious(value, ignore) {
  var ref = (0,react.useRef)();
  (0,react.useEffect)(function () {
    ref.current = ignore ? ref.current : value;
  }, [value, ignore]);
  return ref.current;
};

function useTranslation(ns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var i18nFromProps = props.i18n;

  var _ref = (0,react.useContext)(I18nContext) || {},
      i18nFromContext = _ref.i18n,
      defaultNSFromContext = _ref.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new ReportNamespaces();

  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using initReactI18next');

    var notReadyT = function notReadyT(k) {
      return Array.isArray(k) ? k[k.length - 1] : k;
    };

    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }

  if (i18n.options.react && i18n.options.react.wait !== undefined) warnOnce('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');

  var i18nOptions = useTranslation_objectSpread(useTranslation_objectSpread(useTranslation_objectSpread({}, getDefaults()), i18n.options.react), props);

  var useSuspense = i18nOptions.useSuspense,
      keyPrefix = i18nOptions.keyPrefix;
  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
    return hasLoadedNamespace(n, i18n, i18nOptions);
  });

  function getT() {
    return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  }

  var _useState = (0,react.useState)(getT),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      t = _useState2[0],
      setT = _useState2[1];

  var joinedNS = namespaces.join();
  var previousJoinedNS = usePrevious(joinedNS);
  var isMounted = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    var bindI18n = i18nOptions.bindI18n,
        bindI18nStore = i18nOptions.bindI18nStore;
    isMounted.current = true;

    if (!ready && !useSuspense) {
      loadNamespaces(i18n, namespaces, function () {
        if (isMounted.current) setT(getT);
      });
    }

    if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) {
      setT(getT);
    }

    function boundReset() {
      if (isMounted.current) setT(getT);
    }

    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return function () {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
        return i18n.off(e, boundReset);
      });
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
        return i18n.store.off(e, boundReset);
      });
    };
  }, [i18n, joinedNS]);
  var isInitial = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }

    isInitial.current = false;
  }, [i18n]);
  var ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(function (resolve) {
    loadNamespaces(i18n, namespaces, function () {
      resolve();
    });
  });
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/I18nextProvider.js


function I18nextProvider(_ref) {
  var i18n = _ref.i18n,
      defaultNS = _ref.defaultNS,
      children = _ref.children;
  var value = (0,react.useMemo)(function () {
    return {
      i18n: i18n,
      defaultNS: defaultNS
    };
  }, [i18n, defaultNS]);
  return (0,react.createElement)(I18nContext.Provider, {
    value: value
  }, children);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(91);
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/config/defaultConfig.js
var DEFAULT_LOCALE = 'en';
var LOCALES = ['en'];
var DEFAULT_NAMESPACE = 'common';
var LOCALE_PATH = './public/locales';
var LOCALE_STRUCTURE = '{{lng}}/{{ns}}';
var LOCALE_EXTENSION = 'json';
var defaultConfig = {
  defaultNS: DEFAULT_NAMESPACE,
  errorStackTraceLimit: 0,
  i18n: {
    defaultLocale: DEFAULT_LOCALE,
    locales: LOCALES
  },

  get initImmediate() {
    return  true && typeof window !== 'undefined';
  },

  interpolation: {
    escapeValue: false
  },
  load: 'currentOnly',
  localeExtension: LOCALE_EXTENSION,
  localePath: LOCALE_PATH,
  localeStructure: LOCALE_STRUCTURE,
  react: {
    useSuspense: false
  },
  reloadOnPrerender: false,
  serializeConfig: true,
  use: []
};
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/config/createConfig.js





var _excluded = ["i18n"],
    _excluded2 = ["i18n"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function createConfig_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function createConfig_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? createConfig_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : createConfig_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var deepMergeObjects = ['backend', 'detection'];
var createConfig = function createConfig(userConfig) {
  var _userConfig$use;

  if (typeof (userConfig === null || userConfig === void 0 ? void 0 : userConfig.lng) !== 'string') {
    throw new Error('config.lng was not passed into createConfig');
  } //
  // Initial merge of default and user-provided config
  //


  var userI18n = userConfig.i18n,
      userConfigStripped = (0,objectWithoutProperties/* default */.Z)(userConfig, _excluded);

  var defaultI18n = defaultConfig.i18n,
      defaultConfigStripped = (0,objectWithoutProperties/* default */.Z)(defaultConfig, _excluded2);

  var combinedConfig = createConfig_objectSpread(createConfig_objectSpread(createConfig_objectSpread(createConfig_objectSpread({}, defaultConfigStripped), userConfigStripped), defaultI18n), userI18n);

  var defaultNS = combinedConfig.defaultNS,
      lng = combinedConfig.lng,
      localeExtension = combinedConfig.localeExtension,
      localePath = combinedConfig.localePath,
      localeStructure = combinedConfig.localeStructure;
  var locales = combinedConfig.locales.filter(function (l) {
    return l !== 'default';
  });
  /**
   * Skips translation file resolution while in cimode
   * https://github.com/i18next/next-i18next/pull/851#discussion_r503113620
  */

  if (lng === 'cimode') {
    return combinedConfig;
  }

  if (typeof combinedConfig.fallbackLng === 'undefined') {
    combinedConfig.fallbackLng = combinedConfig.defaultLocale;

    if (combinedConfig.fallbackLng === 'default') {
      var _locales = (0,slicedToArray/* default */.Z)(locales, 1);

      combinedConfig.fallbackLng = _locales[0];
    }
  }

  var hasCustomBackend = userConfig === null || userConfig === void 0 ? void 0 : (_userConfig$use = userConfig.use) === null || _userConfig$use === void 0 ? void 0 : _userConfig$use.some(function (b) {
    return b.type === 'backend';
  });

  if (false) { var getAllLocales, getNamespaces, unique, _defaultNSExists, _defaultNSPath, defaultNSExists, defaultNSPath, defaultFile, defaultLocaleStructure, suffix, prefix, _userConfig$interpola, _userConfig$interpola2, _userConfig$interpola3, _userConfig$interpola4, path, fs; } else {
    //
    // Set client side backend, if there is no custom backend
    //
    if (!hasCustomBackend) {
      if (typeof localePath === 'string') {
        combinedConfig.backend = {
          addPath: "".concat(localePath, "/").concat(localeStructure, ".missing.").concat(localeExtension),
          loadPath: "".concat(localePath, "/").concat(localeStructure, ".").concat(localeExtension)
        };
      } else if (typeof localePath === 'function') {
        combinedConfig.backend = {
          addPath: function addPath(locale, namespace) {
            return localePath(locale, namespace, true);
          },
          loadPath: function loadPath(locale, namespace) {
            return localePath(locale, namespace, false);
          }
        };
      }
    }

    if (typeof combinedConfig.ns !== 'string' && !Array.isArray(combinedConfig.ns)) {
      combinedConfig.ns = [defaultNS];
    }
  } //
  // Deep merge with overwrite - goes last
  //


  deepMergeObjects.forEach(function (obj) {
    if (userConfig[obj]) {
      combinedConfig[obj] = createConfig_objectSpread(createConfig_objectSpread({}, combinedConfig[obj]), userConfig[obj]);
    }
  });
  return combinedConfig;
};
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(97326);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__(32531);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(82963);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(61120);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(83878);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
var iterableToArray = __webpack_require__(59199);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(25267);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toArray.js




function _toArray(arr) {
  return (0,arrayWithHoles/* default */.Z)(arr) || (0,iterableToArray/* default */.Z)(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || (0,nonIterableRest/* default */.Z)();
}
;// CONCATENATED MODULE: ./node_modules/i18next/dist/esm/i18next.js










function i18next_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function i18next_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { i18next_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { i18next_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    (0,classCallCheck/* default */.Z)(this, Logger);

    this.init(concreteLogger, options);
  }

  (0,createClass/* default */.Z)(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, i18next_objectSpread(i18next_objectSpread({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }), this.options));
    }
  }]);

  return Logger;
}();

var baseLogger = new Logger();

var EventEmitter = function () {
  function EventEmitter() {
    (0,classCallCheck/* default */.Z)(this, EventEmitter);

    this.observers = {};
  }

  (0,createClass/* default */.Z)(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;

      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];

        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;

      if (!listener) {
        delete this.observers[event];
        return;
      }

      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }

      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);

        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);

  return EventEmitter;
}();

function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');

  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();

    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);

  if (value !== undefined) {
    return value;
  }

  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }

  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function i18next_escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && typeof window.navigator.userAgentData === 'undefined' && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;
var chars = [' ', ',', '?', '!', ';'];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
  nsSeparator = nsSeparator || '';
  keySeparator = keySeparator || '';
  var possibleChars = chars.filter(function (c) {
    return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
  });
  if (possibleChars.length === 0) return true;
  var r = new RegExp("(".concat(possibleChars.map(function (c) {
    return c === '?' ? '\\?' : c;
  }).join('|'), ")"));
  var matched = !r.test(key);

  if (!matched) {
    var ki = key.indexOf(keySeparator);

    if (ki > 0 && !r.test(key.substring(0, ki))) {
      matched = true;
    }
  }

  return matched;
}

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function deepFind(obj, path) {
  var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  if (!obj) return undefined;
  if (obj[path]) return obj[path];
  var paths = path.split(keySeparator);
  var current = obj;

  for (var i = 0; i < paths.length; ++i) {
    if (!current) return undefined;

    if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) {
      return undefined;
    }

    if (current[paths[i]] === undefined) {
      var j = 2;
      var p = paths.slice(i, i + j).join(keySeparator);
      var mix = current[p];

      while (mix === undefined && paths.length > i + j) {
        j++;
        p = paths.slice(i, i + j).join(keySeparator);
        mix = current[p];
      }

      if (mix === undefined) return undefined;
      if (mix === null) return null;

      if (path.endsWith(p)) {
        if (typeof mix === 'string') return mix;
        if (p && typeof mix[p] === 'string') return mix[p];
      }

      var joinedPath = paths.slice(i + j).join(keySeparator);
      if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
      return undefined;
    }

    current = current[paths[i]];
  }

  return current;
}

var ResourceStore = function (_EventEmitter) {
  (0,inherits/* default */.Z)(ResourceStore, _EventEmitter);

  var _super = _createSuper(ResourceStore);

  function ResourceStore(data) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };

    (0,classCallCheck/* default */.Z)(this, ResourceStore);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }

    _this.data = data || {};
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    if (_this.options.ignoreJSONStructure === undefined) {
      _this.options.ignoreJSONStructure = true;
    }

    return _this;
  }

  (0,createClass/* default */.Z)(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);

      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }

      var result = getPath(this.data, path);
      if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
      return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };

      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }

      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};

      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = _objectSpread$1(_objectSpread$1({}, pack), resources);
      }

      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }

      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === 'v1') return _objectSpread$1(_objectSpread$1({}, {}), this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "hasLanguageSomeTranslations",
    value: function hasLanguageSomeTranslations(lng) {
      var data = this.getDataByLanguage(lng);
      var n = data && Object.keys(data) || [];
      return !!n.find(function (v) {
        return data[v] && Object.keys(data[v]).length > 0;
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);

  return ResourceStore;
}(EventEmitter);

var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var checkedLoadedFor = {};

var Translator = function (_EventEmitter) {
  (0,inherits/* default */.Z)(Translator, _EventEmitter);

  var _super = _createSuper$1(Translator);

  function Translator(services) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    (0,classCallCheck/* default */.Z)(this, Translator);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }

    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, (0,assertThisInitialized/* default */.Z)(_this));
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = baseLogger.create('translator');
    return _this;
  }

  (0,createClass/* default */.Z)(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };

      if (key === undefined || key === null) {
        return false;
      }

      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS || [];
      var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
      var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);

      if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
        var m = key.match(this.interpolator.nestingRegexp);

        if (m && m.length > 0) {
          return {
            key: key,
            namespaces: namespaces
          };
        }

        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }

      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options, lastKey) {
      var _this2 = this;

      if ((0,esm_typeof/* default */.Z)(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }

      if (!options) options = {};
      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)];
      var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
          key = _this$extractFromKey.key,
          namespaces = _this$extractFromKey.namespaces;

      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;

          if (returnDetails) {
            resolved.res = "".concat(namespace).concat(nsSeparator).concat(key);
            return resolved;
          }

          return "".concat(namespace).concat(nsSeparator).concat(key);
        }

        if (returnDetails) {
          resolved.res = key;
          return resolved;
        }

        return key;
      }

      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';

      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          if (!this.options.returnedObjectHandler) {
            this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          }

          var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$2(_objectSpread$2({}, options), {}, {
            ns: namespaces
          })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");

          if (returnDetails) {
            resolved.res = r;
            return resolved;
          }

          return r;
        }

        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;

          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, _objectSpread$2(_objectSpread$2({}, options), {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m];
            }
          }

          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var hasDefaultValue = Translator.hasDefaultValue(options);
        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
        var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;

        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }

        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }

        var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
        var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;

        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);

          if (keySeparator) {
            var fk = this.resolve(key, _objectSpread$2(_objectSpread$2({}, options), {}, {
              keySeparator: false
            }));
            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
          }

          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);

          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }

          var send = function send(l, k, specificDefaultValue) {
            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;

            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
            }

            _this2.emit('missingKey', l, namespace, k, res);
          };

          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (language) {
                _this2.pluralResolver.getSuffixes(language, options).forEach(function (suffix) {
                  send([language], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }

        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);

        if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
          if (this.options.compatibilityAPI !== 'v1') {
            res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
          } else {
            res = this.options.parseMissingKeyHandler(res);
          }
        }
      }

      if (returnDetails) {
        resolved.res = res;
        return resolved;
      }

      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;

      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, _objectSpread$2(_objectSpread$2({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init(_objectSpread$2(_objectSpread$2({}, options), {
          interpolation: _objectSpread$2(_objectSpread$2({}, this.options.interpolation), options.interpolation)
        }));
        var skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
        var nestBef;

        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }

        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = _objectSpread$2(_objectSpread$2({}, this.options.interpolation.defaultVariables), data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);

        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }

        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));

            return null;
          }

          return _this3.translate.apply(_this3, args.concat([key]));
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }

      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$2({
          i18nResolved: resolved
        }, options) : options, this);
      }

      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys];
      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;

        var extracted = _this4.extractFromKey(k, options);

        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';

        var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();

        var needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;

          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;

            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }

          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKeys = [key];

            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
              var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");

              if (needsPluralHandling) {
                finalKeys.push(key + pluralSuffix);

                if (needsZeroSuffixLookup) {
                  finalKeys.push(key + zeroSuffix);
                }
              }

              if (needsContextHandling) {
                var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                finalKeys.push(contextKey);

                if (needsPluralHandling) {
                  finalKeys.push(contextKey + pluralSuffix);

                  if (needsZeroSuffixLookup) {
                    finalKeys.push(contextKey + zeroSuffix);
                  }
                }
              }
            }

            var possibleKey;

            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }], [{
    key: "hasDefaultValue",
    value: function hasDefaultValue(options) {
      var prefix = 'defaultValue';

      for (var option in options) {
        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
          return true;
        }
      }

      return false;
    }
  }]);

  return Translator;
}(EventEmitter);

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    (0,classCallCheck/* default */.Z)(this, LanguageUtil);

    this.options = options;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }

  (0,createClass/* default */.Z)(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === 'x') return null;
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');

        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }

        return p.join('-');
      }

      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }

      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;

      if (!codes) return null;
      var found;
      codes.forEach(function (code) {
        if (found) return;

        var cleanedLng = _this.formatLanguageCode(code);

        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });

      if (!found && this.options.supportedLngs) {
        codes.forEach(function (code) {
          if (found) return;

          var lngOnly = _this.getLanguagePartFromCode(code);

          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = _this.options.supportedLngs.find(function (supportedLng) {
            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
          });
        });
      }

      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;

      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];

      var addCode = function addCode(c) {
        if (!c) return;

        if (_this2.isSupportedCode(c)) {
          codes.push(c);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
        }
      };

      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }

      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);

  return LanguageUtil;
}();

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kk', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
var deprecatedJsonVersions = ['v1', 'v2', 'v3'];
var suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    (0,classCallCheck/* default */.Z)(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');

    if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === 'v4') && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
      this.options.compatibilityJSON = 'v3';
      this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
    }

    this.rules = createRules();
  }

  (0,createClass/* default */.Z)(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.shouldUseIntlApi()) {
        try {
          return new Intl.PluralRules(code, {
            type: options.ordinal ? 'ordinal' : 'cardinal'
          });
        } catch (_unused) {
          return;
        }
      }

      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);

      if (this.shouldUseIntlApi()) {
        return rule && rule.resolvedOptions().pluralCategories.length > 1;
      }

      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.getSuffixes(code, options).map(function (suffix) {
        return "".concat(key).concat(suffix);
      });
    }
  }, {
    key: "getSuffixes",
    value: function getSuffixes(code) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);

      if (!rule) {
        return [];
      }

      if (this.shouldUseIntlApi()) {
        return rule.resolvedOptions().pluralCategories.sort(function (pluralCategory1, pluralCategory2) {
          return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
        }).map(function (pluralCategory) {
          return "".concat(_this.options.prepend).concat(pluralCategory);
        });
      }

      return rule.numbers.map(function (number) {
        return _this.getSuffix(code, number, options);
      });
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var rule = this.getRule(code, options);

      if (rule) {
        if (this.shouldUseIntlApi()) {
          return "".concat(this.options.prepend).concat(rule.select(count));
        }

        return this.getSuffixRetroCompatible(rule, count);
      }

      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }, {
    key: "getSuffixRetroCompatible",
    value: function getSuffixRetroCompatible(rule, count) {
      var _this2 = this;

      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];

      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }

      var returnSuffix = function returnSuffix() {
        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
      };

      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
        return returnSuffix();
      } else if (this.options.compatibilityJSON === 'v2') {
        return returnSuffix();
      } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }

      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
  }, {
    key: "shouldUseIntlApi",
    value: function shouldUseIntlApi() {
      return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
    }
  }]);

  return PluralResolver;
}();

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0,classCallCheck/* default */.Z)(this, Interpolator);

    this.logger = baseLogger.create('interpolator');
    this.options = options;

    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };

    this.init(options);
  }

  (0,createClass/* default */.Z)(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : i18next_escape;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;

      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }

      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = getPathWithDefaults(data, defaultData, key);
          return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
            interpolationkey: key
          })) : path;
        }

        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
          interpolationkey: k
        }));
      };

      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function (todo) {
        replaces = 0;

        while (match = todo.regex.exec(str)) {
          var matchedVar = match[1].trim();
          value = handleFormat(matchedVar);

          if (value === undefined) {
            if (typeof missingInterpolationHandler === 'function') {
              var temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === 'string' ? temp : '';
            } else if (options && options.hasOwnProperty(matchedVar)) {
              value = '';
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));

              value = '';
            }
          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
            value = makeString(value);
          }

          var safeValue = todo.safeValue(value);
          str = str.replace(match[0], safeValue);

          if (skipOnVariables) {
            todo.regex.lastIndex += value.length;
            todo.regex.lastIndex -= match[0].length;
          } else {
            todo.regex.lastIndex = 0;
          }

          replaces++;

          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;

      var clonedOptions = _objectSpread$3({}, options);

      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;

      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c[1]);
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        optionsString = optionsString.replace(/'/g, '"');

        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = _objectSpread$3(_objectSpread$3({}, inheritedOptions), clonedOptions);
        } catch (e) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
          return "".concat(key).concat(sep).concat(optionsString);
        }

        delete clonedOptions.defaultValue;
        return key;
      }

      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        var doReduce = false;

        if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
          var r = match[1].split(this.formatSeparator).map(function (elem) {
            return elem.trim();
          });
          match[1] = r.shift();
          formatters = r;
          doReduce = true;
        }

        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== 'string') return value;
        if (typeof value !== 'string') value = makeString(value);

        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        }

        if (doReduce) {
          value = formatters.reduce(function (v, f) {
            return _this2.format(v, f, options.lng, _objectSpread$3(_objectSpread$3({}, options), {}, {
              interpolationkey: match[1].trim()
            }));
          }, value.trim());
        }

        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }

      return str;
    }
  }]);

  return Interpolator;
}();

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function parseFormatStr(formatStr) {
  var formatName = formatStr.toLowerCase().trim();
  var formatOptions = {};

  if (formatStr.indexOf('(') > -1) {
    var p = formatStr.split('(');
    formatName = p[0].toLowerCase().trim();
    var optStr = p[1].substring(0, p[1].length - 1);

    if (formatName === 'currency' && optStr.indexOf(':') < 0) {
      if (!formatOptions.currency) formatOptions.currency = optStr.trim();
    } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
      if (!formatOptions.range) formatOptions.range = optStr.trim();
    } else {
      var opts = optStr.split(';');
      opts.forEach(function (opt) {
        if (!opt) return;

        var _opt$split = opt.split(':'),
            _opt$split2 = _toArray(_opt$split),
            key = _opt$split2[0],
            rest = _opt$split2.slice(1);

        var val = rest.join(':').trim().replace(/^'+|'+$/g, '');
        if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
        if (val === 'false') formatOptions[key.trim()] = false;
        if (val === 'true') formatOptions[key.trim()] = true;
        if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
      });
    }
  }

  return {
    formatName: formatName,
    formatOptions: formatOptions
  };
}

var Formatter = function () {
  function Formatter() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0,classCallCheck/* default */.Z)(this, Formatter);

    this.logger = baseLogger.create('formatter');
    this.options = options;
    this.formats = {
      number: function number(val, lng, options) {
        return new Intl.NumberFormat(lng, options).format(val);
      },
      currency: function currency(val, lng, options) {
        return new Intl.NumberFormat(lng, _objectSpread$4(_objectSpread$4({}, options), {}, {
          style: 'currency'
        })).format(val);
      },
      datetime: function datetime(val, lng, options) {
        return new Intl.DateTimeFormat(lng, _objectSpread$4({}, options)).format(val);
      },
      relativetime: function relativetime(val, lng, options) {
        return new Intl.RelativeTimeFormat(lng, _objectSpread$4({}, options)).format(val, options.range || 'day');
      },
      list: function list(val, lng, options) {
        return new Intl.ListFormat(lng, _objectSpread$4({}, options)).format(val);
      }
    };
    this.init(options);
  }

  (0,createClass/* default */.Z)(Formatter, [{
    key: "init",
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var iOpts = options.interpolation;
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
    }
  }, {
    key: "add",
    value: function add(name, fc) {
      this.formats[name.toLowerCase().trim()] = fc;
    }
  }, {
    key: "format",
    value: function format(value, _format, lng, options) {
      var _this = this;

      var formats = _format.split(this.formatSeparator);

      var result = formats.reduce(function (mem, f) {
        var _parseFormatStr = parseFormatStr(f),
            formatName = _parseFormatStr.formatName,
            formatOptions = _parseFormatStr.formatOptions;

        if (_this.formats[formatName]) {
          var formatted = mem;

          try {
            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
            formatted = _this.formats[formatName](mem, l, _objectSpread$4(_objectSpread$4(_objectSpread$4({}, formatOptions), options), valOptions));
          } catch (error) {
            _this.logger.warn(error);
          }

          return formatted;
        } else {
          _this.logger.warn("there was no format function for ".concat(formatName));
        }

        return mem;
      }, value);
      return result;
    }
  }]);

  return Formatter;
}();

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function removePending(q, name) {
  if (q.pending[name] !== undefined) {
    delete q.pending[name];
    q.pendingCount--;
  }
}

var Connector = function (_EventEmitter) {
  (0,inherits/* default */.Z)(Connector, _EventEmitter);

  var _super = _createSuper$2(Connector);

  function Connector(backend, store, services) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    (0,classCallCheck/* default */.Z)(this, Connector);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }

    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.waitingReads = [];
    _this.maxParallelReads = options.maxParallelReads || 10;
    _this.readingCalls = 0;
    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }

    return _this;
  }

  (0,createClass/* default */.Z)(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;

      var toLoad = {};
      var pending = {};
      var toLoadLanguages = {};
      var toLoadNamespaces = {};
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);

          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending[name] === undefined) pending[name] = true;
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending[name] === undefined) pending[name] = true;
            if (toLoad[name] === undefined) toLoad[name] = true;
            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
          }
        });
        if (!hasAllNamespaces) toLoadLanguages[lng] = true;
      });

      if (Object.keys(toLoad).length || Object.keys(pending).length) {
        this.queue.push({
          pending: pending,
          pendingCount: Object.keys(pending).length,
          loaded: {},
          errors: [],
          callback: callback
        });
      }

      return {
        toLoad: Object.keys(toLoad),
        pending: Object.keys(pending),
        toLoadLanguages: Object.keys(toLoadLanguages),
        toLoadNamespaces: Object.keys(toLoadNamespaces)
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      if (err) this.emit('failedLoading', lng, ns, err);

      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      }

      this.state[name] = err ? -1 : 2;
      var loaded = {};
      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        removePending(q, name);
        if (err) q.errors.push(err);

        if (q.pendingCount === 0 && !q.done) {
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = {};
            var loadedKeys = q.loaded[l];

            if (loadedKeys.length) {
              loadedKeys.forEach(function (ns) {
                if (loaded[l][ns] === undefined) loaded[l][ns] = true;
              });
            }
          });
          q.done = true;

          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit('loaded', loaded);
      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;

      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 350;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {});

      if (this.readingCalls >= this.maxParallelReads) {
        this.waitingReads.push({
          lng: lng,
          ns: ns,
          fcName: fcName,
          tried: tried,
          wait: wait,
          callback: callback
        });
        return;
      }

      this.readingCalls++;
      return this.backend[fcName](lng, ns, function (err, data) {
        if (err && data && tried < 5) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }

        _this3.readingCalls--;

        if (_this3.waitingReads.length > 0) {
          var next = _this3.waitingReads.shift();

          _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
        }

        callback(err, data);
      });
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;

      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }

      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);

      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }

      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;

      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);

        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      }

      if (key === undefined || key === null || key === '') return;

      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null, _objectSpread$5(_objectSpread$5({}, options), {}, {
          isUpdate: isUpdate
        }));
      }

      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);

  return Connector;
}(EventEmitter);

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if ((0,esm_typeof/* default */.Z)(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];

      if ((0,esm_typeof/* default */.Z)(args[2]) === 'object' || (0,esm_typeof/* default */.Z)(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }

      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: true
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }

  return options;
}

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function noop() {}

function bindMemberFunctions(inst) {
  var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
  mems.forEach(function (mem) {
    if (typeof inst[mem] === 'function') {
      inst[mem] = inst[mem].bind(inst);
    }
  });
}

var I18n = function (_EventEmitter) {
  (0,inherits/* default */.Z)(I18n, _EventEmitter);

  var _super = _createSuper$3(I18n);

  function I18n() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;

    (0,classCallCheck/* default */.Z)(this, I18n);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }

    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };
    bindMemberFunctions((0,assertThisInitialized/* default */.Z)(_this));

    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);

        return (0,possibleConstructorReturn/* default */.Z)(_this, (0,assertThisInitialized/* default */.Z)(_this));
      }

      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }

    return _this;
  }

  (0,createClass/* default */.Z)(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      if (!options.defaultNS && options.ns) {
        if (typeof options.ns === 'string') {
          options.defaultNS = options.ns;
        } else if (options.ns.indexOf('translation') < 0) {
          options.defaultNS = options.ns[0];
        }
      }

      var defOpts = get();
      this.options = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, defOpts), this.options), transformOptions(options));

      if (this.options.compatibilityAPI !== 'v1') {
        this.options.interpolation = _objectSpread$6(_objectSpread$6({}, defOpts.interpolation), this.options.interpolation);
      }

      if (options.keySeparator !== undefined) {
        this.options.userDefinedKeySeparator = options.keySeparator;
      }

      if (options.nsSeparator !== undefined) {
        this.options.userDefinedNsSeparator = options.nsSeparator;
      }

      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      }

      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }

        var formatter;

        if (this.modules.formatter) {
          formatter = this.modules.formatter;
        } else if (typeof Intl !== 'undefined') {
          formatter = Formatter;
        }

        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });

        if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
          s.formatter = createClassOnDemand(formatter);
          s.formatter.init(s, this.options);
          this.options.interpolation.format = s.formatter.format.bind(s.formatter);
        }

        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });

        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }

        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }

        this.translator = new Translator(this.services, this.options);
        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }

      this.format = this.options.interpolation.format;
      if (!callback) callback = noop;

      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
      }

      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      }

      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;

          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
      storeApiChained.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store2;

          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);

          return _this2;
        };
      });
      var deferred = defer();

      var load = function load() {
        var finish = function finish(err, t) {
          if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
          _this2.isInitialized = true;
          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);

          _this2.emit('initialized', _this2.options);

          deferred.resolve(t);
          callback(err, t);
        };

        if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));

        _this2.changeLanguage(_this2.options.lng, finish);
      };

      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }

      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;

      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
        var toLoad = [];

        var append = function append(lng) {
          if (!lng) return;

          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);

          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };

        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }

        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }

        this.services.backendConnector.load(toLoad, this.options.ns, function (e) {
          if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
          usedCallback(e);
        });
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');

      if (module.type === 'backend') {
        this.modules.backend = module;
      }

      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }

      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }

      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }

      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }

      if (module.type === 'formatter') {
        this.modules.formatter = module;
      }

      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }

      return this;
    }
  }, {
    key: "setResolvedLanguage",
    value: function setResolvedLanguage(l) {
      if (!l || !this.languages) return;
      if (['cimode', 'dev'].indexOf(l) > -1) return;

      for (var li = 0; li < this.languages.length; li++) {
        var lngInLngs = this.languages[li];
        if (['cimode', 'dev'].indexOf(lngInLngs) > -1) continue;

        if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
          this.resolvedLanguage = lngInLngs;
          break;
        }
      }
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;

      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);

      var setLngProps = function setLngProps(l) {
        _this4.language = l;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
        _this4.resolvedLanguage = undefined;

        _this4.setResolvedLanguage(l);
      };

      var done = function done(err, l) {
        if (l) {
          setLngProps(l);

          _this4.translator.changeLanguage(l);

          _this4.isLanguageChangingTo = undefined;

          _this4.emit('languageChanged', l);

          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }

        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };

      var setLng = function setLng(lngs) {
        if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);

        if (l) {
          if (!_this4.language) {
            setLngProps(l);
          }

          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
        }

        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };

      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }

      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns, keyPrefix) {
      var _this5 = this;

      var fixedT = function fixedT(key, opts) {
        var options;

        if ((0,esm_typeof/* default */.Z)(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }

          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = _objectSpread$6({}, opts);
        }

        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
        var keySeparator = _this5.options.keySeparator || '.';
        var resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
        return _this5.t(resultKey, options);
      };

      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }

      fixedT.ns = ns;
      fixedT.keyPrefix = keyPrefix;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;

      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;

      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }

      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }

      var lng = this.resolvedLanguage || this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === 'cimode') return true;

      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];

        return loadState === -1 || loadState === 2;
      };

      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== undefined) return preResult;
      }

      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;

      var deferred = defer();

      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }

      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      });

      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }

      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam', 'ckb'];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

      var mergedOptions = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, this.options), options), {
        isClone: true
      });

      var clone = new I18n(mergedOptions);
      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.services = _objectSpread$6({}, this.services);
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages,
        resolvedLanguage: this.resolvedLanguage
      };
    }
  }]);

  return I18n;
}(EventEmitter);

(0,defineProperty/* default */.Z)(I18n, "createInstance", function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var callback = arguments.length > 1 ? arguments[1] : undefined;
  return new I18n(options, callback);
});

var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;

var createInstance = instance.createInstance;
var init = instance.init;
var loadResources = instance.loadResources;
var reloadResources = instance.reloadResources;
var use = instance.use;
var changeLanguage = instance.changeLanguage;
var getFixedT = instance.getFixedT;
var t = instance.t;
var exists = instance.exists;
var setDefaultNamespace = instance.setDefaultNamespace;
var i18next_hasLoadedNamespace = instance.hasLoadedNamespace;
var i18next_loadNamespaces = instance.loadNamespaces;
var loadLanguages = instance.loadLanguages;

/* harmony default export */ var i18next = (instance);


;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/createClient/browser.js

/* harmony default export */ var browser = (function (config) {
  if (config.ns === undefined) config.ns = [];
  var instance = i18next.createInstance(config);
  var initPromise;

  if (!instance.isInitialized) {
    var _config$use;

    config === null || config === void 0 ? void 0 : (_config$use = config.use) === null || _config$use === void 0 ? void 0 : _config$use.forEach(function (x) {
      return instance.use(x);
    });
    initPromise = instance.init(config);
  } else {
    initPromise = Promise.resolve(i18next.t);
  }

  return {
    i18n: instance,
    initPromise: initPromise
  };
});
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/appWithTranslation.js


var __jsx = react.createElement;

function appWithTranslation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function appWithTranslation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? appWithTranslation_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : appWithTranslation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var globalI18n = null;
var appWithTranslation = function appWithTranslation(WrappedComponent) {
  var configOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var AppWithTranslation = function AppWithTranslation(props) {
    var _nextI18Next$initialL, _props$router;

    var _ref = props.pageProps,
        _nextI18Next = _ref._nextI18Next;
    var locale = (_nextI18Next$initialL = _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.initialLocale) !== null && _nextI18Next$initialL !== void 0 ? _nextI18Next$initialL : props === null || props === void 0 ? void 0 : (_props$router = props.router) === null || _props$router === void 0 ? void 0 : _props$router.locale;
    var ns = _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.ns; // Memoize the instance and only re-initialize when either:
    // 1. The route changes (non-shallowly)
    // 2. Router locale changes
    // 3. UserConfig override changes

    var i18n = (0,react.useMemo)(function () {
      var _userConfig, _userConfig2, _userConfig2$i18n;

      if (!_nextI18Next && !configOverride) return null;
      var userConfig = configOverride !== null && configOverride !== void 0 ? configOverride : _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.userConfig;

      if (!userConfig && configOverride === null) {
        throw new Error('appWithTranslation was called without a next-i18next config');
      }

      if (configOverride !== null) {
        userConfig = configOverride;
      }

      if (!((_userConfig = userConfig) !== null && _userConfig !== void 0 && _userConfig.i18n)) {
        throw new Error('appWithTranslation was called without config.i18n');
      }

      if (!((_userConfig2 = userConfig) !== null && _userConfig2 !== void 0 && (_userConfig2$i18n = _userConfig2.i18n) !== null && _userConfig2$i18n !== void 0 && _userConfig2$i18n.defaultLocale)) {
        throw new Error('config.i18n does not include a defaultLocale property');
      }

      var _ref2 = _nextI18Next || {},
          initialI18nStore = _ref2.initialI18nStore;

      var resources = configOverride !== null && configOverride !== void 0 && configOverride.resources ? configOverride.resources : initialI18nStore;
      if (!locale) locale = userConfig.i18n.defaultLocale;
      var instance = browser(appWithTranslation_objectSpread(appWithTranslation_objectSpread({}, createConfig(appWithTranslation_objectSpread(appWithTranslation_objectSpread({}, userConfig), {}, {
        lng: locale
      }))), {}, {
        lng: locale,
        ns: ns,
        resources: resources
      })).i18n;
      globalI18n = instance;
      return instance;
    }, [_nextI18Next, locale, configOverride, ns]);
    return i18n !== null ? __jsx(I18nextProvider, {
      i18n: i18n
    }, __jsx(WrappedComponent, (0,esm_extends/* default */.Z)({
      key: locale
    }, props))) : __jsx(WrappedComponent, (0,esm_extends/* default */.Z)({
      key: locale
    }, props));
  };

  return hoist_non_react_statics_cjs_default()(AppWithTranslation, WrappedComponent);
};
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/index.js



/***/ }),

/***/ 83454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) === null || ref === void 0 ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) === null || ref1 === void 0 ? void 0 : ref1.env) === 'object' ? __webpack_require__.g.process : __webpack_require__(77663);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 81780:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(23802);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 48387:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var config = {
    phone: ' +49 (0)89 80990788-0',
    opening: 'Mo-Fr. 9-12 Uhr und 16-19 Uhr',
    endpoint: 'https://assets.5-anker.com',
    planbar24_url: 'https://portal.chartercheck.com',
    channel: 'cc',
    primarySearchPage: '/yachtcharter',
    social: {
        facebook: 'https://www.facebook.com/chartercheckcom'
    },
    // ids of multinational regions like Mittelmeer, Nordsee and unsupported countries like russia etc..
    regionIdsToHide: []
};
/* harmony default export */ __webpack_exports__["Z"] = (config);


/***/ }),

/***/ 28045:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
__webpack_unused_export__ = ({
    value: true
});
exports["default"] = Image;
var _react = _interopRequireWildcard(__webpack_require__(67294));
var _head = _interopRequireDefault(__webpack_require__(5443));
var _imageConfig = __webpack_require__(5809);
var _useIntersection = __webpack_require__(57190);
var _imageConfigContext = __webpack_require__(59977);
function _defineProperty1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj){
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                    if (desc.get || desc.set) {
                        Object.defineProperty(newObj, key, desc);
                    } else {
                        newObj[key] = obj[key];
                    }
                }
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _objectSpread(target) {
    var _arguments = arguments, _loop = function(i) {
        var source = _arguments[i] != null ? _arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty1(target, key, source[key]);
        });
    };
    for(var i = 1; i < arguments.length; i++)_loop(i);
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default"};
var loadedImageURLs = new Set();
var allImgs = new Map();
var perfObserver;
var emptyDataURL = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
if (false) {}
var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    'lazy',
    'eager',
    undefined
]));
var loaders = new Map([
    [
        'default',
        defaultLoader
    ],
    [
        'imgix',
        imgixLoader
    ],
    [
        'cloudinary',
        cloudinaryLoader
    ],
    [
        'akamai',
        akamaiLoader
    ],
    [
        'custom',
        customLoader
    ], 
]);
var VALID_LAYOUT_VALUES = (/* unused pure expression or super */ null && ([
    'fill',
    'fixed',
    'intrinsic',
    'responsive',
    undefined, 
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === 'object' && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, layout, sizes) {
    var deviceSizes = param.deviceSizes, allSizes = param.allSizes;
    if (sizes && (layout === 'fill' || layout === 'responsive')) {
        // Find all the "vw" percent sizes used in the sizes prop
        var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        var percentSizes = [];
        for(var match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            var _Math;
            var smallestRatio = (_Math = Math).min.apply(_Math, _toConsumableArray(percentSizes)) * 0.01;
            return {
                widths: allSizes.filter(function(s) {
                    return s >= deviceSizes[0] * smallestRatio;
                }),
                kind: 'w'
            };
        }
        return {
            widths: allSizes,
            kind: 'w'
        };
    }
    if (typeof width !== 'number' || layout === 'fill' || layout === 'responsive') {
        return {
            widths: deviceSizes,
            kind: 'w'
        };
    }
    var widths = _toConsumableArray(new Set(// > are actually 3x in the green color, but only 1.5x in the red and
    // > blue colors. Showing a 3x resolution image in the app vs a 2x
    // > resolution image will be visually the same, though the 3x image
    // > takes significantly more data. Even true 3x resolution screens are
    // > wasteful as the human eye cannot see that level of detail without
    // > something like a magnifying glass.
    // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
    [
        width,
        width * 2 /*, width * 3*/ 
    ].map(function(w) {
        return allSizes.find(function(p) {
            return p >= w;
        }) || allSizes[allSizes.length - 1];
    })));
    return {
        widths: widths,
        kind: 'x'
    };
}
function generateImgAttrs(param) {
    var config = param.config, src = param.src, unoptimized = param.unoptimized, layout = param.layout, width = param.width, quality = param.quality, sizes = param.sizes, loader = param.loader;
    if (unoptimized) {
        return {
            src: src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    var ref = getWidths(config, width, layout, sizes), widths = ref.widths, kind = ref.kind;
    var last = widths.length - 1;
    return {
        sizes: !sizes && kind === 'w' ? '100vw' : sizes,
        srcSet: widths.map(function(w, i) {
            return "".concat(loader({
                config: config,
                src: src,
                quality: quality,
                width: w
            }), " ").concat(kind === 'w' ? w : i + 1).concat(kind);
        }).join(', '),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config: config,
            src: src,
            quality: quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === 'number') {
        return x;
    }
    if (typeof x === 'string') {
        return parseInt(x, 10);
    }
    return undefined;
}
function defaultImageLoader(loaderProps) {
    var ref;
    var loaderKey = ((ref = loaderProps.config) === null || ref === void 0 ? void 0 : ref.loader) || 'default';
    var load = loaders.get(loaderKey);
    if (load) {
        return load(loaderProps);
    }
    throw new Error("Unknown \"loader\" found in \"next.config.js\". Expected: ".concat(_imageConfig.VALID_LOADERS.join(', '), ". Received: ").concat(loaderKey));
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(imgRef, src, layout, placeholder, onLoadingCompleteRef) {
    var handleLoad = function() {
        var img = imgRef.current;
        if (!img) {
            return;
        }
        if (img.src !== emptyDataURL) {
            var p = 'decode' in img ? img.decode() : Promise.resolve();
            p.catch(function() {}).then(function() {
                if (!imgRef.current) {
                    return;
                }
                loadedImageURLs.add(src);
                if (placeholder === 'blur') {
                    img.style.filter = '';
                    img.style.backgroundSize = '';
                    img.style.backgroundImage = '';
                    img.style.backgroundPosition = '';
                }
                if (onLoadingCompleteRef.current) {
                    var naturalWidth = img.naturalWidth, naturalHeight = img.naturalHeight;
                    // Pass back read-only primitive values but not the
                    // underlying DOM element because it could be misused.
                    onLoadingCompleteRef.current({
                        naturalWidth: naturalWidth,
                        naturalHeight: naturalHeight
                    });
                }
                if (false) { var parent, ref; }
            });
        }
    };
    if (imgRef.current) {
        if (imgRef.current.complete) {
            // If the real image fails to load, this will still remove the placeholder.
            // This is the desired behavior for now, and will be revisited when error
            // handling is worked on for the image component itself.
            handleLoad();
        } else {
            imgRef.current.onload = handleLoad;
        }
    }
}
function Image(_param) {
    var src = _param.src, sizes = _param.sizes, _unoptimized = _param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized, _priority = _param.priority, priority = _priority === void 0 ? false : _priority, loading = _param.loading, _lazyRoot = _param.lazyRoot, lazyRoot = _lazyRoot === void 0 ? null : _lazyRoot, _lazyBoundary = _param.lazyBoundary, lazyBoundary = _lazyBoundary === void 0 ? '200px' : _lazyBoundary, className = _param.className, quality = _param.quality, width = _param.width, height = _param.height, objectFit = _param.objectFit, objectPosition = _param.objectPosition, onLoadingComplete = _param.onLoadingComplete, _loader = _param.loader, loader = _loader === void 0 ? defaultImageLoader : _loader, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? 'empty' : _placeholder, blurDataURL = _param.blurDataURL, all = _objectWithoutProperties(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "lazyRoot",
        "lazyBoundary",
        "className",
        "quality",
        "width",
        "height",
        "objectFit",
        "objectPosition",
        "onLoadingComplete",
        "loader",
        "placeholder",
        "blurDataURL"
    ]);
    var imgRef = (0, _react).useRef(null);
    var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    var config = (0, _react).useMemo(function() {
        var c = configEnv || configContext || _imageConfig.imageConfigDefault;
        var allSizes = _toConsumableArray(c.deviceSizes).concat(_toConsumableArray(c.imageSizes)).sort(function(a, b) {
            return a - b;
        });
        var deviceSizes = c.deviceSizes.sort(function(a, b) {
            return a - b;
        });
        return _objectSpread({}, c, {
            allSizes: allSizes,
            deviceSizes: deviceSizes
        });
    }, [
        configContext
    ]);
    var rest = all;
    var layout = sizes ? 'responsive' : 'intrinsic';
    if ('layout' in rest) {
        // Override default layout if the user specified one:
        if (rest.layout) layout = rest.layout;
        // Remove property so it's not spread into image:
        delete rest['layout'];
    }
    var staticSrc = '';
    if (isStaticImport(src)) {
        var staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
        }
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!layout || layout !== 'fill') {
            height = height || staticImageData.height;
            width = width || staticImageData.width;
            if (!staticImageData.height || !staticImageData.width) {
                throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
            }
        }
    }
    src = typeof src === 'string' ? src : staticSrc;
    var widthInt = getInt(width);
    var heightInt = getInt(height);
    var qualityInt = getInt(quality);
    var isLazy = !priority && (loading === 'lazy' || typeof loading === 'undefined');
    if (src.startsWith('data:') || src.startsWith('blob:')) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if ( true && loadedImageURLs.has(src)) {
        isLazy = false;
    }
    if (false) { var url, urlStr, VALID_BLUR_EXT; }
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootRef: lazyRoot,
        rootMargin: lazyBoundary,
        disabled: !isLazy
    }), 2), setIntersection = ref1[0], isIntersected = ref1[1];
    var isVisible = !isLazy || isIntersected;
    var wrapperStyle = {
        boxSizing: 'border-box',
        display: 'block',
        overflow: 'hidden',
        width: 'initial',
        height: 'initial',
        background: 'none',
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var sizerStyle = {
        boxSizing: 'border-box',
        display: 'block',
        width: 'initial',
        height: 'initial',
        background: 'none',
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var hasSizer = false;
    var sizerSvgUrl;
    var imgStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        boxSizing: 'border-box',
        padding: 0,
        border: 'none',
        margin: 'auto',
        display: 'block',
        width: 0,
        height: 0,
        minWidth: '100%',
        maxWidth: '100%',
        minHeight: '100%',
        maxHeight: '100%',
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    var blurStyle = placeholder === 'blur' ? {
        filter: 'blur(20px)',
        backgroundSize: objectFit || 'cover',
        backgroundImage: "url(\"".concat(blurDataURL, "\")"),
        backgroundPosition: objectPosition || '0% 0%'
    } : {};
    if (layout === 'fill') {
        // <Image src="i.png" layout="fill" />
        wrapperStyle.display = 'block';
        wrapperStyle.position = 'absolute';
        wrapperStyle.top = 0;
        wrapperStyle.left = 0;
        wrapperStyle.bottom = 0;
        wrapperStyle.right = 0;
    } else if (typeof widthInt !== 'undefined' && typeof heightInt !== 'undefined') {
        // <Image src="i.png" width="100" height="100" />
        var quotient = heightInt / widthInt;
        var paddingTop = isNaN(quotient) ? '100%' : "".concat(quotient * 100, "%");
        if (layout === 'responsive') {
            // <Image src="i.png" width="100" height="100" layout="responsive" />
            wrapperStyle.display = 'block';
            wrapperStyle.position = 'relative';
            hasSizer = true;
            sizerStyle.paddingTop = paddingTop;
        } else if (layout === 'intrinsic') {
            // <Image src="i.png" width="100" height="100" layout="intrinsic" />
            wrapperStyle.display = 'inline-block';
            wrapperStyle.position = 'relative';
            wrapperStyle.maxWidth = '100%';
            hasSizer = true;
            sizerStyle.maxWidth = '100%';
            sizerSvgUrl = "data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27".concat(widthInt, "%27%20height=%27").concat(heightInt, "%27/%3e");
        } else if (layout === 'fixed') {
            // <Image src="i.png" width="100" height="100" layout="fixed" />
            wrapperStyle.display = 'inline-block';
            wrapperStyle.position = 'relative';
            wrapperStyle.width = widthInt;
            wrapperStyle.height = heightInt;
        }
    } else {
        // <Image src="i.png" />
        if (false) {}
    }
    var imgAttributes = {
        src: emptyDataURL,
        srcSet: undefined,
        sizes: undefined
    };
    if (isVisible) {
        imgAttributes = generateImgAttrs({
            config: config,
            src: src,
            unoptimized: unoptimized,
            layout: layout,
            width: widthInt,
            quality: qualityInt,
            sizes: sizes,
            loader: loader
        });
    }
    var srcString = src;
    if (false) { var fullUrl; }
    var imageSrcSetPropName = 'imagesrcset';
    var imageSizesPropName = 'imagesizes';
    if (false) {}
    var _obj;
    var linkProps = (_obj = {}, // Note: imagesrcset and imagesizes are not in the link element type with react 17.
    _defineProperty(_obj, imageSrcSetPropName, imgAttributes.srcSet), _defineProperty(_obj, imageSizesPropName, imgAttributes.sizes), _obj);
    var useLayoutEffect =  false ? 0 : _react.default.useLayoutEffect;
    var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    (0, _react).useEffect(function() {
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    useLayoutEffect(function() {
        setIntersection(imgRef.current);
    }, [
        setIntersection
    ]);
    (0, _react).useEffect(function() {
        handleLoading(imgRef, srcString, layout, placeholder, onLoadingCompleteRef);
    }, [
        srcString,
        layout,
        placeholder,
        isVisible
    ]);
    return(/*#__PURE__*/ _react.default.createElement("span", {
        style: wrapperStyle
    }, hasSizer ? /*#__PURE__*/ _react.default.createElement("span", {
        style: sizerStyle
    }, sizerSvgUrl ? /*#__PURE__*/ _react.default.createElement("img", {
        style: {
            display: 'block',
            maxWidth: '100%',
            width: 'initial',
            height: 'initial',
            background: 'none',
            opacity: 1,
            border: 0,
            margin: 0,
            padding: 0
        },
        alt: "",
        "aria-hidden": true,
        src: sizerSvgUrl
    }) : null) : null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
        decoding: "async",
        "data-nimg": layout,
        className: className,
        ref: imgRef,
        style: _objectSpread({}, imgStyle, blurStyle)
    })), isLazy && /*#__PURE__*/ _react.default.createElement("noscript", null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, generateImgAttrs({
        config: config,
        src: src,
        unoptimized: unoptimized,
        layout: layout,
        width: widthInt,
        quality: qualityInt,
        sizes: sizes,
        loader: loader
    }), {
        decoding: "async",
        "data-nimg": layout,
        style: imgStyle,
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading || 'lazy'
    }))), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: '__nimg-' + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null));
}
function normalizeSrc(src) {
    return src[0] === '/' ? src.slice(1) : src;
}
function imgixLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://static.imgix.net/daisy.png?auto=format&fit=max&w=300
    var url = new URL("".concat(config.path).concat(normalizeSrc(src)));
    var params = url.searchParams;
    params.set('auto', params.get('auto') || 'format');
    params.set('fit', params.get('fit') || 'max');
    params.set('w', params.get('w') || width.toString());
    if (quality) {
        params.set('q', quality.toString());
    }
    return url.href;
}
function akamaiLoader(param) {
    var config = param.config, src = param.src, width = param.width;
    return "".concat(config.path).concat(normalizeSrc(src), "?imwidth=").concat(width);
}
function cloudinaryLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
    var params = [
        'f_auto',
        'c_limit',
        'w_' + width,
        'q_' + (quality || 'auto')
    ];
    var paramsString = params.join(',') + '/';
    return "".concat(config.path).concat(paramsString).concat(normalizeSrc(src));
}
function customLoader(param) {
    var src = param.src;
    throw new Error("Image with src \"".concat(src, "\" is missing \"loader\" prop.") + "\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader");
}
function defaultLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    if (false) { var parsedSrc, missingValues; }
    if (src.endsWith('.svg') && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return "".concat(config.path, "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 48418:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
__webpack_unused_export__ = ({
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(67294));
var _router = __webpack_require__(76273);
var _router1 = __webpack_require__(90387);
var _useIntersection = __webpack_require__(57190);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    router.prefetch(href, as, options).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== 'undefined' ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== '_self' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === 'A';
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    // replace state instead of push if prop is present
    router[replace ? 'replace' : 'push'](href, as, {
        shallow: shallow,
        locale: locale,
        scroll: scroll
    });
}
function Link(props) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var p = props.prefetch !== false;
    var router = (0, _router1).useRouter();
    var ref2 = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, props.href, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: props.as ? (0, _router).resolveHref(router, props.as) : resolvedAs || resolvedHref
        };
    }, [
        router,
        props.href,
        props.as
    ]), href = ref2.href, as = ref2.as;
    var children = props.children, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale;
    if (typeof children === 'string') {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (false) {} else {
        child = _react.default.Children.only(children);
    }
    var childRef = child && typeof child === 'object' && child.ref;
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: '200px'
    }), 2), setIntersectionRef = ref1[0], isVisible = ref1[1];
    var setRef = _react.default.useCallback(function(el) {
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === 'function') childRef(el);
            else if (typeof childRef === 'object') {
                childRef.current = el;
            }
        }
    }, [
        childRef,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale;
        var isPrefetched = prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (child.props && typeof child.props.onClick === 'function') {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale);
            }
        }
    };
    childProps.onMouseEnter = function(e) {
        if (child.props && typeof child.props.onMouseEnter === 'function') {
            child.props.onMouseEnter(e);
        }
        if ((0, _router).isLocalURL(href)) {
            prefetch(router, href, as, {
                priority: true
            });
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (props.passHref || child.type === 'a' && !('href' in child.props)) {
        var curLocale1 = typeof locale !== 'undefined' ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _router).getDomainLocale(as, curLocale1, router && router.locales, router && router.domainLocales);
        childProps.href = localeDomain || (0, _router).addBasePath((0, _router).addLocale(as, curLocale1, router && router.defaultLocale));
    }
    return(/*#__PURE__*/ _react.default.cloneElement(child, childProps));
}
var _default = Link;
exports["default"] = _default; //# sourceMappingURL=link.js.map


/***/ }),

/***/ 57190:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(67294);
var _requestIdleCallback = __webpack_require__(9311);
var hasIntersectionObserver = typeof IntersectionObserver !== 'undefined';
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var unobserve = (0, _react).useRef();
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(rootRef ? rootRef.current : null), 2), root = ref1[0], setRoot = ref1[1];
    var setRef = (0, _react).useCallback(function(el) {
        if (unobserve.current) {
            unobserve.current();
            unobserve.current = undefined;
        }
        if (isDisabled || visible) return;
        if (el && el.tagName) {
            unobserve.current = observe(el, function(isVisible) {
                return isVisible && setVisible(isVisible);
            }, {
                root: root,
                rootMargin: rootMargin
            });
        }
    }, [
        isDisabled,
        root,
        rootMargin,
        visible
    ]);
    (0, _react).useEffect(function() {
        if (!hasIntersectionObserver) {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        visible
    ]);
    (0, _react).useEffect(function() {
        if (rootRef) setRoot(rootRef.current);
    }, [
        rootRef
    ]);
    return [
        setRef,
        visible
    ];
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ''
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
    } else {
        instance = observers.get(id);
        idList.push(id);
    }
    if (instance) {
        return instance;
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    observers.set(id, instance = {
        id: id,
        observer: observer,
        elements: elements
    });
    return instance;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 90638:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
__webpack_unused_export__ = ({
    value: true
});
__webpack_unused_export__ = noSSR;
exports["default"] = dynamic;
var _react = _interopRequireDefault(__webpack_require__(67294));
var _loadable = _interopRequireDefault(__webpack_require__(14302));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var isServerSide = "object" === 'undefined';
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        /*#__PURE__*/ return _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === 'function') {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === 'object') {
        loadableOptions = _objectSpread({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _objectSpread({}, loadableOptions, options);
    var suspenseOptions = loadableOptions;
    if (true) {
        // Error if react root is not enabled and `suspense` option is set to true
        if ( true && suspenseOptions.suspense) {
            // TODO: add error doc when this feature is stable
            throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
        }
    }
    if (suspenseOptions.suspense) {
        return loadableFn(suspenseOptions);
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _objectSpread({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false})
    if (typeof loadableOptions.ssr === 'boolean') {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 16319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _react = _interopRequireDefault(__webpack_require__(67294));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(67294));
var _useSubscription = __webpack_require__(67161);
var _loadableContext = __webpack_require__(16319);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        var state = (0, _useSubscription).useSubscription(subscription);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        return _react.default.createElement(opts.lazy, _objectSpread({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== 'undefined' && !opts.suspense) {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === 'function' ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return !opts.suspense && init();
    };
    LoadableComponent.displayName = 'LoadableComponent';
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === 'number') {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            var _this1 = this;
                            this._delay = setTimeout(function() {
                                _this1._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === 'number') {
                        var _this2 = this;
                        this._timeout = setTimeout(function() {
                            _this2._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _objectSpread({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 98832:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/version.js
var version = __webpack_require__(40105);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/sdk.js + 30 modules
var sdk = __webpack_require__(19985);
;// CONCATENATED MODULE: ./node_modules/@sentry/react/esm/sdk.js


/**
 * Inits the React SDK
 */
function init(options) {
  options._metadata = options._metadata || {};
  options._metadata.sdk = options._metadata.sdk || {
    name: 'sentry.javascript.react',
    packages: [
      {
        name: 'npm:@sentry/react',
        version: version/* SDK_VERSION */.J,
      },
    ],
    version: version/* SDK_VERSION */.J,
  };
  (0,sdk/* init */.S1)(options);
}


//# sourceMappingURL=sdk.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/exports.js
var esm_exports = __webpack_require__(92876);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/hubextensions.js + 1 modules
var hubextensions = __webpack_require__(62758);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(12343);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/global.js
var global = __webpack_require__(82991);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/tracing.js
var TRACEPARENT_REGEXP = new RegExp(
  '^[ \\t]*' + // whitespace
    '([0-9a-f]{32})?' + // trace_id
    '-?([0-9a-f]{16})?' + // span_id
    '-?([01])?' + // sampled
    '[ \\t]*$', // whitespace
);

/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */
function extractTraceparentData(traceparent) {
  var matches = traceparent.match(TRACEPARENT_REGEXP);
  if (matches) {
    let parentSampled;
    if (matches[3] === '1') {
      parentSampled = true;
    } else if (matches[3] === '0') {
      parentSampled = false;
    }
    return {
      traceId: matches[1],
      parentSampled,
      parentSpanId: matches[2],
    };
  }
  return undefined;
}


//# sourceMappingURL=tracing.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/baggage.js
var esm_baggage = __webpack_require__(99181);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/idletransaction.js
var idletransaction = __webpack_require__(16458);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/utils.js
var utils = __webpack_require__(63233);
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/backgroundtab.js



var backgroundtab_global = (0,global/* getGlobalObject */.R)();

/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */
function registerBackgroundTabDetection() {
  if (backgroundtab_global && backgroundtab_global.document) {
    backgroundtab_global.document.addEventListener('visibilitychange', () => {
      var activeTransaction = (0,utils/* getActiveTransaction */.x1)() ;
      if (backgroundtab_global.document.hidden && activeTransaction) {
        var statusType = 'cancelled';

        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          logger/* logger.log */.kg.log(
            `[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${activeTransaction.op}`,
          );
        // We should not set status if it is already set, this prevent important statuses like
        // error or data loss from being overwritten on transaction.
        if (!activeTransaction.status) {
          activeTransaction.setStatus(statusType);
        }
        activeTransaction.setTag('visibilitychange', 'document.hidden');
        activeTransaction.finish();
      }
    });
  } else {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn('[Tracing] Could not set up background tab detection due to lack of global document');
  }
}


//# sourceMappingURL=backgroundtab.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/buildPolyfills/_nullishCoalesce.js
var _nullishCoalesce = __webpack_require__(45375);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(21170);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(58464);
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/bindReporter.js
var bindReporter = (
  callback,
  metric,
  reportAllChanges,
) => {
  let prevValue;
  return (forceReport) => {
    if (metric.value >= 0) {
      if (forceReport || reportAllChanges) {
        metric.delta = metric.value - (prevValue || 0);

        // Report the metric if there's a non-zero delta or if no previous
        // value exists (which can happen in the case of the document becoming
        // hidden when the metric value is 0).
        // See: https://github.com/GoogleChrome/web-vitals/issues/14
        if (metric.delta || prevValue === undefined) {
          prevValue = metric.value;
          callback(metric);
        }
      }
    }
  };
};


//# sourceMappingURL=bindReporter.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/generateUniqueID.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */
var generateUniqueID = () => {
  return `v2-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};


//# sourceMappingURL=generateUniqueID.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/initMetric.js



var initMetric = (name, value) => {
  return {
    name,
    value: (0,_nullishCoalesce/* _nullishCoalesce */.h)(value, () => ( -1)),
    delta: 0,
    entries: [],
    id: generateUniqueID(),
  };
};


//# sourceMappingURL=initMetric.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/observe.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */
var observe = (type, callback) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(type)) {
      // More extensive feature detect needed for Firefox due to:
      // https://github.com/GoogleChrome/web-vitals/issues/142
      if (type === 'first-input' && !('PerformanceEventTiming' in self)) {
        return;
      }

      var po = new PerformanceObserver(l => l.getEntries().map(callback));

      po.observe({ type, buffered: true });
      return po;
    }
  } catch (e) {
    // Do nothing.
  }
  return;
};


//# sourceMappingURL=observe.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/onHidden.js


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var onHidden = (cb, once) => {
  var onHiddenOrPageHide = (event) => {
    if (event.type === 'pagehide' || (0,global/* getGlobalObject */.R)().document.visibilityState === 'hidden') {
      cb(event);
      if (once) {
        removeEventListener('visibilitychange', onHiddenOrPageHide, true);
        removeEventListener('pagehide', onHiddenOrPageHide, true);
      }
    }
  };
  addEventListener('visibilitychange', onHiddenOrPageHide, true);
  // Some browsers have buggy implementations of visibilitychange,
  // so we use pagehide in addition, just to be safe.
  addEventListener('pagehide', onHiddenOrPageHide, true);
};


//# sourceMappingURL=onHidden.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/getCLS.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// https://wicg.github.io/layout-instability/#sec-layout-shift

var getCLS = (onReport, reportAllChanges) => {
  var metric = initMetric('CLS', 0);
  let report;

  let sessionValue = 0;
  let sessionEntries = [];

  var entryHandler = (entry) => {
    // Only count layout shifts without recent user input.
    // TODO: Figure out why entry can be undefined
    if (entry && !entry.hadRecentInput) {
      var firstSessionEntry = sessionEntries[0];
      var lastSessionEntry = sessionEntries[sessionEntries.length - 1];

      // If the entry occurred less than 1 second after the previous entry and
      // less than 5 seconds after the first entry in the session, include the
      // entry in the current session. Otherwise, start a new session.
      if (
        sessionValue &&
        sessionEntries.length !== 0 &&
        entry.startTime - lastSessionEntry.startTime < 1000 &&
        entry.startTime - firstSessionEntry.startTime < 5000
      ) {
        sessionValue += entry.value;
        sessionEntries.push(entry);
      } else {
        sessionValue = entry.value;
        sessionEntries = [entry];
      }

      // If the current session value is larger than the current CLS value,
      // update CLS and the entries contributing to it.
      if (sessionValue > metric.value) {
        metric.value = sessionValue;
        metric.entries = sessionEntries;
        if (report) {
          report();
        }
      }
    }
  };

  var po = observe('layout-shift', entryHandler );
  if (po) {
    report = bindReporter(onReport, metric, reportAllChanges);

    onHidden(() => {
      po.takeRecords().map(entryHandler );
      report(true);
    });
  }
};


//# sourceMappingURL=getCLS.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/getVisibilityWatcher.js



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

let firstHiddenTime = -1;

var initHiddenTime = () => {
  return (0,global/* getGlobalObject */.R)().document.visibilityState === 'hidden' ? 0 : Infinity;
};

var trackChanges = () => {
  // Update the time if/when the document becomes hidden.
  onHidden(({ timeStamp }) => {
    firstHiddenTime = timeStamp;
  }, true);
};

var getVisibilityWatcher = (

) => {
  if (firstHiddenTime < 0) {
    // If the document is hidden when this code runs, assume it was hidden
    // since navigation start. This isn't a perfect heuristic, but it's the
    // best we can do until an API is available to support querying past
    // visibilityState.
    firstHiddenTime = initHiddenTime();
    trackChanges();
  }
  return {
    get firstHiddenTime() {
      return firstHiddenTime;
    },
  };
};


//# sourceMappingURL=getVisibilityWatcher.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/getFID.js






/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var getFID = (onReport, reportAllChanges) => {
  var visibilityWatcher = getVisibilityWatcher();
  var metric = initMetric('FID');
  let report;

  var entryHandler = (entry) => {
    // Only report if the page wasn't hidden prior to the first input.
    if (report && entry.startTime < visibilityWatcher.firstHiddenTime) {
      metric.value = entry.processingStart - entry.startTime;
      metric.entries.push(entry);
      report(true);
    }
  };

  var po = observe('first-input', entryHandler );
  if (po) {
    report = bindReporter(onReport, metric, reportAllChanges);
    onHidden(() => {
      po.takeRecords().map(entryHandler );
      po.disconnect();
    }, true);
  }
};


//# sourceMappingURL=getFID.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/getLCP.js






/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// https://wicg.github.io/largest-contentful-paint/#sec-largest-contentful-paint-interface

var reportedMetricIDs = {};

var getLCP = (onReport, reportAllChanges) => {
  var visibilityWatcher = getVisibilityWatcher();
  var metric = initMetric('LCP');
  let report;

  var entryHandler = (entry) => {
    // The startTime attribute returns the value of the renderTime if it is not 0,
    // and the value of the loadTime otherwise.
    var value = entry.startTime;

    // If the page was hidden prior to paint time of the entry,
    // ignore it and mark the metric as final, otherwise add the entry.
    if (value < visibilityWatcher.firstHiddenTime) {
      metric.value = value;
      metric.entries.push(entry);
    }

    if (report) {
      report();
    }
  };

  var po = observe('largest-contentful-paint', entryHandler);

  if (po) {
    report = bindReporter(onReport, metric, reportAllChanges);

    var stopListening = () => {
      if (!reportedMetricIDs[metric.id]) {
        po.takeRecords().map(entryHandler );
        po.disconnect();
        reportedMetricIDs[metric.id] = true;
        report(true);
      }
    };

    // Stop listening after input. Note: while scrolling is an input that
    // stop LCP observation, it's unreliable since it can be programmatically
    // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
    ['keydown', 'click'].forEach(type => {
      addEventListener(type, stopListening, { once: true, capture: true });
    });

    onHidden(stopListening, true);
  }
};


//# sourceMappingURL=getLCP.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/metrics/utils.js
/**
 * Checks if a given value is a valid measurement value.
 */
function isMeasurementValue(value) {
  return typeof value === 'number' && isFinite(value);
}

/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */
function _startChild(transaction, { startTimestamp, ...ctx }) {
  if (startTimestamp && transaction.startTimestamp > startTimestamp) {
    transaction.startTimestamp = startTimestamp;
  }

  return transaction.startChild({
    startTimestamp,
    ...ctx,
  });
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/metrics/index.js









var metrics_global = (0,global/* getGlobalObject */.R)();

function getBrowserPerformanceAPI() {
  return metrics_global && metrics_global.addEventListener && metrics_global.performance;
}

let _performanceCursor = 0;

let _measurements = {};
let _lcpEntry;
let _clsEntry;

/**
 * Start tracking web vitals
 */
function startTrackingWebVitals(reportAllChanges = false) {
  var performance = getBrowserPerformanceAPI();
  if (performance && time/* browserPerformanceTimeOrigin */.Z1) {
    if (performance.mark) {
      metrics_global.performance.mark('sentry-tracing-init');
    }
    _trackCLS();
    _trackLCP(reportAllChanges);
    _trackFID();
  }
}

/** Starts tracking the Cumulative Layout Shift on the current page. */
function _trackCLS() {
  // See:
  // https://web.dev/evolving-cls/
  // https://web.dev/cls-web-tooling/
  getCLS(metric => {
    var entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding CLS');
    _measurements['cls'] = { value: metric.value, unit: '' };
    _clsEntry = entry ;
  });
}

/** Starts tracking the Largest Contentful Paint on the current page. */
function _trackLCP(reportAllChanges) {
  getLCP(metric => {
    var entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    var timeOrigin = (0,utils/* msToSec */.XL)(time/* browserPerformanceTimeOrigin */.Z1 );
    var startTime = (0,utils/* msToSec */.XL)(entry.startTime);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding LCP');
    _measurements['lcp'] = { value: metric.value, unit: 'millisecond' };
    _measurements['mark.lcp'] = { value: timeOrigin + startTime, unit: 'second' };
    _lcpEntry = entry ;
  }, reportAllChanges);
}

/** Starts tracking the First Input Delay on the current page. */
function _trackFID() {
  getFID(metric => {
    var entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    var timeOrigin = (0,utils/* msToSec */.XL)(time/* browserPerformanceTimeOrigin */.Z1 );
    var startTime = (0,utils/* msToSec */.XL)(entry.startTime);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding FID');
    _measurements['fid'] = { value: metric.value, unit: 'millisecond' };
    _measurements['mark.fid'] = { value: timeOrigin + startTime, unit: 'second' };
  });
}

/** Add performance related spans to a transaction */
function addPerformanceEntries(transaction) {
  var performance = getBrowserPerformanceAPI();
  if (!performance || !metrics_global.performance.getEntries || !time/* browserPerformanceTimeOrigin */.Z1) {
    // Gatekeeper if performance API not available
    return;
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Tracing] Adding & adjusting spans using Performance API');
  var timeOrigin = (0,utils/* msToSec */.XL)(time/* browserPerformanceTimeOrigin */.Z1);

  var performanceEntries = performance.getEntries();

  let responseStartTimestamp;
  let requestStartTimestamp;

    performanceEntries.slice(_performanceCursor).forEach((entry) => {
    var startTime = (0,utils/* msToSec */.XL)(entry.startTime);
    var duration = (0,utils/* msToSec */.XL)(entry.duration);

    if (transaction.op === 'navigation' && timeOrigin + startTime < transaction.startTimestamp) {
      return;
    }

    switch (entry.entryType) {
      case 'navigation': {
        _addNavigationSpans(transaction, entry, timeOrigin);
        responseStartTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(entry.responseStart);
        requestStartTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(entry.requestStart);
        break;
      }
      case 'mark':
      case 'paint':
      case 'measure': {
        var startTimestamp = _addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);

        // capture web vitals
        var firstHidden = getVisibilityWatcher();
        // Only report if the page wasn't hidden prior to the web vital.
        var shouldRecord = entry.startTime < firstHidden.firstHiddenTime;

        if (entry.name === 'first-paint' && shouldRecord) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding FP');
          _measurements['fp'] = { value: entry.startTime, unit: 'millisecond' };
          _measurements['mark.fp'] = { value: startTimestamp, unit: 'second' };
        }
        if (entry.name === 'first-contentful-paint' && shouldRecord) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding FCP');
          _measurements['fcp'] = { value: entry.startTime, unit: 'millisecond' };
          _measurements['mark.fcp'] = { value: startTimestamp, unit: 'second' };
        }
        break;
      }
      case 'resource': {
        var resourceName = (entry.name ).replace(metrics_global.location.origin, '');
        _addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin);
        break;
      }
      default:
      // Ignore other entry types.
    }
  });

  _performanceCursor = Math.max(performanceEntries.length - 1, 0);

  _trackNavigator(transaction);

  // Measurements are only available for pageload transactions
  if (transaction.op === 'pageload') {
    // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
    // start of the response in milliseconds
    if (typeof responseStartTimestamp === 'number') {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding TTFB');
      _measurements['ttfb'] = {
        value: (responseStartTimestamp - transaction.startTimestamp) * 1000,
        unit: 'millisecond',
      };

      if (typeof requestStartTimestamp === 'number' && requestStartTimestamp <= responseStartTimestamp) {
        // Capture the time spent making the request and receiving the first byte of the response.
        // This is the time between the start of the request and the start of the response in milliseconds.
        _measurements['ttfb.requestTime'] = {
          value: (responseStartTimestamp - requestStartTimestamp) * 1000,
          unit: 'millisecond',
        };
      }
    }

    ['fcp', 'fp', 'lcp'].forEach(name => {
      if (!_measurements[name] || timeOrigin >= transaction.startTimestamp) {
        return;
      }
      // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
      // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
      // to be adjusted to be relative to transaction.startTimestamp.
      var oldValue = _measurements[name].value;
      var measurementTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(oldValue);

      // normalizedValue should be in milliseconds
      var normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
      var delta = normalizedValue - oldValue;

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.log */.kg.log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
      _measurements[name].value = normalizedValue;
    });

    if (_measurements['mark.fid'] && _measurements['fid']) {
      // create span for FID
      _startChild(transaction, {
        description: 'first input delay',
        endTimestamp: _measurements['mark.fid'].value + (0,utils/* msToSec */.XL)(_measurements['fid'].value),
        op: 'web.vitals',
        startTimestamp: _measurements['mark.fid'].value,
      });
    }

    // If FCP is not recorded we should not record the cls value
    // according to the new definition of CLS.
    if (!('fcp' in _measurements)) {
      delete _measurements.cls;
    }

    Object.keys(_measurements).forEach(measurementName => {
      transaction.setMeasurement(
        measurementName,
        _measurements[measurementName].value,
        _measurements[measurementName].unit,
      );
    });

    _tagMetricInfo(transaction);
  }

  _lcpEntry = undefined;
  _clsEntry = undefined;
  _measurements = {};
}

/** Create measure related spans */
function _addMeasureSpans(
  transaction,
    entry,
  startTime,
  duration,
  timeOrigin,
) {
  var measureStartTimestamp = timeOrigin + startTime;
  var measureEndTimestamp = measureStartTimestamp + duration;

  _startChild(transaction, {
    description: entry.name ,
    endTimestamp: measureEndTimestamp,
    op: entry.entryType ,
    startTimestamp: measureStartTimestamp,
  });

  return measureStartTimestamp;
}

/** Instrument navigation entries */
function _addNavigationSpans(transaction, entry, timeOrigin) {
  ['unloadEvent', 'redirect', 'domContentLoadedEvent', 'loadEvent', 'connect'].forEach(event => {
    _addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
  });
  _addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
  _addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
  _addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
  _addRequest(transaction, entry, timeOrigin);
}

/** Create performance navigation related spans */
function _addPerformanceNavigationTiming(
  transaction,
    entry,
  event,
  timeOrigin,
  description,
  eventEnd,
) {
  var end = eventEnd ? (entry[eventEnd] ) : (entry[`${event}End`] );
  var start = entry[`${event}Start`] ;
  if (!start || !end) {
    return;
  }
  _startChild(transaction, {
    op: 'browser',
    description: (0,_nullishCoalesce/* _nullishCoalesce */.h)(description, () => ( event)),
    startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(start),
    endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(end),
  });
}

/** Create request and response related spans */
function _addRequest(transaction, entry, timeOrigin) {
  _startChild(transaction, {
    op: 'browser',
    description: 'request',
    startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.requestStart ),
    endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseEnd ),
  });

  _startChild(transaction, {
    op: 'browser',
    description: 'response',
    startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseStart ),
    endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseEnd ),
  });
}

/** Create resource-related spans */
function _addResourceSpans(
  transaction,
  entry,
  resourceName,
  startTime,
  duration,
  timeOrigin,
) {
  // we already instrument based on fetch and xhr, so we don't need to
  // duplicate spans here.
  if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
    return;
  }

    var data = {};
  if ('transferSize' in entry) {
    data['Transfer Size'] = entry.transferSize;
  }
  if ('encodedBodySize' in entry) {
    data['Encoded Body Size'] = entry.encodedBodySize;
  }
  if ('decodedBodySize' in entry) {
    data['Decoded Body Size'] = entry.decodedBodySize;
  }

  var startTimestamp = timeOrigin + startTime;
  var endTimestamp = startTimestamp + duration;

  _startChild(transaction, {
    description: resourceName,
    endTimestamp,
    op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource',
    startTimestamp,
    data,
  });
}

/**
 * Capture the information of the user agent.
 */
function _trackNavigator(transaction) {
  var navigator = metrics_global.navigator ;
  if (!navigator) {
    return;
  }

  // track network connectivity
  var connection = navigator.connection;
  if (connection) {
    if (connection.effectiveType) {
      transaction.setTag('effectiveConnectionType', connection.effectiveType);
    }

    if (connection.type) {
      transaction.setTag('connectionType', connection.type);
    }

    if (isMeasurementValue(connection.rtt)) {
      _measurements['connection.rtt'] = { value: connection.rtt, unit: 'millisecond' };
    }

    if (isMeasurementValue(connection.downlink)) {
      _measurements['connection.downlink'] = { value: connection.downlink, unit: '' }; // unit is empty string for now, while relay doesn't support download speed units
    }
  }

  if (isMeasurementValue(navigator.deviceMemory)) {
    transaction.setTag('deviceMemory', `${navigator.deviceMemory} GB`);
  }

  if (isMeasurementValue(navigator.hardwareConcurrency)) {
    transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
  }
}

/** Add LCP / CLS data to transaction to allow debugging */
function _tagMetricInfo(transaction) {
  if (_lcpEntry) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding LCP Data');

    // Capture Properties of the LCP element that contributes to the LCP.

    if (_lcpEntry.element) {
      transaction.setTag('lcp.element', (0,browser/* htmlTreeAsString */.R)(_lcpEntry.element));
    }

    if (_lcpEntry.id) {
      transaction.setTag('lcp.id', _lcpEntry.id);
    }

    if (_lcpEntry.url) {
      // Trim URL to the first 200 characters.
      transaction.setTag('lcp.url', _lcpEntry.url.trim().slice(0, 200));
    }

    transaction.setTag('lcp.size', _lcpEntry.size);
  }

  // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
  if (_clsEntry && _clsEntry.sources) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding CLS Data');
    _clsEntry.sources.forEach((source, index) =>
      transaction.setTag(`cls.source.${index + 1}`, (0,browser/* htmlTreeAsString */.R)(source.node)),
    );
  }
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(57321);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__(9732);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(67597);
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/request.js



var DEFAULT_TRACING_ORIGINS = ['localhost', /^\//];

/** Options for Request Instrumentation */

var defaultRequestInstrumentationOptions = {
  traceFetch: true,
  traceXHR: true,
  tracingOrigins: DEFAULT_TRACING_ORIGINS,
};

/** Registers span creators for xhr and fetch requests  */
function instrumentOutgoingRequests(_options) {
    const { traceFetch, traceXHR, tracingOrigins, shouldCreateSpanForRequest } = {
    ...defaultRequestInstrumentationOptions,
    ..._options,
  };

  // We should cache url -> decision so that we don't have to compute
  // regexp everytime we create a request.
  var urlMap = {};

  var defaultShouldCreateSpan = (url) => {
    if (urlMap[url]) {
      return urlMap[url];
    }
    var origins = tracingOrigins;
    urlMap[url] =
      origins.some((origin) => (0,string/* isMatchingPattern */.zC)(url, origin)) &&
      !(0,string/* isMatchingPattern */.zC)(url, 'sentry_key');
    return urlMap[url];
  };

  // We want that our users don't have to re-implement shouldCreateSpanForRequest themselves
  // That's why we filter out already unwanted Spans from tracingOrigins
  let shouldCreateSpan = defaultShouldCreateSpan;
  if (typeof shouldCreateSpanForRequest === 'function') {
    shouldCreateSpan = (url) => {
      return defaultShouldCreateSpan(url) && shouldCreateSpanForRequest(url);
    };
  }

  var spans = {};

  if (traceFetch) {
    (0,instrument/* addInstrumentationHandler */.o)('fetch', (handlerData) => {
      fetchCallback(handlerData, shouldCreateSpan, spans);
    });
  }

  if (traceXHR) {
    (0,instrument/* addInstrumentationHandler */.o)('xhr', (handlerData) => {
      xhrCallback(handlerData, shouldCreateSpan, spans);
    });
  }
}

/**
 * Create and track fetch request spans
 */
function fetchCallback(
  handlerData,
  shouldCreateSpan,
  spans,
) {
  if (!(0,utils/* hasTracingEnabled */.zu)() || !(handlerData.fetchData && shouldCreateSpan(handlerData.fetchData.url))) {
    return;
  }

  if (handlerData.endTimestamp) {
    var spanId = handlerData.fetchData.__span;
    if (!spanId) return;

    var span = spans[spanId];
    if (span) {
      if (handlerData.response) {
        // TODO (kmclb) remove this once types PR goes through
                span.setHttpStatus(handlerData.response.status);
      } else if (handlerData.error) {
        span.setStatus('internal_error');
      }
      span.finish();

            delete spans[spanId];
    }
    return;
  }

  var activeTransaction = (0,utils/* getActiveTransaction */.x1)();
  if (activeTransaction) {
    var span = activeTransaction.startChild({
      data: {
        ...handlerData.fetchData,
        type: 'fetch',
      },
      description: `${handlerData.fetchData.method} ${handlerData.fetchData.url}`,
      op: 'http.client',
    });

    handlerData.fetchData.__span = span.spanId;
    spans[span.spanId] = span;

    var request = (handlerData.args[0] = handlerData.args[0] );
        var options = (handlerData.args[1] = (handlerData.args[1] ) || {});
    options.headers = addTracingHeaders(request, activeTransaction.getBaggage(), span, options);
  }
}

function addTracingHeaders(
  request,
  incomingBaggage,
  span,
  options,
) {
  let headers = options.headers;

  if ((0,is/* isInstanceOf */.V9)(request, Request)) {
    headers = (request ).headers;
  }

  if (headers) {
        if (typeof headers.append === 'function') {
            headers.append('sentry-trace', span.toTraceparent());
            headers.append(esm_baggage/* BAGGAGE_HEADER_NAME */.bU, (0,esm_baggage/* mergeAndSerializeBaggage */.J8)(incomingBaggage, headers.get(esm_baggage/* BAGGAGE_HEADER_NAME */.bU)));
    } else if (Array.isArray(headers)) {
      const [, headerBaggageString] = headers.find(([key, _]) => key === esm_baggage/* BAGGAGE_HEADER_NAME */.bU);
      headers = [
        ...headers,
        ['sentry-trace', span.toTraceparent()],
        [esm_baggage/* BAGGAGE_HEADER_NAME */.bU, (0,esm_baggage/* mergeAndSerializeBaggage */.J8)(incomingBaggage, headerBaggageString)],
      ];
    } else {
      headers = {
        ...headers,
        'sentry-trace': span.toTraceparent(),
                baggage: (0,esm_baggage/* mergeAndSerializeBaggage */.J8)(incomingBaggage, headers.baggage),
      };
    }
  } else {
    headers = { 'sentry-trace': span.toTraceparent(), baggage: (0,esm_baggage/* mergeAndSerializeBaggage */.J8)(incomingBaggage) };
  }
  return headers;
}

/**
 * Create and track xhr request spans
 */
function xhrCallback(
  handlerData,
  shouldCreateSpan,
  spans,
) {
  if (
    !(0,utils/* hasTracingEnabled */.zu)() ||
    (handlerData.xhr && handlerData.xhr.__sentry_own_request__) ||
    !(handlerData.xhr && handlerData.xhr.__sentry_xhr__ && shouldCreateSpan(handlerData.xhr.__sentry_xhr__.url))
  ) {
    return;
  }

  var xhr = handlerData.xhr.__sentry_xhr__;

  // check first if the request has finished and is tracked by an existing span which should now end
  if (handlerData.endTimestamp) {
    var spanId = handlerData.xhr.__sentry_xhr_span_id__;
    if (!spanId) return;

    var span = spans[spanId];
    if (span) {
      span.setHttpStatus(xhr.status_code);
      span.finish();

            delete spans[spanId];
    }
    return;
  }

  // if not, create a new span to track it
  var activeTransaction = (0,utils/* getActiveTransaction */.x1)();
  if (activeTransaction) {
    var span = activeTransaction.startChild({
      data: {
        ...xhr.data,
        type: 'xhr',
        method: xhr.method,
        url: xhr.url,
      },
      description: `${xhr.method} ${xhr.url}`,
      op: 'http.client',
    });

    handlerData.xhr.__sentry_xhr_span_id__ = span.spanId;
    spans[handlerData.xhr.__sentry_xhr_span_id__] = span;

    if (handlerData.xhr.setRequestHeader) {
      try {
        handlerData.xhr.setRequestHeader('sentry-trace', span.toTraceparent());

        var headerBaggageString =
          handlerData.xhr.getRequestHeader && handlerData.xhr.getRequestHeader(esm_baggage/* BAGGAGE_HEADER_NAME */.bU);

        handlerData.xhr.setRequestHeader(
          esm_baggage/* BAGGAGE_HEADER_NAME */.bU,
          (0,esm_baggage/* mergeAndSerializeBaggage */.J8)(activeTransaction.getBaggage(), headerBaggageString),
        );
      } catch (_) {
        // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
      }
    }
  }
}


//# sourceMappingURL=request.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/router.js


var router_global = (0,global/* getGlobalObject */.R)();

/**
 * Default function implementing pageload and navigation transactions
 */
function instrumentRoutingWithDefaults(
  customStartTransaction,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  if (!router_global || !router_global.location) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('Could not initialize routing instrumentation due to invalid location');
    return;
  }

  let startingUrl = router_global.location.href;

  let activeTransaction;
  if (startTransactionOnPageLoad) {
    activeTransaction = customStartTransaction({
      name: router_global.location.pathname,
      op: 'pageload',
      metadata: { source: 'url' },
    });
  }

  if (startTransactionOnLocationChange) {
    (0,instrument/* addInstrumentationHandler */.o)('history', ({ to, from }) => {
      /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */
      if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
        startingUrl = undefined;
        return;
      }

      if (from !== to) {
        startingUrl = undefined;
        if (activeTransaction) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
          // If there's an open transaction on the scope, we need to finish it before creating an new one.
          activeTransaction.finish();
        }
        activeTransaction = customStartTransaction({
          name: router_global.location.pathname,
          op: 'navigation',
          metadata: { source: 'url' },
        });
      }
    });
  }
}


//# sourceMappingURL=router.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/browsertracing.js









var BROWSER_TRACING_INTEGRATION_ID = 'BrowserTracing';

/** Options for Browser Tracing integration */

var DEFAULT_BROWSER_TRACING_OPTIONS = {
  idleTimeout: idletransaction/* DEFAULT_IDLE_TIMEOUT */.nT,
  finalTimeout: idletransaction/* DEFAULT_FINAL_TIMEOUT */.mg,
  markBackgroundTransactions: true,
  routingInstrumentation: instrumentRoutingWithDefaults,
  startTransactionOnLocationChange: true,
  startTransactionOnPageLoad: true,
  ...defaultRequestInstrumentationOptions,
};

/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */
class BrowserTracing  {
  // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
  // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
  // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
  // integrations.

  /** Browser Tracing integration options */
  

  /**
   * @inheritDoc
   */
   __init() {this.name = BROWSER_TRACING_INTEGRATION_ID;}

   constructor(_options) {;BrowserTracing.prototype.__init.call(this);
    let tracingOrigins = defaultRequestInstrumentationOptions.tracingOrigins;
    // NOTE: Logger doesn't work in constructors, as it's initialized after integrations instances
    if (_options) {
      if (_options.tracingOrigins && Array.isArray(_options.tracingOrigins) && _options.tracingOrigins.length !== 0) {
        tracingOrigins = _options.tracingOrigins;
      } else {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (this._emitOptionsWarning = true);
      }
    }

    this.options = {
      ...DEFAULT_BROWSER_TRACING_OPTIONS,
      ..._options,
      tracingOrigins,
    };

    const { _metricOptions } = this.options;
    startTrackingWebVitals(_metricOptions && _metricOptions._reportAllChanges);
  }

  /**
   * @inheritDoc
   */
   setupOnce(_, getCurrentHub) {
    this._getCurrentHub = getCurrentHub;

    if (this._emitOptionsWarning) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.warn */.kg.warn(
          '[Tracing] You need to define `tracingOrigins` in the options. Set an array of urls or patterns to trace.',
        );
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.warn */.kg.warn(
          `[Tracing] We added a reasonable default for you: ${defaultRequestInstrumentationOptions.tracingOrigins}`,
        );
    }

        const {
      routingInstrumentation: instrumentRouting,
      startTransactionOnLocationChange,
      startTransactionOnPageLoad,
      markBackgroundTransactions,
      traceFetch,
      traceXHR,
      tracingOrigins,
      shouldCreateSpanForRequest,
    } = this.options;

    instrumentRouting(
      (context) => this._createRouteTransaction(context),
      startTransactionOnPageLoad,
      startTransactionOnLocationChange,
    );

    if (markBackgroundTransactions) {
      registerBackgroundTabDetection();
    }

    instrumentOutgoingRequests({ traceFetch, traceXHR, tracingOrigins, shouldCreateSpanForRequest });
  }

  /** Create routing idle transaction. */
   _createRouteTransaction(context) {
    if (!this._getCurrentHub) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
      return undefined;
    }

        const { beforeNavigate, idleTimeout, finalTimeout } = this.options;

    var parentContextFromHeader = context.op === 'pageload' ? extractTraceDataFromMetaTags() : undefined;

    var expandedContext = {
      ...context,
      ...parentContextFromHeader,
      ...(parentContextFromHeader && {
        metadata: {
          ...context.metadata,
          ...parentContextFromHeader.metadata,
        },
      }),
      trimEnd: true,
    };
    var modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;

    // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
    // from being sent to Sentry).
    var finalContext = modifiedContext === undefined ? { ...expandedContext, sampled: false } : modifiedContext;

    // If `beforeNavigate` set a custom name, record that fact
    finalContext.metadata =
      finalContext.name !== expandedContext.name
        ? { ...finalContext.metadata, source: 'custom' }
        : finalContext.metadata;

    if (finalContext.sampled === false) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.log */.kg.log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] Starting ${finalContext.op} transaction on scope`);

    var hub = this._getCurrentHub();
    const { location } = (0,global/* getGlobalObject */.R)() ;

    var idleTransaction = (0,hubextensions/* startIdleTransaction */.lb)(
      hub,
      finalContext,
      idleTimeout,
      finalTimeout,
      true,
      { location }, // for use in the tracesSampler
    );
    idleTransaction.registerBeforeFinishCallback(transaction => {
      addPerformanceEntries(transaction);
      transaction.setTag(
        'sentry_reportAllChanges',
        Boolean(this.options._metricOptions && this.options._metricOptions._reportAllChanges),
      );
    });

    return idleTransaction ;
  }
}

/**
 * Gets transaction context data from `sentry-trace` and `baggage` <meta> tags.
 * @returns Transaction context data or undefined neither tag exists or has valid data
 */
function extractTraceDataFromMetaTags() {
  var sentrytraceValue = getMetaContent('sentry-trace');
  var baggageValue = getMetaContent('baggage');

  var sentrytraceData = sentrytraceValue ? extractTraceparentData(sentrytraceValue) : undefined;
  var baggage = (0,esm_baggage/* parseBaggageSetMutability */.rg)(baggageValue, sentrytraceValue);

  // TODO more extensive checks for baggage validity/emptyness?
  if (sentrytraceData || baggage) {
    return {
      ...(sentrytraceData && sentrytraceData),
      ...(baggage && { metadata: { baggage } }),
    };
  }

  return undefined;
}

/** Returns the value of a meta tag */
function getMetaContent(metaName) {
  var globalObject = (0,global/* getGlobalObject */.R)();

  // DOM/querySelector is not available in all environments
  if (globalObject.document && globalObject.document.querySelector) {
    var el = globalObject.document.querySelector(`meta[name=${metaName}]`);
    return el ? el.getAttribute('content') : null;
  } else {
    return null;
  }
}


//# sourceMappingURL=browsertracing.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/index.js














;
;

// Treeshakable guard to remove all code related to tracing

// Guard for tree
if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) {
  // We are patching the global object with our hub extension methods
  (0,hubextensions/* addExtensionMethods */.ro)();
}
//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(62844);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(20535);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/performance/client.js



var client_global = (0,global/* getGlobalObject */.R)();

var DEFAULT_TAGS = {
  'routing.instrumentation': 'next-router',
} ;

let activeTransaction = undefined;
let prevTransactionName = undefined;
let startTransaction = undefined;

/**
 * Creates routing instrumention for Next Router. Only supported for
 * client side routing. Works for Next >= 10.
 *
 * Leverages the SingletonRouter from the `next/router` to
 * generate pageload/navigation transactions and parameterize
 * transaction names.
 */
function nextRouterInstrumentation(
  startTransactionCb,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  startTransaction = startTransactionCb;
  router["default"].ready(() => {
    // We can only start the pageload transaction when we have access to the parameterized
    // route name. Setting the transaction name after the transaction is started could lead
    // to possible race conditions with the router, so this approach was taken.
    if (startTransactionOnPageLoad) {
      var pathIsRoute = router["default"].route !== null;

      prevTransactionName = pathIsRoute ? (0,misc/* stripUrlQueryAndFragment */.rt)(router["default"].route) : client_global.location.pathname;
      activeTransaction = startTransactionCb({
        name: prevTransactionName,
        op: 'pageload',
        tags: DEFAULT_TAGS,
        metadata: {
          source: pathIsRoute ? 'route' : 'url',
        },
      });
    }

    // Spans that aren't attached to any transaction are lost; so if transactions aren't
    // created (besides potentially the onpageload transaction), no need to wrap the router.
    if (!startTransactionOnLocationChange) return;

    // `withRouter` uses `useRouter` underneath:
    // https://github.com/vercel/next.js/blob/de42719619ae69fbd88e445100f15701f6e1e100/packages/next/client/with-router.tsx#L21
    // Router events also use the router:
    // https://github.com/vercel/next.js/blob/de42719619ae69fbd88e445100f15701f6e1e100/packages/next/client/router.ts#L92
    // `Router.changeState` handles the router state changes, so it may be enough to only wrap it
    // (instead of wrapping all of the Router's functions).
    var routerPrototype = Object.getPrototypeOf(router["default"].router);
    (0,object/* fill */.hl)(routerPrototype, 'changeState', changeStateWrapper);
  });
}

/**
 * Wraps Router.changeState()
 * https://github.com/vercel/next.js/blob/da97a18dafc7799e63aa7985adc95f213c2bf5f3/packages/next/next-server/lib/router/router.ts#L1204
 * Start a navigation transaction every time the router changes state.
 */
function changeStateWrapper(originalChangeStateWrapper) {
  var wrapper = function (
    
    method,
    // The parameterized url, ex. posts/[id]/[comment]
    url,
    // The actual url, ex. posts/85/my-comment
    as,
    options,
    // At the moment there are no additional arguments (meaning the rest parameter is empty).
    // This is meant to protect from future additions to Next.js API, especially since this is an
    // internal API.
    ...args
  ) {
    var newTransactionName = (0,misc/* stripUrlQueryAndFragment */.rt)(url);
    // do not start a transaction if it's from the same page
    if (startTransaction !== undefined && prevTransactionName !== newTransactionName) {
      if (activeTransaction) {
        activeTransaction.finish();
      }
      var tags = {
        ...DEFAULT_TAGS,
        method,
        ...options,
      };
      if (prevTransactionName) {
        tags.from = prevTransactionName;
      }
      prevTransactionName = newTransactionName;
      activeTransaction = startTransaction({
        name: prevTransactionName,
        op: 'navigation',
        tags,
        metadata: { source: 'route' },
      });
    }
    return originalChangeStateWrapper.call(this, method, url, as, options, ...args);
  };
  return wrapper;
}


//# sourceMappingURL=client.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/utils/metadata.js


var PACKAGE_NAME_PREFIX = 'npm:@sentry/';

/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 * @param options sdk options object that gets mutated
 * @param names list of package names
 */
function buildMetadata(options, names) {
  options._metadata = options._metadata || {};
  options._metadata.sdk =
    options._metadata.sdk ||
    ({
      name: 'sentry.javascript.nextjs',
      packages: names.map(name => ({
        name: `${PACKAGE_NAME_PREFIX}${name}`,
        version: version/* SDK_VERSION */.J,
      })),
      version: version/* SDK_VERSION */.J,
    } );
}


//# sourceMappingURL=metadata.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/utils/userIntegrations.js
/**
 * Recursively traverses an object to update an existing nested key.
 * Note: The provided key path must include existing properties,
 * the function will not create objects while traversing.
 *
 * @param obj An object to update
 * @param value The value to update the nested key with
 * @param keyPath The path to the key to update ex. fizz.buzz.foo
 */
function setNestedKey(obj, keyPath, value) {
  // Ex. foo.bar.zoop will extract foo and bar.zoop
  var match = keyPath.match(/([a-z]+)\.(.*)/i);
  if (match === null) {
    obj[keyPath] = value;
  } else {
    setNestedKey(obj[match[1]], match[2], value);
  }
}

/**
 * Retrieves the patched integrations with the provided integration.
 *
 * The integration must be present in the final user integrations, and they are compared
 * by integration name. If the user has defined one, there's nothing to patch; if not,
 * the provided integration is added.
 *
 * @param integration The integration to patch, if necessary.
 * @param userIntegrations Integrations defined by the user.
 * @param options options to update for a particular integration
 * @returns Final integrations, patched if necessary.
 */
function addIntegration(
  integration,
  userIntegrations,
  options = {},
) {
  if (Array.isArray(userIntegrations)) {
    return addIntegrationToArray(integration, userIntegrations, options);
  } else {
    return addIntegrationToFunction(integration, userIntegrations, options);
  }
}

function addIntegrationToArray(
  integration,
  userIntegrations,
  options,
) {
  let includesName = false;
    for (let x = 0; x < userIntegrations.length; x++) {
    if (userIntegrations[x].name === integration.name) {
      includesName = true;
    }

    var op = options[userIntegrations[x].name];
    if (op) {
      setNestedKey(userIntegrations[x], op.keyPath, op.value);
    }
  }

  if (includesName) {
    return userIntegrations;
  }
  return [...userIntegrations, integration];
}

function addIntegrationToFunction(
  integration,
  userIntegrationsFunc,
  options,
) {
  var wrapper = defaultIntegrations => {
    var userFinalIntegrations = userIntegrationsFunc(defaultIntegrations);
    return addIntegrationToArray(integration, userFinalIntegrations, options);
  };
  return wrapper;
}


//# sourceMappingURL=userIntegrations.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/index.client.js











// Treeshakable guard to remove all code related to tracing

/** Inits the Sentry NextJS SDK on the browser with the React SDK. */
function index_client_init(options) {
  buildMetadata(options, ['nextjs', 'react']);
  options.environment = options.environment || "production";

  let integrations = options.integrations;

  // Guard below evaluates to true unless __SENTRY_TRACING__ is text-replaced with "false"
  if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) {
    // Only add BrowserTracing if a tracesSampleRate or tracesSampler is set
    if (options.tracesSampleRate !== undefined || options.tracesSampler !== undefined) {
      integrations = createClientIntegrations(options.integrations);
    }
  }

  init({
    ...options,
    integrations,
  });

  (0,esm_exports/* configureScope */.e)(scope => {
    scope.setTag('runtime', 'browser');
    var filterTransactions = event =>
      event.type === 'transaction' && event.transaction === '/404' ? null : event;
    filterTransactions.id = 'NextClient404Filter';
    scope.addEventProcessor(filterTransactions);
  });
}

function createClientIntegrations(integrations) {
  var defaultBrowserTracingIntegration = new BrowserTracing({
    tracingOrigins: [...defaultRequestInstrumentationOptions.tracingOrigins, /^(api\/)/],
    routingInstrumentation: nextRouterInstrumentation,
  });

  if (integrations) {
    return addIntegration(defaultBrowserTracingIntegration, integrations, {
      BrowserTracing: { keyPath: 'options.routingInstrumentation', value: nextRouterInstrumentation },
    });
  } else {
    return [defaultBrowserTracingIntegration];
  }
}


//# sourceMappingURL=index.client.js.map

;// CONCATENATED MODULE: ./sentry.client.config.js
/* provided dependency */ var process = __webpack_require__(83454);

var SENTRY_DSN = process.env.SENTRY_DSN || "https://c66a6e3c2ffb4985bcce4377376e48eb@o299040.ingest.sentry.io/1855323";
index_client_init({
    dsn: SENTRY_DSN,
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1
});


/***/ }),

/***/ 17587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ContentHeadline; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/utils/slugify.js
/* eslint-disable */ function slugify(str) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();
    // remove accents, swap ñ for n, etc
    var from = '\xe0\xe1\xe4\xe2\xe8\xe9\xeb\xea\xec\xed\xef\xee\xf2\xf3\xf6\xf4\xf9\xfa\xfc\xfb\xf1\xe7\xb7/_,:;';
    var to = 'aaaaeeeeiiiioooouuuunc------';
    for(var i = 0, l = from.length; i < l; i++){
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }
    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-'); // collapse dashes
    return str;
};

;// CONCATENATED MODULE: ./src/components/content/headline.js


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ContentHeadline(_param) {
    var _tag = _param.tag, tag = _tag === void 0 ? '2' : _tag, _after = _param.after, after = _after === void 0 ? '' : _after, _before = _param.before, before = _before === void 0 ? '' : _before, children = _param.children, _className = _param.className, className = _className === void 0 ? '' : _className, _id = _param.id, id = _id === void 0 ? '' : _id, _line = _param.line, line = _line === void 0 ? true : _line, props = _objectWithoutProperties(_param, [
        "tag",
        "after",
        "before",
        "children",
        "className",
        "id",
        "line"
    ]);
    var aTag = tag || '2';
    var ElementTag = /^\d*$/.test(aTag) ? "h".concat(aTag) : aTag;
    var generatedId = id || "toc-g-".concat(slugify(children.toString()));
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pb-4",
        id: generatedId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ElementTag, _objectSpread({
                className: "text-primary inline ".concat(className)
            }, props, {
                children: [
                    before && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "font-serif text-4xl md:text-5xl pr-2 relative leading-1",
                        children: [
                            before,
                            "\xa0"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-xl md:text-2xl font-semibold uppercase tracking-tight",
                        children: children
                    }),
                    after && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "font-serif text-4xl md:text-5xl pl-1 relative leading-1",
                        children: [
                            "\xa0",
                            after
                        ]
                    })
                ]
            })),
            line && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-[2px] mt-2 ml-10 w-30 bg-action"
            })
        ]
    }));
};


/***/ }),

/***/ 81474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _helper_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34892);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Button(_param) {
    var _mainClass = _param.mainClass, mainClass = _mainClass === void 0 ? '' : _mainClass, _width = _param.width, width = _width === void 0 ? '' : _width, _variant = _param.variant, variant = _variant === void 0 ? 'action' : _variant, _type = _param.type, type = _type === void 0 ? 'button' : _type, _size = _param.size, size = _size === void 0 ? 'md' : _size, _href = _param.href, href = _href === void 0 ? '' : _href, children = _param.children, props = _objectWithoutProperties(_param, [
        "mainClass",
        "width",
        "variant",
        "type",
        "size",
        "href",
        "children"
    ]);
    var variantPrimary = 'bg-primary hover:bg-primary-600 text-white lg:text-base text-sm border border-primary-600 hover:border-primary-700 uppercase font-bold';
    var variantAction = 'bg-action hover:bg-action-600 text-primary lg:text-base text-sm border border-action-600 hover:border-action-700 uppercase font-bold';
    var cl = mainClass || (variant === 'primary' ? variantPrimary : variantAction);
    var sl = size === 'sm' ? 'py-2.5 lg:px-4 px-3' : 'py-3.5 lg:px-6 px-5';
    if (href) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_helper_link__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            href: href,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", _objectSpread({
                className: "flex justify-center text-center focus:outline-none transition-all ".concat(cl, " ").concat(sl, " ").concat(width)
            }, props, {
                children: children
            }))
        }));
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", _objectSpread({
        className: "flex justify-center text-center focus:outline-none transition-all ".concat(cl, " ").concat(sl, " ").concat(width),
        type: type
    }, props, {
        children: children
    })));
};


/***/ }),

/***/ 66505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Input; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Input(param) {
    var label = param.label, type = param.type, id = param.id, placeholder = param.placeholder, register = param.register, error = param.error, name = param.name, _mainClass = param.mainClass, mainClass = _mainClass === void 0 ? '' : _mainClass;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat(mainClass, " relative bg-gray-100 border border-gray-400 group w-full transition-all overflow-hidden"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", _objectSpread({}, register, {
                type: type,
                className: "input-text z-[3] relative block w-full px-2 py-1 pt-5 bg-transparent border-b-2 border-transparent group-hover:border-secondary focus:outline-none focus:border-primary ring-0 ".concat(error ? 'border-red-600s' : ''),
                id: id,
                placeholder: placeholder,
                name: name
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                className: "absolute top-1 z-10 block w-full px-2 text-xs font-bold ".concat(error ? 'text-red-600' : 'text-primary '),
                htmlFor: id,
                children: label
            })
        ]
    }));
};


/***/ }),

/***/ 34892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/* harmony default export */ __webpack_exports__["Z"] = ((0,next_router__WEBPACK_IMPORTED_MODULE_2__.withRouter)(function(_param) /*#__PURE__*/ {
    var router = _param.router, children = _param.children, as = _param.as, href = _param.href, _activeClassName = _param.activeClassName, activeClassName = _activeClassName === void 0 ? 'active' : _activeClassName, rest = _objectWithoutProperties(_param, [
        "router",
        "children",
        "as",
        "href",
        "activeClassName"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], _objectSpread({}, rest, {
        href: href,
        as: as,
        prefetch: false,
        children: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.cloneElement(react__WEBPACK_IMPORTED_MODULE_3__.Children.only(children), {
            className: router.asPath === href && router.locale === rest.locale || router.asPath === as && router.locale === rest.locale ? "".concat(children.props.className || '', " ").concat(activeClassName || 'active') : children.props.className || ''
        })
    }));
}));


/***/ }),

/***/ 57806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pn": function() { return /* binding */ GlobalStateContext; },
/* harmony export */   "aW": function() { return /* binding */ DispatchStateContext; },
/* harmony export */   "MC": function() { return /* binding */ GlobalStateProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var defaultGlobalState = {
    open: false,
    config: {}
};
var GlobalStateContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(defaultGlobalState);
var DispatchStateContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(undefined);
function GlobalStateProvider(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(function(state, newValue) {
        return _objectSpread({}, state, newValue);
    }, defaultGlobalState), state1 = ref[0], dispatch = ref[1];
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GlobalStateContext.Provider, {
        value: state1,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DispatchStateContext.Provider, {
            value: dispatch,
            children: children
        })
    }));
}


/***/ }),

/***/ 43424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Io": function() { return /* binding */ fetchAPI; },
/* harmony export */   "u9": function() { return /* binding */ fetchAPIPost; }
/* harmony export */ });
/* unused harmony export getConnectUrl */
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
/**
 * Get full Strapi URL from path
 * @param {string} path Path of the URL
 * @returns {string} Full Strapi URL
 */ function getConnectUrl() {
    var path = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
    return "".concat("https://connect.5-anker.com" || 0).concat(path);
}
/**
 * Helper to make GET requests to Strapi API endpoints
 * @param {string} path Path of the API route
 * @param {Object} urlParamsObject URL params object, will be stringified
 * @param {Object} options Options passed to fetch
 * @returns Parsed API call response
 */ function fetchAPI(path) {
    return _fetchAPI.apply(this, arguments);
}
function _fetchAPI() {
    _fetchAPI = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(path) {
        var urlParamsObject, options, cid, mergedOptions, queryString, requestUrl, response, _args = arguments;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    urlParamsObject = _args.length > 1 && _args[1] !== void 0 ? _args[1] : {}, options = _args.length > 2 && _args[2] !== void 0 ? _args[2] : {};
                    cid = ''; // @todo look at WLS
                    mergedOptions = _objectSpread({
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': 'de-DE',
                            Authorization: "Bearer ".concat("6173cba3382e5326a5190078c7784a4a"),
                            'Client-Id': cid
                        }
                    }, options);
                    queryString = new URLSearchParams(urlParamsObject);
                    requestUrl = "".concat(getConnectUrl("/dnet/com".concat(path).concat(queryString ? "?".concat(queryString) : '')));
                    ;
                    _ctx.next = 8;
                    return fetch(requestUrl, mergedOptions);
                case 8:
                    response = _ctx.sent;
                    if (response.ok) {
                        _ctx.next = 12;
                        break;
                    }
                    console.error(response.statusText);
                    return _ctx.abrupt("return", null);
                case 12:
                    return _ctx.abrupt("return", response.json());
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _fetchAPI.apply(this, arguments);
}
/**
 * Helper to make GET requests to Strapi API endpoints
 * @param {string} path Path of the API route
 * @param {Object }body POST body content
 * @param {Object} urlParamsObject URL params object, will be stringified
 * @param {Object} options Options passed to fetch
 * @returns Parsed API call response
 */ function fetchAPIPost(path, body) {
    return _fetchAPIPost.apply(this, arguments);
}
function _fetchAPIPost() {
    _fetchAPIPost = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(path, body) {
        var urlParamsObject, options, cid, mergedOptions, queryString, requestUrl, response, json, _args = arguments;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    urlParamsObject = _args.length > 2 && _args[2] !== void 0 ? _args[2] : {}, options = _args.length > 3 && _args[3] !== void 0 ? _args[3] : {};
                    cid = ''; // @todo look at WLS
                    mergedOptions = _objectSpread({
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: "Bearer ".concat("6173cba3382e5326a5190078c7784a4a"),
                            'Client-Id': cid,
                            Accept: 'application/json'
                        },
                        body: JSON.stringify(body)
                    }, options);
                    queryString = new URLSearchParams(urlParamsObject);
                    requestUrl = "".concat(getConnectUrl("/dnet/com".concat(path).concat(queryString ? "?".concat(queryString) : '')));
                    _ctx.next = 7;
                    return fetch(requestUrl, mergedOptions);
                case 7:
                    response = _ctx.sent;
                    _ctx.next = 10;
                    return response.json();
                case 10:
                    json = _ctx.sent;
                    if (response.ok) {
                        _ctx.next = 13;
                        break;
                    }
                    return _ctx.abrupt("return", Promise.reject(json));
                case 13:
                    return _ctx.abrupt("return", json);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _fetchAPIPost.apply(this, arguments);
}


/***/ }),

/***/ 23802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/styles/globals.css
var globals = __webpack_require__(20472);
// EXTERNAL MODULE: ./src/styles/nprogress.css
var nprogress = __webpack_require__(73687);
// EXTERNAL MODULE: ./src/styles/calendar.css
var calendar = __webpack_require__(61284);
// EXTERNAL MODULE: ./node_modules/react-dates/initialize.js
var initialize = __webpack_require__(6063);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 11 modules
var esm = __webpack_require__(70300);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/nprogress/nprogress.js
var nprogress_nprogress = __webpack_require__(74865);
var nprogress_nprogress_default = /*#__PURE__*/__webpack_require__.n(nprogress_nprogress);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./node_modules/moment/locale/de.js
var de = __webpack_require__(59740);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(65988);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/popover/popover.js
var popover = __webpack_require__(86215);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 5 modules
var transition = __webpack_require__(33587);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/outline/esm/MenuIcon.js


function MenuIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4 6h16M4 12h16M4 18h16"
  }));
}

const ForwardRef = react.forwardRef(MenuIcon);
/* harmony default export */ var esm_MenuIcon = (ForwardRef);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/XIcon.js
var XIcon = __webpack_require__(5506);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/outline/esm/SearchIcon.js


function SearchIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
  }));
}

const SearchIcon_ForwardRef = react.forwardRef(SearchIcon);
/* harmony default export */ var esm_SearchIcon = (SearchIcon_ForwardRef);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/outline/esm/GlobeIcon.js


function GlobeIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

const GlobeIcon_ForwardRef = react.forwardRef(GlobeIcon);
/* harmony default export */ var esm_GlobeIcon = (GlobeIcon_ForwardRef);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/outline/esm/GlobeAltIcon.js


function GlobeAltIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
  }));
}

const GlobeAltIcon_ForwardRef = react.forwardRef(GlobeAltIcon);
/* harmony default export */ var esm_GlobeAltIcon = (GlobeAltIcon_ForwardRef);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/outline/esm/NewspaperIcon.js


function NewspaperIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"
  }));
}

const NewspaperIcon_ForwardRef = react.forwardRef(NewspaperIcon);
/* harmony default export */ var esm_NewspaperIcon = (NewspaperIcon_ForwardRef);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/outline/esm/ShoppingCartIcon.js


function ShoppingCartIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
  }));
}

const ShoppingCartIcon_ForwardRef = react.forwardRef(ShoppingCartIcon);
/* harmony default export */ var esm_ShoppingCartIcon = (ShoppingCartIcon_ForwardRef);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/outline/esm/QuestionMarkCircleIcon.js


function QuestionMarkCircleIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

const QuestionMarkCircleIcon_ForwardRef = react.forwardRef(QuestionMarkCircleIcon);
/* harmony default export */ var esm_QuestionMarkCircleIcon = (QuestionMarkCircleIcon_ForwardRef);
;// CONCATENATED MODULE: ./public/assets/icons/inspo.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgInspo = function SvgInspo(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "m107.1 287.3-55.48 32c-7.5 4.125-12.25 12.13-12.38 20.88 0 8.625 4.625 16.63 12.13 21 7.625 4.25 16.87 4.125 24.25-.375l55.5-32c11.12-6.75 14.87-21.25 8.375-32.5C133 284.9 118.5 280.9 107.1 287.3zm24-232.05-55.5-32c-7.375-4.5-16.62-4.625-24.25-.375-7.5 4.375-12.13 12.38-12.13 21 .15 8.755 4.9 16.755 12.4 20.875l55.48 32c7.4 4.55 16.7 4.65 24.3.38 7.5-4.38 12.1-12.38 12.1-21-.1-8.75-4.9-16.75-12.4-20.88zM112 192c0-13.25-10.75-24-24-24H24c-13.25 0-24 10.75-24 24s10.75 24 24 24h64c13.3 0 24-10.7 24-24zm409-92c4.125 0 8.25-1.125 12-3.25l55.38-32c11.25-6.75 14.88-21.25 8.375-32.5-6.5-11.38-21-15.38-32.38-9L509 55.25c-9.5 5.375-14 16.5-11.25 27C500.6 92.75 510.1 100 521 100zm95 68h-64c-13.25 0-24 10.75-24 24s10.75 24 24 24h64c13.25 0 24-10.75 24-24s-10.7-24-24-24zm-27.6 151.3-55.5-32c-7.375-4.5-16.62-4.625-24.25-.375-7.5 4.375-12.12 12.38-12.12 21 .125 8.75 4.875 16.75 12.38 20.88l55.5 32c11.38 6.375 25.88 2.375 32.38-9C603.3 340.5 599.5 326 588.4 319.3zM320 .004C218 .324 144 82.98 144 175.1c0 44.38 16.4 84.82 43.52 115.8 16.53 18.84 42.36 58.26 52.24 91.48.031.25.083.495.115.76l160.3.001c.03-.266.052-.495.083-.761 9.875-33.22 35.71-72.64 52.24-91.48C479.6 260.8 496 220.4 496 175.1 496 78.8 417.2.007 320 .004zM416.4 260.1c-15.66 17.85-35.04 46.3-49.05 75.89h-94.61c-14.01-29.59-33.39-58.04-49.04-75.88C203.2 236.8 192 206.1 192 175.1c0-61.8 48.1-126.85 127.1-127.1C390.6 48 448 105.4 448 175.1c0 31-11.2 61.7-31.6 85zM240.1 454.4c0 6.297 1.89 12.43 5.359 17.68l17.09 25.69c5.25 7.875 17.18 14.28 26.65 14.28h61.72c9.438 0 21.38-6.395 26.63-14.27l17.09-25.69C397.6 467.6 400 459.7 400 454.4v-38.36l-159.9.005V454.4zM304 80c-44.1 0-80 35.9-80 80 0 8.844 7.156 16.01 16 16.01s16-7.21 16-16.01c0-26.47 21.53-48 48-48 8.844 0 16-7.145 16-15.99S312.8 80 304 80z"
  })));
};

/* harmony default export */ var inspo = (SvgInspo);
;// CONCATENATED MODULE: ./public/assets/icons/tour.svg
var tour_path, _path2, _path3;

function tour_extends() { tour_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return tour_extends.apply(this, arguments); }



var SvgTour = function SvgTour(props) {
  return /*#__PURE__*/react.createElement("svg", tour_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 457.2"
  }, props), tour_path || (tour_path = /*#__PURE__*/react.createElement("path", {
    className: "tour_svg__st0",
    d: "M128 395.8c5.5 0 10-4.5 10-10v-35.6c16.7-4.4 29.1-19.7 29.1-37.8 0-21.6-17.5-39.1-39.1-39.1s-39.1 17.5-39.1 39.1c0 18.1 12.4 33.4 29.1 37.8v35.6c0 5.5 4.5 10 10 10zm-19.1-83.4c0-10.5 8.6-19.1 19.1-19.1s19.1 8.6 19.1 19.1c0 10.5-8.6 19.1-19.1 19.1s-19.1-8.5-19.1-19.1zM405.3 209l41.3-57.6c9.9-13.7 13.6-31.1 10.2-47.7s-13.6-31.1-28.1-39.9C409.2 52 385 52 365.6 63.8c-14.4 8.8-24.7 23.3-28.1 39.9s.3 33.9 10.2 47.7L389 209c1.9 2.6 4.9 4.2 8.1 4.2s6.3-1.6 8.2-4.2zm-41.4-69.3c-6.7-9.4-9.1-20.7-6.8-32s9-20.8 18.8-26.8c6.5-4 13.9-5.9 21.2-5.9s14.7 2 21.2 5.9c9.8 6 16.5 15.5 18.8 26.8s-.1 22.6-6.8 32L397.1 186l-33.2-46.3z"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    className: "tour_svg__st0",
    d: "M505.2 55.6 341.2.5c-2.1-.7-4.3-.7-6.4 0L174 54.5 13.2.5c-3.1-1-6.4-.5-9 1.4C1.6 3.8 0 6.8 0 10v382.1c0 4.3 2.7 8.1 6.8 9.5l164 55.1c2.1.7 4.3.7 6.4 0l160.8-54 160.8 54c1 .3 2.1.5 3.2.5 2.1 0 4.1-.6 5.8-1.9 2.6-1.9 4.2-4.9 4.2-8.1v-99.6c0-5.5-4.5-10-10-10s-10 4.5-10 10v85.7l-150.8-50.6c-2.1-.7-4.3-.7-6.4 0l-160.8 54-154-51.8v-361l150.8 50.6c2.1.7 4.3.7 6.4 0l160.8-54 154 51.7v186.7c0 5.5 4.5 10 10 10s10-4.5 10-10V65.1c0-4.3-2.7-8.1-6.8-9.5z"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    className: "tour_svg__st0",
    d: "M502 292.6c-2.6 0-5.2 1.1-7.1 2.9-1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1s4.4 2.9 7.1 2.9 5.2-1.1 7.1-2.9 2.9-4.4 2.9-7.1c0-2.6-1.1-5.2-2.9-7.1-1.9-1.8-4.5-2.9-7.1-2.9zm-319 52.3c-5.5 0-10 4.5-10 10s4.5 10 10 10h6c5.5 0 10-4.5 10-10s-4.5-10-10-10h-6zm125.5-119.7c0-5.5-4.5-10-10-10h-12.1c-5.5 0-10 4.5-10 10s4.5 10 10 10h12.1c5.6 0 10-4.5 10-10zm32.8 115.1c-3.1 1.4-6.4 2.5-9.7 3.2-5.4 1.3-8.7 6.6-7.5 12 1.1 4.6 5.2 7.7 9.7 7.7.8 0 1.5-.1 2.3-.3 4.5-1.1 9-2.5 13.2-4.4 5.1-2.2 7.3-8.1 5.1-13.2-2.1-5-8-7.3-13.1-5zm17.2-102.8c2.6-4.9.8-10.9-4.1-13.5-4.1-2.2-8.4-4-12.9-5.4-5.3-1.6-10.9 1.3-12.5 6.6s1.3 10.9 6.6 12.5c3.2 1 6.4 2.3 9.4 3.9 1.5.8 3.1 1.2 4.7 1.2 3.5 0 7-1.9 8.8-5.3zm-76.8 107.4c-5.5 0-10 4.5-10 10s4.5 10 10 10h12.1c5.5 0 10-4.5 10-10s-4.5-10-10-10h-12.1zm109.5-75.1c-1.3-4.5-2.9-8.9-5-13-2.5-4.9-8.5-7-13.4-4.5s-7 8.5-4.5 13.4c1.5 3 2.7 6.2 3.7 9.5 1.2 4.4 5.3 7.3 9.6 7.3.9 0 1.8-.1 2.7-.4 5.3-1.4 8.4-7 6.9-12.3zm-7.6 32.9c-5.2-1.9-10.9.8-12.8 6-1.2 3.2-2.6 6.3-4.4 9.2-2.8 4.8-1.2 10.9 3.5 13.7 1.6.9 3.4 1.4 5.1 1.4 3.4 0 6.8-1.8 8.6-4.9 2.4-4 4.4-8.2 5.9-12.6 1.9-5.1-.8-10.9-5.9-12.8zM85.2 227c1.6.9 3.3 1.3 5 1.3 3.5 0 6.8-1.8 8.7-5 2.8-4.8 1.1-10.9-3.7-13.6-2.8-1.6-5.5-3.6-7.8-5.8-4-3.8-10.4-3.6-14.1.5s-3.6 10.4.5 14.1c3.4 3.2 7.3 6.1 11.4 8.5zm1-86.6c2 0 4-.6 5.7-1.8 2.7-1.9 5.6-3.4 8.6-4.6 5.1-2 7.6-7.9 5.6-13s-7.9-7.6-13-5.6c-4.4 1.8-8.7 4.1-12.6 6.8-4.5 3.2-5.6 9.4-2.4 13.9 1.9 2.8 5 4.3 8.1 4.3zm-19.5 13.2c-5.4-1-10.7 2.6-11.7 8-.7 3.8-1.1 7.6-1.1 11.5 0 .9 0 1.9.1 2.8.2 5.4 4.7 9.6 10 9.6h.5c5.5-.2 9.8-4.9 9.5-10.4v-1.9c0-2.6.2-5.3.7-7.8 1-5.5-2.5-10.8-8-11.8zM211.1 121c0-5.5-4.5-10-10-10H189c-5.5 0-10 4.5-10 10s4.5 10 10 10h12.1c5.5 0 10-4.5 10-10zm-91.8 104.2c0 5.5 4.5 10 10 10h12.1c5.5 0 10-4.5 10-10s-4.5-10-10-10h-12.1c-5.5 0-10 4.5-10 10zm17.3-94.2h12.1c5.5 0 10-4.5 10-10s-4.5-10-10-10h-12.1c-5.5 0-10 4.5-10 10s4.5 10 10 10zm119.5 94.2c0-5.5-4.5-10-10-10H234c-5.5 0-10 4.5-10 10s4.5 10 10 10h12.1c5.6 0 10-4.5 10-10zm-26.8 119.7c-5.5 0-10 4.5-10 10s4.5 10 10 10h12.1c5.5 0 10-4.5 10-10s-4.5-10-10-10h-12.1zM263.5 121c0-5.5-4.5-10-10-10h-12.1c-5.5 0-10 4.5-10 10s4.5 10 10 10h12.1c5.5 0 10-4.5 10-10zm-59.7 104.2c0-5.5-4.5-10-10-10h-12.1c-5.5 0-10 4.5-10 10s4.5 10 10 10h12.1c5.5 0 10-4.5 10-10zM300 111h-6c-5.5 0-10 4.5-10 10s4.5 10 10 10h6c5.5 0 10-4.5 10-10s-4.5-10-10-10z"
  })));
};

/* harmony default export */ var tour = (SvgTour);
// EXTERNAL MODULE: ./public/assets/icons/tips.svg
var tips = __webpack_require__(31119);
;// CONCATENATED MODULE: ./public/assets/icons/license.svg
var license_path;

function license_extends() { license_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return license_extends.apply(this, arguments); }



var SvgLicense = function SvgLicense(props) {
  return /*#__PURE__*/react.createElement("svg", license_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    fill: "currentColor"
  }, props), license_path || (license_path = /*#__PURE__*/react.createElement("path", {
    d: "M368 344h96c13.25 0 24-10.75 24-24s-10.75-24-24-24h-96c-13.25 0-24 10.75-24 24s10.8 24 24 24zm-160-24c35.35 0 64-28.65 64-64s-28.65-64-64-64-64 28.65-64 64c0 35.3 28.7 64 64 64zM512 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h448c35.35 0 64-28.65 64-64V96c0-35.35-28.7-64-64-64zm16 384c0 8.822-7.178 16-16 16H320c0-44.18-35.82-80-80-80h-64c-44.2 0-80 35.8-80 80H64c-8.822 0-16-7.178-16-16V160h480v256zM368 264h96c13.25 0 24-10.75 24-24s-10.75-24-24-24h-96c-13.25 0-24 10.75-24 24s10.8 24 24 24z"
  })));
};

/* harmony default export */ var license = (SvgLicense);
;// CONCATENATED MODULE: ./public/assets/icons/child.svg
var child_path;

function child_extends() { child_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return child_extends.apply(this, arguments); }



var SvgChild = function SvgChild(props) {
  return /*#__PURE__*/react.createElement("svg", child_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    fill: "currentColor"
  }, props), child_path || (child_path = /*#__PURE__*/react.createElement("path", {
    d: "M87.1 72c0-39.76 33.1-72 72-72 40.7 0 72 32.24 72 72 0 39.8-31.3 72-72 72-38.9 0-72-32.2-72-72zm72 24c14.2 0 24-10.75 24-24s-9.8-24-24-24c-12.4 0-24 10.75-24 24s11.6 24 24 24zM128 384v104c0 13.3-10.7 24-24 24-13.25 0-24-10.7-24-24V257.9l-36.34 51.9c-7.61 10.8-22.58 13.5-33.43 5.9-10.857-7.7-13.489-22.6-5.881-33.5L50.1 216.1c25.02-34.8 65-57 109.5-57 43.1 0 83.6 21.7 108.7 56l47.2 66.9c7.7 10.8 5.2 25.8-6.4 33.5-9.9 7.7-24.9 5.2-32.6-5.6l-36.5-51V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V384h-64zm0-48h64V214.4c-10.2-4.2-21.2-6.4-32.4-6.4-11 0-21.7 2.1-31.6 6v122z"
  })));
};

/* harmony default export */ var child = (SvgChild);
// EXTERNAL MODULE: ./public/assets/icons/boat.svg
var boat = __webpack_require__(93238);
;// CONCATENATED MODULE: ./public/assets/icons/dog.svg
var dog_path;

function dog_extends() { dog_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return dog_extends.apply(this, arguments); }



var SvgDog = function SvgDog(props) {
  return /*#__PURE__*/react.createElement("svg", dog_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    fill: "currentColor"
  }, props), dog_path || (dog_path = /*#__PURE__*/react.createElement("path", {
    d: "M400 144c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm-256-16c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm160 0c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm63.2 172.8c-26.25-14.75-47.12-61.38-67.12-97.76C284.4 174.3 254.3 160 224 160s-60.4 14.3-76.1 43c-20.4 36.9-40.1 82.5-67.27 97.8C51.63 317.1 32 348.1 32 384c0 53 43 95.88 96 95.88 1.2.12 2.7.12 3.1.12 49.7 0 69.7-32 92.9-32s43.2 32 92 32c1.3 0 2.8 0 4-.1 53 0 96-42.88 96-95.88 0-35.92-19.6-66.92-48.8-83.22zM320 431.9h-.75l-.85.1h-2.25c-15.75 0-25.25-5.75-38.5-13.62C263.9 410.1 246.8 400 224 400s-39.88 10.12-53.63 18.38C157.1 426.2 147.6 432 131.9 432h-2.3l-.75-.125H128c-26.5 0-48-21.5-48-47.88 0-17.38 9.125-32.88 24.25-41.38 34.63-19.62 55.25-59 75.25-97.13 3.5-6.625 7-13.12 10.38-19.38C199.1 209.2 218.4 208 224 208s24.88 1.25 34.13 18.12c3.27 5.88 6.47 12.08 9.87 18.38 20.5 38.75 41.63 78.88 75.75 98.13C358.9 351.1 368 366.6 368 384c0 26.4-21.5 47.9-48 47.9zM96 192c0-26.5-21.5-48-48-48S0 165.5 0 192s21.5 48 48 48 48-21.5 48-48z"
  })));
};

/* harmony default export */ var dog = (SvgDog);
;// CONCATENATED MODULE: ./public/assets/icons/route.svg
var route_path;

function route_extends() { route_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return route_extends.apply(this, arguments); }



var SvgRoute = function SvgRoute(props) {
  return /*#__PURE__*/react.createElement("svg", route_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "currentColor"
  }, props), route_path || (route_path = /*#__PURE__*/react.createElement("path", {
    d: "M416 256h-88c-22.1 0-40 17.9-40 40s17.9 40 40 40h96c48.6 0 88 39.4 88 88s-39.4 88-88 88H139.6c8.7-9.9 19.3-22.6 30-36.8 2.7-3.6 5.4-7.4 8.2-11.2H424c22.1 0 40-17.9 40-40s-17.9-40-40-40h-96c-48.6 0-88-39.4-88-88s39.4-88 88-88h46.1C348.3 174.9 320 130.7 320 96c0-53.02 42.1-96 96-96 53 0 96 42.98 96 96 0 39.2-36 90.4-63.9 124.2C430.4 241.6 416 256 416 256zm38.1-129.5c7.6-15.2 9.9-25.4 9.9-30.5 0-26.51-21.5-48-48-48s-48 21.49-48 48c0 5.1 2.3 15.3 9.9 30.5 7.3 14.5 17.5 30 28.5 44.7 3.2 4.3 6.4 8.4 9.6 12.4 3.2-4 6.4-8.1 9.6-12.4 11-14.7 21.2-30.2 28.5-44.7zm-326 349.7c-3.3 4-6.5 6.9-9.5 11.2-.3.4-1.5.7-.9 1-3.7 4.3-7.1 8-10 11.2-.1.2-.3.3-.4.5C100.4 507.6 96 512 96 512s-14.43-14.4-32.1-35.8C35.99 442.4 0 391.2 0 352c0-53.9 42.98-96 96-96 53 0 96 42.1 96 96 0 34.7-28.3 78.9-54.1 112-3.3 4.3-6.6 8.3-9.8 12.2zm6-93.7c7.6-15.2 9.9-25.4 9.9-30.5 0-26.5-21.5-48-48-48-26.51 0-48 21.5-48 48 0 5.1 2.29 15.3 9.93 30.5 7.25 14.5 17.45 30 28.47 44.7 3.21 4.3 6.44 8.4 9.6 12.4 3.16-4 6.4-8.1 9.6-12.4 11-14.7 21.2-30.2 28.5-44.7z"
  })));
};

/* harmony default export */ var route = (SvgRoute);
;// CONCATENATED MODULE: ./public/assets/icons/mail.svg
var mail_path, mail_path2;

function mail_extends() { mail_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return mail_extends.apply(this, arguments); }



var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/react.createElement("svg", mail_extends({
    height: 512,
    fill: "currentColor",
    viewBox: "0 0 511.945 511.945",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), mail_path || (mail_path = /*#__PURE__*/react.createElement("path", {
    d: "m470.896 192.153-32.924-32.938v-65.27c0-22.056-17.944-40-40-40h-65.2L281.799 2.942a10.005 10.005 0 0 0-7.07-2.931L237.476 0h-.003a10 10 0 0 0-7.069 2.927l-51.05 51.019h-65.382c-22.056 0-40 17.944-40 40v65.374L41.07 192.146c-9.735 9.73-15.097 22.669-15.097 36.434v231.855c0 13.875 5.524 26.476 14.476 35.747.193.231.394.458.611.676.216.216.442.415.672.607 9.271 8.954 21.874 14.48 35.751 14.48h133.49c5.523 0 10-4.478 10-10s-4.477-10-10-10H77.482a31.302 31.302 0 0 1-14.05-3.318l117.869-117.869 38.374 38.351c9.728 9.723 22.658 15.076 36.411 15.076h.016c13.759-.004 26.692-5.366 36.418-15.098l38.214-38.238 117.778 117.778a31.312 31.312 0 0 1-14.05 3.318H300.973c-5.523 0-10 4.478-10 10s4.477 10 10 10h133.491c13.875 0 26.478-5.525 35.749-14.478.231-.193.458-.393.674-.609.218-.218.418-.445.612-.677 8.951-9.271 14.475-21.872 14.475-35.746v-231.87c-.001-13.752-5.355-26.683-15.078-36.412zm-32.923-4.648 18.777 18.786a31.753 31.753 0 0 1 4.498 5.673l-23.275 23.29zM241.612 20.001l28.969.01 33.914 33.935h-96.849zM55.202 206.299l18.771-18.728v47.65l-23.269-23.254a31.694 31.694 0 0 1 4.498-5.668zM49.29 474.485a31.307 31.307 0 0 1-3.317-14.049V235.513L167.155 356.62zm229.085-79.535c-5.95 5.953-13.861 9.232-22.278 9.235h-.009c-8.413 0-16.323-3.275-22.274-9.223L93.973 255.208V93.945c0-11.028 8.972-20 20-20h284c11.028 0 20 8.972 20 20v68.134a10.074 10.074 0 0 0 0 2.392v90.794zm187.598 65.486c0 5.047-1.199 9.816-3.317 14.049L344.874 356.703 465.973 235.53z"
  })), mail_path2 || (mail_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M255.973 491.942c-2.63 0-5.21 1.07-7.07 2.93s-2.93 4.44-2.93 7.07 1.07 5.21 2.93 7.07c1.86 1.87 4.44 2.93 7.07 2.93s5.21-1.06 7.07-2.93c1.86-1.86 2.93-4.44 2.93-7.07s-1.07-5.21-2.93-7.07a10.08 10.08 0 0 0-7.07-2.93zm0-376.059c-52.062 0-94.417 42.354-94.417 94.416 0 52.774 42.935 95.709 95.709 95.709h60.779c5.523 0 10-4.478 10-10s-4.477-10-10-10h-60.779c-41.746 0-75.709-33.963-75.709-75.709 0-41.033 33.383-74.416 74.417-74.416s74.417 33.383 74.417 74.416v20.493c0 7.876-6.408 14.283-14.284 14.283s-14.284-6.407-14.284-14.283v-23.147c0-27.379-22.274-49.653-49.653-49.653-28.79 0-52.211 23.422-52.211 52.212 0 28.789 23.422 52.211 52.211 52.211h15.908c5.523 0 10-4.478 10-10s-4.477-10-10-10h-15.908c-17.761 0-32.211-14.45-32.211-32.212 0-17.761 14.45-32.211 32.211-32.211 16.351 0 29.653 13.303 29.653 29.653v23.147c0 18.904 15.379 34.283 34.284 34.283s34.284-15.379 34.284-34.283v-20.493c-.001-52.062-42.356-94.416-94.417-94.416z"
  })));
};

/* harmony default export */ var mail = (SvgMail);
;// CONCATENATED MODULE: ./public/assets/icons/partner.svg
var partner_path;

function partner_extends() { partner_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return partner_extends.apply(this, arguments); }



var SvgPartner = function SvgPartner(props) {
  return /*#__PURE__*/react.createElement("svg", partner_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    fill: "currentColor"
  }, props), partner_path || (partner_path = /*#__PURE__*/react.createElement("path", {
    d: "M640 328c0 13.25-10.75 24-24 24l-129.8-.158c-1.875 8.248-5.375 16.12-11 22.99l-26.12 32.24c-15.88 19.49-41.88 25.49-64 16.87-13.5 16.62-30.62 23.99-48.88 23.99-15 0-28.5-5.123-41-15.87-31.88 21.87-74.75 21.24-105.6-3.875L105 351.8l-81 .2c-13.25 0-24-10.7-24-24s10.75-24 24-24l99.75-.143L221 391.8c16.12 13.12 41.38 10.5 55.25-6.623l15.62-19.12 36.88 31.49c2 1.625 5.5 2.75 9 2.375s6.75-2.123 9-4.873l30-36.49 23.88 19.49c3.5 2.748 8.5 2.123 11.25-1.25l26.12-32.24a7.95 7.95 0 0 0-1.168-11.18l-108.2-87.79-8.25 7.496c-40.25 36.74-86.63 11.75-101.5-4.498-26.62-28.99-25-74.35 4.375-101.2l38.75-35.49-35.907-.797c-16.4 0-32.9 7-44.9 20.2l-43.3 44.5L24 176c-13.25 0-24-10.7-24-24s10.75-24 24-24l93.1-.21 26.39-26.38c24-23.99 56.55-37.47 90.5-37.47h167.5c33.88 0 66.38 13.43 90.38 37.36l26.45 26.37L616 128c13.3 0 24 10.7 24 24 0 13.25-10.75 24-24 24l-116.8-.352-48.65-46.19a63.983 63.983 0 0 0-44.26-17.59l-58.1.174a40.324 40.324 0 0 0-27.12 10.6l-65.38 60c-9.625 8.748-10.5 23.99-1.125 33.99 8.875 9.371 25.12 8.621 34.63 0l55.13-50.61c6.5-5.873 16.62-5.498 22.62 1l10.88 11.75c6 6.498 5.5 16.62-1 22.62l-12.5 11.37 102.8 83.35c2.75 2.375 5.375 4.998 7.625 7.748L616 304c13.3 0 24 10.7 24 24z"
  })));
};

/* harmony default export */ var partner = (SvgPartner);
// EXTERNAL MODULE: ./app.config.js
var app_config = __webpack_require__(48387);
;// CONCATENATED MODULE: ./public/flags/de.svg
var de_path, de_path2, de_path3;

function de_extends() { de_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return de_extends.apply(this, arguments); }



var SvgDe = function SvgDe(props) {
  return /*#__PURE__*/react.createElement("svg", de_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5 3"
  }, props), de_path || (de_path = /*#__PURE__*/react.createElement("path", {
    d: "M0 0h5v3H0z"
  })), de_path2 || (de_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#D00",
    d: "M0 1h5v2H0z"
  })), de_path3 || (de_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#FFCE00",
    d: "M0 2h5v1H0z"
  })));
};

/* harmony default export */ var flags_de = (SvgDe);
;// CONCATENATED MODULE: ./public/flags/fr.svg
var fr_path, fr_path2, fr_path3;

function fr_extends() { fr_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return fr_extends.apply(this, arguments); }



var SvgFr = function SvgFr(props) {
  return /*#__PURE__*/react.createElement("svg", fr_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3 2"
  }, props), fr_path || (fr_path = /*#__PURE__*/react.createElement("path", {
    fill: "#ED2939",
    d: "M0 0h3v2H0z"
  })), fr_path2 || (fr_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h2v2H0z"
  })), fr_path3 || (fr_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#002395",
    d: "M0 0h1v2H0z"
  })));
};

/* harmony default export */ var fr = (SvgFr);
;// CONCATENATED MODULE: ./public/flags/it.svg
var it_path, it_path2, it_path3;

function it_extends() { it_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return it_extends.apply(this, arguments); }



var SvgIt = function SvgIt(props) {
  return /*#__PURE__*/react.createElement("svg", it_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3 2"
  }, props), it_path || (it_path = /*#__PURE__*/react.createElement("path", {
    fill: "#009246",
    d: "M0 0h1v2H0z"
  })), it_path2 || (it_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M1 0h1v2H1z"
  })), it_path3 || (it_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#ce2b37",
    d: "M2 0h1v2H2z"
  })));
};

/* harmony default export */ var it = (SvgIt);
;// CONCATENATED MODULE: ./public/flags/pl.svg
var pl_path, pl_path2;

function pl_extends() { pl_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return pl_extends.apply(this, arguments); }



var SvgPl = function SvgPl(props) {
  return /*#__PURE__*/react.createElement("svg", pl_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 10"
  }, props), pl_path || (pl_path = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v10H0z"
  })), pl_path2 || (pl_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#dc143c",
    d: "M0 5h16v5H0z"
  })));
};

/* harmony default export */ var pl = (SvgPl);
;// CONCATENATED MODULE: ./public/flags/nl.svg
var nl_path, nl_path2, nl_path3;

function nl_extends() { nl_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return nl_extends.apply(this, arguments); }



var SvgNl = function SvgNl(props) {
  return /*#__PURE__*/react.createElement("svg", nl_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 6"
  }, props), nl_path || (nl_path = /*#__PURE__*/react.createElement("path", {
    fill: "#21468B",
    d: "M0 0h9v6H0z"
  })), nl_path2 || (nl_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#FFF",
    d: "M0 0h9v4H0z"
  })), nl_path3 || (nl_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#AE1C28",
    d: "M0 0h9v2H0z"
  })));
};

/* harmony default export */ var nl = (SvgNl);
;// CONCATENATED MODULE: ./public/flags/es.svg
var es_path, es_path2, es_path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579;

function es_extends() { es_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return es_extends.apply(this, arguments); }



var SvgEs = function SvgEs(props) {
  return /*#__PURE__*/react.createElement("svg", es_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500"
  }, props), es_path || (es_path = /*#__PURE__*/react.createElement("path", {
    fill: "#c60b1e",
    d: "M0 0h750v500H0z"
  })), es_path2 || (es_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#ffc400",
    d: "M0 125h750v250H0z"
  })), es_path3 || (es_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M167.99 222.24s-.51 0-.8-.16c-.27-.16-1.12-.96-1.12-.96l-.68-.49-.62-.85s-.73-1.18-.4-2.09c.34-.9.9-1.23 1.42-1.5.5-.26 1.58-.59 1.58-.59s.85-.37 1.13-.42c.28-.06 1.3-.33 1.3-.33s.28-.15.56-.26c.29-.1.68-.1.9-.16.23-.06.8-.24 1.14-.26.52-.02 1.35.1 1.64.1.28 0 1.24.05 1.64.05.39 0 1.8-.1 2.2-.1.4 0 .68-.06 1.13 0 .45.05 1.24.31 1.47.42.23.1 1.58.6 2.1.75.5.16 1.74.37 2.31.64.56.27.9.72 1.19 1.1.28.37.34.78.45 1.05.1.26.11.84 0 1.1-.11.27-.51.82-.51.82l-.62 1.02-.8.64s-.56.54-1 .48c-.46-.05-5.04-.86-7.98-.86-2.94 0-7.63.86-7.63.86",
    fill: "#ad1519"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M167.99 222.24s-.51 0-.8-.16c-.27-.16-1.12-.96-1.12-.96l-.68-.49-.62-.85s-.73-1.18-.4-2.09c.34-.9.9-1.23 1.42-1.5.5-.26 1.58-.59 1.58-.59s.85-.37 1.13-.42c.28-.06 1.3-.33 1.3-.33s.28-.15.56-.26c.29-.1.68-.1.9-.16.23-.06.8-.24 1.14-.26.52-.02 1.35.1 1.64.1.28 0 1.24.05 1.64.05.39 0 1.8-.1 2.2-.1.4 0 .68-.06 1.13 0 .45.05 1.24.31 1.47.42.23.1 1.58.6 2.1.75.5.16 1.74.37 2.31.64.56.27.9.72 1.19 1.1.28.37.34.78.45 1.05.1.26.11.84 0 1.1-.11.27-.51.82-.51.82l-.62 1.02-.8.64s-.56.54-1 .48c-.46-.05-5.04-.86-7.98-.86-2.94 0-7.63.86-7.63.86z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.26
  })), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M174.28 215.68c0-1.38.62-2.5 1.38-2.5.76 0 1.38 1.12 1.38 2.5s-.62 2.5-1.38 2.5c-.76 0-1.38-1.12-1.38-2.5",
    fill: "#c8b100"
  })), _path6 || (_path6 = /*#__PURE__*/react.createElement("path", {
    d: "M174.28 215.68c0-1.38.62-2.5 1.38-2.5.76 0 1.38 1.12 1.38 2.5s-.62 2.5-1.38 2.5c-.76 0-1.38-1.12-1.38-2.5z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path7 || (_path7 = /*#__PURE__*/react.createElement("path", {
    d: "M175.05 215.68c0-1.27.28-2.3.63-2.3s.64 1.03.64 2.3c0 1.26-.28 2.3-.64 2.3-.35 0-.63-1.04-.63-2.3",
    fill: "#c8b100"
  })), _path8 || (_path8 = /*#__PURE__*/react.createElement("path", {
    d: "M175.05 215.68c0-1.27.28-2.3.63-2.3s.64 1.03.64 2.3c0 1.26-.28 2.3-.64 2.3-.35 0-.63-1.04-.63-2.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path9 || (_path9 = /*#__PURE__*/react.createElement("path", {
    d: "M174.75 213.04a.9.9 0 0 1 .93-.87c.5 0 .92.4.92.87 0 .49-.41.87-.92.87-.52 0-.93-.38-.93-.87",
    fill: "#c8b100"
  })), _path10 || (_path10 = /*#__PURE__*/react.createElement("path", {
    d: "M176.33 212.74v.58h-1.43v-.58h.47v-1.31h-.62v-.58h.62v-.57h.6v.57h.62v.58h-.62v1.3h.36",
    fill: "#c8b100"
  })), _path11 || (_path11 = /*#__PURE__*/react.createElement("path", {
    d: "M176.33 212.74v.58h-1.43v-.58h.47v-1.31h-.62v-.58h.62v-.57h.6v.57h.62v.58h-.62v1.3h.36",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path12 || (_path12 = /*#__PURE__*/react.createElement("path", {
    d: "M176.97 212.74v.58h-2.54v-.58h.94v-1.31h-.62v-.58h.62v-.57h.6v.57h.62v.58h-.62v1.3h1",
    fill: "#c8b100"
  })), _path13 || (_path13 = /*#__PURE__*/react.createElement("path", {
    d: "M176.97 212.74v.58h-2.54v-.58h.94v-1.31h-.62v-.58h.62v-.57h.6v.57h.62v.58h-.62v1.3h1",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path14 || (_path14 = /*#__PURE__*/react.createElement("path", {
    d: "M175.94 212.2c.38.1.66.45.66.84 0 .49-.41.87-.92.87-.52 0-.93-.38-.93-.87 0-.4.3-.75.69-.84",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path15 || (_path15 = /*#__PURE__*/react.createElement("path", {
    d: "M175.68 222.08h-4.8l-.12-1.18-.23-1.23-.24-1.53c-1.32-1.75-2.54-2.9-2.95-2.65.1-.32.22-.56.47-.71 1.18-.7 3.6.98 5.44 3.74.16.25.32.5.46.75h3.97c.14-.25.3-.5.46-.75 1.83-2.76 4.26-4.44 5.43-3.74.26.15.37.39.47.71-.4-.24-1.62.9-2.95 2.65l-.24 1.53-.23 1.23-.1 1.18h-4.84",
    fill: "#c8b100"
  })), _path16 || (_path16 = /*#__PURE__*/react.createElement("path", {
    d: "M175.68 222.08h-4.8l-.12-1.18-.23-1.23-.24-1.53c-1.32-1.75-2.54-2.9-2.95-2.65.1-.32.22-.56.47-.71 1.18-.7 3.6.98 5.44 3.74.16.25.32.5.46.75h3.97c.14-.25.3-.5.46-.75 1.83-2.76 4.26-4.44 5.43-3.74.26.15.37.39.47.71-.4-.24-1.62.9-2.95 2.65l-.24 1.53-.23 1.23-.1 1.18h-4.84z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path17 || (_path17 = /*#__PURE__*/react.createElement("path", {
    d: "M167.55 215.44c.9-.53 3.02 1.15 4.73 3.74m11.55-3.74c-.9-.53-3.01 1.15-4.73 3.74",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path18 || (_path18 = /*#__PURE__*/react.createElement("path", {
    d: "M168.58 224.25c-.2-.57-.58-1.08-.58-1.08a28.7 28.7 0 0 1 7.67-.94c3.01 0 5.75.37 7.69.94l-.52.91c-.17.3-.39.81-.38.81a23.8 23.8 0 0 0-6.8-.82c-2.79 0-5.46.35-6.86.86.02 0-.1-.32-.23-.68",
    fill: "#c8b100"
  })), _path19 || (_path19 = /*#__PURE__*/react.createElement("path", {
    d: "M168.58 224.25c-.2-.57-.58-1.08-.58-1.08a28.7 28.7 0 0 1 7.67-.94c3.01 0 5.75.37 7.69.94l-.52.91c-.17.3-.39.81-.38.81a23.8 23.8 0 0 0-6.8-.82c-2.79 0-5.46.35-6.86.86.02 0-.1-.32-.23-.68",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path20 || (_path20 = /*#__PURE__*/react.createElement("path", {
    d: "M175.67 226.73c2.43 0 5.11-.38 6.1-.63.66-.2 1.05-.5.98-.84-.04-.16-.18-.3-.37-.38-1.46-.47-4.07-.8-6.7-.8-2.65 0-5.28.33-6.73.8-.19.08-.33.22-.36.38-.08.35.31.65.97.84.99.25 3.68.62 6.11.63",
    fill: "#c8b100"
  })), _path21 || (_path21 = /*#__PURE__*/react.createElement("path", {
    d: "M175.67 226.73c2.43 0 5.11-.38 6.1-.63.66-.2 1.05-.5.98-.84-.04-.16-.18-.3-.37-.38-1.46-.47-4.07-.8-6.7-.8-2.65 0-5.28.33-6.73.8-.19.08-.33.22-.36.38-.08.35.31.65.97.84.99.25 3.68.62 6.11.63z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path22 || (_path22 = /*#__PURE__*/react.createElement("path", {
    d: "m183.48 222.08-.6-.53s-.56.34-1.27.24c-.7-.11-.93-.97-.93-.97s-.8.67-1.44.62a1.7 1.7 0 0 1-1.07-.62s-.7.5-1.33.46c-.62-.06-1.21-.83-1.21-.83s-.63.8-1.25.86c-.62.05-1.13-.54-1.13-.54s-.28.59-1.07.72c-.8.13-1.47-.62-1.47-.62s-.45.73-.99.92c-.53.18-1.24-.27-1.24-.27l-.2.43c-.09.16-.31.19-.31.19l.18.47c1.93-.56 4.56-.9 7.53-.9 2.97 0 5.67.34 7.61.9l.2-.53",
    fill: "#c8b100"
  })), _path23 || (_path23 = /*#__PURE__*/react.createElement("path", {
    d: "m183.48 222.08-.6-.53s-.56.34-1.27.24c-.7-.11-.93-.97-.93-.97s-.8.67-1.44.62a1.7 1.7 0 0 1-1.07-.62s-.7.5-1.33.46c-.62-.06-1.21-.83-1.21-.83s-.63.8-1.25.86c-.62.05-1.13-.54-1.13-.54s-.28.59-1.07.72c-.8.13-1.47-.62-1.47-.62s-.45.73-.99.92c-.53.18-1.24-.27-1.24-.27l-.2.43c-.09.16-.31.19-.31.19l.18.47c1.93-.56 4.56-.9 7.53-.9 2.97 0 5.67.34 7.61.9l.2-.53z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path24 || (_path24 = /*#__PURE__*/react.createElement("path", {
    d: "m175.69 219.5.28.04a1.09 1.09 0 0 0 1.06 1.43c.5 0 .91-.3 1.06-.73.01.01.1-.38.15-.38.03 0 .03.41.05.4.07.53.55.9 1.1.9.62 0 1.1-.47 1.1-1.06v-.12l.35-.35.2.44a.9.9 0 0 0-.11.46c0 .56.47 1 1.06 1 .37 0 .7-.17.88-.44l.23-.29v.35c0 .35.15.66.49.72 0 0 .38.03.9-.38.52-.41.81-.75.81-.75l.03.42s-.5.84-.97 1.1c-.25.15-.64.3-.95.25-.32-.04-.55-.3-.67-.6-.23.13-.5.21-.8.21-.63 0-1.2-.35-1.42-.86a1.62 1.62 0 0 1-2.42-.08 1.63 1.63 0 0 1-2.43-.26 1.62 1.62 0 0 1-2.42.26 1.63 1.63 0 0 1-2.42.08c-.22.5-.79.86-1.42.86-.29 0-.56-.08-.8-.22-.11.3-.34.56-.67.61-.3.06-.69-.1-.94-.25-.47-.26-1.02-1.1-1.02-1.1l.07-.42s.3.34.8.75c.53.41.92.38.92.38.34-.06.49-.37.49-.72v-.35l.22.29c.19.27.51.45.88.45.59 0 1.06-.45 1.06-1.01a.94.94 0 0 0-.1-.46l.2-.44.34.35-.01.12c0 .59.5 1.06 1.11 1.06.55 0 1.03-.37 1.1-.9.02.01.02-.4.05-.4.05 0 .14.4.16.38.14.42.56.73 1.06.73a1.09 1.09 0 0 0 1.06-1.43l.29-.05",
    fill: "#c8b100"
  })), _path25 || (_path25 = /*#__PURE__*/react.createElement("path", {
    d: "m175.69 219.5.28.04a1.09 1.09 0 0 0 1.06 1.43c.5 0 .91-.3 1.06-.73.01.01.1-.38.15-.38.03 0 .03.41.05.4.07.53.55.9 1.1.9.62 0 1.1-.47 1.1-1.06v-.12l.35-.35.2.44a.9.9 0 0 0-.11.46c0 .56.47 1 1.06 1 .37 0 .7-.17.88-.44l.23-.29v.35c0 .35.15.66.49.72 0 0 .38.03.9-.38.52-.41.81-.75.81-.75l.03.42s-.5.84-.97 1.1c-.25.15-.64.3-.95.25-.32-.04-.55-.3-.67-.6-.23.13-.5.21-.8.21-.63 0-1.2-.35-1.42-.86a1.62 1.62 0 0 1-2.42-.08 1.63 1.63 0 0 1-2.43-.26 1.62 1.62 0 0 1-2.42.26 1.63 1.63 0 0 1-2.42.08c-.22.5-.79.86-1.42.86-.29 0-.56-.08-.8-.22-.11.3-.34.56-.67.61-.3.06-.69-.1-.94-.25-.47-.26-1.02-1.1-1.02-1.1l.07-.42s.3.34.8.75c.53.41.92.38.92.38.34-.06.49-.37.49-.72v-.35l.22.29c.19.27.51.45.88.45.59 0 1.06-.45 1.06-1.01a.94.94 0 0 0-.1-.46l.2-.44.34.35-.01.12c0 .59.5 1.06 1.11 1.06.55 0 1.03-.37 1.1-.9.02.01.02-.4.05-.4.05 0 .14.4.16.38.14.42.56.73 1.06.73a1.09 1.09 0 0 0 1.06-1.43l.29-.05z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path26 || (_path26 = /*#__PURE__*/react.createElement("path", {
    d: "M175.67 222.23c-3.01 0-5.72.37-7.67.94-.13.04-.29-.06-.33-.17-.04-.13.05-.28.18-.32 1.95-.6 4.73-.97 7.82-.98 3.09 0 5.88.38 7.83.98.13.04.22.2.18.32-.04.11-.2.21-.33.17a28.45 28.45 0 0 0-7.68-.94",
    fill: "#c8b100"
  })), _path27 || (_path27 = /*#__PURE__*/react.createElement("path", {
    d: "M175.67 222.23c-3.01 0-5.72.37-7.67.94-.13.04-.29-.06-.33-.17-.04-.13.05-.28.18-.32 1.95-.6 4.73-.97 7.82-.98 3.09 0 5.88.38 7.83.98.13.04.22.2.18.32-.04.11-.2.21-.33.17a28.45 28.45 0 0 0-7.68-.94z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.26
  })), _path28 || (_path28 = /*#__PURE__*/react.createElement("path", {
    d: "M172.75 223.3c0-.22.2-.4.44-.4s.44.18.44.4c0 .23-.2.41-.44.41s-.44-.18-.44-.4",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/react.createElement("path", {
    d: "M172.75 223.3c0-.22.2-.4.44-.4s.44.18.44.4c0 .23-.2.41-.44.41s-.44-.18-.44-.4z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path30 || (_path30 = /*#__PURE__*/react.createElement("path", {
    d: "M175.7 223.48h-.96c-.18 0-.33-.14-.33-.31 0-.17.14-.3.32-.3h1.96c.19 0 .33.13.33.3 0 .17-.15.31-.33.31h-.98",
    fill: "#ad1519"
  })), _path31 || (_path31 = /*#__PURE__*/react.createElement("path", {
    d: "M175.7 223.48h-.96c-.18 0-.33-.14-.33-.31 0-.17.14-.3.32-.3h1.96c.19 0 .33.13.33.3 0 .17-.15.31-.33.31h-.98",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path32 || (_path32 = /*#__PURE__*/react.createElement("path", {
    d: "m170.85 223.81-.7.1a.318.318 0 0 1-.37-.25.3.3 0 0 1 .27-.35l.7-.1.71-.11c.18-.02.34.09.37.25.02.17-.1.33-.27.35l-.71.11",
    fill: "#058e6e"
  })), _path33 || (_path33 = /*#__PURE__*/react.createElement("path", {
    d: "m170.85 223.81-.7.1a.318.318 0 0 1-.37-.25.3.3 0 0 1 .27-.35l.7-.1.71-.11c.18-.02.34.09.37.25.02.17-.1.33-.27.35l-.71.11",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path34 || (_path34 = /*#__PURE__*/react.createElement("path", {
    d: "m168.05 224.3.3-.5.66.13-.38.56-.58-.19",
    fill: "#ad1519"
  })), _path35 || (_path35 = /*#__PURE__*/react.createElement("path", {
    d: "m168.05 224.3.3-.5.66.13-.38.56-.58-.19",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path36 || (_path36 = /*#__PURE__*/react.createElement("path", {
    d: "M177.72 223.3c0-.22.2-.4.44-.4s.43.18.43.4c0 .23-.2.41-.43.41-.25 0-.44-.18-.44-.4",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/react.createElement("path", {
    d: "M177.72 223.3c0-.22.2-.4.44-.4s.43.18.43.4c0 .23-.2.41-.43.41-.25 0-.44-.18-.44-.4z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path38 || (_path38 = /*#__PURE__*/react.createElement("path", {
    d: "m180.5 223.81.7.1c.17.03.34-.08.37-.25a.3.3 0 0 0-.27-.35l-.7-.1-.71-.11c-.18-.02-.34.09-.37.25-.03.17.1.33.27.35l.7.11",
    fill: "#058e6e"
  })), _path39 || (_path39 = /*#__PURE__*/react.createElement("path", {
    d: "m180.5 223.81.7.1c.17.03.34-.08.37-.25a.3.3 0 0 0-.27-.35l-.7-.1-.71-.11c-.18-.02-.34.09-.37.25-.03.17.1.33.27.35l.7.11",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path40 || (_path40 = /*#__PURE__*/react.createElement("path", {
    d: "m183.24 224.33-.25-.53-.67.06.32.59.6-.12",
    fill: "#ad1519"
  })), _path41 || (_path41 = /*#__PURE__*/react.createElement("path", {
    d: "m183.24 224.33-.25-.53-.67.06.32.59.6-.12",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path42 || (_path42 = /*#__PURE__*/react.createElement("path", {
    d: "M175.66 226.16c-2.43 0-4.63-.22-6.3-.65 1.67-.43 3.87-.7 6.3-.7 2.44 0 4.65.27 6.33.7-1.68.44-3.9.65-6.33.65",
    fill: "#ad1519"
  })), _path43 || (_path43 = /*#__PURE__*/react.createElement("path", {
    d: "M175.66 226.16c-2.43 0-4.63-.22-6.3-.65 1.67-.43 3.87-.7 6.3-.7 2.44 0 4.65.27 6.33.7-1.68.44-3.9.65-6.33.65z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.26
  })), _path44 || (_path44 = /*#__PURE__*/react.createElement("path", {
    d: "M183.34 220.88c.06-.18 0-.37-.13-.41-.14-.04-.3.08-.37.26-.06.19 0 .38.13.42.14.04.3-.08.37-.27",
    fill: "#c8b100"
  })), _path45 || (_path45 = /*#__PURE__*/react.createElement("path", {
    d: "M183.34 220.88c.06-.18 0-.37-.13-.41-.14-.04-.3.08-.37.26-.06.19 0 .38.13.42.14.04.3-.08.37-.27z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path46 || (_path46 = /*#__PURE__*/react.createElement("path", {
    d: "M178.5 219.95c.02-.2-.08-.37-.22-.39-.14-.02-.28.13-.3.33-.02.2.07.37.21.38.14.02.28-.13.3-.32",
    fill: "#c8b100"
  })), _path47 || (_path47 = /*#__PURE__*/react.createElement("path", {
    d: "M178.5 219.95c.02-.2-.08-.37-.22-.39-.14-.02-.28.13-.3.33-.02.2.07.37.21.38.14.02.28-.13.3-.32z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path48 || (_path48 = /*#__PURE__*/react.createElement("path", {
    d: "M172.87 219.95c-.03-.2.07-.37.21-.39.14-.02.28.13.3.33.03.2-.07.37-.21.38-.14.02-.28-.13-.3-.32",
    fill: "#c8b100"
  })), _path49 || (_path49 = /*#__PURE__*/react.createElement("path", {
    d: "M172.87 219.95c-.03-.2.07-.37.21-.39.14-.02.28.13.3.33.03.2-.07.37-.21.38-.14.02-.28-.13-.3-.32z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path50 || (_path50 = /*#__PURE__*/react.createElement("path", {
    d: "M168.02 220.88c-.06-.18 0-.37.13-.41.14-.04.3.08.37.26.06.19 0 .38-.14.42-.13.04-.3-.08-.36-.27",
    fill: "#c8b100"
  })), _path51 || (_path51 = /*#__PURE__*/react.createElement("path", {
    d: "M168.02 220.88c-.06-.18 0-.37.13-.41.14-.04.3.08.37.26.06.19 0 .38-.14.42-.13.04-.3-.08-.36-.27z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path52 || (_path52 = /*#__PURE__*/react.createElement("path", {
    d: "m175.66 217.15-.85.52.63 1.38.22.14.22-.14.64-1.38-.86-.52",
    fill: "#c8b100"
  })), _path53 || (_path53 = /*#__PURE__*/react.createElement("path", {
    d: "m175.66 217.15-.85.52.63 1.38.22.14.22-.14.64-1.38-.86-.52",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path54 || (_path54 = /*#__PURE__*/react.createElement("path", {
    d: "m173.78 219.24.4.57 1.34-.42.14-.18-.15-.2-1.33-.39-.4.62",
    fill: "#c8b100"
  })), _path55 || (_path55 = /*#__PURE__*/react.createElement("path", {
    d: "m173.78 219.24.4.57 1.34-.42.14-.18-.15-.2-1.33-.39-.4.62",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path56 || (_path56 = /*#__PURE__*/react.createElement("path", {
    d: "m177.55 219.24-.39.57-1.34-.42-.14-.18.14-.2 1.34-.39.4.62",
    fill: "#c8b100"
  })), _path57 || (_path57 = /*#__PURE__*/react.createElement("path", {
    d: "m177.55 219.24-.39.57-1.34-.42-.14-.18.14-.2 1.34-.39.4.62",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path58 || (_path58 = /*#__PURE__*/react.createElement("path", {
    d: "m170.08 217.76-.67.64.86 1.14.23.09.17-.18.3-1.37-.89-.32",
    fill: "#c8b100"
  })), _path59 || (_path59 = /*#__PURE__*/react.createElement("path", {
    d: "m170.08 217.76-.67.64.86 1.14.23.09.17-.18.3-1.37-.89-.32",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path60 || (_path60 = /*#__PURE__*/react.createElement("path", {
    d: "m168.67 220.04.5.48 1.23-.66.1-.21-.18-.16-1.4-.13-.25.68",
    fill: "#c8b100"
  })), _path61 || (_path61 = /*#__PURE__*/react.createElement("path", {
    d: "m168.67 220.04.5.48 1.23-.66.1-.21-.18-.16-1.4-.13-.25.68",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path62 || (_path62 = /*#__PURE__*/react.createElement("path", {
    d: "m172.36 219.3-.26.63-1.4-.13-.18-.16.1-.21 1.22-.65.52.52",
    fill: "#c8b100"
  })), _path63 || (_path63 = /*#__PURE__*/react.createElement("path", {
    d: "m172.36 219.3-.26.63-1.4-.13-.18-.16.1-.21 1.22-.65.52.52",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path64 || (_path64 = /*#__PURE__*/react.createElement("path", {
    d: "m167.32 220.22-.11.66-1.4.15-.21-.12.05-.23 1.05-.87.62.41",
    fill: "#c8b100"
  })), _path65 || (_path65 = /*#__PURE__*/react.createElement("path", {
    d: "m167.32 220.22-.11.66-1.4.15-.21-.12.05-.23 1.05-.87.62.41",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path66 || (_path66 = /*#__PURE__*/react.createElement("path", {
    d: "M170.02 219.65c0-.26.22-.47.5-.47.26 0 .48.21.48.47 0 .25-.22.46-.49.46a.48.48 0 0 1-.49-.46",
    fill: "#c8b100"
  })), _path67 || (_path67 = /*#__PURE__*/react.createElement("path", {
    d: "M170.02 219.65c0-.26.22-.47.5-.47.26 0 .48.21.48.47 0 .25-.22.46-.49.46a.48.48 0 0 1-.49-.46z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path68 || (_path68 = /*#__PURE__*/react.createElement("path", {
    d: "m181.27 217.76.67.64-.86 1.14-.23.09-.16-.18-.3-1.37.88-.32",
    fill: "#c8b100"
  })), _path69 || (_path69 = /*#__PURE__*/react.createElement("path", {
    d: "m181.27 217.76.67.64-.86 1.14-.23.09-.16-.18-.3-1.37.88-.32",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path70 || (_path70 = /*#__PURE__*/react.createElement("path", {
    d: "m182.68 220.04-.5.48-1.23-.66-.1-.21.19-.16 1.4-.13.24.68",
    fill: "#c8b100"
  })), _path71 || (_path71 = /*#__PURE__*/react.createElement("path", {
    d: "m182.68 220.04-.5.48-1.23-.66-.1-.21.19-.16 1.4-.13.24.68",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path72 || (_path72 = /*#__PURE__*/react.createElement("path", {
    d: "m179 219.3.25.63 1.4-.13.18-.16-.1-.21-1.22-.65-.52.52",
    fill: "#c8b100"
  })), _path73 || (_path73 = /*#__PURE__*/react.createElement("path", {
    d: "m179 219.3.25.63 1.4-.13.18-.16-.1-.21-1.22-.65-.52.52",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path74 || (_path74 = /*#__PURE__*/react.createElement("path", {
    d: "m183.84 220.22.11.66 1.4.15.21-.12-.05-.23-1.05-.87-.62.41",
    fill: "#c8b100"
  })), _path75 || (_path75 = /*#__PURE__*/react.createElement("path", {
    d: "m183.84 220.22.11.66 1.4.15.21-.12-.05-.23-1.05-.87-.62.41",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path76 || (_path76 = /*#__PURE__*/react.createElement("path", {
    d: "M175.18 219.2c0-.25.22-.46.5-.46.26 0 .48.2.48.47 0 .25-.22.46-.49.46s-.49-.2-.49-.46",
    fill: "#c8b100"
  })), _path77 || (_path77 = /*#__PURE__*/react.createElement("path", {
    d: "M175.18 219.2c0-.25.22-.46.5-.46.26 0 .48.2.48.47 0 .25-.22.46-.49.46s-.49-.2-.49-.46z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path78 || (_path78 = /*#__PURE__*/react.createElement("path", {
    d: "M180.36 219.65c0-.26.22-.47.49-.47s.49.21.49.47c0 .25-.22.46-.5.46a.48.48 0 0 1-.48-.46",
    fill: "#c8b100"
  })), _path79 || (_path79 = /*#__PURE__*/react.createElement("path", {
    d: "M180.36 219.65c0-.26.22-.47.49-.47s.49.21.49.47c0 .25-.22.46-.5.46a.48.48 0 0 1-.48-.46z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path80 || (_path80 = /*#__PURE__*/react.createElement("path", {
    d: "M165.43 221c-.01 0-.38-.49-.66-.73-.2-.18-.67-.33-.67-.33 0-.09.28-.28.58-.28.18 0 .35.07.45.2l.04-.2s.24.05.36.32c.1.29.04.72.04.72s-.05.2-.14.3",
    fill: "#c8b100"
  })), _path81 || (_path81 = /*#__PURE__*/react.createElement("path", {
    d: "M165.43 221c-.01 0-.38-.49-.66-.73-.2-.18-.67-.33-.67-.33 0-.09.28-.28.58-.28.18 0 .35.07.45.2l.04-.2s.24.05.36.32c.1.29.04.72.04.72s-.05.2-.14.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path82 || (_path82 = /*#__PURE__*/react.createElement("path", {
    d: "M165.45 220.75c.12-.12.36-.1.53.06.18.15.24.38.12.5-.12.13-.36.1-.53-.06-.18-.15-.24-.38-.12-.5",
    fill: "#c8b100"
  })), _path83 || (_path83 = /*#__PURE__*/react.createElement("path", {
    d: "M165.45 220.75c.12-.12.36-.1.53.06.18.15.24.38.12.5-.12.13-.36.1-.53-.06-.18-.15-.24-.38-.12-.5z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path84 || (_path84 = /*#__PURE__*/react.createElement("path", {
    d: "M185.73 221c.01 0 .38-.49.66-.73.19-.18.67-.33.67-.33 0-.09-.28-.28-.58-.28a.58.58 0 0 0-.45.2l-.04-.2s-.24.05-.36.32c-.1.29-.03.72-.03.72s.04.2.13.3",
    fill: "#c8b100"
  })), _path85 || (_path85 = /*#__PURE__*/react.createElement("path", {
    d: "M185.73 221c.01 0 .38-.49.66-.73.19-.18.67-.33.67-.33 0-.09-.28-.28-.58-.28a.58.58 0 0 0-.45.2l-.04-.2s-.24.05-.36.32c-.1.29-.03.72-.03.72s.04.2.13.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path86 || (_path86 = /*#__PURE__*/react.createElement("path", {
    d: "M185.74 220.75c-.11-.12-.35-.1-.53.06-.18.15-.24.38-.12.5.12.13.36.1.54-.06.18-.15.22-.38.11-.5",
    fill: "#c8b100"
  })), _path87 || (_path87 = /*#__PURE__*/react.createElement("path", {
    d: "M185.74 220.75c-.11-.12-.35-.1-.53.06-.18.15-.24.38-.12.5.12.13.36.1.54-.06.18-.15.22-.38.11-.5z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path88 || (_path88 = /*#__PURE__*/react.createElement("path", {
    d: "M164.58 232.37h22.29v-5.84h-22.29v5.84z",
    fill: "#c8b100"
  })), _path89 || (_path89 = /*#__PURE__*/react.createElement("path", {
    d: "M164.58 232.37h22.29v-5.84h-22.29v5.84z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path90 || (_path90 = /*#__PURE__*/react.createElement("path", {
    d: "M166.92 236.26a.97.97 0 0 1 .41-.07h16.7c.16 0 .31.03.44.08a1.4 1.4 0 0 1-.98-1.32c0-.6.45-1.14 1.03-1.33-.14.04-.33.08-.49.08h-16.7c-.17 0-.33-.01-.47-.06l.1.02c.59.18.93.71.93 1.3 0 .55-.38 1.12-.97 1.3",
    fill: "#c8b100"
  })), _path91 || (_path91 = /*#__PURE__*/react.createElement("path", {
    d: "M166.92 236.26a.97.97 0 0 1 .41-.07h16.7c.16 0 .31.03.44.08a1.4 1.4 0 0 1-.98-1.32c0-.6.45-1.14 1.03-1.33-.14.04-.33.08-.49.08h-16.7c-.17 0-.33-.01-.47-.06l.1.02c.59.18.93.71.93 1.3 0 .55-.38 1.12-.97 1.3z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.39
  })), _path92 || (_path92 = /*#__PURE__*/react.createElement("path", {
    d: "M167.33 236.2h16.7c.56 0 1.01.34 1.01.77 0 .44-.45.79-1.02.79h-16.69c-.56 0-1.02-.35-1.02-.79 0-.43.46-.78 1.02-.78",
    fill: "#c8b100"
  })), _path93 || (_path93 = /*#__PURE__*/react.createElement("path", {
    d: "M167.33 236.2h16.7c.56 0 1.01.34 1.01.77 0 .44-.45.79-1.02.79h-16.69c-.56 0-1.02-.35-1.02-.79 0-.43.46-.78 1.02-.78z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path94 || (_path94 = /*#__PURE__*/react.createElement("path", {
    d: "M167.33 232.37h16.7c.56 0 1.03.3 1.03.66 0 .37-.47.67-1.03.67h-16.7c-.56 0-1.02-.3-1.02-.67 0-.36.46-.66 1.02-.66",
    fill: "#c8b100"
  })), _path95 || (_path95 = /*#__PURE__*/react.createElement("path", {
    d: "M167.33 232.37h16.7c.56 0 1.03.3 1.03.66 0 .37-.47.67-1.03.67h-16.7c-.56 0-1.02-.3-1.02-.67 0-.36.46-.66 1.02-.66z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path96 || (_path96 = /*#__PURE__*/react.createElement("path", {
    d: "M191.28 330.68a8.48 8.48 0 0 1-3.93-.87 8.7 8.7 0 0 0-3.86-.82c-1.5 0-2.9.32-3.9.83-1.02.53-2.41.86-3.93.86a8.48 8.48 0 0 1-3.93-.9c-1-.5-2.33-.8-3.8-.8a8.5 8.5 0 0 0-3.85.82 8.64 8.64 0 0 1-3.95.88v2.41c1.53 0 2.94-.35 3.95-.88 1-.52 2.34-.82 3.86-.82 1.45 0 2.79.3 3.79.8 1 .54 2.39.9 3.93.9 1.52 0 2.91-.33 3.92-.86 1-.52 2.4-.84 3.9-.84s2.87.32 3.87.84a8.4 8.4 0 0 0 3.91.86l.02-2.41",
    fill: "#005bbf"
  })), _path97 || (_path97 = /*#__PURE__*/react.createElement("path", {
    d: "M191.28 330.68a8.48 8.48 0 0 1-3.93-.87 8.7 8.7 0 0 0-3.86-.82c-1.5 0-2.9.32-3.9.83-1.02.53-2.41.86-3.93.86a8.48 8.48 0 0 1-3.93-.9c-1-.5-2.33-.8-3.8-.8a8.5 8.5 0 0 0-3.85.82 8.64 8.64 0 0 1-3.95.88v2.41c1.53 0 2.94-.35 3.95-.88 1-.52 2.34-.82 3.86-.82 1.45 0 2.79.3 3.79.8 1 .54 2.39.9 3.93.9 1.52 0 2.91-.33 3.92-.86 1-.52 2.4-.84 3.9-.84s2.87.32 3.87.84a8.4 8.4 0 0 0 3.91.86l.02-2.41z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path98 || (_path98 = /*#__PURE__*/react.createElement("path", {
    d: "M191.28 333.09a8.5 8.5 0 0 1-3.93-.86c-1-.52-2.36-.84-3.86-.84s-2.9.32-3.9.84c-1.02.53-2.41.86-3.93.86a8.52 8.52 0 0 1-3.93-.9c-1-.5-2.33-.8-3.8-.8-1.5 0-2.85.3-3.85.82a8.69 8.69 0 0 1-3.95.88v2.4a8.7 8.7 0 0 0 3.95-.87c1-.52 2.34-.82 3.86-.82 1.45 0 2.79.3 3.79.8 1 .54 2.39.9 3.93.9a8.7 8.7 0 0 0 3.92-.86c1-.52 2.4-.84 3.9-.84s2.87.32 3.87.83c1.02.54 2.37.87 3.91.87l.02-2.41",
    fill: "#ccc"
  })), _path99 || (_path99 = /*#__PURE__*/react.createElement("path", {
    d: "M191.28 333.09a8.5 8.5 0 0 1-3.93-.86c-1-.52-2.36-.84-3.86-.84s-2.9.32-3.9.84c-1.02.53-2.41.86-3.93.86a8.52 8.52 0 0 1-3.93-.9c-1-.5-2.33-.8-3.8-.8-1.5 0-2.85.3-3.85.82a8.69 8.69 0 0 1-3.95.88v2.4a8.7 8.7 0 0 0 3.95-.87c1-.52 2.34-.82 3.86-.82 1.45 0 2.79.3 3.79.8 1 .54 2.39.9 3.93.9a8.7 8.7 0 0 0 3.92-.86c1-.52 2.4-.84 3.9-.84s2.87.32 3.87.83c1.02.54 2.37.87 3.91.87l.02-2.41",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path100 || (_path100 = /*#__PURE__*/react.createElement("path", {
    d: "M191.28 335.5a8.52 8.52 0 0 1-3.93-.87c-1-.5-2.36-.83-3.86-.83s-2.9.32-3.9.84c-1.02.53-2.41.86-3.93.86a8.52 8.52 0 0 1-3.93-.9c-1-.5-2.33-.8-3.8-.8-1.5 0-2.85.3-3.85.82a8.7 8.7 0 0 1-3.95.88v2.4c1.53 0 2.94-.34 3.95-.88 1-.51 2.34-.8 3.86-.8 1.45 0 2.79.3 3.79.79 1 .54 2.39.9 3.93.9 1.52 0 2.91-.33 3.92-.86 1-.52 2.4-.83 3.9-.83s2.87.3 3.87.82c1.02.55 2.37.86 3.91.86l.02-2.4",
    fill: "#005bbf"
  })), _path101 || (_path101 = /*#__PURE__*/react.createElement("path", {
    d: "M191.28 335.5a8.52 8.52 0 0 1-3.93-.87c-1-.5-2.36-.83-3.86-.83s-2.9.32-3.9.84c-1.02.53-2.41.86-3.93.86a8.52 8.52 0 0 1-3.93-.9c-1-.5-2.33-.8-3.8-.8-1.5 0-2.85.3-3.85.82a8.7 8.7 0 0 1-3.95.88v2.4c1.53 0 2.94-.34 3.95-.88 1-.51 2.34-.8 3.86-.8 1.45 0 2.79.3 3.79.79 1 .54 2.39.9 3.93.9 1.52 0 2.91-.33 3.92-.86 1-.52 2.4-.83 3.9-.83s2.87.3 3.87.82c1.02.55 2.37.86 3.91.86l.02-2.4",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path102 || (_path102 = /*#__PURE__*/react.createElement("path", {
    d: "M191.26 340.32c-1.54 0-2.9-.33-3.9-.87a8.7 8.7 0 0 0-3.87-.82c-1.5 0-2.9.31-3.9.83-1.02.52-2.41.86-3.93.86a8.48 8.48 0 0 1-3.93-.9c-1-.5-2.33-.8-3.8-.8-1.5 0-2.85.3-3.85.82a8.64 8.64 0 0 1-3.95.88v-2.4c1.53 0 2.94-.36 3.95-.9 1-.51 2.34-.8 3.86-.8 1.45 0 2.79.3 3.79.79 1 .54 2.39.9 3.93.9 1.52 0 2.91-.33 3.92-.86 1-.52 2.4-.83 3.9-.83s2.87.3 3.87.82c1.02.55 2.39.86 3.93.86l-.02 2.42",
    fill: "#ccc"
  })), _path103 || (_path103 = /*#__PURE__*/react.createElement("path", {
    d: "M191.26 340.32c-1.54 0-2.9-.33-3.9-.87a8.7 8.7 0 0 0-3.87-.82c-1.5 0-2.9.31-3.9.83-1.02.52-2.41.86-3.93.86a8.48 8.48 0 0 1-3.93-.9c-1-.5-2.33-.8-3.8-.8-1.5 0-2.85.3-3.85.82a8.64 8.64 0 0 1-3.95.88v-2.4c1.53 0 2.94-.36 3.95-.9 1-.51 2.34-.8 3.86-.8 1.45 0 2.79.3 3.79.79 1 .54 2.39.9 3.93.9 1.52 0 2.91-.33 3.92-.86 1-.52 2.4-.83 3.9-.83s2.87.3 3.87.82c1.02.55 2.39.86 3.93.86l-.02 2.42",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path104 || (_path104 = /*#__PURE__*/react.createElement("path", {
    d: "M191.26 342.73c-1.54 0-2.9-.33-3.9-.86a8.6 8.6 0 0 0-3.87-.84c-1.5 0-2.9.32-3.9.84-1.02.52-2.41.86-3.93.86a8.52 8.52 0 0 1-3.93-.9c-1-.5-2.33-.8-3.8-.8a8.5 8.5 0 0 0-3.85.82 8.69 8.69 0 0 1-3.95.88v-2.4c1.53 0 2.94-.36 3.95-.9 1-.51 2.34-.8 3.86-.8 1.45 0 2.79.3 3.79.79 1 .53 2.39.9 3.93.9a8.7 8.7 0 0 0 3.92-.86c1-.52 2.4-.83 3.9-.83s2.87.31 3.87.82a8.5 8.5 0 0 0 3.93.87l-.02 2.4",
    fill: "#005bbf"
  })), _path105 || (_path105 = /*#__PURE__*/react.createElement("path", {
    d: "M191.26 342.73c-1.54 0-2.9-.33-3.9-.86a8.6 8.6 0 0 0-3.87-.84c-1.5 0-2.9.32-3.9.84-1.02.52-2.41.86-3.93.86a8.52 8.52 0 0 1-3.93-.9c-1-.5-2.33-.8-3.8-.8a8.5 8.5 0 0 0-3.85.82 8.69 8.69 0 0 1-3.95.88v-2.4c1.53 0 2.94-.36 3.95-.9 1-.51 2.34-.8 3.86-.8 1.45 0 2.79.3 3.79.79 1 .53 2.39.9 3.93.9a8.7 8.7 0 0 0 3.92-.86c1-.52 2.4-.83 3.9-.83s2.87.31 3.87.82a8.5 8.5 0 0 0 3.93.87l-.02 2.4z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path106 || (_path106 = /*#__PURE__*/react.createElement("path", {
    d: "M166.92 320.78c.05.2.13.4.13.62 0 1.46-1.27 2.63-2.81 2.63h22.94c-1.55 0-2.81-1.17-2.81-2.63 0-.21.04-.41.1-.62-.14.05-.3.06-.45.06h-16.69c-.13 0-.29-.02-.41-.06",
    fill: "#c8b100"
  })), _path107 || (_path107 = /*#__PURE__*/react.createElement("path", {
    d: "M166.92 320.78c.05.2.13.4.13.62 0 1.46-1.27 2.63-2.81 2.63h22.94c-1.55 0-2.81-1.17-2.81-2.63 0-.21.04-.41.1-.62-.14.05-.3.06-.45.06h-16.69c-.13 0-.29-.02-.41-.06z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.39
  })), _path108 || (_path108 = /*#__PURE__*/react.createElement("path", {
    d: "M167.33 319.27h16.7c.56 0 1.01.35 1.01.78 0 .44-.45.79-1.02.79h-16.69c-.56 0-1.02-.35-1.02-.79 0-.43.46-.78 1.02-.78",
    fill: "#c8b100"
  })), _path109 || (_path109 = /*#__PURE__*/react.createElement("path", {
    d: "M167.33 319.27h16.7c.56 0 1.01.35 1.01.78 0 .44-.45.79-1.02.79h-16.69c-.56 0-1.02-.35-1.02-.79 0-.43.46-.78 1.02-.78z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path110 || (_path110 = /*#__PURE__*/react.createElement("path", {
    d: "M164.27 329.86h22.88v-5.83h-22.88v5.83z",
    fill: "#c8b100"
  })), _path111 || (_path111 = /*#__PURE__*/react.createElement("path", {
    d: "M164.27 329.86h22.88v-5.83h-22.88v5.83z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path112 || (_path112 = /*#__PURE__*/react.createElement("path", {
    d: "M162.48 298.62c-2.26 1.3-3.8 2.64-3.55 3.31.12.62.84 1.07 1.87 1.75 1.62 1.13 2.6 3.14 1.83 4.07a5.76 5.76 0 0 0-.15-9.13",
    fill: "#ad1519"
  })), _path113 || (_path113 = /*#__PURE__*/react.createElement("path", {
    d: "M162.48 298.62c-2.26 1.3-3.8 2.64-3.55 3.31.12.62.84 1.07 1.87 1.75 1.62 1.13 2.6 3.14 1.83 4.07a5.76 5.76 0 0 0-.15-9.13z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path114 || (_path114 = /*#__PURE__*/react.createElement("path", {
    d: "M167.55 318.32h16.25V238.7h-16.25v79.63z",
    fill: "#ccc"
  })), _path115 || (_path115 = /*#__PURE__*/react.createElement("path", {
    d: "M179.13 238.8v79.46m1.83-79.46v79.46m-13.41.06h16.25V238.7h-16.25v79.63z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path116 || (_path116 = /*#__PURE__*/react.createElement("path", {
    d: "M200.4 268.47c-3.54-1.46-9.57-2.55-16.5-2.78a50.2 50.2 0 0 0-7.78.7c-9.72 1.63-17.13 5.5-16.54 8.67l.05.26s-3.64-8.2-3.7-8.52c-.65-3.51 7.56-7.82 18.35-9.62 3.39-.57 6.7-.79 9.56-.76 6.9 0 12.9.89 16.52 2.23l.04 9.82",
    fill: "#ad1519"
  })), _path117 || (_path117 = /*#__PURE__*/react.createElement("path", {
    d: "M200.4 268.47c-3.54-1.46-9.57-2.55-16.5-2.78a50.2 50.2 0 0 0-7.78.7c-9.72 1.63-17.13 5.5-16.54 8.67l.05.26s-3.64-8.2-3.7-8.52c-.65-3.51 7.56-7.82 18.35-9.62 3.39-.57 6.7-.79 9.56-.76 6.9 0 12.9.89 16.52 2.23l.04 9.82",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.39
  })), _path118 || (_path118 = /*#__PURE__*/react.createElement("path", {
    d: "M167.52 278.47c-4.5-.32-7.59-1.53-7.94-3.41-.28-1.5 1.25-3.17 3.97-4.68 1.21.14 2.58.3 4 .3l-.03 7.79",
    fill: "#ad1519"
  })), _path119 || (_path119 = /*#__PURE__*/react.createElement("path", {
    d: "M167.52 278.47c-4.5-.32-7.59-1.53-7.94-3.41-.28-1.5 1.25-3.17 3.97-4.68 1.21.14 2.58.3 4 .3l-.03 7.79",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path120 || (_path120 = /*#__PURE__*/react.createElement("path", {
    d: "M183.83 272.38c2.82.43 4.93 1.13 5.98 1.99l.1.17c.5 1.03-1.97 3.22-6.1 5.67l.02-7.83",
    fill: "#ad1519"
  })), _path121 || (_path121 = /*#__PURE__*/react.createElement("path", {
    d: "M183.83 272.38c2.82.43 4.93 1.13 5.98 1.99l.1.17c.5 1.03-1.97 3.22-6.1 5.67l.02-7.83",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path122 || (_path122 = /*#__PURE__*/react.createElement("path", {
    d: "M157.42 293.83c-.43-1.28 3.97-3.86 10.18-6.14 2.84-1.01 5.18-2.07 8.09-3.35 8.63-3.82 15-8.2 14.22-9.8l-.09-.16c.46.38 1.18 8.24 1.18 8.24.78 1.46-5.05 5.78-13 9.58-2.54 1.22-7.9 3.2-10.44 4.1-4.54 1.56-9.04 4.53-8.63 5.63l-1.5-8.1",
    fill: "#ad1519"
  })), _path123 || (_path123 = /*#__PURE__*/react.createElement("path", {
    d: "M157.42 293.83c-.43-1.28 3.97-3.86 10.18-6.14 2.84-1.01 5.18-2.07 8.09-3.35 8.63-3.82 15-8.2 14.22-9.8l-.09-.16c.46.38 1.18 8.24 1.18 8.24.78 1.46-5.05 5.78-13 9.58-2.54 1.22-7.9 3.2-10.44 4.1-4.54 1.56-9.04 4.53-8.63 5.63l-1.5-8.1z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.39
  })), _path124 || (_path124 = /*#__PURE__*/react.createElement("path", {
    d: "M166.43 264.65c1.98-.72 3.28-1.58 2.65-3.14-.4-1-1.43-1.19-2.97-.63l-2.72.99 2.45 6.03c.27-.12.54-.24.81-.34.28-.1.57-.18.85-.26l-1.07-2.64zm-1.19-2.9.69-.26c.57-.2 1.22.1 1.5.8.21.53.16 1.13-.5 1.55-.21.13-.46.23-.7.33l-.99-2.43m7.54-2.52c-.29.07-.57.16-.86.22l-.88.13 1.41 6.27 4.38-.88c-.05-.13-.12-.26-.14-.38-.03-.14-.03-.28-.04-.41-.77.22-1.6.46-2.61.66l-1.26-5.61m8.78 5.41c.82-2.28 1.82-4.46 2.81-6.67a5.51 5.51 0 0 1-1.08.07c-.53 1.6-1.18 3.2-1.87 4.8-.82-1.51-1.73-2.99-2.43-4.51-.34.04-.69.1-1.03.12-.34.02-.7.01-1.04.02 1.26 2.06 2.48 4.1 3.64 6.23l.5-.08c.16 0 .33 0 .5.02m9.16-4.83c.15-.3.3-.6.48-.89a3.6 3.6 0 0 0-1.81-.63c-1.79-.18-2.81.61-2.93 1.7-.26 2.25 3.3 2.06 3.14 3.56-.07.64-.75.9-1.48.83-.81-.08-1.4-.53-1.51-1.19l-.22-.02c-.12.4-.3.77-.48 1.15.53.34 1.2.53 1.85.6 1.83.18 3.22-.55 3.35-1.75.23-2.15-3.37-2.27-3.23-3.54.06-.53.47-.88 1.4-.79.67.07 1.08.43 1.26.95l.18.02",
    fill: "#c8b100"
  })), _path125 || (_path125 = /*#__PURE__*/react.createElement("path", {
    d: "M324.85 220.42s-.74.78-1.28.89c-.53.1-1.21-.49-1.21-.49s-.48.5-1.08.64c-.59.14-1.41-.67-1.41-.67s-.57.8-1.07 1c-.51.18-1.13-.24-1.13-.24s-.23.4-.65.61c-.18.09-.48-.05-.48-.05l-.6-.38-.68-.72-.62-.24s-.28-.91-.3-1.07l-.1-.57c-.12-.64.88-1.4 2.31-1.72.82-.2 1.54-.18 2.06-.02.57-.48 1.78-.82 3.2-.82 1.29 0 2.42.27 3.04.7.61-.43 1.74-.7 3.03-.7 1.42 0 2.62.34 3.2.82a4.1 4.1 0 0 1 2.06.02c1.42.32 2.43 1.08 2.3 1.72l-.08.57c-.03.16-.31 1.07-.31 1.07l-.63.24-.68.72-.59.38s-.3.14-.47.05a1.76 1.76 0 0 1-.66-.61s-.62.42-1.13.24c-.5-.2-1.07-1-1.07-1s-.82.8-1.42.67c-.59-.13-1.07-.64-1.07-.64s-.68.6-1.21.49c-.54-.11-1.27-.89-1.27-.89",
    fill: "#ad1519"
  })), _path126 || (_path126 = /*#__PURE__*/react.createElement("path", {
    d: "M324.85 220.42s-.74.78-1.28.89c-.53.1-1.21-.49-1.21-.49s-.48.5-1.08.64c-.59.14-1.41-.67-1.41-.67s-.57.8-1.07 1c-.51.18-1.13-.24-1.13-.24s-.23.4-.65.61c-.18.09-.48-.05-.48-.05l-.6-.38-.68-.72-.62-.24s-.28-.91-.3-1.07l-.1-.57c-.12-.64.88-1.4 2.31-1.72.82-.2 1.54-.18 2.06-.02.57-.48 1.78-.82 3.2-.82 1.29 0 2.42.27 3.04.7.61-.43 1.74-.7 3.03-.7 1.42 0 2.62.34 3.2.82a4.1 4.1 0 0 1 2.06.02c1.42.32 2.43 1.08 2.3 1.72l-.08.57c-.03.16-.31 1.07-.31 1.07l-.63.24-.68.72-.59.38s-.3.14-.47.05a1.76 1.76 0 0 1-.66-.61s-.62.42-1.13.24c-.5-.2-1.07-1-1.07-1s-.82.8-1.42.67c-.59-.13-1.07-.64-1.07-.64s-.68.6-1.21.49c-.54-.11-1.27-.89-1.27-.89z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.27
  })), _path127 || (_path127 = /*#__PURE__*/react.createElement("path", {
    d: "M323.45 216.2c0-1.09.61-1.96 1.37-1.96.76 0 1.38.87 1.38 1.96 0 1.08-.62 1.96-1.38 1.96-.76 0-1.37-.88-1.37-1.96",
    fill: "#c8b100"
  })), _path128 || (_path128 = /*#__PURE__*/react.createElement("path", {
    d: "M323.45 216.2c0-1.09.61-1.96 1.37-1.96.76 0 1.38.87 1.38 1.96 0 1.08-.62 1.96-1.38 1.96-.76 0-1.37-.88-1.37-1.96z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path129 || (_path129 = /*#__PURE__*/react.createElement("path", {
    d: "M324.22 216.2c0-1 .28-1.8.63-1.8s.63.8.63 1.8-.28 1.8-.63 1.8-.63-.8-.63-1.8",
    fill: "#c8b100"
  })), _path130 || (_path130 = /*#__PURE__*/react.createElement("path", {
    d: "M324.22 216.2c0-1 .28-1.8.63-1.8s.63.8.63 1.8-.28 1.8-.63 1.8-.63-.8-.63-1.8z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path131 || (_path131 = /*#__PURE__*/react.createElement("path", {
    d: "M317.75 224.25a4.72 4.72 0 0 0-.58-1.08c1.94-.57 4.65-.93 7.67-.94 3.01 0 5.74.37 7.69.94l-.52.91c-.17.3-.4.81-.38.81a23.8 23.8 0 0 0-6.8-.82c-2.79 0-5.47.35-6.86.86.02 0-.1-.32-.24-.68h.02",
    fill: "#c8b100"
  })), _path132 || (_path132 = /*#__PURE__*/react.createElement("path", {
    d: "M317.75 224.25a4.72 4.72 0 0 0-.58-1.08c1.94-.57 4.65-.93 7.67-.94 3.01 0 5.74.37 7.69.94l-.52.91c-.17.3-.4.81-.38.81a23.8 23.8 0 0 0-6.8-.82c-2.79 0-5.47.35-6.86.86.02 0-.1-.32-.24-.68h.02",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path133 || (_path133 = /*#__PURE__*/react.createElement("path", {
    d: "M324.84 226.73c2.43 0 5.1-.38 6.1-.63.66-.2 1.05-.5.97-.84-.03-.16-.17-.3-.37-.38-1.45-.47-4.06-.8-6.7-.8-2.64 0-5.27.33-6.72.8-.19.08-.33.22-.37.38-.07.35.32.65.98.84.99.25 3.68.62 6.1.63",
    fill: "#c8b100"
  })), _path134 || (_path134 = /*#__PURE__*/react.createElement("path", {
    d: "M324.84 226.73c2.43 0 5.1-.38 6.1-.63.66-.2 1.05-.5.97-.84-.03-.16-.17-.3-.37-.38-1.45-.47-4.06-.8-6.7-.8-2.64 0-5.27.33-6.72.8-.19.08-.33.22-.37.38-.07.35.32.65.98.84.99.25 3.68.62 6.1.63z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path135 || (_path135 = /*#__PURE__*/react.createElement("path", {
    d: "M330.74 217.07c0-.23.2-.42.44-.42.26 0 .46.19.46.42 0 .24-.2.43-.45.43a.44.44 0 0 1-.45-.43",
    fill: "#fff"
  })), _path136 || (_path136 = /*#__PURE__*/react.createElement("path", {
    d: "M330.74 217.07c0-.23.2-.42.44-.42.26 0 .46.19.46.42 0 .24-.2.43-.45.43a.44.44 0 0 1-.45-.43zm-.26-1.49c0-.24.2-.43.45-.43s.45.19.45.43c0 .23-.2.42-.45.42a.44.44 0 0 1-.45-.42zm-1.13-.94c0-.24.2-.43.45-.43s.45.2.45.43c0 .24-.2.43-.45.43a.44.44 0 0 1-.45-.43zm-1.42-.45c0-.24.2-.44.46-.44.25 0 .45.2.45.44 0 .23-.2.42-.45.42s-.46-.2-.46-.42zm-1.44.05c0-.24.2-.43.45-.43.26 0 .46.19.46.43 0 .23-.2.42-.45.42a.44.44 0 0 1-.45-.42z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.21
  })), _path137 || (_path137 = /*#__PURE__*/react.createElement("path", {
    d: "M335.2 219.99a2.85 2.85 0 0 0-2.6-3.96c-.5 0-.97.13-1.38.37",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.26
  })), _path138 || (_path138 = /*#__PURE__*/react.createElement("path", {
    d: "M330.17 217.96c.15-.26.25-.57.25-.87 0-1.15-1.18-2.08-2.64-2.08-.62 0-1.2.17-1.64.45",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path139 || (_path139 = /*#__PURE__*/react.createElement("path", {
    d: "M335.6 218.68c0-.24.2-.43.45-.43s.45.2.45.43c0 .24-.2.43-.45.43s-.45-.2-.45-.43zm-.18-1.58c0-.24.21-.42.46-.42s.45.18.45.42-.2.43-.45.43-.45-.2-.45-.43zm-1-1.2c0-.24.2-.43.44-.43.25 0 .45.2.45.43 0 .23-.2.42-.45.42a.44.44 0 0 1-.45-.42zm-1.37-.65c0-.23.2-.42.46-.42.25 0 .45.19.45.42 0 .24-.2.44-.45.44a.44.44 0 0 1-.46-.44zm-1.44.06c0-.24.2-.43.45-.43s.46.2.46.43c0 .23-.2.43-.46.43-.25 0-.45-.2-.45-.43z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.21
  })), _path140 || (_path140 = /*#__PURE__*/react.createElement("path", {
    d: "m332.65 222.08-.6-.53s-.56.34-1.27.24c-.7-.11-.93-.97-.93-.97s-.8.67-1.44.62a1.7 1.7 0 0 1-1.07-.62s-.71.5-1.33.46c-.62-.06-1.22-.83-1.22-.83s-.62.8-1.24.86c-.62.05-1.13-.54-1.13-.54s-.29.59-1.08.72-1.47-.62-1.47-.62-.44.73-.98.92c-.54.18-1.24-.27-1.24-.27l-.2.43c-.09.16-.31.19-.31.19l.17.47c1.94-.56 4.57-.9 7.54-.9 2.97 0 5.67.34 7.6.9l.2-.53",
    fill: "#c8b100"
  })), _path141 || (_path141 = /*#__PURE__*/react.createElement("path", {
    d: "m332.65 222.08-.6-.53s-.56.34-1.27.24c-.7-.11-.93-.97-.93-.97s-.8.67-1.44.62a1.7 1.7 0 0 1-1.07-.62s-.71.5-1.33.46c-.62-.06-1.22-.83-1.22-.83s-.62.8-1.24.86c-.62.05-1.13-.54-1.13-.54s-.29.59-1.08.72-1.47-.62-1.47-.62-.44.73-.98.92c-.54.18-1.24-.27-1.24-.27l-.2.43c-.09.16-.31.19-.31.19l.17.47c1.94-.56 4.57-.9 7.54-.9 2.97 0 5.67.34 7.6.9l.2-.53z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path142 || (_path142 = /*#__PURE__*/react.createElement("path", {
    d: "M317.98 217.07c0-.23.2-.42.45-.42s.45.19.45.42c0 .24-.2.43-.45.43s-.45-.19-.45-.43",
    fill: "#fff"
  })), _path143 || (_path143 = /*#__PURE__*/react.createElement("path", {
    d: "M317.98 217.07c0-.23.2-.42.45-.42s.45.19.45.42c0 .24-.2.43-.45.43s-.45-.19-.45-.43zm.25-1.49c0-.24.2-.43.45-.43s.45.19.45.43c0 .23-.2.42-.44.42-.26 0-.46-.19-.46-.42zm1.13-.94c0-.24.2-.43.45-.43s.46.2.46.43c0 .24-.2.43-.46.43a.44.44 0 0 1-.45-.43zm1.41-.45c0-.24.2-.44.46-.44.25 0 .45.2.45.44 0 .23-.2.42-.45.42s-.46-.2-.46-.42zm1.45.05c0-.24.2-.43.45-.43s.45.19.45.43c0 .23-.2.42-.45.42a.44.44 0 0 1-.45-.42z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.21
  })), _path144 || (_path144 = /*#__PURE__*/react.createElement("path", {
    d: "M314.4 219.99a2.85 2.85 0 0 1 2.6-3.96c.51 0 .98.13 1.4.37",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.26
  })), _path145 || (_path145 = /*#__PURE__*/react.createElement("path", {
    d: "M319.48 217.93a1.75 1.75 0 0 1-.29-.84c0-1.15 1.19-2.08 2.64-2.08.62 0 1.2.17 1.65.45",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path146 || (_path146 = /*#__PURE__*/react.createElement("path", {
    d: "M313.11 218.68c0-.24.2-.43.46-.43.24 0 .45.2.45.43 0 .24-.2.43-.45.43s-.46-.2-.46-.43zm.17-1.58c0-.24.2-.42.46-.42.25 0 .45.18.45.42s-.2.43-.45.43-.46-.2-.46-.43zm1.02-1.2c0-.24.2-.43.46-.43.24 0 .45.2.45.43 0 .23-.2.42-.45.42a.44.44 0 0 1-.46-.42zm1.36-.65c0-.23.2-.42.45-.42s.45.19.45.42c0 .24-.2.44-.45.44a.44.44 0 0 1-.45-.44zm1.44.06c0-.24.2-.43.45-.43s.45.2.45.43c0 .23-.2.43-.45.43s-.45-.2-.45-.43z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.21
  })), _path147 || (_path147 = /*#__PURE__*/react.createElement("path", {
    d: "m324.85 219.5.28.04c-.04.12-.05.24-.05.38 0 .58.5 1.05 1.12 1.05.5 0 .91-.3 1.05-.73.02.01.11-.38.16-.38.04 0 .03.41.04.4.07.53.56.9 1.1.9.62 0 1.12-.47 1.12-1.06l-.01-.12.35-.35.19.44c-.08.14-.1.3-.1.46 0 .56.47 1 1.06 1 .37 0 .7-.17.88-.44l.23-.29v.35c0 .35.14.66.48.72 0 0 .4.03.91-.38.53-.41.81-.75.81-.75l.03.42s-.51.84-.97 1.1c-.25.15-.64.3-.95.25-.33-.04-.55-.3-.68-.6-.23.13-.5.21-.8.21-.62 0-1.19-.35-1.41-.86a1.63 1.63 0 0 1-2.42-.08 1.63 1.63 0 0 1-2.43-.26 1.62 1.62 0 0 1-2.42.26c-.3.35-.75.58-1.26.58-.47 0-.87-.19-1.16-.5-.22.5-.79.86-1.42.86-.29 0-.56-.08-.8-.22-.11.3-.34.56-.67.61-.3.06-.69-.1-.94-.25-.47-.26-1.02-1.1-1.02-1.1l.07-.42s.28.34.8.75.92.38.92.38c.34-.06.48-.37.48-.72v-.35l.23.29c.19.27.51.45.88.45.6 0 1.07-.45 1.07-1.01a.93.93 0 0 0-.1-.46l.18-.44.35.35-.01.12c0 .59.5 1.06 1.1 1.06.56 0 1.04-.37 1.11-.9.02.01.01-.4.05-.4.05 0 .14.4.15.38.15.42.57.73 1.06.73a1.09 1.09 0 0 0 1.07-1.43l.29-.05",
    fill: "#c8b100"
  })), _path148 || (_path148 = /*#__PURE__*/react.createElement("path", {
    d: "m324.85 219.5.28.04c-.04.12-.05.24-.05.38 0 .58.5 1.05 1.12 1.05.5 0 .91-.3 1.05-.73.02.01.11-.38.16-.38.04 0 .03.41.04.4.07.53.56.9 1.1.9.62 0 1.12-.47 1.12-1.06l-.01-.12.35-.35.19.44c-.08.14-.1.3-.1.46 0 .56.47 1 1.06 1 .37 0 .7-.17.88-.44l.23-.29v.35c0 .35.14.66.48.72 0 0 .4.03.91-.38.53-.41.81-.75.81-.75l.03.42s-.51.84-.97 1.1c-.25.15-.64.3-.95.25-.33-.04-.55-.3-.68-.6-.23.13-.5.21-.8.21-.62 0-1.19-.35-1.41-.86a1.63 1.63 0 0 1-2.42-.08 1.63 1.63 0 0 1-2.43-.26 1.62 1.62 0 0 1-2.42.26c-.3.35-.75.58-1.26.58-.47 0-.87-.19-1.16-.5-.22.5-.79.86-1.42.86-.29 0-.56-.08-.8-.22-.11.3-.34.56-.67.61-.3.06-.69-.1-.94-.25-.47-.26-1.02-1.1-1.02-1.1l.07-.42s.28.34.8.75.92.38.92.38c.34-.06.48-.37.48-.72v-.35l.23.29c.19.27.51.45.88.45.6 0 1.07-.45 1.07-1.01a.93.93 0 0 0-.1-.46l.18-.44.35.35-.01.12c0 .59.5 1.06 1.1 1.06.56 0 1.04-.37 1.11-.9.02.01.01-.4.05-.4.05 0 .14.4.15.38.15.42.57.73 1.06.73a1.09 1.09 0 0 0 1.07-1.43l.29-.05z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path149 || (_path149 = /*#__PURE__*/react.createElement("path", {
    d: "M324.84 222.23c-3.02 0-5.72.37-7.67.94-.13.04-.29-.06-.33-.17-.04-.13.05-.28.18-.32 1.95-.6 4.73-.97 7.82-.98 3.08 0 5.87.38 7.83.98.13.04.22.2.18.32-.04.11-.2.21-.33.17a28.45 28.45 0 0 0-7.68-.94",
    fill: "#c8b100"
  })), _path150 || (_path150 = /*#__PURE__*/react.createElement("path", {
    d: "M324.84 222.23c-3.02 0-5.72.37-7.67.94-.13.04-.29-.06-.33-.17-.04-.13.05-.28.18-.32 1.95-.6 4.73-.97 7.82-.98 3.08 0 5.87.38 7.83.98.13.04.22.2.18.32-.04.11-.2.21-.33.17a28.45 28.45 0 0 0-7.68-.94z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path151 || (_path151 = /*#__PURE__*/react.createElement("path", {
    d: "M321.92 223.3c0-.22.2-.4.44-.4s.44.18.44.4c0 .23-.2.41-.44.41s-.44-.18-.44-.4",
    fill: "#fff"
  })), _path152 || (_path152 = /*#__PURE__*/react.createElement("path", {
    d: "M321.92 223.3c0-.22.2-.4.44-.4s.44.18.44.4c0 .23-.2.41-.44.41s-.44-.18-.44-.4z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path153 || (_path153 = /*#__PURE__*/react.createElement("path", {
    d: "M324.88 223.48h-.98c-.18 0-.33-.14-.33-.31 0-.17.15-.3.33-.3h1.96c.18 0 .32.13.32.3 0 .17-.14.31-.32.31h-.99",
    fill: "#ad1519"
  })), _path154 || (_path154 = /*#__PURE__*/react.createElement("path", {
    d: "M324.88 223.48h-.98c-.18 0-.33-.14-.33-.31 0-.17.15-.3.33-.3h1.96c.18 0 .32.13.32.3 0 .17-.14.31-.32.31h-.99",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path155 || (_path155 = /*#__PURE__*/react.createElement("path", {
    d: "m320.02 223.81-.7.1a.33.33 0 0 1-.37-.25.3.3 0 0 1 .27-.35l.7-.1.7-.11c.18-.02.35.09.38.25.02.17-.1.33-.27.35l-.71.11",
    fill: "#058e6e"
  })), _path156 || (_path156 = /*#__PURE__*/react.createElement("path", {
    d: "m320.02 223.81-.7.1a.33.33 0 0 1-.37-.25.3.3 0 0 1 .27-.35l.7-.1.7-.11c.18-.02.35.09.38.25.02.17-.1.33-.27.35l-.71.11",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path157 || (_path157 = /*#__PURE__*/react.createElement("path", {
    d: "m317.21 224.3.31-.5.66.13-.38.56-.59-.19",
    fill: "#ad1519"
  })), _path158 || (_path158 = /*#__PURE__*/react.createElement("path", {
    d: "m317.21 224.3.31-.5.66.13-.38.56-.59-.19",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path159 || (_path159 = /*#__PURE__*/react.createElement("path", {
    d: "M326.89 223.3c0-.22.2-.4.43-.4.25 0 .44.18.44.4 0 .23-.2.41-.44.41s-.43-.18-.43-.4",
    fill: "#fff"
  })), _path160 || (_path160 = /*#__PURE__*/react.createElement("path", {
    d: "M326.89 223.3c0-.22.2-.4.43-.4.25 0 .44.18.44.4 0 .23-.2.41-.44.41s-.43-.18-.43-.4z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path161 || (_path161 = /*#__PURE__*/react.createElement("path", {
    d: "m329.66 223.81.7.1c.18.03.34-.08.37-.25a.3.3 0 0 0-.26-.35l-.7-.1-.71-.11c-.18-.02-.35.09-.38.25-.03.17.1.33.28.35l.7.11",
    fill: "#058e6e"
  })), _path162 || (_path162 = /*#__PURE__*/react.createElement("path", {
    d: "m329.66 223.81.7.1c.18.03.34-.08.37-.25a.3.3 0 0 0-.26-.35l-.7-.1-.71-.11c-.18-.02-.35.09-.38.25-.03.17.1.33.28.35l.7.11",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path163 || (_path163 = /*#__PURE__*/react.createElement("path", {
    d: "m332.4 224.33-.24-.53-.68.06.33.59.6-.12",
    fill: "#ad1519"
  })), _path164 || (_path164 = /*#__PURE__*/react.createElement("path", {
    d: "m332.4 224.33-.24-.53-.68.06.33.59.6-.12",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path165 || (_path165 = /*#__PURE__*/react.createElement("path", {
    d: "M324.83 226.16c-2.43 0-4.63-.22-6.3-.65 1.67-.43 3.87-.7 6.3-.7 2.44 0 4.65.27 6.32.7-1.67.44-3.88.65-6.32.65",
    fill: "#ad1519"
  })), _path166 || (_path166 = /*#__PURE__*/react.createElement("path", {
    d: "M324.83 226.16c-2.43 0-4.63-.22-6.3-.65 1.67-.43 3.87-.7 6.3-.7 2.44 0 4.65.27 6.32.7-1.67.44-3.88.65-6.32.65z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.26
  })), _path167 || (_path167 = /*#__PURE__*/react.createElement("path", {
    d: "M332.5 220.88c.07-.18.01-.37-.13-.41-.13-.04-.3.08-.36.26-.06.19 0 .38.13.42.14.04.3-.08.37-.27",
    fill: "#c8b100"
  })), _path168 || (_path168 = /*#__PURE__*/react.createElement("path", {
    d: "M332.5 220.88c.07-.18.01-.37-.13-.41-.13-.04-.3.08-.36.26-.06.19 0 .38.13.42.14.04.3-.08.37-.27z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path169 || (_path169 = /*#__PURE__*/react.createElement("path", {
    d: "M327.66 219.95c.03-.2-.07-.37-.21-.39-.14-.02-.28.13-.3.33-.03.2.06.37.2.38.15.02.28-.13.31-.32",
    fill: "#c8b100"
  })), _path170 || (_path170 = /*#__PURE__*/react.createElement("path", {
    d: "M327.66 219.95c.03-.2-.07-.37-.21-.39-.14-.02-.28.13-.3.33-.03.2.06.37.2.38.15.02.28-.13.31-.32z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path171 || (_path171 = /*#__PURE__*/react.createElement("path", {
    d: "M322.04 219.95c-.03-.2.06-.37.2-.39.15-.02.28.13.31.33.02.2-.07.37-.2.38-.15.02-.29-.13-.31-.32",
    fill: "#c8b100"
  })), _path172 || (_path172 = /*#__PURE__*/react.createElement("path", {
    d: "M322.04 219.95c-.03-.2.06-.37.2-.39.15-.02.28.13.31.33.02.2-.07.37-.2.38-.15.02-.29-.13-.31-.32z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path173 || (_path173 = /*#__PURE__*/react.createElement("path", {
    d: "M317.2 220.88c-.07-.18-.01-.37.12-.41.13-.04.3.08.36.26.07.19.01.38-.12.42-.14.04-.3-.08-.37-.27",
    fill: "#c8b100"
  })), _path174 || (_path174 = /*#__PURE__*/react.createElement("path", {
    d: "M317.2 220.88c-.07-.18-.01-.37.12-.41.13-.04.3.08.36.26.07.19.01.38-.12.42-.14.04-.3-.08-.37-.27z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path175 || (_path175 = /*#__PURE__*/react.createElement("path", {
    d: "m324.83 217.15-.85.52.63 1.38.22.14.22-.14.64-1.38-.86-.52",
    fill: "#c8b100"
  })), _path176 || (_path176 = /*#__PURE__*/react.createElement("path", {
    d: "m324.83 217.15-.85.52.63 1.38.22.14.22-.14.64-1.38-.86-.52",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path177 || (_path177 = /*#__PURE__*/react.createElement("path", {
    d: "m322.95 219.24.4.57 1.33-.42.14-.18-.14-.2-1.34-.39-.39.62",
    fill: "#c8b100"
  })), _path178 || (_path178 = /*#__PURE__*/react.createElement("path", {
    d: "m322.95 219.24.4.57 1.33-.42.14-.18-.14-.2-1.34-.39-.39.62",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path179 || (_path179 = /*#__PURE__*/react.createElement("path", {
    d: "m326.72 219.24-.39.57-1.34-.42-.14-.18.14-.2 1.34-.39.4.62",
    fill: "#c8b100"
  })), _path180 || (_path180 = /*#__PURE__*/react.createElement("path", {
    d: "m326.72 219.24-.39.57-1.34-.42-.14-.18.14-.2 1.34-.39.4.62",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path181 || (_path181 = /*#__PURE__*/react.createElement("path", {
    d: "m319.25 217.76-.67.64.86 1.14.23.09.17-.18.3-1.37-.89-.32",
    fill: "#c8b100"
  })), _path182 || (_path182 = /*#__PURE__*/react.createElement("path", {
    d: "m319.25 217.76-.67.64.86 1.14.23.09.17-.18.3-1.37-.89-.32",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path183 || (_path183 = /*#__PURE__*/react.createElement("path", {
    d: "m317.84 220.04.5.48 1.23-.66.09-.21-.18-.16-1.4-.13-.24.68",
    fill: "#c8b100"
  })), _path184 || (_path184 = /*#__PURE__*/react.createElement("path", {
    d: "m317.84 220.04.5.48 1.23-.66.09-.21-.18-.16-1.4-.13-.24.68",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path185 || (_path185 = /*#__PURE__*/react.createElement("path", {
    d: "m321.53 219.3-.26.63-1.4-.13-.18-.16.1-.21 1.22-.65.52.52",
    fill: "#c8b100"
  })), _path186 || (_path186 = /*#__PURE__*/react.createElement("path", {
    d: "m321.53 219.3-.26.63-1.4-.13-.18-.16.1-.21 1.22-.65.52.52",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path187 || (_path187 = /*#__PURE__*/react.createElement("path", {
    d: "m316.5 220.22-.12.66-1.4.15-.22-.12.06-.23 1.05-.87.62.41",
    fill: "#c8b100"
  })), _path188 || (_path188 = /*#__PURE__*/react.createElement("path", {
    d: "m316.5 220.22-.12.66-1.4.15-.22-.12.06-.23 1.05-.87.62.41",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path189 || (_path189 = /*#__PURE__*/react.createElement("path", {
    d: "M319.19 219.65c0-.26.22-.47.49-.47s.49.21.49.47c0 .25-.22.46-.5.46a.48.48 0 0 1-.48-.46",
    fill: "#c8b100"
  })), _path190 || (_path190 = /*#__PURE__*/react.createElement("path", {
    d: "M319.19 219.65c0-.26.22-.47.49-.47s.49.21.49.47c0 .25-.22.46-.5.46a.48.48 0 0 1-.48-.46z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path191 || (_path191 = /*#__PURE__*/react.createElement("path", {
    d: "m330.44 217.76.67.64-.86 1.14-.23.09-.17-.18-.3-1.37.89-.32",
    fill: "#c8b100"
  })), _path192 || (_path192 = /*#__PURE__*/react.createElement("path", {
    d: "m330.44 217.76.67.64-.86 1.14-.23.09-.17-.18-.3-1.37.89-.32",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path193 || (_path193 = /*#__PURE__*/react.createElement("path", {
    d: "m331.85 220.04-.5.48-1.23-.66-.1-.21.18-.16 1.4-.13.25.68",
    fill: "#c8b100"
  })), _path194 || (_path194 = /*#__PURE__*/react.createElement("path", {
    d: "m331.85 220.04-.5.48-1.23-.66-.1-.21.18-.16 1.4-.13.25.68",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path195 || (_path195 = /*#__PURE__*/react.createElement("path", {
    d: "m328.16 219.3.26.63 1.4-.13.18-.16-.1-.21-1.22-.65-.52.52",
    fill: "#c8b100"
  })), _path196 || (_path196 = /*#__PURE__*/react.createElement("path", {
    d: "m328.16 219.3.26.63 1.4-.13.18-.16-.1-.21-1.22-.65-.52.52",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path197 || (_path197 = /*#__PURE__*/react.createElement("path", {
    d: "m333 220.22.12.66 1.4.15.2-.12-.04-.23-1.05-.87-.62.41",
    fill: "#c8b100"
  })), _path198 || (_path198 = /*#__PURE__*/react.createElement("path", {
    d: "m333 220.22.12.66 1.4.15.2-.12-.04-.23-1.05-.87-.62.41",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path199 || (_path199 = /*#__PURE__*/react.createElement("path", {
    d: "M324.35 219.2c0-.25.22-.46.5-.46.26 0 .48.2.48.47 0 .25-.22.46-.49.46a.48.48 0 0 1-.49-.46",
    fill: "#c8b100"
  })), _path200 || (_path200 = /*#__PURE__*/react.createElement("path", {
    d: "M324.35 219.2c0-.25.22-.46.5-.46.26 0 .48.2.48.47 0 .25-.22.46-.49.46a.48.48 0 0 1-.49-.46z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path201 || (_path201 = /*#__PURE__*/react.createElement("path", {
    d: "M329.52 219.65c0-.26.23-.47.5-.47s.5.21.5.47c0 .25-.23.46-.5.46a.48.48 0 0 1-.5-.46",
    fill: "#c8b100"
  })), _path202 || (_path202 = /*#__PURE__*/react.createElement("path", {
    d: "M329.52 219.65c0-.26.23-.47.5-.47s.5.21.5.47c0 .25-.23.46-.5.46a.48.48 0 0 1-.5-.46z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path203 || (_path203 = /*#__PURE__*/react.createElement("path", {
    d: "M323.92 213.95a.9.9 0 0 1 .92-.87c.51 0 .93.39.93.87 0 .49-.42.88-.93.88a.9.9 0 0 1-.92-.88",
    fill: "#c8b100"
  })), _path204 || (_path204 = /*#__PURE__*/react.createElement("path", {
    d: "M325.5 213.64v.58h-1.43v-.58h.47v-1.3h-.62v-.59h.62v-.57h.6v.57h.61v.59h-.6v1.3h.34",
    fill: "#c8b100"
  })), _path205 || (_path205 = /*#__PURE__*/react.createElement("path", {
    d: "M325.5 213.64v.58h-1.43v-.58h.47v-1.3h-.62v-.59h.62v-.57h.6v.57h.61v.59h-.6v1.3h.34z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path206 || (_path206 = /*#__PURE__*/react.createElement("path", {
    d: "M326.13 213.64v.58h-2.53v-.58h.94v-1.3h-.62v-.59h.62v-.57h.6v.57h.62v.59h-.61v1.3h.98",
    fill: "#c8b100"
  })), _path207 || (_path207 = /*#__PURE__*/react.createElement("path", {
    d: "M325.1 213.12c.39.1.67.44.67.83a.9.9 0 0 1-.93.88.9.9 0 0 1-.92-.88c0-.4.29-.74.68-.84",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path208 || (_path208 = /*#__PURE__*/react.createElement("path", {
    d: "M314.6 221c-.01 0-.38-.49-.66-.73-.2-.18-.67-.33-.67-.33 0-.09.28-.28.58-.28.18 0 .35.07.45.2l.03-.2s.25.05.36.32c.11.29.04.72.04.72s-.05.2-.13.3",
    fill: "#c8b100"
  })), _path209 || (_path209 = /*#__PURE__*/react.createElement("path", {
    d: "M314.6 221c-.01 0-.38-.49-.66-.73-.2-.18-.67-.33-.67-.33 0-.09.28-.28.58-.28.18 0 .35.07.45.2l.03-.2s.25.05.36.32c.11.29.04.72.04.72s-.05.2-.13.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path210 || (_path210 = /*#__PURE__*/react.createElement("path", {
    d: "M314.62 220.75c.11-.12.35-.1.53.06.18.15.23.38.11.5-.11.13-.35.1-.53-.06-.18-.15-.23-.38-.11-.5",
    fill: "#c8b100"
  })), _path211 || (_path211 = /*#__PURE__*/react.createElement("path", {
    d: "M314.62 220.75c.11-.12.35-.1.53.06.18.15.23.38.11.5-.11.13-.35.1-.53-.06-.18-.15-.23-.38-.11-.5z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path212 || (_path212 = /*#__PURE__*/react.createElement("path", {
    d: "M334.9 221c.01 0 .38-.49.65-.73.2-.18.68-.33.68-.33 0-.09-.28-.28-.59-.28a.58.58 0 0 0-.44.2l-.04-.2s-.25.05-.36.32c-.1.29-.04.72-.04.72s.05.2.14.3",
    fill: "#c8b100"
  })), _path213 || (_path213 = /*#__PURE__*/react.createElement("path", {
    d: "M334.9 221c.01 0 .38-.49.65-.73.2-.18.68-.33.68-.33 0-.09-.28-.28-.59-.28a.58.58 0 0 0-.44.2l-.04-.2s-.25.05-.36.32c-.1.29-.04.72-.04.72s.05.2.14.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path214 || (_path214 = /*#__PURE__*/react.createElement("path", {
    d: "M334.91 220.75c-.12-.12-.36-.1-.54.06-.18.15-.23.38-.11.5.11.13.35.1.53-.06.18-.15.24-.38.12-.5",
    fill: "#c8b100"
  })), _path215 || (_path215 = /*#__PURE__*/react.createElement("path", {
    d: "M334.91 220.75c-.12-.12-.36-.1-.54.06-.18.15-.23.38-.11.5.11.13.35.1.53-.06.18-.15.24-.38.12-.5z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path216 || (_path216 = /*#__PURE__*/react.createElement("path", {
    d: "M313.71 232.37H336v-5.84h-22.3v5.84z",
    fill: "#c8b100"
  })), _path217 || (_path217 = /*#__PURE__*/react.createElement("path", {
    d: "M313.71 232.37H336v-5.84h-22.3v5.84z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path218 || (_path218 = /*#__PURE__*/react.createElement("path", {
    d: "M333.66 236.26a.98.98 0 0 0-.41-.07h-16.7c-.16 0-.31.03-.45.08.57-.19.98-.7.98-1.32 0-.6-.44-1.14-1.02-1.33.14.04.32.08.49.08h16.7c.17 0 .32-.01.47-.06l-.1.02c-.6.18-.93.71-.93 1.3 0 .55.37 1.12.97 1.3",
    fill: "#c8b100"
  })), _path219 || (_path219 = /*#__PURE__*/react.createElement("path", {
    d: "M333.66 236.26a.98.98 0 0 0-.41-.07h-16.7c-.16 0-.31.03-.45.08.57-.19.98-.7.98-1.32 0-.6-.44-1.14-1.02-1.33.14.04.32.08.49.08h16.7c.17 0 .32-.01.47-.06l-.1.02c-.6.18-.93.71-.93 1.3 0 .55.37 1.12.97 1.3z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.39
  })), _path220 || (_path220 = /*#__PURE__*/react.createElement("path", {
    d: "M316.56 236.2h16.69c.56 0 1.02.34 1.02.77 0 .44-.46.79-1.02.79h-16.7c-.56 0-1.01-.35-1.01-.79 0-.43.45-.78 1.02-.78",
    fill: "#c8b100"
  })), _path221 || (_path221 = /*#__PURE__*/react.createElement("path", {
    d: "M316.56 236.2h16.69c.56 0 1.02.34 1.02.77 0 .44-.46.79-1.02.79h-16.7c-.56 0-1.01-.35-1.01-.79 0-.43.45-.78 1.02-.78z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path222 || (_path222 = /*#__PURE__*/react.createElement("path", {
    d: "M316.55 232.37h16.7c.56 0 1.02.3 1.02.66 0 .37-.46.67-1.02.67h-16.7c-.57 0-1.03-.3-1.03-.67 0-.36.46-.66 1.03-.66",
    fill: "#c8b100"
  })), _path223 || (_path223 = /*#__PURE__*/react.createElement("path", {
    d: "M316.55 232.37h16.7c.56 0 1.02.3 1.02.66 0 .37-.46.67-1.02.67h-16.7c-.57 0-1.03-.3-1.03-.67 0-.36.46-.66 1.03-.66z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path224 || (_path224 = /*#__PURE__*/react.createElement("path", {
    d: "M309.3 330.68c1.54 0 2.91-.33 3.93-.87 1-.5 2.36-.82 3.86-.82s2.9.32 3.9.83c1.01.53 2.4.86 3.93.86a8.5 8.5 0 0 0 3.93-.9c1-.5 2.33-.8 3.8-.8a8.5 8.5 0 0 1 3.85.82c1.01.54 2.42.88 3.95.88v2.41a8.67 8.67 0 0 1-3.95-.88c-1-.52-2.34-.82-3.86-.82-1.46 0-2.8.3-3.79.8-1 .54-2.4.9-3.93.9a8.7 8.7 0 0 1-3.92-.86c-1-.52-2.4-.84-3.9-.84s-2.87.32-3.88.84a8.4 8.4 0 0 1-3.9.86l-.02-2.41",
    fill: "#005bbf"
  })), _path225 || (_path225 = /*#__PURE__*/react.createElement("path", {
    d: "M309.3 330.68c1.54 0 2.91-.33 3.93-.87 1-.5 2.36-.82 3.86-.82s2.9.32 3.9.83c1.01.53 2.4.86 3.93.86a8.5 8.5 0 0 0 3.93-.9c1-.5 2.33-.8 3.8-.8a8.5 8.5 0 0 1 3.85.82c1.01.54 2.42.88 3.95.88v2.41a8.67 8.67 0 0 1-3.95-.88c-1-.52-2.34-.82-3.86-.82-1.46 0-2.8.3-3.79.8-1 .54-2.4.9-3.93.9a8.7 8.7 0 0 1-3.92-.86c-1-.52-2.4-.84-3.9-.84s-2.87.32-3.88.84a8.4 8.4 0 0 1-3.9.86l-.02-2.41z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path226 || (_path226 = /*#__PURE__*/react.createElement("path", {
    d: "M309.3 333.09a8.5 8.5 0 0 0 3.93-.86c1-.52 2.36-.84 3.86-.84s2.9.32 3.9.84c1.01.53 2.4.86 3.93.86 1.54 0 2.92-.36 3.93-.9 1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v2.4a8.67 8.67 0 0 1-3.95-.87c-1-.52-2.34-.82-3.86-.82-1.46 0-2.8.3-3.79.8-1 .54-2.4.9-3.93.9a8.7 8.7 0 0 1-3.92-.86c-1-.52-2.4-.84-3.9-.84s-2.87.32-3.88.83a8.43 8.43 0 0 1-3.9.87l-.02-2.41",
    fill: "#ccc"
  })), _path227 || (_path227 = /*#__PURE__*/react.createElement("path", {
    d: "M309.3 333.09a8.5 8.5 0 0 0 3.93-.86c1-.52 2.36-.84 3.86-.84s2.9.32 3.9.84c1.01.53 2.4.86 3.93.86 1.54 0 2.92-.36 3.93-.9 1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v2.4a8.67 8.67 0 0 1-3.95-.87c-1-.52-2.34-.82-3.86-.82-1.46 0-2.8.3-3.79.8-1 .54-2.4.9-3.93.9a8.7 8.7 0 0 1-3.92-.86c-1-.52-2.4-.84-3.9-.84s-2.87.32-3.88.83a8.43 8.43 0 0 1-3.9.87l-.02-2.41",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path228 || (_path228 = /*#__PURE__*/react.createElement("path", {
    d: "M309.3 335.5c1.54 0 2.91-.33 3.93-.87 1-.5 2.36-.83 3.86-.83s2.9.32 3.9.84c1.01.53 2.4.86 3.93.86 1.54 0 2.92-.36 3.93-.9 1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v2.4a8.63 8.63 0 0 1-3.95-.88c-1-.51-2.34-.8-3.86-.8-1.46 0-2.8.3-3.79.79-1 .54-2.4.9-3.93.9a8.71 8.71 0 0 1-3.92-.86c-1-.52-2.4-.83-3.9-.83s-2.87.3-3.88.82a8.37 8.37 0 0 1-3.9.86l-.02-2.4",
    fill: "#005bbf"
  })), _path229 || (_path229 = /*#__PURE__*/react.createElement("path", {
    d: "M309.3 335.5c1.54 0 2.91-.33 3.93-.87 1-.5 2.36-.83 3.86-.83s2.9.32 3.9.84c1.01.53 2.4.86 3.93.86 1.54 0 2.92-.36 3.93-.9 1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v2.4a8.63 8.63 0 0 1-3.95-.88c-1-.51-2.34-.8-3.86-.8-1.46 0-2.8.3-3.79.79-1 .54-2.4.9-3.93.9a8.71 8.71 0 0 1-3.92-.86c-1-.52-2.4-.83-3.9-.83s-2.87.3-3.88.82a8.37 8.37 0 0 1-3.9.86l-.02-2.4",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path230 || (_path230 = /*#__PURE__*/react.createElement("path", {
    d: "M309.32 340.32a8.4 8.4 0 0 0 3.9-.87c1.01-.51 2.37-.82 3.87-.82s2.9.31 3.9.83c1.01.52 2.4.86 3.93.86a8.5 8.5 0 0 0 3.93-.9c1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v-2.4a8.63 8.63 0 0 1-3.95-.9c-1-.51-2.34-.8-3.86-.8-1.46 0-2.8.3-3.79.79-1 .54-2.4.9-3.93.9a8.71 8.71 0 0 1-3.92-.86c-1-.52-2.4-.83-3.9-.83s-2.87.3-3.88.82a8.46 8.46 0 0 1-3.92.86l.02 2.42",
    fill: "#ccc"
  })), _path231 || (_path231 = /*#__PURE__*/react.createElement("path", {
    d: "M309.32 340.32a8.4 8.4 0 0 0 3.9-.87c1.01-.51 2.37-.82 3.87-.82s2.9.31 3.9.83c1.01.52 2.4.86 3.93.86a8.5 8.5 0 0 0 3.93-.9c1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v-2.4a8.63 8.63 0 0 1-3.95-.9c-1-.51-2.34-.8-3.86-.8-1.46 0-2.8.3-3.79.79-1 .54-2.4.9-3.93.9a8.71 8.71 0 0 1-3.92-.86c-1-.52-2.4-.83-3.9-.83s-2.87.3-3.88.82a8.46 8.46 0 0 1-3.92.86l.02 2.42",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path232 || (_path232 = /*#__PURE__*/react.createElement("path", {
    d: "M309.32 342.73c1.54 0 2.9-.33 3.9-.86a8.6 8.6 0 0 1 3.87-.84c1.5 0 2.9.32 3.9.84 1.01.52 2.4.86 3.93.86 1.54 0 2.92-.37 3.93-.9 1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v-2.4a8.61 8.61 0 0 1-3.95-.9c-1-.51-2.34-.8-3.86-.8-1.46 0-2.8.3-3.79.79-1 .53-2.4.9-3.93.9a8.7 8.7 0 0 1-3.92-.86c-1-.52-2.4-.83-3.9-.83s-2.87.31-3.88.82a8.5 8.5 0 0 1-3.92.87l.02 2.4",
    fill: "#005bbf"
  })), _path233 || (_path233 = /*#__PURE__*/react.createElement("path", {
    d: "M309.32 342.73c1.54 0 2.9-.33 3.9-.86a8.6 8.6 0 0 1 3.87-.84c1.5 0 2.9.32 3.9.84 1.01.52 2.4.86 3.93.86 1.54 0 2.92-.37 3.93-.9 1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v-2.4a8.61 8.61 0 0 1-3.95-.9c-1-.51-2.34-.8-3.86-.8-1.46 0-2.8.3-3.79.79-1 .53-2.4.9-3.93.9a8.7 8.7 0 0 1-3.92-.86c-1-.52-2.4-.83-3.9-.83s-2.87.31-3.88.82a8.5 8.5 0 0 1-3.92.87l.02 2.4z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path234 || (_path234 = /*#__PURE__*/react.createElement("path", {
    d: "M333.66 320.78c-.06.2-.13.4-.13.62 0 1.46 1.27 2.63 2.8 2.63H313.4c1.55 0 2.8-1.17 2.8-2.63 0-.21-.03-.41-.08-.62.12.05.28.06.44.06h16.69c.13 0 .29-.02.4-.06",
    fill: "#c8b100"
  })), _path235 || (_path235 = /*#__PURE__*/react.createElement("path", {
    d: "M333.66 320.78c-.06.2-.13.4-.13.62 0 1.46 1.27 2.63 2.8 2.63H313.4c1.55 0 2.8-1.17 2.8-2.63 0-.21-.03-.41-.08-.62.12.05.28.06.44.06h16.69c.13 0 .29-.02.4-.06z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.39
  })), _path236 || (_path236 = /*#__PURE__*/react.createElement("path", {
    d: "M316.56 319.27h16.69c.56 0 1.02.35 1.02.78 0 .44-.46.79-1.02.79h-16.7c-.56 0-1.01-.35-1.01-.79 0-.43.45-.78 1.02-.78",
    fill: "#c8b100"
  })), _path237 || (_path237 = /*#__PURE__*/react.createElement("path", {
    d: "M316.56 319.27h16.69c.56 0 1.02.35 1.02.78 0 .44-.46.79-1.02.79h-16.7c-.56 0-1.01-.35-1.01-.79 0-.43.45-.78 1.02-.78z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path238 || (_path238 = /*#__PURE__*/react.createElement("path", {
    d: "M313.43 329.86h22.88v-5.83h-22.88v5.83z",
    fill: "#c8b100"
  })), _path239 || (_path239 = /*#__PURE__*/react.createElement("path", {
    d: "M313.43 329.86h22.88v-5.83h-22.88v5.83z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path240 || (_path240 = /*#__PURE__*/react.createElement("path", {
    d: "M338.1 298.62c2.26 1.3 3.8 2.64 3.55 3.31-.12.62-.84 1.07-1.87 1.75-1.62 1.13-2.6 3.14-1.83 4.07a5.76 5.76 0 0 1 .15-9.13",
    fill: "#ad1519"
  })), _path241 || (_path241 = /*#__PURE__*/react.createElement("path", {
    d: "M338.1 298.62c2.26 1.3 3.8 2.64 3.55 3.31-.12.62-.84 1.07-1.87 1.75-1.62 1.13-2.6 3.14-1.83 4.07a5.76 5.76 0 0 1 .15-9.13z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path242 || (_path242 = /*#__PURE__*/react.createElement("path", {
    d: "M316.78 318.32h16.25V238.7h-16.25v79.63z",
    fill: "#ccc"
  })), _path243 || (_path243 = /*#__PURE__*/react.createElement("path", {
    d: "M328.57 238.66v79.46m1.82-79.46v79.46m-13.61.2h16.25V238.7h-16.25v79.63z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path244 || (_path244 = /*#__PURE__*/react.createElement("path", {
    d: "M300.17 268.47c3.55-1.46 9.58-2.55 16.5-2.78 2.38.02 5.04.25 7.79.7 9.72 1.63 17.12 5.5 16.54 8.67l-.05.26s3.64-8.2 3.7-8.52c.65-3.51-7.56-7.82-18.35-9.62a55.7 55.7 0 0 0-9.56-.76c-6.9 0-12.9.89-16.52 2.23l-.05 9.82",
    fill: "#ad1519"
  })), _path245 || (_path245 = /*#__PURE__*/react.createElement("path", {
    d: "M300.17 268.47c3.55-1.46 9.58-2.55 16.5-2.78 2.38.02 5.04.25 7.79.7 9.72 1.63 17.12 5.5 16.54 8.67l-.05.26s3.64-8.2 3.7-8.52c.65-3.51-7.56-7.82-18.35-9.62a55.7 55.7 0 0 0-9.56-.76c-6.9 0-12.9.89-16.52 2.23l-.05 9.82",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.39
  })), _path246 || (_path246 = /*#__PURE__*/react.createElement("path", {
    d: "M333.06 278.47c4.5-.32 7.59-1.53 7.94-3.41.28-1.5-1.25-3.17-3.97-4.68-1.22.14-2.59.3-4 .3l.03 7.79",
    fill: "#ad1519"
  })), _path247 || (_path247 = /*#__PURE__*/react.createElement("path", {
    d: "M333.06 278.47c4.5-.32 7.59-1.53 7.94-3.41.28-1.5-1.25-3.17-3.97-4.68-1.22.14-2.59.3-4 .3l.03 7.79",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path248 || (_path248 = /*#__PURE__*/react.createElement("path", {
    d: "M316.75 272.38c-2.82.43-4.93 1.13-5.99 1.99l-.1.17c-.5 1.03 1.98 3.22 6.11 5.67l-.02-7.83",
    fill: "#ad1519"
  })), _path249 || (_path249 = /*#__PURE__*/react.createElement("path", {
    d: "M316.75 272.38c-2.82.43-4.93 1.13-5.99 1.99l-.1.17c-.5 1.03 1.98 3.22 6.11 5.67l-.02-7.83",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path250 || (_path250 = /*#__PURE__*/react.createElement("path", {
    d: "M343.15 293.83c.43-1.28-3.96-3.86-10.17-6.14-2.84-1.01-5.19-2.07-8.1-3.35-8.62-3.82-15-8.2-14.2-9.8l.08-.16c-.46.38-1.17 8.24-1.17 8.24-.79 1.46 5.05 5.78 12.98 9.58 2.55 1.22 7.92 3.2 10.45 4.1 4.54 1.56 9.04 4.53 8.63 5.63l1.5-8.1",
    fill: "#ad1519"
  })), _path251 || (_path251 = /*#__PURE__*/react.createElement("path", {
    d: "M343.15 293.83c.43-1.28-3.96-3.86-10.17-6.14-2.84-1.01-5.19-2.07-8.1-3.35-8.62-3.82-15-8.2-14.2-9.8l.08-.16c-.46.38-1.17 8.24-1.17 8.24-.79 1.46 5.05 5.78 12.98 9.58 2.55 1.22 7.92 3.2 10.45 4.1 4.54 1.56 9.04 4.53 8.63 5.63l1.5-8.1z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.39
  })), _path252 || (_path252 = /*#__PURE__*/react.createElement("path", {
    d: "M310.3 264.98c.62-2.33 1.41-4.58 2.2-6.87a5.52 5.52 0 0 1-1.08.16 54.67 54.67 0 0 1-1.42 4.94c-.95-1.44-2-2.84-2.83-4.3-.34.07-.68.15-1.02.2-.34.05-.7.07-1.04.1a143.9 143.9 0 0 1 4.2 5.92c.16-.04.32-.1.5-.12.16-.02.33-.02.5-.03m6.18-6.82-.9.03c-.29 0-.59-.04-.88-.06l-.12 6.41 4.49.08c-.03-.13-.06-.27-.06-.41 0-.13.04-.27.07-.4-.8.05-1.68.1-2.71.08l.1-5.73m7.04 1.05c.72.06 1.41.19 2.1.31-.01-.13-.03-.27-.02-.4 0-.14.06-.27.1-.4l-6.07-.5c.01.13.03.27.02.4-.01.14-.06.27-.1.4a20.1 20.1 0 0 1 2.2.05l-.52 5.77c.3 0 .59 0 .88.03.3.02.6.07.88.11l.53-5.77m2.48 6.32c.3.05.6.09.89.15.28.06.57.15.85.23l.72-2.94.08.01.5 1.19.9 2.22c.35.06.7.1 1.04.18.36.08.7.18 1.04.28l-.31-.67c-.48-1-1-2-1.41-3.02 1.12.04 1.98-.36 2.2-1.26.15-.62-.1-1.11-.69-1.53-.43-.31-1.27-.48-1.82-.6l-2.44-.53-1.54 6.3m3.14-5.43c.7.16 1.59.27 1.59 1.07 0 .2-.03.35-.06.48-.23.94-.94 1.26-2.13.9l.6-2.45m8.42 7.34c-.05.7-.18 1.38-.31 2.1.3.15.6.28.9.45.3.16.57.34.86.52l.6-7.23a4.03 4.03 0 0 1-.78-.43l-6.38 4.05c.17.08.35.16.51.25l.47.28c.54-.45 1.1-.82 1.74-1.3l2.39 1.31zm-1.8-1.65 2.12-1.37-.25 2.4-1.88-1.03",
    fill: "#c8b100"
  })), _path253 || (_path253 = /*#__PURE__*/react.createElement("path", {
    d: "M225.2 200.45c0-1.14.97-2.06 2.17-2.06 1.19 0 2.16.92 2.16 2.06 0 1.13-.97 2.05-2.16 2.05-1.2 0-2.17-.92-2.17-2.05z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path254 || (_path254 = /*#__PURE__*/react.createElement("path", {
    d: "M249.65 182.72c6.64 0 12.56.99 16.4 2.51 2.21 1 5.17 1.73 8.41 2.17 2.47.33 4.81.4 6.85.24 2.73-.06 6.67.74 10.62 2.48 3.26 1.45 5.99 3.2 7.8 4.91l-1.57 1.4-.45 3.96-4.3 4.92-2.15 1.83-5.09 4.07-2.6.21-.79 2.25-32.91-3.86-33.02 3.86-.8-2.25-2.6-.21-5.08-4.07-2.15-1.83-4.3-4.92-.44-3.96-1.58-1.4a28.79 28.79 0 0 1 7.8-4.91c3.95-1.74 7.9-2.54 10.62-2.48 2.04.15 4.38.09 6.85-.24a31.2 31.2 0 0 0 8.4-2.17c3.86-1.52 9.44-2.5 16.08-2.5z",
    fill: "#ad1519",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path255 || (_path255 = /*#__PURE__*/react.createElement("path", {
    d: "M250.15 226.18c-12.26-.02-23.25-1.47-31.09-3.83a1.2 1.2 0 0 1-.84-1.25c0-.52.29-1 .84-1.17 7.84-2.36 18.83-3.81 31.1-3.83 12.26.02 23.23 1.47 31.08 3.83.55.17.84.65.83 1.17a1.2 1.2 0 0 1-.83 1.25c-7.85 2.36-18.82 3.81-31.09 3.83",
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path256 || (_path256 = /*#__PURE__*/react.createElement("path", {
    d: "M250.12 224.57c-11.06-.01-21.07-1.3-28.68-3.26 7.61-1.97 17.62-3.17 28.68-3.2 11.07.03 21.13 1.23 28.74 3.2-7.61 1.97-17.67 3.25-28.74 3.26",
    fill: "#ad1519"
  })), _path257 || (_path257 = /*#__PURE__*/react.createElement("path", {
    d: "M250.95 224.64v-6.57",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.09
  })), _path258 || (_path258 = /*#__PURE__*/react.createElement("path", {
    d: "M249.16 224.64v-6.57",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.14
  })), _path259 || (_path259 = /*#__PURE__*/react.createElement("path", {
    d: "M247.48 224.64v-6.57",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.18
  })), _path260 || (_path260 = /*#__PURE__*/react.createElement("path", {
    d: "M245.8 224.64v-6.57",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.23
  })), _path261 || (_path261 = /*#__PURE__*/react.createElement("path", {
    d: "M244.32 224.64v-6.57",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.28
  })), _path262 || (_path262 = /*#__PURE__*/react.createElement("path", {
    d: "m241.48 224.28-.03-5.97m1.38 6.05v-6.25",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.33
  })), _path263 || (_path263 = /*#__PURE__*/react.createElement("path", {
    d: "M238.87 224.01v-5.5m1.32 5.66-.04-5.86",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.37
  })), _path264 || (_path264 = /*#__PURE__*/react.createElement("path", {
    d: "M235.35 223.7v-4.84m1.15 4.92v-5.08m1.2 5.24v-5.28",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.42
  })), _path265 || (_path265 = /*#__PURE__*/react.createElement("path", {
    d: "M234.12 223.66v-4.68",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.46
  })), _path266 || (_path266 = /*#__PURE__*/react.createElement("path", {
    d: "M232.97 223.42v-4.36",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.51
  })), _path267 || (_path267 = /*#__PURE__*/react.createElement("path", {
    d: "M231.74 223.3v-4.05",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.56
  })), _path268 || (_path268 = /*#__PURE__*/react.createElement("path", {
    d: "m229.22 222.95-.04-3.22m1.33 3.38v-3.62",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.6
  })), _path269 || (_path269 = /*#__PURE__*/react.createElement("path", {
    d: "M227.93 222.68v-2.84",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.63
  })), _path270 || (_path270 = /*#__PURE__*/react.createElement("path", {
    d: "M226.74 222.45v-2.36",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.68
  })), _path271 || (_path271 = /*#__PURE__*/react.createElement("path", {
    d: "M225.45 222.13v-1.84",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.73
  })), _path272 || (_path272 = /*#__PURE__*/react.createElement("path", {
    d: "M224.12 221.98v-1.38",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.77
  })), _path273 || (_path273 = /*#__PURE__*/react.createElement("path", {
    d: "M222.72 221.66V221",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.91
  })), _path274 || (_path274 = /*#__PURE__*/react.createElement("path", {
    d: "M258.04 224.28v-6.01m-3.02 6.21.04-6.37m-2.24 6.45v-6.49",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path275 || (_path275 = /*#__PURE__*/react.createElement("path", {
    d: "M250.07 216.1c-12.41.02-23.55 1.57-31.4 3.99.66-.31.6-1.12-.21-3.2-.98-2.53-2.5-2.42-2.5-2.42 8.66-2.56 20.73-4.16 34.16-4.18 13.44.02 25.6 1.62 34.27 4.18 0 0-1.53-.1-2.5 2.42-.82 2.08-.88 2.89-.22 3.2-7.84-2.42-19.2-3.97-31.6-4",
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path276 || (_path276 = /*#__PURE__*/react.createElement("path", {
    d: "M250.12 210.3c-13.43.02-25.5 1.61-34.16 4.18-.58.17-1.2-.05-1.38-.6-.19-.55.12-1.18.7-1.35 8.7-2.68 21.09-4.35 34.84-4.38 13.77.03 26.2 1.7 34.9 4.38.58.17.89.8.7 1.35-.19.55-.8.77-1.38.6-8.67-2.56-20.78-4.16-34.22-4.19",
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path277 || (_path277 = /*#__PURE__*/react.createElement("path", {
    d: "M250.12 224.57c-11.06-.01-21.07-1.3-28.68-3.26 7.61-1.97 17.62-3.17 28.68-3.2 11.07.03 21.13 1.23 28.74 3.2-7.61 1.97-17.67 3.25-28.74 3.26z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.39
  })), _path278 || (_path278 = /*#__PURE__*/react.createElement("path", {
    d: "M240.54 213.35c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path279 || (_path279 = /*#__PURE__*/react.createElement("path", {
    d: "M250.15 214.16h-3.29c-.6 0-1.1-.46-1.1-1.03 0-.58.49-1.04 1.09-1.04h6.64c.6 0 1.1.46 1.1 1.04 0 .57-.5 1.03-1.11 1.03h-3.33",
    fill: "#ad1519",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path280 || (_path280 = /*#__PURE__*/react.createElement("path", {
    d: "m233.64 215.07-2.36.27c-.6.07-1.17-.33-1.24-.9-.08-.57.35-1.09.96-1.15l2.37-.28 2.42-.28c.6-.07 1.15.33 1.22.9.07.57-.36 1.09-.96 1.16l-2.41.28",
    fill: "#058e6e",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path281 || (_path281 = /*#__PURE__*/react.createElement("path", {
    d: "M224.03 215.28c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.03",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path282 || (_path282 = /*#__PURE__*/react.createElement("path", {
    d: "m216.72 217.16 1.22-1.6 3.37.44-2.7 1.96-1.89-.8",
    fill: "#ad1519",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path283 || (_path283 = /*#__PURE__*/react.createElement("path", {
    d: "m266.66 215.07 2.36.27c.6.07 1.17-.33 1.24-.9a1.05 1.05 0 0 0-.96-1.15l-2.37-.28-2.42-.28c-.6-.07-1.15.33-1.22.9-.08.57.36 1.09.96 1.16l2.41.28",
    fill: "#058e6e",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path284 || (_path284 = /*#__PURE__*/react.createElement("path", {
    d: "M257.56 213.35c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04m16.51 1.93c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.03",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path285 || (_path285 = /*#__PURE__*/react.createElement("path", {
    d: "m283.57 217.16-1.21-1.6-3.37.44 2.7 1.96 1.88-.8",
    fill: "#ad1519",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path286 || (_path286 = /*#__PURE__*/react.createElement("path", {
    d: "M220.12 221.66c7.75-2.17 18.3-3.52 30-3.54 11.71.02 22.31 1.37 30.06 3.54",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path287 || (_path287 = /*#__PURE__*/react.createElement("path", {
    d: "m225.34 191.42 1.38 1.11 2.09-3.4a7.7 7.7 0 0 1-3.75-7.42c.21-4.34 5.5-7.92 12.2-7.92 3.48 0 6.63.95 8.84 2.48.06-.67.12-1.25.21-1.86a18.11 18.11 0 0 0-9.05-2.28c-7.7 0-13.74 4.38-14.03 9.57a9.25 9.25 0 0 0 3.22 7.9l-1.11 1.82",
    fill: "#c8b100"
  })), _path288 || (_path288 = /*#__PURE__*/react.createElement("path", {
    d: "m225.34 191.42 1.38 1.11 2.09-3.4a7.7 7.7 0 0 1-3.75-7.42c.21-4.34 5.5-7.92 12.2-7.92 3.48 0 6.63.95 8.84 2.48.06-.67.12-1.25.21-1.86a18.11 18.11 0 0 0-9.05-2.28c-7.7 0-13.74 4.38-14.03 9.57a9.25 9.25 0 0 0 3.22 7.9l-1.11 1.82",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path289 || (_path289 = /*#__PURE__*/react.createElement("path", {
    d: "M225.43 191.46c-2.64-1.97-4.27-4.64-4.27-7.58 0-3.38 2.22-6.4 5.58-8.4a8.84 8.84 0 0 0-3.56 7.14 9.25 9.25 0 0 0 3.26 6.99l-1.01 1.85",
    fill: "#c8b100"
  })), _path290 || (_path290 = /*#__PURE__*/react.createElement("path", {
    d: "M225.43 191.46c-2.64-1.97-4.27-4.64-4.27-7.58 0-3.38 2.22-6.4 5.58-8.4a8.84 8.84 0 0 0-3.56 7.14 9.25 9.25 0 0 0 3.26 6.99l-1.01 1.85",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path291 || (_path291 = /*#__PURE__*/react.createElement("path", {
    d: "M202.2 194.89a9.16 9.16 0 0 1-2.37-6.12c0-1.4.32-2.75.91-3.95 2.13-4.38 8.81-7.57 16.76-7.57 2.16 0 4.23.23 6.14.67-.42.46-.75.97-1.08 1.48-1.59-.31-3.29-.48-5.06-.48-7.27 0-13.35 2.83-15.12 6.65a7.36 7.36 0 0 0-.73 3.2c0 2.32 1.09 4.4 2.8 5.82l-2.64 4.3-1.41-1.12 1.8-2.88",
    fill: "#c8b100"
  })), _path292 || (_path292 = /*#__PURE__*/react.createElement("path", {
    d: "M202.2 194.89a9.16 9.16 0 0 1-2.37-6.12c0-1.4.32-2.75.91-3.95 2.13-4.38 8.81-7.57 16.76-7.57 2.16 0 4.23.23 6.14.67-.42.46-.75.97-1.08 1.48-1.59-.31-3.29-.48-5.06-.48-7.27 0-13.35 2.83-15.12 6.65a7.36 7.36 0 0 0-.73 3.2c0 2.32 1.09 4.4 2.8 5.82l-2.64 4.3-1.41-1.12 1.8-2.88z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path293 || (_path293 = /*#__PURE__*/react.createElement("path", {
    d: "M204.9 180.48a10.98 10.98 0 0 0-4.16 4.34 8.95 8.95 0 0 0-.91 3.95c0 2.33.9 4.47 2.38 6.12l-1.6 2.6a10.87 10.87 0 0 1-2.42-6.7c0-4.2 2.67-7.88 6.71-10.3",
    fill: "#c8b100"
  })), _path294 || (_path294 = /*#__PURE__*/react.createElement("path", {
    d: "M204.9 180.48a10.98 10.98 0 0 0-4.16 4.34 8.95 8.95 0 0 0-.91 3.95c0 2.33.9 4.47 2.38 6.12l-1.6 2.6a10.87 10.87 0 0 1-2.42-6.7c0-4.2 2.67-7.88 6.71-10.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path295 || (_path295 = /*#__PURE__*/react.createElement("path", {
    d: "M250.04 171.27a3.69 3.69 0 0 1 3.64 2.72c.23 1.39.38 2.96.41 4.63l-.01.52c0 .2.04.41.05.61.06 3.52.56 6.62 1.27 8.52l-5.36 5.14-5.43-5.14c.72-1.9 1.22-5 1.28-8.52 0-.2.05-.41.05-.61l-.01-.51c.03-1.68.18-3.25.41-4.63.36-1.57 1.94-2.73 3.7-2.73",
    fill: "#c8b100"
  })), _path296 || (_path296 = /*#__PURE__*/react.createElement("path", {
    d: "M250.04 171.27a3.69 3.69 0 0 1 3.64 2.72c.23 1.39.38 2.96.41 4.63l-.01.52c0 .2.04.41.05.61.06 3.52.56 6.62 1.27 8.52l-5.36 5.14-5.43-5.14c.72-1.9 1.22-5 1.28-8.52 0-.2.05-.41.05-.61l-.01-.51c.03-1.68.18-3.25.41-4.63.36-1.57 1.94-2.73 3.7-2.73z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path297 || (_path297 = /*#__PURE__*/react.createElement("path", {
    d: "M250.04 172.94c.91 0 1.69.58 1.87 1.4a30 30 0 0 1 .4 4.37l-.01.48c0 .2.03.4.04.6.05 3.31.53 6.24 1.21 8.04l-3.54 3.35-3.54-3.35c.68-1.8 1.15-4.73 1.21-8.05 0-.2.04-.4.04-.59v-.48c.02-1.58.16-3.07.39-4.38.18-.8 1.02-1.39 1.93-1.39",
    fill: "#c8b100"
  })), _path298 || (_path298 = /*#__PURE__*/react.createElement("path", {
    d: "M250.04 172.94c.91 0 1.69.58 1.87 1.4a30 30 0 0 1 .4 4.37l-.01.48c0 .2.03.4.04.6.05 3.31.53 6.24 1.21 8.04l-3.54 3.35-3.54-3.35c.68-1.8 1.15-4.73 1.21-8.05 0-.2.04-.4.04-.59v-.48c.02-1.58.16-3.07.39-4.38.18-.8 1.02-1.39 1.93-1.39z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path299 || (_path299 = /*#__PURE__*/react.createElement("path", {
    d: "m274.7 191.42-1.39 1.11-2.08-3.4a7.71 7.71 0 0 0 3.75-7.42c-.21-4.34-5.5-7.92-12.2-7.92-3.5 0-6.63.95-8.84 2.48-.06-.67-.12-1.25-.22-1.86a18.12 18.12 0 0 1 9.06-2.28c7.7 0 13.74 4.38 14.03 9.57a9.24 9.24 0 0 1-3.22 7.9l1.11 1.82",
    fill: "#c8b100"
  })), _path300 || (_path300 = /*#__PURE__*/react.createElement("path", {
    d: "m274.7 191.42-1.39 1.11-2.08-3.4a7.71 7.71 0 0 0 3.75-7.42c-.21-4.34-5.5-7.92-12.2-7.92-3.5 0-6.63.95-8.84 2.48-.06-.67-.12-1.25-.22-1.86a18.12 18.12 0 0 1 9.06-2.28c7.7 0 13.74 4.38 14.03 9.57a9.24 9.24 0 0 1-3.22 7.9l1.11 1.82",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path301 || (_path301 = /*#__PURE__*/react.createElement("path", {
    d: "M274.61 191.46c2.63-1.97 4.27-4.64 4.27-7.58 0-3.38-2.22-6.4-5.58-8.4a8.87 8.87 0 0 1 3.56 7.14 9.24 9.24 0 0 1-3.27 6.99l1.02 1.85",
    fill: "#c8b100"
  })), _path302 || (_path302 = /*#__PURE__*/react.createElement("path", {
    d: "M274.61 191.46c2.63-1.97 4.27-4.64 4.27-7.58 0-3.38-2.22-6.4-5.58-8.4a8.87 8.87 0 0 1 3.56 7.14 9.24 9.24 0 0 1-3.27 6.99l1.02 1.85",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path303 || (_path303 = /*#__PURE__*/react.createElement("path", {
    d: "M297.83 194.89a9.02 9.02 0 0 0 1.46-10.07c-2.13-4.38-8.8-7.57-16.75-7.57-2.17 0-4.23.23-6.15.67.43.46.76.97 1.09 1.48 1.58-.31 3.29-.48 5.06-.48 7.27 0 13.35 2.83 15.11 6.65.47.97.73 2.06.73 3.2 0 2.32-1.09 4.4-2.79 5.82l2.63 4.3 1.42-1.12-1.8-2.88",
    fill: "#c8b100"
  })), _path304 || (_path304 = /*#__PURE__*/react.createElement("path", {
    d: "M297.83 194.89a9.02 9.02 0 0 0 1.46-10.07c-2.13-4.38-8.8-7.57-16.75-7.57-2.17 0-4.23.23-6.15.67.43.46.76.97 1.09 1.48 1.58-.31 3.29-.48 5.06-.48 7.27 0 13.35 2.83 15.11 6.65.47.97.73 2.06.73 3.2 0 2.32-1.09 4.4-2.79 5.82l2.63 4.3 1.42-1.12-1.8-2.88z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path305 || (_path305 = /*#__PURE__*/react.createElement("path", {
    d: "M295.13 180.48a11.02 11.02 0 0 1 4.17 4.34 9.06 9.06 0 0 1-1.47 10.07l1.6 2.6a10.86 10.86 0 0 0 2.41-6.7c0-4.2-2.67-7.88-6.7-10.3",
    fill: "#c8b100"
  })), _path306 || (_path306 = /*#__PURE__*/react.createElement("path", {
    d: "M295.13 180.48a11.02 11.02 0 0 1 4.17 4.34 9.06 9.06 0 0 1-1.47 10.07l1.6 2.6a10.86 10.86 0 0 0 2.41-6.7c0-4.2-2.67-7.88-6.7-10.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path307 || (_path307 = /*#__PURE__*/react.createElement("path", {
    d: "M248.13 188.93c0-1 .86-1.8 1.9-1.8 1.06 0 1.91.8 1.91 1.8s-.85 1.8-1.9 1.8c-1.05 0-1.9-.8-1.9-1.8",
    fill: "#fff"
  })), _path308 || (_path308 = /*#__PURE__*/react.createElement("path", {
    d: "M248.13 188.93c0-1 .86-1.8 1.9-1.8 1.06 0 1.91.8 1.91 1.8s-.85 1.8-1.9 1.8c-1.05 0-1.9-.8-1.9-1.8z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path309 || (_path309 = /*#__PURE__*/react.createElement("path", {
    d: "M248.13 185.4c0-1 .86-1.8 1.9-1.8 1.06 0 1.91.8 1.91 1.8s-.85 1.8-1.9 1.8c-1.05 0-1.9-.8-1.9-1.8m.37-3.8c0-.8.69-1.44 1.53-1.44.83 0 1.51.64 1.51 1.44 0 .8-.68 1.44-1.51 1.44-.84 0-1.53-.64-1.53-1.44m.43-3.43c0-.57.5-1.03 1.1-1.03.6 0 1.09.46 1.09 1.03 0 .58-.49 1.05-1.1 1.05-.6 0-1.09-.47-1.09-1.05m.22-2.99c0-.47.39-.83.88-.83.48 0 .87.37.87.83 0 .45-.4.83-.87.83a.86.86 0 0 1-.88-.83",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path310 || (_path310 = /*#__PURE__*/react.createElement("path", {
    d: "m250.2 199.78 1.23.22a4.8 4.8 0 0 0 4.68 6.28 4.9 4.9 0 0 0 4.68-3.21c.07.05.46-1.68.67-1.66.17.02.15 1.8.22 1.77.31 2.34 2.46 3.93 4.87 3.93a4.78 4.78 0 0 0 4.87-5.22l1.54-1.52.83 1.94c-.33.61-.46 1.3-.46 2.03 0 2.46 2.1 4.44 4.7 4.44 1.62 0 3.05-.78 3.9-1.97l.98-1.25v1.53c0 1.55.65 2.93 2.15 3.18 0 0 1.73.1 4.03-1.7 2.3-1.8 3.56-3.29 3.56-3.29l.2 1.8s-1.91 2.95-3.98 4.15c-1.14.66-2.86 1.35-4.23 1.13-1.44-.24-2.47-1.4-3-2.74a7 7 0 0 1-3.56.97c-2.8 0-5.33-1.54-6.32-3.86a7.28 7.28 0 0 1-10.77-.3 7.22 7.22 0 0 1-4.88 1.86 7.2 7.2 0 0 1-5.94-3.05 7.19 7.19 0 0 1-5.94 3.05c-1.89 0-3.61-.71-4.87-1.86a7.27 7.27 0 0 1-10.77.3c-1 2.32-3.52 3.86-6.32 3.86-1.3 0-2.52-.36-3.55-.97-.54 1.34-1.57 2.5-3.01 2.74-1.37.22-3.1-.47-4.23-1.13-2.07-1.2-3.98-4.14-3.98-4.14l.2-1.8s1.27 1.48 3.56 3.28c2.3 1.8 4.02 1.7 4.02 1.7 1.5-.25 2.16-1.63 2.16-3.18v-1.53l.98 1.25a4.76 4.76 0 0 0 3.9 1.97c2.6 0 4.7-1.98 4.7-4.44 0-.73-.14-1.42-.47-2.03l.83-1.94 1.54 1.52-.03.57c0 2.57 2.19 4.65 4.9 4.65 2.42 0 4.56-1.59 4.88-3.93.06.03.05-1.75.22-1.77.2-.02.6 1.7.67 1.66a4.9 4.9 0 0 0 4.68 3.21 4.79 4.79 0 0 0 4.67-6.28l1.29-.22",
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path311 || (_path311 = /*#__PURE__*/react.createElement("path", {
    d: "M283.96 205.91c.28-.83.03-1.66-.57-1.84-.6-.18-1.32.34-1.6 1.17-.3.83-.04 1.65.56 1.84.6.18 1.32-.34 1.6-1.17m-21.37-4.14c.11-.87-.3-1.63-.93-1.7-.63-.07-1.22.57-1.34 1.44-.11.86.3 1.63.93 1.7.63.07 1.23-.57 1.34-1.44m-24.82 0c-.1-.87.31-1.63.93-1.7.63-.07 1.23.57 1.34 1.44.11.86-.3 1.63-.93 1.7-.63.07-1.22-.57-1.34-1.44m-21.36 4.14c-.3-.83-.04-1.66.56-1.84.6-.18 1.32.34 1.6 1.17.28.83.03 1.65-.57 1.84-.6.18-1.31-.34-1.6-1.17",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path312 || (_path312 = /*#__PURE__*/react.createElement("path", {
    d: "M225.68 191.65a5.34 5.34 0 0 1 2.3 3.03s.13-.25.71-.6c.6-.32 1.09-.31 1.09-.31s-.17.97-.25 1.32c-.09.34-.1 1.38-.32 2.32a7.72 7.72 0 0 1-.63 1.68 1.98 1.98 0 0 0-1.58-.41 1.9 1.9 0 0 0-1.32.9s-.66-.58-1.2-1.38c-.56-.8-.94-1.78-1.14-2.08-.21-.3-.72-1.15-.72-1.15s.47-.18 1.14-.05c.67.12.88.32.88.32a5.1 5.1 0 0 1 1.04-3.59",
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path313 || (_path313 = /*#__PURE__*/react.createElement("path", {
    d: "M226.13 201.86c-.34-.27-.6-.64-.68-1.08a1.7 1.7 0 0 1 .23-1.23s-.88-.44-1.83-.7c-.72-.18-1.99-.19-2.37-.2l-1.15-.02s.07.17.28.55c.26.46.5.75.5.75a5.25 5.25 0 0 0-3.03 2.09c.99.68 2.3 1.1 3.6.97 0 0-.12.34-.2.86-.06.43-.06.61-.06.61l1.07-.4c.35-.12 1.54-.54 2.15-.95.8-.54 1.49-1.25 1.49-1.25m2.84-.48a1.72 1.72 0 0 0-.42-2.3s.67-.71 1.47-1.26c.6-.4 1.8-.82 2.15-.95l1.07-.4s0 .18-.06.61c-.08.52-.2.87-.2.87 1.3-.14 2.62.3 3.6.98a5.27 5.27 0 0 1-3.03 2.08 6.82 6.82 0 0 0 .78 1.3l-1.15-.03c-.38 0-1.65 0-2.37-.2-.95-.25-1.84-.7-1.84-.7",
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path314 || (_path314 = /*#__PURE__*/react.createElement("path", {
    d: "M225.2 200.45c0-1.14.97-2.06 2.17-2.06 1.19 0 2.16.92 2.16 2.06 0 1.13-.97 2.05-2.16 2.05-1.2 0-2.17-.92-2.17-2.05",
    fill: "#ad1519",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path315 || (_path315 = /*#__PURE__*/react.createElement("path", {
    d: "M250.11 188.37a5.91 5.91 0 0 1 1.95 3.8s.19-.26.91-.52 1.28-.16 1.28-.16-.39 1.05-.56 1.42c-.16.37-.38 1.53-.83 2.53a8.58 8.58 0 0 1-1.05 1.76c-.4-.45-1-.75-1.67-.75-.67 0-1.27.3-1.67.75 0 0-.61-.76-1.06-1.76-.44-1-.66-2.16-.83-2.53-.17-.37-.56-1.42-.56-1.42s.56-.1 1.28.16.92.53.92.53c.1-1.46.86-2.87 1.9-3.81",
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path316 || (_path316 = /*#__PURE__*/react.createElement("path", {
    d: "M248.5 199.83a1.96 1.96 0 0 1-.01-2.65s-.9-.67-1.9-1.12c-.77-.35-2.18-.59-2.6-.67l-1.28-.24s.04.2.2.67c.2.56.4.93.4.93a6.1 6.1 0 0 0-3.81 1.76 6.17 6.17 0 0 0 3.8 1.75s-.19.36-.39.93c-.16.46-.2.66-.2.66l1.28-.23c.42-.09 1.83-.32 2.6-.67 1-.46 1.9-1.11 1.9-1.11m3.27-.01a1.95 1.95 0 0 0 .01-2.65s.9-.67 1.9-1.12c.77-.35 2.18-.59 2.6-.67l1.28-.24s-.03.2-.2.67c-.2.56-.4.93-.4.93 1.47.08 2.86.81 3.81 1.76a6.15 6.15 0 0 1-3.8 1.75 7.05 7.05 0 0 0 .59 1.6l-1.27-.24c-.43-.09-1.84-.32-2.6-.67-1-.46-1.92-1.11-1.92-1.11m22.91-8.19a5.36 5.36 0 0 0-2.3 3.03s-.13-.25-.72-.6c-.58-.32-1.09-.31-1.09-.31s.17.97.26 1.32c.09.34.09 1.38.31 2.32.23.93.64 1.68.64 1.68.42-.34.99-.5 1.57-.41.59.1 1.06.44 1.33.9 0 0 .66-.58 1.2-1.38.55-.8.93-1.78 1.13-2.08.21-.3.72-1.15.72-1.15s-.47-.18-1.14-.05c-.67.12-.88.32-.88.32a5.06 5.06 0 0 0-1.03-3.59",
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path317 || (_path317 = /*#__PURE__*/react.createElement("path", {
    d: "M274.22 201.86c.34-.27.6-.64.67-1.08.09-.44 0-.87-.22-1.23 0 0 .88-.44 1.82-.7.73-.18 2-.19 2.37-.2l1.15-.02s-.06.17-.28.55c-.26.46-.5.75-.5.75a5.26 5.26 0 0 1 3.04 2.09 5.5 5.5 0 0 1-3.6.97s.11.34.2.86c.06.43.05.61.05.61l-1.06-.4c-.36-.12-1.55-.54-2.16-.95-.8-.54-1.48-1.25-1.48-1.25m-2.84-.48a1.74 1.74 0 0 1-.25-1.23c.09-.44.33-.8.67-1.08 0 0-.67-.7-1.47-1.25-.61-.4-1.8-.82-2.16-.95l-1.06-.4s0 .18.06.61c.08.52.2.87.2.87-1.3-.14-2.62.3-3.6.98a5.27 5.27 0 0 0 3.02 2.08s-.23.28-.49.74c-.22.39-.28.56-.28.56l1.14-.03c.38 0 1.66 0 2.37-.2.95-.25 1.84-.7 1.84-.7",
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path318 || (_path318 = /*#__PURE__*/react.createElement("path", {
    d: "M270.81 200.45c0-1.14.97-2.06 2.17-2.06s2.17.92 2.17 2.06c0 1.13-.97 2.05-2.17 2.05s-2.17-.92-2.17-2.05m24.24 4.55c-.5-.53-1.57-.42-2.36.26-.79.67-1.02 1.66-.5 2.2.5.53 1.56.41 2.35-.26.8-.67 1.02-1.66.51-2.2",
    fill: "#ad1519",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path319 || (_path319 = /*#__PURE__*/react.createElement("path", {
    d: "M291.97 206.31c.11-.36.36-.74.72-1.05.8-.68 1.85-.8 2.36-.25.06.07.14.17.18.25 0 0 1.1-2.08 2.4-2.78 1.3-.7 3.5-.52 3.5-.52 0-1.6-1.3-2.89-3-2.89-.99 0-1.92.41-2.48 1.1l-.22-1.06s-1.36.27-1.98 1.82c-.62 1.55.05 3.8.05 3.8s-.33-.96-.84-1.6a8.33 8.33 0 0 0-2.49-1.66 11.2 11.2 0 0 1-1.37-.8s-.03.18-.06.6c-.02.52.02.84.02.84a8.21 8.21 0 0 0-3.83.48c.48.95 1.4 1.84 2.61 2.3 0 0-.43.36-.83.75-.33.34-.44.5-.44.5l1.28.18c.43.05 1.84.28 2.68.22.63-.04 1.32-.14 1.74-.22m-83.6-.01c-.1-.36-.35-.74-.72-1.05-.79-.68-1.84-.8-2.36-.25a1.1 1.1 0 0 0-.17.25s-1.1-2.08-2.4-2.78c-1.3-.7-3.5-.52-3.5-.52 0-1.6 1.3-2.89 2.99-2.89 1 0 1.92.41 2.48 1.1l.23-1.06s1.36.27 1.98 1.82c.62 1.55-.06 3.8-.06 3.8s.34-.96.85-1.6a8.36 8.36 0 0 1 2.49-1.66c.67-.32 1.37-.8 1.37-.8a8.21 8.21 0 0 0 .04 1.44c1.24-.17 2.7.04 3.83.48a4.92 4.92 0 0 1-2.62 2.3s.44.36.83.75c.34.34.44.5.44.5l-1.27.18c-.43.05-1.84.28-2.69.22-.62-.04-1.32-.14-1.74-.22",
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path320 || (_path320 = /*#__PURE__*/react.createElement("path", {
    d: "M205.3 205c.5-.53 1.56-.42 2.35.26.8.67 1.02 1.66.51 2.2-.5.53-1.57.41-2.36-.26-.79-.67-1.02-1.66-.5-2.2m42.67-6.5c0-1.13.97-2.05 2.17-2.05s2.17.92 2.17 2.05c0 1.14-.97 2.06-2.17 2.06s-2.17-.92-2.17-2.06",
    fill: "#ad1519",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path321 || (_path321 = /*#__PURE__*/react.createElement("path", {
    d: "M245.63 167.3c0-2.32 1.98-4.2 4.42-4.2a4.32 4.32 0 0 1 4.43 4.2 4.31 4.31 0 0 1-4.43 4.2 4.32 4.32 0 0 1-4.43-4.2",
    fill: "#005bbf",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path322 || (_path322 = /*#__PURE__*/react.createElement("path", {
    d: "M248.9 155.54v2.26h-2.43v2.3h2.42v6.6h-3.05c-.03.21-.22.37-.22.6 0 .57.12 1.13.35 1.63 0 .02.02.02.03.03h8.12l.03-.03a4 4 0 0 0 .34-1.63c0-.23-.18-.39-.22-.6h-2.95v-6.61h2.42v-2.3h-2.42v-2.26h-2.43z",
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path323 || (_path323 = /*#__PURE__*/react.createElement("path", {
    d: "M250.5 344.33a85.31 85.31 0 0 1-36.96-8.54 23.65 23.65 0 0 1-13.36-21.19v-33.3h100.43v33.3c0 9.19-5.33 17.21-13.37 21.2a84.42 84.42 0 0 1-36.75 8.53",
    fill: "#ccc"
  })), _path324 || (_path324 = /*#__PURE__*/react.createElement("path", {
    d: "M250.5 344.33a85.31 85.31 0 0 1-36.96-8.54 23.65 23.65 0 0 1-13.36-21.19v-33.3h100.43v33.3c0 9.19-5.33 17.21-13.37 21.2a84.42 84.42 0 0 1-36.75 8.53z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.52
  })), _path325 || (_path325 = /*#__PURE__*/react.createElement("path", {
    d: "M250.28 281.25h50.32v-55.72h-50.32v55.72z",
    fill: "#ccc"
  })), _path326 || (_path326 = /*#__PURE__*/react.createElement("path", {
    d: "M250.28 281.25h50.32v-55.72h-50.32v55.72z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.52
  })), _path327 || (_path327 = /*#__PURE__*/react.createElement("path", {
    d: "M250.32 314.57c0 13.16-11.16 23.82-25.05 23.82-13.9 0-25.16-10.66-25.16-23.82V281.2h50.2v33.36",
    fill: "#ad1519"
  })), _path328 || (_path328 = /*#__PURE__*/react.createElement("path", {
    d: "M211.08 334.23c1.57.83 3.72 2.22 6.03 2.77l-.15-56.96h-5.88v54.19z",
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.52
  })), _path329 || (_path329 = /*#__PURE__*/react.createElement("path", {
    d: "M200.03 314.12a25.4 25.4 0 0 0 5.73 15.67v-49.47h-5.66l-.07 33.8z",
    fill: "#c8b100",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _path330 || (_path330 = /*#__PURE__*/react.createElement("path", {
    d: "M222.28 338.25c2.3.23 4.01.19 5.87 0v-58.21h-5.88v58.21z",
    fill: "#c7b500",
    stroke: "#000",
    strokeWidth: 0.52
  })), _path331 || (_path331 = /*#__PURE__*/react.createElement("path", {
    d: "M233.32 337c2.3-.46 4.9-1.9 6.03-2.63v-54.33h-5.88l-.15 56.96z",
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.52
  })), _path332 || (_path332 = /*#__PURE__*/react.createElement("path", {
    d: "M200.12 281.25h50.18v-55.72h-50.18v55.72z",
    fill: "#ad1519"
  })), _path333 || (_path333 = /*#__PURE__*/react.createElement("path", {
    d: "M200.12 281.25h50.18v-55.72h-50.18v55.72z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.52
  })), _path334 || (_path334 = /*#__PURE__*/react.createElement("path", {
    d: "M244.81 329.24c2.45-2.18 4.75-7.13 5.59-12.76l.14-36.44h-5.87l.14 49.2z",
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.52
  })), _path335 || (_path335 = /*#__PURE__*/react.createElement("path", {
    d: "M250.32 314.57c0 13.16-11.16 23.82-25.05 23.82-13.9 0-25.16-10.66-25.16-23.82V281.2h50.2v33.36",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.52
  })), _path336 || (_path336 = /*#__PURE__*/react.createElement("path", {
    d: "M300.65 281.21v33.36c0 13.16-11.28 23.82-25.17 23.82-13.9 0-25.16-10.66-25.16-23.82V281.2h50.33",
    fill: "#ad1519"
  })), _path337 || (_path337 = /*#__PURE__*/react.createElement("path", {
    d: "M300.65 281.21v33.36c0 13.16-11.28 23.82-25.17 23.82-13.9 0-25.16-10.66-25.16-23.82V281.2h50.33",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.52
  })), _path338 || (_path338 = /*#__PURE__*/react.createElement("path", {
    d: "M259.47 306.39c.08.17.13.34.13.52 0 .61-.52 1.1-1.17 1.1-.65 0-1.17-.49-1.17-1.1 0-.18.04-.35.12-.5l-1.63-.02a2.6 2.6 0 0 0 1.85 2.99v4.01l1.71.01v-4.04c.8-.26 1.43-.86 1.7-1.62h4.6v-1.35h-6.14m22.58 0v1.35l-4.14.01c-.06.19-.16.35-.26.51l4.8 5.46-1.29 1.05-4.78-5.47-.23.09v9.04h-1.7v-9.08a.61.61 0 0 1-.2-.09l-4.98 5.5-1.3-1.04 4.98-5.52c-.08-.14-.15-.3-.2-.46h-4.28v-1.35h13.59zm2.76 0v1.35h4.6c.28.76.9 1.36 1.7 1.62v4.04h1.71v-4.02a2.6 2.6 0 0 0 1.91-2.47c0-.18-.02-.36-.06-.52h-1.63c.08.17.12.34.12.52 0 .61-.52 1.1-1.16 1.1-.65 0-1.17-.49-1.17-1.1 0-.18.04-.35.12-.5l-6.14-.02m-6.96 23.04c1.34-.21 2.58-.58 3.8-1.1l.85 1.43c-1.41.6-2.93 1.04-4.5 1.28a2.7 2.7 0 0 1-2.67 2.04 2.7 2.7 0 0 1-2.67-2.02 18.23 18.23 0 0 1-4.73-1.3l.84-1.43c1.29.55 2.66.9 4.08 1.1a2.6 2.6 0 0 1 1.58-1.38l.01-7.01h1.7l.01 6.98c.75.22 1.38.74 1.7 1.4zm-11.5-2.35-.83 1.44a17.35 17.35 0 0 1-3.8-3.22c-.86.26-1.85.1-2.59-.5a2.49 2.49 0 0 1-.3-3.64l.14-.16a15.9 15.9 0 0 1-1.32-5h1.71c.13 1.51.51 2.94 1.1 4.28.48-.06.99 0 1.45.16l4.28-4.73 1.29 1.04-4.25 4.73c.57.87.55 2-.1 2.85a15.8 15.8 0 0 0 3.23 2.75zm-6.33-4.96a1.21 1.21 0 0 1 1.65-.13c.49.4.55 1.1.13 1.56-.42.47-1.16.52-1.65.13-.5-.4-.55-1.1-.13-1.56zm-2.16-4.69-1.76-.39-.25-4.45 1.75-.58v2.56c0 .99.09 1.92.26 2.86zm1.46-5.52 1.75.41s.09 2.87.05 2.22c-.04-.75.2 2.24.2 2.24l-1.77.58c-.18-.9-.24-1.84-.24-2.8v-2.65zm5.77 14.25a16.32 16.32 0 0 0 5.04 2.68l.4-1.7a14.27 14.27 0 0 1-4.18-2.1l-1.26 1.12m-.84 1.46c1.5 1.13 3.2 2.03 5.04 2.65l-1.31 1.23a19.49 19.49 0 0 1-4.12-2.11l.38-1.77m2.29-9.81 1.67.7 3.06-3.39-1-1.44-3.73 4.13m-1.3-1.05-1-1.45 3.06-3.4 1.67.72-3.73 4.13m18.84 10.32.83 1.44a17.4 17.4 0 0 0 3.8-3.22c.87.26 1.85.1 2.6-.5a2.5 2.5 0 0 0 .3-3.64l-.15-.16c.7-1.56 1.17-3.24 1.32-5h-1.7c-.14 1.51-.52 2.94-1.1 4.28-.48-.06-1 0-1.46.16l-4.27-4.73-1.3 1.04 4.26 4.73c-.57.87-.55 2 .1 2.85a15.71 15.71 0 0 1-3.23 2.75zm6.34-4.96a1.2 1.2 0 0 0-1.65-.13c-.5.4-.55 1.1-.13 1.56.42.47 1.16.52 1.65.13.5-.4.55-1.1.13-1.56zm2.15-4.69 1.76-.39.25-4.45-1.74-.58v2.56c0 .99-.1 1.92-.27 2.86zm-1.45-5.52-1.75.41s-.1 2.87-.06 2.22c.05-.75-.2 2.24-.2 2.24l1.77.58c.18-.9.24-1.84.24-2.8v-2.65m-5.78 14.25a16.38 16.38 0 0 1-5.04 2.68l-.39-1.7a14.24 14.24 0 0 0 4.17-2.1l1.26 1.12m.85 1.46a18.18 18.18 0 0 1-5.04 2.65l1.31 1.23a19.5 19.5 0 0 0 4.12-2.11l-.39-1.77m-2.28-9.81-1.67.7-3.06-3.39 1-1.44 3.73 4.13m1.3-1.05 1-1.45-3.06-3.4-1.67.72 3.72 4.13m-20.94-9.01.51 1.67h4.72l.5-1.67h-5.73m22.02 0-.52 1.67h-4.71l-.5-1.67h5.73m-12.11 22.75c0-.62.52-1.12 1.17-1.12.64 0 1.17.5 1.17 1.12 0 .6-.53 1.1-1.17 1.1-.65 0-1.17-.5-1.17-1.1zm1.98-8.08 1.76-.5v-4.45l-1.76-.48v5.43m-1.7 0-1.76-.5v-4.45l1.76-.48v5.43",
    fill: "#c8b100"
  })), _path339 || (_path339 = /*#__PURE__*/react.createElement("path", {
    d: "M255.75 306.43c.2-.93.93-1.69 1.86-1.97l-.01-5.5h1.7v5.53c.84.26 1.48.88 1.74 1.68h4.57v.26h-6.14a1.2 1.2 0 0 0-2.09.02l-1.63-.02m12.71 0v-.25h4.25c.05-.14.11-.28.19-.4l-5.25-5.85 1.3-1.04 5.17 5.75.27-.12.01-7.66h1.7v7.61l.26.07 5.06-5.76 1.3 1.03-5.08 5.74c.13.19.22.4.3.63h4.1v.25h-13.58zm22.5 0a1.2 1.2 0 0 1 1.04-.6c.45 0 .85.26 1.04.62l1.63-.02a2.68 2.68 0 0 0-1.86-1.97l.01-5.5h-1.7v5.54c-.83.26-1.48.87-1.73 1.67h-4.58v.26h6.14m-31.38-15.54 6.3 7.07 1.3-1.05-6.34-7.04c.12-.19.21-.4.29-.62h4.61v-1.6h-4.61a2.72 2.72 0 0 0-2.61-1.8 2.67 2.67 0 0 0-2.73 2.6c0 1.13.76 2.1 1.84 2.45l-.01 5.45h1.69v-5.42l.27-.04zm33.27.03-.01 5.43h-1.7v-5.45c-.13-.04-.26-.1-.38-.15l-6.27 7.07-1.3-1.03 6.4-7.21c-.06-.1-.12-.21-.15-.33h-4.64v-1.6h4.62a2.71 2.71 0 0 1 2.6-1.8c1.5 0 2.73 1.17 2.73 2.6a2.6 2.6 0 0 1-1.9 2.47zm-16.73-.02-.01 3.35h-1.7v-3.32a2.68 2.68 0 0 1-1.78-1.68h-4.13v-1.6h4.13a2.7 2.7 0 0 1 2.6-1.8c1.2 0 2.23.75 2.6 1.8h4.21v1.6h-4.23a2.63 2.63 0 0 1-1.69 1.65zm-18.49 4.06-1.76.5v4.46l1.76.49v-5.45m1.7 0 1.76.5v4.46l-1.75.49v-5.45m31.78 0-1.75.5v4.46l1.75.49v-5.45m1.71 0 1.76.5v4.46l-1.76.49v-5.45m-26.61.88 1.67-.7 3.06 3.4-1 1.44-3.73-4.14m-1.3 1.06-1 1.45 3.06 3.4 1.67-.72-3.73-4.13m19.22-1.19-1.68-.7-3.03 3.43 1.02 1.44 3.69-4.17m1.3 1.04 1.02 1.45-3.03 3.42-1.68-.7 3.7-4.17m-21.19 9.43.51-1.67h4.72l.5 1.67h-5.73m-6.91-17.73c0-.61.52-1.11 1.17-1.11.64 0 1.17.5 1.17 1.11 0 .61-.53 1.1-1.17 1.1-.65 0-1.17-.49-1.17-1.1zm12.6.8-.51 1.68h-4.71l-.51-1.67h5.74m0-1.62-.52-1.67h-4.71l-.51 1.67h5.74m16.32 18.54-.52-1.67h-4.71l-.5 1.67h5.73m4.57-17.73c0-.61.52-1.11 1.17-1.11.64 0 1.16.5 1.16 1.11 0 .61-.52 1.1-1.16 1.1-.65 0-1.17-.49-1.17-1.1zm-16.8 0c0-.61.53-1.11 1.17-1.11.65 0 1.17.5 1.17 1.11 0 .61-.52 1.1-1.17 1.1-.64 0-1.17-.49-1.17-1.1zm6.53.8.52 1.68h4.7l.52-1.67h-5.74m0-1.62.52-1.67h4.7l.52 1.67h-5.74m-6.15 5.22-1.76.5v4.46l1.76.49v-5.45m1.69 0 1.75.5v4.46l-1.75.49v-5.45",
    fill: "#c8b100"
  })), _path340 || (_path340 = /*#__PURE__*/react.createElement("path", {
    d: "M277.85 329.43c1.34-.21 2.58-.58 3.8-1.1l.85 1.43c-1.41.6-2.93 1.04-4.5 1.28a2.7 2.7 0 0 1-2.67 2.04 2.7 2.7 0 0 1-2.67-2.02 18.23 18.23 0 0 1-4.73-1.3l.84-1.43c1.29.55 2.66.9 4.08 1.1a2.6 2.6 0 0 1 1.58-1.38l.01-7.01h1.7l.01 6.98c.75.22 1.38.74 1.7 1.4zm-4.9-21.23c-.09-.14-.15-.3-.2-.46h-4.29v-1.6h4.25c.05-.14.12-.27.19-.4l-5.25-5.83 1.3-1.05 5.17 5.74.28-.12v-7.64h1.7v7.6c.07.02.19.04.26.07l5.06-5.75 1.3 1.03-5.08 5.72c.13.19.22.4.3.63h4.1v1.6l-4.13.01c-.06.19-.17.35-.26.51l4.8 5.47-1.29 1.04-4.78-5.47c-.09.03-.13.07-.23.1l-.01 9.03h-1.7v-9.08a.882.882 0 0 1-.2-.09l-4.98 5.51-1.29-1.04 4.98-5.53m-13.38-17.32 6.3 7.05 1.3-1.04-6.34-7.03c.12-.19.21-.4.29-.61h4.61v-1.6h-4.61a2.72 2.72 0 0 0-2.61-1.8 2.66 2.66 0 0 0-2.73 2.6c0 1.12.76 2.09 1.84 2.44l-.01 5.44h1.69v-5.4c.07-.03.2-.03.27-.05zm6.79 36.2-.84 1.44a17.35 17.35 0 0 1-3.8-3.22c-.86.26-1.85.1-2.59-.5a2.49 2.49 0 0 1-.3-3.64l.14-.16a15.9 15.9 0 0 1-1.32-5h1.71c.13 1.51.51 2.94 1.1 4.28.48-.06.99 0 1.45.16l4.28-4.73 1.29 1.04-4.25 4.73c.57.87.55 2-.1 2.85a15.8 15.8 0 0 0 3.23 2.75zm-8.76-13.69v-4.01a2.6 2.6 0 0 1-1.9-2.47c0-1.16.8-2.15 1.91-2.48l-.01-5.5h1.7v5.53c.84.26 1.48.88 1.74 1.67h4.57v1.61h-4.6c-.27.76-.9 1.36-1.7 1.62v4.04h-1.71m2.42 8.72a1.21 1.21 0 0 1 1.65-.13c.49.4.55 1.1.13 1.56-.42.47-1.16.52-1.65.13-.5-.4-.55-1.1-.13-1.56zm-2.16-4.69-1.76-.39-.25-4.45 1.75-.58v2.56c0 .99.09 1.92.26 2.86zm1.46-5.52 1.75.41s.09 2.87.05 2.22c-.04-.75.2 2.24.2 2.24l-1.77.58c-.18-.9-.24-1.84-.24-2.8v-2.65zm5.77 14.25a16.32 16.32 0 0 0 5.04 2.68l.4-1.7a14.27 14.27 0 0 1-4.18-2.1l-1.26 1.12m-.84 1.46c1.5 1.13 3.2 2.03 5.04 2.65l-1.31 1.23a19.49 19.49 0 0 1-4.12-2.11l.38-1.77",
    fill: "none",
    stroke: "#c8b100",
    strokeWidth: 0.26
  })), _path341 || (_path341 = /*#__PURE__*/react.createElement("path", {
    d: "m266.53 317.8 1.67.72 3.06-3.4-1-1.44-3.73 4.13m-1.3-1.05-1-1.45 3.06-3.4 1.67.72-3.73 4.13m-7.97-9.85c0-.62.52-1.11 1.17-1.11.64 0 1.16.5 1.16 1.11 0 .61-.52 1.1-1.16 1.1-.65 0-1.17-.49-1.17-1.1zm26.8 20.17.84 1.44a17.4 17.4 0 0 0 3.8-3.22c.87.26 1.85.1 2.6-.5a2.5 2.5 0 0 0 .3-3.64l-.15-.16c.7-1.56 1.17-3.24 1.32-5h-1.7c-.14 1.51-.52 2.94-1.1 4.28-.48-.06-1 0-1.46.16l-4.27-4.73-1.3 1.04 4.26 4.73c-.57.87-.55 2 .1 2.85a15.71 15.71 0 0 1-3.23 2.75zm8.77-13.69v-4.01a2.6 2.6 0 0 0 1.9-2.47c0-1.16-.81-2.15-1.92-2.48l.01-5.5h-1.7v5.53c-.83.26-1.48.88-1.73 1.67h-4.58v1.61h4.6c.28.76.9 1.36 1.7 1.62v4.04h1.71zm-2.42 8.73a1.2 1.2 0 0 0-1.65-.13c-.5.4-.55 1.1-.13 1.56.42.47 1.16.52 1.65.13.5-.4.55-1.1.13-1.56zm2.15-4.69 1.76-.39.25-4.45-1.74-.58v2.56c0 .99-.1 1.92-.27 2.86zm-1.45-5.52-1.75.41s-.1 2.87-.06 2.22c.05-.75-.2 2.24-.2 2.24l1.77.58c.18-.9.24-1.84.24-2.8v-2.65m1.73-21-.01 5.42h-1.7v-5.44c-.13-.04-.26-.1-.38-.15l-6.27 7.06-1.3-1.03 6.4-7.2c-.06-.1-.12-.2-.15-.32h-4.64v-1.6h4.62a2.71 2.71 0 0 1 2.6-1.8c1.5 0 2.73 1.16 2.73 2.6a2.6 2.6 0 0 1-1.9 2.46zm-16.73-.02-.01 3.34h-1.7v-3.31a2.68 2.68 0 0 1-1.78-1.67h-4.13v-1.6h4.13a2.7 2.7 0 0 1 2.6-1.8c1.2 0 2.23.75 2.6 1.8h4.21v1.6h-4.23a2.63 2.63 0 0 1-1.69 1.64zm9.22 35.27a16.38 16.38 0 0 1-5.04 2.68l-.39-1.7a14.24 14.24 0 0 0 4.17-2.1l1.26 1.12m.85 1.46a18.18 18.18 0 0 1-5.04 2.65l1.31 1.23a19.5 19.5 0 0 0 4.12-2.11l-.39-1.77m-28.56-32.68-1.76.5v4.46l1.76.48v-5.44m1.7 0 1.76.5v4.46l-1.75.48v-5.44m31.78 0-1.75.5v4.46l1.75.48v-5.44",
    fill: "none",
    stroke: "#c8b100",
    strokeWidth: 0.26
  })), _path342 || (_path342 = /*#__PURE__*/react.createElement("path", {
    d: "m292.82 294.94 1.76.5v4.46l-1.76.48v-5.44m-8.92 22.87-1.67.7-3.06-3.39 1-1.44 3.73 4.13m1.3-1.05 1-1.45-3.06-3.4-1.67.72 3.72 4.13m-18.98-20.94 1.67-.7 3.06 3.39-1 1.45-3.73-4.14m-1.3 1.05-1 1.46 3.06 3.39 1.67-.72-3.73-4.13m19.22-1.18-1.68-.7-3.03 3.43 1.02 1.43 3.69-4.16m1.3 1.04 1.02 1.44-3.03 3.42-1.68-.7 3.7-4.16m-21.19 9.4.51-1.66h4.72l.5 1.67h-5.73m0 1.6.51 1.68h4.72l.5-1.67h-5.73m-6.91-19.3c0-.62.52-1.11 1.17-1.11.64 0 1.17.5 1.17 1.1 0 .62-.53 1.1-1.17 1.1-.65 0-1.17-.48-1.17-1.1zm12.6.8-.51 1.67h-4.71l-.51-1.67h5.74m0-1.62-.52-1.66h-4.71l-.51 1.66h5.74m20.88 19.28c0-.62.52-1.11 1.17-1.11.64 0 1.16.5 1.16 1.11 0 .61-.52 1.1-1.16 1.1-.65 0-1.17-.49-1.17-1.1zm-4.56-.77-.52-1.67h-4.71l-.5 1.67h5.73m0 1.6-.52 1.68h-4.71l-.5-1.67h5.73m-12.11 22.75c0-.62.52-1.12 1.17-1.12.64 0 1.17.5 1.17 1.12 0 .6-.53 1.1-1.17 1.1-.65 0-1.17-.5-1.17-1.1zm1.98-8.08 1.76-.5v-4.45l-1.76-.48v5.43m-1.7 0-1.76-.5v-4.45l1.76-.48v5.43m16.4-33.98c0-.6.52-1.1 1.17-1.1.64 0 1.16.5 1.16 1.1 0 .62-.52 1.1-1.16 1.1-.65 0-1.17-.48-1.17-1.1zm-16.8 0c0-.6.53-1.1 1.17-1.1.65 0 1.17.5 1.17 1.1 0 .62-.52 1.1-1.17 1.1-.64 0-1.17-.48-1.17-1.1zm6.53.81.52 1.67h4.7l.52-1.67h-5.74m0-1.62.52-1.66h4.7l.52 1.66h-5.74m-6.15 5.22-1.76.49v4.46l1.76.48v-5.43m1.69 0 1.75.49v4.46l-1.75.48v-5.43",
    fill: "none",
    stroke: "#c8b100",
    strokeWidth: 0.26
  })), _path343 || (_path343 = /*#__PURE__*/react.createElement("path", {
    d: "M272.6 306.94c0-1.44 1.22-2.6 2.73-2.6 1.5 0 2.73 1.16 2.73 2.6a2.66 2.66 0 0 1-2.73 2.58c-1.51 0-2.74-1.15-2.74-2.58",
    fill: "#058e6e"
  })), _path344 || (_path344 = /*#__PURE__*/react.createElement("path", {
    d: "m275.93 239.26.06-.62.08-.34s-1.61.13-2.46-.1a6.15 6.15 0 0 1-2.4-1.26c-.8-.68-1.1-1.1-1.67-1.18-1.36-.22-2.4.4-2.4.4s1.02.37 1.78 1.3a4.85 4.85 0 0 0 1.95 1.54c.6.18 2.66.05 3.22.07.57.03 1.84.2 1.84.2",
    fill: "#db4446"
  })), _path345 || (_path345 = /*#__PURE__*/react.createElement("path", {
    d: "m275.93 239.26.06-.62.08-.34s-1.61.13-2.46-.1a6.15 6.15 0 0 1-2.4-1.26c-.8-.68-1.1-1.1-1.67-1.18-1.36-.22-2.4.4-2.4.4s1.02.37 1.78 1.3a4.85 4.85 0 0 0 1.95 1.54c.6.18 2.66.05 3.22.07.57.03 1.84.2 1.84.2z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path346 || (_path346 = /*#__PURE__*/react.createElement("path", {
    d: "M283.46 237s0 .72.08 1.4c.06.67-.22 1.24-.1 1.61.1.37.15.66.3.93.13.26.2.94.2.94l-.74-.54c-.35-.27-.6-.44-.6-.44l.1 1.03c.04.31.22.9.51 1.24.29.33.87.89 1.05 1.33.18.45.14 1.44.14 1.44s-.46-.75-.87-.89c-.4-.14-1.26-.62-1.26-.62s.8.8.8 1.55-.33 1.6-.33 1.6-.36-.68-.83-1.13c-.47-.44-1.13-.89-1.13-.89s.52 1.17.52 1.95c0 .8-.15 2.47-.15 2.47s-.4-.64-.8-.96c-.4-.3-.86-.58-1-.78-.15-.2.46.64.53 1.16.07.51.32 2.35 1.92 4.7.94 1.36 2.39 3.76 5.5 2.97 3.11-.78 1.95-4.97 1.3-6.92a17.52 17.52 0 0 1-.94-4.87c.04-.75.58-2.97.5-3.39-.06-.4-.23-2 .15-3.28.4-1.33.73-1.85.94-2.4.22-.55.4-.86.47-1.34.07-.48.07-1.37.07-1.37s.58 1.06.72 1.44c.15.38.15 1.5.15 1.5s.1-1.12.98-1.67c.87-.55 1.88-1.13 2.13-1.44.25-.31.33-.51.33-.51s-.08 1.92-.62 2.67c-.36.5-1.77 2.1-1.77 2.1s.73-.29 1.23-.31c.5-.04.87 0 .87 0s-.62.48-1.41 1.64c-.8 1.16-.47 1.26-1.05 2.22-.58.96-1.05 1-1.78 1.58-1.08.87-.5 4.34-.36 4.86.15.51 2.03 4.76 2.07 5.8.03 1.02.21 3.32-1.6 4.79-1.16.95-3.07.96-3.5 1.23-.44.28-1.3 1.13-1.3 2.91 0 1.79.64 2.06 1.15 2.5.5.45 1.16.21 1.3.56.15.34.22.54.44.75.22.2.36.44.29.82-.07.38-.9 1.23-1.2 1.85-.29.61-.87 2.23-.87 2.47 0 .24-.06 1 .18 1.37 0 0 .9 1.06.3 1.26-.4.14-.8-.25-.98-.2-.54.14-.82.47-.98.44-.36-.06-.36-.24-.4-.75-.03-.51-.01-.72-.18-.72-.21 0-.32.18-.36.45-.04.27-.04.89-.29.89-.25 0-.61-.45-.83-.55-.22-.1-.83-.2-.87-.48-.03-.27.36-.85.76-.96.4-.1.76-.3.5-.5-.25-.21-.5-.21-.75 0-.25.2-.8.03-.76-.28.04-.31.1-.69.07-.86-.03-.17-.47-.51.1-.82.59-.3.84.27 1.42.17s.87-.31 1.08-.65c.22-.34.18-1.06-.21-1.5-.4-.45-.8-.52-.95-.8-.14-.27-.36-.92-.36-.92s.1 1.2.04 1.37c-.07.17-.04.89-.04.89l-.72-.79a5.1 5.1 0 0 1-.65-1.37l-.03 1.34c0 .37.43.72.29.86-.15.13-.83-.72-1.02-.86a3.81 3.81 0 0 1-1.01-1.06c-.25-.48-.44-1.16-.5-1.4-.08-.25-.2-1.32-.08-1.59.18-.4.47-1.13.47-1.13h-1.41c-.76 0-1.3-.23-1.6.28-.28.51-.14 1.54.22 2.88.37 1.33.58 1.98.48 2.22-.11.24-.58.8-.76.9-.19.1-.7.06-.91-.04a2.6 2.6 0 0 0-1.26-.27c-.69 0-1.12.03-1.38-.03-.25-.07-.87-.38-1.16-.31-.29.07-.79.32-.65.72.22.61-.21.75-.5.72-.3-.04-.54-.14-.91-.24-.36-.1-.9 0-.83-.42.07-.4.22-.44.4-.75.18-.3.25-.5.04-.53-.25-.02-.5-.05-.7.11-.2.16-.5.5-.76.38-.26-.14-.46-.43-.46-1.08 0-.64-.68-1.2-.05-1.17.62.03 1.41.48 1.55.13.14-.35.06-.5-.28-.78-.34-.26-.76-.43-.3-.77.44-.35.55-.35.73-.54.17-.18.4-.79.72-.64.63.3.03.73.66 1.42.62.7 1.01.94 2.06.83 1.04-.1 1.33-.24 1.33-.54 0-.3-.09-.82-.12-1.04-.02-.21.15-1 .15-1s-.48.3-.63.6c-.13.3-.42.8-.42.8s-.11-.6-.08-1.1c.02-.28.12-.78.11-.88-.03-.27-.22-.94-.22-.94s-.18.73-.29.94c-.1.21-.17 1.07-.17 1.07s-.66-.58-.47-1.55c.13-.75-.12-1.74.1-2.06.23-.33.77-1.64 2.07-1.7 1.3-.04 2.31.06 2.77.04.45-.03 2.06-.32 2.06-.32s-2.97-1.53-3.65-1.99a9.89 9.89 0 0 1-2.06-2.16c-.34-.54-.65-1.58-.65-1.58s-.53.03-1.02.3a5.13 5.13 0 0 0-1.97 2.03s.08-.94.08-1.24c0-.28-.06-.85-.06-.85s-.33 1.28-1.01 1.76c-.68.49-1.47 1.15-1.47 1.15s.08-.71.08-.88c0-.16.17-.99.17-.99s-.48.72-1.21.86c-.74.13-1.81.1-1.9.56-.08.45.2 1.07.03 1.4-.17.31-.54.53-.54.53s-.42-.35-.79-.38c-.36-.03-.7.16-.7.16s-.32-.4-.2-.67c.11-.26.68-.66.54-.83-.15-.16-.6.06-.88.2-.28.13-.88.26-.82-.2.06-.45.2-.72.06-1.04-.15-.32-.06-.53.17-.62.22-.07 1.13.03 1.21-.18.08-.21-.22-.48-.82-.61-.6-.14-.88-.49-.56-.78.3-.3.4-.38.53-.64.14-.27.2-.75.74-.51.53.24.42.82.99 1.01.56.2 1.89-.07 2.17-.23.29-.17 1.19-.84 1.5-1 .31-.16 1.6-1.12 1.6-1.12s-.75-.53-1.04-.8c-.28-.27-.78-.91-1.04-1.05a8.72 8.72 0 0 0-1.92-.64 12 12 0 0 1-1.73-.48s.6-.19.8-.35c.2-.16.64-.56.87-.53l.28.03s-1.21-.06-1.47-.14c-.25-.08-.99-.54-1.27-.54s-.84.11-.84.11.76-.48 1.38-.59c.62-.1 1.1-.08 1.1-.08s-.96-.26-1.19-.58c-.22-.33-.45-.8-.62-1.02-.17-.21-.28-.56-.6-.59-.3-.03-.84.38-1.15.35-.3-.02-.54-.22-.57-.67-.02-.46 0-.3-.1-.53-.12-.25-.57-.81-.15-.94.43-.14 1.33.08 1.42-.08.08-.16-.48-.65-.85-.83-.37-.19-.96-.51-.65-.78.31-.27.62-.37.8-.61.16-.24.36-.91.73-.7.36.21.87 1.26 1.16 1.18.28-.08.3-.83.25-1.15-.06-.32 0-.88.28-.83.28.05.5.43.96.46.45.02 1.13-.11 1.07.2-.05.33-.3.72-.62 1.08a1.6 1.6 0 0 0-.25 1.5c.2.45.7 1.18 1.16 1.47.45.3 1.3.5 1.84.85.53.36 1.78 1.34 2.2 1.45.42.1.85.32.85.32s.48-.21 1.13-.21c.65 0 2.15.1 2.71-.14.57-.24 1.3-.64 1.08-1.15-.23-.5-1.47-.96-1.36-1.36.11-.4.57-.43 1.33-.46.76-.02 1.8.14 2-.94.2-1.06.25-1.68-.81-1.92-1.08-.24-1.87-.27-2.07-1.04-.2-.78-.4-.97-.17-1.18.23-.21.62-.32 1.41-.37.8-.06 1.7-.06 1.95-.25.26-.18.31-.7.62-.91.31-.21 1.53-.4 1.53-.4s1.45.7 2.8 1.7c1.21.91 2.3 2.24 2.3 2.24",
    fill: "#ed72aa",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path347 || (_path347 = /*#__PURE__*/react.createElement("path", {
    d: "M273.05 236.24s-.17-.48-.2-.62c-.03-.13-.12-.29-.12-.29s.88 0 .85.27c-.02.27-.28.27-.33.37-.06.1-.2.27-.2.27"
  })), _path348 || (_path348 = /*#__PURE__*/react.createElement("path", {
    d: "M273.05 236.24s-.17-.48-.2-.62c-.03-.13-.12-.29-.12-.29s.88 0 .85.27c-.02.27-.28.27-.33.37-.06.1-.2.27-.2.27z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path349 || (_path349 = /*#__PURE__*/react.createElement("path", {
    d: "m277.06 234.85-.06-.43s.77 0 1.13.26c.57.4.93 1.02.9 1.05-.09.1-.53-.27-.84-.38 0 0-.23.06-.45.06-.23 0-.34-.1-.37-.22-.03-.1.03-.29.03-.29l-.34-.05"
  })), _path350 || (_path350 = /*#__PURE__*/react.createElement("path", {
    d: "m277.06 234.85-.06-.43s.77 0 1.13.26c.57.4.93 1.02.9 1.05-.09.1-.53-.27-.84-.38 0 0-.23.06-.45.06-.23 0-.34-.1-.37-.22-.03-.1.03-.29.03-.29l-.34-.05z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path351 || (_path351 = /*#__PURE__*/react.createElement("path", {
    d: "M282.57 240.9s-.34-.49-.42-.65c-.09-.15-.23-.48-.23-.48",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path352 || (_path352 = /*#__PURE__*/react.createElement("path", {
    d: "M261.88 236.08s.48.34.85.4c.37.05.76.05.82.05.06 0 .17-.54.11-.9a1.84 1.84 0 0 0-1.3-1.48s.33.73.17 1.07c-.23.48-.65.86-.65.86",
    fill: "#db4446"
  })), _path353 || (_path353 = /*#__PURE__*/react.createElement("path", {
    d: "M261.88 236.08s.48.34.85.4c.37.05.76.05.82.05.06 0 .17-.54.11-.9a1.84 1.84 0 0 0-1.3-1.48s.33.73.17 1.07c-.23.48-.65.86-.65.86z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path354 || (_path354 = /*#__PURE__*/react.createElement("path", {
    d: "M259.59 237.12s-.42-.77-1.33-.67c-.9.1-1.5.8-1.5.8s1-.02 1.25.14c.37.24.48.86.48.86s.54-.32.7-.54c.17-.21.4-.59.4-.59",
    fill: "#db4446"
  })), _path355 || (_path355 = /*#__PURE__*/react.createElement("path", {
    d: "M259.59 237.12s-.42-.77-1.33-.67c-.9.1-1.5.8-1.5.8s1-.02 1.25.14c.37.24.48.86.48.86s.54-.32.7-.54c.17-.21.4-.59.4-.59z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path356 || (_path356 = /*#__PURE__*/react.createElement("path", {
    d: "M258.49 240.25s-.76.11-1.19.6c-.43.48-.37 1.39-.37 1.39s.51-.54.96-.54c.46 0 1.16.16 1.16.16s-.22-.56-.22-.8-.34-.8-.34-.8",
    fill: "#db4446"
  })), _path357 || (_path357 = /*#__PURE__*/react.createElement("path", {
    d: "M258.49 240.25s-.76.11-1.19.6c-.43.48-.37 1.39-.37 1.39s.51-.54.96-.54c.46 0 1.16.16 1.16.16s-.22-.56-.22-.8-.34-.8-.34-.8z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path358 || (_path358 = /*#__PURE__*/react.createElement("path", {
    d: "m273.08 240.15.33-.54.34.49-.67.05"
  })), _path359 || (_path359 = /*#__PURE__*/react.createElement("path", {
    d: "m273.08 240.15.33-.54.34.49-.67.05",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path360 || (_path360 = /*#__PURE__*/react.createElement("path", {
    d: "m273.9 240.12.39-.53.42.48-.82.05"
  })), _path361 || (_path361 = /*#__PURE__*/react.createElement("path", {
    d: "m273.9 240.12.39-.53.42.48-.82.05",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path362 || (_path362 = /*#__PURE__*/react.createElement("path", {
    d: "m273.53 236.83.82.3-.74.37-.08-.67"
  })), _path363 || (_path363 = /*#__PURE__*/react.createElement("path", {
    d: "m273.53 236.83.82.3-.74.37-.08-.67",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path364 || (_path364 = /*#__PURE__*/react.createElement("path", {
    d: "m274.51 237.1.74.18-.6.46-.13-.64"
  })), _path365 || (_path365 = /*#__PURE__*/react.createElement("path", {
    d: "m274.51 237.1.74.18-.6.46-.13-.64",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path366 || (_path366 = /*#__PURE__*/react.createElement("path", {
    d: "M269 243.39s-.8.23-1.1.67c-.37.53-.34 1.07-.34 1.07s.68-.56 1.56-.33c.87.24.96.33 1.33.3.37-.03 1.27-.35 1.27-.35s-.74.86-.65 1.45c.08.59.2.85.17 1.15-.06.72-.6 1.6-.6 1.6s.31-.18 1.05-.34a4.77 4.77 0 0 0 1.75-.8c.4-.3.9-1.03.9-1.03s-.16 1 0 1.43c.17.42.23 1.66.23 1.66s.47-.42.85-.62c.2-.11.7-.38.9-.7.14-.22.31-1.06.31-1.06s.12.9.4 1.34c.28.42.7 1.74.7 1.74s.29-.86.6-1.21c.3-.35.68-.8.7-1.07.03-.27-.08-.85-.08-.85l.4.85m-11.42.61s.48-.83.93-1.1c.46-.27 1.08-.75 1.25-.8.16-.05.9-.46.9-.46m.99 5.17s1.09-.55 1.41-.75a4.11 4.11 0 0 0 1.16-1.12",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path367 || (_path367 = /*#__PURE__*/react.createElement("path", {
    d: "M261.06 250.37s-.43-.45-1.16-.32c-.73.14-1.21.97-1.21.97s.62-.17.99-.08c.36.08.62.45.62.45s.33-.3.45-.45c.11-.16.3-.57.3-.57",
    fill: "#db4446"
  })), _path368 || (_path368 = /*#__PURE__*/react.createElement("path", {
    d: "M261.06 250.37s-.43-.45-1.16-.32c-.73.14-1.21.97-1.21.97s.62-.17.99-.08c.36.08.62.45.62.45s.33-.3.45-.45c.11-.16.3-.57.3-.57z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path369 || (_path369 = /*#__PURE__*/react.createElement("path", {
    d: "M260.21 253.34s-.62-.1-1.16.33c-.53.43-.56 1.25-.56 1.25s.5-.43.9-.37c.4.05.88.27.88.27l.11-.64c.09-.38-.17-.84-.17-.84",
    fill: "#db4446"
  })), _path370 || (_path370 = /*#__PURE__*/react.createElement("path", {
    d: "M260.21 253.34s-.62-.1-1.16.33c-.53.43-.56 1.25-.56 1.25s.5-.43.9-.37c.4.05.88.27.88.27l.11-.64c.09-.38-.17-.84-.17-.84z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path371 || (_path371 = /*#__PURE__*/react.createElement("path", {
    d: "M261.65 256.08s-.04.8.34 1.28c.4.51 1.13.59 1.13.59s-.24-.53-.28-.8c-.06-.4.34-.75.34-.75s-.37-.38-.73-.38c-.37 0-.8.06-.8.06",
    fill: "#db4446"
  })), _path372 || (_path372 = /*#__PURE__*/react.createElement("path", {
    d: "M261.65 256.08s-.04.8.34 1.28c.4.51 1.13.59 1.13.59s-.24-.53-.28-.8c-.06-.4.34-.75.34-.75s-.37-.38-.73-.38c-.37 0-.8.06-.8.06zm16.68 1.33s2.04 1.26 1.98 2.3c-.06 1.05-1.13 2.42-1.13 2.42",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path373 || (_path373 = /*#__PURE__*/react.createElement("path", {
    d: "M269 263.12s-.5-.64-1.21-.62c-.71.03-1.45.7-1.45.7s.88-.08 1.1.21c.24.3.46.67.46.67s.4-.21.57-.35c.17-.13.53-.61.53-.61",
    fill: "#db4446"
  })), _path374 || (_path374 = /*#__PURE__*/react.createElement("path", {
    d: "M269 263.12s-.5-.64-1.21-.62c-.71.03-1.45.7-1.45.7s.88-.08 1.1.21c.24.3.46.67.46.67s.4-.21.57-.35c.17-.13.53-.61.53-.61z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path375 || (_path375 = /*#__PURE__*/react.createElement("path", {
    d: "M266.83 265.93s-.93-.14-1.39.35c-.45.48-.42 1.36-.42 1.36s.56-.61 1.07-.56c.51.05 1.08.32 1.08.32s-.09-.53-.15-.78c-.05-.24-.2-.7-.2-.7",
    fill: "#db4446"
  })), _path376 || (_path376 = /*#__PURE__*/react.createElement("path", {
    d: "M266.83 265.93s-.93-.14-1.39.35c-.45.48-.42 1.36-.42 1.36s.56-.61 1.07-.56c.51.05 1.08.32 1.08.32s-.09-.53-.15-.78c-.05-.24-.2-.7-.2-.7z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path377 || (_path377 = /*#__PURE__*/react.createElement("path", {
    d: "M268.83 268.9s-.45.64-.1 1.15a2.3 2.3 0 0 0 1.04.75s-.26-.37-.14-.8c.09-.34.68-.8.68-.8l-1.48-.3",
    fill: "#db4446"
  })), _path378 || (_path378 = /*#__PURE__*/react.createElement("path", {
    d: "M268.83 268.9s-.45.64-.1 1.15a2.3 2.3 0 0 0 1.04.75s-.26-.37-.14-.8c.09-.34.68-.8.68-.8l-1.48-.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path379 || (_path379 = /*#__PURE__*/react.createElement("path", {
    d: "M281.24 270.1s-.81-.18-1.27.09c-.45.26-.82 1.39-.82 1.39s.74-.62 1.28-.54c.53.08.93.3.93.3s.08-.46.02-.78c-.03-.19-.14-.45-.14-.45",
    fill: "#db4446"
  })), _path380 || (_path380 = /*#__PURE__*/react.createElement("path", {
    d: "M281.24 270.1s-.81-.18-1.27.09c-.45.26-.82 1.39-.82 1.39s.74-.62 1.28-.54c.53.08.93.3.93.3s.08-.46.02-.78c-.03-.19-.14-.45-.14-.45z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path381 || (_path381 = /*#__PURE__*/react.createElement("path", {
    d: "M281.64 273.1s-.62.64-.4 1.18c.23.54.63 1.1.63 1.1s-.03-.8.22-1.02c.37-.32 1.05-.37 1.05-.37s-.54-.48-.71-.54c-.17-.05-.79-.35-.79-.35",
    fill: "#db4446"
  })), _path382 || (_path382 = /*#__PURE__*/react.createElement("path", {
    d: "M281.64 273.1s-.62.64-.4 1.18c.23.54.63 1.1.63 1.1s-.03-.8.22-1.02c.37-.32 1.05-.37 1.05-.37s-.54-.48-.71-.54c-.17-.05-.79-.35-.79-.35z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path383 || (_path383 = /*#__PURE__*/react.createElement("path", {
    d: "M284.75 274.04s-.31.78.28 1.28c.6.51 1.1.57 1.1.57s-.45-.8-.3-1.23c.14-.45.53-.73.53-.73s-.74-.24-.85-.21c-.1.02-.76.32-.76.32",
    fill: "#db4446"
  })), _path384 || (_path384 = /*#__PURE__*/react.createElement("path", {
    d: "M284.75 274.04s-.31.78.28 1.28c.6.51 1.1.57 1.1.57s-.45-.8-.3-1.23c.14-.45.53-.73.53-.73s-.74-.24-.85-.21c-.1.02-.76.32-.76.32z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path385 || (_path385 = /*#__PURE__*/react.createElement("path", {
    d: "M252.9 329.55c2.1.63 3.16 2.19 3.16 4.01 0 2.38-2.3 4.18-5.3 4.18-2.99 0-5.41-1.8-5.41-4.18 0-1.8 1-3.8 3.07-3.94 0 0-.06-.2-.24-.5l-.64-.66s.8-.15 1.25.02c.46.18.77.47.77.47s.21-.43.52-.76c.3-.33.7-.53.7-.53s.46.38.61.64c.15.27.25.59.25.59s.42-.35.8-.5c.36-.14.83-.25.83-.25s-.13.46-.22.69c-.1.23-.14.72-.14.72",
    fill: "#ffd691",
    stroke: "#000",
    strokeWidth: 0.52
  })), _path386 || (_path386 = /*#__PURE__*/react.createElement("path", {
    d: "M250.32 340.32s-3.98-2.68-5.7-3.04c-2.2-.47-4.69-.1-5.76-.15.03.03 1.29.93 1.84 1.48.55.55 2.39 1.65 3.43 1.91 3.22.81 6.2-.2 6.2-.2m1.13.24s2.54-2.66 5.21-3.02c3.15-.44 5.22.26 6.44.58.03 0-1.01.5-1.56.87-.55.38-1.97 1.56-4.14 1.59-2.18.03-4.58-.23-4.98-.17l-.97.14",
    fill: "#058e6e",
    stroke: "#000",
    strokeWidth: 0.52
  })), _path387 || (_path387 = /*#__PURE__*/react.createElement("path", {
    d: "M250.7 337.28a5.05 5.05 0 0 1 0-7.43 5.05 5.05 0 0 1 0 7.43",
    fill: "#ad1519",
    stroke: "#000",
    strokeWidth: 0.52
  })), _path388 || (_path388 = /*#__PURE__*/react.createElement("path", {
    d: "M249.68 342.71s.61-1.52.67-2.83c.06-1.09-.15-2.17-.15-2.17h.8s.4 1.16.4 2.17c0 1.02-.2 2.37-.2 2.37s-.54.08-.72.17c-.19.09-.8.29-.8.29",
    fill: "#058e6e",
    stroke: "#000",
    strokeWidth: 0.52
  })), _path389 || (_path389 = /*#__PURE__*/react.createElement("path", {
    d: "M300 198.67c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04",
    fill: "#fff"
  })), _path390 || (_path390 = /*#__PURE__*/react.createElement("path", {
    d: "M300 198.67c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path391 || (_path391 = /*#__PURE__*/react.createElement("path", {
    d: "M301.5 196.02c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04",
    fill: "#fff"
  })), _path392 || (_path392 = /*#__PURE__*/react.createElement("path", {
    d: "M301.5 196.02c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path393 || (_path393 = /*#__PURE__*/react.createElement("path", {
    d: "M302.5 192.94c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04",
    fill: "#fff"
  })), _path394 || (_path394 = /*#__PURE__*/react.createElement("path", {
    d: "M302.5 192.94c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path395 || (_path395 = /*#__PURE__*/react.createElement("path", {
    d: "M302.63 189.64c0-.57.49-1.03 1.1-1.03.6 0 1.09.46 1.09 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.09-.46-1.09-1.04",
    fill: "#fff"
  })), _path396 || (_path396 = /*#__PURE__*/react.createElement("path", {
    d: "M302.63 189.64c0-.57.49-1.03 1.1-1.03.6 0 1.09.46 1.09 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.09-.46-1.09-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path397 || (_path397 = /*#__PURE__*/react.createElement("path", {
    d: "M301.82 186.4c0-.58.49-1.04 1.09-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.05-1.1 1.05-.6 0-1.1-.47-1.1-1.04",
    fill: "#fff"
  })), _path398 || (_path398 = /*#__PURE__*/react.createElement("path", {
    d: "M301.82 186.4c0-.58.49-1.04 1.09-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.05-1.1 1.05-.6 0-1.1-.47-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path399 || (_path399 = /*#__PURE__*/react.createElement("path", {
    d: "M300.13 183.45c0-.58.49-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.61 0-1.1-.47-1.1-1.04",
    fill: "#fff"
  })), _path400 || (_path400 = /*#__PURE__*/react.createElement("path", {
    d: "M300.13 183.45c0-.58.49-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.61 0-1.1-.47-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path401 || (_path401 = /*#__PURE__*/react.createElement("path", {
    d: "M297.88 181.03c0-.58.49-1.04 1.1-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.61 0-1.1-.46-1.1-1.03",
    fill: "#fff"
  })), _path402 || (_path402 = /*#__PURE__*/react.createElement("path", {
    d: "M297.88 181.03c0-.58.49-1.04 1.1-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.61 0-1.1-.46-1.1-1.03z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path403 || (_path403 = /*#__PURE__*/react.createElement("path", {
    d: "M295.26 179.01c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
    fill: "#fff"
  })), _path404 || (_path404 = /*#__PURE__*/react.createElement("path", {
    d: "M295.26 179.01c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path405 || (_path405 = /*#__PURE__*/react.createElement("path", {
    d: "M292.14 177.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04",
    fill: "#fff"
  })), _path406 || (_path406 = /*#__PURE__*/react.createElement("path", {
    d: "M292.14 177.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path407 || (_path407 = /*#__PURE__*/react.createElement("path", {
    d: "M288.9 176.19c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
    fill: "#fff"
  })), _path408 || (_path408 = /*#__PURE__*/react.createElement("path", {
    d: "M288.9 176.19c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path409 || (_path409 = /*#__PURE__*/react.createElement("path", {
    d: "M285.28 175.54c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
    fill: "#fff"
  })), _path410 || (_path410 = /*#__PURE__*/react.createElement("path", {
    d: "M285.28 175.54c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path411 || (_path411 = /*#__PURE__*/react.createElement("path", {
    d: "M281.84 175.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04",
    fill: "#fff"
  })), _path412 || (_path412 = /*#__PURE__*/react.createElement("path", {
    d: "M281.84 175.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path413 || (_path413 = /*#__PURE__*/react.createElement("path", {
    d: "M278.47 175.48c0-.57.49-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.61 0-1.1-.47-1.1-1.04",
    fill: "#fff"
  })), _path414 || (_path414 = /*#__PURE__*/react.createElement("path", {
    d: "M278.47 175.48c0-.57.49-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.61 0-1.1-.47-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path415 || (_path415 = /*#__PURE__*/react.createElement("path", {
    d: "M275.1 175.48c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
    fill: "#fff"
  })), _path416 || (_path416 = /*#__PURE__*/react.createElement("path", {
    d: "M275.1 175.48c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path417 || (_path417 = /*#__PURE__*/react.createElement("path", {
    d: "M276.79 178.37c0-.57.49-1.04 1.09-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04m.69 3.2c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.03-1.1 1.03-.6 0-1.1-.46-1.1-1.03m.13 3.18c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04m-.99 2.9c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04m-1.86 2.66c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.03",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path418 || (_path418 = /*#__PURE__*/react.createElement("path", {
    d: "M272.54 173.47c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
    fill: "#fff"
  })), _path419 || (_path419 = /*#__PURE__*/react.createElement("path", {
    d: "M272.54 173.47c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path420 || (_path420 = /*#__PURE__*/react.createElement("path", {
    d: "M269.55 171.81c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04",
    fill: "#fff"
  })), _path421 || (_path421 = /*#__PURE__*/react.createElement("path", {
    d: "M269.55 171.81c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path422 || (_path422 = /*#__PURE__*/react.createElement("path", {
    d: "M266.25 170.82c0-.58.49-1.04 1.1-1.04.6 0 1.09.46 1.09 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
    fill: "#fff"
  })), _path423 || (_path423 = /*#__PURE__*/react.createElement("path", {
    d: "M266.25 170.82c0-.58.49-1.04 1.1-1.04.6 0 1.09.46 1.09 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path424 || (_path424 = /*#__PURE__*/react.createElement("path", {
    d: "M262.81 170.23c0-.57.5-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .57-.49 1.03-1.1 1.03-.6 0-1.09-.46-1.09-1.03",
    fill: "#fff"
  })), _path425 || (_path425 = /*#__PURE__*/react.createElement("path", {
    d: "M262.81 170.23c0-.57.5-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .57-.49 1.03-1.1 1.03-.6 0-1.09-.46-1.09-1.03z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path426 || (_path426 = /*#__PURE__*/react.createElement("path", {
    d: "M259.45 170.28c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04",
    fill: "#fff"
  })), _path427 || (_path427 = /*#__PURE__*/react.createElement("path", {
    d: "M259.45 170.28c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path428 || (_path428 = /*#__PURE__*/react.createElement("path", {
    d: "M255.95 170.87c0-.57.49-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.61 0-1.1-.46-1.1-1.04",
    fill: "#fff"
  })), _path429 || (_path429 = /*#__PURE__*/react.createElement("path", {
    d: "M255.95 170.87c0-.57.49-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.61 0-1.1-.46-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path430 || (_path430 = /*#__PURE__*/react.createElement("path", {
    d: "M252.7 172c0-.58.5-1.05 1.1-1.05.61 0 1.1.47 1.1 1.04 0 .57-.49 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
    fill: "#fff"
  })), _path431 || (_path431 = /*#__PURE__*/react.createElement("path", {
    d: "M252.7 172c0-.58.5-1.05 1.1-1.05.61 0 1.1.47 1.1 1.04 0 .57-.49 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path432 || (_path432 = /*#__PURE__*/react.createElement("path", {
    d: "M197.84 198.67c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04",
    fill: "#fff"
  })), _path433 || (_path433 = /*#__PURE__*/react.createElement("path", {
    d: "M197.84 198.67c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path434 || (_path434 = /*#__PURE__*/react.createElement("path", {
    d: "M196.34 196.02c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04",
    fill: "#fff"
  })), _path435 || (_path435 = /*#__PURE__*/react.createElement("path", {
    d: "M196.34 196.02c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path436 || (_path436 = /*#__PURE__*/react.createElement("path", {
    d: "M195.34 192.94c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04",
    fill: "#fff"
  })), _path437 || (_path437 = /*#__PURE__*/react.createElement("path", {
    d: "M195.34 192.94c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path438 || (_path438 = /*#__PURE__*/react.createElement("path", {
    d: "M195.22 189.64c0-.57.49-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.61 0-1.1-.46-1.1-1.04",
    fill: "#fff"
  })), _path439 || (_path439 = /*#__PURE__*/react.createElement("path", {
    d: "M195.22 189.64c0-.57.49-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.61 0-1.1-.46-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path440 || (_path440 = /*#__PURE__*/react.createElement("path", {
    d: "M196.03 186.4c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.05-1.1 1.05-.6 0-1.1-.47-1.1-1.04",
    fill: "#fff"
  })), _path441 || (_path441 = /*#__PURE__*/react.createElement("path", {
    d: "M196.03 186.4c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.05-1.1 1.05-.6 0-1.1-.47-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path442 || (_path442 = /*#__PURE__*/react.createElement("path", {
    d: "M197.71 183.45c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
    fill: "#fff"
  })), _path443 || (_path443 = /*#__PURE__*/react.createElement("path", {
    d: "M197.71 183.45c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path444 || (_path444 = /*#__PURE__*/react.createElement("path", {
    d: "M199.97 181.03c0-.58.49-1.04 1.1-1.04.6 0 1.09.46 1.09 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.03",
    fill: "#fff"
  })), _path445 || (_path445 = /*#__PURE__*/react.createElement("path", {
    d: "M199.97 181.03c0-.58.49-1.04 1.1-1.04.6 0 1.09.46 1.09 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.03z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path446 || (_path446 = /*#__PURE__*/react.createElement("path", {
    d: "M202.58 179.01c0-.57.49-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.61 0-1.1-.47-1.1-1.04",
    fill: "#fff"
  })), _path447 || (_path447 = /*#__PURE__*/react.createElement("path", {
    d: "M202.58 179.01c0-.57.49-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.61 0-1.1-.47-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path448 || (_path448 = /*#__PURE__*/react.createElement("path", {
    d: "M205.7 177.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04",
    fill: "#fff"
  })), _path449 || (_path449 = /*#__PURE__*/react.createElement("path", {
    d: "M205.7 177.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path450 || (_path450 = /*#__PURE__*/react.createElement("path", {
    d: "M208.94 176.19c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
    fill: "#fff"
  })), _path451 || (_path451 = /*#__PURE__*/react.createElement("path", {
    d: "M208.94 176.19c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path452 || (_path452 = /*#__PURE__*/react.createElement("path", {
    d: "M212.57 175.54c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
    fill: "#fff"
  })), _path453 || (_path453 = /*#__PURE__*/react.createElement("path", {
    d: "M212.57 175.54c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path454 || (_path454 = /*#__PURE__*/react.createElement("path", {
    d: "M216 175.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04",
    fill: "#fff"
  })), _path455 || (_path455 = /*#__PURE__*/react.createElement("path", {
    d: "M216 175.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path456 || (_path456 = /*#__PURE__*/react.createElement("path", {
    d: "M219.38 175.48c0-.57.49-1.04 1.09-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
    fill: "#fff"
  })), _path457 || (_path457 = /*#__PURE__*/react.createElement("path", {
    d: "M219.38 175.48c0-.57.49-1.04 1.09-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path458 || (_path458 = /*#__PURE__*/react.createElement("path", {
    d: "M222.75 175.48c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
    fill: "#fff"
  })), _path459 || (_path459 = /*#__PURE__*/react.createElement("path", {
    d: "M222.75 175.48c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path460 || (_path460 = /*#__PURE__*/react.createElement("path", {
    d: "M221.06 178.37c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04m-.68 3.2c0-.58.48-1.04 1.1-1.04.6 0 1.09.46 1.09 1.04 0 .57-.5 1.03-1.1 1.03-.6 0-1.1-.46-1.1-1.03m-.12 3.18c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04m1 2.9c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04m1.86 2.66c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.03",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path461 || (_path461 = /*#__PURE__*/react.createElement("path", {
    d: "M225.3 173.47c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
    fill: "#fff"
  })), _path462 || (_path462 = /*#__PURE__*/react.createElement("path", {
    d: "M225.3 173.47c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path463 || (_path463 = /*#__PURE__*/react.createElement("path", {
    d: "M228.3 171.81c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04",
    fill: "#fff"
  })), _path464 || (_path464 = /*#__PURE__*/react.createElement("path", {
    d: "M228.3 171.81c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path465 || (_path465 = /*#__PURE__*/react.createElement("path", {
    d: "M231.6 170.82c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
    fill: "#fff"
  })), _path466 || (_path466 = /*#__PURE__*/react.createElement("path", {
    d: "M231.6 170.82c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path467 || (_path467 = /*#__PURE__*/react.createElement("path", {
    d: "M235.04 170.23c0-.57.49-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.03-1.1 1.03-.61 0-1.1-.46-1.1-1.03",
    fill: "#fff"
  })), _path468 || (_path468 = /*#__PURE__*/react.createElement("path", {
    d: "M235.04 170.23c0-.57.49-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.03-1.1 1.03-.61 0-1.1-.46-1.1-1.03z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path469 || (_path469 = /*#__PURE__*/react.createElement("path", {
    d: "M238.4 170.28c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.09-.46-1.09-1.04",
    fill: "#fff"
  })), _path470 || (_path470 = /*#__PURE__*/react.createElement("path", {
    d: "M238.4 170.28c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.09-.46-1.09-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path471 || (_path471 = /*#__PURE__*/react.createElement("path", {
    d: "M241.9 170.87c0-.57.49-1.03 1.1-1.03.6 0 1.09.46 1.09 1.03 0 .58-.49 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04",
    fill: "#fff"
  })), _path472 || (_path472 = /*#__PURE__*/react.createElement("path", {
    d: "M241.9 170.87c0-.57.49-1.03 1.1-1.03.6 0 1.09.46 1.09 1.03 0 .58-.49 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path473 || (_path473 = /*#__PURE__*/react.createElement("path", {
    d: "M245.13 172c0-.58.5-1.05 1.1-1.05.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
    fill: "#fff"
  })), _path474 || (_path474 = /*#__PURE__*/react.createElement("path", {
    d: "M245.13 172c0-.58.5-1.05 1.1-1.05.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.39
  })), _path475 || (_path475 = /*#__PURE__*/react.createElement("path", {
    d: "M217.34 238.41h-.92v-.92h-1.62v3.7h1.62v2.54h-3.47v7.4h1.85v14.78h-3.7v7.63h28.42v-7.63h-3.7v-14.79h1.86v-7.4h-3.47v-2.53h1.62v-3.7h-1.62v.92h-.93v-.92h-1.61v.92h-1.16v-.92h-1.62v3.7h1.62v2.54h-3.46v-8.1h1.84v-3.69h-1.84v.93h-.93v-.93h-1.62v.93h-.92v-.93h-1.85v3.7h1.85v8.09h-3.47v-2.54h1.62v-3.7h-1.62v.92h-.92v-.92h-1.85v.92zm-6.24 35.13h28.42m-28.42-1.85h28.42m-28.42-1.85h28.42m-28.42-1.85h28.42m-28.42-2.08h28.42m-24.72-1.62h21.03m-21.03-1.85h21.03m-21.03-2.08h21.03m-21.03-1.85h21.03m-21.03-1.84h21.03m-21.03-1.85h21.03m-21.03-1.85h21.03m-22.88-1.85h24.73m-24.73-1.85h24.73m-24.73-1.85h24.73m-24.73-1.84h24.73m-21.26-1.85h17.79m-10.63-1.85h3.47m-3.47-1.85h3.47m-3.47-1.85h3.47m-3.47-1.85h3.47m-5.32-2.3h7.16m-12.47 7.85h3.7m-5.32-2.31h6.93m-6.93 33.97v-1.85m0-1.85v-1.85m-1.85 1.85v1.85m3.47 0v-1.85m1.84 3.7v-1.85m0-1.85v-1.85m0-2.08v-1.62m0-1.85v-2.08m-1.84 7.63v-2.08m-3.47 2.08v-2.08m7.16 0v2.08m1.62-2.08v-1.62m-5.31-1.85v1.85m3.7-1.85v1.85m3.46-1.85v1.85m-1.85-1.85v-2.08m1.85-1.85v1.85m0-5.54v1.85m-1.85-3.7v1.85m1.85-3.7v1.85m-3.47-1.85v1.85m-3.7-1.85v1.85m-1.61-3.7v1.85m3.46-1.85v1.85m3.47-1.85v1.85m1.85-3.7v1.85m-3.47-1.85v1.85m-3.7-1.85v1.85m-1.61-3.7v1.85m6.93-1.84v1.84m-3.47-5.54v1.85m15.95-1.85h-3.7m5.32-2.31h-6.94m6.94 33.97v-1.85m0-1.85v-1.85m1.84 1.85v1.85m-3.46 0v-1.85m-1.85 3.7v-1.85m0-1.85v-1.85m0-2.08v-1.62m0-1.85v-2.08m1.85 7.63v-2.08m3.47 2.08v-2.08m-7.17 0v2.08m-1.62-2.08v-1.62m5.32-1.85v1.85m-3.7-1.85v1.85m-3.46-1.85v1.85m1.84-1.85v-2.08m-1.84-1.85v1.85m0-5.54v1.85m1.84-3.7v1.85m-1.84-3.7v1.85m3.46-1.85v1.85m3.7-1.85v1.85m1.62-3.7v1.85m-3.47-1.85v1.85m-3.47-1.85v1.85m-1.84-3.7v1.85m3.46-1.85v1.85m3.7-1.85v1.85m1.62-3.7v1.85m-6.94-1.84v1.84m3.47-5.54v1.85m-7.16 18.71v-2.08m0-5.54v-1.85m0 5.54v-1.84m0-5.55v-1.85m0-1.85v-1.84m0-3.7v-1.85m0-1.85v-1.85m-8.78 4.85h3.7m3.46-5.54h3.47m3.46 5.55h3.7",
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.46
  })), _path476 || (_path476 = /*#__PURE__*/react.createElement("path", {
    d: "M230.05 273.54v-4.86c0-.92-.46-3.7-4.85-3.7-4.16 0-4.62 2.78-4.62 3.7v4.86h9.47z",
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.46
  })), _path477 || (_path477 = /*#__PURE__*/react.createElement("path", {
    d: "m222.2 268.91-2.32-.23c0-.92.23-2.3.93-2.77l2.08 1.62c-.23.23-.7.92-.7 1.38zm6.23 0 2.31-.23c0-.92-.23-2.3-.92-2.77l-2.08 1.62c.23.23.7.92.7 1.38zm-2.31-2.31 1.16-2.08a5.52 5.52 0 0 0-2.08-.46c-.46 0-1.39.23-1.85.46l1.15 2.08h1.62zm-4.39-5.77v-5.09c0-1.38-.92-2.54-2.54-2.54s-2.54 1.16-2.54 2.54v5.09h5.08zm7.17 0v-5.09c0-1.38.92-2.54 2.54-2.54 1.61 0 2.54 1.16 2.54 2.54v5.09h-5.09zm-1.85-12.48.46-4.62h-4.4l.24 4.62h3.7zm3.46 0-.46-4.62h4.62l-.46 4.62h-3.7zm-10.4 0 .23-4.62h-4.39l.47 4.62h3.7z",
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.46
  })), _path478 || (_path478 = /*#__PURE__*/react.createElement("path", {
    d: "M228.43 273.54v-4.17c0-.69-.46-2.77-3.23-2.77a2.8 2.8 0 0 0-3 2.77v4.17h6.23zm-7.16-13.18v-4.39c0-1.15-.7-2.3-2.08-2.3-1.39 0-2.08 1.15-2.08 2.3v4.4h4.16zm8.09 0v-4.39c0-1.15.69-2.3 2.08-2.3 1.38 0 2.08 1.15 2.08 2.3v4.4h-4.16z",
    fill: "#0039f0"
  })), _path479 || (_path479 = /*#__PURE__*/react.createElement("path", {
    d: "M234.18 281c0-10.1 7.27-18.29 16.25-18.29s16.26 8.2 16.26 18.3c0 10.1-7.28 18.29-16.26 18.29s-16.25-8.2-16.25-18.3",
    fill: "#ad1519"
  })), _path480 || (_path480 = /*#__PURE__*/react.createElement("path", {
    d: "M234.18 281c0-10.1 7.27-18.29 16.25-18.29s16.26 8.2 16.26 18.3c0 10.1-7.28 18.29-16.26 18.29s-16.25-8.2-16.25-18.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.61
  })), _path481 || (_path481 = /*#__PURE__*/react.createElement("path", {
    d: "M239 280.97c0-7.4 5.12-13.41 11.44-13.41 6.31 0 11.43 6 11.43 13.41s-5.12 13.42-11.43 13.42c-6.32 0-11.44-6-11.44-13.42",
    fill: "#005bbf"
  })), _path482 || (_path482 = /*#__PURE__*/react.createElement("path", {
    d: "M239 280.97c0-7.4 5.12-13.41 11.44-13.41 6.31 0 11.43 6 11.43 13.41s-5.12 13.42-11.43 13.42c-6.32 0-11.44-6-11.44-13.42z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.61
  })), _path483 || (_path483 = /*#__PURE__*/react.createElement("path", {
    d: "M245.03 271.74s-1.35 1.49-1.35 2.86c0 1.39.57 2.54.57 2.54a1.5 1.5 0 0 0-1.41-.94c-.83 0-1.5.63-1.5 1.42 0 .22.14.58.24.77l.5.99c.15-.37.53-.57.97-.57.6 0 1.08.45 1.08 1.01 0 .09-.01.17-.04.25h-1.22v1.04h1.1l-.82 1.6 1.07-.41.81.91.84-.91 1.07.42-.8-1.6h1.08v-1.05H246a1.04 1.04 0 0 1 1.04-1.26c.44 0 .82.2.99.57l.48-.99c.1-.2.24-.55.24-.77 0-.79-.66-1.42-1.5-1.42-.65 0-1.2.4-1.4.94 0 0 .57-1.15.57-2.54 0-1.38-1.39-2.86-1.39-2.86",
    fill: "#c8b100"
  })), _path484 || (_path484 = /*#__PURE__*/react.createElement("path", {
    d: "M245.03 271.74s-1.35 1.49-1.35 2.86c0 1.39.57 2.54.57 2.54a1.5 1.5 0 0 0-1.41-.94c-.83 0-1.5.63-1.5 1.42 0 .22.14.58.24.77l.5.99c.15-.37.53-.57.97-.57.6 0 1.08.45 1.08 1.01 0 .09-.01.17-.04.25h-1.22v1.04h1.1l-.82 1.6 1.07-.41.81.91.84-.91 1.07.42-.8-1.6h1.08v-1.05H246a1.04 1.04 0 0 1 1.04-1.26c.44 0 .82.2.99.57l.48-.99c.1-.2.24-.55.24-.77 0-.79-.66-1.42-1.5-1.42-.65 0-1.2.4-1.4.94 0 0 .57-1.15.57-2.54 0-1.38-1.39-2.86-1.39-2.86z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.34
  })), _path485 || (_path485 = /*#__PURE__*/react.createElement("path", {
    d: "M242.87 281.11h4.36v-1.04h-4.36v1.04z",
    fill: "#c8b100"
  })), _path486 || (_path486 = /*#__PURE__*/react.createElement("path", {
    d: "M242.87 281.11h4.36v-1.04h-4.36v1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.34
  })), _path487 || (_path487 = /*#__PURE__*/react.createElement("path", {
    d: "M255.66 271.74s-1.35 1.49-1.35 2.86c0 1.39.57 2.54.57 2.54a1.5 1.5 0 0 0-1.41-.94c-.83 0-1.5.63-1.5 1.42 0 .22.14.58.24.77l.49.99c.16-.37.54-.57.98-.57.6 0 1.07.45 1.07 1.01 0 .09 0 .17-.03.25h-1.22v1.04h1.1l-.82 1.6 1.07-.41.81.91.84-.91 1.07.42-.8-1.6h1.08v-1.05h-1.22a.88.88 0 0 1-.03-.25c0-.56.48-1 1.07-1 .44 0 .82.2.98.56l.49-.99c.1-.2.24-.55.24-.77 0-.79-.67-1.42-1.5-1.42-.64 0-1.2.4-1.4.94 0 0 .57-1.15.57-2.54 0-1.38-1.39-2.86-1.39-2.86",
    fill: "#c8b100"
  })), _path488 || (_path488 = /*#__PURE__*/react.createElement("path", {
    d: "M255.66 271.74s-1.35 1.49-1.35 2.86c0 1.39.57 2.54.57 2.54a1.5 1.5 0 0 0-1.41-.94c-.83 0-1.5.63-1.5 1.42 0 .22.14.58.24.77l.49.99c.16-.37.54-.57.98-.57.6 0 1.07.45 1.07 1.01 0 .09 0 .17-.03.25h-1.22v1.04h1.1l-.82 1.6 1.07-.41.81.91.84-.91 1.07.42-.8-1.6h1.08v-1.05h-1.22a.88.88 0 0 1-.03-.25c0-.56.48-1 1.07-1 .44 0 .82.2.98.56l.49-.99c.1-.2.24-.55.24-.77 0-.79-.67-1.42-1.5-1.42-.64 0-1.2.4-1.4.94 0 0 .57-1.15.57-2.54 0-1.38-1.39-2.86-1.39-2.86z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.34
  })), _path489 || (_path489 = /*#__PURE__*/react.createElement("path", {
    d: "M253.5 281.11h4.35v-1.04h-4.35v1.04z",
    fill: "#c8b100"
  })), _path490 || (_path490 = /*#__PURE__*/react.createElement("path", {
    d: "M253.5 281.11h4.35v-1.04h-4.35v1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.34
  })), _path491 || (_path491 = /*#__PURE__*/react.createElement("path", {
    d: "M250.35 280.88s-1.36 1.49-1.36 2.87c0 1.38.57 2.53.57 2.53a1.5 1.5 0 0 0-1.41-.94c-.83 0-1.5.63-1.5 1.42 0 .23.14.58.25.78l.48.98c.17-.36.54-.57.99-.57.59 0 1.07.45 1.07 1.02a.9.9 0 0 1-.03.25h-1.22v1.04h1.09l-.81 1.6 1.07-.42.8.91.85-.9 1.07.41-.81-1.6h1.09v-1.04h-1.22a.94.94 0 0 1-.03-.25c0-.57.47-1.02 1.07-1.02.44 0 .81.2.98.57l.49-.98c.1-.2.24-.55.24-.78 0-.79-.67-1.42-1.5-1.42-.65 0-1.2.4-1.41.94 0 0 .57-1.15.57-2.53s-1.39-2.87-1.39-2.87",
    fill: "#c8b100"
  })), _path492 || (_path492 = /*#__PURE__*/react.createElement("path", {
    d: "M250.35 280.88s-1.36 1.49-1.36 2.87c0 1.38.57 2.53.57 2.53a1.5 1.5 0 0 0-1.41-.94c-.83 0-1.5.63-1.5 1.42 0 .23.14.58.25.78l.48.98c.17-.36.54-.57.99-.57.59 0 1.07.45 1.07 1.02a.9.9 0 0 1-.03.25h-1.22v1.04h1.09l-.81 1.6 1.07-.42.8.91.85-.9 1.07.41-.81-1.6h1.09v-1.04h-1.22a.94.94 0 0 1-.03-.25c0-.57.47-1.02 1.07-1.02.44 0 .81.2.98.57l.49-.98c.1-.2.24-.55.24-.78 0-.79-.67-1.42-1.5-1.42-.65 0-1.2.4-1.41.94 0 0 .57-1.15.57-2.53s-1.39-2.87-1.39-2.87z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.34
  })), _path493 || (_path493 = /*#__PURE__*/react.createElement("path", {
    d: "M248.19 290.26h4.35v-1.04h-4.35v1.04z",
    fill: "#c8b100"
  })), _path494 || (_path494 = /*#__PURE__*/react.createElement("path", {
    d: "M248.19 290.26h4.35v-1.04h-4.35v1.04z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.34
  })), _path495 || (_path495 = /*#__PURE__*/react.createElement("path", {
    d: "m282.88 232.7-.29.03c-.01.03-.14.24-.26.35-.26.25-.64.27-.86.07a.5.5 0 0 1-.14-.4.52.52 0 0 1-.51-.02c-.26-.14-.32-.5-.14-.8.03-.05.06-.13.1-.17l-.01-.32-.35.08-.1.2c-.22.24-.54.3-.7.16a.58.58 0 0 1-.13-.27c0 .01-.09.09-.18.1-.53.14-.74-1.04-.76-1.34l-.17.25s.16.7.08 1.3c-.08.6-.3 1.2-.3 1.2.75.18 1.87.79 2.98 1.64a9.39 9.39 0 0 1 2.35 2.42s.57-.32 1.17-.5c.6-.2 1.36-.2 1.36-.2l.22-.22c-.32.05-1.59.1-1.56-.43 0-.08.07-.18.08-.18 0 .01-.21 0-.3-.06-.18-.13-.18-.43.02-.69l.18-.13.01-.34-.34.05c-.03.04-.1.09-.15.13-.27.23-.65.25-.86.03a.44.44 0 0 1-.11-.46.57.57 0 0 1-.45-.05c-.26-.15-.31-.52-.11-.8.1-.14.28-.3.3-.32l-.06-.3",
    fill: "#c8b100"
  })), _path496 || (_path496 = /*#__PURE__*/react.createElement("path", {
    d: "m282.88 232.7-.29.03c-.01.03-.14.24-.26.35-.26.25-.64.27-.86.07a.5.5 0 0 1-.14-.4.52.52 0 0 1-.51-.02c-.26-.14-.32-.5-.14-.8.03-.05.06-.13.1-.17l-.01-.32-.35.08-.1.2c-.22.24-.54.3-.7.16a.58.58 0 0 1-.13-.27c0 .01-.09.09-.18.1-.53.14-.74-1.04-.76-1.34l-.17.25s.16.7.08 1.3c-.08.6-.3 1.2-.3 1.2.75.18 1.87.79 2.98 1.64a9.39 9.39 0 0 1 2.35 2.42s.57-.32 1.17-.5c.6-.2 1.36-.2 1.36-.2l.22-.22c-.32.05-1.59.1-1.56-.43 0-.08.07-.18.08-.18 0 .01-.21 0-.3-.06-.18-.13-.18-.43.02-.69l.18-.13.01-.34-.34.05c-.03.04-.1.09-.15.13-.27.23-.65.25-.86.03a.44.44 0 0 1-.11-.46.57.57 0 0 1-.45-.05c-.26-.15-.31-.52-.11-.8.1-.14.28-.3.3-.32l-.06-.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path497 || (_path497 = /*#__PURE__*/react.createElement("path", {
    d: "M280.63 233.4c.05-.07.16-.06.23 0 .08.06.1.16.06.21-.05.06-.15.06-.24 0-.07-.06-.1-.16-.05-.22"
  })), _path498 || (_path498 = /*#__PURE__*/react.createElement("path", {
    d: "M280.63 233.4c.05-.07.16-.06.23 0 .08.06.1.16.06.21-.05.06-.15.06-.24 0-.07-.06-.1-.16-.05-.22z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path499 || (_path499 = /*#__PURE__*/react.createElement("path", {
    d: "m281.58 234.2-.33-.26c-.06-.04-.07-.12-.04-.16.04-.04.12-.04.18 0l.32.26.34.25c.06.04.08.12.04.16-.04.04-.12.04-.18 0l-.33-.26"
  })), _path500 || (_path500 = /*#__PURE__*/react.createElement("path", {
    d: "m281.58 234.2-.33-.26c-.06-.04-.07-.12-.04-.16.04-.04.12-.04.18 0l.32.26.34.25c.06.04.08.12.04.16-.04.04-.12.04-.18 0l-.33-.26",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path501 || (_path501 = /*#__PURE__*/react.createElement("path", {
    d: "m279.84 233-.26-.15c-.07-.04-.1-.12-.07-.16.03-.06.1-.07.17-.03l.26.16.26.15c.06.03.1.1.07.16-.03.05-.1.06-.17.02l-.26-.15"
  })), _path502 || (_path502 = /*#__PURE__*/react.createElement("path", {
    d: "m279.84 233-.26-.15c-.07-.04-.1-.12-.07-.16.03-.06.1-.07.17-.03l.26.16.26.15c.06.03.1.1.07.16-.03.05-.1.06-.17.02l-.26-.15",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path503 || (_path503 = /*#__PURE__*/react.createElement("path", {
    d: "M278.8 232.29c.05-.06.16-.06.24 0 .08.06.1.16.05.22-.05.05-.15.05-.23 0-.08-.07-.1-.16-.06-.22"
  })), _path504 || (_path504 = /*#__PURE__*/react.createElement("path", {
    d: "M278.8 232.29c.05-.06.16-.06.24 0 .08.06.1.16.05.22-.05.05-.15.05-.23 0-.08-.07-.1-.16-.06-.22z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path505 || (_path505 = /*#__PURE__*/react.createElement("path", {
    d: "M282.63 234.93c.05-.06.02-.15-.05-.22-.08-.06-.19-.06-.23 0-.05.05-.03.15.05.21s.18.06.23 0"
  })), _path506 || (_path506 = /*#__PURE__*/react.createElement("path", {
    d: "M282.63 234.93c.05-.06.02-.15-.05-.22-.08-.06-.19-.06-.23 0-.05.05-.03.15.05.21s.18.06.23 0z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path507 || (_path507 = /*#__PURE__*/react.createElement("path", {
    d: "m283.2 235.58.22.2c.05.06.13.08.18.04.04-.04.04-.11-.01-.16l-.21-.2-.22-.22c-.05-.05-.14-.07-.18-.03-.05.03-.04.11.01.16l.21.21"
  })), _path508 || (_path508 = /*#__PURE__*/react.createElement("path", {
    d: "m283.2 235.58.22.2c.05.06.13.08.18.04.04-.04.04-.11-.01-.16l-.21-.2-.22-.22c-.05-.05-.14-.07-.18-.03-.05.03-.04.11.01.16l.21.21",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path509 || (_path509 = /*#__PURE__*/react.createElement("path", {
    d: "M284.15 236.4c.05-.07.03-.16-.05-.22-.08-.07-.18-.07-.23 0-.05.05-.03.14.05.2s.18.07.23.01"
  })), _path510 || (_path510 = /*#__PURE__*/react.createElement("path", {
    d: "M284.15 236.4c.05-.07.03-.16-.05-.22-.08-.07-.18-.07-.23 0-.05.05-.03.14.05.2s.18.07.23.01z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path511 || (_path511 = /*#__PURE__*/react.createElement("path", {
    d: "m281.4 230.35-.59.02-.11.87.06.14h.15l.76-.52-.27-.5",
    fill: "#c8b100"
  })), _path512 || (_path512 = /*#__PURE__*/react.createElement("path", {
    d: "m281.4 230.35-.59.02-.11.87.06.14h.15l.76-.52-.27-.5",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path513 || (_path513 = /*#__PURE__*/react.createElement("path", {
    d: "m279.8 230.84-.02.54.92.12.15-.07-.02-.15-.53-.7-.5.26",
    fill: "#c8b100"
  })), _path514 || (_path514 = /*#__PURE__*/react.createElement("path", {
    d: "m279.8 230.84-.02.54.92.12.15-.07-.02-.15-.53-.7-.5.26",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path515 || (_path515 = /*#__PURE__*/react.createElement("path", {
    d: "m281.7 231.92-.5.27-.53-.71v-.15l.13-.06.93.11-.03.54",
    fill: "#c8b100"
  })), _path516 || (_path516 = /*#__PURE__*/react.createElement("path", {
    d: "m281.7 231.92-.5.27-.53-.71v-.15l.13-.06.93.11-.03.54",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path517 || (_path517 = /*#__PURE__*/react.createElement("path", {
    d: "M280.51 231.25a.3.3 0 0 1 .4-.1c.13.08.17.25.1.38a.3.3 0 0 1-.4.1.27.27 0 0 1-.1-.38",
    fill: "#c8b100"
  })), _path518 || (_path518 = /*#__PURE__*/react.createElement("path", {
    d: "M280.51 231.25a.3.3 0 0 1 .4-.1c.13.08.17.25.1.38a.3.3 0 0 1-.4.1.27.27 0 0 1-.1-.38z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path519 || (_path519 = /*#__PURE__*/react.createElement("path", {
    d: "M278.36 230.35c-.01 0-.13-.46-.26-.71-.08-.19-.39-.43-.39-.43.03-.06.42-.2.87.1.38.3-.03.86-.03.86s-.1.14-.19.18",
    fill: "#c8b100"
  })), _path520 || (_path520 = /*#__PURE__*/react.createElement("path", {
    d: "M278.36 230.35c-.01 0-.13-.46-.26-.71-.08-.19-.39-.43-.39-.43.03-.06.42-.2.87.1.38.3-.03.86-.03.86s-.1.14-.19.18z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path521 || (_path521 = /*#__PURE__*/react.createElement("path", {
    d: "m279.4 230.66-.43.37-.68-.6.06-.08.02-.15.93-.07.1.53",
    fill: "#c8b100"
  })), _path522 || (_path522 = /*#__PURE__*/react.createElement("path", {
    d: "m279.4 230.66-.43.37-.68-.6.06-.08.02-.15.93-.07.1.53",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path523 || (_path523 = /*#__PURE__*/react.createElement("path", {
    d: "M278.24 230.3c.05-.16.18-.24.28-.21.1.04.15.18.1.33-.05.15-.18.23-.29.2-.1-.03-.15-.18-.1-.33",
    fill: "#c8b100"
  })), _path524 || (_path524 = /*#__PURE__*/react.createElement("path", {
    d: "M278.24 230.3c.05-.16.18-.24.28-.21.1.04.15.18.1.33-.05.15-.18.23-.29.2-.1-.03-.15-.18-.1-.33z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path525 || (_path525 = /*#__PURE__*/react.createElement("path", {
    d: "m283.67 231.77-.6-.06-.24.85.05.14h.15l.83-.4-.2-.53",
    fill: "#c8b100"
  })), _path526 || (_path526 = /*#__PURE__*/react.createElement("path", {
    d: "m283.67 231.77-.6-.06-.24.85.05.14h.15l.83-.4-.2-.53",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path527 || (_path527 = /*#__PURE__*/react.createElement("path", {
    d: "m282 232.03-.09.54.9.24.15-.05v-.14l-.42-.79-.53.2",
    fill: "#c8b100"
  })), _path528 || (_path528 = /*#__PURE__*/react.createElement("path", {
    d: "m282 232.03-.09.54.9.24.15-.05v-.14l-.42-.79-.53.2",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path529 || (_path529 = /*#__PURE__*/react.createElement("path", {
    d: "m283.73 233.35-.53.22-.42-.79.01-.15.15-.03.9.23-.1.52",
    fill: "#c8b100"
  })), _path530 || (_path530 = /*#__PURE__*/react.createElement("path", {
    d: "m283.73 233.35-.53.22-.42-.79.01-.15.15-.03.9.23-.1.52",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path531 || (_path531 = /*#__PURE__*/react.createElement("path", {
    d: "M282.65 232.54c.1-.12.28-.13.4-.04.13.1.15.26.05.38a.3.3 0 0 1-.4.04.26.26 0 0 1-.05-.38",
    fill: "#c8b100"
  })), _path532 || (_path532 = /*#__PURE__*/react.createElement("path", {
    d: "M282.65 232.54c.1-.12.28-.13.4-.04.13.1.15.26.05.38a.3.3 0 0 1-.4.04.26.26 0 0 1-.05-.38z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path533 || (_path533 = /*#__PURE__*/react.createElement("path", {
    d: "m285.64 233.6.11.56-.87.3-.15-.03-.02-.15.36-.8.57.13",
    fill: "#c8b100"
  })), _path534 || (_path534 = /*#__PURE__*/react.createElement("path", {
    d: "m285.64 233.6.11.56-.87.3-.15-.03-.02-.15.36-.8.57.13",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path535 || (_path535 = /*#__PURE__*/react.createElement("path", {
    d: "m285.49 235.2-.56.13-.31-.84.03-.14.16-.02.85.35-.17.52",
    fill: "#c8b100"
  })), _path536 || (_path536 = /*#__PURE__*/react.createElement("path", {
    d: "m285.49 235.2-.56.13-.31-.84.03-.14.16-.02.85.35-.17.52",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path537 || (_path537 = /*#__PURE__*/react.createElement("path", {
    d: "m283.97 233.66-.18.52.85.34.16-.02.03-.14-.3-.83-.56.13",
    fill: "#c8b100"
  })), _path538 || (_path538 = /*#__PURE__*/react.createElement("path", {
    d: "m283.97 233.66-.18.52.85.34.16-.02.03-.14-.3-.83-.56.13",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path539 || (_path539 = /*#__PURE__*/react.createElement("path", {
    d: "M284.91 234.63c.12-.11.12-.28.02-.4a.31.31 0 0 0-.41 0 .27.27 0 0 0-.01.38c.1.11.29.12.4.02",
    fill: "#c8b100"
  })), _path540 || (_path540 = /*#__PURE__*/react.createElement("path", {
    d: "M284.91 234.63c.12-.11.12-.28.02-.4a.31.31 0 0 0-.41 0 .27.27 0 0 0-.01.38c.1.11.29.12.4.02z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path541 || (_path541 = /*#__PURE__*/react.createElement("path", {
    d: "M286.29 236.43c0 .01.5.03.79.09.2.04.52.27.52.27.06-.04.11-.42-.28-.78-.4-.29-.88.2-.88.2s-.12.13-.15.22",
    fill: "#c8b100"
  })), _path542 || (_path542 = /*#__PURE__*/react.createElement("path", {
    d: "M286.29 236.43c0 .01.5.03.79.09.2.04.52.27.52.27.06-.04.11-.42-.28-.78-.4-.29-.88.2-.88.2s-.12.13-.15.22z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path543 || (_path543 = /*#__PURE__*/react.createElement("path", {
    d: "m285.75 235.53-.29.47.76.51.1-.08.12-.04-.12-.88-.57.03",
    fill: "#c8b100"
  })), _path544 || (_path544 = /*#__PURE__*/react.createElement("path", {
    d: "m285.75 235.53-.29.47.76.51.1-.08.12-.04-.12-.88-.57.03",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path545 || (_path545 = /*#__PURE__*/react.createElement("path", {
    d: "M286.37 236.53c.14-.07.2-.22.15-.3-.06-.1-.22-.1-.36-.03-.14.08-.2.22-.14.31.05.1.21.1.35.02",
    fill: "#c8b100"
  })), _path546 || (_path546 = /*#__PURE__*/react.createElement("path", {
    d: "M286.37 236.53c.14-.07.2-.22.15-.3-.06-.1-.22-.1-.36-.03-.14.08-.2.22-.14.31.05.1.21.1.35.02z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26
  })), _path547 || (_path547 = /*#__PURE__*/react.createElement("path", {
    d: "M326.13 213.64v.58h-2.53v-.58h.94v-1.3h-.62v-.59h.62v-.57h.6v.57h.62v.59h-.61v1.3h.98",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path548 || (_path548 = /*#__PURE__*/react.createElement("path", {
    d: "M175.44 226.15v-1.27",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.02
  })), _path549 || (_path549 = /*#__PURE__*/react.createElement("path", {
    d: "M175.1 226.15v-1.27",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.03
  })), _path550 || (_path550 = /*#__PURE__*/react.createElement("path", {
    d: "M174.77 226.15v-1.27m-.33 1.27v-1.27",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.04
  })), _path551 || (_path551 = /*#__PURE__*/react.createElement("path", {
    d: "M174.16 226.15v-1.27",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path552 || (_path552 = /*#__PURE__*/react.createElement("path", {
    d: "M173.6 226.08v-1.15m.27 1.17v-1.21",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.06
  })), _path553 || (_path553 = /*#__PURE__*/react.createElement("path", {
    d: "M173.1 226.03v-1.06m.26 1.09v-1.13",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.07
  })), _path554 || (_path554 = /*#__PURE__*/react.createElement("path", {
    d: "M172.43 225.97v-.94m.22.95v-.97m.23 1V225",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.08
  })), _path555 || (_path555 = /*#__PURE__*/react.createElement("path", {
    d: "M172.19 225.96v-.9",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.09
  })), _path556 || (_path556 = /*#__PURE__*/react.createElement("path", {
    d: "M171.97 225.92v-.85",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1
  })), _path557 || (_path557 = /*#__PURE__*/react.createElement("path", {
    d: "M171.73 225.9v-.79",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.11
  })), _path558 || (_path558 = /*#__PURE__*/react.createElement("path", {
    d: "M171.24 225.82v-.62m.25.66v-.7m-.49.61v-.55",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.12
  })), _path559 || (_path559 = /*#__PURE__*/react.createElement("path", {
    d: "M170.76 225.73v-.46",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.13
  })), _path560 || (_path560 = /*#__PURE__*/react.createElement("path", {
    d: "M170.51 225.67v-.36",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.14
  })), _path561 || (_path561 = /*#__PURE__*/react.createElement("path", {
    d: "M170.26 225.64v-.27",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.15
  })), _path562 || (_path562 = /*#__PURE__*/react.createElement("path", {
    d: "M169.99 225.58v-.13",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.18
  })), _path563 || (_path563 = /*#__PURE__*/react.createElement("path", {
    d: "M176.8 226.08v-1.16m-.58 1.2v-1.23m-.42 1.25v-1.26",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.01
  })), _path564 || (_path564 = /*#__PURE__*/react.createElement("path", {
    d: "M324.77 226.17v-1.27",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.02
  })), _path565 || (_path565 = /*#__PURE__*/react.createElement("path", {
    d: "M324.42 226.17v-1.27",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.03
  })), _path566 || (_path566 = /*#__PURE__*/react.createElement("path", {
    d: "M324.1 226.17v-1.27m-.32 1.27v-1.27",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.04
  })), _path567 || (_path567 = /*#__PURE__*/react.createElement("path", {
    d: "M323.49 226.17v-1.27",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path568 || (_path568 = /*#__PURE__*/react.createElement("path", {
    d: "M322.94 226.1v-1.15m.26 1.17v-1.2",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.06
  })), _path569 || (_path569 = /*#__PURE__*/react.createElement("path", {
    d: "M322.44 226.05V225m.25 1.1v-1.14",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.07
  })), _path570 || (_path570 = /*#__PURE__*/react.createElement("path", {
    d: "M321.76 226v-.94m.22.95v-.98m.23 1v-1.01",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.08
  })), _path571 || (_path571 = /*#__PURE__*/react.createElement("path", {
    d: "M321.52 225.98v-.9",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.09
  })), _path572 || (_path572 = /*#__PURE__*/react.createElement("path", {
    d: "M321.3 225.94v-.84",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1
  })), _path573 || (_path573 = /*#__PURE__*/react.createElement("path", {
    d: "M321.06 225.91v-.78",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.11
  })), _path574 || (_path574 = /*#__PURE__*/react.createElement("path", {
    d: "M320.57 225.85v-.63m.25.66v-.7m-.5.62v-.55",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.12
  })), _path575 || (_path575 = /*#__PURE__*/react.createElement("path", {
    d: "M320.1 225.75v-.46",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.13
  })), _path576 || (_path576 = /*#__PURE__*/react.createElement("path", {
    d: "M319.85 225.69v-.36",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.14
  })), _path577 || (_path577 = /*#__PURE__*/react.createElement("path", {
    d: "M319.6 225.66v-.27",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.15
  })), _path578 || (_path578 = /*#__PURE__*/react.createElement("path", {
    d: "M319.32 225.6v-.13",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.18
  })), _path579 || (_path579 = /*#__PURE__*/react.createElement("path", {
    d: "M326.14 226.1v-1.16m-.58 1.2v-1.23m-.43 1.25v-1.26",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.01
  })));
};

/* harmony default export */ var es = (SvgEs);
;// CONCATENATED MODULE: ./public/flags/dk.svg
var dk_path, dk_path2, dk_path3;

function dk_extends() { dk_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return dk_extends.apply(this, arguments); }



var SvgDk = function SvgDk(props) {
  return /*#__PURE__*/react.createElement("svg", dk_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 370 280"
  }, props), dk_path || (dk_path = /*#__PURE__*/react.createElement("path", {
    fill: "#c60c30",
    d: "M0 0h370v280H0z"
  })), dk_path2 || (dk_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M120 0h40v280h-40z"
  })), dk_path3 || (dk_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 120h370v40H0z"
  })));
};

/* harmony default export */ var dk = (SvgDk);
;// CONCATENATED MODULE: ./public/flags/no.svg
var no_path, no_path2, no_path3, no_path4, no_path5;

function no_extends() { no_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return no_extends.apply(this, arguments); }



var SvgNo = function SvgNo(props) {
  return /*#__PURE__*/react.createElement("svg", no_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1100 800"
  }, props), no_path || (no_path = /*#__PURE__*/react.createElement("path", {
    fill: "#ef2b2d",
    d: "M0 0h1100v800H0z"
  })), no_path2 || (no_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M300 0h200v800H300z"
  })), no_path3 || (no_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 300h1100v200H0z"
  })), no_path4 || (no_path4 = /*#__PURE__*/react.createElement("path", {
    fill: "#002868",
    d: "M350 0h100v800H350z"
  })), no_path5 || (no_path5 = /*#__PURE__*/react.createElement("path", {
    fill: "#002868",
    d: "M0 350h1100v100H0z"
  })));
};

/* harmony default export */ var no = (SvgNo);
;// CONCATENATED MODULE: ./public/flags/hr.svg
var hr_path, hr_path2, hr_path3, hr_path4, hr_path5, _g, hr_path6, hr_path7, hr_path8, hr_path9, _g2, hr_path10, _g3, _g4, hr_path11, hr_path12, _g5, hr_path13, hr_path14, hr_path15, _g6, hr_path16, hr_path17, hr_path18, hr_path19, hr_path20, hr_path21, _g7;

function hr_extends() { hr_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return hr_extends.apply(this, arguments); }



var SvgHr = function SvgHr(props) {
  return /*#__PURE__*/react.createElement("svg", hr_extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1200 600"
  }, props), hr_path || (hr_path = /*#__PURE__*/react.createElement("path", {
    fill: "#171796",
    d: "M0 0h1200v600H0z"
  })), hr_path2 || (hr_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h1200v400H0z"
  })), hr_path3 || (hr_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "red",
    d: "M0 0h1200v200H0z"
  })), hr_path4 || (hr_path4 = /*#__PURE__*/react.createElement("path", {
    fill: "red",
    d: "M600.037 455.185c64.152 0 116.636-52.487 116.636-116.635V199.954H483.399V338.55c0 64.151 52.487 116.635 116.635 116.635z"
  })), hr_path5 || (hr_path5 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M600.037 453.316c62.928 0 114.411-51.485 114.411-114.41V202.198H485.623v136.706c0 62.929 51.486 114.411 114.414 114.411z"
  })), _g || (_g = /*#__PURE__*/react.createElement("g", {
    fill: "red"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M533.916 206.5h-44.03v48.376h44.03zM533.916 303.249h44.03v-48.373h-44.03zM489.886 338.636c0 4.393.272 8.726.779 12.988h43.251V303.25h-44.03v35.387zM621.98 303.249h-44.034v48.375h44.034zM621.98 399.997h44.03v-48.373h-44.03zM666.01 426.46A111.488 111.488 0 0 0 691.15 400H666.01v26.46zM533.919 399.997h44.03v-48.373h-44.03zM508.739 399.997a111.46 111.46 0 0 0 25.18 26.492v-26.492h-25.18z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M607.632 448.373a109.46 109.46 0 0 0 14.345-1.958v-46.418h-44.03v46.424c4.668.957 9.445 1.611 14.303 1.949 5.127.317 10.254.299 15.379 0zM709.217 351.624c.51-4.277.782-8.625.782-13.033v-35.34h-43.992v48.376h43.21zM621.98 303.249h44.03v-48.373h-44.03zM621.98 206.5h-44.03v48.376h44.03zM710 254.876V206.5h-43.99v48.376z"
  }))), hr_path6 || (hr_path6 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "m712.464 198.535 27.3-61.885-20.799-33.587-34.46 12.758-24.194-27.656-31.88 18.27-28.426-23.282-28.427 23.281-31.88-18.27-24.197 27.654-34.46-12.757-20.805 33.595 27.265 61.897c34.357-15.55 72.451-24.214 112.507-24.214 40.037 0 78.114 8.658 112.461 24.196z"
  })), hr_path7 || (hr_path7 = /*#__PURE__*/react.createElement("path", {
    fill: "#0093dd",
    d: "m516.26 118.552-.051.06-34.173-12.655-19.123 30.876 7.325 16.656 18.558 42.126a274.588 274.588 0 0 1 43.227-14.953l-15.76-62.107z"
  })), hr_path8 || (hr_path8 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.34976248,
    d: "M514.293 149.084a16.572 16.572 0 0 1 1.916 7.752c0 9.2-7.503 16.703-16.703 16.703-8.107 0-14.896-5.83-16.395-13.51 2.885 5.1 8.362 8.554 14.618 8.554 9.244 0 16.786-7.538 16.786-16.785 0-.925-.077-1.83-.222-2.717z"
  })), hr_path9 || (hr_path9 = /*#__PURE__*/react.createElement("path", {
    d: "m498.985 125.975-.056.275-1.165 5.995 4.6 4.02.21.183-.266.092-5.773 1.99-1.182 5.993-.056.275-.21-.186-4.61-4.005-5.778 1.973-.27.092.057-.279 1.164-5.992-4.597-4.02-.213-.186.266-.092 5.773-1.987 1.182-5.993.056-.275.21.184 4.61 4.007 5.778-1.972z"
  })), _g2 || (_g2 = /*#__PURE__*/react.createElement("g", {
    fill: "#f7db17"
  }, /*#__PURE__*/react.createElement("path", {
    d: "m492.048 134.488 4.31 3.758 5.393-1.857zM492.083 134.298l9.707 1.899-4.295-3.756zM481.663 132.257l9.704 1.899-4.31-3.756zM491.331 134.348l-9.707-1.898 4.295 3.753zM491.873 133.984l6.499-7.455-5.4 1.842zM484.895 141.99l6.498-7.455-5.408 1.854zM491.541 134.662l-6.498 7.456 5.4-1.843zM498.52 126.656l-6.499 7.455 5.409-1.854zM491.497 134.008l-3.208-9.354-1.105 5.598zM494.942 144.055l-3.208-9.354-1.1 5.61zM491.917 134.636l3.208 9.357 1.105-5.599zM488.473 124.588l3.208 9.358 1.098-5.614z"
  }))), hr_path10 || (hr_path10 = /*#__PURE__*/react.createElement("path", {
    fill: "#171796",
    d: "m571.874 109.257-.059.047-31.614-18.115-23.942 27.363 15.761 62.108a274.725 274.725 0 0 1 45.147-7.542l-5.296-63.86z"
  })), _g3 || (_g3 = /*#__PURE__*/react.createElement("g", {
    fill: "red"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M528.11 165.245a290.314 290.314 0 0 1 47.745-7.974l-1.339-16.143a306.934 306.934 0 0 0-50.392 8.416l3.983 15.701zM520.187 134.031a322.445 322.445 0 0 1 53.005-8.853l-1.315-15.847a338.401 338.401 0 0 0-55.603 9.286l3.913 15.414z"
  }))), _g4 || (_g4 = /*#__PURE__*/react.createElement("g", {
    transform: "scale(.00296)"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#0093dd",
    d: "m212105 36890-23 13-9517-7794-9497 7778 1788 21560c2543-210 5113-322 7709-322 2608 0 5190 113 7744 325l1795-21560z"
  }), /*#__PURE__*/react.createElement("g", {
    id: "hr_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M202545 46585c-18-2-44 10-69 45-186 250-359 469-545 720-195 61-242 180-167 348-261-26-291 193-302 432-250-379-522-482-814-307-11-230-187-338-439-392-180-10-319-65-436-145-60-42-110-64-170-106-126-88-226-5-172 74 267 434 535 868 802 1302-14 80 6 151 88 204 47 133 93 265 140 397-11 38-21 75-32 113-221-105-443-118-664-133-170-8-287-50-361-137-54-63-91-26-92 82-3 534 162 1014 599 1492-231 4-462 11-694 21-79 6-95 39-73 104 126 304 339 579 822 766-208 112-327 285-357 520-9 224-75 382-212 455-60 32-81 65-24 106 253 185 565 193 895 112-157 270-226 553-198 850 208 56 412 15 614-52-29 61-44 175-52 309-7 115-41 229-104 343-32 33-65 84 4 102 336 91 648 52 915-47 0 243 2 487 76 727 18 58 70 102 125 26 155-214 322-396 527-517 31 90 75 168 156 215 96 55 147 170 153 343 0 30-2 60 35 90 149 7 514-380 589-597 206 121 284 246 439 461 55 76 99 29 128-25 62-243 67-481 66-724 267 99 579 138 915 47 69-19 36-70 4-102-62-114-105-250-113-365-9-133-14-226-43-287 202 68 405 108 614 52 29-297-53-579-211-850 330 80 655 73 908-112 57-41 35-74-24-106-136-73-203-231-212-455-30-235-149-409-357-520 483-187 696-463 822-766 22-66 6-99-73-104-231-10-480-24-711-27 437-478 606-961 604-1495-1-108-38-146-92-82-74 87-179 137-348 146-222 15-435 24-656 128-11-38-21-75-32-113 46-132 106-260 153-393 82-53 102-123 88-204 267-434 513-868 781-1302 54-79-46-162-171-74-60 42-110 64-170 106-117 80-257 134-437 145-251 54-417 167-428 397-293-175-564-73-814 307-11-239-41-457-302-432 75-168 17-291-178-352-186-250-458-470-644-720-31-35-51-47-69-45z"
  }), /*#__PURE__*/react.createElement("g", {
    fill: "#f7db17"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M205075 47978c-51-26-124 17-162 95s-33 170 19 196c40 20 84-6 119-56l22-36c2-3 4-6 5-9 38-78 49-163-2-188zM200067 47978c52-26 124 17 162 95s39 165-13 191-103-24-141-102-60-158-9-184zM204606 48883c-32 0-59 27-59 59s26 59 59 59 59-26 59-59c0-32-26-59-59-59zM200574 48883c-32 0-59 26-59 59 0 32 26 59 59 59s59-26 59-59-26-59-59-59zM204868 48579c-754-91-1506-133-2260-133s-1509 41-2269 115c-26 8-21 90 14 86 756-73 1507-113 2256-113 743 0 1485 40 2228 129 39 4 54-80 32-84z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M200319 48495c768-75 1530-117 2289-116 754 0 1507 42 2261 133l111-184c-32 10-62 9-90-5-76-38-92-161-36-274 56-114 164-175 240-138 39 19 62 62 68 114l446-739c-204 130-328 214-581 252-281 41-409 139-368 307 38 156-57 133-201 54-314-171-541 71-652 353-73 186-159 181-168-13-4-70 0-131-7-200-21-223-89-286-216-224-161 78-175 25-137-58 28-60 86-128 66-221-9-67-66-92-151-98-182-244-467-483-649-727-182 244-374 483-556 727-86 5-142 30-152 98-20 93 52 157 80 217 38 82 23 135-137 57-127-61-186-3-207 220-7 69-10 139-13 209-9 194-95 199-168 13-111-282-352-524-667-353-145 79-203 102-182-54 23-172-107-266-388-307-253-37-377-122-581-252l419 682c12-25 29-45 53-57 76-38 184 24 240 138 56 113 40 237-36 274-10 5-21 8-32 10l100 163zM204708 49406c-7 3-7 4-24 11-46 19-80 66-134 124-57 60-128 125-211 188-12 10-25 19-44-6s-7-35 6-44c80-62 149-124 204-182 30-32 56-63 77-92-95-11-190-21-284-30-79 24-157 55-222 95-59 35-107 77-137 125-8 14-16 27-44 11-27-16-19-30-11-44 35-58 91-107 158-147 33-20 69-38 106-54-107-9-214-18-321-25-22 13-42 29-61 47-20 19-39 42-56 67-9 13-18 26-44 8s-18-31-8-44c19-29 41-54 64-77l9-9c-80-5-161-10-241-14-2 2-5 5-8 7-21 18-40 38-55 59s-28 43-38 67c-6 15-12 29-41 18-29-12-23-26-17-41 12-29 27-55 45-81 8-11 18-22 27-33-115-5-230-9-344-12-4 5-9 8-14 11-25 15-47 32-66 51s-35 40-48 63c-8 14-16 28-43 12-28-16-20-29-12-43 16-28 35-54 59-77 7-7 14-13 21-19-122-2-244-4-365-4-120 0-240 1-360 3 8 7 15 13 22 20 23 23 42 49 59 77 8 14 16 27-12 43s-35 2-44-12c-13-23-29-44-48-63s-41-36-66-51c-6-3-12-7-15-12-115 2-230 6-345 11 11 11 20 23 29 35 19 25 33 52 45 81 6 15 12 29-17 41s-35-3-41-18c-9-24-22-46-38-67-15-21-34-41-55-59-4-3-7-6-10-10-81 4-162 8-243 13 4 4 9 8 13 12 24 23 45 48 64 77 9 13 18 26-8 44s-35 5-44-8c-18-26-36-48-56-67s-41-35-64-49c-1-1-3-2-5-3-110 7-220 14-330 23 43 18 85 38 122 61 67 40 124 89 158 147 8 14 16 27-11 44-27 16-35 3-44-11-29-48-78-90-137-125-72-44-159-77-246-102h-2c-90 7-179 15-268 24 22 33 51 68 86 106 55 58 124 120 204 182 13 9 25 19 6 44s-32 15-44 6c-83-64-155-128-211-188-37-38-99-111-135-140-196-90-354-127-575-147-153-14-318-9-458-79 36 85 75 164 126 229 53 68 120 121 209 147 8 2 21 16 22 25 28 157 84 286 169 386 52 60 114 110 188 149-75-81-132-166-172-251-67-142-90-286-77-420 1-16 3-32 34-29 32 3 30 19 29 35-11 123 9 256 72 387 56 118 159 237 291 346 24 19 0 63-29 55-154-44-290-123-383-231-89-104-149-237-180-397-94-32-165-90-222-164-47-60-85-131-118-205 28 428 182 801 456 1137 61 75 165 182 255 216 92 35 95 100-20 101-34 1-69 1-105 1 84 31 164 66 233 105 127 73 217 162 224 273 1 16 2 32-29 34-32 2-33-14-34-29-6-86-82-160-192-223-113-65-259-117-402-160-154 0-312-1-459 3 39 28 80 57 131 84 82 44 188 86 343 122 89 21 166 52 233 91 71 42 130 93 177 150 10 12 20 25-5 45s-34 8-45-5c-42-52-95-98-159-135-61-36-133-64-216-84-161-38-272-81-358-128-75-40-131-82-184-123 180 393 450 573 835 689 23 7 43 13 61 19 3 1 6 1 9 2 86 21 175 40 266 55 92 15 166 28 261 37 16 1 32 3 29 34-3 32-19 30-34 29-99-9-174-22-266-38-58-10-115-21-171-33-26 6-64 9-107 12-232 14-420 225-435 494 0 5 0 11-1 16 88-80 179-157 273-212 117-68 239-103 364-69 15 4 31 8 22 39-8 31-23 27-39 22-106-28-212 3-316 63-108 63-213 158-315 253-24 147-82 285-205 377 61 34 104 65 163 45 86-39 172-78 261-108 91-31 184-52 282-57 16-1 32-1 33 31s-14 32-31 33c-91 4-179 24-264 53-75 26-149 58-222 91 221 47 460-1 667-79 60-22 105-42 133-41 51-30 112-53 172-79 66-28 132-51 182-57 16-2 32-4 35 28 4 32-12 33-28 35-112 13-127 21-222 79 0 21-66 57-126 96-36 24-70 52-87 67-95 86-144 181-188 287-29 70-52 145-68 224 55-108 121-211 201-303 94-108 208-201 345-265 14-7 29-13 42 15 13 29-1 35-15 42-129 60-236 147-324 250-90 103-161 222-219 345-31 64-8 1-42 86 110-122 212-224 323-307 132-100 283-157 418-133 15 3 31 6 26 37s-21 28-37 26c-116-21-250 32-369 121-121 92-244 223-366 361 184 26 366-26 542-85 91-30 183-135 239-152 19-24 38-46 57-67 33-37 67-71 102-100 12-10 24-20 45 4s8 34-4 45c-33 28-65 60-96 94-32 35-62 73-92 113-6 8-13 17-24 16-60 70-151 162-172 240-57 210-25 370-122 576 71-38 128-81 175-134 53-60 94-135 128-230 37-104 95-195 167-270 75-77 165-136 261-172 15-5 30-11 41 19s-4 35-19 41c-87 32-169 86-238 157-66 68-119 151-153 247-37 102-81 183-141 250-44 50-95 91-156 127 52-3 78-10 121-7 79-6 211-66 279-119 66-51 116-120 154-206 6-15 13-29 42-16s23 27 16 42c-42 96-99 174-173 231-56 43-121 75-196 93 161-5 311-42 467-100 65-24 87-168 127-208 32-58 66-112 105-158 47-56 101-101 164-127 15-6 29-12 41 18 12 29-3 35-17 41-52 21-98 60-139 108-36 42-68 93-98 147 10 73-51 228-53 305-7 205-2 409 53 612 53-71 107-134 162-192 0-5 0-10 1-15 18-106 33-219 40-332 7-112 7-223-6-329-2-16-4-32 27-35 32-4 34 12 35 28 14 111 14 226 7 340-6 90-16 180-30 269 54-51 53-51 77-103 37-80 59-159 67-237 9-80 5-157-13-230-4-15-7-31 24-38s35 8 38 24c19 80 25 165 14 252-8 65-24 132-49 199 56-42 114-82 178-122-4-75-5-153-3-227 2-68 7-134 18-190 4-20 7-40 47-33s37 27 33 48c-9 50-14 111-16 177-2 78 0 162 4 243 5 82 49 185 125 230 103 62 158 163 186 274 16-145 17-280 3-400-17-143-55-267-114-368-8-14-16-27 12-44 27-16 35-2 43 12 63 110 104 241 122 393 17 146 13 310-13 488 102-82 381-258 352-594-7-27-16-52-28-75-7-14-14-28 14-42s35 0 42 14c17 33 30 69 39 110 5 24 8 49 11 76 13-7 45-43 51-39 24 16 58 38 80 54-21-60-35-120-42-178-10-87-5-172 14-252 4-15 7-31 38-24s27 23 24 38c-18 73-22 151-13 230 9 77 31 157 67 237 4 8 8 16 5 25 24 21 47 42 70 65-13-84-22-170-28-255-8-115-7-230 7-341 2-16 4-32 35-28s29 20 27 35c-13 106-13 217-6 329 7 113 22 225 40 332 1 2 1 5 1 7 54 59 95 120 152 196 55-203 73-407 66-612-2-76-69-227-65-302-30-55-63-107-100-151-41-49-87-87-139-108-15-6-29-12-18-41 12-29 27-24 41-18 62 26 117 71 164 127 38 45 72 98 103 154 57 7 78 179 143 212 154 57 298 94 453 100-75-19-140-50-195-93-74-57-131-135-173-231-6-15-13-29 16-42s35 2 42 16c38 86 88 156 154 206 85 66 289 124 400 127-61-37-113-78-157-128-59-67-104-148-141-250-34-95-87-179-153-247-68-71-150-124-238-157-15-6-29-11-19-41 11-29 26-24 41-19 96 36 186 94 261 172 72 74 130 166 167 270 34 95 75 169 128 230 47 54 105 98 177 135-98-207-66-367-122-577-35-129-232-277-193-320 45-51 133 88 248 127 175 59 357 111 540 85-122-138-244-269-366-361-119-90-237-140-352-120-16 3-31 6-37-26-5-31 10-34 26-37 135-24 269 32 401 132 111 84 201 175 311 298-18-47 0-14-30-77-59-123-130-241-220-345-89-102-196-189-324-250-14-7-28-13-15-42 13-28 28-22 42-15 137 65 251 157 345 265 81 93 147 198 203 307-15-81-39-157-68-227-44-106-93-201-188-287-62-56-209-140-208-179-29-15-33-11-63-24-61-26-121-46-164-52-16-2-32-4-28-35 4-32 19-30 35-28 50 6 115 28 182 56 33 14 66 43 98 60 53 4 139 47 208 74 206 78 446 126 666 79-73-33-147-65-223-91-85-29-172-49-264-53-16-1-32-1-31-33s17-31 33-31c98 4 191 26 282 57 89 30 175 69 261 108 59 27 101-7 163-45-123-92-181-230-205-376l-2-2c-102-95-207-190-315-253-104-60-210-91-316-63-15 4-31 8-39-22-8-31 7-35 22-39 125-33 247 1 364 69 94 55 186 132 274 213 0-6-1-11-1-17-15-270-203-480-435-494-78-5-189 21-186-32 4-59 97-44 234-86 385-116 655-296 836-690-54 41-110 83-186 124-86 47-198 91-358 128-82 19-154 48-216 84-64 38-117 84-159 135-10 12-20 25-45 5s-14-32-5-45c47-57 106-108 177-150 67-39 145-70 233-91 155-36 261-78 343-122 51-27 92-55 131-84-148-4-305-3-459-3-143 44-289 96-402 160-110 63-186 136-192 223-1 16-2 32-34 29-32-2-31-18-29-34 8-111 97-200 224-273 69-39 149-74 233-105-35 0-70 0-104-1-116-2-112-66-20-101 90-34 190-141 251-216 271-334 412-714 456-1130-33 72-69 140-115 198-57 73-128 131-222 164-31 160-91 293-180 397-92 108-216 185-369 230-29 8-52-35-29-55 132-109 221-226 278-344 62-131 83-264 72-387-1-16-3-32 29-35 31-3 33 13 34 29 12 134-10 278-78 420-40 85-97 170-172 251 73-39 136-89 187-149 85-100 141-229 170-386 1-8 14-22 22-25 89-27 155-79 209-147 51-65 90-143 126-228-140 69-304 64-457 78-213 19-369 68-554 152z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M204649 49231c-680-88-1359-113-2041-114-684 0-1369 40-2058 112-20 6-15 33-14 46 2 28 37 35 121 27 643-60 1285-93 1932-93 674 0 1351 21 2038 102 33 9 77-85 22-81z"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M200570 49160c683-71 1362-110 2038-110 675 0 1349 40 2025 127l31-127c-17 9-37 15-58 15-67 0-123-55-123-123s55-123 123-123c51 0 94 31 113 75l60-170c-724-84-1446-122-2171-122-729 0-1459 38-2193 107l58 164c22-32 59-54 101-54 68 0 123 55 123 123s-55 123-123 123c-12 0-25-2-36-6l33 94-2 7zm3067-416c-68 0-123 55-123 123s55 123 123 123 123-55 123-123-55-123-123-123zm0 64c-33 0-59 27-59 59s26 59 59 59c32 0 59-27 59-59s-26-59-59-59zm-1082-91c-67 0-123 55-123 123s55 123 123 123 123-55 123-123-55-123-123-123zm0 64c-32 0-59 26-59 59s26 59 59 59 59-26 59-59c0-32-26-59-59-59zm-1064-40c-68 0-123 55-123 123s55 123 123 123c67 0 123-55 123-123s-55-123-123-123zm0 64c-33 0-59 26-59 59s26 59 59 59c32 0 59-26 59-59 0-32-26-59-59-59z"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M202601 47974c-14-68-49-129-100-175-51-47-116-78-187-88-33-4-39-58-7-68 60-20 114-67 157-133 45-69 79-157 95-256 5-34 64-35 69-1 15 84 51 153 97 208 55 66 125 112 193 138 31 12 25 63-8 68-59 9-105 42-141 87-50 62-81 145-100 221-8 33-62 31-69-2zm33-118c20-52 47-103 81-146 28-34 60-64 99-84-51-30-100-70-143-120-28-34-53-73-73-116-19 59-45 112-75 158-31 47-67 86-108 116 50 19 95 47 134 82 34 31 63 68 85 110zM203433 52971l-515 206c-17 7-35 14-48-21-14-34 4-41 21-48l515-206c17-7 35-14 48 21 14 34-4 41-21 48zm59-326-604 328c-16 9-33 18-51-15s-1-42 15-51l604-328c16-9 33-18 51 15s1 42-15 51zm-1826-65 604 328c16 9 33 18 15 51s-34 24-51 15l-604-328c-16-9-33-18-15-51s34-24 51-15zm51 322 515 206c18 7 35 14 21 48-14 35-31 28-49 21l-515-206c-17-7-34-14-21-48 14-35 31-28 48-21zm224 434c137 33 261 48 358 31 88-16 155-60 191-146v-493c-107-1-212-15-303-41-109-31-170-98-201-178-41-107-27-235-4-329 5-18 9-36 45-27s32 27 27 45c-20 82-33 194 1 284 23 60 69 110 152 133 91 25 198 38 307 38 107 0 214-13 304-40 82-24 148-69 192-123s65-117 57-176c-5-36-24-62-49-80-34-24-82-35-128-37-47-2-94 7-142 16-25 5-50 9-77 13-19 2-37 5-42-32s14-40 32-42c23-3 48-8 73-12 52-10 105-20 159-18 60 2 121 18 168 51 42 29 72 72 80 131 11 80-16 163-73 233-53 65-131 119-229 147-83 24-178 38-274 42v483c3 5 3 11 2 16 37 82 102 125 188 141 97 18 221 2 358-31 18-5 36-9 45 27 8 37-9 41-28 45-146 35-279 51-388 32-92-17-165-58-215-132-49 74-124 115-215 132-109 20-242 4-388-32-18-4-37-8-28-45 8-36 27-32 45-27zm356 210 402-9c19 0 38-1 38 37 1 38-18 38-37 38l-402 9c-19 0-37 1-38-37s18-38 37-38zM202890 50464c151-125 293-227 423-297 133-72 254-111 359-106 19 1 37 1 36 39-1 37-20 37-39 36-92-4-200 32-322 97-125 67-263 166-410 289-14 12-29 24-53-5s-9-41 5-53zm-605 56c-141-130-298-240-445-314-139-71-268-108-363-100-19 2-37 4-40-34-4-37 15-39 34-40 110-10 252 31 404 107 152 77 315 191 461 325 14 13 28 25 2 53-25 27-39 15-53 2zm-213 1004c37-83 83-155 136-219 53-63 112-119 174-170 14-12 29-24 52 5 24 29 9 41-5 53-59 48-114 101-164 160-49 59-91 125-125 201-8 17-15 34-49 19s-27-32-19-49zm371-1734c49 66 88 139 114 223 26 82 40 175 39 279 5 80 6 165-7 249-13 86-42 170-97 246-43 60-101 97-165 113-53 13-109 10-164-7 29 100 51 208 6 308-8 18-33 27-51 18-43-22-86-43-128-62s-84-36-127-51l-1-1c-95-37-173-73-236-112-65-39-115-80-150-124l1 2c-44-49-72-106-88-170-14-55-20-114-22-174-72-39-138-78-194-116-64-43-118-87-161-131-13-14-26-27 1-53s40-12 53 1c39 40 89 80 150 121 60 40 128 81 204 121 124 13 247 51 370 109 106 50 211 115 317 192 13 7 19 16 27 20 8 6 16 13 25 19 51 22 104 28 152 16 47-11 90-39 122-84 48-66 72-139 84-214 12-77 11-157 6-234v-2c1-97-12-183-35-258-24-76-58-142-102-201-11-15-22-30 7-52s41-7 52 7zm-375 1047c-104-77-207-141-311-190-105-49-210-83-314-98 2 48 8 93 18 135 13 52 35 99 71 138l1 1c30 37 73 72 130 107 60 36 134 71 225 106l-1-1c45 16 89 34 133 54 31 14 61 28 93 44 19-83-10-179-37-267-2-8-5-15-9-29zm776-1003c-44 59-79 125-102 201-24 76-36 161-35 258v2c-5 77-6 158 6 234 12 75 37 148 84 214 32 45 75 72 122 84 48 12 101 6 152-16 8-6 17-13 25-19 6-4 13-12 27-20 105-77 211-143 317-192 123-58 246-95 370-109 75-40 144-80 204-121s111-81 149-121c13-13 26-27 53-1s14 39 0 53c-43 44-97 88-161 131-57 38-122 77-194 116-2 61-8 119-22 174-16 63-44 121-88 170l1-2c-35 44-85 85-150 124-63 38-141 75-237 112l-1 1c-43 15-85 32-127 51-43 19-85 40-128 62-18 9-43 0-51-18-45-100-23-208 6-308-55 18-111 20-164 7-64-15-122-53-165-113-55-76-84-160-97-246-13-85-12-169-7-249-1-104 13-196 39-279 26-84 65-158 114-223 11-15 22-30 52-7 30 22 19 37 7 52zm940 715c-105 15-209 49-314 98-104 49-207 113-311 190-4 13-6 21-8 29-27 88-56 184-37 267 31-15 62-30 93-44 44-20 87-38 133-54l-1 1c91-35 165-70 225-106 58-34 100-70 131-107l1-1c35-39 57-86 71-138 11-42 16-87 19-135z"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M203459 50602c-119 0-216 97-216 216s97 217 216 217 216-97 216-217c0-119-97-216-216-216zm0 69c-81 0-147 66-147 147s66 147 147 147 147-66 147-147-66-147-147-147zm0 60c-48 0-87 39-87 87s39 87 87 87 87-39 87-87-39-87-87-87zm-1697-124c119 0 217 97 217 216s-97 217-217 217c-119 0-216-97-216-217 0-119 97-216 216-216zm0 69c81 0 147 66 147 147s-66 147-147 147-147-66-147-147 66-147 147-147zm0 60c48 0 87 39 87 87s-39 87-87 87-87-39-87-87 39-87 87-87z"
  })), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#hr_svg__a",
    transform: "rotate(-2.173 -55532.79 156275.842)"
  }), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#hr_svg__a",
    transform: "rotate(2.18 459865.852 156275.761)"
  }))), hr_path11 || (hr_path11 = /*#__PURE__*/react.createElement("path", {
    fill: "#171796",
    d: "m683.871 118.584-.074.027-23.992-27.422-31.546 18.08-5.32 63.861a274.6 274.6 0 0 1 45.145 7.556l15.784-62.099z"
  })), hr_path12 || (hr_path12 = /*#__PURE__*/react.createElement("path", {
    d: "M634.482 122.518c1.096-.267 2.178-.323 3.226.32.46.19.806.432 1.019.743.486-.376.98-.728 1.493-1.03.72-.534 1.454-1.005 2.245-1.268 1.132-.575 2.26-.915 3.392-1.02 1.196-.203 2.399-.215 3.596-.144.998.059 1.963.335 2.885.865.835.414 1.667.832 2.502 1.247.883.491 1.766.936 2.648 1.309 1.12.441 2.379.59 3.72.64.658.023 1.304.023 1.938-.145.512-.137.832.19.267.536-4.147 2.544-7.397.281-10.17-.732a20.117 20.117 0 0 1 2.667 2.124c1.054 1.016 2.233 2.047 4.318 2.997 1.265.575 2.642 1.028 4.41 1.043.6.006 1.245-.018 1.944-.133.352-.057.503-.024.51.16.005.124-.027.373-.238.512-1.069.717-2.076.907-3.199.978-2.138.136-4.425-.566-6.516-1.689-1.674-.9-2.802-1.996-4.135-2.98-1.33-.98-2.48-1.525-3.714-1.786-1.218-.26-2.536-.23-3.647.113.332.065.613.222.785.42.572.338 1.307.486 2.37.608.554.065.382.447-.471.906-.512.66-1.179 1.016-2.065.93-1.22.809-1.655.32-2.064-.21-.05.335-.148.663-.293.98a.753.753 0 0 1-.018.533c.195.303.29.596.225.919a.77.77 0 0 0 .272.491c.255.231.418.498.45.824.004.216.122.394.294.554.249.204.5.385.75.69.737.266 1.078.832 1.199 1.564.557.18.788.583.897 1.063.317.134.608.293.774.575 1.137.003 2.248.003 3.287.112.975.104 1.769.711 2.48 1.5.48.073.965.097 1.463-.016.512-.225 1.054-.397 1.644-.447.974-.083 1.952-.133 2.882.089.63.151 1.122.486 1.525.942.58.66 1.475.572 2.24.246 1.036-.442 1.898-.427 2.959.038.453-.175.906-.257 1.36-.21.387-.42.799-.524 1.222-.536.69-.024 1.191.083 1.06.968-.035.24-.177.471-.358.554-.316.685-.92.886-1.688.82-.083.472-.275.821-.583 1.046.352 1.087.014 1.523-.791 1.508-.17.314-.42.51-.85.447a1.726 1.726 0 0 1-1.09.643c.047.284.168.418.37.723.548.83-.276 1.164-1.028 1.176.193.548.216 1.096.148 1.644.767.465.871.953.163 1.436.518.907.317 1.573-.655 2.059-.014.506-.065 1.016-.402 1.3-.231.196-.563.231-.344.598.394.652.308 1.476-.275 1.5-.125-.013-.237.005-.246.204 0 .068-.06.136-.175.204-.7.376-1.354.806-1.955 1.3-.089.06-.178.101-.267.021-.438.954-1.255 1.922-2.159 2.897-.14.717-.545 1.203-1.217 1.454a.512.512 0 0 1-.4.409c.376.418.518.82.154 1.217-.447.49-1.037.966-1.626 1.117-1.253.32-2.038.26-2.542-.22-.444-.423-.27-.743.012-.876-.773.062-.93-.346-.91-.891.045-.273.137-.237.41-.228.42.011.8-.217 1.196-.347.154-.26.356-.486.604-.675.14-.877.694-1.363 1.446-1.65.607-.231 1.188-.818 1.75-1.576.347-.598.697-1.194 1.043-1.792-.243-.317-.308-.634-.317-.95a1.847 1.847 0 0 1-.696-.647c-.545-.038-.77-.284-.85-.625a1.294 1.294 0 0 1-.409-.053c-.266.172-.536.323-.87.308a8.618 8.618 0 0 1-1.363 1.138c-.163.45-.486.63-.88.687-1.12.133-1.789 1.528-2.405 2.097-.249.184-.403.51-.512.9-.054.735-.181 1.31-.584 1.321-.361-.014-.418-.053-.43-.091a1.482 1.482 0 0 0-.47.02c.302.332.35.75.07 1.117-.278.361-.678.474-1.063.5-.796.054-1.442-.017-2.04-.26-.572-.234-.64-.575-.622-.906-.412-.196-.495-.391-.45-.584.056-.249.284-.376.57-.296a3.06 3.06 0 0 1 .747-.246c.723-.779 1.467-1.448 2.284-1.76.24-.29.515-.55.85-.767.095-.699.554-1.25 1.117-1.762.05-.252.133-.507.275-.758-.032-.151.01-.222.012-.365-.228-.423-.364-.933-.195-1.356a1.642 1.642 0 0 1-.063-.676c-1.344.8-1.759.528-1.913-.121-.492.412-.95.604-1.28.012-.476.142-.956.302-1.433.112-.311.122-.625.231-.984.255-.145.287-.34.575-.604.862-.015.604-.225 1.209-.613 1.813a11.588 11.588 0 0 1-.87 1.934c.005.207-.024.415-.134.625.104.743-.145 1.105-.554 1.288-.11.3-.272.602-.521.9-.012.099-.021.2-.033.297.163.439.19.874-.255 1.312-.358.225-.74.462-1.12.649-.447.22-.861.116-1.237-.02-.66-.238-.61-.469-.525-.694a.805.805 0 0 1-.651-.009c-.16-.1-.261-.204-.42-.308-.143-.257-.193-.491.153-.675.436-.193.732-.335 1.075-.687.119-.267.27-.468.483-.522.207-.485.462-.814.809-.903.254-.601.527-1.265.85-1.84.112-.174.195-.355.142-.553-.006-.163.006-.317.142-.41.077-.064.213-.124.042-.215a1.7 1.7 0 0 1 .204-1.443c.35-.527.74-1.8.37-2.426-.068-.35-.136-.75-.092-1.078-.127-.006-.222.012-.349-.077-.284-.175-.521-.009-.738.308-.157.397-.314.747-.47.747-.149 1.024-.652 1.821-1.176 2.026-.122.47-.199.941-.134 1.412.054.513 0 .862-.237.922-.26.065-.503.216-.654.634a1.28 1.28 0 0 0-.092.42c.361.373.252.838-.095 1.182-.782.77-1.753.658-2.781.355-.744-.293-.924-.604-.85-.92-1.055-.09-.845-.898.03-1.141.938-.264 1.7-.865 2.324-1.724.057-1.019.29-1.712.839-1.822.053-.625.249-1.187.512-1.72.276-.483.444-1.014.347-1.66-.584-.364-.608-.74-.071-1.125.177-.104.157-.21-.063-.317-.355-.035-.31-.376-.287-.696-.015-.166-.1-.252-.258-.255-.788-.115-.592-.438-.254-.788.142-.16.237-.396.089-.491-.122-.077-.205-.347-.232-.584-.482-.364-.275-.737 0-1.096-.272-.23-.4-.568-.438-.962-.897-.039-1.232-.495-.746-1.159.204-.28.468-.55.788-.808.207-.335.405-.67.308-1.004-.258-.655.565-1.15 1.27-1.659a1.1 1.1 0 0 1-.154-.512c-.397-.383-.296-.738.142-1.076a1.33 1.33 0 0 1-.162-.521c-.987.196-.98-.394-.522-1.342-.571-.329-.411-.912.625-1.8.015-.205.054-.362.113-.472a2.395 2.395 0 0 0-1.25.38c-.394.257-.785.225-1.18.062-.12-.196-.307-.362-.52-.513-.27-.237-.332-.503-.276-.788-1.161.066-1.383-.793-.687-1.3.388-.308.672-.63.779-.983.314-.797.98-1.34 1.63-1.896 0-.228.05-.456.12-.687-.287-.193-.589-.332-.92-.359a1.47 1.47 0 0 0-.717-.796c-.217-.13-.288-.252-.154-.545-.617-.551-.463-.886-.306-1.203z"
  })), _g5 || (_g5 = /*#__PURE__*/react.createElement("g", {
    fill: "#f7db17"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M655.548 152.429c-.068.005-.139.011-.219.008-.299.305-.657.61-.99.871-.286-.332-.713.033-.295.234l-.214.148c-.136.362-.26.516-.663.578-.062.009-.125.02-.187.035a3.69 3.69 0 0 1 .018-.447c.018-.18.047-.355.086-.527.006-.033.015-.062-.047-.077s-.072.018-.077.05a5.446 5.446 0 0 0-.092.542 3.438 3.438 0 0 0-.018.495c-1.016.326-1.603 1.383-2.296 2.136-.299.257-.45.613-.56.986-.059.198-.08 1.108-.284 1.123-.098.003-.201 0-.31 0-.11-.166-.259-.17-.445-.012-.424-.01-.874-.012-1.25.047-.258.279.45.175.826.406.172.104.246.308.178.592-.347.827-2.28.56-2.923.22-.3-.157-.311-.338-.3-.596a2.7 2.7 0 0 0 .406-.03c.231-.032.46-.1.684-.228.063-.035.128-.07.057-.198s-.137-.092-.199-.056c-.19.11-.385.166-.58.192-.202.03-.41.03-.608.021-.017 0-.035-.003-.05 0-.112-.065-.198-.142-.151-.21.047-.065.234.006.27.017.299-.139.56-.228.882-.29.682-.728 1.375-1.413 2.314-1.789.281-.338.586-.604.953-.847.13-.812.525-1.244 1.114-1.783a2.78 2.78 0 0 1 .32-.868c-.036-.187-.009-.305 0-.495-.225-.426-.358-.796-.18-1.273-.11-.347-.095-.58-.054-.9a.436.436 0 0 0-.003-.181 7.777 7.777 0 0 1 1.06-.717 3.87 3.87 0 0 0 .048 1.004l-.003.003c-.1.11-.187.216-.246.329a.662.662 0 0 0-.092.346c0 .033 0 .065.065.062.066 0 .066-.032.063-.065a.54.54 0 0 1 .077-.281c.053-.098.133-.199.228-.3a.132.132 0 0 0 .023-.032c.311-.009.616-.175.922-.42a7.67 7.67 0 0 0 .823-.821c-.003.444-.006.889-.012 1.333a2.928 2.928 0 0 0-.672.88c-.015.03-.03.056.026.085.06.03.074 0 .086-.03.163-.322.37-.589.61-.81h.012c.065 0 .065-.033.065-.066v-.003a3.963 3.963 0 0 1 1.146-.658c-.056.392-.082.774-.014 1.14.074.404.264.783.649 1.115a.06.06 0 0 0 .023.012z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M636.2 141.161c.05-.092.178-.21.22-.201l.023-.006c.14-.261.285-.504.436-.723.195-.284.403-.536.622-.75.023-.023.047-.044.092 0 .044.048.02.069 0 .092-.214.208-.415.45-.608.729-.148.216-.29.453-.426.71.044.06.065.152.041.217.045.406.098.634.279.868a.253.253 0 0 1 .062-.041c.074-.181.175-.341.3-.483.153-.172.34-.317.565-.439a2.24 2.24 0 0 0 .379-.394c.1-.133.18-.27.237-.408.012-.03.024-.06.086-.036.06.024.047.056.035.086a1.99 1.99 0 0 1-.251.438 2.57 2.57 0 0 1-.41.418s-.008.006-.011.006c-.21.115-.391.252-.533.412-.11.121-.196.257-.264.408.095.069.136.255.048.374-.27.388-.59.616-.086.947-.018.261.065.46.237.64.115.122.103.545-.181.85-.267.27-.062.199.213.231.021.006.042.015.062.021v-.003c.101-.195.22-.37.35-.533.127-.16.267-.311.409-.453.198-.196.355-.409.468-.625.11-.21.174-.427.186-.634.003-.033.003-.065.071-.06.066.004.063.036.06.069a1.763 1.763 0 0 1-.202.687c-.118.228-.284.45-.491.655-.14.139-.273.281-.397.441a3.249 3.249 0 0 0-.335.512c.332.202.225.563.275.895a.584.584 0 0 1 .172.047c.003-.006.006-.012.012-.017l.196-.308.308-.49c.017-.026.035-.056.088-.02.057.036.039.062.021.089l-.308.489-.195.308c-.003.006-.006.012-.01.014.205.166.22.468-.032.7-.494.373-.355.488.107.784.06.436.062.785-.033 1.156.003.009.003.02.006.032.012.122.02.246.03.368l.03.37c.002.032.005.065-.06.07s-.068-.026-.07-.058l-.03-.37c-.004-.033-.006-.063-.006-.095-.024.056-.048.115-.077.177-.332.726-.676 1.318-.75 2.133-.797.19-.678.974-.723 1.668-.628.847-1.356 1.525-2.366 1.863-.19.062-.649.174-.693.414-.006.086.308.273.51.163.556-.533.834-.237.195.308-.05.104-.01.22.1.317.578.519 2.009.687 2.66.276.483-.302.735-.634.314-1.093.027-.652.282-1.289.969-1.472.08-.148.056-.424.02-.575-.065-.566.024-1.07.163-1.614.024-.068.074-.125.187-.154.26-.054.761-.809.918-1.535.039-.157.062-.32.092-.482.042-.252.14-.297.267-.149.121-.162.118-.26.192-.447.267-.388.652-.699 1.102-.48a3.795 3.795 0 0 1-.22-1.04c-.032-.432.01-.88.143-1.288.018-.062.039-.121.136-.106l.388-.922c.13-.308.26-.619.391-.927.012-.03.024-.059.083-.035s.048.056.036.086l-.391.927c-.13.308-.258.613-.388.918.056.041.038.095.02.148-.118.37-.157.78-.127 1.179.03.432.136.85.296 1.19.015.033.033.066.027.098.213.125.21.154.201.439-.006.222.024.441.077.708.424.782-.017 2.09-.43 2.745a1.357 1.357 0 0 0-.168 1.043c.255.246.089.5-.136.673-.018.059 0 .127.003.186.023.255-.068.468-.202.678-.346.625-.613 1.292-.891 1.946-.504.14-.607.433-.809.904-.293.083-.323.169-.447.438-.338.34-.66.545-1.093.74-.358.164-.012.32.24.492.228.17.527-.198.714-.476.204-.308.411-.217.278.023a2.432 2.432 0 0 0-.27.841c-.076.214.735.377.874.383.495.023 1.117-.46 1.505-.705.323-.33.273-.616.13-1.016l.003-.027a2.463 2.463 0 0 1-.595-.06 4.29 4.29 0 0 1-.699-.23c-.03-.012-.06-.024-.036-.086.024-.06.057-.048.086-.036.231.095.454.175.679.222.186.042.379.063.583.057l.033-.311c.257-.317.435-.628.574-1.007.548-.258.551-.525.477-1.111.122-.237.148-.376.14-.646.36-.643.657-1.3.903-1.996.432-.575.64-1.117.59-1.801.038-.267.136-.418.331-.409.142-.198.27-.403.385-.63a.575.575 0 0 0 .071.005c-.006-.015-.003-.033 0-.047.036-.157.077-.297.13-.412a.997.997 0 0 1 .178-.281c.08-.196.11-.385.09-.57a1.379 1.379 0 0 0-.193-.553.615.615 0 0 1-.146-.231c-.026-.092-.008-.184.083-.276.024-.023.048-.044.092 0 .045.048.024.072 0 .092-.053.05-.062.098-.047.145a.57.57 0 0 0 .121.187l.006.012c.116.198.193.403.213.613s-.008.427-.103.643c0 .003-.012.018-.012.02a.902.902 0 0 0-.163.252c-.047.11-.089.237-.121.385-.003.01-.003.018-.006.024.305 0 .574-.095.868-.24l.017-.018a1.8 1.8 0 0 0 .436-.536c.11-.198.198-.441.249-.72.005-.032.011-.062.077-.053.062.012.056.045.053.074a2.527 2.527 0 0 1-.264.761c-.1.187-.219.338-.337.457.473.142.885.003 1.335-.137-.065-.634-.056-1.116.012-1.496.074-.411.214-.702.388-.92.021-.027.039-.051.092-.013.05.042.033.066.012.092-.163.205-.293.477-.361.865-.066.362-.077.824-.015 1.434.006-.003.015-.003.023-.006.19.323.29.557.679.305.142-.095.29-.19.409-.314.044-.047.03-.074.065-.113.37-.394.743-.76 1.113-1.087.374-.328.747-.61 1.12-.838.027-.018.056-.035.089.02s.006.072-.02.09a8.062 8.062 0 0 0-1.103.823c-.317.279-.634.587-.95.918.017.057.026.154.035.303.033.438.113.702.738.462a3.18 3.18 0 0 0 .708-.341c.157-.095.29-.175.382-.196.204-.16.405-.31.61-.447.198-.133.4-.255.598-.361.033-.237.086-.468.163-.69.193-.569.515-1.096.921-1.594l.021-.018c.338-.183.613-.4.832-.645.222-.246.388-.522.513-.82.012-.03.023-.06.086-.036.059.023.047.056.035.085a3.07 3.07 0 0 1-.533.857c-.228.254-.51.48-.859.669-.394.486-.708.995-.892 1.543a3.328 3.328 0 0 0-.145.593c.012.003.024.014.036.038.03.06 0 .074-.027.086-.009.003-.018.009-.026.015-.039.32-.03.657.03 1.007.275-.009.553-.163.834-.391.3-.243.605-.578.907-.918.003-.01.003-.015.012-.021.074-.243.169-.456.293-.628.133-.184.296-.323.498-.409.03-.012.059-.026.085.036.024.059-.003.07-.035.086a1.078 1.078 0 0 0-.444.364c-.119.166-.21.373-.282.61l-.012 1.386c.015-.011.033-.023.048-.038.34-.264.731-.46 1.155-.613.044-.018.095.023.086.07-.065.416-.1.827-.033 1.206.065.356.225.688.545.984a3.475 3.475 0 0 1 .584-.77c.003-.006.006-.012.015-.015a5.07 5.07 0 0 1 .376-.34c.095-.087.19-.176.281-.264.095-.086.19-.175.285-.264.023-.024.047-.044.091.003s.021.071-.003.092c-.094.089-.19.174-.284.263-.095.086-.19.175-.284.264l-.003.003a3.89 3.89 0 0 0-.35.314c.003.121.01.24.015.361.003.065.003.13.006.196.272.074.435.077.714.07.092.549.139.635.616.647a4.055 4.055 0 0 1 .018-.572c.023-.213.068-.42.142-.616.012-.03.024-.06.083-.039.062.024.05.054.038.083-.07.184-.112.38-.136.584-.02.18-.024.367-.018.56h.039c.19.39.414.583.817.758.113-.178.196-.356.25-.533a1.71 1.71 0 0 0 .07-.596c-.003-.032-.003-.065.06-.068.065-.003.068.027.07.06.015.213-.011.426-.077.64s-.168.423-.31.633c-.012.018-.024.036-.045.036.018.228.056.397.136.568.06-.127.122-.254.193-.373.098-.172.21-.326.346-.462.024-.024.045-.044.092 0 .045.044.024.068 0 .092a2.09 2.09 0 0 0-.326.435 4.979 4.979 0 0 0-.228.453c.045.078.101.155.166.243-.758 1.3-1.57 3.102-3.066 3.694-.773.305-1.11.7-1.264 1.525-.29.226-.498.454-.687.768-.504.168-.954.42-1.5.397 0 .352.116.506.469.509.672-.338.823-.4.882-.352.083.07-.094.553-.651.944-.086.054-.083.086-.033.175.471.738 1.706.474 2.37.3.474-.125 1.33-.688 1.567-1.162.092-.219-.116-.5-.323-.731-.948.145-.767-.765.047-.385.276-.083.311-.086.388-.391.726-.282 1.028-.587 1.194-1.366.732-.788 1.466-1.6 1.993-2.544.146-.178.231-.492.19-.655.13-.154.201-.35.249-.527.047-.19.077-.376.07-.566 0-.032-.002-.065.063-.068s.065.03.068.062a2.2 2.2 0 0 1-.074.601 5.599 5.599 0 0 1-.15.463c.046.118.07.198.174.168.634-.51 1.274-.868 1.958-1.291.047-.29.234-.433.521-.444.116.003.157-.033.199-.14.16-.4-.042-.675-.234-1.007-.178-.494.139-.613.456-.85.331-.246.308-.897.32-1.273h.003c-.012-.063-.024-.128-.039-.193a3.279 3.279 0 0 0-.113-.4c-.011-.03-.02-.062.039-.083.062-.02.071.01.083.042.05.145.089.281.118.414.012.054.021.107.033.157.317-.163.649-.352.773-.705.11-.39-.104-.76-.293-1.093a11.957 11.957 0 0 1-.743.32c-.03.012-.06.024-.084-.035s.006-.074.036-.083a12.774 12.774 0 0 0 .859-.38c.142-.094.287-.195.39-.328.229-.329-.384-.625-.597-.758 0-.01.003-.018.003-.027-.308-.281-.614-.566-.922-.847-.023-.02-.047-.045-.003-.092s.069-.027.092-.003l.853.782c.048-.483.054-.945-.097-1.425-.048-.154-.104-.305-.157-.456a1.395 1.395 0 0 1-.598-.498 1.296 1.296 0 0 1-.2-.619c-.002-.032-.002-.065.063-.07.065-.004.065.029.071.062.015.201.065.39.175.556.11.17.275.317.515.439.258.133.8.065 1.114-.086.435-.246-.133-.744-.267-1.037-.094-.21-.118-.426-.16-.651.039-.006.077-.015.119-.021a1.304 1.304 0 0 0-.175-.184.752.752 0 0 0-.234-.142c-.03-.012-.062-.02-.038-.083.02-.062.053-.05.083-.038.097.035.19.091.275.165.083.072.16.157.234.258.041-.006.086-.015.127-.024.43-.085.667-.325.927-.633a4.495 4.495 0 0 0-.467-.483 12.61 12.61 0 0 0-.534-.45c-.023-.021-.05-.042-.009-.092s.066-.03.092-.01c.184.149.368.3.54.457.174.16.34.329.491.512.015.018.03.036.018.06.394.035.459-.045.657-.397-.05-.181-.133-.35-.237-.513a3.126 3.126 0 0 0-.394-.483c-.023-.023-.044-.047 0-.091.048-.045.072-.021.092 0 .154.16.297.328.41.503.112.172.198.35.25.542.184.003.383.012.54-.083.344-.204.053-.939-.036-1.223a.052.052 0 0 0 .015-.012 3.452 3.452 0 0 0-.136-.086c-.08-.05-.163-.1-.243-.154-.027-.018-.053-.035-.02-.089.035-.056.062-.038.088-.02l.243.154.178.112.08-.062c.252-.201.34-.468.417-.746.119-.427.143-.237.64-.311.536-.083.827-.143 1.144-.77.165-.083.251-.155.28-.359.054-.37.025-.56-.399-.592-.592-.048-.954.07-1.354.462.054.08.107.163.16.243.018.026.036.053-.017.091-.054.036-.071.01-.09-.017l-.15-.231c-.54-.054-.972.032-1.475.222l-.151-.062c.106.142.19.278.251.411.086.19.13.37.137.542 0 .033.003.065-.063.068s-.065-.03-.068-.062c-.006-.157-.044-.32-.124-.494s-.202-.359-.373-.554l-.003-.003c-.421-.151-.806-.228-1.2-.22.065.066.133.13.198.193.086.083.172.166.255.249.024.024.048.044 0 .092-.044.047-.068.023-.092 0a20.421 20.421 0 0 1-.254-.25 20.421 20.421 0 0 1-.255-.248c-.009-.009-.018-.018-.024-.027a3.445 3.445 0 0 0-1.063.276c-.24.1-.486.178-.726.222.178.172.329.364.447.584.125.225.22.473.282.749.006.033.015.062-.048.077s-.07-.018-.077-.047c-.059-.264-.15-.504-.27-.717s-.266-.403-.44-.569c-.018-.015-.033-.033-.027-.056a2.225 2.225 0 0 1-.658.003l.264.435c.015.03.027.06-.03.086-.059.027-.074 0-.086-.03l-.242-.509a1.807 1.807 0 0 1-.593-.234c.062.234.11.486.145.752.048.353.077.729.086 1.126 0 .032.003.065-.062.065s-.065-.033-.065-.062a9.81 9.81 0 0 0-.083-1.11 5.874 5.874 0 0 0-.187-.89 2.077 2.077 0 0 1-.266-.248 2.624 2.624 0 0 0-.711-.554 1.186 1.186 0 0 1-.26.91c-.022.026-.04.05-.093.011-.05-.041-.032-.065-.012-.092a1.058 1.058 0 0 0 .22-.9c-.406-.187-.853-.279-1.316-.317a6.64 6.64 0 0 1 .687 1.09c.184.15.282.334.338.536.054.198.066.412.074.628 0 .032.003.065-.062.068s-.065-.03-.068-.062a2.608 2.608 0 0 0-.068-.599.893.893 0 0 0-.302-.476c-.003-.003-.018-.018-.018-.021-.1-.202-.213-.4-.335-.596a5.762 5.762 0 0 0-.411-.568l-.006-.006a6.246 6.246 0 0 0-.471-.009c.026.036.053.071.077.11a.721.721 0 0 1 .106.308c.003.032.006.065-.059.07s-.068-.026-.07-.059a.623.623 0 0 0-.09-.254.843.843 0 0 0-.139-.172c-.326.009-.649.035-.96.062.326.418.587.85.788 1.295.225.494.376 1.004.462 1.53.006.033.012.066-.053.075-.062.012-.068-.02-.074-.053a5.99 5.99 0 0 0-.453-1.5 6.4 6.4 0 0 0-.827-1.335l-.047.003a4.295 4.295 0 0 0-.75.145c.11.068.205.136.288.204.112.092.201.184.278.276.021.027.042.05-.009.092s-.07.018-.091-.01a1.966 1.966 0 0 0-.261-.26 3.003 3.003 0 0 0-.373-.255 5.97 5.97 0 0 0-.385.14c-.071.026-.14.053-.21.074.219.157.429.329.63.521.243.234.471.498.676.803.017.026.035.053-.018.089s-.071.008-.092-.018a4.744 4.744 0 0 0-.655-.782c-.222-.213-.459-.4-.705-.572-.266.06-.536.074-.805.065.166.33.31.66.42.996.119.361.202.725.228 1.096.003.032.006.065-.059.07s-.068-.026-.07-.059a4.47 4.47 0 0 0-.223-1.066 7.779 7.779 0 0 0-.447-1.043c-.163-.011-.33-.032-.495-.053.095.302.178.613.249.93.083.373.15.756.201 1.144.003.032.006.065-.056.074-.065.008-.068-.024-.074-.057a11.558 11.558 0 0 0-.199-1.131 11.598 11.598 0 0 0-.275-1.013c-.468-.507-.986-1.001-1.62-1.265a2.13 2.13 0 0 1 .468 1.404c0 .033-.003.065-.065.062-.066 0-.066-.035-.063-.065a2.041 2.041 0 0 0-.15-.835 2.094 2.094 0 0 0-.439-.658 2.44 2.44 0 0 0-.447-.089 19.527 19.527 0 0 0-1.25-.083c.32.29.571.557.548.88-.003.033-.006.065-.071.06s-.063-.04-.06-.072c.021-.299-.275-.568-.622-.876-.248-.01-.5-.012-.75-.015.137.139.256.278.35.417.13.19.223.38.267.57v.008c.027.293.098.55.228.764.127.21.311.373.563.489.03.015.06.027.032.086s-.056.047-.085.032a1.368 1.368 0 0 1-.62-.539 1.88 1.88 0 0 1-.245-.811 1.568 1.568 0 0 0-.246-.522 3.344 3.344 0 0 0-.43-.494c-.278 0-.554-.003-.832-.003.116.329.196.666.252 1.01.065.42.095.85.103 1.285 0 .033 0 .065-.065.065s-.065-.032-.065-.062a8.927 8.927 0 0 0-.1-1.267 5.592 5.592 0 0 0-.261-1.031h-.077a1.253 1.253 0 0 0-.61-.548.754.754 0 0 1-.133.352c-.018.027-.04.054-.093.018s-.035-.062-.017-.089a.618.618 0 0 0 .112-.338c-.041-.017-.086-.035-.133-.056-.133-.557-.258-.788-.702-.977a2.966 2.966 0 0 1-.042.477c-.035.201-.1.405-.222.6-.017.028-.035.057-.089.022-.056-.036-.038-.063-.02-.09a1.52 1.52 0 0 0 .204-.553c.03-.169.039-.34.039-.507l-.077-.026c-.119-.78-.261-1.215-1.07-1.523.01.101.012.205.006.308a1.704 1.704 0 0 1-.112.536c-.012.03-.024.063-.083.039s-.048-.053-.039-.083c.065-.169.095-.335.104-.498a2.375 2.375 0 0 0-.024-.459c-.172-.195-.417-.382-.628-.59.006.288-.032.572-.112.86a3.825 3.825 0 0 1-.483 1.042c-.018.027-.036.057-.089.021-.056-.035-.038-.062-.02-.089.216-.334.373-.672.467-1.007.092-.32.125-.643.101-.965-.092-.101-.169-.21-.222-.326a.58.58 0 0 1-.018.041l-.095.214c-.014.03-.026.059-.086.035-.059-.027-.047-.056-.035-.086.032-.07.062-.142.095-.213.023-.056.05-.116.074-.172-.006-.035-.012-.071-.015-.11-.027-.248-.16-.44-.34-.604l-.004-.003a1.887 1.887 0 0 1-.089.234c-.056.122-.13.24-.225.362-.02.026-.038.05-.091.012-.05-.042-.03-.066-.012-.092.089-.113.157-.225.21-.335.044-.095.077-.19.1-.287a1.202 1.202 0 0 1-.189-.308.995.995 0 0 1-.124.213 1.454 1.454 0 0 1-.243.246c-.024.02-.05.041-.092-.01s-.015-.07.009-.091c.092-.074.163-.148.22-.222s.094-.145.12-.22c.042-.115.057-.04.018-.227.068-.368-.068-.587-.263-.892a.089.089 0 0 1 .012-.024 1.114 1.114 0 0 0-.394.104 3.58 3.58 0 0 0-.57.332c-.026.018-.052.035-.088-.018-.039-.053-.012-.071.018-.089.21-.142.409-.26.59-.34.183-.08.352-.125.497-.116a.462.462 0 0 0 .015-.284c-.593.219-1.06.322-1.437.346a2.05 2.05 0 0 1-.948-.145c-.03-.015-.059-.027-.032-.086.023-.06.056-.047.086-.035.234.1.515.16.888.136.37-.024.827-.125 1.413-.344l-.006-.018c.107-.236.193-.468.252-.699-.21.057-.418.054-.625.048h-.042c-.032 0-.065-.003-.065-.065 0-.065.036-.065.065-.065h.042c.22.002.438.008.654-.063a6.26 6.26 0 0 0 .039-.23c.033-.258.335-.32.548-.09.178.19.34.391.515.474.356.17.756.018 1.043-.213l-.264-.086c-.032-.009-.062-.02-.041-.08.02-.062.05-.053.08-.041.112.035.225.07.338.11l.077-.08c.734.062 1.211-.092 1.682-.566a8.657 8.657 0 0 1-1.114-.039c-.355-.041-.648-.112-.865-.22-.03-.014-.059-.029-.03-.085.03-.06.06-.044.087-.03.201.101.482.17.823.208.347.038.755.05 1.22.035h.006c.042-.047.083-.097.128-.15.201-.084.403-.176.55-.341-.855-.092-1.67-.261-2.437-.661-.199-.222-.513-.347-.847-.432-.622-.077-1.173.077-1.68.34-.133-.124-.237-.237-.367-.358-.195-.024-.38-.128-.575-.151-.26-.03-.533.02-.793-.01-.033-.002-.066-.005-.057-.07.006-.065.039-.062.071-.057.261.03.534-.02.794.01.252.029.492.139.744.168.84-.317 1.537-.491 2.138-.465a7.1 7.1 0 0 1 2.16-.272.192.192 0 0 1-.027-.024c-.086-.086-.045-.13 0-.172.394-.4.486-.767.358-1.099-.13-.343-.485-.666-.98-.962-.527.059-1.034-.083-1.594-.021-.35.038-.693.115-1.03.228.28.1.527.267.728.504.249.293.427.693.521 1.196.012.06.021.122-.097.142-.119.024-.13-.038-.142-.097-.086-.46-.246-.82-.468-1.085-.234-.334-.77-.465-.94-.533-.56.057-1.11.119-1.59.243-.361.092-.678.22-.921.409.361-.077.737-.062 1.063.1.311.155.575.445.74.916.021.056.04.115-.076.154s-.137-.018-.154-.077c-.14-.406-.359-.649-.616-.776-.513-.255-1.57-.033-2.018.3-.26.195-.52.446-.779.74-.047.056-.097.11-.207.014-.11-.097-.062-.15-.012-.204.27-.305.542-.575.824-.782.272-.201.554-.347.844-.415.296-.328.734-.527 1.24-.657.496-.128 1.061-.193 1.636-.249-.169-.34-.385-.545-.634-.655-.267-.118-.572-.136-.903-.103-.69.237-1.304.607-1.893 1.025.053 0 .107 0 .157.003.175.011.332-.015.477.041.056.02.115.041.074.157-.05.14-.433.053-.566.044a1.69 1.69 0 0 0-.5.048c-.027.006-.057.015-.083.006-.72.444-1.236.894-1.834 1.4l-.1.036c-.534-.02-.901.054-1.12.22-.199.15-.214.388-.175.707-.092.3-.207.628-.237.978-.625.536-1.321 1.072-1.644 1.854-.071.228-.192.43-.343.61.127.021.23.06.31.122.03.023.057.047.08.077a2.88 2.88 0 0 1 .069-.394c.044-.184.11-.353.195-.489.018-.027.036-.053.089-.018.056.036.038.062.02.09-.08.12-.139.278-.18.45-.05.204-.077.429-.083.636-.003.065-.121.071-.13.006a.358.358 0 0 0-.14-.252.65.65 0 0 0-.337-.106 3.93 3.93 0 0 1-.436.397c-.124.1-.242.21-.27.373-.017.284.333.335.664.355.756.045.154.474.57.85.2.14.387.303.53.501.287.104.464.08.66-.009.038-.512-.006-.773.219-.773h.024a.96.96 0 0 1 .053-.195c.039-.095.095-.193.172-.288.02-.024.041-.05.092-.009s.03.065.009.092a1.009 1.009 0 0 0-.152.255.937.937 0 0 0-.053.213c.039.077.03.228.027.498.43-.21.82-.264 1.259-.285.82-.96 1.17-.716.45-.017l-.116.219c-.124.24-.204.426-.23.752-.21.184-1.242 1.03-.857 1.345.27-.039.439-.027.335.175-.127.27-.512.829-.385 1.137.047.113.213.1.376.062l.036-.032c.27-.22.554-.471.82-.764a4.75 4.75 0 0 0 .708-.993c.027-.053.053-.103.13-.086.08-.296.175-.59.282-.885.11-.305.234-.613.367-.922.02-.044.083-.053.113-.011.112.163.222.281.331.358.098.071.196.104.29.104s.193-.033.291-.098c.107-.074.213-.187.323-.34.018-.027.038-.054.092-.015s.035.062.014.091c-.118.166-.234.288-.355.37s-.24.125-.364.122a.63.63 0 0 1-.365-.13 1.417 1.417 0 0 1-.296-.3c-.115.27-.222.54-.32.81-.11.298-.204.6-.287.9.068.056.038.11.012.163a5.17 5.17 0 0 1-.753 1.051 7.307 7.307 0 0 1-.699.667c.033.219.09.426.19.64.447-.386.865-.777 1.232-1.18a7.47 7.47 0 0 0 .94-1.258c.017-.027.032-.057.088-.024s.039.062.024.089c-.13.225-.279.444-.439.66.03.045.006.062-.017.083-.048.039-.075.193-.086.391-.018.27 0 .604.03.844.002.033.008.066-.057.074s-.068-.023-.074-.056c-.033-.252-.047-.595-.033-.868.003-.07.012-.136.021-.195a15.78 15.78 0 0 1-.302.346c-.373.412-.8.809-1.256 1.2l-.012.009a.883.883 0 0 0 .042.07c-.397.288-.72.389-.276.774l.445-.32.473-.34c.027-.018.054-.039.092.014s.012.071-.015.092l-.476.34-.46.33a.778.778 0 0 0 .113.453.66.66 0 0 1 .098-.01l.995-.722c.027-.02.053-.038.092.015s.012.071-.015.092c-.32.234-.643.468-.966.702a.892.892 0 0 1-.115.148c-.326.234-1.463.936-1.342 1.422v.003c.273-.077.545-.172.806-.306.27-.139.533-.325.782-.58.023-.024.044-.044.092 0 .044.044.023.068 0 .092-.258.263-.53.453-.812.601v.012c-.003.044-.003.089-.006.133s-.003.089-.006.133c-.003.033-.003.066-.068.063s-.062-.036-.062-.068c.003-.045.003-.09.006-.134.003-.023.003-.05.003-.074a4.526 4.526 0 0 1-.702.252c.097.46-.143.853-.388 1.247-.14.113-1.277 1.034-.803 1.31.127.061.27.091.412.106z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M636.716 125.14c-.237-.143-.542-.318-.838-.377a1.801 1.801 0 0 0-.631-.702c-.22-.142-.22-.13-.137-.287.25-.027.353-.095.356-.163.13.003.243.02.338.053a.51.51 0 0 1 .251.175c.021.027.039.053.092.012.053-.039.033-.065.012-.092a.678.678 0 0 0-.314-.22 1.279 1.279 0 0 0-.462-.058c-.015 0-.027 0-.039.006a.929.929 0 0 0-.414-.069c-.17-.16-.311-.346-.243-.577.009.009.024.012.038.015.134.038.258.077.365.127.103.045.19.1.248.166.021.024.045.047.092.003s.027-.068.006-.092a.93.93 0 0 0-.29-.198 2.228 2.228 0 0 0-.281-.104c.977-.198 1.85-.184 2.725.335.459.19.675.408.924.746l-.249.21c-.572-.014-.992.066-1.256.267-.237.178-.284.498-.293.817z"
  }))), hr_path13 || (hr_path13 = /*#__PURE__*/react.createElement("path", {
    d: "M656.147 152.189c-.193.118-.35.201-.548.234a.09.09 0 0 0 .023-.024c.128-.24.276-.45.442-.64l.065-.074.009.237.009.27zM658.596 157.431c-.13.196-.29.374-.47.536-.178.16-.38.312-.596.454-.027.017-.056.035-.092-.018s-.009-.071.018-.089c.207-.136.403-.284.58-.441.175-.157.33-.326.45-.513.018-.026.036-.053.092-.017.054.035.036.062.018.088zM660.216 155.5l-.245.376c-.018.027-.036.054-.092.018-.054-.035-.036-.062-.018-.089.083-.124.163-.252.246-.376.018-.027.035-.053.092-.018.053.036.035.062.017.092zM659.334 155.376c-.042.186-.11.364-.228.527s-.294.308-.545.424c-.03.014-.06.026-.086-.033s.003-.074.032-.086c.231-.107.388-.237.495-.382.11-.145.169-.308.207-.48.006-.032.015-.062.077-.047s.057.044.048.077zM660.921 153.439c-.065.065-.121.139-.171.222a1.437 1.437 0 0 0-.125.272c-.012.03-.02.062-.083.042s-.053-.054-.041-.083a1.42 1.42 0 0 1 .326-.542c.023-.024.044-.045.091 0 .045.044.024.068 0 .092zM662.219 153.566c-.056.184-.11.37-.178.554a3.53 3.53 0 0 1-.258.563c-.017.026-.032.056-.088.023s-.042-.062-.024-.089c.104-.18.18-.36.249-.539.065-.18.118-.364.174-.548.01-.032.018-.062.08-.044s.054.047.045.08zM661.63 145.974c.402.593.491 1.203.506 1.816a9.11 9.11 0 0 1 .157-.67l.009-.02c.169-.237.275-.474.329-.708s.053-.471.011-.705c-.006-.033-.011-.062.054-.074.062-.012.07.02.077.053.044.252.044.507-.012.758a2.098 2.098 0 0 1-.34.747c-.11.412-.19.826-.267 1.241l-.015.077c-.012.062-.13.053-.13-.012 0-.047 0-.092.002-.139.01-.773.018-1.55-.482-2.284-.018-.026-.039-.053.017-.092.054-.035.074-.008.092.018zM660.643 147.245c-.006.05-.009.1-.015.148-.003.05-.009.1-.012.151-.003.033-.006.065-.07.06s-.063-.04-.06-.072c.003-.05.009-.1.012-.148.003-.05.009-.1.015-.15.003-.033.006-.066.07-.06s.063.038.06.071zM660.368 148.969c.1.329.177.663.234 1.007.038.234.062.47.074.714.026-.045.056-.086.088-.128.107-.133.25-.248.418-.346.027-.018.056-.033.089.024s.006.074-.024.088a1.31 1.31 0 0 0-.379.317.88.88 0 0 0-.184.403c-.011.065-.13.054-.13-.012.003-.355-.027-.702-.08-1.04s-.13-.666-.228-.989c-.009-.032-.02-.062.042-.08s.07.012.08.042zM661.742 149.585a4.436 4.436 0 0 1 .08 1.487c-.003.032-.009.065-.074.056s-.06-.041-.056-.074c.026-.222.035-.453.023-.696a4.503 4.503 0 0 0-.1-.746c-.006-.033-.015-.063.05-.077.062-.015.071.017.077.05zM662.92 149.366c.045.243.069.48.057.708-.012.23-.056.45-.151.663-.08.243-.086.486-.044.729.041.249.136.497.248.75.015.029.027.058-.032.085s-.074-.003-.086-.032a3.173 3.173 0 0 1-.26-.78 1.622 1.622 0 0 1 .05-.796l.003-.006a1.7 1.7 0 0 0 .139-.62 2.812 2.812 0 0 0-.056-.678c-.006-.032-.012-.062.053-.074s.07.021.077.054zM663.49 147.41c-.03.122-.06.247-.092.371-.03.122-.06.246-.092.37-.006.033-.015.063-.077.048s-.056-.048-.048-.08c.03-.122.06-.246.092-.37.03-.122.06-.246.092-.37.009-.033.015-.063.08-.048.062.015.056.047.047.08zM662.906 144.164c.036.113.068.226.104.338.009.033.017.062-.045.08-.062.02-.07-.012-.08-.041l-.103-.338c-.012-.033-.021-.062.041-.08s.071.012.08.041zM663.205 141.697c.003.154.003.308-.009.969a.967.967 0 0 0-.293.477c-.053.198-.06.44-.009.731.006.033.012.065-.053.077s-.071-.02-.077-.053a1.778 1.778 0 0 1 .012-.788c.059-.222.174-.4.331-.54l-.026-.41c-.003-.155-.003-.309-.006-.46 0-.033 0-.065.065-.065s.065.032.065.065zM660.756 140.838c.379.249.705.524.93.85.228.329.358.705.343 1.15a.067.067 0 0 1-.092.056l-.642-.276c.142.921.106 1.656-.095 2.219a2.003 2.003 0 0 1-1.17 1.232.064.064 0 0 1-.086-.08c.11-.35.175-.699.201-1.048s.012-.7-.047-1.046c-.006-.033-.012-.065.053-.074.065-.012.071.02.074.053.06.359.077.72.048 1.078a4.8 4.8 0 0 1-.166.942c.459-.225.785-.586.968-1.099.202-.565.232-1.318.072-2.271-.01-.05.044-.092.088-.072l.661.285a1.718 1.718 0 0 0-.32-.975c-.216-.31-.527-.574-.894-.814-.027-.018-.054-.036-.018-.092.035-.053.062-.036.089-.018zM667.168 139.576l-.053.128c-.018.042-.033.086-.05.127-.012.03-.024.06-.083.036s-.048-.054-.036-.083l.054-.128c.018-.042.032-.086.05-.127.012-.03.024-.06.083-.036s.047.054.035.083zM665.66 139.544c.125.05.226.118.309.201.083.08.145.175.198.279.015.03.03.059-.026.085-.06.03-.075 0-.086-.026-.048-.092-.104-.175-.175-.246s-.157-.13-.267-.172c-.03-.012-.059-.024-.035-.083s.053-.047.083-.035zM663.421 140.186c.163.181.27.391.326.631.056.234.065.495.036.773-.003.033-.006.066-.071.06s-.063-.039-.057-.071c.027-.267.021-.513-.032-.732a1.292 1.292 0 0 0-.296-.572c-.021-.023-.045-.047.006-.091.047-.045.07-.018.091.005zM655.853 140.915l-.026.255a8.156 8.156 0 0 0-.024.255c-.003.032-.006.065-.071.059s-.062-.039-.056-.071c.009-.086.017-.172.023-.255l.027-.255c.003-.032.006-.065.071-.059s.062.039.06.071zM657.257 140.175c.036.121.072.243.11.364l.033.11c.008.032.017.062-.045.08s-.07-.012-.08-.045l-.032-.11c-.036-.12-.071-.242-.11-.364-.009-.03-.018-.062.044-.08s.072.012.08.045zM660.137 142.109a.757.757 0 0 1 .026.157c.003.053.003.103 0 .157-.003.032-.006.065-.07.059s-.063-.038-.06-.071a1.046 1.046 0 0 0 0-.136.69.69 0 0 0-.024-.137c-.009-.032-.018-.062.045-.08s.07.015.08.048zM661.129 139.917a.42.42 0 0 1 .118.195.292.292 0 0 1-.03.21c-.014.03-.032.06-.088.027-.056-.03-.042-.059-.027-.088.02-.042.027-.08.018-.122s-.039-.089-.083-.136c-.024-.024-.044-.045 0-.092.044-.044.068-.024.092 0zM654.257 140.263c0 .155.024.303.074.439.05.14.13.27.243.39.15.173.228.341.27.513.04.17.044.335.053.498 0 .032.003.065-.063.068s-.065-.03-.068-.062c-.006-.16-.011-.32-.047-.474a1.076 1.076 0 0 0-.24-.46 1.318 1.318 0 0 1-.27-.432 1.407 1.407 0 0 1-.082-.485c0-.033 0-.066.065-.066s.065.033.065.066zM657.038 142.135c.154.288.24.57.273.854.035.28.018.568-.033.867-.056.347.018.685.208 1.002.174.296.45.577.805.838a3.573 3.573 0 0 1-.16-1.123c.018-.426.148-.838.447-1.226.128-.166.214-.338.273-.512.062-.175.095-.353.118-.525.003-.032.01-.065.072-.056.065.006.059.038.056.071-.024.184-.06.367-.122.551s-.157.37-.293.548a1.984 1.984 0 0 0-.42 1.152c-.018.406.07.827.207 1.26.018.055-.05.103-.098.073-.447-.302-.788-.634-.998-.986-.204-.347-.287-.711-.222-1.087.047-.288.062-.563.03-.833s-.113-.533-.258-.805c-.015-.027-.033-.057.026-.086.057-.033.074-.003.09.026zM655.922 143.845c0 .308-.086.616-.24.924a4.233 4.233 0 0 1-.471.722c.097-.038.198-.077.296-.124a2.867 2.867 0 0 0 .874-.622c.121-.124.243-.27.367-.441.018-.027.038-.054.092-.015s.032.065.015.092a4.485 4.485 0 0 1-.38.456 3.101 3.101 0 0 1-.337.302 30.597 30.597 0 0 1 .086.427c.006.032.014.062-.05.077-.063.014-.072-.018-.078-.05l-.047-.229c-.009-.047-.018-.095-.03-.142-.154.11-.31.192-.462.264-.177.082-.352.145-.527.21-.056.02-.11-.056-.071-.104.249-.296.459-.59.604-.883.145-.29.228-.577.228-.864 0-.033 0-.066.065-.066s.066.033.066.066zM654.562 143.735v.293c0 .033 0 .065-.065.065s-.065-.032-.065-.065v-.293c0-.033 0-.065.065-.065s.065.032.065.065z"
  })), hr_path14 || (hr_path14 = /*#__PURE__*/react.createElement("path", {
    d: "M653.709 142.07c.178.436.225.842.157 1.22-.065.38-.246.732-.515 1.064l-.01.009c-.257.222-.45.489-.592.788a3.267 3.267 0 0 0-.228.646c.071-.098.142-.19.228-.276a1.39 1.39 0 0 1 .637-.38 5.94 5.94 0 0 0 .77-.503 5.03 5.03 0 0 0 .676-.63c.02-.024.044-.048.091-.006s.027.065.006.091c-.213.24-.444.454-.693.646s-.512.364-.794.518l-.014.006c-.243.066-.43.19-.587.347s-.281.352-.403.554c-.032.053-.13.018-.118-.045.065-.367.163-.713.31-1.027s.35-.593.623-.827c.255-.314.423-.646.486-1.001s.017-.738-.152-1.15c-.011-.029-.023-.058.036-.085.06-.024.074.006.086.035zM656.472 146.502c-.041.118.045.228.22.453l.118.154c.234.31.32.663.326 1.033.006.362-.062.738-.133 1.102-.012.063-.119.06-.128-.003a2.236 2.236 0 0 0-.482-1.075c-.255-.32-.596-.604-.987-.865-.026-.018-.053-.035-.018-.092.036-.053.063-.035.09-.017.402.27.752.562 1.015.894.202.252.353.524.442.824a4.25 4.25 0 0 0 .074-.765c-.006-.343-.086-.669-.3-.956-.044-.063-.082-.11-.115-.151-.204-.264-.302-.391-.24-.575.012-.03.02-.062.083-.041s.05.053.041.082zM657.651 146.424c.048.05.098.101.146.155.047.05.097.1.145.154.023.023.044.047-.003.091s-.071.021-.092-.003c-.048-.05-.098-.1-.145-.154-.048-.05-.098-.1-.145-.154-.021-.023-.045-.047.003-.091s.07-.021.091.002zM659.097 146.89c-.092.29-.18.577-.27.867-.092.29-.18.578-.272.868-.01.033-.018.062-.08.042-.062-.018-.053-.05-.042-.08.092-.29.181-.578.27-.868.092-.29.18-.578.272-.868.01-.033.018-.062.08-.044.063.02.054.05.042.083zM659.914 151.738a.302.302 0 0 0 0 .217c.012.03.024.062-.038.083-.06.023-.071-.006-.083-.039a.433.433 0 0 1 0-.311c.012-.033.024-.062.083-.039.062.024.05.054.038.083zM659.055 150.314c-.038.15-.08.305-.118.456a26.13 26.13 0 0 1-.119.459c-.008.032-.017.062-.08.047-.062-.017-.056-.047-.047-.08l.119-.459c.038-.15.08-.305.118-.456.009-.033.015-.062.08-.047.062.014.056.047.047.08zM657.817 150.308l.113.112c.024.024.044.045 0 .092-.048.045-.071.024-.092 0l-.113-.112c-.023-.024-.044-.045 0-.092.048-.045.072-.024.092 0zM656.363 149.612c-.03.086-.06.171-.092.257-.03.086-.06.172-.092.258-.012.03-.02.062-.083.039-.059-.021-.05-.054-.038-.083.03-.086.06-.172.092-.258.03-.086.059-.172.091-.258.012-.032.021-.062.083-.041s.05.053.042.083zM654.28 151.812a.867.867 0 0 0-.171.279c-.039.1-.06.204-.077.314-.006.032-.012.065-.074.053-.065-.012-.06-.041-.054-.074.021-.115.045-.228.086-.338a.962.962 0 0 1 .196-.32c.02-.023.044-.047.092-.002s.026.068.003.091zM648.321 157.65a.829.829 0 0 1-.127.199 1.373 1.373 0 0 1-.199.193c-.024.02-.05.041-.092-.012-.041-.05-.014-.071.01-.092a1.02 1.02 0 0 0 .287-.34c.014-.03.026-.06.085-.036.06.026.045.056.033.086zM649.254 157.156a.44.44 0 0 1-.127.169.765.765 0 0 1-.202.115c-.032.012-.062.024-.083-.038-.023-.062.01-.074.039-.083.065-.024.121-.056.163-.092s.07-.077.092-.121c.011-.03.026-.06.085-.033s.045.056.033.086zM650.492 156.4c-.02.036-.044.072-.077.107s-.077.071-.133.107c-.027.018-.056.035-.089-.02s-.006-.075.024-.09a.476.476 0 0 0 .169-.166c.017-.026.032-.056.088-.02.057.032.039.059.024.089zM652.355 151.555c-.059.174-.1.346-.115.518s-.006.344.03.512c.005.033.014.063-.048.078s-.071-.018-.077-.05c-.041-.184-.05-.371-.033-.555s.06-.367.122-.548c.012-.032.02-.062.083-.041s.05.053.041.083zM653.623 138.661c-.006.145-.044.287-.113.43s-.165.28-.293.42c-.02.024-.044.048-.092.003s-.026-.068-.003-.092c.119-.13.21-.26.273-.388a.96.96 0 0 0 .098-.379c0-.032.003-.065.068-.062s.062.035.062.068zM652.329 137.518c.112.195.18.394.219.592.038.196.047.394.035.59 0 .032-.003.065-.068.062s-.062-.036-.062-.068c.012-.187.003-.37-.033-.557-.035-.184-.1-.37-.204-.554-.015-.027-.033-.056.024-.089s.074-.003.089.024zM650.614 139.644a1.888 1.888 0 0 1-.507-.52.816.816 0 0 1-.118-.546c.006-.032.011-.062.074-.053.065.012.059.041.053.074a.69.69 0 0 0 .1.459c.095.16.252.32.472.483.026.018.053.038.014.092s-.065.032-.091.014zM652.512 142.87V143.152c0 .032 0 .065-.065.065s-.065-.033-.065-.066v-.281c0-.033 0-.065.065-.065s.065.032.065.065zM650.086 140.426c.382.362.61.797.732 1.28.077.3.11.616.116.948.002 0 .008-.003.014-.003.172-.06.305-.213.397-.46.098-.26.148-.621.157-1.08 0-.003.006-.03.01-.033.135-.222.218-.447.275-.67s.083-.45.103-.678c.006-.056.083-.08.119-.032.222.314.417.64.568.99s.252.719.29 1.122c.004.032.007.065-.059.07s-.068-.026-.07-.058a3.631 3.631 0 0 0-.279-1.082 4.834 4.834 0 0 0-.453-.82 3.62 3.62 0 0 1-.09.521c-.055.231-.141.46-.28.69-.01.468-.063.839-.163 1.108-.107.287-.267.465-.477.536-.021.006-.039.012-.057.003-.003.16-.011.323-.023.489-.003.033-.006.065-.071.06s-.063-.04-.06-.072c.045-.539.033-1.051-.085-1.513a2.471 2.471 0 0 0-.697-1.218c-.023-.02-.047-.044-.003-.092s.069-.023.092-.003zM651.508 146.507l-.08.513-.08.51c-.003.032-.009.064-.074.053-.062-.01-.06-.042-.053-.074l.08-.51.08-.512c.006-.033.009-.063.074-.054.062.012.06.042.053.074zM648.777 147.666l.071.388c.006.032.012.062-.053.074-.062.012-.071-.021-.077-.054l-.071-.388c-.006-.032-.012-.062.053-.074.062-.012.071.021.074.054zM651.138 144.532a2.838 2.838 0 0 1-.199.746c-.103.24-.245.474-.432.696l-.003.003c-.234.255-.347.519-.382.794s.003.563.08.856c.009.033.015.062-.047.08-.063.015-.072-.015-.08-.047a2.363 2.363 0 0 1-.083-.904c.038-.299.163-.59.414-.865.178-.21.314-.432.412-.66.098-.231.16-.468.19-.714.003-.033.008-.065.07-.056.066.009.06.041.057.074zM650.522 143.614c.044.248.006.494-.098.743-.104.24-.27.483-.483.723l-.006.006c-.222.186-.379.39-.503.601a5.133 5.133 0 0 0-.308.66c-.012.03-.024.06-.086.036-.06-.024-.048-.053-.036-.083.092-.228.187-.456.317-.678s.296-.436.527-.631c.202-.228.359-.456.457-.684.094-.222.13-.448.088-.667-.005-.032-.011-.062.054-.077.062-.012.07.02.077.054zM647.51 145.044c.07.498-.007.924-.193 1.298-.184.373-.477.693-.835.98-.024.02-.05.041-.092-.012-.042-.05-.015-.07.012-.092.343-.275.625-.583.8-.936s.248-.752.18-1.223c-.003-.033-.009-.065.056-.074s.068.024.074.056zM643.662 147.174c.038.077.074.154.11.23.04.084.08.164.118.247.015.03.026.059-.03.086-.059.026-.074 0-.086-.03-.038-.083-.08-.163-.118-.246-.036-.077-.074-.154-.11-.228-.015-.03-.026-.06.03-.086.06-.026.074 0 .086.03zM642.136 147.204c-.003.293.021.583.092.861.074.279.193.548.388.806l.006.012c.098.198.154.397.193.598.026.148.044.297.053.445.187-.199.329-.4.432-.61.119-.243.181-.495.187-.756 0-.032 0-.065.065-.062.065 0 .065.032.062.065a1.96 1.96 0 0 1-.198.809c-.127.26-.314.51-.56.75-.038.038-.107.01-.11-.045-.008-.193-.023-.385-.059-.572s-.089-.373-.177-.56c-.202-.27-.33-.554-.406-.847s-.101-.592-.098-.897c0-.033 0-.066.065-.066s.065.033.065.066zM642.344 152.414a3.287 3.287 0 0 1 .225-.957c.012-.03.023-.06.083-.036.062.024.047.054.038.083a3.155 3.155 0 0 0-.216.916c-.003.032-.003.065-.071.059-.065-.003-.062-.036-.06-.068zM642.166 153.865l.08-.578c.003-.032.009-.065.074-.056s.06.042.056.074l-.08.578c-.003.032-.009.065-.074.056s-.059-.041-.056-.074zM641.168 156.297c.095-.095.186-.207.272-.332.09-.127.172-.266.255-.412.015-.03.033-.056.089-.026.056.032.041.059.024.089a5.182 5.182 0 0 1-.261.423c-.092.13-.187.249-.29.35-.024.023-.048.044-.092 0s-.021-.068 0-.092zM639.725 148.137v.24c0 .032 0 .065-.065.065s-.065-.033-.065-.066v-.24c0-.032 0-.065.065-.065s.065.033.065.066zM637.285 153.758c-.003-.059-.006-.118-.012-.177l-.012-.18c0-.034-.003-.066.062-.07s.068.028.068.063l.012.178c.003.06.006.118.012.178 0 .032.003.065-.062.068s-.068-.027-.068-.063zM643.413 143.759c-.124.43-.222.876-.213 1.259.006.37.11.678.376.85.31.201.447.503.577.796.01.018.015.036.024.054.039-.145.071-.3.086-.453.02-.19.02-.374-.006-.54-.006-.032-.012-.065.053-.077.063-.011.072.021.074.054.03.177.03.376.01.574a3.13 3.13 0 0 1-.14.643c-.018.053-.095.06-.118.009a7.43 7.43 0 0 1-.098-.213c-.122-.276-.249-.56-.53-.74-.308-.2-.43-.546-.439-.957-.006-.397.092-.856.22-1.298.008-.032.017-.062.08-.044s.053.047.044.08zM642.983 142.12c.042.335.03.643-.026.954a5.007 5.007 0 0 1-.29.951c-.157.4-.229.824-.208 1.25.02.424.13.844.326 1.244.015.03.03.06-.03.086-.059.03-.074 0-.086-.03a3.17 3.17 0 0 1-.124-2.598 4.75 4.75 0 0 0 .281-.926 2.84 2.84 0 0 0 .027-.913c-.003-.032-.009-.065.056-.074.063-.008.069.024.074.057zM640.137 146.173a.989.989 0 0 0-.074.586c.035.199.121.4.243.601.018.027.032.057-.02.09-.057.032-.075.005-.09-.024a1.88 1.88 0 0 1-.258-.646 1.095 1.095 0 0 1 .083-.66c.015-.03.027-.06.086-.033s.045.056.033.086zM638.896 145.728c.02.116.027.252.015.388a1.072 1.072 0 0 1-.09.338v.003a.497.497 0 0 0-.047.329c.024.115.083.23.163.35.018.026.036.053-.017.091s-.072.012-.092-.018a1.065 1.065 0 0 1-.184-.396.605.605 0 0 1 .06-.415.951.951 0 0 0 .076-.293 1.382 1.382 0 0 0-.012-.353c-.005-.032-.011-.065.054-.074.065-.012.07.02.074.053zM646.153 134.98a2.897 2.897 0 0 0 .39 1.833c.019.026.033.056-.023.089s-.071.003-.089-.024c-.163-.284-.287-.587-.358-.904s-.092-.651-.048-1.007c.003-.032.006-.065.072-.056.065.006.062.039.056.071zM645.243 135.859c.17.3.314.622.424.974s.184.741.21 1.17c.003.033.003.066-.062.069s-.065-.03-.068-.063a4.71 4.71 0 0 0-.616-2.085c-.015-.03-.033-.056.024-.089s.074-.003.088.024zM640.735 135.998c-.435.62-.625 1.123-.66 1.558-.036.433.08.794.252 1.129l.002.009c.119.343.172.684.163 1.027-.006.341-.077.685-.198 1.025-.012.033-.02.063-.083.039-.062-.02-.05-.054-.039-.083.119-.329.184-.655.193-.984a2.81 2.81 0 0 0-.154-.977c-.18-.352-.302-.738-.264-1.194s.234-.983.685-1.623c.017-.027.038-.053.091-.018.054.039.036.066.015.092zM644.938 134.215a.918.918 0 0 1-.065.572c-.077.174-.21.34-.409.497-.201.157-.32.362-.373.608-.056.251-.044.545.018.873.006.033.012.066-.053.077-.062.012-.071-.02-.077-.053-.063-.347-.074-.655-.015-.924a1.14 1.14 0 0 1 .42-.681c.181-.143.3-.294.37-.448a.793.793 0 0 0 .057-.491c-.006-.033-.015-.063.05-.077.063-.012.071.02.077.05zM640.486 134.597c.086.276.09.545.01.815-.078.266-.238.53-.48.788l-.006.006a1.512 1.512 0 0 0-.465.72c-.092.28-.125.595-.143.92-.003.033-.003.066-.068.063s-.062-.036-.062-.068c.018-.335.053-.658.148-.954s.249-.563.5-.776c.229-.243.377-.489.451-.735a1.263 1.263 0 0 0-.009-.74c-.009-.033-.02-.063.042-.08s.07.012.08.044zM643.034 134.73a.954.954 0 0 0 0 .29c.015.093.05.181.11.267.017.027.035.054-.018.092-.054.036-.071.012-.092-.018a.784.784 0 0 1-.13-.317 1.02 1.02 0 0 1 0-.328c.002-.033.008-.066.074-.057s.059.042.056.074zM642.912 134.061a1.066 1.066 0 0 0-.539.5c-.124.235-.198.537-.222.907.015.018.024.033.024.044.124.17.21.37.263.596.06.246.08.524.072.826 0 .033-.003.065-.069.062s-.062-.035-.062-.065a3.029 3.029 0 0 0-.068-.794 1.528 1.528 0 0 0-.225-.524c-.483.45-.72.948-.735 1.49-.017.566.205 1.182.631 1.84.018.026.036.056-.017.091s-.072.006-.09-.02c-.44-.682-.669-1.322-.651-1.914.018-.583.273-1.117.797-1.596v-.003c.02-.406.1-.738.24-.999.142-.263.34-.45.604-.56.03-.011.06-.023.086.036.024.06-.006.074-.036.086zM642.19 133.125c-.006.053-.012.095-.015.14-.033.307-.065.654-.3.864-.13.116-.213.252-.272.397a1.97 1.97 0 0 0-.11.486c-.002.032-.005.065-.07.056-.066-.006-.06-.038-.057-.074.02-.18.056-.355.119-.518a1.15 1.15 0 0 1 .305-.448c.195-.174.23-.497.257-.779.006-.053.012-.103.015-.142.003-.032.01-.065.074-.056s.06.041.057.074zM649.266 140.675c.077.16.14.326.18.495s.063.343.054.524c0 .033-.003.065-.068.062s-.062-.035-.062-.068a1.791 1.791 0 0 0-.048-.489 2.429 2.429 0 0 0-.175-.468c-.014-.03-.026-.059.033-.085s.071 0 .086.03zM649.287 142.997c.056.267.059.54.011.812s-.148.551-.296.832c-.1.234-.198.468-.299.702-.015.03-.027.06-.086.036s-.047-.056-.035-.086c.1-.234.198-.471.299-.705l.003-.006c.145-.27.24-.533.287-.794a2.008 2.008 0 0 0-.012-.764c-.006-.032-.012-.065.05-.077.063-.015.072.018.078.05zM647.812 140.835c.423.471.699.969.829 1.493.133.524.118 1.075-.042 1.65-.008.032-.017.062-.08.044s-.053-.047-.044-.08c.154-.554.169-1.08.042-1.584s-.394-.984-.803-1.44c-.02-.024-.042-.047.006-.092s.07-.017.092.006zM647.681 143.442a6.646 6.646 0 0 1-1.084 1.653 3.148 3.148 0 0 0-.672 1.173c-.018.059-.13.038-.125-.024.012-.196-.012-.391-.065-.587s-.142-.394-.26-.59v.004c-.237-.35-.338-.702-.32-1.052.02-.35.16-.696.408-1.042.143-.243.243-.489.314-.732s.107-.489.116-.734c0-.033.003-.066.068-.063s.062.036.062.068a3.26 3.26 0 0 1-.45 1.529l-.003.006c-.234.329-.367.654-.385.977-.018.326.08.649.3.975l.002.003c.124.207.216.414.276.625.026.097.047.195.059.293a3.312 3.312 0 0 1 .586-.91 6.15 6.15 0 0 0 .62-.811 6.68 6.68 0 0 0 .444-.812c.014-.03.026-.059.086-.032s.044.056.032.086zM643.816 142.198c-.01.323.02.625.086.909.065.281.171.545.32.788.017.027.032.056-.021.089-.056.035-.071.006-.089-.02a2.817 2.817 0 0 1-.335-.824 3.742 3.742 0 0 1-.089-.942c0-.033.003-.065.066-.063.065.003.065.036.062.066zM641.615 143.377v.379c0 .032 0 .065-.065.065s-.065-.033-.065-.065v-.38c0-.032 0-.065.065-.065s.065.033.065.066zM642.344 141.365c.006.223-.024.439-.092.646-.071.207-.18.406-.34.592-.022.024-.042.05-.093.006-.05-.041-.026-.065-.006-.091a1.62 1.62 0 0 0 .314-.551 1.71 1.71 0 0 0 .086-.602c0-.032-.003-.065.063-.065s.065.033.065.062zM640.362 145.27c-.355-.886-.441-1.588-.352-2.16a2.455 2.455 0 0 1 .705-1.374c.234-.24.438-.477.571-.773s.196-.652.148-1.132c-.003-.033-.006-.065.06-.071s.065.027.07.06c.048.503-.017.879-.16 1.196-.139.314-.352.563-.595.811a2.339 2.339 0 0 0-.67 1.304c-.085.55 0 1.232.347 2.094.012.03.024.06-.035.083s-.074-.006-.086-.036zM639.219 143.815a.9.9 0 0 0-.057.43c.015.142.069.287.157.432.018.027.036.056-.02.089-.057.035-.071.006-.09-.021-.097-.16-.156-.323-.174-.486s.003-.326.065-.488c.012-.03.024-.06.083-.039.062.024.048.053.039.083zM644.84 139.822c.235.329.37.67.398 1.025s-.054.723-.255 1.105c-.015.027-.03.056-.086.027-.06-.03-.042-.06-.027-.086.19-.359.267-.702.24-1.034-.024-.332-.154-.652-.373-.96-.02-.026-.039-.053.015-.092s.07-.012.092.015zM646.597 138.448a3.002 3.002 0 0 1 .089 2.088c-.018.06-.124.047-.127-.018-.012-.326-.08-.619-.202-.877s-.302-.48-.536-.669c-.024-.02-.05-.041-.009-.092s.065-.03.092-.009c.252.202.441.439.572.714.08.169.139.353.174.548.039-.216.057-.432.048-.649a2.81 2.81 0 0 0-.22-.989c-.011-.03-.023-.06.036-.086.06-.023.074.006.086.036zM647.64 137.023c.23.228.394.53.494.903.098.368.134.8.116 1.295v.003c-.024.21-.033.415-.009.604.02.187.074.358.172.513.018.026.035.056-.018.091-.056.036-.074.006-.092-.02a1.326 1.326 0 0 1-.192-.57 2.85 2.85 0 0 1 .009-.633v.003c.017-.483-.018-.903-.11-1.256-.095-.35-.246-.63-.46-.844-.023-.024-.047-.045 0-.092.045-.047.069-.024.093 0zM644.873 136.748c-.15.183-.243.4-.287.64a2.42 2.42 0 0 0 .006.8c.006.032.012.061-.053.073-.063.012-.069-.02-.075-.053a2.528 2.528 0 0 1-.005-.844c.047-.261.15-.495.314-.7.02-.023.041-.05.091-.008s.03.065.01.092zM639.45 140.4c-.024.539-.18.977-.433 1.339-.251.358-.595.642-1 .88-.028.017-.057.032-.09-.024s-.006-.071.024-.09c.388-.227.72-.5.96-.843.24-.341.388-.756.411-1.268 0-.033.003-.065.069-.062s.062.035.062.068zM639.31 138.534c.03.201.018.397-.026.592a2.715 2.715 0 0 1-.22.584c-.014.03-.029.056-.085.03-.06-.03-.045-.06-.03-.087.095-.19.169-.373.21-.554s.054-.358.027-.545c-.003-.032-.009-.065.056-.074s.072.024.074.057zM642.983 138.264v.184l.063.954.006.085c.003.033.003.066-.06.072h-.02c-.01.011-.024.017-.054.017-.065 0-.065-.032-.065-.065v-1.054l-.018-.258c-.003-.033-.006-.065.06-.071.065-.003.068.027.07.06v.02c.015.012.015.032.015.053zM643.87 136.626c-.262.317-.365.622-.371.921s.086.599.222.895c.308.495.409.986.376 1.48-.03.493-.192.981-.409 1.47-.014.03-.026.06-.085.033s-.045-.057-.033-.086c.213-.474.367-.951.397-1.425a2.31 2.31 0 0 0-.359-1.41l-.003-.006c-.145-.314-.242-.63-.236-.957.005-.328.121-.66.4-1 .02-.024.04-.051.091-.01s.03.066.01.092zM638.173 126.47c.43-.33.85-.516 1.292-.563.438-.045.891.05 1.383.281l.489-.006c.165-.003.334-.006.5-.006.033 0 .065 0 .065.065s-.032.065-.065.065c-.169.003-.335.006-.5.006l-.45.006-.01.01c-.527.464-.977.719-1.377.802a1.324 1.324 0 0 1-1.09-.237c-.032-.024-.065-.047-.02-.113s.08-.044.112-.02c.29.201.604.284.966.21.35-.074.746-.29 1.211-.684-.427-.187-.818-.26-1.194-.222-.408.041-.805.219-1.211.53-.033.023-.065.047-.113-.015-.047-.065-.017-.089.015-.113z"
  })), hr_path15 || (hr_path15 = /*#__PURE__*/react.createElement("path", {
    d: "M639.447 126.22c.18 0 .326.146.326.326a.327.327 0 0 1-.326.326c-.178 0-.326-.145-.326-.326s.145-.325.326-.325zM641.69 128.19c.233-.121.414-.251.565-.385.148-.133.266-.27.367-.406.018-.026.039-.053.092-.014s.032.065.015.091a2.83 2.83 0 0 1-.385.43c-.157.14-.347.272-.593.4-.03.015-.059.03-.086-.027-.03-.056-.003-.074.027-.086zM646.313 126.277a.652.652 0 0 1 .361.003.957.957 0 0 1 .35.192c.023.021.05.042.009.092s-.066.03-.092.009c-.101-.083-.205-.14-.302-.166s-.196-.026-.294-.003c-.032.01-.062.018-.08-.047-.017-.062.015-.071.045-.08zM643.668 126.383c.103-.236.26-.417.477-.533.213-.112.482-.16.811-.13.033.003.065.006.06.071s-.04.062-.072.06c-.305-.027-.55.014-.74.115a.91.91 0 0 0-.418.47c-.012.03-.026.06-.086.033s-.047-.056-.032-.086zM643.97 126.816a.529.529 0 0 1 .145-.3.697.697 0 0 1 .335-.183c.032-.009.062-.018.08.045s-.015.07-.045.08a.556.556 0 0 0-.272.148.432.432 0 0 0-.11.23c-.006.033-.012.063-.074.054s-.06-.041-.053-.074zM639.568 128.28a1.993 1.993 0 0 0-.183.352 1.028 1.028 0 0 0-.06.414c.003.033.006.065-.059.068s-.068-.026-.071-.059a1.18 1.18 0 0 1 .065-.468c.048-.136.119-.26.196-.379.017-.027.035-.056.089-.02.056.035.038.062.02.088zM640.83 128.845v.195c0 .033 0 .066-.065.066s-.065-.033-.065-.066v-.195c0-.033 0-.065.065-.065s.065.032.065.065zM640.01 127.435a1.2 1.2 0 0 0 .388.074c.13 0 .263-.018.394-.047.032-.006.062-.015.077.047s-.018.071-.048.08a1.748 1.748 0 0 1-.426.05 1.244 1.244 0 0 1-.433-.083c-.032-.011-.062-.023-.038-.083.023-.062.053-.047.083-.038zM640.821 125.068a.397.397 0 0 0-.26.08.472.472 0 0 0-.163.237c-.01.033-.018.062-.08.045s-.054-.05-.045-.08c.033-.104.1-.22.21-.302a.538.538 0 0 1 .341-.107c.033 0 .065.003.065.065 0 .065-.032.065-.065.065zM639.509 125.202a.995.995 0 0 0-.234.136.318.318 0 0 0-.104.142c-.012.033-.02.062-.083.042s-.05-.05-.041-.083a.46.46 0 0 1 .145-.202c.068-.056.157-.11.27-.157.03-.012.059-.024.083.036.026.059-.003.074-.036.086zM638.7 125.225c-.08.057-.148.116-.204.184s-.1.145-.133.228c-.012.03-.021.062-.083.039-.06-.021-.05-.054-.039-.083.036-.098.09-.187.154-.267s.142-.148.231-.21c.027-.018.054-.036.092.017s.012.072-.018.092zM637.66 126.058c-.085.065-.168.136-.248.219s-.154.172-.225.27c-.018.026-.039.053-.092.014s-.033-.065-.015-.092c.074-.103.154-.198.237-.284s.172-.163.264-.231c.026-.02.053-.039.092.012.038.053.011.07-.015.092zM637.764 127.204c-.062.068-.124.136-.186.201l-.19.202c-.02.023-.044.047-.092.003s-.026-.068-.003-.092l.187-.201c.062-.066.124-.134.19-.202.02-.024.044-.047.091-.003s.027.068.003.092zM636.713 127.509v.403c0 .032 0 .065-.065.065s-.065-.033-.065-.065v-.403c0-.033 0-.065.065-.065s.065.032.065.065zM638.06 129.28c-.02.22-.04.439-.062.66l-.006.063c-.003.033-.005.065-.07.06s-.063-.04-.06-.072c.003-.02.003-.041.006-.062l.062-.66c.003-.033.006-.066.071-.06s.063.039.06.071zM637.27 128.694c-.003.142-.01.287-.015.43 0 .032-.003.065-.068.062s-.062-.036-.062-.066c.003-.145.008-.287.014-.432 0-.033.003-.065.069-.062s.062.035.062.068zM636.535 123.084a.91.91 0 0 1 .584.584c.012.032.02.061-.042.082s-.07-.012-.083-.041a.811.811 0 0 0-.195-.317.87.87 0 0 0-.311-.19c-.03-.012-.06-.023-.039-.083.024-.062.054-.05.083-.038zM642.986 131.496c.125.281.193.563.196.841.006.282-.05.563-.169.844-.012.03-.024.06-.083.036s-.047-.056-.035-.086c.11-.264.163-.527.157-.79a1.973 1.973 0 0 0-.184-.792c-.015-.03-.027-.059.033-.086s.074.003.085.033zM640.883 133.928c.092-.317.225-.593.38-.844s.328-.48.503-.705c.201-.261.335-.545.406-.836.077-.314.08-.64.024-.948-.006-.032-.012-.062.053-.074.062-.011.071.021.074.054.06.326.056.666-.024 1-.074.309-.213.611-.43.887a7.893 7.893 0 0 0-.494.693 3.27 3.27 0 0 0-.364.811c-.01.033-.018.062-.08.045s-.054-.048-.045-.08zM638.18 133.214c.043-.119.109-.222.198-.314s.198-.169.328-.231c.03-.015.06-.027.086.03.027.059 0 .074-.032.085a.993.993 0 0 0-.294.205.716.716 0 0 0-.168.27c-.012.029-.024.062-.083.038-.06-.02-.05-.053-.039-.083zM637.655 133.024c.1-.13.201-.251.317-.358.118-.11.251-.202.406-.264.03-.012.059-.023.082.036.024.062-.005.074-.038.083-.14.056-.258.139-.364.237-.11.1-.208.222-.303.343-.02.027-.038.054-.091.012-.054-.038-.033-.065-.012-.092zM640.457 130.246c.112.05.219.074.323.077s.204-.012.302-.039c.032-.008.062-.017.08.045s-.015.071-.045.08a.995.995 0 0 1-.71-.044c-.03-.015-.06-.027-.033-.086s.056-.045.086-.033zM639.062 130.065l.097-.112.012-.015c.021-.024.045-.047.092-.006.048.044.027.068.006.092l-.012.015a3.445 3.445 0 0 1-.1.112c-.021.024-.042.048-.092.006-.048-.041-.027-.068-.006-.092zM669.227 138.768c.062.068.115.139.163.216.044.077.08.157.11.243.011.032.02.062-.042.08-.062.02-.071-.012-.083-.042a.95.95 0 0 0-.098-.216.995.995 0 0 0-.145-.192c-.02-.024-.044-.048.003-.092s.071-.021.092.003zM635.738 154.484c.143.13.29.249.454.332.16.08.337.13.539.13.032 0 .065 0 .065.065s-.033.066-.065.066c-.223 0-.418-.057-.599-.146a2.202 2.202 0 0 1-.483-.35c-.023-.02-.047-.044-.002-.09s.068-.028.091-.004z"
  })), _g6 || (_g6 = /*#__PURE__*/react.createElement("g", {
    fill: "red"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M661.016 124.479c.744.032 1.46.003 2.07-.098-.651.471-1.483.788-2.38.936.174-.136.287-.278.337-.423a.533.533 0 0 0-.027-.415zM659.242 124.295c.483.08.983.136 1.478.17.006.01.015.02.02.032.08.11.104.216.069.32-.042.118-.154.242-.338.37-.05.035-.1.07-.03.169a7.037 7.037 0 0 1-1.516.026.22.22 0 0 0 .05-.041c.181-.19.297-.385.33-.59a.783.783 0 0 0-.063-.453zM646.132 120.528a16.54 16.54 0 0 1 2.55-.116c.285.116.495.284.625.507.143.248.193.574.134.98-.01.06-.018.121.103.136.122.018.13-.044.137-.103.065-.463.006-.839-.163-1.135a1.307 1.307 0 0 0-.32-.367c.077.003.154.006.23.012.996.053 1.77.337 2.634.767.006.006.015.015.02.024.184.192.247.39.217.595-.033.216-.163.45-.37.69-.039.047-.08.092.015.172.091.08.133.032.171-.015.234-.275.388-.548.427-.815a.87.87 0 0 0-.045-.435c.73.361 1.47.708 2.19 1.087.014.009.029.015.044.024a.14.14 0 0 0 .012.047c.059.205.035.38-.065.53-.11.157-.309.294-.596.4-.056.021-.112.042-.07.157.04.113.1.092.156.071.338-.127.575-.29.71-.491a.79.79 0 0 0 .134-.566c.477.258.954.524 1.443.758l.003.003c.086.172.1.326.032.468-.07.151-.237.293-.5.424-.054.026-.11.053-.057.163s.11.083.163.056c.317-.157.519-.338.613-.54a.68.68 0 0 0 .054-.432c.169.074.34.145.515.21.471.175 1.04.326 1.65.439.003.006.009.012.015.018.112.157.15.308.124.453-.026.151-.118.305-.266.46-.042.044-.083.085.003.17a.323.323 0 0 0 .038.033c-1.851-.19-3.498-1.075-5.222-1.741-.204-.08-.412-.157-.616-.237-.637-.24-1.28-.566-1.92-.827a.2.2 0 0 0-.082-.041c-.045-.015-.086-.03-.13-.041-.027-.012-.057-.021-.084-.033.003.003.01.006.012.009a10.594 10.594 0 0 0-1.771-.415 7.639 7.639 0 0 0-2.032-.02l-.113-.018c.06-.365.012-.685-.168-.963a1.564 1.564 0 0 0-.587-.518z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M643.102 121.342c.85-.37 1.712-.607 2.592-.752.403.16.67.355.82.586.145.228.18.495.13.803a5.246 5.246 0 0 0-2.299.281c-.195-.411-.458-.66-.766-.796a1.553 1.553 0 0 0-.477-.125zM652.423 126.058c-.228-.145-.459-.288-.699-.418-1.152-.634-2.473-1.025-3.797-1.075.012-.01.02-.02.033-.03.47-.48.574-.933.414-1.356-.124-.33-.411-.634-.808-.91.444-.023.856.003 1.318.068.651.092 1.496.311 2.266.622.19.415.243.78.16 1.087-.086.323-.33.593-.72.815-.053.03-.107.06-.047.166s.112.077.165.044c.454-.254.732-.574.836-.965.08-.302.056-.64-.077-1.016.521.234.992.512 1.32.817.43.296.854.596 1.268.91.003.527-.15.826-.405.983-.27.163-.655.184-1.093.14-.06-.007-.122-.013-.134.109v.006z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M654.959 127.965c-.77-.601-1.523-1.23-2.331-1.771.447.035.847 0 1.15-.18.292-.181.485-.495.517-1.008.483.373.948.767 1.39 1.19.222.211.444.419.672.623 0 .003.003.006.003.012.053.19.071.352.056.488a.574.574 0 0 1-.139.33.684.684 0 0 1-.34.192c-.217.062-.498.074-.845.035-.056-.006-.115-.012-.13.092z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M657.616 129.716a14.382 14.382 0 0 1-.767-.424c-.59-.35-1.144-.75-1.686-1.167.332.027.61.009.836-.053a.937.937 0 0 0 .456-.264.806.806 0 0 0 .201-.468 1.153 1.153 0 0 0-.003-.266c.53.453 1.087.873 1.689 1.24.314.193.63.374.944.543-.003.02 0 .041.003.065.039.243-.097.397-.346.495-.29.115-.723.162-1.218.192-.056.003-.11.006-.115.1z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M660.453 130.83c-.9-.246-1.77-.59-2.568-.978.457-.033.86-.086 1.15-.201.328-.13.518-.332.506-.655.527.267 1.055.498 1.59.687.096.21.101.382.013.527-.107.178-.341.326-.631.454-.057.023-.113.05-.063.16v.002z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M666.366 130.228c.077-.012.55-.136.305.045-1.742 1.14-3.952 1.137-6.034.6.323-.144.587-.319.72-.538.1-.163.118-.35.071-.554.663.216 1.336.37 2.029.459a.47.47 0 0 1-.11.317c-.11.136-.296.27-.6.403-.057.023-.114.047-.063.16.047.112.104.086.16.062.343-.151.566-.311.696-.474a.687.687 0 0 0 .163-.441c.856.092 1.741.08 2.666-.042zM654.322 160.23c-.13.137-.24.288-.346.466-.507.168-.954.42-1.5.396 0 .353.116.507.469.51.672-.338.823-.4.882-.353.083.071-.094.554-.651.945-.086.054-.083.086-.033.175.471.738 1.706.474 2.37.3.474-.125 1.33-.688 1.567-1.162.092-.216-.116-.5-.323-.732-.524.08-.705-.162-.622-.331-.554-.196-1.17-.237-1.813-.214zM635.386 154.262a4.095 4.095 0 0 1-1.315.729c-.19.062-.649.174-.693.414-.006.086.308.273.51.163.556-.533.834-.237.195.308-.05.104-.01.22.1.317.578.519 2.009.687 2.66.276.483-.302.735-.634.314-1.093.003-.104.015-.205.033-.308l-.797-.08-.489-.285-.518-.441zM647.85 158.598c-.047.006-.098.012-.145.021-.258.279.45.175.826.406.172.104.246.308.178.592-.347.827-2.28.56-2.923.22-.3-.157-.311-.338-.3-.596a2.7 2.7 0 0 0 .406-.03c.231-.032.46-.1.684-.228.063-.035.128-.074.057-.198-.071-.127-.137-.092-.199-.056-.19.106-.385.166-.58.192-.202.03-.41.03-.608.021h-.05c-.112-.065-.198-.142-.151-.21.047-.065.234.006.27.017.299-.139.56-.228.882-.29.045-.044.086-.092.13-.136.59.05 1.153.14 1.526.275zM638.908 158.092c-.119.071-.16.172-.246.358-.338.34-.66.545-1.093.74-.359.164-.012.32.24.492.228.17.527-.198.714-.476.204-.308.411-.217.278.023a2.432 2.432 0 0 0-.27.842c-.076.213.735.376.874.382.495.023 1.117-.46 1.505-.705.323-.33.273-.616.13-1.016l.003-.027a2.463 2.463 0 0 1-.595-.06 4.29 4.29 0 0 1-.7-.23c-.029-.012-.058-.024-.035-.086.015-.039.033-.048.054-.045l-.853-.195zM642.37 125.125c.137-.006.273-.012.406.003.252.03.492.139.744.168.84-.317 1.537-.491 2.138-.465a7.1 7.1 0 0 1 2.16-.272.192.192 0 0 1-.027-.024c-.086-.086-.045-.13 0-.172.394-.4.486-.767.358-1.099-.13-.343-.486-.666-.98-.962-.527.059-1.034-.083-1.594-.02-.35.038-.693.115-1.03.227.28.1.527.267.728.504.249.293.427.693.521 1.196.012.06.021.119-.097.143s-.13-.039-.143-.098c-.085-.46-.245-.82-.468-1.084-.234-.335-.77-.465-.938-.533-.56.056-1.111.118-1.591.242-.361.092-.678.22-.921.41.361-.078.737-.063 1.063.1.311.154.575.444.74.915.021.056.04.116-.076.154s-.137-.018-.154-.077c-.14-.406-.359-.649-.617-.776-.512-.255-1.57-.032-2.017.3-.26.195-.521.447-.779.74-.026.032-.056.062-.092.065.96.065 1.926.115 2.672.415zm-2.846-.542c-.02-.054.015-.092.047-.13.27-.306.542-.575.824-.783.272-.201.554-.346.844-.414.296-.33.734-.528 1.244-.658.495-.127 1.06-.193 1.632-.249-.169-.34-.385-.545-.634-.654-.267-.119-.575-.137-.903-.104-.69.237-1.304.607-1.893 1.025.053 0 .107 0 .157.003.175.012.332-.015.477.041.059.02.115.042.074.157-.05.14-.433.054-.566.045a1.69 1.69 0 0 0-.5.047c-.03.006-.057.015-.083.006-.62.382-1.087.77-1.588 1.194.38.133.675.29.868.474z"
  }))), hr_path16 || (hr_path16 = /*#__PURE__*/react.createElement("path", {
    fill: "#0093dd",
    d: "m711.17 195.594 25.923-58.758-19.123-30.876-34.102 12.627-15.784 62.1a274.19 274.19 0 0 1 43.082 14.91z"
  })), hr_path17 || (hr_path17 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M678.11 141.244a314.594 314.594 0 0 1 49.48 17.126l-10.002 22.68a289.893 289.893 0 0 0-45.586-15.775z"
  })), hr_path18 || (hr_path18 = /*#__PURE__*/react.createElement("path", {
    fill: "red",
    d: "m719.196 177.407 6.683-15.145a310.646 310.646 0 0 0-48.812-16.895l-3.94 15.494a294.82 294.82 0 0 1 46.3 16.025l-.23.521z"
  })), hr_path19 || (hr_path19 = /*#__PURE__*/react.createElement("path", {
    d: "M681.878 157.168c.447-.282.924-.214 1.404-.137.388-.145.835-.195 1.32-.177.208-.113.448-.193.72-.243.146-.113.152-.234.021-.364-.121-.149-.19-.294-.198-.442-.77-.447-1.055-1.128-1.348-1.804-.438-.115-.643-.263-.69-.43-.213-.02-.424-.04-.634-.064-.998.11-1.256-.214-1.611-.477-.296-.098-.554-.26-.72-.572-.11-.14-.22-.275-.329-.415-.272-.346-.19-.805.222-.779.29.033.578.033.845-.082.31-.14.776-.137 1.128-.107.418-.024.681-.293 1.087-.673l-.006-.485c-.065-.175.018-.252.249-.228.542.017.865.272 1.084.634.631.11 1.129.411 1.463.941.839.003 1.404.32 1.472.631.05.228-.195.49-.574.768.003.056.006.115.006.171.225.196.373.391.45.584.471.18.921.423 1.342.779 1.2-.14 3.222.731 5.956 2.476 1.775.317 3.496.809 5.148 1.523.35.011.7.02 1.046.032 2.965-.438 5.838-.1 8.504 1.937 1.007.122 1.91.439 2.784.8.649.267 1.31.37 1.976.433a9.91 9.91 0 0 1 3.255.873c1.218.273 2.355.655 3.06 1.508.5.604.38 1.161-.258 1.392-.385.812-1.152.847-2.301.447-.791.146-1.662-.488-2.453-1.084-1.099-.352-2.109-.986-3.107-1.661-.518-.388-1.043-.634-1.552-.744-.4-.086-.758-.142-.998 0-.119.071-.104.113 0 .199a1.6 1.6 0 0 1 .536 1.004c.056.37-.003.796.018 1.25.023.477.31.823.79 1.12.33.2.72.414 1.286.494.27.053.347.21.338.415.15.722.29 1.451.554 2.106.074.186.216.275.43.432.73.527.352 1.117-.315 1.244-.583.516-1.087.862-1.685.998-.477.16-.673-.035-.833-.27a.604.604 0 0 1-.554-.307c-.583-.43-.085-1.176 1.31-.856.03-.163.148-.214.266-.21-.083-.362-.13-.765.027-1.14-.124-.08-.231-.182-.412-.24-.503-.16-.98-.392-1.356-.744-.714-.673-1.83-1.235-2.906-1.801-.889-.045-1.55-.453-2.245-.8l-.942-.012c-.276-.092-.5.003-.667.202-.278.337-.601.281-.983.237-.438-.05-.883-.018-1.321-.024-.216.053-.43.121-.664.124-.494-.026-.977-.032-1.306.243-.272.287-.545.267-.817.16-.205-.095-.353-.195-.439-.302-.343-.071-.566-.157-.64-.26-.577-.164-.74-.327-.713-.49-.768-.183-.403-.787.094-.808.587-.024 1.123.089 1.698.169.482.136 1.078.056 1.472-.3.254-.23.35-.429.66-.6-.992-.066-1.724-.24-2.263-.581-1.451-.915-2.612-1.138-3.536-.362-.246.14-.439.196-.702.095a1.329 1.329 0 0 0-.73-.035c-.523.118-1.042.053-1.566-.137-.767.193-1.531.234-2.298.077-.65.341-1.123.38-1.425.119-.285-.16-.554-.323-.809-.498-.412-.062-.59-.166-.607-.302-.527-.06-.592-.252-.59-.462-.219-.252-.136-.444.083-.607.391-.163.797-.222 1.247.009.27.127.468.252.631.379.3-.036.557 0 .782.083.166-.26.637-.273 1.153-.243.257-.172.565-.293.96-.329-.013-.062-.024-.124-.033-.184-.519-.136-.785-.512-1.043-.891-.797-.015-1.368-.35-1.937-.7-.468.04-.844-.115-1.209-.334-.296.024-.625.036-.936-.044-.616.169-1.2.157-1.75 0-.388.035-.7-.003-1.02-.033-.363.418-.772.492-1.22.279-.245-.311-.595-.516-1.036-.631-.335-.11-.439-.255-.498-.412-.409-.252-.326-.5.068-.69.297-.142.667-.169 1.23.11.183.068.388.115.619.133z"
  })), hr_path20 || (hr_path20 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M701.41 163.121c-.04-.068-.122-.24-.421-.068-.927-.05-1.964-.038-2.743-.497-.812-.477-1.647-.975-2.545-.94.267-.251.599-.423.984-.527.515-.136 1.125-.145 1.8-.035.949.154 1.784.338 2.43.58.622.234 1.06.525 1.253.898a.507.507 0 0 0 .053.06c.249.16.465.322.646.494.136.127.254.26.355.403a3.123 3.123 0 0 1-.892-.054 3.593 3.593 0 0 1-.924-.32z"
  })), hr_path21 || (hr_path21 = /*#__PURE__*/react.createElement("path", {
    d: "m703.542 118.368.053.279 1.167 6.042-4.641 4.046-.213.187.27.095 5.817 2.01 1.181 6.043.057.279.213-.187 4.65-4.031 5.827 1.996.27.092-.054-.278-1.167-6.046 4.641-4.046.214-.186-.27-.092-5.817-2.014-1.182-6.043-.057-.278-.213.186-4.653 4.034-5.824-1.999z"
  })), _g7 || (_g7 = /*#__PURE__*/react.createElement("g", {
    fill: "#f7db17"
  }, /*#__PURE__*/react.createElement("path", {
    d: "m700.698 128.667 4.337-3.78 5.453 1.879zM711.21 126.626l4.352-3.782 5.435 1.88zM721.036 124.917l-4.337 3.78-5.453-1.878zM710.523 126.961l-4.35 3.78-5.436-1.878zM704.158 118.925l5.441 1.866 1.102 5.66zM711.184 127.005l5.45 1.878 1.09 5.649zM717.576 134.66l-5.441-1.864-1.102-5.66zM710.55 126.579l-5.45-1.875-1.09-5.649zM714.327 117.047l1.105 5.646-4.352 3.782zM710.84 127.171l1.1 5.66-4.346 3.771zM707.407 136.537l-1.104-5.645 4.35-3.783zM710.894 126.413l-1.1-5.66 4.346-3.768z"
  }))));
};

/* harmony default export */ var hr = (SvgHr);
;// CONCATENATED MODULE: ./public/flags/sl.svg
var sl_path, sl_path2, sl_path3;

function sl_extends() { sl_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return sl_extends.apply(this, arguments); }



var SvgSl = function SvgSl(props) {
  return /*#__PURE__*/react.createElement("svg", sl_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 450 300"
  }, props), sl_path || (sl_path = /*#__PURE__*/react.createElement("path", {
    fill: "#0072C6",
    d: "M0 0h450v300H0z"
  })), sl_path2 || (sl_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#FFF",
    d: "M0 0h450v200H0z"
  })), sl_path3 || (sl_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#1EB53A",
    d: "M0 0h450v100H0z"
  })));
};

/* harmony default export */ var sl = (SvgSl);
;// CONCATENATED MODULE: ./public/flags/tr.svg
var tr_path, _circle, _circle2, tr_path2;

function tr_extends() { tr_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return tr_extends.apply(this, arguments); }



var SvgTr = function SvgTr(props) {
  return /*#__PURE__*/react.createElement("svg", tr_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 800"
  }, props), tr_path || (tr_path = /*#__PURE__*/react.createElement("path", {
    fill: "#E30A17",
    d: "M0 0h1200v800H0z"
  })), _circle || (_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 425,
    cy: 400,
    r: 200,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/react.createElement("circle", {
    cx: 475,
    cy: 400,
    r: 160,
    fill: "#e30a17"
  })), tr_path2 || (tr_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "m583.334 400 180.901 58.779-111.804-153.885v190.212l111.804-153.885z"
  })));
};

/* harmony default export */ var tr = (SvgTr);
;// CONCATENATED MODULE: ./public/flags/gr.svg
var gr_path, gr_path2;

function gr_extends() { gr_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return gr_extends.apply(this, arguments); }



var SvgGr = function SvgGr(props) {
  return /*#__PURE__*/react.createElement("svg", gr_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 18"
  }, props), gr_path || (gr_path = /*#__PURE__*/react.createElement("path", {
    fill: "#0D5EAF",
    d: "M0 0h27v18H0z"
  })), gr_path2 || (gr_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "none",
    strokeWidth: 2,
    stroke: "#FFF",
    d: "M5 0v11M0 5h10m0-2h17M10 7h17M0 11h27M0 15h27"
  })));
};

/* harmony default export */ var gr = (SvgGr);
;// CONCATENATED MODULE: ./public/flags/is.svg
var is_path, is_path2, is_path3;

function is_extends() { is_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return is_extends.apply(this, arguments); }



var SvgIs = function SvgIs(props) {
  return /*#__PURE__*/react.createElement("svg", is_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2500 1800"
  }, props), is_path || (is_path = /*#__PURE__*/react.createElement("path", {
    d: "M0 0h2500v1800H0",
    fill: "#003897"
  })), is_path2 || (is_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M700 0h400v1800H700M0 700h2500v400H0",
    fill: "#fff"
  })), is_path3 || (is_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M800 0h200v1800H800M0 800h2500v200H0",
    fill: "#d72828"
  })));
};

/* harmony default export */ var is = (SvgIs);
;// CONCATENATED MODULE: ./public/flags/ru.svg
var ru_path, ru_path2, ru_path3;

function ru_extends() { ru_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ru_extends.apply(this, arguments); }



var SvgRu = function SvgRu(props) {
  return /*#__PURE__*/react.createElement("svg", ru_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 6"
  }, props), ru_path || (ru_path = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h9v3H0z"
  })), ru_path2 || (ru_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#d52b1e",
    d: "M0 3h9v3H0z"
  })), ru_path3 || (ru_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#0039a6",
    d: "M0 2h9v2H0z"
  })));
};

/* harmony default export */ var ru = (SvgRu);
;// CONCATENATED MODULE: ./public/flags/mx.svg
var _defs, mx_path, mx_path2, mx_path3, mx_g, mx_g2, mx_g3, mx_path4, mx_path5, mx_path6, mx_path7, mx_path8, mx_circle, mx_circle2, _circle3, mx_path9, mx_path10, mx_path11, mx_path12, mx_path13, mx_path14, mx_g4, mx_g5, _ellipse, mx_g6, mx_g7, _ellipse2, _g8, mx_path15, _ellipse3, _g9, _g10, _g11, _g12, _g13, _g14, mx_path16, mx_path17, mx_path18;

function mx_extends() { mx_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return mx_extends.apply(this, arguments); }



var SvgMx = function SvgMx(props) {
  return /*#__PURE__*/react.createElement("svg", mx_extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 840 480"
  }, props), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("radialGradient", {
    id: "mx_svg__b",
    xlinkHref: "#mx_svg__a",
    gradientUnits: "userSpaceOnUse",
    cx: 842.31,
    cy: 103.66,
    r: 25.86,
    gradientTransform: "matrix(.18574 .04718 -.04532 .18635 233.8 198.77)"
  }), /*#__PURE__*/react.createElement("radialGradient", {
    id: "mx_svg__c",
    xlinkHref: "#mx_svg__a",
    gradientUnits: "userSpaceOnUse",
    cx: 651.52,
    cy: 550.46,
    r: 25.86,
    gradientTransform: "matrix(-.17642 -.07067 .06515 -.16392 430.54 377.88)"
  }), /*#__PURE__*/react.createElement("radialGradient", {
    id: "mx_svg__d",
    xlinkHref: "#mx_svg__a",
    gradientUnits: "userSpaceOnUse",
    cx: 380.84,
    cy: 740.37,
    r: 25.86,
    gradientTransform: "matrix(.0989 .0037 -.0045 .1943 442.36 123.3)"
  }), /*#__PURE__*/react.createElement("linearGradient", {
    id: "mx_svg__a"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/react.createElement("stop", {
    stopColor: "#f15770",
    offset: 1
  })))), mx_path || (mx_path = /*#__PURE__*/react.createElement("path", {
    fill: "#ce1126",
    d: "M0 0h840v480H0z"
  })), mx_path2 || (mx_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h560v480H0z"
  })), mx_path3 || (mx_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#006847",
    d: "M0 0h280v480H0z"
  })), mx_g || (mx_g = /*#__PURE__*/react.createElement("g", {
    fill: "#fcca3e",
    stroke: "#aa8c30"
  }, /*#__PURE__*/react.createElement("path", {
    strokeWidth: 0.35,
    d: "m466.96 303.53.3 5.88 2.21-1.47-1.7-4.84z"
  }), /*#__PURE__*/react.createElement("circle", {
    strokeWidth: 0.3,
    cx: 466.7,
    cy: 301.93,
    r: 1.89
  }), /*#__PURE__*/react.createElement("path", {
    strokeWidth: 0.35,
    d: "m474 312.69-4.3-4.12-1.93 1.55 5.84 3.4z"
  }), /*#__PURE__*/react.createElement("path", {
    strokeWidth: 0.3,
    d: "M473.63 315.01c-.6-.81-.4-2 .45-2.66a1.87 1.87 0 0 1 2.64.29c.6.81.4 2-.45 2.66-.85.65-2.03.52-2.64-.29z"
  }), /*#__PURE__*/react.createElement("path", {
    strokeWidth: 0.35,
    d: "m507.04 251.22 4.4 4.38.52-2.22-4.03-2.7z"
  }), /*#__PURE__*/react.createElement("circle", {
    strokeWidth: 0.3,
    cx: 506.45,
    cy: 250.09,
    r: 1.84
  }), /*#__PURE__*/react.createElement("path", {
    strokeWidth: 0.35,
    d: "m518.65 253.82-6.73 1.92.55-2.22 5.79-.57z"
  }), /*#__PURE__*/react.createElement("circle", {
    strokeWidth: 0.3,
    cx: 519.74,
    cy: 252.89,
    r: 1.8
  }), /*#__PURE__*/react.createElement("path", {
    strokeWidth: 0.35,
    d: "m496.03 287-4.1-6.4.65-.33 4.65 5.5z"
  }), /*#__PURE__*/react.createElement("circle", {
    strokeWidth: 0.3,
    cx: 491.52,
    cy: 279.12,
    r: 1.91
  }), /*#__PURE__*/react.createElement("path", {
    strokeWidth: 0.35,
    d: "m496.29 287.17 5.22.95.19-.71-4.37-1.73z"
  }), /*#__PURE__*/react.createElement("circle", {
    strokeWidth: 0.3,
    cx: 503.1,
    cy: 288.18,
    r: 1.89
  }), /*#__PURE__*/react.createElement("path", {
    strokeWidth: 0.3,
    d: "M373.59 301.72c0 .91-.71 1.56-1.4 1.56-.66 0-1.21-.74-1.21-1.64 0-.91.55-1.65 1.22-1.65.68 0 1.39.83 1.39 1.73z"
  }), /*#__PURE__*/react.createElement("path", {
    strokeWidth: 0.35,
    d: "m373.56 304.65 1.2 6.57-1.6-.63-.57-5.7z"
  }), /*#__PURE__*/react.createElement("path", {
    strokeWidth: 0.3,
    d: "M375.01 302.42c.77 1-.53 2.51-1.9 2.89-1.39.37-3.1-.26-3.09-1.52.02-1.44 2.01-.69 2.54-.86.83-.26 1.63-1.58 2.45-.51z"
  }), /*#__PURE__*/react.createElement("ellipse", {
    strokeWidth: 0.3,
    cx: 363.57,
    cy: 312.49,
    rx: 2.04,
    ry: 1.48
  }), /*#__PURE__*/react.createElement("path", {
    strokeWidth: 0.35,
    d: "m367.03 312.14 6.3-.31-1.06-1.26-5.18.56z"
  }), /*#__PURE__*/react.createElement("path", {
    strokeWidth: 0.3,
    d: "M367.56 311.41c.53 1.6.57 3.77-1.22 3.54-1.79-.23-1.45-1.83-1.59-2.44-.26-1.13-1.3-2.14-.23-3.23 1.08-1.1 2.51.53 3.04 2.13z"
  }), /*#__PURE__*/react.createElement("ellipse", {
    strokeWidth: 0.3,
    cx: 347.01,
    cy: 276.95,
    rx: 1.24,
    ry: 1.88
  }), /*#__PURE__*/react.createElement("path", {
    strokeWidth: 0.35,
    d: "m347.03 281.12.14 6.11-1.59-1.44.12-4.87z"
  }), /*#__PURE__*/react.createElement("path", {
    strokeWidth: 0.3,
    d: "M349.39 279.26c.32 1.41-1.75 2.2-3.15 1.94-1.4-.26-2.47-1-2.26-2.29.21-1.3 1.96-1 2.56-.64.6.35 2.4-.99 2.85.99z"
  }), /*#__PURE__*/react.createElement("ellipse", {
    strokeWidth: 0.3,
    cx: 336.23,
    cy: 286.5,
    rx: 2.13,
    ry: 0.97
  }), /*#__PURE__*/react.createElement("path", {
    strokeWidth: 0.35,
    d: "m340.06 286.5 4.8-.32 2.04 1.58-6.91-.26z"
  }), /*#__PURE__*/react.createElement("path", {
    strokeWidth: 0.3,
    d: "M338.3 283.93c1.3.04 2.19 1.47 2 2.98-.18 1.51-1.35 2.74-2.54 2.55-1.2-.19-1.1-1.2-1.08-1.5.03-.3.7-.85.77-1.34.07-.48-.34-1.57-.19-2.07.16-.5.46-.64 1.04-.62zm-3.87-37.19c-.54.85-1.55 1.5-2.07 1.17-.52-.34-.33-1.52.2-2.38.53-.85 1.39-1.27 1.9-.94.52.34.5 1.3-.03 2.15z"
  }), /*#__PURE__*/react.createElement("path", {
    strokeWidth: 0.35,
    d: "m329.08 256.35 2.68-6.31-.4-.35-3.04 4.44z"
  }), /*#__PURE__*/react.createElement("path", {
    strokeWidth: 0.3,
    d: "M331.27 250.05c-1.33-.97-1.62-1.96-1.2-2.94.43-.98 1.43-.35 1.43-.35s.65.73 1.13.98c.49.26 1.25-.08 1.82.72.57.8.23 1.61-.23 1.82-.45.2-1.84.57-2.95-.23zm-11.13-.83c.95.54 1.46 1.46 1.13 2.06-.33.59-1.37.63-2.32.09-.95-.54-1.45-1.46-1.12-2.06.32-.6 1.36-.63 2.31-.09z"
  }), /*#__PURE__*/react.createElement("path", {
    strokeWidth: 0.35,
    d: "m322.92 251.99 4.95 2.97-.15 2.33-5.37-4.61z"
  }), /*#__PURE__*/react.createElement("path", {
    strokeWidth: 0.3,
    d: "M322.88 252.55c-1.1 1.23-2.1 1.41-3.01.87-.92-.54-.18-1.47-.18-1.47s.78-.58 1.09-1.04c.3-.45.06-1.27.91-1.75.86-.47 1.6-.04 1.76.44.14.48.35 1.93-.57 2.95z"
  }))), mx_g2 || (mx_g2 = /*#__PURE__*/react.createElement("g", {
    fill: "#aa8c30"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M468.03 303.97s-.36.24-.56.63c-.19.38-.4 1.16-.4 1.16l.02-1.9.64-.37.3.48z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M468.31 302.78s-.44.75-1.5.7c-1.04-.07-1.55-.55-1.68-1.09-.13-.53-.13-.92.21-1.54.34-.62-.5.59-.5.59v1.18l.77.91.65.2.65.04.82-.27.55-.42.03-.3zm5.53 9.66s-.53.28-.93.13a21.72 21.72 0 0 1-4.57-2.34l4.99 3.1.51-.89zm3.1 1.41s-.06.87-1.02 1.3c-.96.44-1.64.24-1.99-.18a1.87 1.87 0 0 1-.5-1.47c.03-.7-.18.75-.18.75l.53 1.06 1.09.45.68-.12.58-.26.61-.62.31-.63-.11-.28zm31.85-62.45s-.13.2-.13.52l-.02.9-1.08-1.2.55-.71.68.49zm-.58-1.57c.06.86-1.2 2.1-2.13 1.7-.94-.38-1.62-1.36-1.1-2.33.5-.97-.26.37-.26.37l.13 1.43.89.81 1.11.07.87-.5.54-.97-.05-.58zm13.17 2.35s-.21-.6-.1.07c.1.68-.76 2.11-1.76 1.98-1-.13-1.46-1-1.38-1.81.09-.81-.16.28-.16.28l.15 1.08.54.5.77.46.89-.15.8-.52.37-.76v-.55l-.12-.58z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M516.87 253.18s.03.45-.56.78c-.6.32-1.73 1-1.73 1l3.7-1.09-.3-.9-1.11.21zm-22.44 29.39s-.2.22-.21.68c-.01.47.1 1.02.1 1.02l-2.08-3.29.61-.39 1.58 1.98zm-1.14-3.09c-.37.87-1.88 1.42-2.6 1-.73-.43-1.35-2-.46-2.69l-.46.4-.24.9.33.94.73.82.67.2 1.06-.2.78-.62s.56-1.61.19-.75zm7.32 7.53s.02.39-.66.39l-2.1.02 3.44.67.17-.7-.85-.38z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M504.85 287.82c.3 1.15-.71 2.26-2.03 1.87-1.32-.39-1.68-1.7-1.26-2.4l-.33.82.24 1.1.8.7.84.18.84-.21.86-.82.21-.98-.17-.26zm-129.93 14.64c.36.4-.2 1.9-1.69 2.5-1.49.6-2.23.03-2.63-.47-.4-.5-.37-1.04-.37-1.04l-.2.28.2.78.74.64 1.32.29.99-.19.96-.51.5-.52.42-.64.06-.77-.24-.4h-.06l-.02.04.02.01z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M373.59 305.73s-.26.08-.48.46c-.23.37-.31 1.04-.31 1.04l-.12-1.76.77-.4.14.66zm-4.97 5.28s-.14.38.26.58c.4.2 1.33.43 1.33.43l-2.44.08-.26-.94 1.11-.15zm-.83 1.52s.03.09.02.25c0 .16-.05.4-.19.7-.29.6-.4 1.3-1.28 1.12a1.62 1.62 0 0 1-1.33-1.4c-.09-.58-.29-.81-.29-.81v.77l.54 1.3.88.4h.77l.6-.23.28-.78.14-.63-.14-.69z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M361.63 312.36s.29 1.12 1.53 1.15c1.25.03 1.57-.35 1.57-.35l.14.44-.46.23-1.08.12-.96-.19-.44-.33-.34-.59.04-.48zm-12.39-33.34s.04.13-.04.54c-.09.4-.85 1.38-2.28 1.4-1.43.03-2.02-.45-2.4-.93-.4-.47-.46-1.14-.46-1.14l-.04.71.55.89 1.41.66h1.34l1.37-.4.6-.65.13-.73-.18-.35zm-2.26 3.03s-.51.04-.77.27c-.25.23-.48.5-.48.5l-.02-1.69 1.27.1v.82zm-6.14 4.48s-.1.1.64.43c.74.33 4.1.7 4.1.7l-5.4-.15.2-.92.46-.06zm-.61.1s-.01.2-.28.75-.95 2-2.09 1.8c-1.14-.2-1-1-1-1.12v-.4l-.2.82.26.57.47.3.92.1.63-.27.68-.65.35-.69.29-.73-.03-.48zm-2.91.14s-.03.26-.92.29c-.9.02-2.18-.36-2.18-.36l.43.53.74.19.92.01.72-.07.29-.59zm-2.75-37.91s.2.58-.31.95-1.62.6-2.33.2c-.71-.4-2-1.7-2-1.7l.6 1.07.94.78 1.3.37 1.26-.2.57-.5.17-.4-.2-.57z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M330.76 250.59s.03.15 0 .72c-.03.58-.26 1.53-.26 1.53l1.14-2.54-.45-.4-.43.69zm-7.04 1.99s-.17-.17.17.58 3.12 3.42 3.12 3.42l-4.43-3.74.51-.72.63.46zm-1.48.43s-.57.35-1.08.38c-.51.03-1.36-.03-1.48-.64-.1-.6.17-.86.17-.86l-.36.83.14.46.65.38.91.09.82-.4.23-.24zm-1.79-1.9s.06.17-.77.06c-.82-.12-1.81-1.07-1.81-1.07l.65 1.04 1.39.57.54-.6z"
  }))), mx_g3 || (mx_g3 = /*#__PURE__*/react.createElement("g", {
    fill: "#9ca168"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M524.81 238.85c-.4 5.03-5.37 7.6-7.96 9.48-2.6 1.89-3.86 4.22-3.86 4.22l-.88 2.93-.42 1.88-.09.65c.17.53.4 1.43.43 2.8.07 2.28-.15 5.54-.15 5.54l3.5-2.5 2.53-.95.76-.13s-2.8 2.8-3.91 5.82c-1.1 3.03-3.16 9.45-6.99 11.53-3.83 2.07-6.22 1.21-7.5 2.33-1.27 1.12-1.32 1.43-1.32 1.43l-1.63 2.23-1.3 1.67-1.2.84-.76.62c-.03.62-.1 1.43-.31 2.17-.42 1.48-.92 3.12-.92 3.12s.76-.47 1.7-.58c.92-.12 1.78-.11 1.78-.11s-.72.89-.98 1.75c-.25.87.17 6.05-4.77 9.16-4.94 3.11-17.52 2.62-17.52 2.62l-2.38.95-2.25 1.68-2.05 2.24-.15.6s-1.55 1.9-2.66 2.63l-3.66 2.42s2.17-.09 2.9.17c.72.26 4.6 1.99 4.6 1.99s-2.84-.06-4.77.69c-1.94.75-10.74 5.73-15 5.59-4.25-.14-10.33-6.37-10.33-6.37l-2.76-1.93-4.57-.89-5.65-.32.08-.74.1-.91s1.92-.22 5 .14c2.65.32 3.52 1.2 5.74 1.45a9.45 9.45 0 0 0 4.66-.43c.81-.37 7.65-6.16 7.65-6.16l7.69-2.7 2.93.44 1.3.34 1.2.35s-.4.63-1.26 1.42c-.85.8-1.92 1.35-1.92 1.35l.94.75 4.86-.78 1.58.41s.13.03.46.24c.07-.35.27-1.07.7-1.64.6-.78 3.33-3 4.5-3.78 1.17-.78 1.43-.89 1.81-1.3.38-.41 1.96-4.47 1.96-4.47l.21-2.07 5.37-5.17 3.62-3.85 1.58-4.38-.17-.89s1.3 1.34 1.06 4.06c-.23 2.73-.83 3.68-.83 3.68s3.66-2.53 5.62-3.4a6.28 6.28 0 0 1 3.14-.6 8.82 8.82 0 0 0 2.78-2.42c1.07-1.55 1.35-2.01 1.35-2.64 0-.62.17-3.65.17-3.65l-.34-9.27 3.15-6.98 4.58-4.1.87-.52s-.36.97-.43 1.64c-.06.67-.06 1.86-.06 1.86s2.32-3.18 3.51-3.76l.74-.35c.25-.44.68-1.33.94-2.56.37-1.76.43-4.12.43-4.12l.07-3.84-.75-2.98-2.13-5.73-.08-7.54-1.6-2.15s1.51-.12 3.39 2.59c1.87 2.7 2.43 6.5 2.43 6.5l4.35-13.35s1.16 1.57 1.99 4.21c.83 2.64 1.09 4.43 1.09 4.43l1.71-3.7c-.01.03-.05.25.2 1.3.3 1.23 2.96 2.77 2.56 7.8zm-88.33 85.35s-.81-2.05-5-4.12c-4.19-2.08-7.31-2.48-7.31-2.48l-.05 1.54 6.58 2.87 3.28 2.68 2.5-.5z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#717732",
    d: "M466.42 311.65c.4-.54 3.94-3.7 5.75-4.62 1.81-.93 4.22-1.1 4.22-1.1 2.5-.46 2.9-.1 8.65-3.27s7.03-6.83 8.13-7.71c1.11-.89 3.13-1.1 3.13-1.1s-2.4 2.83-4.51 5.14c-2.1 2.31-4.37 3.78-7.6 5.96-3.24 2.19-9.97 2.3-9.97 2.3-2.84.64-3.8 1.33-5.37 2.71-1.58 1.39-2.65 2.9-2.65 2.9s-.18-.67.22-1.21zm15.87-16.66c-5.32 4.86-7.07 9.38-7.07 9.38s4.73-4.06 7.16-6.4c2.42-2.33 5.83-3.45 7.36-4.88 1.54-1.43 1.62-2.63 2.6-3.54.98-.9 1.7-1.34 1.7-1.34s-2.34-1.82-11.75 6.78zm-11.23 11.25s2.28-1 3.14-3.04c.64-1.51.3-1.9 1.28-3.63 0 0 5.53-5.34 7.49-7.65 3.5-4.1 1.92-7.47 1.92-7.47s.38 1.73-1.07 3.54c-1.45 1.81-8.59 6.7-9.45 9.51-.87 2.8-.39 2.91-.77 4.4-.89 3.45-2.54 4.35-2.54 4.35zm-3.68 13.82s-2.79-1.87-5.9-1.67c-6.37.4-11.75 4.32-15.95 4.43-4.2.12-5.86-2-9.1-4.2-3.47-2.36-12.04-2.02-12.04-2.02l-.06.2-.06.25s5.9.06 8.41.76c4.8 1.33 7.4 6.33 12.85 6 7.08-.41 12.88-4.72 15.77-4.7 4.97.03 6.08.95 6.08.95zm-31.56-3.22s4.94.89 8.77-1.93c3.84-2.8 8.4-6.6 10.9-6.78 2.52-.17 5.16.48 5.16.48s-3.2-1.43-5.75-1.39c-2.56.05-5.15.4-7.54 1.82-2.39 1.43-3.54 4.01-6.13 5.66a16.79 16.79 0 0 1-5.4 2.14zm-.88 6.63c-.66 0-1.42.43-1.68.39-.25-.04-1.77-1.6-3.88-2.72-2.1-1.12-5.25-1.8-5.25-1.8s-.39.1.31.33c.7.24 3.3 1.12 4.96 1.9 1.67.78 3.35 2.55 3.5 2.83.15.28.74 1.08 1.98 1.04 1.23-.05 1.73-.76 1.6-1.23-.13-.48-.88-.74-1.54-.74zm3.47-4.8s1.96 1.12 5.2 1.04c6.9-.17 11.25-4.9 15.77-6.62 4.5-1.73 6.82-.24 6.82-.24s.12-.24-.02-.35a9.23 9.23 0 0 0-5.05-1.58c-7.58.12-14.68 4.9-17.77 6.2-3 1.25-4.94 1.56-4.94 1.56zm73.4-52.26c-2.33 2.4-5.8 10.07-7.33 12.16-1.53 2.1-3.45 2.72-4.28 3.57-.73.74-3.51 4.49-4.15 5.4-.64.9-.84.65-1.28 1.04-.45.38-.68.4.06.21.75-.2.98-.65 2.13-1.94 1.15-1.3 1.09-1.88 2.92-3.52 1.83-1.65 5.15-3.52 6.8-5.54 1.64-2.01 5-9.82 6.76-11.72 1.9-2.06 5.22-3.29 5.22-3.29s-2.62-.76-6.85 3.63zM500 280.95s-.09-1.38 1.62-3.42c1.7-2.03 2.3-1.77 3.66-4.75 1.36-2.98 1.96-5.88 3.07-9.03 1.1-3.16 3.02-6.27 3.02-6.27s-1.79.17-3.62 2.64c-1.83 2.46-4.73 6.96-6.22 11.36-1.5 4.41-1.53 9.47-1.53 9.47zm-2.17 2.89s.63-.34.72-4.19c.09-3.84-.21-9.24.9-11.92 1.1-2.68 6.98-9.12 6.98-9.12s-2.43.6-5.84 3.32c-3.4 2.72-4.85 6.14-4.68 8.73.17 2.6 1.62 5.53 1.75 8.09.12 2.54.17 5.09.17 5.09zm13.84-26.47s1.45-5.22 2.04-6.48c.6-1.27.63-2.02 3.58-5.33 1.7-1.9 3.35-3.12 4.06-5.77.71-2.65.69-10.05.69-10.05s-.77.69-1.4 1.99c-.62 1.3-.17 6.1-1.28 8.32-1.1 2.22-3.6 7.44-4.85 8.56 0 0-.26-3.75.2-7.52.45-3.77 1.73-4.92 2.3-7.4.57-2.48.22-8.88.22-8.88s-2.01 2.08-3 4.47c-1 2.39-1.6 6.68-1.62 9.9-.03 3.24.74 5.86.85 7.7.1 1.84.25 2.7-.49 4.73-.73 2.01-.36.63-.82 2.59a45.72 45.72 0 0 1-.93 3.43l.45-.26zm-4.6-28.3s1.76 2.23 1.47 4.76c-.28 2.54-1.25 5.88-.25 8.53 1 2.65 2.47 2.9 2.87 4.43.4 1.53.42 4.51.42 4.51s.83-5.66.26-7.22c-.57-1.55-.82-.83-1.65-2.47-.82-1.64.03-6.14-.6-8.76-.62-2.62-2.52-3.77-2.52-3.77z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M402.55 323.75s.53-1.49 4.11-3.24c3.58-1.75 8.97-4.1 9.48-3.8.5.3-.28 2.25-.28 2.25l-3.47 1.05-2.77 1.63-3.24 2.1-3.83.01z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M411.67 314.34c-4.57.17-7.07 1.3-7.94 1.47-.3.06-.97.53-1.53.25-1.07-.53-2-2-2-2l-.97-.81-.23 3.28-6.67-5.79-.71 3.83-.85 1.76-6.62-6.25.31 4.84s-1.73.23-1.81.17l-4.72-3.28-1.39.46 1.54 2.85-5.97.46s-.48.26-1.3 1c-.8.76-1.25 1.46-1.25 1.46s-.18.3.03.44c.22.14 1.85.1 2.36-.09.5-.2.84-.9.99-.61.15.29.34 1.6 1.13 1.47.79-.13 3.56-2.23 5.53-1.31 2.2 1.03-2.85 2.52-2.33 4.08s4.17.9 5.1.4c.92-.5 3.68-3.94 4.82-2.63 1.57 1.82-3.31 3.24-2.41 5.06.87 1.76 3.6 1.37 4.92.6 1.32-.75 4.39-5.47 5.07-4.45 1.18 1.77-2.59 3.45-1.64 4.82.95 1.38 3.03-.05 4.42-1.02 1.38-.97 1.94-3.29 3.85-4.37 1.92-1.08 1.79-.63 2.32-.64.53-.03 2-1.5 2-1.5l4.51-1.9 2.2.15 1.15.54 2.25.32.27-1.9s-2.61-1.23-4.43-1.16zm-36.05.04.95-1.7-.54-.82s-1.59-.89-3.04-2.36c-1.45-1.47-1.98-1.8-2.64-2.14-.66-.33-2.9-1.78-2.9-1.78l-1-3.72-.6-1.07-1.72.67-2.26-7.98-.45-1.43-.93-.06-1.86 4.84-2.08-3.02-.53-6.62-1.3 1.45-1.66 1.7-2.97-6s-.24-.16-.39.34c-.15.49-.4 2.38-.22 3.5-.8-.49-2.15-1.42-3.98-3-3-2.59-3.73-3.92-3.73-3.92l-1.4-3.17 1.31-2.8.66-3.32-2.9 1.19-.5-7.52-.45-2.38-3.5 5s-1.36-1.93-1.36-2.15l.07-4.75-.94-.28-1.43 2.68s-1.37-2.77-1.98-3.35c.1-1.07.26-3.78-.39-5.87-.81-2.67-1.77-4.09-1.43-6.26.34-2.18 1.23-2.39 1.13-3.36-.1-.96-1.54.63-1.06-.65s5.04-4.18 4.09-5.7c-.96-1.53-5.35 2.38-4.33-.24 1.02-2.63 5.25-2.67 5.49-6.33.15-2.28-3.99 1.42-4.36.27-.38-1.14 2.55-3.49 2.52-4.97-.04-1.49.54-1.66-.28-2.46-.81-.8-3.33 3.11-3.33 3.11l-2.76-1.04-.96 3.95-.85 3.35-3.4-2 .91 4.08.82 3.97-3.55-.9 1.88 3.39 2.44 2.48 1.51 2.05 1.1.58 1.46 1.46.5 2.18s.86 2.38.86 2.49l.14 2.34.03 1.56-.07 1.2-.06.46-.07.52-.03 1.42c-.67.07-1.75-1.02-2.15-.34-.42.73 2.05 2.63 1.58 3.1-.47.49-4.09-.73-4.3.44-.22 1.17.34 2.8 2.43 3.33 2.08.52 6.94 1.64 6.13 2.59-.8.95-6.09-2.9-5.88-.08a4.96 4.96 0 0 0 3.41 4.49c1.36.52 6.69-.09 6.39 1.17-.3 1.25-4.34-.4-4.73 1.42-.38 1.82 2.81 2.07 3.5 2.07.68 0 2.9-.08 3.74.57.86.65 3.84 3.8 5.71 5.4a98.67 98.67 0 0 0 6.03 4.43h-.05c-1-.1-3.1-.32-3.43.43-.42.97 8.01 3.98 5.59 4.91-2.42.93-5.03-2.57-5.73-.43-.7 2.14 1.6 3.95 2.92 4.73 1.31.78 8.79.16 7.32 1.85-1.46 1.7-6.88-1.14-6.93.87-.05 2 3.61 5.18 5.49 5.1 1.87-.09 3.93-3.1 4.78-1.47.86 1.62-1.44 2.28.36 2.71 1.8.43 3.09-1.85 5.18-1.44 2.1.42 5.39 1.75 7.23 3.42 1.84 1.68 3.73 3.62 3.73 3.62z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#717732",
    d: "M404.74 322.82c1.28.02 1.45.71 1.62.7.17-.03 2.32-1.87 4.37-2.99 2.04-1.12 5.15-1.8 5.15-1.8l.2.29s-3.71.92-5.5 2.18c-2.22 1.56-3.96 2.53-4.07 2.8-.1.29-.92.83-2.17.85-1.26.02-1.8-.73-1.8-1.1 0-.37.92-.95 2.2-.93zm11.16-5.65s-1.1.11-1.73-.44a5.67 5.67 0 0 0-3.35-1.03c-1.34 0-3.47.73-5.17 2.36-.14.13-.48.75-1.93 1.73.5.1 1.48-.58 2.55-1.44 1.54-1.25 3.47-1.59 4.83-1.79 1.36-.2 2.22.58 2.84 1 .63.44 1.9.32 1.9.32l.06-.71zm-66.25-27.08c.14-.06.12-.36.03-.88-.2-.08-1.03-.43-2.89-1.53-2.17-1.3-6.68-4.89-6.68-4.89s1.87 1.82 3.75 3.5c1.87 1.69 5.24 3.76 5.24 3.76l.01.02c.3.03.5.04.54.02zm46.77 33.13s.68-.9 1.9-2.84c1.21-1.96 2.32-2.58 2.49-2.82.17-.24-.47-1.19-.83-1.92-.36-.74-.3-1.51-.3-1.58 0-.06.45 1.15 1.34 1.82.9.66 1.43 1.23 1.43 1.23s1.79-.24 1.83-.59c.04-.34-.04-.58-.34-.7-.3-.14-.64.26-1.45-.1-1.68-.73-2.36-3.28-3.37-3.37-1-.08-.28 2.7-.72 2.75-1.55.15-2.77-5.66-6.5-5.9-2.62-.17-3.08.32-3.21.9-.13.59 3.17 4.07 2.06 4.56-1.1.5-4.62-5.46-7.17-5.53-2.56-.06-2.77.91-2.58 1.47.19.56 2.83 1.06 2.21 2.92-.6 1.8-3.17-2.78-5.53-2.53-2.37.26-2.62.43-2.73 1.1-.1.67.83 1.65.5 1.88-.35.24-1.84.17-3.03 1-1.2.82-2.86 3.07-2.86 3.07s1.56-2.2 3.62-2.45c2.07-.23 7.29.03 7.29.03s-.7-.44-1.47-1.13-1.43-2.1-1.43-2.1 1.15 1.09 2.26 2c1.1.9 2.49 1.6 2.49 1.6s2.22.21 2.36.47c.15.26-.06.78-.97 1.77-.92 1-2.24 2.16-2.24 2.16s2.21-1.68 2.64-2.05c.43-.37 1.96-1.53 1.96-1.53s1.62.21 1.79.17c.17-.04.09-.6-1-2.2-1.08-1.6-2.11-3.33-2.11-3.33s1.33 1.22 2.68 3 1.15 2.6 1.7 2.69c.56.08 1.45.2 1.86.19.54-.03.4.77-.54 2.2-.93 1.42-1.48 3.26-1.48 3.26s.95-1.54 1.97-2.6c1.03-1.05 1.56-2.3 1.96-2.37.41-.06 1.78.1 1.97.02.2-.08-.33-.65-1.05-2.12-.72-1.47-.96-3.5-.96-3.5s.7 1.9 1.81 3.29c1.11 1.38 1.54 2.5 1.78 2.5.24.02 1.1-.1 1.72-.08.3 0 .34-.07.38.13.1.6-.15.97-.9 2.37-.74 1.4-1.23 2.8-1.23 2.8zm-28.28-16.4c1.6.54 2.21.54 2.21.54s-2.2-1.3-2.77-3.13c-.57-1.84-.06-5.7-1-5.66-.94.04-1.47 2.85-2.4 2.29-.94-.56.31-5.73-.7-7.93-1.03-2.2-3.44-3.74-4-2.94-.54.8-.42 5.55-1.9 4.52-1.5-1.04.12-5.1-.33-6.96-.44-1.86-1.57-3.2-2.42-2.75-.86.46.33 3.94-1 3.98-1.35.04-1.16-2.44-1.73-2.68-.58-.24-.77.5-1.09.03-.32-.48-.15-2.25-.85-2.08-.7.17-.57 1.53-.38 2.29.19.75.61 1.84.91 2.33.3.5 1.37 1.12 1.28 1.54-.08.4-.64.76-1.36.78-.73.02-2.37-.05-2.37-.05s1.75.54 2.4.6c.67.07 1.95-.27 2.27.31.32.58 1.85 2.66 1.85 2.66s.36-1.08.55-2.99c.2-1.9.1-3.56.1-3.56s.52 2.2.46 3.52c-.07 1.32-.56 3.89-.56 3.89s1.45 1.21 1.03 1.53c-.43.33-1.94.29-3.71.27-1.77-.03-4.28-.63-4.28-.63s2.26 1.08 3.83 1.34c1.58.26 5 .34 5 .34l2.35 2.66s1.12-1.93 1.28-3.84c.16-1.92-.04-4.15-.04-4.15s.49 2 .57 3.71c.09 1.71-.55 4.74-.77 5-.2.25-1.4 1-2.46 1.26-1.55.4-4.65.79-4.65.79s2.86.38 4.92-.11 2.3-1.06 2.88-.72c.57.35 1.08.98 1.08.98s1.24.96 1.8 1.2c.08.2-.96.63-1.49.96-.52.33-1.9.97-1.9.97s2.02-.73 2.91-.97c.45-.12 1.54-.52 1.54-.52l.6.32s.04-.43-.13-1.64c-.17-1.2-.43-2.38-.43-2.38s.7 1.1.92 2.15c.2 1.03.2 2.09.2 2.09s.18.3 1.78.84zm-40.81-46.75s.45-2.2.45-4.73c0-2.54-1.76-6.46-2.04-6.86-.29-.4-.46-.75-.46-.75l1.2-1.84-1.54 1.2s-.85-.17-1.59-.62c-.74-.46-1.1-1.15-1.1-1.15s.78.57 1.53.89c.75.3.94.2.94.2l-.6-2.56s-.78-.31-2.52-1.28-3.3-2.49-3.3-2.49 2.35 1.42 3.68 1.97c1.33.56 2.08.6 2.08.6s1.4-.43 2.11-.84 2.18-1.52 2.18-1.52-1.4.8-2.32 1c-.92.21-2.08.34-2.08.34l-.4-3.1-1.47-1.52c-1.16-1.53-2.05-3.7-2.05-3.7s1.2 1.52 2.15 2.24c.96.73 1.84 1.9 1.84 1.9s1.1-.58 2.15-1.3c1.05-.73 3.68-2.64 3.68-2.64s-1.5.8-3.58 1.77c-2.08.96-2.15.86-2.15.86s-.17-1.35.14-1.94c.3-.58.96-1.55.85-2.14-.1-.59-.54-.38-.71-.86-.17-.49.54-3.46.54-3.46s.17 1.07.2 1.62c.04.56-.26 1.32.49 1.32s4.26-3.53 4.7-4.18c.44-.66 1.09-2.46-.75-1.73-1.84.72-1.4 2.3-2.93 2.17-.45-.03-.96-2-1.54-1.52-.58.5-1.87 1.7-2.11 3.08-.24 1.38.3 3.5-.48 4.11-.78.63-1.46-2.38-3-1.97-1.53.42-1.87 2.53-1.63 3.36.24.83 3.58 4.7 2.52 5.18-1.06.49-3.65-3.28-5.04-.72-1.4 2.55 4.4 5.18 5.1 5.8.72.63.08.8 1.1 2.08s2.38 1.59 3.1 2.46c.71.86 2.83 4.97 2.83 7.63s-.17 3.64-.17 3.64zm15.39 22.43s-1.42-1.65-.95-4.37 2.34-7.52 1.7-8.13c-.64-.6-2.64 2.94-3.15 2.12-.51-.82 1.15-5.62.3-7.6-.85-2-.94-3.25-2.64-3.07-1.7.17-2.43 5.79-3.24 4.8-.81-1 .47-3.5-.08-4.84-.56-1.34-.86-1.82-1.7-1.6-.86.21-1.24 2.8-1.84 2.76-.6-.04-1.58-3.11-2.81-2.68-1.24.43 2.94 5.88 2.94 5.88s.74-.65 1.13-1.58c.38-.93.76-1.94.76-1.94s.34 1.77.05 2.46c-.3.69-.54 2.31-.54 2.31s-1.02.33-2.7.07c-1.68-.26-3.07-.95-3.07-.95s1.13.75 2.85 1.2c1.73.46 3.56 1.02 3.56 1.02s.45.56 1.22 1.58l1.42 1.88s.5-1.04.98-2.75c.5-1.7 1.66-4.51 1.66-4.51s-.36 3.4-.76 5.05c-.4 1.67-.83 4.02-.83 4.02s-1.5-.15-3.5-.51c-2-.37-4.72-1.06-4.72-1.06s2.38.95 4.7 1.57l3.77 1.02 1.83 2.41s.5-.88 1.22-1.89c.72-1.02 1.28-2.4 1.28-2.4s-.32 1.88-.88 3c-.55 1.13-.93 1.8-.93 1.8s-1.18.28-2.26.25l-3.3-.04s1.85.63 3.32.87c1.47.24 2.53.39 2.53.39s.11.66.9 1.8a6.01 6.01 0 0 0 1.78 1.66z"
  }))), mx_path4 || (mx_path4 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M412.7 331.62s-.83-.9-1.94-1.48c-1.1-.58-1.48-.4-1.48-.4l-.51-.19.97-2.53 7.3-6.97 1.12-7h.27l4.23-.05-.05 9.56 1.34.6 8.15 4.89-.03 2.12-1.19.46c-.79.31-.98.54-.98.54l-3.07.29-5.37-3.9-2.21-2.32-4.05 5.18-2.5 1.2z"
  })), mx_path5 || (mx_path5 = /*#__PURE__*/react.createElement("path", {
    fill: "#016848",
    d: "M418.44 313.04s-.12.37-.17 1.45c-.06 1.07.07 6.72-.2 7.5-.28.76-4.2 2.38-6.45 4.34s-2.33 3.4-2.33 3.4-.74.06-2.13.58c-1.4.51-2.02 1.3-2.02 1.3s.83-3.5 4.46-6.72c3.64-3.23 5.4-3.5 5.8-4.04.4-.54 0-6.72.09-7.22.08-.5.52-.54.82-.58.3-.05 2.13 0 2.13 0zm9.27 20.64s.57-1.12.94-1.5c.37-.37 1.25-1 1.25-1s.14-.15-1.85-1.01c-1.99-.87-3-.58-4.43-1.59-1.42-1-2.84-2.73-2.84-2.73l-1.9 1.7s1.14 1.6 2.22 2.65c1.07 1.03 3.51 1.38 4.6 1.98 1.07.6 2.01 1.5 2.01 1.5z"
  })), mx_path6 || (mx_path6 = /*#__PURE__*/react.createElement("path", {
    fill: "#cd202a",
    d: "M422 313s2.15-.13 2.45.2c.3.34.25.7.27.82 0 .1.1 5.22-.27 6.9-.4 1.76-1.3 3.51-1.82 4.03-.51.52-3.75 3.35-5.28 4.84-1.53 1.5-3.1 3.63-3.1 3.63s-.56-.63-1.05-1.24c-.48-.6-.96-.8-.85-1.2.11-.4 1.73-2.83 4.32-4.53 2.58-1.7 4.74-3.63 5.22-6.4.49-2.76.11-7.05.11-7.05z"
  })), mx_path7 || (mx_path7 = /*#__PURE__*/react.createElement("path", {
    fill: "#cd202a",
    d: "M436.38 330.48s-.52-.52-2.34-.55c-1.82-.03-1.97.24-1.97.24s-1-1.26-2.62-2.3c-1.6-1.06-2.82-.9-4.55-2.04-1.73-1.14-2.64-2.8-2.64-2.8l1.33-2.72s1.5 2.1 3.04 3.24c1.55 1.14 4.98 2.25 6.08 3.2 1.09.96 3.67 3.73 3.67 3.73z"
  })), mx_path8 || (mx_path8 = /*#__PURE__*/react.createElement("path", {
    fill: "#30c2dc",
    stroke: "#0872a7",
    strokeWidth: 0.7,
    d: "M452.73 299.48s-4.69-1.82-4.35-3.46c.34-1.64 10.83-4.4 10.83-4.4l.16-2.77s-1.53-.09-4.17.78a37.32 37.32 0 0 1-11.33 1.98c-2.74 0-4.23-.28-4.97-.5-.48-.15-36.95-2.3-38.14-2.28-.51 0-1.16-.01-1.99-.07-4.85-.34-7.98-7.78-7.98-7.78l-2.3.4s.7 3.66-.51 3.98c-2.38.64-18.23-7.84-18.23-7.84l-.87 3.44s9.68 5.18 9.4 7.11c-.3 1.93-3.17 1.78-3.17 1.78l1.23 2.31c.43.04 15.95.79 16.21 5.45.11 1.88-3.8 3-3.8 3l1.3 1.59v.79s8.62.05 11 1.38c2.4 1.34 3.6 3.26 6.53 4.94 2.92 1.68 22.75 1.27 25.85.4 3.5-.99 5.65-4.96 11.35-6.69 5.7-1.72 7.53-1.81 7.53-1.81z"
  })), mx_circle || (mx_circle = /*#__PURE__*/react.createElement("circle", {
    fill: "#fff",
    stroke: "#0872a7",
    strokeWidth: 1.37,
    cx: 373.42,
    cy: 292.05,
    r: 2.75
  })), mx_circle2 || (mx_circle2 = /*#__PURE__*/react.createElement("circle", {
    fill: "#fff",
    stroke: "#0872a7",
    strokeWidth: 1.37,
    cx: 389.1,
    cy: 279.26,
    r: 2.75
  })), _circle3 || (_circle3 = /*#__PURE__*/react.createElement("circle", {
    fill: "#fff",
    stroke: "#0872a7",
    strokeWidth: 1.37,
    cx: 454.82,
    cy: 299.74,
    r: 2.82
  })), mx_path9 || (mx_path9 = /*#__PURE__*/react.createElement("path", {
    fill: "#f8c83c",
    d: "M361.11 275.15c-.9 2.07 2.64 6 5.1 6.44 2.48.43 3.84-.17 4.27-1.39.43-1.2.1-2.52-.47-3.28-1.57-2.12-8-3.84-8.9-1.77z"
  })), mx_path10 || (mx_path10 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M368.9 278.31c-.07-1.25-2.13-2.47-3.45-2.47-1.32 0-2.64-.04-2.43.66.21.68 3.62 1.6 3.7 1.98.1.4-1.01.86-.46 1.38.55.52 1.23.14 1.79-.25.55-.4.9-.52.85-1.3z"
  })), mx_path11 || (mx_path11 = /*#__PURE__*/react.createElement("path", {
    fill: "#f8c83c",
    d: "M390.71 301.99c.57 1.83-.85 2.72-2.68 3.54-1.84.82-5.58.34-6.43-1.12-.86-1.47 1.36-3.85 3.62-4.41 2.25-.56 4.98.35 5.49 1.99z"
  })), mx_path12 || (mx_path12 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M386.92 303.07c.72-.12.73 1.08 1.36 1 .64-.1 1.2-1.13 1.03-1.82-.17-.7-1.37-1.64-2.39-1.56-1.02.1-4.05 2.64-3.7 3.33.33.69 1.02.6 1.57.35.56-.26 1.36-1.17 2.13-1.3z"
  })), mx_path13 || (mx_path13 = /*#__PURE__*/react.createElement("path", {
    fill: "#f8c83c",
    d: "M458.35 292.53c1.66 2.2 4.66.17 5.45-.69.8-.86 3.24-2.27 2.24-3.72-1-1.44-2.7-1.32-3.83-1.27-1.14.06-3.47 1.74-3.86 2.51-.4.78-.74 2.2 0 3.17z"
  })), mx_path14 || (mx_path14 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M458.89 291.07s.14-2.4 2.39-2.5c1.28-.06 1.33.34 2.3.89.96.54 1.33-.72 1.33-.72s.06 1.7-1.5 1.75c-1.56.06-1-.69-2.53-.92-1.35-.2-1.99 1.5-1.99 1.5z"
  })), mx_g4 || (mx_g4 = /*#__PURE__*/react.createElement("g", {
    fill: "#f9aa51",
    stroke: "#953220",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/react.createElement("path", {
    d: "m422.43 286.4-1.1-.72s-2.22-.11-3.73-.08c-1.5.02-4.48.17-4.48.17l4.45 12.93 5.34 7.7 2.05.73 4.14-.27.7-2.02-1.55-12.47-5.82-5.97z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m407.71 287.21.21-1.47s1.01-.13 2.42-.17c1.4-.05 2.63.1 2.78.2.15.11 3.11 3.73 4.13 6.1 1.02 2.39 2.22 6.36 3.54 8.78 1.32 2.42 4.17 6.48 4.17 6.48s-1.43.09-2.68.09c-1.26 0-2.66.04-2.66.04l-2.4-.93-7.5-11.68-2.01-7.44z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M404.57 285.62s3.07-.06 3.35.12c.29.17 3.7 3.2 5.05 6.94 1.37 3.74.69 4.26 2.45 8.12 1.76 3.86 4.2 6.46 4.2 6.46s-5.11.28-8-.24c-2.9-.51-3.93-.46-4.6-1.26-.69-.81-2.28-1.79-2.28-1.79h-2.9l.68-4.03-.79-9.05.17-4.67 2.67-.6zm30.67 2.39-4.88-2.02-9.1-.46s.35 2.43.69 4.67c.34 2.25 1.93 7.55 3.4 10.14 1.48 2.6 2.96 5.76 3.76 6.51.8.75 6.02-1.41 6.02-1.41l3.4-.52-.45-3.72-.48-1.15.8-10.57-.75-1.64-2.41.17z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M403.09 288.07c0 1.15 1.22 1.21 1.53 1.15.32-.05 1.37-.46 1.37-2.02 0-1.55-.97-2.76-2.87-2.87-1.9-.12-3.35 2.27-3.35 3.88 0 1.62 1.62 2.45 1.62 3.06 0 0-1.62 1.5-1.54 4.12.09 2.62 2.22 4.64 2.22 4.64s-2.27 1.81-2.27 3.63c0 1.81 1.73 3.02 3.35 3.02s3.69-1.04 3.69-2.42-1.22-2.21-2.24-2.21c-1.03 0-1.45.6-1.45 1.06m33.65-14.31c0 1.12-.73 1.17-1.37 1.17-.63 0-1.49-.35-1.49-1.78 0-1.42 1.88-2.2 3.07-2.2 1.2 0 3.24 1.64 3.24 3.63s-1.45 3.33-1.45 3.33.9.43.9 2.94c0 2.5-1.62 4.32-1.62 4.32s2.1.82 2.1 3.41c0 2.6-1.78 3.44-3.02 3.44s-3.39-.74-3.39-2.5c0-1.78 1.11-2.4 1.96-2.4.85 0 1.69.99 1.69 1.96"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#953220",
    d: "M406.22 302.5s.32.2.56.72c.24.5.41 1.33.97 1.83 1.11 1 9.54 1.3 12.1 1.3 2.56 0 10.22.34 11.67-.52 1.45-.87 1.62-2.3 2.52-2.94.89-.65 1.15-.6 1.15-.6l-1.11.94-.08 1.82.65 1s-.14.51-1.04 1.07c-.9.57-1.7.74-2.94.87-1.23.13-17.38.08-19.98-.35-2.6-.43-2.42-.39-3.2-.95a5.65 5.65 0 0 1-1.18-1.16l.34-1.17-.43-1.86zm26.19-15.49 1.45.63s-1.24.39-2.17 2.94c-.94 2.55-.17 3.37-.81 3.63-.64.26-7.63.05-7.63.05l-1.2-2.9 10.36-4.35z",
    stroke: "none"
  }))), mx_g5 || (mx_g5 = /*#__PURE__*/react.createElement("g", {
    fill: "#231f20"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M454.69 286s-1.2-.43-1.75-1.43-1.02-2.24-.6-2.5c.44-.26 1.33.6 1.24 1.38-.08.78 1.11 2.55 1.11 2.55zm13.65-3.77s.85 1.55 1.15 1.73c.3.17 1.66.78 1.66.78s-1.92 0-2.51-.52c-.6-.52-1.45-1.95-1.45-1.95l1.15-.04z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M472.46 283.49s-1.15.69-2.13.3c-.98-.39-1.74-.95-1.36-1.38.38-.43.63-.26 1.15.3.5.57 2.34.78 2.34.78zm6.94-5.88s-.94.83-1.62.83-2.05-.27-2.05-.57c0-.3 1.8-.47 2.1-.43l1.57.17zM469 263.83s-1.54.47-2.04 1.25c-.51.78-.39 1.65.25 1.6.64-.04.81-.9.81-1.16 0-.26.98-1.69.98-1.69zm-6.85 3.76s-1.15.73-1.45 1.38c-.3.65-.55 2.03.13 2.08.68.04.9-1.04.93-1.6.05-.57.39-1.86.39-1.86z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8cbebf",
    stroke: "#04534e",
    strokeWidth: 0.7,
    d: "m449.89 275.88-3.76 3.98s8.65 4.84 15.3 4.63c6.64-.22 14.22-5.4 14.73-6.49.51-1.07.09-5.7-.77-7.17-.85-1.47-5.45-5.06-7.2-4.88-1.74.17-4.81 2.5-7.66 5.27-2.86 2.76-2.56 5.1-6.52 4.88l-4.12-.22z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#0c8489",
    d: "M448.93 277.47s9.26 1.39 11.92-.98c2.68-2.36 5.57-6.97 7.45-8s2.72-1.05 2.72-1.05 1.38.88 2.02 1.43c.64.55 2.35 1.96 2.35 1.96l.74 4.4.06 2.41-2.9 2.37-5.3 2.45-5.09 1.58-4.32-.12-8.74-2.53-2.22-1.57-.57-.5 1.88-1.85z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#04534e",
    d: "M463.04 272.14c0-.79.52-.75 1.22-.75s1.48.13 1.48.92c0 .8-.77 1.93-1.48 1.93-.7 0-1.22-1.31-1.22-2.1zm3.72 2.33c0-.71.54-1.1 1.39-1.1.85 0 1.62.95 1.62 1.66s-.69 1.28-1.53 1.28c-.85 0-1.48-1.13-1.48-1.84zm-1.28 5.54c0-.89.54-1.07 1.4-1.07.84 0 1.36.4 1.36 1.28s-.7 1.6-1.54 1.6c-.85 0-1.22-.93-1.22-1.81zm-4.88-1.7c0-.95.9-1.24 1.66-1.24.76 0 1.38.77 1.38 1.72 0 .94-.62 1.7-1.38 1.7-.76 0-1.66-1.23-1.66-2.18zm-7.73.94a1.89 1.89 0 1 1 3.78 0 1.89 1.89 0 0 1-3.78 0z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8cbebf",
    d: "M466.76 274.47c0-.64.87-1.1 1.39-1.1.52 0 .94.52.94 1.16 0 .63-.42 1.15-.94 1.15s-1.39-.58-1.39-1.21zm-1.25 5.31c0-.73.68-1.04 1.45-1.04.77 0 1.36.3 1.36 1.04 0 .73-.63 1.32-1.4 1.32-.78 0-1.41-.59-1.41-1.32zm-4.88-1.62c0-.8 1.33-1.18 1.88-1.18.55 0 .45.54.45 1.35 0 .82-.45 1.47-1 1.47-.54 0-1.33-.82-1.33-1.64zm2.3-6.11c0-.74.58-.78 1.05-.78.48 0 .83.22.83.97 0 .74-.4 1.34-.87 1.34-.48 0-1.01-.79-1.01-1.53zm-10.08 6.63c0-.86.75-1.67 1.85-1.67s2.21.38 2.21 1.24-1.34 2.33-2.44 2.33c-1.1 0-1.62-1.04-1.62-1.9z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M456.39 277.18s-1.28.22-1.96.87c-.68.64-.77 1.38-.38 1.6.38.21.85-.48.98-.78a16.5 16.5 0 0 1 1.36-1.69zm6.14-1.34s-1.23.87-1.36 1.73c-.13.87 0 1.3.34 1.34.34.04.55-1.12.43-1.56-.13-.42.59-1.51.59-1.51z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M463.55 277.14s-.8.04-1.36.56c-.55.52-1.07 1.17-.68 1.21.38.04.98-.26 1.02-.6.04-.35 1.02-1.17 1.02-1.17zm1.32-7.13s-.64.52-.98.82c-.34.3-.77 1.17-.34 1.39.43.21.72-.18 1.02-.78.3-.61.3-1.43.3-1.43zm4.65 2.98s-1.2.17-1.58.69c-.38.52-.64 1.12-.12 1.12.5 0 .63-.26.85-.73.21-.47.85-1.08.85-1.08zm-.73 5.49s-.25.82-.98 1.2c-.72.4-.93.75-1.23.23-.3-.52.08-.78.46-.91.39-.13 1.75-.52 1.75-.52z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#04534e",
    d: "M476.2 274.76s.51 2.55-1.7 3.8c-2.22 1.26-8.44 5.66-14.31 5.14-5.88-.52-12.57-3.88-12.57-3.88l-.94.43 1.5.64 4.55 1.9 5.2 1.52 3.24.21 2.8-.34 5.2-1.73 4.4-2.25 2.29-1.81.61-.75-.06-1.07v-1.47l-.21-.34z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M360.78 241.54s1.36 1.17 1.24 2.16c-.13 1-.47 1.39-.86 1.21-.38-.17-.38-1.21-.3-1.64a9.11 9.11 0 0 0-.08-1.73zm10.08 9.37s-.38 1.73-1.07 1.9c-.68.17-1.19-.56-1.06-.86.13-.3.68-.05.98-.3.3-.26 1.15-.74 1.15-.74zm-21.94 1.34s.47 1 1.36 1.17c.9.17 1.32-.44 1.2-.74-.13-.3-.52-.22-.98-.22-.47 0-1.58-.21-1.58-.21zm3.92 7.69s.81.95 1.92 1.08c1.1.13 1.66-.73 1.74-1 .09-.25-1.27-.21-1.7.14-.43.34-1.96-.22-1.96-.22zm6.94 5.92s1.79-.35 2.09-.82c.3-.48.76-1.3.38-1.77-.38-.48-.68.73-.9 1.2-.2.48-1.57 1.39-1.57 1.39z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8cbebf",
    stroke: "#04534e",
    strokeWidth: 0.7,
    d: "M370.95 261.16s1.2-8.01-5.28-13.66c-6.48-5.64-10.68-4.26-12.9-2.18-2.21 2.07-4.14 8.87 2.73 14.8 6.87 5.94 15.34 4.1 15.34 4.1l.1-3.06z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#0c8489",
    d: "M351.2 252.68s-.12-4.4 1.96-5.71c2.07-1.32 8.92-2.46 12.3 4.04 3.37 6.5 3.44 9.75 2.59 13.04l-3.62-.04-5.59-2.28-4.63-3.42-3.01-5.63z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#04534e",
    d: "M370.09 262.31s-1.13 1.27-3.46 1.15c-2.33-.11-13.18-2.94-15.9-12.67l.16 2.13.12.7.71 1.95 2.28 3.32 2.87 2.45 3.61 1.87 2.6.76 3.36.59h1.95l1.7-2.25z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#04534e",
    d: "M364.44 259.5c0-.87.44-.9 1.14-.9.69 0 1.22-.3 1.22.57 0 .86-.48 2.11-1.17 2.11s-1.19-.92-1.19-1.78zm.46-5.15c0-.6.55-1.08 1.22-1.08.68 0 1.22.48 1.22 1.08 0 .6-.54 1.08-1.22 1.08-.67 0-1.22-.48-1.22-1.08zm-4.92 5.68c0-.47.62-.85 1.38-.85.76 0 1.37.38 1.37.85s-1.36 1.1-2.13 1.1c-.75 0-.62-.63-.62-1.1zm-.45-6.07c0-.76.37-.52 1.04-.52s1.49.22 1.49.98c0 .77-.83 1.79-1.5 1.79-.66 0-1.03-1.49-1.03-2.25zm-4.57 1.02c0-.64.43-1.54 1.25-1.54.81 0 1.7.9 1.7 1.54s-.66 1.17-1.48 1.17c-.8 0-1.47-.53-1.47-1.17zm.82-5.37c0-.67.45-.63 1.3-.63.83 0 1.51.34 1.51 1 0 .68-.98 1.5-1.82 1.5-.84 0-.99-1.2-.99-1.87zm4.95-.52c0-.65.55-.43 1.33-.43.8 0 1.43.52 1.43 1.16 0 .65-1 1.37-1.8 1.37-.78 0-.96-1.46-.96-2.1z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8cbebf",
    d: "M355.78 249.47c.11-.46.43-.78 1.02-.78.59 0 1.1.11 1.1.78s-.47 1.21-1.06 1.21c-.58 0-1.22-.56-1.06-1.21zm-.91 5.27c0-.65.33-1.27 1-1.27.66 0 1.19.07 1.19.72 0 .66-.59 1.42-1.25 1.42-.67 0-.94-.22-.94-.87zm5.82-5.56c0-.52.44-.58 1.08-.58.63 0 1.05.14 1.05.65 0 .52-.52.94-1.15.94-.64 0-.98-.5-.98-1.01zm-1.13 5.05c0 .7.52 1.29 1.16 1.29.65 0 1.34-.57 1.34-1.27 0-.72-.72-1.39-1.36-1.39-.65 0-1.14.66-1.14 1.37zm5.54-.74c0 .64.56 1.17 1.25 1.17s1.25-.53 1.25-1.17c0-.65-.56-1.17-1.25-1.17-.7 0-1.25.52-1.25 1.17zm-5.34 6.48c0-.56.59-1.1 1.17-1.1.57 0 1.13.35 1.13.91 0 .57-1 1.33-1.59 1.33-.58 0-.71-.58-.71-1.14zm4.71-.83c0-.7.53-.75 1.25-.75s1.08.07 1.08.76c0 .7-.59 1.26-1.3 1.26-.73 0-1.03-.58-1.03-1.27z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M365.75 251.04s.72.9.85 1.6c.13.69.13 1.47-.13 1.55-.25.09-.68-.43-.8-1.08-.13-.65.08-2.07.08-2.07zm-4.13-4.41s.47.74.47 1.39c0 .64-.09 1.33-.43 1.33-.34 0-.34-.64-.34-1.12 0-.47.3-1.6.3-1.6zm-4.86.65s.47.74.47 1.39c0 .64-.09 1.33-.43 1.33-.34 0-.34-.64-.34-1.12 0-.48.3-1.6.3-1.6z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M355.06 248.19s.64.17 1.2.6c.55.44.76.95.55 1.21-.22.26-.73-.12-.86-.43-.12-.3-.89-1.38-.89-1.38zm3.7 5.09s.94.04 1.45.52c.51.48.93.87.64 1.21-.3.35-1.03-.26-1.32-.6-.3-.35-.77-1.13-.77-1.13zm-4.51-.17s.85.21 1.28.52c.42.3.55.9.34 1.04-.21.12-.51-.1-.9-.48-.38-.4-.72-1.08-.72-1.08zm10.9 3.42s.3 1.04.3 1.77c0 .74.08 1.38-.26 1.38s-.5-.9-.5-1.47c0-.56.46-1.68.46-1.68z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M363.92 258.21s.77.3 1.1.6c.35.3.43.78.18.87-.26.09-.43-.48-.64-.7-.21-.2-.64-.77-.64-.77zm-4.86.3s.82.1 1.18.34c.35.25.39 1.37.35 1.51-.03.15-.57.05-.78-.49-.21-.53-.75-1.36-.75-1.36z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#04534e",
    d: "M357.18 243.69s-4.3.93-5.07 3.7a25.71 25.71 0 0 0-.82 5.84l-.62-3.52.86-2.29 1.24-2.1 1.9-1.18 1.7-.59.81.14zm13.39 16.41s.44-1.07-.82-4.46c-1.26-3.39-3.85-7.81-3.85-7.81l2.01 2.28 1.6 2.6.79 2.38.58 2.18-.04 2.14-.27.69z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M374.91 254.62s1.49.98 1.64 1.51c.15.55.21.72-.17.87-.38.15-1-.45-1.17-.87a8.59 8.59 0 0 1-.3-1.51zm-6.29 16.9s.7-1.32 1.64-1.81c.94-.5 1.64-.44 1.9-.13.25.3-.62.99-1.26 1.23s-2.28.71-2.28.71zm10.57 4.04s1.04-.5 1.73-1.23c.68-.73.76-1.25.5-1.51-.25-.26-1.1.17-1.48.75-.39.58-.75 1.99-.75 1.99zm-1.15-.99s.36-1.36.73-1.8c.36-.43.87-.66 1.25-.43.39.24.15.85-.13 1.17-.27.33-1.85 1.06-1.85 1.06z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8cbebf",
    stroke: "#04534e",
    strokeWidth: 0.7,
    d: "M395.71 266.52s-6.58-9.52-16.81-10.03c-8.18-.4-10.76 6.9-10.47 9.1.3 2.18 3.37 6.94 14.27 7.74 10.9.8 12.67-5.14 13.12-5.43.46-.29-.11-1.38-.11-1.38z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#0c8489",
    d: "M387.94 259.98s2.73 2.08 3.88 3.72c1.15 1.64 1.4 2.85.72 3.07-.68.2-6.6-5.28-11.46-6.44-4.85-1.17-9.07-.09-10 2.25-.94 2.33-.6 5.83 1.61 7.25 2.22 1.43 12.61 3.12 12.61 3.12s4.73-.65 4.9-.74c.17-.08 3.02-1.68 3.02-1.68l.64-1.65.77-2.16.34-.86-2.51-2.77-4.52-3.11z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#04534e",
    d: "M379.59 261.32c0 .61-.64.91-1.28.91-.63 0-1.17-.32-1.17-.93 0-.6.52-1.1 1.15-1.1.64 0 1.3.51 1.3 1.12zm-6 2.16c0-.61.69-.6 1.38-.6.68 0 1.24.5 1.24 1.11 0 .61-1.08 1.45-1.7 1.16-.77-.37-.92-1.05-.92-1.67zm6.45 3.53c0-.78.66-1.4 1.47-1.4.81 0 1.47.62 1.47 1.4 0 .77-1.1 1.62-1.92 1.62-.8 0-1.02-.85-1.02-1.62z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8cbebf",
    d: "M375.16 268.45c0-.68.7-.82 1.3-.82.6 0 1.36.64 1.36 1.32s-.76 1.14-1.36 1.14c-.6 0-1.3-.96-1.3-1.64z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#04534e",
    d: "M383.89 270.82c0-.55.33-1.05.9-1.05.56 0 1.25.33 1.25.89 0 .55-.56 1.16-1.13 1.16-.56 0-1.02-.44-1.02-1zm3.92-2.99c0-.7.4-.63 1.09-.63.69 0 1.38.4 1.38 1.1 0 .7-.86 1.08-1.55 1.08-.7 0-.92-.85-.92-1.55z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8cbebf",
    d: "M379.21 260.76c0 .55-.23.84-.77.84s-1.2-.3-1.2-.84c0-.55.26-.72.8-.72s1.17.17 1.17.72zm-3.13 2.55c0 .6-.9.97-1.47.97s-.94-.37-.94-.97.44-.78 1-.78c.57 0 1.41.18 1.41.78zm1.39 5.04c0 .52-.2.93-.8.93-.62 0-1.42-.4-1.42-.93 0-.52.23-.89.84-.89.6 0 1.38.37 1.38.89zm5.21-1.71c0 .55-1.07 1.17-1.64 1.17-.57 0-.81-1.01-.81-1.56a1 1 0 0 1 1.02-.99c.57 0 1.43.83 1.43 1.38zm7.56 1.62c0 .57-.9.54-1.43.54-.51 0-.98-.64-.98-1.2 0-.58.17-1.11 1.45-.96.52.06.96 1.05.96 1.62zm-4.47 2.31c0 .57-.44 1.04-.98 1.04s-.98-.47-.98-1.04c0-.57.44-.8.98-.8s.98.23.98.8z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M386.45 267.42s1.06-.35 1.87-.26c.81.09.86.39.86.52s-.64.39-.94.3a113 113 0 0 1-1.79-.56zm-4.43 3.75s.85-.52 1.5-.65c.63-.12 1.14.09 1.1.48-.04.39-.26.48-.9.48-.63 0-1.7-.31-1.7-.31zm-2.85-6.56s1.83.78 2.22 1.51c.38.74.55.91.16 1.13-.38.21-.8-.27-1.06-.6a71.74 71.74 0 0 1-1.32-2.04z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M378.7 266.94s1.4-.39 2.04-.39c.64 0 .82.05.9.35.09.3-.14.43-.67.4-.52-.03-2.27-.36-2.27-.36zm-4.49.09s1.53.2 1.92.6c.38.4.38.77.22 1-.15.23-.88.09-1.1-.15-.23-.23-1.04-1.45-1.04-1.45z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M373.99 269.24c.07-.07.6-.87 1.15-1.05.55-.19 1.2-.16 1.3.13.12.29-.48.72-.87.8-.4.09-1.58.12-1.58.12zm-1.16-6.71 1.52.42c.55.42.68.75.55.9-.13.16-.66.25-1.12-.05a2.82 2.82 0 0 1-.95-1.27zm3.33-3.87s1.55.43 2.06 1.14c.51.7.44 1.12.18 1.27-.25.14-.85-.22-1.19-.53-.34-.32-1.05-1.88-1.05-1.88z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#04534e",
    d: "M393.86 269.79s-3.15 2.68-10.26 2.42c-7.12-.26-13.55-3.28-15.17-6.61l.64 1.64 1.58 2.12 4.98 2.55 5.58 1.25 4.43.26 4.18-.73 3.23-1.56c.17-.08.51-.82.51-.82l.3-.52zm.94-3.37s-1.2-1.47-2.85-3.03c-1.67-1.55-8.14-5.75-8.14-5.75l5.24 2.38 3.45 2.9 2.47 2.72-.17.78z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M395.1 260.11s1.79.7 2.09 1.12c.3.43.68.83.68.83s-.47 1.16-.9.69c-.42-.48-.5-.48-.98-1.13-.46-.65-.89-1.51-.89-1.51zm5.32-2.85s1.66.7 2.26 1.51c.6.83.47 1.52.21 1.6-.25.1-1.36-.86-1.53-1.25-.17-.39-.94-1.86-.94-1.86z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M402.09 256.92s1.57 1.17 1.83 1.69c.26.51.77 1.2.26 1.38-.52.17-1.24-.6-1.45-1.08-.22-.48-.64-1.99-.64-1.99zm8.98 2.11s1.24.43 1.36 1.47c.13 1.04-.12 1.77-.12 1.77s-.86-.73-.86-.95c0-.21.13-.39 0-.86l-.38-1.43zm2.39.83s.98 1 1.1 1.64c.14.65.26 1.08-.29 1.17-.55.09-.85-.56-.85-1.12 0-.57.04-1.69.04-1.69zm-16.1 19.62s.77.34 1.49.09c.72-.26 1.32-.91 1.2-1.34-.13-.44-.52-.83-1.07-.26-.56.56-.26.82-.68 1.03l-.94.48zm8.86 2.41s1.2-.17 2-1.04c.81-.86 1.15-1.47.6-1.68-.55-.22-1.28 0-1.4.69-.13.69-1.2 2.03-1.2 2.03zm7.28.26s.9-.52 1.58-1.17c.68-.64 1.06-1.03.6-1.5-.47-.49-.82-.14-1.03.08-.21.22 0 .22-.25.9-.26.7-.9 1.69-.9 1.69z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M415.72 282.11s.96-1.17 1.18-1.82c.22-.64.34-1.38-.1-1.34-.43.04-.96.65-.98 1.13-.04.47-.1 2.03-.1 2.03z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8cbebf",
    stroke: "#04534e",
    strokeWidth: 0.7,
    d: "M393.56 270.31c.06-3.2 4.6-10.59 9.84-10.5 2.18.04 6.46 1.17 9.92 2.72 2.9 1.3 3.84 2.73 5.76 3.2 1.91.47 4.8.13 4.8.13l6.53-.74-5.12 7.48-1.82 1.64s-1.63 3.16-6.27 4.97c-4.64 1.82-12.48.48-16.02-.39-3.53-.86-7.7-4.23-7.62-8.51z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#04534e",
    d: "M393.56 270.31h.34c.01-.71.29-1.74.79-2.84.74-1.66 1.98-3.5 3.5-4.93 1.51-1.41 3.3-2.39 5.12-2.39h.08c1.04.02 2.64.3 4.4.78 1.76.48 3.68 1.15 5.4 1.91 1.41.64 2.34 1.3 3.18 1.88a7.8 7.8 0 0 0 2.62 1.34c.83.2 1.8.27 2.66.27 1.24 0 2.27-.13 2.28-.13l5.77-.65-4.66 6.82-1.85 1.66-.03.05v.01c-.08.14-1.68 3.08-6.08 4.8-1.63.64-3.7.88-5.85.88-3.76 0-7.74-.74-9.97-1.28a11.04 11.04 0 0 1-4.96-2.85 7.42 7.42 0 0 1-2.4-5.2v-.12l-.34-.01-.34-.01v.14c0 2.23 1.09 4.2 2.6 5.7a11.72 11.72 0 0 0 5.28 3.02 45.9 45.9 0 0 0 10.13 1.3c2.2 0 4.34-.24 6.1-.93 4.74-1.85 6.41-5.08 6.43-5.13l-.3-.16.23.26 1.86-1.67 5.56-8.13-7.26.82-.17.01c-.34.04-1.13.1-2.04.1-.83 0-1.75-.05-2.49-.24a7.16 7.16 0 0 1-2.4-1.24c-.83-.57-1.81-1.28-3.3-1.93a38 38 0 0 0-5.49-1.95c-1.79-.49-3.42-.79-4.56-.81h-.1c-1.37 0-2.69.49-3.88 1.25a14.74 14.74 0 0 0-4.41 4.7c-1.1 1.79-1.76 3.6-1.8 4.9h.35z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#0c8489",
    d: "M425.21 271.31c-.55.43-1.15.43-1.83.43-.69 0-15.2-8.86-19.72-8.47-4.52.39-8.82 2.34-8.95 6.96-.13 4.62 1.02 4.67 1.96 5.96.94 1.3 9.8 3.25 9.8 3.25l5.4-.1 4.36-.47 3.83-2.07 2.09-1.69 1.4-1.72 1.66-2.08z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#04534e",
    d: "M402.26 268.95c0 .9-.35 1.54-1.23 1.54s-1.54-.4-1.54-1.3.5-1.25 1.38-1.25c.88 0 1.39.1 1.39 1.01zm1.52-4.04c0-.75.73-1.08 1.56-1.08.84 0 1.48.3 1.48 1.05s-.66 1.33-1.5 1.33c-.83 0-1.54-.55-1.54-1.3zm8.7 2.36c0-.65.56-1.19 1.26-1.19.69 0 1.25.54 1.25 1.19 0 .66-.56 1.19-1.25 1.19-.7 0-1.26-.53-1.26-1.19zm1.75 5.33c0-.84.6-1.51 1.36-1.51.76 0 1.46.35 1.46 1.18 0 .84-.27 1.65-1.03 1.65-.75 0-1.79-.49-1.79-1.32zm-4.22 3.41c0-.72.64-1.3 1.43-1.3.79 0 1.42.58 1.42 1.3 0 .72-.56 1.18-1.35 1.18s-1.5-.46-1.5-1.18zm-7.97-1.38c0-.7.56-1.25 1.26-1.25a1.25 1.25 0 1 1 0 2.5c-.7 0-1.26-.56-1.26-1.25z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8cbebf",
    d: "M402.21 268.76c0 .71-.61 1.3-1.36 1.3-.76 0-1.37-.59-1.37-1.3 0-.72.6-1 1.36-1 .75 0 1.37.28 1.37 1zm4.22-4.11c0 .7-.22 1.14-.95 1.14-.72 0-1.7-.45-1.7-1.14 0-.7.6-1.25 1.33-1.25.73 0 1.32.56 1.32 1.25zm8.43 2.25c0 .6-.55 1.08-1.24 1.08-.68 0-1.23-.49-1.23-1.08 0-.6.55-1.08 1.23-1.08.69 0 1.24.48 1.24 1.08z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#04534e",
    d: "M410.39 270.46c0 .91-.35 1.55-1.23 1.55-.89 0-1.54-.4-1.54-1.31s.5-1.24 1.38-1.24c.88 0 1.39.1 1.39 1z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8cbebf",
    d: "M404.3 274.33c0 .72-.61 1.3-1.36 1.3-.76 0-1.37-.58-1.37-1.3 0-.71.87-1.08 1.62-1.08.75 0 1.11.37 1.11 1.08zm5.83-4.02c0 .72-.6 1.3-1.32 1.3a1.3 1.3 0 0 1-1.32-1.3c0-.71.6-1.3 1.32-1.3.73 0 1.32.59 1.32 1.3zm6.89 1.78c0 .79-.48 1.42-1.3 1.42-.83 0-1.5-.64-1.5-1.43 0-.78.25-1.05 1.07-1.05.82 0 1.73.27 1.73 1.06zm-4.41 3.62c0 .74-.5 1.16-1.25 1.16-.76 0-1.48-.42-1.48-1.16s.65-1.04 1.4-1.04c.75 0 1.33.3 1.33 1.04z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M413.12 271.39s2.17-.22 2.55.17c.39.4.34.95.17 1.13-.17.17-1.02.21-1.23-.09-.21-.3-1.49-1.21-1.49-1.21zm-2.13-7s1.66.43 2.34 1.12c.68.7.56 1.39.43 1.51-.13.13-.73.27-1.2-.25-.46-.52-1.57-2.38-1.57-2.38zm-4.94 3.37s1.94 1.06 2.36 1.66c.43.6.54 1.08.35 1.34-.2.26-1.16-.07-1.3-.39-.15-.32-1.41-2.61-1.41-2.61z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M405.2 269.25s2.17.28 2.7.7c.54.4.92.42.88.75-.04.32-.28.56-.62.52a4.72 4.72 0 0 1-1.49-.65l-1.47-1.32zm-2.5-6.36s2.22.35 2.67.7c.46.34.57 1.32.06 1.61-.51.28-1.08-.29-1.25-.7-.17-.4-1.48-1.61-1.48-1.61zm-4.78 3.35s2.04.97 2.67 1.87c.34.49.64.9 0 1.13-.58.19-1.2-.87-1.2-1.13 0-.26-1.47-1.87-1.47-1.87z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M397.47 268.89s1.3-.29 1.93-.29c.62 0 1.52-.22 1.53.29.01.5-.76.6-1.22.46-.46-.16-2.24-.46-2.24-.46zm11.28 7.28s1.43-.89 2.13-.74c.7.16.94.1.94.52 0 .43-.83.35-1.1.35-.25 0-1.97-.13-1.97-.13zm-7.9-1.15s.55-.82 1.15-.9c.6-.1.85-.05.94.2.08.27-.51.74-.77.74l-1.32-.04z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#04534e",
    d: "M423.43 273.58s-2.17 2.61-5.2 3.91c-3.02 1.3-5.32 1.73-9.54 1.47-4.21-.26-6.26-.9-9.11-2.38-2.86-1.47-5.12-3.58-5.54-4.49-.43-.91.47 1.51.47 1.51l2.6 3.41 3.1 1.39 4.56 1.12 4.3.52 3.28-.08 3.92-.61 2.52-.9 1.7-1.05 1.32-1.08 1.62-2.74zm-4.06-7.72s-1.18.4-3.78-1.21c-2.6-1.6-5.7-3.68-11.59-3.72-5.87-.04-7.75 3.98-8.13 4.28-.39.3 2.64-3.5 2.64-3.5l2.68-1.42 2.09-.35 2 .09 2.6.69 2.34.73 2.73.9 2.38 1.31 2.88 1.5 1.16.7zm7.89 1.73s-3.45-.04-4.43.04c-.98.09-1.02.26-1.15.52-.13.26-.39.6-.39.6l-1.06-2.29 4.69-.65 2.55.96-.21.82z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#0c8489",
    stroke: "#04534e",
    strokeWidth: 0.7,
    d: "M420.91 291.7c.24.63.78 1.2 1.47 1.22.69.02 2.13-.03 2.13-.03l4.67-.28 1.64-1.88 1-4.22s1.26-1.53 1.26-1.6 4.34-2.4 4.34-2.4l3.75-1.07 2.4-.26 3.33-1.1 2.45-1.28 1.06-1.58 1.04-2.4-1.04-3.24-2.6-3.47-4.4-1.8h-3.65l-4.09 1.5-7.2 1.7s-3.96 1.73-5.6 4.82c-1.63 3.09-1.62 3.89-1.9 7.97-.27 4.09-.06 9.4-.06 9.4z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8cbebf",
    d: "M422.86 290.09c1.38 0 .31-2.28 1.88-4.99 1.56-2.7 3.46-6 3.94-6 .49 0 .57.5 1.14.33a3.79 3.79 0 0 0 1.59-1.27c.06-.23.06-1.76 1.25-2.74 1.2-.98 2.87-2.36 3.66-2.53.8-.17 1.17-.32 1.3.06.15.37-.45.89.1 1.06.53.18 1.78.12 2.1-.69.3-.8.22-1.24.22-1.24s.83-.8 2.39-.46c1.56.35 1.76.26 1.9.87.14.6-.71.69-.54 1.12.17.43-.12.38.04.71.16.33.41 1.25 1.46 1.22 1.06-.03 1.5-.64 1.5-.64l.32-.55s.29-.65-.11-.91c-.4-.26-.26-.58.14-.4.4.17 1.99 2.38 2.53 1.46.54-.92.6-2.22.31-2.53-.28-.32-2.53-3.7-2.53-3.7l-4-1.35-5.31.44-5.14 2.94-4.72 2.5s-.25 3.86-1.1 3.17c-.86-.7-2.08-2.6-2.44-1.96-.38.64-1.2 3.46-1.68 4.87-.48 1.41-1.87 5.76-1.74 7.38.15 1.61 1.03 3.83 1.54 3.83z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8cbebf",
    d: "M427.6 283.85a2 2 0 0 0-1.08.62c-.17.22-.41.68-.26 1.18.16.5.9 1 .96 1.05l.59-.01 1.28-.38s.4-.46.43-1.06c.02-.6-.35-.77-.53-.82-.19-.06-1.39-.58-1.39-.58zm8.12-6.71c-.73-.26-1.05.24-1.17.45-.13.22-.07.75-.07.75s.15 1 .54 1.19c.38.18 1.38.53 1.7.18.32-.34.64-.58.62-1.23-.01-.65-.92-.97-.92-.97l-.7-.37zm6.54 1.57c-.03-.25-.67-.42-1.1-.34-.42.07-1 .61-.79 1.43.2.82.98.9 1.6.74.6-.16.49-1.03.49-1.15 0-.13-.2-.68-.2-.68zm-18.89 1.32c0 .37.68 1.15 1.6 1.1.9-.06 1.46-.75 1.55-1.3.09-.55-.48.46-1.16.63-.68.17-1.08.35-1.4-.03-.3-.37-.59-.4-.59-.4z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#04534e",
    d: "M429.52 285.25s.1.83-.5 1.27c-.6.43-.99.38-1.34.38-.34 0-.72-.07-.97-.41-.26-.35-.44-.84-.44-.84s.66 1.1 1.7.8c1.05-.28 1.55-1.2 1.55-1.2zm17.59-10.9s0 .84-.66 1.19c-.65.35-.95.45-1.3.4-.34-.04-.82-.18-1.04-.55-.78-1.2-.32-1.99-.32-1.99s.56 2.1 1.63 1.95c1.07-.15 1.69-1 1.69-1zm-15.68 3.75s-.54 1.64-1.62 1.64-.99-.31-.9-.52c.08-.2.48.2.96.06s1.56-1.18 1.56-1.18zm3.04-.29s-.11 1.19.29 1.59c.4.4.85.61 1.3.61.46 0 .8-.12 1.14-.58.34-.46.14-.95.14-.95s0 .25-.33.6c-.34.34-.62.4-.96.4-.34 0-.93-.05-1.1-.45-.17-.4-.48-1.22-.48-1.22zm5.57-5.72s.34.89-.34 1.61c-.68.72-1.99.32-1.99.32s1.05.26 1.57-.32c.5-.57.76-1.61.76-1.61z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#04534e",
    d: "M422.26 292.59s6.91-.12 7.47-1.07c.55-.95-.6-4.66 3.58-7.6 4.17-2.94 7.4-2.9 9.62-3.07 2.22-.17 7-1.66 7.84-5.92.5-2.6-2.98-2.77-4.3-5.23-1.32-2.46-4.73-1.47-4.9-1.47-.17 0-3.95-.1-5.75 1.64-1.07 1.04-.94 2.34-1.45 2.94-.51.6-5.07 0-5.58.74-.51.73.13 2.28-.22 2.63-.33.35-1.44-1-1.44-1l.38-3.67 5.84-3.4 6.64-3.68s4.35.21 4.52.13c.17-.1 4.47 2.24 4.6 2.29.12.04 2.25 2.6 2.25 2.6s.42 1.03.6 3.06c.09.96 0 1.79-.2 2.54-1.08 3.83-4.82 6.4-8.77 6.6-3.94.2-7.5 1.97-9.3 3.28-1.8 1.3-2.7 7.06-2.72 7.76-.03.69-8.6.22-8.6.22l-.11-.32z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M425.17 279.13c-.35.28-.87.27-.98-.13-.32-1.13.35-2.8.35-2.8s-.01 1.75.12 2.04c.13.28.48.22.63.46.06.08.16.2-.12.43zm4.35-.89c-.33-.1-.28-1.17-.02-1.62.25-.45 2.2-1.88 2.2-1.88l-.86 1.95c-.23.51-.9 1.68-1.32 1.55zm-1.71 7.02c-.27.06-.36-.54-.36-1.3 0-.75 1.32-2.14 1.32-2.14s-.4 1.22-.45 1.6c-.04.4.22.74.17 1.2-.04.44-.38.58-.68.64z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M431.03 283.32s-.62.71-1.32 1.1c-.7.39-1.47.97-1.9.85-.42-.14.28-1.06.51-1.15 1.2-.48 2.71-.8 2.71-.8zm5.92-8.45s-.79.65-1.17 1.58c-.38.93-.55 1.68-.17 1.86.39.17.96-1.06 1-1.47.04-.41.34-1.97.34-1.97z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M439.12 277.83s-.55-.52-1.53-.75c-.98-.24-1.43-.03-1.54.26-.1.27-.83.72-.46.93.36.22.78-.37 1.08-.44.3-.06.64-.28 1.17-.2.53.1 1.28.2 1.28.2zm-1.27-5.8c.35.3.88-.26 1.37-.8.48-.56.85-1.56.85-1.56s-1 .52-1.42.86c-.43.35-1 1.33-.8 1.5zm9.03-.21s-1.16.55-1.56 1.07c-.4.52-.91 1.09-.51 1.38.4.29.76-.26 1.08-.69.3-.43.99-1.76.99-1.76zm-2.58 6.05s-.4.8-1.13 1.3c-.74.49-1.62.72-1.76.46-.15-.26.11-.81.4-.95.28-.15.45-.12 1.1-.29a9.58 9.58 0 0 0 1.39-.52z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/react.createElement("ellipse", {
    fill: "url(#mx_svg__b)",
    cx: 385.55,
    cy: 257.83,
    rx: 3.77,
    ry: 5.63,
    transform: "rotate(8.67 385.55 257.83)"
  })), mx_g6 || (mx_g6 = /*#__PURE__*/react.createElement("g", {
    fill: "#fcca3e",
    stroke: "#aa8c30"
  }, /*#__PURE__*/react.createElement("path", {
    strokeWidth: 0.35,
    d: "m387.66 247.73-2.24 5.6 1.83-.25 1.06-4.93z"
  }), /*#__PURE__*/react.createElement("path", {
    strokeWidth: 0.3,
    d: "M388.7 245.35c-.8-.1-1.53.5-1.63 1.36-.1.85.45 1.62 1.25 1.72.8.1 1.53-.5 1.64-1.36.1-.85-.46-1.62-1.26-1.72z"
  }), /*#__PURE__*/react.createElement("path", {
    strokeWidth: 0.35,
    d: "m485.22 259.35-5.52 5.18 2.28.58 3.78-5z"
  }), /*#__PURE__*/react.createElement("path", {
    strokeWidth: 0.3,
    d: "M487.68 257.21a2 2 0 0 0-2.62.74c-.56.9-.3 2.02.58 2.5a2 2 0 0 0 2.62-.73c.56-.9.3-2.02-.58-2.51z"
  }), /*#__PURE__*/react.createElement("path", {
    strokeWidth: 0.35,
    d: "m344.88 229.45 2.91 6.42 1.26-1.79-3.3-4.86z"
  }), /*#__PURE__*/react.createElement("path", {
    strokeWidth: 0.3,
    d: "M343.71 226.65a1.8 1.8 0 0 0-.17 2.5c.63.78 1.73.9 2.46.3.72-.61.8-1.74.16-2.5a1.73 1.73 0 0 0-2.45-.3z"
  }))), mx_g7 || (mx_g7 = /*#__PURE__*/react.createElement("g", {
    fill: "#aa8c30"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M389.25 245.56s.45.24-.07.08c-.52-.15-1.76.45-1.76 1.32 0 .87.65 1.36 1.3 1.36.66 0-.24.12-.24.12l-.84-.25-.35-.5-.28-.7.21-.76.5-.65.65-.23.43.05.45.16z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M387.99 249.33s-.36-.07-.68.4c-.32.49-.97 1.4-.97 1.4l1.25-3.09.68.36-.28.93zm100.23 8.36s.4.48-.13.06-2.28-.34-2.74.63c-.46.98.06 1.82.82 2.13.76.32-.35.02-.35.02l-.86-.67-.14-.73.03-.92.65-.73.92-.49.88.05.47.26.45.39z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M484.78 261.3s-.38-.25-1.01.13c-.62.39-1.86 1.08-1.86 1.08l3.06-2.84.62.72-.81.91zm-140.45-34.97s.56-.2.01.13c-.55.32-1.04 1.87-.3 2.57.73.7 1.66.53 2.19-.03s-.1.3-.1.3l-.88.54-.7-.11-.82-.32-.47-.79-.14-.95.32-.75.4-.33.49-.26z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M346.49 230.45s-.35.25-.2.91c.15.67.38 1.95.38 1.95l-1.59-3.54.85-.31.56.99z"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/react.createElement("ellipse", {
    fill: "url(#mx_svg__c)",
    cx: 351.47,
    cy: 241.61,
    rx: 6.06,
    ry: 4.08,
    transform: "rotate(62.9 351.47 241.6)"
  })), _g8 || (_g8 = /*#__PURE__*/react.createElement("g", {
    fill: "#e92736"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M344.65 240.24s1.25.29 1.93-.06c.68-.34.8-.86.96-1.03.18-.17.35-.8.29-1.21a4.99 4.99 0 0 0-1.25-1.9c-.28-.12-1.25 0-1.42-.18-.17-.17.14-.55-.23-.63-.37-.09-2.27 2.08-1.93 2.42.34.34.54-.17.65.12.12.28.03 1.09.03 1.43 0 .35.97 1.04.97 1.04z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M346.5 236.2c.15.3.85 1.24 1.14 1.35.28.12 1.13.15 1.42.04.28-.12 1.19-.99 1.22-1.36.03-.38 0-.66-.17-1.04-.17-.37-.07-1.38-.41-1.44-.35-.06-.5-.1-.66-.3-.17-.2.1-.56-.15-.94-.26-.37-3.3 1.42-3.07 1.76.23.35.54-.03.65.2.11.23-.14 1.38.03 1.73z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M353.37 235.43c.17-.46.11-1.96-.2-2.28-.31-.31-.82-.34-.85-.54-.03-.2.37-.3.37-.64s-3.38.12-3.15.5c.22.37.8.17.76.4-.03.22-.57.51-.62.8-.06.3.17 1.24.31 1.47.14.24-.05.52.34.66.4.15.34.15.71.26.37.12 1.7.06 1.88-.08.17-.15.28-.09.45-.55zm28.73 16.88s.55.96 1.17 1.19c.6.23 1 0 1.2 0 .2 0 .7-.25.9-.53.22-.27.54-1.65.44-1.9-.1-.25-.73-.8-.72-1 0-.21.42-.23.25-.51-.16-.29-2.6-.23-2.61.2-.01.41.42.23.31.47-.11.25-.65.66-.87.86-.21.2-.07 1.22-.07 1.22z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M385.66 251.11c-.1.27-.26 1.26-.17 1.51.1.25.58.8.82.91.23.12 1.3.19 1.54-.02.25-.2.41-.38.54-.71.13-.33.8-.86.64-1.1-.16-.25-.22-.37-.2-.6.03-.23.41-.26.49-.64.08-.38-2.8-1.26-2.87-.91-.08.35.33.32.25.53-.07.2-.93.72-1.04 1.03z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M390.16 255c.38-.16 1.27-1.07 1.28-1.46.01-.38-.27-.72-.16-.86.1-.13.4.07.6-.14.22-.2-2.04-2.06-2.14-1.7-.1.36.36.6.2.72-.16.12-.65-.05-.86.08-.21.13-.66.83-.72 1.06-.06.22-.35.27-.2.6.14.34.1.3.25.6.14.3.96 1.11 1.15 1.13.19.03.22.14.6-.03zm86.74 7.25s.05 1.07.46 1.55c.42.48.84.47 1.01.57.17.1.7.11 1-.01a4.03 4.03 0 0 0 1.19-1.4c.03-.25-.27-1.01-.17-1.19.1-.17.45 0 .43-.3-.01-.32-2.08-1.42-2.28-1.08-.19.35.25.4.06.56-.2.15-.85.24-1.1.3-.28.08-.6 1-.6 1z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M480.26 262.95c-.21.16-.84.82-.9 1.05-.04.23.06.86.2 1.05.12.2.93.73 1.23.69.3-.04.52-.1.78-.29.27-.19 1.07-.27 1.07-.53s0-.38.14-.54c.13-.15.46 0 .7-.25.26-.25-1.57-2.21-1.8-1.99-.25.22.09.4-.07.51-.17.12-1.1.12-1.35.3z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M480.96 267.83c.36.14 1.56.14 1.82-.1.26-.22.3-.6.46-.62.16-.01.22.29.5.3.27 0 0-2.55-.3-2.39-.31.17-.18.6-.35.57-.19-.03-.4-.44-.63-.49a3.1 3.1 0 0 0-1.18.2c-.18.1-.4-.06-.53.24s-.13.25-.23.53c-.1.27-.1 1.27.02 1.4.1.14.06.22.42.36z"
  }))), mx_path15 || (mx_path15 = /*#__PURE__*/react.createElement("path", {
    d: "M346.72 237.45c.28.42-.09 1.42-.32 1.7-.22.29-1.74-.12-1.76-.4-.02-.29-.13-.76.07-1.03.2-.26.7-.87 1.09-.8.38.07.82.39.92.53zm.41-1.88c-.18.38.08.8.27 1.02.2.2 1.29.48 1.58.3.3-.19.75-1.87.54-2.13-.2-.26-.79-.3-.99-.28-.2.04-1.28.83-1.4 1.09zm3.62-1.72c-.15.34-.1.82.03.97.12.15.83.64 1.24.62.42-.03.62-1.2.62-1.42 0-.22-.13-.32-.42-.45-.3-.12-1.47.28-1.47.28zm34.27 18.13c-.1.42-.93.78-1.23.8-.31.02-.94-1.18-.78-1.36.16-.18.38-.53.66-.55.28-.03.96-.07 1.13.22.18.28.25.74.22.89zm1.4-.84c-.34.1-.45.52-.47.77-.01.24.46 1.09.74 1.17.29.08 1.6-.62 1.63-.9.03-.29-.28-.68-.42-.79a3.9 3.9 0 0 0-1.48-.25zm3.17 1.29c-.3.1-.56.42-.58.58-.02.17.09.9.35 1.15.26.25 1.09-.3 1.23-.44.13-.13.12-.26.03-.52-.1-.26-1.03-.77-1.03-.77zm89.98 10.76c-.26.31-1.11.22-1.38.09-.27-.13-.28-1.43-.07-1.5.21-.08.56-.27.8-.16.25.1.83.4.86.72.02.32-.12.74-.21.85zm1.27.12c-.32-.07-.62.19-.76.36-.13.18-.18 1.02 0 1.2.18.2 1.57.27 1.74.07.17-.2.12-.63.07-.77a3.5 3.5 0 0 0-1.05-.86zm1.45 2.59c-.27-.11-.65-.1-.77 0-.12.09-.54.6-.53.92 0 .32.93.49 1.1.5.19 0 .27-.09.38-.3.1-.22-.18-1.12-.18-1.12z",
    fill: "#f7e204"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/react.createElement("ellipse", {
    fill: "url(#mx_svg__d)",
    cx: 476.69,
    cy: 268.57,
    rx: 2.94,
    ry: 5.86,
    transform: "rotate(47.85 476.7 268.57)"
  })), _g9 || (_g9 = /*#__PURE__*/react.createElement("g", {
    fill: "#78732e"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#a8ac71",
    d: "M375.12 185.22s-5.03.43-8.52-.17c-3.5-.6-2.73-9.51-2.81-9.77-.09-.26-2.13-2.42-1.8-4.4.35-2 6.8-7.24 7.68-7.52.6-.2 1.87.34 1.87.34s1.63-1.58 2.12-1.58c.5 0 1.18.91 1 1.3-.2.39-2.42 1.68-2.59 2.68-.17 1 .03 1.99-.62 2.96-.63.97-1.87 2.29-2.02 3.11-.15.82-.5 1.54.1 1.84.63.3 2.74.04 4.55-.78 1.8-.82 2.55-1.92 2.8-1.82.26.11-1.04 2.27-3.04 3.12-2 .84-3.32 1.81-4.32 1.66 0 0-1.11 2.66 2.32 2.8 3.43.16 5.32-.75 5.32-.75l-2.04 6.98zm-19.64 20.96s2.64 1.04 2.64 3.98c0 2.93-2.9 5.4-2.81 10.58.09 5.19.9 5.24 7.75 10.8a7.45 7.45 0 0 1 2.05 3.34c.38 1.68 1.62 11.62 8.22 11.57 6.6-.04 7.5-4.23 7.5-4.23l-2.82-4.15s-2.3.7-3.53.4a4.51 4.51 0 0 1-3.07-2.73c-.72-1.6-.92-5.4-2.04-7.09-2.77-4.15-7.71-4.84-7.76-9.2-.04-4.37 3.03-4.84 2.18-10.03-.85-5.18-7.03-7.7-7.03-7.7l-2.51-1-.88 5.2 2.11.26z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#f1a720",
    d: "M373.67 169.89c2.21-.52.94-6.29.94-6.29l-1.54 1.28s.95 1.23.95 2.56c0 1.32-.35 2.45-.35 2.45z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#a8ac71",
    d: "M377.71 227.47s-1.03-.84-1.13-.91c-.79-.53-4.26-3.33-3.7-11.66.63-9.42 14.32-14.38 15.22-18.12 1-4.15 4.1-5.96-6.82-14.5l-2.55 3 4.47 3.36s.99-.55 1.05.72c.06 1.26-1.2 2.35-1.5 3.34-.29.9-7.09 5.64-7.6 6.1-.51.46-3.9 3.1-3.9 3.1s-1.78 1.74-3.42 5.4c-1.65 3.66-.8 8.35-.8 8.35s.05 10 10.68 11.82z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m371.03 232.74.77 3.54-2.17.8-.94-.04-.68.3-1.69 1.62-.42-.13s-.26.09-.34-.95c-.09-1.03-.24-1.94-.24-1.94l2.05.84.72.04.51-.17.9-1.94 1.53-1.97zm-6.35.65s-.68-.82-1.02-1.32c-.3-.42-.44-.52-1.2-1.12l1.5-.84 1.6.02-.24 1.92-.64 1.34zm3.63-5.69s1 .5 1.32 1.25c.32.76.79 1.69.79 1.69l-2.54-.2-1.93-.6 1.25-1.75 1.11-.39zm-.99 15.67s-.51-.32-.81-1.14c-.3-.82-.53-2.14-.53-2.14l1.68-.32 1.98.8.56.04s-.47 1-.54 1.04l-1.91 1.66-.43.06zm6.72-5.43s-1.49-.47-1.72-1.17c-.26-.75-.45-.6-.45-.6l-.47 2-.6 1.89s.13.32.2.32c.06 0 1.42-.35 1.51-.39.08-.04 1.13-1.12 1.15-1.18l.38-.87zm-6.27 6.31s.75.41 1.79 1.02c1.04.6 1.66.6 1.66.6l.79-.84.8-1.6.11-.2-4.02.37-1.13.65zm5.82-1.55 3.43-2.05.23-1.86-.68-.52s.13.06-.8.06h-1.18l-.62 2.27-.38 2.1zm-2.45 3.24s2.4 1.04 6.56-.48c1.88-.68 2.24-1.6 2.24-1.6l-1.67-.64-1.57 1.4-5.56 1.32zm-3.28-26.63s-.24-.78-.48-1.79c-.23-1.01-.21-1.45-.21-1.45l1.22.64 1.77 1.31-1.26 1-1.04.29zm2.89 4.89s-.6-.6-1.1-1.38c-.52-.78-.87-1.5-.87-1.5l1.3.27 1.5.73-.66 1.95-.17-.07z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#c6c7a6",
    d: "M363.02 169.18c-.23.84-.54 2.36.62 2.65.64.16 3.13-.05 5.97-3.28 1.36-1.56 1.39-3.09 1.39-3.09l.54-1.75s-1.1-.81-2.9.31c-1.6 1.01-5.62 5.16-5.62 5.16z"
  }), /*#__PURE__*/react.createElement("ellipse", {
    fill: "#1c242f",
    cx: 370.77,
    cy: 164.64,
    rx: 0.5,
    ry: 0.53
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#a8ac71",
    d: "M367.16 165.17c-1.21.95-2.34 2.16-2.34 2.16s1.91-.54 3.44-1.92a4.52 4.52 0 0 1 3.44-.89c.46.1.3-.49.08-.66-.5-.4-1.88-.59-2.18-.36-.05.03-1.22.72-2.44 1.67z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M372.92 218.3s-.08-.4-.14-1.4c-.05-.99.06-1.49.06-1.49l-1.13.99-1.09 1.51 1.68.6.62-.21zm-5.88-3.36s-.16-1.55-.07-3.01c.08-1.47.68-4.14.68-4.14l.72 1.83 2.06 3.21.66.48-1.74 1.28-1.8.58-.51-.23zm5.92-.82s.1-.73.29-1.41c.17-.67.7-1.73.7-1.73s.02.1-.07.13a33.73 33.73 0 0 0-2.66 2.24l1.09.83.7-.04m-4.82-7.66s.26-.96 1.18-2.13l1.82-2.36.78 3.13.46 2.68.09.56s-.64.28-.9.26c-.25-.02-2.17-.13-2.4-.45a42.79 42.79 0 0 1-1.03-1.69zm6.21 3.65s.58-.62 1.1-1.1c.5-.47 1.32-1.39 1.32-1.39l-4.21.77.6 1.43 1.19.29zm-2.54-8.7s.39-.14 1.52-1.28c1.13-1.15 1.7-1.01 1.7-1.01l.47 4.52-2.21-.65-1.48-1.58z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m377.1 207.36 2.53-2.57-4.21-1.2.77 2.95zm1.77-6.8.26-4.36s-.86.4-1.95 1.3a13 13 0 0 1-1.59 1.2l.51.78 1.5.97 1.27.11zm3.75-4.23v-3.44l-.14.07s-.6.93-1.3 1.51c-.71.59-1.03 1-1.03 1l1.13.73 1.34.13zm1.57 4.6s1.19-.99 2.06-1.67c1.3-1.03 1.94-2.15 1.94-2.15l-5.45-.42.22 2.19 1.23 2.05zm-12.68-18.05-.17 2.4 4.55-.03-1.11-1.53-1.4-.87-1.3-1.32zm8.78 21.31c.24-.18 1.42-1.07 1.98-1.63.62-.63 1.59-1.26 1.59-1.26l-4.33-.47.09 2.85.67.51zm8.23-7.79s.46-1.74.42-3.4c-.04-1.67-.31-2.41-.31-2.41l-3.24 2.2.47 1.64 1.23 1.35 1.43.62z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M382.98 192.4s.96-1.16 1.02-1.83c.07-.67.06-.46.06-.46l2.56.04 1.53.13.19.15-1.15 1.36-1.58.91-2.02.24-.61-.54zm5.18-2.55-1.57-2.67a5.64 5.64 0 0 0-1.11-1.4l-1.25 3.71-.13.36h4.06z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "m356.53 215.28-.49 1.03s1.7-.88 3.03-.84c1.31.05 2.79 1.7 2.79 1.7l.31-1.2s-1.74-1.7-2.9-1.79c-1.14-.09-2.74 1.1-2.74 1.1zm.85-7.63s.36.43.45.56c.08.13.13-1.27 1.85-2 1.73-.74 2.67-.16 2.67-.16s-.35-1-1.11-1.2c-.77-.22-1.51-.07-2.45.6-.94.67-1.4 2.2-1.4 2.2zm5.86 5.75s-.81-1.73-2.21-2.07c-1.41-.35-3.2.73-3.2.73l-.3.9s1.92-1.08 3.32-.51c1.41.56 1.96 2.16 1.96 2.16l.43-1.21zm-6.58-6.7c.08.3.42.69.42.69s-.19-1.85.66-2.8c.86-.96 1.5-1.3 1.5-1.3l-.8-.41s-1.12.75-1.5 1.57a4.18 4.18 0 0 0-.28 2.25zm-.76-3.04c.4-.92 1.57-1.32 1.57-1.32s-.12-.2-.39-.35c-.26-.14-.54.01-.54.01s-.75.4-1.21 1.43c-.45 1.04-.4 2.54-.4 2.54l.7.39s-.13-1.78.27-2.7zm10.34-25.06c1.08-.58 1.87-.46 1.87-.46s-1.6 1.68-.83 3.76c-.9 1.76-1.18 3.09-1.18 3.09h.85s.28-1.37.62-2.44c.92 1.78 2.47 2.79 2.47 2.79l1.3-.06s0-1.74.68-3.25l.12.14a6.64 6.64 0 0 0 2.62 1.85l.01-.45s-1.5-.88-2.34-2.03l-.09-.13.03-.05c1.02-1.6 2.39-2.13 2.39-2.13l.9.75.23-.29-.68-.86-.79.02s-1.41 1.18-2.32 2.2a12.01 12.01 0 0 1-1.04-2.05l-.58-.21s-1.41.16-2.68 2.2c-.16-1.5 1.57-3.13 1.57-3.13l-.08-.63s-1.75.33-3.11.73c-1.36.4-2.2 1.7-2.2 1.7l-.05.91s1.23-1.4 2.3-1.97zm1.87 2.76c.8-1.15 2.56-1.9 2.56-1.9s.04.94 1.01 2.18c-.66 1.16-.96 2.95-.96 2.95s-1.36-.86-2.55-2.6a2.12 2.12 0 0 1-.21-.38l.15-.25zm-9.94 27.76.06 1.01s1.05-1.14 2.62-1.18c1.58-.05 2.92 1.18 2.92 1.18s.02-1.35-.19-1.48a5.95 5.95 0 0 0-2.68-.87c-1.2 0-2.73 1.34-2.73 1.34zm28.12-14.74c-.21-.37-.44-.9-.62-1.35.24-.09.48-.2.7-.37 1.32-1 2.26-2.08 2.26-2.08l-.47-.73h-2.13c-.42 0-1.3-.1-1.8-.17.09-.33.35-1.24.66-2.2.38-1.19.73-1.82.73-1.82l-.73-.74s.17.68-1.1.85c-1.28.17-3.64-1.03-3.64-1.03v.51s2.07.67 3.27.84c.7.1 1.25-.14 1.59-.35-.19.38-.52 1.11-.7 1.77-.16.57-.38.94-.37 1.18.01.16.24.3.24.3l-.1 1.12s1.27.17 1.86.17c.6 0 2.22.13 2.22.13s-1.15 1.34-2.26 1.86c-.14.07-.3.12-.46.17a59.15 59.15 0 0 0-1.32-2.09l-.13.72s.9 1.24 1 1.5c-.82.1-2-.17-2-.17l-.5.56s-.05 1.6 0 3.26c-1.1-.3-2.34-.75-2.34-.75l-.46.34.03-.08-.6.47s-.5 1.94-.37 4.15v.11c-2.1-.52-3.16-1.75-3.16-1.75l-.5.43s-.35 1.9.12 4.2a7.73 7.73 0 0 1-3.35-1.9l-.67.55s.4 3.72.83 5.75c.03.17.08.32.13.48-.36.03-.7.05-.99.04-1.83-.09-2.96-1.77-2.96-1.77l-.54 1.3s.7 3.58 2.7 5.18l.45.36a7.95 7.95 0 0 1-3.76 1.61l.12 1.13s1.22.96 2.42 1.78l.37.23c-.95.84-2.12 1.19-2.12 1.19l.32.75s1.58-1.1 2.31-1.7c1.06.42 2.46.6 2.46.6v-.62s-1.03-.09-1.98-.4l.14-.12c.6-.58 1.76-2.36 1.76-2.36l.11-1.3s-.73-.1-1.52-.73c2.41-1.66 2.5-2.4 2.5-2.4l.46-.86s-.82-.35-1.42-1.54a28.4 28.4 0 0 0 3.84-.95c.04-.13.28-.27.28-.27s-.92-1.52-1.32-3.38c1.9.5 3.86.81 3.86.81l.6-.52s-.46-1.55-.61-3.23c2.26.15 4.18.32 4.18.32l.39-.44s-1.28-2.44-1.24-3.82v-.13c.44.08.88.14 1.28.13 1.87-.05 3.96 0 3.96 0l.32-.71s-1.81-1.24-2.23-2.02zm-13.8 20.33s-.6 1.24-1.84 2.67l-.3.3a6.05 6.05 0 0 1-.64-.3c-1.44-.83-1.81-1.76-1.81-1.76s.8-.4 3.23-2.03c1.3 1.02 1.37 1.12 1.37 1.12zm1.14-4.12s-.76.9-2.53 2.49a5.42 5.42 0 0 1-.55-.6c-1.13-1.47-2.55-2.74-2.41-4.96 0 0 .88 1.59 2.84 1.38.4-.03.86-.1 1.34-.19a4.36 4.36 0 0 0 1.31 1.88zm2.64-3.33s-1.81.6-3.5.87a6.96 6.96 0 0 1-.2-.56c-.64-2.08-.64-5.23-.64-5.23s1.42.98 3.4 1.53c.58 2.35.94 3.4.94 3.4zm-.6-3.83c-.3-1.94.1-3.86.1-3.86s1.05 1.06 3.02 1.39c.13 1.78.34 2.67.34 2.67s-1.5.09-3.46-.2zm7.63-2.95s-1.27.5-3.7.15l-.05-.71c-.08-2.2.11-3.99.11-3.99l.01-.03c.35.16 1.65.69 2.86.98v.14c.18 1.99.77 3.46.77 3.46zm-.17-4.1-.13-.04c.08-1.4.08-3.47.08-3.47s1.18.32 2.1.2c.24.6.08.75.68 1.66.6.91 1.49 1.65 1.49 1.65s-3.02.25-4.22 0zm-9.88 24.44-.17-.71s-1.2.89-1.53 1.8a2.16 2.16 0 0 1-.37-.1c-.8-.29-2.67-1.02-2.67-1.02l.27.53s1.94.9 2.45 1.01l.17.03a72.1 72.1 0 0 1-.65 1.84l.31.44s.18-1.32.68-2.24c.67.07 1.6.1 1.6.1s-.12.52-.29 1.1c-.17.57-.51 1.93-.51 1.93l.58.36 2.72.06-.46-.54s-.09-.14-.97-.17-1.42.12-1.42.12.12-.55.46-1.65c.34-1.1.35-1.03.35-1.03l-.34-.95s-.87.24-1.44.22c.5-.74 1.23-1.13 1.23-1.13zm-14.82-1.72a5.57 5.57 0 0 1 3.06 1.13l-.06-.8s-1.3-1.75-2.79-1.75c-1.5 0-3.26 1.53-3.26 1.53v1.64s1.38-1.75 3.05-1.75zm17.5 25.5c-1.7.73-3.62.73-3.62.73s.52-.74 1.03-2.02c3.33-.94 4-3.16 4-3.16l-.21-.82s-.81 2.03-3.5 3.15c.5-1.57 1-4.23 1-4.23l-.91-.24s-1.31 1.65-2.55 2.06c.84-1.63.95-3.5.95-3.5l-.4-.72s-.9.8-2.3 1.06c-.22.04-.45.03-.7 0h.01c.77-1.08 2.24-4.2 2.24-4.2l-.26-.58s-1.12 2.75-2.27 4.13l-.44.5c-1.18-.33-2.86-1.34-2.86-1.34l.19.52s.95.73 2.35 1.17c-.85.9-1.78 1.72-1.78 1.72l.09 1.25s2.15.41 3.93.6a9.63 9.63 0 0 1-2.6 2.69l.58.86s1.76 0 4.9-.78c-.89 1.69-1.57 2.43-1.57 2.43s2.87.2 4.83-.8 2.56-2.03 2.56-2.03l-.56-.61s-.42 1.43-2.13 2.16zm-9.07-5.4s.85-.94 1.57-1.89l.1.02c2 .44 2.55-.17 2.55-.17s.38 1.09-.84 3.04c-1.44-.06-3.38-1-3.38-1zm1.79 4.01 1.79-2.07c.13-.15.24-.3.34-.44 1.96-.07 3.07-1.68 3.07-1.68s.23 1.63-.65 3.63c-2.5.9-4.55.56-4.55.56zm-2.43-12.87c1.88.12 4.3 1 4.3 1l-.3-.98s-2.3-.57-3.74-.75c.64-1.44 2.06-2.13 2.06-2.13l-.64-.34s-.78.13-1.85 1.94l-.24.45a5.48 5.48 0 0 0-3.53.93l.26.52s1.48-.64 2.94-.66c-.53 1.47-.92 3.15-.92 3.15l.38.89 1.27-4.02h.01zm-3.94-8.04-.4-1.04s-2-.71-3.54.02c-1.53.74-2.68 2.5-2.68 2.5l.64 1.22s1.06-1.97 2.47-2.44c1.4-.48 3.51-.26 3.51-.26zm3.9 3.04-1.32-.69s-2.17.63-2.94 1.4c-.77.79-1.39 2.77-1.17 3.33.21.56.9.93.9.93s.35-2.1 1.42-3.09c1.07-.99 3.1-1.88 3.1-1.88zm-5.07-.62a5.9 5.9 0 0 1 2.51-1.2l-.8-.73s-1.97.24-2.99 1.15c-1.02.9-2.34 2.79-2.34 2.79l1.15 1.12s1.58-2.27 2.47-3.13zm6.75-58.72.07-.09c1.03-1.33 2.03-1.33 2.42-1.22.17.05.39.03.59 0h-.01l.03-.01.14-.03c.05 0 .1.02.12.07-.33.52-.8 1.94-1.04 3.13-.3 1.47-.93 1.64-1.4 2.55-.47.9-1.45 2.42-1.5 3.71-.03 1.3.3 2 .65 2.16.34.18.96-.56.93-.86-.04-.43-.38 0-.63 0s-.22-.43-.35-1.2c-.12-.79.94-2.95 1.33-3.64.38-.7 1.19-1.51 1.36-2.68.15-1.04.9-3.32.9-3.33 0-.06-.57-.22-1.7-.3-.84-.06-1.97.68-2.5 1.5-.54.82-2.22 1.48-2.22 1.48s1.84.01 2.8-1.24z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m374.33 178.91-3.27.09.94 2.44zm-3.85-.13s-.48-.3-.7-.56c-.23-.26-.4-.37-.4-.37l-1.19.74-.68 2.42.34.35 2.63-2.58zm-.44 6.56-2.39-3.52-1.36 2.94.65.23s.66.06 1.65.2c1 .15 1.45.15 1.45.15zm9.7 58.72-.12.08c-.57.38-3.07 1.9-6.14 1.9a8.76 8.76 0 0 1-4.54-1.24 5.14 5.14 0 0 1-2-2.35c-.7-1.47-1-3.33-1.31-5.14-.32-1.8-.65-3.55-1.44-4.83-1.08-1.71-3.1-2.78-4.9-4.3a9.62 9.62 0 0 1-3.81-7.9c0-2.26.72-4.23 1.46-5.95.73-1.73 1.49-3.2 1.5-4.53 0-.22-.03-.44-.08-.65-.24-1.02-1.13-1.88-1.94-2.52-.81-.63-1.57-1.01-1.57-1.02h-.02l-1.27-.36-.1.4 1.24.35.05-.2-.09.18.12.07c.29.15 1 .57 1.69 1.15.68.57 1.33 1.31 1.5 2.04.03.18.05.37.05.56 0 1.17-.71 2.63-1.46 4.36a15.42 15.42 0 0 0-1.5 6.12c0 .35.02.7.06 1.06.34 3.56 2.05 5.61 3.9 7.16 1.86 1.55 3.84 2.63 4.82 4.2.98 1.57 1.24 4.09 1.71 6.5.24 1.2.54 2.4 1.02 3.43a5.53 5.53 0 0 0 2.17 2.53 9.17 9.17 0 0 0 4.74 1.3c3.66 0 6.48-2.05 6.5-2.06l-.24-.34z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m376.91 237.6-.03.02c-.14.08-.8.45-1.64.45-.67 0-1.47-.23-2.28-1.02a5.32 5.32 0 0 1-1.52-3.03c-.25-1.14-.44-2.53-1.22-4.34-.8-1.86-2.78-3.35-4.62-4.82-1.85-1.45-3.55-2.88-3.85-4.44a4.3 4.3 0 0 1-.09-.88c0-1.31.56-2.64 1.15-4.15a14 14 0 0 0 1.18-5.22c0-.34-.01-.7-.05-1.05-.27-2.61-2.26-4.55-4.15-5.84a18.5 18.5 0 0 0-3.73-1.96l-.13.4.3.11c.68.28 2.41 1.05 4.02 2.3 1.6 1.23 3.07 2.92 3.28 5.03.04.35.05.69.05 1.01 0 1.94-.57 3.56-1.15 5.07-.58 1.5-1.18 2.87-1.18 4.3 0 .32.03.64.1.96.37 1.79 2.15 3.22 4 4.7 1.85 1.45 3.77 2.94 4.5 4.65.76 1.76.94 3.09 1.19 4.26.24 1.17.58 2.2 1.64 3.24a3.58 3.58 0 0 0 4.46.6l-.23-.35z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#a8ac71",
    d: "M388.97 227.59s2.29.54 2.2 2.4a17.5 17.5 0 0 1-1.1 4.45l-3.16-2.86 1.78-1.57.65-.93-.37-1.49z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#f8c83c",
    stroke: "#977c2e",
    strokeWidth: 0.35,
    d: "M349.61 205.23s-2.26.78-2.73-.22c-.46-.99-.25-1.77-.3-1.98-.04-.22-1.36-.3-1.23-1.6.13-1.3 1.79-1.21 2.13-1.21.34 0 .43-2 1.58-1.9 1.15.08 1.7 1.42 1.7 1.42l-1.15 5.49z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#f8c83c",
    stroke: "#977c2e",
    strokeWidth: 0.35,
    d: "M352.12 205.84s-1.92 1-2.51.04c-.6-.95 0-2.16-.22-2.37-.21-.22-1.36-.6-1.15-1.73.22-1.13 1.4-.78 1.84-1 .42-.21.72-1.9 1.91-1.6 1.2.3 1.4 1.26 1.4 1.26s-.93 4.5-1.27 5.4z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#f8c83c",
    stroke: "#977c2e",
    strokeWidth: 0.35,
    d: "M355.36 206.27s-.55 1.21-1.92.95c-1.36-.26-.93-2.25-1.15-2.6-.21-.34-1.19-.6-1.02-1.85.17-1.25 1.4-1.08 1.87-1.25.47-.18.98-2.12 1.88-1.82.9.3 1.74 1.43 1.57 1.95 0 0-1.91.6-2.17 1.9-.25 1.3.94 2.72.94 2.72z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#af7029",
    d: "M385.51 227.14s-1.7-1.87-2.9-3.51a37.44 37.44 0 0 0-3.04-3.52l-2.92-1.47-1.84-3.08-.23-3.63.8-2.1 1.1-1.62s-6.06 2.17-2.98 13.77c1.3 4.93 4.65 5.65 4.65 5.65l5.57-.34 1.79-.15z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#816c2a",
    d: "M382.71 188.39c.58.02.86.2 1.03.45.18.24.23.57.23.85 0 .15-.01.29-.03.39l-.02.1v.04l.2.06-.2-.09c-2 4.44-6.25 6.51-10.07 9.28a18.1 18.1 0 0 0-5 5.08c-1.32 2.13-2.15 4.83-2.15 8.46v.56c.16 6.68 2.68 10.27 5.46 12.15a12.7 12.7 0 0 0 6.9 2.07h.48v-.01c.01 0 .79-.1 1.9-.2 1.12-.1 2.57-.2 3.9-.2.86 0 1.67.04 2.31.14.64.1 1.1.3 1.24.49.18.22.25.44.25.67 0 .5-.37 1.09-.82 1.55-.44.47-.96.83-1.15.91l.18.38c.26-.13.78-.5 1.27-1 .48-.5.92-1.14.93-1.84 0-.32-.1-.65-.34-.94-.3-.34-.82-.5-1.5-.63-.67-.1-1.5-.15-2.36-.15-2.72 0-5.85.4-5.85.4l.02.21-.01-.2h-.44c-1.1 0-4.02-.19-6.69-2-2.66-1.81-5.1-5.23-5.26-11.8V213c0-3.57.8-6.18 2.07-8.24 1.9-3.1 4.88-4.99 7.79-6.95 2.9-1.96 5.75-4 7.31-7.46l.01-.01v-.02c0-.01.08-.28.08-.64 0-.33-.06-.74-.3-1.1-.25-.35-.7-.6-1.36-.62l-.01.42z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M390.88 229.04s-1.44 2.63-1.8 2.66c-.37.02 1.24.41 1.6 1.03l-.34.65s-1.59-1.13-2.58-1.18l-.1-.97s.82-.28 1.5-.9a5.27 5.27 0 0 0 1.14-2.24l.58.95z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#fcca3d",
    d: "m396.48 230.77-3.58.98-1.82-1.14s.15-1.49-.66-2.13c-.84-.66-1.33-.85-2.06-1.16-.72-.3-3.28-.35-3.28-.35l-6.46-7 2.41.25 3.82-.47 3.55-.3 1.88.27 2 .62 1.05.9 1.09.96 1.1 1.8.7 2.03.27 2.19-.01 2.55z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#af7029",
    d: "M396.62 230.54s-1.28.38-2.9.34c-1.62-.02-2.65-.27-2.65-.27s.1.1-.24 1.17a15.07 15.07 0 0 1-.66 1.73l.06 4.2 3.4.67 1.8-.7.9-4.58.29-2.56z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#fcca3d",
    d: "m395.67 228.76.15 1.63.67.2-.01-1.47zm-3.21-39.29-.4-2.87-1.12-1.9-1.42-1.94-1.52-1.67-.85-.76-.36-.57-3.73.18-1.96 2.33s5.1 3.6 7.02 7.53a9.26 9.26 0 0 1 3.67 2.26l.17-.31.5-2.28z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#af7029",
    d: "M388.84 192.63c-.05 2.92-.55 4.3-.94 4.95l2.26-2.59 1.63-2.93a9.26 9.26 0 0 0-3.67-2.25c.46.93.74 1.89.72 2.82z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#816c2a",
    d: "M394.11 235.87s-1.05-1.31-1.83-2.08c-.8-.78-1.73-1.2-1.74-1.2l-.17.37.15.07c.28.15.92.52 1.47 1.06a22 22 0 0 1 1.8 2.04l.32-.26z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#6f5b24",
    d: "M396.31 232.73s-.34 1.26-1.62 2.42c-1.28 1.15-2.9 1.93-2.9 1.93l3.67 1.35 2.44-2.27-1.59-3.43z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#404118",
    d: "m396.85 235.77-.22.43-.7.67-.53.57.91-3.8.65 1.12.09.6z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "none",
    stroke: "#78732e",
    strokeWidth: 0.3,
    d: "M375.12 185.22s-5.03.43-8.52-.17c-3.5-.6-2.73-9.51-2.81-9.77-.09-.26-2.13-2.42-1.8-4.4.35-2 6.8-7.24 7.68-7.52.6-.2 1.87.34 1.87.34s1.63-1.58 2.12-1.58c.5 0 1.18.91 1 1.3-.2.39-2.42 1.68-2.59 2.68-.17 1 .03 1.99-.62 2.96-.63.97-1.87 2.29-2.02 3.11-.15.82-.5 1.54.1 1.84.63.3 2.74.04 4.55-.78 1.8-.82 2.55-1.92 2.8-1.82.26.11-1.04 2.27-3.04 3.12-2 .84-3.32 1.81-4.32 1.66 0 0-1.11 2.66 2.32 2.8 3.43.16 5.32-.75 5.32-.75l-2.04 6.98z"
  }))), _g10 || (_g10 = /*#__PURE__*/react.createElement("g", {
    fill: "#d2a567"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#ab6d29",
    stroke: "#4d2a15",
    strokeWidth: 0.51,
    d: "M418.24 147.56s-9.2-1.74-9.05 5.93c.04 2.42.58 3.25 2.53 3.8 1.94.54 5.84.74 9.15 3.7 3.3 2.97 3.55 5.14 3.55 6.92 0 1.77-.82 3.4-.82 3.4l2.09 10.13 2.1 7.5 6.22-3.6 3.66-11.11-4.68-20-14.75-6.67z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#4d2a15",
    d: "M427.38 186.09s3.2-1.21 4.03-3.8c.23-.72-3.24-3.83-3.32-3.83-.08 0 1.76.89 2.61 1.67.85.78 1.5 1.1 1.76.98.26-.12 1.74-3.55 1.17-4.3-.57-.75-1.45-2.5-2.79-3.4-1.33-.89-3.1-.77-3.1-.77s2.45-.78 3.67-.09c1.22.7 1.34 1.5 1.48 1.21.14-.29-.26-3.72-.81-4.87s-1.12-1.7-2.6-1.99c-1.47-.29-3.07-.17-3.07-.17s2.13-1.18 3.75-.78c1.62.4 1.6 1.21 1.73 1.04.15-.17-.8-3.14-1.17-3.9a8.75 8.75 0 0 0-2.86-2.41c-.54-.17-2.3-.23-2.3-.23l-.85.01s1.22-.85 2.79-.7c1.55.14 1.64.66 1.86.57.23-.08-.17-.28-1.11-.95-.96-.66-5.56-2.62-5.56-2.62l-4.2-.06s-.05-1.06 1.18-1.26c1.22-.2 1.57.15 1.49-.16-.09-.32-3.55-1.08-3.55-1.08l-2.84.09c-.85.02-3.95.38-3.95.38s.27-.68.88-1.2c.46-.41 1.17-.67 1.76-.83 1.36-.37-.76-1.44-.76-1.44l1.13-1.73 5.12.43 10.79 6.31 5.05 4.36 3.21 8.18-.97 14.06-7.21 5.96s-3.18.5-3.18.35c0-.15.74-3.03.74-3.03z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M417.97 151.17s-.34-1-.34-2.25.21-1.2.21-1.2-3.45-.48-5.96 1.5c-2.51 2-1.07 5.45-1.07 5.45s1.1-1.08 2.5-1.6 3.94-.43 3.94-.43c.2-.22-.56-1.21-1.5-1.43-.93-.21-2.76-.21-2.76-.21s1.06-.74 2.9-.56c1.83.17 2.08.73 2.08.73z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8f4620",
    d: "m428.76 187.3-2.33.8 1.42 9.8 9.31 15.96 4.89-.86 1.65-2.94 1.3.58c.57.57 2.39 3.68 3.92 4.32 1.53.63 2.33.4 3.7 1.5 1.36 1.1 6.34 8.51 6.6 8.8.25.28-.29-3.19-.29-3.19l-1.52-4.43-1.88-3.1-.29-.83 2.59.02 1.6.99 2.46 2.05 1.27 1.51.67 1.56.28 1.37.66 2.12 1.36 2.94 1.64 2.8.52-1.15-.8-3.28-2.5-7.97-1.53-2.68s2.02 1.45 2.56 1.64c.54.2 2.37 2.93 2.37 2.93l1.16 2.82.84 2.62.58 2.3.84 2.44 1.45-.83-.26-1.77-1.25-5.47-.54-5.92s.7-.01 1.55.92c.85.94 1.62 3.06 1.62 3.06l.63 5.36.85 4.91 1.59 5.01 1.66 3.16 1.08 1.77s.05-2.5.04-2.62l-2.03-20.97.27-.88s.24-.13.94.86c.7 1 1.39 2.55 1.39 2.55l.6 3.27.3 2.26.43 4.26.57 4.63 2.13 4.96 1.15 2.67.64-3.18-1.01-22.43.47-.65s1.2.98 1.59 1.68a7 7 0 0 0 1.14 1.36l.7 4.95.62 14.14.5 3.64 4.16-37.04 2.56-.57.3-.7-1.87-1.44-4.22-6.54-2.84-6.33-4.98-9.18-8.65-10.54s-5.37-4.58-6.73-5.62a26.34 26.34 0 0 0-2.5-1.69l.43-1.31 1.43-2.32-.23-.1-1.11.06-2.9.41-2.92-.86-5.72-4-6.14-2.92-3.6-1.27-8.69-2.2-8.64-1.17-3.88-.06-3.54.66s-1.8.74-2.36 1.85c-.56 1.11-.6 1.89-.43 3.51.17 1.62 1.15 2.46 3.58 3.46s8.14 4.8 8.14 4.8l2.75 2.76 1.02 1.32.14 1.02 1.86 14.58-3.67 7.93-2.62 1.36z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#ab6d29",
    d: "M438.11 210.03s1.56 2.65 3.78.6c2.21-2.04-.97-7.86-.94-8.2.03-.35 1.02-.47 1.02-.47l1.62 3s.97 1.61.6 4.18c-.37 2.56-2.84 4.78-2.84 4.78l-2.81-.64-.43-3.25z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#4d2a15",
    d: "m492.51 244.21-2-5.92s-.6-3.8-.6-4.58c0-.78-.38-10.42-.55-12.23-.17-1.82-.08-3.9-.28-4.15l-2.17-2.87-.85-.9.6-.42s.74.8.94.37c.2-.43-.03-2.53-.85-5.82-.83-3.28-5.03-10.97-5.03-10.97l.45.37 1.17 1.18 2.47 1.99 5.34 1.96 2.9.46 1.87 3.75s1.33 6.45 1.25 9.7c-.09 3.26-.29 5.9-1.53 9.16-1.25 3.26-1.56 13.57-1.73 15.21-.18 1.65-.8 3.26-.8 3.26l-.6.45z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8f4620",
    d: "M492.53 227.08s1.12-1.33 1.6-3.16c.5-1.83.69-16.2-1.01-17.98-1.7-1.78-5.19-3.18-5.36-3.06-.17.12 1.4 4.68 1.4 4.68s.51.67 1.05 1.86c.3.66.7 1.86.77 2.3.19 1.23 1.2 4.15 1.36 7.9.14 3.76.19 7.46.19 7.46z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#4d2a15",
    d: "M484.68 236.1s.73-6.8.39-11.78c-.34-4.98-.75-5.6-1.22-6.5-.48-.9-2.19-4.15-3.35-8.3-1.15-4.14-1.9-7.32-2.65-8.15-.75-.83-2.26-2.63-2.6-2.15-.34.49-.34 1.52-.34 1.52l-2.04-.55-.48-1.31.66-2.12-.13-.9-.24-1.5 2.64 2.1 5.43 3.71 2.72 11.25 2.53 7 .35 11.86-.25 10.44-1.42-4.62zm3.19-32.44s1.42 1.34 2.25 1.8c.83.47 2.4 1.43 2.08 1.54-.3.1-1.77-.47-2.69-.99-.92-.51-1.54-1.15-1.54-1.15l-.1-1.2z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#4d2a15",
    d: "M477.3 233.42s1.08-2.39.91-5.41c-.17-3.03-1.62-10.32-2.07-11.24-.46-.93-2.61-2.3-4.55-6.4-1.93-4.09-1.73-4.92-3-6.42a123.9 123.9 0 0 1-2.62-3.2l.4-4.38 4.71 2.4 2.02 1 2.39 11.47 2.13 3.2.9 4.58 1.14 10.68.62 8.5-.34.75-2.64-5.53zm-5.44-4.85s.13-3.37-.73-6.4c-.85-3.02-1.44-5.27-2.38-6.22a45.79 45.79 0 0 1-5.45-6.61c-2.13-3.2-5.08-6.57-5.08-6.57l.08-4.29s1.42 1.33 2.62 1.92c1.2.58 3.01 1.6 3.01 1.6l1.26 4.91 1.63 3.54 2.38 3.17 1.53 1.4.97 5.3.52 2.98 1.25 4.25-.41 2.13-1.2-1.11zm-3.92.04-1.3-1.25s.7-.85.36-2.53c-.34-1.69-.79-3.3-1.55-4.9-.77-1.6-1-2.58-1.47-3.05-.47-.48-4.45-4.24-5.84-5.38-1.38-1.15-3.5-3.33-4.83-4.17-1.32-.84-2.28-1.06-2.28-1.06l-.75-5.28s1.75 2.34 2.8 2.73c1.04.39 2.74.93 2.74.93l3.7 6.54 1.26 1.67 3.43 2.74 1.4 2.83 1.05 3.27 1.3 4.5.24 2.71-.26-.3zm-7.28-1.47s-2.19-2.5-2.53-4.12c-.34-1.61.23-1.61-.45-3.46-.69-1.84-2.96-4.55-4.83-6.05-1.88-1.5-4.54-3.68-4.37-4.9.17-1.2.5-1.26.5-1.26l1.14.97 5.85 6.23 1.8 3.26 1.36 4.06.9 1.9.88 2.42-.25.95zm21.1-30.54s4.03 5 5.05.4c.46-2.04-1.4-5.94-1.4-5.94s-3.74-6.56-5.01-8.14c-1.28-1.59-7.53-9.6-7.53-9.6l-4.57-2.13 1.56 2.68s3.4 3.4 7.76 10.92c4.34 7.52 3.49 11.67 3.49 11.67l.65.14zm-23.41-30.13s8 6.83 13.16 14.22c5.16 7.39 7.2 12.32 6.05 13.3-1.15 1-4.39-.55-5.7-2.63-1.33-2.07-2.44-5.7-7.3-11.24-4.85-5.53-7.19-6.35-7.19-6.35l-3.5-5.66 4.48-1.64z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#4d2a15",
    d: "M454.18 182.84s4.73 3.93 7.7 7.13a49.06 49.06 0 0 1 4.53 5.49l1.91 1.9s-1.15-2.03-.5-2.72c.63-.7 1.4-.35 1.4-.35l-15.04-15.77v4.32zm-.98.44s1.53 2.94 4.05 5.4c2.51 2.46 5.28 5.1 5.28 5.1l1.07 3.85s-6.86-5.27-6.9-3.98c-.05 1.3 1.66 3.98 1.66 3.98l-2.1-1.13-2.89-4.19-1.75-3.63-1.96-5.01 3.54-.39z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#4d2a15",
    d: "M432.46 199.53s3.58 3.2 5.54.09c1.96-3.12.43-6.7.43-6.7s5.05 7.45 6.47.47c.26-1.25-3.07-6.1-3.07-6.1l1.2-1.11 2.55 4.32s2.39-1.08 2.39-4.06c0-2.99-2.47-6.83-2.47-6.83l2.35 2.62s4.67.1 4.76-2.75c.08-2.85-3.92-5.84-3.92-5.84s3.2.22 3.15-1.64c-.04-1.86-4.34-3.15-4.43-4.32-.08-1.17 1.28-3.16 3.24-2.07 1.96 1.08 4.69 1.94 5.8-.18 1.1-2.12-.1-2.55-.1-2.55s-2.5-.51-2.76-.6c-.26-.09-4.48-2.38-4.48-2.38l-3.54-1.34-3.65-.47 1.36 2.72.94 7.47.04 3.46.68 7.52-1.8 6.27-.92 1.13-.66.84-1.56 3.3-2.18 2.38-2.8 3.58-2.56 2.77z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#ab6d29",
    d: "M457.82 213.57s-.9-2.24-2.83-3.74c-1.94-1.5-5-1.62-5-1.62l5.25 5.56 2.58-.2zm7.35 1.27s-1.7-3.4-3.69-5.47c-1.99-2.08-3.3-4.76-3.84-4.76-.53 0-.93.12-.93.12l.51 4.29 3.63 3.52s3.41 2.53 4.32 2.3zm6.05-.26s-.85-3.95-2.87-7.75c-2-3.8-4.14-5.36-4.14-5.36l.48 4.06 1.65 3.92 2.67 3.86 2.21 1.27zm4.94-2.22s1.42-8.12.14-10.37c-1.27-2.25-3.69-2.68-3.69-2.68l-.77 1.18.77 5.79 1.93 4.43 1.62 1.65zm4.86-13.54s1.2.6 2.64 3.34c1.45 2.74 3.5 10.84 3.46 11.27-.03.42-.76.33-.96.23-.2-.1-5.11-7.78-5.11-7.78l-.78-7.18.75.12z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M446.72 208.26s2.6-.56 2.6-1.47c0-.9-3.1-2.72-2.85-4.2.12-.73 2.64.14 2.81-.38.17-.52-2.6-4.84-1.75-5.83.85-1 3.2 4.66 3.2 4.66s1.4 2.67.9 4.2c-1.59 4.7-4.91 3.02-4.91 3.02zm6.09-5.88c.13-.38 4.1.52 4.13.26.16-.93-3.57-3.8-3.57-3.8s-.86-1.64-.6-1.9c.25-.26 2.64.26 2.77-.09.13-.35-2.73-4.1-2.73-4.8 0-.69.77-.08.77-.08s2.26 2.33 3.45 4.23c1.2 1.9 2.31 3.46 1.92 6.48-.43 3.24-6.48.74-6.14-.3zm17.9-5.96s-.64-2.68-.26-3.03c.39-.34 1.41-.64 1.41-.64s-2.11-1.32-3.11-1.34c-1-.03-1.15-.32-1.4.1-.26.42 1.8 3.03 1.8 3.03l1.56 1.88z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M458.65 198.49s6.1 1.51 6.35 1.08c.25-.43-4.86-5.19-4.86-5.19s-.34-.86-.25-1.16c.08-.3 2.2-.35 2.85.17.64.52 0 1.51.21 1.9.21.4 2.13 3.33 2.48 2.85.34-.47-.4-4.06-.22-4.32.17-.26 2.34 2.03 2.94 2.42.6.4 4 3.07 4.34 1.82.35-1.25.56-1.47.43-2.2-.13-.74 1.14 3.45-.46 3.97-1.59.52-3.42-.56-3.42-.56l-1.4-1.08-.83-.87s.91 3.25-.15 3.59c-1.07.35-2.3.17-2.3.17l-2.56-.26-3.15-2.33zm13.99-4.16s6.5 3.9 7.14 3.21c.65-.69-1.7-9.85-1.32-10.8.3-.76 5.28 10.4 2.86 11.93-1.86 1.16-2.77.34-2.77.34l-3.2-1.68-2.71-3zm18.09 16.43s.59.44 1.42.67c.26.08 1.04.31.83.34-.22.01-1.74.2-1.85.24-.1.04-.4-1.25-.4-1.25zm-6.31-21.49s.62.35 1 .46c.39.11.88.35.88.41 0 .07-.48.27-.82.23-.34-.04-.56-.14-.56-.14l-.5-.96zm-1.87-3.2s.67.3 1.52-.3.9-1 .84-1.33c-.07-.31-1.4-.31-1.86-.62-.46-.3-.43-.85-.43-.85l-1.46-.02-.54.2 1.93 2.92zm5.74 18.86s1.99 1.17 2.55 1.28c.55.1 1.49.62 1.36.8-.13.17-1.6.3-2.34-.13-.75-.44-1-.17-1-.17l-.57-1.78zm-10.71-29.61.03.01c.11.03.48.13.8.1.38-.05.7-.28.82-.13.27.3.06 1.68-.48 2.07-.54.4-1.2.72-1.29.7-.1-.03-2.1-2.9-2.1-2.9l2.22.15zm-9.32-8.34s1.3-.08 1.95-.07c.65 0 1.4.47 2 .84.58.37 1.16 4.3.84 5.03-.31.75-4.7-2.54-4.81-2.83-.13-.3-2.03-3.24-2.03-3.24l2.05.27zm-4.11-1.78s3.19.2 2.9-1.83a4.21 4.21 0 0 0-1.76-2.91l-3.82 2.72 2.68 2.02zm-8.55-3.73s.85.47 1.8.1c.95-.37 3.46-3.63 5.28-4.03 1.83-.4 2.2-.37 2.54.05.34.42.17 2.28-.25 2.8-.4.51-5.72 2.76-5.72 2.76s-1.1-.07-1.96-.27c-.86-.2-1.74-.57-1.74-.57l.05-.84zm-.99-5.87c-.8-1.88-2.24-2.65-2.78-2.53-.53.13 1.83 2 2.17 4.6.34 2.59.31 4.33.27 4.48-.05.14 1.1.16 1.1.16l.21-.99.14-.7-.01-.64-.16-1.35-.28-1.05-.23-.81s-.02-.2-.43-1.17zm-7.55-2.68a20.19 20.19 0 0 0-7.17-4.88c-.3 0 5.15 3.28 6.39 5.4 1.23 2.12 1.27 4.97 1.83 5.36.55.39 1.06-.2 1.1-.26.05-.07.45-.65.39-.82a30.4 30.4 0 0 1-.34-1.36l-.85-1.43-.51-.89-.84-1.12zm-7.24-2.98c-3.1-2.72-8.7-4.02-13.23-4.08-4.54-.07-6.86.34-6.2 2.83.66 2.48 2.7 3.56 6.54 3.56s4.75-.4 6.82.24c2.07.65 3.96 1.81 4.7 2.6.75.77-1.42-1.9-3.38-3.38-1.96-1.47-3.25-2.24-3.25-2.24s-.37-.8 2.27-.44c2.64.37 6.17 2.08 7.13 4.28s.81 3.42.8 3.9c-.03.47.9-.27.9-.27l.4-1.08s.14-.86-.37-1.84c-.51-.97-.6-1.3-1.79-2.7-1.2-1.4-1.34-1.38-1.34-1.38zm-12.59 37.41c1.93-.06 6.25-3.74 6.88-8.87.62-5.13-2.56-15.56-3.3-16.65-.74-1.1 1.19-.52 2.24.57s3.21 8.53 3.21 13.95c0 5.41-1.08 6.97-3.97 9.73-2.9 2.77-5.23 2.48-5.23 2.48l.17-1.21zm6.71 15.22s.96 1.21 2.04.8c1.99-.74 5.06-2.2 5.06-5.06 0-1.85-2.39-3.46-2.5-4.15-.11-.7 0-1.27 0-1.27l2.1.46.6 2.94s.82.86 1.67.52c.86-.35 3.3-2.13 2.95-3.86-.33-1.73-2.66-3.86-2.89-4.73-.23-.86.06-1.61.06-1.61l1.99.34.6 2.53s.53.87 1.67.64c1.13-.23 3.12-2.3 2.67-3.28-.46-.98-1.93-3.29-2.05-3.52-.11-.23-.05-1.1-.05-1.1l.8.46s.76.3 2.3-.15c1.53-.46 3.02-1.5 3-2.55-.03-1.06-1.16-2.08-1.24-2.66-.09-.58-.02-.82-.02-.82l1 .15 1.23 1.53.3 1.84-.45 1.57-1.87 2.04-1.85.78-.51-.05 1.13 1.97-.37 2.61-1.64 1.51-2.2 1.32-.16 2.44-1.22 2.64-2.8 1.66h-.84l-.32 1.6-1.76 2.51-3.05 2.03-2.22.41-1.27-1.86.11-.63z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M450.74 174.88s5.1 1.44 4.94-1.79c-.09-1.81-5-5.99-5.3-6.68-.32-.7-.23-1.64-.23-1.64l2.54 2.32s3.24.78 4.16-1.1c.92-1.87.18-3.04.02-3.09-.16-.04.74-.16.74-.16l1.5.3-.18 2.9-1.66 7.25s.44 2.85-1.8 3.05c-2.25.2-4.73-1.36-4.73-1.36zm4.83 38.67s.09-1.47-1.05-2.5c-1.14-1.02-3.32-1.98-3.68-2.2-.35-.21 3.65 4.55 3.65 4.55l1.08.15zm7.39.24s-2.56-3.15-3.1-4.24c-.56-1.07-1.89-3.45-2.95-3.56-1.06-.11 1 3.93 1 3.93l4.15 3.78.9.09zm7-.07s-2.2-4.15-2.73-5.36c-.53-1.21-1.68-4.52-2.98-5.42-1.3-.91.17 1.5.17 1.5l1.39 4.3 2.43 3.75 1.72 1.23zm5.16-3.01s-.15-3.54-.58-6c-.42-2.47-2.34-4.52-2.47-4.43-.13.08.15 4.38.15 4.38l2.9 6.05zm10.65 2.67s-1.79-4.26-2.51-6.27c-.73-2-2.52-5.38-2.7-5.42-.2-.04.53 3.87.53 3.87l2.17 6.22 2.51 1.6zm9.24-11.15s-1.64-1.69-5.18-3.07c-3.53-1.38-7.07-1.53-7.07-1.53l.43.45 1.6 1.36 3.7 1.9 4.83 1.17 1.69-.28z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#202020",
    d: "M457.05 204.32s.03 3.08 1.62 4.96c1.59 1.87 5.34 5.3 6.08 5.99.74.69 1.36 4.5 2.47 7.66 1.1 3.17 1.36 5.77 1.84 6.66.49.89 1.48 2.33.74 2.19-.74-.15-1.42-1.01-1.87-2.16-.46-1.16-.32-1.16-.26-2.74.06-1.59-2.41-9.71-3.55-10.6-1.14-.9-6.36-5.25-8.38-8.24-2.01-3-1.59-3.7-1.59-3.7l2.9-.02z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#202020",
    d: "M465.48 224.63c-1.1-2.28-1.3-4.3-1.65-5.65-.34-1.35-4.74-5.04-5.8-5.53-.79-.37-2.45.1-3.11-.4-.67-.5-4.83-5.23-4.83-5.23s-.63.6-.43.76c.2.18 4.52 4.84 6.08 6.34 1.56 1.5 2.41 4.84 3.55 7.43 1.14 2.6.68 2.08.8 3.34.1 1.27.9 2 1.7 2 .8 0 1-.38.7-.6-.3-.21-1.93-2.11-2.86-4.58-.86-2.25-1.96-6.4-3.32-7.95l-.31-.35c.32-.04.86-.14 1.7-.18 1.05-.06 5.4 3.94 5.77 5.13.36 1.18-.04 1.64 1.78 5.59 1.82 3.94 2.67 4.86 2.67 4.86h.32s-1.65-2.7-2.76-4.98zm-6.83-26.14s3.15 1.99 4.09 2.25c.93.26 1.62.34 1.62.34s.47 5.75 2.77 9c2.3 3.23 4.17 4.4 4.17 4.4s.08 6.26 1.79 10.59c1.7 4.32 2.04 9.55 1.66 10.37-.38.82-1.83-2.55-2.77-5.53-.94-2.99-1.83-6.22-2.47-8.21-.64-2-2.39-4.98-3.36-5.8-.99-.82-.2-.73.38-.21.57.52 2.23 2.57 3.3 5.88 1.06 3.3 1.49 6.65 2.06 6.67.58.02 1.03-.54 1-1.2-.02-.67-.74-2.4-1.27-5.5-.53-3.08-1.07-5.2-1.58-6.07-.51-.86-1.26-1.01-3.23-4.47-1.99-3.46-2.86-5.38-3.2-6.98-.34-1.6.06-1.44-.28-1.68s-.6.02-2.1-.82c-1.52-.85-2.58-3.03-2.58-3.03zm8.17-1.17s1.93 1.5 3 1.96c1.09.46 2.65.54 2.65.54s-.4 5.45 1.74 9c2.12 3.54 4.34 5.61 4.34 5.61s.34 1.33 1.02 8.93c.68 7.61.71 7.75.91 10.8.2 3.06.3 13.88-.14 13.55-1.65-1.27-.29-7.15-1.1-9.57-.83-2.42-2.14-2.82-3.73-9.68-1.59-6.85-.57-8.41-1.7-10.97-1.14-2.57-2.64-2.8-2.64-2.8s2.1.4 2.98 2.57c.88 2.16 1.01 7.9 1.73 10.74 1.62 6.43 3.84 9.68 3.84 9.68s-.49-8.07-1.11-12.65c-.63-4.58-.6-8.4-1.45-10.16-.85-1.77-2.7-3.18-3.8-5.51-1.11-2.33-1.51-6.91-2.05-8.1-.54-1.18-.85-.8-1.62-1.12-2.5-1-2.87-2.82-2.87-2.82z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#202020",
    d: "M472.64 194.33s1.7 1.9 4.09 3.31c2.39 1.41 3.58.98 3.95 1.27.37.29-.49 5.13 2.01 9.6 2.5 4.46 3.41 4.55 3.47 5.15.05.6.5 13.77.82 18.24.31 4.46.65 19.44-1.2 19.44-1.84 0-.16-11.06-1.07-13.65-.91-2.6-.88-1.85-1.76-3.92-.88-2.08-.87-10.28-2.27-15.13-1.05-3.63-2.13-4.2-2.13-4.2s1.76.95 2.58 3.94c.82 3 1.08 13.06 2.05 14.67.96 1.61 2.35 3.6 2.67 5.1.3 1.5-.2-19.1-.63-20.34-.42-1.24-4.57-8.7-4.89-12.82-.3-4.12-.45-4.53-.82-4.84-.37-.32-1.56-.06-3.52-1.9a25.79 25.79 0 0 1-3.35-3.92zm9.37 2.37c.12-.4 1.3 2.21 5 3.69 3.71 1.46 7.25 1.2 7.72 1.6.47.38 2.81 5.96 2.9 13.39.08 7.43-1.29 6.74-2.43 13.14-1.15 6.4-1.2 19.4-1.92 21.39-.34.73-.73 1.03-1.11 2.29-.38 1.25.3 3.63-.85 3.67-1.15.04-1.28-1.81-1.28-2.8 0-1 1.2-4.54 1.2-8.09 0-3.54-.77-3.97-1.29-8.21-.5-4.23-.55-17.72-1.02-19.01-.47-1.3-2.78-4.1-2.78-4.1s2.49 1.59 3.08 3.4c.6 1.82.66 16.8 1.32 19.8.68 3.06.47-.7.73-2.42.25-1.73 1.15-9.08 1.02-13.01-.13-3.93-1.8-12.44-3.16-13.87 0 0 .71.82 1.5 2.7.01.05.5.54 1.05.86.6.34 1.27.52 1.29.58.02.04-.75-.07-1.35-.33-.45-.2-.78-.56-.76-.52.84 2.22 1.68 5.66 1.76 10.58.12 6.7-.97 21.44.1 21.6 1.06.18.85-8.03 1.95-14.68 1.1-6.66 2.6-7.61 2.13-13.06-.47-5.44-1.91-11.32-3.06-12.05-1.15-.74-4.43-.48-7.33-2.34-2.9-1.85-4.53-3.8-4.41-4.2z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#202020",
    d: "M435.05 204.2s1.07.47 2.3-.13c1.24-.6 4.52-3.2 4.52-4.28s.04-2.16.04-2.16.04.48.98.6c.94.14 3.62-1.9 3.83-3.19.22-1.3.22-3.59-.08-4.06-.3-.48.8.47 1.36-.05.56-.51 3.15-2.2 3.11-3.93-.04-1.73-1.45-3.33-1.45-3.33s1.28.18 2.05 0c.77-.17 3.32-1.68 3.24-3.24-.1-1.55-.98-3.93-2.99-4.1 0 0 1.5.34 2.94-.17 1.45-.52 1.96-1.34 1.96-2.99 0-1.64-2.94-5.18-3.45-5.48-.5-.3 3.15 1.03 4.1-.44.92-1.47 1.05-2.5.8-3.32-.26-.83-1.02-1.04-1.02-1.04s1.58.43 3.7-.65c2.14-1.08 4-2.5 4.99-2.46.98.04-3.11 2.2-3.33 3.41-.08.5 1.12 1.36 2.97 2.71.12.09.17.17.36.26.83.46 4.02.59 4.23.75.27.2-3.07.12-2.79.34a44.74 44.74 0 0 1 7.49 7.06c.1.12.62.58 1.23.75.75.21 1.6.15 1.7.29.09.1-2.15-.06-2.07.05 1.6 2.09 3.05 4.2 4.3 6.16.08.14.6.75 1.2 1 .65.29 1.39.22 1.48.37.16.26-1.83 0-1.67.26 2.48 4.09 4.33 7.89 4.33 7.89s-4.01-7.06-8.91-12.55c-4.9-5.49-6.05-6.22-6.3-5.7-.26.52 3.66 5.36 5.75 8.77 2.08 3.42 3.98 7.66 3.98 7.66s-4.92-10.2-11.82-16.48c-6.9-6.26-7.62-7.3-8.4-7.04-.76.26-1.35 4.88-.89 5.83.47.96 5.5 4.76 9.8 9.81 4.3 5.06 9.75 13.75 9.75 13.75s-3.87-6.27-10.43-13.23c-6.56-6.95-9.07-8.55-9.58-8.51-.52.04-.56 1.3-1.32 2.33-.77 1.04-2.35.91-2.4 1.39-.03.47 5.55 5.61 6.65 6.22 1.11.6 1.7.3 2.56.78.85.47 1.77 1.26 1.77 1.26s-1.17-.44-2.03-.7c-.85-.26-1.7-.3-1.7-.04 0 .25 4.52 5.78 5.28 6.13.77.35 1.2.17 2.22.56 1.02.4 2.47 1.43 2.47 1.43s-1.58-.9-2.69-1.12c-1.1-.22-1.57 0-1.53.3.04.3 3.45 4.67 3.28 4.75-.17.09-5.28-6.05-9.63-9.9-4.34-3.84-6.3-4.66-6.52-4.53-.2.13-.08 1.25-1.15 1.64-1.06.39-2.04.52-2.04.9 0 .4 3.92 4.07 6.69 7.14 2.77 3.07 5.15 5.96 5.15 5.96s-2.8-2.8-5.88-5.7c-3.06-2.9-4.64-4.02-4.94-3.85-.3.17-.34 1.64-.04 2.03.3.4 5.97 7.1 5.8 7.26-.18.18-6.7-8.03-7.12-8.03-.43 0-.68 1.03-1.1 1.5-.44.48-2.27.48-2.27 1.13 0 .65 9.2 9.68 8.95 9.9 0 0-7.62-6.57-7.88-6.18-.26.39 3.2 6.7 2.98 6.82-.21.14-4.47-6.6-4.86-6.56-.38.04-.34.77-1.44 1.77-1.11 1-2.52.56-2.56 1-.04.42 6.35 7.51 6.18 7.64-.17.13-6.48-6.74-6.65-6.35-.04.1-.38.4-.2 1 .46 1.65 1.88 4.66 1.7 4.92 0 0-2.05-4.2-2.6-4.02-.56.17-.56 1-1.5 1.6-.93.6-1.7.47-1.79.9-.08.44 1.11 1.17 1.63 2.17.5 1 .93 3.15.93 3.15s-.64-1.81-1.53-2.98c-.9-1.17-1.7-1.95-2.39-1.95-.68 0-1.15.65-1.15.65l-.64-1.51z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#202020",
    d: "M494.74 201.99s2.09-.13 2.34-.56c.26-.43-.77-.13-2.64-2.16-1.87-2.03-6.66-15.89-11.88-22.86-8.56-11.41-16.57-16.64-16.57-16.64s9.53 5.52 16.91 16.3c7.5 10.94 9.31 19.53 11.41 21.77 2.1 2.25 4.15 2.65 4.04 3.29-.12.63-.46 1.1-1.26 1.2-.79.12-2.72.3-2.72.3l.37-.64zm-62.97-3.02s.06.17.44.21c.4.05 2.98-2.53 2.84-3.28 0 0-1.15-.43-2.08-1.38-.94-.95-1.16-2.46-1.16-2.46s.86 1.68 1.58 2.16c.72.47 1.87.73 2.3.39.43-.35 4.24-3.17 4-4.28 0 0-1.19.04-2.3-.78-1.1-.82-1.3-2.51-1.3-2.51s.71 1.36 1.85 1.9c1.13.55 2.24.32 2.55-.08.31-.4 2.81-3.84 2.53-4.84 0 0-1.28.14-2.42-.66-1.13-.81-1.73-2.83-1.73-2.83s.82 1.7 2.27 1.99c1.45.29 2.64-.58 2.87-1.61.23-1.04 1.02-4.9-.2-5.88 0 0-1.87.6-3.2-.09-1.34-.69-1.82-2.39-1.82-2.39s1.13 1.56 2.63 1.76c1.51.2 2.17-.6 2.42-1.21.26-.6.31-2.8-.14-4-.45-1.22-1.4-1.13-1.62-2.94 0 0-.48.72-2.41.72-1.93 0-2.96-2.2-2.96-2.2s1.54 1.42 3.07 1.3c1.53-.11 2.1-1.38 2.13-2.36.03-.98-.77-1.84-1.2-2.85-.42-1.01-.45-2.22-.73-2.08-.29.15-.65 1.07-2.64.75-1.99-.31-2.42-1.67-2.42-1.67s1.45 1.01 2.56.92c1.11-.08 1.82-.6 1.82-1.35 0-.75-.43-2.13-2.93-4.27-2.5-2.13-4.54-3.6-4.54-3.6s3.24 1.8 5.34 3.55c2.1 1.76 3.29 3.46 3.29 3.46s2.3.75 2.56-.03c.25-.78.21-1.75-.51-3.14-.71-1.35-2.68-3.37-2.68-3.37s2.06 1.71 3.04 3.48.53 3 .62 3.44c.08.43 4.38 2.1 5.34 1.51.96-.58.51-1.84-.3-3.11l-1.47-2.34s1 1.1 1.73 2.36c.72 1.25 1.32 2.25 1.04 2.83-.27.58-.87.84-.8 1.08.06.24 1.48 1 2.93 1.75 1.45.76 3.13 1.43 3.35 1.02a6 6 0 0 0 .23-2.81c-.13-1.4-.93-3.55-.93-3.55s.95 2.08 1.12 3.55c.17 1.47-.19 2.57.15 3.09.34.52 1.4.65 1.4.65s-.85.6-2.74.04c-1.9-.56-10.03-4.67-10.42-4.28-.38.39 3.8 2.92 5.71 4.73 1.92 1.82 2.86 3.72 2.86 3.72s-1.5-1.26-2.94-2.05c-1.45-.8-5.8-3.03-6.07-2.73-.28.3 1.64.7 1.78 1.04.15.35-1.36 1.7-1.36 2.27 0 .56 6.2 4.86 6 5.34-.18.47-1.57 1.6-1.82 1.53-.26-.07-3.32-2.42-3.32-2.05 0 .37 1.76 1.86 1.74 2.18-.02.32-1.17 1.1-.96 1.84.22.73 3.46 3.39 3.43 4.3-.02.9-1.85 1.68-1.5 2.26.33.59 2 2.64 2 2.64s-1.8-1.19-2.37-1.81c-.58-.63-1.73-2-1.94-1.78-.21.22-1.36 2.75-1.26 3.31.11.56 1.56 1.43 1.84 2.96.27 1.53-.22 3.13-.33 3.13-.1 0-2.14-2.63-2.55-2.68-.4-.04-.91.13-1.26.8-.34.67-1.53 2.77-1.38 3.16.15.39 2.15.84 2.2 2.44a4.46 4.46 0 0 1-1.4 3.09c-.12 0-2.48-3.18-2.72-3.18-.23 0-2.92 2.99-2.98 3.35-.06.37 1.83 1.71 1.5 2.23-.35.52-1.63-.2-2.35.21-.73.42-2 .93-2.26.93-.25 0-.64-.86-.64-.86z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#202020",
    d: "M465.92 159.9s.21-.84.62-1.27c.4-.44 2.05-2.25 1.43-2.62-.62-.36-2.7.3-4.03.2-1.32-.11-2.19.21-6.02-2.97 0 0-12.16-8.5-31-9.59-5.96-.34-8.63 1.79-8.91 2.91-.03.26 1.56-2.42 7.55-2.33 2.64.03 21.6 1.56 31.44 9.27.51.4 3.77 3.53 6.81 3.18 3.05-.35 3.69-.7 3.63-.26-.07.43-1.03 1.56-1.24 2.07a12.1 12.1 0 0 0-.42 1.47l.14-.06zm-32.86 2.51-.05-.15c-.17-.52-1.38-2.21-3.44-4.13-2.47-2.29-10.14-5.49-10.53-5.62-.38-.13 7.88 3.8 10.19 6.01 3.7 3.54 3.83 3.89 3.83 3.89z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M433.04 175.94s-.5-.83-2.12-1.87-3.24-1.47-3.24-1.47l3.75.95a6.28 6.28 0 0 1 1.61 2.39zm-.97-7.05s-.51-.73-2.81-1.47c-2.3-.73-2.85-.7-2.85-.7s2.13-.9 3.74-.08a3.6 3.6 0 0 1 1.92 2.25zm-1.36-5.79s-.47-1.04-2.51-1.77c-2.05-.74-3.5-.87-3.5-.87s2.13-.6 4.18.22c2.04.82 1.83 2.42 1.83 2.42zm-2.47-3.72s-.6-.82-4.43-1.73c-3.84-.9-5.33-.95-5.33-.95s5.46-.43 6.9.18c1.45.6 2.86 2.5 2.86 2.5zm-7.03-4.02s-2.34-.65-4.6-.82c-2.26-.17-5.8.13-5.8.13s6.57-1.04 8.31-.65c1.75.39 2.09 1.34 2.09 1.34z"
  }))), _g11 || (_g11 = /*#__PURE__*/react.createElement("g", {
    fill: "#f8c83c",
    stroke: "#977c2e",
    strokeWidth: 0.35
  }, /*#__PURE__*/react.createElement("path", {
    d: "M399.63 236.56s1.16 2.05 3.46 2.13c2.3.09 4.1 3.37 4.1 3.37l-2.53 2.48-6.08.29-1.96-3.14 3.01-5.13zm.14-2.1c.2-.4-1.79-4.32-3.21-4.98-1.42-.66.48 1.27.17 2.07-.31.8-.52 1.8-.4 1.95.1.14 1.17 1.8.6 2.55-.57.75 2.84-1.59 2.84-1.59z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M398.68 240.44s1.08.54 1.93.29a4.15 4.15 0 0 0 1.61-1.12m-4.64-.69s3.41-2.48 3.13-3.8c-.29-1.33-.97-1.27-1.43-1.15-.45.11-2.55 1.84-2.66 2.24-.12.4.96 2.71.96 2.71z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M395.17 240.62s.62 1.64 1.73 1.64c1.11 0 2.7-.89 2.73-1.55.03-.67-1.11-1.88-1.85-2.22-.74-.34-2.44.55-2.44.55l-.17 1.58z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M398.27 238.38c-.17.51-2.33 1.52-3.04 1.58-.7.06-2.16-1.75-1.56-2.02.6-.25 1.34-.23 1.87-.51.54-.3.69-1.01 1-1.04.31-.03 1.2.2 1.42.75.23.55.48.72.31 1.24z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M396.05 239.81s-3.35 4.53-4.74 4.3c-1.4-.23.57-6.43.57-6.43s.54.35 1.64.7c1.11.34 2.22.74 2.53 1.43z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M390.09 236.59s4.32.75 4.52 1.44c.2.7-2.08 1.61-3.3 1.61-1.22 0-1.22-3.05-1.22-3.05z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#202220",
    d: "M379.35 243.13s.57 2.08 2.44 2.2c1.88.1 3.64-1.97 3.64-1.97l-4.43-1.73-1.65 1.5z",
    stroke: "none"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#4b4139",
    d: "m379.35 243.13-.1.03s.15.53.54 1.08a2.61 2.61 0 0 0 2 1.18l.16.01c1.88-.01 3.55-2 3.56-2l.09-.11-4.62-1.8-1.75 1.58.02.06.1-.03.07.08 1.6-1.46 4.37 1.7.04-.09-.08-.07-.28.3c-.55.55-1.82 1.63-3.12 1.63h-.15a2.4 2.4 0 0 1-1.85-1.1 3.72 3.72 0 0 1-.39-.7l-.08-.23-.03-.09-.1.03.07.08-.07-.08z",
    stroke: "none"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#202220",
    d: "M380.6 242.55s.74 1.56 3.18 1.62c2.44.05 4.37-1.96 4.37-1.96l-3.86-3.06-3.69 3.4z",
    stroke: "none"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#4b4139",
    d: "m380.6 242.55-.09.05c0 .01.78 1.61 3.27 1.67h.1c2.45 0 4.34-1.99 4.35-1.99l.08-.08-4.02-3.18-3.81 3.5.03.08.09-.05.07.08 3.63-3.34 3.8 3 .05-.08-.07-.08-.08.09c-.39.36-2.07 1.85-4.12 1.84h-.1a3.93 3.93 0 0 1-2.44-.8 2.89 2.89 0 0 1-.62-.7l-.03-.05-.09.04.07.08-.07-.08z",
    stroke: "none"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#4b4139",
    d: "M380.93 242.91s1.08.9 2.36.96c1.28.08 2.87-.33 2.87-.33l-1.47.53-1.05.12-1-.16-.89-.33-.7-.52-.12-.27z",
    stroke: "none"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#202220",
    d: "M383.78 240.76s1.08 2.65 3.35 2.36c2.27-.29 2.33-1.6 2.33-1.6l-2.56-3.7-3.12 2.94z",
    stroke: "none"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#4b4139",
    d: "m383.78 240.76-.1.04c0 .01.25.61.76 1.22.5.61 1.29 1.23 2.35 1.23.11 0 .23 0 .35-.02 1.16-.15 1.77-.56 2.08-.95.32-.4.34-.75.34-.76v-.04l-2.64-3.81-3.26 3.06.03.07.09-.04.07.08 3.04-2.86 2.49 3.6.08-.07h-.1v.04c-.05.23-.29 1.21-2.24 1.47-.12.02-.23.02-.33.02-.98 0-1.7-.57-2.2-1.15a5.23 5.23 0 0 1-.54-.8l-.13-.27-.04-.1-.1.04.07.08-.07-.08z",
    stroke: "none"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#4b4139",
    d: "M384.1 241.28s1.36 1.66 2.56 1.63c1.19-.03 1.94-.48 1.94-.48l.06.2-.63.3-1.08.23-1.1-.15-.91-.55-.84-1.18zm-4.31 2.66s1.05 1.08 2.02 1.12c.96.05 2.44-.78 2.44-.78l.18-.05-.25.23-1 .54-1.2.35-.95-.17-.73-.45-.44-.56-.07-.23z",
    stroke: "none"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M389.83 236.36c1.02-.14 3.15 2.77 3.15 4.2 0 1.45-.62 3.6-1.67 3.55-1.06-.06-3.44-2.19-3.98-3.28-.54-1.1-1.08-1.85-.68-2.43.4-.57 3.18-2.04 3.18-2.04zm-10.59.26s-1.7-1.32-2.39-.63c-.68.69-.45 3 0 3.45.46.47 2.5-1.1 2.5-1.1l-.11-1.72z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M379.01 238.23s-2.27.23-2.27 1.27 1.08 2.13 1.3 2.36c.23.23 2.28-.92 2.28-.92l-1.31-2.71z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M379.92 240.13s-2.33.7-2.33 1.5 1.02 2.3 1.76 2.3 1.3-1.44 1.59-1.73c.29-.29-1.02-2.07-1.02-2.07zm1.14-6.74s-.45-.63-1.42-.23-2.05 1.38-1.87 2.94c.17 1.55.73 2.6.73 2.6l3.53-1.22-.97-4.09z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M381.34 236.1s-3 .98-3.12 2.13c-.12 1.15.68 2.3 1.47 2.53.8.24 3.35-2.24 3.35-2.24l-1.7-2.42z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M383.95 240.89s-2.95 1.95-3.35 1.95c-.4 0-1.48-1.55-1.25-2.59.23-1.03 2.21-1.78 3-2.07.8-.3 1.6 2.71 1.6 2.71zm2.59-10.72s-.94-.78-2.73-.65-3.1 2.46-3.32 3.63c-.21 1.17-.04 3.37.64 3.72.68.34 4.39-2.64 4.39-2.64l1.02-4.06z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M382.92 239.02c-1.24-.13-2.34-1.9-2.13-2.98.21-1.08 2.64-2.94 3.92-2.72 1.28.21 1.02 3.41 1.02 3.41s-1.58 2.42-2.81 2.29z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M386.85 238.75s-.62 1.44-1.87 2.08c-1.25.63-2 .1-2.73-.93-.74-1.03.34-1.5.9-2.02.58-.51 2.22-.92 2.22-.92l1.48 1.79z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M384.86 234.95s-1.4 1.12-.6 2.42c.8 1.3 1.42 1.76 2.42 1.93 1 .17 1.64-.23 2.44-1.18s1.96-1.38 1.85-2.57c-.12-1.18-.57-2.1-1.28-2.45-.71-.34-2.87.03-4.83 1.85z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#202220",
    d: "M388.82 229.39s-1.44-.55-2.54.1a4.04 4.04 0 0 0-1.92 3.17c-.04 1.22.22 2.91.22 2.91s1.52-.43 2.5-1.25c.97-.82 1.3-1.05 1.16-1.47-.08-.26-.48-.54-.48-1.56 0-1.77 1.06-1.9 1.06-1.9z",
    stroke: "none"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#4b4139",
    d: "M388.82 229.39s-1.66-.28-2.49.26a4.22 4.22 0 0 0-1.83 2.42c-.3 1.08-.09 1.36-.09 1.36s-.15-.94.14-1.84c.34-1.03 1.19-2.06 2.01-2.3 1.01-.3 2.26.1 2.26.1z",
    stroke: "none"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M431.58 260.88s1.2-.5 2.03-.96c.83-.46 2.62-1.62 2.62-1.62l.58 2.98-2.3 1.77-2 .02-1.22-.88.29-1.31z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M428.37 261.18s.03.04 1.43.07c1.4.04 1.53-.49 1.78-.37s.64 1.61.64 1.61l-.51.94-2.01 1.14-1.7-.93-.14-2.35.51-.11zm15.95-.96s-.4-.67-1.2-1.36l-2.84-2.48-.01 6.47 2.98-.07 1.42-2-.35-.56z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M428.37 261.18s-.44-.65-1.7-.52c-1.26.14-2.6 1.17-2.73 2.04-.14.87 0 3.4.68 3.88s1.53.72 2.9.38c1.36-.35 8.31-4.64 8.31-4.64l-1.77.39c-.95.2-1.84-.22-1.84-.22s-.95 1.08-2.04 1.25c-1.1.17-1.4-.52-1.6-1.03-.21-.52-.21-1.53-.21-1.53z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M433.01 263.42s-1.02.4-1.41.67c-.38.28-1.76.77-1.76.77l.53 2.1 2.96.76 1.85-1.53.02-2.12-2.19-.65zm13.76-1.49s-.47-.43-1.02-1.06c-.55-.62-1.24-.75-1.43-.65-.2.11-1.6 1.92-1.6 1.92l-.1 1.37 1.64.89 1.15.2 1.51-.99-.15-1.68z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M436.61 260.89s-1.32.6-1.96 1.14c-.64.55-1.64 1.15-1.64 1.39 0 .23 1.5 1.78 1.5 1.78l1.5.12 3.28-2.3-.21-2.09-2.47-.04zm12.46 2.72s-.25-.52-.76-1c-.52-.47-1.15-.73-1.54-.68-.38.04-1.66 1.94-1.66 1.94l-.16.54 1.18 1.37 2.1.51 1.45-1.46-.61-1.22z"
  }), /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m443.66 265.9 1.5.26s-.05.39.38.74c.42.34.47.08.47.08s.21 1.43 1.78 2.64c0 0 1.84.6 2.77.08.94-.52.81.16.81.16l2.64-3.27s0-.65-.64-.69c0 0 .47-2.03-1.23-2.46-1.7-.44-3.07.17-3.07.17s-1.3 2.4-2.08 2.07a3.1 3.1 0 0 1-.94-.64c-.72-.78-.94-1.17-.94-1.17s-.55.17-1.2-.26c-.63-.43-1.18-1.47-1.18-1.47s-.98-.17-1.32-.52c-.34-.34-.7-1.03-.7-1.03l-2.44 1.76s-.07.77-1.5 1.8c-1.41 1.05-2.26 1.05-2.26 1.05s-.4 2.13-2 1.78c-1.58-.34-2.66-2.13-2.66-2.13s-1.14-.17-1.88.8c-.74.99-1.08 1.33-1.08 2.31s.63 2.36 1.14 2.82c.51.46 2.1 1.73 3.97.75 1.88-.98 1.26-2.59 1.26-2.59s-.06.12 1.07-.63c1.14-.75 2.39-1.9 3.24-2.25"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m440.75 252.87.01 4.18s.51 3.72-.3 4.88c-.8 1.17-3.75.91-4.17-.08-.43-1-.21-4.24-.21-4.24l4.67-4.74z"
  }), /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M437.45 265.54s-.63 1.1 1.3 1.27c.56.04.92-.15 1.17-.43.5-.58.39-1.06.39-1.06s-.17 1.54 1.57 1.6c1.93.07 1.76-1.78 1.76-1.78"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#202220",
    d: "M421.55 268.97s-1.08-1.82.2-2.48c1.28-.66 1.96.03 2.72.06.77.03.52-1.97.35-2.37a4.88 4.88 0 0 0-.88-1.49c-.32-.23-4.54.2-4.5 3.03.02 2.72 2.11 3.25 2.11 3.25zm6.62 6.77s-1.36-1.93-.62-3.08c.74-1.16 1.3-.46 1.67-.5.37-.02.54-.86-.08-2.12-.63-1.27-1.4-1.9-1.85-1.97-.46-.05-3 1.82-2.5 4.21a4.56 4.56 0 0 0 3.38 3.46zm23.83-2.33s4.6 1.93 4.91-2.7c.17-2.49-2.04-4.2-2.75-4.18-.49 0-.85.28-1.68 1.26-.82.98-1.45 1.7-1.1 2.08.33.37 1.7-.4 2.3 1.06 1.02 2.51-1.68 2.48-1.68 2.48z",
    stroke: "none"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#4b4139",
    d: "M428.17 275.74s-3.58-.79-3.55-4.29c.02-2.33 2.62-3.37 2.62-3.37s-2.4 1.28-2.45 3.33c-.07 3.56 3.38 4.33 3.38 4.33zm-6.57-6.77s-2.06-.46-2.29-3.43c-.22-2.97 4.68-2.85 4.68-2.85s-4.7.23-4.46 3.07c.26 2.94 2.07 3.21 2.07 3.21zm30.4 4.44s.92.45 1.98.4c1.05-.04 2.31-.31 2.75-2.07.44-1.76.26-2.59-.9-4.14-.81-1.08-1.56-1.06-1.56-1.06s.8.16 1.42 1.14c.62.98 1.53 2.07.9 4.05-.62 1.97-2.52 2.01-3.21 1.95-.7-.05-1.38-.27-1.38-.27z",
    stroke: "none"
  }))), _g12 || (_g12 = /*#__PURE__*/react.createElement("g", {
    fill: "#4d2a15"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#904720",
    d: "m397.2 176.12-.86-.18.62-1.44 2.42-.89 2.4-.1 2.55-.1 1.17.81 1.3 3.01-4.81 2.87-.78.26-.3-1.19-.74-1.94z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#202020",
    d: "m442.21 245.84-.3-7.22-19.47 6 7.71 7.22z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#d2a567",
    d: "m406.16 233.27-1.64-1.28s-1.17-.83-1.83-1.04c-.65-.2-1.49-.04-1.49-.04l-.27.39.26.66 1.78 2.07 2.96 1.53c.07.03 1.05 1.01 1.05 1.01l.68.3-1.5-3.6zm-.46 3.06 1.11.15 1.11 1.27.69 1.36.9 1.8.3 1.04-2.18-.48-6.3-1.95.54-1.5 1.1-1.01.92-.4 1.28-.2z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#d2a567",
    d: "m409.8 241.52 1.04-.09.7-.6-.33-2.36.39-7.56-5.12-6.06-1.05 3.5 1.5 6.12 1.11 3.67z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#ab6d29",
    d: "M406.13 227.69s-.34.63.09 2.62c.42 1.98 1.16 6.43 2.92 9.45 1.76 3.02-1.7-2.39-1.7-2.39s-2.73-6.14-2.3-10.78c.42-4.63.99 1.1.99 1.1z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#ab6d29",
    d: "M409.85 231.52s-1.1 1.44-1.28 2.5c-.17 1.07.09 2.89.09 2.89s-.17-1.38.96-1.7c1.14-.32 1 3.11 1.05 3.43.06.31.66-6.14.66-6.14l-1.48-.98zm.57 12.67-5.77-1.32c-2.98-1.33-4.55-2.37-4.5-3.09.06-.72 5.3.18 6.06.35.77.17 3.12 1.35 3.12 1.35h1.34l2.45-1.08.34 2.6-3.04 1.19zm-9.63-1.09s1.42 1 .74 1.44c-.68.43-2.5.49-3.07.35-.57-.15 5.57 1.35 5.57 1.35s1.19-1.01 1.1-1.07c-.08-.06-4.34-2.07-4.34-2.07z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#d2a567",
    d: "M399.27 241.58c.21-.35.38.8 2.37 1.07 2 .25 2.9-.35 2.9-.35l.88.58 1.05.23-.97 1.44-3.63-1.07-1.96-1.1-.64-.8z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#ab6d29",
    d: "m412.22 238.97 1.02 1.47.64-3.2-.04-3.33-2.09-1.38z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m406.47 233.58-1.7-2.85-2.22-4.06 1.36-2.34 1.67 2.42s-.47 1.64-.17 3.2c.3 1.56 1.06 3.63 1.06 3.63z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#d2a567",
    d: "M394.8 243.95s.74-1.23 2.47-1.37c1.73-.15 3.12.23 3.12.23l3.52 1.84.72 1.16-6.65-.9-3.18-.96z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8f4620",
    d: "M412.09 232.2s.13 3.97.25 5.23c.13 1.25.9 2.46.77 2.98s-.38.78-1.24 1.08c-.85.3-2.55 0-2.55 0s1.66-.22 1.75-.56c.08-.35-.51-1.86-.6-3.24-.09-1.39.09-2.9-.38-2.9s-.98.6-1.07.78c-.08.17.47-4.93 1.02-5.49.56-.56 2.05 2.12 2.05 2.12z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#ab6d29",
    d: "M399.94 242.64s-.68-.63-.67-1.07c.02-.43.8 2.09 4.45 1.95 3.65-.14 3.43-.2 3.43-.2h1.7s-.37 1.58-.67 1.72c-.3.15-2.84 1.86-2.89 1.9l-.9.5.07-.25-.17.01-.3-2.8-3.15-1.21-.9-.55z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8f4620",
    d: "M406.47 233.58s-4.22-4.37-5.62-7.26c-1.4-2.9-.56-6.87-.56-6.87l3.97 5.18s-.52 1-.35 2.64c.17 1.64 2.56 6.31 2.56 6.31z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#ab6d29",
    d: "M403.77 249.48c-.14-.3-.3-1.26.51-2.28 2.5-3.12 8.85-5.37 8.85-5.37v3.83l-8.13 3.9-1.23-.08z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8f4620",
    d: "M404.25 246.59c.35-.25 1.77-1.3 1.82-1.76.06-.52-.96-.6-2.8-.98-1.85-.37-3.36-1.2-3.36-1.2s2.27 1.75 3.15 2.1c.88.34.8.69.69.92-.12.23.45.96.5.92zm10.89.89s-1.17-1.75-1.55-2.82c-.37-1.07-.39-2.8-.46-2.82-.07-.02-.78.57-1.3.81-.54.24-2.41.85-2.51.92-.1.07 2.58-.06 2.57.88-.02.93-3.87 1.33-3.89 1.4-.01.07 3.1-.69 2.92.07-.2.76-1.57.83-3.24 1.52-1.67.7-2.4 1.04-3.02 1.4-.62.35-.92.63-.92.63s.75.42 1.93.38c1.18-.05 3.8-.7 3.8-.7l5.03-1.9.64.23z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#ab6d29",
    d: "M415.14 247.48s-1.4-.49-2.4-6.35c-1-5.85-.7-7.43-.7-7.43l2.36 1.66 2.12 3.86-1.38 8.26z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8f4620",
    d: "M415.9 237.74s-1.1 3.28-1.1 5.19c0 1.9-.2 3.19.34 4.54.55 1.35 2.4 3.03 2.4 3.03l.86-.9.38-2.65.22-4.4-3.1-4.81z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#202020",
    d: "M419.23 242.2s.54 8.27-1.56 8.5c-1 .1-2.5-3.12-2.53-3.23-.02-.1 1.82 3 2.51 2.72 1.32-.54.92-8.6.92-8.6l.66.61zm-4.09 5.28s-.35-.15-.93-1.1c-.57-.93-.07.84-4.48 2.4-4.4 1.55-5.98.69-5.98.69s1.46 1.14 5.91-.16c4.46-1.3 4.05-1.57 4.65-1.7.6-.13.83-.13.83-.13z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#ab6d29",
    d: "M406.94 236.95s.7.6 1.49 2.2l1.36 2.74.2-.2s-.54-1.55-1.28-2.77c-.73-1.2-2.87-4.14-2.87-4.14l1.1 2.17z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8f4620",
    d: "M404.26 247.21s.45-1.55 0-1.83c-.46-.3-.88.02-3.89-.35-3.01-.38-5.57-1.08-5.57-1.08s2.05 1.25 4 1.77c1.97.52 4.52 1.1 4.52 1.1l.68.11.26.28z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#202020",
    d: "M404.26 247.21s.06-.36-.28-.74c-.34-.36-.96.18-4.6-.84-3.64-1-4.58-1.68-4.58-1.68s1.3 1.14 4.52 1.97c3.21.82 4.94 1.29 4.94 1.29z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#ab6d29",
    d: "M405.9 236.32s-2.76.15-3.64.86c-.89.71-2.1 2.6-2.1 2.6l1.79.21s-.22-1.66.63-2.5c.85-.83 2.14-.9 3.32-1.17z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8f4620",
    d: "M400.68 231.08s1.1 1.47 2.26 1.99c1.15.52 2.3.95 2.85 1.5.55.57 1.15 2.38 1.15 2.38s-3.96-1.76-4.72-2.63c-.77-.87-1.54-3.24-1.54-3.24z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8f4620",
    d: "M404.52 231.99s-.36-.6-1.45-1.09c-1.08-.5-1.88-.42-2.2-.2-.3.23-.2.38-.2.38l1.45 2.18.81-.2s-2.15-1.35-1.65-1.78c1.06-.9 3.24.71 3.24.71z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#202020",
    d: "m415.2 227 22.17-11.45 10.5 14.6-19.17 5.14-10.14.87-4.94-3.58z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m444.93 233.26 27.64 23.94-3.06 2.1-6.48-1.84-13.46-13.3-4.98-5.02z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M480.33 252.46s-6.87-5.41-15.79-12.04c-8.92-6.63-19.95-14.98-19.95-14.98l.51 7.14 22.82 20.98 7.53 3.62 3.8-1.15 1.93-2.01-.85-1.56z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#803f1d",
    d: "M444.85 235.53s7.96 8.99 14.02 13.57c6.04 4.58 11.84 9.59 13.03 8.9 1.19-.7.76-1.47.76-1.47l-27.98-22.82.17 1.82z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m464.4 258.5-2.81 2.19-3.24-1.32-17-17.38.86-3.2 2.38.35z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#202020",
    d: "M480.33 252.46s-2.08 4.91-6.51 3.76c-4.43-1.15-28.83-24.33-28.83-24.33l-.06 2.42s24.73 22.65 29.5 23.57c4.77.92 8.68-3.22 8.18-3.69-.34-.31-2.28-1.73-2.28-1.73z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#803f1d",
    d: "M442.12 239.16s7.88 10.11 12.06 13.83c4.17 3.72 7.75 6.65 9.45 6.3 1.7-.34-1.02-2.24-1.02-2.24l-11.93-11.75-6.09-6.14s-2.38-.95-2.47 0z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#202020",
    d: "M444.08 239.16s20.01 20.4 21.6 20.86c3.35.98 8.12-2.48 8.12-2.48l-1.76-1.04-.23.64s-.85 2.07-5.17 1.15c-4.32-.92-21.88-19.82-21.88-19.82l-.68.69z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m451.62 258.68-7.28-8.38-1.62-2.77-.43-3.55 14.53 14.61-2.05 1.38-1.79-.6z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#202020",
    d: "M464.78 258.97s-1.76 2.6-4.15 2.07a7.04 7.04 0 0 1-3.75-2.24l-13.93-13.64-.34-2.08s15.28 16.17 18.02 16.88c1.99.52 3.47-1.9 3.47-1.9l.68.92z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#202020",
    d: "M457.05 258.51s-.68 2.02-2.72 1.73c-2.05-.29-2.68-1.1-2.68-1.1L443.12 249l-.17-2.7s8.87 12.27 10.92 12.96c2.05.7 2.56-1.38 2.56-1.38l.62.63z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#b07229",
    d: "M447.93 231.92s8.26 7.09 8.95 7.43c.68.35 3.57.44 3.74.87.17.43-1.87 0-2.04.43-.17.43 4.17 3.98 4.86 4.06.68.09 4.17.09 4.09.52-.09.44-2.39 0-2.47.52-.09.52 3.75 3.54 4.43 3.63.68.09 5.1.09 5.1.52 0 .43-3.57-.09-3.48.69.08.78 6.04 4.5 5.79 5.01-.26.52-7.16-4.67-7.33-4.4-.17.25-.42 1.9-.85 2.15-.43.26 0-2.16-.35-3.2-.34-1.03-4.34-4.06-4.76-3.7-.43.34-.09 2.15-.51 2.15-.43 0 .08-2.25-.35-3.02-.42-.78-4.17-3.9-4.68-3.9-.51 0-.17 1.65-.51 1.9-.35.27-.26-1.9-.77-2.59-.5-.68-9.2-8.55-8.86-9.07z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M433.76 254.86s.07 3.13-1.34 3.59c-1.4.45-4.07-5.75-4.07-5.75l-.62-5.79 4.14 3.84 1.89 4.11zm11.08-1.59s.06-.92-.05-1.67c-.1-.76-.34-1.9-.34-1.9l-.27-3.22-.77-2.16-.62-1.37-.9.07-2.17 1.54-.74 2.1 1.15 3.9 1.06 3.57 1.62.52 2.03-1.38z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M441.99 258.74c.49-.15-.45-4.44-.45-4.44l-2.56-6.34-.68-2.24-2.07-.78-1.37 1.56.32 2.5s1.98 4.18 2.95 5.65c.97 1.47 3.01 4.35 3.86 4.09z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#202020",
    d: "M439.7 245.29c.74.52 1.6 2.22 1.79 3.37 0 0 1.7 4.66 1.48 5.13-.23.46-1.25.52-1.25.52s2.27 2.36 2.95 2.07c.68-.29.4-2.6.17-3.11-.23-.52-.97-.17-1.25-.7a20.2 20.2 0 0 1-1.2-5.47c-.05-1.84-.1-3.1.12-3.57.23-.46 1.93 3.86 1.93 6.17l.74.86s-.45-3.17-.74-4.15c-.28-.98-.9-2.65-.9-3 0-.34.34-1.15.34-1.95s-.06-1.33-.06-1.33.9.63 1.25.58c.34-.06.85-.52 1.08-2.54.22-2.01-.23-7.88-.23-7.88l-8.86 11.69 2.64 3.31z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#202020",
    d: "M439.7 244.28s-.34 3.14.82 6.37c1.17 3.22 1.48 3.34 1.7 3.8.23.46.21 3.86-.22 4.3 0 0-2.27-5.8-3.03-8.65-.77-2.85-.97-3.95-1.37-4.18-.4-.23-1.05-.29-1.05-.29l3.15-1.35z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M438.86 261c.25-.05.1-1.33.1-1.33l-.37-3.03-3.11-6.38-3.41-3.07-1.79-2.77-.25 5.28s2.47 5.27 4.09 6.78c1.61 1.51 4.29 4.63 4.74 4.52z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#202020",
    d: "M426.13 246.61s.53 1.41.53 2.34v1.79s1.25 2.53 2.39 4.55c1.14 2.01 2.21 4.09 3.18 3.63.97-.46 1.3-1.96 1.36-2.14.06-.17-1.08 1.73-1.65 1.44-.56-.28-3.12-8.52-3.06-8.7.06-.17-.68-.51-1.25-1.09-.57-.58-1.5-1.82-1.5-1.82zm9.28 7.18s-1.76-2.88-2.33-4.15c-.57-1.27-1.54-2.25-1.82-2.25s-.65-2.58-.65-2.58.93 1.72 2.13 2.3c1.2.57 1.93 1.03 2.5.8 0 0 .34 1.33.34 2.65s-.17 3.23-.17 3.23z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#5c3a1d",
    d: "M429.73 249.55s.6 1.81 1.76 3.54c1.16 1.73 3.07 3.8 3.07 3.8s-2.1-2.07-3.21-3.68c-1.1-1.62-1.85-3.72-1.85-3.72l.23.06z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#202020",
    d: "M435.8 247.4s.56-1.57 1.05-1.64c.49-.08 1.51-.38 1.51-.38s-.88-.22-1.58-1.04c-.74-.88-.9-.81-1.71-1.74 0 0 .45 1.74.6 2.56.13.82.13 2.24.13 2.24zm-.56.51s2.53 5.41 3.18 7.23c.65 1.82.54 4.53.54 4.53s-.32-1.93-.88-3.52c-.57-1.58-2.87-6-3.07-6.5-.2-.53.23-1.74.23-1.74z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m438.68 244.39.6-7.96-.6-2.8-3.58-7.95s-.17 1.16-1.07 1.12c-.89-.05-3.27-1.3-4.09-2.38 0 0 .47 1.86.3 3.63-.17 1.77-.46 2.72-.46 2.72l6.9 12.97 2 .65z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8b441f",
    d: "M424.96 249.61s1.08 1.3 1.7 1.13c.63-.18.4-2.66-.4-4.04s-9.2-12.62-10.45-13.3c-1.24-.7 9.15 16.21 9.15 16.21z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8b441f",
    stroke: "#5c3a1d",
    strokeWidth: 0.07,
    d: "M430.7 244.97c.17.52.77 4.1-.68 4.44-2 .46-11.24-12.3-12.67-14.05 0 0-5.8-3.63-5.91-4.55-.12-.92 6.25 1.25 6.25 1.25l12.38 11.84s.46.55.63 1.07z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#202020",
    d: "M424.96 249.61s-1.02-1.81-1.11-3.1c-.08-1.3-.51-2-.6-2.43-.08-.43-6.81-10.2-7.5-10.8-.67-.6-2.97-1.9-2.97-1.9s.26 1.55.26 2.24c0 .7.08.89.08.89s2.13 4.04 5.2 7.59c3.06 3.54 6.64 7.51 6.64 7.51z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M435.24 247.91c.9-.52.5-3.63.17-4.61-.34-.98-5.85-12.44-5.85-12.44l-1.65.63-3.12-2.45-1.76-1.9s.62 2.74.56 4.07c-.05 1.32-.1 2.12-.1 2.12l4.36 7.67 7.39 6.91zm6.19-6.91 1.31-1.73-.68-5.7-3.64-12.44s-.9.22-1.82-.35c-.9-.58-1.84-1.67-1.84-1.67l.88 7.43 3.75 10.43.23 3.11 1.81.92z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#202020",
    d: "M430.07 243.91s-3.66-3.98-4.86-5.96c-1.2-2-2.21-3.9-2.21-3.9s-1.02.44-2.3-.08c-1.28-.52-2.98-2.33-2.98-2.33s-1.02 1.98 4.26 7.34c6.05 6.14 8.09 4.93 8.09 4.93z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8b441f",
    d: "M438.89 245.25c1.54-.62 1.5-7.09.05-11.45-1.46-4.37-3.84-8.13-3.84-8.13s2.98 7 3.62 9.86c.64 2.85 0 4.88-.51 4.7-.51-.17-.51-1.68-1.7-4.45-1.2-2.76-2-3.45-2-3.45s4.21 11.54 3.02 11.32c-1.2-.22-7.07-13-7.33-13.35-.26-.35-.42.47-.42.47s5.23 16.03 9.11 14.48z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m442.31 214.09 2.59 5.5.82 5.8.2 4.9s.17 9.67-1.02 9.9c-1.2.23-1.76-.92-1.82-1.15-.06-.23-2.22-10.9-2.22-10.9l-2.27-11.11.8-.78.28-1.64 1.76-.12.88-.4z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8b441f",
    d: "M435.24 247.91c1.03-.14 0-2.76 0-2.76s-.85 1.26-1.54.4c-.68-.86-1.76-4.06-1.76-4.06l-.68-1.93s-.74 2.13-1.7 2.13c-.97 0-5.97-8.47-5.97-8.47l-.6.83s7.05 14.58 12.25 13.86z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#202020",
    d: "M431.94 241.49s.85-2.07.51-3.97c-.34-1.9-2.9-6.66-2.9-6.66s-.76.18-1.78-.17-2.98-1.64-2.98-1.64 1.36 3.54 2.9 6.13c1.53 2.6 4.25 6.31 4.25 6.31zm4.09-2.94s-.64-4.5-2.68-8.65c-2.05-4.14-3.41-5.49-3.41-5.49s.17.91.13 2.6c-.04 1.68 0 2.03 0 2.03s1.87.7 3.28 3.2c1.4 2.5 2.68 6.31 2.68 6.31zm5.57-7.69s-.28-4.84-1.05-7.61c-.77-2.76-1.57-6.44-1.57-6.44s.1-.37.42-.56c.19-.12.47-.17.85-.04 1.02.34 1.45 2.9 1.45 2.9s-.13-3.94-.21-4.11c-.08-.17-.35-.65-.35-.65s-.33.17-.8.13l-1.03-.13s.32 1.2-.19 1.77c-.37.41-.72-.37-.93-.47-.08-.04-.2.56-.2.56s.39 1.38.47 2.6c.09 1.2-.12 2.2-.12 2.2s.75 2.89 1.56 4.66c.8 1.77 1.7 5.19 1.7 5.19zm4.32-.56s.85-6.96-.72-11.4c-1.58-4.46-2.9-5.63-2.9-5.63l-.72.87s2.37 3.78 3.06 7.3c.73 3.67 1.28 8.86 1.28 8.86zm-6.99 3.5s-.77-5.44-1.75-8.94c-.98-3.5-1.26-4.76-1.26-4.76l-1.49-1.38s.88 3.71.8 4.8l-.18 1.81s.73 1.86 1.7 3.41c.98 1.56 2.18 5.06 2.18 5.06z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#904720",
    d: "M442.57 242.44c1.39.04.17-7.83-.4-9.85-.57-2.01-3.8-11.48-3.8-11.48s3.89 13.46 3.57 14.13c-.46 1-1.98-4.09-2.26-4.03-.29.05 2.89 9.1 1.75 9.22-1.13.11-1.7-1.9-1.7-1.9l.11 1.96s.74 1.9 2.73 1.95z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#904720",
    d: "M444.27 238.46c.95 0-.27-7.43-.94-10.72-.68-3.28-2.58-9.85-2.58-9.85s1.93 4.55 3 9.8c1.08 5.24 1.82 11.98.8 12.1-1.02.11-1.53-.99-1.53-.99l-.17-1.2s.45.86 1.42.86z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#312317",
    d: "M431.48 247.19c.15.53.12 3.08-1.23 2.9-1.36-.19-3.83-2.47-4.34-3.97 0 0 2.94 3.25 3.95 3.23 1.01-.02 1-3.35.84-4.22-.17-.86.78 2.06.78 2.06z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#d2a567",
    d: "M438.55 211.8s1.75 1.12 3.15.3a5.16 5.16 0 0 0 2.3-3.89c-.04-1.08-.08-2.03-.94-3.15-.85-1.13 1.37.95 1.33 3.02-.05 2.08.12 5.66-3.2 6.44-3.32.78-1.87-.17-1.87-.17l-.77-2.55z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8f4620",
    d: "M435.92 205.45s2.1 3.44 2.9 6.53c.81 3.09.66 4.27.15 4.34-.5.06-.7-.37-.83-1.14-.12-.79-2.22-9.73-2.22-9.73z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#1e2121",
    d: "m399.14 209.67 13.88 20.14 17.39-19.62-11-11.32z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m416.69 197.31-.8 3.16 1.7 5.35 2.9 2.99 3.35 2.24.77-2.5.81-2.94.85-.3 2.13.82 1.41-2.03 2.26-4.07-.47-1.57-.54-1.12-3.52-6.13-1.18 2.32-1.1.67-2.06-1.17-2.47 3.24-3.02-1.4z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#5c3818",
    d: "M423.85 211.06s.6-.43.86-2.03c.25-1.6.3-6.48-.13-8.43-.43-1.94-1.7-5.79-1.96-5.48-.26.3 2 4.23 1.66 9.03-.34 4.8-.17 6.14-1.2 6.61-1.02.47.77.3.77.3z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#5c3818",
    d: "M424.66 202.98s2.3 3.28 3.41 2.12c1.1-1.17.55-5.36-.17-7a49.94 49.94 0 0 1-1.5-4.02l.7-.7s.76 2.77 1.18 4.5c.43 1.73 1.7 6.83.17 7.74-1.53.9-3.75-1.86-3.75-1.86l-.04-.78z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8f4620",
    d: "M417.23 205.24s.77-1.12 1.82-1.24c1.05-.11 1.25.35 1.25.35l.94 2.7 1.56 2.8 1.39 1.38-.83.78-1.1.2s-3.3-1.73-3.35-1.84c-.06-.12-.91-1.21-.91-1.21l-.77-3.92z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#d2a567",
    d: "M422.69 233.84c-1.08.56-3.57-.68-4.98-1.92-1.4-1.24-8.82-8.8-8.82-8.8l-1.03-4.2 2.86.79 5.03-2.16.94-1.78 6.05-3.15 3.37-1.81 7.32-.13 1.75-3.6s2.45 4.26 2.86 6c.42 1.74.33 7.1-.3 7.45-.65.34-3.03-1.6-3.37-1.73-.34-.13 1.79 7.52 0 7.82-1.8.3-4.77-2.85-4.77-2.85s1.19 6.82-.22 6.87c-1.4.04-5.04-1.71-6.58-3.39 0 0 1.72 5.64-.11 6.59z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8f4620",
    d: "m421.25 224.98 1.55 2.28c.37.54-.07 3.78-.29 4.37-.45 1.25-2.13-1.46-3.04-3.85 0 0-2.66-4.44-2.84-5.02-.17-.57 4.62 2.22 4.62 2.22zm14.27-16.91s2.58 10.66 1.34 11.03c-1.26.38-4.8-3.37-5.2-3.92-.4-.54-5.34-8.4-5.34-8.4l-1.05-1.07.31-.55 2.1.8 7.84 2.1z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8f4620",
    d: "M417.23 228.55c-.58.37-1.67-1.38-2.19-1.84-.5-.46-2.24-2.6-3.94-4.33-1.7-1.72-2.96-3-2.96-3.34 0-.34-1.02-1.44-1.02-1.44l.91-1.15 1.2-.17s7.04 5.61 7.52 6.5c.48.9.8 5.57.48 5.77zm10.6.09c-.33.26-5-3.11-6.96-5.9-1.96-2.8-4-5.25-4.49-6.55-.48-1.3-.88-2.47-.88-2.47l1.42.31s11.45 14.17 10.91 14.61zm1.67-4.93c-.26.32-2.3-1.2-3.55-2.85-1.25-1.64-.6-3.69-.6-3.69s4.4 6.23 4.15 6.54zm2.61-.63c-.63.3-3.3-2.93-5.54-6.57-1.64-2.69-2.05-3.1-2.4-3.3-.62-.38-1.77-.56-1.77-.56l-.23-.34 1.2-.3.88-1.03 1.39-1.78 5.54 11.18s1.36 2.5.93 2.7z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#ab6d29",
    d: "M417.72 231.92c.04.4-.02.82-1.53.66-1.51-.15-9.42-4.36-12.97-10.17a2863.2 2863.2 0 0 1-4.03-6.6l1.58-1.79 12.54 14.3 4.41 3.6z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8f4620",
    d: "M417.72 231.92c.17.66-.62.84-1.42.63-.8-.2-3.95-1.32-8.97-6.91-5.03-5.59-6.99-9.6-6.99-9.68l-.25-2.4 1.47-.62 8.64 13.16 7.52 5.82z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M426.11 226.27s-2.6-1.86-4.26-3.85c-1.66-1.99-5.03-6.6-4.94-7.52.08-.9 1.49-.9 1.49-.9l-.09-2.33.43-.79 2.43 1 3.06 3.76 1.13 1.53s1.98 4.78 1.6 5.21c-.38.43-3.2-2.68-3.54-2.29-.34.4 3.2 5.83 2.69 6.18zm-4.86-1.29s.85 1.3.46 2.2c-.37.91-.72 1.39-2-.51-1.27-1.9-2.82-4.04-2.96-3.88-.14.16.15 2.92-.48 2.92-.65 0-2.65-2.37-3.93-4.27-1.27-1.9-3.23-5.06-3.23-5.06s.17-.65.09-2.8c-.09-2.17-.26-3.3-.26-3.3s.18.68.41 1.19c.23.5.57.86.57.86l4.68 5.52 1.32-.91 2.78 5.4 2.55 2.64zm-17.76-8.04s3.62 6.35 6.99 9.9a22.83 22.83 0 0 0 7.24 5.08l-10.95-12.95-3.28-2.03zm27.77 3.76c-.19.13-2.43-2.3-3.83-4.45-1.41-2.16-2.51-5.19-2.43-6.53.09-1.34.47-4.58.47-4.58s3.75 3.9 4.47 5.7c.72 1.82 2.27 4.3 1.93 4.6-.34.3-2.87-1.7-3.17-1.22-.3.47 2.94 6.22 2.56 6.48zm4.26-4.06c-.46.23-2.34-1.99-2.85-3.37-.52-1.39-.69-4.1-.69-4.1l-1.66-3.94.17-4.36 1.66-.26 2.51 3.46s.99 2.02.94 4.96c-.04 2.94.43 7.35-.08 7.61zM406 227.32c-3.37-4.15-5.41-8.04-5.41-8.04l-1.1-3.72.59.48s.98 4.28 6.17 9.38c5.2 5.1 6.35 5.53 6.35 5.53s1.02 2.81.51 3.8c0 0-3.74-3.28-7.11-7.43z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#202020",
    d: "M411.61 233.27s-4.43-3.91-7.95-8.35c-3.52-4.44-5.74-8.7-5.74-8.7l1.54-1.44s2.92 6.82 5.02 9.53c2.1 2.71 7.13 8.96 7.13 8.96zm6.11-1.35s-5.14-5.1-7.75-7.98c-2.61-2.88-4.06-5.79-4.06-5.79l2.16.84s.85 2.24 2.72 4.58c1.88 2.33 6.93 8.35 6.93 8.35zm-.97-9.14s-2.81-3.43-4.15-5.59c-1.33-2.16-2.7-4.92-2.7-4.92s3.78 4.32 4.89 4.6c1.1.3 1.08-.02 1.08-.02s-.46 1.55-.09 2.85.97 3.08.97 3.08zm1.14-13.9s.46 2.42.14 3.83c-.3 1.41-1.06 1.4-1.06 1.4s1.46 2.06 2.31 2.92c.85.87 2.99 2.36 2.99 2.36s-1.71-2.36-2.4-3.57c-.67-1.2-1.67-2.56-1.24-3.74.42-1.19 2.73.8 3.38 1.35.65.55 3.35 3.74 3.35 3.74s-1-3.31-2.33-4.52c-1.33-1.2-5.14-3.77-5.14-3.77z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#202020",
    d: "M429.22 216.13s-1.45-3.48-2.28-5.61c-.82-2.14-2.1-6.76-2.1-6.76s.09 2.12-.03 3.67c-.1 1.56-.66 3.94-1.34 4.28-.68.34-.84.41-2.1.07-1.25-.35.88.58.88.58s1.28-.04 1.84-.67c.55-.63.67-1.97 1.27-1.77.6.2 1.24 2.22 1.73 3.1.49.9 2.13 3.11 2.13 3.11z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#202020",
    d: "M424.81 203.72s2.7 3.03 3.87 1.66c1.17-1.36.5-5.2.5-5.2s1.63.62 2.14.21c.52-.4.28-1.92.28-1.92s2.91 4.26 4.32 6.98c1.4 2.72 2.13 7.64 2.13 7.64s-2.42-3.92-3.64-7.64c-1.11-3.38-2.74-4.93-3.05-4.6-.3.32-.74 2.7-.38 3.93.37 1.23 1.36 2.83 2.05 4.58.68 1.75 1.44 4.5 1.44 4.5s-1.38-2.1-2.19-3.25c-.8-1.14-1.66-1.6-2.21-2.13-.56-.55-1.39-1.54-2.2-1.86-.8-.33-2.4-1.13-2.4-.5 0 .63-.32-1.23-.32-1.23l-.34-1.17z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#171717",
    d: "M415.76 216.68s1.5 2.98 2.68 4.54c1.2 1.55 2.82 3.76 2.82 3.76s-2.56-2.33-3.58-3.8c-1.03-1.47-1.92-4.5-1.92-4.5z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8f4620",
    d: "M433.35 217.46c-.38.15-1.62-.3-1.75.15-.13.45.7 2.23 1.62 3.16.91.93 1.3.97 1.51.86.22-.1-.1-.93-.24-1.88-.15-.95-.03-1.97-.14-2.27-.1-.3-1-.02-1-.02z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#d2a567",
    d: "m401.52 198.44-1.55 1.02-1.87 3.8.5 6.97s1.74 2.45 2.8 4c1.07 1.54 4.59 5.51 5.5 5.28.9-.23 1.87-3 1.99-4.5.11-1.5.22-4.26.22-4.26s.86 1.5 2.33 3.11c1.48 1.62 2.73 3.11 3.41 3 .68-.12 2.72-4.2 2.78-4.72.06-.52-5.11-13.2-5.11-13.2l-2.3-1.2-8.7.7z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#ab6d29",
    d: "M413.12 208.99s.9 3.24 1.45 4.84c.55 1.6-.02 2.98.28 3.02.3.04 3-3.58 3.04-5.22.04-1.64.04-3.33-.68-8.35-.73-5 .23-6.47.23-6.47l-1.55-1.26-2.69 5.4-.08 8.04zm-9.08-2.85s.6 4.88.94 6.48c.34 1.6 1.27 4.32 1.79 4.28.5-.04 2.13-4.32 2.17-5.8 0 0-1.1-2.06-1.07-7.3.05-5.22-.5-5.74-.5-5.74l-3.33 8.08z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#45392d",
    d: "M397.04 196.05s-4.09 5.93-4 9.19c.08 3.25.62 2.53 1.56 5.47.93 2.95 1.45 7.3 1.5 7.67.06.37.66-.2.74-.64.09-.43.2-21.7.2-21.7z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#ab6d29",
    d: "M397.02 196.75s-3.58 5.53-3.32 8.59c.25 3.05.74 2.96 1.76 5.7s1.1 7.2 1.1 7.2 1.14-.34 2.42-1.25c1.28-.91 2.43-2.77 2.43-2.77s-.44-1-1.27-2.78c-.82-1.78-.9-2.48-.9-2.48l-1.06-1.5.32-5.3.93-3.83v-1.44l-2.41-.14z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#dbad6c",
    d: "M416.35 206.27s-1.79-.39-2.51-.82c-.72-.43-1.02-1.47-1.02-1.47l.42-1.04 3.11 3.33z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#d2a567",
    d: "M397.75 197.35s-2.58 5.56-2.27 9.4c.31 3.83 2.41 8.72 2.61 8.78.2.06.11-.37.17-1.24.06-.86-.11-11.44-.11-11.44l1.25-3.71.05-1.93-1.7.14z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8f4620",
    d: "M404 198.59s.34 1.67.11 2.36c-.22.7-1.59 1.56-2.15 2.65-.57 1.1-1.37 3.63-1.37 3.63s.63-1.44 1.48-2.36c.85-.92 1.2-1.55 1.36-1.04.17.52.46 2.71.29 3.12-.17.4-.86 1.06-1.3 2.59-.5 1.63.05 3.11.05 3.11s.3-1.86.57-2.82c.23-.86.96-1.27.96-1.27l1.42 3.06s0-1.45.23-2.54c.23-1.1 1.42-2.64 1.8-2.64.39 0 .98-.21-.47-.95-.47-.3-.17-5.62.21-5.83.39-.22 2.39-.3 2.18-1.03-.21-.73-1.95-2.71-2.12-2.88-.17-.18-3.25 2.84-3.25 2.84z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#dbad6c",
    d: "m416.06 209.9-1.92-.35c-.68-.13-.77-.77-.77-.77l.22-.82 1.57.86.9 1.08z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8f4620",
    d: "M399.59 210.53c-.03.57-.46 1.15-.73 1.95-.33.97-.53 2.11-.53 2.11s-.38-2.55-.5-4.34c-.14-1.8-.26-2.96-.47-3.07-.22-.1-.84.84-.84.84s0-2 .39-2.98c.38-.97.7-2.35.36-2.57-.34-.22-1.06.39-1.38.9-.33.53-.92 1.65-.92 1.65s.38-1.7.79-2.4c.4-.7 2.34-2.92 2.7-3.78.36-.86.36-1.8.36-1.8l1.35-.06s1.4 1.1 1.41 2.04c.01.54-1.34 1.14-1.37 1.2-.09.18-1.13-.09-1.39 4.37-.25 4.45.89 4.08.77 5.94zm12.25-11.39s.3 2.42.04 3.15c-.25.74-.98 1.34-1.49 2.3-.51.95-.47 3.24-.47 3.24s.26-1.13.69-1.82c.42-.69.76-1.3.93-1.3.17 0 .68.87 1.02 2.12.35 1.25 1.03 3.37 1.03 3.37s-.3-1.64.12-1.64c.43 0 .6-.13 1.15.3.56.43 1.2 1.04 1.2 1.04s-.05-.6-.85-1.47c-.81-.86-1.28-.82-1.54-1.99a8.16 8.16 0 0 1-.25-2.8c.12-.48.68.3 1.15.86.46.56 1.96 1.86 1.96 1.86s-.64-1-.81-1.3c-.17-.3-.05-2.6 0-3.9.04-1.29-.05-2.5.42-2.84.47-.35.56-2.03.34-2.34-.21-.3-4.64 3.16-4.64 3.16z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#1e2121",
    d: "M426.09 194.16s.12 2.74.48 4.32c.37 1.59 1.42 5.04 1.42 5.04s-1.42-2.56-2.04-4.78c-.63-2.22-1.2-4.6-1.76-4.78-.57-.17-1.22 1.06-1.22 1.99 0 .92.6 4.38 1.36 5.59.77 1.2-1.22-1.59-1.7-3.09-.48-1.5-.97-2.82-.97-2.82s-.48 1.27-.28 2.68c.2 1.41 1.4 3.43 1.4 3.43s-.78-.67-1.26-1.24c-.48-.58-.91-.92-.91-.92s.08 1.93.6 2.76c.5.84 1.5 2.16 1.5 2.16s-1.19-.89-1.65-1.4c-.45-.53-.59-.9-.59-.9s.25 2.76.85 4.23c.6 1.47 1.9 3.9 1.9 3.9s-1.56-1.25-2.61-3.66c-1.05-2.43-1.56-9.64-1.3-10.74 0 0 .8-1.36 1.53-2.43.74-1.06 1.68-6.15 1.68-6.15s1.16 4.7 1.95 5.6c.8.9 1.62 1.21 1.62 1.21zm-11.27-1.42s.6 1.26.98 1.83c.39.56.77 1.28.77 1.28s-1.4 1.51-2.98 2.72c-1.58 1.21-3.67 2.55-4.13 1.86-.47-.7-.45-1.28-.45-1.28s1.73-1.04 3.1-2.42c1.36-1.39 1.83-2.11 2.13-2.84.3-.74.58-1.15.58-1.15zm-14.34 4.67s.24 2.94 1.48 2.9c1.24-.05 4.9-3.76 5.15-3.94.26-.17.5-1.08.5-1.38 0-.3-.22-1-.22-1s-3.94 4.05-5.34 4.18c-1.03.1-1.57-.76-1.57-.76zm.12-3.86s-.47 2.07-.4 2.65c.06.58.24 1.04.24 1.04s-2.82.99-3.29.13c-.47-.87-.16-2.1-.16-2.1s1.31 0 2.03-.16c.73-.18 1.58-1.56 1.58-1.56zm26.67-4.15s1.15 3.03 1.9 4.24a50 50 0 0 1 1.9 3.72s-1.9-2.22-2.5-2.71l-1.57-1.3s.28-.82.28-1.45l-.01-2.5z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#dbad6c",
    d: "M396.55 195.29s1.05.13 1.7.1c.64-.04 1.07-.3 1.07-.3l1.07-1.6s-.54 1.9-.17 3.24c.38 1.35 1.16 1.56 1.47 1.56.3 0 1.8-.31 2.96-1.52s2.76-2.47 2.76-2.47-.37 1.74.24 3.47c.62 1.73 1.6 1.7 2.93.62 1.33-1.07 2.7-2.9 3.42-3.72.4-.44.91-1.37.91-1.37l1.46-1.16 1.26-7.13-.68-.93-1.84.88-2.21-.88-.65-.9-1.26 2.14-1.33.87-.67.11-1.54.3-.69-1.38-.4-1.07-.76-.35-3.17 3.2-1.8-.08-1.8 2.83-1.3 1.8-1.33 3.14.35.6z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8f4620",
    d: "M411.97 188.08s.26 1.77-.64 4.75c-.9 2.99-2.13 5.1-2.13 5.1s3.2-1.94 4.73-5.44c1.53-3.5 1.18-7.52 1.18-7.52l-3.14 3.11zm3.87-3.25s.39.52.04 3.2c-.34 2.68-.97 5.27-.97 5.27s.37.65.8 1.51c.43.87 1.5 2.38 2.26 2.12.77-.26 1.96-1.17 2.77-2.94.8-1.77 1.53-3.5 1.83-3.76.3-.26.43.17.56.3.12.13.37 1.65 1.13 2.3.77.64 1.77 1.66 2.24 1.36.47-.3.93-1.2.84-1.63-.08-.43-1.7-5.27-1.7-5.27l-2.04-5.23-1.31-2.03-3.72.35-2.73 4.45z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#ab6d29",
    d: "M422.29 180.03s1.05 2.25 1.11 4.67c.06 2.42-.48 4.95-.48 4.95s.22-3.02-.12-4.84c-.34-1.81-.88-3-.82-3.51.06-.52.31-1.27.31-1.27z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M427.34 189.49s.21 2.09 0 3.08c-.21 1-1.66-.65-2.55-3.93-.9-3.29-.73-4.02-1.41-5.62-.69-1.6-1.1-2.98-1.1-2.98l1.86-.26 3.2 9.71zm-9.11 6.1s3.55-2.01 4-8.08c.22-2.85-1.61-7.48-1.61-7.48s0 4.93-1.32 8.1c-1.33 3.18-2.41 5.3-2.41 5.3s.85-.37 1.28-.89c.42-.52 1.02-1.4 1.02-1.4s.19.9-.13 2.1a19.66 19.66 0 0 1-.83 2.35zm-3.13-10.63s-.11 1.34-1.6 2.55c-1.5 1.21-4.18 2.55-4.18 2.55s1.96-1.81 2.68-3.41c.73-1.6.17-2.64.17-2.64s-.25.86-1.1 1.51c-.85.65-2.09.78-2.09.78s.1-.82.87-1.68c.16-.18.13-.59.24-.92.42-1.3 1.53-3.1 1.53-3.1s.85 1.9 1.7 2.72c.86.82 1.78 1.64 1.78 1.64z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#1e2121",
    d: "M426.21 177.79s.85 2.2 1.2 5.19c.33 3-.06 6.5-.06 6.5s-1.82-2.82-2.28-3.97c-.45-1.15-.45-2.88-.85-3.74a4.2 4.2 0 0 0-1.37-1.37c-.32-.22-1.33-.18-1.33-.18s1.05-.5 1.14-1.42c.08-.92 0-1.41 0-1.41s.68.34 1.79.49c1.1.14 1.76-.09 1.76-.09zm-7.96 12.79s1.94-2.7 2.45-6.05c.5-3.34-.09-4.5-.09-4.5s-.8-.11-1.44-.74c-.66-.64-1.68-2.28-1.68-2.28s.28 1.73-.09 3.83c-.36 2.1-2.3 4.12-2.3 4.12s1.03.35 1.94-.17c1.92-1.13 1.78-3.26 1.78-3.26s.43.26.37 2.91c-.06 2.65-.94 6.14-.94 6.14z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8f4620",
    d: "M395.31 195.2c-.41-.06 1.28-2.68 2.43-4.5l2.77-4.36s.3.3.98.26a4.76 4.76 0 0 0 3.15-2.16c.72-1.34 1.28-2.81 1.32-3.24.04-.43-.13 2.33 1.2 3.84 1.31 1.51 1.27 1.39 1.83 1.26 0 0-.05 1.9-.56 3.67s-1.02 4.32-1.02 4.32.21-3.32-.34-4.28c-.55-.95-.85.09-1.32 1.3-.47 1.2-1.5 2.07-1.5 2.07s.77-1.46 1.28-3.02c.52-1.56.26-1.6.13-1.64-.13-.05-.38-.09-.93.56-.56.65-1.11.82-1.11.82s.68-.56.9-1.34c.2-.78.85-1.9 1.23-2.33.38-.44.64-.96.64-1.26 0-.3-.09-.95-.35-.95-.25 0-.6.4-1.82 1.56-1.24 1.16-1.45 1.25-1.67 1.68-.21.43-.38 1-1.15 3.42a20.74 20.74 0 0 1-1.4 3.63c-.13.21-.68.57-.68.57s.42-1.35 1.06-3.12c.64-1.77 1.5-4.1 1.28-4.5-.21-.38-.77-.34-.94 0-.17.35-1.4 1.86-2.64 3.68-1.23 1.81-1.23 4.06-1.53 4.15 0 0-.83-.03-1.24-.09z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#874f20",
    d: "M427.43 175.83c-.02.2.11 1.5-1.22 1.96a4.55 4.55 0 0 1-3.13-.24c-.16-.15-.16-1.86-.16-1.86l4.51.14z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#b27129",
    d: "M401.59 180.06s-.24 1.24-.97 2.76c-.73 1.54-1.95 2.81-1.8 3 .15.2.84.91 1.9.9 1.06-.03 1.45-6.39 1.45-6.39l-.19-.22-.39-.05z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#dbad6c",
    d: "M417.95 176.56s-.48 8.42-2.85 8.4c-2.36 0-3.43-4.25-3.43-4.25s-.2 5.68-3.21 5.68c-1.36 0-2.8-4.39-2.5-5.18 0 0-.56 3.02-1.98 4.14-2.82 2.22-4.63 1.14-4.72.79-.1-.34 2.38-2.71 2.72-6.02 0 0 .44.14 1.12-.84.68-1 1.07-2.08 1.76-1.88.68.2 4.08-1.38 4.08-1.38l1.8-2.27s.2.74 1.51-.15a4.8 4.8 0 0 0 1.76-2.23l3.5 2.97.44 2.22z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#b27129",
    d: "M408.73 168.56s2.12 3.2 3.54 5c.08.1.77-.68.77-.68.47.64.73 1.2.59 1.54-.55 1.3-1.7 3.07-.77 4.92 0 0-.3-1.03.22-2.37.5-1.34.89-1.82 1.19-1.78.3.05.8 7.7 1.32 7.65.5-.04 1.2-3.45 1.2-5.87 0-2.43.48-.44.7.04.23.47 2.32 3.89 4.1 3.37 1.8-.52 1.54-3.67 1.5-4.36-.04-.7-1.28-4.89-1.28-4.89l-8.01-5.04s-.23.63-.66 2.06c-.43 1.43-4.41.41-4.41.41z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8f4620",
    d: "M420.1 167.81s.47.43 1.24 2.42c.76 1.99.85 8.43-.17 8.38-1.03-.04-3.07-1.2-3.41-2.07-.34-.87.12-4.06-.56-4.93-.68-.86-1.49-3.02-1.53-3.63-.04-.6.13-2.55.13-2.55l1.79-.65 2.51 3.03z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m419.53 165.81 3.4 5.07 3.02 4.35s1.52.5 1.48.6a3.24 3.24 0 0 1-4.11.65c-1.18-.66-.58-2.7-2.07-5.99-1.5-3.28-4.17-4.71-4.17-4.71l.93-.9 1.52.93z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#1e2121",
    d: "M417.65 163.04s3.04 2.01 4.12 4.2c1.08 2.2 1.71 3.52 3.02 5.65 1.3 2.13 2.7 2.8 2.64 2.94-.06.14-.94.34-1.6-.15a6.22 6.22 0 0 1-1.87-2.04c-.54-.98-2.44-4.55-3.15-5.48-.71-.92-2.98-2.65-3.04-2.47-.05.17.71.69 2.02 2.8 1.3 2.1 1.62 4 1.53 4.02-.08.03-.37-.77-1.5-2.67-1.14-1.9-3.61-4.36-3.75-4.01-.15.35 1.22 2.6 1.9 3.89.68 1.3 1.82 4.32 1.7 4.32-.1 0-.9-1.7-2.27-3.8-1.36-2.1-1.62-1.85-2.19-2.54-.56-.69-1.78-2.28-1.78-2.28s1.22.38 2.4-.4c1.2-.77 1.82-1.98 1.82-1.98z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8f4620",
    d: "M409.9 168.65s1.96.45 3.02.32c1.07-.13 1.43-.08 1.43-.08s.64.86.64 1.85c0 1-.68 2.86-.98 2.9-.3.04-.25-1.69-.72-2.3-.47-.6-3.39-2.69-3.39-2.69z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#b27129",
    d: "M410.94 173.79s.63 2.13.15 5.09c-.49 2.96-2.2 6.02-2.63 6.02-.44 0-.3-3.36-.49-5.13l-.06-.55c-.03-.24-.67 2.24-.7 2.03-.02-.23.57-3.15.55-3.34l-.14-1.11 2.2-2.61 1.12-.4z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8f4620",
    d: "M407.21 176c-.6.74-1.51.54-2.36.8-.79.25-1.07 1.45-1.07 1.45s.64-.47.94-.34c.3.13.65.1.05 1.57s-2.92 3.96-2.81 3.99c.11.03 2.6-2.1 3.4-3.31.82-1.21.75-1.93.92-2.37.17-.43 1.13-.95 1.34-.99.22-.04.69.04.9.9.21.87.55 3.33.72 3.42.17.09.77-2.25 1.03-3.41.25-1.17.24-3.74.24-3.74s-.16-.07-.76-.2-2.02-1.15-2.02-1.15.28 2.4-.52 3.38z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#dbad6c",
    d: "M417.72 160.94s.8 2.01-.85 3.42c-.5.4-.97.69-1.85.73-.88.04-2.29-.71-2.29-.71l-5.09-2.12-2.68-.84-1.32-.37.19-1.47 3.98.17 3.94 1.51 1.73.57 1.47.25h1.1l.92-.25s.43-.18.55-.41c.13-.24.2-.48.2-.48z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#ab6d29",
    d: "M417.72 160.94c.17.35-.3 1.47-.68 1.64-.39.18-1.07.48-2.6.13-1.53-.34-3.11-1.34-4.82-1.81-1.7-.48-2.98-.91-4.3-.87-1.32.05-.68-.56-.68-.56s3.03-.34 5.67.65c2.64 1 3.78 1.67 5.11 1.64 2-.04 2.3-.82 2.3-.82z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M403.79 159.34s.6.13 1.1.04c.52-.08.9-.39.9-.39s.09.7-.25.91c-.34.22-1.37.13-1.54.13-.17 0-.21-.69-.21-.69z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#dbad6c",
    d: "M413.8 165.63s1.78 1.74 1.3 3.25l-3.43-1.57-5.6-2.34-3.04-.9-.37-.48s.58-.54.85-1.06c.28-.52.2-1.01.2-1.01l3.7.5 3.88 1.18 2.51 2.43z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#dbad6c",
    d: "M409.99 168.13s3.2 4.13 2.45 5.49l-7.46-4.71-2.62 4.33-6.14-3.03s4.95-3.8 5.53-4.52c.57-.72.61-.97.61-.97l2.77.53 4.37 1.39.49 1.49z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#ab6d29",
    d: "M408.26 162.03s2.61.63 4.29 1.5c1.67.86 4.02 1.06 4.02 1.06s-.94.99-2.77 1.04c-.54.02-1.85-1.04-2.7-1.64-.85-.6-3.31-1.33-3.31-1.33l.47-.63z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M403.66 160.63s1.88.39 3.03.9c1.15.53 1.23.4 1.53.27.3-.13.34-.26.34-.26s.24 1.12-.66 1.12-1.26-.3-2.4-.82c-1.16-.52-1.92 0-1.92 0l.08-1.21z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#ab6d29",
    d: "M414.02 167.88s1.34.84 1.08 1c-.25.18-.92.5-2.09.57a4.52 4.52 0 0 1-2.54-.45c-.82-.37-1.33-1.81-3.32-2.59-1.99-.78-2.33-.9-3.7-1.24-1.36-.34-1.67-.32-1.67-.32l1.25-.52 4.29.87 3.66 1.07 2.22 1.06.82.55zm-7.2 2.52.85 3.37-.47 2.03-1.15.74-1.06-.43-.3-.61s.47-.78 0-1.47-2.64-1.55-2.64-1.55.85-1.65 1.83-2.04c.98-.38.51-1.64.51-1.64l2.43 1.6z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M402.64 163.53s.68.58 2.08.72a16 16 0 0 1 2.83.62c.38.12 1.32-.4 1.4-.38l-.81.49c1.23.35 2.79.9 3.33 1.14a7.61 7.61 0 0 1 2.56 1.76c-.05.02-.84-.46-2.56-1.18a22.88 22.88 0 0 0-3.97-1.24c-2.56-.5-5.12-.34-5.65-.52-.55-.17.22-.2.5-.49.29-.29.29-.92.29-.92z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#ab6d29",
    d: "M412.18 172.78s.81.86-.04 1.17c-.85.3-3.18.24-4.28-.92 0 0-.28-1.11-.7-1.63-.43-.52-2.13-1.6-3.12-2.2-.97-.61.34-.7.34-.7s3.5 1.34 4.78 2.03c1.28.7 3.02 2.25 3.02 2.25z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M412.23 172.86s-1.72-2.38-6.5-4.26c-.13-.05 1.62-.3 1.49-.35-.2-.08-2.3.04-2.53-.04l-1.12-.36c-2.51-.77-2.7-.7-2.87-1.04-.17-.34-.48.06-.74.49-.25.43-.96 1.37-.9 1.28.05-.09 1.84-.5 3.26-.16 1.42.35 1.36.87 1.25 1.42-.11.54-1.84 2.65-1.65 2.7.2.06 1.2-1.99 2.5-1.7 1.3.3 1.74 1.01 1.74 1.01s-.03-.75-.29-1.07c-.25-.31-1.7-1.67-1.3-1.67.4 0 2.01.38 4.34 1.56 2.27 1.15 2.64 1.5 3.32 2.19z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#dbad6c",
    d: "M404.43 169.12s3.67 1.04 3.5 4.93c-.18 3.88-3.02 3.17-3.27 1.75-.26-1.4.34.68 1.36.5 1.12-.21 1.35-1.33 1.28-2.83-.07-1.44-.37-2.16-1.25-3a15.72 15.72 0 0 0-1.62-1.35z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#6c3f18",
    d: "M388.58 159.75s.38.3-.66 3.04c-1.05 2.74-1.61 3.72-3.2 5.47-2.96 3.26-4.25 3.28-3.94 4.66.32 1.39 1.47 1.02 1.73 1.06.26.05 5.58-7.8 5.58-7.8l1.17-4.7-.28-1.33-.4-.4z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#dbad6c",
    d: "M401.79 154.14s1.53 2.3 1.05 6.65c-.48 4.35-6.22 8.16-6.22 8.16l-8.37 5.79-3.5-.21s-.55.08-1.06-.06c-.55-.14-1.06-.71-1.18-.71-.23 0-.66-1.47-.66-1.47l1.11-1.35 3.04-3.03 1.9-2.74s.86-1.58.97-3.1c.11-1.54-.28-2.31-.28-2.31l.7 1.1.4 2.3-.3 2.56 2.18-1.47 2.9-1.3s.8-.11 1.36-1.72a20.37 20.37 0 0 0 1.05-5.05c.01-1.06-.12-2.33-.12-2.33s.19-.01.37.1c.18.1.94 1.45.94 2.21 0 .77.5 3.59.5 3.59l1.34-1.36s.99-1.24 1.25-1.9c.27-.64.64-1.66.63-2.35z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#904720",
    d: "M402.72 175.91s.58.47.36 2.05c-.21 1.58-1.51 2.44-2.15 2.47l.06-2.2-1.85-1.48-1.98-.6s.13-.11.36-.35c.24-.23 2.28-1.08 2.28-1.08l2.92 1.19z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#ab6d29",
    d: "M401.27 175.93s.58.56 1.5.32c.9-.23 1.3-1.7.8-2.29-.49-.58-.28 1.4-.87 1.62-.6.22-1.24-1.49-2.05-1.66-.8-.17-2.08.39-2.4.93-.32.54 1.3.1 1.3.1l.87.24.64.16.21.58z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#904720",
    d: "M389.17 169.89s1.09.33 2.27.17 4.07-1.37 4.07-1.37 1.34-.75 2.32-1.7c.98-.95 4.07-2.88 4.41-6.74.34-3.86-.45-6.1-.45-6.1s4.58 5 .57 10.74c-2.61 3.74-4.89 4.84-4.89 4.84s4.43-1.3 4.83-.23c.4 1.06-.2 2.72-.32 2.98 0 0 2.51.58 2.88 1.86.21.76-2.86-.89-5.18-.33s-3.34 1.95-3.34 1.95-.43-.67-2.5-.7c-2.06-.02-3 .96-4.17.91-1.17-.04-4.85-.83-5.56-1.83 0 0 .87-1.1 2.43-2.88 1.07-2.05 2.63-1.57 2.63-1.57z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#ab6d29",
    d: "M398.69 159.53s1.79-1.76 2.38-3.05c.6-1.3.72-2.34.72-2.34s.2 1.41-.85 3a16.93 16.93 0 0 1-2.22 2.68l-.03-.29z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#904720",
    d: "M398.2 155.61s1.46 5.68-.1 8c-1.56 2.34-8.36 5.36-8.36 5.36s5.15-2.79 6.77-6c1.62-3.21 1.5-5.9 1.5-5.9l.2-1.46z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#1e2121",
    d: "M391.44 170.05s2.17-.04 3.4-.78c1.24-.73 3-2.29 3-2.29s-1.63 1.43-2.1 1.43c-.47 0-.85-.74-.64-1.3 0 0-.38 1.08-1.36 1.82-.98.73-2.3 1.12-2.3 1.12zm5.06-7.08s1.83-1.9 1.79-5.88c-.04-3.97-1.54-3.24-1.54-3.24s1.24.9.98 3.93a17.32 17.32 0 0 1-1.23 5.19zm2.22.39s2.06-.5 2.79-1.7c.72-1.22.7-3.53.7-3.53s-.21 2.12-.8 2.9c-.6.77-2.69 2.33-2.69 2.33zm-1.2 12.44s1.02-1.99 2.39-1.47c1.36.52 1.36 1.6 1.36 1.6s-.55-.86-1.58-.9c-1.02-.05-2.17.77-2.17.77zm-3.87-3.58s3.02-.74 4.81-1.3c1.8-.56 3.84-1.42 3.84-1.42s-1.5 1.85-3.71 3.1c-2.22 1.26-4.05 1.35-4.05 1.35s4.18-1.82 4.52-2.55c0 0-4 1.08-5.41.82z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M388.81 167.55a3.46 3.53 67.76 0 1-3.98 5.72"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#f16e16",
    d: "M388.63 167.94a3.05 3.1 67.77 0 1-3.57 4.97"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#000",
    d: "M387.28 169.62a1.23 1.23 0 1 1-1.2 1.85"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#d5d3ca",
    d: "M387.45 171.18a.4.4 0 1 1-.77-.13.39.39 0 0 1 .45-.33.4.4 0 0 1 .32.46z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#ab6d29",
    d: "M389.58 165.4s2.02-1.99 2.47-4.61c.46-2.62.18-4.11.18-4.11l1.1 1.14.42 2-.7 3.3 2.21-1c.74-1.01 1.9-5.5 1.5-8.27 0 0 .6 1.21-.2 4.98-.79 3.78-1.44 4.22-4.28 5.78-1.46.8-3.3 2.34-4.97 5.54a24.7 24.7 0 0 1-3.06 4c-.06.05 1.42-2.01 2.14-3.56 1.08-2.3 2.25-3.6 2.25-3.6l.94-1.59z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#904720",
    d: "M388.64 166.99s.88-2.65.88-4.1-.94-3.13-.94-3.13 1.28-.18 1.4 2.96c.1 3.15-.57 3.32-1.34 4.27z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M392.69 163.61s.94-2.33.87-3.89c-.06-1.56-1.34-3.05-1.34-3.05s1.58.3 1.7 3.14c.13 2.83-.36 2.85-1.23 3.8z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#ab6d29",
    d: "M383.39 174.25s-.73-.94-.64-1.67c.08-.73.02-.9 1.83-2.8s2.82-3.07 3.26-4.09c.45-1.01 1.92-3.78.75-5.93 0 0 .8 3.13-1 5.61-1.81 2.48-2.86 3.78-4.35 4.88-1.49 1.1-1.64 1.62-1.6 2.25.05.63.2 1.25.45 1.4.46.27 1.3.35 1.3.35z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#6c4119",
    d: "M400.94 180.42s.4.04.66-.43c.25-.48.25-1.28-.38-2.08a4.33 4.33 0 0 0-2.26-1.53c-.9-.26-2.62-.43-2.62-.43s.59 1 1.74 1.66c.57.32 1.54-.09 2.16.52.61.6.7 2.29.7 2.29z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#6c4119",
    d: "M400.94 180.42s2.01-.65 2.15-2.6c.09-1.2-.17-1.61-.17-1.61s.3.62 1.1.86l.73-.28s-1.2 3.76-3.81 3.63z"
  }))), _g13 || (_g13 = /*#__PURE__*/react.createElement("g", {
    fill: "#f9c83a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#bf802d",
    d: "M386.9 180.05s.4.16 1.14 1.03c.75.86 1.1 1.14 1.1 1.14l4.87-1.25 1.58-1.56-1.32-2.09h-3.5l-3.87 2.73z"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#8f4620",
    strokeWidth: 0.48,
    d: "m398.72 178.39-.94-1.27s-.2-.49-.9-.86c-.72-.37-3.67-.35-3.67-.35l-2.13.44s-.6.54-1.68.31c-1.08-.23-3.46-1.2-3.46-1.2l-2.39-1.05s-1.79-.74-2.18-.6c-.4.14-1.88 1.76-1.88 1.76s-.25.86.31.89c.57.03-.85.29-.85.29s-3.7 2.03-4.3 5.66c-.6 3.63 6.1 8.99 8.56 6.27 0 0-3.62-2.68-2.9-4.93.73-2.25 2.4-3.63 5.24-3.8 2.86-.17 3.03-.52 4.26-1.39 1.24-.86 3.54-1.38 5.24.4 1.7 1.76-6.47 3.45-6.47 3.45l.9 1.3s10.1-3.46 9.24-5.32z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#fcf3d8",
    d: "M379.85 187s-4.09-1-3.75-4.75c.34-3.76 3.75-5.14 4.35-5.32.6-.17.47-2.07 1.15-2.29.68-.21 1.99 0 2.58.56.6.57 1.87 1.1 1.87 1.1s-7.24 3.22-7.3 7.37c-.05 2.77 1.1 3.33 1.1 3.33z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#fdeaaf",
    d: "M398.7 177.99s-.5.3-.63.05c-.76-1.42-2.55-1.8-4-1.78-1.85.03-3.1.72-4.35.72-1.25 0-.9-.2-2.39-.26-1.47-.06-4.62-2.4-5.34-2.16-.7.23-.99 1.1-.9 1.54.08.43-1.29.46-1.48.14-.2-.32 1.08-2.36 2.36-2.36 3.44 0 5.99 2.32 7.64 2.32 1.64 0 2.21-.95 4.43-.95 2.21 0 4.6.98 4.66 2.74z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#513625",
    d: "M387.45 180.66s1.64-.32 2.87-.86c1.24-.54 2.89-.97 2.89-.97s-1.51 1-2.56 1.5c-1.04.49-2.73.76-2.73.76l-.47-.43z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M381.66 189.16c-.3.12-1.73.06-4.02-1.47-2.28-1.53-2.88-4.12-2.88-4.12s-.52-2.48 1.85-5 2.76-1.8 2.88-1.68c.11.1-.12.23-.12.23l-2.08 1.7-1.04 1.74-.92 1.57.07 1.86 1.06 1.86 3.27 2.04 1.93 1.27z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8b5122",
    d: "m380.41 174.93-.13-.31v.34c.1 0 .12-.03.13-.03l-.13-.31v.34-.35l-.24.25c.09.08.19.1.24.1v-.35l-.24.25.24-.25h-.34c0 .06.02.17.1.25l.24-.25h-.34.34l-.31-.14c0 .03-.03.05-.03.14h.34l-.31-.14.27.12-.24-.17-.03.05.27.12-.24-.17.06.04-.06-.04.06.04-.06-.04-.18.2c-.14.17-.33.4-.48.64-.16.25-.3.5-.31.82v.12c.05.33.27.6.52.7.24.13.5.16.75.16.54 0 1.05-.16 1.07-.16a.35.35 0 0 0 .22-.44.34.34 0 0 0-.42-.23h-.02c-.08.03-.49.14-.85.14-.19 0-.36-.03-.45-.08-.1-.06-.12-.08-.14-.2 0-.04.03-.16.1-.3a3.95 3.95 0 0 1 .64-.84l.07-.08.03-.04.03-.04.02-.05c0-.03.02-.06.02-.13a.34.34 0 0 0-.34-.35c-.1.01-.12.03-.13.03a.35.35 0 0 0-.19.46c.08.17.28.25.45.18z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M387.36 178.44s-4.89 1.37-5.01 1.46c-.36.26 1.56-.04 3.07-.09 1-.03 1.76.22 1.76.22s.59-.01 1.18-.24c1.88-.74 5.83-2.2 6.2-.48.3 1.45-5.46 2.71-5.46 2.71l-.05.57 4.63-1.15 2.38-1.26.77-1.23-2.3-1.64h-3.37l-1.55.43-2.25.7z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#8f4620",
    d: "M380.21 185.51c.36 1.02 1.18 2.5 2.1 2.97 0 0 .16.01.1.11s-.74.52-2.3.12c-1.56-.4-3.95-1.04-5.4-5.42l.05.97.85 1.71 1.53 1.59 2.4 1.5 1.65.41 1.4-.36.62-.47-1.44-1.3-1.76-3s-.07.42.2 1.17z"
  }))), _g14 || (_g14 = /*#__PURE__*/react.createElement("g", {
    fill: "#816c2a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fcca3d",
    d: "m396.5 228.99-.07 1.59-.88-.1.16-1.98zm-6.13-45.21-1.62-1.82-1.05.16 1.6 2.28z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M396.42 232.7s-.98-.64-2.24-1.22c-1.3-.6-3.1-.87-3.12-.87l-.06.4.3.06c.56.1 1.8.37 2.71.78a18.72 18.72 0 0 1 2.02 1.1l.17.1.22-.35zm-.14-4.05s-.9-.06-1.85-.06c-.66 0-1.34.03-1.8.14-1.1.27-1.81.82-1.83.83l.25.33.03-.02a4.99 4.99 0 0 1 3.35-.87 29.74 29.74 0 0 1 1.82.06l.03-.41zm-.47-3.48s-2.26 1.06-3.3 1.76c-1.04.68-2.12 1.57-2.13 1.58l.26.32.67-.53c.39-.3.91-.7 1.42-1.03a48.85 48.85 0 0 1 3.25-1.72l-.17-.38zm-2.17-3.58c0 .08-.02.92-.42 1.56-.1.16-.42.54-.83 1-.6.69-1.43 1.57-2.1 2.29l-1.18 1.24.3.3 1.89-2.01 1.4-1.54c.41-.47.73-.84.86-1.06.48-.77.49-1.66.49-1.77v-.01h-.41zm-2.83-1.6.02.07c.03.16.1.53.1 1.03 0 .51-.08 1.16-.31 1.83a27 27 0 0 1-1.29 2.85l-.6 1.17-.26.48.35.2s1.6-2.91 2.18-4.56a5.95 5.95 0 0 0 .2-3.18l-.39.11zm-2.74-.33a11.6 11.6 0 0 0 .07 1.5 7.4 7.4 0 0 1-.29 2.3 144.64 144.64 0 0 1-1.34 3.65l.38.15s.85-2.26 1.35-3.66c.25-.72.3-1.65.31-2.45 0-.85-.07-1.53-.07-1.53l-.41.04zm-2.11-.01s0 .7-.05 1.56c-.04.87-.12 1.9-.27 2.54-.32 1.35-.65 3.3-.65 3.3l.4.07.2-1.14c.13-.65.3-1.47.45-2.13.32-1.39.33-4.19.33-4.2h-.41zm-2.28.37.06.65c.02.4.05.92.05 1.45a7.2 7.2 0 0 1-.15 1.66c-.33 1.26-.53 3.25-.53 3.25l.4.05a30.33 30.33 0 0 1 .53-3.2 7.4 7.4 0 0 0 .16-1.76c0-1.1-.11-2.14-.11-2.15l-.41.05zm-1.79.24v.23c0 .5-.04 1.67-.37 2.89l-.72 2.52c-.2.76-.36 1.3-.36 1.3l.39.12 1.08-3.83c.35-1.27.4-2.49.4-3l-.01-.25-.41.02zm-2 .02a10.26 10.26 0 0 0 .05.9c0 .76-.1 1.87-.58 2.74a7.2 7.2 0 0 1-1.81 1.96c-.33.26-.63.47-.85.62l-.26.17-.09.05.2.36c.02-.01 2.27-1.33 3.17-2.97a6.3 6.3 0 0 0 .63-2.93c0-.57-.05-.95-.05-.95l-.41.05zm-1.23-.39-.09.28a8.78 8.78 0 0 1-1.25 2.46 8.7 8.7 0 0 1-1.68 1.46l-.74.49-.3.18.2.36s1.91-1.09 2.84-2.23a9.53 9.53 0 0 0 1.41-2.88l-.39-.12zm-1.95-.98-.11.22c-.12.22-.3.54-.5.86a4 4 0 0 1-.62.79c-.27.23-.8.56-1.25.83l-.83.48.2.36s.38-.2.84-.48c.46-.28 1-.61 1.3-.88.34-.29.65-.78.9-1.2.26-.43.43-.8.43-.8l-.36-.18zm-.95-1.22-.32.37c-.3.34-.77.85-1.23 1.3a8.5 8.5 0 0 1-.67.59c-.2.16-.4.26-.5.3l.11.4c.27-.09.55-.3.86-.56.94-.79 2.06-2.13 2.06-2.13l-.31-.27zm-.47-.82-.3.23c-.27.22-.7.53-1.14.8-.42.25-.87.45-1.1.45v.41c.27 0 .56-.11.86-.26.9-.44 1.93-1.3 1.94-1.3l-.26-.33zm-.36-.88s-.45.26-.98.53l-.78.38c-.25.1-.47.18-.57.19l.04.4c.2-.01.42-.1.69-.2.77-.34 1.8-.94 1.8-.94l-.2-.36zm-.43-1.82-.04.05c-.1.1-.36.37-.7.6a2.1 2.1 0 0 1-1.14.46v.41a2.74 2.74 0 0 0 1.52-.63c.4-.3.66-.61.66-.62l-.3-.27zm.15-2.86s-.37.3-.78.68c-.4.38-.84.84-1 1.27 0 0-.06.1-.12.16l-.09.07-.03.02v.02-.02.02-.02.41c.2 0 .32-.12.41-.21.1-.11.17-.2.2-.3.1-.29.53-.75.92-1.12.19-.19.38-.35.52-.47a2 2 0 0 1 .22-.18l-.25-.33zm14.04-16.79h2l.03-.01.05-.02.05-.05.04-.13-.04-.12-.07-.06-.06-.02h-.03l-.02.41v-.16.16-.16.16l.01-.2-.04.2h.02l.02-.2-.04.2.04-.2-.07.19h.03l.05-.2-.08.2.08-.2-.13.17.05.03.07-.2-.12.17-.04-.05.16-.12h-.2l.04.12.17-.12h-.2l.03-.12.08-.07.08.2-.02-.21-.06.01.08.19-.02-.2.01.13v-.13h-.01l.01.13v-.13h-1.95v.41zm.05-1.23h.13c.29 0 .58-.11.88-.27.44-.23.9-.58 1.3-.86.21-.14.4-.26.58-.35.16-.08.31-.13.4-.13v-.42c-.27.01-.52.13-.79.3-.4.23-.84.57-1.27.85-.42.28-.84.48-1.1.47h-.08l-.05.41zm-.17-1.97c.3-.04.63-.19.97-.38.5-.3 1.06-.69 1.57-1 .5-.33.98-.56 1.23-.56v-.42c-.3.01-.6.14-.93.32-.5.27-1.05.66-1.57.99a3.9 3.9 0 0 1-1.32.64l.05.41zm-.73-1.83c.5-.26 1.24-.84 2.01-1.43.77-.6 1.57-1.22 2.1-1.55l-.21-.35c-.57.35-1.37.97-2.14 1.57-.76.6-1.52 1.16-1.95 1.4l.19.36zm-1.38-2.09c.98-.7 3.37-2.4 4.27-2.98l-.21-.35c-.92.59-3.31 2.3-4.3 3l.24.33zm-1.83-2.01c.65-.55 1.56-1.16 2.4-1.7.85-.55 1.62-1.02 2-1.3l-.23-.34c-.36.27-1.14.74-1.98 1.28a24.4 24.4 0 0 0-2.45 1.74l.26.32zm-1.44-1.24a173.4 173.4 0 0 1 3.54-2.5c.46-.31.83-.55.97-.61l-.17-.38c-.2.1-.56.33-1.02.64-1.38.93-3.56 2.51-3.56 2.51l.24.34z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#78732e",
    d: "m386.48 180.09.25.2c.56.46 1.96 1.67 3.23 3.25 1.26 1.58 2.36 3.53 2.36 5.43 0 .18-.01.37-.03.55-.29 2.48-1.53 4.66-3.25 6.67-2.59 3.03-6.25 5.66-9.27 8.33a23.72 23.72 0 0 0-3.86 4.1 8 8 0 0 0-1.6 4.56l.01.22c.05 1.5.54 3.14 1.47 4.46a5.74 5.74 0 0 0 5.1 2.55c2.35 0 4.93-.75 7.38-.75 2.07 0 4.03.51 5.77 2.42 1.67 1.82 2.18 4.75 2.18 7.57a31.9 31.9 0 0 1-.87 7.17l-.16.65.4.12c0-.02 1.04-3.84 1.04-7.94 0-2.87-.5-5.9-2.29-7.85a7.68 7.68 0 0 0-6.07-2.55c-2.53 0-5.1.75-7.39.75-.3 0-.6-.02-.88-.05-1.71-.17-3-1.09-3.88-2.33a8 8 0 0 1-1.4-4.23v-.2c0-2.04 1.02-3.89 2.6-5.69 2.37-2.7 5.97-5.26 9.11-8.09 3.14-2.83 5.82-5.96 6.26-9.84.03-.2.04-.4.04-.6 0-2.36-1.52-4.65-3.02-6.36a22.61 22.61 0 0 0-2.98-2.85l-.25.33z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#a8ac71",
    d: "m383.38 184.11-.5-.42-.41.15.8.65zm1.32 1.25-.37-.38-.19.1.3.41z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#78732e",
    d: "m386.54 187.39-.31-.4-.2.25.32.37zm1.38 2.06-.23-.41-.37.06.48.52zm.78 1.94-.18-.56-.05.1-.04.42zm.09 1.95.02-.54-.24-.15.03.74zm-.08 1.25.05-.6-.16-.11.01.79zm-15.94 19.37s.04-.5.18-.93c.14-.43-.4.2-.4.2l-.06.6.28.13z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "m372.64 215.2-.23.1.08.59.13-.18.02-.51z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#78732e",
    d: "m372.68 217.51-.03-.57-.17-.06v.92z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "m372.83 218.8-.05-.51-.18.02-.02.49zm.35 1.86-.1-.5-.12.12.1.5zm.49 1.91-.2-.67-.15.06.2.65z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#a8ac71",
    d: "m374.91 225.13-.28-.42-.26-.04.34.5zm1.89 1.87s-.26-.15-.63-.45c-.37-.3-.15.28-.15.28l.54.28.24-.11zm12.83.96s-.3-.2-.51-.3c-.21-.1.11.02.3.44.18.42.21-.14.21-.14z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M390.73 228.85s-.25-.31-.4-.42c-.17-.1-.11.32-.11.32l.33.14.18-.04z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#a8ac71",
    d: "M390.95 229.36c-.14-.18-.29.27-.29.27l.4.37s.03-.45-.11-.64zm.06 1.77s.09-.38.06-.62c-.02-.23-.2.09-.2.09l.01.53h.13z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "m390.39 233 .15-.47-.2.01-.11.48zm-19.53-68.35s.73-.15.18.68c-.55.83.37-.74.37-.74l-.3-.1-.25.16z"
  }))), mx_path16 || (mx_path16 = /*#__PURE__*/react.createElement("path", {
    fill: "#f9c83a",
    d: "m386.69 179.57.45.46s-.42-.11-.6-.14c-.18-.02.15-.32.15-.32z"
  })), mx_path17 || (mx_path17 = /*#__PURE__*/react.createElement("path", {
    fill: "#8f4620",
    d: "m387.13 180.03-.85.12c-.23.03.25-.25.25-.25l.6.13z"
  })), mx_path18 || (mx_path18 = /*#__PURE__*/react.createElement("path", {
    fill: "#977c2e",
    d: "M394.97 237.46s.53-.06.77-.38c.24-.33-.15.5-.15.5l-.34.14-.28-.26z"
  })));
};

/* harmony default export */ var mx = (SvgMx);
;// CONCATENATED MODULE: ./public/flags/ee.svg
var ee_path, ee_path2, ee_path3;

function ee_extends() { ee_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ee_extends.apply(this, arguments); }



var SvgEe = function SvgEe(props) {
  return /*#__PURE__*/react.createElement("svg", ee_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 21"
  }, props), ee_path || (ee_path = /*#__PURE__*/react.createElement("path", {
    fill: "#FFF",
    d: "M0 0h33v21H0z"
  })), ee_path2 || (ee_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M0 0h33v14H0z"
  })), ee_path3 || (ee_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#4891D9",
    d: "M0 0h33v7H0z"
  })));
};

/* harmony default export */ var ee = (SvgEe);
;// CONCATENATED MODULE: ./public/flags/pa.svg
var pa_path, pa_g, pa_g2;

function pa_extends() { pa_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return pa_extends.apply(this, arguments); }



var SvgPa = function SvgPa(props) {
  return /*#__PURE__*/react.createElement("svg", pa_extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 36 24"
  }, props), pa_path || (pa_path = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v24H0z"
  })), pa_g || (pa_g = /*#__PURE__*/react.createElement("g", {
    fill: "#005293"
  }, /*#__PURE__*/react.createElement("g", {
    id: "pa_svg__c",
    transform: "translate(9 6)"
  }, /*#__PURE__*/react.createElement("g", {
    id: "pa_svg__b"
  }, /*#__PURE__*/react.createElement("path", {
    id: "pa_svg__a",
    d: "M0-3v3h1.5z",
    transform: "rotate(18 0 -3)"
  }), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#pa_svg__a",
    transform: "scale(-1 1)"
  })), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#pa_svg__b",
    transform: "rotate(72)"
  }), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#pa_svg__b",
    transform: "rotate(144)"
  }), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#pa_svg__b",
    transform: "rotate(216)"
  }), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#pa_svg__b",
    transform: "rotate(288)"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M0 12h18v12H0z"
  }))), pa_g2 || (pa_g2 = /*#__PURE__*/react.createElement("g", {
    fill: "#d21034"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M18 0h18v12H18z"
  }), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#pa_svg__c",
    x: 18,
    y: 12
  }))));
};

/* harmony default export */ var pa = (SvgPa);
;// CONCATENATED MODULE: ./public/flags/ca.svg
var ca_path, ca_path2, ca_path3;

function ca_extends() { ca_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ca_extends.apply(this, arguments); }



var SvgCa = function SvgCa(props) {
  return /*#__PURE__*/react.createElement("svg", ca_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 500"
  }, props), ca_path || (ca_path = /*#__PURE__*/react.createElement("path", {
    fill: "red",
    d: "M0 0h1000v500H0z"
  })), ca_path2 || (ca_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M250 0h500v500H250z"
  })), ca_path3 || (ca_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "red",
    d: "M499.992 46.875 465.88 110.5c-3.87 6.915-10.806 6.274-17.742 2.412l-24.697-12.789 18.408 97.727c3.87 17.854-8.55 17.854-14.678 10.135l-43.101-48.251-6.998 24.503c-.806 3.217-4.354 6.597-9.677 5.792l-54.502-11.459 14.315 52.045c3.065 11.58 5.455 16.375-3.093 19.43l-19.426 9.13 93.82 76.208c3.714 2.882 5.59 8.067 4.268 12.762l-8.21 26.947c32.303-3.724 61.248-9.326 93.568-12.776 2.854-.305 7.63 4.404 7.61 7.71l-4.28 98.724h15.707l-2.472-98.512c-.02-3.306 4.313-8.227 7.166-7.922 32.32 3.45 61.266 9.052 93.57 12.776l-8.211-26.947c-1.322-4.695.554-9.88 4.267-12.762l93.822-76.208-19.427-9.13c-8.548-3.055-6.158-7.85-3.093-19.43l14.315-52.045-54.502 11.46c-5.323.804-8.87-2.576-9.677-5.793l-6.998-24.503-43.1 48.25c-6.13 7.72-18.55 7.72-14.679-10.134l18.407-97.727-24.696 12.789c-6.936 3.862-13.871 4.503-17.742-2.412"
  })));
};

/* harmony default export */ var ca = (SvgCa);
;// CONCATENATED MODULE: ./public/flags/cy.svg
var cy_path, cy_path2, _use, cy_path3;

function cy_extends() { cy_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return cy_extends.apply(this, arguments); }



var SvgCy = function SvgCy(props) {
  return /*#__PURE__*/react.createElement("svg", cy_extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 900 600"
  }, props), cy_path || (cy_path = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h900v600H0z"
  })), cy_path2 || (cy_path2 = /*#__PURE__*/react.createElement("path", {
    id: "cy_svg__a",
    fill: "#435125",
    d: "M434.8 498.25a1.018 1.018 0 0 1-.347-.245l-.125-.117a21.368 21.368 0 0 1-1.582-1.643c-1.332-1.513-3.119-3.728-4.69-5.685-3.115-3.883-5.689-7.228-6.174-7.858l-.793-1.032-7.767-2.395-5.671-2.644 3.03-3.406 10.408 4.456 7.767 1.594 14.363 10.564-.011.009c-.029.024-2.089 1.738-4.136 3.599-.913.83-2.064 1.896-2.877 2.783-.375.408-.705.813-.93 1.14a2.554 2.554 0 0 0-.252.471l.892-.555.967.752-1.968.184-.09.02zm-53.34-16.02c-6.777-.001-13.471-1.874-19.895-5.567l-.007-.004.003-.008s.84-1.601 2.878-3.096c1.941-1.425 5.442-3.128 11.1-3.15h.117c6.701 0 14.901 2.278 24.373 6.771-.32.212-7.756 5.054-18.566 5.054l.01.01zm-29.37-6.51c-1.253 0-2.379-.474-3.17-1.333-.649-.706-1.114-1.646-1.422-2.878-.504-2.018-.365-4.025-.351-4.217a4.349 4.349 0 0 1 1.562-.354l.112-.002c2.511 0 4.49 2.178 5.338 4.337.481 1.227.574 2.259.274 3.067-.3.81-1.24 1.37-2.34 1.37zm51.68-5.99c-17.359-2.479-24.717-8.755-27.833-13.583-3.323-5.149-2.641-9.912-2.634-9.96l.003-.014.013-.004c.005 0 1.061-.285 2.658-.293 4.618 0 16.43 2.323 27.798 23.842l.007.014-.02-.01zm-35.58-3.44c-7.416-.001-13.062-1.28-16.782-3.804-2.138-1.45-3.184-3.043-3.686-4.125-.47-1.014-.577-1.856-.594-2.023.196-.09 3.232-1.438 7.765-1.65.383-.018.769-.029 1.174-.03 5.732 0 14.448 1.87 23.646 10.78l.009.009-.011.001c-4.2.55-8.08.84-11.53.84zm-35.91-1.38c-7.82 0-18.563-2.388-25.263-9.087l-.007-.008.02-.005c.07-.018 7.342-1.863 15.523-2.062.488-.012.979-.019 1.475-.019 7.332 0 12.944 1.422 16.682 4.225 1.305.979 2.018 1.89 2.178 2.783.134.746-.26 1.55-1.056 2.15-1.683 1.271-4.692 1.949-8.945 2.017l-.6.02zm-25.34-13a3.206 3.206 0 0 1-2.479-1.167c-.506-.614-.858-1.416-1.108-2.522-.418-1.848-.292-3.656-.291-3.674l.001-.018a2.994 2.994 0 0 1 1.217-.275h.003c1.157 0 2.039.63 2.589 1.158a6.964 6.964 0 0 1 1.688 2.645c.365 1.03.424 1.892.18 2.635-.2.59-.88 1.21-1.8 1.21zm58.53-1.32c-1.253 0-2.379-.474-3.17-1.333-.649-.706-1.114-1.646-1.422-2.878-.504-2.018-.365-4.025-.351-4.217a4.349 4.349 0 0 1 1.562-.354l.112-.002c2.511 0 4.49 2.178 5.338 4.337.481 1.227.574 2.259.274 3.067-.3.82-1.25 1.37-2.34 1.37zm-28.51-1.18c-15.737-.554-23.904-5.027-27.984-8.683-2.297-2.058-3.574-4.098-4.24-5.447-.628-1.274-.866-2.249-.908-2.438l.021-.009c.003 0 1.489-.532 3.885-.579l.368-.004c5.307 0 16.111 2.229 28.852 17.153v.01zm17.09-1.59c-12.661-1.928-19.834-7.363-23.622-11.585-3.971-4.425-5.16-8.546-5.213-8.738.023-.007 1.57-.41 3.9-.469a17.83 17.83 0 0 1 1.077 0c6.368.139 17.934 3.023 23.855 20.785h.01zm-65-6.08c-4.149 0-8.174-.48-11.962-1.427-6.629-1.658-9.473-4.189-10.691-6.021-.692-1.04-.943-1.952-1.031-2.534a4.268 4.268 0 0 1-.031-1.073l.031-.011c.017-.004 4.4-1.235 10.464-1.328a43.783 43.783 0 0 1 9.289.824c10.536 2.107 16 10.06 16.053 10.14l.005.009-.013.003c-.06.01-5.08 1.42-12.12 1.42zm29.39-10.68c-1.269 0-2.395-.463-3.172-1.304-.639-.691-1.104-1.643-1.42-2.908-.506-2.015-.365-4.002-.351-4.185a4.349 4.349 0 0 1 1.562-.354l.112-.002c2.506 0 4.488 2.179 5.339 4.338.468 1.188.55 2.208.243 3.034-.31.84-1.22 1.38-2.31 1.38zm-22.1-3.03c-.095-.023-5.977-1.536-11.967-5.225-5.544-3.413-12.326-9.45-13.153-18.83v-.005l.014-.004c.001 0 .516-.125 1.278-.154a8.82 8.82 0 0 1 .334-.006c1.656 0 5.046.466 9.147 3.584 5.22 3.98 10.04 10.92 14.35 20.65zm14.43-.53c-.037-.015-4.229-1.693-9.469-6.084-4.882-4.092-11.746-11.46-16.716-23.33.003-.001 1.142-.608 2.886-.718.101-.007.203-.009.306-.009.15 0 .305.005.463.009 2.411.068 6.083 1.07 10.154 5.463 4.676 5.047 8.85 13.34 12.404 24.651l.01.032-.03-.01zm-37.39-1.09c-4.821 0-6.471-2.615-6.957-3.74-.798-1.849-.556-3.689-.554-3.707l.003-.02c.78-.195 1.605-.303 2.398-.314l.165-.001c3.799 0 6.798 1.929 8.084 3.841.255.379 1.037 1.694.39 2.721-.52.81-1.7 1.22-3.53 1.22zm-10.68-13.47c-2.692 0-6.811-.165-11.141-.952-4.294-.781-6.728-4.432-8.013-7.356-1.399-3.185-1.794-6.223-1.798-6.254h.012c13.282.39 19.555 4.271 22.478 7.457 3.018 3.29 3.197 6.706 3.206 6.922l-.009.001c-.02 0-1.89.18-4.74.18zm13.83-13.82a53.416 53.416 0 0 1-3.033-4.228c-1.573-2.445-3.028-4.996-3.028-7.084 0-2.016-.474-6.266-.757-8.619-.358-2.985-.72-5.54-.75-5.757l.013.004c.337.123 8.308 3.114 8.308 10.591 0 7.489-.738 15.014-.745 15.089l-.001.011h-.01zm-10.33-.71c-.084 0-.167-.008-.25-.021-2.356-.393-6.496-2.194-11.073-4.818-5.082-2.914-9.209-6.036-11.62-8.791-2.198-2.512-3.503-6.457-3.88-11.726-.267-3.739.053-6.854.087-7.163.412-.137.85-.204 1.315-.204 1.764.029 3.647.823 6.189 2.574 1.981 1.365 4.165 3.221 6.49 5.514 4.012 3.957 7.168 7.932 7.199 7.971l.032.04c.265.475 2.537 4.571 4.307 8.558 1.124 2.532 1.767 4.357 2.024 5.746.147.791.19 1.31-.004 1.781-.081.195-.235.376-.385.448-.14.06-.28.09-.44.09z"
  })), _use || (_use = /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#cy_svg__a",
    transform: "matrix(-1 0 0 1 842.178 0)"
  })), cy_path3 || (cy_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#d47600",
    d: "m698.83 95.476-2.355.938-.923.368-2.854-.157-2.673 1.283-4.74 3.239-.209.15-1.767.461-1.641-.708-.932.424-.321 1.92-.887 1.379-1.092.767-3.783.387-3.19 1.645-4.15-1.111-1.928.755-4.099 3.692-2.095.992-.732-.042-2.778-.143-1.173.384-1.752 1.693-3.315.258-1.033.715-1.618 3.26-1.753 1.808-1.003.212-1.087-.398-.817.144-.37 2.086-.793.874-2.219.764-1.773 1.477-1.556.799-2.084-.052h-.479l-2.076 1.146-3.905.342-1.624 1.549-.358.331-.758.458-1.24.74-.304.184-1.495-.267-1.75.693-.708-1.089-1.211.727-1.604.069-1.998-.889-1.522-.678-1.113.161-.387 1.94-.039.206-1.17 1.557-2.184 1.323-.297.387-2.485 3.208-4.722 4.966-3.993 2.028-4.139 1.259-2.897 2.38-7.599 3.767-11.994 5.967-2.453.786-3.52.562-6.278 2.312-5.539 1.671-.308.094-1.096.332-7.81 2.363-3.635-.384-2.153.782-5.605-.622-3.897.077-2.467.513-4.637 2.224-7.827 3.762-2.586 2.366-4.027 2.101-4.715 1.493.011-1.981-.028-.084-1.636.517-1.181.373-3.825.59h-2.128l-1.321-.384-.204.069-7.818 2.576-8.719.842-4.363 1.399-3.26-.052-2.038.607-3.995.488-1.428-.381-.322-.088-11.75.51-5.372-.607-2.564.583-4.296-1.445-6.269-.727-1.465-.439-3.295-.978-1.491.859-1.116.119-2.667-.967-.96-.025-2.202.796-1.267-.325-1.177-.938-2.761-.411-1.682-1.414-9.402 1.246-2.551-.75-8.554-2.492-1.361.069-1.696 1.271-2.548.929-2.212.575-3.012.105-3.497-.918-3.606-1.748-1.333-.317-2.974.3-.91.083-5.466-2.932-7.042-4.404-4.778-2.296-1.794-.291-.241.853.89 2.805.303 2.774-.091 2.563-.049 1.587.446 1.425 1.725 1.912.719 1.92.526 5.284-.006 5.362-.839 8.551-.283 1.302-1.001 4.43-.914 4.069-3.546 10.833-.974 1.343-2.391 1.631-5.419 3.688-3.99 2.301-1.263.523-3.239.245-2.018-.105-2.513-1.361-2.467-.635-3.232-2.324-3.595-.744-3.941-2.278-1.026-1.233-2.146-.202-2.976-.893.002-.005-1.093-.327-.755-.22v-.001l-3.796-.104-3.54-1.634-1.864-.45-2.547-.129-2.666 1.239-.001-.004-1.351.629-1.707-.678-1.235.077-1.399 2.115-.209.328-.964.51-1.2-.017-.939-.025-1.016.444-1.368.593v.003l-1.208.527-.59.255-.01-.01-.363.073-.645.112-.8.153-1.41-.824-.75-.442-1.257-.256-.677.489-.133 2.301-.618 1.378-1.961 1.734-1.993 1.755-1.389 2.047-3.676 8.39-2.303 3.385-.715.789-2.408 2.656-2.136 1.657-4.922 3.815-4.659 1.741-4.013.82-1.951.008-3.696-.492-3.323-1.02-3.65-2.282-4.003-3.217-5.794-5.724-.82-.493-.171-.114-1.825-1.167-1.354.035-.53.874-.29 1.263-.245 1.12-.664 6.367.049.369.349 2.622 4.401 6.15 1.358 3.267.223.373.908 1.525.691 1.163.069.118 1.504 4.488-1.057 2.534.534 1.697-1.336 1.037-.245 1.465 3.951 4.953.862 2.185-.963 3.029-1.536 1.671-.429.457.216 1.28 1.818 1.635 3.089 2.75 1.647 4.086 1.253 1.096 1.456-.31.81.618 1.228-.021 1.208 1.208.782.379 1.236.616.977 1.272.216 3.911 1.822 4.86.028 2.635.01.374 1.134 1.948.356 1.538-.604 4.069 1.445 1.306 1.567-.32 1.012.16 1.626 1.354 1.969 3.001 1.926-.282 1.222.589 5.902 5.334 1.339.676.074.042.963.483 1.197 1.208 1.856-1.232.206-.021 2.018-.178.886.597 1.704 1.149 2.234-.029 4.844 1.485 2.119.543 4.261 2.648 1.811 1.12 1.072.871 1.424 1.161 2.845 1.224 2.44.584 1.322.314.995.384.025-.062.014.004-.024.063 5.284 2.023 2.862.668 2.648.975 1.927.703 1.414.023 2-1.682 1.937-.112 1.609.401 1.57-.263 2.485-1.531.485-.719 1.762-.839 5.944-.738 1.737.564 4.46-1.94 2.988.831 2.645-.938 5.779 1.284 1.536 1.081 1.717 1.965.21.009 1.912.037-.799 1.331 2.523 2.647 2.279 3.445.154.455 1.657 4.864 1.232 1.723.862 2.405.042 1.568-1.34 1.022-.22.583-.076.216.272.655.506-.276.963-.533 1.166-.181 2.066.22 1.364.143 2.154-1.069 1.427-.71 2.293.987 2.52-.028 1.058.471 2.995 1.358 1.529.144.565-.371.36-.856-.185-.996-1.145-1.323-2.531-2.938-1.036-1.51-.789-2.186-.245-2.794-.174-1.885.314-2.477.68-.884.5-1.968h.009l.129-.515 1.406-1.866 3.724-2.393 4-3.582 3.162-2.085 3.26-1.412.087-.396.363.146 8.292-2.819.137-.016 3.692-.643 24.92 1.755.924-.279.004-.006.83-2.33.447-.432.297-.282 2.74-1.206 1.281-.183 3.556.878 1.456.359 2.332-1.307 1.654.028 3.417-1.866 2.111.053.803-.321 4.112-2.955 3.961-1.135 1.03-.548.363-.199 4.06-2.144 2.579-1.981 2.226-1.183 2.438-.629 6.38-.449 1.283-2.138 2.744-.366 1.657-1.87 1.896-.771 1.359-1.958 1.139-1.641 1.591-.921 5.1-.32 6.045.749.799-.485 1.366-4.875 1.43-.915 3.851-5.612.013-2.045.004-1.708.633-2.432-.43-4.391.51-4.446 2.394-5.65 2.109-2.279 3.401-2.301 1.729-.753 2.449-.412v-.006l.36-.061.624-.107 8.433-.116c.117-.087 3.067-.042 3.067-.042l2.812-.038 7.114 1.266.506.088 2.405.779 2.774 2.157 2.936 2.868.551.535 1.902.801.575.251 1.571-.251 2.237-1.165 1.688-1.427 2.301-1.257.056-.08 1.295-1.948.039-.04.028.007.003-.011-.022-.005.511-.775 4.447-1.733 5.23-.304.588-.318.327-.175 1.382-1.623 1.295-.011 3.135 1.134 2.204-.437 1.75.699 1.36-.161 2.565-.304 2.754 1.938 1.605.205 5.658 3.31.294.048.152.028.324.053.671-.199.998-.289.132-.039.126.174.643.907.882.126 1.044-1.393-.415-.632-.157-.23-2.021-.411-1.815-3.103 1.728-1.861-2.711-3.326-.45-.551-.153-.234-.937-1.423-4.746-7.235-6.182-4.935-.002.004-2.165-1.732-.014-.01-.758-.596-3.302-3.358-2.358-3.13-.309-.674-.487-1.062-1.413-3.078-2.462-1.896-2.006-2.191-.098-.129-4.14-5.626-.68-.943-.978-.565-2.066-.014-.195-.196-.116-.121.07-.074.991-.985 1.105-.278.476-1.089-2.108-6.104-.014-.213-.157-1.95 1.718-8.855.22-1.079 2.928-5.958 1.814-1.486 1.98-3.892 1.696-2.488 1.625-1.582.284-.168 2.934-1.776 2.465-.347 2.348-.331 4.099 1.264 3.901-.076.761-.081 1.77-.203 2.911-.917 1.374-.848.713-1.093 1.487-4.987.478-1.587.917-1.724 5.306-6.108 4.011-3.71 9.019-6.613 4.415-2.639 2.254-1.347 20.126-8.946 5.23-5.302 2.725-2.757 4.821-3.235 5.641-2.311 4.854-3.842 1.06-1.334 1.336-4.303 1.113-.269 1.005-2.174.286-.618 3.961-2.792.448-.223 15.388-7.71 2.236.307 1.197-1.793 4.477-.751.824-.14 1.104-.551.939-1.599v-.316l.129-4.273.956-1.155.521-2.816.491-.65.513-.676 1.268-.891-.22-.531z"
  })));
};

/* harmony default export */ var cy = (SvgCy);
;// CONCATENATED MODULE: ./public/flags/br.svg
var br_defs, _rect, br_path, br_circle, _clipPath, br_path2, br_g, br_use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25, _use26, _use27;

function br_extends() { br_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return br_extends.apply(this, arguments); }



var SvgBr = function SvgBr(props) {
  return /*#__PURE__*/react.createElement("svg", br_extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-2100 -1470 4200 2940"
  }, props), br_defs || (br_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("path", {
    id: "br_svg__i",
    fillRule: "evenodd",
    d: "M-31.5 0h33a30 30 0 0 0 30-30v-10a30 30 0 0 0-30-30h-33zm13-13h19a19 19 0 0 0 19-19v-6a19 19 0 0 0-19-19h-19z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "br_svg__j",
    transform: "translate(-31.5)",
    d: "M0 0h63v-13H12v-18h40v-12H12v-14h48v-13H0z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "br_svg__l",
    d: "M-26.25 0h52.5v-12h-40.5v-16h33v-12h-33v-11H25v-12h-51.25z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "br_svg__k",
    d: "M-31.5 0h12v-48l14 48h11l14-48V0h12v-70H14L0-22l-14-48h-17.5z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "br_svg__a",
    fillRule: "evenodd",
    d: "M0 0a31.5 35 0 0 0 0-70A31.5 35 0 0 0 0 0m0-13a18.5 22 0 0 0 0-44 18.5 22 0 0 0 0 44"
  }), /*#__PURE__*/react.createElement("path", {
    id: "br_svg__c",
    fillRule: "evenodd",
    d: "M-31.5 0h13v-26h28a22 22 0 0 0 0-44h-40zm13-39h27a9 9 0 0 0 0-18h-27z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "br_svg__n",
    d: "M-15.75-22C-15.75-15-9-11.5 1-11.5s14.74-3.25 14.75-7.75c0-14.25-46.75-5.25-46.5-30.25C-30.5-71-6-70 3-70s26 4 25.75 21.25H13.5c0-7.5-7-10.25-15-10.25-7.75 0-13.25 1.25-13.25 8.5-.25 11.75 46.25 4 46.25 28.75C31.5-3.5 13.5 0 0 0c-11.5 0-31.55-4.5-31.5-22z"
  }), /*#__PURE__*/react.createElement("use", {
    id: "br_svg__o",
    xlinkHref: "#br_svg__f",
    transform: "scale(31.5)"
  }), /*#__PURE__*/react.createElement("use", {
    id: "br_svg__p",
    xlinkHref: "#br_svg__f",
    transform: "scale(26.25)"
  }), /*#__PURE__*/react.createElement("use", {
    id: "br_svg__r",
    xlinkHref: "#br_svg__f",
    transform: "scale(21)"
  }), /*#__PURE__*/react.createElement("use", {
    id: "br_svg__q",
    xlinkHref: "#br_svg__f",
    transform: "scale(15)"
  }), /*#__PURE__*/react.createElement("use", {
    id: "br_svg__s",
    xlinkHref: "#br_svg__f",
    transform: "scale(10.5)"
  }), /*#__PURE__*/react.createElement("g", {
    id: "br_svg__m"
  }, /*#__PURE__*/react.createElement("clipPath", {
    id: "br_svg__b"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M-31.5 0v-70h63V0zM0-47v12h31.5v-12z"
  })), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#br_svg__a",
    clipPath: "url(#br_svg__b)"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M5-35h26.5v10H5z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M21.5-35h10V0h-10z"
  })), /*#__PURE__*/react.createElement("g", {
    id: "br_svg__h"
  }, /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#br_svg__c"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M28 0c0-10 0-32-15-32H-6c22 0 22 22 22 32"
  })), /*#__PURE__*/react.createElement("g", {
    id: "br_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/react.createElement("g", {
    id: "br_svg__e"
  }, /*#__PURE__*/react.createElement("path", {
    id: "br_svg__d",
    transform: "rotate(18 0 -1)",
    d: "M0-1v1h.5"
  }), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#br_svg__d",
    transform: "scale(-1 1)"
  })), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#br_svg__e",
    transform: "rotate(72)"
  }), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#br_svg__e",
    transform: "rotate(-72)"
  }), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#br_svg__e",
    transform: "rotate(144)"
  }), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#br_svg__e",
    transform: "rotate(216)"
  })))), _rect || (_rect = /*#__PURE__*/react.createElement("rect", {
    y: "-50%",
    x: "-50%",
    height: "100%",
    fill: "#009b3a",
    width: "100%"
  })), br_path || (br_path = /*#__PURE__*/react.createElement("path", {
    d: "M-1743 0 0 1113 1743 0 0-1113z",
    fill: "#fedf00"
  })), br_circle || (br_circle = /*#__PURE__*/react.createElement("circle", {
    r: 735,
    fill: "#002776"
  })), _clipPath || (_clipPath = /*#__PURE__*/react.createElement("clipPath", {
    id: "br_svg__g"
  }, /*#__PURE__*/react.createElement("circle", {
    r: 735
  }))), br_path2 || (br_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M-2205 1470a1785 1785 0 0 1 3570 0h-105a1680 1680 0 1 0-3360 0z",
    clipPath: "url(#br_svg__g)"
  })), br_g || (br_g = /*#__PURE__*/react.createElement("g", {
    transform: "translate(-420 1470)",
    fill: "#009b3a"
  }, /*#__PURE__*/react.createElement("use", {
    y: -1697.5,
    xlinkHref: "#br_svg__a",
    transform: "rotate(-7)"
  }), /*#__PURE__*/react.createElement("use", {
    y: -1697.5,
    xlinkHref: "#br_svg__h",
    transform: "rotate(-4)"
  }), /*#__PURE__*/react.createElement("use", {
    y: -1697.5,
    xlinkHref: "#br_svg__i",
    transform: "rotate(-1)"
  }), /*#__PURE__*/react.createElement("use", {
    y: -1697.5,
    xlinkHref: "#br_svg__j",
    transform: "rotate(2)"
  }), /*#__PURE__*/react.createElement("use", {
    y: -1697.5,
    xlinkHref: "#br_svg__k",
    transform: "rotate(5)"
  }), /*#__PURE__*/react.createElement("use", {
    y: -1697.5,
    xlinkHref: "#br_svg__l",
    transform: "rotate(9.75)"
  }), /*#__PURE__*/react.createElement("use", {
    y: -1697.5,
    xlinkHref: "#br_svg__c",
    transform: "rotate(14.5)"
  }), /*#__PURE__*/react.createElement("use", {
    y: -1697.5,
    xlinkHref: "#br_svg__h",
    transform: "rotate(17.5)"
  }), /*#__PURE__*/react.createElement("use", {
    y: -1697.5,
    xlinkHref: "#br_svg__a",
    transform: "rotate(20.5)"
  }), /*#__PURE__*/react.createElement("use", {
    y: -1697.5,
    xlinkHref: "#br_svg__m",
    transform: "rotate(23.5)"
  }), /*#__PURE__*/react.createElement("use", {
    y: -1697.5,
    xlinkHref: "#br_svg__h",
    transform: "rotate(26.5)"
  }), /*#__PURE__*/react.createElement("use", {
    y: -1697.5,
    xlinkHref: "#br_svg__j",
    transform: "rotate(29.5)"
  }), /*#__PURE__*/react.createElement("use", {
    y: -1697.5,
    xlinkHref: "#br_svg__n",
    transform: "rotate(32.5)"
  }), /*#__PURE__*/react.createElement("use", {
    y: -1697.5,
    xlinkHref: "#br_svg__n",
    transform: "rotate(35.5)"
  }), /*#__PURE__*/react.createElement("use", {
    y: -1697.5,
    xlinkHref: "#br_svg__a",
    transform: "rotate(38.5)"
  }))), br_use || (br_use = /*#__PURE__*/react.createElement("use", {
    y: -132,
    x: -600,
    xlinkHref: "#br_svg__o"
  })), _use2 || (_use2 = /*#__PURE__*/react.createElement("use", {
    y: 177,
    x: -535,
    xlinkHref: "#br_svg__o"
  })), _use3 || (_use3 = /*#__PURE__*/react.createElement("use", {
    y: 243,
    x: -625,
    xlinkHref: "#br_svg__p"
  })), _use4 || (_use4 = /*#__PURE__*/react.createElement("use", {
    y: 132,
    x: -463,
    xlinkHref: "#br_svg__q"
  })), _use5 || (_use5 = /*#__PURE__*/react.createElement("use", {
    y: 250,
    x: -382,
    xlinkHref: "#br_svg__p"
  })), _use6 || (_use6 = /*#__PURE__*/react.createElement("use", {
    y: 323,
    x: -404,
    xlinkHref: "#br_svg__r"
  })), _use7 || (_use7 = /*#__PURE__*/react.createElement("use", {
    y: -228,
    x: 228,
    xlinkHref: "#br_svg__o"
  })), _use8 || (_use8 = /*#__PURE__*/react.createElement("use", {
    y: 258,
    x: 515,
    xlinkHref: "#br_svg__o"
  })), _use9 || (_use9 = /*#__PURE__*/react.createElement("use", {
    y: 265,
    x: 617,
    xlinkHref: "#br_svg__r"
  })), _use10 || (_use10 = /*#__PURE__*/react.createElement("use", {
    y: 323,
    x: 545,
    xlinkHref: "#br_svg__p"
  })), _use11 || (_use11 = /*#__PURE__*/react.createElement("use", {
    y: 477,
    x: 368,
    xlinkHref: "#br_svg__p"
  })), _use12 || (_use12 = /*#__PURE__*/react.createElement("use", {
    y: 551,
    x: 367,
    xlinkHref: "#br_svg__r"
  })), _use13 || (_use13 = /*#__PURE__*/react.createElement("use", {
    y: 419,
    x: 441,
    xlinkHref: "#br_svg__r"
  })), _use14 || (_use14 = /*#__PURE__*/react.createElement("use", {
    y: 382,
    x: 500,
    xlinkHref: "#br_svg__p"
  })), _use15 || (_use15 = /*#__PURE__*/react.createElement("use", {
    y: 405,
    x: 365,
    xlinkHref: "#br_svg__r"
  })), _use16 || (_use16 = /*#__PURE__*/react.createElement("use", {
    y: 30,
    x: -280,
    xlinkHref: "#br_svg__p"
  })), _use17 || (_use17 = /*#__PURE__*/react.createElement("use", {
    y: -37,
    x: 200,
    xlinkHref: "#br_svg__r"
  })), _use18 || (_use18 = /*#__PURE__*/react.createElement("use", {
    y: 330,
    xlinkHref: "#br_svg__o"
  })), _use19 || (_use19 = /*#__PURE__*/react.createElement("use", {
    y: 184,
    x: 85,
    xlinkHref: "#br_svg__p"
  })), _use20 || (_use20 = /*#__PURE__*/react.createElement("use", {
    y: 118,
    xlinkHref: "#br_svg__p"
  })), _use21 || (_use21 = /*#__PURE__*/react.createElement("use", {
    y: 184,
    x: -74,
    xlinkHref: "#br_svg__r"
  })), _use22 || (_use22 = /*#__PURE__*/react.createElement("use", {
    y: 235,
    x: -37,
    xlinkHref: "#br_svg__q"
  })), _use23 || (_use23 = /*#__PURE__*/react.createElement("use", {
    y: 495,
    x: 220,
    xlinkHref: "#br_svg__p"
  })), _use24 || (_use24 = /*#__PURE__*/react.createElement("use", {
    y: 430,
    x: 283,
    xlinkHref: "#br_svg__r"
  })), _use25 || (_use25 = /*#__PURE__*/react.createElement("use", {
    y: 412,
    x: 162,
    xlinkHref: "#br_svg__r"
  })), _use26 || (_use26 = /*#__PURE__*/react.createElement("use", {
    y: 390,
    x: -295,
    xlinkHref: "#br_svg__o"
  })), _use27 || (_use27 = /*#__PURE__*/react.createElement("use", {
    y: 575,
    xlinkHref: "#br_svg__s"
  })));
};

/* harmony default export */ var br = (SvgBr);
;// CONCATENATED MODULE: ./public/flags/mu.svg
var mu_path, mu_path2, mu_path3, mu_path4;

function mu_extends() { mu_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return mu_extends.apply(this, arguments); }



var SvgMu = function SvgMu(props) {
  return /*#__PURE__*/react.createElement("svg", mu_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6 4"
  }, props), mu_path || (mu_path = /*#__PURE__*/react.createElement("path", {
    fill: "#00A551",
    d: "M0 0h6v4H0z"
  })), mu_path2 || (mu_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#FFD500",
    d: "M0 0h6v3H0z"
  })), mu_path3 || (mu_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#1A206D",
    d: "M0 0h6v2H0z"
  })), mu_path4 || (mu_path4 = /*#__PURE__*/react.createElement("path", {
    fill: "#EA2839",
    d: "M0 0h6v1H0z"
  })));
};

/* harmony default export */ var mu = (SvgMu);
;// CONCATENATED MODULE: ./public/flags/me.svg
var me_path, me_path2, me_path3, me_path4, me_path5, me_path6, me_path7, me_path8, me_path9, me_path10, me_path11, me_path12, me_path13, me_ellipse, me_path14, me_path15, me_path16, me_path17, me_path18, me_path19, me_path20, me_path21, me_path22, me_path23, me_circle, me_path24, me_ellipse2, me_ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, me_path25, me_g, me_path26, me_path27, me_path28, me_path29, me_path30, me_path31, me_circle2, me_circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, me_use;

function me_extends() { me_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return me_extends.apply(this, arguments); }



var SvgMe = function SvgMe(props) {
  return /*#__PURE__*/react.createElement("svg", me_extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 640 320"
  }, props), me_path || (me_path = /*#__PURE__*/react.createElement("path", {
    fill: "#d3ae3b",
    d: "M0 0h640v320H0z"
  })), me_path2 || (me_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#c40308",
    d: "M16 16h608v288H16z"
  })), me_path3 || (me_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#B96B29",
    d: "M389.64 157.4c1.87-.53 8.39-2.43 12.98-6.16 4.6-3.72 5.49-6.7 5.86-8.32.37-1.61.53-2.88-.66-1.96-1.19.93-4.75 3.73-7.18 5.08a26.85 26.85 0 0 1-5.99 2.35c-1.32.37-2.37.6-1.1.1 1.26-.5 5.4-1.95 8.6-5.15 3.19-3.2 5.71-7.99 5.76-10.93.06-2.94-.15-2.73-1.1-2-.94.74-4.3 4.9-6.2 6.47a60.01 60.01 0 0 1-6.46 4.57c-1.52.9-3.67 1.89-.68-.16 3-2.05 8.67-6.88 10.98-13.13 2.31-6.25 1.89-9.93 1.84-10.56-.06-.63-.58-1.9-1.1-.73-.53 1.15-4.32 8.72-7.36 11.97-3.05 3.26-2.31 2.63-3 3.15-.68.53-1.83 1.47-.36-.37 1.47-1.83 4.52-6.09 6.1-10.29 1.57-4.2 1.99-8.4 2.04-10.82.05-2.42-1-5.78-1.47-6.78s-.95-1.73-1.1-.58c-.16 1.16-2.58 8.62-3.9 12.24a47.14 47.14 0 0 1-4.46 8.51c-.52.8-1.89 2.42-.42-.31s4.31-10.77 4.68-18.39c.37-7.61-.68-11.81-1.74-13.92-1.05-2.1-1.96-2.84-1.96-2.84s.18 5.2-1.37 12.67-3.82 11.41-3.82 11.41-.95 1.08-.3-.71a31.8 31.8 0 0 0 1.77-8.36c.44-4.72.5-10.1-.88-14.66-1.5-4.98-4.1-7.52-4.1-7.52-.73 7.14-.59 16.34-3.2 23.8-.5-.44-1.14-1.25-1.4.4a42.09 42.09 0 0 1-4.66 12.9c-3.22 5.87-4.53 6.64-4.53 6.64s-.6-1.43-1.02-2.2c-.41-.78-.65-1.2-1.19-.13-.54 1.08-2.33 5.2-6.27 9.74-3.93 4.55-6.14 6.76-6.02 10.16.12 3.41 1.9 5.14 4.3 6.7 2.38 1.55 2.8 2.39 2.44 4.24-.36 1.85-2.5 2.51-4.35 2.57-1.86.06-4.18-.12-5.02.36-.83.48-.9 1.67-1.73 2.5-.83.84-1.2 1.32-1.97 1.44l-.67.09c-.17-8.99 3.31-13 3.31-13l-9.73-11.42-1.5.7a2.72 2.72 0 0 0-.29-.44 7.46 7.46 0 0 1-1.72-5.18c.48.05 1.46.4 2.34.22.88-.17.22-1.06-.05-1.9-.26-.84-.53-3.76-.35-4.86l.26-1.55s1.42 1.55 2.3 1.55c.88 0 .8-.89.92-1.86.2-1.47.9-3.32 2.03-4.34 0 0 1.55 1.07 3.31 1.07a8.7 8.7 0 0 0 6.04-2.3c1.9-1.82 1.85-2.26 1.85-2.26s3.53 1.24 6.22 1.37c2.7.14 5.56-.3 6.93-3.14 1.36-2.83-.4-5.44-.7-5.88-.32-.44-1.2-.8-1.2 0s.05 2.92-1.59 3.98c-1.63 1.06-2.9 1.02-4.45.53a13.68 13.68 0 0 0-8.73-.23c.12-.11 2.13-2.18 4.1-2.78 2.03-.62 3.22.22 3.88 1.02s1.23 2.08 1.76.22a6.9 6.9 0 0 0-.66-5.35 5.05 5.05 0 0 0-4.76-2.04c-1.98.23-2.69.53-2.69.53s-1.01-2.87-3.57-3.4c-3.12-.65-6.56.52-9.26 2.03 0 0-2.12.5-4.28-.13a13.96 13.96 0 0 1-3.64-1.81l.73-2.35 1.27-.43c.64-.25.5-.46.59-1 .08-.54-1.22-1.48-1.22-1.48s-.18-1.61 1.94-2.72c2.13-1.11 1.9-.93 1.9-.93s1.25.24 1.76-.13c.5-.37.5-.6.5-.6s.94-.31 1.3-.88c.34-.57.4-1.39.15-2.05-.25-.66-.57-.8-.22-1.1.34-.32.66-1.08.69-1.61l.03-.67s.72-.25.7-1.35c-.04-1.1-.64-1.55-.99-1.65-.34-.09-.56-.09-.56-.09s-.06-.66-.63-1.54c-.57-.89-.94-1.27-.94-1.27s.4-.31.19-1.04a1.94 1.94 0 0 0-1.23-1.32c-.5-.16-1.04 0-1.04 0s-1.67-1.01-2.45-1.42l-.98-.5s-.03-.7-.31-1.08-.95-.54-1.3-.54-.71.2-.71.2-2.84-.73-4-.92c-1.16-.2-1.23-.29-1.23-.29s-2.51-1.2-3.49-1.38c-.97-.2-1.25-.29-1.25-.29s1.01-1.23 1.08-2.65a3.95 3.95 0 0 0-1.89-3.36c-.57-.33-.87-.39-1.06-.5l-.02-.98 1.9.19.15-3.04-1.84.23.28-1.83-3.86-.05.29 1.83-1.86-.12.16 3 1.95-.26-.19 1.14s-.71.12-1.32.56c-1 .6-1.86 1.77-1.8 3.2.07 1.41.92 2.67.92 2.67s-.25.07-1.23.25c-.97.2-3.49 1.4-3.49 1.4s-.06.09-1.23.28c-1.16.19-4 .91-4 .91s-.37-.19-.72-.19c-.34 0-1 .16-1.28.54-.29.38-.32 1.07-.32 1.07l-.97.5c-.8.42-2.46 1.43-2.46 1.43s-.53-.16-1.04 0c-.5.16-1 .6-1.22 1.32s.19 1.04.19 1.04-.38.38-.95 1.26c-.56.89-.63 1.55-.63 1.55s-.22 0-.56.1c-.35.09-.95.53-.98 1.64-.03 1.1.7 1.35.7 1.35l.03.66c.03.54.34 1.3.69 1.61.34.32.03.44-.22 1.1-.25.67-.2 1.49.15 2.06.35.56 1.3.87 1.3.87s0 .23.5.6 1.76.14 1.76.14-.23-.18 1.9.93c2.12 1.1 1.93 2.72 1.93 2.72s-1.3.94-1.21 1.48c.08.54-.06.75.59 1 .65.24 1.26.43 1.26.43l.73 2.35c-.8.54-2.22 1.4-3.63 1.81-2.16.62-4.28.13-4.28.13-2.7-1.5-6.14-2.68-9.26-2.03-2.56.53-3.58 3.4-3.58 3.4s-.7-.3-2.68-.53a5.06 5.06 0 0 0-4.77 2.04 6.9 6.9 0 0 0-.66 5.35c.53 1.86 1.1.57 1.76-.22.67-.8 1.86-1.64 3.89-1.02 1.97.6 3.98 2.66 4.1 2.78a13.68 13.68 0 0 0-8.73.23 4.67 4.67 0 0 1-4.46-.53c-1.63-1.06-1.59-3.19-1.59-3.98s-.88-.44-1.19 0-2.07 3.05-.7 5.88c1.36 2.83 4.23 3.27 6.92 3.14 2.7-.13 6.22-1.37 6.22-1.37s-.04.44 1.85 2.26c1.9 1.8 4.28 2.3 6.04 2.3s3.31-1.07 3.31-1.07c1.14 1.02 1.83 2.87 2.03 4.34.13.97.04 1.86.93 1.86.88 0 2.29-1.55 2.29-1.55s.09.44.26 1.55c.18 1.1-.08 4.02-.35 4.86-.26.84-.93 1.73-.04 1.9.88.18 1.85-.17 2.33-.22 0 2.12-.42 3.52-1.72 5.18l-.27.4c-.48-.2-.96-.43-1.44-.67l-9.73 11.44s3.5 4.02 3.3 13.06v-.07c-.17-.01-.4-.04-.7-.09-.78-.12-1.14-.6-1.97-1.43-.84-.84-.9-2.03-1.73-2.51s-3.17-.3-5.02-.36c-1.85-.06-4-.72-4.35-2.57-.36-1.85.06-2.69 2.44-4.24 2.4-1.56 4.18-3.29 4.3-6.7.12-3.4-2.09-5.61-6.03-10.16-3.94-4.54-5.73-8.66-6.26-9.74s-.78-.65-1.2.12c-.41.78-1.01 2.21-1.01 2.21s-1.31-.77-4.54-6.63a42 42 0 0 1-4.65-12.91c-.26-1.65-.9-.84-1.4-.4-2.62-7.46-2.47-16.66-3.2-23.8 0 0-2.6 2.54-4.1 7.52-1.38 4.57-1.33 9.94-.89 14.66.42 4.5 1.33 7.15 1.77 8.36.66 1.79-.3.71-.3.71s-2.26-3.94-3.81-11.41c-1.56-7.47-1.38-12.67-1.38-12.67s-.9.74-1.96 2.84c-1.05 2.1-2.1 6.3-1.73 13.92.37 7.62 3.2 15.66 4.68 18.39 1.47 2.73.1 1.1-.43.31a47.3 47.3 0 0 1-4.46-8.5c-1.31-3.63-3.73-11.09-3.89-12.25-.16-1.15-.63-.42-1.1.58-.47 1-1.52 4.36-1.47 6.78a34.3 34.3 0 0 0 2.05 10.82c1.57 4.2 4.62 8.46 6.09 10.3 1.47 1.83.31.89-.37.36s.05.1-3-3.15-6.82-10.82-7.35-11.97c-.52-1.16-1.05.1-1.1.73-.05.63-.47 4.3 1.84 10.56 2.31 6.25 7.98 11.08 10.98 13.13 3 2.05.84 1.05-.69.16-1.52-.9-4.57-3-6.46-4.57-1.89-1.58-5.25-5.73-6.2-6.46-.94-.74-1.15-.95-1.1 2s2.58 7.72 5.77 10.92c3.2 3.2 7.33 4.65 8.6 5.15 1.27.5.21.27-1.1-.1a26.8 26.8 0 0 1-6-2.35c-2.42-1.35-5.98-4.15-7.17-5.08-1.19-.92-1.03.35-.66 1.96.37 1.61 1.26 4.6 5.85 8.32 4.6 3.73 11.11 5.63 12.99 6.16 1.87.53.55.53.55.53s-.74-.1-4.54-.95-9.55-3.86-11.1-4.84c-1.56-.98-1.8-1.35-1.59.71.21 2.06 2.4 6.48 5.91 8.54s9.84 3.12 11.48 3.2c1.63.08 1.21.31.47.37-.74.05-2.56.05-5.54-.3-2.44-.28-6.07-1.46-7.3-1.88-.14-.53-.27-1.04-.33-1.35-.14-.79-.55-.67-.8-.5-.27.18-.42.32-1.28.76-.88.44-.9-.09-.93-.35-.03-.26-.2-1.4-.24-1.98-.03-.58-.35-.61-.75-.44l-3.08 1.32c-.72.32-.06.9.32 1.6.38.7.96 1.71.96 1.71l-2.41.65c-.58.14-.4.55-.26.96.14.4 1.04 2.44 1.28 3.02s.75.24.75.24l1.83-1.08.64 2.44c-.03.04-.85.2-1.77.85-.93.65-.7 1.48.41 1.8 1.11.33 2.4.89 3.84 3.48 1.43 2.6 1.8 7.28 2.68 14.65.88 7.36 5.59 11.12 6.24 11.58s.27.84.27.84-.64.93-.37 2.36a3.55 3.55 0 0 0 2.17 2.5c.65.24.47.89.47.89s-.33 1.57 0 4.45c.32 2.87 2.68 6.11 3.32 6.67.65.55.7.83.6 1.07-.09.23-.5.04-1.29.64a8.15 8.15 0 0 0-2.22 2.46c-.55 1.02-.37 1.62-.18 3.01.18 1.4 2.22 2.65 2.22 2.65s-.37.09-.47 1.1c-.09 1.03.65 2.19 1.58 2.93.92.74 2.68 1.1 2.68 1.1l.23 1.5c.09.6 1.24 1.2 1.98 1.61.74.42 2.17.19 2.78-.09.6-.28 1.01.05 1.38.65.37.6.23 2.92.23 3.85 0 .92-.55 1.9-.23 2.36.32.46 1.2.14 2.08-.37.88-.51 1.11-.14 1.9.37a6 6 0 0 0 2.35.93c.33-.05.19-.88.19-1.58s.12-2.27.45-2.5c.15-.1 1.5-.21 2.55-.65.49-.2 1.11-.42 1.16-.88.04-.46-.65-.46-2.18-1.25-1.52-.79-1.8-1.25-2.77-1.9-.97-.65-.5-.88-.5-1.16 0-.28.46-.6.64-.97s.1-1.2.1-1.2.78-.8 1.15-1.21c.37-.42.83-1.07 1.34-1.49s1.3-2.4 1.8-3.06c.5-.64 1.66-1.34 2.36-2.22.69-.88 2.54-2.32 3.6-3.01 1.06-.7 3.93-2.04 3.93-2.04s-.05 1.71.7 2.55c.73.83 1.7-.65 4.98-2.97 3.28-2.32 5.78-3.15 5.78-3.15s.69 1.06 1.57 2.18c.87 1.1 1.66-.05 5.68-5.61a72.84 72.84 0 0 1 8.97-9.9l.9.4c-.09.22-.17.46-.25.72-.37 1.16-.97 1.9-1.75 3.5-.79 1.62-1.98 1.98-3.36 4.15-1.39 2.16-1.57 3.64-1.7 5.85-.15 2.2 1.1 2.67 1.1 2.67s-2.03 1.98-2.63 3.45c-.6 1.47-.92 4.47-.92 4.47s-.32.13-1.06 1.65c-.74 1.53-2.07 1.75-4 3.69-1.94 1.93-4.1 2.76-5.12 3.36-1 .6-.73 1.2-.46 1.98.28.78 1.66 1.56 3.27 2.16 1.62.6 2.17.37 3.27.32 1.1-.04.23.83-.23 1.3-.46.45-1.06 2.06-.96 3.86.09 1.8 1.42 1.38 3.08 1.1 1.66-.27 3.6-1.1 3.6-1.1l-.19.5c-.18.51-.28.88-.28 2.31 0 1.43.23 2.12.65 2.49.41.36 1.24-.42 1.84-.6.6-.19 1.61-.78 3.09-1.1 1.47-.33 2.02-.97 2.02-.97s-.37.46-.46 1.47c-.1 1.01-.05 2.53.19 3.4.22.88.87 1.94 1.88 2.86 1.02.92 1.25.5 1.98-.64.74-1.15 2.26-2.63 2.26-2.63s.09.37 1.1 3.64c1.02 3.27 4.33 5.99 4.33 5.99s3.32-2.72 4.33-6c1.01-3.26 1.1-3.63 1.1-3.63s1.52 1.48 2.26 2.63c.74 1.15.97 1.56 1.98.64a6.29 6.29 0 0 0 1.89-2.85c.23-.88.27-2.4.18-3.41-.09-1.01-.46-1.47-.46-1.47s.55.64 2.03.96c1.47.33 2.48.92 3.08 1.1.6.2 1.43.97 1.84.6.42-.36.65-1.05.65-2.48s-.1-1.8-.28-2.3l-.18-.51s1.93.83 3.6 1.1 2.98.7 3.08-1.1c.09-1.8-.51-3.4-.97-3.87-.46-.46-1.34-1.33-.23-1.29 1.1.05 1.66.28 3.27-.32 1.6-.6 3-1.38 3.27-2.16.27-.78.55-1.38-.46-1.98-1.02-.6-3.18-1.43-5.11-3.36-1.94-1.94-3.27-2.16-4.01-3.69-.74-1.52-1.06-1.65-1.06-1.65s-.32-3-.92-4.47c-.6-1.47-2.62-3.45-2.62-3.45s1.24-.46 1.1-2.67c-.14-2.21-.32-3.69-1.7-5.85-1.38-2.17-2.58-2.53-3.37-4.15-.78-1.6-1.38-2.34-1.74-3.5a21.1 21.1 0 0 0-.24-.7l1.19-.51a72.7 72.7 0 0 1 8.99 9.9c4.02 5.57 4.8 6.73 5.68 5.62.88-1.11 1.57-2.18 1.57-2.18s2.5.83 5.78 3.15c3.28 2.32 4.25 3.8 4.99 2.97.39-.44.47-1.17.52-1.73a69.7 69.7 0 0 1 7.84 2.78c2.85 1.2 3.16 1.83 5.42 3.61s5.48 1.62 8.53.69c3.04-.93 11.16-3.6 14.42-5.02 3.25-1.4 5.58-2.64 5.92-3.3.34-.65.72-2.47.72-3.12 0-.65-.72-1.62-.96-1.79-.24-.17-.13-.69-.07-1.1a3.45 3.45 0 0 0-.65-2.2c-.5-.55-.44-.75-.37-2.33.14-3.36-2.25-7.58-5.64-8.93 0 0-.09-.39-.36-.62-.28-.22-.73-.43-.73-.43s.06-1.93.04-2.34c-.02-.41.16-.37.4-.25.22.11.58.57 1.13.7.55.15.9-.25 1.01-.86.11-.62.57-1.86.78-2.48.2-.62-.05-.71-.3-.78-.25-.07-1.07-.16-1.46-.25-.4-.1-.4-.12-.3-.32.1-.21.23-.53.73-1.31s.05-.8-.44-.96c-.48-.17-2.65-.83-3.24-.92-.6-.1-.73.4-.73.66s.02 1.36.04 1.77-.36.3-.6.18a8.45 8.45 0 0 1-1.16-.76c-.41-.32-.7-.02-.87.44-.16.46-.66 2.34-.82 2.9-.16.54-.12.98.11 1.07.23.1 1.3 0 1.95 0 .64 0 .27.37.27.37s-.69 1.12-.91 1.56c-.23.43-.62.5-1.15.5h-1.4s-3.52.13-6.1 2.05c-2.6 1.92-3.32 3.52-3.72 4.44-.4.93-.86.73-1.26 1.06-.4.34-1.52 1.53-1.52 2.26 0 .73.26 1.13-.87 1.86-1.12.73-2.05 3.9-.53 5.57 1.53 1.65 2.13 3.3 2.6 4.1.45.8 0 1.13-.4 1.13s-1.24-.67-1.93-1.2c-.7-.5-4.2-3.24-5.7-4.37-1.5-1.12-.4-1-.4-1s.38.04 1.26-.33 1.02-.83.14-1.1a11.14 11.14 0 0 1-3.05-1.72c-.46-.47-.7-.98.19-1.44.87-.46 2.81-1.71 1.29-2.13-1.53-.42-3.33-.74-4.8-1.16-1.49-.42-1.63-.83-1.63-.83l.98-1.4s.78-1.1-.14-1.25-3.14-.41-5.18-1.3c-4.06-1.75-6.6-4.74-7.55-8.38l.07-.09c.76 1.5 2.53 4.3 5.19 4.4 3.64.12 4.06-1.02 3.22-2.22s-1.79-2.27-2.03-2.62c-.24-.36-.3-.84.66.06s2.77 3.94 8.26 3.58c5.5-.36 5.46-1.43 5.46-1.73 0-1.06-1.11-1.22-1.77-1.88-.35-.35-.56-.85.55-.43s3.83.93 7.52.13c1.46-.3 5.33-2 5.7-3.96 0 0-2.45-.13-4.17-.87-1.71-.74-2.74-1.35-.92-.98 1.82.37 5.36 1.11 8.47.06 1.82-.62 4.17-2.1 4.17-4.79 0 0-3.38-.71-4.62-1.16-1.24-.45-1.64-.8-1.64-.8s4.83 1.54 9.21-.68c4.38-2.22 4.57-5.26 4.57-5.97s-.1-.93-.1-.93-4 .98-6.97.95c-2.99-.02-3.9-.29-3.9-.29s8.33-.23 12.52-2.8c4.2-2.56 4.44-7.6 4.44-7.6s-4.75 1.68-7.73 2.03c-2.98.34-4.8.34-5.54.29-.74-.06-1.16-.3.47-.37 1.64-.08 7.97-1.14 11.48-3.2 3.5-2.06 5.7-6.48 5.91-8.53.21-2.07-.03-1.7-1.58-.72-1.56.98-7.31 4-11.11 4.84-3.8.84-4.54.95-4.54.95s-1.46-.07.42-.6zm-150.1 9.58-1.68.96s-.67-1.37-.85-1.77c-.17-.41-.08-.59.15-.59.23 0 .93-.2 1.48-.26.08 0 .15-.02.21-.03.19.52.43 1.09.75 1.66l-.06.04zm51.18 29.97c-1.02 1.9-3.79 3.9-5.82 4.78s-4.25 1.15-5.18 1.3c-.92.13-.14 1.24-.14 1.24l.97 1.4s-.13.41-1.61.83-3.28.74-4.8 1.16c-1.53.41.4 1.67 1.28 2.13.88.46.65.97.19 1.44-.46.46-2.17 1.43-3.05 1.71s-.74.75.14 1.12c.88.36 3.28.83 3.28.83s-.05.1-1.52 1.2a12.1 12.1 0 0 1-5.78 1.95c-1.71.1-4.41.2-7.84.05-3.43-.16-3.82-.24-3.82-.24s-.12-1.14-.36-2.84c-.23-1.69-1.26-4.1-2.05-5.2-.78-1.1-2.44-3.3-2.44-3.3s.04-.48.16-1.03.04-1.14-.36-2.18c-.4-1.05-2.4-2.57-2.4-2.57s-.09-1.12-.09-2.16-.72-5.13-1.36-7.05c-.64-1.92-3.76-6.97-5.2-9.37-1.45-2.4-2.3-5.96-2.74-8.73-.43-2.76-.26-3.67-.11-4.4.06-.31.2-.6.32-.86a8.6 8.6 0 0 0 2.32 2.08c4.2 2.56 12.54 2.8 12.54 2.8s-.93.27-3.9.3c-2.99.02-6.97-.96-6.97-.96s-.11.21-.11.93.19 3.75 4.56 5.97c4.38 2.22 9.21.69 9.21.69s-.4.34-1.63.79c-1.24.45-4.62 1.16-4.62 1.16 0 2.7 2.35 4.17 4.17 4.78 3.11 1.06 6.65.32 8.47-.05 1.82-.37.8.24-.93.98-1.7.74-4.16.87-4.16.87.37 1.96 4.24 3.65 5.7 3.96 3.69.8 6.4.3 7.52-.13s.9.08.55.42c-.66.67-1.78.83-1.78 1.89 0 .3-.03 1.37 5.46 1.73s7.31-2.69 8.27-3.59c.95-.9.9-.42.65-.06-.23.36-1.19 1.44-2.02 2.63-.84 1.2-.42 2.33 3.22 2.21 2.68-.08 4.45-2.93 5.2-4.42l.05.07.15.2c-.34.88-.93 2.32-1.58 3.54zM335 78.19c-.5-.94-.76-1.39-.76-1.39s2.07.97 3.3 2.36c1.23 1.4 1.2 2.13 1.39 2.81.18.69 0 1.94-.19 3.13-.18 1.18-.18 1.89.06 2.3.23.43.44.64.44.64s-.92.23-1.78.57c-.86.35-1.99.66-2.62.14-.63-.53-.78-.9-.39-1.24.4-.34 1.86-.76 2.04-3.28.18-2.52-.99-5.1-1.49-6.04zm-11.28 6.86c.47-1.2.67-2.34.3-4.8-.3-2.06-.7-3.82-.8-6.04 0 0 1.53.33 3.72 2.34 2.2 2 2.7 4.07 2.7 5.07s-.53 2.23-.61 3.2c-.09.98.27 1.85.27 1.85s-.8.33-1.52.83c-.73.5-1.23.8-2.34.75-1.1-.05-1.78-.55-2.42-.89s-1.05-.39-1.05-.39 1.27-.72 1.74-1.92zm-10.7-8.5c2.2-2 3.72-2.34 3.72-2.34-.1 2.22-.5 3.98-.8 6.05-.36 2.45-.17 3.59.3 4.79.48 1.2 1.75 1.92 1.75 1.92s-.41.06-1.05.39c-.64.33-1.3.84-2.42.9-1.11.05-1.61-.26-2.33-.76-.73-.5-1.53-.83-1.53-.83s.36-.87.27-1.84c-.08-.98-.6-2.2-.6-3.2 0-1.01.5-3.07 2.7-5.08zm-7.91 12.2c-.63.52-1.75.2-2.62-.13-.86-.35-1.78-.58-1.78-.58s.21-.21.45-.63c.23-.42.23-1.13.05-2.31-.18-1.19-.37-2.44-.18-3.13.18-.68.15-1.42 1.38-2.8 1.23-1.4 3.3-2.37 3.3-2.37s-.26.45-.76 1.39c-.5.95-1.67 3.52-1.49 6.04.18 2.52 1.65 2.94 2.04 3.28.4.34.23.71-.4 1.24zm29.24 21.07c-2.16 1.2-3.4.93-3.3 1.82.08.88 2.02 1.55 2.02 1.55s-1.98 2.12-3.53 3.1c-1.54.97-3.35 1.59-3.35 1.59s-.62.08-.27 1.06c.36.97.97 1.63 1.46 1.9.48.26.75.35.75.35s-2.69 2.88-3.88 3.8c-1.2.94-1.85 1.25-2.82 1.64-.97.4-.49 2-.27 2.7.22.7 1.06 1.68 1.55 1.82.48.13.66.48.04 1.46-.46.72-2 2.65-2.74 3.72l-.04.02c-.73-1.06-2.29-3.01-2.75-3.74-.62-.98-.44-1.33.04-1.46s1.32-1.11 1.54-1.82c.22-.7.71-2.3-.26-2.7-.97-.4-1.63-.7-2.82-1.63-1.2-.93-3.88-3.8-3.88-3.8s.26-.1.75-.36a3.6 3.6 0 0 0 1.45-1.9c.35-.98-.26-1.06-.26-1.06s-1.81-.62-3.36-1.6c-1.54-.97-3.52-3.1-3.52-3.1s1.94-.66 2.03-1.54c.08-.89-1.15-.62-3.31-1.82s-2.87-2.7-2.87-2.7 2.51-.83 3.75-3.36c.44-.89.54-1.7.5-2.39l.1.04c4 1.3 8.7 1.83 12.9 1.83 4.18 0 8.87-.53 12.87-1.83l.1-.04c-.05.69.06 1.5.5 2.4 1.23 2.52 3.74 3.36 3.74 3.36s-.7 1.5-2.86 2.7z"
  })), me_path4 || (me_path4 = /*#__PURE__*/react.createElement("path", {
    fill: "#D4AF3A",
    d: "M347.47 158.5c0-6.79 3.12-11.08 3.12-11.08l-8.5-9.73c-8.08 3.13-15.5 3.32-22.09-.04-6.6 3.36-14 3.17-22.1.04l-8.5 9.73s3.13 4.3 3.13 11.08c0 6.79-1.31 11.82-2.08 15.1-.76 3.29-1.42 9.41.33 13.8 1.75 4.37 3.61 8.2 11.16 11.37s11.5 4.82 14.12 7c2.63 2.2 3.94 3.95 3.94 3.95s1.31-1.76 3.94-3.94c2.63-2.2 6.57-3.83 14.12-7 7.55-3.18 9.4-7.01 11.16-11.39 1.75-4.38 1.1-10.5.33-13.79-.76-3.28-2.07-8.3-2.07-15.1z"
  })), me_path5 || (me_path5 = /*#__PURE__*/react.createElement("path", {
    fill: "#B96B29",
    d: "M344.8 161.3c-1.06-6.48 2.67-12.19 2.67-12.19l-7.27-8.5c-5.6 3.15-13.4 2.72-20.17-.4-6.78 3.12-14.58 3.55-20.18.4l-7.27 8.5s3.74 5.7 2.67 12.19c-1.07 6.48-3.36 16.74-2.79 20.92.58 4.18 3.53 9.02 6.57 11.57s7.54 4.67 10.74 5.82a30.98 30.98 0 0 1 7.8 4.51c1.47 1.15 2.46 2.14 2.46 2.14s.98-.99 2.46-2.14 4.6-3.36 7.79-4.5c3.2-1.16 7.71-3.3 10.75-5.83 3.03-2.55 5.98-7.39 6.56-11.57.57-4.2-1.73-14.45-2.8-20.93z"
  })), me_path6 || (me_path6 = /*#__PURE__*/react.createElement("path", {
    fill: "#1D5E91",
    d: "M344.1 162.07c-1.05-7 2.1-12.63 2.1-12.63l-6.56-7.31c-5.55 2.85-12.29 2.11-19.63-.44-7.35 2.55-14.09 3.29-19.64.44l-6.56 7.3s3.16 5.64 2.1 12.64-2.66 14.92-2.35 19.57c.02.32.06.64.1.97h5.98s.35-.4 1.01-.69c.67-.28.86-.47.86-.47s.12-1.21.85-1.46c.73-.26 1.05-.26 1.33-.26s.5-.06.86-.41c.35-.35 1.3-1.2 1.7-2.42s.67-1.68.67-2.47c0-.8.29-2.07.29-2.07s-.16-.38-.76-.15c-.6.22-.7-.39-.76-.99-.07-.6-.03-1.84.31-2.41s.48-.77.48-.77l-.25-.95s-3.8.76-4.47-2.19c-.66-2.95-.79-4.38-.88-4.7-.1-.32-.2-.48-.7-.44-.5.03-1.59-.32-2.35-1.85-.76-1.52-.82-2.15-.6-2.76.22-.6.64-.38.76-.19.13.2 1.14 1.65 1.55 1.24.42-.41.2-.41-.38-1.56s-.38-1.52-.31-2.1c.06-.56-.2-1.33-.2-1.64 0-.32.36-.58.7-.42.35.16.67.42.83.6.16.2.22.48.54.3s.12-1.25.12-1.6c0-.34.41-.6.92-.31.5.28.76.82.76 1.2 0 .39.03.73.22.73s.41-.57.45-.95c.03-.38.25-.95.6-.47.35.47.47 1.17.35 1.9-.13.73.12.35-.13 1.62s-.38 1.84-.35 2.8c.03.95.06 1.49.54 2.66.47 1.18.85 2.54 1.74 2.57l1.14.04s.98-1.9 1.74-2.35c.76-.45 1.84-.51 2.6-.6.76-.1 1.07-.33 1.07-.52s-.25-.25-1.17-.38c-.91-.12-1.67-.35-1.7-1.05-.04-.7.15-1.3-.45-1.33-.6-.03-2.09-.51-2.63-1.5-.53-.98-.4-1.2-.34-1.74s.76-1.62 1.2-.6.73 1.14 1.1 1.36c.39.23.9.29.64-.41-.25-.7-.41-1.14-.35-1.65.07-.5.41-.73.83-.83.4-.1 1.64-.47 2.28-.6.63-.13.66-.19.66-.19s.06-.44.89-.7a5.96 5.96 0 0 1 1.96-.28c.6 0 1.04.1 1.84-.29.79-.38 1.42-.44 1.93-.41.5.03.88.22 1.26.47.38.26.26.6.26.96 0 .35.06.54.6.54s1.01 0 1.52.19c.5.19 1.2.47.76 1.01-.44.54-.47 1.15-.76 1.12-.28-.04-.25.28-.38.47-.13.2-.22.35.1.54.31.2.34.38.79.8.44.4 1.1.85.44 1.52-.66.67-1.84 1.2-1.84 1.2s-.66.32.1.77c.76.44 1.1 1.37 1.4 1.52.28.16.56.42.75.51.2.1.16.73.16.73s-.41.29-.98.51c-.57.22-1.17.48-1.71.48s-.82 0-.6.5c.22.51.6 1.05.7 1.34.09.28.22.8.22.8s.88.18 1.67.18c.8 0 1.14.03 2.88-.16 1.75-.18 2.25-.25 3.93-.06 1.68.2 1.93.13 2.38.29.44.16.88.38.88.38s2.38-.03 3.68-.32c1.3-.28 1.61-1.11 1.42-1.55-.19-.45-.16-1.12-2.44-1.43-2.28-.32-3.2-.2-5-.55-1.8-.34-4.62-1.27-5.13-3.52-.5-2.25 1.33-3.2 2.25-3.65.92-.45 2.91-1.14 3.83-1.52.92-.39 2.6-.77 4.37-.51 1.77.25 2.79.73 3.48.31.7-.4 1.27-.1 1.14.54-.12.64-.82 1.94-2.82 2.54-1.99.6-4.4.67-5.7.32-1.3-.35-2.27-.86-3.06-.57-.8.29-1.68 1.27-.83 2.44.86 1.18 5.23 1.53 6.4 1.66 1.17.12 5.5-.2 6.74 1.96 1.24 2.17.25 4.58-1.2 5.12-1.46.54-2.7.89-3.8 1.05l-1.1.15s.5 1.15.5 1.63c0 .47-.07 1.36.47 1.7.54.36 1.3.61 2.22.52.92-.1 2.03.54 2.09 1.36.06.83.32 1.97.41 3.62.1 1.65 0 3.02 0 3.02s-.06.64-.28 1.24c-.23.6-1.37 2.94-1.37 2.94h6.38c.05-.33.08-.65.1-.97.26-4.71-1.35-12.63-2.4-19.63z"
  })), me_path7 || (me_path7 = /*#__PURE__*/react.createElement("path", {
    fill: "#6D8C3E",
    d: "M294.42 185.72a18.27 18.27 0 0 0 7.75 9.55c5.45 3.28 7.8 2.85 12.94 6.2 5.14 3.34 4.83 3.9 4.9 3.9s-.25-.57 4.89-3.9c5.14-3.35 7.5-2.92 12.94-6.2a18.25 18.25 0 0 0 7.75-9.55h-51.16z"
  })), me_path8 || (me_path8 = /*#__PURE__*/react.createElement("path", {
    fill: "#D4AF3A",
    d: "M298.88 158.13c.58.61 1.02.8 1.91.71.9-.1 1.1.56 1.26 1.26.16.71.16 2.38.8 3.92.65 1.54 2.8 1.63 2.8 1.63a9.6 9.6 0 0 1 .65-2.56c.06-.14.34-.83-.43-.83s-.74-.31-1.2-1.05a14.44 14.44 0 0 1-1.57-3.97c-.21-1.27.19-3.14.4-3.82.22-.68.25-1.14 0-1.26-.25-.13-.74 0-.74 0s.19.58-.03.67c-.22.1-.4-.3-.55-.74-.16-.43-.34-.37-.65-.34-.3.04-.3.31-.1.62.22.3.1.86.1.86s-.68-.49-.95-.61c-.28-.13-.93.12-1 .49-.05.37.26 1.32.84 1.82.59.49.59 1.5.4 1.97-.18.46-1.05.4-1.23.18a.53.53 0 0 0-.8 0c-.25.28-.5.44.09 1.05zm-.34-1.63s-.34-.28-.46-.43l-.37-.5s-.06.16-.06.53.4.77.4.77l.49-.37zm1.29-4.28c.28-.12.5-.19.28-.5-.22-.3-.4-.64-.62-.7-.22-.06-.4-.03-.4-.03s.25.55.3.9c.07.33.17.45.44.33zm1.61-1.3c-.03.28.03.4.28.28.24-.13.34-.47.21-.71-.12-.25-.4-.43-.4-.43l-.18-.13c-.02 0 .1.71.08.98zm2.3.37c.03-.3-.1-.65-.1-.65s0 .37-.15.59c-.15.22-.12.15.03.34.15.19.18.03.21-.28zm3.62 15.66c.45 1.05 1.6-.6 2.65-1.93 1.04-1.32 1.01-.3.87.77a5.1 5.1 0 0 0 .7 2.98c.42.73.77.31.94-.21.17-.52.31-1.6.66-2.13s.7-.07.73.38.6 1.47 1.12 2.06c.52.6.77-.2.94-.94s.38-1.85.52-2.31c.14-.45.63-.07.63-.07l1.05 1.01c.7.67.76-.38.83-.9.07-.53-.1-1.68.1-1.86.22-.17.8.25 1.72.7.9.46.87-.42.76-.9-.1-.5-.62-1.62-1.36-2.24-.73-.63-.83-1.37-.59-1.68.25-.32 1.12-.04 1.67-.1.56-.08.84-.15 1.26-.22.42-.07.42-.49.42-.49s-.32-.52-.9-1.05c-.6-.52-.95-.94-1.68-1.12-.73-.17-1.74 0-1.74 0l-.1-.2c-.11-.21-.32-.21-.46 0-.14.2-.49.48-.77.73-.28.24-.45.38-.63.28-.17-.1.14-.35.14-.35s.39-.28.74-.98c.34-.7.45-1.37.17-1.68-.28-.32-1.05 0-1.46 0-.42 0-.67.07-.7-.14-.04-.21.42-.1.94-.18.52-.07.84-.7 1.01-1.22s.31-.46.63-.14c.31.31.6.24.66.03.07-.2.35-.73.7-1.26.35-.52.56-1.25.17-1.74-.38-.5-1.32-.42-1.7-.1-.39.3-.63.62-.74 1.4-.1.76-.31.34-.31.1s-.32-.64-.18-.95c.14-.31 0-.66 0-.66s-.07-.67-.8-.8-1.57.03-2.3.2-.6.8-.6.8-.55.04-1.14.11c-.6.07-1.3.32-1.85.46-.56.14-.77.2-.77.48 0 .29.1.74.1.74s.46 0 .7.14c.25.14.1.38-.17.49-.28.1-.39.14-.39.49s.14.42.42.42.87 0 1.57.31c.7.32.87.95.8 1.3-.07.35-1.04.8-1.53.8s-.63.1-.63.42c0 .32.6.28.6.28s.59.04 1.74.17c1.15.15 1.32.39 1.85.84.52.46.14.56-.1.7-.25.14-.64.46-1.02.6-.38.14-.63.42-.98.49s-1.22.03-2.82.66c-1.6.63-2.16 2.73-2.16 2.73s.2-.07.94-.45c.73-.39 1.64-.8 2.47-1.33.84-.53.84.24.42.98-.42.73.39.59.63.38.24-.21.56-.42 1.36-.84s.52.25.52.25-.24.49-.31 1.64c-.07 1.16 1.15.07 1.7-.66s.81 0 .4.84c-.43.84-1.23 1.5-1.68 1.5-.46 0-.8-.49-.84-.77s.14-1.12-.14-1.33c-.28-.2-1.08.04-1.67.39-.6.35-.74.07-.87-.25-.14-.31.2-.42.07-.63-.14-.2-.46 0-.7.1-.25.11-.8.43-1.88.99-1.09.55-1.02.87-1.02 1.67s.2 1 .65 2.04z"
  })), me_path9 || (me_path9 = /*#__PURE__*/react.createElement("path", {
    fill: "#D4AF3A",
    d: "M317.82 149.44c.23-.14.64-.3.64-.3s.51-.13.99-.2c.47-.06.39-.33.28-.55-.1-.23-.28-.31-.9-.31s-1.01.31-1.36.45c-.35.15-.76.25-.76.25l.3.43c.23.35.58.4.8.24zm2.52 2.5c.25 0 .52-.14.52-.14s.45-.23.86-.38c.41-.14.58-.2.82-.7.25-.49-.27-.49-.99-.67-.72-.2-1.07.06-1.15.32-.08.27-.06.58-.35 1.1-.29.5.04.47.3.47zm-.23.63c-.7 0-1.48 1.05-1.77 1.24s-.12.37-.12.37.2.43.28.84c.09.41.1 1.11.1 1.11s.11.04.52.04c.41 0 .66-.2 1.05-.5s.7-.38 1.26-.49c.55-.1.82-.2 1.44-.53s-.33-.9-.99-1.44a2.46 2.46 0 0 0-1.77-.62zm-9.31 2.42c.55-.06.8-.34.8-.65s-.28-.64-.99-.58c-1.73.15-3.41-.47-3.72-2.19 0 0-.59 1.08.5 2.28 1.08 1.2 2.86 1.2 3.42 1.14zm-5.91 27.32c.09.15.2.25.3.3h2.66c.46-.12.46-.54.48-.83.03-.34.3-1.31.66-3.08.37-1.77 1-3.03 1.26-3.74s-.26-.95-.45-1.4c-.18-.44-.47-1.23-.55-1.63-.08-.4-.7-.34-1.05-.32s-.4.58-.45 1.11c-.05.53-.29 2.08-.55 3.42-.26 1.35-1.78 3.14-2.2 3.54-.43.4-.77.55-1.06.55s-.91 0-1.23.18c-.31.19-.63.69-.66 1.08-.02.4.6.61.6.61s.5-.29.7-.53c.17-.23.6-.29 1.01-.36.42-.08.48.07.32.28-.16.2-.11.25.21.81zm-4.07-.14c-.2.07-.35.27-.44.44h1.74a.93.93 0 0 0-.17-.44c-.21-.26-.77-.13-1.13 0z"
  })), me_path10 || (me_path10 = /*#__PURE__*/react.createElement("path", {
    fill: "#D4AF3A",
    d: "M303.18 182.12c-.21.12-.47.3-.6.49h1.87c.07-.18.09-.4-.14-.6-.42-.34-.84-.05-1.13.1zm16.22-.77c-.2 0-.39.18-.68.39-.3.2-.38.52-.43.77l.01.1h.8a.14.14 0 0 0 .05-.1c0-.23.1-.44.43-.73.35-.3.03-.43-.17-.43zm1.56.86c0-.25-.1-.47-.27-.45s-.48.34-.72.52c-.14.1-.24.23-.32.33h1.17c.07-.14.14-.29.14-.4z"
  })), me_path11 || (me_path11 = /*#__PURE__*/react.createElement("path", {
    fill: "#D4AF3A",
    d: "M328.18 173.58c.56-.4.47-.52.5-.95.02-.43.02-.57-.2-.72-.23-.16-1.07-.53-1.86-.53s-2.28.19-2.84.57c-.57.39-.84 1.77-.84 2.49s.11.84.32.84.54-.52.54-.52.74.97 1.2 1.65c.45.68.24.95.04 1.47-.2.52-.95 1.9-1.53 2.2-.6.3-1.04.02-1.74-.1-.7-.1-1.09.1-1.5.5s-.01.73.23.73c.25 0 .6-.02.86.32.19.23.06.77-.03 1.08h3.46c.59-.26 1-1.07 1.15-1.52.18-.5.93-1.15 1.3-1.49.35-.34.4-.56.4-1.31s-.2-1.18-.48-1.7a3.1 3.1 0 0 1-.38-1.7c.06-.46.8-.93 1.37-1.34z"
  })), me_path12 || (me_path12 = /*#__PURE__*/react.createElement("path", {
    fill: "#D4AF3A",
    d: "M322.49 164.95c.35.56.17.67-.32.78-.5.1-1.04.19-1.81.13-.78-.07-.76.04-.78.43a3.4 3.4 0 0 1-.54 1.8c-.45.61-1.01.38-1.36.14s-.54-.18-.67.26-.36.73-.73 1.38c-.37.64-.6.67-.86.6s-.5-.45-.76-.47-.67-.54-1.05-1.17c-.4-.62-.59.07-.84.6-.26.54-.52.93-1.02.87-.5-.07-1.05-1-1.33-1.56s-.46-1.1-.89-1.07c-.43.02-1.14.92-1.62 1.16-.47.24-.6.15-.81-.15-.22-.3-.5.1-.78.82-.28.71.02 1.31.4 1.5.4.2 1.17-.36 1.7-.7.5-.35.75-.26 1.29-.26.53 0 .5.88.73 2.18.24 1.29.99 1.46.99 1.46s.26.22.84-.77c.58-1 .65-1.97 1.2-1.97.57 0 .61.13 1.17.91.56.78 1.04 1.36 1.36.78.32-.59.6-1.45.97-1.75.37-.3.71-.39.33.17-.4.56-.57 1.17.23.93s3.84-1.47 5.07-1.7c0 0 1.44-.24 3.1-.33 1.66-.08 2.07-.2 2.72-.2.65 0 .67-.06.71-.49.05-.43-.3-.34-1.5-.34-1.21 0-2.06.15-2.9.28-.84.13-1.22.1-1.08-.1.16-.23.4-.38 1.36-.53a39.7 39.7 0 0 1 4-.28c1.03-.02.7.3.62 1-.09.68.08 1.7.15 2.35.06.64.08.84.65 1.74s2.5 1.47 3.06 1.77c.56.3.47 0 .45-.54-.02-.54.43-.52.93-.24.5.29 1.31.52 1.9.67.58.15.66.26.66.56s.07.97.13 1.6c.07.63.05.82-.21 1.2s-1.36 1.52-1.36 1.52-.5 0-1.55.26c-1.06.26-1.39.75-1.5 1.18s.2.56.25.74c.02.1 0 .32 0 .51h.24c.09-.15.22-.35.38-.56.37-.47 1.3-.58 1.9-.3.4.18.4.6.36.86h2.41a86.8 86.8 0 0 0 1.3-2.59c.26-.58.41-.94.43-1.74s.11-3.88-.04-4.06c-.15-.17.04-.69 0-1.55-.04-.86 0-1.5-1.6-1.66-1.6-.15-2.09-.82-2.63-1.36-.54-.54-.4-1.79-.84-3.3-.43-1.5-1.48-1.74-3.36-2.11-1.88-.37-3.26-.4-4.66-.28s-3.14.32-4.12.24c-.95-.12-.8.16-.45.72z"
  })), me_path13 || (me_path13 = /*#__PURE__*/react.createElement("path", {
    fill: "#D4AF3A",
    d: "M331.55 182.27c-.16.1-.27.23-.35.34h1.63c.01-.14-.01-.3-.16-.47-.24-.3-.72-.13-1.12.13zm2.92-.11c-.27.13-.44.3-.54.45h1.65v-.19c-.06-.26-.56-.54-1.1-.26zm-40.72 1.03c.1.51.21 1.03.36 1.55h51.79c.14-.52.27-1.04.36-1.55h-52.51zm34.9-24.74c1.64 1.09 6.83 1.15 9.27 1.64 2.44.48 2.27 2.35 1.52 3.32-.75.98-4.18 1.1-4.8 1.18.34.23.84.95.84.95l1.4-.12c1.04-.08 2.85-.34 4.08-1.38 1.24-1.03 1.15-2.7.06-3.81-1.1-1.12-2.9-1.23-4.74-1.44-1.83-.2-3.27-.34-5.33-.68-2.07-.35-3.07-1.18-3.07-2.39 0-1.2 1.12-1.83 1.92-2.06.8-.23 2.1-.57 3.24-.15 1.15.43 2.5.5 4.77.2 2.26-.28 2.78-1.86 2.78-1.86s-.29.14-1.44.17c-1.14.03-1.98-.49-4.07-.52-2.1-.02-2.84.72-3.82 1.07-.97.34-3.58.6-4.36 2.3-.77 1.7.12 2.5 1.76 3.58z"
  })), me_ellipse || (me_ellipse = /*#__PURE__*/react.createElement("ellipse", {
    rx: 0.98,
    ry: 0.96,
    cy: 150.64,
    cx: 315.04,
    fill: "#B96B29"
  })), me_path14 || (me_path14 = /*#__PURE__*/react.createElement("path", {
    fill: "#B96B29",
    d: "M336.02 152.28c-1.3-.11-2.99.23-2.99.23s.32.26.75.23 1.2-.06 2.47.17c1.26.23 2.18-.37 2.18-.37s-1.12-.14-2.41-.26z"
  })), me_path15 || (me_path15 = /*#__PURE__*/react.createElement("path", {
    fill: "#1D5E91",
    d: "M323.74 176.38c-.32-.5-.4-.45-.77-.14-.36.32-.72-.77-.77-1.44-.04-.68.27-2.76.27-2.76s-1.76.36-2.71.68c-.95.31-1.86.4-2.63.59s-1.17.36-1.58.27c-.4-.1-1.27-.14-1.94-.14s-.64.14-1.32.81c-.67.68-.85 1.04-1.4 2.31a13.45 13.45 0 0 0-.9 3.98c-.12 1-.32 1.7-.44 2.06h8.11l.33-.83c.22-.46.66-.76.98-.9s.6-.16.74-.52c.15-.36.56-.66.98-.85s1.17-.08 1.85.1c.68.2.91-.27 1.1-.52.2-.26.28-.62.64-1.09.36-.46.1-.89.1-.89s-.34-.22-.66-.72zm13.01.22c-.1-.47-.06-.53-.34-.6-.28-.06-.74-.14-1.15-.31-.4-.17-.36.91-.36.91s-.95.1-2.04-.02c-1.08-.13-2.35-1.1-2.8-1.43-.44-.31-.93-1.04-.93-1.04s-.34.32-.68.51-.54.88-.6 1.56c-.06.68.79 1.5.85 2.18.06.68-.74 2.04-1.15 2.6-.27.37-.63 1.18-.83 1.65h3.92a2 2 0 0 1 .42-.66c.4-.4 1.08-.48 1.08-.48s0-.17.15-.53c.15-.37.55-.8 1.53-1.17.98-.39 2.14-.45 2.14-.45s.47-.38.81-.91c.34-.53.1-1.33-.02-1.8z"
  })), me_path16 || (me_path16 = /*#__PURE__*/react.createElement("path", {
    fill: "#D4AF3A",
    d: "M304.15 219.77c.73.24 2.1-.3 2.77-1.12.68-.82.93-2.1 1.41-2.82l.84-1.27s-.1 1.2-.75 2.81a10.31 10.31 0 0 0-.57 4.54c.29 1.8 1.45 2.1 2.14 1.85.51-.19 1.3-.98 2.01-2.18.23-.38.4-.9.61-1.32.46-.88.88-2.31 1.08-2.27.45.09.16 1.1 0 1.78-.35 1.36-1.03 3.36-1.08 4.57s.1 3.4 1.32 3.5c1.21.1 1.84-.97 2.52-3.45.69-2.48.83-3.26 1.12-3.26.3 0 .3 1.7.3 2.43 0 .25 0 .94.1 1.64.2 1.33.58 2.92.97 3.28.58.53 1.07.43 1.07.43s.48.1 1.07-.43c.58-.54 1.06-4.19 1.06-4.92s0-2.43.3-2.43c.29 0 .43.78 1.11 3.26.69 2.48 1.32 3.55 2.53 3.45 1.22-.1 1.37-2.28 1.32-3.5s-.73-3.21-1.07-4.57c-.34-1.36.14-1.27 1.07.49.29.54.59 1.21.88 1.68.65 1.03 1.28 1.65 1.74 1.82.68.24 1.85-.05 2.14-1.85.3-1.8-1.07-6.96-1.07-6.96l.59.88c.48.73.73 2 1.4 2.82.69.83 2.05 1.36 2.78 1.12s.83-1.6.3-4.04c-.54-2.43-2.73-3.8-4.29-5.74-1.43-1.79-2.53-4.93-2.7-5.43a17.96 17.96 0 0 0-5.23 3.7c-3.22 3.35-3.92 4.2-3.92 4.2s-.7-.85-3.91-4.2a18.03 18.03 0 0 0-5.27-3.71c-.18.41-1.52 3.42-2.96 5.23-.72.9-1.71 1.57-2.42 2.44-.82 1-1.31 2.2-1.6 3.5-.52 2.43-.42 3.79.3 4.04z"
  })), me_path17 || (me_path17 = /*#__PURE__*/react.createElement("path", {
    fill: "#D4AF3A",
    d: "M304.06 228.01c.94-.83 1.43-1.29 1.43-1.29s.68-.57.51.52c-.17 1.08-.54 3.31-.31 4.28.23.97.34 1.8 1.54 1.08 1.2-.71 1.48-1.14 2.05-1.74.57-.6 1.17-.85 1.03.09-.14.94-.57 2.37-.37 4.28.2 1.91 1.14 2.2 2.37.57a21.5 21.5 0 0 0 2.34-3.91c.37-.8 1.11-1.48 1.11 0 0 3.2.73 7.83 4.25 9.07 3.52-1.24 4.25-5.88 4.25-9.07 0-1.48.74-.8 1.11 0 .38.8 1.12 2.28 2.34 3.9 1.23 1.63 2.17 1.35 2.37-.56.2-1.91-.23-3.34-.37-4.28s.46-.69 1.03-.09c.57.6.85 1.03 2.05 1.74 1.2.72 1.32-.11 1.54-1.08.23-.97-.14-3.2-.3-4.28-.18-1.09.5-.52.5-.52s.49.46 1.43 1.29a4 4 0 0 0 2.24.88s.6-3.35-.8-5.35-1.9-2.66-1.9-2.66-.8-.04-1.4-.27c-.6-.24-1.2-.67-1.2-.67v1.85s1.72 1.63 2.12 2.11c.4.48 1.2 1.31.03.51s-2.14-1.6-2.14-1.6-.23 1.69-.72 2.12c-.48.42-1.17.48-1.45.37l-.29-.12-.08.66s1.05 1.97 1.2 2.77c.14.8-.09.71-.57-.32-.49-1.02-1.43-2.34-1.86-3.05s-1.05-1.2-1-.28c.06.9-.31 2.56-.63 3.16-.3.6-.5.8-.5.8s.65 2.31.73 2.74c.09.43.03.91-.34.37s-1.43-2.82-1.43-2.82-1.4-.06-1.8-.46c-.4-.4-1.02-1.94-1.02-1.94s-.57 1.97-1.05 2.6c-.47.63-1.57 1.26-1.57 1.26s-.08 3.41-.16 4.02c-.08.6-.1.86-.36.86-.25 0-.28-.26-.36-.86-.08-.6-.16-4.02-.16-4.02s-1.1-.63-1.57-1.26c-.48-.63-1.05-2.6-1.05-2.6s-.63 1.54-1.03 1.94c-.4.4-1.8.46-1.8.46s-1.05 2.28-1.42 2.82c-.37.54-.43.06-.34-.37s.74-2.74.74-2.74-.2-.2-.51-.8a8.2 8.2 0 0 1-.63-3.16c.06-.92-.57-.43-1 .28s-1.37 2.03-1.85 3.05c-.49 1.03-.72 1.12-.57.32s1.2-2.77 1.2-2.77l-.1-.66-.28.12c-.28.11-.97.05-1.45-.37-.49-.43-.72-2.12-.72-2.12s-.97.8-2.14 1.6c-1.17.8-.37-.03.03-.51s2.11-2.11 2.11-2.11v-1.85s-.58.43-1.19.67c-.6.23-1.4.27-1.4.27s-.5.65-1.9 2.66c-1.4 2-.8 5.35-.8 5.35s1.3-.04 2.25-.86zm17.17 22.31c-.9-1.05-1.2-1.58-1.2-1.58s-.3.52-1.2 1.58c-.9 1.05-3.01 2.7-3.01 2.7s.18 2.8 1.2 4.3c.86 1.27 1.67 2.43 3 3.3a10.97 10.97 0 0 0 3.02-3.3c1.01-1.5 1.2-4.3 1.2-4.3s-2.11-1.65-3.01-2.7z"
  })), me_path18 || (me_path18 = /*#__PURE__*/react.createElement("path", {
    fill: "#B96B29",
    d: "M319.57 253.73c.08.65.03 2.28.42 2.28s.34-1.63.42-2.28c.08-.65.11-2.2.11-2.2h-1.06s.04 1.55.12 2.2z"
  })), me_path19 || (me_path19 = /*#__PURE__*/react.createElement("path", {
    fill: "#D4AF3A",
    d: "M319.98 100.87c-3.77.06-8.18-.46-10.62-1.36l-2.59.57c4.01 1.5 7.36 2.1 13.21 2.15 5.85-.06 9.2-.64 13.2-2.15l-2.59-.57c-2.43.9-6.85 1.42-10.62 1.36zm13.7-3.14c-.3-.25-2.01-1.47-2.46-1.7-.45-.22-.1-.82-.02-1.07.07-.25 2-.8 3.08-1.07 1.06-.27.9-.5.9-.5s-.63-.72-4.5-1.14c-3.88-.43-10.69-.33-10.69-.33s-6.8-.1-10.68.33c-3.87.42-4.5 1.14-4.5 1.14s-.17.23.9.5 3 .82 3.08 1.07c.07.25.42.85-.02 1.07a27.9 27.9 0 0 0-2.46 1.7c-.3.25-.33.64.15.67.47.02.48.02 1.8-.25 4-.8 7.75-1.01 11.74-1.07 3.98.06 7.73.28 11.72 1.07 1.33.27 1.34.27 1.81.25.47-.03.45-.42.15-.67z"
  })), me_path20 || (me_path20 = /*#__PURE__*/react.createElement("path", {
    fill: "#D4AF3A",
    d: "M329.27 99.37c-2.66-.31-4.35-.66-9.27-.61-4.92.04-6.6.3-9.27.61 1.68.68 4.38 1.01 9.27 1.01s7.6-.34 9.27-1zm-10.09-36.48 2.03-.16-.19-1.78 2.18.3.09-1.75-2.29.21.4-1.89-2.52-.02.44 1.91-2.22-.2v1.74l2.2-.25zm4.43 2.87h-2.73v-2.33a4.02 4.02 0 0 0-1.51-.01v2.34h-2.82a3.05 3.05 0 0 0-.12 1.33h7.3a2.9 2.9 0 0 0-.14-1.33z"
  })), me_path21 || (me_path21 = /*#__PURE__*/react.createElement("path", {
    fill: "#1D5E91",
    d: "M320.08 70.03c1.62 0 3-.95 3.48-2.27h-6.97a3.67 3.67 0 0 0 3.5 2.27zm1.5-6.38v1.6h1.8a3.5 3.5 0 0 0-1.8-1.6zm-3.01 0c-.8.32-1.43.89-1.8 1.6h1.8v-1.6z"
  })), me_path22 || (me_path22 = /*#__PURE__*/react.createElement("path", {
    fill: "#B96B29",
    d: "M322.17 93.31c-.69-.32-2.19-.96-2.19-.96l-2.2 1.09c-.77.39-.67.27-.91.84s.02.76.36.91c.34.15 2.79 1.4 2.79 1.4l3.01-1.4c.6-.27.48-.55.32-.98-.16-.42-.5-.57-1.17-.9z"
  })), me_path23 || (me_path23 = /*#__PURE__*/react.createElement("path", {
    fill: "#D4AF3A",
    d: "m317.64 94.03 2.4 1.22 2.37-1.22-2.43-1.14zm2.34-9.38s-.2.84-.47 1.2c-.27.36-.48.69-.4 1.12.08.44.58.73.87.73.3 0 .8-.29.87-.73.08-.43-.13-.76-.4-1.12-.26-.35-.47-1.2-.47-1.2z"
  })), me_circle || (me_circle = /*#__PURE__*/react.createElement("circle", {
    cy: 88.56,
    cx: 320,
    r: 0.45,
    fill: "#D4AF3A"
  })), me_path24 || (me_path24 = /*#__PURE__*/react.createElement("path", {
    fill: "#D4AF3A",
    d: "M318.39 86.24s.78-.87 1.07-1.42c.29-.54.52-1.03.52-1.03s.24.49.52 1.03c.3.55 1.07 1.42 1.07 1.42s1.1-.58 1.73-2.68c.64-2.11-.14-4.33-.43-6.73s-.52-6.52-.52-6.52c-.83.48-1.62.68-2.37.7a4.89 4.89 0 0 1-2.37-.7s-.23 4.13-.52 6.52c-.29 2.4-1.07 4.62-.43 6.73.64 2.1 1.73 2.68 1.73 2.68z"
  })), me_ellipse2 || (me_ellipse2 = /*#__PURE__*/react.createElement("ellipse", {
    rx: 1.89,
    ry: 1.83,
    cy: 81.51,
    cx: 319.98,
    fill: "#B96B29"
  })), me_ellipse3 || (me_ellipse3 = /*#__PURE__*/react.createElement("ellipse", {
    rx: 1.82,
    ry: 1.76,
    cy: 77.22,
    cx: 319.98,
    fill: "#B96B29"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/react.createElement("ellipse", {
    rx: 1.74,
    ry: 1.68,
    cy: 73.12,
    cx: 319.98,
    fill: "#B96B29"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/react.createElement("ellipse", {
    rx: 1,
    ry: 0.97,
    cy: 81.18,
    cx: 319.98,
    fill: "#D4AF3A"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/react.createElement("ellipse", {
    rx: 0.97,
    ry: 0.93,
    cy: 76.91,
    cx: 319.98,
    fill: "#D4AF3A"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/react.createElement("ellipse", {
    rx: 0.85,
    ry: 0.82,
    cy: 72.82,
    cx: 319.98,
    fill: "#D4AF3A"
  })), me_path25 || (me_path25 = /*#__PURE__*/react.createElement("path", {
    fill: "#b96b29",
    d: "M319.93 224.04c.12.02.14-.28.16-.83.03-.56.1-1.9.23-2.7.14-.78-.2-.73-.41-.69-.21.05-.33.65-.33 1s.1 2.34.1 2.76.13.44.25.46z"
  })), me_g || (me_g = /*#__PURE__*/react.createElement("g", {
    id: "me_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#d4af3a",
    d: "M300.28 239.41c.84-.53 1.57-1.13 3.48-2.4 1.9-1.26 2.6-2.66 2.6-2.66h-.67c-.36 0-.67-.51-.7-1.02-.03-.5 0-1.55.14-2.76.14-1.2-.2-2.19-.2-2.19s-.8.76-2.04 1.4c-1.24.65-1.74.34-1.74.34l-.31-1.23s-.53 1.12-1.29 2.44c-.76 1.33-2.8 2.79-4.26 3.89s-3.06 2.25-4.27 2.67c-1.2.42-.5.99-.5.99s1.2 1.2 4.32 1.77 4.6-.7 5.44-1.24z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#d4af3a",
    d: "M311.17 238.2c-1.11-.12-1.78-.54-2-1.75-.13-.78.06-3.8.06-3.8s-.36.32-.78.82c-.42.5-1.38.62-1.38.62s-.14.42-.56 1.1c-.42.67-.95 1.5-2.02 2.16-1.06.68-2.3 1.47-3.11 2.14-.81.68-1.77 1.47-2.83 2.06a4.66 4.66 0 0 0-2.39 3.12c-.36 1.58-.08 2.08 1.15 2 1.24-.09 1.38.03 3.37-.48 1.99-.5 4.82-2.73 6.9-4.05 2.08-1.32 3.59-3.94 3.59-3.94z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#d4af3a",
    d: "M316.69 240.02s-.84-1.07-1.15-2.28l-.9-3.6s-.28.76-.95 2.2c-.67 1.43-1.82 1.77-1.82 1.77s-.06.62-1.01 1.83a14.03 14.03 0 0 1-3.8 3.18c-1.42.84-3.27 2-4.28 3.43-1.01 1.43-1.1 2.92-.62 3.57.48.65 1.15-.09 2.1-.56s3.68-.9 7.44-2.93c3.76-2.02 4.99-6.61 4.99-6.61z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#d4af3a",
    d: "M318.32 248.44c1.04-1.55 1.2-5.32 1.2-5.32s-.36-.25-.86-.67c-.5-.42-1.49-1.91-1.49-1.91s-.62 1.29-1.29 2.5a9.4 9.4 0 0 1-2.41 2.92c-1.4 1.3-3.31 2.57-4.13 3.94-.8 1.38-.36 4.14.17 5.07.54.93 1.3.61 2.08-.14.78-.76 1.04-.96 2.41-2.14s3.28-2.7 4.32-4.25z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#b96b29",
    d: "M305.98 216.89c.55-1.13 1.18-2.5 1.68-3.19.5-.7.86-1.49.86-1.49s-1.34 1.22-1.87 2.09c-.53.86-.86 1.7-1.1 2.64-.24.93-.12 1.08.43-.05zm5.33.96c.22-.74.34-1.24.34-1.24s.21-.72.1-.77c-.13-.05-.68.45-1.06 1.67-.39 1.23-.96 3-.84 3.07.12.08 1.24-1.99 1.46-2.73zm4.2 3.38.24-.55s.43-1.4.43-1.68c0-.29-.14-.62-.5.1s-.38 1.41-.46 1.72c-.07.32-.48 1.4-.36 1.5.12.09.41-.56.65-1.09zm-13.04 12.8-.56-.34s-.34.45-.82.96c-.47.5-1 .7-1.37 1.18-.36.48-.93 1.07-1.8 1.52s-1.2.6-1.03.73c.17.14.76-.2.76-.2s.25-.02 1.29-.64 1.29-.96 1.96-1.55 1.57-1.66 1.57-1.66zm4.55 5.38c.4-.42.81-.7.59-.93-.23-.22-.5-.2-.87.11s-1.4 1.3-1.88 1.72c-.48.42-.87.67-1.35 1.04-.47.37-1.51.93-2.02 1.2-.5.3-.02.32-.02.32s.39-.2.81-.34c.42-.14 1.63-.67 1.63-.67s.47-.23 1.12-.68c.64-.45 1.6-1.35 1.99-1.77zm5.24 3.63c.34-.67-.03-.48-.59-.25-.56.22-1.82 1.6-2.55 2.1s-1.35.71-1.96 1.02c-.62.31-.62.48-.6.62.03.14.29.14.54.03.25-.12 1.12-.62 1.12-.62s.37-.11.7-.14c.34-.03.82-.4 1.57-1.04.76-.65 1.43-1.04 1.77-1.72zm2.44 4.81c-.93.56-2.52 1.83-2.94 2.67-.43.85-.7 1.44-.57 1.58.14.14.6-.14.79-.48.2-.34.62-.85.62-.85s1.6-1.57 2.18-1.94 1.55-1.4 1.77-2.02c.22-.62.06-.96.06-.96s-.99 1.44-1.91 2z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#c52126",
    d: "M289.99 113.28c-.85-.5-3.13-1.47-5.56-1.68-2.42-.2-4.3.16-6.31.7a6.98 6.98 0 0 1-3.77.14 5.23 5.23 0 0 1-3.54-3.95s-1.6 2.06.03 4.29a4.8 4.8 0 0 0 2.86 1.95c3.4.68 6.73-1.4 9.56-1.57 2.72-.18 4.86 1.55 4.86 1.55s.64.53 1.55 0c.9-.53 1.17-.93.32-1.43z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#d4af3a",
    d: "m280.2 211.66-.8-.1c-.47-.07-1.47-.4-1.77-.54-.3-.13-.77-.17-1.07.17-.3.34-2.75 1.78-2.75 1.78h4.05c1.4 0 2.34-1.31 2.34-1.31z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#d4af3a",
    d: "M291.59 210.97v-.4l-.54-1.16s-.63.39-1.24 1.02c-.79.82-1.64 1.97-2.02 2.46-.67.86-1.61 1.68-.8.3.8-1.38 1.07-1.98 1.72-2.9.64-.91 1.13-1.32 1.05-1.37-.08-.06-.6-.14-2.3-.35-1.69-.22-2.74-.87-3.52-1.33-.78-.46-2.18-1.21-2.18-1.21s-2.88 1.21-3.96 1.48-1.73.43-.68.95c1.06.51 1.94.67 2.46 1 .5.32 2.1.83 3.07.83.97 0 2.6.03 1.96.7-.64.68-1.37 1.98-2.07 3.95-.7 1.97-.73 3.73-.73 4.6s.1 1.72.1 1.72 1.2-1.32 4.37-3.32a56.1 56.1 0 0 1 4.96-2.94c.59-.27.89-.27.78-1.03-.1-.76-.43-2.62-.43-3z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#d4af3a",
    d: "m303.73 201.31-.59-.27a.7.7 0 0 0-.15.05c-.37.2-2.3 1.5-3.1 2.76-.77 1.27-1.56 1.38-.7 0a11.94 11.94 0 0 1 2.84-3.32 35.56 35.56 0 0 1-4.9-2.8 7.49 7.49 0 0 1-1.07 1.65c-.67.7-2.17 1.3-2.17 1.3s1.2-1.22 1.6-2.16c.27-.6.44-1.23.53-1.62a21.1 21.1 0 0 1-3.21-3.06c-.2.8-.84 2.77-2.76 4.9-2.5 2.8-7.5 4.22-7.5 4.22s-1.74.19-.33.56 2.43 1 5.19.52c2.76-.48 2.94-.6 3.32-.7.37-.12 1.38-.04 0 .48s-4.6 1-5.82.9c-1.23-.12-2.91-.38-1.16.55s2.5 1.3 3.58 1.3 1.53.35 2.58.35c1.04 0 1.34-.2 2.08-.34.75-.15 1.23.11 1.23.4 0 .3-1 1.13-.96 3.18.03 2.05.18 3.4.37 3.99.19.6.63 1.56.93 2.13.3.55.41 1.11.7-.08.3-1.2.98-2.9 1.24-4.06.26-1.16.4-1.2.52-1.8.11-.6.75-1.04.45.04s-.64 2.46-.86 3.43c-.22.97-.74 2.76.15 1.35.9-1.42 4.25-5.19 4.8-5.86s1.02-1.3 1.43-1.86c.4-.56 1.56-1.3 2.12-2.13.5-.74 1.99-2.18 2.63-2.7-.95-.4-1.95-.83-3.01-1.3zm-46.36-86.08c.09 2.06 2.36 5.99 3.66 8.09 1.3 2.1 1.65 2.94 1.43 3.08-.23.13-.76-.94-1.48-1.88-.71-.93-2.1-3.12-3.25-4.78s-2.86-5.58-3.08-5.94c-.22-.36-.31-.58-.9-.13-.57.44-1.69 4.78-.35 7.73 1.34 2.94 3.35 5.09 4.2 6.12.84 1.02 1.96 2.63 1.78 2.77-.18.13-.5-.27-1.52-1.34s-2.72-2.9-3.84-4.25a31.7 31.7 0 0 1-2.56-4.09c-.16-.3-.37-.21-.53-.06-.37.37-.95 1.23-.7 3.57.36 3.26 2.05 5.14 3.57 6.8 1.52 1.64 3.03 3.03 2.81 3.25s-1.78-1.16-2.85-2.19a95.4 95.4 0 0 1-4.29-4.29c-.58-.7-1.42-.35-1.38 2.46s3.17 5.68 4.46 7.24c1.3 1.56 2.9 2.5 2.77 2.81-.14.32-1.43-.49-2.28-1.07-.84-.58-4.01-2.64-4.64-3.08-.62-.45-.93.4-.13 3.08s3.12 4.82 4.5 5.8c1.39.99 3.62 2.2 3.48 2.51-.13.31-1.07-.09-2.36-.72-1.3-.62-2.85-1.2-3.97-1.51-1.12-.32-1.11.49-1.11.49s-.23 2.27 1.42 4.1 3.53 2.55 5.31 2.86c1.78.32 2.05.4 2 .68-.04.26-.22.3-.62.3s-2.05.19-3.57.19-2.31.35-2.31 1.02-.05 1.57 2.23 3.09c2.27 1.52 4.81 1.74 5.88 1.96 1.07.23 1.12.32.9.63-.23.31-.72.27-2.41.45-1.7.17-2.72.84-2.95 1.29-.22.45.14 1.79 1.52 2.73 1.38.93 3.17 1.25 5.84 1.07 2.68-.18 3.35-.23 3.44.22.09.45-.8.58-2.14.8-1.34.23-2.37.23-3.13.86-.75.62-.17 1.92 1.12 2.85s4.5.94 5.84.85 3.4-.58 3.53-.22-.98.9-2.37 1.38c-1.38.5-1.78.8-2.05 1.39-.27.58-.04 1.12 1.6 1.74 1.66.63 4.07.63 5.32.05s1.91-.8 2.14-.58c.22.22 0 .44-.27.76-.27.3-1.34 1.16-2.72 1.52s-1.52.35-2 1.47c-.5 1.12.75 2.01 3.25 2.1 2.5.09 5.84-.9 6.91-1.52 1.07-.63 1.47-.76 1.65-.54.18.23.14.36-.4.76s-2.23 1.61-3.08 1.84c-.84.22-.93.84-.93 1.43 0 .58-.23 1.74 2 2.27 2.23.54 4.86.14 7.27-1.56a5.5 5.5 0 0 0 1.48-1.39c-.19-2.28-.09-3.85.19-5.3a8.81 8.81 0 0 1-2.3-.55c-1.33-.53-1.86-1.78-2.18-2.45-.31-.67-.76-.67-1.3-.5-.53.18-1.06.4-1.82.36s-2.36-.44-3.52-1.83c-1.16-1.39-.94-2.72-.99-3.4-.04-.67-1.11-.17-1.65-.17-.53 0-2.1-.23-3.52-1.21-1.43-.98-1.43-2.32-1.56-2.86-.14-.54-.72-.9-1.16-1.07-.45-.18-1.16-.36-2.14-1.16-.98-.8-1.34-2.37-1.39-2.9-.04-.54-.62-.59-2.63-1.61s-1.83-3.18-1.74-4.02c.1-.85 1.03-1.57 1.03-1.88 0-.32-.67-.4-1.34-.8s-2.36-1.08-2.4-3.58c-.05-2.5 1.6-2.77 1.6-2.77s-.31-.13-.98-.54c-.67-.4-2.5-1.65-2.5-3.12 0-1.48.67-2.15 1.16-2.5.49-.36 1.83-.72 1.83-.72s-.85-.54-1.2-1.7c-.36-1.16-.5-2.59.35-3.62.85-1.02 2.27-1.02 3.03-1.02s1.43.4 1.7.18c.27-.23.31-.4.04-.99a4.38 4.38 0 0 1-.09-2.5c.23-.49.27-1.47 2.19-2.1 1.92-.62 3.92.67 4.55 1.03s.36-.5.36-1.12c0-.62-1.3-2.19-2.77-4.42s-2.14-3.4-3.8-6.8-2.71-7.76-2.94-8.88c-.22-1.12-.67-.58-.67-.58s-.44.18-1.47 2.77a16.66 16.66 0 0 0-1.11 7.01z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#d4af3a",
    d: "M291.02 160.92a5.02 5.02 0 0 1-3.8-2.36c-1.14-1.67-2.87-2.07-5.85-2.01-3 .05-4.37-1.38-5.12-3.46-.74-2.07.12-4.43 3.16-5.92s4.43-3.17 4.54-5.76c.12-2.59-3.04-5.81-6.2-9.43s-5.63-8.75-5.63-8.75-.92 1.2-.92 2.41.46 2.48 0 2.82c-.46.35-.63-.51-2.47-1.32-1.84-.8-3.34-.92-4.48.4s0 3.63 1.03 4.72c1.03 1.1 1.9 1.9 1.6 2.3s-1.83-.63-2.35-.97-1.72-1.67-3.5-1.5-2.42.69-2.59 2.19c-.17 1.5 1.61 2.82 2.76 3.4 1.15.57 1.6 1.09 1.32 1.31-.29.24-.57 0-1.1-.17a5.35 5.35 0 0 0-2.86 0c-.92.35-2.42 1.61-1.04 3.17 1.38 1.55 4.25 2.13 4.83 2.24.57.12.86-.06.92.4.05.47-1.21.47-2.76.52s-2.01 1.56-1.78 2.7 2.81 2.42 4.25 2.65c1.44.23 1.95 0 2.07.4.11.4-.17.58-.98.81-.8.23-2.35.4-2.64 1.67-.29 1.27-.35 1.84.86 2.94 1.2 1.09 3.16.92 3.73.8.58-.11 1.27-.75 1.84-.17.58.57-.51 1.04-1.5 1.73-.97.69-.91 2.01.76 2.93 1.66.92 3.33.58 4.02.35s1.6-1.33 2.07-.64c.46.7-1.44.93-2.24 1.9-.8.98-.52 2.6 1.09 3.57 1.6.98 4.25.29 4.7-.11.47-.4 1.04-.58 1.39-.23.34.34-.17 1.26-.52 2.07-.34.8-.98 3.16 1.44 4.08 2.41.92 4.6-1.15 5-1.55.4-.4.8-.46 1.15-.29.34.17.17.52-.12.92-.29.4-.92 2.13.8 3.34 1.18.82 2.47.76 3.16.64.36-1.34.83-2.78 1.3-4.8H290c-.23 0-.27.34-.27.48s.07.25-.14.25c-.2 0-.23.12-.53.33-.3.2-.58.46-.74.34-.16-.11.62-.53.83-.78.2-.25.62-.65.65-.92.02-.28.16-.44.57-.78.13-.11.23-.24.31-.36.28-1.34.55-2.92.8-4.82.16-1.29.26-2.5.3-3.64l-.76-.04zm-49.11-35.87c2.57 5.2 6.2 8.12 6.2 8.12s-.48-1.3-.7-2.18c-.2-.89-.04-1.9-.04-1.9s-.91-1.16-2.6-3.75-2.56-6.42-2.56-6.42 1.56 3.83 2.78 5.86c1.21 2.03 2.61 3.69 2.61 3.69s.5-1.8.84-1.9c.35-.08.61.2.91.6.3.39.57.35.57.35s-.42-.85-1.06-1.88c-.29-.47-.71-.97-1-1.45-.97-1.5-3.03-4.38-4.09-7.25-1.06-2.88-3.37-10.09-3.77-12.2-.4-2.12-.8-.96-1.21.6-.4 1.56-.96 3.78-.6 7.1s1.15 7.42 3.72 12.61zm3.32 14.02c.96.7 2.37 1.66 2.37 1.66s-.23-.52-.37-1.14-.2-1.91-.2-1.91l-1.9-1.68a27.83 27.83 0 0 1-3.73-3.98c-1.95-2.42-.38-.97 1.2.76s4.63 4.25 4.63 4.25l.02-.56c.02-.53.18-.9.47-1.27.28-.36.13-.41-1.58-1.72-1.71-1.32-6.15-6.3-7.96-9.28-1.81-2.98-3.77-7.01-3.77-7.01s-.96 5.95 2.66 12.5c3.63 6.56 7.2 8.67 8.16 9.38zm19.02 37.53c1.99-.77 1.44-2.73 1.44-2.76s-1.22.38-2.34.8c-1.12.42-3.87 1.22-4.96 1.25-1.09.03-1.09-.12-1.12-.29-.03-.16.83 0 2.4-.28 1.57-.3 4.32-1.74 4.8-2.06.48-.32.42-.38-.28-.45a3.02 3.02 0 0 1-1.57-.6c-.26-.23-1 .1-2.79.5-1.8.42-5.51 1.07-8.36 1.07s-5.51-.48-5.96-.58c-.45-.1-.93.16.45 2.47 1.38 2.31 6.21 3.56 9.58 3.53 3.36-.04 6.72-1.83 8.71-2.6zm-8.94-4.77c3.47.03 4.76-1 4.76-1s0-.18-.47-.89c-.47-.7-.38-1.9-.38-1.9s-.82.14-2.26.35c-1.44.2-3.12.4-4.97.08s-1.06-.53.4-.35c1.48.18 4.3-.36 5.21-.68.91-.32.53-.62-.08-.82-.62-.2-2.3-1.27-2.3-1.27s-4.2.53-8.11.09c-3.91-.44-6.39-1.44-7.18-1.56s-.76.2-.76.2-.21.36 1.14 2.48c1.35 2.12 4 3.5 6.24 4.15 2.23.65 5.29 1.1 8.76 1.12zm-.89-8.13s-.15-.2-.35-.91c-.2-.71.38-1.24.38-1.24s-.8-.23-3.38-.56c-2.6-.32-2.74-.53-4.33-.88-1.58-.36-2.64-.83-2.61-1s.53.08 1.47.44c.94.35 4.9.76 6.58 1 1.68.23 2.62.41 2.91.23.3-.17 1.33-.44 1.33-.44s-.7-.2-1.59-.35a5.6 5.6 0 0 1-2.15-.86c-.47-.32-.61-.41-2.73-.64-2.12-.24-3.82-.92-7.62-2.3-3.79-1.39-6.64-3.03-7.4-3.65-.77-.62-.71-.18-.5.62.2.8.17 1.8 2.08 4.03 1.91 2.24 2.85 3.21 7.67 4.98 4.83 1.77 10.24 1.53 10.24 1.53zm-14.26-11.75c4.26 3 9.26 4.1 10.32 4.24.24-.28-.26-1.28-.03-1.89.28-.72.74-.73 1.77-.79 1.02-.06.35-.27.11-.27s-.29-.02-2-.47c-1.7-.44-3.44-.7-5.79-1.59-2.35-.88-3.06-1.53-3-1.7.06-.18 1.09.56 3.27 1.38 2.17.82 4.7 1.15 6.08 1.44 1.39.3.18-.3-.47-.68-.64-.38-1.56-1.8-1.56-1.8s-1.53-.26-4.02-1.02a32.52 32.52 0 0 1-6.68-2.8c-.72-.4-1.41-.93-2.16-1.47-1.43-1.02-2.87-2.07-3.43-2.48-.85-.62-.58-.12-.5.27s.68 2.15 2.03 4.1c1.35 1.94 1.8 2.52 6.06 5.53zm-.7-8.45c4.2 3.33 7.82 4.36 8.44 4.62.62.27.56-.09.44-.44-.12-.35-.2-1.5-.2-1.5l-3.18-1.83c-1.68-.97-3.53-2.3-4.77-3.15-1.23-.85-.5-.8-.11-.47.38.32 2.08 1.33 3.79 2.39 1.7 1.06 4.3 2.59 4.3 2.59s.05-.56.4-.91 1.24-.27 1.24-.27-.44-.44-.7-.85c-.27-.42-1.65-.86-3.21-1.6-1.56-.73-4.36-2.79-6.41-4.53a83.89 83.89 0 0 1-6.33-6.45c-.26-.35-.44-.3-.47.15-.03.44-.17.73.27 2.74.44 2 2.3 6.18 6.5 9.51zm14.88-31.47c.48.99 1 1.74 1.38 2.38.56.98.88 1.6.88 1.6s.12-.34.03-.92-.18-1.4-.02-2.36c.08-.52.19-1.04.16-1.5-.03-.52-.2-.97-.28-1.27-.13-.56-.74-3.02-1.03-4.75-.3-1.73-.6-4.2-.59-6.39.03-2.18.34-1.08.34-.02s.11 2.68.45 5.17c.34 2.5 1.4 6.3 1.4 6.3s.06-.58.38-1.41.83-1.78 1.23-2.82c.4-1.03.26-1.2.26-1.2s-1.47-7.07-1.86-10.41a427.64 427.64 0 0 1-1.01-12.12c-2.16 2.18-3.77 7.9-4.05 13.3-.22 4.08.44 7.85.63 9.38.38 3.03.9 5.4 1.7 7.04zm-4.79 11.15c.07-1.6.43-2.81 1.47-3.17 0 0-.92-1.6-1.71-3.88-.55-1.56-1-3.57-1.23-5.1-.56-3.8-1.01-7.7.11-1.3 1.13 6.38 2.49 8.64 2.49 8.64l1.63 2.66c-.24-1.17-.28-1.99-.21-3.26s.22-3 .6-4.37c0 0-1.97-3.96-3.2-8.7s-1.96-9.08-1.98-11.65l-.17-3.45s-2.03 1.53-2.71 9.27c-.68 7.75 1.35 15.15 2.37 17.98 1.02 2.82 2.54 6.33 2.54 6.33zm22.16 59.06s-.32-.22-1.28-.83-.67-2.44-.67-2.44-.26.19-.97.67c-.7.48-1.5 1.03-2.46 1.41s-1.44.65-2.05.84c-.61.19-.45-.07.06-.36.51-.28.68-.44 1.96-.96 1.28-.51 3.84-2.76 3.84-2.76s-.6-.06-1.67-.1-2.4-.57-2.4-.57-1.05.96-5.32 2.79c-4.26 1.83-7.88 2.3-7.88 2.3s.45 2.2 2.5 2.93c1.7.74 4.04 1.19 8.62.1 4.58-1.1 7.72-3.02 7.72-3.02zm5.61 4.37c.35-1.8-.67-3.05-.67-3.05s-.23.13-.87.7c-.64.58-1.57 1.68-3.36 2.57s-2.44.84-.7-.1 4.26-3.56 4.26-3.56l-.68-.25c-.67-.26-1.82.19-6.63 3.08-4.8 2.88-7.62 2.98-7.62 2.98s2.14 2.6 7.97 2.4c5.83-.18 7.95-2.97 8.3-4.77zm11.02-2.09s-.64.9-1.5 1.48-3.18.93-3.18.93-.1.25-.54.83c-.45.58-1.44 1.96-2.47 2.7-1.02.73-2.62 1.21-2.72 1.02s.93-.58 1.92-1.19c1-.6 1.9-1.73 2.56-2.5.68-.77-.28-.64-.28-.64s-1.22.03-2.34-.06c-1.12-.1-.9 0-1.22.54s-.77 1.03-1.6 2c-1.02 1.17-1.98 2.23-2.95 3.39-.64.77-.16 1-.16 1s.29.48 2.88.77c1.6.17 3.34-.03 5.17-1.08 1.13-.66 2.3-1.7 3.49-3 3.1-3.4 2.94-6.19 2.94-6.19zm1.38 7.02c-.64.83-1 1.19-1 1.19s.45-1.38.84-2.02c.2-.35.43-.67.6-.9-.44-.96-.79-2-1.05-3.12-.28.93-1.17 3.64-2.27 5.4-1.35 2.14-2.53 2.92-1.77 3.5.77.57 2.28.7 3.98-.14 1.64-.8 2.11-2.2 2.34-3.34-.28-.45-.55-.91-.8-1.4-.22.13-.52.38-.87.83z"
  }), /*#__PURE__*/react.createElement("ellipse", {
    rx: 1.19,
    ry: 1.09,
    cy: 105.75,
    cx: 289.34,
    fill: "#d4af3a"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#d4af3a",
    d: "M286.83 103.69c1.09-.03 1.67-.54 2.87-.42 1.42.13 3.34.96 5.67 2.2a9.7 9.7 0 0 0 6.55.57c.65-.19 1.3-.54 1.91-.9 2.84-1.6 2.15-4.76 2.15-4.76a11.12 11.12 0 0 1-7.09 2.15s.19.14.6.55c.41.42 1.16.9.91 1.1-.24.21-1.28-.78-2.14-1.42a12.92 12.92 0 0 0-4.35-2.15c-2.2-.65-4.66-.7-6.3.22-1.66.92-1.8 2.07-1.56 2.53.12.26.43.34.78.33zm30.81 23.11c-.5-.14-1.37-.28-2.51-1.33a47.76 47.76 0 0 1-4.21-4.63c-.32-.55-.19-1.06.6-1.38.77-.32 1.32-1.33 1.32-1.33s-1.7-.64-2.83-1.47c-1.15-.82-3.8-3.2-4.17-3.8s-.18-.7.37-.87c.55-.19.69-.56.69-.56s-1.24-.77-2.38-1.7c-1.14-.9-2.7-2.42-2.7-2.42-1.71.69-4.4.4-5.85.14-2.56-.46-4.44-1.52-4.44-1.52s-.09.41-.4 1.2c-.33.77-1.52 1.23-2.7.45-1.2-.78-.92-2.47-.92-2.47s-.96-.6-2.93-1.33-3.56-.83-5.16-.1c-1.6.74-2.38 2.94-2.38 4.6 0 1.64.87.95 1.05.72.18-.23.55-1.42 2.56-1.74 2.01-.32 3.84.64 6.13 2.52 2.28 1.88 2.79 2.02 3.93 3.21 1.14 1.2.23 1.84-1.74 2.48s-4.48-.64-4.57-.6c-.38.2.85 1.94 2.54 2.6 1.7.66 3.87.24 5.55-.44 1.15-.46 1.36.02 1.7.37 1.85 1.95 2.33 3.78 2.65 6a2.7 2.7 0 0 0 1.73-2.01c.07-.37.19-1.2.83-.6.64.6 1.14 3.9 1.14 5.41s-.46 3.54-.46 3.54l.46-.05c.28-.05.82-.37 1.55-.78.74-.41.78.05.78.87s.28 2.39 1.37 5.18 2.7 3.72 2.7 3.72.32-.55.64-1.65c.32-1.1.55-3.26.55-5.14s-.5-5.92-.5-5.92 2.29 2.8 4.66 3.5c2.38.68 4.76.27 5.76-.88s.1-1.65-.41-1.79z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#d4af3a",
    d: "M302 134.04s-.72 1.6-1.12 2.17-.56.65-.56.65.72.62 1.77.94c1.05.33 1.99.53 1.99.53s-1.18-1.62-1.6-2.76c-.41-1.14-.48-1.53-.48-1.53zm14.28-.94c-.35-.9-.57-1.4-.57-1.4-1.46.3-4.23-.4-5.43-1.12 0 0 1.1 2.23 2.2 3 1.09.77 1.24.81 1.24.81s-1.1.18-2.56-1.27c-1.47-1.44-2.13-3.1-2.13-3.1s.33 3.85-.26 6.2-.72 2.68-.72 2.68 3.1.55 6.57-.42c3.45-.96 3.72-1.27 3.72-1.27s.41-.1-.13-.83a18.68 18.68 0 0 1-1.93-3.28z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#b96b29",
    d: "M310 124.64c-1.06-1.22-1.17-1.52-1.17-1.52s-.37.38-.05.9a11.1 11.1 0 0 0 2.87 2.45 7.4 7.4 0 0 0 2.07.77l-.05-.2s-2.6-1.18-3.67-2.4zm-4.22 8.03s-.27-4.84-.27-5.56-.45-.53-.45-.53l-.53.24 1.04 7.08c.11.76.49.7.68.66-.38-.2-.45-1.67-.47-1.89zm-6.53-20.95c-.4-.4-1.28-.69-.43.26.86.96 1.98 2.14 2.3 3.13.34.99.53 2.2-.03 1.94-.56-.26-.95-.26-1.54-.75a9.86 9.86 0 0 0-2.18-1.45c-.46-.13-1.28 0-.62.72.66.73 1.38 1.42 2.63 2.34 1.25.92 1.98 1.31 2.64 1.78.65.46 1.31.85 1.31.85s-.6-3.95-1.68-5.7-2-2.72-2.4-3.12zm-21.34 66.15c-.8.6-1.85.86-1.85.86s-.5-.03-.5.16.58 0 1.19-.1c.6-.12 1.44-.73 1.74-.95.3-.22.75-.5.6-.88-.13-.4-.38.3-1.18.91zm6.89 3.69c-.17.2-1.5 1.19-1.5 1.19s-.4.28-.85.44c-.44.17-.55.42-.55.42s.08.1.55-.03c.47-.14 1.85-1.1 2.3-1.5.44-.38.63-.5.47-.66-.17-.16-.25-.05-.42.14zm-27.93-49.63c.25.3.55.71.69.58.14-.14-.03-.28-.36-.66-.33-.39-.52-.58-.52-.58s-.47-.75-.75-1.02c-.27-.28-.68-.42-.16.22.52.63.85 1.16 1.1 1.46zm-2.12 4.65c.3.28.58.52.9.88s.59.74.78.55c.19-.2-.5-.6-.8-.99-.3-.39-.55-.63-.94-.94s-.85-.55-.85-.55.6.78.91 1.05zm.79 7.51c.53.55 1.3.72 1.41.5.11-.22-.06-.4-.5-.62-.43-.22-1.15-.69-1.5-.94a7.61 7.61 0 0 1-.97-.77c-.25-.25-.54-.47-.63-.38-.1.08.73.96.97 1.1.25.14.7.56 1.22 1.11zm1.52 6.01c0-.22.05-.33-.39-.36-.44-.03-1.05-.1-1.05-.1s-.86-.34-.91-.18c-.06.17.72.5 1.05.56.33.05.75.16.94.27.2.11.36.03.36-.19zm.66 6.53c-.94 0-1.74-.22-1.8-.08s.45.36.92.52c.47.17 1.35.22 1.96.25s.72-.1.7-.41c-.04-.3-.84-.28-1.78-.28zm7.36 7.15c-.14-.14-.47-.03-1 .08-.52.11-1.38.28-1.88.25s-1.57-.05-1.57-.05l-.61.14c0 .14.8.1 1.96.25 1.16.13 1.94-.11 2.5-.2.54-.08.74-.33.6-.47zm3.04 5.09c-.58.22-1 .28-1.44.28-.44 0-1.5.19-1.5.19s-.49.06-.4.25c.08.2.24 0 .68-.06.45-.05.78 0 1.55-.02.78-.03 1.22-.23 1.69-.3.47-.1 1-.34.75-.65-.25-.3-.75.09-1.33.31zm5.92 3.85c-.33.33-1.6 1.2-1.6 1.2s-.25.19-.75.43-.47.37-.39.5.39-.2.67-.3 1.18-.72 1.65-1.1c.47-.4 1.08-.7.97-.98-.1-.28-.22-.08-.55.25zm-9.85-49.85s.11.25 1.13 1.53c1.02 1.28.48.07.22-.25-.26-.33-1.75-2.45-2.26-3.03-.51-.59-.59-.3-.33.07.26.37 1.24 1.68 1.24 1.68zm-2.15 6.56c.15-.15-.18-.3-.77-1.02l-1.75-2.23s-.33-.69-.43-.62c-.11.08.4 1.17.87 1.65.48.47 1.1 1.38 1.42 1.78s.51.59.66.44zm2.83 12.3c0-.36-1.16-.3-1.68-.41l-1.46-.3s-1.1-.2-1.12-.06c-.03.13.22.27.82.38.6.11 1.51.39 2.2.5s1.24.25 1.24-.11zm-2.83-6.64c.77.62 1.28.91 1.68 1.13.4.22.73.55.95.3.22-.26-.19-.45-.84-.74-.66-.29-.99-.54-.99-.54l-.7-.37c-.32-.18-.87-.4-.1.22zm6.6-4.38c-.47-.4-.88-.62-.88-.62s-.58-.55-.69-.37c-.1.19.66.73 1.02 1.06.37.33 1.02 1.28 1.35 1.1.33-.19-.33-.77-.8-1.17zm-4.31 17.14-1.05.28c-.41.1-.44.3.3.3s1.06-.2 1.8-.33c.75-.14 1-.22.89-.47-.11-.25-.5-.17-.8-.08l-1.14.3zm1.16 6.21c-.06.14.53 0 .91-.14.39-.14 1.2-.55 1.66-.69.47-.14.47-.22.47-.5 0-.27-.5-.05-1.1.14-.61.2-1.39.8-1.39.8s-.5.25-.55.39zm7.99 3.76c.55-.33.67-.58.47-.75-.2-.16-.36-.14-.8.22-.44.36-1.3.97-1.3.97s-.44.17-.77.34-.75.44-.64.6c.1.17.8 0 1.16-.3.36-.3 1.33-.75 1.88-1.08zm3.77 4.99c.22-.2.88-.41 1.19-.64.3-.22.5-.88.25-.97s-.39.28-.91.67c-.53.39-2.33 1.58-2.33 1.58l-.47.19c-.5.2-.27.33.14.28.42-.06.7-.06 1.19-.44.5-.4.72-.48.94-.67zm5.58 4.73c.47-.2 1.16-.8 1.5-1.1.33-.31.74-.7.5-.9-.26-.19-.53.06-.92.42s-1.41 1.44-1.41 1.44-.14.03-.7.47c-.55.44.04.36.23.17.2-.2.33-.3.8-.5z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#d4af3a",
    d: "m305.58 96.59 2.25-1.6-2.65-.68-1.7 1.36z"
  }), /*#__PURE__*/react.createElement("ellipse", {
    rx: 2.15,
    ry: 2.07,
    cy: 94.72,
    cx: 312.78,
    fill: "#b96b29"
  }), /*#__PURE__*/react.createElement("ellipse", {
    cx: 312.78,
    rx: 1.29,
    cy: 94.28,
    ry: 1.24,
    fill: "#d4af3a"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#d4af3a",
    d: "M308.3 87.6c.55.21 1.27.12 1.27.12s.22-.95-.3-1.41c-.53-.47-1-.8-1.32-1.1l-.38-.42s0 .82-.04 1.34c-.04.51.22 1.27.77 1.48z"
  }), /*#__PURE__*/react.createElement("ellipse", {
    cx: 309.44,
    rx: 0.39,
    cy: 88.65,
    ry: 0.37,
    fill: "#d4af3a"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#d4af3a",
    d: "M306.51 88.25c-.17.23-.53.6-.53.6s.44.02.8.27c.36.26.82.48 1.24.43.43-.05.6-.45.52-.74-.1-.28-.3-.57-.99-.83-.7-.26-.87.04-1.04.27z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#d4af3a",
    d: "M308.01 90.76c-1.35.12-3.13-1.37-3.13-1.37-.17 1.2-.9 1.81-2.04 2.04l.1.05s1.06.54 2.3.73c.57.09 1.07 0 1.67-.13a7.06 7.06 0 0 0 2-.63c.81-.5.57-1.8.57-1.8s-.12.98-1.47 1.1zm-5.25-1.36c-.55-.2-1.38-.6-1.73-.62-.34-.02-.85-.1-.76.54.09.64.74.95 1.38.97.64.02.97-.23 1.35-.42.38-.19.31-.26-.24-.47zm-4.22-2.29c-.6-.43-1.14-.55-1.14-.55s-.4 1.04-.17 1.68c.22.65.69.82 1.26.8.57-.02 1.42-.31 1.17-.75a3.38 3.38 0 0 0-1.12-1.18z"
  }), /*#__PURE__*/react.createElement("ellipse", {
    cx: 299.09,
    rx: 0.47,
    cy: 90.04,
    ry: 0.34,
    fill: "#d4af3a"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#d4af3a",
    d: "M300.38 84.86c-.37-1.77-.31-3.7 1.37-6.16 1.68-2.46 4.6-3.45 4.6-3.45s.1-.2 1.03-1.19c.94-1 2.84-2.24 2.84-2.24s-2.2.55-3.46.95v.06c0 .85-.67 1.54-1.5 1.54-.33 0-.62-.1-.87-.27-.68.13-2.94 1.49-3.52 1.97.14.23.23.51.23.81 0 .85-.68 1.54-1.51 1.54-.25 0-.49-.06-.7-.17l-.19.33c-.47.87-.82 1.7-1.08 2.48.38.26.64.76.64 1.33 0 .85-.57 1.53-1.28 1.54-.05.5-.04.85-.02 1 .06.5.25.8 1.12 1.06.87.24 2.05 1.77 2.05 1.77.09 0 .7-1.12.25-2.9z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#d4af3a",
    d: "M305.74 73.5c.32-.25.37-.65.12-.87-.25-.23-.71-.2-1.03.06-.31.26-.37.65-.12.88.25.22.71.2 1.03-.06zm-5.64 3.82c.36-.33.42-.82.14-1.1-.29-.3-.8-.26-1.17.07-.35.32-.41.82-.13 1.1.28.29.8.25 1.16-.07z"
  }), /*#__PURE__*/react.createElement("ellipse", {
    cx: 296.74,
    rx: 0.87,
    cy: 82.11,
    ry: 0.86,
    fill: "#d4af3a"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#d4af3a",
    d: "M315.54 70.02c-.45.1-1.29.37-2.54 1.02h.02c.87 0 1.55.56 1.55 1.28s-.8 1.5-1.66 1.5-1.46-.75-1.46-1.47c0-.17.04-.34.11-.49l-1.19.77c-2.77 1.87-3.42 2.77-4.8 5.33-1.36 2.55-1.86 5.35-1.27 7 .6 1.65 2.77 2 2.8 2s-.25-.26-.28-.57c-.03-.31.07-.47.16-1.09.1-.62.03-1.37.03-1.37s.5-.06.78.28c.28.35.68.75.96 1.1.28.33 1.03.99 1.03.99s.44-.63.44-1.37c0-.75-.5-1.56-.6-2.87s.6-3.64 1.87-5.35a15.05 15.05 0 0 1 4.39-3.61c.72-.34.84-.87.87-1.18.03-.32.1-.53.16-1.31s-.65-.75-1.37-.6z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#d4af3a",
    d: "M312.79 72.97c.49 0 .94-.44.94-.84 0-.4-.39-.72-.88-.72s-.88.33-.88.73.33.83.82.83zm4.12 16.28c.67.27 1.42.12 1.78-.12.35-.24.47-.84.05-1.19a1.34 1.34 0 0 0-1.43-.12c-.39.22-1.26.84-1.26.84s.2.32.86.59z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#d4af3a",
    d: "M319.05 90c-.24.37-.42.6-1.16.63s-1.55-.02-2.03-.5c-.49-.49-.82-1.17-.82-1.17l-.84-.01s-.28 1.16-.65 1.48c-.37.33-1.66.38-2.22-.04s-1.08-.94-1.18-.88 0 .49.58.99.98.8 1.92.8h5.32s1.08.07 1.39-.58c.3-.64.32-1.05.17-1.2-.14-.17-.24.1-.48.48z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#d4af3a",
    d: "M310.96 89.1c.8.44 1.24.17 1.53-.19.3-.35.34-.51.34-.51s-.75-.28-1.12-.5c-.36-.2-.61-.41-.98-.37-.36.05-.42.1-.42.1s-.15 1.02.65 1.47z"
  }), /*#__PURE__*/react.createElement("ellipse", {
    cx: 307.11,
    rx: 1.77,
    cy: 81.24,
    ry: 1.76,
    fill: "#b96b29"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#b96b29",
    d: "M310.19 75.14c-.71-.47-1.75-.28-2.33.43-.58.72-.47 1.68.24 2.16.71.48 1.76.29 2.34-.43.57-.7.46-1.68-.25-2.16z"
  }), /*#__PURE__*/react.createElement("ellipse", {
    cx: 307.04,
    rx: 1.03,
    cy: 81.01,
    ry: 0.98,
    fill: "#d4af3a"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#d4af3a",
    d: "M309.45 75.34c-.46-.13-1.02.1-1.26.5s.01.83.62.96c1.12.22 1.66-1.18.64-1.46z"
  }))), me_path26 || (me_path26 = /*#__PURE__*/react.createElement("path", {
    fill: "#D4AF3A",
    d: "M282.34 212.67s-2.74 1.31-3.61 1.54c-.87.24-1.07.24-1.07.24s-1.87 1.7-3.25 2.51c-1.44.85-3.09 1.47-4.74 1.65-2.14.23-8.03.16-10.67.06s-4.28.54-5.42 1.82c-1.13 1.27-1.4 3.11.04 4.52s3.04.7 3.57-.16c.54-.88.27-1.98.04-2.49-.24-.5.47-.67 1.2-.7.74-.03 1.98.07 3.11.23 1.14.17 3.15.84 4.02 1.31.87.47.36.54-.24.44s-1.27-.34-2.34-.74a9.28 9.28 0 0 0-2.64-.64c-.67-.03-.44.34-.3.57.13.24.5.8.6 1.08.1.27-.2 1.27-.2 1.27l.33.64s.4-.64.54-.97c.13-.34-.04-.98.1-1.28s.7-.3 1.14.2c.43.5.93 1.11 1.17 2.38.23 1.28-.2 2.18-.2 2.18s.53.44.63.74c.1.3-.13 1.51-.13 1.51s.36.24.7-.47c.33-.7.73-1.94.83-2.38.1-.44.4-1.24.94-.64s.9 1.34 1 1.71c.1.37.1.67.1.67s1.2-1.17 1.6-1.84 1.25-1.68 2.38-2.62c1.14-.94 3.11-2.81 4.08-3.45.97-.64 3.45-1.98 4.22-2.45s.9-.5 1.03-1.81c.14-1.31.77-2.48 1.07-3.39.3-.9.36-1.24.36-1.24zm-43.85-49.15c-.02-.22-.47-1-.58-1.4-.11-.4-.51-.16-.51-.16s-.87.49-1.52.67-.73-.07-.8-.4c-.07-.34-.22-1.4-.34-2.13-.1-.74-.26-.7-.53-.58-.27.11-1.07.4-1.63.65-.55.24-.38.51-.2.82.18.32.83 1.64 1.12 2.1.29.48.02.68-.32.83-.33.16-.82.23-1.49.45s-.62.38-.56.6c.07.23.52 1.15.76 1.57.25.42.47.13.47.13s.71-.64 1.31-.94c.6-.28.65-.2.8.25.16.45.85 2.8.99 3.24.13.45.35.4.67.27.3-.13.73-.2 1.09-.31.35-.11.49-.83.49-.83s-1.32-2.37-1.67-2.97c-.36-.6 0-.74.26-.78.27-.05 1.05-.16 1.72-.32.66-.17.48-.55.46-.78zm14.86 64.38c-.1-.57 0-1.14-.43-1.58a5.4 5.4 0 0 1-1.17-2c-.2-.71.16-1.05.1-1.45-.07-.4-.6-.4-1.14.03-.54.44-1.24.84-1.24 2.11 0 1.28.47 2.79 2.24 3.32 1.77.54 1.74.14 1.64-.43zm1.8-.61s-.37-.23-.54.1-.13.5.34 1.24.77.9 1.3 1.24c.54.34.17-.33.1-.53-.06-.2 0-.47-.13-.64-.13-.17-.2-.37-.2-.9 0-.54-.87-.5-.87-.5z"
  })), me_path27 || (me_path27 = /*#__PURE__*/react.createElement("path", {
    fill: "#D4AF3A",
    d: "M257.32 233.33c.33-.5.64-.64 1.44-1s2.27-.58 2.77-.61c.5-.03 1.64-1 1.47-2.01-.16-1.01-.9-1.41-1.54-1.55s-1.2-.13-1.4.17c-.2.3-.57.7-1.27.94s-.8.47-1.24.6c-.43.14-.1.4-.47.7-.36.31-.86 0-1.43-.16-.57-.17-.6-.27-1.24-.3l-2.3-.14s-.07-.03-.44-.03-.4.07-.57.47c-.17.4.03 1.41.44 1.91.4.5 1.7.74 2.57 1 .87.28 1.3.38 2.04.51.76.13.86 0 1.2-.5zm8.13.8c.7-.47.3-1.27.13-1.78-.16-.5-1.13-.6-1.63-.6s-.77 0-1.04.23c-.27.24-.64.57-1.37.8-.74.24-1.3.51-2.31.91-1 .4-1.3 1.08-1.74 1.35-.43.26-1.27 0-1.27 0s-.6-.17-.8 0c-.2.16 0 .5.4.93.4.44 1.17.4 2.04.68.87.26 1.04.06 1.37-.17.33-.24.6-.74 1.2-1.1.6-.38 1.91-.44 2.55-.51a6.15 6.15 0 0 0 2.49-.74zm0-3.05c.3.27.64.64.9.2.27-.43.7-1.34.4-1.88-.3-.53-.66-1-.66-1s-.5 1.54-.74 1.94c-.22.41-.19.47.11.74zm-2.71-4.63c0-.87-.6-1.95-.6-1.95s-.2.8-.57 1.51c-.37.7-.74 1.08-.74 1.08s.87.23 1.2.23.72.01.72-.86zm-5.01 1.85c.94-.2 1.44-.57 1.84-.9s.64-1.25.37-1.71c-.27-.48-.94-.98-1.2-.98h-.5s-.28.87-.64 1.31c-.37.44-.8.74-.77 1.3.03.57-.04 1.17.9.97zm1.9-4.26a1.6 1.6 0 0 0-.43-1.2l-.5-.5s-.07.66-.14 1.03-.1.44-.1.44.27.27.5.37c.23.09.63.3.66-.14zm-11.56-23.79.63-3.95c-.47-3.95-2.53-7.7-4.16-10.28a49.03 49.03 0 0 1-4.06-8.8 24.93 24.93 0 0 1-1.23-6.66c0-1.55.66-2.35.66-2.35s.29-.42.02-.69c-.26-.26-.68-.02-1.1.4s-.86 1.2-1.04 1.75c-.17.56-.17.75-.17.75s-.84-.2-2.19-.08c-1.34.1-1.98.22-2.03.5-.04.3.18.51 1.15.93.97.42 1.59.6 2.07 1.18.49.57 1.73 3.46 2.1 4.86.39 1.4 1.2 5.18 1.53 8.15s1.33 6.57 2.73 9.57c.46.99 2.97 5.67 5.09 4.73zm2.45 6.96c-.92.51-.88 4.25-.47 6.19.4 1.94 2.3 4.35 2.88 5 .57.64.7.64 1.01.47.31-.17.44-.17.44-.17s.82-.27 1.43-.74c.6-.48.37-1.67.27-2.73-.1-1.05-.92-3.16-2.4-5.6-1.49-2.46-2.24-2.94-3.15-2.43zm1.01-3.03c0-1.22-1.06-2.14-2.27-2.14a2.1 2.1 0 0 0-1.4.43c-1.23 1.1-.49 3.89 1.3 3.89.64 0 1.4-.11 1.86-.56.42-.39.51-1.04.51-1.62zm17.68 35.14c-.49-.09-.77-.28-1.5-.77-.7-.49-1.86-1.5-2.06-1.98-.2-.5-.2-.52-.89-.29-.69.23-1.66.2-2.4.23-.75.03.08.86.6 1.64.51.77.34 3.38.34 3.38s0 .23-.12.6c-.11.38-.03.64.17.72.2.09.32-.08.84-.69.51-.6 1.46-2.18 1.46-2.18l.95.23c.8.2 2.1.09 2.75-.11.68-.2.36-.7-.13-.78z"
  })), me_path28 || (me_path28 = /*#__PURE__*/react.createElement("path", {
    fill: "#D4AF3A",
    d: "M266.14 241.34c-.34-.06-.49-.09-.66.14-.17.23-.32.66-.4.9-.09.22-.06.42.14.6.2.17.5.37.5.37s.28.31.57.46c.28.14.34-.29.34-.6 0-.32.17-.9.17-1.27s-.3-.55-.65-.6z"
  })), me_path29 || (me_path29 = /*#__PURE__*/react.createElement("path", {
    fill: "#1D5E91",
    d: "M396.62 216.11c-.84-.2-1.2-.52-1.2-.52s-.35-.04-.64.48c-.27.52-1.35 1.2-1.35 1.2s-1.51.4-1.72 1.43c-.2 1.04.52 1.4 1.24 1.28.72-.12 2.48-.48 3.23-1.4.76-.91.88-1.43 1.04-1.8.14-.34.23-.46-.61-.66zm2.35-8.26c-.55-2.3-2.03-5.16-4.9-6.58 0 0-1.08 3.79-1.4 4.98-.32 1.2-.32 1.16.6 1.4.91.24 3.86.88 4.46 1.04s1.6.67 1.24-.85zm-13.68-2.15c.68.12.6-.16.84-1.08l1.43-5.46s-3.03-.12-5.66 1.16c-2.63 1.27-3.79 3.62-3.79 3.62s.68.28 2.48.68c1.8.4 4.03.95 4.7 1.07zm-7.02 6.26c-1.07-.2-1.48-.32-1.48-.32s.68 2.6 1.8 4.03c1.12 1.44 2.35 2.15 4.67 2.2 2.3.03 4.06-1.24 4.34-2.24.28-1 .76-1.75.76-1.75s-4.19-.56-5.9-.96c-1.74-.4-3.13-.76-4.21-.96z"
  })), me_path30 || (me_path30 = /*#__PURE__*/react.createElement("path", {
    fill: "#D4AF3A",
    d: "M377.55 210.32c1.04.24 9.57 1.87 10.29 2.03.72.16 1.32.32 1.52.12.2-.2.32-.32 1.07-.6.76-.27.72-1.03.72-1.03s.2-.72.28-1.44c.08-.72.48-.96 1.32-.08.83.88 1 2.15 1.15 3.4.16 1.23 2.12 1.55 2.87 1.67.76.12 1.12-.12 1.56-.84.44-.72.68-2.15.8-3.07.12-.92.04-.84-.92-1.08-.96-.24-5.38-1.23-6.18-1.44-.8-.2-.64-.71-.52-1.27s1.87-6.18 1.87-6.18c-1.25-.78-3-1.24-5.1-1.48 0 0-1.28 5.74-1.52 6.62-.24.88-.8.88-1.71.72-.92-.16-7.54-1.71-7.54-1.71l-.52 1.23c-.52 1.24-.76 2.71-.76 3.47s.27.74 1.3.97z"
  })), me_path31 || (me_path31 = /*#__PURE__*/react.createElement("path", {
    fill: "#D4AF3A",
    d: "M400.2 215.51c-.88-.57-1.53-.73-1.99.34-.45 1.07-.5 2.64-1.64 3.75-1.14 1.11-2.75 2.26-4.35 2.14-1.6-.11-2.52-.5-2.14-2.33.38-1.83 2.83-2.4 3.4-3.36s.42-2.07-.42-2.8c-.84-.72-2.06-.88-2.4-.65a5.29 5.29 0 0 0-1.84 2.45c-.5 1.38-.8 2.49-1.87 3.37a8.1 8.1 0 0 1-5.96 1.26c-2.13-.5-2.9-1.15-3.7-3.25-.8-2.1-1.76-5.58-2.18-5.97-.42-.38-.95-.69-1.87-.04-.91.65-.99 1.61-1.1 2.38-.12.76 0 1.64.91 2.75.92 1.1 1.87 2.22 2.22 3.36.34 1.15 1.37 2.91-.08 2.99-1.45.07-2.1.11-3.2-.96-1.11-1.07-5.43-4.02-6.61-4.97-1.19-.96-1.68-1.26-1.68-1.26-2-.04-4-.86-6-2.22 0 0 1.15 2.94 1.38 4.05.23 1.11.19 1.72.19 1.72s4.35 2.22 6.07 3.06c1.72.84 5.2 2.83 6.87 3.86 1.68 1.04 3.1 2.64 6.07 2.03 2.98-.61 9.01-2.45 10.96-3.02 1.95-.57 7.33-1.91 9.32-3.29s2.17-1.3 2.52-2.68c.34-1.35 0-2.1-.88-2.69zm-11.49-20.59c.33-.04.46-.09 1.48-.22 1.02-.14.64.84.46 1.21-.17.38-.48 1.13-.9 1.84-.42.7.13.82.42.93.28.11.7.15 1.52.38.82.22.66-.38.69-.69.02-.31.06-1.93.15-2.5.09-.57.62-.42.82-.3l1.12.6c.42.23.62-.01.7-.26s.3-.68.47-1.32c.18-.64-.22-.51-.62-.51s-.97 0-1.63-.02c-.66-.02-.24-.67-.24-.67L394 192c.37-.6.24-.68-.14-.8l-1.87-.46c-.33-.09-.49-.04-.49.18s-.04 1.37-.04 1.81c0 .44-.04.7-.62.73-.57.02-.93-.31-1.39-.82-.46-.5-.66-.3-.7-.1-.05.19-.43 1.65-.52 2.05-.1.39.11.37.44.32zm3.2 14.49s-.04 1.16-.16 1.55c-.12.4-.4 1 .08 1.16.48.16.92.36 1.2.28.28-.08.15-.64 0-1.11a4.27 4.27 0 0 0-.76-1.48l-.35-.4zm7.02 4.62c.16.36.48.44.72.52.24.08.56.08.56-.36s.08-1-.28-1.48c-.36-.48-.55-.82-.76-.12-.2.72-.4 1.1-.24 1.44zm-24.45-4.66c.2.04.96.28.96.28s0-1.12.16-1.88c.15-.75.47-1.27.2-1.27s-.44.24-.64.56c-.2.31-.76.4-.96 1.31-.2.91.08.95.28 1z"
  })), me_circle2 || (me_circle2 = /*#__PURE__*/react.createElement("circle", {
    cy: 207.45,
    cx: 379.27,
    r: 1.56,
    fill: "#B96B29"
  })), me_circle3 || (me_circle3 = /*#__PURE__*/react.createElement("circle", {
    cy: 208.53,
    cx: 383.65,
    r: 1.59,
    fill: "#B96B29"
  })), _circle4 || (_circle4 = /*#__PURE__*/react.createElement("circle", {
    cy: 211.24,
    cx: 396.42,
    r: 1.6,
    fill: "#B96B29"
  })), _circle5 || (_circle5 = /*#__PURE__*/react.createElement("circle", {
    cy: 209.57,
    cx: 388.04,
    r: 1.6,
    fill: "#B96B29"
  })), _circle6 || (_circle6 = /*#__PURE__*/react.createElement("circle", {
    cy: 205.74,
    cx: 389.2,
    r: 1.6,
    fill: "#B96B29"
  })), _circle7 || (_circle7 = /*#__PURE__*/react.createElement("circle", {
    cy: 201.91,
    cx: 390.32,
    r: 1.6,
    fill: "#B96B29"
  })), _circle8 || (_circle8 = /*#__PURE__*/react.createElement("circle", {
    cy: 207.3,
    cx: 379.38,
    r: 0.78,
    fill: "#D4AF3A"
  })), _circle9 || (_circle9 = /*#__PURE__*/react.createElement("circle", {
    cy: 208.37,
    cx: 383.77,
    r: 0.8,
    fill: "#D4AF3A"
  })), _circle10 || (_circle10 = /*#__PURE__*/react.createElement("circle", {
    cy: 211.08,
    cx: 396.54,
    r: 0.8,
    fill: "#D4AF3A"
  })), _circle11 || (_circle11 = /*#__PURE__*/react.createElement("circle", {
    cy: 209.41,
    cx: 388.16,
    r: 0.8,
    fill: "#D4AF3A"
  })), _circle12 || (_circle12 = /*#__PURE__*/react.createElement("circle", {
    cy: 205.58,
    cx: 389.32,
    r: 0.8,
    fill: "#D4AF3A"
  })), _circle13 || (_circle13 = /*#__PURE__*/react.createElement("circle", {
    cy: 201.75,
    cx: 390.44,
    r: 0.8,
    fill: "#D4AF3A"
  })), me_use || (me_use = /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#me_svg__a",
    transform: "matrix(-1 0 0 1 639.97 0)",
    height: 320,
    width: 640
  })));
};

/* harmony default export */ var me = (SvgMe);
;// CONCATENATED MODULE: ./public/flags/pt.svg
var pt_path, pt_path2, pt_g, pt_path3, pt_path4, pt_g2, pt_use, pt_use2, pt_g3, pt_use3, pt_use4, pt_use5, pt_use6;

function pt_extends() { pt_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return pt_extends.apply(this, arguments); }



var SvgPt = function SvgPt(props) {
  return /*#__PURE__*/react.createElement("svg", pt_extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 400"
  }, props), pt_path || (pt_path = /*#__PURE__*/react.createElement("path", {
    fill: "red",
    d: "M0 0h600v400H0z"
  })), pt_path2 || (pt_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#060",
    d: "M0 0h240v400H0z"
  })), pt_g || (pt_g = /*#__PURE__*/react.createElement("g", {
    fill: "#ff0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.573,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M318.24 262.04c-30.21-.91-168.74-87.38-169.69-101.15l7.65-12.757c13.74 19.966 155.36 104.06 169.27 101.08l-7.23 12.823"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M154.59 146.4c-2.71 7.294 36.149 31.318 82.903 59.754 46.752 28.434 87.065 46.006 90.053 43.486.183-.325 1.47-2.54 1.352-2.523-.56.844-1.923 1.11-4.05.497-12.632-3.643-45.576-18.765-86.375-43.506-40.798-24.743-76.294-47.544-81.81-57.232-.384-.671-.658-1.896-.602-2.848l-.134-.002-1.175 2.053-.161.322h-.001zm164.36 116.04c-.512.93-1.467.96-3.282.761-11.3-1.25-45.589-17.925-86.162-42.213-47.21-28.26-86.2-54.01-81.97-60.74l1.151-2.034.227.07c-3.804 11.405 76.948 57.578 81.702 60.522 46.724 28.947 86.115 45.851 89.601 41.458l-1.268 2.181v-.002z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M240.17 169.23c30.237-.239 67.55-4.132 89.023-12.69l-4.627-7.517c-12.692 7.025-50.21 11.644-84.652 12.335-40.736-.375-69.49-4.168-83.897-13.835l-4.367 8.005c26.484 11.207 53.623 13.587 88.52 13.703"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M330.44 156.71c-.739 1.182-14.743 6.011-35.373 9.575-13.988 2.133-32.234 3.956-55.004 3.978-21.633.02-39.305-1.52-52.684-3.333-21.656-3.396-32.833-8.12-36.965-9.79.395-.785.65-1.337 1.03-2.07 11.895 4.736 23.124 7.591 36.28 9.615 13.29 1.8 30.75 3.362 52.275 3.342 22.664-.023 40.71-1.984 54.616-4.053 21.155-3.412 32.711-7.804 34.334-9.843l1.494 2.579h-.002zm-4.06-7.623c-2.293 1.842-13.718 5.894-33.82 9.104-13.414 1.922-30.471 3.643-52.264 3.664-20.704.02-37.62-1.375-50.485-3.249-20.414-2.666-31.28-7.475-35.196-8.877.39-.674.786-1.343 1.194-2.014 3.048 1.535 13.533 5.791 34.226 8.723 12.72 1.803 29.66 3.147 50.262 3.126 21.69-.022 38.553-1.776 51.883-3.688 20.205-2.78 31.077-7.948 32.728-9.241l1.473 2.45v.003zm-185.5 56.573c18.598 10.003 59.905 15.044 98.994 15.391 35.591.056 81.958-5.502 99.297-14.69l-.477-10.012c-5.425 8.477-55.113 16.609-99.206 16.276-44.093-.333-85.038-7.143-98.687-15.959l.08 8.991"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M340.12 204.22v2.387c-2.605 3.116-18.945 7.826-39.436 11.142-15.595 2.391-35.927 4.195-61.262 4.195-24.07 0-43.263-1.716-58.148-4.001-23.53-3.427-38.58-9.427-41.6-11.217l.013-2.786c9.075 6.034 33.661 10.447 41.917 11.798 14.788 2.27 33.868 3.974 57.817 3.974 25.216 0 45.434-1.792 60.931-4.167 14.701-2.123 35.644-7.646 39.767-11.324h.001zm.01-8.492v2.387c-2.605 3.114-18.945 7.824-39.436 11.14-15.595 2.391-35.927 4.195-61.262 4.195-24.07 0-43.263-1.715-58.148-4.002-23.53-3.424-38.58-9.424-41.6-11.216l.013-2.785c9.075 6.033 33.661 10.447 41.917 11.796 14.788 2.272 33.868 3.976 57.817 3.976 25.216 0 45.434-1.792 60.931-4.17 14.701-2.123 35.644-7.646 39.767-11.323l.001.002zM239.79 260.32c-42.772-.255-79.421-11.659-87.16-13.544l5.643 8.834c13.67 5.75 49.424 14.32 81.927 13.371 32.504-.948 60.91-3.466 80.928-13.21l5.787-9.156c-13.642 6.425-60.068 13.639-87.125 13.705"
  }), /*#__PURE__*/react.createElement("path", {
    strokeWidth: 0.55,
    d: "M323.3 253.72a134.08 134.08 0 0 1-2.596 3.83c-9.442 3.329-24.32 6.824-30.597 7.843-12.824 2.643-32.665 4.594-50.274 4.603-37.89-.554-68.905-7.972-83.496-14.299l-1.178-2.024.193-.304 1.996.774c25.948 9.284 55.091 12.987 82.698 13.652 17.538.062 35.095-2.01 49.292-4.549 21.771-4.362 30.574-7.65 33.275-9.14l.687-.386zm5.017-8.275.066.077a269.275 269.275 0 0 1-1.963 3.263c-5.035 1.8-18.702 5.798-38.659 8.589-13.149 1.791-21.322 3.526-47.479 4.034-49.015-1.247-80.75-10.831-88.289-13.195l-1.117-2.143c28.406 7.415 57.422 12.592 89.408 13.12 23.93-.509 34.112-2.271 47.152-4.05 23.27-3.618 34.996-7.449 38.515-8.555a2.667 2.667 0 0 0-.154-.2l2.523-.942-.002.002z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M328.83 197.76c.139 28.137-14.26 53.386-25.858 64.525-16.408 15.759-38.163 25.896-63.569 26.363-28.37.521-55.12-17.974-62.295-26.099-14.028-15.885-25.449-36.057-25.815-63.243 1.738-30.709 13.793-52.1 31.268-66.769s40.743-21.813 60.121-21.302c22.358.59 48.475 11.558 66.521 33.332 11.823 14.266 16.943 29.748 19.627 53.193zm-89.186-96.342c54.485 0 99.296 44.338 99.296 98.703 0 54.364-44.811 98.704-99.296 98.704s-98.924-44.339-98.924-98.704 44.439-98.703 98.924-98.703"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M239.91 101.08c54.534 0 99.011 44.483 99.011 99.022 0 54.538-44.478 99.02-99.011 99.02-54.534 0-99.011-44.481-99.011-99.02s44.478-99.022 99.011-99.022zm-96.832 99.022c0 53.26 43.736 96.842 96.832 96.842 53.097 0 96.833-43.582 96.833-96.842 0-53.262-43.737-96.844-96.833-96.844s-96.832 43.584-96.832 96.844z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M239.99 109.31c49.731 0 90.693 40.821 90.693 90.704 0 49.884-40.963 90.703-90.693 90.703s-90.693-40.819-90.693-90.703c0-49.883 40.964-90.704 90.693-90.704zm-88.515 90.703c0 48.685 39.979 88.524 88.515 88.524s88.515-39.839 88.515-88.524c0-48.686-39.978-88.525-88.515-88.525-48.536 0-88.515 39.84-88.515 88.525z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M243.98 100.68h-8.485l.01 198.96h8.514z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M243.13 99.546h2.16l.018 201.25h-2.161l-.016-201.25zm-8.421.002h2.176l.003 201.25h-2.178V99.548z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M338.99 203.935v-7.355L333 191l-34-9-49-5-59 3-42 10-8.48 6.28v7.357L162 194l51-8h49l36 4 25 6z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M239.95 184.77c23.383-.043 46.07 2.215 64.065 5.72 18.569 3.712 31.637 8.355 36.105 13.57l-.005 2.583c-5.388-6.49-22.973-11.248-36.518-13.968-17.858-3.474-40.393-5.717-63.647-5.674-24.538.046-47.387 2.37-64.984 5.803-14.12 2.802-32.951 8.368-35.302 13.858v-2.689c1.291-3.8 15.313-9.479 34.984-13.417 17.729-3.457 40.62-5.741 65.302-5.786zm.01-8.492c23.383-.042 46.07 2.217 64.065 5.72 18.569 3.713 31.637 8.355 36.105 13.57l-.005 2.583c-5.388-6.489-22.973-11.247-36.518-13.966-17.858-3.476-40.393-5.719-63.647-5.674-24.538.044-47.276 2.37-64.875 5.801-13.626 2.584-33.226 8.37-35.412 13.86v-2.69c1.291-3.76 15.597-9.642 34.985-13.417 17.729-3.458 40.62-5.74 65.302-5.787zm-.48-43.318c36.849-.184 68.99 5.152 83.695 12.685l5.364 9.279c-12.781-6.888-47.456-14.05-89.005-12.979-33.854.208-70.027 3.727-88.176 13.41l6.403-10.709c14.895-7.724 50.022-11.643 81.72-11.684"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M239.97 140.62c21.017-.056 41.325 1.13 57.476 4.044 15.041 2.799 29.385 7 31.436 9.26l1.59 2.81c-4.988-3.257-17.4-6.884-33.339-9.906-16.006-3.008-36.3-4.005-57.2-3.95-23.722-.081-42.152 1.171-57.969 3.929-16.728 3.13-28.334 7.601-31.197 9.726l1.558-2.97c5.564-2.838 14.39-6.26 29.223-8.93 16.357-2.988 34.983-3.884 58.423-4.013zm-.009-8.484c20.113-.053 39.972 1.068 55.452 3.85 12.209 2.377 24.283 6.088 28.704 9.39l2.326 3.695c-3.954-4.395-18.836-8.56-31.974-10.892-15.361-2.65-34.395-3.698-54.508-3.866-21.108.06-40.615 1.352-55.752 4.108-14.441 2.749-23.76 6.002-27.703 8.543l2.045-3.087c5.441-2.864 14.232-5.495 25.303-7.646 15.249-2.777 34.876-4.036 56.108-4.095zM289.15 241.26c-18.218-3.4-36.469-3.895-49.217-3.745-61.407.72-81.244 12.61-83.665 16.21l-4.59-7.482c15.635-11.332 49.074-17.687 88.588-17.037 20.518.336 38.224 1.698 53.119 4.583l-4.236 7.473"
  }), /*#__PURE__*/react.createElement("path", {
    strokeWidth: 0.55,
    d: "M239.58 236.46c17.082.255 33.849.96 50.033 3.978l-1.172 2.07c-15.031-2.775-31.055-3.837-48.803-3.75-22.663-.178-45.585 1.939-65.541 7.666-6.297 1.753-16.721 5.8-17.784 9.146l-1.166-1.923c.336-1.977 6.636-6.08 18.414-9.39 22.858-6.545 44.24-7.649 66.02-7.799v.002zm.775-8.596c17.698.33 35.975 1.149 53.74 4.668l-1.22 2.153c-16.042-3.184-31.37-4.246-52.415-4.57-22.735.042-46.851 1.663-68.778 8.037-7.08 2.063-19.297 6.52-19.704 10.05l-1.166-2.065c.265-3.206 10.842-7.388 20.358-10.156 22.096-6.424 46.275-8.076 69.186-8.117z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m327.58 247.38-7.379 11.449L299 240l-55-37-62-34-32.19-11.01 6.86-12.72L159 144l20 5 66 34 38 24 32 23 13 15z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M148.65 158.29c5.646-3.83 47.139 14.655 90.555 40.834 43.301 26.254 84.677 55.921 80.942 61.473l-1.228 1.932-.564.445c.12-.087.743-.848-.06-2.906-1.846-6.07-31.196-29.491-79.895-58.895-47.475-28.31-87.04-45.371-90.997-40.494l1.247-2.39zm180.44 88.927c3.57-7.052-34.916-36.044-82.632-64.272-48.813-27.666-83.994-43.951-90.42-39.095l-1.428 2.6c-.012.142.052-.178.354-.411 1.168-1.02 3.105-.95 3.979-.967 11.065.166 42.667 14.71 87.006 40.128 19.428 11.315 82.071 51.491 81.832 62.79.017.97.08 1.17-.285 1.651l1.594-2.423v-.002z"
  }))), pt_path3 || (pt_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.67,
    d: "M180.6 211.01c0 16.271 6.663 30.987 17.457 41.742 10.815 10.778 25.512 17.579 41.809 17.579 16.381 0 31.247-6.653 42.016-17.389 10.769-10.735 17.443-25.552 17.446-41.88h-.002v-79.189l-118.74-.141.012 79.278h.002z"
  })), pt_path4 || (pt_path4 = /*#__PURE__*/react.createElement("path", {
    fill: "red",
    stroke: "#000",
    strokeWidth: 0.507,
    d: "M182.82 211.12v.045c0 15.557 6.441 29.724 16.775 40.009 10.354 10.305 24.614 16.712 40.214 16.712 15.681 0 29.912-6.36 40.222-16.626 10.308-10.265 16.697-24.433 16.699-40.044h-.002V134.39l-113.84-.019-.07 76.748m91.022-53.747.004 48.891-.041 5.172c0 1.361-.081 2.912-.24 4.233-.925 7.73-4.48 14.467-9.745 19.708-6.164 6.136-14.671 9.942-24.047 9.942-9.327 0-17.64-3.938-23.83-10.1-6.349-6.32-10.03-14.986-10.03-23.947l-.012-54.023 67.94.122.002.002z"
  })), pt_g2 || (pt_g2 = /*#__PURE__*/react.createElement("g", {
    id: "pt_svg__e"
  }, /*#__PURE__*/react.createElement("g", {
    id: "pt_svg__d",
    fill: "#ff0",
    stroke: "#000",
    strokeWidth: 0.5
  }, /*#__PURE__*/react.createElement("path", {
    stroke: "none",
    d: "M190.19 154.43c.135-5.521 4.052-6.828 4.08-6.847.029-.019 4.232 1.407 4.218 6.898l-8.298-.051"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m186.81 147.69-.682 6.345 4.14.009c.04-5.25 3.975-6.123 4.07-6.103.09-.005 3.989 1.16 4.093 6.103h4.151l-.75-6.394-15.022.038v.002zm-.96 6.37h16.946c.357 0 .65.353.65.784 0 .43-.293.781-.65.781H185.85c-.357 0-.65-.35-.65-.781 0-.431.293-.784.65-.784z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M192.01 154.03c.018-3.313 2.262-4.25 2.274-4.248 0 0 2.342.966 2.36 4.248h-4.634m-5.8-8.98h16.245c.342 0 .623.318.623.705 0 .387-.28.704-.623.704H186.21c-.342 0-.623-.315-.623-.704 0-.387.28-.705.623-.705zm.34 1.42h15.538c.327 0 .595.317.595.704 0 .388-.268.704-.595.704H186.55c-.327 0-.595-.316-.595-.704 0-.387.268-.704.595-.704zm5.02-10.59 1.227.002v.871h.895v-.89l1.257.004v.887h.897v-.89h1.258l-.002 2.01c0 .317-.254.521-.549.521h-4.41c-.297 0-.57-.237-.572-.526l-.003-1.988h.001zm4.62 2.69.277 6.451-4.303-.015.285-6.453 3.741.017"
  }), /*#__PURE__*/react.createElement("path", {
    id: "pt_svg__a",
    d: "m190.94 141.56.131 3.478-4.125.001.116-3.479h3.879-.001z"
  }), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#pt_svg__a",
    x: 10.609
  }), /*#__PURE__*/react.createElement("path", {
    id: "pt_svg__b",
    d: "m186.3 139.04 1.2.003v.872h.877v-.892l1.23.004v.889h.879v-.893l1.23.002-.002 2.012c0 .314-.249.518-.536.518h-4.317c-.29 0-.559-.235-.56-.525l-.002-1.989z"
  }), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#pt_svg__b",
    x: 10.609
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#000",
    stroke: "none",
    d: "M193.9 140.61c-.026-.627.877-.634.866 0v1.536h-.866v-1.536"
  }), /*#__PURE__*/react.createElement("path", {
    id: "pt_svg__c",
    fill: "#000",
    stroke: "none",
    d: "M188.57 142.84c-.003-.606.837-.618.826 0v1.187h-.826v-1.187"
  }), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#pt_svg__c",
    x: 10.641
  })), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#pt_svg__d",
    y: 46.32
  }), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#pt_svg__d",
    transform: "rotate(-45.202 312.766 180.004)"
  }))), pt_use || (pt_use = /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#pt_svg__d",
    x: 45.714
  })), pt_use2 || (pt_use2 = /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#pt_svg__e",
    transform: "matrix(-1 0 0 1 479.792 0)"
  })), pt_g3 || (pt_g3 = /*#__PURE__*/react.createElement("g", {
    id: "pt_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#039",
    d: "M232.636 202.406v.005c0 2.212.85 4.227 2.212 5.69 1.365 1.466 3.245 2.377 5.302 2.377 2.067 0 3.944-.905 5.303-2.365 1.358-1.459 2.202-3.472 2.202-5.693v-10.768l-14.992-.013-.028 10.766"
  }), /*#__PURE__*/react.createElement("circle", {
    cx: 236.074,
    cy: 195.735,
    r: 1.486
  }), /*#__PURE__*/react.createElement("circle", {
    cx: 244.392,
    cy: 195.742,
    r: 1.486
  }), /*#__PURE__*/react.createElement("circle", {
    cx: 240.225,
    cy: 199.735,
    r: 1.486
  }), /*#__PURE__*/react.createElement("circle", {
    cx: 236.074,
    cy: 203.916,
    r: 1.486
  }), /*#__PURE__*/react.createElement("circle", {
    cx: 244.383,
    cy: 203.905,
    r: 1.486
  }))), pt_use3 || (pt_use3 = /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#pt_svg__f",
    y: -26.016
  })), pt_use4 || (pt_use4 = /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#pt_svg__f",
    x: -20.799
  })), pt_use5 || (pt_use5 = /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#pt_svg__f",
    x: 20.745
  })), pt_use6 || (pt_use6 = /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#pt_svg__f",
    y: 25.784
  })));
};

/* harmony default export */ var pt = (SvgPt);
;// CONCATENATED MODULE: ./public/flags/ro.svg
var ro_path, ro_path2, ro_path3;

function ro_extends() { ro_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ro_extends.apply(this, arguments); }



var SvgRo = function SvgRo(props) {
  return /*#__PURE__*/react.createElement("svg", ro_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3 2"
  }, props), ro_path || (ro_path = /*#__PURE__*/react.createElement("path", {
    fill: "#002B7F",
    d: "M0 0h1v2H0z"
  })), ro_path2 || (ro_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#FCD116",
    d: "M1 0h1v2H1z"
  })), ro_path3 || (ro_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#CE1126",
    d: "M2 0h1v2H2z"
  })));
};

/* harmony default export */ var ro = (SvgRo);
;// CONCATENATED MODULE: ./public/flags/se.svg
var se_path, se_path2, se_path3;

function se_extends() { se_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return se_extends.apply(this, arguments); }



var SvgSe = function SvgSe(props) {
  return /*#__PURE__*/react.createElement("svg", se_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 10"
  }, props), se_path || (se_path = /*#__PURE__*/react.createElement("path", {
    fill: "#006aa7",
    d: "M0 0h16v10H0z"
  })), se_path2 || (se_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#fecc00",
    d: "M5 0h2v10H5z"
  })), se_path3 || (se_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#fecc00",
    d: "M0 4h16v2H0z"
  })));
};

/* harmony default export */ var se = (SvgSe);
;// CONCATENATED MODULE: ./public/flags/be.svg
var be_path, be_path2, be_path3;

function be_extends() { be_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return be_extends.apply(this, arguments); }



var SvgBe = function SvgBe(props) {
  return /*#__PURE__*/react.createElement("svg", be_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 450 390"
  }, props), be_path || (be_path = /*#__PURE__*/react.createElement("path", {
    fill: "#ED2939",
    d: "M0 0h450v390H0z"
  })), be_path2 || (be_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#FAE042",
    d: "M0 0h300v390H0z"
  })), be_path3 || (be_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M0 0h150v390H0z"
  })));
};

/* harmony default export */ var be = (SvgBe);
;// CONCATENATED MODULE: ./public/flags/us.svg
var us_path, us_path2, us_path3, us_g;

function us_extends() { us_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return us_extends.apply(this, arguments); }



var SvgUs = function SvgUs(props) {
  return /*#__PURE__*/react.createElement("svg", us_extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 7410 3900"
  }, props), us_path || (us_path = /*#__PURE__*/react.createElement("path", {
    fill: "#b22234",
    d: "M0 0h7410v3900H0z"
  })), us_path2 || (us_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M0 450h7410m0 600H0m0 600h7410m0 600H0m0 600h7410m0 600H0",
    stroke: "#fff",
    strokeWidth: 300
  })), us_path3 || (us_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#3c3b6e",
    d: "M0 0h2964v2100H0z"
  })), us_g || (us_g = /*#__PURE__*/react.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/react.createElement("g", {
    id: "us_svg__d"
  }, /*#__PURE__*/react.createElement("g", {
    id: "us_svg__c"
  }, /*#__PURE__*/react.createElement("g", {
    id: "us_svg__e"
  }, /*#__PURE__*/react.createElement("g", {
    id: "us_svg__b"
  }, /*#__PURE__*/react.createElement("path", {
    id: "us_svg__a",
    d: "m247 90 70.534 217.082-184.66-134.164h228.253L176.466 307.082z"
  }), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#us_svg__a",
    y: 420
  }), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#us_svg__a",
    y: 840
  }), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#us_svg__a",
    y: 1260
  })), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#us_svg__a",
    y: 1680
  })), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#us_svg__b",
    x: 247,
    y: 210
  })), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#us_svg__c",
    x: 494
  })), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#us_svg__d",
    x: 988
  }), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#us_svg__c",
    x: 1976
  }), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#us_svg__e",
    x: 2470
  }))));
};

/* harmony default export */ var us = (SvgUs);
;// CONCATENATED MODULE: ./public/flags/au.svg
var au_defs, au_path, au_path2, au_path3, au_path4, au_path5, au_path6, au_g;

function au_extends() { au_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return au_extends.apply(this, arguments); }



var SvgAu = function SvgAu(props) {
  return /*#__PURE__*/react.createElement("svg", au_extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 10080 5040"
  }, props), au_defs || (au_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("path", {
    id: "au_svg__a",
    d: "m0-360 69.421 215.845 212.038-80.301L155.99-35.603l194.985 115.71-225.881 19.651 31.105 224.59L0 160l-156.198 164.349 31.105-224.59-225.881-19.651 194.986-115.711-125.471-188.853 212.038 80.301z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "au_svg__d",
    d: "M0-210 54.86-75.508l144.862 10.614L88.765 28.842l34.67 141.052L0 93.334l-123.435 76.56 34.67-141.052-110.957-93.736L-54.86-75.508z"
  }), /*#__PURE__*/react.createElement("clipPath", {
    id: "au_svg__b"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M0 0v1.5h7V3H6zm6 0H3v3.5H0V3z"
  })), /*#__PURE__*/react.createElement("use", {
    id: "au_svg__c",
    xlinkHref: "#au_svg__a",
    transform: "scale(2.1)"
  }))), au_path || (au_path = /*#__PURE__*/react.createElement("path", {
    fill: "#00008b",
    d: "M0 0h10080v5040H0z"
  })), au_path2 || (au_path2 = /*#__PURE__*/react.createElement("path", {
    d: "m0 0 5040 2520m0-2520L0 2520",
    stroke: "#fff",
    strokeWidth: 504
  })), au_path3 || (au_path3 = /*#__PURE__*/react.createElement("path", {
    d: "m0 0 6 3m0-3L0 3",
    stroke: "red",
    strokeWidth: 0.4,
    clipPath: "url(#au_svg__b)",
    transform: "scale(840)"
  })), au_path4 || (au_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M2520 0v2940M0 1260h5880",
    stroke: "#fff",
    strokeWidth: 840
  })), au_path5 || (au_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M2520 0v2940M0 1260h5880",
    stroke: "red",
    strokeWidth: 504
  })), au_path6 || (au_path6 = /*#__PURE__*/react.createElement("path", {
    d: "M0 2520h5040V0h1680v3360H0z",
    fill: "#00008b"
  })), au_g || (au_g = /*#__PURE__*/react.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#au_svg__c",
    x: 2520,
    y: 3780
  }), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#au_svg__a",
    x: 7560,
    y: 4200
  }), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#au_svg__a",
    x: 6300,
    y: 2205
  }), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#au_svg__a",
    x: 7560,
    y: 840
  }), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#au_svg__a",
    x: 8680,
    y: 1869
  }), /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#au_svg__d",
    x: 8064,
    y: 2730
  }))));
};

/* harmony default export */ var au = (SvgAu);
;// CONCATENATED MODULE: ./public/flags/gb.svg
var gb_clipPath, gb_path, gb_path2, gb_path3, gb_path4, gb_path5;

function gb_extends() { gb_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return gb_extends.apply(this, arguments); }



var SvgGb = function SvgGb(props) {
  return /*#__PURE__*/react.createElement("svg", gb_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 30"
  }, props), gb_clipPath || (gb_clipPath = /*#__PURE__*/react.createElement("clipPath", {
    id: "gb_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M30 15h30v15zv15H0zH0V0zV0h30z"
  }))), gb_path || (gb_path = /*#__PURE__*/react.createElement("path", {
    d: "M0 0v30h60V0z",
    fill: "#00247d"
  })), gb_path2 || (gb_path2 = /*#__PURE__*/react.createElement("path", {
    d: "m0 0 60 30m0-30L0 30",
    stroke: "#fff",
    strokeWidth: 6
  })), gb_path3 || (gb_path3 = /*#__PURE__*/react.createElement("path", {
    d: "m0 0 60 30m0-30L0 30",
    clipPath: "url(#gb_svg__a)",
    stroke: "#cf142b",
    strokeWidth: 4
  })), gb_path4 || (gb_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M30 0v30M0 15h60",
    stroke: "#fff",
    strokeWidth: 10
  })), gb_path5 || (gb_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M30 0v30M0 15h60",
    stroke: "#cf142b",
    strokeWidth: 6
  })));
};

/* harmony default export */ var gb = (SvgGb);
;// CONCATENATED MODULE: ./public/flags/mv.svg
var mv_path, mv_g;

function mv_extends() { mv_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return mv_extends.apply(this, arguments); }



var SvgMv = function SvgMv(props) {
  return /*#__PURE__*/react.createElement("svg", mv_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 720 480"
  }, props), mv_path || (mv_path = /*#__PURE__*/react.createElement("path", {
    fill: "#D21034",
    d: "M0 0h720v480H0z"
  })), mv_g || (mv_g = /*#__PURE__*/react.createElement("g", {
    fill: "#007E3A"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M120 120h480v240H120z"
  }), /*#__PURE__*/react.createElement("circle", {
    fill: "#FFF",
    cx: 390,
    cy: 240,
    r: 80
  }), /*#__PURE__*/react.createElement("circle", {
    cx: 420,
    cy: 240,
    r: 80
  }))));
};

/* harmony default export */ var mv = (SvgMv);
;// CONCATENATED MODULE: ./public/icons/favicon3.svg
var _feColorMatrix, _style, favicon3_path, favicon3_path2, favicon3_path3, favicon3_path4, favicon3_path5, favicon3_path6, favicon3_path7, favicon3_path8, favicon3_path9, favicon3_path10, favicon3_path11, favicon3_path12, favicon3_path13, favicon3_path14, favicon3_path15, favicon3_path16, favicon3_path17, favicon3_path18, favicon3_path19, favicon3_path20, favicon3_path21, favicon3_path22, favicon3_path23, favicon3_path24, favicon3_path25, favicon3_path26, favicon3_path27, favicon3_path28, favicon3_path29, favicon3_path30, favicon3_path31, favicon3_path32, favicon3_path33, favicon3_path34, favicon3_path35, favicon3_path36, favicon3_path37, favicon3_path38, favicon3_path39, favicon3_path40, favicon3_path41, favicon3_path42, favicon3_path43, favicon3_path44, favicon3_path45, favicon3_path46, favicon3_path47, favicon3_path48, favicon3_path49, favicon3_path50, favicon3_path51, favicon3_path52, favicon3_path53, favicon3_path54, favicon3_path55, favicon3_path56, favicon3_path57, favicon3_path58, favicon3_path59, favicon3_path60, favicon3_path61, favicon3_path62, favicon3_path63, favicon3_path64, favicon3_path65, favicon3_path66, favicon3_path67, favicon3_path68, favicon3_path69, favicon3_path70, favicon3_path71, favicon3_path72, favicon3_path73, favicon3_path74, favicon3_path75, favicon3_path76, favicon3_path77, favicon3_path78, favicon3_path79, favicon3_path80, favicon3_path81, favicon3_path82, favicon3_path83, favicon3_path84, favicon3_path85, favicon3_path86, favicon3_path87, favicon3_path88, favicon3_path89, favicon3_path90, favicon3_path91, favicon3_path92, favicon3_path93, favicon3_path94, favicon3_path95, favicon3_path96, favicon3_path97, favicon3_path98, favicon3_path99, favicon3_path100, favicon3_path101, favicon3_path102, favicon3_path103, favicon3_path104, favicon3_path105, favicon3_path106, favicon3_path107, favicon3_path108, favicon3_path109, favicon3_path110, favicon3_path111, favicon3_path112, favicon3_path113, favicon3_path114, favicon3_path115, favicon3_path116, favicon3_path117, favicon3_path118, favicon3_path119, favicon3_path120, favicon3_path121, favicon3_path122, favicon3_path123, favicon3_path124, favicon3_path125, favicon3_path126, favicon3_path127, favicon3_path128, favicon3_path129, favicon3_path130, favicon3_path131, favicon3_path132, favicon3_path133, favicon3_path134, favicon3_path135, favicon3_path136, favicon3_path137, favicon3_path138, favicon3_path139, favicon3_path140, favicon3_path141, favicon3_path142, favicon3_path143, favicon3_path144, favicon3_path145, favicon3_path146, favicon3_path147, favicon3_path148, favicon3_path149, favicon3_path150, favicon3_path151, favicon3_path152, favicon3_path153, favicon3_path154, favicon3_path155, favicon3_path156, favicon3_path157, favicon3_path158, favicon3_path159, favicon3_path160, favicon3_path161, favicon3_path162, favicon3_path163, favicon3_path164, favicon3_path165, favicon3_path166, favicon3_path167, favicon3_path168, favicon3_path169, favicon3_path170, favicon3_path171, favicon3_path172, favicon3_path173, favicon3_path174, favicon3_path175, favicon3_path176, favicon3_path177, favicon3_path178, favicon3_path179, favicon3_path180, favicon3_path181, favicon3_path182, favicon3_path183, favicon3_path184, favicon3_path185, favicon3_path186, favicon3_path187, favicon3_path188, favicon3_path189, favicon3_path190, favicon3_path191, favicon3_path192, favicon3_path193, favicon3_path194, favicon3_path195, favicon3_path196, favicon3_path197, favicon3_path198, favicon3_path199, favicon3_path200, favicon3_path201, favicon3_path202, favicon3_path203;

function favicon3_extends() { favicon3_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return favicon3_extends.apply(this, arguments); }



var SvgFavicon3 = function SvgFavicon3(props) {
  return /*#__PURE__*/react.createElement("svg", favicon3_extends({
    id: "favicon3_svg__Ebene_1",
    x: 0,
    y: 0,
    viewBox: "0 0 375.5 377.8",
    style: {
      enableBackground: "new 0 0 375.5 377.8"
    },
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/react.createElement("defs", {
    id: "favicon3_svg__defs1146"
  }, /*#__PURE__*/react.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "favicon3_svg__filter1583",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _feColorMatrix || (_feColorMatrix = /*#__PURE__*/react.createElement("feColorMatrix", {
    values: "0.21 0.72 0.072 0 0 0.21 0.72 0.072 0 0 0.21 0.72 0.072 0 0 0 0 0 1 0",
    id: "favicon3_svg__feColorMatrix1581"
  })))), _style || (_style = /*#__PURE__*/react.createElement("style", {
    type: "text/css",
    id: "style591"
  }, ".favicon3_svg__st0{fill:#00b7e2}.favicon3_svg__st4{fill:#0061ac}.favicon3_svg__st5{fill:#00b5e1}.favicon3_svg__st8{fill:#22bae4}.favicon3_svg__st12{fill:#30bce4}.favicon3_svg__st13{fill:#2ebbe4}.favicon3_svg__st14{fill:#29bbe4}.favicon3_svg__st15{fill:#26bbe4}.favicon3_svg__st16{fill:#00b4e1}.favicon3_svg__st17{fill:#005ca6}.favicon3_svg__st18{fill:#005aa4}.favicon3_svg__st22{fill:#0072b8}.favicon3_svg__st23{fill:#0087c6}.favicon3_svg__st25{fill:#008dca}.favicon3_svg__st27{fill:#006cb3}.favicon3_svg__st28{fill:#007bbe}.favicon3_svg__st29{fill:#0067b0}.favicon3_svg__st31{fill:#07b}.favicon3_svg__st33{fill:#0059a2}.favicon3_svg__st34{fill:#fefefe}.favicon3_svg__st39{fill:#0082c3}.favicon3_svg__st41{fill:#0194cf}.favicon3_svg__st42{fill:#009ad2}.favicon3_svg__st45{fill:#31bce5}.favicon3_svg__st51{fill:#0088c7}.favicon3_svg__st52{fill:#0096d0}.favicon3_svg__st53{fill:#0091cd}.favicon3_svg__st58{fill:#41bee6}.favicon3_svg__st59{fill:#49bfe6}.favicon3_svg__st60{fill:#36bde5}.favicon3_svg__st61{fill:#46bfe6}.favicon3_svg__st62{fill:#41bee5}.favicon3_svg__st63{fill:#38bde5}.favicon3_svg__st65{fill:#005298}.favicon3_svg__st66{fill:#00569f}.favicon3_svg__st67{fill:#004e94}.favicon3_svg__st76{fill:#00579f}.favicon3_svg__st79{fill:#0076ba}.favicon3_svg__st93{fill:#5ec4e8}.favicon3_svg__st95{fill:#4fc1e7}.favicon3_svg__st98{fill:#004a8f}.favicon3_svg__st99{fill:#004588}.favicon3_svg__st103{fill:#6fc8ea}.favicon3_svg__st104{fill:#6dc8ea}.favicon3_svg__st105{fill:#70c9ea}.favicon3_svg__st108{fill:#004182}.favicon3_svg__st109{fill:#004688}.favicon3_svg__st110{fill:#003d7d}.favicon3_svg__st116{fill:#87d0ed}.favicon3_svg__st118{fill:#94d4ef}.favicon3_svg__st120{fill:#9bd6f0}")), /*#__PURE__*/react.createElement("g", {
    id: "favicon3_svg__Ebene_1-2",
    style: {
      filter: "url(#favicon3_svg__filter1583)"
    }
  }, favicon3_path || (favicon3_path = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st0",
    d: "M74 39.9C91.9 25 112.4 15 134.5 8.2c12.3-3.7 24.9-6 37.7-7.1 1.1-.1 2.4.5 3-1.1h3c5.2 1.1 10.5.2 15.8.5 1.7.2 3.5-.4 5.2.4 30.6 2.1 60.1 11.8 86 28.2 2.2 1.4 4.6 2.5 6 5 .3 1.2-.2 1.8-1.2 2.2-1.2.1-2.3-.3-3.2-1C276.4 28 265 22.2 253 18.1c-1.4-1.2-2.8-2.6-4.9-2.5-.4 0-.8-.1-1.2-.3-1.5-.8-3.2-1.3-4.9-1.5-.4-.1-.9-.2-1.3-.4-7.1-2.2-14.1-4.7-21.7-4.6-2.8 0-5.1-2.4-8.1-1.4-12.6-2.2-25.2-1.3-37.7.5-.5.1-1 .2-1.4.2-13.8.7-26.5 5.4-39.4 9.7-5 1.7-9.4 4.9-14.8 5.6-5.6 2.7-11 5.8-16.2 9.4-15 10.4-28.5 22.9-40 37.1-4.5 5.6-7.8 12-12 17.7-1.5 2-.5 3.2 1 4.6 4.8 4.4 10.5 7.6 15.5 11.6 10.7 8.7 22.1 16.6 33.3 24.6 17.5 12.4 37 16.8 58.2 13.4 2.1-.3 4.4.1 6.4-.9 3.2-1.6 6.8-2.3 10.1-3.8 7.9-2.1 14.7-6.6 21.4-11 3.9-2 6.5-6.4 11.5-6.5 1.1 2.5-1.2 3.4-2.2 4.9-.5.5-1.1 1-1.7 1.4-12.8 10.2-26.8 18.1-42.7 22-27.3 6.7-51.8.5-74.2-16.4-12.5-9.4-25.4-18.2-37.8-27.7-3.3-2.6-7.1-4.8-10.2-7.8-2.9-2.8-3.3-5.6-1-9.3 9.4-15.4 21-29 34.1-41.4 1.6-1.5 3.5-2.8 2.9-5.4Z",
    id: "favicon3_svg__path593"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M194.2.9c-5.3-.3-10.8 1.4-16-.9h16c.3.2.4.4.3.6-.1.2-.2.3-.3.3z",
    id: "favicon3_svg__path595",
    style: {
      fill: "#92daef"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M194.2.9V0h5v.9z",
    id: "favicon3_svg__path597",
    style: {
      fill: "#cfedf7"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M350.1 283.8c-17 30.4-42.4 55.3-73 71.8-82.9 45.4-191.1 19-244-59.2-.4-.7-.8-1.4-1.1-2.2-.4-2.2 1.4-1.7 2.5-1.9.9.1 1.8.4 2.5.9 5.7 6.4 10.4 13.6 16.2 20 3.7 4.1 7.5 7.9 11.3 11.8 1.6 1.8 3.5 3.4 5.6 4.8.4.3.7.6 1 .9 2.5 2.3 4.5 5.2 7.9 6.5.4.2.8.5 1.2.8 8 5.9 16.6 11 25.6 15.2 7.7 3.7 15.6 6.5 23.4 9.6 6.4 3.2 13.3 5 20.4 5.2.5.1.9.2 1.4.4 2.9 1.9 6.9.1 9.7 2.7 4.1 2.5 8.7 1.9 13 2.1 20.8 1.5 41.7-.9 61.6-7 26.2-8.2 50.3-20.8 70.2-40.2 12-11.6 22.9-24 30.9-38.8 2.1-3.8 1.1-5.8-1.9-7.9-7.9-5.9-16.2-11.1-23.7-17.5-11.8-10-25.2-17.9-36.9-28.1-4.5-3.9-10.2-6.2-15.7-8.6-8.6-3.8-17.1-8.5-26.6-9.9-14.1-2.2-28-6.1-42.4-3.2-2.3.3-4.7.3-7 0-2.4-.2-2.2-1.5-.9-3.1 8.2-3.5 17-3.4 25.5-3.4 13 0 25.9 2 38.3 6 2.9 1.2 5.9 2 8.8 3.3 3.3 1.5 6.7 2.7 10.1 4.1 3.1 1.6 6.2 3.2 9.2 5.1 3.6 2.4 7.6 4.3 11.1 7 1.7 1.5 3.6 2.6 5.3 4.2 2.4 2.3 5.5 3.7 7.9 5.9 1.6 1.5 3.5 2.6 5.2 4 3.2 2.3 6.3 4.8 9.5 7 1.7 1.4 3.4 2.8 5.3 3.9 2.4 1.6 4.6 3.4 6.9 5 1.7 1.5 3.6 2.6 5.2 4.1 2.5 2.2 5.6 3.7 8 6 1.8 2.1 4.6 2.7 6.4 4.8 2.5 2.5 6.8 3.3 6.1 7.9z",
    id: "favicon3_svg__path599",
    style: {
      fill: "#005ea8"
    }
  }), favicon3_path2 || (favicon3_path2 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st4",
    d: "M34.2 292.8c-.4 1-2.1 0-2.2 1.4-13-18.4-21.4-38.8-26.8-60.5-4-16-5.4-32.4-5.2-48.8 1.1-32.6 9.6-63.1 26.6-91.1 3.1.1 4.6 2.5 6.4 4.3 1.5 2.3.6 4.3-.7 6.5-5.1 8.6-8.7 17.9-11.9 27.3-1.8 5.1-4.4 10-4.7 15.7-.1 1.7-1.2 3.2-2.8 3.9-1.3.4-2.4-.2-3.7-.8.9 1.8 3.7 2.3 3.3 4.9-2 2.4-3.3 5.5-3.4 8.7-1.2 11.4-1.5 22.9-1 34.3.3 6.3-.4 12.6 2.4 18.5.7 1.4.5 3-1.4 3.7-.2.6-3.1-.8-1.1 1.4s5.1 2.9 6.2 5.9c3 17 10 32.4 17.2 47.9-4.3 3-2.4 6-.3 9.4 1.5 2 4.6 3.9 3.1 7.4z",
    id: "favicon3_svg__path601"
  })), favicon3_path3 || (favicon3_path3 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st4",
    d: "M343 85c7.2 10.3 13.2 21.3 18 32.9 12 28.8 16.7 60.2 13.5 91.3-1.5 16.4-5.4 32.4-11.5 47.7-2.7 1-3.5-.6-3-2.7 2.3-8.6 3.7-17.5 7-25.9.2-.4.6-.8 1-1.1 1.9-1.6.4-2.5-.7-3.5-1.7-1.4-3.2-2.9-2.9-5.4 2.9-19.6 2.8-39.6-.2-59.2-.3-2-.6-4 1.1-5.5.6-.1-.2-.3.4-.2 2.4.4 3-.3 1.5-2.4-4.9-10.7-7.5-22.1-11-33.2-1.3-4.1-4.4-7.2-6.2-11.1-2.5-5.5-5.3-11-9.2-15.8-2.3-3.2-1.7-4.4 2.2-5.9z",
    id: "favicon3_svg__path603"
  })), favicon3_path4 || (favicon3_path4 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st5",
    d: "m204.2 123.9 3-4c.4-3.9 4-5 6.4-6.9 3.2-2.5 6.9-4.5 10.2-7 11-6.4 22-12.6 33.5-17.9 7.2-2.6 14.2-5.5 21.5-7.7 14.7-4.4 29.6-7.3 45-6.7.7.2 1.5-.1 2-.7-6-10-15.7-16.8-22.9-25.7.3-4 2.5-2.2 4.3-1.3 11.3 8.4 20.4 18.8 28.8 30 0 2.4-1.9 2.2-3.4 2.4-2.4.2-4.8.2-7.2.2-4.7-.8-9.2.7-13.8.9-5.1.1-10.1 1.5-15 2.6-2.8.6-5.5 1.3-8.2 2-2.7.7-5.3 1.2-7.9 2-3.7 1.1-7.4 2.4-11 3.9-2.7.8-5.4 1.8-8 3-3.8 1.2-7.2 3.4-10.8 5.1-3.4 1.5-6.6 3.3-10 5-3.1 1.4-6.1 3.1-9 4.9-3.6 1.6-6.7 3.9-10 6-3.2 1.8-6.3 3.8-9.2 5.9-3 .9-4.2 5.4-8.3 4z",
    id: "favicon3_svg__path605"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M325.1 77.1c3.6-.8 7.6 1.4 11-1.2 1.2.2 1.5 1.2 1.9 2.1-2 2.1-4.8.5-7.6 1.9 4.5 5.6 8.6 11.4 12.3 17.5 7.4 12.6 14.3 25.6 16.8 40.2.6 3.3 4.2 5.5 2.9 9.2-6-.9-9.5-5.3-13-9.6-2.1-9.7-6.4-18.5-11.1-27.1-4.7-8.8-10.1-17.2-16.1-25.1-1.5-1.9-4.2-3.8-3.3-6.3.9-2.5 4.3-.3 6.2-1.6z",
    id: "favicon3_svg__path607",
    style: {
      fill: "#0067af"
    }
  }), favicon3_path5 || (favicon3_path5 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st4",
    d: "M369.3 227.8c-3.3 1.2-1.8 4.6-2.8 6.8-3 6.4-2.8 13.8-5.7 20.4-.6 1.4 1 1.7 2.2 1.9-3.2 9.5-7.5 18.6-12.9 27-.9-3.7-4.4-4.9-7-7 4.6-10.1 9.4-20.1 13.4-30.5 2.7-7.1 4.2-14.5 4.5-22.1.1-.7.4-1.3 1-1.6 3.8-.4 6.1 1.6 7.3 5.1z",
    id: "favicon3_svg__path609"
  })), favicon3_path6 || (favicon3_path6 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st4",
    d: "M362.1 146.7c-5.7-15.1-9.6-31-18-45.1-3.5-5.9-7.8-11.4-11.9-17-1.4-1.9-2.9-3.6-3.5-6.7h9.2c2 2 3.7 4.4 5 7-2.8 1.5-3 2.9-.9 5.7 4.5 5.9 6.9 13.3 11 19.3 5.1 7.3 5.4 15.9 9.3 23.3 1.3 2.4 1.1 5 2 7.5 1 2.7.9 5.9 3.7 7.8 1.1.8.1 1.8-.1 2.7-3.4.5-4.8-1.7-5.8-4.5z",
    id: "favicon3_svg__path611"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M307.3 45.9c-1.4.2-3.3-1.4-4.2 1.1-5.7-2-10.2-5.5-13-11l1-1.9c6.5 2.5 11.3 7.2 16.2 11.8z",
    id: "favicon3_svg__path613",
    style: {
      fill: "#0db8e3"
    }
  }), favicon3_path7 || (favicon3_path7 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st5",
    d: "m32.2 98.1-5.6-4.3C34.2 80.7 43.5 68.7 54.2 58c1.2-.7 2.2-1.8 3-3 .9-2.4 3.7-3 5.1-5 1.2-.8 2.2-1.7 3-2.8 2.4-3 6-4.6 8.8-7.2 2.9 1.4 2 2.9.2 4.5-8.5 7.8-16.8 15.9-23.9 25-4.9 6.3-9.2 13.2-13.7 19.9-1.3 2.1 0 3.9 1.7 5.2 7.2 5.5 14.8 10.6 21.7 16.4 10 8.4 21.1 15.4 31.7 23.1 12 8.7 26.2 13.8 41 14.9 20.9 1.8 39.3-5 57-14.9 4.7-2.6 8.3-7.1 13.4-9.2.4 2.6 3.3 3.8 3.4 6.5-.7 1.7-2.1 2.5-3.6 3.3-23.1 13.3-46.8 25.7-71.1 36.7-1.5.7-3 1.5-4.7.9-1.9-1.3-1.4-3.1-.9-4.9.9-3 2.1-5.9 3.6-8.6 2.4-4.4 2.4-4.4-2.7-5.3-2.8-.5-5.5-1.1-8.3-1.3-3.2-.5-6.4-1.3-9.5-2.3-2.8-.8-5.5-1.8-8.3-2.7-3.1-.6-5.4-2.9-8.3-4-3.2-1.4-5.7-3.9-8.7-5.6-1.4-1.1-2.9-2-4.3-3.1-1.7-1.4-3.5-2.6-5.2-4-2.3-1.6-4.5-3.4-6.8-5s-4.4-3.5-6.8-5c-1.3-1.1-2.7-2.2-4.2-3.1-3.2-2.1-6-4.6-9.2-6.5-2.6-1.3-4.3-3.8-6.8-5.4-3-2.3-6.4-4.2-8.6-7.4z",
    id: "favicon3_svg__path615"
  })), favicon3_path8 || (favicon3_path8 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st0",
    d: "M57.2 55c.1 1.5-1.1 2.9-2.6 3h-.3z",
    id: "favicon3_svg__path617"
  })), favicon3_path9 || (favicon3_path9 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st0",
    d: "M65.2 47.1c0 1.6-1.3 2.9-2.9 2.8h-.1z",
    id: "favicon3_svg__path619"
  })), favicon3_path10 || (favicon3_path10 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st8",
    d: "M117.2 23c13.9-6.4 28.4-11.4 43.3-14.9 3.8-.9 7.8-.8 11.7-1.1 0 3.1-2.4 3-4.5 3.3-8.4 1.6-16.7 3.8-24.9 6.5-10.3 2.3-19.6 7.1-28.6 12.4-13.4 7.8-25.6 17.5-36.4 28.6-8.2 8.5-15.3 18-21.1 28.2-1.3 2.2-.9 3.7 1 5.1L90 115.4c5.2 3.9 10.3 7.8 15.6 11.4 7.5 5.3 16 9.1 24.9 11.2 9.9 2.3 20.1 2.9 30.2 1.6 1.5-.3 2.9-.8 4.3-1.3 1.6-.6 3.4-.6 5-1.1.5-.1 1-.2 1.5-.2 1-.1 2 .2 2.7 1-2.9 2.5-6.7 2.5-10 4-18.9 3.2-37.3 1.8-54.7-7.1-3-1.5-5.8-3.3-8.4-5.2-16-11.6-31.7-23.6-47.9-35-3.5-2.5-4.2-5.9-1.8-9.7 6.7-10.7 14.5-20.6 23.1-29.8C87 42.1 101.7 32.1 117.2 23Z",
    id: "favicon3_svg__path621"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M117.2 23c-.7 3.1-3.8 3.6-6 4.8-10.9 5.7-20.8 13-29.6 21.6-11 11-21.4 22.6-29.2 36.2-2.1 3.6-1.6 6.3 2.3 8.7 8.8 5.2 16.4 12.2 24.7 18.2 9.6 7 18.5 15.1 28.9 20.6 14.6 7.7 30.4 12.2 47.3 9.1 2.7-.5 5.6-.1 8.5-.2-2.9 2.1-6.4 1.4-9.6 1.7-22.8 2.5-43.2-3.6-61.2-17.9-9-7.1-18.5-13.7-27.8-20.6-5.9-4.4-11.7-8.9-17.8-13.1-1.8-1.3-1.6-2.1-.7-3.5 9.2-14.3 19.1-28 31.9-39.3 9.6-8.5 19.2-17 30.9-22.6 2.2-1 3.7-2.7 5.4-4.3 1.3-1.2 1.9-.8 2 .6z",
    id: "favicon3_svg__path623",
    style: {
      fill: "#13b9e3"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "m290.1 36 13 11c6 4.8 11.5 10.1 16.4 15.9 3.2 3.6 6.7 7 9.1 12.1h-9.1c-20.4-.1-39.5 5.3-58.1 13.2-1.4.5-2.8.8-4.3.8-.5-1 .1-1.8.7-2.4.9-.7 1.9-1.2 3-1.5 1.5-.5 2.9-1.1 4.2-1.8.4-.2.8-.4 1.3-.5 2.7-.7 5.3-1.7 7.9-2.8 3.9-2.1 8.3-2.9 12.5-3.9 1.7-.3 3.4-.2 5-.8.5-.1.9-.3 1.4-.3 8.7-1.2 17.3-2.7 26.2-2.3 1.6.1 4.1.2 1.3-2.3-2.6-2.1-5.1-4.4-6.5-7.6-1.2-3.9-4.3-6-7.7-7.8-3-1.5-4.9-4.2-7.1-6.6-1.8-2.1-4.1-3.8-6.6-4.9-11-8.8-23.3-15.9-36.3-21.3-5.8-2.4-11.9-4.1-17.6-6.8-.7-.3-1.3-.8-1.8-1.4-.1-.5 0-1.1.5-1.4 1.3-.3 2.6-.5 3.8.4h1c1.5 1.1 3.4 1.1 5 2h1c1.9.1 3.2 1.5 5 2 13.3 4.2 25.2 11.3 36.8 19z",
    id: "favicon3_svg__path625",
    style: {
      fill: "#30bce5"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M206.2 131.2c-1-2.1-5.4-2.5-3.1-6.3l1-1c3.4-.4 4.7-4.3 8-5 3.1 1.8 7 2.1 9.3 5.2-4 4.1-9.4 6.7-15.2 7.1z",
    id: "favicon3_svg__path627",
    style: {
      fill: "#01addd"
    }
  }), favicon3_path11 || (favicon3_path11 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st8",
    d: "M173.2 7c6.9-2.2 14-1.5 21.1-1.9 5.7-.3 11.5-.7 16.9 1.8.3.4.3.9 0 1.3-.6.6-1.5.8-2.3.8-8.9-1.5-17.8-.1-26.6 0-2.1-.5-4.2-.1-6.4-.3-1.2 0-2.8.4-2.7-1.7z",
    id: "favicon3_svg__path629"
  })), favicon3_path12 || (favicon3_path12 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st12",
    d: "M173.2 7c2.8 2.3 6.2-.9 9 1-1.8 3.8-5.5 2.9-8.5 3.2-4.9.6-9.8 1.1-14.4 3.1-.5.3-1 .5-1.5.6-3.3.2-6.6 1-9.6 2.2-1.8.8-3.8 1.4-5.7.3-.4-.3-.5-1-.2-1.4 8.3-3.3 17-5.6 25.8-6.9 1.7-.3 3.4-.2 4.2-2.1h.9z",
    id: "favicon3_svg__path631"
  })), favicon3_path13 || (favicon3_path13 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st13",
    d: "M224.2 107c-5.3 4.8-12.2 7.5-17.1 12.9-4.1 1.6-7.1 5-11 7-.8.6-1.9.7-2.8.2-.8-2.4 1.5-2.7 2.5-3.9 6.9-4.3 13.4-9.2 19.9-14.1 1.7-1.3 3.4-2.7 5.6-3.2 1.1-.1 2.2.3 2.9 1.1z",
    id: "favicon3_svg__path633"
  })), favicon3_path14 || (favicon3_path14 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st14",
    d: "M211.2 8V7c.4-.3.8-1 1.1-1 9.4 2.2 19.3 2.6 28.4 6.2.2.1.4.5.5.8h-4c-9-.3-17.7-1.6-26-5z",
    id: "favicon3_svg__path635"
  })), favicon3_path15 || (favicon3_path15 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st15",
    d: "M193.2 126.9h3c-6.8 4.7-13.4 9.8-22 11h-3c-.4-1.6.9-2 1.8-2.7 2-1.2 4.3-2.1 6.6-2.5 2.8-.3 5.1-1.9 7.5-3.1l1.2-.6c1.4-.6 2.7-1.5 4.2-2z",
    id: "favicon3_svg__path637"
  })), favicon3_path16 || (favicon3_path16 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st14",
    d: "M247.1 15c-2.1.5-3.9.1-5-2 2 0 4-.3 5 2z",
    id: "favicon3_svg__path639"
  })), favicon3_path17 || (favicon3_path17 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st14",
    d: "M253.1 17c-1.9.2-3.8-.6-5-2 2.6-1.6 3.4 1.2 5 2z",
    id: "favicon3_svg__path641"
  })), favicon3_path18 || (favicon3_path18 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st16",
    d: "M246.1 213c-13.4-3.5-27.1-6.1-41-5.9-8 .1-16.2.6-24 2.8-2.9 2.7-6.8 2.5-10.2 3.5-12.1 3.5-23.8 8.4-34.8 14.7-1.5.8-2.9 1.7-4.7 1.3-1.8-1.1-3.1-2.8-3.7-4.9a4.8 4.8 0 0 1 2.3-3.1c30.9-23.3 64.3-41.3 102.5-49.4 4.1-.9 8.2-1.3 12.3-1.9 1.6-.2 3.3-.5 4.7.9 3.7 11.7 3.9 24.2.5 36.1-.6 2.3-1.2 4.8-3.9 5.9z",
    id: "favicon3_svg__path643"
  })), favicon3_path19 || (favicon3_path19 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st17",
    d: "M131.2 229c9.2-4.5 18.2-9.6 27.9-13.1 7.2-2.6 14.4-4.9 22-6 2.4 1.8 5.2 1.3 7.7.9 8.5-1.4 17.2-1.4 25.7.1 7.9 1.3 16.1 2 23.7 4.4 8.8 2.8 17.4 6.5 25.4 11.1 20.4 11.6 37.9 27.2 56.6 41.1 5.1 3.8 10.4 7.5 15.6 11.2 4.7 3.4 4.8 4.7 1.6 9.2-3 4.1-5.5 8.6-8.3 13-4.5 6.9-9.9 13.2-16 18.7-5 4.7-9.3 10-14.8 14.3-10.4 8.2-20.5 16.7-33.3 21-1.3.5-2.4 1.8-3.7 2.5-9.7 4.8-19.8 9.4-30.1 11.7-19 4.4-38.5 7-58.2 5.6-3.6-.3-7.1-1.6-10.8-.7-1.4.4-1.6-1.4-2.2-2.3.9-2.2 2.8-2.3 4.6-1.8 9 2.4 18.1.8 27.1.3 14.4-.8 28.7-3.4 42.5-7.7 15.2-4.9 29.6-12 42.8-21 9.1-6.4 17.7-13.5 25.7-21.2 10-9.4 17.9-20.5 25.1-32.2 2-3.2 1.5-5.6-1.6-8.1-10-8.1-20.9-14.9-30.8-23-10.4-8.6-21.3-16.5-32.5-24-15.1-10.2-32.6-16.4-50.7-18-5.3-.4-10.6-1.2-15.9-.9-4.8-.3-9.7-.8-14.3 1.2-.7.2-1.4.3-2.1.3-10.3.8-20.4 2.8-29.6 7.8-8.9 3.6-17.4 7.8-25.6 12.7-.8.5-1.7.9-2.6 1.3-.9.3-1.9.3-2.8-.1-.4-.3-.6-.7-.6-1.2 3.3-4 7.9-5.5 12.5-7.1z",
    id: "favicon3_svg__path645"
  })), favicon3_path20 || (favicon3_path20 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st18",
    d: "M196.2 212.9c22.7-.6 45.1 5.3 64.5 17 11 6.8 21.4 14.4 31.4 22.6 8.6 7 17.7 13.4 26.6 20 3.6 2.6 6.9 5.7 10.6 8.2 2.4 1.6 2.1 3.8.9 6.2-4.5 8.8-10.6 16.4-16.6 24.1-8.2 10.5-18.6 18.9-29 27-11.4 8.9-24.1 15.5-37.4 21.4-13.6 6-27.7 9.1-42 11.1-9 1.1-18 1.8-27 2-6 .2-11.9-2.4-17.9-.5-1.7-1.1-3.6-1.1-5.6-1-2 .1-3.6 0-4.4-2 1.6-1.9 3.6-1.9 5.8-1.6 3.9.5 7.7 1.2 11.6 1.6 6.9 1.5 14 1 20.9.6 15.6-1.1 31-4.2 45.7-9.4 21.2-7.3 39.7-18.8 56.6-33.6 10.9-9.6 19-21.3 28.4-32 2.1-2.4 2.9-5.6 4.2-8.5 1.2-2.7-.7-4-2.4-5.3-12.2-9-24.1-18.4-36.3-27.2-7-5-13.7-10.5-20.7-15.6-16-11.8-34.1-18.5-53.6-21.4-3.3-.6-6.6-1-9.9-1.2-1.9-.3-4.1.2-4.4-2.5z",
    id: "favicon3_svg__path647"
  })), /*#__PURE__*/react.createElement("path", {
    d: "m284.1 231.9-11-7c3.9-7.4 6.2-15.5 6.5-23.9.5-7.9 1.3-15.9-.1-23.9-.3-1.7-.2-3.4 1.3-4.6 5.2-.8 9.9 0 13.7 4.1-.6 2.1-.7 4.2-.6 6.4 1.6 12.1-.6 23.8-3.7 35.4-1 3.7-2.7 7.1-3.7 10.9-.3 1.3-.5 2.8-2.4 2.6z",
    id: "favicon3_svg__path649",
    style: {
      fill: "#0098d1"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M281.1 173c-1.7 2.2-.2 4.6.1 6.7 1.3 7.8-.1 15.5-.3 23.2-.2 6.9-2.9 13.5-4.8 20.2-.5 1.7-1.8 1.7-3.1 1.8l-9-4.9c-.2-1.1-.1-2.3.4-3.4 5.6-12.5 5.4-25.7 4-38.9-.2-2.1-1-4.3.7-6.2 4.3-1.4 8.5-2.2 12 1.5z",
    id: "favicon3_svg__path651",
    style: {
      fill: "#00a0d6"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M312.1 252.9c-3.9-1.5-6.7-4.5-10-7 9.5-12 11.4-26.7 13.5-41.1.7-4.5 1.8-9.2.4-13.9-.3-.9.6-1.4 1.5-1.6 4.9 1.8 10.1 3.2 12 9-2.3 14-4.9 28-9.9 41.4-1.3 3.4-2.3 6.9-4.1 10.1-.8 1.3-1.2 3.2-3.4 3.1z",
    id: "favicon3_svg__path653",
    style: {
      fill: "#0081c2"
    }
  }), favicon3_path21 || (favicon3_path21 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st22",
    d: "M329.1 265.9c-1.6-1.4-3.9-2-5-4-.6-6.3 3.1-11.4 5.3-16.8 4.1-10.1 6.2-20.6 8.5-31 .5-2.5.3-5.4 2.5-7.3 5 .3 8.4 2.9 10.4 7.4-3.2 16.4-7.1 32.6-15.1 47.5-1.4 2.4-2.5 5.7-6.6 4.2z",
    id: "favicon3_svg__path655"
  })), favicon3_path22 || (favicon3_path22 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st23",
    d: "M318.2 189.9c-.4.2-1.2.4-1.2.5 2.3 17.6-3 33.7-9 49.8-1 2.7-3.1 4.7-5.8 5.7-1.7-1.3-3.9-2-5-4 .2-2 .7-3.9 1.5-5.8 5.5-15.2 9.8-30.7 8.8-47.1-.1-2.4.6-4.3 3.4-4.7 3.3.7 6.5 1.5 7.3 5.6z",
    id: "favicon3_svg__path657"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M269.2 171.8c.6 5.4 2.1 10.8 1.8 16.2-.6 10.9-.4 22.2-6.9 32-3.5-.9-6.8-2.3-9.9-4.1-1.4-3.4 1-6.1 1.8-8.9 2.8-9.9 3.3-20.3 1.5-30.4-.4-2.1-1-4.3.8-6.1 3.8-1.1 7.7-2.7 10.9 1.3z",
    id: "favicon3_svg__path659",
    style: {
      fill: "#00a6da"
    }
  }), favicon3_path23 || (favicon3_path23 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st25",
    d: "M311.2 184.8c-1.6.9-3.1 1.6-2.6 4 1.6 8.1-.1 16.1-1.6 24-1.7 9.2-4.9 18-7.9 26.9-.3 1-1 1.8-1.9 2.2-2.6-2-5.9-3.3-8-6 8.4-16.2 11.1-33.5 10.5-51.6 0-1.6-.7-3.3.8-4.7 4.4-.1 8.4.8 10.7 5.2z",
    id: "favicon3_svg__path661"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M301.5 179.8c-2.3 1.3-.4 3-.4 4.4.6 16.2-2.2 32.4-8.2 47.6-.7 1.8-1.5 3.8-3.9 4.1-1.7-1.3-3.8-2-5-4 3.8-9.9 7.2-19.9 8.1-30.7.6-6.7 1.6-13.4 0-20.2-.4-1.6-.7-3.8 2.1-4.2 3.1-.4 5.8-.3 7.3 3z",
    id: "favicon3_svg__path663",
    style: {
      fill: "#0092cd"
    }
  }), favicon3_path24 || (favicon3_path24 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st27",
    d: "M329.1 265.9c2.7-.2 3.9-1.9 5.1-4.1 6.9-13 11-26.9 13.8-41.1.5-2.4 1.2-4.8 2.2-7.1 3.9-.1 6 2.3 7.6 5.4.4 4.2-1.4 8.1-2.4 12.1-2.9 11.6-6.9 22.8-12 33.6-1.3 2.9-2 6.9-6.4 7.3-2.5-2.2-5.8-3.3-7.9-6.1z",
    id: "favicon3_svg__path665"
  })), favicon3_path25 || (favicon3_path25 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st28",
    d: "M312.1 252.9c7-12.6 10.6-26.3 13.4-40.4 1-4.8-.4-10.6 3.8-14.6 3-.3 4.6 1.3 5.4 4 .2 18.6-4.9 35.9-13.5 52.2-.8 1.6-1.8 3.3-4.1 2.8-2-1-4-1.9-5-4z",
    id: "favicon3_svg__path667"
  })), favicon3_path26 || (favicon3_path26 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st29",
    d: "M337.1 271.9c6.1-5.3 7.4-13.2 10.4-20.1 4.6-10.5 7.1-21.8 9.7-33 1.2-.4 2.1.1 3.1.6 1.1.8 2.1 1.6 2 3.1 1.7 5.1-.9 9.6-1.8 14.4-1.8 10.5-6.8 19.9-11.2 29.5-1.7 3.7-2.5 8-6.2 10.5-1.1-2.8-5.2-1.9-6-5z",
    id: "favicon3_svg__path669"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M258.1 171c.7 5.2 1.7 10.4 1.9 15.7.4 10.1-1.7 20.1-5.9 29.2-2.8-.6-5.5-1.5-8-2.9 5.5-11.6 6-23.7 3.5-36.1-.4-1.9-1.5-3.7-.5-5.7 3-2.5 6-2.4 9-.2z",
    id: "favicon3_svg__path671",
    style: {
      fill: "#00aede"
    }
  }), favicon3_path27 || (favicon3_path27 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st31",
    d: "M317.1 256.9c5.1-4.6 7.2-11 9.4-17 3.5-9.6 5.5-19.6 7.2-29.7.5-2.8-1.5-5.8.8-8.4 3.6-.1 5.9 1.5 6.6 5.2-2.1 8.9-4.1 17.9-6.3 26.8-2.4 9.8-7.3 18.7-10.6 28.2-2.8-1.2-4.9-3.3-7.1-5.1z",
    id: "favicon3_svg__path673"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M64.2 325.8c-9.5-7.9-16.8-17.7-24.3-27.4-1.2-1.5-1.7-3.6-3.7-4.5-2.2-4.1-5-7.9-7.4-11.8-1.5-2.5-1.4-3.7 1.6-4.7 9.1-3.1 18.1-6.4 27.2-9.5 3-1 5.6-4.1 9.3-2.4 1.1 1 .5 1.9-.1 2.8-1.7 2-4.2 2.6-6.6 3.5-7.6 1.8-14.5 5.6-22.1 7.6-5.9 1.6-5.8 1.9-2.4 7 12.3 19.4 27.7 35.7 46.9 48.4 1.1.7 2.2 1.5 3.1 2.5 1.1 1.5 3.3 2.5 2.3 4.9-4.1 1-5.9-3-8.9-4.3-3.7-1.5-5.8-4.9-9-7-1.8-1.9-3.8-3.6-5.9-5.1z",
    id: "favicon3_svg__path675",
    style: {
      fill: "#00569e"
    }
  }), favicon3_path28 || (favicon3_path28 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st17",
    d: "M67.2 265.9c-4.4-.3-7.7 2.7-11.5 4-8.3 2.7-16.3 6.2-24.8 8.1-2.5.5-2.5 1.6-1.4 3.9 2.1 4.1 6 7.2 6.8 12l-2-1c-.8-3.6-3.6-6.1-5.3-9.3-3-5.7-3.2-5.5 2.3-7.7 2.2-2.8 5.9-2.3 8.7-3.8 2.1-.6 4.1-1.3 6.1-2.1 4.2-1.7 8.6-3.1 12.8-4.9 3-1.3 6-2.8 9.1-4 2.8-1.1 5.5-2.6 8.1-4 4.1-2.3 8.7-3.5 12.7-6 4.9-2.9 10.1-5.2 15.1-7.9 4-1.6 7.3-4.2 11.1-6 1.3-.5 2.6-1.4 4.1-.4l.1.1c.4 2.9-2.5 3.3-3.8 4.9-13.9 8.1-27.6 16.5-42.5 22.7-1.9.7-3.6 1.8-5.7 1.4z",
    id: "favicon3_svg__path677"
  })), favicon3_path29 || (favicon3_path29 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st33",
    d: "M79.2 337.8c3.7-.1 5.2 4.5 9 4 4 .1 6.7 2.7 9.9 4.6 3.6 3.4 8.1 4.8 12.5 6.5.5.1.9.3 1.4.6 7.3 3.7 15.2 5.4 23 7.1 1.8.2 3.6.8 5.2 1.5 6.8 2.3 13.9 2.7 20.9 3.5 6.5.7 13.2.5 19.6 1.8 1.4 2.4-.8 2.2-2 2.5-3.5.7-7.1 0-10.6.1-6.1.7-11.9-2.6-18-1-7-1.5-14-3.2-21-5-9.4-2.2-18.1-6.3-26.6-10.5-8.3-4.4-17.1-8.2-23.3-15.7z",
    id: "favicon3_svg__path679"
  })), favicon3_path30 || (favicon3_path30 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st18",
    d: "M129.2 363.8c7.3 0 14.5 1.7 21 5-7.4.6-14.7-1.2-21-5z",
    id: "favicon3_svg__path681"
  })), favicon3_path31 || (favicon3_path31 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st33",
    d: "M70.2 330.8c3.7 1.4 6.2 4.4 9 7-4.7-.2-6.4-4.2-9-7z",
    id: "favicon3_svg__path683"
  })), favicon3_path32 || (favicon3_path32 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st33",
    d: "M64.2 325.8c2.7.6 4.9 2.5 6 5-2.5-.9-4.7-2.7-6-5z",
    id: "favicon3_svg__path685"
  })), favicon3_path33 || (favicon3_path33 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st34",
    d: "m206.2 131.2 15.1-7.2c2.6-3.9 7.4-2.9 10.8-5 3.4-1.2 6.9-2.1 10.3-3.1 3.5-1.4 7.4-1.2 11-2.2 3.9-.5 7.7-1.5 11.7-1.2h1.7c5 .1 10 .1 15 0 3.8-.4 7.4.8 11 1 3.8.5 7.5 1.3 11.2 2.2 4.4 1.2 9 2.1 13.2 4 2.3.9 4.7 1.6 7 2.4 4.3 2.2 9 3.6 13.2 6.1 4.1 3.2 9.7 4.3 12.6 9.1l12.2 9.4c1.7 1.8 3.7 3.4 5.9 4.6.7 1.3 2.8 1.9 2.1 4.2l-3-1.6c-4.2-1-7-4.3-10.5-6.4-4-3.4-8.4-6.4-13.1-8.9-3.6-2.6-7.5-4.6-11.8-5.9-2.7-1.1-5.6-1.5-8.2-2.7-3.3-1.1-6.7-1.6-10.1-2.6-2.2-.6-4.5-1-6.8-1.1-3.3.4-6.5-.7-9.8-.9-2.2-.1-4.4-.1-6.7-.1-1.7.1-3.3.1-5 .1-3-.3-5.8 1.1-8.8 1-3.2.1-6.1 1.1-9.2 1.7-2.5.3-5 1.1-7.6 1.4-3.5.7-6.8 1.9-10.2 2.8-4 1-8 2.3-11.9 3.9-4.2 1.4-8.3 3-12.3 4.9-19.6 8.5-38.1 19.3-55.2 32-11.8 8.7-23.7 17.2-37.8 22.2-4.6 1.6-9.3 2.7-13.9 4-4.7 1.5-9.7.7-14.5 1.8-3.6.8-7.2-.6-10.8-.6-4.4 0-8.6-1.2-12.8-2.1-2.7-.8-5.5-1.4-8.1-2.3-3.9-1.2-7.4-3.6-11.4-4.7-3.6-1.8-6.9-4-10.3-6.1-3.6-2.8-7.4-5.4-10.9-8.3-1.3-1.2-2.7-2.3-4.2-3.2-2.5-2.1-5.5-3.7-8-5.8-3-2.2-5.9-4.4-8.8-6.6-1.1-.8-2.1-1.6-3.1-2.4-1.4-1-2.9-1.9-3.5-3.7-1.2-1-2.4-2.1-3.7-3.1-.9-.8-2.8-1.4-1.5-2.9 1.3-1.5 2 .5 3 .9.7.3 1.4.7 2.1 1.2 3.5.8 5.7 3.5 8.6 5.3 2.3 1.8 4.5 3.5 6.9 5.1 3 2.4 6 4.6 9.1 6.9 2.6 2.1 5.3 4.1 8 6 2.3 1.8 4.6 3.5 7.1 5 2.1 1.4 4.4 2.4 6.9 2.9 3.2 1 6.6 1.5 9.9 2.2 1.5.1 2.9.2 4.4.2h3.6c1.4.1 2.8 0 4.2-.4.5-.1.9-.3 1.4-.4 3.2-.1 6.3-.6 9.4-1.4 3.1-.9 6.3-1.2 9.4-2.4 3.5-1.1 7.2-1.9 10.7-3.2 5.2-1.4 9.8-4.7 15.4-4.9 18-6.9 34.9-16.1 51.9-25.2 9.5-5.3 18.5-10.7 27.5-15.9z",
    id: "favicon3_svg__path687"
  })), favicon3_path34 || (favicon3_path34 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st34",
    d: "M341 206.9c-1.6-2.4-4.1-3.8-6.6-5.2-1.4-1.7-3.2-3-5.1-3.9-3.1-3.5-7.3-5.4-11.1-8-1.7-2.6-4.4-3.8-7.1-5.1-2.7-2.7-6.4-3.4-9.6-5.1-1.9-2.3-5.1-1.2-7.2-2.9-4.1-2-8.6-3.3-13.1-3.8-3.9-1.5-7.9-1.4-12-1.2-3.6-1.9-7.3-.7-11-.8l-9 .1c-19.9 1.5-38.8 7-57 15-23.1 9.9-44.6 22.9-64.2 38.7-2.4 4.4-7.2 5.6-10.9 8.2-1.5 1-3.1 1.9-4.8 2.7-3.7 1.8-7.4 3.7-11.3 5.2-5.3 2.4-11 3.5-16.6 5-6.9 1.7-13.8 1.2-20.8 1.3-2 .1-4 0-6-.2-4.5-.7-8.9-1.6-13.3-2.8-4.1-1.1-8.2-2.5-12.1-4.2-3.1-1.3-6.1-2.9-9.1-4.4-3.3-2.6-7.4-4.2-9.8-7.9-2.2-1.7-4.4-3.3-6.5-5.1-.9-.8-1.6-2-.6-3.2.1-.2 1.2.4 1.8.6 2.2.6 4.2 1.7 5.9 3.2 2.7 2.1 5.7 3.8 8.9 5 2.2.9 4.5 1.5 6.8 1.9 2.2.7 4.5.3 6.7.9 3.3 1 6.6.5 9.9-.2 2.6-.2 5.2-.5 7.8-1 3.6-.4 7.1-1.2 10.6-2.2 3.9-1 7.7-2.2 11.4-3.6 3-.9 6-1.8 8.9-3 3.6-1.3 7.1-2.8 10.7-4.2 2.8-1.4 5.8-2.2 8.5-3.7 6.1-3.1 12.3-5.8 18.2-9.2 19.7-9.3 38-21.2 57.5-30.7 16-7.7 32.7-12.9 50.6-13.7 3.1-.1 6.2-1.2 9.4-1 5.3-.1 10.6 1.2 15.9 1.2 4.8.9 9.6 1.4 14.3 2.7 2.8.4 5.4 1.5 8.2 2.1 3.1.9 6.1 1.9 9 3.2 2 .8 4.1 1.4 6 2.3 2.6 1.4 5.4 2.7 8.1 4 2.4 1.4 4.9 2.5 7.3 3.8 2.7 1.7 5.2 3.5 7.9 5.2 1.5 1 2.9 2 4.3 3.2 2.5 2.1 5.2 4 7.9 6 2.2 1.9 4.7 3.3 7 5 2.3 1.7 4.5 3.5 6.9 5.1 2.4 2 4.9 3.8 7.4 5.6 2.5 2 5.1 3.8 7.8 5.5 1.7 1.9 5 2.5 4.8 6-.7 1.1-1.6 1.1-2.6.6l-2.6-1.3c-2-2.1-4.4-3.8-6.9-5.2-2.9-2.5-6.1-4.8-9.5-6.5z",
    id: "favicon3_svg__path689"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M20 157c-2.9-1.6-5.6-3.7-8-6 1.6-.6 2.1-2 2.4-3.5 2-13.4 8.6-25.1 13.3-37.5.9-2.3 2.1-4.5 3.7-6.4 1.6-1.9 1.3-3.5.7-5.5 3.3 1.8 6.3 4.1 9 6.8 1.2 1.6.1 2.8-.8 4-7.2 9.1-10.3 20-14 30.7-1.6 4.2-2.7 8.6-3.3 13-.1 1.7-.2 4.2-3 4.4z",
    id: "favicon3_svg__path691",
    style: {
      fill: "#0068b0"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M13.1 223.9c-2-.9-3.8-2.3-5.2-3.9 2.3-.2 2.2-1.5 1.3-3.1-4-6.8-1.9-14.4-2.5-21.6-.5-6.3-.5-12.6 0-18.9.5-5.9.5-12 2.2-17.7.5-1.7 1.3-3.3 3.3-3.8l4 3c.3 1 .3 2 .1 2.9-3.7 17.5-3.2 35.2-1.2 52.8.3 2.6.2 5.3-.1 7.9-.1 1.1-.1 2.6-1.9 2.4z",
    id: "favicon3_svg__path693",
    style: {
      fill: "#0064ae"
    }
  }), favicon3_path35 || (favicon3_path35 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st29",
    d: "m13.2 227.8 10.1 6.6c1.9 2 1.1 4.7 1.9 7 2.5 8.1 5.8 15.9 9 23.7 1.3 3.1 3.4 5.7 6 7.8-2.6 2.1-6 1.9-9 3-4.6-3.7-5.2-9.6-7.5-14.5-4.2-8.7-7.4-17.9-9.5-27.4-.5-2.1-.7-4.2-1-6.2z",
    id: "favicon3_svg__path695"
  })), /*#__PURE__*/react.createElement("path", {
    d: "m362.2 218.8-5.4-4.8c.3-6.8 1.9-13.4 1.9-20.2 0-12.9-1.2-25.8-3.8-38.4-.6-1.9-.8-3.9-.8-5.9.2-1.9.6-3.8 3.4-2.8 3.5 2 6.8 4.4 9.8 7.1-3.1.7-1.9 2.9-1.7 4.7 2.1 14.6 3.5 29.3 1.8 44.1-.6 5.9-.3 11.8-2.3 17.5-1.6.7-2.4 0-2.9-1.3z",
    id: "favicon3_svg__path697",
    style: {
      fill: "#0066af"
    }
  }), favicon3_path36 || (favicon3_path36 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st34",
    d: "m362.2 218.8 2.8 1.4 4.6 3.7c1.7 1.4 1.6 2.7-.2 3.8-2.1-2.1-4.4-3.9-7-5.3l-2.5-2.5c.9.1 1.7-.3 2.3-1.1z",
    id: "favicon3_svg__path699"
  })), /*#__PURE__*/react.createElement("path", {
    d: "m337 129.3-13-6.1c-2.3-3.1-4.2-6.4-5.8-9.8-4.9-9.4-11.4-17.4-18.7-25-1.9-2-5-3.8-3.3-7.5 4.8-1.6 9.9-2.6 15-2.9 0 1.6-.5 3.1.9 4.6 7.6 8.6 14.3 18 19.8 28.1 2.3 4.1 4.1 8.3 6.1 12.6.9 2 1.9 4.4-1 6z",
    id: "favicon3_svg__path701",
    style: {
      fill: "#0073b8"
    }
  }), favicon3_path37 || (favicon3_path37 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st27",
    d: "M337 129.3c1.6-2.3.5-4.5-.5-6.5-6.8-14.5-15-28.2-26.1-39.9-2.3-2.5-2-3.6.7-4.8 4.7-.3 9.3-1.6 14-1-6.4 2.1-6.1 1.9-1.7 7.8 11.4 15 20.8 31.2 26.6 49.3.4 1 .4 2.2-.1 3.2z",
    id: "favicon3_svg__path703"
  })), favicon3_path38 || (favicon3_path38 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st28",
    d: "m317.1 120.8-13-3.9c-4-3.5-5.9-8.7-9.6-12.6-4.5-4.6-8.8-9.5-12.8-14.6-1-1.3-3-2.5-1.5-4.7 2.5-1.1 5.2-1.8 8-2 6.6 3 10.6 8.8 15 14.1 5.2 6.2 9.7 13 13.4 20.2.6 1 1.7 2.1.5 3.5z",
    id: "favicon3_svg__path705"
  })), favicon3_path39 || (favicon3_path39 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st39",
    d: "M280.2 85c2 4.4 5.6 7.6 8.7 11.1 5.6 6.5 12.1 12.4 15.3 20.7l-11-2c-1.7-.5-3.5-.6-4.6-2.4-4.2-7.1-10.7-12.2-16.2-18.2-1.4-1.5-3.7-2.6-3.1-5.2 3.3-1.8 7-3.2 10.9-4z",
    id: "favicon3_svg__path707"
  })), favicon3_path40 || (favicon3_path40 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st31",
    d: "M317.1 120.8C310 107.5 301.8 95 290 85.2c-.7-.7-1.3-1.4-1.9-2.2 2.5-1.1 5.2-1.8 8-2 .3 3.3 2.6 5.2 4.8 7.3 9.3 9 16.2 19.8 22 31.3.8 1.1 1.1 2.4 1.1 3.7z",
    id: "favicon3_svg__path709"
  })), favicon3_path41 || (favicon3_path41 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st23",
    d: "M269.2 89c5.7 7.2 13.4 12.7 18.8 20.2 1.5 2.1 2.3 4.8 5.2 5.6l-11-1c-1-.7-2.4 0-3.4-.8-5.1-5.2-10-10.7-15.7-15.2-1.7-1.4-3.8-3-1.9-5.8 2.5-1.4 5.2-2.4 8-3z",
    id: "favicon3_svg__path711"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M261.2 92c-.3 3 1.9 4.3 3.8 5.9 5.2 4.5 10.7 8.8 14.2 14.9-4.2 1.5-8.7-.2-13 1h-1c-3.4-4.3-7.5-8-11.9-11.1-1.9-1.3-3.8-2.9-3-5.7 3.5-1.7 6.8-4.1 10.9-5z",
    id: "favicon3_svg__path713",
    style: {
      fill: "#018ecb"
    }
  }), favicon3_path42 || (favicon3_path42 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st41",
    d: "M250.2 97c1.4 4.1 5.2 5.7 8.2 8.1 3 2.5 6 4.6 6.8 8.7l-12 1.1c-3.9-2.7-7.4-5.9-11.3-8.6-1.4-.9-3.1-2.2-1.7-4.4z",
    id: "favicon3_svg__path715"
  })), favicon3_path43 || (favicon3_path43 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st42",
    d: "M240.2 102c1.2 4.9 6.4 5.4 9.3 8.4 1.5 1.3 2.7 2.8 3.7 4.5l-10.8 2.1c-4.9-1.3-7.8-5.4-11.5-8.3-.5-.4-.1-1.2.3-1.8z",
    id: "favicon3_svg__path717"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M231.2 107c3 4.2 7.9 6.2 11.2 10.1-3.3 1.3-6.7 2.3-10.1 2.9-4.3-1.4-8.7-2.7-11.1-7z",
    id: "favicon3_svg__path719",
    style: {
      fill: "#01a0d6"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M221.2 112.9c3.4 2.8 7.9 3.9 11.1 7l-10.9 4c-3.1-1.6-7.2-1.3-9.2-5.1 2.7-2.3 5.7-4.3 9-5.9z",
    id: "favicon3_svg__path721",
    style: {
      fill: "#01a6d9"
    }
  }), favicon3_path44 || (favicon3_path44 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st45",
    d: "M224.2 107h-3c-.3-2.3 1.7-2.5 3-3.4 3.7-2.5 7.9-4.2 11.1-7.4 1.6-1.3 3.4-2.4 5.4-3 1.5-.2 2.9-.8 4.1-1.8.7-.6 1.4-1 2.3-1.3 1.5-.3 2.9-.9 4.1-1.8.4-.2.8-.4 1.2-.5 1.9-.3 3.6-2.3 5.8-.8-.3.7-.7 1.4-1 2-7.5 4.1-15 8.1-22.5 12.2-3.6 1.9-7 3.8-10.5 5.8z",
    id: "favicon3_svg__path723"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M36 169c-3.3-1.9-6.4-4.3-9.1-6.9.5-1.4 1.4-2.5 1.6-4.1 2.2-15.7 8.2-30.2 15.4-44.2.9-1.8 1.9-3.5 4.2-3.7 3.3 1.8 6.4 4.1 9.1 6.8-.7 4.8-4 8.5-5.8 12.9-3.7 9.1-7 18.2-8.8 27.8-.6 3.1-1.9 5.9-3.1 8.9-.5 1.5-1.3 3-3.5 2.5z",
    id: "favicon3_svg__path725",
    style: {
      fill: "#0073b9"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M48.1 110.1c-5.5 6-7.8 13.8-10.8 21.1-3.1 7.8-6.2 15.7-7.2 24.1-.1 1-.9 2.3-.5 2.8 2.8 3.9-1.2 3.1-2.7 4-2.6-1.3-4.9-3-6.9-5.1 3.2-7.7 3.9-16.2 7-23.9 3.9-9.8 7.7-19.6 14.1-28.1 3 .7 4.3 3.9 7 5.1z",
    id: "favicon3_svg__path727",
    style: {
      fill: "#006db4"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M36 169c4.7-4.2 4.7-10.1 6.1-15.6 3.3-12.9 7.2-25.5 15-36.5 1.7.3 3.2 1.4 4 3 3.3 2.5 1.8 5.3.5 8-3.9 7.8-7.1 16-9.5 24.5-1.8 6.4-2.4 13-4.8 19.2-.6 1.6-.7 3.8-3.3 3.4-2.9-1.6-5.6-3.7-8-6z",
    id: "favicon3_svg__path729",
    style: {
      fill: "#007abe"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M44.1 175c2.8-2.7 3.3-6.5 4-10 2.3-13.1 6.5-25.8 12.5-37.7 1.3-2.4 2.3-4.8.7-7.4 2.9 1 5 3 7 5.1 1.4 2 .5 3.8-.3 5.6-4 9.1-7.4 18.4-10.2 28-1.8 5.7-1.8 11.8-2.3 17.7-.2 2.5-.7 4.8-4.1 3.7-3-1.1-5.2-3.1-7.3-5z",
    id: "favicon3_svg__path731",
    style: {
      fill: "#007fc1"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M51.2 179.9c.6-1 2.6.5 2.7-1.9.2-18.1 6.7-34.5 14-50.6.2-.8.3-1.6.3-2.4 2.7 1.2 4.8 3.1 7 5 .5 1.6-.3 2.9-1 4.2-7 14-11.2 29.2-12.3 44.7-.2 2.2 0 5.1-3.8 4-2.9.3-4.8-1.7-6.9-3z",
    id: "favicon3_svg__path733",
    style: {
      fill: "#0083c4"
    }
  }), favicon3_path45 || (favicon3_path45 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st51",
    d: "M58.1 182.9c1.7-.2 2.3-.7 2.4-2.8.9-14.9 4.5-29.5 10.7-43 1.1-2.5 2.6-4.8 3.9-7.3 1.7 1.3 3.9 2 5 4 1.2 1.7.4 3.2-.4 4.7-7 14-10.1 28.9-10.8 44.3.1 1-.2 2-.8 2.8-3.3-.9-6.9-.7-10-2.7z",
    id: "favicon3_svg__path735"
  })), favicon3_path46 || (favicon3_path46 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st52",
    d: "M92.2 183.6c-3.6.9-7.1 1.7-10.8 1.4-1.4-2.9-.8-5.9-.3-8.7 1.6-10.3 3.6-20.6 8.3-30 .9-1.8 1.9-3.5 3.8-4.4 2.9.9 4.8 3.7 8 4 1 .6 1.5 1.4.8 2.4-5.5 8.3-6.9 18.1-9.2 27.6-.8 2.7 1.5 5.3-.6 7.7z",
    id: "favicon3_svg__path737"
  })), favicon3_path47 || (favicon3_path47 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st53",
    d: "M93.2 141.9c-5.4 9.1-7.8 19.2-10.1 29.4-1 4.6 0 9.3-1.8 13.7-1.3.7-2.9-.4-4.1.7h-4c-1.1-4.4-.4-8.9.3-13.2 1.3-7.9 2.9-15.6 6.3-23 1.9-4.1 3.3-8.3 4.5-12.6 3.5.5 5.3 4.3 8.9 5z",
    id: "favicon3_svg__path739"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M92.2 183.6c-1.7-9.2 1-17.6 4.1-26 1.4-4 3-7.9 4.9-11.6l8 3c1.2 1.4 1.1 3 .6 4.6-2.7 7.9-6.1 15.6-6.7 24.1-.1 1.3-1 2.4-1.8 3.5-2.9 1.5-6.1 1.8-9.1 2.4z",
    id: "favicon3_svg__path741",
    style: {
      fill: "#009dd4"
    }
  }), favicon3_path48 || (favicon3_path48 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st25",
    d: "M84.2 136.9c1.3 2.6.2 4.9-.9 7.4-5.1 11.9-9.2 24-9.2 37.1-.2 1.5-.5 2.9-1 4.3h-5c-1.1-7.1.6-14 1.5-21 1.5-11 6.6-20.7 10.5-30.9 1.5.9 3.3 1.3 4.1 3.1z",
    id: "favicon3_svg__path743"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M101.3 181.1c.4-9.5 3.4-18.3 6.8-27 .7-1.6 1.1-3.4 1.1-5.2l10 2c1.9.5 3 1.6 1.9 3.6-3.9 7.1-6.1 14.9-8.1 22.7-.1.3-.5.4-.8.6-3.5 1.6-7.2 2.7-10.9 3.3z",
    id: "favicon3_svg__path745",
    style: {
      fill: "#00a4d8"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M112.2 177.8c.8-7.7 3.2-15.1 6.9-21.8.9-1.6 2.4-3.4.1-5.1 3.9.7 7.8 1.7 11.7 1.9 3.9.2 3.1 2 1.7 4-2.3 3.3-4 6.9-5.2 10.7-.4 1.4-1.2 2.8-.3 4.3-4.7 2.6-9.7 4.5-14.9 6z",
    id: "favicon3_svg__path747",
    style: {
      fill: "#00abdc"
    }
  }), favicon3_path49 || (favicon3_path49 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st15",
    d: "M142.2 16v1c-.4 1.9-1.9 2.6-3.5 3.1-8.9 3-16.9 7.6-25 12.3-1.6.8-3.6.8-4.8 2.4-3.7 3.3-7.8 6.3-12.1 8.9-1.6.6-3 1.5-4.3 2.6-1.2.7-2.2 1.8-2.7 3.1-.3.5-.8 1-1.3 1.3-1.1.5-2.1 1.4-2.7 2.4-.4.5-.8.9-1.3 1.3-1.2.8-2.3 1.9-3 3.1-2.4 2.9-5.6 5.2-7.3 8.7-.4.6-.8 1.1-1.3 1.5-1.2.9-2.2 2-3 3.2-.3.5-.7 1-1.2 1.5-1 1-1.9 2.1-2.6 3.3-.2.4-.4.7-.6 1.1-.8 1.4-1.8 2.8-2.6 4.2-.3.5-.7 1-1.1 1.5-.7 1-1.2 2.2-1.8 3.2-.2.4-.5.7-.8 1-1.5 1.8-.1 2.6 1.2 3.5 1.5.8 2.9 1.8 4.2 3 1.1 1.3 2.4 2.3 3.8 3.1 1.1.6 2.2 1.2 3.3 1.7 1 .4 2 1 2.8 1.7 1.3 1.9 2.9 3.4 4.9 4.6 2.4 1.6 4.6 3.4 7 5 1.8 1.2 3.5 2.5 5.2 3.9 1.1.9 2.4 1.7 3.7 2.3l2.4 2.1c1.9 1.6 3.5 3.5 5.6 4.8 1.3 1.2 2.8 2.2 4.3 3.1 2.5 1.8 5.2 3.3 8 4.5.4.2.7.4 1.1.6 1 .7 2.1 1.3 3.3 1.7 1 .4 2 .7 3 1 .4.1.8.3 1.2.5 2.3 1.5 5 2.1 7.8 2 4.1.2 7.9 2 11.9 2 .8.1 1.5.2 2.3.4 2.9.9 6 .9 8.9 0 1.3-.3 2.6-.4 3.9-.4 1.9.1 3.8-.2 5.5.7l.6.6c-5.1 3.6-11.3 2.8-16.7 2.8-15.5-.1-30.6-4.8-43.4-13.5-12.8-8.8-25-18.5-37.5-27.8-3.7-2.8-7.4-5.5-11-8.3-2.1-1.7-2.9-3.4-1.2-6.3C64.5 70 76.6 55.8 91 44.1c13-10.7 27.2-19.8 43.2-25.8 2.6-1.2 4.9-3 8-2.3z",
    id: "favicon3_svg__path749"
  })), favicon3_path50 || (favicon3_path50 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st13",
    d: "m173.2 135.9-2 2h-1c-1.6.8-3.5.8-5-.1 1.8-4.2 4.7-3.7 8-1.9z",
    id: "favicon3_svg__path751"
  })), favicon3_path51 || (favicon3_path51 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st15",
    d: "M165.2 137.9h5c-1.4 1.7-3.3.8-5 1l-.4-.5c.1-.1.2-.3.4-.5z",
    id: "favicon3_svg__path753"
  })), /*#__PURE__*/react.createElement("path", {
    d: "m247.1 90.9-2 1c-1.1 1.1-2.7 1.2-4 2-1.7 1-3.7 1.4-5 3-.8.6-1.9.7-2.9.3-.6-3.6 2.6-4.3 4.7-5.4 5.5-2.8 10.7-5.9 16.2-8.7 12-4.8 24.2-9.2 36.9-11.7 5.7-1.1 11.5-1.7 17.3-1.8 1.6 0 3.3.5 5-.8-6.3-8.1-13.5-15.5-21.3-22.1-1.7-2.3-5.7-2.9-5-6.9 3.4-1.6 3.9 2.5 6.2 3.1 4.5 0 6.2 4 8.8 6.5 1.7 1.6 3.2 3.3 5.2 4.5 2.7 2.7 5.9 4.8 8 8 1.3 2.9 3.4 5.3 6 7 .5 1.3 2 2.2 1.9 4.4-10.4 0-20.8-.2-30.9 2.6-1.5 1.2-3.5-.2-5 1l-13 4c-2.1.7-4.4.9-6.5 1.8-5.4 1.6-10.8 2.9-15.5 6.2h-1c-1.2 1.1-2.9 1-4.1 2z",
    id: "favicon3_svg__path755",
    style: {
      fill: "#49c0e6"
    }
  }), favicon3_path52 || (favicon3_path52 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st58",
    d: "M237.1 14h2c-.9 3.3-3.5 1.9-5.6 2-1.9-.7-3.9-.6-5.7-1.1-27.4-5.1-54-2.9-80 7.3-4.3 1.7-8.1 4.7-12.9 5.1-.8 0-1.7-.2-2.4-.6-1.5-2.4.8-3.1 1.8-4.4 7.7-3.4 15.6-6.1 23.8-8.1 12.8-3.8 25.8-5.3 39.1-5.6 13-.4 25.6 2 38.2 4.6.7 0 1.2.4 1.7.8z",
    id: "favicon3_svg__path757"
  })), favicon3_path53 || (favicon3_path53 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st59",
    d: "M233.1 15c2-.3 4.2.8 6-1 9.5 4.5 20.1 6.7 29.2 12.2 8.5 5.2 18.1 8.8 24.8 16.7-2.6.2-3.4-3.2-6-3-3.1.9-4.9-1.6-7.1-2.8-7.6-4-15-8.5-22.8-12.2-4-2.9-8.5-4.1-13.3-4.7-3.7-.8-7.5-1.1-10.8-3.2-.3-.4-.4-.9-.4-1.5z",
    id: "favicon3_svg__path759"
  })), favicon3_path54 || (favicon3_path54 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st60",
    d: "M237.1 14c-12.6-3.2-25.4-5.3-38.3-4.7-11.6.5-23.6-.4-34.8 4.5-1.7.8-4 .2-6 .2 4-3.8 9.3-3.3 14.1-3.9 3.4-.4 6.7-.7 9.9-2.1 9.6-1.2 19.4-1.2 29 0 8.7 1.4 17.5 2.4 26 5z",
    id: "favicon3_svg__path761"
  })), favicon3_path55 || (favicon3_path55 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st45",
    d: "M292.1 76c9.5-4.4 19.7-2.7 29.8-3-.3-1.4-.5-2.7-.8-4 1.7.9 2.9 2.2 3.4 5.1-10.9-.9-21.6.9-32.4 1.9z",
    id: "favicon3_svg__path763"
  })), favicon3_path56 || (favicon3_path56 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st61",
    d: "M252.1 89c3.8-4.9 9.6-5.5 15-7 .6 1.2-.5 1.4-1 2h-1c-1.3.7-2.9.9-4 2l-3 1z",
    id: "favicon3_svg__path765"
  })), favicon3_path57 || (favicon3_path57 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st45",
    d: "M315.1 62c-2.9-2.4-5.9-4.7-8-8 3.6 1.8 6.8 3.9 8 8z",
    id: "favicon3_svg__path767"
  })), favicon3_path58 || (favicon3_path58 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st45",
    d: "m266.1 84 1-2c2.3-.6 4.6-1.3 7-1-2.4 1.7-5.2 2.2-8 3z",
    id: "favicon3_svg__path769"
  })), favicon3_path59 || (favicon3_path59 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st45",
    d: "M261.1 85.9c.8-1.8 2.3-2.1 4-2-.9 1.3-2.4 2-4 2z",
    id: "favicon3_svg__path771"
  })), favicon3_path60 || (favicon3_path60 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st45",
    d: "M287.1 77c1.4-1.7 3.3-.8 5-1-1.4 1.6-3.3.7-5 1z",
    id: "favicon3_svg__path773"
  })), favicon3_path61 || (favicon3_path61 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st60",
    d: "M158.2 14c-6.9 2.9-13.7 5.9-21.1 7.6-.7.2-1.3.9-1.9 1.4-3.3.9-5.3 4-8.7 4.8-15.1 8.7-29.9 17.9-40.8 32C78.6 66.6 73 74.6 67.9 83c-1.8 2.9-1.7 4.7 1.4 7.3 13.7 11.1 28.6 20.5 42.3 31.6 9 7.3 19.9 10.5 31.1 12.7 1.8.4 3.7.3 4.7 2.2.1 2.5-2.4 1-3.2 2.1-4.5.5-8.5-2.2-13-2-.3-.3-.6-.6-1-.8-1.4-.6-2.9-1.1-4.5-1.4-.8-.4-1.8-.2-2.5-.8-1.2-1.2-2.8-1.9-4.6-2.1-.9-.1-1.7-.4-2.4-.9-1.7-1.5-4.1-1.9-5.8-3.5-1.8-2.3-4.4-3.8-6.9-5.3-.4-.3-.7-.6-1-.9-.8-1-1.9-1.8-3.1-2.3-.4-.2-.7-.5-1-.8-.9-.9-1.9-1.7-2.9-2.5-.4-.2-.8-.4-1.1-.6-1.4-1-2.5-2.3-4.1-3.1-.4-.2-.7-.5-1.1-.8-4.6-2.8-8.6-6.4-13.1-9.2-.8-.4-1.5-1.1-2-1.9l-3-1c-1-2.4-3.2-3.6-5.4-4.7-7-6.4-6.9-6.3-1.7-14.5 1.9-2.9 4.2-5.6 5.6-8.8.4-1.6 1.9-2.6 2.6-4l1-1c5-4.7 9.7-9.8 14.1-15 .3-.4.6-.7.9-1l1-1c.3-.3.6-.6.9-.8 1.3-.6 2.5-1.5 3.3-2.6.8-1 1.7-1.9 2.8-2.5l12-9c1.4-1.2 3.5-1 5-2 7.3-6 15.9-9.6 24.7-12.8 1.6-.6 2.9-1.4 4.3-2.1 5.5 0 10.2-4.5 16-3.2z",
    id: "favicon3_svg__path775"
  })), favicon3_path62 || (favicon3_path62 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st62",
    d: "m196.2 123.9-3 3c-1.6 1.2-3.5 1.7-5 3-1.6.7-3.2 1.4-4.9 1.9-9.7 2.8-19.4 5.3-29.7 4.6-10.5-.7-20.9-3.4-30.5-7.8-11.5-5.2-20.2-14.3-30.5-21.3-8.1-5.5-16-11.2-23.6-17.4-2.4-2-2.7-3.6-1.2-6.3 4.7-8.2 10.2-15.9 16.6-22.9 8.5-10 18.5-18.8 29.6-25.9 1.5-1 2.8-3 5.2-2.1.5.5.7 1.3.5 2-1.5 2.8-4.7 3.7-6.8 5.8-1.4 1-2.9 2-4.3 3-1.5.8-2.8 1.9-3.9 3.2-.8.8-1.6 1.5-2.5 2.2-7.2 6-13.9 12.6-18.7 20.8-1 3-3 5.5-4.5 8.2-.3.6-.7 1.1-1.1 1.6-.8 1-1.5 2.1-1.9 3.3-.2.4-.5.8-.8 1.1-3.2 3.2-.8 3.9 2 4.5.6.3 1.2.7 1.7 1.1 2.8 3.1 6.4 5.3 9.9 7.7.4.2.8.4 1.2.7 7.2 4.8 14 10.2 21 15.2.4.3.7.6 1 .9 4.8 5.3 11.1 9.2 18 11.1.4.2.8.4 1.2.7 4.7 4.3 11.2 3.2 16.6 5.3.5.2.9.3 1.4.6 11.6 0 23.2 1 34.2-4.1 1.7-.8 3.7-1 5.3-2.1 1.5-.6 2.9-1.3 4.3-2.1.4-.2.9-.3 1.4-.3.6 0 1.3.3 1.8.8z",
    id: "favicon3_svg__path777"
  })), favicon3_path63 || (favicon3_path63 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st61",
    d: "M196.2 123.9h-2c.8-3.7 4.2-4.8 6.9-6.5 2.6-1.5 5-3.2 7.2-5.2 3.5-2.7 7.2-5.1 10.7-7.9 2.5-1.2 4.5-3.1 6.8-4.7s4.2-3.7 7.4-2.6h3c-4.2 4.5-10.4 6.1-15 10-7.4 5.3-14.9 10.6-22.3 15.8-.9.5-1.8.9-2.7 1.1z",
    id: "favicon3_svg__path779"
  })), favicon3_path64 || (favicon3_path64 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st63",
    d: "M85.2 61c-5.7 7.4-11.4 14.7-16.1 22.9-1.4 2.4-1.8 3.6.8 5.4 13.3 9.5 26.9 18.6 39.4 29 11.4 9.4 25.3 15.3 40 16.8 9.4 1.1 19.3.7 28.6-2.9 1.7-.6 3.5-1 5.3-1.2.2 2.2-2.2 1.8-3 3-2.6-.4-4.5 1.9-7 2-2.8.1-5.8-.6-8 2-2.2 1.3-4.7-.4-7 .5-2.2-.2-4.2.6-6.4.5-1.8-.1-3.7.2-4.6-2-8.4-1.9-16.7-3.9-24.7-7.2-7-2.8-12.4-7.6-18.2-12-8.5-6.5-17.2-12.7-26-18.8-4.3-3-7.7-7.2-12.6-9.5-2.1-1-.8-3.7-.1-4.9C71 75.2 76.8 66.1 85.2 59c.6.5.6 1.3.1 1.9-.1 0-.1.1-.1.1z",
    id: "favicon3_svg__path781"
  })), favicon3_path65 || (favicon3_path65 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st13",
    d: "m180.2 133.9 3-3 5-1c-2.4 2-5.1 3.3-8 4z",
    id: "favicon3_svg__path783"
  })), favicon3_path66 || (favicon3_path66 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st13",
    d: "M188.2 129.9c1.1-2 2.9-2.7 5-3-1.1 2-3 2.7-5 3z",
    id: "favicon3_svg__path785"
  })), /*#__PURE__*/react.createElement("path", {
    d: "m112.1 234.8 15.8-10c1.7.9 3.1 2 3.2 4.2-3.5 3.5-8.7 4.2-12.1 7.8l-3.8 1.2c-2.2.1-3.4-.8-3.1-3.2z",
    id: "favicon3_svg__path787",
    style: {
      fill: "#03a6d9"
    }
  }), favicon3_path67 || (favicon3_path67 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st65",
    d: "M122.2 236.9c.4-.7 1.2-1.1 2-1 5.1-2.9 10.4-5.4 16-7.3 7.5-.3 14.7-2.5 22.2-3.4 18.2-2.1 35.4.9 52.2 7.8 10.5 4.3 19.4 11 28.3 17.7l38.2 28.9c4.6 3.5 5.4 5.6 2.2 10.5-8 12.5-17 24.2-28.6 33.8-4.1 3.4-8.2 6.7-12.6 9.8-20.8 14.8-44 23-69.4 25.7-17 1.8-33.5-.9-49.9-4.3-1.8-.4-3.7-.7-4-3.1 2.1-2 4.7-1.2 7.1-.9 9.8 1 19.5 2.8 29.3 2.6 30.5-.6 57.7-10 81.8-28.9 12.5-9.8 22.5-21.6 31.1-34.8 2.1-3.3 2-5.4-1.2-8-9.7-7.9-20.1-14.9-30-22.3-7.2-5.4-14-11.2-21.9-15.7-14.6-8.5-31.2-13-48.1-13-13.9 0-27 2.8-39.9 7.3-2.4.9-4.3 3.4-7.4 2.3-1.5-3.1 1.8-2.5 2.6-3.7z",
    id: "favicon3_svg__path789"
  })), favicon3_path68 || (favicon3_path68 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st33",
    d: "M180.2 214.9h2c9.6-1.3 19-.3 28.4 1.1 19.2 2.8 37 9.6 52.5 21.4 18.1 13.8 36.5 27.3 54.6 41.1 4.9 3.7 5.1 5.3 2.1 11-9.4 17.9-23.6 31.6-38.8 44.5-20.2 17.1-44 27.1-69.6 32.7-7.4 1.6-15 2.1-22.6 3.1-1.6.2-3.4.4-4.1-1.7.2-2 1.8-2.2 3.3-2.4 12.4-1.3 24.7-3.4 36.5-7.5 11.6-4.1 22.8-9.3 33.4-15.6 10.5-6.2 19.5-14.5 28.6-22.4 7.8-6.8 14.1-15.4 20-24 1.8-2.6 3.5-5.3 5.4-7.8 2-2.8 2-5-1.1-7.1-9.8-6.9-19.3-14.1-28.9-21.2-9.6-7.1-19-15.1-29-21.9-14.3-9.6-30.1-15.2-47.1-18.1-9.3-1.5-18.8-1.8-28.2-.8-2.2.2-4.7.7-6.6-1.3 2.1-4 6.1-2.3 9.2-3.1z",
    id: "favicon3_svg__path791"
  })), favicon3_path69 || (favicon3_path69 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st18",
    d: "M185.2 367.8c5.2 2.4 10.6.4 15.5-.4 18.3-3.1 36.3-7.6 52.8-16.7 18.9-10.2 35.7-23.8 49.6-40.1 6.2-7.4 12.5-14.5 16.7-23.4 1.4-3 1.2-4.6-1.1-6.3-4.7-3.7-9.4-7.3-14.2-10.9-12.1-9-24.6-17.4-36.3-26.9-11.1-9.3-23.7-16.5-37.4-21.3-9.8-3.5-20.2-5.5-30.6-5.9-6-.2-12.1-.1-18.1-1 2.3-3.6 6.2-1.3 9.2-2.3 1.4-.4 3.2.2 4.8.3 6 1.8 12.3 1.7 18.4 2.8 20.3 3.7 38.6 11.4 54.6 24.6 8 6.6 16.7 12.4 25.1 18.6 9.7 7.2 19.4 14.5 29 21.7 2.3 1.7 2.5 3.2 1.1 6.1-6.5 13.5-16.5 24.4-26.6 35-7.7 8-16.3 15.1-25.6 21.1-12.6 8.3-26.3 14.9-40.7 19.4-19 5.9-38.3 9.2-58.2 8.6-1.8-.1-3.7.7-5.2-1 3.3-2.4 7 .6 10.4-1 .8-.4 2-.1 2.6-1 1-1.1 2.8-1.2 3.9-.2.2.1.2.1.3.2z",
    id: "favicon3_svg__path793"
  })), favicon3_path70 || (favicon3_path70 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st66",
    d: "m140.2 229.9-16 6c5.8-5 12.9-7.7 19.7-10.8 1.9-.9 3.8-2.8 6.4-2.2 1.8-.4 3.2-2.1 5.2-1.7 1 .2 1.7 1 2 1.9-.7 2.2-2.9 2.5-4.5 3.5-4.4.6-8.7 1.7-12.8 3.3z",
    id: "favicon3_svg__path795"
  })), favicon3_path71 || (favicon3_path71 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st18",
    d: "M155.2 221.9c-1.8-.3-3 2.5-5 1 1.6-3 5-3.4 7.6-4.1 6.8-1.9 13.8-3.2 20.7-4.7.5-.1 1.1.5 1.6.8-2.7 2-6.6.3-9 3-4.9 3-10.5 3.3-15.9 4z",
    id: "favicon3_svg__path797"
  })), favicon3_path72 || (favicon3_path72 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st66",
    d: "m122.2 236.9-3 3-.4.6c-1.1.8-2.3 1.6-3.6.4l4-4z",
    id: "favicon3_svg__path799"
  })), favicon3_path73 || (favicon3_path73 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st67",
    d: "M119.2 239.9c3.2.4 5.1-2.1 7.7-3.1 13.8-5 28.5-7.4 43.2-7.2 12.8.2 24.6 3.3 36.1 8.1 8.5 3.7 16.5 8.5 23.7 14.4 9.9 8 20.5 15.1 30.6 22.8 3.3 2.5 6.5 5.1 9.8 7.6 2 1.5 2.1 3.2.9 5.2-8.5 13.3-17.9 25.8-30.4 35.8-12.5 10-25.8 18.1-40.9 23.3-10.5 3.5-21.3 6-32.3 7.2-16.4 2-32.3-1.5-48.4-2.3-10.6-1.8-20.7-5.7-29.7-11.5-1.3-1-2.7-1.9-4.3-2.5-16.4-10.3-30.8-23.5-42.3-39.1-2.8-3.7-6-7.4-7.7-11.9-.6-.5-.7-1.4-.2-2 2.4-.6 2.9 1.6 3.8 2.9 1.3 1.8 2.3 3.9 4.2 5.3 1.5 1.4 2.2 3.2 3.2 4.9 5.9 8.7 13.4 15.9 21.4 22.7 11.8 10 25.6 17.5 40.5 21.9 13.8 4.1 27.9 6.8 42.6 5.4 13.2-1.3 26.1-3.1 38.4-7.9 23.7-9.1 42.6-24.4 57.6-44.6 1-1.3 1.9-2.8 2.6-4.2 1.8-3.8 1.4-6.9-2.2-9.6-11.8-8.9-23.6-17.8-35.5-26.7-12.3-9.5-26.8-15.7-42.2-18.1-15.5-2.3-30.8-1.5-45.4 4.7-1.8.8-3.6 1.9-5.7.7-1-1.1.1-1.6.9-2.2z",
    id: "favicon3_svg__path801"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M85.2 337.8c1.2-.7 2.7-.6 3.7.4 7.8 6.1 17 9.1 26.4 11.5 1.5.4 2.5 1.5 3.9 2.1 5.3 3.5 11.6 3.6 17.5 4.7 8.1 1.5 16.4 2.3 24.7 2.2 13.2-.1 26.1-2.7 39-6.1 11.6-3.1 21.9-8.5 32.2-13.9 7.1-3.7 13.3-9.6 19.8-14.7 11.7-9.2 20.3-20.8 28.7-32.6.9-1.4 1.7-2.8 2.4-4.4 1-2 .7-3.6-1.3-5.1-8.6-6.2-17-12.6-25.5-18.9-8.7-6.5-17.4-13-26.2-19.4-12.7-9.3-27.2-14.1-42.6-16.7-14.3-2.4-28.4-.5-42.4 2.4-1.8.4-3.6.6-5.4.6 3.8-3.2 8.3-4 13-4 5.6-3.4 12.1-3.9 18.3-4.2 27.9-1.3 52.6 7.2 74.6 24.4 14 11 28.6 21.2 42.6 32.2 6.5 5 7 6.5 2.7 13.6-7.3 11.7-16.3 22.3-26.6 31.5-14.6 13.2-30.9 23.7-49.5 30.3-11.5 4-23.1 7-35.5 7.7-6.2.4-12.4 2.1-18.7 1.7-17.1-1.1-33.9-4.1-50-10.2-5.1-1-9.3-3.9-13.8-6.1l-9-5z",
    id: "favicon3_svg__path803",
    style: {
      fill: "#00539a"
    }
  }), favicon3_path74 || (favicon3_path74 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st65",
    d: "M119.2 239.9c-.3.7-.7 1.3-1 2-5.8 5.5-13.3 8.4-20.1 12.4-1.3.7-2.6 1.3-4 1.9-1.4.5-2.8 1.1-4.1 1.9-.4.2-.7.4-1.1.6-1.2.4-2.3 1-3.2 1.8-.7.5-1.4.9-2.2 1.2-1.4.4-2.7 1-3.9 1.8-.7.5-1.5.9-2.3 1.2-1.3.3-2.5.8-3.5 1.5-.4.3-.8.5-1.2.7-2.1.6-4 2.4-6.5.9l1-2c7.9-3.8 15.9-7.3 23.6-11.4 6.9-3.6 13.5-7.9 20.3-11.8 1.3-.7 2.7-1.3 4.1-1.8z",
    id: "favicon3_svg__path805"
  })), favicon3_path75 || (favicon3_path75 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st65",
    d: "M35.2 284.8v2c-1.8-.6-2.1-2.5-3.1-3.7-1.5-1.9-.6-3.4 1.3-3.7 9.3-1.9 17.5-6.9 26.8-8.5.3 2.1-1.4 2.4-2.7 2.8-1.7.5-3.3 1.4-4.7 2.5-.4.2-.8.4-1.3.5-2 .2-4 .7-5.8 1.6-.4.2-.8.3-1.3.5-3.2 1.1-6.8.9-9.3 3.7 0 .8.2 1.6.1 2.3z",
    id: "favicon3_svg__path807"
  })), favicon3_path76 || (favicon3_path76 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st67",
    d: "M52.2 275.9c1.3-3.9 6-2.2 8-5l6-3 7-2c.4 2.3-1.4 2.6-2.8 3.4-4.9 2.7-10.1 4.8-15.3 7.2-1 .3-2.2.1-2.9-.6z",
    id: "favicon3_svg__path809"
  })), /*#__PURE__*/react.createElement("path", {
    d: "m32.2 238.9 12 4.1c3.9 2.7 4.6 7.4 6.6 11.2 2.3 4.3 3.4 9.3 8.4 11.6-4 2.5-8.5 3.8-13 5-2.4.2-2.8-2-3.7-3.4-4.6-7.1-7.7-14.9-10.3-22.9-.6-1.7-1.4-3.7 0-5.6z",
    id: "favicon3_svg__path811",
    style: {
      fill: "#0071b7"
    }
  }), favicon3_path77 || (favicon3_path77 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st27",
    d: "M32.2 238.9c2.5 11.5 7.2 22.4 14 32-1.7 1.3-3.8 2-6 2-3.1.3-4.4-1.7-5.5-4.1-4.4-9.1-8.1-18.5-11-28.1-.6-1.9-.3-4.2-.4-6.3z",
    id: "favicon3_svg__path813"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M59.2 265.9c-2.8.4-4.6-.8-5.8-3.4-3-6.5-6.1-13-9.2-19.4l13 2.8c2 1.1 2.9 3.1 3.8 5 1.8 4.1 4.2 7.8 7.2 11-2.8 1.6-5.9 3-9 4z",
    id: "favicon3_svg__path815",
    style: {
      fill: "#0079bd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M68.2 261.9c-3-.4-4.3-2.7-5.5-5.1-1.9-3.6-3.7-7.3-5.5-11l6 .2c.6.3 1.2.4 1.9.4 7.2.2 10.9 4 11.1 11.5-2.4 1.9-5.1 3.2-8 4z",
    id: "favicon3_svg__path817",
    style: {
      fill: "#0180c2"
    }
  }), favicon3_path78 || (favicon3_path78 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st51",
    d: "M76.2 257.9c-2.4-6-5-11.9-13-11.9 7.3.2 14.6-.3 21.9-1.4 2.8 1.6 3.7 4.3 4.1 7.2-3.9 3.1-8.6 4.2-13 6.1z",
    id: "favicon3_svg__path819"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M89.2 251.9c-2-2-2.7-4.8-4.1-7.2l16.1-4.8c1.3 1.1 2.3 2.5 3 4.1-4.6 3.2-10 5.2-15 7.9z",
    id: "favicon3_svg__path821",
    style: {
      fill: "#0192ce"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M104.2 243.9c-1.8-.8-3.4-1.6-3-4.1l11-5.1c.6 1.4 1.7 2.5 3.1 3.1-3.6 2.4-7 5-11.1 6.1z",
    id: "favicon3_svg__path823",
    style: {
      fill: "#029bd3"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M111.2 351.8c13.4 4.5 26.9 7.9 41 9.1 5.6.5 11.3 1.4 16.9.7 19-2.2 37.9-4.8 55.6-13 20-9.4 37.8-22.9 52.4-39.5 5.7-6.4 11.2-13.1 15-21 1.5-3 1.1-4.8-1.8-7-14.5-11-29.3-21.6-43.6-32.9-15.4-12.1-32.1-20.2-51.2-23.8-12.9-2.4-26.1-2.1-38.8.8-1.1.2-2.3.4-3.4.6.5-2.1 3-1.6 4-3 .5-.6 1.3-1 2.1-1.2 27.9-5.1 54.1-1.4 78.9 13 13.3 7.8 24.7 18 37.1 27 7.9 5.8 16.1 11.2 23.7 17.5 5.1 4.3 5.3 5 1.9 10.8-15 25.5-36.3 44.3-62.2 58.1-22.9 12.2-47.4 16.9-73 17-8.4 0-16.8-1.5-25.3-2.4-3.9-2.4-8.5-2-12.7-3.3-5.5-1.8-11.1-3.1-16.3-5.5h-1c-1-1.1.1-1.4.7-2z",
    id: "favicon3_svg__path825",
    style: {
      fill: "#00559d"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M159.2 222.9h-2l-2-1c5-2.7 10.6-3 16-4 5.6.2 11.2-.7 16.8-.9 13.2-.4 26 2.7 38.5 6.6 11.6 3.6 22.2 9.4 32 16.5 8.4 6.1 16.3 12.9 24.6 19.1 9.6 7.2 19.4 14.3 29.2 21.3 3.4 2.4 3.6 4.6 1.2 7.8-7.1 9.5-13.8 19.3-21.9 28.1-7.8 8.4-16.6 15.6-25.5 22.4-12 9.2-26.2 15.6-40.5 20.5-12.5 4.3-25.5 6.8-38.7 7.6-.6 0-1.1.6-1.7.9h-4c-12.6.2-25.1-1.3-37.5-3.1-1.6-.2-3.3-.5-4.5-1.9.5-.4 1-.5 1.6-.5 6.5.5 12.9 1.5 19.3 2.1 4.8.9 9.6.2 14.4.4h2.5c2.6-.1 5.2-.3 7.8-.8.5-.1 1-.2 1.5-.2 2.3-.1 4.6-.4 6.9-.9 12.5-2.4 24.9-5.3 36.7-10.3 4.6-2 8.6-5.1 13.3-6.6 2.3-.5 4.6-1.1 6.3-2.9 3.5-2.6 7.2-5 11-7.1 3.3-1.5 6-3.9 8.6-6.3.3-.3.7-.6 1.1-.8 4.5-3.8 9.6-6.8 12.7-12 8.3-8.7 16-17.9 22-28.3 2.7-4.8 2.5-5.2-2.3-8.8-15.5-11.5-31.3-22.6-46.5-34.5-27.4-21.5-58.1-28.9-92.2-23.9-1.7.1-3.3.6-4.7 1.5z",
    id: "favicon3_svg__path827",
    style: {
      fill: "#0057a0"
    }
  }), favicon3_path79 || (favicon3_path79 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st76",
    d: "M140.2 362.8h-1c-8.6-1.9-17.2-3.8-25.4-6.9-1.1-.3-2.1-1-2.6-2.1 6.8 1.9 13.6 3.7 20.3 5.7 2.9.9 6.3-.1 8.7 2.3.3.2.4.4.3.7-.1.3-.2.3-.3.3z",
    id: "favicon3_svg__path829"
  })), favicon3_path80 || (favicon3_path80 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st76",
    d: "m111.2 351.8-1 2c-4.7-1.7-9.7-2.8-13-7 4.3-.4 6.9 3.3 10.7 4.2 1 .4 2.1.7 3.3.8z",
    id: "favicon3_svg__path831"
  })), favicon3_path81 || (favicon3_path81 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st16",
    d: "M239.2 159.9c-32.4.7-60.5 13.8-87.6 30.1-9.3 5.7-19 10.8-29 15.1-4-1-4.5-3.7-3.4-7.1 20-4.7 36.7-15.7 52.9-27.8 16.3-12.3 34.2-22.5 53.1-30.2 7.8 2.5 12.1 8.8 16.2 15.1 1.4 2.2.4 4.1-2.2 4.8z",
    id: "favicon3_svg__path833"
  })), favicon3_path82 || (favicon3_path82 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st22",
    d: "M349.1 208.5c-2.6-1.4-5-3.2-7.2-5.3-1.4-3.9-1.2-7.9-1.1-11.8.1-15.4-2.3-30.4-6.2-45.3-.7-2-1.5-4-2.3-6-1.1-2.8-2.2-5.7-.1-8.5 4.4 1.4 8.6 3.5 12.4 6.3 2.8 10 5.4 20.2 6.7 30.5 1.3 10.8 2.3 21.7.3 32.6-.5 2.4.6 5.7-2.5 7.5z",
    id: "favicon3_svg__path835"
  })), favicon3_path83 || (favicon3_path83 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st27",
    d: "M349.1 208.5c1.4-9.4 1.9-19 1.6-28.5-.1-9.2-2.8-17.7-3.6-26.6-.4-4.6-2.6-8.7-3.8-13-.4-1.5-.9-2.5 1.2-2.6 4.6 2.6 9.1 5.3 12.9 9-3.3.7-2.3 3-1.8 5.1 3.2 14.2 4.7 28.7 4.3 43.3-.2 6.3.3 13-3.2 18.9-2.7-1.5-5.3-3.3-7.6-5.6z",
    id: "favicon3_svg__path837"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M28.7 231c-2.4 0-4.7-.7-6.6-2.1-2.8-3.5-2.2-7.9-3-11.9-3.6-18.5-2.3-37.1-.6-55.6.1-.5.3-.9.6-1.3l9 6.8c1.1 3.3.5 6.6.1 9.9-2 16 .2 31.7 2.9 47.4.4 2 .9 3.9.3 5.9-.3 1.5-1.4 1.3-2.7.9z",
    id: "favicon3_svg__path839",
    style: {
      fill: "#006db5"
    }
  }), favicon3_path84 || (favicon3_path84 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st28",
    d: "m335.1 198.1-7-5.1c-1.2-1.9-1.7-4-1.6-6.2 1.1-18.9-4.2-36.5-11.4-53.7-.9-2.2-2.6-4.4-1-7l10.1 2.7c6.6 14.9 10.8 30.8 12.2 47.1.3 3.5.7 6.9.9 10.4.3 4 .7 8.3-2.2 11.8z",
    id: "favicon3_svg__path841"
  })), favicon3_path85 || (favicon3_path85 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st39",
    d: "M65.2 228.7c-3.6 1.1-7.1 2.4-11 2.2-4.5-13.9-7.5-27.9-6.2-42.6.2-2.1.5-4 3.2-4.3l10 6c.8 11.5 2.4 23 4.5 34.4.3 1.5.5 3-.5 4.3z",
    id: "favicon3_svg__path843"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M314.1 126.1c3.3 9.2 7 18.3 9.9 27.6 3.9 12.8 4.5 26 4.1 39.3-2.9-1.7-5.6-3.7-8-6-.4-.5-.6-1.2-.6-1.9.6-18.4-4.4-35.4-12.1-51.9-1.2-2.6-3-5.4-.2-8.2 2.4-.4 4.6.5 6.9 1.1z",
    id: "favicon3_svg__path845",
    style: {
      fill: "#0080c1"
    }
  }), favicon3_path86 || (favicon3_path86 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st22",
    d: "M28.7 231c3.1-.9 1.9-3.3 1.5-5.1-3.1-14.2-4.8-28.6-3.9-43.2.3-5.2-.1-10.7 1.8-15.9 2.9 1.7 5.6 3.7 8 6-2.6 17.4-1 34.6 3.1 51.6.4 1.3.6 2.6.8 3.9.3 3.2-.9 4.8-4.3 3.7-2.4.1-4.8.4-7-1z",
    id: "favicon3_svg__path847"
  })), favicon3_path87 || (favicon3_path87 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st79",
    d: "M335.1 198.1c2.2-15.3-.8-30.1-3.9-44.9-1.8-8.3-6.3-15.8-7-24.4l8 2.8c.7 8.6 4.3 16.4 6.3 24.6 2.3 10 3.5 20.2 3.5 30.5 0 5.5 1.9 11.1 0 16.6z",
    id: "favicon3_svg__path849"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M51.1 184.1c-3.5 1.7-2.4 5.7-2.3 7.9.4 11 1 22.1 4.9 32.5.8 2.1 1 4.3.4 6.5-2.5 1.6-5.3 1-8 1.1-1.7-1.4-1.9-3.4-2.4-5.3-3.1-11.5-4.5-23.4-4-35.3.1-3.3-.1-6.6-.4-9.9-.2-1.9-.7-4 .9-5.7z",
    id: "favicon3_svg__path851",
    style: {
      fill: "#007cbf"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "m270.1 163.7-14-2.8c-2.4-.4-4.5-1.9-5.5-4.2-2.7-5.8-6.7-11.1-11.6-15.3-1.9-1.6-3.6-3.6-1.8-6.4 3.8-1.8 7.9-3.1 12-4 4.2 1.3 6 5.1 8.2 8.2 5.1 7.7 9.4 15.9 12.7 24.5z",
    id: "favicon3_svg__path853",
    style: {
      fill: "#00a6d9"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M19.2 160.1c1.7 6.2.4 12.6-.4 18.6-1.3 10.4-.3 20.5.8 30.7.7 6.5 1.7 13 2.6 19.5-3.6-.7-6.4-2.7-9-5.1 1.8-6.4.2-12.8-.3-19.1-.9-12.4-1.4-24.6.9-36.9.6-3.4.1-7 2.5-9.9z",
    id: "favicon3_svg__path855",
    style: {
      fill: "#0069b1"
    }
  }), favicon3_path88 || (favicon3_path88 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st79",
    d: "M40.2 175.8c.7 6.2 1.4 12.4.9 18.7-.9 12.9 2.7 25.1 5 37.5-3.4 1.1-7 1.1-10.4 0 2.8 0 3.9-1.1 3-4-3.3-10.8-4.1-22-5.6-33.1-.8-6.4 2-12.7.6-19.2-.3-1.6 1.9-1.7 2.4-2.9z",
    id: "favicon3_svg__path857"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M308.1 178.8c-2.5-.9-4.9-2.2-7-3.9-2.3-1.4-2.3-4-2.7-6.2-2.3-13-7-25.4-13.9-36.6-.8-1.3-1.5-2.6-2.1-4-1.4-2.9-.1-3.9 2.6-4l5-.1c6.1 7.4 9.7 16.1 13.1 25 2.9 7.4 4.8 15.2 5.8 23.1.4 2.3.8 4.7-.8 6.7z",
    id: "favicon3_svg__path859",
    style: {
      fill: "#008cca"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M307.1 125c-1.2 3.6.7 6.4 2.2 9.4 5.9 11.3 8.4 23.6 10.9 35.9 1.2 5.5 1.2 11.2-.1 16.7l-4-3c-1.8-2.2-2.9-4.8-3.1-7.6-1.1-14.4-5.1-28.4-11.7-41.3-1.8-3.5-4.2-6.8-4.1-11z",
    id: "favicon3_svg__path861",
    style: {
      fill: "#0084c4"
    }
  }), favicon3_path89 || (favicon3_path89 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st51",
    d: "M297.2 124.1c9.3 16.5 16 33.8 17.2 52.8.2 2.6 1.7 4.6 1.7 7.1l-8-5.2c-.8-18.4-7.1-35-16.3-50.7-.7-1.3-1.2-2.7-1.7-4.1z",
    id: "favicon3_svg__path863"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M65.2 228.7c-2-10.9-4.4-21.8-5-32.9-.1-2-.2-4 1-5.7l11.1 4.6c1.1 9.3 1.4 18.7 4.5 27.7.3 1 .1 2-.5 2.9-3.5 1.6-7.3 2.7-11.1 3.4z",
    id: "favicon3_svg__path865",
    style: {
      fill: "#008ac8"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M270.1 163.7c-4.6-3.3-5.1-9-7.6-13.6-3.8-6.8-8.3-13.2-13.4-19.1l10-2.8c10.4 10.4 17.6 22.6 19 37.6z",
    id: "favicon3_svg__path867",
    style: {
      fill: "#009fd5"
    }
  }), favicon3_path90 || (favicon3_path90 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st53",
    d: "M285.1 124.2c-2.9.8-2.3 2.4-1.2 4.3 4.6 8.1 9.4 16 11.9 25.1 2 7.1 3.5 14.2 5.3 21.4l-8.1-3.8c-.8-1.2-1.4-2.7-1.5-4.2-2.5-12.9-8.5-24.4-15.1-35.6-1.2-2-3.5-4.1-.3-6.3z",
    id: "favicon3_svg__path869"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M276.1 125.1c-1.4 1.9-.3 3.4.7 5 7.5 11.1 13 23.6 16 36.6.2 1.5.3 3 .2 4.5l-5.9-2.4c-2.8-1.2-3.6-3.9-4.2-6.4-2.4-10.7-7.7-20.1-13.5-29.2-1.2-1.9-3.2-3.5-2.3-6.2 2.9-1.5 5.9-1.7 9-1.9z",
    id: "favicon3_svg__path871",
    style: {
      fill: "#0095cf"
    }
  }), favicon3_path91 || (favicon3_path91 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st42",
    d: "M267.1 126.9c5.8 9.2 11.5 18.5 15.4 28.7 1.7 4.4 1.5 9.4 4.6 13.2l-9-3c-.5-.7-1.3-1.3-1.4-2-1.5-13.5-8.9-24-17.2-34.1-.2-.4-.4-.9-.4-1.4 2.7-.5 5.2-1.9 8-1.4z",
    id: "favicon3_svg__path873"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M76.3 225.3c-3-7.7-4-15.8-5-23.9-.5-2.3-.1-4.6 1-6.7l7.9 2.3c2.3.3 2.7 2.1 2.9 4 .5 5.6 1.6 11.2 3.3 16.6.6 1.8.5 3.3-1.2 4.4-2.8 1.5-5.8 2.7-8.9 3.3z",
    id: "favicon3_svg__path875",
    style: {
      fill: "#0090cc"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M237.1 135c-.2 2 .6 4 2.2 5.3 6 4.2 9.6 10.2 12.8 16.6 1 1.9 2.5 2.9 4.1 4l-17-1c3.3-2.3 1.4-4.4-.2-6.6-3.8-5.3-8.7-9.4-13.8-13.3 3.7-2.2 7.8-3.8 11.9-5z",
    id: "favicon3_svg__path877",
    style: {
      fill: "#01aede"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M85.2 222c1.3-4.3-1.4-7.9-2.2-11.8-.9-4.4.2-9.2-2.8-13.2l13 2.1c1.3 6.2 4.4 12.1 3 18.7-3.6 1.5-7.1 3.3-11 4.2z",
    id: "favicon3_svg__path879",
    style: {
      fill: "#0197d0"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M96.2 217.7c-.9-6.2-4-12.1-3-18.7l11 .7c4 4.4 4 11 .1 14.1-2.5 1.9-5.4 2.8-8.1 3.9z",
    id: "favicon3_svg__path881",
    style: {
      fill: "#019fd5"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M104.2 213.9c3.8-4.7.4-9.4-.1-14.1l15.1-1.8c.8 2.5.8 5.4 3.4 7.1-5.9 3.5-12 6.5-18.4 8.8z",
    id: "favicon3_svg__path883",
    style: {
      fill: "#02a6d9"
    }
  }), favicon3_path92 || (favicon3_path92 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st41",
    d: "M266.2 113.8c4.2-1.8 8.7-.3 13-1 1 .2 2.2-.1 3 1z",
    id: "favicon3_svg__path885"
  })), favicon3_path93 || (favicon3_path93 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st52",
    d: "M77.2 185.7c1-2.3 2.7-.8 4.1-.7-1.2 1-2.7.8-4.1.7z",
    id: "favicon3_svg__path887"
  })), favicon3_path94 || (favicon3_path94 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st61",
    d: "M247.1 90.9c.8-1.8 2.3-2.1 4-2-.7 1.9-2.2 2.2-4 2z",
    id: "favicon3_svg__path889"
  })), favicon3_path95 || (favicon3_path95 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st61",
    d: "M241.1 94c1-1.2 2.4-1.9 4-2-.7 1.8-2.2 2.1-4 2z",
    id: "favicon3_svg__path891"
  })), favicon3_path96 || (favicon3_path96 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st12",
    d: "M70.2 71c-.4 4.3-3.6 7.1-5.8 10.4-4 6-4.2 5.9.7 11 .4.5.8 1 1.1 1.6l-.4.4c-.6.2-1.2 0-1.6-.4l-4-3c-1.8-1.4-4.1-2.7-1-5 1.1-1.1 1.3-2.7 2-4l1-1c1.3-1.5 2.3-3.2 3-5 1.1-1.2 2.1-2.6 3-4l1-1c.3-.5.6-.5 1 0z",
    id: "favicon3_svg__path893"
  })), favicon3_path97 || (favicon3_path97 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st12",
    d: "M88.2 51c-2.2 4.8-6.7 7.6-10 11.3-1.3 1.5-1.7 4.6-5 3.7 1.7-3.9 4.7-6.5 8-9 .7-1.2 1.8-2.3 3-3l1-1c.9-.8 1.1-2.7 3-2z",
    id: "favicon3_svg__path895"
  })), favicon3_path98 || (favicon3_path98 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st12",
    d: "M76.2 100.9c5 2.8 9.7 6.2 14 10-1.7 1.2-2.7-.4-4-1-3-.8-5-2.9-7-5-1.2-1.2-3.5-1.6-3-4z",
    id: "favicon3_svg__path897"
  })), favicon3_path99 || (favicon3_path99 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st12",
    d: "M147.2 136.9c3.9 1.9 8 .6 12 1 .3.2.3.4.3.7 0 .3-.2.3-.3.3h-4c-3 .8-6 .8-9 0h-2z",
    id: "favicon3_svg__path899"
  })), favicon3_path100 || (favicon3_path100 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st13",
    d: "M111.2 126.9c1.2 1.8 4.1 1.7 5 4-3.4-.9-6.7-2.1-9-5l.5-.5c1.3-.3 2.8.3 3.5 1.5z",
    id: "favicon3_svg__path901"
  })), favicon3_path101 || (favicon3_path101 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st12",
    d: "M66.2 94c3.4 0 5 1.6 5 5l-3-2c-.6-1.1-2.6-1.2-2-3z",
    id: "favicon3_svg__path903"
  })), favicon3_path102 || (favicon3_path102 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st13",
    d: "M103.2 122.9c-3-.5-4.4-2.9-6-5 .5-.6 1.4-.6 1.9-.1l.1.1c1.3 1 2.8 1.8 4 3 .4.4.6 1 .4 1.6z",
    id: "favicon3_svg__path905"
  })), favicon3_path103 || (favicon3_path103 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st13",
    d: "M123.2 133.9h3c1.6.9 3.4 1.2 5 2v1c-3 .2-5.9-.9-8-3z",
    id: "favicon3_svg__path907"
  })), favicon3_path104 || (favicon3_path104 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st13",
    d: "M59.2 86c-1.7 2.1.1 3.4 1 5-1.7-.1-3.1-.8-3.3-2.4-.3-1.5.6-2.6 2.3-2.6z",
    id: "favicon3_svg__path909"
  })), favicon3_path105 || (favicon3_path105 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st12",
    d: "M99.2 117.9h-2c-1 .1-1.9-.6-2-1.6v-.4c-.3-.2-.3-.4-.3-.7 0-.3.2-.3.3-.3 2 .1 3.1 1.4 4 3z",
    id: "favicon3_svg__path911"
  })), favicon3_path106 || (favicon3_path106 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st13",
    d: "m76.2 100.9 3 4c-2.6-.4-4.6-2.4-5-5z",
    id: "favicon3_svg__path913"
  })), favicon3_path107 || (favicon3_path107 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st13",
    d: "M146.2 138.9h9c-2.8 1.6-6.3 1.6-9 0z",
    id: "favicon3_svg__path915"
  })), favicon3_path108 || (favicon3_path108 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st12",
    d: "M119.2 130.9c1.8.3 3.7.6 4 3-1.1 0-2.3.2-3-1-.6-.5-1.7-.8-1-2z",
    id: "favicon3_svg__path917"
  })), favicon3_path109 || (favicon3_path109 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st13",
    d: "M159.2 138.9v-1c2-1.6 4 .8 6 0v1z",
    id: "favicon3_svg__path919"
  })), favicon3_path110 || (favicon3_path110 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st13",
    d: "m86.2 109.9 4 1c.8.7 1.9 1.2 1.4 2.5l-.4.5c-1.7-1.3-3.9-1.9-5-4z",
    id: "favicon3_svg__path921"
  })), favicon3_path111 || (favicon3_path111 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st13",
    d: "M66.2 94c.6 1 2.2 1.4 2 3-2-.1-3.1-1.4-4-3z",
    id: "favicon3_svg__path923"
  })), favicon3_path112 || (favicon3_path112 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st13",
    d: "M65.2 76c.2 2.4-1 4-3 5 .2-2.2 1.7-3.6 3-5z",
    id: "favicon3_svg__path925"
  })), favicon3_path113 || (favicon3_path113 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st13",
    d: "M68.2 72c.4 2.4-1.2 3.3-3 4 0-2.1 1.4-3.2 3-4z",
    id: "favicon3_svg__path927"
  })), favicon3_path114 || (favicon3_path114 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st12",
    d: "M113.2 32c-1.2 1.5-3.1 2.2-5 2 1-2.4 3-2 5-2z",
    id: "favicon3_svg__path929"
  })), favicon3_path115 || (favicon3_path115 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st13",
    d: "M107.2 125.9c-2-.1-3.1-1.4-4-3 3-1.2 4.1.1 4 3z",
    id: "favicon3_svg__path931"
  })), favicon3_path116 || (favicon3_path116 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st13",
    d: "M70.2 71h-1c.1-2 1.4-3.1 3-4 .4 1.8-1 2.8-2 4z",
    id: "favicon3_svg__path933"
  })), favicon3_path117 || (favicon3_path117 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st13",
    d: "m119.2 130.9 1 2c-1.7.1-3.2-.2-4-2z",
    id: "favicon3_svg__path935"
  })), favicon3_path118 || (favicon3_path118 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st13",
    d: "m96.2 43-2 3c-.4.4-1 .6-1.6.4l-.4-.4c.8-1.6 1.9-3 4-3z",
    id: "favicon3_svg__path937"
  })), favicon3_path119 || (favicon3_path119 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st13",
    d: "M61.2 82c.1 1.7-.2 3.2-2 4 0-1.6.8-3 2-4z",
    id: "favicon3_svg__path939"
  })), favicon3_path120 || (favicon3_path120 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st13",
    d: "M95.2 114.9v1c-1.7.1-3.2-.2-4-2 1.7-1.3 2.7.5 4 1z",
    id: "favicon3_svg__path941"
  })), favicon3_path121 || (favicon3_path121 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st13",
    d: "M84.2 54c-.6 1.3-1.7 2.4-3 3-.1-1.5 1.1-2.9 2.6-3h.4z",
    id: "favicon3_svg__path943"
  })), favicon3_path122 || (favicon3_path122 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st13",
    d: "m88.2 51-3 2c-.1-1.5 1.1-2.9 2.6-3h.4z",
    id: "favicon3_svg__path945"
  })), favicon3_path123 || (favicon3_path123 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st13",
    d: "M90.2 49h-1c-.1-1.6 1.1-2.9 2.6-3h.4c.6 1.8-1.2 2.1-2 3z",
    id: "favicon3_svg__path947"
  })), favicon3_path124 || (favicon3_path124 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st93",
    d: "M219.2 105c-2.5 3.7-6.7 5.2-10 8-7.7 5-15.6 9.8-24.7 12.3-1.4.5-2.9.8-4.3.9-4.4-.2-8.6 2.1-13 .7-3.7-.9-7.5-1.6-11.3-2.1-12.7-1.9-22.7-9.2-32.5-16.6-9.8-7.4-19.6-14.8-29.5-22-3-2.1-3.2-5-.9-8.8C108.2 53 129 35 155.6 24c16.2-6.7 33.2-10.5 50.9-10.1 11.6.2 23.1 1.5 34.2 5.3 1.1.3 2.3.5 3.4.4 5 .6 9.2 3.4 14 4.5 3.7 3.3 8.8 3.9 12.8 6.7 5 3.6 10.8 6.2 16.2 9.3.6 2.9 4.1 3.3 5 6l-.6.4c-3 .2-4.6-2.3-6.7-3.7-2.1-1.4-3.9-3.1-6.4-3.6-7.3-4-14.8-7.6-22.2-11.4-11.1-4.9-22.8-7.2-34.7-8.7-12.6-1.5-25.3-1-37.7 1.5-15.5 3.1-30.3 9.2-43.6 17.9-15.1 10-28 23.1-37.6 38.5-2 3.2-1.6 5.2 1.6 7.4 11.8 8.1 22.6 17.5 34.5 25.4 13.6 9 28.5 13.4 44.9 9.7 2.9-.7 6-.4 8.6-2.2 2.8-1.5 5.8-2.4 8.5-4 5.6-2.6 10.6-6.5 16.3-9 .9-.2 1.7.1 2.2.7z",
    id: "favicon3_svg__path949"
  })), favicon3_path125 || (favicon3_path125 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st93",
    d: "M292.1 46c1.5 0 2.4.9 3.4 1.9 6.4 6.5 13.1 12.7 18.9 19.9.6.7 1.7 1.3 1.2 2.5-.4.9-1.4.8-2.2.7-19.5-.7-37.6 5.1-55.4 12.2-1.3.4-2.5.7-3.9.9.4-3.5 3.9-3.2 5.8-4.8 3.3-1.4 6.9-2 10-4 2-.9 4-2.1 6.2-2.3 4.5 0 8.6-2.2 13.1-2.5.5-.2 1-.3 1.5-.4 2.5-.4 5 0 7.4-.9.7-.2 1.5-.3 2.3-.4 2-.1 4.1 0 6.1-.1h2.2c2.7 0 1.6-1.1.7-2.3-4.1-5.6-9.4-10.2-14.2-15.2-1.4-1.5-3.6-2.5-3.1-5.2z",
    id: "favicon3_svg__path951"
  })), favicon3_path126 || (favicon3_path126 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st93",
    d: "m260.1 80-6 4c-4.1 3.5-9.1 5.5-13.8 8-2.6 1.4-5.3 2.5-7.2 5-5.6 1-8.5 6.8-14 8h-2c-.5-2.6 1.6-3.5 3.2-4.4 4.4-2.4 8.3-5.5 12.4-8.4 6.7-4.5 13.8-8.4 21.2-11.7 1.8-.8 3.6-1.8 5.7-1 .2.1.4.3.5.5z",
    id: "favicon3_svg__path953"
  })), favicon3_path127 || (favicon3_path127 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st59",
    d: "m77.2 79 1-1c2.6-3.1 4.7-6.6 6.2-10.3.3-.6.8-1.1 1.3-1.6 6.4-5.5 11.3-12.6 17.7-18.2 2.9-2.6 6.6-4.5 8.8-7.9 1.8-2.5 4.4-3.7 7-5 2.2-3.6 6.2-4.7 9.6-6.6 1.7-1 3.5-1.8 5.4-2.4 4.9-.2 8.5-3.4 12.8-5.1 10.9-4.4 22.3-7.4 34-8.8 15-1.9 30.1-2.1 45 .9.8.3 1.5.6 2.2 1l-.6.6c-1.7.9-3.5.3-5.3.4-.5 0-1-.1-1.5-.2-12.1-2-24.1-1-36.2.1-5.6.4-11.1 1.3-16.6 2.6-4.7 1.2-9.5 2.4-13.9 4.7-5 2.6-10.3 4.7-15.4 7.1-23.9 11.4-41 30-55.7 51.3-2 3-1.8 4.9 1.3 6.9 14.2 9.3 26.8 20.7 41 29.9 7.5 4.7 15.7 8.1 24.2 10.2 1.9.5 4.1.7 3.8 3.6-1.6 1-3.1 2.2-5.1.8-5.9-2.1-12.8-1.7-18-6-7-2.9-13.1-7.2-19-12-7.1-5.7-14.6-10.8-22-16-3.6-2.8-7.2-5.5-11-8l-1-1c-2.3-1.5-3.7-3.2-2-6 .7-1.3.9-2.9 2-4z",
    id: "favicon3_svg__path955"
  })), favicon3_path128 || (favicon3_path128 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st63",
    d: "M126.2 27c3-1.4 5.4-4.1 9-4l-3 3c-.6.7-1.3 1.3-2.2 1.7-.9.3-1.8.4-2.8.1-.4-.2-.8-.4-1-.8z",
    id: "favicon3_svg__path957"
  })), favicon3_path129 || (favicon3_path129 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st62",
    d: "M130.2 27c.4-.7 1.2-1.1 2-1h2c-1.5 1.3-2.9 2.8-5 3l-.2-.6c.1-.7.7-1 1.2-1.4z",
    id: "favicon3_svg__path959"
  })), favicon3_path130 || (favicon3_path130 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st59",
    d: "M228.2 14c1.7.2 3.6-.7 5 1-2 1.1-4 2.3-5-1z",
    id: "favicon3_svg__path961"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M221.1 14h1c3.6 1.1 7.4 1.2 11 2 3.5 1.8 7.2 2.4 11 3 .3.2.4.4.3.7-.1.3-.2.3-.3.3-4.6-.8-9.2-1.3-13.6-2.4-7.8-2-15.8-2.2-23.6-2.4-15.5-.3-31 2.5-45.4 8.2-10.1 3.8-19.7 8.6-28.8 14.3-13.5 8.8-24.3 20.4-34 33-1.8 2.4-3.1 5.3-4.9 7.8C92 81 91.9 83.8 96 86c6.3 3.5 11.8 8.3 17.5 12.8 10.4 8.1 20.7 16.4 32.7 22 5.7 2.6 12.2 2.9 18.3 4.1 1 .2 2 .1 2.7 1-2.8 2.1-6.1 1.5-9.1 1-10.7-1.5-20.9-5.7-29.6-12-11.8-8.7-23.2-17.9-35.4-26-6.7-4.4-6.7-6.1-2.3-12.9 8.6-13.4 19.6-24.6 31.6-34.9 4.5-3.9 10.6-5.7 14.4-10.5 10.9-6.7 22.8-11 35.2-14.1 16-3.9 32.2-3.4 48.3-3 .3.1.6.3.8.5z",
    id: "favicon3_svg__path963",
    style: {
      fill: "#57c2e7"
    }
  }), favicon3_path131 || (favicon3_path131 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st95",
    d: "M244.1 20v-1c5 .7 9.8 2 14 5-5.2.8-9.1-3.5-14-4z",
    id: "favicon3_svg__path965"
  })), favicon3_path132 || (favicon3_path132 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st95",
    d: "M233.1 16c-3.8.1-7.6.1-11-2h6c1.4 1.7 3.3.8 5 1z",
    id: "favicon3_svg__path967"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M126.2 27h1c.6 1.1-.1 1.8-.7 2.5-2.5.9-4.4 3.3-7.2 3.5-9.6 4.7-17.4 11.7-25 19-3.1 2.9-6 6-9 9v-2c10.5-14.5 25.3-23.8 40.9-32Z",
    id: "favicon3_svg__path969",
    style: {
      fill: "#3abde5"
    }
  }), favicon3_path133 || (favicon3_path133 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st12",
    d: "M107.2 125.9c-.7-1.8-1.6-3.4-4-3v-2c3.2 1.2 6.2 2.9 8 6-1.2-.7-2.6-1.1-4-1z",
    id: "favicon3_svg__path971"
  })), favicon3_path134 || (favicon3_path134 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st12",
    d: "m95.2 114.9-4-1c-.3-1-.7-2-1-3 2.5.3 3.7 2.2 5 4z",
    id: "favicon3_svg__path973"
  })), favicon3_path135 || (favicon3_path135 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st12",
    d: "M103.2 120.9c-2-.1-3.1-1.4-4-3 1.8.4 3.7.7 4 3z",
    id: "favicon3_svg__path975"
  })), favicon3_path136 || (favicon3_path136 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st12",
    d: "M131.2 135.9c-1.9.2-3.8-.6-5-2 1.9-.2 3.7.6 5 2z",
    id: "favicon3_svg__path977"
  })), favicon3_path137 || (favicon3_path137 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st12",
    d: "M90.2 49c.7-1 1.3-2 2-3h2c-.9 1.6-2 2.9-4 3z",
    id: "favicon3_svg__path979"
  })), favicon3_path138 || (favicon3_path138 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st61",
    d: "m148.2 131.9 5-1c1.2-1.4 2.9-1.4 4.6-1.4 7.4-.1 14.8-.5 21.9-2.5 1.3-.4 2.7-.3 3.8.3l.7.6c-4.4 3-9.5 4.2-14.5 4.9-6.5.9-13.1-.7-19.7.9-1.2.3-1.7-.7-1.8-1.8z",
    id: "favicon3_svg__path981"
  })), favicon3_path139 || (favicon3_path139 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st61",
    d: "M112.2 40c-.8 3-2.9 5.6-5.7 7-3.9 2.2-6.4 6-9.3 9.4-3.3 3.9-7.3 7.1-11 10.7-1.1-1.2-.1-2.1.6-3 4.6-5.9 9.7-11.2 15.4-16 .3-.9 1.1-1.7 2-2 1.4-.9 2.6-2.1 4-3 .7-1.9 2.5-2.3 4-3.1z",
    id: "favicon3_svg__path983"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M180.2 124.9c8.7-2 16.9-5.4 24.5-10 1.4-.9 2.8-1.8 4.5-2-4.1 4.9-10.8 6.2-15 11h-1c-1.3.9-2.9 1.2-4.3 1.7-2.8.8-5.6 2-8.5.7-.5-.3-.6-.9-.2-1.4z",
    id: "favicon3_svg__path985",
    style: {
      fill: "#53c2e7"
    }
  }), favicon3_path140 || (favicon3_path140 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st61",
    d: "M111.2 113.9c7 3 12.6 8.1 19 12-7.9-1.5-14.8-4.7-19-12z",
    id: "favicon3_svg__path987"
  })), favicon3_path141 || (favicon3_path141 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st62",
    d: "M102.2 48c-4.2 5.3-9.6 9.3-13.5 14.9-.9 1.3-2.5 2.2-2.5 4l-1 1c-.8 1-1.5 2.2-3 1C86.7 62.1 92 56 98.1 50.5c1.2-1.1 2.1-2.5 4.1-2.5Z",
    id: "favicon3_svg__path989"
  })), favicon3_path142 || (favicon3_path142 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st61",
    d: "M89.2 98c8.2 4.1 15.6 9.5 22 16-5.5-1.8-9.3-6.2-13.7-9.4-2.9-2.2-6.8-2.9-8.3-6.6z",
    id: "favicon3_svg__path991"
  })), favicon3_path143 || (favicon3_path143 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st61",
    d: "m130.2 125.9 18 6c-6.1-1.7-13.5.3-18-6z",
    id: "favicon3_svg__path993"
  })), favicon3_path144 || (favicon3_path144 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st61",
    d: "M78.2 90c4.5 1.3 8.4 4.1 11 8-4.5-1.3-8.4-4.1-11-8z",
    id: "favicon3_svg__path995"
  })), favicon3_path145 || (favicon3_path145 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st62",
    d: "M119.2 33c2.1-1.8 4.1-3.6 7-4 .8-.8 2.2-.8 3 0l-10 6z",
    id: "favicon3_svg__path997"
  })), favicon3_path146 || (favicon3_path146 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st61",
    d: "m82.2 69 3-1c-1 4.1-3.5 7.6-7 10 0-3.6 4-5.4 4-9z",
    id: "favicon3_svg__path999"
  })), favicon3_path147 || (favicon3_path147 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st61",
    d: "M75.2 83c-.3 2.3 1.1 4.1 2 6-3 1.1-4.5-.6-5.3-3-1-3.1 2.4-1.8 3.3-3z",
    id: "favicon3_svg__path1001"
  })), favicon3_path148 || (favicon3_path148 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st61",
    d: "M189.2 125.9c-1 2.3-3.1 2-5 2 .6-2.4 2.4-2.5 4.4-2.4z",
    id: "favicon3_svg__path1003"
  })), favicon3_path149 || (favicon3_path149 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st61",
    d: "M189.2 124.9c1.2-.7 2.6-1.1 4-1-.8 1.8-2.3 2.1-4 2-.3-.2-.4-.4-.3-.7.1-.3.1-.3.3-.3z",
    id: "favicon3_svg__path1005"
  })), favicon3_path150 || (favicon3_path150 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st62",
    d: "M108.2 43c-.9 1.6-2 2.9-4 3 .8-1.6 1.9-3 4-3z",
    id: "favicon3_svg__path1007"
  })), favicon3_path151 || (favicon3_path151 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st61",
    d: "M77.2 79c-.1 1.6-.8 3-2 4-.1-1.8.1-3.3 2-4z",
    id: "favicon3_svg__path1009"
  })), favicon3_path152 || (favicon3_path152 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st98",
    d: "M55.2 275.9c4.4-3.8 10.2-4.9 15-7.8 1.1-.7 2.5-.8 3-2.2 1.1-1.1 2.7-1.2 4-2l2-1c1.3-.7 2.9-.9 4-2l2-1c1.1-1.1 2.7-1.2 4-2 1.1-1.1 2.7-1.2 4-2l25-14c5.4-.2 10.1-3 15.1-4.4 18.7-5.5 36.8-3.2 54.7 2.9 16 5.5 28.6 16.6 41.8 26.6 6.2 4.7 12.3 9.5 18.7 14 3.6 2.5 4.3 5.3 2.9 9.4-1.6 4.6-4.9 7.9-7.8 11.5-18.6 23-42.2 38.3-71.1 44.6-11.6 2.7-23.5 3.6-35.4 2.8-17.5-1.3-34.6-6.2-50.2-14.2-15.6-8-28-19.8-39.6-32.6-1.1-1.2-1.9-2.8-2-4.5 2.2-.5 2.8 1.4 3.8 2.5 10.5 11.5 22.1 21.6 35.8 29.1 8.5 5.5 18.1 8.4 27.8 10.6 33.5 7.4 68.6-1.1 95-23.1 9.2-7.7 17.1-16.7 23.7-26.7 1.7-2.6 1.6-4.3-.7-6.4-6.1-5.4-13-9.8-19.5-14.8-5-3.8-10.1-7.5-15.1-11.4-19.1-14.8-40.5-19.3-64-15.2-6.9 1.2-13.6 3.2-20.1 5.9-3 1.3-5.5 3.5-8.4 5l-2.4 1.2c-3.7 1.8-7.2 3.8-10.6 6.1-3.2 2.5-6.7 4.5-10.5 6-6.3 2.8-12.4 5.9-18.7 8.7-1.8.8-3.5 1.9-5.6 1z",
    id: "favicon3_svg__path1011"
  })), favicon3_path153 || (favicon3_path153 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st99",
    d: "M84.2 329.8c-6.7-2.5-12.1-7-17.7-11.2-7.9-6-14.5-13.5-21.3-20.8l-3-4c-1.8-2.4-3.1-5.1-4.8-7.5-1.7-2.4-.8-4.5 1.9-5.4 2.9-1 6-1.9 9.2-1.5 2.1 3.2-1 3.1-2.5 3.7-4.8 1.9-4.7 1.8-2.3 6.5 1.9 3.5 4.2 6.7 6.9 9.6 1.3 2.3 3.2 4.3 5.4 5.8 2.5 2 4.9 4.2 7 6.6 5.5 5.5 12.1 9.8 19.2 12.8 2 .9 3.9 1.9 5.7 3 2.7 2.1 6 2.9 9.2 3.9 29.1 8.3 56.3 3.7 81.4-12.8 10.4-6.7 19.2-15.6 25.6-26.2 2.9-4.9 2.6-6.2-2-9.5-9.6-6.8-19-14.1-28.5-21.1-9.8-7.3-20.9-12-33.1-13-7.6-.7-15.2 0-22.6 1.9-1.9.5-3.9 1-5.7-.4-.5-1.3.2-2 1.1-2.6 3.9-.9 7.5-3.1 11.7-2.9 10.3-.1 20.6-1.1 30.6 1.9s19.4 6.8 27.5 13.6c9.2 7.6 19.3 14.1 28.6 21.6 4.8 3.9 5.2 5 1.9 10.4-11.1 18.5-28.2 32.8-48.4 40.4-12.4 4.9-25.7 7.2-39 6.8-2.5-.2-5 0-7.4.6-12.1-.8-24-4.2-34.6-10.2z",
    id: "favicon3_svg__path1013"
  })), favicon3_path154 || (favicon3_path154 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st98",
    d: "m49.2 279.9-9.2 2c-2.9.6-3.4 2.1-1.8 4.6 1.5 2.3 3.6 4.4 3.9 7.4-3.7-1.9-4-6.6-7-9-.7-.4-1.1-1.2-1-2-.3-1.8.9-2.2 2.2-2.5 3-.6 5.9-1.4 8.8-2.5 1.9-1 4.2-.9 6-2h4c-.4 3.2-3.5 2.7-5.3 4z",
    id: "favicon3_svg__path1015"
  })), favicon3_path155 || (favicon3_path155 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st67",
    d: "M77.2 263.9c-1 1.2-2.4 1.9-4 2 .7-1.9 2.3-2.1 4-2z",
    id: "favicon3_svg__path1017"
  })), favicon3_path156 || (favicon3_path156 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st67",
    d: "M83.2 260.9c-.8 1.8-2.3 2.1-4 2 1-1.2 2.4-2 4-2z",
    id: "favicon3_svg__path1019"
  })), favicon3_path157 || (favicon3_path157 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st67",
    d: "M89.2 257.9c-1 1.2-2.4 1.9-4 2 .7-1.9 2.3-2.1 4-2z",
    id: "favicon3_svg__path1021"
  })), favicon3_path158 || (favicon3_path158 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st67",
    d: "M93.2 255.9c-1 1.2-2.4 1.9-4 2 .7-1.9 2.2-2.1 4-2z",
    id: "favicon3_svg__path1023"
  })), favicon3_path159 || (favicon3_path159 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st67",
    d: "M45.2 277.9c-1.8 2.4-4.7 1.9-7 2.8-1.5.5-3.2.4-4 2.2-1.4-1.2-.6-2.4.5-2.6 3.5-.7 6.7-2.8 10.5-2.4z",
    id: "favicon3_svg__path1025"
  })), favicon3_path160 || (favicon3_path160 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st67",
    d: "M51.2 275.9c-1.6 1.9-3.8 2.1-6 2 1.5-2 3.7-2.1 6-2z",
    id: "favicon3_svg__path1027"
  })), favicon3_path161 || (favicon3_path161 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st66",
    d: "M140.2 362.8v-1c8.9.7 17.8 1.8 26.7 1.9 23 .2 45.2-4.2 65.9-14.1 13.7-6.3 26.3-14.8 37.4-25 6.1-5.6 11.9-11.5 17.4-17.7 5.3-6.3 10-13.2 13.9-20.5.9-1.7.9-3.1-.8-4.3-7.5-5.4-14.8-11.2-22.4-16.4-10-6.8-19.1-14.8-28.8-22-13.4-10.1-28.3-17.3-44.8-20.6-6-1.3-12.1-2-18.2-2.1-9.1-.4-18.2.3-27.2 2 .7-1.6 2.1-1.8 3.7-2.1 15.1-2.5 30-2.7 45.3.6 14.9 3.2 29 8.2 41 16.8 12 8.6 23.6 17.5 35.3 26.4 7 5.3 13.9 10.7 21 15.7 3.5 2.4 3.4 4.2 1.3 7.7-6.6 11-13.9 21.3-23.6 29.8-3.6 4.8-8.8 7.8-13 12-3 2.4-6.1 4.6-9 7l-11 7c-1.8 1.4-4 2-6 3-10.9 6.3-22.7 11.1-35 14.1-5.3 1.3-10.7 2-16 2.9-2.2 1.3-4.8-.4-7 1h-1c-2.5 1.3-5.5-.4-8 1h-2c-4.9-1.4-10.1.4-15-1-6.9.6-13.5-1.5-20.1-2.1z",
    id: "favicon3_svg__path1029"
  })), favicon3_path162 || (favicon3_path162 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st76",
    d: "M270.1 329.8c3.2-5.2 8.6-8 13-12-2.6 5.9-8 8.7-13 12z",
    id: "favicon3_svg__path1031"
  })), favicon3_path163 || (favicon3_path163 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st76",
    d: "M261.1 336.8c2.3-3.2 5.4-5.6 9-7-2.2 3.2-5.3 5.6-9 7z",
    id: "favicon3_svg__path1033"
  })), favicon3_path164 || (favicon3_path164 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st76",
    d: "M160.2 364.8c5 .6 10.1-1.2 15 1-5-.6-10.2 1.2-15-1z",
    id: "favicon3_svg__path1035"
  })), favicon3_path165 || (favicon3_path165 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st76",
    d: "M177.2 365.8c2.5-2 5.4-.6 8-1-2.5 2-5.4.6-8 1z",
    id: "favicon3_svg__path1037"
  })), favicon3_path166 || (favicon3_path166 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st76",
    d: "M244.1 346.8c1.6-1.6 3.7-2.6 6-3-1.3 2.3-3.5 3-6 3z",
    id: "favicon3_svg__path1039"
  })), favicon3_path167 || (favicon3_path167 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st76",
    d: "M186.2 364.8c2.1-1.9 4.7-.6 7-1-2.2 1.9-4.7.6-7 1z",
    id: "favicon3_svg__path1041"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M201.2 113.9c-2.2 2.3-5.3 2.7-8 4-21.7 6.7-40.9 1.5-58.3-12.2-9.5-7.5-19.5-14.5-29.1-21.9-3.1-2.3-3.5-4.4-1.5-7.5 19.3-30.1 45.9-49.6 81.4-56.6 11.7-2.2 23.7-2.8 35.5-1.7 12.5.8 24.6 3.5 36 9-2.3 2-4.6.4-6.9 0-3.4-1.3-6.9-2.4-10.5-3.1-8.6-1.6-17.1-3.6-26-3.5-22.8.4-44.2 5.5-63.6 18-6.8 3.4-12.4 8.3-17.7 13.5-7.5 7.1-14.4 14.7-19.7 23.6-1.2 2-2.3 3.7.2 5.5 14.2 10.5 27.3 22.8 43.5 30.5 6.5 3.1 13.6 4.6 20.8 4.3 2.9-.4 5.9-.2 8.8-.3 3 .3 5.8-.8 8.6-1.7 2.1-.6 4.3-1.8 6.5.1z",
    id: "favicon3_svg__path1043",
    style: {
      fill: "#68c6e9"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M221.2 18c-16.5-.7-32.8.7-48.6 5.9-17.8 5.8-34.1 15.7-47.5 28.8-7.6 7.3-13.4 15.8-19.7 24-1.8 2.3-2.3 3.9 1.1 6.2 7.7 5.1 15.2 10.7 22.3 16.6 14.1 11.5 29.1 20.6 48.1 20.4 5.5 0 10.7-2.3 16.2-2-4.2 3.1-9.4 3.3-14.1 3.8-11.6 1.1-23.2-1.2-33.4-6.6-12.7-6.4-22.7-16.4-34.3-24.1-3-2-5.9-4.2-8.9-6.2s-3.8-3.7-1.7-7.3c15.2-25.1 36.8-42.6 64-53.1 17.5-6.7 36-8.7 54.8-7.4.5.1 1.1.7 1.7 1z",
    id: "favicon3_svg__path1045",
    style: {
      fill: "#65c5e9"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M180.2 124.9v1c-4.7 4.5-10.8 3.7-16.4 3.5-17.3-.3-31.8-8.2-45.3-18.2-10.3-7.6-20-16-31-22.6-4.8-2.9-4.8-5-1.8-9.8 10.2-16.7 23.8-30.2 39.5-41.7 2.3-1.7 4.8-3 7.1-4.6 1.5-1 3.1-2.1 5-.5-1.8 2.2-4 3.9-6.5 5.2-7.6 4.2-13.5 10.4-19.6 16.3-7.3 7.2-13.8 15-19.5 23.5-3.7 5.4-4.1 6.9 1.1 10.3 13.9 9.2 26.5 20.2 40.3 29.4 10 6.9 22.1 10.2 34.3 9.3 4.2.9 8.3-1.8 12.8-1.1z",
    id: "favicon3_svg__path1047",
    style: {
      fill: "#55c2e7"
    }
  }), favicon3_path168 || (favicon3_path168 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st103",
    d: "m250.1 26 7 1 22 11c11 7.4 20.9 16.4 29.2 26.7 1.2 1.6 3.7 3 .8 5.3h-2c-2.3-.8-4.7-.8-7 0h-2c-2.5 1.3-5.5-.4-8 1-4.7.6-9.4 1.6-14 3l-6 2c-1.1.7-2.4.8-3.7.4-1.3-2.4 1-2.7 2.2-3.3 2.2-1.1 4.4-2 6.7-2.7.5-.2.9-.3 1.4-.4 8.9-1.1 17.6-3.2 27.2-3.5-3.2-5.5-7.4-9.5-11.4-13.5-5.7-5.7-12.5-10.3-19.3-14.7-1-.6-2.1-1-3.3-1.1-6.1-2.3-12-5.1-17.9-7.8-.9-.7-1.7-1.6-2.1-2.7.1-.3.2-.5.2-.7z",
    id: "favicon3_svg__path1049"
  })), favicon3_path169 || (favicon3_path169 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st104",
    d: "M201.2 113.9c-5.3-.3-9.7 3.7-15 3 .7-3.5 4.4-2.4 6.3-4.1 4.5-2.1 9.7-2.5 13.7-5.6 5.6-3.6 11.8-6.1 16.6-10.8 1-.6 2.1-1.2 3.3-1.6 2.4-.5 4.2-3.6 7.2-1.9-3.3 3.2-7.1 5.9-11.2 8-1.9 1-3.9 1.8-4.9 4-5.2 3.4-10.2 6.9-16 9z",
    id: "favicon3_svg__path1051"
  })), favicon3_path170 || (favicon3_path170 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st93",
    d: "M309.1 70c1.3-2.6-.7-3.9-2-5.6-7.6-9.4-16.5-17.7-26.5-24.5-.6-.6-1.1-1.2-1.5-1.9 5.2 1.3 8 6.5 13 8 5.9 7.2 13.3 12.8 18.9 20.3.7.9 1.8 2 1.3 3s-2.1.5-3.2.7z",
    id: "favicon3_svg__path1053"
  })), favicon3_path171 || (favicon3_path171 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st93",
    d: "M276.1 74c4.3-2.6 9.1-3.1 14-3-4.6 1.1-9.1 3-14 3z",
    id: "favicon3_svg__path1055"
  })), favicon3_path172 || (favicon3_path172 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st93",
    d: "M266.1 76h4c-2.7 2.8-6.5 3-10 4 .3-3.9 3.2-3.9 6-4z",
    id: "favicon3_svg__path1057"
  })), favicon3_path173 || (favicon3_path173 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st93",
    d: "M290.1 71c2.5-2 5.3-.6 8-1-2.4 2-5.3.5-8 1z",
    id: "favicon3_svg__path1059"
  })), favicon3_path174 || (favicon3_path174 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st93",
    d: "M300.1 70c2.1-1.6 4.9-1.6 7 0z",
    id: "favicon3_svg__path1061"
  })), favicon3_path175 || (favicon3_path175 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st105",
    d: "M266.1 76c-1.7 1.8-4.9 1.3-6 4-6.7 1.4-12.6 4.8-18.5 8-2.9 1.6-5.7 3.3-8.5 5-2.8-.1-4.3 2.8-7 3-.5-2.5 1.4-3.6 3-4.7 12.7-8.4 26-15.5 40.4-20.3 2.1-.7 4.4-2 6.6 0-2.9 2.4-7.1 2.2-10 5z",
    id: "favicon3_svg__path1063"
  })), favicon3_path176 || (favicon3_path176 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st95",
    d: "M137.2 32c-7.3 2.2-13 7-18.6 11.7-8.5 7.3-17.1 14.6-23.6 23.9-3.3 4.8-6.7 9.4-10 14.2-1.9 2.8.9 4.4 2.2 5.2 14.3 8.4 26.4 19.7 40 29.1 6.3 4.2 13.2 7.4 20.4 9.4 8.5 2.6 17.1 3.9 26.1 2.6 2.4-.4 4.2-2 6.5-2.2l9-1v1c-1.9-.2-3.8.5-5 2-10.3 1.6-20.5 3.7-31 3-2.2-3.4-6.3-2.8-9.4-3.7-7.8-2.1-14.5-6-21.3-10.3-14.1-9-26.3-20.5-40.4-29.4-3-1.9-3.2-3.2-1.3-6.2 10.6-16.7 24-31.3 39.8-43.2 8.3-6.2 17.7-10.5 27.2-14.8 5.6-2.5 11.5-4.3 17.1-6.9 3.2-1.5 7.4-1.7 11.1-2.1 14.6-1.5 29.3-3.3 44-1.3.4.1.8.5 1.2.8-7.8 0-15.6.1-23.4 0-11.2-.2-21.7 2.7-32.3 5.5-8.1 2.1-15.5 5.5-23 9-2 1-4.3 1.5-5.3 3.7z",
    id: "favicon3_svg__path1065"
  })), favicon3_path177 || (favicon3_path177 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st58",
    d: "M129.2 29h-3l1-2h3c-.4.6-.7 1.3-1 2z",
    id: "favicon3_svg__path1067"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M84.2 329.8c6.7 2 13 5.3 20 6.5l15 2.5c12.6.8 25.2-.2 37.5-3.2 17.2-4.1 31.4-13.3 44.6-24.6 6.6-5.7 11.7-12.7 16.4-20 2-3 1.7-5.2-1.2-7.7-12.2-10.1-24.9-19.5-38.2-28.1-12.7-8.2-27.4-11.1-42.4-11.1-3.4 0-7.3 0-10.7 1.8-4.2-.8-7.9 1.7-12 2-.5.6-1.3.6-1.9.1l-.1-.1c6.3-3.9 13.5-5.2 20.6-6.6 18.1-3.5 35.7-1.5 52.2 7.1 8.6 4.5 16.1 10.8 23.8 16.8 7.4 5.8 15.2 11.1 22.7 16.8 5.1 3.9 4.6 4.9 1.1 10.3-5 7.5-10.3 14.6-16.9 20.6-13.1 11.9-27.7 21-44.9 26.2-14.3 4.2-29.4 5.8-44.3 4.5-13.6-1-26.6-5.4-38.9-11.3-1.1-.4-1.7-1.6-2.4-2.5z",
    id: "favicon3_svg__path1069",
    style: {
      fill: "#00488b"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M112.2 249.9c4.6-.3 9.3-2.4 13.5-2.3 7.8.1 15.6-1.1 23.5 1 16.2 4.2 28.5 14.5 41.3 24.2 4.2 3.2 8.6 6.2 12.9 9.3 5.1 3.6 5.5 4.8 2.2 10-14.8 23.8-36.8 36.8-63.6 42.9-10.5 2.4-21 2-31.3.6-6.7-.9-13.7-2.1-20-5-1.4-.6-2.8-1.1-3.4-2.7.3-.4.8-.7 1.3-.8 1-.2 2.1-.1 3.1.3 5.6 2.9 11.8 3.5 17.9 4.1 24.2 2.4 46.2-3.6 65.3-18.9 7.5-5.9 13.8-13.1 18.9-21.1 1.5-2.4 2.3-4.5-.4-6.5-11.5-8.5-22.2-18.1-34.7-25.2-14.9-8.5-30.9-11.1-47.7-6.1-2.4.5-4.8 1.4-7 2.6-.4.2-.9.2-1.4.2-.7-.2-1.3-.6-1.6-1.2-.2-.4-.1-.9.3-1.2.4-.7 1.2-1.1 2-1 3-.9 5.2-4.3 8.9-3.2z",
    id: "favicon3_svg__path1071",
    style: {
      fill: "#004385"
    }
  }), favicon3_path178 || (favicon3_path178 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st108",
    d: "M50.2 299.8c-5.1-3.3-6.8-9.1-10.1-13.7-1.5-2.1.6-2.4 1.7-3.1 2.3-1.4 5.8-.3 7.4-3.2 10.6-4 21-8.6 31-14l10-6c.5-.5 1.3-.6 1.9-.3 0 3.9-4.2 4-5.9 6.4-.4.3-.7.5-1.1.7-1.5.5-2.8 1.3-3.8 2.4-10.4 6.6-21.5 12-33.1 16.1-4 1.4-4 2.8-1.8 5.9 1.7 2.4 4.2 4.4 4.5 7.6-.2.4-.4.9-.7 1.2z",
    id: "favicon3_svg__path1073"
  })), favicon3_path179 || (favicon3_path179 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st99",
    d: "M80.2 265.9c-9.4 6.5-19.9 11.2-31 14 1.1-2.7 4.6-1.7 6-4 7.2-1.4 13.4-5.2 19.9-8.3 1.6-.9 3.1-1.9 5.1-1.7z",
    id: "favicon3_svg__path1075"
  })), favicon3_path180 || (favicon3_path180 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st109",
    d: "M112.2 249.9c-3 .9-5.7 2.9-9 3 2.5-2 4.8-4.2 8-5h2z",
    id: "favicon3_svg__path1077"
  })), favicon3_path181 || (favicon3_path181 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st109",
    d: "M92.2 259.9h-2c3.5-2.4 6.8-5 11-6v1c-1.1 2.5-3.8 3.3-5.7 4.8-1.1.5-2.2 1.2-3.3.2z",
    id: "favicon3_svg__path1079"
  })), favicon3_path182 || (favicon3_path182 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st110",
    d: "m92.2 259.9 3-1c2.4-.9 4.5-2.3 7-3h1c9.3-3.2 19.3-3.6 28.8-1.1 12.6 3.2 22.9 10.4 32.8 18.4 4 3.3 8.2 6.2 12.4 9.2 4.7 3.3 5.3 5.8 2.4 11-5 8.7-12.3 15.2-20.3 21-9.9 7.3-21 12.5-33.2 14.1-9.8 1.4-19.8 2.1-29.6-.9-3.5-1-7.2-.9-10.8-1.7-1.7-.4-3.3-1.1-4.8-2-1.2-1.1-2.7-1.8-4.2-2.1-5.3-2.6-10.2-6-14.4-10l-7-6c-.5-.6-.6-1.4-.2-2.1 2.4-1.2 3.8.6 5.2 1.9 21.1 19 52.9 19.8 76.2 5.5 7.8-4.7 14.8-10.7 19.6-18.8 1.4-2.4 1.9-4.7-.7-6.6-7.5-5.7-14.9-11.9-23-16.7-13.2-7.8-27.1-9.5-41.6-3.8-1.8.7-3.6 2.1-5.6.7 1.4-3.1 5-3.7 7-6z",
    id: "favicon3_svg__path1081"
  })), favicon3_path183 || (favicon3_path183 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st109",
    d: "M125.2 245.9c5.7-3.4 12.1-3.6 18.2-2.8 10.3 1.3 20.5 3.4 30.1 7.9 7.6 3.6 14 8.9 20.7 13.7 8.3 6 16.7 11.9 24.5 18.7 2.3 2.1 3 3.4 1.4 6.2-9.5 16.9-23.6 28.9-40.1 38.3-13.4 7.6-28 10.5-43.2 12.1-5.9.5-11.8.1-17.6-1.2 2-1.9 4.5-1 6.7-.9 17.2.8 33.3-3.2 48.4-10.8 11.8-5.8 22.1-14.2 30.2-24.5 3.1-4.1 6.3-8 9-12.4 1.9-3 1.4-4.8-1.2-6.6-9.8-7.3-19.9-14.2-29.4-22-10.1-8.2-21.5-12.9-34-15.2-7.9-1.5-15.8-.7-23.7-.5z",
    id: "favicon3_svg__path1083"
  })), favicon3_path184 || (favicon3_path184 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st108",
    d: "M81.2 322.8c1 1.2 2.4 1.9 4 2 1 1 3.7.3 3 3h-1c-8.7-3.2-16.8-7.9-23.9-13.9-.6-.5-1.1-1.2-1.1-2 5.4 2.3 8.8 8 15 9 1.1 1.1 2.6 1.2 4 1.9z",
    id: "favicon3_svg__path1085"
  })), favicon3_path185 || (favicon3_path185 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st108",
    d: "M55.2 303.8v2c-2.1-1.6-4.5-3-5-6v-1c3.2.1 4.9 1.8 5 5z",
    id: "favicon3_svg__path1087"
  })), favicon3_path186 || (favicon3_path186 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st103",
    d: "M193.2 113.9c-2 1.8-5.1.9-7 3h-10c-10-1.7-19.8-4.1-28.3-10-11.1-7.8-21.8-16.1-32.8-24.3-3.1-2.3-3.3-4.9-1.3-8.2 8.9-15 21.3-26.5 35.4-36.5 4.9-4.6 10.9-7.4 17-9.8 16.8-6.6 34.3-10 52.3-9.1 7.4.3 14.7 1.6 21.6 3.9l-.5.5c-1.9 1-3.9.5-5.8.2-18.9-2.7-37.5-2.2-55.6 4.2-18.8 6.4-35.6 17.9-48.4 33.1-3.7 4.3-6.8 9-10.2 13.5-1.9 2.6-1.6 4.3 1.1 6.2C131 88 140.8 96 151.2 103.2c10.4 7.4 23.1 10.9 35.8 9.7 2.1-.2 4.3-.7 6.2 1z",
    id: "favicon3_svg__path1089"
  })), favicon3_path187 || (favicon3_path187 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st104",
    d: "M149.2 38c-1.9 3.5-5.6 5.2-8.4 7.6-10.3 8.7-19.5 18.2-26.3 29.9-1.4 2.4-1.5 4.2.9 6 12 8.7 23.5 18.2 36 26.2 5.9 3.8 12.4 6.2 19.3 7.3 2 .3 3.9.6 5.5 2-7 .3-14-1.2-20.3-4.3-13.6-6.6-25.2-16.1-36.8-25.7-.3-.2-.4-.5-.7-.7-10.3-7.3-10.2-7.2-2.9-17.1 8.5-11.4 18.6-21.5 30-30 1-.9 2.3-1.3 3.7-1.2z",
    id: "favicon3_svg__path1091"
  })), favicon3_path188 || (favicon3_path188 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st103",
    d: "M240.1 23c3.5.1 7 1.1 10 3-4.3 1.5-7.5.5-10-3z",
    id: "favicon3_svg__path1093"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M276.1 71c-7.5.3-13.8 4.2-20.4 6.8-9.5 3.8-17.9 9.6-26.6 14.9-1.2.7-2 2.2-3 3.3l-3 1c-.5.5-1.3.6-1.9.3-.5-2.8 2.3-3.2 3.4-4.9 2.3-2 4.7-3.8 7.3-5.4 4.5-2.2 8.7-4.8 12.8-7.7 1-1 2.2-1.8 3.5-2.3 5.6-2.2 11.1-4.7 16.4-7.5.4-.2.9-.4 1.3-.5 9.6-2.2 19.1-5.2 30.4-4.2-7.9-10.5-16.4-18.4-27.1-24-2.9-.9-5.2-2.8-7.7-4.3-15.7-7.9-32.5-10.6-49.9-9-22.2 2.1-41 11.7-56.9 27.3-4.8 4.7-8.3 10.3-12.3 15.6-1.8 2.4-1.1 4.2 1.1 5.9 4.1 3.3 8.4 6.7 12.7 9.6 5.8 3.8 10.9 8.5 17.1 12 13.9 7.7 27.4 6.6 41.2.7 1.8-.8 3.4-2.3 5.6-1 .7 2.5-1.6 2.6-2.8 3.4-5.7 3.8-12.5 5.2-18.5 8.4-1.7.9-3.6 0-5.4-.1-10.2-.3-20.3-1-29.3-6.6-4.8-3-9.2-6.6-13.8-9.9-5.3-3.8-10.5-7.6-15.9-11.3-5.1-3.5-5.9-6.6-2.7-11.8 7.8-12.8 18.6-22.5 30.8-31s25.8-12.4 39.8-15.1c9.8-1.9 19.9-1.5 29.9-.8 6.9.8 13.3 3.3 20 5l18 8c12.3 7 23.2 16.2 32.1 27.2.7.9 1.6 1.8 1.3 3.1-.4 1.6-1.8 1.2-2.9 1.2-8.3.3-16.4 1.8-24.5 3.5z",
    id: "favicon3_svg__path1095",
    style: {
      fill: "#7fcdec"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M252.1 28c-5 .3-9.6-2-14.3-3.1-1.9-.5-3.8-.8-5.7-.9-15.3-2.1-30.8-.8-45.5 3.7-17.8 5.1-33.9 15-46.6 28.5-5 5.2-9.3 10.9-13 17-1.6 2.7-1.1 4.5 1 6.5 2.8 2.7 6.3 4.3 9.4 6.6 8.7 6.3 17.2 13.1 26.5 18.6 9.3 5.5 19.7 5.3 30 4.8 2.8-.2 5.5-.1 8.1-1.8 1.6-1.1 3.6-1 5.2.1-2.4 2.6-5.9 3-9 4.2-1.6.7-3.7.2-5 1.8-8.1.6-16.2 1.1-24-1.1-8-2.1-15.4-5.9-21.9-11.1-8.6-6.9-17.6-13.2-26.7-19.5-5.3-3.7-5-3.2-1.9-8.6 5-8.5 11.3-16.3 18.7-22.9 14-12.8 30.2-22.5 49.1-26.8 16.3-3.9 33.2-4.2 49.7-1.1 1.3.1 2.7.2 4 .1 3 1.9 6.5 2.9 10 3z",
    id: "favicon3_svg__path1097",
    style: {
      fill: "#75caeb"
    }
  }), favicon3_path189 || (favicon3_path189 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st105",
    d: "M276.1 71c7.1-3.1 14.7-3 22.2-4 1.4-.2 3.4.8 4.1-.7.9-1.7-1.2-2.4-2.1-3.5-7.8-10.3-17.6-18.2-28.6-25-.6-.5-1.2-1.1-1.7-1.8 5.2.3 8.3 4.5 12.3 7.1 7.8 5 14 12 20.2 18.9 1.4 1.5 3.7 3.3 2.7 5.3-.7 1.6-3.4.4-5.1.7-7.9 1-15.9 2-24 3z",
    id: "favicon3_svg__path1099"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M207.1 107.9c-8.5 2.5-17.3 3.6-26.1 3.3-10.3-.3-18.9-5.3-27-11.1-8.3-5.9-16.6-11.9-25-17.8-5.9-4.1-5.9-5.1-2.2-11.1 9.1-14.7 21.7-26.8 36.8-35.2 12.5-7.2 26.1-11 40.3-13.2 9.4-1.4 19.1-1 28.4 1.1-9.8.2-19.6-.2-29.2.8-4.7.5-9.6 2.1-14.2 3.6-8.2 2.7-15.9 5.7-23.1 10.2-13.9 8.7-25.3 19.6-34 33.5-1.5 2.4-1.6 5.5 1.1 7.1 12.3 7.5 22.8 17.7 35.5 24.5 8 4.3 16.8 4.6 25.4 4.3 9.7-.3 18.4-4.4 26.2-10-.2-.9.1-1.2 1-1h2c-3.1 4.6-8.1 6.5-12.7 9-1 .7-2.3.9-3.2 2z",
    id: "favicon3_svg__path1101",
    style: {
      fill: "#7acceb"
    }
  }), favicon3_path190 || (favicon3_path190 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st108",
    d: "m88.2 327.8-3-3c7.6.1 14.8 3.1 22.5 3.2 9.4.1 18.7-.2 27.9-3.1 13.6-4.3 25-12.1 35-22 3.5-3.5 6.5-7.5 8.9-11.9 1.5-2.8.9-5.1-1.7-6.9-8-5.3-15.5-11.3-23.1-17.2-11.5-8.9-24.9-12.9-39.2-12.7-3.9.1-8 1.9-12.2 1.6 1.6-2.7 4.4-2.6 7-3 16.8-4.3 32.6-1.5 47.4 7.1 5.6 3.2 10.5 7.6 15.8 11.3 5 3.5 9.8 7.5 14.6 11.3 4.8 3.8 5.2 5.6 1.6 10.8-16.3 23.3-38.3 37-67 38.5-10.5.6-21.3.1-31.3-4.1z",
    id: "favicon3_svg__path1103"
  })), favicon3_path191 || (favicon3_path191 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st108",
    d: "M91.2 327.8c9.7 2.3 19.6 3.4 29.5 3 19.2-.6 37.6-7.9 51.9-20.7 6.2-5.6 11.8-11.8 16.7-18.6 2.4-3.3 1.6-5-.9-7-5.4-4.3-10.6-9-16.5-12.7-6.8-4.3-12.5-10.1-20.1-13.4-10.8-4.6-21.6-8.2-33.6-5.9-2.6.5-5.3.2-8 .2 13-5.1 25.9-3.3 38.8.9 12.4 4 21.6 12.6 31.7 20.1 4.6 3.4 9.2 6.9 14 10.2 2.6 1.8 3 3.7 1.3 6.3-14.6 22.8-35 37-61.9 41.6-13.3 2.2-26.3 1.2-39.2-2-1.6-.2-3-.4-3.7-2z",
    id: "favicon3_svg__path1105"
  })), favicon3_path192 || (favicon3_path192 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st108",
    d: "M102.2 255.9c-1.6 2.7-4.4 2.6-7 3 1.8-1.7 3.8-3 6-4z",
    id: "favicon3_svg__path1107"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M55.2 303.8c-1.3-2-3-3.7-5-5-2.3-3.4-4.5-6.9-6.8-10.3-1.2-1.8-1.8-2.9 1.2-3.8 13.1-3.6 24.8-10.4 36.6-16.9 1.1-1.1 2.7-1.2 4-2 8.4-3 16.6-6.1 25.9-5.1 9.1.9 17.8 4 25.4 9.1 6.6 4.4 12.8 9.5 19.1 14.2 2.9 2.2 4.7 4.2 2 8.2-10.3 15.4-24.5 25-42.6 28.5-21.5 4.1-40.9-.4-57.2-15.7-.7-.7-1.6-1.1-2.6-1.2z",
    id: "favicon3_svg__path1109",
    style: {
      fill: "#003a78"
    }
  }), favicon3_path193 || (favicon3_path193 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st110",
    d: "M85.2 265.9c-1 1.2-2.4 1.9-4 2 .7-1.9 2.3-2.1 4-2z",
    id: "favicon3_svg__path1111"
  })), favicon3_path194 || (favicon3_path194 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st108",
    d: "M81.2 322.8c-1.7.1-3.2-.2-4-2 1.5.1 3 .8 4 2z",
    id: "favicon3_svg__path1113"
  })), /*#__PURE__*/react.createElement("path", {
    d: "m248.1 78-3 2c-4.6 2.1-9 4.8-13 8l-7 5c-13 10.4-35.7 11-49.4.7-7-5.3-14.2-10.5-21.4-15.4-5.6-3.8-6.1-6.9-2.2-12.5 15.7-22.8 37.1-36.1 65.1-38.2 15.8-1.2 30.6 2 44.9 8.4 2.8.5 4.4 3.1 7 4 9.7 5.8 18.4 12.9 25.2 22 .6.8 1.5 1.4 1 2.5-.4.9-1.3 1-2.1.9-9.8-.9-19 1.9-28.1 4.5-5.8 2.4-11.4 5.1-17 8.1z",
    id: "favicon3_svg__path1115",
    style: {
      fill: "#8ed2ee"
    }
  }), favicon3_path195 || (favicon3_path195 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st116",
    d: "M262.1 36c-3.5.4-6.4-1.6-9.3-2.8-7.2-3-14.8-3.3-22.3-4.2-10.9-1.2-21.8-.1-32.2 3.3-12.1 3.6-23.1 10.2-32.2 19-5.1 4.9-9.7 10.3-13.8 16.1-2.5 3.7-1.8 6.7 1 8.6 10 6.7 18.7 15.4 29.7 20.4 10.3 4.9 22.2 5.2 32.7.7l9.5-4c-.7 2-2.8 2.5-4 4l-1 1c-6.7 2.2-13 5.5-20.1 6.5-8.6 1.3-17.3-.2-25-4.2-12.4-6.2-22.2-16-33.6-23.7-2-1.4-2.9-2.9-1.1-5.4 6.1-8.8 12.5-17.1 21-24 12.1-10 26.4-16.7 41.8-19.7 20-3.8 39.2-1 57.8 7 .4.1.7.9 1.1 1.4z",
    id: "favicon3_svg__path1117"
  })), favicon3_path196 || (favicon3_path196 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st116",
    d: "M265.1 70c4.5-2.3 9.4-3.8 14.5-4.5 4.8-.6 9.8-.1 15.6-.1-6.1-9.6-13.6-16.2-22.1-21.8-1.5-1-3.2-1.8-4-3.5 6 .8 9.6 5.6 14 8.8 5.3 3.9 9.6 9.1 13.6 14.3.8 1.1 1.9 2.9-.4 2.7-10.7-1-20.7 2.8-31.2 4.1z",
    id: "favicon3_svg__path1119"
  })), favicon3_path197 || (favicon3_path197 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st116",
    d: "M248.1 78c5.2-3.6 10.3-7.4 17-8-5 3.9-11 6-17 8z",
    id: "favicon3_svg__path1121"
  })), favicon3_path198 || (favicon3_path198 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st116",
    d: "M232.1 88c3.5-4.1 7.4-7.4 13-8-3.7 3.6-8.3 5.8-13 8z",
    id: "favicon3_svg__path1123"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M236.1 32c14.9.9 27.9 6.9 39.6 15.6 5.3 3.9 10.4 8.6 13.7 14.9-4.5.7-8.9 1.3-13.2 1.9-18.1 2.8-32.9 12.2-47.1 23-.9.7-1.8 1.5-3 1.5-12.9 8-25.6 6.4-38-1.2-6.5-4-12.4-9-18.5-13.6-5.1-3.8-5.3-5.5-1.6-10.7 9.5-13.8 23.2-24.1 39.1-29.4 9.7-1.4 19.1-4.8 29-2z",
    id: "favicon3_svg__path1125",
    style: {
      fill: "#98d5f0"
    }
  }), favicon3_path199 || (favicon3_path199 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st118",
    d: "M207.2 34c-6.6 5.6-15.4 7.2-21.9 12.9-6.6 5.7-12.6 12.3-17.7 19.4-1.6 2.2-1.2 4 .9 5.5 7.7 5.7 15 12.3 23.4 16.7 9.7 5.1 20.4 7.9 31 1.3 1-.6 2.1-.9 3.3-.8-.6 1.4-1.8 2.5-3.2 2.9-14.1 4.3-28 7.4-40.8-3.8-5.8-5.1-12.6-9.1-19-13.6-4.2-2.9-4.4-6.3-1.4-10.2 8.4-11 19.1-20 31.3-26.3 4.2-2.3 8.9-4.1 14.1-4z",
    id: "favicon3_svg__path1127"
  })), favicon3_path200 || (favicon3_path200 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st118",
    d: "M236.1 32c-9.8-1.4-19.3 2.2-29 2 9.5-3.2 19-6.2 29-2z",
    id: "favicon3_svg__path1129"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M236.1 34h1c3.6.8 7.4 1 11 2 12.6 3.6 24.1 10.4 33.3 19.8.9.8 1.6 1.7 2.3 2.6 1.4 2 1.8 3.7-1.7 3.6-16.6-.1-30.2 7.8-43.3 16.9-5.5 3.8-10.9 7.7-17.6 9.1-6.8.5-13.5 2-19.8-2.4-5.7-4-11.6-7.7-17.3-11.8-6.9-5.1-7.3-8.9-1.7-15.2 7-7.8 14.5-15.1 24.2-19.5 5.1-2.3 10.8-2.8 16.3-4.2 1.1-.3 2.4.1 3.3-.8h4c2 .5 4 1.1 6-.1z",
    id: "favicon3_svg__path1131",
    style: {
      fill: "#a1d8f1"
    }
  }), favicon3_path201 || (favicon3_path201 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st120",
    d: "M226.2 34c-3.1 2-6.6 3.2-10.2 3.5-11.9 1.7-20.2 9.2-28.1 17.2-2.7 2.8-6.1 5.2-7.6 9.2-.9 2.4-.9 4.3 1.4 6.1 7.9 6.6 16.3 12.7 25.6 17 3.9 1.8 9.3-.1 14 1-4.8 3.6-10.3 1.9-15.5 1.6-5.3-.3-9.9-3.1-14.1-6.5-5.4-4.3-11.2-8.2-16.7-12.4-1.6-1.2-3.6-2.7-1.7-5.3C186.6 47.5 202.9 35 226.2 34Z",
    id: "favicon3_svg__path1133"
  })), favicon3_path202 || (favicon3_path202 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st120",
    d: "M248.1 36c-3.8.1-7.5-.3-11-2 3.9-.1 7.6-.1 11 2z",
    id: "favicon3_svg__path1135"
  })), favicon3_path203 || (favicon3_path203 = /*#__PURE__*/react.createElement("path", {
    className: "favicon3_svg__st120",
    d: "M236.1 34c-2 2.9-4 .8-6 0z",
    id: "favicon3_svg__path1137"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M241.2 37c11.8-.7 25.8 7.6 37.8 20 .7.7 2 1.6 1.3 3s-2 1-3.1 1c-11.8.2-22 4.9-31.6 11.3-6.7 4.4-12.9 9.6-21.2 11.2-4.9 1-8.9-.7-12.9-2.5-7.2-3.3-13.1-8.7-19.5-13.3-3.2-2.3-1.8-5.7.1-8 11.2-13.3 25-22 49.1-22.7z",
    id: "favicon3_svg__path1139",
    style: {
      fill: "#a7dbf2"
    }
  })));
};

/* harmony default export */ var favicon3 = (SvgFavicon3);
;// CONCATENATED MODULE: ./src/components/globals/header/data.js



// import DiscountIcon from '../../../../public/assets/icons/discount.svg';






// import InsuranceIcon from '../../../../public/assets/icons/insurance.svg';


































var faqs = [
    {
        name: 'H\xe4ufige Fragen',
        href: '/faq',
        list: [
            {
                name: '\xdcber CharterCheck',
                href: '/faq#ueber',
                collapsed: false,
                subList: [
                    {
                        name: 'Wer ist CharterCheck?',
                        href: '/faq#ueber'
                    },
                    {
                        name: 'Bekomme ich woanders g\xfcnstigere Preise?',
                        href: '/faq#ueber'
                    },
                    {
                        name: 'Mit welchen Partnern arbeitet CharterCheck zusammen?',
                        href: '/faq#ueber'
                    },
                    {
                        name: 'Kann ich mich auch pers\xf6nlich beraten lassen?',
                        href: '/faq#ueber'
                    }, 
                ]
            },
            {
                name: 'Voraussetzungen',
                href: '/faq#voraussetzungen',
                collapsed: false,
                subList: [
                    {
                        name: 'Ben\xf6tige ich einen Bootsf\xfchrerschein?',
                        href: '/faq#voraussetzungen'
                    },
                    {
                        name: 'Wann ist ein Boot f\xfchrerscheinfrei?',
                        href: '/faq#voraussetzungen'
                    },
                    {
                        name: 'Charterbescheinigung oder Fahrtraining?',
                        href: '/faq#voraussetzungen'
                    },
                    {
                        name: 'Darf ich auch alleine fahren?',
                        href: '/faq#voraussetzungen'
                    }, 
                ]
            },
            {
                name: 'Auswahl Hausboot / Fahrgebiet',
                href: '/faq#auswahl',
                subList: [
                    {
                        name: 'Wie unterscheiden sich die Bootsklassen',
                        href: '/faq#auswahl'
                    },
                    {
                        name: 'Wie sind die Hausboote versichert?',
                        href: '/faq#auswahl'
                    },
                    {
                        name: 'Macht eine Zusatzversicherung Sinn?',
                        href: '/faq#auswahl'
                    },
                    {
                        name: 'Was ist eine Skipper-Haftpflichtversicherung?',
                        href: '/faq#auswahl'
                    }, 
                ]
            },
            {
                name: 'Reservierung & Buchung',
                href: '/faq#buchung',
                subList: [
                    {
                        name: 'Kann ich auch unverbindlich reservieren?',
                        href: '/faq#buchung'
                    },
                    {
                        name: 'Gibt es einen Mindestbuchungszeitraum?',
                        href: '/faq#buchung'
                    },
                    {
                        name: 'Wie lauten die Stornierungsbedingungen?',
                        href: '/faq#buchung'
                    },
                    {
                        name: 'Wann muss ich die Charter zahlen?',
                        href: '/faq#buchung'
                    }, 
                ]
            },
            {
                name: 'An Bord',
                href: '/faq#bord',
                subList: [
                    {
                        name: 'Kann ich einen Hund mitnehmen?',
                        href: '/faq#bord'
                    },
                    {
                        name: 'Mit wie vielen Personen darf ich auf&apos;s Boot?',
                        href: '/faq#bord'
                    },
                    {
                        name: 'Was ist der Unterschied zwischen Kojen und Kabinen?',
                        href: '/faq#bord'
                    },
                    {
                        name: 'Muss man mit den Booten immer in einem Hafen anlegen?',
                        href: '/faq#bord'
                    },
                    {
                        name: 'Kann ich einen Liegeplatz im Hafen reservieren?',
                        href: '/faq#bord'
                    },
                    {
                        name: 'Gibt es Kartenmaterial an Bord?',
                        href: '/faq#bord'
                    }, 
                ]
            }, 
        ]
    }, 
];
var HeaderData = [
    {
        name: 'Reviere',
        href: '/',
        icon: tour,
        list: [
            {
                name: 'Top Reviere',
                header: true
            },
            {
                name: 'Kroatien',
                icon: hr,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Kroatien',
                        href: '/yachtcharter/kroatien',
                        list: [
                            {
                                name: 'Istrien',
                                href: '/yachtcharter/kroatien/istrien',
                                subList: [
                                    {
                                        name: 'Pula',
                                        href: '/yachtcharter/kroatien/istrien/pula'
                                    },
                                    {
                                        name: 'Pomer',
                                        href: '/yachtcharter/kroatien/istrien/pomer'
                                    },
                                    {
                                        name: 'Ičići',
                                        href: '/yachtcharter/kroatien/istrien/icici'
                                    },
                                    {
                                        name: 'Rabac',
                                        href: '/yachtcharter/kroatien/istrien/rabac'
                                    },
                                    {
                                        name: 'Medulin',
                                        href: '/yachtcharter/kroatien/istrien/medulin'
                                    },
                                    {
                                        name: 'Rovinj',
                                        href: '/yachtcharter/kroatien/istrien/rovinj'
                                    },
                                    {
                                        name: 'Vrsar',
                                        href: '/yachtcharter/kroatien/istrien/vrsar'
                                    },
                                    {
                                        name: 'Vinkuran',
                                        href: '/yachtcharter/kroatien/istrien/vinkuran'
                                    },
                                    {
                                        name: 'Trget',
                                        href: '/yachtcharter/kroatien/istrien/trget'
                                    },
                                    {
                                        name: 'Marina Tehnomont Veruda, Pula',
                                        href: '/yachtcharter/kroatien/istrien/marina-tehnomont-veruda-pula'
                                    }, 
                                ]
                            },
                            {
                                name: 'Kvarner Bucht',
                                href: '/yachtcharter/kroatien/kvarner-bucht',
                                subList: [
                                    {
                                        name: 'Punat',
                                        href: '/yachtcharter/kroatien/kvarner-bucht/punat'
                                    },
                                    {
                                        name: 'Rijeka',
                                        href: '/yachtcharter/kroatien/kvarner-bucht/rijeka'
                                    },
                                    {
                                        name: 'Mali Lošinj',
                                        href: '/yachtcharter/kroatien/kvarner-bucht/mali-losinj'
                                    },
                                    {
                                        name: 'Novi Vinodolski',
                                        href: '/yachtcharter/kroatien/kvarner-bucht/novi-vinodolski'
                                    },
                                    {
                                        name: 'Kraljevica',
                                        href: '/yachtcharter/kroatien/kvarner-bucht/kraljevica'
                                    },
                                    {
                                        name: 'Crikvenica',
                                        href: '/yachtcharter/kroatien/kvarner-bucht/crikvenica'
                                    },
                                    {
                                        name: 'Rab',
                                        href: '/yachtcharter/kroatien/kvarner-bucht/rab'
                                    },
                                    {
                                        name: 'Malinska',
                                        href: '/yachtcharter/kroatien/kvarner-bucht/malinska'
                                    }, 
                                ]
                            },
                            {
                                name: 'S\xfcddalmatien',
                                href: '/yachtcharter/kroatien/sueddalmatien',
                                subList: [
                                    {
                                        name: 'Slano',
                                        href: '/yachtcharter/kroatien/sueddalmatien/slano'
                                    },
                                    {
                                        name: 'Komolac',
                                        href: '/yachtcharter/kroatien/sueddalmatien/komolac'
                                    },
                                    {
                                        name: 'Zaton',
                                        href: '/yachtcharter/kroatien/sueddalmatien/zaton'
                                    },
                                    {
                                        name: 'Dubrovnik',
                                        href: '/yachtcharter/kroatien/sueddalmatien/dubrovnik'
                                    },
                                    {
                                        name: 'Ploče',
                                        href: '/yachtcharter/kroatien/sueddalmatien/ploce'
                                    }, 
                                ]
                            },
                            {
                                name: 'Mitteldalmatien',
                                href: '/yachtcharter/kroatien/mitteldalmatien',
                                subList: [
                                    {
                                        name: 'Trogir',
                                        href: '/yachtcharter/kroatien/mitteldalmatien/trogir'
                                    },
                                    {
                                        name: 'Baška Voda',
                                        href: '/yachtcharter/kroatien/mitteldalmatien/baska-voda'
                                    },
                                    {
                                        name: 'Kaštel Gomilica',
                                        href: '/yachtcharter/kroatien/mitteldalmatien/kastel-gomilica'
                                    },
                                    {
                                        name: 'Split',
                                        href: '/yachtcharter/kroatien/mitteldalmatien/split'
                                    },
                                    {
                                        name: 'Seget Donji',
                                        href: '/yachtcharter/kroatien/mitteldalmatien/seget-donji'
                                    },
                                    {
                                        name: 'Podstrana',
                                        href: '/yachtcharter/kroatien/mitteldalmatien/podstrana'
                                    },
                                    {
                                        name: 'Tučepi',
                                        href: '/yachtcharter/kroatien/mitteldalmatien/tucepi'
                                    },
                                    {
                                        name: 'Šolta',
                                        href: '/yachtcharter/kroatien/mitteldalmatien/solta'
                                    },
                                    {
                                        name: 'Stobreč',
                                        href: '/yachtcharter/kroatien/mitteldalmatien/stobrec'
                                    },
                                    {
                                        name: 'Vinišće',
                                        href: '/yachtcharter/kroatien/mitteldalmatien/vinisce'
                                    },
                                    {
                                        name: 'Rogač',
                                        href: '/yachtcharter/kroatien/mitteldalmatien/rogac'
                                    },
                                    {
                                        name: 'Milna',
                                        href: '/yachtcharter/kroatien/mitteldalmatien/milna'
                                    },
                                    {
                                        name: 'Kaštel Lukšić',
                                        href: '/yachtcharter/kroatien/mitteldalmatien/kastel-luksic'
                                    }, 
                                ]
                            },
                            {
                                name: 'Norddalmatien',
                                href: '/yachtcharter/kroatien/norddalmatien',
                                subList: [
                                    {
                                        name: 'Rogoznica',
                                        href: '/yachtcharter/kroatien/norddalmatien/rogoznica'
                                    },
                                    {
                                        name: 'Šibenik',
                                        href: '/yachtcharter/kroatien/norddalmatien/sibenik'
                                    },
                                    {
                                        name: 'Primošten',
                                        href: '/yachtcharter/kroatien/norddalmatien/primosten'
                                    },
                                    {
                                        name: 'Jezera',
                                        href: '/yachtcharter/kroatien/norddalmatien/jezera'
                                    },
                                    {
                                        name: 'Betina',
                                        href: '/yachtcharter/kroatien/norddalmatien/betina'
                                    },
                                    {
                                        name: 'Bibinje',
                                        href: '/yachtcharter/kroatien/norddalmatien/bibinje'
                                    },
                                    {
                                        name: 'Murter',
                                        href: '/yachtcharter/kroatien/norddalmatien/murter'
                                    },
                                    {
                                        name: 'Pirovac',
                                        href: '/yachtcharter/kroatien/norddalmatien/pirovac'
                                    },
                                    {
                                        name: 'Zadar',
                                        href: '/yachtcharter/kroatien/norddalmatien/zadar'
                                    },
                                    {
                                        name: 'Tribunj',
                                        href: '/yachtcharter/kroatien/norddalmatien/tribunj'
                                    },
                                    {
                                        name: 'Petrčane',
                                        href: '/yachtcharter/kroatien/norddalmatien/petrcane'
                                    },
                                    {
                                        name: 'Sukošan',
                                        href: '/yachtcharter/kroatien/norddalmatien/sukosan'
                                    },
                                    {
                                        name: 'Kukljica',
                                        href: '/yachtcharter/kroatien/norddalmatien/kukljica'
                                    },
                                    {
                                        name: 'Vodice',
                                        href: '/yachtcharter/kroatien/norddalmatien/vodice'
                                    },
                                    {
                                        name: 'Biograd',
                                        href: '/yachtcharter/kroatien/norddalmatien/biograd'
                                    },
                                    {
                                        name: 'Skradin',
                                        href: '/yachtcharter/kroatien/norddalmatien/skradin'
                                    },
                                    {
                                        name: 'Drage',
                                        href: '/yachtcharter/kroatien/norddalmatien/drage'
                                    },
                                    {
                                        name: 'Biograd na Moru',
                                        href: '/yachtcharter/kroatien/norddalmatien/biograd-na-moru'
                                    }, 
                                ]
                            },
                            {
                                name: 'Dalmatien',
                                href: '/yachtcharter/kroatien/dalmatien',
                                subList: [
                                    {
                                        name: 'Rogoznica',
                                        href: '/yachtcharter/kroatien/dalmatien/rogoznica'
                                    },
                                    {
                                        name: 'Šibenik',
                                        href: '/yachtcharter/kroatien/dalmatien/sibenik'
                                    },
                                    {
                                        name: 'Primošten',
                                        href: '/yachtcharter/kroatien/dalmatien/primosten'
                                    },
                                    {
                                        name: 'Trogir',
                                        href: '/yachtcharter/kroatien/dalmatien/trogir'
                                    },
                                    {
                                        name: 'Slano',
                                        href: '/yachtcharter/kroatien/dalmatien/slano'
                                    },
                                    {
                                        name: 'Komolac',
                                        href: '/yachtcharter/kroatien/dalmatien/komolac'
                                    },
                                    {
                                        name: 'Baška Voda',
                                        href: '/yachtcharter/kroatien/dalmatien/baska-voda'
                                    },
                                    {
                                        name: 'Kaštel Gomilica',
                                        href: '/yachtcharter/kroatien/dalmatien/kastel-gomilica'
                                    },
                                    {
                                        name: 'Split',
                                        href: '/yachtcharter/kroatien/dalmatien/split'
                                    },
                                    {
                                        name: 'Jezera',
                                        href: '/yachtcharter/kroatien/dalmatien/jezera'
                                    },
                                    {
                                        name: 'Betina',
                                        href: '/yachtcharter/kroatien/dalmatien/betina'
                                    },
                                    {
                                        name: 'Bibinje',
                                        href: '/yachtcharter/kroatien/dalmatien/bibinje'
                                    },
                                    {
                                        name: 'Murter',
                                        href: '/yachtcharter/kroatien/dalmatien/murter'
                                    },
                                    {
                                        name: 'Biograd',
                                        href: '/yachtcharter/kroatien/dalmatien/biograd'
                                    },
                                    {
                                        name: 'Pirovac',
                                        href: '/yachtcharter/kroatien/dalmatien/pirovac'
                                    },
                                    {
                                        name: 'Zadar',
                                        href: '/yachtcharter/kroatien/dalmatien/zadar'
                                    },
                                    {
                                        name: 'Seget Donji',
                                        href: '/yachtcharter/kroatien/dalmatien/seget-donji'
                                    },
                                    {
                                        name: 'Podstrana',
                                        href: '/yachtcharter/kroatien/dalmatien/podstrana'
                                    },
                                    {
                                        name: 'Tribunj',
                                        href: '/yachtcharter/kroatien/dalmatien/tribunj'
                                    },
                                    {
                                        name: 'Petrčane',
                                        href: '/yachtcharter/kroatien/dalmatien/petrcane'
                                    },
                                    {
                                        name: 'Tučepi',
                                        href: '/yachtcharter/kroatien/dalmatien/tucepi'
                                    },
                                    {
                                        name: 'Šolta',
                                        href: '/yachtcharter/kroatien/dalmatien/solta'
                                    },
                                    {
                                        name: 'Zaton',
                                        href: '/yachtcharter/kroatien/dalmatien/zaton'
                                    },
                                    {
                                        name: 'Sukošan',
                                        href: '/yachtcharter/kroatien/dalmatien/sukosan'
                                    },
                                    {
                                        name: 'Dubrovnik',
                                        href: '/yachtcharter/kroatien/dalmatien/dubrovnik'
                                    },
                                    {
                                        name: 'Stobreč',
                                        href: '/yachtcharter/kroatien/dalmatien/stobrec'
                                    },
                                    {
                                        name: 'Kukljica',
                                        href: '/yachtcharter/kroatien/dalmatien/kukljica'
                                    },
                                    {
                                        name: 'Vinišće',
                                        href: '/yachtcharter/kroatien/dalmatien/vinisce'
                                    },
                                    {
                                        name: 'Zaton',
                                        href: '/yachtcharter/kroatien/dalmatien/zaton'
                                    },
                                    {
                                        name: 'Vodice',
                                        href: '/yachtcharter/kroatien/dalmatien/vodice'
                                    },
                                    {
                                        name: 'Biograd',
                                        href: '/yachtcharter/kroatien/dalmatien/biograd'
                                    },
                                    {
                                        name: 'Skradin',
                                        href: '/yachtcharter/kroatien/dalmatien/skradin'
                                    },
                                    {
                                        name: 'Ploče',
                                        href: '/yachtcharter/kroatien/dalmatien/ploce'
                                    },
                                    {
                                        name: 'Rogač',
                                        href: '/yachtcharter/kroatien/dalmatien/rogac'
                                    },
                                    {
                                        name: 'Milna',
                                        href: '/yachtcharter/kroatien/dalmatien/milna'
                                    },
                                    {
                                        name: 'Trogir',
                                        href: '/yachtcharter/kroatien/dalmatien/trogir'
                                    },
                                    {
                                        name: 'Šibenik',
                                        href: '/yachtcharter/kroatien/dalmatien/sibenik'
                                    },
                                    {
                                        name: 'Rab',
                                        href: '/yachtcharter/kroatien/dalmatien/rab'
                                    },
                                    {
                                        name: 'Zaton',
                                        href: '/yachtcharter/kroatien/dalmatien/zaton'
                                    },
                                    {
                                        name: 'Drage',
                                        href: '/yachtcharter/kroatien/dalmatien/drage'
                                    },
                                    {
                                        name: 'Kaštel Lukšić',
                                        href: '/yachtcharter/kroatien/dalmatien/kastel-luksic'
                                    },
                                    {
                                        name: 'Biograd na Moru',
                                        href: '/yachtcharter/kroatien/dalmatien/biograd-na-moru'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Griechenland',
                icon: gr,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Griechenland',
                        href: '/yachtcharter/griechenland',
                        list: [
                            {
                                name: 'Ost Makedonien',
                                href: '/yachtcharter/griechenland/ost-makedonien',
                                subList: [
                                    {
                                        name: 'Kavala',
                                        href: '/yachtcharter/griechenland/ost-makedonien/kavala'
                                    },
                                    {
                                        name: 'Keramoti',
                                        href: '/yachtcharter/griechenland/ost-makedonien/keramoti'
                                    },
                                    {
                                        name: 'Thasos',
                                        href: '/yachtcharter/griechenland/ost-makedonien/thasos'
                                    },
                                    {
                                        name: 'Limenas Thassos',
                                        href: '/yachtcharter/griechenland/ost-makedonien/limenas-thassos'
                                    },
                                    {
                                        name: 'Limenas Avdiron',
                                        href: '/yachtcharter/griechenland/ost-makedonien/limenas-avdiron'
                                    }, 
                                ]
                            },
                            {
                                name: 'Makedonien',
                                href: '/yachtcharter/griechenland/makedonien',
                                subList: [
                                    {
                                        name: 'Neos Marmaras',
                                        href: '/yachtcharter/griechenland/makedonien/neos-marmaras'
                                    },
                                    {
                                        name: 'Thessaloniki',
                                        href: '/yachtcharter/griechenland/makedonien/thessaloniki'
                                    },
                                    {
                                        name: 'Ormos Panagias',
                                        href: '/yachtcharter/griechenland/makedonien/ormos-panagias'
                                    },
                                    {
                                        name: 'Nikiti',
                                        href: '/yachtcharter/griechenland/makedonien/nikiti'
                                    },
                                    {
                                        name: 'Halkidiki',
                                        href: '/yachtcharter/griechenland/makedonien/halkidiki'
                                    }, 
                                ]
                            },
                            {
                                name: 'Thessalien',
                                href: '/yachtcharter/griechenland/thessalien',
                                subList: [
                                    {
                                        name: 'Skiathos',
                                        href: '/yachtcharter/griechenland/thessalien/skiathos'
                                    },
                                    {
                                        name: 'Volos',
                                        href: '/yachtcharter/griechenland/thessalien/volos'
                                    },
                                    {
                                        name: 'Skopelos',
                                        href: '/yachtcharter/griechenland/thessalien/skopelos'
                                    },
                                    {
                                        name: 'Achillio',
                                        href: '/yachtcharter/griechenland/thessalien/achillio'
                                    }, 
                                ]
                            },
                            {
                                name: 'Ionische Inseln',
                                href: '/yachtcharter/griechenland/ionische-inseln',
                                subList: [
                                    {
                                        name: 'Lefkada',
                                        href: '/yachtcharter/griechenland/ionische-inseln/lefkada'
                                    },
                                    {
                                        name: 'Sami',
                                        href: '/yachtcharter/griechenland/ionische-inseln/sami'
                                    },
                                    {
                                        name: 'Agia Eufimia',
                                        href: '/yachtcharter/griechenland/ionische-inseln/agia-eufimia'
                                    },
                                    {
                                        name: 'Zakynthos',
                                        href: '/yachtcharter/griechenland/ionische-inseln/zakynthos'
                                    },
                                    {
                                        name: 'Kerkira',
                                        href: '/yachtcharter/griechenland/ionische-inseln/kerkira'
                                    },
                                    {
                                        name: 'Sivota',
                                        href: '/yachtcharter/griechenland/ionische-inseln/sivota'
                                    },
                                    {
                                        name: 'Corfu',
                                        href: '/yachtcharter/griechenland/ionische-inseln/corfu'
                                    },
                                    {
                                        name: 'Kontokali',
                                        href: '/yachtcharter/griechenland/ionische-inseln/kontokali'
                                    },
                                    {
                                        name: 'Nikiana',
                                        href: '/yachtcharter/griechenland/ionische-inseln/nikiana'
                                    },
                                    {
                                        name: 'Nidri',
                                        href: '/yachtcharter/griechenland/ionische-inseln/nidri'
                                    },
                                    {
                                        name: 'Kefalonia',
                                        href: '/yachtcharter/griechenland/ionische-inseln/kefalonia'
                                    },
                                    {
                                        name: 'Gouvia',
                                        href: '/yachtcharter/griechenland/ionische-inseln/gouvia'
                                    },
                                    {
                                        name: 'Vlicho',
                                        href: '/yachtcharter/griechenland/ionische-inseln/vlicho'
                                    },
                                    {
                                        name: 'Corfu, Mandraki',
                                        href: '/yachtcharter/griechenland/ionische-inseln/corfu-mandraki'
                                    },
                                    {
                                        name: 'Benitses, Corfu',
                                        href: '/yachtcharter/griechenland/ionische-inseln/benitses-corfu'
                                    }, 
                                ]
                            },
                            {
                                name: 'West Griechenland',
                                href: '/yachtcharter/griechenland/west-griechenland',
                                subList: [
                                    {
                                        name: 'Paleros',
                                        href: '/yachtcharter/griechenland/west-griechenland/paleros'
                                    },
                                    {
                                        name: 'Palairos',
                                        href: '/yachtcharter/griechenland/west-griechenland/palairos'
                                    },
                                    {
                                        name: 'Patra ',
                                        href: '/yachtcharter/griechenland/west-griechenland/patra'
                                    }, 
                                ]
                            },
                            {
                                name: 'Peloponnese',
                                href: '/yachtcharter/griechenland/peloponnese',
                                subList: [
                                    {
                                        name: 'Kalamata',
                                        href: '/yachtcharter/griechenland/peloponnese/kalamata'
                                    },
                                    {
                                        name: 'Ermioni',
                                        href: '/yachtcharter/griechenland/peloponnese/ermioni'
                                    }, 
                                ]
                            },
                            {
                                name: 'Athen',
                                href: '/yachtcharter/griechenland/athen',
                                subList: [
                                    {
                                        name: 'Alimos',
                                        href: '/yachtcharter/griechenland/athen/alimos'
                                    },
                                    {
                                        name: 'Lavrio',
                                        href: '/yachtcharter/griechenland/athen/lavrio'
                                    },
                                    {
                                        name: 'Elliniko',
                                        href: '/yachtcharter/griechenland/athen/elliniko'
                                    },
                                    {
                                        name: 'Piraeus',
                                        href: '/yachtcharter/griechenland/athen/piraeus'
                                    },
                                    {
                                        name: 'Athen',
                                        href: '/yachtcharter/griechenland/athen/athen'
                                    },
                                    {
                                        name: 'Palaio Faliro',
                                        href: '/yachtcharter/griechenland/athen/palaio-faliro'
                                    },
                                    {
                                        name: 'Pireas',
                                        href: '/yachtcharter/griechenland/athen/pireas'
                                    },
                                    {
                                        name: 'Glifada',
                                        href: '/yachtcharter/griechenland/athen/glifada'
                                    },
                                    {
                                        name: 'Nea Peramos - Attica',
                                        href: '/yachtcharter/griechenland/athen/nea-peramos-attica'
                                    },
                                    {
                                        name: 'Athens',
                                        href: '/yachtcharter/griechenland/athen/athens'
                                    },
                                    {
                                        name: 'Aegina',
                                        href: '/yachtcharter/griechenland/athen/aegina'
                                    },
                                    {
                                        name: 'Kallithea',
                                        href: '/yachtcharter/griechenland/athen/kallithea'
                                    },
                                    {
                                        name: 'Elefsina',
                                        href: '/yachtcharter/griechenland/athen/elefsina'
                                    },
                                    {
                                        name: 'Salamina',
                                        href: '/yachtcharter/griechenland/athen/salamina'
                                    },
                                    {
                                        name: 'Nea Peramos',
                                        href: '/yachtcharter/griechenland/athen/nea-peramos'
                                    },
                                    {
                                        name: 'Egina',
                                        href: '/yachtcharter/griechenland/athen/egina'
                                    },
                                    {
                                        name: 'Yacht Club Marina Salamina, Athens area',
                                        href: '/yachtcharter/griechenland/athen/yacht-club-marina-salamina-athens-area'
                                    }, 
                                ]
                            },
                            {
                                name: 'Kreta',
                                href: '/yachtcharter/griechenland/kreta',
                                subList: [
                                    {
                                        name: 'Heraklion',
                                        href: '/yachtcharter/griechenland/kreta/heraklion'
                                    }, 
                                ]
                            },
                            {
                                name: 'South Aegean',
                                href: '/yachtcharter/griechenland/south-aegean',
                                subList: [
                                    {
                                        name: 'Kos',
                                        href: '/yachtcharter/griechenland/south-aegean/kos'
                                    },
                                    {
                                        name: 'Tourlos',
                                        href: '/yachtcharter/griechenland/south-aegean/tourlos'
                                    },
                                    {
                                        name: 'Ermoupoli',
                                        href: '/yachtcharter/griechenland/south-aegean/ermoupoli'
                                    },
                                    {
                                        name: 'Syros',
                                        href: '/yachtcharter/griechenland/south-aegean/syros'
                                    },
                                    {
                                        name: 'Heraklion',
                                        href: '/yachtcharter/griechenland/south-aegean/heraklion'
                                    },
                                    {
                                        name: 'Paros',
                                        href: '/yachtcharter/griechenland/south-aegean/paros'
                                    },
                                    {
                                        name: 'Santorini',
                                        href: '/yachtcharter/griechenland/south-aegean/santorini'
                                    },
                                    {
                                        name: 'Mykonos',
                                        href: '/yachtcharter/griechenland/south-aegean/mykonos'
                                    },
                                    {
                                        name: 'Mikonos',
                                        href: '/yachtcharter/griechenland/south-aegean/mikonos'
                                    },
                                    {
                                        name: 'Piso Livadi',
                                        href: '/yachtcharter/griechenland/south-aegean/piso-livadi'
                                    },
                                    {
                                        name: 'Rhodos',
                                        href: '/yachtcharter/griechenland/south-aegean/rhodos'
                                    },
                                    {
                                        name: 'Ialisos',
                                        href: '/yachtcharter/griechenland/south-aegean/ialisos'
                                    },
                                    {
                                        name: 'Naoussa',
                                        href: '/yachtcharter/griechenland/south-aegean/naoussa'
                                    }, 
                                ]
                            },
                            {
                                name: 'Kykladen',
                                href: '/yachtcharter/griechenland/kykladen',
                                subList: [
                                    {
                                        name: 'Tourlos',
                                        href: '/yachtcharter/griechenland/kykladen/tourlos'
                                    },
                                    {
                                        name: 'Ermoupoli',
                                        href: '/yachtcharter/griechenland/kykladen/ermoupoli'
                                    },
                                    {
                                        name: 'Syros',
                                        href: '/yachtcharter/griechenland/kykladen/syros'
                                    },
                                    {
                                        name: 'Paros',
                                        href: '/yachtcharter/griechenland/kykladen/paros'
                                    },
                                    {
                                        name: 'Santorini',
                                        href: '/yachtcharter/griechenland/kykladen/santorini'
                                    },
                                    {
                                        name: 'Mykonos',
                                        href: '/yachtcharter/griechenland/kykladen/mykonos'
                                    },
                                    {
                                        name: 'Mikonos',
                                        href: '/yachtcharter/griechenland/kykladen/mikonos'
                                    },
                                    {
                                        name: 'Piso Livadi',
                                        href: '/yachtcharter/griechenland/kykladen/piso-livadi'
                                    },
                                    {
                                        name: 'Naoussa',
                                        href: '/yachtcharter/griechenland/kykladen/naoussa'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Italien',
                icon: it,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Italien',
                        href: '/yachtcharter/italien',
                        list: [
                            {
                                name: 'Venedig / Venezien',
                                href: '/yachtcharter/italien/venedig-venezien',
                                subList: [
                                    {
                                        name: 'Chioggia',
                                        href: '/yachtcharter/italien/venedig-venezien/chioggia'
                                    },
                                    {
                                        name: 'Navene di Malcesine',
                                        href: '/yachtcharter/italien/venedig-venezien/navene-di-malcesine'
                                    },
                                    {
                                        name: 'Caorle ',
                                        href: '/yachtcharter/italien/venedig-venezien/caorle'
                                    },
                                    {
                                        name: 'Lignano Sabbiadoro',
                                        href: '/yachtcharter/italien/venedig-venezien/lignano-sabbiadoro'
                                    },
                                    {
                                        name: 'Marano',
                                        href: '/yachtcharter/italien/venedig-venezien/marano'
                                    },
                                    {
                                        name: 'Casale sul Sile',
                                        href: '/yachtcharter/italien/venedig-venezien/casale-sul-sile'
                                    },
                                    {
                                        name: 'Precenicco',
                                        href: '/yachtcharter/italien/venedig-venezien/precenicco'
                                    },
                                    {
                                        name: 'Lughignano',
                                        href: '/yachtcharter/italien/venedig-venezien/lughignano'
                                    },
                                    {
                                        name: 'Precenicco',
                                        href: '/yachtcharter/italien/venedig-venezien/precenicco'
                                    }, 
                                ]
                            },
                            {
                                name: 'Sardinien',
                                href: '/yachtcharter/italien/sardinien',
                                subList: [
                                    {
                                        name: 'Cagliari',
                                        href: '/yachtcharter/italien/sardinien/cagliari'
                                    },
                                    {
                                        name: 'La Maddalena',
                                        href: '/yachtcharter/italien/sardinien/la-maddalena'
                                    },
                                    {
                                        name: 'Olbia',
                                        href: '/yachtcharter/italien/sardinien/olbia'
                                    },
                                    {
                                        name: 'Genova',
                                        href: '/yachtcharter/italien/sardinien/genova'
                                    },
                                    {
                                        name: 'Golfo Aranci',
                                        href: '/yachtcharter/italien/sardinien/golfo-aranci'
                                    },
                                    {
                                        name: 'Santa Maria Navarrese',
                                        href: '/yachtcharter/italien/sardinien/santa-maria-navarrese'
                                    },
                                    {
                                        name: 'Porto Rotondo',
                                        href: '/yachtcharter/italien/sardinien/porto-rotondo'
                                    },
                                    {
                                        name: 'Portisco',
                                        href: '/yachtcharter/italien/sardinien/portisco'
                                    },
                                    {
                                        name: 'Carloforte',
                                        href: '/yachtcharter/italien/sardinien/carloforte'
                                    },
                                    {
                                        name: 'Cannigione',
                                        href: '/yachtcharter/italien/sardinien/cannigione'
                                    },
                                    {
                                        name: 'Alghero',
                                        href: '/yachtcharter/italien/sardinien/alghero'
                                    },
                                    {
                                        name: 'Arzachena',
                                        href: '/yachtcharter/italien/sardinien/arzachena'
                                    },
                                    {
                                        name: 'Aranci',
                                        href: '/yachtcharter/italien/sardinien/aranci'
                                    },
                                    {
                                        name: 'Cannigione Arzachena',
                                        href: '/yachtcharter/italien/sardinien/cannigione-arzachena'
                                    }, 
                                ]
                            },
                            {
                                name: 'Sizilien',
                                href: '/yachtcharter/italien/sizilien',
                                subList: [
                                    {
                                        name: 'Tonnarella',
                                        href: '/yachtcharter/italien/sizilien/tonnarella'
                                    },
                                    {
                                        name: 'Marsala',
                                        href: '/yachtcharter/italien/sizilien/marsala'
                                    },
                                    {
                                        name: 'Palermo',
                                        href: '/yachtcharter/italien/sizilien/palermo'
                                    },
                                    {
                                        name: 'Furnari',
                                        href: '/yachtcharter/italien/sizilien/furnari'
                                    },
                                    {
                                        name: 'Ragusa',
                                        href: '/yachtcharter/italien/sizilien/ragusa'
                                    },
                                    {
                                        name: 'Milazzo',
                                        href: '/yachtcharter/italien/sizilien/milazzo'
                                    },
                                    {
                                        name: 'S. Agata di Militello',
                                        href: '/yachtcharter/italien/sizilien/s-agata-di-militello'
                                    },
                                    {
                                        name: "Capo d'Orlando",
                                        href: '/yachtcharter/italien/sizilien/capo-dorlando'
                                    },
                                    {
                                        name: 'Trapani',
                                        href: '/yachtcharter/italien/sizilien/trapani'
                                    },
                                    {
                                        name: 'San Vito Lo Capo',
                                        href: '/yachtcharter/italien/sizilien/san-vito-lo-capo'
                                    },
                                    {
                                        name: 'Lipari',
                                        href: '/yachtcharter/italien/sizilien/lipari'
                                    },
                                    {
                                        name: 'Reggio Calabria',
                                        href: '/yachtcharter/italien/sizilien/reggio-calabria'
                                    },
                                    {
                                        name: 'Kalkara',
                                        href: '/yachtcharter/italien/sizilien/kalkara'
                                    },
                                    {
                                        name: 'San Gregorio-bagnoli',
                                        href: '/yachtcharter/italien/sizilien/san-gregorio-bagnoli'
                                    },
                                    {
                                        name: 'Castellammare del Golfo',
                                        href: '/yachtcharter/italien/sizilien/castellammare-del-golfo'
                                    },
                                    {
                                        name: 'Il-Kalkara',
                                        href: '/yachtcharter/italien/sizilien/il-kalkara'
                                    },
                                    {
                                        name: 'Balestrate',
                                        href: '/yachtcharter/italien/sizilien/balestrate'
                                    },
                                    {
                                        name: "Capo D'orlando Marina",
                                        href: '/yachtcharter/italien/sizilien/capo-dorlando-marina'
                                    },
                                    {
                                        name: 'Marina Villa Igea, Palermo',
                                        href: '/yachtcharter/italien/sizilien/marina-villa-igea-palermo'
                                    }, 
                                ]
                            },
                            {
                                name: 'Kalabrien',
                                href: '/yachtcharter/italien/kalabrien',
                                subList: [
                                    {
                                        name: 'Marina',
                                        href: '/yachtcharter/italien/kalabrien/marina'
                                    },
                                    {
                                        name: 'Tropea',
                                        href: '/yachtcharter/italien/kalabrien/tropea'
                                    },
                                    {
                                        name: 'Vibo Marina',
                                        href: '/yachtcharter/italien/kalabrien/vibo-marina'
                                    },
                                    {
                                        name: 'Reggio Calabria',
                                        href: '/yachtcharter/italien/kalabrien/reggio-calabria'
                                    }, 
                                ]
                            },
                            {
                                name: 'Apulien',
                                href: '/yachtcharter/italien/apulien',
                                subList: [
                                    {
                                        name: 'Bari',
                                        href: '/yachtcharter/italien/apulien/bari'
                                    },
                                    {
                                        name: 'Rodi',
                                        href: '/yachtcharter/italien/apulien/rodi'
                                    },
                                    {
                                        name: 'San Foca',
                                        href: '/yachtcharter/italien/apulien/san-foca'
                                    },
                                    {
                                        name: 'Leuca',
                                        href: '/yachtcharter/italien/apulien/leuca'
                                    },
                                    {
                                        name: 'Taranto',
                                        href: '/yachtcharter/italien/apulien/taranto'
                                    }, 
                                ]
                            },
                            {
                                name: 'Basilikata',
                                href: '/yachtcharter/italien/basilikata',
                                subList: [
                                    {
                                        name: 'Marina',
                                        href: '/yachtcharter/italien/basilikata/marina'
                                    }, 
                                ]
                            },
                            {
                                name: 'Kampanien',
                                href: '/yachtcharter/italien/kampanien',
                                subList: [
                                    {
                                        name: 'Mergellina',
                                        href: '/yachtcharter/italien/kampanien/mergellina'
                                    },
                                    {
                                        name: 'Pozzuoli',
                                        href: '/yachtcharter/italien/kampanien/pozzuoli'
                                    },
                                    {
                                        name: 'Procida',
                                        href: '/yachtcharter/italien/kampanien/procida'
                                    },
                                    {
                                        name: 'Castellammare di Stabia',
                                        href: '/yachtcharter/italien/kampanien/castellammare-di-stabia'
                                    },
                                    {
                                        name: 'Agropoli',
                                        href: '/yachtcharter/italien/kampanien/agropoli'
                                    },
                                    {
                                        name: 'Amalfi',
                                        href: '/yachtcharter/italien/kampanien/amalfi'
                                    },
                                    {
                                        name: 'Porto di Castellammare di Stabia',
                                        href: '/yachtcharter/italien/kampanien/porto-di-castellammare-di-stabia'
                                    },
                                    {
                                        name: 'Salerno',
                                        href: '/yachtcharter/italien/kampanien/salerno'
                                    },
                                    {
                                        name: 'Napoli',
                                        href: '/yachtcharter/italien/kampanien/napoli'
                                    },
                                    {
                                        name: 'Naples',
                                        href: '/yachtcharter/italien/kampanien/naples'
                                    },
                                    {
                                        name: 'Neapel',
                                        href: '/yachtcharter/italien/kampanien/neapel'
                                    }, 
                                ]
                            },
                            {
                                name: 'Abruzzen',
                                href: '/yachtcharter/italien/abruzzen',
                                subList: [
                                    {
                                        name: 'Marina di Montenero di Bisaccia',
                                        href: '/yachtcharter/italien/abruzzen/marina-di-montenero-di-bisaccia'
                                    },
                                    {
                                        name: 'San Benedetto del Tronto',
                                        href: '/yachtcharter/italien/abruzzen/san-benedetto-del-tronto'
                                    }, 
                                ]
                            },
                            {
                                name: 'Latium',
                                href: '/yachtcharter/italien/latium',
                                subList: [
                                    {
                                        name: 'Rome',
                                        href: '/yachtcharter/italien/latium/rome'
                                    },
                                    {
                                        name: 'Anzio',
                                        href: '/yachtcharter/italien/latium/anzio'
                                    },
                                    {
                                        name: 'Nettuno',
                                        href: '/yachtcharter/italien/latium/nettuno'
                                    }, 
                                ]
                            },
                            {
                                name: 'Marken',
                                href: '/yachtcharter/italien/marken',
                                subList: [
                                    {
                                        name: 'San Benedetto del Tronto',
                                        href: '/yachtcharter/italien/marken/san-benedetto-del-tronto'
                                    }, 
                                ]
                            },
                            {
                                name: 'Toskana',
                                href: '/yachtcharter/italien/toskana',
                                subList: [
                                    {
                                        name: 'Cecina',
                                        href: '/yachtcharter/italien/toskana/cecina'
                                    },
                                    {
                                        name: 'Puntone',
                                        href: '/yachtcharter/italien/toskana/puntone'
                                    },
                                    {
                                        name: 'San Vincenzo',
                                        href: '/yachtcharter/italien/toskana/san-vincenzo'
                                    },
                                    {
                                        name: 'La Spezia',
                                        href: '/yachtcharter/italien/toskana/la-spezia'
                                    },
                                    {
                                        name: 'Viareggio',
                                        href: '/yachtcharter/italien/toskana/viareggio'
                                    },
                                    {
                                        name: 'Punta Ala',
                                        href: '/yachtcharter/italien/toskana/punta-ala'
                                    },
                                    {
                                        name: 'Portoferraio',
                                        href: '/yachtcharter/italien/toskana/portoferraio'
                                    },
                                    {
                                        name: 'Portovenere',
                                        href: '/yachtcharter/italien/toskana/portovenere'
                                    },
                                    {
                                        name: 'Bocca di Magra',
                                        href: '/yachtcharter/italien/toskana/bocca-di-magra'
                                    },
                                    {
                                        name: 'Castiglioncello',
                                        href: '/yachtcharter/italien/toskana/castiglioncello'
                                    },
                                    {
                                        name: 'Rosignano Solvay',
                                        href: '/yachtcharter/italien/toskana/rosignano-solvay'
                                    },
                                    {
                                        name: 'Salivoli',
                                        href: '/yachtcharter/italien/toskana/salivoli'
                                    },
                                    {
                                        name: 'Marina di Scarlino - Follonica',
                                        href: '/yachtcharter/italien/toskana/marina-di-scarlino-follonica'
                                    },
                                    {
                                        name: 'Rosignano Solvay-Castiglioncello',
                                        href: '/yachtcharter/italien/toskana/rosignano-solvay-castiglioncello'
                                    }, 
                                ]
                            },
                            {
                                name: 'Emilia Romana',
                                href: '/yachtcharter/italien/emilia-romana',
                                subList: [
                                    {
                                        name: 'Ravenna',
                                        href: '/yachtcharter/italien/emilia-romana/ravenna'
                                    }, 
                                ]
                            },
                            {
                                name: 'Ligurien',
                                href: '/yachtcharter/italien/ligurien',
                                subList: [
                                    {
                                        name: 'La Spezia',
                                        href: '/yachtcharter/italien/ligurien/la-spezia'
                                    },
                                    {
                                        name: 'Portovenere',
                                        href: '/yachtcharter/italien/ligurien/portovenere'
                                    },
                                    {
                                        name: 'Bocca di Magra',
                                        href: '/yachtcharter/italien/ligurien/bocca-di-magra'
                                    }, 
                                ]
                            },
                            {
                                name: 'Friaul-Julisch Venetien',
                                href: '/yachtcharter/italien/friaul-julisch-venetien',
                                subList: [
                                    {
                                        name: 'Izola',
                                        href: '/yachtcharter/italien/friaul-julisch-venetien/izola'
                                    },
                                    {
                                        name: 'Muggia',
                                        href: '/yachtcharter/italien/friaul-julisch-venetien/muggia'
                                    },
                                    {
                                        name: 'Lignano Sabbiadoro',
                                        href: '/yachtcharter/italien/friaul-julisch-venetien/lignano-sabbiadoro'
                                    },
                                    {
                                        name: 'Marano',
                                        href: '/yachtcharter/italien/friaul-julisch-venetien/marano'
                                    },
                                    {
                                        name: 'Marina Portorož',
                                        href: '/yachtcharter/italien/friaul-julisch-venetien/marina-portoroz'
                                    },
                                    {
                                        name: 'Precenicco',
                                        href: '/yachtcharter/italien/friaul-julisch-venetien/precenicco'
                                    },
                                    {
                                        name: 'Precenicco',
                                        href: '/yachtcharter/italien/friaul-julisch-venetien/precenicco'
                                    }, 
                                ]
                            },
                            {
                                name: 'Elba',
                                href: '/yachtcharter/italien/elba',
                                subList: [
                                    {
                                        name: 'Portoferraio',
                                        href: '/yachtcharter/italien/elba/portoferraio'
                                    }, 
                                ]
                            },
                            {
                                name: 'Neapel',
                                href: '/yachtcharter/italien/neapel',
                                subList: [
                                    {
                                        name: 'Mergellina',
                                        href: '/yachtcharter/italien/neapel/mergellina'
                                    },
                                    {
                                        name: 'Pozzuoli',
                                        href: '/yachtcharter/italien/neapel/pozzuoli'
                                    },
                                    {
                                        name: 'Procida',
                                        href: '/yachtcharter/italien/neapel/procida'
                                    },
                                    {
                                        name: 'Napoli',
                                        href: '/yachtcharter/italien/neapel/napoli'
                                    },
                                    {
                                        name: 'Naples',
                                        href: '/yachtcharter/italien/neapel/naples'
                                    },
                                    {
                                        name: 'Neapel',
                                        href: '/yachtcharter/italien/neapel/neapel'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Karibik',
                icon: us,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Karibik',
                        href: '/yachtcharter/karibik',
                        list: [
                            {
                                name: 'Britische Jungferninseln',
                                href: '/yachtcharter/karibik/britische-jungferninseln',
                                subList: [
                                    {
                                        name: 'Road Town',
                                        href: '/yachtcharter/karibik/britische-jungferninseln/road-town'
                                    },
                                    {
                                        name: 'Nanny Cay',
                                        href: '/yachtcharter/karibik/britische-jungferninseln/nanny-cay'
                                    },
                                    {
                                        name: 'St. Thomas',
                                        href: '/yachtcharter/karibik/britische-jungferninseln/st-thomas'
                                    },
                                    {
                                        name: 'Red Hook',
                                        href: '/yachtcharter/karibik/britische-jungferninseln/red-hook'
                                    },
                                    {
                                        name: 'Tortola',
                                        href: '/yachtcharter/karibik/britische-jungferninseln/tortola'
                                    },
                                    {
                                        name: 'Tortola West End',
                                        href: '/yachtcharter/karibik/britische-jungferninseln/tortola-west-end'
                                    },
                                    {
                                        name: 'St. Thomas',
                                        href: '/yachtcharter/karibik/britische-jungferninseln/st-thomas'
                                    },
                                    {
                                        name: 'BVI, Scrub Island Marina',
                                        href: '/yachtcharter/karibik/britische-jungferninseln/bvi-scrub-island-marina'
                                    },
                                    {
                                        name: 'St. Thomas',
                                        href: '/yachtcharter/karibik/britische-jungferninseln/st-thomas'
                                    },
                                    {
                                        name: 'Bimini Marina, St Thomas, USVI',
                                        href: '/yachtcharter/karibik/britische-jungferninseln/bimini-marina-st-thomas-usvi'
                                    },
                                    {
                                        name: 'St. Thomas',
                                        href: '/yachtcharter/karibik/britische-jungferninseln/st-thomas'
                                    }, 
                                ]
                            },
                            {
                                name: 'Grenada',
                                href: '/yachtcharter/karibik/grenada',
                                subList: [
                                    {
                                        name: 'Grenada / St. George',
                                        href: '/yachtcharter/karibik/grenada/grenada-st-george'
                                    },
                                    {
                                        name: "Saint George's",
                                        href: '/yachtcharter/karibik/grenada/saint-georges'
                                    },
                                    {
                                        name: "St George's",
                                        href: '/yachtcharter/karibik/grenada/st-georges'
                                    }, 
                                ]
                            },
                            {
                                name: 'Guadeloupe',
                                href: '/yachtcharter/karibik/guadeloupe',
                                subList: [
                                    {
                                        name: 'Pointe a Pitre',
                                        href: '/yachtcharter/karibik/guadeloupe/pointe-a-pitre'
                                    },
                                    {
                                        name: 'Guadeloupe',
                                        href: '/yachtcharter/karibik/guadeloupe/guadeloupe'
                                    },
                                    {
                                        name: 'Pointe-\xe0-Pitre',
                                        href: '/yachtcharter/karibik/guadeloupe/pointe-a-pitre'
                                    }, 
                                ]
                            },
                            {
                                name: 'Tortola',
                                href: '/yachtcharter/karibik/tortola',
                                subList: [
                                    {
                                        name: 'Road Town',
                                        href: '/yachtcharter/karibik/tortola/road-town'
                                    },
                                    {
                                        name: 'Nanny Cay',
                                        href: '/yachtcharter/karibik/tortola/nanny-cay'
                                    },
                                    {
                                        name: 'Tortola',
                                        href: '/yachtcharter/karibik/tortola/tortola'
                                    },
                                    {
                                        name: 'Tortola West End',
                                        href: '/yachtcharter/karibik/tortola/tortola-west-end'
                                    }, 
                                ]
                            },
                            {
                                name: 'Kuba',
                                href: '/yachtcharter/karibik/kuba',
                                subList: [
                                    {
                                        name: 'Cienfuegos',
                                        href: '/yachtcharter/karibik/kuba/cienfuegos'
                                    }, 
                                ]
                            },
                            {
                                name: 'Martinique',
                                href: '/yachtcharter/karibik/martinique',
                                subList: [
                                    {
                                        name: 'Le Marin',
                                        href: '/yachtcharter/karibik/martinique/le-marin'
                                    }, 
                                ]
                            },
                            // {
                            //  name: 'St. Lucia',
                            //  href: '/yachtcharter/karibik/st-lucia',
                            //  subList: [
                            //    {
                            //      name: 'St. Lucia',
                            //      href: '/yachtcharter/karibik/st-lucia/st-lucia',
                            //    },
                            //  ],
                            // },
                            {
                                name: 'Antigua',
                                href: '/yachtcharter/karibik/antigua',
                                subList: [
                                    {
                                        name: 'Antigua',
                                        href: '/yachtcharter/karibik/antigua/antigua'
                                    },
                                    {
                                        name: 'Jolly Harbour',
                                        href: '/yachtcharter/karibik/antigua/jolly-harbour'
                                    },
                                    {
                                        name: 'Antigua, Jolly Harbour Marina',
                                        href: '/yachtcharter/karibik/antigua/antigua-jolly-harbour-marina'
                                    }, 
                                ]
                            },
                            {
                                name: 'St. Martin',
                                href: '/yachtcharter/karibik/st-martin',
                                subList: [
                                    {
                                        name: 'Marigot',
                                        href: '/yachtcharter/karibik/st-martin/marigot'
                                    },
                                    {
                                        name: 'Saint Martin',
                                        href: '/yachtcharter/karibik/st-martin/saint-martin'
                                    },
                                    {
                                        name: 'Sint Maarten',
                                        href: '/yachtcharter/karibik/st-martin/sint-maarten'
                                    },
                                    {
                                        name: 'Saint Martin',
                                        href: '/yachtcharter/karibik/st-martin/saint-martin'
                                    },
                                    {
                                        name: 'Philipsburg',
                                        href: '/yachtcharter/karibik/st-martin/philipsburg'
                                    }, 
                                ]
                            },
                            // {
                            //  name: 'St. Vincent und die Grenadinen',
                            //  href: '/yachtcharter/karibik/st-vincent-und-die-grenadinen',
                            //  subList: [
                            //    {
                            //      name: 'Kingstown',
                            //      href: '/yachtcharter/karibik/st-vincent-und-die-grenadinen/kingstown',
                            //    },
                            //    {
                            //      name: 'St Vincent',
                            //      href: '/yachtcharter/karibik/st-vincent-und-die-grenadinen/st-vincent',
                            //   },
                            //  ],
                            // },
                            {
                                name: 'Bahamas',
                                href: '/yachtcharter/karibik/bahamas',
                                subList: [
                                    {
                                        name: 'Nassau',
                                        href: '/yachtcharter/karibik/bahamas/nassau'
                                    },
                                    {
                                        name: 'Marsh Harbour',
                                        href: '/yachtcharter/karibik/bahamas/marsh-harbour'
                                    },
                                    {
                                        name: 'George Town',
                                        href: '/yachtcharter/karibik/bahamas/george-town'
                                    },
                                    {
                                        name: 'Nassau, Palm Cay Marina',
                                        href: '/yachtcharter/karibik/bahamas/nassau-palm-cay-marina'
                                    },
                                    {
                                        name: 'Staniel Cay',
                                        href: '/yachtcharter/karibik/bahamas/staniel-cay'
                                    },
                                    {
                                        name: 'Spanish Wells',
                                        href: '/yachtcharter/karibik/bahamas/spanish-wells'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Deutschland',
                icon: flags_de,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Deutschland',
                        href: '/yachtcharter/deutschland',
                        list: [
                            {
                                name: 'Ostsee und Peene',
                                href: '/yachtcharter/deutschland/ostsee-und-peene',
                                subList: [
                                    {
                                        name: 'Barth',
                                        href: '/yachtcharter/deutschland/ostsee-und-peene/barth'
                                    },
                                    {
                                        name: 'Neukalen',
                                        href: '/yachtcharter/deutschland/ostsee-und-peene/neukalen'
                                    },
                                    {
                                        name: 'Kr\xf6slin',
                                        href: '/yachtcharter/deutschland/ostsee-und-peene/kroeslin'
                                    },
                                    {
                                        name: 'L\xfcbeck',
                                        href: '/yachtcharter/deutschland/ostsee-und-peene/luebeck'
                                    },
                                    {
                                        name: 'Putbus',
                                        href: '/yachtcharter/deutschland/ostsee-und-peene/putbus'
                                    },
                                    {
                                        name: 'Kiel',
                                        href: '/yachtcharter/deutschland/ostsee-und-peene/kiel'
                                    },
                                    {
                                        name: 'Altef\xe4hr',
                                        href: '/yachtcharter/deutschland/ostsee-und-peene/altefaehr'
                                    },
                                    {
                                        name: 'Ribnitz-Damgarten',
                                        href: '/yachtcharter/deutschland/ostsee-und-peene/ribnitz-damgarten'
                                    },
                                    {
                                        name: 'Peenem\xfcnde',
                                        href: '/yachtcharter/deutschland/ostsee-und-peene/peenemuende'
                                    }, 
                                ]
                            },
                            {
                                name: 'R\xfcgen',
                                href: '/yachtcharter/deutschland/ruegen',
                                subList: [
                                    {
                                        name: 'Putbus',
                                        href: '/yachtcharter/deutschland/ruegen/putbus'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'L\xe4nder',
                header: true
            },
            {
                name: 'Frankreich',
                icon: fr,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Frankreich',
                        href: '/yachtcharter/frankreich',
                        list: [
                            {
                                name: 'Bretagne',
                                href: '/yachtcharter/frankreich/bretagne',
                                subList: [
                                    {
                                        name: 'Melesse',
                                        href: '/yachtcharter/frankreich/bretagne/melesse'
                                    },
                                    {
                                        name: 'Saint-Martin-sur-Oust',
                                        href: '/yachtcharter/frankreich/bretagne/saint-martin-sur-oust'
                                    },
                                    {
                                        name: 'Gl\xe9nac',
                                        href: '/yachtcharter/frankreich/bretagne/glenac'
                                    },
                                    {
                                        name: 'Messac',
                                        href: '/yachtcharter/frankreich/bretagne/messac'
                                    },
                                    {
                                        name: 'La Trinit\xe9-sur-Mer',
                                        href: '/yachtcharter/frankreich/bretagne/la-trinite-sur-mer'
                                    },
                                    {
                                        name: 'Redon',
                                        href: '/yachtcharter/frankreich/bretagne/redon'
                                    },
                                    {
                                        name: 'Saint Nicolas-des-Eaux',
                                        href: '/yachtcharter/frankreich/bretagne/saint-nicolas-des-eaux'
                                    },
                                    {
                                        name: 'Pl\xe8neuf-Val-Andr\xe8',
                                        href: '/yachtcharter/frankreich/bretagne/pleneuf-val-andre'
                                    },
                                    {
                                        name: 'Messac',
                                        href: '/yachtcharter/frankreich/bretagne/messac'
                                    }, 
                                ]
                            },
                            {
                                name: 'Okzitanien',
                                href: '/yachtcharter/frankreich/okzitanien',
                                subList: [
                                    {
                                        name: 'Lattes',
                                        href: '/yachtcharter/frankreich/okzitanien/lattes'
                                    },
                                    {
                                        name: 'Argens-Minervois',
                                        href: '/yachtcharter/frankreich/okzitanien/argens-minervois'
                                    },
                                    {
                                        name: 'Lauragais',
                                        href: '/yachtcharter/frankreich/okzitanien/lauragais'
                                    },
                                    {
                                        name: 'Valence-sur-Ba\xefse',
                                        href: '/yachtcharter/frankreich/okzitanien/valence-sur-baise'
                                    },
                                    // {
                                    //  name: 'Cahors',
                                    //  href: '/yachtcharter/frankreich/okzitanien/cahors',
                                    // },
                                    {
                                        name: 'Bellegarde',
                                        href: '/yachtcharter/frankreich/okzitanien/bellegarde'
                                    },
                                    {
                                        name: "Saint-Nazaire-d'Aude",
                                        href: '/yachtcharter/frankreich/okzitanien/saint-nazaire-daude'
                                    },
                                    {
                                        name: 'Lauragais',
                                        href: '/yachtcharter/frankreich/okzitanien/lauragais'
                                    },
                                    {
                                        name: 'Bram',
                                        href: '/yachtcharter/frankreich/okzitanien/bram'
                                    },
                                    {
                                        name: 'Douelle',
                                        href: '/yachtcharter/frankreich/okzitanien/douelle'
                                    },
                                    {
                                        name: 'Tr\xe8bes',
                                        href: '/yachtcharter/frankreich/okzitanien/trebes'
                                    },
                                    {
                                        name: 'Capestang',
                                        href: '/yachtcharter/frankreich/okzitanien/capestang'
                                    },
                                    {
                                        name: 'Castelnaudary ',
                                        href: '/yachtcharter/frankreich/okzitanien/castelnaudary'
                                    },
                                    {
                                        name: 'Homps',
                                        href: '/yachtcharter/frankreich/okzitanien/homps'
                                    },
                                    {
                                        name: 'Le Somail',
                                        href: '/yachtcharter/frankreich/okzitanien/le-somail'
                                    },
                                    {
                                        name: 'Agde',
                                        href: '/yachtcharter/frankreich/okzitanien/agde'
                                    },
                                    {
                                        name: 'Carcassonne',
                                        href: '/yachtcharter/frankreich/okzitanien/carcassonne'
                                    },
                                    {
                                        name: 'Carnon',
                                        href: '/yachtcharter/frankreich/okzitanien/carnon'
                                    },
                                    {
                                        name: 'Colombiers',
                                        href: '/yachtcharter/frankreich/okzitanien/colombiers'
                                    },
                                    {
                                        name: 'Luzech',
                                        href: '/yachtcharter/frankreich/okzitanien/luzech'
                                    },
                                    {
                                        name: 'Portiranges',
                                        href: '/yachtcharter/frankreich/okzitanien/portiranges'
                                    },
                                    {
                                        name: 'St. Gilles',
                                        href: '/yachtcharter/frankreich/okzitanien/st-gilles'
                                    }, 
                                ]
                            },
                            {
                                name: 'Nouvelle-Aquitanien',
                                href: '/yachtcharter/frankreich/nouvelle-aquitanien',
                                subList: [
                                    {
                                        name: 'Agen',
                                        href: '/yachtcharter/frankreich/nouvelle-aquitanien/agen'
                                    },
                                    {
                                        name: 'Buzet-sur-Baise',
                                        href: '/yachtcharter/frankreich/nouvelle-aquitanien/buzet-sur-baise'
                                    },
                                    {
                                        name: 'Sireuil',
                                        href: '/yachtcharter/frankreich/nouvelle-aquitanien/sireuil'
                                    },
                                    {
                                        name: "Le Mas d'Agenais",
                                        href: '/yachtcharter/frankreich/nouvelle-aquitanien/le-mas-dagenais'
                                    },
                                    {
                                        name: 'Jarnac',
                                        href: '/yachtcharter/frankreich/nouvelle-aquitanien/jarnac'
                                    },
                                    {
                                        name: 'La Rochelle',
                                        href: '/yachtcharter/frankreich/nouvelle-aquitanien/la-rochelle'
                                    },
                                    {
                                        name: 'Cognac',
                                        href: '/yachtcharter/frankreich/nouvelle-aquitanien/cognac'
                                    },
                                    {
                                        name: "Le Mas d'Agenais",
                                        href: '/yachtcharter/frankreich/nouvelle-aquitanien/le-mas-dagenais'
                                    }, 
                                ]
                            },
                            {
                                name: 'Korsika',
                                href: '/yachtcharter/frankreich/korsika',
                                subList: [
                                    {
                                        name: 'Propriano',
                                        href: '/yachtcharter/frankreich/korsika/propriano'
                                    },
                                    {
                                        name: 'Ajaccio',
                                        href: '/yachtcharter/frankreich/korsika/ajaccio'
                                    }, 
                                ]
                            },
                            {
                                name: 'Neukaledonien',
                                href: '/yachtcharter/frankreich/neukaledonien',
                                subList: [
                                    {
                                        name: 'Noumea',
                                        href: '/yachtcharter/frankreich/neukaledonien/noumea'
                                    }, 
                                ]
                            },
                            {
                                name: 'Canal du Midi',
                                href: '/yachtcharter/frankreich/canal-du-midi',
                                subList: [
                                    {
                                        name: 'Argens-Minervois',
                                        href: '/yachtcharter/frankreich/canal-du-midi/argens-minervois'
                                    },
                                    {
                                        name: 'Lauragais',
                                        href: '/yachtcharter/frankreich/canal-du-midi/lauragais'
                                    },
                                    {
                                        name: "Saint-Nazaire-d'Aude",
                                        href: '/yachtcharter/frankreich/canal-du-midi/saint-nazaire-daude'
                                    },
                                    {
                                        name: 'Bram',
                                        href: '/yachtcharter/frankreich/canal-du-midi/bram'
                                    },
                                    {
                                        name: 'Tr\xe8bes',
                                        href: '/yachtcharter/frankreich/canal-du-midi/trebes'
                                    },
                                    {
                                        name: 'Capestang',
                                        href: '/yachtcharter/frankreich/canal-du-midi/capestang'
                                    },
                                    {
                                        name: 'Castelnaudary ',
                                        href: '/yachtcharter/frankreich/canal-du-midi/castelnaudary'
                                    },
                                    {
                                        name: 'Homps',
                                        href: '/yachtcharter/frankreich/canal-du-midi/homps'
                                    },
                                    {
                                        name: 'Le Somail',
                                        href: '/yachtcharter/frankreich/canal-du-midi/le-somail'
                                    },
                                    {
                                        name: 'Agde',
                                        href: '/yachtcharter/frankreich/canal-du-midi/agde'
                                    },
                                    {
                                        name: 'Carcassonne',
                                        href: '/yachtcharter/frankreich/canal-du-midi/carcassonne'
                                    },
                                    {
                                        name: 'Colombiers',
                                        href: '/yachtcharter/frankreich/canal-du-midi/colombiers'
                                    },
                                    {
                                        name: 'Portiranges',
                                        href: '/yachtcharter/frankreich/canal-du-midi/portiranges'
                                    }, 
                                ]
                            },
                            {
                                name: 'Franz\xf6sische Mittelmeerk\xfcste',
                                href: '/yachtcharter/frankreich/franzoesische-mittelmeerkueste',
                                subList: [
                                    {
                                        name: 'Lattes',
                                        href: '/yachtcharter/frankreich/franzoesische-mittelmeerkueste/lattes'
                                    },
                                    {
                                        name: 'Bellegarde',
                                        href: '/yachtcharter/frankreich/franzoesische-mittelmeerkueste/bellegarde'
                                    },
                                    {
                                        name: 'Saint-Mandrier-sur-Mer',
                                        href: '/yachtcharter/frankreich/franzoesische-mittelmeerkueste/saint-mandrier-sur-mer'
                                    },
                                    {
                                        name: 'Bormes-les-Mimosas',
                                        href: '/yachtcharter/frankreich/franzoesische-mittelmeerkueste/bormes-les-mimosas'
                                    },
                                    {
                                        name: 'Cogolin',
                                        href: '/yachtcharter/frankreich/franzoesische-mittelmeerkueste/cogolin'
                                    },
                                    {
                                        name: 'Hyeres',
                                        href: '/yachtcharter/frankreich/franzoesische-mittelmeerkueste/hyeres'
                                    },
                                    {
                                        name: 'Nice',
                                        href: '/yachtcharter/frankreich/franzoesische-mittelmeerkueste/nice'
                                    },
                                    {
                                        name: 'Toulon',
                                        href: '/yachtcharter/frankreich/franzoesische-mittelmeerkueste/toulon'
                                    },
                                    {
                                        name: 'Marseille',
                                        href: '/yachtcharter/frankreich/franzoesische-mittelmeerkueste/marseille'
                                    },
                                    {
                                        name: 'Grimaud',
                                        href: '/yachtcharter/frankreich/franzoesische-mittelmeerkueste/grimaud'
                                    },
                                    {
                                        name: 'Vallauris',
                                        href: '/yachtcharter/frankreich/franzoesische-mittelmeerkueste/vallauris'
                                    },
                                    {
                                        name: 'Saint-Rapha\xebl',
                                        href: '/yachtcharter/frankreich/franzoesische-mittelmeerkueste/saint-raphael'
                                    },
                                    {
                                        name: 'Agde',
                                        href: '/yachtcharter/frankreich/franzoesische-mittelmeerkueste/agde'
                                    },
                                    {
                                        name: 'Carnon',
                                        href: '/yachtcharter/frankreich/franzoesische-mittelmeerkueste/carnon'
                                    },
                                    {
                                        name: 'Colombiers',
                                        href: '/yachtcharter/frankreich/franzoesische-mittelmeerkueste/colombiers'
                                    },
                                    {
                                        name: 'Portiranges',
                                        href: '/yachtcharter/frankreich/franzoesische-mittelmeerkueste/portiranges'
                                    },
                                    {
                                        name: 'St. Gilles',
                                        href: '/yachtcharter/frankreich/franzoesische-mittelmeerkueste/st-gilles'
                                    }, 
                                ]
                            },
                            {
                                name: 'C\xf4te d’Azur',
                                href: '/yachtcharter/frankreich/cote-d-azur',
                                subList: [
                                    {
                                        name: 'Saint-Mandrier-sur-Mer',
                                        href: '/yachtcharter/frankreich/cote-d-azur/saint-mandrier-sur-mer'
                                    },
                                    {
                                        name: 'Bormes-les-Mimosas',
                                        href: '/yachtcharter/frankreich/cote-d-azur/bormes-les-mimosas'
                                    },
                                    {
                                        name: 'Cogolin',
                                        href: '/yachtcharter/frankreich/cote-d-azur/cogolin'
                                    },
                                    {
                                        name: 'Hyeres',
                                        href: '/yachtcharter/frankreich/cote-d-azur/hyeres'
                                    },
                                    {
                                        name: 'Nice',
                                        href: '/yachtcharter/frankreich/cote-d-azur/nice'
                                    },
                                    {
                                        name: 'Toulon',
                                        href: '/yachtcharter/frankreich/cote-d-azur/toulon'
                                    },
                                    {
                                        name: 'Marseille',
                                        href: '/yachtcharter/frankreich/cote-d-azur/marseille'
                                    },
                                    {
                                        name: 'Grimaud',
                                        href: '/yachtcharter/frankreich/cote-d-azur/grimaud'
                                    },
                                    {
                                        name: 'Vallauris',
                                        href: '/yachtcharter/frankreich/cote-d-azur/vallauris'
                                    },
                                    {
                                        name: 'Saint-Rapha\xebl',
                                        href: '/yachtcharter/frankreich/cote-d-azur/saint-raphael'
                                    }, 
                                ]
                            },
                            {
                                name: 'Camargue',
                                href: '/yachtcharter/frankreich/camargue',
                                subList: [
                                    {
                                        name: 'Lattes',
                                        href: '/yachtcharter/frankreich/camargue/lattes'
                                    },
                                    {
                                        name: 'Bellegarde',
                                        href: '/yachtcharter/frankreich/camargue/bellegarde'
                                    },
                                    {
                                        name: 'Agde',
                                        href: '/yachtcharter/frankreich/camargue/agde'
                                    },
                                    {
                                        name: 'Carnon',
                                        href: '/yachtcharter/frankreich/camargue/carnon'
                                    },
                                    {
                                        name: 'Portiranges',
                                        href: '/yachtcharter/frankreich/camargue/portiranges'
                                    },
                                    {
                                        name: 'St. Gilles',
                                        href: '/yachtcharter/frankreich/camargue/st-gilles'
                                    }, 
                                ]
                            },
                            {
                                name: 'Charente',
                                href: '/yachtcharter/frankreich/charente',
                                subList: [
                                    {
                                        name: 'Sireuil',
                                        href: '/yachtcharter/frankreich/charente/sireuil'
                                    },
                                    {
                                        name: 'Jarnac',
                                        href: '/yachtcharter/frankreich/charente/jarnac'
                                    },
                                    {
                                        name: 'La Rochelle',
                                        href: '/yachtcharter/frankreich/charente/la-rochelle'
                                    },
                                    {
                                        name: 'Cognac',
                                        href: '/yachtcharter/frankreich/charente/cognac'
                                    }, 
                                ]
                            },
                            {
                                name: 'Burgund Nivernais & Loire',
                                href: '/yachtcharter/frankreich/burgund-nivernais-loire',
                                subList: [
                                    {
                                        name: 'Joigny',
                                        href: '/yachtcharter/frankreich/burgund-nivernais-loire/joigny'
                                    },
                                    {
                                        name: 'Corbigny',
                                        href: '/yachtcharter/frankreich/burgund-nivernais-loire/corbigny'
                                    },
                                    {
                                        name: 'Dompierre-sur-Besbre',
                                        href: '/yachtcharter/frankreich/burgund-nivernais-loire/dompierre-sur-besbre'
                                    },
                                    {
                                        name: 'Briare',
                                        href: '/yachtcharter/frankreich/burgund-nivernais-loire/briare'
                                    },
                                    {
                                        name: 'Saint-L\xe9ger-sur-Dheune',
                                        href: '/yachtcharter/frankreich/burgund-nivernais-loire/saint-leger-sur-dheune'
                                    },
                                    {
                                        name: 'Chassey-l\xe8s-Scey',
                                        href: '/yachtcharter/frankreich/burgund-nivernais-loire/chassey-les-scey'
                                    },
                                    {
                                        name: 'Sermoise-Sur-Loire',
                                        href: '/yachtcharter/frankreich/burgund-nivernais-loire/sermoise-sur-loire'
                                    },
                                    {
                                        name: 'Brienon',
                                        href: '/yachtcharter/frankreich/burgund-nivernais-loire/brienon'
                                    },
                                    {
                                        name: 'Venarey-les-Laumes',
                                        href: '/yachtcharter/frankreich/burgund-nivernais-loire/venarey-les-laumes'
                                    },
                                    {
                                        name: 'Dole',
                                        href: '/yachtcharter/frankreich/burgund-nivernais-loire/dole'
                                    },
                                    {
                                        name: 'Port-sur-Saone',
                                        href: '/yachtcharter/frankreich/burgund-nivernais-loire/port-sur-saone'
                                    },
                                    {
                                        name: 'Decize',
                                        href: '/yachtcharter/frankreich/burgund-nivernais-loire/decize'
                                    },
                                    {
                                        name: 'Migennes',
                                        href: '/yachtcharter/frankreich/burgund-nivernais-loire/migennes'
                                    },
                                    {
                                        name: 'Branges',
                                        href: '/yachtcharter/frankreich/burgund-nivernais-loire/branges'
                                    },
                                    {
                                        name: 'Fontenoy-le-Ch\xe2teau',
                                        href: '/yachtcharter/frankreich/burgund-nivernais-loire/fontenoy-le-chateau'
                                    },
                                    {
                                        name: 'Auxerre',
                                        href: '/yachtcharter/frankreich/burgund-nivernais-loire/auxerre'
                                    },
                                    {
                                        name: 'Saint-Jean-de-Losne',
                                        href: '/yachtcharter/frankreich/burgund-nivernais-loire/saint-jean-de-losne'
                                    },
                                    {
                                        name: 'Ch\xe2tillon-sur-Loire',
                                        href: '/yachtcharter/frankreich/burgund-nivernais-loire/chatillon-sur-loire'
                                    },
                                    {
                                        name: 'Nevers - Plagny',
                                        href: '/yachtcharter/frankreich/burgund-nivernais-loire/nevers-plagny'
                                    },
                                    {
                                        name: 'La Rochelle',
                                        href: '/yachtcharter/frankreich/burgund-nivernais-loire/la-rochelle'
                                    },
                                    {
                                        name: 'Vermenton',
                                        href: '/yachtcharter/frankreich/burgund-nivernais-loire/vermenton'
                                    },
                                    {
                                        name: 'Digoin',
                                        href: '/yachtcharter/frankreich/burgund-nivernais-loire/digoin'
                                    },
                                    {
                                        name: 'Chatillon-En-Bazois',
                                        href: '/yachtcharter/frankreich/burgund-nivernais-loire/chatillon-en-bazois'
                                    },
                                    {
                                        name: 'Louhans',
                                        href: '/yachtcharter/frankreich/burgund-nivernais-loire/louhans'
                                    },
                                    {
                                        name: 'Mailly Le Chateau',
                                        href: '/yachtcharter/frankreich/burgund-nivernais-loire/mailly-le-chateau'
                                    },
                                    {
                                        name: 'Pontailler sur Sa\xf4ne',
                                        href: '/yachtcharter/frankreich/burgund-nivernais-loire/pontailler-sur-saone'
                                    },
                                    {
                                        name: 'Tannay',
                                        href: '/yachtcharter/frankreich/burgund-nivernais-loire/tannay'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Niederlande',
                icon: nl,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Niederlande',
                        href: '/yachtcharter/niederlande',
                        list: [
                            {
                                name: 'Nordholland',
                                href: '/yachtcharter/niederlande/nordholland',
                                subList: [
                                    {
                                        name: 'Loosdrecht',
                                        href: '/yachtcharter/niederlande/nordholland/loosdrecht'
                                    },
                                    {
                                        name: 'Vinkeveen',
                                        href: '/yachtcharter/niederlande/nordholland/vinkeveen'
                                    }, 
                                ]
                            },
                            {
                                name: 'Friesland',
                                href: '/yachtcharter/niederlande/friesland',
                                subList: [
                                    {
                                        name: 'Drachten',
                                        href: '/yachtcharter/niederlande/friesland/drachten'
                                    },
                                    {
                                        name: 'Lemmer',
                                        href: '/yachtcharter/niederlande/friesland/lemmer'
                                    },
                                    {
                                        name: 'Hindeloopen',
                                        href: '/yachtcharter/niederlande/friesland/hindeloopen'
                                    },
                                    {
                                        name: 'Woudsend',
                                        href: '/yachtcharter/niederlande/friesland/woudsend'
                                    }, 
                                ]
                            },
                            {
                                name: 'S\xfcdholland',
                                href: '/yachtcharter/niederlande/suedholland',
                                subList: [
                                    {
                                        name: 'Alphen aan den Rijn',
                                        href: '/yachtcharter/niederlande/suedholland/alphen-aan-den-rijn'
                                    }, 
                                ]
                            },
                            {
                                name: 'Utrecht',
                                href: '/yachtcharter/niederlande/utrecht',
                                subList: [
                                    {
                                        name: 'Loosdrecht',
                                        href: '/yachtcharter/niederlande/utrecht/loosdrecht'
                                    },
                                    {
                                        name: 'Montfoort',
                                        href: '/yachtcharter/niederlande/utrecht/montfoort'
                                    },
                                    {
                                        name: 'Vinkeveen',
                                        href: '/yachtcharter/niederlande/utrecht/vinkeveen'
                                    }, 
                                ]
                            },
                            {
                                name: 'Seeland',
                                href: '/yachtcharter/niederlande/seeland',
                                subList: [
                                    {
                                        name: 'Kortgene',
                                        href: '/yachtcharter/niederlande/seeland/kortgene'
                                    },
                                    {
                                        name: 'Yerseke',
                                        href: '/yachtcharter/niederlande/seeland/yerseke'
                                    },
                                    {
                                        name: 'Breskens',
                                        href: '/yachtcharter/niederlande/seeland/breskens'
                                    }, 
                                ]
                            },
                            {
                                name: 'Ijsselmeer',
                                href: '/yachtcharter/niederlande/ijsselmeer',
                                subList: [
                                    {
                                        name: 'Lemmer',
                                        href: '/yachtcharter/niederlande/ijsselmeer/lemmer'
                                    },
                                    {
                                        name: 'Lelystad',
                                        href: '/yachtcharter/niederlande/ijsselmeer/lelystad'
                                    },
                                    {
                                        name: 'Hindeloopen',
                                        href: '/yachtcharter/niederlande/ijsselmeer/hindeloopen'
                                    },
                                    {
                                        name: 'Woudsend',
                                        href: '/yachtcharter/niederlande/ijsselmeer/woudsend'
                                    }, 
                                ]
                            },
                            {
                                name: 'Zeeland',
                                href: '/yachtcharter/niederlande/zeeland',
                                subList: [
                                    {
                                        name: 'Kortgene',
                                        href: '/yachtcharter/niederlande/zeeland/kortgene'
                                    },
                                    {
                                        name: 'Yerseke',
                                        href: '/yachtcharter/niederlande/zeeland/yerseke'
                                    },
                                    {
                                        name: 'Breskens',
                                        href: '/yachtcharter/niederlande/zeeland/breskens'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Polen',
                icon: pl,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Polen',
                        href: '/yachtcharter/polen',
                        list: [
                            {
                                name: 'Oder & Stettiner Haff',
                                href: '/yachtcharter/polen/oder-stettiner-haff',
                                subList: [
                                    {
                                        name: 'Kamień Pomorski',
                                        href: '/yachtcharter/polen/oder-stettiner-haff/kamien-pomorski'
                                    },
                                    {
                                        name: 'Trzebież',
                                        href: '/yachtcharter/polen/oder-stettiner-haff/trzebiez'
                                    },
                                    {
                                        name: 'Eggesin',
                                        href: '/yachtcharter/polen/oder-stettiner-haff/eggesin'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Portugal',
                icon: pt,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Portugal',
                        href: '/yachtcharter/portugal',
                        list: [
                            {
                                name: 'Alentejo - Grande Lago',
                                href: '/yachtcharter/portugal/alentejo-grande-lago',
                                subList: [
                                    {
                                        name: 'Amieira',
                                        href: '/yachtcharter/portugal/alentejo-grande-lago/amieira'
                                    }, 
                                ]
                            },
                            {
                                name: 'Algarve',
                                href: '/yachtcharter/portugal/algarve',
                                subList: [
                                    {
                                        name: 'Portimao',
                                        href: '/yachtcharter/portugal/algarve/portimao'
                                    },
                                    {
                                        name: 'Ayamonte',
                                        href: '/yachtcharter/portugal/algarve/ayamonte'
                                    }, 
                                ]
                            },
                            {
                                name: 'Lissabon',
                                href: '/yachtcharter/portugal/lissabon',
                                subList: [
                                    {
                                        name: 'Lissabon',
                                        href: '/yachtcharter/portugal/lissabon/lissabon'
                                    },
                                    {
                                        name: 'Cascais',
                                        href: '/yachtcharter/portugal/lissabon/cascais'
                                    }, 
                                ]
                            },
                            {
                                name: 'Nordportugal',
                                href: '/yachtcharter/portugal/nordportugal',
                                subList: [
                                    {
                                        name: 'Freixo',
                                        href: '/yachtcharter/portugal/nordportugal/freixo'
                                    },
                                    {
                                        name: 'Vila Nova Gaia',
                                        href: '/yachtcharter/portugal/nordportugal/vila-nova-gaia'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Spanien',
                icon: es,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Spanien',
                        href: '/yachtcharter/spanien',
                        list: [
                            {
                                name: 'Balearische Inseln',
                                href: '/yachtcharter/spanien/balearische-inseln',
                                subList: [
                                    {
                                        name: 'Portocolom',
                                        href: '/yachtcharter/spanien/balearische-inseln/portocolom'
                                    },
                                    {
                                        name: 'Llucmajor',
                                        href: '/yachtcharter/spanien/balearische-inseln/llucmajor'
                                    },
                                    {
                                        name: "Cala D'or",
                                        href: '/yachtcharter/spanien/balearische-inseln/cala-dor'
                                    },
                                    {
                                        name: 'Palma de Mallorca',
                                        href: '/yachtcharter/spanien/balearische-inseln/palma-de-mallorca'
                                    },
                                    {
                                        name: 'Ibiza',
                                        href: '/yachtcharter/spanien/balearische-inseln/ibiza'
                                    },
                                    {
                                        name: 'Alcudia',
                                        href: '/yachtcharter/spanien/balearische-inseln/alcudia'
                                    },
                                    {
                                        name: 'Port de Pollen\xe7a',
                                        href: '/yachtcharter/spanien/balearische-inseln/port-de-pollenca'
                                    },
                                    {
                                        name: 'Can Pastilla',
                                        href: '/yachtcharter/spanien/balearische-inseln/can-pastilla'
                                    },
                                    {
                                        name: 'Santa Pon\xe7a',
                                        href: '/yachtcharter/spanien/balearische-inseln/santa-ponca'
                                    },
                                    {
                                        name: 'Mahon - Menorca',
                                        href: '/yachtcharter/spanien/balearische-inseln/mahon-menorca'
                                    },
                                    {
                                        name: 'Santany\xed',
                                        href: '/yachtcharter/spanien/balearische-inseln/santanyi'
                                    },
                                    {
                                        name: 'Eivissa',
                                        href: '/yachtcharter/spanien/balearische-inseln/eivissa'
                                    },
                                    {
                                        name: 'Ma\xf3',
                                        href: '/yachtcharter/spanien/balearische-inseln/mao'
                                    },
                                    {
                                        name: 'Pollen\xe7a',
                                        href: '/yachtcharter/spanien/balearische-inseln/pollenca'
                                    },
                                    {
                                        name: 'Portals Nous-Calvi\xe0',
                                        href: '/yachtcharter/spanien/balearische-inseln/portals-nous-calvia'
                                    },
                                    {
                                        name: 'Sant Antoni',
                                        href: '/yachtcharter/spanien/balearische-inseln/sant-antoni'
                                    },
                                    {
                                        name: 'Palma',
                                        href: '/yachtcharter/spanien/balearische-inseln/palma'
                                    },
                                    {
                                        name: 'San Antonio Abad',
                                        href: '/yachtcharter/spanien/balearische-inseln/san-antonio-abad'
                                    }, 
                                ]
                            },
                            {
                                name: 'Mallorca',
                                href: '/yachtcharter/spanien/mallorca',
                                subList: [
                                    {
                                        name: 'Portocolom',
                                        href: '/yachtcharter/spanien/mallorca/portocolom'
                                    },
                                    {
                                        name: 'Llucmajor',
                                        href: '/yachtcharter/spanien/mallorca/llucmajor'
                                    },
                                    {
                                        name: "Cala D'or",
                                        href: '/yachtcharter/spanien/mallorca/cala-dor'
                                    },
                                    {
                                        name: 'Palma de Mallorca',
                                        href: '/yachtcharter/spanien/mallorca/palma-de-mallorca'
                                    },
                                    {
                                        name: 'Alcudia',
                                        href: '/yachtcharter/spanien/mallorca/alcudia'
                                    },
                                    {
                                        name: 'Port de Pollen\xe7a',
                                        href: '/yachtcharter/spanien/mallorca/port-de-pollenca'
                                    },
                                    {
                                        name: 'Can Pastilla',
                                        href: '/yachtcharter/spanien/mallorca/can-pastilla'
                                    },
                                    {
                                        name: 'Santa Pon\xe7a',
                                        href: '/yachtcharter/spanien/mallorca/santa-ponca'
                                    },
                                    {
                                        name: 'Santany\xed',
                                        href: '/yachtcharter/spanien/mallorca/santanyi'
                                    },
                                    {
                                        name: 'Pollen\xe7a',
                                        href: '/yachtcharter/spanien/mallorca/pollenca'
                                    },
                                    {
                                        name: 'Portals Nous-Calvi\xe0',
                                        href: '/yachtcharter/spanien/mallorca/portals-nous-calvia'
                                    },
                                    {
                                        name: 'Palma',
                                        href: '/yachtcharter/spanien/mallorca/palma'
                                    }, 
                                ]
                            },
                            {
                                name: 'Ibiza',
                                href: '/yachtcharter/spanien/ibiza',
                                subList: [
                                    {
                                        name: 'Ibiza',
                                        href: '/yachtcharter/spanien/ibiza/ibiza'
                                    },
                                    {
                                        name: 'Eivissa',
                                        href: '/yachtcharter/spanien/ibiza/eivissa'
                                    },
                                    {
                                        name: 'Sant Antoni',
                                        href: '/yachtcharter/spanien/ibiza/sant-antoni'
                                    },
                                    {
                                        name: 'San Antonio Abad',
                                        href: '/yachtcharter/spanien/ibiza/san-antonio-abad'
                                    }, 
                                ]
                            },
                            {
                                name: 'Menorca',
                                href: '/yachtcharter/spanien/menorca',
                                subList: [
                                    {
                                        name: 'Mahon - Menorca',
                                        href: '/yachtcharter/spanien/menorca/mahon-menorca'
                                    },
                                    {
                                        name: 'Ma\xf3',
                                        href: '/yachtcharter/spanien/menorca/mao'
                                    }, 
                                ]
                            },
                            {
                                name: 'Kanarische Inseln',
                                href: '/yachtcharter/spanien/kanarische-inseln',
                                subList: [
                                    {
                                        name: 'Arrecife',
                                        href: '/yachtcharter/spanien/kanarische-inseln/arrecife'
                                    },
                                    {
                                        name: 'Lanzarote',
                                        href: '/yachtcharter/spanien/kanarische-inseln/lanzarote'
                                    },
                                    {
                                        name: 'Santa Cruz de Tenerife',
                                        href: '/yachtcharter/spanien/kanarische-inseln/santa-cruz-de-tenerife'
                                    },
                                    {
                                        name: 'Las Galletas',
                                        href: '/yachtcharter/spanien/kanarische-inseln/las-galletas'
                                    },
                                    {
                                        name: 'Arona',
                                        href: '/yachtcharter/spanien/kanarische-inseln/arona'
                                    },
                                    {
                                        name: 'San Bartolom\xe9 de Tirajana',
                                        href: '/yachtcharter/spanien/kanarische-inseln/san-bartolome-de-tirajana'
                                    },
                                    {
                                        name: 'Lomo Quiebre',
                                        href: '/yachtcharter/spanien/kanarische-inseln/lomo-quiebre'
                                    },
                                    {
                                        name: 'Amarilla Golf',
                                        href: '/yachtcharter/spanien/kanarische-inseln/amarilla-golf'
                                    },
                                    {
                                        name: 'Gran Canaria',
                                        href: '/yachtcharter/spanien/kanarische-inseln/gran-canaria'
                                    }, 
                                ]
                            },
                            {
                                name: 'Gran Canaria',
                                href: '/yachtcharter/spanien/gran-canaria',
                                subList: [
                                    {
                                        name: 'San Bartolom\xe9 de Tirajana',
                                        href: '/yachtcharter/spanien/gran-canaria/san-bartolome-de-tirajana'
                                    },
                                    {
                                        name: 'Lomo Quiebre',
                                        href: '/yachtcharter/spanien/gran-canaria/lomo-quiebre'
                                    },
                                    {
                                        name: 'Gran Canaria',
                                        href: '/yachtcharter/spanien/gran-canaria/gran-canaria'
                                    }, 
                                ]
                            },
                            {
                                name: 'Lanzarote',
                                href: '/yachtcharter/spanien/lanzarote',
                                subList: [
                                    {
                                        name: 'Arrecife',
                                        href: '/yachtcharter/spanien/lanzarote/arrecife'
                                    },
                                    {
                                        name: 'Lanzarote',
                                        href: '/yachtcharter/spanien/lanzarote/lanzarote'
                                    }, 
                                ]
                            },
                            {
                                name: 'Katalonien',
                                href: '/yachtcharter/spanien/katalonien',
                                subList: [
                                    {
                                        name: 'Barcelona',
                                        href: '/yachtcharter/spanien/katalonien/barcelona'
                                    },
                                    {
                                        name: 'Roses',
                                        href: '/yachtcharter/spanien/katalonien/roses'
                                    },
                                    {
                                        name: 'Girona',
                                        href: '/yachtcharter/spanien/katalonien/girona'
                                    },
                                    {
                                        name: 'El Masnou',
                                        href: '/yachtcharter/spanien/katalonien/el-masnou'
                                    },
                                    {
                                        name: 'Palamos',
                                        href: '/yachtcharter/spanien/katalonien/palamos'
                                    },
                                    {
                                        name: 'Mataro',
                                        href: '/yachtcharter/spanien/katalonien/mataro'
                                    },
                                    {
                                        name: 'Cambrils',
                                        href: '/yachtcharter/spanien/katalonien/cambrils'
                                    },
                                    {
                                        name: 'Premi\xe0 de Mar, Barcelona',
                                        href: '/yachtcharter/spanien/katalonien/premia-de-mar-barcelona'
                                    },
                                    {
                                        name: 'Roda de Bar\xe0',
                                        href: '/yachtcharter/spanien/katalonien/roda-de-bara'
                                    },
                                    {
                                        name: 'Sitges',
                                        href: '/yachtcharter/spanien/katalonien/sitges'
                                    },
                                    {
                                        name: 'Sitges, Barcelona',
                                        href: '/yachtcharter/spanien/katalonien/sitges-barcelona'
                                    },
                                    {
                                        name: 'Torredembarra',
                                        href: '/yachtcharter/spanien/katalonien/torredembarra'
                                    },
                                    {
                                        name: 'Roda de Ber\xe0',
                                        href: '/yachtcharter/spanien/katalonien/roda-de-bera'
                                    }, 
                                ]
                            },
                            {
                                name: 'Valencia',
                                href: '/yachtcharter/spanien/valencia',
                                subList: [
                                    {
                                        name: 'Denia',
                                        href: '/yachtcharter/spanien/valencia/denia'
                                    },
                                    {
                                        name: 'Valencia',
                                        href: '/yachtcharter/spanien/valencia/valencia'
                                    },
                                    {
                                        name: 'La Vila Joiosa',
                                        href: '/yachtcharter/spanien/valencia/la-vila-joiosa'
                                    }, 
                                ]
                            },
                            {
                                name: 'Andalusien',
                                href: '/yachtcharter/spanien/andalusien',
                                subList: [
                                    {
                                        name: 'Ayamonte',
                                        href: '/yachtcharter/spanien/andalusien/ayamonte'
                                    }, 
                                ]
                            },
                            {
                                name: 'Galicien',
                                href: '/yachtcharter/spanien/galicien',
                                subList: [
                                    {
                                        name: 'Pontevedra',
                                        href: '/yachtcharter/spanien/galicien/pontevedra'
                                    }, 
                                ]
                            },
                            {
                                name: 'Teneriffa',
                                href: '/yachtcharter/spanien/teneriffa',
                                subList: [
                                    {
                                        name: 'Santa Cruz de Tenerife',
                                        href: '/yachtcharter/spanien/teneriffa/santa-cruz-de-tenerife'
                                    },
                                    {
                                        name: 'Las Galletas',
                                        href: '/yachtcharter/spanien/teneriffa/las-galletas'
                                    },
                                    {
                                        name: 'Arona',
                                        href: '/yachtcharter/spanien/teneriffa/arona'
                                    },
                                    {
                                        name: 'Amarilla Golf',
                                        href: '/yachtcharter/spanien/teneriffa/amarilla-golf'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Belgien',
                icon: be,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Belgien',
                        href: '/yachtcharter/belgien',
                        list: [
                            {
                                name: 'Fl\xe4mische Region',
                                href: '/yachtcharter/belgien/flaemische-region',
                                subList: [
                                    {
                                        name: 'Zeebrugge',
                                        href: '/yachtcharter/belgien/flaemische-region/zeebrugge'
                                    },
                                    {
                                        name: 'Kinrooi',
                                        href: '/yachtcharter/belgien/flaemische-region/kinrooi'
                                    },
                                    {
                                        name: 'Nieuwpoort',
                                        href: '/yachtcharter/belgien/flaemische-region/nieuwpoort'
                                    },
                                    {
                                        name: 'Brugge',
                                        href: '/yachtcharter/belgien/flaemische-region/brugge'
                                    }, 
                                ]
                            },
                            {
                                name: 'Flandern',
                                href: '/yachtcharter/belgien/flandern',
                                subList: [
                                    {
                                        name: 'Nieuwpoort',
                                        href: '/yachtcharter/belgien/flandern/nieuwpoort'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'D\xe4nemark',
                icon: dk,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'D\xe4nemark',
                        href: '/yachtcharter/daenemark',
                        list: [
                            {
                                name: 'Kopenhagen',
                                href: '/yachtcharter/daenemark/kopenhagen',
                                subList: [
                                    {
                                        name: 'Ish\xf8j',
                                        href: '/yachtcharter/daenemark/kopenhagen/ishoj'
                                    }, 
                                ]
                            },
                            {
                                name: 'S\xfcd-D\xe4nemark',
                                href: '/yachtcharter/daenemark/sued-daenemark',
                                subList: [
                                    {
                                        name: 'Kolding',
                                        href: '/yachtcharter/daenemark/sued-daenemark/kolding'
                                    }, 
                                ]
                            },
                            {
                                name: 'Sj\xe6lland (Zeeland)',
                                href: '/yachtcharter/daenemark/sjaelland-zeeland',
                                subList: [
                                    {
                                        name: 'Ish\xf8j',
                                        href: '/yachtcharter/daenemark/sjaelland-zeeland/ishoj'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Norwegen',
                icon: no,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Norwegen',
                        href: '/yachtcharter/norwegen',
                        list: []
                    }, 
                ]
            },
            {
                name: 'Slowenien',
                icon: sl,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Slowenien',
                        href: '/yachtcharter/slowenien',
                        list: []
                    }, 
                ]
            },
            {
                name: 'T\xfcrkei',
                icon: tr,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'T\xfcrkei',
                        href: '/yachtcharter/tuerkei',
                        list: [
                            {
                                name: 'Mittelmeerregion',
                                href: '/yachtcharter/tuerkei/mittelmeerregion',
                                subList: [
                                    {
                                        name: 'G\xf6cek',
                                        href: '/yachtcharter/tuerkei/mittelmeerregion/goecek'
                                    },
                                    {
                                        name: 'Fethiye',
                                        href: '/yachtcharter/tuerkei/mittelmeerregion/fethiye'
                                    },
                                    {
                                        name: 'Ece Saray Marina Resort, Fethiye',
                                        href: '/yachtcharter/tuerkei/mittelmeerregion/ece-saray-marina-resort-fethiye'
                                    },
                                    {
                                        name: 'G\xf6cek/D-Marin',
                                        href: '/yachtcharter/tuerkei/mittelmeerregion/goecek-d-marin'
                                    },
                                    {
                                        name: 'Marin Turk G\xf6cek Village Port',
                                        href: '/yachtcharter/tuerkei/mittelmeerregion/marin-turk-goecek-village-port'
                                    },
                                    {
                                        name: 'Kas Marina',
                                        href: '/yachtcharter/tuerkei/mittelmeerregion/kas-marina'
                                    },
                                    {
                                        name: 'Yacht Classic Hotel Marina, Fethiye',
                                        href: '/yachtcharter/tuerkei/mittelmeerregion/yacht-classic-hotel-marina-fethiye'
                                    },
                                    {
                                        name: 'Yes Marina',
                                        href: '/yachtcharter/tuerkei/mittelmeerregion/yes-marina'
                                    },
                                    {
                                        name: 'G\xf6cek/Skopea Marina',
                                        href: '/yachtcharter/tuerkei/mittelmeerregion/goecek-skopea-marina'
                                    }, 
                                ]
                            },
                            {
                                name: '\xc4g\xe4is',
                                href: '/yachtcharter/tuerkei/aegaeis',
                                subList: [
                                    {
                                        name: 'Kos',
                                        href: '/yachtcharter/tuerkei/aegaeis/kos'
                                    },
                                    {
                                        name: 'Orhaniye',
                                        href: '/yachtcharter/tuerkei/aegaeis/orhaniye'
                                    },
                                    {
                                        name: 'Marmaris',
                                        href: '/yachtcharter/tuerkei/aegaeis/marmaris'
                                    },
                                    {
                                        name: 'Bodrum',
                                        href: '/yachtcharter/tuerkei/aegaeis/bodrum'
                                    },
                                    {
                                        name: 'Marmaris, Netsel Marina',
                                        href: '/yachtcharter/tuerkei/aegaeis/marmaris-netsel-marina'
                                    },
                                    {
                                        name: 'Bodrum/Turgutreis/D-Marin',
                                        href: '/yachtcharter/tuerkei/aegaeis/bodrum-turgutreis-d-marin'
                                    },
                                    {
                                        name: 'Milta Bodrum Marina',
                                        href: '/yachtcharter/tuerkei/aegaeis/milta-bodrum-marina'
                                    },
                                    {
                                        name: 'Marmaris Yacht Marina',
                                        href: '/yachtcharter/tuerkei/aegaeis/marmaris-yacht-marina'
                                    },
                                    {
                                        name: 'G\xf6kova \xd6ren Marina',
                                        href: '/yachtcharter/tuerkei/aegaeis/goekova-oeren-marina'
                                    },
                                    {
                                        name: 'Marmaris Adakoy Marina',
                                        href: '/yachtcharter/tuerkei/aegaeis/marmaris-adakoy-marina'
                                    },
                                    {
                                        name: 'Palmarina - Yalikavak, Bodrum',
                                        href: '/yachtcharter/tuerkei/aegaeis/palmarina-yalikavak-bodrum'
                                    },
                                    {
                                        name: 'Bodrum, G\xfcmbet Marina',
                                        href: '/yachtcharter/tuerkei/aegaeis/bodrum-guembet-marina'
                                    },
                                    {
                                        name: 'Marmaris, Joya Del Mar Marina',
                                        href: '/yachtcharter/tuerkei/aegaeis/marmaris-joya-del-mar-marina'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Schweden',
                icon: se,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Schweden',
                        href: '/yachtcharter/schweden',
                        list: [
                            {
                                name: 'V\xe4stra G\xf6talands l\xe4n',
                                href: '/yachtcharter/schweden/vaestra-goetalands-laen',
                                subList: [
                                    {
                                        name: 'G\xf6teborg',
                                        href: '/yachtcharter/schweden/vaestra-goetalands-laen/goeteborg'
                                    },
                                    {
                                        name: 'Marstrand',
                                        href: '/yachtcharter/schweden/vaestra-goetalands-laen/marstrand'
                                    },
                                    {
                                        name: 'Wallhamn',
                                        href: '/yachtcharter/schweden/vaestra-goetalands-laen/wallhamn'
                                    },
                                    {
                                        name: 'Gothenburg',
                                        href: '/yachtcharter/schweden/vaestra-goetalands-laen/gothenburg'
                                    }, 
                                ]
                            },
                            {
                                name: 'Stockholm',
                                href: '/yachtcharter/schweden/stockholm',
                                subList: [
                                    {
                                        name: 'Stockholm',
                                        href: '/yachtcharter/schweden/stockholm/stockholm'
                                    },
                                    {
                                        name: 'Liding\xf6-Gȧshaga',
                                        href: '/yachtcharter/schweden/stockholm/lidingoe-gashaga'
                                    },
                                    {
                                        name: 'Sune Carlsson Boatyard',
                                        href: '/yachtcharter/schweden/stockholm/sune-carlsson-boatyard'
                                    },
                                    {
                                        name: 'Bulland\xf6 Marina',
                                        href: '/yachtcharter/schweden/stockholm/bullandoe-marina'
                                    },
                                    {
                                        name: 'Stockholm, Saltsj\xf6 Pir Marina',
                                        href: '/yachtcharter/schweden/stockholm/stockholm-saltsjoe-pir-marina'
                                    },
                                    {
                                        name: 'V\xe4rmd\xf6',
                                        href: '/yachtcharter/schweden/stockholm/vaermdoe'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Russland',
                icon: ru,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Russland',
                        href: '/yachtcharter/russland',
                        list: [
                            {
                                name: 'Moskau',
                                href: '/yachtcharter/russland/moskau',
                                subList: [
                                    {
                                        name: 'Novoaleksandrovo',
                                        href: '/yachtcharter/russland/moskau/novoaleksandrovo'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Malediven',
                icon: mv,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Malediven',
                        href: '/yachtcharter/malediven',
                        list: [
                            {
                                name: 'Male',
                                href: '/yachtcharter/malediven/male',
                                subList: [
                                    {
                                        name: 'Mal\xe9',
                                        href: '/yachtcharter/malediven/male/male'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Rum\xe4nien',
                icon: ro,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Rum\xe4nien',
                        href: '/yachtcharter/rumaenien',
                        list: [
                            {
                                name: 'Dobrudscha',
                                href: '/yachtcharter/rumaenien/dobrudscha',
                                subList: [
                                    {
                                        name: 'Limanu, Judetul Constanta',
                                        href: '/yachtcharter/rumaenien/dobrudscha/limanu-judetul-constanta'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Vereinigtes K\xf6nigreich',
                icon: gb,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Vereinigtes K\xf6nigreich',
                        href: '/yachtcharter/vereinigtes-koenigreich',
                        list: [
                            {
                                name: 'England',
                                href: '/yachtcharter/vereinigtes-koenigreich/england',
                                subList: [
                                    {
                                        name: 'Hamble-le-Rice',
                                        href: '/yachtcharter/vereinigtes-koenigreich/england/hamble-le-rice'
                                    },
                                    {
                                        name: 'Staffordshire',
                                        href: '/yachtcharter/vereinigtes-koenigreich/england/staffordshire'
                                    },
                                    {
                                        name: 'Chertsey',
                                        href: '/yachtcharter/vereinigtes-koenigreich/england/chertsey'
                                    },
                                    {
                                        name: 'Benson',
                                        href: '/yachtcharter/vereinigtes-koenigreich/england/benson'
                                    },
                                    {
                                        name: 'Poole',
                                        href: '/yachtcharter/vereinigtes-koenigreich/england/poole'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Island',
                icon: is,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Island',
                        href: '/yachtcharter/island',
                        list: [
                            {
                                name: 'Su\xf0urnes',
                                href: '/yachtcharter/island/sudurnes',
                                subList: [
                                    {
                                        name: 'Reykjavik',
                                        href: '/yachtcharter/island/sudurnes/reykjavik'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Mexiko',
                icon: mx,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Mexiko',
                        href: '/yachtcharter/mexiko',
                        list: [
                            {
                                name: 'Baja California Sur',
                                href: '/yachtcharter/mexiko/baja-california-sur',
                                subList: [
                                    {
                                        name: 'La Paz, Costa Baja Marina',
                                        href: '/yachtcharter/mexiko/baja-california-sur/la-paz-costa-baja-marina'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Franz\xf6sisch-Polynesien',
                icon: fr,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Franz\xf6sisch-Polynesien',
                        href: '/yachtcharter/franzoesisch-polynesien',
                        list: [
                            {
                                name: 'Tahiti',
                                href: '/yachtcharter/franzoesisch-polynesien/tahiti',
                                subList: [
                                    {
                                        name: "Puna'auia",
                                        href: '/yachtcharter/franzoesisch-polynesien/tahiti/punaauia'
                                    },
                                    {
                                        name: 'Moorea',
                                        href: '/yachtcharter/franzoesisch-polynesien/tahiti/moorea'
                                    }, 
                                ]
                            },
                            {
                                name: 'Bora Bora',
                                href: '/yachtcharter/franzoesisch-polynesien/bora-bora',
                                subList: [
                                    {
                                        name: 'Bora-Bora',
                                        href: '/yachtcharter/franzoesisch-polynesien/bora-bora/bora-bora'
                                    }, 
                                ]
                            },
                            {
                                name: 'Raiatea',
                                href: '/yachtcharter/franzoesisch-polynesien/raiatea',
                                subList: [
                                    {
                                        name: 'Raiatea',
                                        href: '/yachtcharter/franzoesisch-polynesien/raiatea/raiatea'
                                    },
                                    {
                                        name: 'Uturoa',
                                        href: '/yachtcharter/franzoesisch-polynesien/raiatea/uturoa'
                                    }, 
                                ]
                            },
                            {
                                name: 'Rangiroa',
                                href: '/yachtcharter/franzoesisch-polynesien/rangiroa',
                                subList: [
                                    {
                                        name: 'Rangiroa',
                                        href: '/yachtcharter/franzoesisch-polynesien/rangiroa/rangiroa'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Mauritius',
                icon: mu,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Mauritius',
                        href: '/yachtcharter/mauritius',
                        list: []
                    }, 
                ]
            },
            {
                name: 'Azoren',
                icon: pt,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Azoren',
                        href: '/yachtcharter/azoren',
                        list: [
                            {
                                name: 'Faial',
                                href: '/yachtcharter/azoren/faial',
                                subList: [
                                    {
                                        name: 'Horta',
                                        href: '/yachtcharter/azoren/faial/horta'
                                    }, 
                                ]
                            },
                            {
                                name: 'Terceira',
                                href: '/yachtcharter/azoren/terceira',
                                subList: [
                                    {
                                        name: 'Angra do Heriosmo',
                                        href: '/yachtcharter/azoren/terceira/angra-do-heriosmo'
                                    }, 
                                ]
                            },
                            {
                                name: 'Sao Miguel',
                                href: '/yachtcharter/azoren/sao-miguel',
                                subList: [
                                    {
                                        name: 'Ponta Delgada - Azores',
                                        href: '/yachtcharter/azoren/sao-miguel/ponta-delgada-azores'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Estland',
                icon: ee,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Estland',
                        href: '/yachtcharter/estland',
                        list: []
                    }, 
                ]
            },
            {
                name: 'Kanada',
                icon: ca,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Kanada',
                        href: '/yachtcharter/kanada',
                        list: [
                            {
                                name: 'Smith Falls',
                                href: '/yachtcharter/kanada/smith-falls',
                                subList: [
                                    {
                                        name: 'Ontario',
                                        href: '/yachtcharter/kanada/smith-falls/ontario'
                                    }, 
                                ]
                            },
                            {
                                name: 'Rideau Kanal',
                                href: '/yachtcharter/kanada/rideau-kanal',
                                subList: [
                                    {
                                        name: 'Ontario',
                                        href: '/yachtcharter/kanada/rideau-kanal/ontario'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Montenegro',
                icon: me,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Montenegro',
                        href: '/yachtcharter/montenegro',
                        list: []
                    }, 
                ]
            },
            {
                name: 'Zypern',
                icon: cy,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Zypern',
                        href: '/yachtcharter/zypern',
                        list: [
                            {
                                name: 'Limassol',
                                href: '/yachtcharter/zypern/limassol',
                                subList: [
                                    {
                                        name: 'Limassol',
                                        href: '/yachtcharter/zypern/limassol/limassol'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Brasilien',
                icon: br,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Brasilien',
                        href: '/yachtcharter/brasilien',
                        list: [
                            {
                                name: 'Rio de Janero',
                                href: '/yachtcharter/brasilien/rio-de-janero',
                                subList: [
                                    {
                                        name: 'Verolme',
                                        href: '/yachtcharter/brasilien/rio-de-janero/verolme'
                                    },
                                    {
                                        name: 'Jacuecanga, Angra dos Reis (RJ)',
                                        href: '/yachtcharter/brasilien/rio-de-janero/jacuecanga-angra-dos-reis-rj'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Panama',
                icon: pa,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Panama',
                        href: '/yachtcharter/panama',
                        list: []
                    }, 
                ]
            },
            {
                name: 'Balearische Inseln',
                icon: es,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Balearische Inseln',
                        href: '/yachtcharter/balearische-inseln',
                        list: [
                            {
                                name: 'Mallorca',
                                href: '/yachtcharter/balearische-inseln/mallorca'
                            },
                            {
                                name: 'Ibiza',
                                href: '/yachtcharter/balearische-inseln/ibiza',
                                subList: [
                                    {
                                        name: 'Ibiza',
                                        href: '/yachtcharter/balearische-inseln/ibiza/ibiza'
                                    },
                                    {
                                        name: 'Eivissa',
                                        href: '/yachtcharter/balearische-inseln/ibiza/eivissa'
                                    },
                                    {
                                        name: 'Sant Antoni',
                                        href: '/yachtcharter/balearische-inseln/ibiza/sant-antoni'
                                    },
                                    {
                                        name: 'San Antonio Abad',
                                        href: '/yachtcharter/balearische-inseln/ibiza/san-antonio-abad'
                                    }, 
                                ]
                            },
                            {
                                name: 'Menorca',
                                href: '/yachtcharter/balearische-inseln/menorca',
                                subList: [
                                    {
                                        name: 'Mahon - Menorca',
                                        href: '/yachtcharter/balearische-inseln/menorca/mahon-menorca'
                                    },
                                    {
                                        name: 'Ma\xf3',
                                        href: '/yachtcharter/balearische-inseln/menorca/mao'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Kontinente',
                header: true
            },
            {
                name: 'Afrika',
                icon: esm_GlobeIcon,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Afrika',
                        href: '/yachtcharter/afrika',
                        list: [
                            {
                                name: 'Seychellen',
                                href: '/yachtcharter/afrika/seychellen',
                                subList: [
                                    {
                                        name: 'Baie Ste Anne',
                                        href: '/yachtcharter/afrika/seychellen/baie-ste-anne'
                                    },
                                    {
                                        name: 'Mahe, Victoria',
                                        href: '/yachtcharter/afrika/seychellen/mahe-victoria'
                                    },
                                    {
                                        name: 'Grand Anse Village',
                                        href: '/yachtcharter/afrika/seychellen/grand-anse-village'
                                    },
                                    {
                                        name: 'Mahe',
                                        href: '/yachtcharter/afrika/seychellen/mahe'
                                    },
                                    {
                                        name: 'Praslin',
                                        href: '/yachtcharter/afrika/seychellen/praslin'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'S\xfcdamerika',
                icon: esm_GlobeIcon,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'S\xfcdamerika',
                        href: '/yachtcharter/suedamerika',
                        list: []
                    }, 
                ]
            },
            {
                name: 'Mittelamerika',
                icon: esm_GlobeIcon,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Mittelamerika',
                        href: '/yachtcharter/mittelamerika',
                        list: [
                            {
                                name: 'Panama',
                                href: '/yachtcharter/mittelamerika/panama',
                                subList: [
                                    {
                                        name: 'Corazon De Jesus',
                                        href: '/yachtcharter/mittelamerika/panama/corazon-de-jesus'
                                    },
                                    {
                                        name: 'Carti',
                                        href: '/yachtcharter/mittelamerika/panama/carti'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Australien',
                icon: au,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Australien',
                        href: '/yachtcharter/australien',
                        list: [
                            {
                                name: 'Queensland',
                                href: '/yachtcharter/australien/queensland',
                                subList: [
                                    {
                                        name: 'Airlie Beach',
                                        href: '/yachtcharter/australien/queensland/airlie-beach'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'S\xfcdostasien',
                icon: esm_GlobeIcon,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'S\xfcdostasien',
                        href: '/yachtcharter/suedostasien',
                        list: [
                            {
                                name: 'Thailand',
                                href: '/yachtcharter/suedostasien/thailand',
                                subList: [
                                    {
                                        name: 'Tambon Mai Khao',
                                        href: '/yachtcharter/suedostasien/thailand/tambon-mai-khao'
                                    },
                                    {
                                        name: 'Tambon Koh Chang Tai',
                                        href: '/yachtcharter/suedostasien/thailand/tambon-koh-chang-tai'
                                    },
                                    {
                                        name: 'Koh Chang',
                                        href: '/yachtcharter/suedostasien/thailand/koh-chang'
                                    },
                                    {
                                        name: 'Phuket',
                                        href: '/yachtcharter/suedostasien/thailand/phuket'
                                    },
                                    {
                                        name: 'Ko Samui',
                                        href: '/yachtcharter/suedostasien/thailand/ko-samui'
                                    },
                                    {
                                        name: 'Koh Samui',
                                        href: '/yachtcharter/suedostasien/thailand/koh-samui'
                                    }, 
                                ]
                            },
                            {
                                name: 'Phuket',
                                href: '/yachtcharter/suedostasien/phuket',
                                subList: [
                                    {
                                        name: 'Tambon Mai Khao',
                                        href: '/yachtcharter/suedostasien/phuket/tambon-mai-khao'
                                    },
                                    {
                                        name: 'Phuket',
                                        href: '/yachtcharter/suedostasien/phuket/phuket'
                                    }, 
                                ]
                            },
                            {
                                name: 'Ko Samui',
                                href: '/yachtcharter/suedostasien/ko-samui',
                                subList: [
                                    {
                                        name: 'Ko Samui',
                                        href: '/yachtcharter/suedostasien/ko-samui/ko-samui'
                                    },
                                    {
                                        name: 'Koh Samui',
                                        href: '/yachtcharter/suedostasien/ko-samui/koh-samui'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Gew\xe4sser',
                header: true
            },
            {
                name: 'Nordsee',
                icon: esm_GlobeAltIcon,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Nordsee',
                        href: '/yachtcharter/nordsee',
                        list: [
                            {
                                name: 'Ijsselmeer',
                                href: '/yachtcharter/nordsee/ijsselmeer',
                                subList: [
                                    {
                                        name: 'Lemmer',
                                        href: '/yachtcharter/nordsee/ijsselmeer/lemmer'
                                    },
                                    {
                                        name: 'Lelystad',
                                        href: '/yachtcharter/nordsee/ijsselmeer/lelystad'
                                    },
                                    {
                                        name: 'Hindeloopen',
                                        href: '/yachtcharter/nordsee/ijsselmeer/hindeloopen'
                                    }, 
                                ]
                            },
                            {
                                name: 'S\xfcdholland',
                                href: '/yachtcharter/nordsee/suedholland',
                                subList: [
                                    {
                                        name: 'Alphen aan den Rijn',
                                        href: '/yachtcharter/nordsee/suedholland/alphen-aan-den-rijn'
                                    }, 
                                ]
                            },
                            {
                                name: 'Fl\xe4mische Region',
                                href: '/yachtcharter/nordsee/flaemische-region',
                                subList: [
                                    {
                                        name: 'Zeebrugge',
                                        href: '/yachtcharter/nordsee/flaemische-region/zeebrugge'
                                    },
                                    {
                                        name: 'Kinrooi',
                                        href: '/yachtcharter/nordsee/flaemische-region/kinrooi'
                                    },
                                    {
                                        name: 'Nieuwpoort',
                                        href: '/yachtcharter/nordsee/flaemische-region/nieuwpoort'
                                    },
                                    {
                                        name: 'Brugge',
                                        href: '/yachtcharter/nordsee/flaemische-region/brugge'
                                    }, 
                                ]
                            },
                            {
                                name: 'Friesland',
                                href: '/yachtcharter/nordsee/friesland',
                                subList: [
                                    {
                                        name: 'Drachten',
                                        href: '/yachtcharter/nordsee/friesland/drachten'
                                    },
                                    {
                                        name: 'Lemmer',
                                        href: '/yachtcharter/nordsee/friesland/lemmer'
                                    },
                                    {
                                        name: 'Hindeloopen',
                                        href: '/yachtcharter/nordsee/friesland/hindeloopen'
                                    },
                                    {
                                        name: 'Woudsend',
                                        href: '/yachtcharter/nordsee/friesland/woudsend'
                                    }, 
                                ]
                            },
                            {
                                name: 'England',
                                href: '/yachtcharter/nordsee/england',
                                subList: [
                                    {
                                        name: 'Hamble-le-Rice',
                                        href: '/yachtcharter/nordsee/england/hamble-le-rice'
                                    },
                                    {
                                        name: 'Staffordshire',
                                        href: '/yachtcharter/nordsee/england/staffordshire'
                                    },
                                    {
                                        name: 'Chertsey',
                                        href: '/yachtcharter/nordsee/england/chertsey'
                                    },
                                    {
                                        name: 'Benson',
                                        href: '/yachtcharter/nordsee/england/benson'
                                    },
                                    {
                                        name: 'Poole',
                                        href: '/yachtcharter/nordsee/england/poole'
                                    }, 
                                ]
                            },
                            {
                                name: 'Island',
                                href: '/yachtcharter/nordsee/island',
                                subList: [
                                    {
                                        name: 'Reykjavik',
                                        href: '/yachtcharter/nordsee/island/reykjavik'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Ostsee',
                icon: esm_GlobeAltIcon,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Ostsee',
                        href: '/yachtcharter/ostsee',
                        list: [
                            {
                                name: 'R\xfcgen',
                                href: '/yachtcharter/ostsee/ruegen',
                                subList: [
                                    {
                                        name: 'Putbus',
                                        href: '/yachtcharter/ostsee/ruegen/putbus'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Adria',
                icon: esm_GlobeAltIcon,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Adria',
                        href: '/yachtcharter/adria',
                        list: [
                            {
                                name: 'Apulien',
                                href: '/yachtcharter/adria/apulien',
                                subList: [
                                    {
                                        name: 'Bari',
                                        href: '/yachtcharter/adria/apulien/bari'
                                    },
                                    {
                                        name: 'Rodi',
                                        href: '/yachtcharter/adria/apulien/rodi'
                                    },
                                    {
                                        name: 'San Foca',
                                        href: '/yachtcharter/adria/apulien/san-foca'
                                    },
                                    {
                                        name: 'Leuca',
                                        href: '/yachtcharter/adria/apulien/leuca'
                                    },
                                    {
                                        name: 'Taranto',
                                        href: '/yachtcharter/adria/apulien/taranto'
                                    }, 
                                ]
                            },
                            {
                                name: 'Friaul-Julisch Venetien',
                                href: '/yachtcharter/adria/friaul-julisch-venetien',
                                subList: [
                                    {
                                        name: 'Izola',
                                        href: '/yachtcharter/adria/friaul-julisch-venetien/izola'
                                    },
                                    {
                                        name: 'Muggia',
                                        href: '/yachtcharter/adria/friaul-julisch-venetien/muggia'
                                    },
                                    {
                                        name: 'Lignano Sabbiadoro',
                                        href: '/yachtcharter/adria/friaul-julisch-venetien/lignano-sabbiadoro'
                                    },
                                    {
                                        name: 'Marano',
                                        href: '/yachtcharter/adria/friaul-julisch-venetien/marano'
                                    },
                                    {
                                        name: 'Marina Portorož',
                                        href: '/yachtcharter/adria/friaul-julisch-venetien/marina-portoroz'
                                    },
                                    {
                                        name: 'Precenicco',
                                        href: '/yachtcharter/adria/friaul-julisch-venetien/precenicco'
                                    },
                                    {
                                        name: 'Precenicco',
                                        href: '/yachtcharter/adria/friaul-julisch-venetien/precenicco'
                                    }, 
                                ]
                            },
                            {
                                name: 'Marken',
                                href: '/yachtcharter/adria/marken',
                                subList: [
                                    {
                                        name: 'San Benedetto del Tronto',
                                        href: '/yachtcharter/adria/marken/san-benedetto-del-tronto'
                                    }, 
                                ]
                            },
                            {
                                name: 'Istrien',
                                href: '/yachtcharter/adria/istrien',
                                subList: [
                                    {
                                        name: 'Rijeka',
                                        href: '/yachtcharter/adria/istrien/rijeka'
                                    },
                                    {
                                        name: 'Pula',
                                        href: '/yachtcharter/adria/istrien/pula'
                                    },
                                    {
                                        name: 'Pomer',
                                        href: '/yachtcharter/adria/istrien/pomer'
                                    },
                                    {
                                        name: 'Ičići',
                                        href: '/yachtcharter/adria/istrien/icici'
                                    },
                                    {
                                        name: 'Rabac',
                                        href: '/yachtcharter/adria/istrien/rabac'
                                    },
                                    {
                                        name: 'Medulin',
                                        href: '/yachtcharter/adria/istrien/medulin'
                                    },
                                    {
                                        name: 'Rovinj',
                                        href: '/yachtcharter/adria/istrien/rovinj'
                                    },
                                    {
                                        name: 'Vrsar',
                                        href: '/yachtcharter/adria/istrien/vrsar'
                                    },
                                    {
                                        name: 'Vinkuran',
                                        href: '/yachtcharter/adria/istrien/vinkuran'
                                    },
                                    {
                                        name: 'Trget',
                                        href: '/yachtcharter/adria/istrien/trget'
                                    },
                                    {
                                        name: 'Marina Tehnomont Veruda, Pula',
                                        href: '/yachtcharter/adria/istrien/marina-tehnomont-veruda-pula'
                                    }, 
                                ]
                            },
                            {
                                name: 'Kvarner Bucht',
                                href: '/yachtcharter/adria/kvarner-bucht',
                                subList: [
                                    {
                                        name: 'Punat',
                                        href: '/yachtcharter/adria/kvarner-bucht/punat'
                                    },
                                    {
                                        name: 'Rijeka',
                                        href: '/yachtcharter/adria/kvarner-bucht/rijeka'
                                    },
                                    {
                                        name: 'Mali Lošinj',
                                        href: '/yachtcharter/adria/kvarner-bucht/mali-losinj'
                                    },
                                    {
                                        name: 'Ičići',
                                        href: '/yachtcharter/adria/kvarner-bucht/icici'
                                    },
                                    {
                                        name: 'Kraljevica',
                                        href: '/yachtcharter/adria/kvarner-bucht/kraljevica'
                                    },
                                    {
                                        name: 'Crikvenica',
                                        href: '/yachtcharter/adria/kvarner-bucht/crikvenica'
                                    },
                                    {
                                        name: 'Rab',
                                        href: '/yachtcharter/adria/kvarner-bucht/rab'
                                    },
                                    {
                                        name: 'Punat',
                                        href: '/yachtcharter/adria/kvarner-bucht/punat'
                                    },
                                    {
                                        name: 'Malinska',
                                        href: '/yachtcharter/adria/kvarner-bucht/malinska'
                                    }, 
                                ]
                            },
                            {
                                name: 'S\xfcddalmatien',
                                href: '/yachtcharter/adria/sueddalmatien',
                                subList: [
                                    {
                                        name: 'Slano',
                                        href: '/yachtcharter/adria/sueddalmatien/slano'
                                    },
                                    {
                                        name: 'Komolac',
                                        href: '/yachtcharter/adria/sueddalmatien/komolac'
                                    },
                                    {
                                        name: 'Zaton',
                                        href: '/yachtcharter/adria/sueddalmatien/zaton'
                                    },
                                    {
                                        name: 'Dubrovnik',
                                        href: '/yachtcharter/adria/sueddalmatien/dubrovnik'
                                    },
                                    {
                                        name: 'Ploče',
                                        href: '/yachtcharter/adria/sueddalmatien/ploce'
                                    },
                                    {
                                        name: 'Zaton',
                                        href: '/yachtcharter/adria/sueddalmatien/zaton'
                                    }, 
                                ]
                            },
                            {
                                name: 'Mitteldalmatien',
                                href: '/yachtcharter/adria/mitteldalmatien',
                                subList: [
                                    {
                                        name: 'Trogir',
                                        href: '/yachtcharter/adria/mitteldalmatien/trogir'
                                    },
                                    {
                                        name: 'Baška Voda',
                                        href: '/yachtcharter/adria/mitteldalmatien/baska-voda'
                                    },
                                    {
                                        name: 'Kaštel Gomilica',
                                        href: '/yachtcharter/adria/mitteldalmatien/kastel-gomilica'
                                    },
                                    {
                                        name: 'Split',
                                        href: '/yachtcharter/adria/mitteldalmatien/split'
                                    },
                                    {
                                        name: 'Seget Donji',
                                        href: '/yachtcharter/adria/mitteldalmatien/seget-donji'
                                    },
                                    {
                                        name: 'Podstrana',
                                        href: '/yachtcharter/adria/mitteldalmatien/podstrana'
                                    },
                                    {
                                        name: 'Tučepi',
                                        href: '/yachtcharter/adria/mitteldalmatien/tucepi'
                                    },
                                    {
                                        name: 'Šolta',
                                        href: '/yachtcharter/adria/mitteldalmatien/solta'
                                    },
                                    {
                                        name: 'Stobreč',
                                        href: '/yachtcharter/adria/mitteldalmatien/stobrec'
                                    },
                                    {
                                        name: 'Vinišće',
                                        href: '/yachtcharter/adria/mitteldalmatien/vinisce'
                                    },
                                    {
                                        name: 'Rogač',
                                        href: '/yachtcharter/adria/mitteldalmatien/rogac'
                                    },
                                    {
                                        name: 'Milna',
                                        href: '/yachtcharter/adria/mitteldalmatien/milna'
                                    },
                                    {
                                        name: 'Trogir',
                                        href: '/yachtcharter/adria/mitteldalmatien/trogir'
                                    },
                                    {
                                        name: 'Kaštel Lukšić',
                                        href: '/yachtcharter/adria/mitteldalmatien/kastel-luksic'
                                    }, 
                                ]
                            },
                            {
                                name: 'Norddalmatien',
                                href: '/yachtcharter/adria/norddalmatien',
                                subList: [
                                    {
                                        name: 'Rogoznica',
                                        href: '/yachtcharter/adria/norddalmatien/rogoznica'
                                    },
                                    {
                                        name: 'Šibenik',
                                        href: '/yachtcharter/adria/norddalmatien/sibenik'
                                    },
                                    {
                                        name: 'Primošten',
                                        href: '/yachtcharter/adria/norddalmatien/primosten'
                                    },
                                    {
                                        name: 'Jezera',
                                        href: '/yachtcharter/adria/norddalmatien/jezera'
                                    },
                                    {
                                        name: 'Betina',
                                        href: '/yachtcharter/adria/norddalmatien/betina'
                                    },
                                    {
                                        name: 'Bibinje',
                                        href: '/yachtcharter/adria/norddalmatien/bibinje'
                                    },
                                    {
                                        name: 'Murter',
                                        href: '/yachtcharter/adria/norddalmatien/murter'
                                    },
                                    {
                                        name: 'Biograd',
                                        href: '/yachtcharter/adria/norddalmatien/biograd'
                                    },
                                    {
                                        name: 'Pirovac',
                                        href: '/yachtcharter/adria/norddalmatien/pirovac'
                                    },
                                    {
                                        name: 'Zadar',
                                        href: '/yachtcharter/adria/norddalmatien/zadar'
                                    },
                                    {
                                        name: 'Tribunj',
                                        href: '/yachtcharter/adria/norddalmatien/tribunj'
                                    },
                                    {
                                        name: 'Petrčane',
                                        href: '/yachtcharter/adria/norddalmatien/petrcane'
                                    },
                                    {
                                        name: 'Sukošan',
                                        href: '/yachtcharter/adria/norddalmatien/sukosan'
                                    },
                                    {
                                        name: 'Kukljica',
                                        href: '/yachtcharter/adria/norddalmatien/kukljica'
                                    },
                                    {
                                        name: 'Zaton',
                                        href: '/yachtcharter/adria/norddalmatien/zaton'
                                    },
                                    {
                                        name: 'Vodice',
                                        href: '/yachtcharter/adria/norddalmatien/vodice'
                                    },
                                    {
                                        name: 'Biograd',
                                        href: '/yachtcharter/adria/norddalmatien/biograd'
                                    },
                                    {
                                        name: 'Skradin',
                                        href: '/yachtcharter/adria/norddalmatien/skradin'
                                    },
                                    {
                                        name: 'Šibenik',
                                        href: '/yachtcharter/adria/norddalmatien/sibenik'
                                    },
                                    {
                                        name: 'Drage',
                                        href: '/yachtcharter/adria/norddalmatien/drage'
                                    },
                                    {
                                        name: 'Biograd na Moru',
                                        href: '/yachtcharter/adria/norddalmatien/biograd-na-moru'
                                    }, 
                                ]
                            },
                            {
                                name: 'Montenegro',
                                href: '/yachtcharter/adria/montenegro',
                                subList: [
                                    {
                                        name: 'Tivat',
                                        href: '/yachtcharter/adria/montenegro/tivat'
                                    },
                                    {
                                        name: 'Kotor',
                                        href: '/yachtcharter/adria/montenegro/kotor'
                                    },
                                    {
                                        name: 'Herceg Novi',
                                        href: '/yachtcharter/adria/montenegro/herceg-novi'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Ozeanien',
                icon: esm_GlobeAltIcon,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Ozeanien',
                        href: '/yachtcharter/ozeanien',
                        list: [
                            {
                                name: 'Neukaledonien',
                                href: '/yachtcharter/ozeanien/neukaledonien',
                                subList: [
                                    {
                                        name: 'Noumea',
                                        href: '/yachtcharter/ozeanien/neukaledonien/noumea'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Mittelmeer',
                icon: esm_GlobeAltIcon,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Mittelmeer',
                        href: '/yachtcharter/mittelmeer',
                        list: [
                            {
                                name: 'Zypern',
                                href: '/yachtcharter/mittelmeer/zypern',
                                subList: [
                                    {
                                        name: 'Limassol',
                                        href: '/yachtcharter/mittelmeer/zypern/limassol'
                                    }, 
                                ]
                            },
                            {
                                name: 'C\xf4te d’Azur',
                                href: '/yachtcharter/mittelmeer/cote-d-azur',
                                subList: [
                                    {
                                        name: 'Saint-Mandrier-sur-Mer',
                                        href: '/yachtcharter/mittelmeer/cote-d-azur/saint-mandrier-sur-mer'
                                    },
                                    {
                                        name: 'Bormes-les-Mimosas',
                                        href: '/yachtcharter/mittelmeer/cote-d-azur/bormes-les-mimosas'
                                    },
                                    {
                                        name: 'Cogolin',
                                        href: '/yachtcharter/mittelmeer/cote-d-azur/cogolin'
                                    },
                                    {
                                        name: 'Hyeres',
                                        href: '/yachtcharter/mittelmeer/cote-d-azur/hyeres'
                                    },
                                    {
                                        name: 'Nice',
                                        href: '/yachtcharter/mittelmeer/cote-d-azur/nice'
                                    },
                                    {
                                        name: 'Toulon',
                                        href: '/yachtcharter/mittelmeer/cote-d-azur/toulon'
                                    },
                                    {
                                        name: 'Marseille',
                                        href: '/yachtcharter/mittelmeer/cote-d-azur/marseille'
                                    },
                                    {
                                        name: 'Grimaud',
                                        href: '/yachtcharter/mittelmeer/cote-d-azur/grimaud'
                                    },
                                    {
                                        name: 'Vallauris',
                                        href: '/yachtcharter/mittelmeer/cote-d-azur/vallauris'
                                    },
                                    {
                                        name: 'Saint-Rapha\xebl',
                                        href: '/yachtcharter/mittelmeer/cote-d-azur/saint-raphael'
                                    }, 
                                ]
                            },
                            {
                                name: 'Franz\xf6sische Mittelmeerk\xfcste',
                                href: '/yachtcharter/mittelmeer/franzoesische-mittelmeerkueste',
                                subList: [
                                    {
                                        name: 'Lattes',
                                        href: '/yachtcharter/mittelmeer/franzoesische-mittelmeerkueste/lattes'
                                    },
                                    {
                                        name: 'Bellegarde',
                                        href: '/yachtcharter/mittelmeer/franzoesische-mittelmeerkueste/bellegarde'
                                    },
                                    {
                                        name: 'Saint-Mandrier-sur-Mer',
                                        href: '/yachtcharter/mittelmeer/franzoesische-mittelmeerkueste/saint-mandrier-sur-mer'
                                    },
                                    {
                                        name: 'Capestang',
                                        href: '/yachtcharter/mittelmeer/franzoesische-mittelmeerkueste/capestang'
                                    },
                                    {
                                        name: 'Bormes-les-Mimosas',
                                        href: '/yachtcharter/mittelmeer/franzoesische-mittelmeerkueste/bormes-les-mimosas'
                                    },
                                    {
                                        name: 'Cogolin',
                                        href: '/yachtcharter/mittelmeer/franzoesische-mittelmeerkueste/cogolin'
                                    },
                                    {
                                        name: 'Hyeres',
                                        href: '/yachtcharter/mittelmeer/franzoesische-mittelmeerkueste/hyeres'
                                    },
                                    {
                                        name: 'Nice',
                                        href: '/yachtcharter/mittelmeer/franzoesische-mittelmeerkueste/nice'
                                    },
                                    {
                                        name: 'Toulon',
                                        href: '/yachtcharter/mittelmeer/franzoesische-mittelmeerkueste/toulon'
                                    },
                                    {
                                        name: 'Marseille',
                                        href: '/yachtcharter/mittelmeer/franzoesische-mittelmeerkueste/marseille'
                                    },
                                    {
                                        name: 'Grimaud',
                                        href: '/yachtcharter/mittelmeer/franzoesische-mittelmeerkueste/grimaud'
                                    },
                                    {
                                        name: 'Vallauris',
                                        href: '/yachtcharter/mittelmeer/franzoesische-mittelmeerkueste/vallauris'
                                    },
                                    {
                                        name: 'Saint-Rapha\xebl',
                                        href: '/yachtcharter/mittelmeer/franzoesische-mittelmeerkueste/saint-raphael'
                                    },
                                    {
                                        name: 'Agde',
                                        href: '/yachtcharter/mittelmeer/franzoesische-mittelmeerkueste/agde'
                                    },
                                    {
                                        name: 'Carnon',
                                        href: '/yachtcharter/mittelmeer/franzoesische-mittelmeerkueste/carnon'
                                    },
                                    {
                                        name: 'Colombiers',
                                        href: '/yachtcharter/mittelmeer/franzoesische-mittelmeerkueste/colombiers'
                                    },
                                    {
                                        name: 'Portiranges',
                                        href: '/yachtcharter/mittelmeer/franzoesische-mittelmeerkueste/portiranges'
                                    },
                                    {
                                        name: 'St. Gilles',
                                        href: '/yachtcharter/mittelmeer/franzoesische-mittelmeerkueste/st-gilles'
                                    }, 
                                ]
                            },
                            {
                                name: 'Westliches Mittelmeer',
                                href: '/yachtcharter/mittelmeer/westliches-mittelmeer',
                                subList: [
                                    {
                                        name: 'Lattes',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/lattes'
                                    },
                                    {
                                        name: 'Bellegarde',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/bellegarde'
                                    },
                                    {
                                        name: 'Tonnarella',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/tonnarella'
                                    },
                                    {
                                        name: 'Marina',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/marina'
                                    },
                                    {
                                        name: 'Mergellina',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/mergellina'
                                    },
                                    {
                                        name: 'Marsala',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/marsala'
                                    },
                                    {
                                        name: 'Pozzuoli',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/pozzuoli'
                                    },
                                    {
                                        name: 'Cagliari',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/cagliari'
                                    },
                                    {
                                        name: 'La Maddalena',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/la-maddalena'
                                    },
                                    {
                                        name: 'Olbia',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/olbia'
                                    },
                                    {
                                        name: 'Portocolom',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/portocolom'
                                    },
                                    {
                                        name: 'Barcelona',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/barcelona'
                                    },
                                    {
                                        name: 'Roses',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/roses'
                                    },
                                    {
                                        name: 'Llucmajor',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/llucmajor'
                                    },
                                    {
                                        name: "Cala D'or",
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/cala-dor'
                                    },
                                    {
                                        name: 'Genova',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/genova'
                                    },
                                    {
                                        name: 'Girona',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/girona'
                                    },
                                    {
                                        name: 'Palermo',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/palermo'
                                    },
                                    {
                                        name: 'Palma de Mallorca',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/palma-de-mallorca'
                                    },
                                    {
                                        name: 'Denia',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/denia'
                                    },
                                    {
                                        name: 'Golfo Aranci',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/golfo-aranci'
                                    },
                                    {
                                        name: 'Saint-Mandrier-sur-Mer',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/saint-mandrier-sur-mer'
                                    },
                                    {
                                        name: 'Rome',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/rome'
                                    },
                                    {
                                        name: 'El Masnou',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/el-masnou'
                                    },
                                    {
                                        name: 'Palamos',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/palamos'
                                    },
                                    {
                                        name: 'Cecina',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/cecina'
                                    },
                                    {
                                        name: 'Puntone',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/puntone'
                                    },
                                    {
                                        name: 'Furnari',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/furnari'
                                    },
                                    {
                                        name: 'Capestang',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/capestang'
                                    },
                                    {
                                        name: 'Ragusa',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/ragusa'
                                    },
                                    {
                                        name: 'San Vincenzo',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/san-vincenzo'
                                    },
                                    {
                                        name: 'Ibiza',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/ibiza'
                                    },
                                    {
                                        name: 'La Spezia',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/la-spezia'
                                    },
                                    {
                                        name: 'Tropea',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/tropea'
                                    },
                                    {
                                        name: 'Mataro',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/mataro'
                                    },
                                    {
                                        name: 'Propriano',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/propriano'
                                    },
                                    {
                                        name: 'Alcudia',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/alcudia'
                                    },
                                    {
                                        name: 'Milazzo',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/milazzo'
                                    },
                                    {
                                        name: 'S. Agata di Militello',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/s-agata-di-militello'
                                    },
                                    {
                                        name: 'Port de Pollen\xe7a',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/port-de-pollenca'
                                    },
                                    {
                                        name: 'Santa Maria Navarrese',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/santa-maria-navarrese'
                                    },
                                    {
                                        name: "Capo d'Orlando",
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/capo-dorlando'
                                    },
                                    {
                                        name: 'Can Pastilla',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/can-pastilla'
                                    },
                                    {
                                        name: 'Santa Pon\xe7a',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/santa-ponca'
                                    },
                                    {
                                        name: 'Trapani',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/trapani'
                                    },
                                    {
                                        name: 'Vibo Marina',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/vibo-marina'
                                    },
                                    {
                                        name: 'Viareggio',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/viareggio'
                                    },
                                    {
                                        name: 'San Vito Lo Capo',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/san-vito-lo-capo'
                                    },
                                    {
                                        name: 'Punta Ala',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/punta-ala'
                                    },
                                    {
                                        name: 'Procida',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/procida'
                                    },
                                    {
                                        name: 'Portoferraio',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/portoferraio'
                                    },
                                    {
                                        name: 'Portovenere',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/portovenere'
                                    },
                                    {
                                        name: 'Porto Rotondo',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/porto-rotondo'
                                    },
                                    {
                                        name: 'Portisco',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/portisco'
                                    },
                                    {
                                        name: 'Bormes-les-Mimosas',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/bormes-les-mimosas'
                                    },
                                    {
                                        name: 'Lipari',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/lipari'
                                    },
                                    {
                                        name: 'Cogolin',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/cogolin'
                                    },
                                    {
                                        name: 'Castellammare di Stabia',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/castellammare-di-stabia'
                                    },
                                    {
                                        name: 'Carloforte',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/carloforte'
                                    },
                                    {
                                        name: 'Cannigione',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/cannigione'
                                    },
                                    {
                                        name: 'Bocca di Magra',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/bocca-di-magra'
                                    },
                                    {
                                        name: 'Anzio',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/anzio'
                                    },
                                    {
                                        name: 'Alghero',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/alghero'
                                    },
                                    {
                                        name: 'Agropoli',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/agropoli'
                                    },
                                    {
                                        name: 'Valencia',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/valencia'
                                    },
                                    {
                                        name: 'Reggio Calabria',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/reggio-calabria'
                                    },
                                    {
                                        name: 'Cambrils',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/cambrils'
                                    },
                                    {
                                        name: 'Castiglioncello',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/castiglioncello'
                                    },
                                    {
                                        name: 'Mahon - Menorca',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/mahon-menorca'
                                    },
                                    {
                                        name: 'Ajaccio',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/ajaccio'
                                    },
                                    {
                                        name: 'Arzachena',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/arzachena'
                                    },
                                    {
                                        name: 'Hyeres',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/hyeres'
                                    },
                                    {
                                        name: 'Kalkara',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/kalkara'
                                    },
                                    {
                                        name: 'Nice',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/nice'
                                    },
                                    {
                                        name: 'Toulon',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/toulon'
                                    },
                                    {
                                        name: 'Marseille',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/marseille'
                                    },
                                    {
                                        name: 'Grimaud',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/grimaud'
                                    },
                                    {
                                        name: 'Premi\xe0 de Mar, Barcelona',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/premia-de-mar-barcelona'
                                    },
                                    {
                                        name: 'Roda de Bar\xe0',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/roda-de-bara'
                                    },
                                    {
                                        name: 'Rosignano Solvay',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/rosignano-solvay'
                                    },
                                    {
                                        name: 'Santany\xed',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/santanyi'
                                    },
                                    {
                                        name: 'Eivissa',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/eivissa'
                                    },
                                    {
                                        name: 'Ma\xf3',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/mao'
                                    },
                                    {
                                        name: 'San Gregorio-bagnoli',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/san-gregorio-bagnoli'
                                    },
                                    {
                                        name: 'Pollen\xe7a',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/pollenca'
                                    },
                                    {
                                        name: 'Portals Nous-Calvi\xe0',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/portals-nous-calvia'
                                    },
                                    {
                                        name: 'La Vila Joiosa',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/la-vila-joiosa'
                                    },
                                    {
                                        name: 'Vallauris',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/vallauris'
                                    },
                                    {
                                        name: 'Saint-Rapha\xebl',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/saint-raphael'
                                    },
                                    {
                                        name: 'Amalfi',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/amalfi'
                                    },
                                    {
                                        name: 'Sitges',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/sitges'
                                    },
                                    {
                                        name: 'Castellammare del Golfo',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/castellammare-del-golfo'
                                    },
                                    {
                                        name: 'Agde',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/agde'
                                    },
                                    {
                                        name: 'Carnon',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/carnon'
                                    },
                                    {
                                        name: 'Colombiers',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/colombiers'
                                    },
                                    {
                                        name: 'Porto di Castellammare di Stabia',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/porto-di-castellammare-di-stabia'
                                    },
                                    {
                                        name: 'Salivoli',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/salivoli'
                                    },
                                    {
                                        name: 'Sant Antoni',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/sant-antoni'
                                    },
                                    {
                                        name: 'Aranci',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/aranci'
                                    },
                                    {
                                        name: 'Nettuno',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/nettuno'
                                    },
                                    {
                                        name: 'Palma',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/palma'
                                    },
                                    {
                                        name: 'Salerno',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/salerno'
                                    },
                                    {
                                        name: 'Napoli',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/napoli'
                                    },
                                    {
                                        name: 'Il-Kalkara',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/il-kalkara'
                                    },
                                    {
                                        name: 'Cannigione Arzachena',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/cannigione-arzachena'
                                    },
                                    {
                                        name: 'Naples',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/naples'
                                    },
                                    {
                                        name: 'Sitges, Barcelona',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/sitges-barcelona'
                                    },
                                    {
                                        name: 'Balestrate',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/balestrate'
                                    },
                                    {
                                        name: 'Portiranges',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/portiranges'
                                    },
                                    {
                                        name: 'St. Gilles',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/st-gilles'
                                    },
                                    {
                                        name: 'Gandia',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/gandia'
                                    },
                                    {
                                        name: 'Torredembarra',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/torredembarra'
                                    },
                                    {
                                        name: "Capo D'orlando Marina",
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/capo-dorlando-marina'
                                    },
                                    {
                                        name: 'Marina di Scarlino - Follonica',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/marina-di-scarlino-follonica'
                                    },
                                    {
                                        name: 'San Antonio Abad',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/san-antonio-abad'
                                    },
                                    {
                                        name: 'Marina Villa Igea, Palermo',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/marina-villa-igea-palermo'
                                    },
                                    {
                                        name: 'Rosignano Solvay-Castiglioncello',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/rosignano-solvay-castiglioncello'
                                    },
                                    {
                                        name: 'Roda de Ber\xe0',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/roda-de-bera'
                                    },
                                    {
                                        name: 'Neapel',
                                        href: '/yachtcharter/mittelmeer/westliches-mittelmeer/neapel'
                                    }, 
                                ]
                            },
                            {
                                name: '\xd6stliches Mittelmeer',
                                href: '/yachtcharter/mittelmeer/oestliches-mittelmeer',
                                subList: [
                                    {
                                        name: 'Chioggia',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/chioggia'
                                    },
                                    {
                                        name: 'Rogoznica',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/rogoznica'
                                    },
                                    {
                                        name: 'Šibenik',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/sibenik'
                                    },
                                    {
                                        name: 'Primošten',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/primosten'
                                    },
                                    {
                                        name: 'Trogir',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/trogir'
                                    },
                                    {
                                        name: 'Slano',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/slano'
                                    },
                                    {
                                        name: 'Komolac',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/komolac'
                                    },
                                    {
                                        name: 'Baška Voda',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/baska-voda'
                                    },
                                    {
                                        name: 'Kaštel Gomilica',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/kastel-gomilica'
                                    },
                                    {
                                        name: 'Split',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/split'
                                    },
                                    {
                                        name: 'Jezera',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/jezera'
                                    },
                                    {
                                        name: 'Alimos',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/alimos'
                                    },
                                    {
                                        name: 'Kos',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/kos'
                                    },
                                    {
                                        name: 'Lavrio',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/lavrio'
                                    },
                                    {
                                        name: 'Lefkada',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/lefkada'
                                    },
                                    {
                                        name: 'Betina',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/betina'
                                    },
                                    {
                                        name: 'Bibinje',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/bibinje'
                                    },
                                    {
                                        name: 'Murter',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/murter'
                                    },
                                    {
                                        name: 'Biograd',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/biograd'
                                    },
                                    {
                                        name: 'Pirovac',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/pirovac'
                                    },
                                    {
                                        name: 'Punat',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/punat'
                                    },
                                    {
                                        name: 'Zadar',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/zadar'
                                    },
                                    {
                                        name: 'Tourlos',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/tourlos'
                                    },
                                    {
                                        name: 'Rijeka',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/rijeka'
                                    },
                                    {
                                        name: 'Skiathos',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/skiathos'
                                    },
                                    {
                                        name: 'Volos',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/volos'
                                    },
                                    {
                                        name: 'Kalamata',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/kalamata'
                                    },
                                    {
                                        name: 'Sami',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/sami'
                                    },
                                    {
                                        name: 'Ermoupoli',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/ermoupoli'
                                    },
                                    {
                                        name: 'Seget Donji',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/seget-donji'
                                    },
                                    {
                                        name: 'Pula',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/pula'
                                    },
                                    {
                                        name: 'Elliniko',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/elliniko'
                                    },
                                    {
                                        name: 'Pomer',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/pomer'
                                    },
                                    {
                                        name: 'Mali Lošinj',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/mali-losinj'
                                    },
                                    {
                                        name: 'Podstrana',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/podstrana'
                                    },
                                    {
                                        name: 'Tribunj',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/tribunj'
                                    },
                                    {
                                        name: 'Tivat',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/tivat'
                                    },
                                    {
                                        name: 'Paleros',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/paleros'
                                    },
                                    {
                                        name: 'Preveza',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/preveza'
                                    },
                                    {
                                        name: 'Ičići',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/icici'
                                    },
                                    {
                                        name: 'Rabac',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/rabac'
                                    },
                                    {
                                        name: 'Marina di Montenero di Bisaccia',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/marina-di-montenero-di-bisaccia'
                                    },
                                    {
                                        name: 'San Benedetto del Tronto',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/san-benedetto-del-tronto'
                                    },
                                    {
                                        name: 'Petrčane',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/petrcane'
                                    },
                                    {
                                        name: 'Izola',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/izola'
                                    },
                                    {
                                        name: 'Orhaniye',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/orhaniye'
                                    },
                                    {
                                        name: 'Neos Marmaras',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/neos-marmaras'
                                    },
                                    {
                                        name: 'Piraeus',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/piraeus'
                                    },
                                    {
                                        name: 'Medulin',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/medulin'
                                    },
                                    {
                                        name: 'Muggia',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/muggia'
                                    },
                                    {
                                        name: 'Athen',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/athen'
                                    },
                                    {
                                        name: 'Syros',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/syros'
                                    },
                                    {
                                        name: 'Marmaris',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/marmaris'
                                    },
                                    {
                                        name: 'Rovinj',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/rovinj'
                                    },
                                    {
                                        name: 'Bari',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/bari'
                                    },
                                    {
                                        name: 'Tučepi',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/tucepi'
                                    },
                                    {
                                        name: 'Šolta',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/solta'
                                    },
                                    {
                                        name: 'Heraklion',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/heraklion'
                                    },
                                    {
                                        name: 'Zaton',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/zaton'
                                    },
                                    {
                                        name: 'Rodi',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/rodi'
                                    },
                                    {
                                        name: 'Sukošan',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/sukosan'
                                    },
                                    {
                                        name: 'Skopelos',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/skopelos'
                                    },
                                    {
                                        name: 'Paros',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/paros'
                                    },
                                    {
                                        name: 'Santorini',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/santorini'
                                    },
                                    {
                                        name: 'Thessaloniki',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/thessaloniki'
                                    },
                                    {
                                        name: 'Dubrovnik',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/dubrovnik'
                                    },
                                    {
                                        name: 'Stobreč',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/stobrec'
                                    },
                                    {
                                        name: 'Palairos',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/palairos'
                                    },
                                    {
                                        name: 'Kraljevica',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/kraljevica'
                                    },
                                    {
                                        name: 'Caorle ',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/caorle'
                                    },
                                    {
                                        name: 'Agia Eufimia',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/agia-eufimia'
                                    },
                                    {
                                        name: 'Kotor',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/kotor'
                                    },
                                    {
                                        name: 'Kukljica',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/kukljica'
                                    },
                                    {
                                        name: 'Vinišće',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/vinisce'
                                    },
                                    {
                                        name: 'San Foca',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/san-foca'
                                    },
                                    {
                                        name: 'Vrsar',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/vrsar'
                                    },
                                    {
                                        name: 'Leuca',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/leuca'
                                    },
                                    {
                                        name: 'Kavala',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/kavala'
                                    },
                                    {
                                        name: 'Lignano Sabbiadoro',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/lignano-sabbiadoro'
                                    },
                                    {
                                        name: 'Zakynthos',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/zakynthos'
                                    },
                                    {
                                        name: 'Taranto',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/taranto'
                                    },
                                    {
                                        name: 'Mykonos',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/mykonos'
                                    },
                                    {
                                        name: 'Ravenna',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/ravenna'
                                    },
                                    {
                                        name: 'Zaton',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/zaton'
                                    },
                                    {
                                        name: 'Vodice',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/vodice'
                                    },
                                    {
                                        name: 'Biograd',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/biograd'
                                    },
                                    {
                                        name: 'Bodrum',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/bodrum'
                                    },
                                    {
                                        name: 'Crikvenica',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/crikvenica'
                                    },
                                    {
                                        name: 'Limassol',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/limassol'
                                    },
                                    {
                                        name: 'G\xf6cek',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/goecek'
                                    },
                                    {
                                        name: 'Herceg Novi',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/herceg-novi'
                                    },
                                    {
                                        name: 'Kerkira',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/kerkira'
                                    },
                                    {
                                        name: 'Skradin',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/skradin'
                                    },
                                    {
                                        name: 'Ormos Panagias',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/ormos-panagias'
                                    },
                                    {
                                        name: 'Palaio Faliro',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/palaio-faliro'
                                    },
                                    {
                                        name: 'Fethiye',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/fethiye'
                                    },
                                    {
                                        name: 'Ploče',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/ploce'
                                    },
                                    {
                                        name: 'Sivota',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/sivota'
                                    },
                                    {
                                        name: 'Keramoti',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/keramoti'
                                    },
                                    {
                                        name: 'Corfu',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/corfu'
                                    },
                                    {
                                        name: 'Achillio',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/achillio'
                                    },
                                    {
                                        name: 'Pireas',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/pireas'
                                    },
                                    {
                                        name: 'Mikonos',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/mikonos'
                                    },
                                    {
                                        name: 'Piso Livadi',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/piso-livadi'
                                    },
                                    {
                                        name: 'Rhodos',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/rhodos'
                                    },
                                    {
                                        name: 'Kontokali',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/kontokali'
                                    },
                                    {
                                        name: 'Nikiana',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/nikiana'
                                    },
                                    {
                                        name: 'Nidri',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/nidri'
                                    },
                                    {
                                        name: 'Rogač',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/rogac'
                                    },
                                    {
                                        name: 'Glifada',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/glifada'
                                    },
                                    {
                                        name: 'Milna',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/milna'
                                    },
                                    {
                                        name: 'Marano',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/marano'
                                    },
                                    {
                                        name: 'Kefalonia',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/kefalonia'
                                    },
                                    {
                                        name: 'Gouvia',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/gouvia'
                                    },
                                    {
                                        name: 'Nikiti',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/nikiti'
                                    },
                                    {
                                        name: 'Nea Peramos - Attica',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/nea-peramos-attica'
                                    },
                                    {
                                        name: 'Halkidiki',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/halkidiki'
                                    },
                                    {
                                        name: 'Marina Portorož',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/marina-portoroz'
                                    },
                                    {
                                        name: 'Trogir',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/trogir'
                                    },
                                    {
                                        name: 'Šibenik',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/sibenik'
                                    },
                                    {
                                        name: 'Thasos',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/thasos'
                                    },
                                    {
                                        name: 'Athens',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/athens'
                                    },
                                    {
                                        name: 'Ialisos',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/ialisos'
                                    },
                                    {
                                        name: 'Rab',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/rab'
                                    },
                                    {
                                        name: 'Ece Saray Marina Resort, Fethiye',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/ece-saray-marina-resort-fethiye'
                                    },
                                    {
                                        name: 'Marmaris, Netsel Marina',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/marmaris-netsel-marina'
                                    },
                                    {
                                        name: 'Casale sul Sile',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/casale-sul-sile'
                                    },
                                    {
                                        name: 'Precenicco',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/precenicco'
                                    },
                                    {
                                        name: 'Aegina',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/aegina'
                                    },
                                    {
                                        name: 'Kallithea',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/kallithea'
                                    },
                                    {
                                        name: 'Lughignano',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/lughignano'
                                    },
                                    {
                                        name: 'Precenicco',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/precenicco'
                                    },
                                    {
                                        name: 'Punat',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/punat'
                                    },
                                    {
                                        name: 'Elefsina',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/elefsina'
                                    },
                                    {
                                        name: 'Patra ',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/patra'
                                    },
                                    {
                                        name: 'Salamina',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/salamina'
                                    },
                                    {
                                        name: 'Malinska',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/malinska'
                                    },
                                    {
                                        name: 'Naoussa',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/naoussa'
                                    },
                                    {
                                        name: 'Nea Peramos',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/nea-peramos'
                                    },
                                    {
                                        name: 'Vinkuran',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/vinkuran'
                                    },
                                    {
                                        name: 'Zaton',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/zaton'
                                    },
                                    {
                                        name: 'Cleopatra Marina (Preveza)',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/cleopatra-marina-preveza'
                                    },
                                    {
                                        name: 'Bodrum/Turgutreis/D-Marin',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/bodrum-turgutreis-d-marin'
                                    },
                                    {
                                        name: 'G\xf6cek/D-Marin',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/goecek-d-marin'
                                    },
                                    {
                                        name: 'Vlicho',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/vlicho'
                                    },
                                    {
                                        name: 'Rhodos',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/rhodos'
                                    },
                                    {
                                        name: 'Marin Turk G\xf6cek Village Port',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/marin-turk-goecek-village-port'
                                    },
                                    {
                                        name: 'Milta Bodrum Marina',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/milta-bodrum-marina'
                                    },
                                    {
                                        name: 'Kas Marina',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/kas-marina'
                                    },
                                    {
                                        name: 'Trget',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/trget'
                                    },
                                    {
                                        name: 'Marina Tehnomont Veruda, Pula',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/marina-tehnomont-veruda-pula'
                                    },
                                    {
                                        name: 'Yacht Classic Hotel Marina, Fethiye',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/yacht-classic-hotel-marina-fethiye'
                                    },
                                    {
                                        name: 'Marmaris Yacht Marina',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/marmaris-yacht-marina'
                                    },
                                    {
                                        name: 'Limenas Thassos',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/limenas-thassos'
                                    },
                                    {
                                        name: 'Yes Marina',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/yes-marina'
                                    },
                                    {
                                        name: 'G\xf6kova \xd6ren Marina',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/goekova-oeren-marina'
                                    },
                                    {
                                        name: 'Drage',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/drage'
                                    },
                                    {
                                        name: 'Ermioni',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/ermioni'
                                    },
                                    {
                                        name: 'Egina',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/egina'
                                    },
                                    {
                                        name: 'G\xf6cek/Skopea Marina',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/goecek-skopea-marina'
                                    },
                                    {
                                        name: 'Yacht Club Marina Salamina, Athens area',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/yacht-club-marina-salamina-athens-area'
                                    },
                                    {
                                        name: 'Limenas Avdiron',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/limenas-avdiron'
                                    },
                                    {
                                        name: 'Corfu, Mandraki',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/corfu-mandraki'
                                    },
                                    {
                                        name: 'Marmaris Adakoy Marina',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/marmaris-adakoy-marina'
                                    },
                                    {
                                        name: 'Kaštel Lukšić',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/kastel-luksic'
                                    },
                                    {
                                        name: 'Palmarina - Yalikavak, Bodrum',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/palmarina-yalikavak-bodrum'
                                    },
                                    {
                                        name: 'Biograd na Moru',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/biograd-na-moru'
                                    },
                                    {
                                        name: 'Benitses, Corfu',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/benitses-corfu'
                                    },
                                    {
                                        name: 'Bodrum, G\xfcmbet Marina',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/bodrum-guembet-marina'
                                    },
                                    {
                                        name: 'Marmaris, Joya Del Mar Marina',
                                        href: '/yachtcharter/mittelmeer/oestliches-mittelmeer/marmaris-joya-del-mar-marina'
                                    }, 
                                ]
                            },
                            {
                                name: 'Balearische Inseln',
                                href: '/yachtcharter/mittelmeer/balearische-inseln',
                                subList: [
                                    {
                                        name: 'Portocolom',
                                        href: '/yachtcharter/mittelmeer/balearische-inseln/portocolom'
                                    },
                                    {
                                        name: 'Llucmajor',
                                        href: '/yachtcharter/mittelmeer/balearische-inseln/llucmajor'
                                    },
                                    {
                                        name: "Cala D'or",
                                        href: '/yachtcharter/mittelmeer/balearische-inseln/cala-dor'
                                    },
                                    {
                                        name: 'Palma de Mallorca',
                                        href: '/yachtcharter/mittelmeer/balearische-inseln/palma-de-mallorca'
                                    },
                                    {
                                        name: 'Ibiza',
                                        href: '/yachtcharter/mittelmeer/balearische-inseln/ibiza'
                                    },
                                    {
                                        name: 'Alcudia',
                                        href: '/yachtcharter/mittelmeer/balearische-inseln/alcudia'
                                    },
                                    {
                                        name: 'Port de Pollen\xe7a',
                                        href: '/yachtcharter/mittelmeer/balearische-inseln/port-de-pollenca'
                                    },
                                    {
                                        name: 'Can Pastilla',
                                        href: '/yachtcharter/mittelmeer/balearische-inseln/can-pastilla'
                                    },
                                    {
                                        name: 'Santa Pon\xe7a',
                                        href: '/yachtcharter/mittelmeer/balearische-inseln/santa-ponca'
                                    },
                                    {
                                        name: 'Mahon - Menorca',
                                        href: '/yachtcharter/mittelmeer/balearische-inseln/mahon-menorca'
                                    },
                                    {
                                        name: 'Santany\xed',
                                        href: '/yachtcharter/mittelmeer/balearische-inseln/santanyi'
                                    },
                                    {
                                        name: 'Eivissa',
                                        href: '/yachtcharter/mittelmeer/balearische-inseln/eivissa'
                                    },
                                    {
                                        name: 'Ma\xf3',
                                        href: '/yachtcharter/mittelmeer/balearische-inseln/mao'
                                    },
                                    {
                                        name: 'Pollen\xe7a',
                                        href: '/yachtcharter/mittelmeer/balearische-inseln/pollenca'
                                    },
                                    {
                                        name: 'Portals Nous-Calvi\xe0',
                                        href: '/yachtcharter/mittelmeer/balearische-inseln/portals-nous-calvia'
                                    },
                                    {
                                        name: 'Sant Antoni',
                                        href: '/yachtcharter/mittelmeer/balearische-inseln/sant-antoni'
                                    },
                                    {
                                        name: 'Palma',
                                        href: '/yachtcharter/mittelmeer/balearische-inseln/palma'
                                    },
                                    {
                                        name: 'San Antonio Abad',
                                        href: '/yachtcharter/mittelmeer/balearische-inseln/san-antonio-abad'
                                    }, 
                                ]
                            },
                            {
                                name: 'Mallorca',
                                href: '/yachtcharter/mittelmeer/mallorca',
                                subList: [
                                    {
                                        name: 'Portocolom',
                                        href: '/yachtcharter/mittelmeer/mallorca/portocolom'
                                    },
                                    {
                                        name: 'Llucmajor',
                                        href: '/yachtcharter/mittelmeer/mallorca/llucmajor'
                                    },
                                    {
                                        name: "Cala D'or",
                                        href: '/yachtcharter/mittelmeer/mallorca/cala-dor'
                                    },
                                    {
                                        name: 'Palma de Mallorca',
                                        href: '/yachtcharter/mittelmeer/mallorca/palma-de-mallorca'
                                    },
                                    {
                                        name: 'Alcudia',
                                        href: '/yachtcharter/mittelmeer/mallorca/alcudia'
                                    },
                                    {
                                        name: 'Port de Pollen\xe7a',
                                        href: '/yachtcharter/mittelmeer/mallorca/port-de-pollenca'
                                    },
                                    {
                                        name: 'Can Pastilla',
                                        href: '/yachtcharter/mittelmeer/mallorca/can-pastilla'
                                    },
                                    {
                                        name: 'Santa Pon\xe7a',
                                        href: '/yachtcharter/mittelmeer/mallorca/santa-ponca'
                                    },
                                    {
                                        name: 'Santany\xed',
                                        href: '/yachtcharter/mittelmeer/mallorca/santanyi'
                                    },
                                    {
                                        name: 'Pollen\xe7a',
                                        href: '/yachtcharter/mittelmeer/mallorca/pollenca'
                                    },
                                    {
                                        name: 'Portals Nous-Calvi\xe0',
                                        href: '/yachtcharter/mittelmeer/mallorca/portals-nous-calvia'
                                    },
                                    {
                                        name: 'Palma',
                                        href: '/yachtcharter/mittelmeer/mallorca/palma'
                                    }, 
                                ]
                            },
                            {
                                name: 'Ibiza',
                                href: '/yachtcharter/mittelmeer/ibiza',
                                subList: [
                                    {
                                        name: 'Ibiza',
                                        href: '/yachtcharter/mittelmeer/ibiza/ibiza'
                                    },
                                    {
                                        name: 'Eivissa',
                                        href: '/yachtcharter/mittelmeer/ibiza/eivissa'
                                    },
                                    {
                                        name: 'Sant Antoni',
                                        href: '/yachtcharter/mittelmeer/ibiza/sant-antoni'
                                    },
                                    {
                                        name: 'San Antonio Abad',
                                        href: '/yachtcharter/mittelmeer/ibiza/san-antonio-abad'
                                    }, 
                                ]
                            },
                            {
                                name: 'Katalonien',
                                href: '/yachtcharter/mittelmeer/katalonien',
                                subList: [
                                    {
                                        name: 'Barcelona',
                                        href: '/yachtcharter/mittelmeer/katalonien/barcelona'
                                    },
                                    {
                                        name: 'Roses',
                                        href: '/yachtcharter/mittelmeer/katalonien/roses'
                                    },
                                    {
                                        name: 'Girona',
                                        href: '/yachtcharter/mittelmeer/katalonien/girona'
                                    },
                                    {
                                        name: 'El Masnou',
                                        href: '/yachtcharter/mittelmeer/katalonien/el-masnou'
                                    },
                                    {
                                        name: 'Palamos',
                                        href: '/yachtcharter/mittelmeer/katalonien/palamos'
                                    },
                                    {
                                        name: 'Mataro',
                                        href: '/yachtcharter/mittelmeer/katalonien/mataro'
                                    },
                                    {
                                        name: 'Cambrils',
                                        href: '/yachtcharter/mittelmeer/katalonien/cambrils'
                                    },
                                    {
                                        name: 'Premi\xe0 de Mar, Barcelona',
                                        href: '/yachtcharter/mittelmeer/katalonien/premia-de-mar-barcelona'
                                    },
                                    {
                                        name: 'Roda de Bar\xe0',
                                        href: '/yachtcharter/mittelmeer/katalonien/roda-de-bara'
                                    },
                                    {
                                        name: 'Sitges',
                                        href: '/yachtcharter/mittelmeer/katalonien/sitges'
                                    },
                                    {
                                        name: 'Sitges, Barcelona',
                                        href: '/yachtcharter/mittelmeer/katalonien/sitges-barcelona'
                                    },
                                    {
                                        name: 'Torredembarra',
                                        href: '/yachtcharter/mittelmeer/katalonien/torredembarra'
                                    },
                                    {
                                        name: 'Roda de Ber\xe0',
                                        href: '/yachtcharter/mittelmeer/katalonien/roda-de-bera'
                                    }, 
                                ]
                            },
                            {
                                name: 'Valencia',
                                href: '/yachtcharter/mittelmeer/valencia',
                                subList: [
                                    {
                                        name: 'Denia',
                                        href: '/yachtcharter/mittelmeer/valencia/denia'
                                    },
                                    {
                                        name: 'Valencia',
                                        href: '/yachtcharter/mittelmeer/valencia/valencia'
                                    },
                                    {
                                        name: 'La Vila Joiosa',
                                        href: '/yachtcharter/mittelmeer/valencia/la-vila-joiosa'
                                    }, 
                                ]
                            },
                            {
                                name: '\xc4g\xe4is',
                                href: '/yachtcharter/mittelmeer/aegaeis',
                                subList: [
                                    {
                                        name: 'Kos',
                                        href: '/yachtcharter/mittelmeer/aegaeis/kos'
                                    },
                                    {
                                        name: 'Orhaniye',
                                        href: '/yachtcharter/mittelmeer/aegaeis/orhaniye'
                                    },
                                    {
                                        name: 'Marmaris',
                                        href: '/yachtcharter/mittelmeer/aegaeis/marmaris'
                                    },
                                    {
                                        name: 'Bodrum',
                                        href: '/yachtcharter/mittelmeer/aegaeis/bodrum'
                                    },
                                    {
                                        name: 'Marmaris, Netsel Marina',
                                        href: '/yachtcharter/mittelmeer/aegaeis/marmaris-netsel-marina'
                                    },
                                    {
                                        name: 'Bodrum/Turgutreis/D-Marin',
                                        href: '/yachtcharter/mittelmeer/aegaeis/bodrum-turgutreis-d-marin'
                                    },
                                    {
                                        name: 'Milta Bodrum Marina',
                                        href: '/yachtcharter/mittelmeer/aegaeis/milta-bodrum-marina'
                                    },
                                    {
                                        name: 'Marmaris Yacht Marina',
                                        href: '/yachtcharter/mittelmeer/aegaeis/marmaris-yacht-marina'
                                    },
                                    {
                                        name: 'G\xf6kova \xd6ren Marina',
                                        href: '/yachtcharter/mittelmeer/aegaeis/goekova-oeren-marina'
                                    },
                                    {
                                        name: 'Marmaris Adakoy Marina',
                                        href: '/yachtcharter/mittelmeer/aegaeis/marmaris-adakoy-marina'
                                    },
                                    {
                                        name: 'Palmarina - Yalikavak, Bodrum',
                                        href: '/yachtcharter/mittelmeer/aegaeis/palmarina-yalikavak-bodrum'
                                    },
                                    {
                                        name: 'Bodrum, G\xfcmbet Marina',
                                        href: '/yachtcharter/mittelmeer/aegaeis/bodrum-guembet-marina'
                                    },
                                    {
                                        name: 'Marmaris, Joya Del Mar Marina',
                                        href: '/yachtcharter/mittelmeer/aegaeis/marmaris-joya-del-mar-marina'
                                    }, 
                                ]
                            },
                            {
                                name: 'Korsika',
                                href: '/yachtcharter/mittelmeer/korsika',
                                subList: [
                                    {
                                        name: 'Propriano',
                                        href: '/yachtcharter/mittelmeer/korsika/propriano'
                                    },
                                    {
                                        name: 'Ajaccio',
                                        href: '/yachtcharter/mittelmeer/korsika/ajaccio'
                                    }, 
                                ]
                            },
                            {
                                name: 'Okzitanien',
                                href: '/yachtcharter/mittelmeer/okzitanien',
                                subList: [
                                    {
                                        name: 'Lattes',
                                        href: '/yachtcharter/mittelmeer/okzitanien/lattes'
                                    },
                                    {
                                        name: 'Argens-Minervois',
                                        href: '/yachtcharter/mittelmeer/okzitanien/argens-minervois'
                                    },
                                    {
                                        name: 'Lauragais',
                                        href: '/yachtcharter/mittelmeer/okzitanien/lauragais'
                                    },
                                    {
                                        name: 'Valence-sur-Ba\xefse',
                                        href: '/yachtcharter/mittelmeer/okzitanien/valence-sur-baise'
                                    },
                                    {
                                        name: 'Cahors',
                                        href: '/yachtcharter/mittelmeer/okzitanien/cahors'
                                    },
                                    {
                                        name: 'Bellegarde',
                                        href: '/yachtcharter/mittelmeer/okzitanien/bellegarde'
                                    },
                                    {
                                        name: "Saint-Nazaire-d'Aude",
                                        href: '/yachtcharter/mittelmeer/okzitanien/saint-nazaire-daude'
                                    },
                                    {
                                        name: 'Lauragais',
                                        href: '/yachtcharter/mittelmeer/okzitanien/lauragais'
                                    },
                                    {
                                        name: 'Bram',
                                        href: '/yachtcharter/mittelmeer/okzitanien/bram'
                                    },
                                    {
                                        name: 'Douelle',
                                        href: '/yachtcharter/mittelmeer/okzitanien/douelle'
                                    },
                                    {
                                        name: 'Tr\xe8bes',
                                        href: '/yachtcharter/mittelmeer/okzitanien/trebes'
                                    },
                                    {
                                        name: 'Capestang',
                                        href: '/yachtcharter/mittelmeer/okzitanien/capestang'
                                    },
                                    {
                                        name: 'Castelnaudary ',
                                        href: '/yachtcharter/mittelmeer/okzitanien/castelnaudary'
                                    }, 
                                ]
                            },
                            {
                                name: 'Athen',
                                href: '/yachtcharter/mittelmeer/athen',
                                subList: [
                                    {
                                        name: 'Alimos',
                                        href: '/yachtcharter/mittelmeer/athen/alimos'
                                    },
                                    {
                                        name: 'Lavrio',
                                        href: '/yachtcharter/mittelmeer/athen/lavrio'
                                    },
                                    {
                                        name: 'Elliniko',
                                        href: '/yachtcharter/mittelmeer/athen/elliniko'
                                    },
                                    {
                                        name: 'Piraeus',
                                        href: '/yachtcharter/mittelmeer/athen/piraeus'
                                    },
                                    {
                                        name: 'Athen',
                                        href: '/yachtcharter/mittelmeer/athen/athen'
                                    },
                                    {
                                        name: 'Palaio Faliro',
                                        href: '/yachtcharter/mittelmeer/athen/palaio-faliro'
                                    },
                                    {
                                        name: 'Pireas',
                                        href: '/yachtcharter/mittelmeer/athen/pireas'
                                    },
                                    {
                                        name: 'Glifada',
                                        href: '/yachtcharter/mittelmeer/athen/glifada'
                                    },
                                    {
                                        name: 'Nea Peramos - Attica',
                                        href: '/yachtcharter/mittelmeer/athen/nea-peramos-attica'
                                    },
                                    {
                                        name: 'Athens',
                                        href: '/yachtcharter/mittelmeer/athen/athens'
                                    },
                                    {
                                        name: 'Aegina',
                                        href: '/yachtcharter/mittelmeer/athen/aegina'
                                    },
                                    {
                                        name: 'Kallithea',
                                        href: '/yachtcharter/mittelmeer/athen/kallithea'
                                    },
                                    {
                                        name: 'Elefsina',
                                        href: '/yachtcharter/mittelmeer/athen/elefsina'
                                    },
                                    {
                                        name: 'Salamina',
                                        href: '/yachtcharter/mittelmeer/athen/salamina'
                                    },
                                    {
                                        name: 'Nea Peramos',
                                        href: '/yachtcharter/mittelmeer/athen/nea-peramos'
                                    },
                                    {
                                        name: 'Egina',
                                        href: '/yachtcharter/mittelmeer/athen/egina'
                                    },
                                    {
                                        name: 'Yacht Club Marina Salamina, Athens area',
                                        href: '/yachtcharter/mittelmeer/athen/yacht-club-marina-salamina-athens-area'
                                    }, 
                                ]
                            },
                            {
                                name: 'Ionische Inseln',
                                href: '/yachtcharter/mittelmeer/ionische-inseln',
                                subList: [
                                    {
                                        name: 'Lefkada',
                                        href: '/yachtcharter/mittelmeer/ionische-inseln/lefkada'
                                    },
                                    {
                                        name: 'Sami',
                                        href: '/yachtcharter/mittelmeer/ionische-inseln/sami'
                                    },
                                    {
                                        name: 'Agia Eufimia',
                                        href: '/yachtcharter/mittelmeer/ionische-inseln/agia-eufimia'
                                    },
                                    {
                                        name: 'Zakynthos',
                                        href: '/yachtcharter/mittelmeer/ionische-inseln/zakynthos'
                                    },
                                    {
                                        name: 'Kerkira',
                                        href: '/yachtcharter/mittelmeer/ionische-inseln/kerkira'
                                    },
                                    {
                                        name: 'Sivota',
                                        href: '/yachtcharter/mittelmeer/ionische-inseln/sivota'
                                    },
                                    {
                                        name: 'Corfu',
                                        href: '/yachtcharter/mittelmeer/ionische-inseln/corfu'
                                    },
                                    {
                                        name: 'Kontokali',
                                        href: '/yachtcharter/mittelmeer/ionische-inseln/kontokali'
                                    },
                                    {
                                        name: 'Nikiana',
                                        href: '/yachtcharter/mittelmeer/ionische-inseln/nikiana'
                                    },
                                    {
                                        name: 'Nidri',
                                        href: '/yachtcharter/mittelmeer/ionische-inseln/nidri'
                                    },
                                    {
                                        name: 'Kefalonia',
                                        href: '/yachtcharter/mittelmeer/ionische-inseln/kefalonia'
                                    },
                                    {
                                        name: 'Gouvia',
                                        href: '/yachtcharter/mittelmeer/ionische-inseln/gouvia'
                                    },
                                    {
                                        name: 'Vlicho',
                                        href: '/yachtcharter/mittelmeer/ionische-inseln/vlicho'
                                    },
                                    {
                                        name: 'Corfu, Mandraki',
                                        href: '/yachtcharter/mittelmeer/ionische-inseln/corfu-mandraki'
                                    },
                                    {
                                        name: 'Benitses, Corfu',
                                        href: '/yachtcharter/mittelmeer/ionische-inseln/benitses-corfu'
                                    }, 
                                ]
                            },
                            {
                                name: 'Kreta',
                                href: '/yachtcharter/mittelmeer/kreta',
                                subList: [
                                    {
                                        name: 'Heraklion',
                                        href: '/yachtcharter/mittelmeer/kreta/heraklion'
                                    }, 
                                ]
                            },
                            {
                                name: 'Ost Makedonien',
                                href: '/yachtcharter/mittelmeer/ost-makedonien',
                                subList: [
                                    {
                                        name: 'Kavala',
                                        href: '/yachtcharter/mittelmeer/ost-makedonien/kavala'
                                    },
                                    {
                                        name: 'Keramoti',
                                        href: '/yachtcharter/mittelmeer/ost-makedonien/keramoti'
                                    },
                                    {
                                        name: 'Thasos',
                                        href: '/yachtcharter/mittelmeer/ost-makedonien/thasos'
                                    },
                                    {
                                        name: 'Limenas Thassos',
                                        href: '/yachtcharter/mittelmeer/ost-makedonien/limenas-thassos'
                                    },
                                    {
                                        name: 'Limenas Avdiron',
                                        href: '/yachtcharter/mittelmeer/ost-makedonien/limenas-avdiron'
                                    }, 
                                ]
                            },
                            {
                                name: 'Makedonien',
                                href: '/yachtcharter/mittelmeer/makedonien',
                                subList: [
                                    {
                                        name: 'Neos Marmaras',
                                        href: '/yachtcharter/mittelmeer/makedonien/neos-marmaras'
                                    },
                                    {
                                        name: 'Thessaloniki',
                                        href: '/yachtcharter/mittelmeer/makedonien/thessaloniki'
                                    },
                                    {
                                        name: 'Ormos Panagias',
                                        href: '/yachtcharter/mittelmeer/makedonien/ormos-panagias'
                                    },
                                    {
                                        name: 'Nikiti',
                                        href: '/yachtcharter/mittelmeer/makedonien/nikiti'
                                    },
                                    {
                                        name: 'Halkidiki',
                                        href: '/yachtcharter/mittelmeer/makedonien/halkidiki'
                                    }, 
                                ]
                            },
                            {
                                name: 'Peloponnese',
                                href: '/yachtcharter/mittelmeer/peloponnese',
                                subList: [
                                    {
                                        name: 'Kalamata',
                                        href: '/yachtcharter/mittelmeer/peloponnese/kalamata'
                                    },
                                    {
                                        name: 'Ermioni',
                                        href: '/yachtcharter/mittelmeer/peloponnese/ermioni'
                                    }, 
                                ]
                            },
                            {
                                name: 'South Aegean',
                                href: '/yachtcharter/mittelmeer/south-aegean',
                                subList: [
                                    {
                                        name: 'Kos',
                                        href: '/yachtcharter/mittelmeer/south-aegean/kos'
                                    },
                                    {
                                        name: 'Tourlos',
                                        href: '/yachtcharter/mittelmeer/south-aegean/tourlos'
                                    },
                                    {
                                        name: 'Ermoupoli',
                                        href: '/yachtcharter/mittelmeer/south-aegean/ermoupoli'
                                    },
                                    {
                                        name: 'Syros',
                                        href: '/yachtcharter/mittelmeer/south-aegean/syros'
                                    },
                                    {
                                        name: 'Heraklion',
                                        href: '/yachtcharter/mittelmeer/south-aegean/heraklion'
                                    },
                                    {
                                        name: 'Paros',
                                        href: '/yachtcharter/mittelmeer/south-aegean/paros'
                                    },
                                    {
                                        name: 'Santorini',
                                        href: '/yachtcharter/mittelmeer/south-aegean/santorini'
                                    },
                                    {
                                        name: 'Mykonos',
                                        href: '/yachtcharter/mittelmeer/south-aegean/mykonos'
                                    },
                                    {
                                        name: 'Mikonos',
                                        href: '/yachtcharter/mittelmeer/south-aegean/mikonos'
                                    },
                                    {
                                        name: 'Piso Livadi',
                                        href: '/yachtcharter/mittelmeer/south-aegean/piso-livadi'
                                    },
                                    {
                                        name: 'Rhodos',
                                        href: '/yachtcharter/mittelmeer/south-aegean/rhodos'
                                    },
                                    {
                                        name: 'Ialisos',
                                        href: '/yachtcharter/mittelmeer/south-aegean/ialisos'
                                    },
                                    {
                                        name: 'Naoussa',
                                        href: '/yachtcharter/mittelmeer/south-aegean/naoussa'
                                    },
                                    {
                                        name: 'Rhodos',
                                        href: '/yachtcharter/mittelmeer/south-aegean/rhodos'
                                    }, 
                                ]
                            },
                            {
                                name: 'Thessalien',
                                href: '/yachtcharter/mittelmeer/thessalien',
                                subList: [
                                    {
                                        name: 'Skiathos',
                                        href: '/yachtcharter/mittelmeer/thessalien/skiathos'
                                    },
                                    {
                                        name: 'Volos',
                                        href: '/yachtcharter/mittelmeer/thessalien/volos'
                                    },
                                    {
                                        name: 'Skopelos',
                                        href: '/yachtcharter/mittelmeer/thessalien/skopelos'
                                    },
                                    {
                                        name: 'Achillio',
                                        href: '/yachtcharter/mittelmeer/thessalien/achillio'
                                    }, 
                                ]
                            },
                            {
                                name: 'West Griechenland',
                                href: '/yachtcharter/mittelmeer/west-griechenland',
                                subList: [
                                    {
                                        name: 'Paleros',
                                        href: '/yachtcharter/mittelmeer/west-griechenland/paleros'
                                    },
                                    {
                                        name: 'Palairos',
                                        href: '/yachtcharter/mittelmeer/west-griechenland/palairos'
                                    },
                                    {
                                        name: 'Patra ',
                                        href: '/yachtcharter/mittelmeer/west-griechenland/patra'
                                    }, 
                                ]
                            },
                            {
                                name: 'Basilikata',
                                href: '/yachtcharter/mittelmeer/basilikata',
                                subList: [
                                    {
                                        name: 'Marina',
                                        href: '/yachtcharter/mittelmeer/basilikata/marina'
                                    }, 
                                ]
                            },
                            {
                                name: 'Elba',
                                href: '/yachtcharter/mittelmeer/elba',
                                subList: [
                                    {
                                        name: 'Portoferraio',
                                        href: '/yachtcharter/mittelmeer/elba/portoferraio'
                                    }, 
                                ]
                            },
                            {
                                name: 'Kalabrien',
                                href: '/yachtcharter/mittelmeer/kalabrien',
                                subList: [
                                    {
                                        name: 'Marina',
                                        href: '/yachtcharter/mittelmeer/kalabrien/marina'
                                    },
                                    {
                                        name: 'Tropea',
                                        href: '/yachtcharter/mittelmeer/kalabrien/tropea'
                                    },
                                    {
                                        name: 'Vibo Marina',
                                        href: '/yachtcharter/mittelmeer/kalabrien/vibo-marina'
                                    },
                                    {
                                        name: 'Reggio Calabria',
                                        href: '/yachtcharter/mittelmeer/kalabrien/reggio-calabria'
                                    }, 
                                ]
                            },
                            {
                                name: 'Kampanien',
                                href: '/yachtcharter/mittelmeer/kampanien',
                                subList: [
                                    {
                                        name: 'Mergellina',
                                        href: '/yachtcharter/mittelmeer/kampanien/mergellina'
                                    },
                                    {
                                        name: 'Pozzuoli',
                                        href: '/yachtcharter/mittelmeer/kampanien/pozzuoli'
                                    },
                                    {
                                        name: 'Procida',
                                        href: '/yachtcharter/mittelmeer/kampanien/procida'
                                    },
                                    {
                                        name: 'Castellammare di Stabia',
                                        href: '/yachtcharter/mittelmeer/kampanien/castellammare-di-stabia'
                                    },
                                    {
                                        name: 'Agropoli',
                                        href: '/yachtcharter/mittelmeer/kampanien/agropoli'
                                    },
                                    {
                                        name: 'Amalfi',
                                        href: '/yachtcharter/mittelmeer/kampanien/amalfi'
                                    },
                                    {
                                        name: 'Porto di Castellammare di Stabia',
                                        href: '/yachtcharter/mittelmeer/kampanien/porto-di-castellammare-di-stabia'
                                    },
                                    {
                                        name: 'Salerno',
                                        href: '/yachtcharter/mittelmeer/kampanien/salerno'
                                    },
                                    {
                                        name: 'Napoli',
                                        href: '/yachtcharter/mittelmeer/kampanien/napoli'
                                    },
                                    {
                                        name: 'Naples',
                                        href: '/yachtcharter/mittelmeer/kampanien/naples'
                                    },
                                    {
                                        name: 'Neapel',
                                        href: '/yachtcharter/mittelmeer/kampanien/neapel'
                                    }, 
                                ]
                            },
                            {
                                name: 'Latium',
                                href: '/yachtcharter/mittelmeer/latium',
                                subList: [
                                    {
                                        name: 'Rome',
                                        href: '/yachtcharter/mittelmeer/latium/rome'
                                    },
                                    {
                                        name: 'Anzio',
                                        href: '/yachtcharter/mittelmeer/latium/anzio'
                                    },
                                    {
                                        name: 'Nettuno',
                                        href: '/yachtcharter/mittelmeer/latium/nettuno'
                                    }, 
                                ]
                            },
                            {
                                name: 'Ligurien',
                                href: '/yachtcharter/mittelmeer/ligurien',
                                subList: [
                                    {
                                        name: 'La Spezia',
                                        href: '/yachtcharter/mittelmeer/ligurien/la-spezia'
                                    },
                                    {
                                        name: 'Portovenere',
                                        href: '/yachtcharter/mittelmeer/ligurien/portovenere'
                                    },
                                    {
                                        name: 'Bocca di Magra',
                                        href: '/yachtcharter/mittelmeer/ligurien/bocca-di-magra'
                                    }, 
                                ]
                            },
                            {
                                name: 'Neapel',
                                href: '/yachtcharter/mittelmeer/neapel',
                                subList: [
                                    {
                                        name: 'Mergellina',
                                        href: '/yachtcharter/mittelmeer/neapel/mergellina'
                                    },
                                    {
                                        name: 'Pozzuoli',
                                        href: '/yachtcharter/mittelmeer/neapel/pozzuoli'
                                    },
                                    {
                                        name: 'Procida',
                                        href: '/yachtcharter/mittelmeer/neapel/procida'
                                    },
                                    {
                                        name: 'Napoli',
                                        href: '/yachtcharter/mittelmeer/neapel/napoli'
                                    },
                                    {
                                        name: 'Naples',
                                        href: '/yachtcharter/mittelmeer/neapel/naples'
                                    },
                                    {
                                        name: 'Neapel',
                                        href: '/yachtcharter/mittelmeer/neapel/neapel'
                                    }, 
                                ]
                            },
                            {
                                name: 'Sardinien',
                                href: '/yachtcharter/mittelmeer/sardinien',
                                subList: [
                                    {
                                        name: 'Cagliari',
                                        href: '/yachtcharter/mittelmeer/sardinien/cagliari'
                                    },
                                    {
                                        name: 'La Maddalena',
                                        href: '/yachtcharter/mittelmeer/sardinien/la-maddalena'
                                    },
                                    {
                                        name: 'Olbia',
                                        href: '/yachtcharter/mittelmeer/sardinien/olbia'
                                    },
                                    {
                                        name: 'Genova',
                                        href: '/yachtcharter/mittelmeer/sardinien/genova'
                                    },
                                    {
                                        name: 'Golfo Aranci',
                                        href: '/yachtcharter/mittelmeer/sardinien/golfo-aranci'
                                    },
                                    {
                                        name: 'Santa Maria Navarrese',
                                        href: '/yachtcharter/mittelmeer/sardinien/santa-maria-navarrese'
                                    },
                                    {
                                        name: 'Porto Rotondo',
                                        href: '/yachtcharter/mittelmeer/sardinien/porto-rotondo'
                                    },
                                    {
                                        name: 'Portisco',
                                        href: '/yachtcharter/mittelmeer/sardinien/portisco'
                                    },
                                    {
                                        name: 'Carloforte',
                                        href: '/yachtcharter/mittelmeer/sardinien/carloforte'
                                    },
                                    {
                                        name: 'Cannigione',
                                        href: '/yachtcharter/mittelmeer/sardinien/cannigione'
                                    },
                                    {
                                        name: 'Alghero',
                                        href: '/yachtcharter/mittelmeer/sardinien/alghero'
                                    },
                                    {
                                        name: 'Arzachena',
                                        href: '/yachtcharter/mittelmeer/sardinien/arzachena'
                                    },
                                    {
                                        name: 'Aranci',
                                        href: '/yachtcharter/mittelmeer/sardinien/aranci'
                                    },
                                    {
                                        name: 'Cannigione Arzachena',
                                        href: '/yachtcharter/mittelmeer/sardinien/cannigione-arzachena'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Indischer Ozean',
                icon: esm_GlobeAltIcon,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Indischer Ozean',
                        href: '/yachtcharter/indischer-ozean',
                        list: [
                            {
                                name: 'Seychellen',
                                href: '/yachtcharter/indischer-ozean/seychellen',
                                subList: [
                                    {
                                        name: 'Baie Ste Anne',
                                        href: '/yachtcharter/indischer-ozean/seychellen/baie-ste-anne'
                                    },
                                    {
                                        name: 'Mahe, Victoria',
                                        href: '/yachtcharter/indischer-ozean/seychellen/mahe-victoria'
                                    },
                                    {
                                        name: 'Grand Anse Village',
                                        href: '/yachtcharter/indischer-ozean/seychellen/grand-anse-village'
                                    },
                                    {
                                        name: 'Mahe',
                                        href: '/yachtcharter/indischer-ozean/seychellen/mahe'
                                    },
                                    {
                                        name: 'Praslin',
                                        href: '/yachtcharter/indischer-ozean/seychellen/praslin'
                                    }, 
                                ]
                            },
                            {
                                name: 'Malaysia',
                                href: '/yachtcharter/indischer-ozean/malaysia',
                                subList: [
                                    {
                                        name: 'Nongsa Point Marina',
                                        href: '/yachtcharter/indischer-ozean/malaysia/nongsa-point-marina'
                                    },
                                    {
                                        name: 'ONE\xb015 Marina Sentosa Cove',
                                        href: '/yachtcharter/indischer-ozean/malaysia/one-15-marina-sentosa-cove'
                                    }, 
                                ]
                            },
                            {
                                name: 'Thailand',
                                href: '/yachtcharter/indischer-ozean/thailand',
                                subList: [
                                    {
                                        name: 'Tambon Mai Khao',
                                        href: '/yachtcharter/indischer-ozean/thailand/tambon-mai-khao'
                                    },
                                    {
                                        name: 'Tambon Koh Chang Tai',
                                        href: '/yachtcharter/indischer-ozean/thailand/tambon-koh-chang-tai'
                                    },
                                    {
                                        name: 'Koh Chang',
                                        href: '/yachtcharter/indischer-ozean/thailand/koh-chang'
                                    },
                                    {
                                        name: 'Phuket',
                                        href: '/yachtcharter/indischer-ozean/thailand/phuket'
                                    },
                                    {
                                        name: 'Ko Samui',
                                        href: '/yachtcharter/indischer-ozean/thailand/ko-samui'
                                    },
                                    {
                                        name: 'Koh Samui',
                                        href: '/yachtcharter/indischer-ozean/thailand/koh-samui'
                                    }, 
                                ]
                            },
                            {
                                name: 'Phuket',
                                href: '/yachtcharter/indischer-ozean/phuket',
                                subList: [
                                    {
                                        name: 'Tambon Mai Khao',
                                        href: '/yachtcharter/indischer-ozean/phuket/tambon-mai-khao'
                                    },
                                    {
                                        name: 'Phuket',
                                        href: '/yachtcharter/indischer-ozean/phuket/phuket'
                                    }, 
                                ]
                            },
                            {
                                name: 'Ko Samui',
                                href: '/yachtcharter/indischer-ozean/ko-samui',
                                subList: [
                                    {
                                        name: 'Ko Samui',
                                        href: '/yachtcharter/indischer-ozean/ko-samui/ko-samui'
                                    },
                                    {
                                        name: 'Koh Samui',
                                        href: '/yachtcharter/indischer-ozean/ko-samui/koh-samui'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Pazifischer Ozean',
                icon: esm_GlobeAltIcon,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Pazifischer Ozean',
                        href: '/yachtcharter/pazifischer-ozean',
                        list: []
                    }, 
                ]
            },
            {
                name: 'Atlantischer Ozean',
                icon: esm_GlobeAltIcon,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Atlantischer Ozean',
                        href: '/yachtcharter/atlantischer-ozean',
                        list: [
                            {
                                name: 'Bretagne',
                                href: '/yachtcharter/atlantischer-ozean/bretagne',
                                subList: [
                                    {
                                        name: 'Melesse',
                                        href: '/yachtcharter/atlantischer-ozean/bretagne/melesse'
                                    },
                                    {
                                        name: 'Saint-Martin-sur-Oust',
                                        href: '/yachtcharter/atlantischer-ozean/bretagne/saint-martin-sur-oust'
                                    },
                                    {
                                        name: 'Gl\xe9nac',
                                        href: '/yachtcharter/atlantischer-ozean/bretagne/glenac'
                                    },
                                    {
                                        name: 'Messac',
                                        href: '/yachtcharter/atlantischer-ozean/bretagne/messac'
                                    },
                                    {
                                        name: 'La Trinit\xe9-sur-Mer',
                                        href: '/yachtcharter/atlantischer-ozean/bretagne/la-trinite-sur-mer'
                                    },
                                    {
                                        name: 'Redon',
                                        href: '/yachtcharter/atlantischer-ozean/bretagne/redon'
                                    }, 
                                ]
                            },
                            {
                                name: 'Nouvelle-Aquitanien',
                                href: '/yachtcharter/atlantischer-ozean/nouvelle-aquitanien',
                                subList: [
                                    {
                                        name: 'Agen',
                                        href: '/yachtcharter/atlantischer-ozean/nouvelle-aquitanien/agen'
                                    },
                                    {
                                        name: 'Buzet-sur-Baise',
                                        href: '/yachtcharter/atlantischer-ozean/nouvelle-aquitanien/buzet-sur-baise'
                                    },
                                    {
                                        name: 'Sireuil',
                                        href: '/yachtcharter/atlantischer-ozean/nouvelle-aquitanien/sireuil'
                                    },
                                    {
                                        name: "Le Mas d'Agenais",
                                        href: '/yachtcharter/atlantischer-ozean/nouvelle-aquitanien/le-mas-dagenais'
                                    },
                                    {
                                        name: 'Jarnac',
                                        href: '/yachtcharter/atlantischer-ozean/nouvelle-aquitanien/jarnac'
                                    },
                                    {
                                        name: 'La Rochelle',
                                        href: '/yachtcharter/atlantischer-ozean/nouvelle-aquitanien/la-rochelle'
                                    },
                                    {
                                        name: 'Cognac',
                                        href: '/yachtcharter/atlantischer-ozean/nouvelle-aquitanien/cognac'
                                    },
                                    {
                                        name: "Le Mas d'Agenais",
                                        href: '/yachtcharter/atlantischer-ozean/nouvelle-aquitanien/le-mas-dagenais'
                                    }, 
                                ]
                            },
                            {
                                name: 'Galicien',
                                href: '/yachtcharter/atlantischer-ozean/galicien',
                                subList: [
                                    {
                                        name: 'Pontevedra',
                                        href: '/yachtcharter/atlantischer-ozean/galicien/pontevedra'
                                    }, 
                                ]
                            },
                            {
                                name: 'Gran Canaria',
                                href: '/yachtcharter/atlantischer-ozean/gran-canaria',
                                subList: [
                                    {
                                        name: 'San Bartolom\xe9 de Tirajana',
                                        href: '/yachtcharter/atlantischer-ozean/gran-canaria/san-bartolome-de-tirajana'
                                    },
                                    {
                                        name: 'Lomo Quiebre',
                                        href: '/yachtcharter/atlantischer-ozean/gran-canaria/lomo-quiebre'
                                    },
                                    {
                                        name: 'Gran Canaria',
                                        href: '/yachtcharter/atlantischer-ozean/gran-canaria/gran-canaria'
                                    }, 
                                ]
                            },
                            {
                                name: 'Lanzarote',
                                href: '/yachtcharter/atlantischer-ozean/lanzarote',
                                subList: [
                                    {
                                        name: 'Arrecife',
                                        href: '/yachtcharter/atlantischer-ozean/lanzarote/arrecife'
                                    },
                                    {
                                        name: 'Lanzarote',
                                        href: '/yachtcharter/atlantischer-ozean/lanzarote/lanzarote'
                                    }, 
                                ]
                            },
                            {
                                name: 'Alentejo - Grande Lago',
                                href: '/yachtcharter/atlantischer-ozean/alentejo-grande-lago',
                                subList: [
                                    {
                                        name: 'Amieira',
                                        href: '/yachtcharter/atlantischer-ozean/alentejo-grande-lago/amieira'
                                    }, 
                                ]
                            },
                            {
                                name: 'Algarve',
                                href: '/yachtcharter/atlantischer-ozean/algarve',
                                subList: [
                                    {
                                        name: 'Portimao',
                                        href: '/yachtcharter/atlantischer-ozean/algarve/portimao'
                                    },
                                    {
                                        name: 'Ayamonte',
                                        href: '/yachtcharter/atlantischer-ozean/algarve/ayamonte'
                                    }, 
                                ]
                            },
                            {
                                name: 'Lissabon',
                                href: '/yachtcharter/atlantischer-ozean/lissabon',
                                subList: [
                                    {
                                        name: 'Lissabon',
                                        href: '/yachtcharter/atlantischer-ozean/lissabon/lissabon'
                                    },
                                    {
                                        name: 'Cascais',
                                        href: '/yachtcharter/atlantischer-ozean/lissabon/cascais'
                                    }, 
                                ]
                            },
                            {
                                name: 'Nordportugal / Porto',
                                href: '/yachtcharter/atlantischer-ozean/nordportugal-porto',
                                subList: [
                                    {
                                        name: 'Freixo',
                                        href: '/yachtcharter/atlantischer-ozean/nordportugal-porto/freixo'
                                    },
                                    {
                                        name: 'Vila Nova Gaia',
                                        href: '/yachtcharter/atlantischer-ozean/nordportugal-porto/vila-nova-gaia'
                                    }, 
                                ]
                            },
                            {
                                name: 'Maryland',
                                href: '/yachtcharter/atlantischer-ozean/maryland',
                                subList: [
                                    {
                                        name: 'Annapolis',
                                        href: '/yachtcharter/atlantischer-ozean/maryland/annapolis'
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: 'Saronischer Golf',
                icon: esm_GlobeAltIcon,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                children: [
                    {
                        name: 'Saronischer Golf',
                        href: '/yachtcharter/saronischer-golf',
                        list: []
                    }, 
                ]
            }, 
        ]
    },
    {
        name: 'Informationen',
        href: '/',
        icon: tips/* default */.Z,
        list: [
            {
                name: 'Planung vor der Reise',
                icon: license,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                href: '/wissenswertes/planung-vor-der-reise'
            },
            {
                name: '\xdcbernahme des Bootes',
                icon: child,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                href: '/wissenswertes/uebernahme-des-bootes'
            },
            {
                name: 'Man\xf6vrieren des Bootes',
                icon: dog,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                href: '/wissenswertes/manoevrieren'
            },
            {
                name: 'Vorfahrts- & Navigationsregeln',
                icon: boat/* default */.Z,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                href: '/wissenswertes/vorfahrts-und-navigationsregeln'
            },
            {
                name: 'Zusammenleben an Bord',
                icon: inspo,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                href: '/wissenswertes/zusammenleben-an-bord'
            },
            {
                name: 'R\xfcckgabe',
                icon: route,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                href: '/wissenswertes/rueckgabe'
            },
            {
                name: 'Sicherheit & Unfallverhalten',
                icon: partner,
                mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
                href: '/wissenswertes/sicherheit-unfall'
            },
            /*
      {
        name: 'Charterrücktritt-Versicherung',
        icon: NewspaperIcon,
        href: '/wissenswertes/charterruecktritt-versicherung-plus-von-yacht-pool',
        mainClass: 'border-b border-gray-50 border-opacity-20 text-lg lg:text-lg font-light py-2',
      },

       */ {
                name: 'Blog',
                icon: esm_NewspaperIcon,
                href: '/blog',
                mainClass: 'text-sm lg:text-base font-semibold py-3 lg:py-2  mt-7'
            },
            {
                name: 'Shop',
                icon: esm_ShoppingCartIcon,
                href: "".concat(app_config/* default.planbar24_url */.Z.planbar24_url, "/shop"),
                mainClass: 'text-sm lg:text-base font-semibold py-3 lg:py-2'
            },
            {
                name: 'H\xe4ufige Fragen',
                icon: esm_QuestionMarkCircleIcon,
                mainClass: 'text-sm lg:text-base font-semibold py-3 lg:py-2',
                children: faqs
            },
            {
                name: 'Newsletter',
                icon: mail,
                href: '/newsletter',
                mainClass: 'text-sm lg:text-base font-semibold py-3 lg:py-2'
            },
            {
                name: '\xdcber uns',
                icon: favicon3,
                href: '/ueber-uns',
                mainClass: 'text-sm lg:text-base font-semibold py-3 lg:py-2'
            }, 
        ]
    }, 
];
/* harmony default export */ var data = (HeaderData);

;// CONCATENATED MODULE: ./src/components/globals/header/nav-menu.js



function HeaderNavMenu(param) {
    var open = param.open;
    var menuList = data;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "hidden md:flex items-center lg:space-x-10 space-x-8",
        children: menuList.map(function(v, k) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(popover/* Popover.Button */.J.Button, {
                className: "dropdown group inline text-base cursor-pointer px-1 lg:py-2 py-2 text-white transition-all ring:0",
                onClick: function() {
                    return open(v, k);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center space-x-2 transition-all group-hover:font-semibold py-1.5 border-b border-transparent hover:border-primary",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "lg:w-6 w-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v.icon, {
                                "aria-hidden": "true",
                                className: "flex-shrink-0 lg:h-5 lg:w-5 h-4 w-4 text-white fill-white"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: v.name
                        })
                    ]
                })
            }, v.name);
        })
    }));
};

;// CONCATENATED MODULE: ./node_modules/@heroicons/react/solid/esm/ChevronRightIcon.js


function ChevronRightIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
    clipRule: "evenodd"
  }));
}

const ChevronRightIcon_ForwardRef = react.forwardRef(ChevronRightIcon);
/* harmony default export */ var esm_ChevronRightIcon = (ChevronRightIcon_ForwardRef);
// EXTERNAL MODULE: ./src/components/helper/link.js
var helper_link = __webpack_require__(34892);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/ChevronDownIcon.js
var ChevronDownIcon = __webpack_require__(13342);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/solid/esm/ChevronUpIcon.js


function ChevronUpIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z",
    clipRule: "evenodd"
  }));
}

const ChevronUpIcon_ForwardRef = react.forwardRef(ChevronUpIcon);
/* harmony default export */ var esm_ChevronUpIcon = (ChevronUpIcon_ForwardRef);
;// CONCATENATED MODULE: ./src/components/globals/header/collapsable-location.js




function CollapsableLocation(param) {
    var element = param.element, close = param.close, closeParent = param.closeParent, _collapsed = param.collapsed, collapsed = _collapsed === void 0 ? true : _collapsed;
    var ref = (0,react.useState)(collapsed), isCollapsed = ref[0], setIsCollapsed = ref[1];
    var toggleCollapsed = function(e) {
        e.preventDefault();
        setIsCollapsed(!isCollapsed);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "flex items-center border-t border-gray-900",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(helper_link/* default */.Z, {
                            href: element.href,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "".concat(element.icon ? '' : '', " hover:underline text-primary flex-grow flex items-center justify-between text-base py-3 font-medium text-left"),
                                onClick: function() {
                                    close();
                                    closeParent();
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: element.name
                                    }),
                                    element.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_ChevronRightIcon, {
                                        className: "flex-shrink-0 h-6 w-6 text-primary",
                                        "aria-hidden": "true"
                                    })
                                ]
                            })
                        }),
                        !element.icon && // eslint-disable-next-line react/jsx-no-useless-fragment
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: isCollapsed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownIcon/* default */.Z, {
                                className: "flex-shrink-0 h-6 w-6 text-primary",
                                "aria-hidden": "true",
                                onClick: toggleCollapsed
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_ChevronUpIcon, {
                                className: "flex-shrink-0 h-6 w-6 text-primary",
                                "aria-hidden": "true",
                                onClick: toggleCollapsed
                            })
                        })
                    ]
                }),
                element.subList && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "mb-3 w-full ".concat(isCollapsed ? 'hidden' : ''),
                    children: element.subList.map(function(a) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(helper_link/* default */.Z, {
                                href: a.href,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: "text-primary hover:underline w-full text-left flex justify-start text-base py-1 font-light",
                                    onClick: function() {
                                        close();
                                        closeParent();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_ChevronRightIcon, {
                                            className: "-ml-1.5 h-5 mr-2 w-5 grow-0 shrink-0"
                                        }),
                                        ' ',
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            dangerouslySetInnerHTML: {
                                                __html: a.name
                                            }
                                        })
                                    ]
                                })
                            })
                        }, a.name);
                    })
                })
            ]
        })
    }, element.name));
};

;// CONCATENATED MODULE: ./src/components/globals/header/sidebar.js







function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function accentFold(inStr) {
    return inStr.replace(/([àáâãäå])|([çčć])|([èéêë])|([ìíîï])|([ñ])|([òóôõöø])|([ß])|([ùúûü])|([ÿ])|([æ])/g, function(str, a, c, e, i, n, o, s, u, y, ae) {
        if (a) return 'a';
        if (c) return 'c';
        if (e) return 'e';
        if (i) return 'i';
        if (n) return 'n';
        if (o) return 'o';
        if (s) return 's';
        if (u) return 'u';
        if (y) return 'y';
        if (ae) return 'ae';
        return '';
    });
}
var contains = function(needle, haystack) {
    return accentFold("".concat(haystack)).toLowerCase().indexOf(accentFold("".concat(needle)).toLowerCase()) !== -1;
};
function HeaderSidebar(param1) {
    var data = param1.data, click = param1.click, closeParent = param1.closeParent;
    var ref2 = (0,react.useState)(data), nav1 = ref2[0], setNav = ref2[1];
    var ref1 = (0,react.useState)(data.list), menu = ref1[0], setMenu = ref1[1];
    var list1 = data.list;
    (0,react.useEffect)(function() {
        setNav(data);
        setMenu(data.list);
    }, [
        data
    ]);
    var search = function(e) {
        var _instance, _instance1;
        var nav = (_instance = []).concat.apply(_instance, _toConsumableArray(list1)).slice();
        var term = "".concat(e.target.value);
        var x = (_instance1 = []).concat.apply(_instance1, _toConsumableArray(list1.slice())).slice().filter(function(i) {
            return !i.header;
        }).map(function(i1) {
            var ref3;
            var children = (ref3 = i1.children) === null || ref3 === void 0 ? void 0 : ref3.map(function(i2) {
                var ref4;
                var list = (ref4 = i2.list) === null || ref4 === void 0 ? void 0 : ref4.map(function(i3) {
                    var ref;
                    return _objectSpread({}, i3, {
                        collapsed: false,
                        subList: (ref = i3.subList) === null || ref === void 0 ? void 0 : ref.filter(function(d) {
                            return !term || contains(term, d.name);
                        })
                    });
                });
                return _objectSpread({}, i2, {
                    collapsed: false,
                    list: list === null || list === void 0 ? void 0 : list.filter(function(c) {
                        var ref;
                        return !term || ((ref = c.subList) === null || ref === void 0 ? void 0 : ref.length) > 0 || contains(term, c.name);
                    })
                });
            });
            return _objectSpread({}, i1, {
                collapsed: false,
                children: children === null || children === void 0 ? void 0 : children.filter(function(b) {
                    var ref;
                    return !term || ((ref = b.list) === null || ref === void 0 ? void 0 : ref.length) > 0 || contains(term, b.name);
                })
            });
        }).filter(function(a) {
            var ref;
            return !term || ((ref = a.children) === null || ref === void 0 ? void 0 : ref.length) > 0 || contains(term, a.name);
        });
        setMenu(term ? x : nav);
    };
    var _collapsed;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_SearchIcon, {
                        className: "absolute left-2 top-2.5 h-5 text-primary text-opacity-70 "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        className: "bg-white bg-opacity-20 px-3 py-2 pl-10 -ml-1 mb-3 w-full placeholder:text-action-50 placeholder:text-opacity-40 focus:ring-1 focus:ring-primary focus:ring-opacity-25",
                        placeholder: "\"".concat(nav1.name, "\" durchsuchen"),
                        onKeyUp: search
                    })
                ]
            }),
            menu.map(function(item) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                    children: !item.children ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: item.mainClass,
                        children: item.header ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "uppercase font-semibold text-xs text-white mt-5",
                            children: item.name
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            onClick: function() {
                                return click;
                            },
                            href: item.href,
                            className: "text-action-50 group cursor-pointer w-full flex items-center hover:underline",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-10",
                                    children: item.icon !== '' && /*#__PURE__*/ (0,jsx_runtime.jsx)(item.icon, {
                                        className: "text-action-50 mr-3 flex-shrink-0 h-5 w-5",
                                        "aria-hidden": "true"
                                    })
                                }),
                                item.name
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover */.J, {
                        as: "div",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover.Button */.J.Button, {
                                    className: "".concat(item.mainClass, " text-action-50 group w-full flex items-center hover:underline"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-10",
                                            children: item.icon !== '' && /*#__PURE__*/ (0,jsx_runtime.jsx)(item.icon, {
                                                className: "text-action-50 mr-3 flex-shrink-0 h-5 w-5",
                                                "aria-hidden": "true"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "flex-1 text-left",
                                            children: item.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_ChevronRightIcon, {
                                            className: "text-action-50 flex-shrink-0 h-6 w-6",
                                            "aria-hidden": "true"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                                    enter: "transition duration-200 ease-out",
                                    enterFrom: "opacity-0",
                                    enterTo: "opacity-100",
                                    leave: "transition duration-100 ease-in",
                                    leaveFrom: "opacity-100",
                                    leaveTo: "opacity-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Panel */.J.Panel, {
                                        className: "bg-white absolute top-12 md:top-12 lg:top-18 left-2.5 md:left-full lg:left-[470px] w-full md:w-[407px] lg:w-full md:right-0 h-screen",
                                        children: function(param) {
                                            var close = param.close;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                className: "px-6 py-8 lg:px-16 lg:pb-26 pb-18 overflow-y-auto h-full",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover.Button */.J.Button, {
                                                        className: "w-full flex items-center space-x-2 mb-6 text-sm uppercase font-semibold text-primary",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_ChevronRightIcon, {
                                                                className: "h-6 w-6 text-primary -ml-2 transform rotate-180",
                                                                "aria-hidden": "true"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "Zur\xfcck"
                                                            })
                                                        ]
                                                    }),
                                                    item.children.map(function(subItem) {
                                                        var ref;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(popover/* Popover.Button */.J.Button, {
                                                            className: "w-full",
                                                            children: [
                                                                subItem.name ? /*#__PURE__*/ (0,jsx_runtime.jsx)(helper_link/* default */.Z, {
                                                                    href: subItem.href,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                        className: "text-primary hover:underline w-full flex items-center justify-between text-lg font-medium py-3",
                                                                        onClick: function() {
                                                                            close();
                                                                            closeParent();
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                children: subItem.name
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_ChevronRightIcon, {
                                                                                className: "flex-shrink-0 h-6 w-6 text-primary",
                                                                                "aria-hidden": "true"
                                                                            })
                                                                        ]
                                                                    })
                                                                }) : '',
                                                                subItem === null || subItem === void 0 ? void 0 : (ref = subItem.list) === null || ref === void 0 ? void 0 : ref.map(function(v, k) {
                                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(CollapsableLocation, {
                                                                        collapsed: (_collapsed = v.collapsed) !== null && _collapsed !== void 0 ? _collapsed : true,
                                                                        element: v,
                                                                        close: close,
                                                                        closeParent: closeParent
                                                                    }, k);
                                                                })
                                                            ]
                                                        }, subItem.name);
                                                    })
                                                ]
                                            });
                                        }
                                    })
                                })
                            ]
                        })
                    })
                }, item.name);
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./public/assets/images/logo-inverted.svg
function logo_inverted_extends() { logo_inverted_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return logo_inverted_extends.apply(this, arguments); }



var SvgLogoInverted = function SvgLogoInverted(props) {
  return /*#__PURE__*/react.createElement("svg", logo_inverted_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240.27 58.34"
  }, props), /*#__PURE__*/react.createElement("g", {
    "data-name": "Ebene 2"
  }, /*#__PURE__*/react.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M59.29 33.78c0 1 .05 2.29 1.45 2.29 1.2 0 1.51-.57 1.51-2.29v-4h5.25v2.75c0 6.35-2.34 8.17-6.76 8.17-3.8 0-6.71-2.08-6.71-8.43V19.9c0-6.35 2.91-8.43 6.71-8.43 4.42 0 6.76 1.82 6.76 8.17v2.23h-5.25v-3.43c0-1.72-.31-2.29-1.51-2.29-1.4 0-1.45 1.25-1.45 2.29ZM75 17.92v22.41h-5.21V2.11H75v12.17c.42-.26 2.44-2.81 4.26-2.81 2.81 0 4 3.23 4 5.57v23.29H78V17.82c0-1.1-.62-1.25-1.24-1.25-1.04 0-1.76 1.35-1.76 1.35Zm19.19 3.85v-3.12c0-1 0-2.6-1.46-2.6-1.77 0-1.45 2.6-1.51 4.21H86v-1.2a7.3 7.3 0 0 1 7.07-7.59 6.4 6.4 0 0 1 6.4 6.45v17.47a26.83 26.83 0 0 0 .36 4.94H94.7a4.38 4.38 0 0 1-.47-2.33h-.37a5.16 5.16 0 0 1-4.21 2.71c-1.4 0-4.21-1-4.21-7 0-9.6 8.27-10.23 8.79-11.94ZM92 35.6a2 2 0 0 0 2.19-1.72V26.6c-2.55 1.09-3.64 3.64-3.64 6.35.04.67.19 2.65 1.45 2.65Zm21-18.31a4.66 4.66 0 0 0-4.11.68 3.22 3.22 0 0 0-1.14 2.6v19.76h-5.25V11.89h5.25v3.17a5.14 5.14 0 0 1 5.25-3.59Zm9.67-12.42v7h3.59v4.73h-3.59v14.16c0 1.77 0 4.68 1.67 4.68a12.07 12.07 0 0 0 1.92-.2v5.14a10 10 0 0 1-2.81.37c-6 0-6-6.24-6-9.57V16.62h-2.65v-4.73h2.65v-7Zm19.55 25.27v3.28s0 7.33-6.81 7.33-6.76-7.49-6.76-7.49V19s.05-7.49 6.81-7.49 6.76 7.33 6.76 7.33v8.27h-8.68v6.19s0 2.86 1.92 2.86 1.88-2.86 1.88-2.86v-3.16ZM133.59 23h3.8v-4s.1-2.91-1.88-2.91-1.92 2.91-1.92 2.91Zm22.77-5.67a4.63 4.63 0 0 0-4.1.68 3.21 3.21 0 0 0-1.15 2.6v19.72h-5.25V11.89h5.25v3.17a5.15 5.15 0 0 1 5.25-3.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M37.6 4.62a23.84 23.84 0 1 0 5.74 33.23A23.85 23.85 0 0 0 37.6 4.62Z",
    style: {
      fill: "#005faa",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M37.53 4.71a23.72 23.72 0 1 0 5.71 33.07 23.72 23.72 0 0 0-5.71-33.07Z",
    style: {
      fill: "#0060ab",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M37.47 4.81a23.61 23.61 0 1 0 5.68 32.91 23.62 23.62 0 0 0-5.68-32.91Z",
    style: {
      fill: "#0060ab",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M37.4 4.9a23.49 23.49 0 1 0 5.66 32.75A23.5 23.5 0 0 0 37.4 4.9Z",
    style: {
      fill: "#0061ab",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M37.33 5A23.38 23.38 0 1 0 43 37.59 23.39 23.39 0 0 0 37.33 5Z",
    style: {
      fill: "#0061ac",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M37.27 5.08a23.27 23.27 0 1 0 5.6 32.44 23.27 23.27 0 0 0-5.6-32.44Z",
    style: {
      fill: "#0062ac",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M37.2 5.18a23.15 23.15 0 1 0 5.58 32.28A23.15 23.15 0 0 0 37.2 5.18Z",
    style: {
      fill: "#0062ad",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M37.14 5.27a23 23 0 1 0 5.55 32.12 23 23 0 0 0-5.55-32.12Z",
    style: {
      fill: "#0063ad",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M37.07 5.36a22.93 22.93 0 1 0 5.52 32 22.94 22.94 0 0 0-5.52-32Z",
    style: {
      fill: "#0064ae",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M37 5.45a22.82 22.82 0 1 0 5.5 31.81A22.83 22.83 0 0 0 37 5.45Z",
    style: {
      fill: "#0064ae",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M36.94 5.55a22.7 22.7 0 1 0 5.47 31.65 22.7 22.7 0 0 0-5.47-31.65Z",
    style: {
      fill: "#0065ae",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M36.88 5.64a22.59 22.59 0 1 0 5.44 31.49 22.6 22.6 0 0 0-5.44-31.49Z",
    style: {
      fill: "#0065af",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M36.81 5.73a22.47 22.47 0 1 0 5.41 31.34 22.5 22.5 0 0 0-5.41-31.34Z",
    style: {
      fill: "#0066af",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M36.75 5.82A22.37 22.37 0 1 0 42.13 37a22.37 22.37 0 0 0-5.38-31.18Z",
    style: {
      fill: "#0067b0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M36.68 5.92a22.24 22.24 0 1 0 5.36 31 22.25 22.25 0 0 0-5.36-31Z",
    style: {
      fill: "#0067b0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M36.62 6A22.14 22.14 0 1 0 42 36.87 22.14 22.14 0 0 0 36.62 6Z",
    style: {
      fill: "#0068b1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M36.55 6.1a22 22 0 1 0 5.3 30.7 22 22 0 0 0-5.3-30.7Z",
    style: {
      fill: "#0068b1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M36.49 6.19a21.91 21.91 0 1 0 5.27 30.55 21.93 21.93 0 0 0-5.27-30.55Z",
    style: {
      fill: "#0069b1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M36.42 6.29a21.79 21.79 0 1 0 5.25 30.38 21.8 21.8 0 0 0-5.25-30.38Z",
    style: {
      fill: "#006ab2",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M36.35 6.38a21.68 21.68 0 1 0 5.23 30.23 21.69 21.69 0 0 0-5.23-30.23Z",
    style: {
      fill: "#006ab2",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M36.29 6.47a21.57 21.57 0 1 0 5.19 30.07 21.58 21.58 0 0 0-5.19-30.07Z",
    style: {
      fill: "#006bb3",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M36.22 6.56a21.46 21.46 0 1 0 5.17 29.92 21.46 21.46 0 0 0-5.17-29.92Z",
    style: {
      fill: "#006bb3",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M36.16 6.66a21.34 21.34 0 1 0 5.14 29.75 21.35 21.35 0 0 0-5.14-29.75Z",
    style: {
      fill: "#006cb4",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M36.09 6.75a21.23 21.23 0 1 0 5.12 29.6 21.24 21.24 0 0 0-5.12-29.6Z",
    style: {
      fill: "#006cb4",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M36 6.84a21.12 21.12 0 1 0 5.08 29.44A21.13 21.13 0 0 0 36 6.84Z",
    style: {
      fill: "#006db5",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M36 6.93a21 21 0 1 0 5 29.29 21 21 0 0 0-5-29.29Z",
    style: {
      fill: "#006eb5",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M35.9 7a20.89 20.89 0 1 0 5 29.12A20.9 20.9 0 0 0 35.9 7Z",
    style: {
      fill: "#006eb5",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M35.83 7.12a20.77 20.77 0 1 0 5 29 20.77 20.77 0 0 0-5-29Z",
    style: {
      fill: "#006fb6",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M35.77 7.21a20.66 20.66 0 1 0 5 28.81 20.67 20.67 0 0 0-5-28.81Z",
    style: {
      fill: "#006fb6",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M35.7 7.3A20.55 20.55 0 1 0 40.65 36 20.56 20.56 0 0 0 35.7 7.3Z",
    style: {
      fill: "#0070b7",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M35.64 7.4a20.43 20.43 0 1 0 4.92 28.49A20.44 20.44 0 0 0 35.64 7.4Z",
    style: {
      fill: "#0071b7",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M35.57 7.49a20.32 20.32 0 1 0 4.9 28.33 20.33 20.33 0 0 0-4.9-28.33Z",
    style: {
      fill: "#0071b7",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M35.51 7.58a20.21 20.21 0 1 0 4.86 28.18 20.22 20.22 0 0 0-4.86-28.18Z",
    style: {
      fill: "#0072b8",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M35.44 7.67a20.1 20.1 0 1 0 4.84 28 20.11 20.11 0 0 0-4.84-28Z",
    style: {
      fill: "#0072b8",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M35.37 7.77a20 20 0 1 0 4.82 27.86 20 20 0 0 0-4.82-27.86Z",
    style: {
      fill: "#0073b9",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M35.31 7.86a19.87 19.87 0 1 0 4.79 27.7 19.87 19.87 0 0 0-4.79-27.7Z",
    style: {
      fill: "#0073b9",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M35.24 8A19.76 19.76 0 1 0 40 35.5 19.76 19.76 0 0 0 35.24 8Z",
    style: {
      fill: "#0074ba",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M35.18 8a19.65 19.65 0 1 0 4.73 27.39A19.66 19.66 0 0 0 35.18 8Z",
    style: {
      fill: "#0075ba",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M35.11 8.14a19.53 19.53 0 1 0 4.71 27.23 19.53 19.53 0 0 0-4.71-27.23Z",
    style: {
      fill: "#0075ba",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M35.05 8.23a19.42 19.42 0 1 0 4.67 27.07 19.43 19.43 0 0 0-4.67-27.07Z",
    style: {
      fill: "#0076bb",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M35 8.32a19.3 19.3 0 1 0 4.65 26.91A19.31 19.31 0 0 0 35 8.32Z",
    style: {
      fill: "#0076bb",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M34.92 8.41a19.19 19.19 0 1 0 4.62 26.76 19.2 19.2 0 0 0-4.62-26.76Z",
    style: {
      fill: "#0077bc",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M34.85 8.51a19.07 19.07 0 1 0 4.6 26.59 19.08 19.08 0 0 0-4.6-26.59Z",
    style: {
      fill: "#0078bc",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M34.79 8.6A19 19 0 1 0 39.35 35a19 19 0 0 0-4.56-26.4Z",
    style: {
      fill: "#0078bd",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M34.72 8.69A18.85 18.85 0 1 0 39.26 35a18.85 18.85 0 0 0-4.54-26.31Z",
    style: {
      fill: "#0079bd",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M34.66 8.78a18.74 18.74 0 1 0 4.51 26.13 18.76 18.76 0 0 0-4.51-26.13Z",
    style: {
      fill: "#0079bd",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M34.59 8.88a18.62 18.62 0 1 0 4.49 26 18.63 18.63 0 0 0-4.49-26Z",
    style: {
      fill: "#007abe",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M34.53 9A18.51 18.51 0 1 0 39 34.78 18.53 18.53 0 0 0 34.53 9Z",
    style: {
      fill: "#007abe",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M34.46 9.06a18.4 18.4 0 1 0 4.43 25.65 18.41 18.41 0 0 0-4.43-25.65Z",
    style: {
      fill: "#007bbf",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M34.4 9.15a18.29 18.29 0 1 0 4.4 25.5 18.29 18.29 0 0 0-4.4-25.5Z",
    style: {
      fill: "#007cbf",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M34.33 9.25a18.17 18.17 0 1 0 4.38 25.33 18.17 18.17 0 0 0-4.38-25.33Z",
    style: {
      fill: "#007cbf",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M34.26 9.34a18.06 18.06 0 1 0 4.35 25.18 18.07 18.07 0 0 0-4.35-25.18Z",
    style: {
      fill: "#007dc0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M34.2 9.43a17.95 17.95 0 1 0 4.32 25 17.95 17.95 0 0 0-4.32-25Z",
    style: {
      fill: "#007dc0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M34.13 9.52a17.83 17.83 0 1 0 4.3 24.86 17.84 17.84 0 0 0-4.3-24.86Z",
    style: {
      fill: "#007ec1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M34.07 9.62a17.72 17.72 0 1 0 4.27 24.7 17.73 17.73 0 0 0-4.27-24.7Z",
    style: {
      fill: "#007fc1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M34 9.71a17.6 17.6 0 1 0 4.24 24.54A17.6 17.6 0 0 0 34 9.71Z",
    style: {
      fill: "#007fc1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M33.94 9.8a17.49 17.49 0 1 0 4.21 24.39A17.5 17.5 0 0 0 33.94 9.8Z",
    style: {
      fill: "#0080c2",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M33.87 9.89a17.38 17.38 0 1 0 4.19 24.23 17.39 17.39 0 0 0-4.19-24.23Z",
    style: {
      fill: "#0080c2",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M33.81 10A17.26 17.26 0 1 0 38 34.06 17.27 17.27 0 0 0 33.81 10Z",
    style: {
      fill: "#0081c3",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M33.74 10.08A17.15 17.15 0 1 0 37.87 34a17.15 17.15 0 0 0-4.13-23.92Z",
    style: {
      fill: "#0081c3",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M33.68 10.17a17 17 0 1 0 4.1 23.76 17.06 17.06 0 0 0-4.1-23.76Z",
    style: {
      fill: "#0082c3",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M33.61 10.26a16.93 16.93 0 1 0 4.08 23.6 16.94 16.94 0 0 0-4.08-23.6Z",
    style: {
      fill: "#0083c4",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M33.55 10.36A16.81 16.81 0 1 0 37.6 33.8a16.83 16.83 0 0 0-4.05-23.44Z",
    style: {
      fill: "#0083c4",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M33.48 10.45a16.7 16.7 0 1 0 4 23.28 16.7 16.7 0 0 0-4-23.28Z",
    style: {
      fill: "#0084c5",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M33.42 10.54a16.59 16.59 0 1 0 4 23.13 16.6 16.6 0 0 0-4-23.13Z",
    style: {
      fill: "#0084c5",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M33.35 10.63a16.47 16.47 0 1 0 4 23 16.48 16.48 0 0 0-4-23Z",
    style: {
      fill: "#0085c5",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M33.28 10.73a16.36 16.36 0 1 0 3.94 22.8 16.35 16.35 0 0 0-3.94-22.8Z",
    style: {
      fill: "#0086c6",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M33.22 10.82a16.24 16.24 0 1 0 3.91 22.65 16.25 16.25 0 0 0-3.91-22.65Z",
    style: {
      fill: "#0086c6",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M33.15 10.91A16.13 16.13 0 1 0 37 33.4a16.14 16.14 0 0 0-3.85-22.49Z",
    style: {
      fill: "#0087c7",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M33.09 11A16 16 0 1 0 37 33.34 16 16 0 0 0 33.09 11Z",
    style: {
      fill: "#0087c7",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M33 11.1a15.9 15.9 0 1 0 3.83 22.17A15.9 15.9 0 0 0 33 11.1Z",
    style: {
      fill: "#0088c7",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M33 11.19a15.79 15.79 0 1 0 3.8 22 15.8 15.8 0 0 0-3.8-22Z",
    style: {
      fill: "#0089c8",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M32.89 11.28a15.68 15.68 0 1 0 3.78 21.86 15.68 15.68 0 0 0-3.78-21.86Z",
    style: {
      fill: "#0089c8",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M32.83 11.37a15.57 15.57 0 1 0 3.75 21.71 15.58 15.58 0 0 0-3.75-21.71Z",
    style: {
      fill: "#008ac8",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M32.76 11.47A15.45 15.45 0 1 0 36.48 33a15.46 15.46 0 0 0-3.72-21.53Z",
    style: {
      fill: "#008ac9",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M32.7 11.56A15.34 15.34 0 1 0 36.39 33a15.35 15.35 0 0 0-3.69-21.44Z",
    style: {
      fill: "#008bc9",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M32.63 11.65a15.23 15.23 0 1 0 3.67 21.23 15.24 15.24 0 0 0-3.67-21.23Z",
    style: {
      fill: "#008bca",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M32.57 11.74a15.12 15.12 0 1 0 3.64 21.08 15.13 15.13 0 0 0-3.64-21.08Z",
    style: {
      fill: "#008cca",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M32.5 11.84a15 15 0 1 0 3.61 20.91 15 15 0 0 0-3.61-20.91Z",
    style: {
      fill: "#008dca",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M32.44 11.93A14.89 14.89 0 1 0 36 32.68a14.89 14.89 0 0 0-3.56-20.75Z",
    style: {
      fill: "#008dcb",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M32.37 12a14.77 14.77 0 1 0 3.56 20.6A14.79 14.79 0 0 0 32.37 12Z",
    style: {
      fill: "#008ecb",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M32.3 12.11a14.66 14.66 0 1 0 3.54 20.44 14.66 14.66 0 0 0-3.54-20.44Z",
    style: {
      fill: "#008ecc",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M32.24 12.21a14.54 14.54 0 1 0 3.5 20.28 14.55 14.55 0 0 0-3.5-20.28Z",
    style: {
      fill: "#008fcc",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M32.17 12.3a14.43 14.43 0 1 0 3.48 20.12 14.43 14.43 0 0 0-3.48-20.12Z",
    style: {
      fill: "#0090cc",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M32.11 12.39a14.32 14.32 0 1 0 3.45 20 14.33 14.33 0 0 0-3.45-20Z",
    style: {
      fill: "#0090cd",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M32 12.48a14.21 14.21 0 1 0 3.43 19.81A14.21 14.21 0 0 0 32 12.48Z",
    style: {
      fill: "#0091cd",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M32 12.58a14.09 14.09 0 1 0 3.39 19.65A14.09 14.09 0 0 0 32 12.58Z",
    style: {
      fill: "#0091cd",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M31.91 12.67a14 14 0 1 0 3.37 19.49 14 14 0 0 0-3.37-19.49Z",
    style: {
      fill: "#0092ce",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M31.85 12.76a13.87 13.87 0 1 0 3.34 19.34 13.88 13.88 0 0 0-3.34-19.34Z",
    style: {
      fill: "#0093ce",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M31.78 12.85A13.76 13.76 0 1 0 35.1 32a13.76 13.76 0 0 0-3.32-19.15Z",
    style: {
      fill: "#0093ce",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M31.72 13A13.64 13.64 0 1 0 35 32a13.65 13.65 0 0 0-3.28-19Z",
    style: {
      fill: "#0094cf",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M31.65 13a13.53 13.53 0 1 0 3.26 18.9A13.54 13.54 0 0 0 31.65 13Z",
    style: {
      fill: "#0094cf",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M31.59 13.13a13.42 13.42 0 1 0 3.23 18.7 13.42 13.42 0 0 0-3.23-18.7Z",
    style: {
      fill: "#0095d0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M31.52 13.22a13.3 13.3 0 1 0 3.21 18.55 13.31 13.31 0 0 0-3.21-18.55Z",
    style: {
      fill: "#0096d0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M31.46 13.32a13.19 13.19 0 1 0 3.17 18.38 13.19 13.19 0 0 0-3.17-18.38Z",
    style: {
      fill: "#0096d0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M31.39 13.41a13.07 13.07 0 1 0 3.15 18.23 13.08 13.08 0 0 0-3.15-18.23Z",
    style: {
      fill: "#0097d1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M31.33 13.5a13 13 0 1 0 3.12 18.07 13 13 0 0 0-3.12-18.07Z",
    style: {
      fill: "#0097d1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M31.26 13.59a12.85 12.85 0 1 0 3.09 17.92 12.87 12.87 0 0 0-3.09-17.92Z",
    style: {
      fill: "#0098d1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M31.19 13.69a12.73 12.73 0 1 0 3.07 17.75 12.73 12.73 0 0 0-3.07-17.75Z",
    style: {
      fill: "#0099d2",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M31.13 13.78a12.62 12.62 0 1 0 3 17.6 12.63 12.63 0 0 0-3-17.6Z",
    style: {
      fill: "#0099d2",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M31.06 13.87a12.51 12.51 0 1 0 3 17.44 12.51 12.51 0 0 0-3-17.44Z",
    style: {
      fill: "#009ad2",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M31 14a12.4 12.4 0 1 0 3 17.29A12.41 12.41 0 0 0 31 14Z",
    style: {
      fill: "#009ad3",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M30.93 14.06a12.28 12.28 0 1 0 3 17.12 12.28 12.28 0 0 0-3-17.12Z",
    style: {
      fill: "#009bd3",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M30.87 14.15a12.17 12.17 0 1 0 2.93 17 12.17 12.17 0 0 0-2.93-17Z",
    style: {
      fill: "#009bd4",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M30.8 14.24a12.06 12.06 0 1 0 2.91 16.81 12.06 12.06 0 0 0-2.91-16.81Z",
    style: {
      fill: "#009cd4",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M30.74 14.33A11.95 11.95 0 1 0 33.61 31a12 12 0 0 0-2.87-16.67Z",
    style: {
      fill: "#009dd4",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M30.67 14.43a11.82 11.82 0 1 0 2.85 16.49 11.82 11.82 0 0 0-2.85-16.49Z",
    style: {
      fill: "#009dd5",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M30.61 14.52a11.72 11.72 0 1 0 2.82 16.33 11.72 11.72 0 0 0-2.82-16.33Z",
    style: {
      fill: "#009ed5",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M30.54 14.61a11.6 11.6 0 1 0 2.8 16.18 11.61 11.61 0 0 0-2.8-16.18Z",
    style: {
      fill: "#009ed5",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M30.48 14.7a11.49 11.49 0 1 0 2.76 16 11.49 11.49 0 0 0-2.76-16Z",
    style: {
      fill: "#009fd6",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M30.41 14.8a11.37 11.37 0 1 0 2.74 15.86 11.38 11.38 0 0 0-2.74-15.86Z",
    style: {
      fill: "#00a0d6",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M30.35 14.89a11.26 11.26 0 1 0 2.71 15.7 11.28 11.28 0 0 0-2.71-15.7Z",
    style: {
      fill: "#00a0d6",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M30.28 15A11.15 11.15 0 1 0 33 30.53 11.16 11.16 0 0 0 30.28 15Z",
    style: {
      fill: "#00a1d7",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M30.21 15.07a11 11 0 1 0 2.66 15.39 11 11 0 0 0-2.66-15.39Z",
    style: {
      fill: "#00a1d7",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M30.15 15.17a10.92 10.92 0 1 0 2.63 15.23 10.93 10.93 0 0 0-2.63-15.23Z",
    style: {
      fill: "#00a2d7",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M30.08 15.26a10.81 10.81 0 1 0 2.61 15.07 10.8 10.8 0 0 0-2.61-15.07Z",
    style: {
      fill: "#00a2d8",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M30 15.35a10.7 10.7 0 1 0 2.6 14.92A10.71 10.71 0 0 0 30 15.35Z",
    style: {
      fill: "#00a3d8",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M30 15.44a10.58 10.58 0 1 0 2.5 14.76A10.58 10.58 0 0 0 30 15.44Z",
    style: {
      fill: "#00a4d8",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M29.89 15.54a10.47 10.47 0 1 0 2.52 14.59 10.47 10.47 0 0 0-2.52-14.59Z",
    style: {
      fill: "#00a4d9",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M29.82 15.63a10.35 10.35 0 1 0 2.5 14.44 10.36 10.36 0 0 0-2.5-14.44Z",
    style: {
      fill: "#00a5d9",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M29.76 15.72A10.25 10.25 0 1 0 32.23 30a10.25 10.25 0 0 0-2.47-14.28Z",
    style: {
      fill: "#00a5d9",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M29.69 15.81a10.13 10.13 0 1 0 2.44 14.13 10.13 10.13 0 0 0-2.44-14.13Z",
    style: {
      fill: "#00a6da",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M29.63 15.91a10 10 0 1 0 2.41 14 10 10 0 0 0-2.41-14Z",
    style: {
      fill: "#00a7da",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M29.56 16A9.9 9.9 0 1 0 32 29.81 9.91 9.91 0 0 0 29.56 16Z",
    style: {
      fill: "#00a7da",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M29.5 16.09a9.79 9.79 0 1 0 2.36 13.65 9.8 9.8 0 0 0-2.36-13.65Z",
    style: {
      fill: "#00a8db",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M29.43 16.18a9.68 9.68 0 1 0 2.33 13.5 9.69 9.69 0 0 0-2.33-13.5Z",
    style: {
      fill: "#00a8db",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M29.37 16.28a9.56 9.56 0 1 0 2.3 13.33 9.57 9.57 0 0 0-2.3-13.33Z",
    style: {
      fill: "#00a9db",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M29.3 16.37a9.45 9.45 0 1 0 2.28 13.18 9.46 9.46 0 0 0-2.28-13.18Z",
    style: {
      fill: "#00aadc",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M29.23 16.46a9.34 9.34 0 1 0 2.25 13 9.34 9.34 0 0 0-2.25-13Z",
    style: {
      fill: "#00aadc",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M29.17 16.55a9.23 9.23 0 1 0 2.22 12.87 9.23 9.23 0 0 0-2.22-12.87Z",
    style: {
      fill: "#00abdc",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M29.1 16.65a9.11 9.11 0 1 0 2.2 12.7 9.11 9.11 0 0 0-2.2-12.7Z",
    style: {
      fill: "#00abdd",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M29 16.74a9 9 0 1 0 2.17 12.54A9 9 0 0 0 29 16.74Z",
    style: {
      fill: "#00acdd",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M29 16.83a8.88 8.88 0 1 0 2.14 12.39A8.88 8.88 0 0 0 29 16.83Z",
    style: {
      fill: "#00addd",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M28.91 16.92A8.78 8.78 0 1 0 31 29.15a8.78 8.78 0 0 0-2.09-12.23Z",
    style: {
      fill: "#00adde",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M28.84 17a8.65 8.65 0 1 0 2.09 12.07A8.65 8.65 0 0 0 28.84 17Z",
    style: {
      fill: "#00aede",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M28.78 17.11A8.55 8.55 0 1 0 30.84 29a8.55 8.55 0 0 0-2.06-11.89Z",
    style: {
      fill: "#00aede",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M28.71 17.2a8.43 8.43 0 1 0 2 11.76 8.43 8.43 0 0 0-2-11.76Z",
    style: {
      fill: "#00afdf",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M28.65 17.29a8.32 8.32 0 1 0 2 11.6 8.32 8.32 0 0 0-2-11.6Z",
    style: {
      fill: "#00b0df",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M28.58 17.39a8.2 8.2 0 1 0 2 11.44 8.2 8.2 0 0 0-2-11.44Z",
    style: {
      fill: "#00b0df",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M28.52 17.48a8.09 8.09 0 1 0 1.95 11.28 8.1 8.1 0 0 0-1.95-11.28Z",
    style: {
      fill: "#00b1e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M28.45 17.57a8 8 0 1 0 1.92 11.13 8 8 0 0 0-1.92-11.13Z",
    style: {
      fill: "#00b2e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M28.39 17.66a7.87 7.87 0 1 0 1.89 11 7.88 7.88 0 0 0-1.89-11Z",
    style: {
      fill: "#00b2e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M28.32 17.76a7.75 7.75 0 1 0 1.87 10.81 7.75 7.75 0 0 0-1.87-10.81Z",
    style: {
      fill: "#00b3e1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M28.26 17.85A7.64 7.64 0 1 0 30.1 28.5a7.65 7.65 0 0 0-1.84-10.65Z",
    style: {
      fill: "#00b3e1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M28.19 17.94A7.53 7.53 0 1 0 30 28.43a7.53 7.53 0 0 0-1.81-10.49Z",
    style: {
      fill: "#00b4e1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M28.12 18a7.42 7.42 0 1 0 1.79 10.34A7.42 7.42 0 0 0 28.12 18Z",
    style: {
      fill: "#00b4e2",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M28.06 18.13a7.3 7.3 0 1 0 1.76 10.17 7.3 7.3 0 0 0-1.76-10.17Z",
    style: {
      fill: "#00b5e2",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M45.09 17.93s-8.37-7.27-19.38-1S9.19 25 5.93 22.51l-5-3.78-.11.27 5 3.7s6.63 6 15-.42c6.64-5.07 16.87-9.64 24.12-4.19l2.2 1.63c0-.11-.05-.21-.07-.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M40.8 23.88s-8.38-7.27-19.38-1-16.53 8-19.78 5.55l-.95-.7c0 .14 0 .28.07.41l.72.5s6.63 6 15-.42c6.64-5.07 16.87-9.64 24.12-4.19L47 28.9c0-.12.05-.24.07-.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M10.07 16.78s6.63 6 15-.42c4.84-3.7 11.6-7.13 17.71-6.6a24 24 0 0 0-5-5A23.24 23.24 0 0 0 4.89 9.67a25.31 25.31 0 0 0-1.43 2.22Z",
    style: {
      fill: "#00b5e2"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M10.2 16.72s6.59 5.94 14.91-.42c4.81-3.67 11.53-7.09 17.62-6.55a24.06 24.06 0 0 0-4.93-5 23.2 23.2 0 0 0-34.17 7.11Z",
    style: {
      fill: "#00b5e2"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M10.33 16.66s6.56 5.9 14.82-.41c4.79-3.66 11.47-7 17.52-6.52a23.77 23.77 0 0 0-4.9-5A23 23 0 0 0 5.2 9.64a25.45 25.45 0 0 0-1.41 2.19Z",
    style: {
      fill: "#00b6e2"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M10.46 16.61s6.54 5.86 14.74-.42c4.76-3.63 11.4-7 17.41-6.48a23.73 23.73 0 0 0-4.87-4.94A22.84 22.84 0 0 0 5.36 9.62 24.35 24.35 0 0 0 4 11.8Z",
    style: {
      fill: "#00b6e2"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M10.59 16.55s6.48 5.83 14.65-.41c4.73-3.62 11.34-7 17.32-6.45a24 24 0 0 0-4.85-4.91A22.72 22.72 0 0 0 5.52 9.6a24.09 24.09 0 0 0-1.39 2.17Z",
    style: {
      fill: "#00b6e3"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M10.72 16.49s6.44 5.8 14.56-.41C30 12.49 36.56 9.16 42.5 9.68a23.21 23.21 0 0 0-4.82-4.88 22.69 22.69 0 0 0-33.39 7Z",
    style: {
      fill: "#00b7e3"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M10.84 16.44s6.41 5.76 14.49-.44c4.67-3.54 11.2-6.86 17.11-6.34a22.92 22.92 0 0 0-4.79-4.85A22.43 22.43 0 0 0 5.84 9.57a20.59 20.59 0 0 0-1.38 2.15Z",
    style: {
      fill: "#00b7e3"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M11 16.38s6.37 5.73 14.4-.41c4.65-3.55 11.14-6.84 17-6.33a23.41 23.41 0 0 0-4.77-4.82A22.32 22.32 0 0 0 6 9.55c-.5.7-1 1.41-1.37 2.14Z",
    style: {
      fill: "#00b7e3"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M11.1 16.32s6.33 5.7 14.31-.4c4.59-3.53 11.08-6.81 16.92-6.3a23.32 23.32 0 0 0-4.73-4.79A22.18 22.18 0 0 0 6.15 9.54a20.6 20.6 0 0 0-1.36 2.12Z",
    style: {
      fill: "#00b7e3"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M11.23 16.26s6.29 5.67 14.23-.4c4.59-3.5 11-6.76 16.81-6.25a22.59 22.59 0 0 0-4.7-4.77A22.05 22.05 0 0 0 6.31 9.52 19.79 19.79 0 0 0 5 11.63Z",
    style: {
      fill: "#00b8e3"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M11.36 16.21s6.25 5.63 14.14-.4c4.57-3.49 11-6.73 16.72-6.22a22.83 22.83 0 0 0-4.68-4.74A21.92 21.92 0 0 0 6.47 9.5a21.36 21.36 0 0 0-1.35 2.1Z",
    style: {
      fill: "#00b8e3"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M11.49 16.15s6.21 5.6 14.05-.4c4.55-3.46 10.88-6.68 16.62-6.18a22.79 22.79 0 0 0-4.65-4.71A21.8 21.8 0 0 0 6.62 9.48a24.48 24.48 0 0 0-1.33 2.09Z",
    style: {
      fill: "#00b8e4"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M11.61 16.09s6.18 5.57 14-.39C30.1 12.25 36.4 9.06 42.1 9.55a22.25 22.25 0 0 0-4.62-4.68 21.66 21.66 0 0 0-30.7 4.6 22.71 22.71 0 0 0-1.33 2.07Z",
    style: {
      fill: "#00b9e4"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M11.74 16s6.15 5.52 13.89-.39C30.12 12.22 36.38 9 42 9.54a22 22 0 0 0-4.59-4.66A21.53 21.53 0 0 0 6.94 9.45a23.9 23.9 0 0 0-1.32 2.06Z",
    style: {
      fill: "#00b9e4"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M11.87 16s6.11 5.49 13.81-.39C30.13 12.19 36.36 9 42 9.52a22 22 0 0 0-4.58-4.62A21.39 21.39 0 0 0 7.1 9.43a23.75 23.75 0 0 0-1.32 2.05Z",
    style: {
      fill: "#04b9e4"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M12 15.92s6.07 5.46 13.72-.38c4.43-3.39 10.61-6.53 16.21-6a21.69 21.69 0 0 0-4.54-4.59A21.39 21.39 0 0 0 6 11.45Z",
    style: {
      fill: "#0cbae4"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M12.13 15.86s6 5.43 13.63-.38c4.41-3.36 10.55-6.48 16.11-6a21.64 21.64 0 0 0-4.5-4.57 21.14 21.14 0 0 0-30 4.48 22.93 22.93 0 0 0-1.29 2Z",
    style: {
      fill: "#13bae4"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M12.26 15.81s6 5.39 13.55-.38c4.37-3.35 10.48-6.45 16-6a21.64 21.64 0 0 0-4.48-4.54A21 21 0 0 0 7.57 9.38q-.71 1-1.29 2Z",
    style: {
      fill: "#18bae4"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M12.39 15.75s5.95 5.36 13.46-.38C30.2 12.05 36.27 9 41.76 9.45a21.6 21.6 0 0 0-4.45-4.51A20.86 20.86 0 0 0 7.73 9.37a20.32 20.32 0 0 0-1.28 2Z",
    style: {
      fill: "#1dbae5"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M12.51 15.69s5.92 5.33 13.38-.37C30.21 12 36.25 9 41.7 9.43A21.3 21.3 0 0 0 37.28 5 20.74 20.74 0 0 0 7.89 9.35a22.21 22.21 0 0 0-1.28 2Z",
    style: {
      fill: "#20bbe5"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M12.64 15.64s5.88 5.29 13.3-.38C30.23 12 36.22 8.94 41.65 9.42A21.12 21.12 0 0 0 37.25 5 20.61 20.61 0 0 0 8 9.33a21.83 21.83 0 0 0-1.26 2Z",
    style: {
      fill: "#24bbe5"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M12.77 15.58s5.84 5.26 13.21-.37C30.25 12 36.2 8.93 41.59 9.4A21.07 21.07 0 0 0 37.22 5a20.47 20.47 0 0 0-29 4.35A19.46 19.46 0 0 0 7 11.27Z",
    style: {
      fill: "#27bbe5"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M12.9 15.52s5.8 5.23 13.12-.37c4.24-3.23 10.16-6.24 15.51-5.77A21 21 0 0 0 37.19 5 20.34 20.34 0 0 0 8.36 9.3a21.28 21.28 0 0 0-1.25 1.94Z",
    style: {
      fill: "#2abce5"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M13 15.46s5.76 5.2 13-.36c4.21-3.22 10.09-6.2 15.41-5.74A20.75 20.75 0 0 0 37.16 5 20.2 20.2 0 0 0 8.52 9.28a19.23 19.23 0 0 0-1.24 1.94Z",
    style: {
      fill: "#2dbce5"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M13.16 15.41s5.73 5.15 13-.37c4.19-3.19 10-6.16 15.31-5.69A20.46 20.46 0 0 0 37.14 5 20.07 20.07 0 0 0 8.68 9.27a19.6 19.6 0 0 0-1.24 1.92Z",
    style: {
      fill: "#2fbce5"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M13.28 15.35S19 20.47 26.15 15c4.16-3.18 10-6.12 15.21-5.66A20.65 20.65 0 0 0 37.11 5 20 20 0 0 0 8.83 9.25a22.8 22.8 0 0 0-1.22 1.91Z",
    style: {
      fill: "#32bde5"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M13.41 15.29s5.66 5.09 12.79-.36c4.13-3.15 9.89-6.07 15.11-5.62A20.66 20.66 0 0 0 37.08 5 19.82 19.82 0 0 0 9 9.23a20.25 20.25 0 0 0-1.21 1.9Z",
    style: {
      fill: "#34bde6"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M13.54 15.24s5.62 5 12.7-.36c4.1-3.13 9.83-6 15-5.59A20.37 20.37 0 0 0 37.05 5a19.67 19.67 0 0 0-27.9 4.22 22.2 22.2 0 0 0-1.21 1.88Z",
    style: {
      fill: "#36bde6"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M13.67 15.18s5.58 5 12.62-.36c4.07-3.11 9.76-6 14.9-5.54A20.12 20.12 0 0 0 37 5.05a19.63 19.63 0 0 0-28.91 6Z",
    style: {
      fill: "#38bee6"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M13.8 15.12s5.54 5 12.53-.35c4.05-3.09 9.69-6 14.81-5.51A20.38 20.38 0 0 0 37 5.06 19.54 19.54 0 0 0 8.27 11Z",
    style: {
      fill: "#3abee6"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M13.93 15.06s5.5 5 12.44-.34c4-3.07 9.63-5.92 14.71-5.48A19.84 19.84 0 0 0 37 5.07 19.29 19.29 0 0 0 9.62 9.16 21.37 21.37 0 0 0 8.44 11Z",
    style: {
      fill: "#3cbee6"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M14.06 15s5.46 4.92 12.36-.35c4-3.05 9.56-5.88 14.6-5.44a19.56 19.56 0 0 0-4.09-4.14A19.16 19.16 0 0 0 9.78 9.15 18.83 18.83 0 0 0 8.61 11Z",
    style: {
      fill: "#3ebee6"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M14.18 15s5.43 4.89 12.28-.34c4-3 9.5-5.84 14.51-5.4a19.75 19.75 0 0 0-4.06-4.16 19 19 0 0 0-27 4A18.7 18.7 0 0 0 8.77 11Z",
    style: {
      fill: "#40bfe6"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M14.31 14.89s5.39 4.86 12.19-.34c3.94-3 9.44-5.79 14.41-5.36a19.47 19.47 0 0 0-4-4.08 18.89 18.89 0 0 0-26.78 4 19.73 19.73 0 0 0-1.16 1.81Z",
    style: {
      fill: "#42bfe7"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M14.44 14.84s5.35 4.82 12.11-.34c3.91-3 9.36-5.76 14.3-5.33a19.18 19.18 0 0 0-4-4 18.76 18.76 0 0 0-26.6 4 20.1 20.1 0 0 0-1.15 1.72Z",
    style: {
      fill: "#44bfe7"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M14.57 14.78s5.32 4.78 12-.34c3.88-3 9.3-5.71 14.21-5.28a19.47 19.47 0 0 0-4-4 18.63 18.63 0 0 0-26.41 4 19.07 19.07 0 0 0-1.14 1.78Z",
    style: {
      fill: "#46c0e7"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M14.7 14.72s5.28 4.75 11.93-.33c3.86-3 9.24-5.68 14.11-5.25a19.18 19.18 0 0 0-4-4 18.5 18.5 0 0 0-26.17 3.92c-.42.58-.79 1.17-1.14 1.77Z",
    style: {
      fill: "#47c0e7"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M14.83 14.67s5.24 4.71 11.85-.34c3.82-2.92 9.17-5.63 14-5.21a18.9 18.9 0 0 0-3.92-4 18.36 18.36 0 0 0-26 3.9A19.28 19.28 0 0 0 9.6 10.8Z",
    style: {
      fill: "#49c0e7"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M15 14.61s5.21 4.68 11.77-.33c3.8-2.9 9.1-5.6 13.9-5.18a18.85 18.85 0 0 0-3.89-3.94 18.32 18.32 0 0 0-27 5.61Z",
    style: {
      fill: "#4bc1e7"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M15.08 14.55s5.17 4.65 11.68-.33c3.78-2.88 9-5.55 13.81-5.13a19.1 19.1 0 0 0-3.86-3.92A18.11 18.11 0 0 0 11 9c-.4.57-.77 1.14-1.11 1.73Z",
    style: {
      fill: "#4cc1e7"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M15.21 14.49s5.13 4.62 11.6-.32c3.74-2.86 9-5.52 13.7-5.1a18.81 18.81 0 0 0-3.83-3.89A18 18 0 0 0 11.2 9a17.27 17.27 0 0 0-1.1 1.72Z",
    style: {
      fill: "#4ec1e7"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M15.34 14.44s5.09 4.58 11.51-.33c3.72-2.84 8.91-5.47 13.6-5.06a18.51 18.51 0 0 0-3.8-3.86A17.85 17.85 0 0 0 11.36 9a17.13 17.13 0 0 0-1.1 1.71Z",
    style: {
      fill: "#4fc1e8"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M15.47 14.38s5 4.55 11.42-.32c3.7-2.82 8.85-5.43 13.51-5a18.48 18.48 0 0 0-3.78-3.82A17.7 17.7 0 0 0 11.52 9a18.11 18.11 0 0 0-1.09 1.7Z",
    style: {
      fill: "#51c2e8"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M15.6 14.32s5 4.52 11.34-.32c3.66-2.79 8.77-5.39 13.4-5a18 18 0 0 0-3.75-3.8A17.58 17.58 0 0 0 11.67 9a16.44 16.44 0 0 0-1.07 1.68Z",
    style: {
      fill: "#52c2e8"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M15.73 14.27S20.7 18.75 27 14c3.62-2.83 8.69-5.4 13.28-5a17.71 17.71 0 0 0-3.72-3.77 17.5 17.5 0 0 0-25.8 5.37Z",
    style: {
      fill: "#54c2e8"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M15.85 14.21s4.94 4.45 11.18-.32c3.6-2.75 8.64-5.31 13.2-4.91a17.71 17.71 0 0 0-3.7-3.74 17.34 17.34 0 0 0-25.6 5.33Z",
    style: {
      fill: "#55c3e8"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M16 14.15s4.91 4.41 11.09-.31c3.58-2.73 8.58-5.27 13.1-4.88a17.66 17.66 0 0 0-3.69-3.71A17.18 17.18 0 0 0 12.15 8.9a16.94 16.94 0 0 0-1.06 1.64Z",
    style: {
      fill: "#57c3e8"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M16.11 14.09s4.87 4.38 11-.31c3.56-2.71 8.52-5.23 13-4.83a17.61 17.61 0 0 0-3.63-3.69 17 17 0 0 0-24.17 3.62 15 15 0 0 0-1.05 1.63Z",
    style: {
      fill: "#58c3e8"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M16.24 14s4.83 4.34 10.92-.31c3.52-2.69 8.44-5.19 12.9-4.8a17.62 17.62 0 0 0-3.61-3.66 16.93 16.93 0 0 0-24 3.59 17.61 17.61 0 0 0-1 1.62Z",
    style: {
      fill: "#59c4e9"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M16.37 14s4.79 4.31 10.83-.3C30.7 11 35.58 8.53 40 8.91a17.57 17.57 0 0 0-3.58-3.63 16.8 16.8 0 0 0-23.8 3.56c-.37.53-.72 1.06-1 1.61Z",
    style: {
      fill: "#5bc4e9"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M16.5 13.92s4.75 4.28 10.74-.3c3.47-2.65 8.32-5.11 12.7-4.73a17.53 17.53 0 0 0-3.55-3.6 16.66 16.66 0 0 0-23.61 3.54q-.55.78-1 1.59Z",
    style: {
      fill: "#5cc4e9"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M16.62 13.87s4.72 4.24 10.67-.3c3.44-2.63 8.25-5.07 12.6-4.69a16.81 16.81 0 0 0-3.53-3.57 16.51 16.51 0 0 0-23.42 3.5 17.69 17.69 0 0 0-1 1.58Z",
    style: {
      fill: "#5dc4e9"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M16.75 13.81s4.68 4.21 10.58-.3c3.42-2.61 8.18-5 12.5-4.65a16.53 16.53 0 0 0-3.5-3.54A16.39 16.39 0 0 0 13.1 8.79a16.68 16.68 0 0 0-1 1.57Z",
    style: {
      fill: "#5fc5e9"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M16.88 13.75s4.64 4.18 10.49-.29c3.39-2.59 8.12-5 12.4-4.62a16.71 16.71 0 0 0-3.47-3.51 16.26 16.26 0 0 0-23 3.45 16.91 16.91 0 0 0-1 1.55Z",
    style: {
      fill: "#60c5e9"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M17 13.69s4.6 4.15 10.41-.29c3.36-2.56 8-5 12.3-4.58a16.72 16.72 0 0 0-3.45-3.48 16.12 16.12 0 0 0-22.85 3.42 18.24 18.24 0 0 0-1 1.54Z",
    style: {
      fill: "#61c5e9"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M17.14 13.64s4.56 4.11 10.32-.29c3.34-2.55 8-4.91 12.2-4.54a16.43 16.43 0 0 0-3.41-3.46 16 16 0 0 0-22.68 3.39 15.79 15.79 0 0 0-1 1.53Z",
    style: {
      fill: "#63c6e9"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M17.27 13.58s4.52 4.08 10.23-.29c3.31-2.52 7.93-4.86 12.1-4.5a16.63 16.63 0 0 0-3.38-3.43 15.86 15.86 0 0 0-22.49 3.37 17.66 17.66 0 0 0-1 1.51Z",
    style: {
      fill: "#64c6ea"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M17.4 13.52s4.49 4 10.15-.28c3.28-2.51 7.85-4.83 12-4.47a16.64 16.64 0 0 0-3.36-3.4 15.74 15.74 0 0 0-22.31 3.34 17.25 17.25 0 0 0-1 1.5Z",
    style: {
      fill: "#65c6ea"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M17.52 13.47s4.46 4 10.07-.29c3.25-2.48 7.79-4.78 11.9-4.42a16.15 16.15 0 0 0-3.33-3.38A15.62 15.62 0 0 0 14 8.69a17.25 17.25 0 0 0-1 1.5Z",
    style: {
      fill: "#66c7ea"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M17.65 13.41s4.42 4 10-.28c3.22-2.46 7.72-4.75 11.79-4.39a15.86 15.86 0 0 0-3.3-3.35 15.54 15.54 0 0 0-22.88 4.77Z",
    style: {
      fill: "#68c7ea"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M17.78 13.35s4.38 3.94 9.9-.28c3.2-2.44 7.66-4.7 11.69-4.35a15.77 15.77 0 0 0-3.27-3.31 15.33 15.33 0 0 0-21.74 3.25 14.56 14.56 0 0 0-.94 1.47Z",
    style: {
      fill: "#69c7ea"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M17.91 13.29s4.34 3.91 9.81-.27c3.17-2.42 7.59-4.67 11.6-4.32a15.78 15.78 0 0 0-3.25-3.28 15.2 15.2 0 0 0-21.55 3.22 14.44 14.44 0 0 0-.94 1.46Z",
    style: {
      fill: "#6ac8ea"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M18 13.24s4.3 3.87 9.73-.28c3.14-2.4 7.52-4.62 11.49-4.27a15.22 15.22 0 0 0-24.59-.06 16.71 16.71 0 0 0-.92 1.44Z",
    style: {
      fill: "#6bc8ea"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M18.17 13.18s4.26 3.84 9.64-.27c3.11-2.38 7.46-4.59 11.39-4.24A15.2 15.2 0 0 0 36 5.44a14.94 14.94 0 0 0-21.17 3.17 16.55 16.55 0 0 0-.92 1.39Z",
    style: {
      fill: "#6cc8eb"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M18.29 13.12s4.23 3.81 9.56-.27c3.09-2.35 7.4-4.54 11.3-4.2A15.44 15.44 0 0 0 36 5.45a14.82 14.82 0 0 0-21 3.14 15.48 15.48 0 0 0-.92 1.41Z",
    style: {
      fill: "#6ec9eb"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M18.42 13.07s4.19 3.77 9.48-.27c3.1-2.34 7.33-4.5 11.19-4.17A15.15 15.15 0 0 0 36 5.46a14.68 14.68 0 0 0-20.85 3.12 13.86 13.86 0 0 0-.9 1.4Z",
    style: {
      fill: "#6fc9eb"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M18.55 13s4.15 3.74 9.39-.26C31 10.43 35.2 8.28 39 8.62a14.91 14.91 0 0 0-3.1-3.15 14.55 14.55 0 0 0-20.6 3.09c-.32.45-.62.92-.89 1.39Z",
    style: {
      fill: "#70c9eb"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M18.68 13s4.11 3.71 9.3-.26c3-2.29 7.2-4.42 11-4.09a15.16 15.16 0 0 0-3.08-3.17 14.44 14.44 0 0 0-21.32 4.44Z",
    style: {
      fill: "#71caeb"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M18.81 12.89s4.08 3.67 9.22-.25c3-2.28 7.13-4.39 10.89-4.06a14.87 14.87 0 0 0-3.05-3.09 14.29 14.29 0 0 0-20.25 3c-.32.45-.61.91-.88 1.37Z",
    style: {
      fill: "#72caeb"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M18.94 12.84s4 3.63 9.13-.26c2.95-2.25 7.07-4.34 10.79-4a14.83 14.83 0 0 0-3-3.06 14.24 14.24 0 0 0-20.95 4.34Z",
    style: {
      fill: "#73caeb"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M19.07 12.78s4 3.6 9-.25c2.93-2.24 7-4.31 10.7-4a14.35 14.35 0 0 0-3-3 14 14 0 0 0-19.87 3 13.15 13.15 0 0 0-.86 1.34Z",
    style: {
      fill: "#74cbeb"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M19.19 12.72s4 3.57 9-.25c2.89-2.21 6.93-4.26 10.59-3.94a14.5 14.5 0 0 0-3-3 13.9 13.9 0 0 0-19.7 2.94c-.31.44-.59.88-.85 1.33Z",
    style: {
      fill: "#76cbec"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M19.32 12.67s3.93 3.53 8.88-.25c2.87-2.19 6.87-4.22 10.49-3.91a14.45 14.45 0 0 0-2.93-3 13.76 13.76 0 0 0-19.51 2.95 12.11 12.11 0 0 0-.84 1.31Z",
    style: {
      fill: "#77cbec"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M19.45 12.61s3.89 3.5 8.79-.25c2.85-2.17 6.81-4.18 10.4-3.87a14.21 14.21 0 0 0-2.91-2.94 13.63 13.63 0 0 0-19.32 2.89 15.12 15.12 0 0 0-.84 1.3Z",
    style: {
      fill: "#78cbec"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M19.58 12.55s3.85 3.47 8.71-.24C31.1 10.16 35 8.17 38.58 8.48a14 14 0 0 0-2.88-2.92 13.5 13.5 0 0 0-19.13 2.86 14.84 14.84 0 0 0-.83 1.29Z",
    style: {
      fill: "#79ccec"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M19.71 12.5s3.81 3.43 8.62-.25c2.79-2.12 6.67-4.1 10.19-3.79a13.92 13.92 0 0 0-2.85-2.89 13.35 13.35 0 0 0-18.94 2.84 11.56 11.56 0 0 0-.82 1.28Z",
    style: {
      fill: "#7accec"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M19.84 12.44s3.77 3.4 8.54-.24c2.75-2.11 6.6-4.06 10.09-3.76a13.69 13.69 0 0 0-2.83-2.86 13.24 13.24 0 0 0-18.76 2.81c-.29.41-.56.83-.81 1.27Z",
    style: {
      fill: "#7bccec"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M20 12.38s3.73 3.37 8.45-.24c2.73-2.08 6.54-4 10-3.71A13.22 13.22 0 0 0 17 8.37a14 14 0 0 0-.8 1.26Z",
    style: {
      fill: "#7ccdec"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M20.09 12.32s3.71 3.34 8.37-.23c2.71-2.07 6.48-4 9.89-3.68a13.59 13.59 0 0 0-2.76-2.81A13 13 0 0 0 17.2 8.36a12.47 12.47 0 0 0-.8 1.24Z",
    style: {
      fill: "#7dcded"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M20.22 12.27s3.67 3.29 8.29-.24c2.67-2 6.41-3.93 9.79-3.64a13.31 13.31 0 0 0-2.74-2.77 12.84 12.84 0 0 0-18.2 2.72 13.48 13.48 0 0 0-.79 1.23Z",
    style: {
      fill: "#7ecded"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M20.35 12.21s3.65 3.26 8.2-.21c2.65-2 6.34-3.9 9.69-3.61a13 13 0 0 0-2.71-2.74 12.71 12.71 0 0 0-18 2.69c-.28.4-.54.8-.78 1.22Z",
    style: {
      fill: "#7fceed"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M20.48 12.15s3.59 3.23 8.11-.23c2.62-2 6.28-3.85 9.59-3.56a13 13 0 0 0-2.68-2.72 12.58 12.58 0 0 0-17.83 2.67 12.82 12.82 0 0 0-.77 1.2Z",
    style: {
      fill: "#80ceed"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M20.61 12.1s3.55 3.19 8-.23c2.59-2 6.21-3.82 9.49-3.53a13 13 0 0 0-2.66-2.69 12.47 12.47 0 0 0-18.4 3.83Z",
    style: {
      fill: "#81ceed"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M20.74 12s3.51 3.16 7.94-.22c2.57-2 6.15-3.78 9.39-3.5a12.5 12.5 0 0 0-2.63-2.66 12.38 12.38 0 0 0-18.21 3.83Z",
    style: {
      fill: "#82ceed"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M20.86 12s3.48 3.13 7.86-.22C31.26 9.82 34.8 8 38 8.3a12.45 12.45 0 0 0-2.6-2.63 12.18 12.18 0 0 0-17.25 2.58 10.51 10.51 0 0 0-.75 1.17Z",
    style: {
      fill: "#83cfed"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M21 11.92s3.44 3.1 7.78-.21c2.51-1.92 6-3.7 9.18-3.42a12.21 12.21 0 0 0-2.57-2.61A12.05 12.05 0 0 0 18.3 8.24c-.27.37-.51.76-.74 1.15Z",
    style: {
      fill: "#84cfed"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M21.12 11.87s3.4 3.06 7.69-.22c2.48-1.9 5.95-3.65 9.09-3.38a12.41 12.41 0 0 0-2.54-2.58 11.93 11.93 0 0 0-16.9 2.53 11.56 11.56 0 0 0-.73 1.14Z",
    style: {
      fill: "#85cfee"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M21.25 11.81s3.36 3 7.6-.21c2.46-1.88 5.89-3.62 9-3.35a12.12 12.12 0 0 0-2.52-2.55 11.8 11.8 0 0 0-16.71 2.5 12.6 12.6 0 0 0-.72 1.13Z",
    style: {
      fill: "#86d0ee"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M21.38 11.75s3.32 3 7.52-.21c2.43-1.85 5.82-3.54 8.88-3.31a12 12 0 0 0-2.48-2.51 11.65 11.65 0 0 0-16.52 2.47 13.14 13.14 0 0 0-.72 1.11Z",
    style: {
      fill: "#87d0ee"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M21.51 11.7s3.29 3 7.43-.21c2.4-1.84 5.75-3.54 8.79-3.27a11.84 11.84 0 0 0-2.46-2.49 11.53 11.53 0 0 0-16.34 2.44c-.25.36-.49.73-.7 1.1Z",
    style: {
      fill: "#88d0ee"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M21.64 11.64s3.25 2.92 7.35-.21c2.37-1.81 5.68-3.49 8.68-3.23a11.56 11.56 0 0 0-2.43-2.46 11.4 11.4 0 0 0-16.15 2.41c-.25.36-.49.72-.7 1.09Z",
    style: {
      fill: "#89d1ee"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M21.76 11.58s3.24 2.89 7.24-.2c2.35-1.79 5.62-3.46 8.58-3.2a11.51 11.51 0 0 0-2.4-2.43 11.26 11.26 0 0 0-16 2.39c-.25.35-.48.71-.69 1.07Z",
    style: {
      fill: "#89d1ee"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M21.89 11.52s3.18 2.86 7.18-.2c2.32-1.77 5.56-3.41 8.49-3.16a11.76 11.76 0 0 0-2.38-2.4 11.16 11.16 0 0 0-16.45 3.42Z",
    style: {
      fill: "#8ad1ee"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M22 11.47s3.14 2.82 7.1-.2c2.29-1.75 5.49-3.38 8.38-3.12a11.27 11.27 0 0 0-2.35-2.38A11 11 0 0 0 19.57 8.1a11.14 11.14 0 0 0-.68 1.06Z",
    style: {
      fill: "#8bd1ee"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M22.15 11.41s3.1 2.79 7-.2c2.26-1.73 5.42-3.33 8.28-3.08a11.17 11.17 0 0 0-2.31-2.35 10.88 10.88 0 0 0-15.4 2.31 10.15 10.15 0 0 0-.66 1Z",
    style: {
      fill: "#8cd2ef"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M22.28 11.35s3.06 2.76 6.92-.19c2.24-1.71 5.36-3.29 8.19-3.05a11.43 11.43 0 0 0-2.29-2.32 10.74 10.74 0 0 0-15.22 2.28 11.23 11.23 0 0 0-.66 1Z",
    style: {
      fill: "#8dd2ef"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M22.41 11.3s3 2.72 6.84-.2c2.21-1.68 5.29-3.25 8.08-3a10.94 10.94 0 0 0-2.26-2.3A10.62 10.62 0 0 0 20 8.05a11 11 0 0 0-.65 1Z",
    style: {
      fill: "#8ed2ef"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M22.53 11.24s3 2.69 6.76-.19c2.18-1.67 5.23-3.21 8-3A10.61 10.61 0 0 0 35 5.82 10.46 10.46 0 0 0 20.2 8a8.89 8.89 0 0 0-.64 1Z",
    style: {
      fill: "#8fd3ef"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M22.66 11.18s2.95 2.66 6.67-.19c2.16-1.64 5.16-3.17 7.89-2.93A10.61 10.61 0 0 0 35 5.83 10.33 10.33 0 0 0 20.36 8a8.77 8.77 0 0 0-.64 1Z",
    style: {
      fill: "#90d3ef"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M22.79 11.12s2.91 2.63 6.59-.18C31.5 9.32 34.47 7.81 37.16 8A10.56 10.56 0 0 0 35 5.84 10.21 10.21 0 0 0 20.51 8c-.22.32-.43.65-.62 1Z",
    style: {
      fill: "#91d3ef"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M22.92 11.07a5 5 0 0 0 6.5-.19c2.1-1.6 5-3.09 7.68-2.85A10.32 10.32 0 0 0 35 5.85 10.07 10.07 0 0 0 20.67 8c-.22.31-.43.63-.62 1Z",
    style: {
      fill: "#92d3ef"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M23.05 11a5 5 0 0 0 6.41-.18c2.08-1.58 5-3 7.59-2.82a10.33 10.33 0 0 0-2.13-2.15A9.94 9.94 0 0 0 20.83 8a10.88 10.88 0 0 0-.61 1Z",
    style: {
      fill: "#92d4ef"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M23.18 11a4.89 4.89 0 0 0 6.33-.17c2-1.57 4.9-3 7.48-2.79a10.49 10.49 0 0 0-2.09-2.17A9.82 9.82 0 0 0 21 8a10.61 10.61 0 0 0-.6.94Z",
    style: {
      fill: "#93d4f0"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M23.31 10.9a4.82 4.82 0 0 0 6.24-.18c2-1.54 4.83-3 7.38-2.75a10.45 10.45 0 0 0-2.06-2.09 9.7 9.7 0 0 0-13.73 2.05c-.21.31-.41.62-.59.93Z",
    style: {
      fill: "#94d4f0"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M23.43 10.84a4.76 4.76 0 0 0 6.16-.17c2-1.52 4.77-2.93 7.29-2.71a10.25 10.25 0 0 0-2-2.07 9.55 9.55 0 0 0-13.54 2 9.93 9.93 0 0 0-.58.91Z",
    style: {
      fill: "#95d5f0"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M23.56 10.78a4.69 4.69 0 0 0 6.08-.17c2-1.5 4.7-2.89 7.18-2.67a9.71 9.71 0 0 0-2-2 9.43 9.43 0 0 0-13.35 2c-.21.29-.4.6-.58.9Z",
    style: {
      fill: "#96d5f0"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M23.69 10.72a4.62 4.62 0 0 0 6-.16c1.94-1.48 4.64-2.85 7.08-2.64a9.91 9.91 0 0 0-2-2 9.3 9.3 0 0 0-13.16 2 9.53 9.53 0 0 0-.57.89Z",
    style: {
      fill: "#97d5f0"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M23.82 10.67a4.56 4.56 0 0 0 5.91-.17c1.9-1.45 4.57-2.81 7-2.6a9.38 9.38 0 0 0-2-2 9.14 9.14 0 0 0-13 1.94 8.13 8.13 0 0 0-.57.87Z",
    style: {
      fill: "#98d5f0"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M24 10.61a4.49 4.49 0 0 0 5.82-.16c1.88-1.44 4.5-2.77 6.88-2.56a8.92 8.92 0 0 0-1.93-1.95 9 9 0 0 0-12.84 1.91c-.2.28-.38.57-.55.86Z",
    style: {
      fill: "#98d6f0"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M24.08 10.55a4.41 4.41 0 0 0 5.73-.16c1.86-1.39 4.44-2.73 6.78-2.52A9.28 9.28 0 0 0 34.7 6a8.9 8.9 0 0 0-12.61 1.83 8.65 8.65 0 0 0-.54.85Z",
    style: {
      fill: "#99d6f0"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M24.2 10.5a4.37 4.37 0 0 0 5.66-.16c1.82-1.4 4.37-2.69 6.67-2.49A9 9 0 0 0 34.67 6a8.76 8.76 0 0 0-12.42 1.82 7.48 7.48 0 0 0-.54.84Z",
    style: {
      fill: "#9ad6f1"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M24.33 10.44a4.3 4.3 0 0 0 5.57-.16c1.8-1.37 4.31-2.64 6.58-2.45A9 9 0 0 0 34.64 6a8.63 8.63 0 0 0-12.23 1.8 7.28 7.28 0 0 0-.53.83Z",
    style: {
      fill: "#9bd7f1"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M24.46 10.38a4.24 4.24 0 0 0 5.48-.15c1.77-1.35 4.24-2.61 6.48-2.41A8.76 8.76 0 0 0 34.61 6a8.49 8.49 0 0 0-12 1.8 8.15 8.15 0 0 0-.61.8Z",
    style: {
      fill: "#9cd7f1"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M24.59 10.33a4.18 4.18 0 0 0 5.4-.16c1.74-1.33 4.17-2.56 6.37-2.37A8.71 8.71 0 0 0 34.58 6a8.38 8.38 0 0 0-12.37 2.57Z",
    style: {
      fill: "#9dd7f1"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M24.72 10.27a4.1 4.1 0 0 0 5.28-.15c1.72-1.31 4.11-2.53 6.28-2.34A8.72 8.72 0 0 0 34.55 6a8.23 8.23 0 0 0-11.67 1.75c-.18.26-.35.52-.5.79Z",
    style: {
      fill: "#9ed8f1"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M24.85 10.21a4 4 0 0 0 5.22-.15c1.69-1.29 4-2.48 6.18-2.29A8 8 0 0 0 34.52 6 8.1 8.1 0 0 0 23 7.73a7.94 7.94 0 0 0-.5.78Z",
    style: {
      fill: "#9ed8f1"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M25 10.15a4 4 0 0 0 5.12-.15c1.66-1.27 4-2.45 6.07-2.26A7.7 7.7 0 0 0 34.49 6 8 8 0 0 0 23.2 7.72a7.57 7.57 0 0 0-.49.76Z",
    style: {
      fill: "#9fd8f1"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M25.1 10.1a3.91 3.91 0 0 0 5.06-.1c1.63-1.24 3.91-2.4 6-2.22A8.1 8.1 0 0 0 34.47 6a7.84 7.84 0 0 0-11.12 1.7q-.26.36-.48.75Z",
    style: {
      fill: "#a0d8f1"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M25.23 10a3.83 3.83 0 0 0 5-.14c1.61-1.23 3.85-2.36 5.88-2.19a7.81 7.81 0 0 0-1.64-1.66 7.71 7.71 0 0 0-10.96 1.67 8.35 8.35 0 0 0-.47.74Z",
    style: {
      fill: "#a1d9f2"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M25.36 10a3.77 3.77 0 0 0 4.89-.13C31.83 8.64 34 7.52 36 7.7a7.63 7.63 0 0 0-12.35 0 6.76 6.76 0 0 0-.46.72Z",
    style: {
      fill: "#a2d9f2"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M25.49 9.93a3.7 3.7 0 0 0 4.8-.14C31.84 8.61 34 7.51 36 7.68a7.82 7.82 0 0 0-1.59-1.61 7.44 7.44 0 0 0-10.58 1.58 7.8 7.8 0 0 0-.46.71Z",
    style: {
      fill: "#a2d9f2"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M25.62 9.87a3.64 3.64 0 0 0 4.72-.13c1.52-1.17 3.66-2.25 5.57-2.08a7.53 7.53 0 0 0-1.56-1.58A7.3 7.3 0 0 0 24 7.63a5.92 5.92 0 0 0-.45.7Z",
    style: {
      fill: "#a3daf2"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M25.75 9.81a3.57 3.57 0 0 0 4.63-.13 8.64 8.64 0 0 1 5.47-2 7.48 7.48 0 0 0-1.53-1.55 7.19 7.19 0 0 0-10.18 1.48c-.16.23-.3.46-.44.69Z",
    style: {
      fill: "#a4daf2"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M25.87 9.75a3.52 3.52 0 0 0 4.55-.12 8.36 8.36 0 0 1 5.38-2 7.29 7.29 0 0 0-1.51-1.53 7 7 0 0 0-10 1.5 6.9 6.9 0 0 0-.43.67Z",
    style: {
      fill: "#a5daf2"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M26 9.7a3.46 3.46 0 0 0 4.47-.13 8.27 8.27 0 0 1 5.27-2 7.25 7.25 0 0 0-1.48-1.5 6.91 6.91 0 0 0-9.8 1.47 6 6 0 0 0-.42.66Z",
    style: {
      fill: "#a6daf2"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M26.13 9.64a3.39 3.39 0 0 0 4.38-.12 8.16 8.16 0 0 1 5.17-1.93 7.11 7.11 0 0 0-1.44-1.46 6.79 6.79 0 0 0-9.62 1.43c-.15.22-.29.43-.42.65Z",
    style: {
      fill: "#a6dbf2"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M26.26 9.58a3.31 3.31 0 0 0 4.29-.12 8 8 0 0 1 5.08-1.89 6.87 6.87 0 0 0-1.42-1.43 6.65 6.65 0 0 0-9.44 1.41c-.14.2-.28.42-.4.63Z",
    style: {
      fill: "#a7dbf2"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M26.39 9.53a3.26 3.26 0 0 0 4.21-.12 7.79 7.79 0 0 1 5-1.85 6.63 6.63 0 0 0-1.39-1.41 6.52 6.52 0 0 0-9.25 1.38c-.14.2-.28.41-.4.62Z",
    style: {
      fill: "#a8dbf3"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M26.52 9.47a3.18 3.18 0 0 0 4.12-.12 7.67 7.67 0 0 1 4.87-1.81 6.58 6.58 0 0 0-1.36-1.38 6.39 6.39 0 0 0-9.06 1.35c-.14.2-.27.41-.39.62Z",
    style: {
      fill: "#a9dcf3"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M36.5 29.82s-8.37-7.26-19.38-1C10.93 32.4 6.48 34.49 3.19 35.2a24.11 24.11 0 0 0 6.84 8 23.33 23.33 0 0 0 34.49-7.39Z",
    style: {
      fill: "#005faa"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M36.24 29.89s-8.3-7.21-19.21-1c-6.13 3.55-10.55 5.62-13.81 6.33A23.87 23.87 0 0 0 10 43.16a23 23 0 0 0 32.65-4.88 24.28 24.28 0 0 0 1.54-2.44Z",
    style: {
      fill: "#005ea9"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M36 30s-8.23-7.14-19-.95c-6.08 3.48-10.46 5.53-13.69 6.23A23.7 23.7 0 0 0 10 43.11a22.83 22.83 0 0 0 32.36-4.84 22.27 22.27 0 0 0 1.53-2.42Z",
    style: {
      fill: "#005ea9"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M35.72 30s-8.15-7.08-18.87-.94c-6 3.45-10.36 5.48-13.57 6.18a23.46 23.46 0 0 0 6.66 7.8A22.62 22.62 0 0 0 42 38.26a21.93 21.93 0 0 0 1.52-2.4Z",
    style: {
      fill: "#005da8"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M35.46 30.07s-8.08-7-18.7-.93c-6 3.42-10.27 5.43-13.45 6.12A23.29 23.29 0 0 0 9.91 43a22.42 22.42 0 0 0 31.79-4.76 24.78 24.78 0 0 0 1.5-2.37Z",
    style: {
      fill: "#005da7"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M35.2 30.13s-8-6.95-18.53-.92C10.75 32.6 6.49 34.6 3.34 35.28a23.07 23.07 0 0 0 6.54 7.66 22.22 22.22 0 0 0 31.5-4.71 22.6 22.6 0 0 0 1.49-2.35Z",
    style: {
      fill: "#005ca7"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M34.94 30.2s-7.94-6.89-18.37-.92c-5.86 3.36-10.08 5.34-13.2 6a22.9 22.9 0 0 0 6.48 7.6 22 22 0 0 0 31.21-4.67 23.33 23.33 0 0 0 1.48-2.33Z",
    style: {
      fill: "#005ca6"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M34.68 30.26s-7.86-6.83-18.2-.91c-5.81 3.33-10 5.29-13.08 6a22.49 22.49 0 0 0 6.43 7.52 21.81 21.81 0 0 0 30.92-4.62 20.94 20.94 0 0 0 1.46-2.32Z",
    style: {
      fill: "#005ba5"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M34.42 30.32s-7.79-6.76-18-.9c-5.75 3.3-9.9 5.24-12.95 5.9a22.28 22.28 0 0 0 6.33 7.46 21.6 21.6 0 0 0 30.63-4.59 20.48 20.48 0 0 0 1.45-2.29Z",
    style: {
      fill: "#005ba5"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M34.16 30.38s-7.72-6.7-17.86-.89c-5.7 3.27-9.8 5.19-12.83 5.85a22.15 22.15 0 0 0 6.3 7.38 21.4 21.4 0 0 0 30.34-4.54 20.15 20.15 0 0 0 1.44-2.27Z",
    style: {
      fill: "#005aa4"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M33.9 30.44s-7.64-6.63-17.69-.88C10.56 32.8 6.5 34.7 3.5 35.35a21.88 21.88 0 0 0 6.24 7.32 21.21 21.21 0 0 0 30.06-4.5 22.3 22.3 0 0 0 1.42-2.25Z",
    style: {
      fill: "#005aa3"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M33.64 30.51s-7.57-6.58-17.52-.88c-5.59 3.21-9.62 5.09-12.59 5.74a21.76 21.76 0 0 0 6.18 7.24 21 21 0 0 0 29.77-4.45 21.93 21.93 0 0 0 1.41-2.23Z",
    style: {
      fill: "#0059a3"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M33.38 30.57s-7.5-6.51-17.38-.87c-5.54 3.18-9.53 5-12.47 5.68a21.49 21.49 0 0 0 6.12 7.18 20.79 20.79 0 0 0 29.48-4.41 20 20 0 0 0 1.4-2.21Z",
    style: {
      fill: "#0059a2"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M33.12 30.63s-7.42-6.45-17.18-.86c-5.49 3.15-9.44 5-12.35 5.63a21.25 21.25 0 0 0 6.06 7.1 20.59 20.59 0 0 0 29.2-4.37A20 20 0 0 0 40.23 36Z",
    style: {
      fill: "#0058a1"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M32.86 30.69s-7.35-6.38-17-.85C10.42 33 6.51 34.79 3.62 35.41a21.2 21.2 0 0 0 6 7 20.39 20.39 0 0 0 28.91-4.33A20.62 20.62 0 0 0 39.9 36Z",
    style: {
      fill: "#0058a1"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M32.6 30.75a14.77 14.77 0 0 0-16.84-.84c-5.38 3.09-9.25 4.9-12.11 5.52a21 21 0 0 0 5.94 7 20.18 20.18 0 0 0 28.62-4.28A18.77 18.77 0 0 0 39.57 36Z",
    style: {
      fill: "#0057a0"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M32.34 30.81A14.62 14.62 0 0 0 15.66 30c-5.32 3.05-9.15 4.85-12 5.46a20.79 20.79 0 0 0 5.88 6.9A20 20 0 0 0 37.9 38.1a22.78 22.78 0 0 0 1.34-2.1Z",
    style: {
      fill: "#00579f"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M32.08 30.88a14.47 14.47 0 0 0-16.51-.83c-5.27 3-9.06 4.8-11.86 5.41a20.57 20.57 0 0 0 5.82 6.82 19.78 19.78 0 0 0 28.05-4.19A21.16 21.16 0 0 0 38.91 36Z",
    style: {
      fill: "#00569f"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M31.82 30.94a14.32 14.32 0 0 0-16.34-.82c-5.21 3-9 4.75-11.74 5.35a20.31 20.31 0 0 0 5.77 6.76 19.57 19.57 0 0 0 27.75-4.16A19 19 0 0 0 38.58 36Z",
    style: {
      fill: "#00569e"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M31.56 31a14.17 14.17 0 0 0-16.17-.8c-5.16 2.95-8.87 4.69-11.62 5.29a20 20 0 0 0 5.71 6.68A19.37 19.37 0 0 0 37 38.06 20.18 20.18 0 0 0 38.25 36Z",
    style: {
      fill: "#00559d"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M31.3 31.06a14 14 0 0 0-16-.79c-5.11 2.92-8.78 4.64-11.5 5.23a20 20 0 0 0 5.65 6.62A19.28 19.28 0 0 0 37.92 36Z",
    style: {
      fill: "#00559d"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M31 31.12a13.87 13.87 0 0 0-15.83-.78c-5.05 2.89-8.69 4.59-11.38 5.18a19.67 19.67 0 0 0 5.59 6.54 19 19 0 0 0 26.9-4 19.35 19.35 0 0 0 1.27-2Z",
    style: {
      fill: "#00549c"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M30.78 31.19a13.71 13.71 0 0 0-15.66-.78c-5 2.86-8.6 4.54-11.26 5.12A19.52 19.52 0 0 0 9.39 42 18.77 18.77 0 0 0 36 38a22.12 22.12 0 0 0 1.26-2Z",
    style: {
      fill: "#00549b"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M30.52 31.25A13.57 13.57 0 0 0 15 30.48C10.08 33.31 6.52 35 3.89 35.54A19.22 19.22 0 0 0 9.36 42a18.69 18.69 0 0 0 27.57-5.9Z",
    style: {
      fill: "#00539b"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M30.26 31.31a13.41 13.41 0 0 0-15.32-.76c-4.89 2.8-8.42 4.45-11 5a19 19 0 0 0 5.39 6.35 18.37 18.37 0 0 0 26-3.9 21 21 0 0 0 1.23-1.94Z",
    style: {
      fill: "#00539a"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M30 31.37a13.27 13.27 0 0 0-15.15-.75C10 33.39 6.53 35 4 35.57a18.68 18.68 0 0 0 5.3 6.27A18.16 18.16 0 0 0 35.05 38a17.85 17.85 0 0 0 1.22-1.93Z",
    style: {
      fill: "#005299"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M29.74 31.43a13.13 13.13 0 0 0-15-.74C10 33.43 6.53 35 4 35.59a18.67 18.67 0 0 0 5.28 6.2A18 18 0 0 0 34.73 38a17.51 17.51 0 0 0 1.21-1.91Z",
    style: {
      fill: "#005299"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M29.48 31.49a13 13 0 0 0-14.82-.73C9.93 33.47 6.53 35.06 4 35.6a18.27 18.27 0 0 0 5.22 6.13A17.77 17.77 0 0 0 34.42 38a18.7 18.7 0 0 0 1.19-1.89Z",
    style: {
      fill: "#005198"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M29.22 31.56a12.82 12.82 0 0 0-14.65-.73c-4.67 2.68-8 4.25-10.52 4.79a18.28 18.28 0 0 0 5.16 6.06A17.56 17.56 0 0 0 34.1 38a18.19 18.19 0 0 0 1.18-1.86Z",
    style: {
      fill: "#005197"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M29 31.62a12.69 12.69 0 0 0-14.48-.72c-4.62 2.65-7.95 4.2-10.4 4.73a17.8 17.8 0 0 0 5.11 6 17.33 17.33 0 0 0 24.59-3.68A17.83 17.83 0 0 0 35 36.1Z",
    style: {
      fill: "#005097"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M28.7 31.68A12.53 12.53 0 0 0 14.39 31c-4.57 2.61-7.85 4.15-10.28 4.68a17.7 17.7 0 0 0 5.05 5.92 17.16 17.16 0 0 0 24.31-3.64 20.56 20.56 0 0 0 1.15-1.82Z",
    style: {
      fill: "#005096"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M28.44 31.74A12.39 12.39 0 0 0 14.3 31c-4.51 2.58-7.76 4.11-10.16 4.62a17.41 17.41 0 0 0 5 5.85 17 17 0 0 0 25.16-5.39Z",
    style: {
      fill: "#004f96"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M28.18 31.8a12.25 12.25 0 0 0-14-.69c-4.46 2.55-7.67 4.06-10 4.57a17.4 17.4 0 0 0 4.92 5.78 16.75 16.75 0 0 0 23.73-3.55A17.74 17.74 0 0 0 34 36.13Z",
    style: {
      fill: "#004f95"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M27.92 31.87a12.09 12.09 0 0 0-13.8-.69c-4.41 2.52-7.58 4-9.92 4.51a17.1 17.1 0 0 0 4.87 5.71 16.54 16.54 0 0 0 23.45-3.51 16.1 16.1 0 0 0 1.11-1.75Z",
    style: {
      fill: "#004e94"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M27.66 31.93A12 12 0 0 0 14 31.25c-4.35 2.49-7.49 4-9.8 4.46A17 17 0 0 0 9 41.35a16.34 16.34 0 0 0 23.2-3.47 18.65 18.65 0 0 0 1.1-1.73Z",
    style: {
      fill: "#004e94"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M27.4 32a11.79 11.79 0 0 0-13.46-.67c-4.3 2.46-7.39 3.91-9.68 4.4A16.71 16.71 0 0 0 9 41.29a16.13 16.13 0 0 0 22.87-3.42A18.25 18.25 0 0 0 33 36.16Z",
    style: {
      fill: "#004d93"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M27.14 32.05a11.67 11.67 0 0 0-13.3-.66c-4.24 2.43-7.29 3.86-9.55 4.35A16.51 16.51 0 0 0 9 41.24a16 16 0 0 0 22.59-3.38 17.75 17.75 0 0 0 1.07-1.69Z",
    style: {
      fill: "#004d92"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M26.88 32.11a11.51 11.51 0 0 0-13.13-.65c-4.19 2.4-7.2 3.81-9.43 4.29A16.42 16.42 0 0 0 9 41.18a15.74 15.74 0 0 0 22.3-3.33 18.69 18.69 0 0 0 1.06-1.67Z",
    style: {
      fill: "#004d92"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M26.61 32.18a11.34 11.34 0 0 0-12.95-.65c-4.13 2.37-7.11 3.76-9.31 4.24a16.2 16.2 0 0 0 4.57 5.36 15.53 15.53 0 0 0 22-3.3A16.84 16.84 0 0 0 32 36.19Z",
    style: {
      fill: "#004c91"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M26.35 32.24a11.19 11.19 0 0 0-12.78-.64c-4.08 2.34-7 3.71-9.19 4.18a15.92 15.92 0 0 0 4.51 5.29 15.33 15.33 0 0 0 21.73-3.25 17.61 17.61 0 0 0 1-1.62Z",
    style: {
      fill: "#004c90"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M26.09 32.3a11 11 0 0 0-12.61-.63c-4 2.31-6.92 3.67-9.07 4.13A15.84 15.84 0 0 0 8.87 41a15.13 15.13 0 0 0 21.43-3.19c.37-.52.71-1.06 1-1.6Z",
    style: {
      fill: "#004b90"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M25.83 32.36a10.89 10.89 0 0 0-12.44-.62c-4 2.28-6.83 3.62-8.95 4.07A15.33 15.33 0 0 0 8.84 41 14.91 14.91 0 0 0 30 37.8a16.82 16.82 0 0 0 1-1.58Z",
    style: {
      fill: "#004b8f"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M25.57 32.42a10.75 10.75 0 0 0-12.27-.61c-3.92 2.25-6.74 3.57-8.82 4a15.19 15.19 0 0 0 4.33 5.08 14.72 14.72 0 0 0 20.86-3.12q.54-.76 1-1.56Z",
    style: {
      fill: "#004a8f"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M25.31 32.48a10.59 10.59 0 0 0-12.1-.6c-3.87 2.22-6.65 3.52-8.7 4a14.89 14.89 0 0 0 4.27 5 14.51 14.51 0 0 0 20.57-3.08 16.66 16.66 0 0 0 1-1.54Z",
    style: {
      fill: "#004a8e"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M25.05 32.55A10.44 10.44 0 0 0 13.12 32c-3.81 2.19-6.56 3.47-8.58 3.91a14.78 14.78 0 0 0 4.21 4.89A14.41 14.41 0 0 0 30 36.24Z",
    style: {
      fill: "#00498d"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M24.79 32.61A10.29 10.29 0 0 0 13 32c-3.76 2.16-6.47 3.42-8.46 3.85a14.6 14.6 0 0 0 4.15 4.87 14.11 14.11 0 0 0 20-3 13.9 13.9 0 0 0 .94-1.5Z",
    style: {
      fill: "#00498d"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M24.53 32.67a10.16 10.16 0 0 0-11.6-.58c-3.7 2.12-6.36 3.37-8.33 3.8a14.39 14.39 0 0 0 4.09 4.8 13.9 13.9 0 0 0 19.71-2.95 13.55 13.55 0 0 0 .93-1.48Z",
    style: {
      fill: "#00488c"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M24.27 32.73a10 10 0 0 0-11.43-.57c-3.65 2.09-6.27 3.32-8.21 3.74a14.09 14.09 0 0 0 4 4.73 13.7 13.7 0 0 0 19.42-2.9 14.22 14.22 0 0 0 .95-1.46Z",
    style: {
      fill: "#00488b"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M24 32.79a9.87 9.87 0 0 0-11.26-.56c-3.59 2.06-6.18 3.27-8.09 3.69a14 14 0 0 0 4 4.66 13.5 13.5 0 0 0 19.14-2.87 14.27 14.27 0 0 0 .9-1.43Z",
    style: {
      fill: "#00478b"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M23.75 32.86a9.72 9.72 0 0 0-11.09-.56c-3.54 2-6.09 3.23-8 3.63a13.8 13.8 0 0 0 3.94 4.59 13.33 13.33 0 0 0 19.74-4.23Z",
    style: {
      fill: "#00478a"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M23.49 32.92a9.57 9.57 0 0 0-10.92-.55c-3.49 2-6 3.18-7.85 3.58a13.6 13.6 0 0 0 3.85 4.52 13.09 13.09 0 0 0 18.56-2.78A12 12 0 0 0 28 36.3Z",
    style: {
      fill: "#004689"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M23.23 33a9.42 9.42 0 0 0-10.75-.54c-3.43 2-5.9 3.13-7.73 3.52a13.33 13.33 0 0 0 3.8 4.45 12.89 12.89 0 0 0 18.27-2.73 14.2 14.2 0 0 0 .86-1.37Z",
    style: {
      fill: "#004689"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M23 33a9.27 9.27 0 0 0-10.58-.53A30 30 0 0 1 4.78 36a13 13 0 0 0 3.74 4.37 12.74 12.74 0 0 0 18.83-4Z",
    style: {
      fill: "#004588"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M22.71 33.1a9.13 9.13 0 0 0-10.41-.52A29.35 29.35 0 0 1 4.81 36a12.82 12.82 0 0 0 3.68 4.3 12.47 12.47 0 0 0 17.69-2.65 13.31 13.31 0 0 0 .82-1.32Z",
    style: {
      fill: "#004588"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M22.45 33.17a9 9 0 0 0-10.24-.51A29.3 29.3 0 0 1 4.84 36a12.8 12.8 0 0 0 3.62 4.23 12.28 12.28 0 0 0 17.41-2.6 12.83 12.83 0 0 0 .82-1.3Z",
    style: {
      fill: "#004487"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M22.19 33.23a8.81 8.81 0 0 0-10.07-.5A28.68 28.68 0 0 1 4.87 36a12.42 12.42 0 0 0 3.56 4.17 12.08 12.08 0 0 0 17.12-2.56 12.47 12.47 0 0 0 .81-1.28Z",
    style: {
      fill: "#004486"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M21.93 33.29A8.67 8.67 0 0 0 12 32.8 28.2 28.2 0 0 1 4.9 36a12.29 12.29 0 0 0 3.5 4.09 11.86 11.86 0 0 0 16.83-2.51 12.11 12.11 0 0 0 .8-1.26Z",
    style: {
      fill: "#004386"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M21.67 33.35a8.53 8.53 0 0 0-9.74-.48 27.58 27.58 0 0 1-7 3.18 12.24 12.24 0 0 0 3.44 4 11.68 11.68 0 0 0 16.55-2.45 11.53 11.53 0 0 0 .78-1.23Z",
    style: {
      fill: "#004385"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M21.41 33.41a8.37 8.37 0 0 0-9.57-.47A26.93 26.93 0 0 1 5 36.07a11.79 11.79 0 0 0 3.38 4 11.46 11.46 0 0 0 16.22-2.48 11.19 11.19 0 0 0 .77-1.21Z",
    style: {
      fill: "#004284"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M21.15 33.47a8.24 8.24 0 0 0-9.4-.46A26.43 26.43 0 0 1 5 36.08 11.59 11.59 0 0 0 8.31 40a11.27 11.27 0 0 0 16-2.39 11.89 11.89 0 0 0 .69-1.22Z",
    style: {
      fill: "#004284"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M20.89 33.54a8.07 8.07 0 0 0-9.23-.46A26.3 26.3 0 0 1 5 36.1a11.47 11.47 0 0 0 3.25 3.81A11.07 11.07 0 0 0 24 37.57a12.07 12.07 0 0 0 .74-1.17Z",
    style: {
      fill: "#004283"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M20.63 33.6a7.93 7.93 0 0 0-9.06-.45 25.73 25.73 0 0 1-6.51 3 11.18 11.18 0 0 0 3.19 3.75 10.87 10.87 0 0 0 15.4-2.3 11.83 11.83 0 0 0 .73-1.16Z",
    style: {
      fill: "#004182"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M20.37 33.66a7.77 7.77 0 0 0-8.89-.44 25.6 25.6 0 0 1-6.39 2.91 11 11 0 0 0 3.13 3.67 10.65 10.65 0 0 0 15.11-2.26 9 9 0 0 0 .72-1.13Z",
    style: {
      fill: "#004182"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M20.11 33.72a7.64 7.64 0 0 0-8.72-.43 25 25 0 0 1-6.27 2.85 10.71 10.71 0 0 0 3.08 3.61A10.45 10.45 0 0 0 23 37.53a10.85 10.85 0 0 0 .7-1.11Z",
    style: {
      fill: "#004081"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M19.85 33.78a7.5 7.5 0 0 0-8.55-.42 24.68 24.68 0 0 1-6.15 2.8 10.47 10.47 0 0 0 3 3.53 10.25 10.25 0 0 0 14.55-2.17 9.53 9.53 0 0 0 .69-1.09Z",
    style: {
      fill: "#004080"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M19.59 33.85a7.34 7.34 0 0 0-8.39-.42 23.87 23.87 0 0 1-6 2.74 10.32 10.32 0 0 0 3 3.47 10.1 10.1 0 0 0 14.92-3.2Z",
    style: {
      fill: "#003f80"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M19.33 33.91a7.21 7.21 0 0 0-8.22-.41 23.74 23.74 0 0 1-5.9 2.69 10.18 10.18 0 0 0 2.9 3.39 9.85 9.85 0 0 0 14-2.08 11.53 11.53 0 0 0 .66-1Z",
    style: {
      fill: "#003f7f"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M19.07 34a7.05 7.05 0 0 0-8-.4 22.6 22.6 0 0 1-5.83 2.6 9.91 9.91 0 0 0 2.84 3.33 9.65 9.65 0 0 0 13.67-2.05 9.23 9.23 0 0 0 .65-1Z",
    style: {
      fill: "#003e7f"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M18.81 34a6.91 6.91 0 0 0-7.88-.39 22.3 22.3 0 0 1-5.66 2.58 9.79 9.79 0 0 0 2.78 3.25 9.43 9.43 0 0 0 13.38-2 8.89 8.89 0 0 0 .64-1Z",
    style: {
      fill: "#003e7e"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M18.55 34.09a6.75 6.75 0 0 0-7.71-.38 21.68 21.68 0 0 1-5.54 2.52A9.5 9.5 0 0 0 8 39.42a9.25 9.25 0 0 0 13.1-2 10.08 10.08 0 0 0 .62-1Z",
    style: {
      fill: "#003d7d"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M18.29 34.16a6.61 6.61 0 0 0-7.54-.38 21.54 21.54 0 0 1-5.42 2.47A9.29 9.29 0 0 0 8 39.36a9 9 0 0 0 12.8-1.91 8.16 8.16 0 0 0 .61-1Z",
    style: {
      fill: "#003d7d"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M18 34.22a6.45 6.45 0 0 0-7.37-.37 20.77 20.77 0 0 1-5.3 2.41A9.33 9.33 0 0 0 8 39.31a8.83 8.83 0 0 0 12.52-1.87 10.61 10.61 0 0 0 .6-.94Z",
    style: {
      fill: "#003d7c"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M17.77 34.28a6.31 6.31 0 0 0-7.2-.36 20.48 20.48 0 0 1-5.18 2.36 8.88 8.88 0 0 0 2.54 3 8.63 8.63 0 0 0 12.24-1.83 10.77 10.77 0 0 0 .58-.91Z",
    style: {
      fill: "#003c7b"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M17.51 34.34a6.15 6.15 0 0 0-7-.35 19.85 19.85 0 0 1-5.06 2.3A8.82 8.82 0 0 0 7.9 39.2a8.42 8.42 0 0 0 12-1.79 9.53 9.53 0 0 0 .57-.89Z",
    style: {
      fill: "#003c7b"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M17.25 34.4a6 6 0 0 0-6.86-.34 19.56 19.56 0 0 1-4.94 2.25 8.52 8.52 0 0 0 2.43 2.83 8.21 8.21 0 0 0 11.65-1.74 8 8 0 0 0 .56-.87Z",
    style: {
      fill: "#003b7a"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M17 34.46a5.87 5.87 0 0 0-6.7-.33 18.41 18.41 0 0 1-4.81 2.19 8.24 8.24 0 0 0 2.37 2.77 8 8 0 0 0 11.37-1.7 8.65 8.65 0 0 0 .54-.85Z",
    style: {
      fill: "#003b7a"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M16.73 34.53a5.72 5.72 0 0 0-6.53-.33 18.75 18.75 0 0 1-4.68 2.14A8 8 0 0 0 7.82 39a7.82 7.82 0 0 0 11.08-1.62 8.28 8.28 0 0 0 .53-.83Z",
    style: {
      fill: "#003a79"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M16.47 34.59a5.57 5.57 0 0 0-6.36-.32 18 18 0 0 1-4.56 2.08A7.91 7.91 0 0 0 7.79 39a7.61 7.61 0 0 0 10.79-1.62c.19-.26.36-.53.52-.8Z",
    style: {
      fill: "#003a78"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M163.49 33.78c0 1 0 2.29 1.45 2.29 1.2 0 1.51-.57 1.51-2.29v-4h5.25v2.75c0 6.35-2.34 8.17-6.76 8.17-3.79 0-6.7-2.08-6.7-8.43V19.9c0-6.35 2.91-8.43 6.7-8.43 4.42 0 6.76 1.82 6.76 8.17v2.23h-5.25v-3.43c0-1.72-.31-2.29-1.51-2.29-1.4 0-1.45 1.25-1.45 2.29ZM180.28 17.92v22.41H175V2.11h5.25v12.17c.42-.26 2.45-2.81 4.27-2.81 2.8 0 3.95 3.23 3.95 5.57v23.29h-5.25V17.82c0-1.1-.63-1.25-1.25-1.25-.97 0-1.69 1.35-1.69 1.35ZM205.71 30.14v3.28s0 7.33-6.81 7.33-6.76-7.49-6.76-7.49V19s.05-7.49 6.81-7.49 6.76 7.33 6.76 7.33v8.27H197v6.19s0 2.86 1.92 2.86 1.87-2.86 1.87-2.86v-3.16ZM197 23h3.79v-4s.11-2.91-1.87-2.91S197 19 197 19ZM214.13 33.78c0 1 .05 2.29 1.46 2.29 1.2 0 1.51-.57 1.51-2.29v-4h5.25v2.75c0 6.35-2.34 8.17-6.76 8.17-3.8 0-6.71-2.08-6.71-8.43V19.9c0-6.35 2.91-8.43 6.71-8.43 4.42 0 6.76 1.82 6.76 8.17v2.23h-5.25v-3.43c0-1.72-.31-2.29-1.51-2.29-1.41 0-1.46 1.25-1.46 2.29ZM230.93 2.11v18.15h.26l.31-.94 2.55-7.43h4.73L235 21.14l4.78 19.19h-5.05l-2.6-11.49-.1-.42h-.26l-.16.42-.67 1.66v9.83h-5.25V2.11ZM157.21 49h6.06l1.87-5.76L167 49h6.06l-4.9 3.57 1.87 5.77-4.91-3.57-4.9 3.57 1.87-5.77ZM174 49h6.06l1.94-5.76 1.82 5.76h6.06L185 52.57l1.87 5.77-4.87-3.57-5 3.57 1.87-5.77ZM190.81 49h6.06l1.87-5.76 1.88 5.76h6.06l-4.9 3.57 1.87 5.77-4.91-3.57-4.91 3.57 1.88-5.77ZM207.61 49h6.06l1.87-5.76 1.88 5.76h6.06l-4.9 3.57 1.87 5.77-4.91-3.57-4.91 3.57 1.88-5.77ZM224.41 49h6.06l1.87-5.76 1.87 5.76h6.06l-4.89 3.57 1.87 5.77-4.91-3.57-4.91 3.57 1.88-5.77Z",
    style: {
      fill: "#fbba00"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M57.43 57.28a1.63 1.63 0 0 1-.13-.75v-.21a1.93 1.93 0 0 1-1.68 1.12c-1 0-1.68-.83-1.68-2.2a2.6 2.6 0 0 1 1.33-2.42 4.13 4.13 0 0 1 1.91-.43c0-1.38-.12-1.67-.55-1.67S56 51 56 51.89l-1.81-.21a2.41 2.41 0 0 1 2.53-2.45 2.45 2.45 0 0 1 2.11 1 4.18 4.18 0 0 1 .33 2.2v3.18a5.43 5.43 0 0 0 .1 1.71Zm-.25-3.81c-.85.15-1.19.6-1.19 1.56 0 .67.16 1 .51 1a.6.6 0 0 0 .56-.48 6.91 6.91 0 0 0 .12-1.68ZM61 47l1.78-.15v2.56H64V51h-1.22v3.33c0 1 .14 1.23.81 1.23a3 3 0 0 0 .51 0v1.63a4.47 4.47 0 0 1-1.31.21 2.09 2.09 0 0 1-1.62-.63c-.35-.43-.43-.88-.43-2.34V51h-.85v-1.61h.94ZM67.54 46.61h2v3.81a1.53 1.53 0 0 1 1.6-1.19 1.62 1.62 0 0 1 1.43.66 3.2 3.2 0 0 1 .3 1.68v5.71h-2v-5.47c0-.69-.13-.88-.62-.88s-.66.22-.66 1v5.39h-2ZM79.42 53.33c0 2.72-1 4.11-2.84 4.11a2.33 2.33 0 0 1-1.84-.73 5.32 5.32 0 0 1-.94-3.4c0-2.65 1-4.08 2.86-4.08s2.76 1.46 2.76 4.1ZM75.93 53c0 2.59.09 3 .67 3s.69-.41.69-2.73c0-2.13-.11-2.6-.64-2.6s-.72.39-.72 2.33ZM80.36 49.39h1.84v1.17c.37-1 .8-1.33 1.63-1.33s1.28.32 1.63 1.25c.29-.89.73-1.25 1.54-1.25a1.61 1.61 0 0 1 1.51.77 4.21 4.21 0 0 1 .24 1.73v5.55h-2v-5.55c0-.61-.15-.8-.6-.8s-.61.26-.61 1.17v5.18h-2v-5.42c0-.74-.11-.93-.57-.93s-.61.26-.61 1v5.33h-2ZM91.66 53.7v.3c0 1.37.24 1.89.86 1.89s.7-.32.83-1.3l1.7.14a3.19 3.19 0 0 1-.8 2 2.39 2.39 0 0 1-1.81.68q-2.84 0-2.83-4c0-2.7 1-4.18 2.81-4.18a2.41 2.41 0 0 1 2.42 1.84 8.58 8.58 0 0 1 .27 2.63Zm1.55-1.3c0-1.21-.23-1.73-.74-1.73s-.77.47-.83 1.73ZM104.09 53.33c0 2.72-1 4.11-2.83 4.11a2.3 2.3 0 0 1-1.84-.73 5.32 5.32 0 0 1-1-3.4c0-2.65 1-4.08 2.87-4.08s2.8 1.46 2.8 4.1ZM100.6 53c0 2.59.1 3 .67 3s.69-.41.69-2.73c0-2.13-.11-2.6-.64-2.6s-.72.39-.72 2.33ZM105 49.39h1.84v1.16c.4-1 .88-1.32 1.76-1.32a1.67 1.67 0 0 1 1.46.64 3.32 3.32 0 0 1 .32 1.89v5.52h-2v-5.36a2.42 2.42 0 0 0-.06-.7.6.6 0 0 0-.56-.29c-.48 0-.66.27-.66 1v5.36h-2ZM116.92 57.28a1.51 1.51 0 0 1-.13-.75v-.21a1.93 1.93 0 0 1-1.68 1.12c-1 0-1.68-.83-1.68-2.2a2.58 2.58 0 0 1 1.33-2.42 4.08 4.08 0 0 1 1.9-.43c0-1.38-.11-1.67-.54-1.67s-.59.32-.66 1.17l-1.81-.21a2.42 2.42 0 0 1 2.53-2.45 2.45 2.45 0 0 1 2.12 1 4.18 4.18 0 0 1 .33 2.2v3.18a5.43 5.43 0 0 0 .1 1.71Zm-.26-3.81c-.85.15-1.18.6-1.18 1.56 0 .67.16 1 .51 1a.6.6 0 0 0 .56-.48 7.12 7.12 0 0 0 .11-1.68ZM119.8 46.61h2v10.67h-2ZM123.06 46.61h2v10.67h-2ZM131.72 51.65c-.1-.61-.37-.9-.88-.9s-.66.21-.66.55a.75.75 0 0 0 .42.64 8.84 8.84 0 0 0 1.29.64 2.57 2.57 0 1 1-3.72 2.53l1.58-.26c.11.72.43 1 1 1s.79-.24.79-.61a.77.77 0 0 0-.37-.67 7 7 0 0 0-1-.5c-1.43-.69-1.91-1.3-1.91-2.39a2.42 2.42 0 0 1 2.55-2.48c1.24 0 2 .63 2.3 2.05ZM136 53.7v.3c0 1.37.24 1.89.86 1.89s.71-.32.83-1.3l1.7.14a3.09 3.09 0 0 1-.8 2 2.39 2.39 0 0 1-1.81.68q-2.83 0-2.83-4c0-2.7 1-4.18 2.82-4.18a2.4 2.4 0 0 1 2.41 1.84 8.2 8.2 0 0 1 .28 2.63Zm1.55-1.3c0-1.21-.22-1.73-.74-1.73s-.76.47-.83 1.73ZM143.4 57.28a1.51 1.51 0 0 1-.13-.75v-.21a1.93 1.93 0 0 1-1.68 1.12c-1 0-1.68-.83-1.68-2.2a2.58 2.58 0 0 1 1.33-2.42 4.08 4.08 0 0 1 1.9-.43c0-1.38-.11-1.67-.54-1.67s-.59.32-.66 1.17l-1.81-.21a2.42 2.42 0 0 1 2.53-2.45 2.45 2.45 0 0 1 2.12 1 4.18 4.18 0 0 1 .33 2.2v3.18a5.43 5.43 0 0 0 .1 1.71Zm-.26-3.81c-.85.15-1.18.6-1.18 1.56 0 .67.16 1 .51 1a.6.6 0 0 0 .56-.48 7.12 7.12 0 0 0 .11-1.68ZM149.45 51.65c-.1-.61-.37-.9-.88-.9s-.66.21-.66.55a.75.75 0 0 0 .42.64 8.84 8.84 0 0 0 1.29.64 2.57 2.57 0 1 1-3.73 2.53l1.59-.26c.11.72.43 1 1 1s.78-.24.78-.61a.77.77 0 0 0-.37-.67 5.78 5.78 0 0 0-1-.5c-1.42-.69-1.9-1.3-1.9-2.39a2.42 2.42 0 0 1 2.54-2.48c1.25 0 2 .63 2.31 2.05Z",
    style: {
      fill: "#fff"
    }
  }))));
};

/* harmony default export */ var logo_inverted = (SvgLogoInverted);
// EXTERNAL MODULE: ./public/assets/icons/f_phone2.svg
var f_phone2 = __webpack_require__(23364);
;// CONCATENATED MODULE: ./public/assets/icons/user.svg
var user_g;

function user_extends() { user_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return user_extends.apply(this, arguments); }



var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/react.createElement("svg", user_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 482.9 482.9",
    width: 512,
    height: 512
  }, props), user_g || (user_g = /*#__PURE__*/react.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M239.7 260.2h3.2c29.3-.5 53-10.8 70.5-30.5 38.5-43.4 32.1-117.8 31.4-124.9-2.5-53.3-27.7-78.8-48.5-90.7C280.8 5.2 262.7.4 242.5 0h-1.7c-11.1 0-32.9 1.8-53.8 13.7-21 11.9-46.6 37.4-49.1 91.1-.7 7.1-7.1 81.5 31.4 124.9 17.4 19.7 41.1 30 70.4 30.5zm-75.1-152.9c0-.3.1-.6.1-.8 3.3-71.7 54.2-79.4 76-79.4h1.2c27 .6 72.9 11.6 76 79.4 0 .3 0 .6.1.8.1.7 7.1 68.7-24.7 104.5-12.6 14.2-29.4 21.2-51.5 21.4h-1c-22-.2-38.9-7.2-51.4-21.4-31.7-35.6-24.9-103.9-24.8-104.5z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M446.8 383.6v-.3c0-.8-.1-1.6-.1-2.5-.6-19.8-1.9-66.1-45.3-80.9-.3-.1-.7-.2-1-.3-45.1-11.5-82.6-37.5-83-37.8-6.1-4.3-14.5-2.8-18.8 3.3-4.3 6.1-2.8 14.5 3.3 18.8 1.7 1.2 41.5 28.9 91.3 41.7 23.3 8.3 25.9 33.2 26.6 56 0 .9 0 1.7.1 2.5.1 9-.5 22.9-2.1 30.9-16.2 9.2-79.7 41-176.3 41-96.2 0-160.1-31.9-176.4-41.1-1.6-8-2.3-21.9-2.1-30.9 0-.8.1-1.6.1-2.5.7-22.8 3.3-47.7 26.6-56 49.8-12.8 89.6-40.6 91.3-41.7 6.1-4.3 7.6-12.7 3.3-18.8-4.3-6.1-12.7-7.6-18.8-3.3-.4.3-37.7 26.3-83 37.8-.4.1-.7.2-1 .3-43.4 14.9-44.7 61.2-45.3 80.9 0 .9 0 1.7-.1 2.5v.3c-.1 5.2-.2 31.9 5.1 45.3 1 2.6 2.8 4.8 5.2 6.3 3 2 74.9 47.8 195.2 47.8s192.2-45.9 195.2-47.8c2.3-1.5 4.2-3.7 5.2-6.3 5-13.3 4.9-40 4.8-45.2z"
  }))));
};

/* harmony default export */ var user = (SvgUser);
;// CONCATENATED MODULE: ./src/components/globals/header.js














function Header() {
    var PhoneBlock = function PhoneBlock() {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            /*#__PURE__*/ children: app_config/* default.phone */.Z.phone
        }));
    };
    var ref = (0,react.useState)(false), menu = ref[0], setMenu = ref[1];
    var ref1 = (0,react.useState)(data[0]), openTab = ref1[0], setOpenTab = ref1[1];
    var router = (0,next_router.useRouter)();
    var openMenu = function() {
        setMenu(!menu);
    };
    var toggleTabs = function(tabNumber) {
        setOpenTab(tabNumber);
    };
    // const exp = useExperiment('pfM453XPRJq2AzrB3YGa4Q');
    var phone = app_config/* default.phone */.Z.phone;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-762322e4f5e91505",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover */.J, {
                className: "fixed top-0 left-0 right-0 w-full z-[10000] bg-primary",
                children: function(param1) {
                    var open = param1.open;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                "aria-hidden": "true",
                                className: "jsx-762322e4f5e91505" + " " + "absolute inset-0 shadow-sm bg-primary-600 text-white z-50 pointer-events-none"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "jsx-762322e4f5e91505" + " " + "relative z-50",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "jsx-762322e4f5e91505" + " " + "max-w-7xl mx-auto flex justify-between items-center px-6 md:py-0 py-2 xl:px-0 md:justify-start md:space-x-5 lg:space-x-8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "jsx-762322e4f5e91505" + " " + "flex items-center space-x-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(helper_link/* default */.Z, {
                                                    className: "flex",
                                                    href: "/",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                        className: "jsx-762322e4f5e91505",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "jsx-762322e4f5e91505" + " " + "sr-only",
                                                                children: "Chartercheck"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(logo_inverted, {
                                                                alt: "Chartercheck Logo",
                                                                className: "h-8 w-auto md:h-9 lg:h-10"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "jsx-762322e4f5e91505" + " " + "border-l border-gray-100 pl-2",
                                                    children: open ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        className: "jsx-762322e4f5e91505" + " " + " rounded-md lg:p-2 p-1 inline-flex items-center justify-center text-white focus:outline-none",
                                                        children: !open ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_MenuIcon, {
                                                            "aria-hidden": "true",
                                                            className: "h-6 w-6"
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(XIcon/* default */.Z, {
                                                            "aria-hidden": "true",
                                                            className: "h-6 w-6"
                                                        })
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Button */.J.Button, {
                                                        className: " rounded-md lg:p-2 p-1 inline-flex items-center justify-center text-white focus:outline-none",
                                                        children: !open ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_MenuIcon, {
                                                            "aria-hidden": "true",
                                                            className: "h-6 w-6"
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(XIcon/* default */.Z, {
                                                            "aria-hidden": "true",
                                                            className: "h-6 w-6"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "jsx-762322e4f5e91505" + " " + "md:flex-1 md:flex md:items-center md:justify-between md:pl-5 lg:pl-0",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderNavMenu, {
                                                    open: function(v) {
                                                        return toggleTabs(v);
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "jsx-762322e4f5e91505" + " " + "flex items-center lg:space-x-2 bg-primary-500 text-white px-4 md:px-3 pl-2 md:pl-3 py-2 -mt-4 md:mt-0 -mb-3 md:-mb-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "jsx-762322e4f5e91505" + " " + "hidden lg:block cursor-pointer order-gray-200 -mt-3",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(f_phone2/* default */.Z, {
                                                                "aria-hidden": "true",
                                                                className: "h-12 w-12 fill-white"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "tel:".concat(phone),
                                                            className: "jsx-762322e4f5e91505",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "jsx-762322e4f5e91505" + " " + "text-right hidden lg:block border-gray-200 border-opacity-50 border-r pr-4 cursor-pointer",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: "jsx-762322e4f5e91505" + " " + "font-light",
                                                                        children: "Mo-Fr. 9-12 Uhr und 16-19 Uhr"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "jsx-762322e4f5e91505" + " " + "text-white",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                            className: "jsx-762322e4f5e91505" + " " + "text-xl",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneBlock, {})
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "jsx-762322e4f5e91505" + " " + "cursor-pointer lg:hidden",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_SearchIcon, {
                                                                "aria-hidden": "true",
                                                                className: "h-7 w-7 mx-2 text-white"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: app_config/* default.planbar24_url */.Z.planbar24_url,
                                                            target: "_blank",
                                                            rel: "noreferrer",
                                                            className: "jsx-762322e4f5e91505" + " " + "cursor-pointer border-l border-gray-100 lg:border-l-0 py-1.5 pl-3 lg:p-0",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(user, {
                                                                "aria-hidden": "true",
                                                                className: "h-7 w-7 lg:h-8 lg:w-8 text-white"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(transition/* Transition */.u, {
                                enter: "transition duration-200 ease-out",
                                enterFrom: "opacity-0 ",
                                enterTo: "opacity-100 ",
                                leave: "transition duration-100 ease-in",
                                leaveFrom: "opacity-100 ",
                                leaveTo: "opacity-0 ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        "aria-hidden": "true",
                                        className: "jsx-762322e4f5e91505" + " " + "absolute left-0 top-0 top-header h-screen w-full z-[30] bg-black bg-opacity-50"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Panel */.J.Panel, {
                                        className: "absolute top-0 left-0 w-full h-screen",
                                        children: function(param) {
                                            var close = param.close;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                className: "jsx-762322e4f5e91505" + " " + "relative w-full lg:w-[470px] md:w-90 z-[40] inset-x-0",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "jsx-762322e4f5e91505" + " " + "bg-primary-500 h-screen overflow-y-auto p-6 pb-10 lg:px-14 lg:pt-24 pt-18 flex flex-col justify-between",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "jsx-762322e4f5e91505" + " " + "sm:pb-8 text-left",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                    className: "jsx-762322e4f5e91505" + " " + "flex pt-1 list-none flex-wrap pb-7 space-x-4",
                                                                    children: data.map(function(h) {
                                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                                            className: "jsx-762322e4f5e91505",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                onClick: function() {
                                                                                    return toggleTabs(h);
                                                                                },
                                                                                className: "jsx-762322e4f5e91505" + " " + "".concat(openTab !== h ? 'text-gray-200' : 'border-b border-action border-opacity-30 text-action-50 font-semibold', " text-base lg:text-lg cursor-pointer leading-normal pb-2 px-0.5"),
                                                                                children: h.name
                                                                            })
                                                                        }, h.name);
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "jsx-762322e4f5e91505",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSidebar, {
                                                                        click: openMenu,
                                                                        data: openTab,
                                                                        closeParent: close
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "jsx-762322e4f5e91505" + " " + "text-primary font-light mt-auto hidden",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                    className: "jsx-762322e4f5e91505" + " " + "text-xs",
                                                                    children: "Sprache:"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                    className: "jsx-762322e4f5e91505" + " " + "flex items-center space-x-2 pt-2",
                                                                    children: router.locales.map(function(i, k) {
                                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                                                                            className: "jsx-762322e4f5e91505",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(helper_link/* default */.Z, {
                                                                                    href: "/",
                                                                                    locale: i,
                                                                                    activeClassName: "text-white font-semibold",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                        className: "jsx-762322e4f5e91505" + " " + "text-base hover:underline transition-all cursor-pointer",
                                                                                        children: i.toUpperCase()
                                                                                    })
                                                                                }),
                                                                                k < router.locales.length - 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "jsx-762322e4f5e91505" + " " + "ml-2",
                                                                                    children: "|"
                                                                                }) : ''
                                                                            ]
                                                                        }, i);
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            });
                                        }
                                    })
                                ]
                            })
                        ]
                    });
                }
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "762322e4f5e91505",
                children: "a.router-link-exact-active.jsx-762322e4f5e91505{@apply font-semibold border-primary !important;}"
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./src/lib/app-server-context.js
var app_server_context = __webpack_require__(57806);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/disclosure/disclosure.js
var disclosure = __webpack_require__(6512);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/ChevronDownIcon.js
var esm_ChevronDownIcon = __webpack_require__(61782);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./src/components/elements/input.js
var input = __webpack_require__(66505);
// EXTERNAL MODULE: ./src/components/elements/button.js
var elements_button = __webpack_require__(81474);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./src/lib/connect.js
var connect = __webpack_require__(43424);
;// CONCATENATED MODULE: ./src/components/globals/newsletter.js







function newsletter_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function newsletter_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            newsletter_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Newsletter() {
    var ref = (0,react.useState)(false), showMessage = ref[0], setShowMessage = ref[1];
    var ref1 = (0,index_esm/* useForm */.cI)(), register = ref1.register, handleSubmit = ref1.handleSubmit, reset = ref1.reset, errors = ref1.formState.errors;
    var onSubmit = function(data) {
        (0,connect/* fetchAPIPost */.u9)('/newsletter', {
            email: data.email
        }).then(function() {
            setShowMessage(true);
            setTimeout(function() {
                setShowMessage(false);
                reset();
            }, 3000);
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-xl font-semibold uppercase mb-7",
                children: "Newsletter abonnieren"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "md:text-sm text-xs font-light",
                children: "Abonnieren Sie unseren Newsletter, um keine unserer besten Angebote, neuesten Nachrichten, Artikel und vieles mehr zu verpassen."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: "mt-4 divide-gray-200",
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center space-x-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                label: "E-Mail Adresse",
                                type: "email",
                                name: "email",
                                id: "email",
                                autocomplete: "email",
                                required: "",
                                placeholder: "E-Mail Adresse",
                                error: errors === null || errors === void 0 ? void 0 : errors.email,
                                register: newsletter_objectSpread({}, register('email', {
                                    required: true,
                                    pattern: /^\S+@\S+$/i
                                }))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_button/* default */.Z, {
                                type: "submit",
                                children: "abonnieren"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", newsletter_objectSpread({
                                type: "checkbox",
                                id: "nl-footer-privacy",
                                placeholder: "agb"
                            }, register('agb', {
                                required: true
                            }))),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                htmlFor: "nl-footer-privacy",
                                className: "ml-2 text-sm ".concat((errors === null || errors === void 0 ? void 0 : errors.agb) ? 'text-red-600' : ''),
                                children: [
                                    "Ich stimme den",
                                    ' ',
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(helper_link/* default */.Z, {
                                        href: "/datenschutz",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "underline",
                                            children: "Datenschutzbedingungen"
                                        })
                                    }),
                                    ' ',
                                    "zu"
                                ]
                            })
                        ]
                    }),
                    showMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-2 p-3 bg-primary text-white",
                        children: "Sie haben sich erfolgreich f\xfcr unseren Newsletter angemeldet. Danke f\xfcr die Registrierung."
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./node_modules/@heroicons/react/outline/esm/PhoneIcon.js


function PhoneIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
  }));
}

const PhoneIcon_ForwardRef = react.forwardRef(PhoneIcon);
/* harmony default export */ var esm_PhoneIcon = (PhoneIcon_ForwardRef);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/ChevronRightIcon.js
var outline_esm_ChevronRightIcon = __webpack_require__(40169);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/outline/esm/MailIcon.js


function MailIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
  }));
}

const MailIcon_ForwardRef = react.forwardRef(MailIcon);
/* harmony default export */ var esm_MailIcon = (MailIcon_ForwardRef);
// EXTERNAL MODULE: ./src/components/content/headline.js + 1 modules
var headline = __webpack_require__(17587);
;// CONCATENATED MODULE: ./src/components/content/cta.js



function ContentCta(param) {
    var title = param.title, content = param.content, children = param.children, _right = param.right, right = _right === void 0 ? false : _right;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "lg:py-0 relative overflow-hidden bg-gray-100",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative z-30 flex items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "max-w-7xl mx-auto w-full px-6 xl:px-0 flex ".concat(right ? 'justify-end' : 'justify-start', " h-full py-10"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bg-white md:p-10 p-4 shadow-sm md:px-16 max-w-3xl",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(headline/* default */.Z, {
                                tag: "div",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "border-t border-secondary pt-4 pb-3",
                                children: content
                            }),
                            children
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "hidden lg:grid grid-cols-2 items-end py-10 w-full h-full z-20 lg:absolute w-full h-full top-0 left-0 items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(right ? 'order-last justify-end' : 'items-end', " lg:flex hidden"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            width: "272px",
                            height: "176px",
                            viewBox: "0 0 272 176",
                            className: "fill-action",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "16",
                                    cy: "16",
                                    r: "16"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "16",
                                    cy: "64",
                                    r: "16"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "16",
                                    cy: "112",
                                    r: "16"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "16",
                                    cy: "160",
                                    r: "16"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "112",
                                    cy: "16",
                                    r: "16"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "112",
                                    cy: "64",
                                    r: "16"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "112",
                                    cy: "112",
                                    r: "16"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "112",
                                    cy: "160",
                                    r: "16"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "208",
                                    cy: "16",
                                    r: "16"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "208",
                                    cy: "64",
                                    r: "16"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "208",
                                    cy: "112",
                                    r: "16"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "208",
                                    cy: "160",
                                    r: "16"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "64",
                                    cy: "16",
                                    r: "16"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "64",
                                    cy: "64",
                                    r: "16"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "64",
                                    cy: "112",
                                    r: "16"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "64",
                                    cy: "160",
                                    r: "16"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "160",
                                    cy: "16",
                                    r: "16"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "160",
                                    cy: "64",
                                    r: "16"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "160",
                                    cy: "112",
                                    r: "16"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "160",
                                    cy: "160",
                                    r: "16"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "256",
                                    cy: "16",
                                    r: "16"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "256",
                                    cy: "64",
                                    r: "16"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "256",
                                    cy: "112",
                                    r: "16"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "256",
                                    cy: "160",
                                    r: "16"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(right ? 'justify-end' : '', " flex"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                            title: "Sie haben Fragen?",
                            alt: "Notizzettel",
                            height: 400,
                            width: 600,
                            objectFit: "cover",
                            src: "/images/notice.png"
                        })
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/home/questions.js





function Questions() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ContentCta, {
        title: "Sie w\xfcnschen ein Individuelles Angebot oder m\xf6chten sich telefonisch beraten lassen?",
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "prose",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "font-semibold",
                            children: "Unsere Experten und Serviceberater stehen Ihnen zur Verf\xfcgung!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "\xdcber unser Kontaktformular k\xf6nnen Sie sich zu jeder Zeit ein individuelles Angebot f\xfcr Ihre n\xe4chste Reise anfordern. Senden Sie uns unkompliziert alle wichtigen Angaben zu Ihrer Planung (Zeitraum, Personen, Fahrgebiet usw.) damit wir Ihnen ein ma\xdfgeschneidertes Angebot zusenden k\xf6nnen."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Nat\xfcrlich steht Ihnen auch unsere freundlichen Kundenberater*innen des Serviceteams - f\xfcr alle Fragen zur Yachtvermietung (Montag bis Freitag, jeweils zwischen 09:00 Uhr und 12:00 Uhr sowie 16:00 Uhr und 19:00 Uhr) zur Verf\xfcgung. Bei CharterCheck gelten \xfcbrigens die gesetzlichen Feiertage des Bundeslandes Bayern."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid md:grid-cols-2 gap-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_button/* default */.Z, {
                            size: "sm",
                            href: "tel:".concat(app_config/* default.phone */.Z.phone),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_PhoneIcon, {
                                        className: "h-6 text-primary mr-2"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            app_config/* default.phone */.Z.phone,
                                            ' ',
                                            "*"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm_ChevronRightIcon/* default */.Z, {
                                        className: "w-5 text-primary"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_button/* default */.Z, {
                            size: "sm",
                            href: "/kontakt",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_MailIcon, {
                                        className: "h-6 text-primary mr-2"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: " Kontaktformular"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm_ChevronRightIcon/* default */.Z, {
                                        className: "w-5 text-primary"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./public/assets/images/payment-methods.svg
var payment_methods_style, payment_methods_path, payment_methods_path2, payment_methods_path3, payment_methods_path4, payment_methods_path5, payment_methods_path6, payment_methods_path7, payment_methods_path8, payment_methods_path9, payment_methods_path10, payment_methods_path11, payment_methods_path12, payment_methods_path13, payment_methods_path14;

function payment_methods_extends() { payment_methods_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return payment_methods_extends.apply(this, arguments); }



var SvgPaymentMethods = function SvgPaymentMethods(props) {
  return /*#__PURE__*/react.createElement("svg", payment_methods_extends({
    id: "payment-methods_svg__Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 720 61"
  }, props), payment_methods_style || (payment_methods_style = /*#__PURE__*/react.createElement("style", null, ".payment-methods_svg__st0,.payment-methods_svg__st1,.payment-methods_svg__st5,.payment-methods_svg__st6{fill:#000268;fill-rule:evenodd;clip-rule:evenodd}.payment-methods_svg__st1,.payment-methods_svg__st5,.payment-methods_svg__st6{fill:#fff}.payment-methods_svg__st5,.payment-methods_svg__st6{fill:#006}.payment-methods_svg__st6{fill:#c00}")), payment_methods_path || (payment_methods_path = /*#__PURE__*/react.createElement("path", {
    className: "payment-methods_svg__st0",
    d: "M4 0h92c2.2 0 4 1.8 4 4v52c0 2.2-1.8 4-4 4H4c-2.2 0-4-1.8-4-4V4c0-2.2 1.8-4 4-4z",
    transform: "translate(620 1)"
  })), payment_methods_path2 || (payment_methods_path2 = /*#__PURE__*/react.createElement("path", {
    className: "payment-methods_svg__st1",
    d: "M24.7 17h50.6c2.6 0 4.6 2.1 4.6 4.7v16.6c0 2.6-2.1 4.7-4.6 4.7H24.7c-2.6 0-4.6-2.1-4.6-4.7V21.7c-.1-2.6 2-4.7 4.6-4.7z",
    transform: "translate(620 1)"
  })), payment_methods_path3 || (payment_methods_path3 = /*#__PURE__*/react.createElement("path", {
    className: "payment-methods_svg__st0",
    d: "M21.9 21.8v16.3c0 1.6 1.3 2.9 2.9 2.9h26.5V18.9H24.9c-1.7 0-3 1.3-3 2.9zm35.9 4.8c1.8 0 2.8 1.7 2.8 3.3 0 1.9-1 3.5-3 3.5-.8 0-1.6-.3-2.1-1.1v3.5h-2.2v-9.1h2.1v1.2c.4-.9 1.4-1.3 2.4-1.3zm-.9 1.7c-.8 0-1.4.7-1.4 1.7s.6 1.7 1.4 1.7c.8 0 1.4-.7 1.4-1.8-.1-.8-.6-1.6-1.4-1.6zm8-1.7c1.7 0 3.1.7 3.1 2.7v2.4c0 .5 0 1 .1 1.5H66c0-.3-.1-.7-.1-1-.5.8-1.1 1.2-2.1 1.2-1.3 0-2.4-.6-2.4-2.1 0-2 2.2-2.2 3.3-2.2.4 0 .8 0 1 .1 0-.9-.7-1.1-1.5-1.1-.7 0-1.4.1-2.1.5v-1.5c1-.4 1.8-.5 2.8-.5zm.1 3.7c-.8 0-1.4.2-1.4.9 0 .5.4.7.9.7.8 0 1.4-.8 1.4-1.5-.3-.1-.6-.1-.9-.1zm4.1 5.6c.5.1.9.1 1.4.1 2.1 0 2.5-1.6 3.2-3.2l2.4-6.1h-2.2L72.5 31l-1.4-4.3h-2.4l2.6 6.7c-.2.6-.6.9-1.1.9-.3 0-.6 0-.9-.1l-.2 1.7z",
    transform: "translate(620 1)"
  })), payment_methods_path4 || (payment_methods_path4 = /*#__PURE__*/react.createElement("path", {
    className: "payment-methods_svg__st1",
    d: "M28 26.6c1 0 1.7.5 2.2 1.3v-1.2h2v5.8c0 2.7-1.3 3.5-3.9 3.5-.8 0-1.7-.1-2.5-.4l.1-1.8c.7.3 1.3.5 2.2.5 1.3 0 2-.6 2-1.9V32c-.5.8-1.3 1.1-2.2 1.1-1.8 0-2.9-1.4-2.9-3.3.1-1.8 1-3.2 3-3.2zm.7 1.7c-.8 0-1.3.7-1.3 1.6 0 1 .6 1.6 1.3 1.6.8 0 1.4-.7 1.4-1.7 0-.7-.4-1.5-1.4-1.5zm7.4-4.3h-2.2v1.7h2.2V24zm-2.3 9.2H36v-6.5h-2.2v6.5zm8.5-6.5c-.3 0-.5-.1-.8-.1-1 0-1.5.5-1.9 1.4v-1.2h-2v6.5h2.2v-2.8c0-1.3.6-2 1.6-2 .3 0 .5 0 .8.1l.1-1.9zm3.8-.1c2.1 0 3.8 1.3 3.8 3.4 0 2.2-1.6 3.4-3.8 3.4-2.1 0-3.8-1.2-3.8-3.4.1-2.2 1.7-3.4 3.8-3.4zm0 1.6c-1 0-1.5.9-1.5 1.8 0 1 .4 1.8 1.5 1.8 1 0 1.5-.9 1.5-1.8 0-1-.4-1.8-1.5-1.8z",
    transform: "translate(620 1)"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M4 0h92c2.2 0 4 1.8 4 4v52c0 2.2-1.8 4-4 4H4c-2.2 0-4-1.8-4-4V4c0-2.2 1.8-4 4-4z",
    transform: "translate(496)",
    style: {
      fill: "#0b4a8e",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), payment_methods_path5 || (payment_methods_path5 = /*#__PURE__*/react.createElement("path", {
    className: "payment-methods_svg__st1",
    d: "m13 40.6.7-.1c0 .2.1.4.3.5.1.1.3.2.6.2.2 0 .4-.1.6-.2.1-.1.2-.2.2-.4 0-.1 0-.2-.1-.2-.1-.1-.2-.1-.3-.2-.2-.1-.4-.1-.6-.2-.4-.1-.7-.2-.9-.4-.2-.2-.3-.5-.3-.8 0-.2.1-.4.2-.5.1-.2.3-.3.5-.4.1.1.4.1.7.1.5 0 .8.1 1.1.3.2.2.4.5.4.8h-.8c0-.2-.1-.3-.2-.4-.1-.1-.3-.1-.5-.1s-.4 0-.5.1c-.1.1-.1.1-.1.2s0 .2.1.2c.1.1.3.2.7.2.4.1.6.2.8.3.2.1.3.2.4.4.1.2.2.4.2.6 0 .4-.3.9-.7 1-.2.1-.5.1-.8.1-.5 0-.8-.1-1.1-.3-.4-.1-.5-.4-.6-.8m3.9-1.5h.7v2.7h-.7v-2.7zm0-1h.7v.7h-.7v-.7zm4.1 3.7h-.7v-2c0-.1-.1-.2-.1-.2-.1 0-.2-.1-.2-.1-.1 0-.2 0-.3.1-.1.1-.2.2-.2.3 0 .1-.1.3-.1.6v1.2h-.7V39h.7v.4c.2-.3.5-.5.9-.5.2 0 .3 0 .4.1.1 0 .2.1.3.2.1.1.1.2.1.3v.5l-.1 1.8m1.4-1.4c0 .3.1.5.2.6.1.1.2.2.4.2s.3-.1.4-.2c.1-.1.2-.3.2-.6s-.1-.5-.2-.6c-.1-.1-.3-.2-.4-.2-.2 0-.3.1-.4.2-.1.1-.2.3-.2.6zm-.6 1.6.8.1c0 .1 0 .2.1.2.1.1.2.1.3.1.2 0 .3 0 .4-.1.1 0 .1-.1.1-.2v-.7c-.2.3-.5.4-.8.4-.4 0-.7-.2-.9-.5-.2-.2-.2-.5-.2-.9 0-.5.1-.8.3-1 .2-.2.5-.4.8-.4.3 0 .6.1.8.4V39h.7v2.4c0 .3 0 .6-.1.7 0 .1-.1.3-.2.4-.1.1-.2.2-.4.2-.2.1-.4.1-.6.1-.5 0-.8-.1-1-.2 0-.1-.1-.3-.1-.6 0 .1 0 0 0 0zm3.4-3.9h.7v3.8h-.7v-3.8zm3.3 2.1c0-.2-.1-.4-.2-.5-.1-.1-.2-.2-.4-.2s-.3.1-.4.2c-.1.1-.2.3-.2.5h1.2zm-.1.8.7.1c-.1.2-.2.5-.4.6-.2.1-.4.2-.7.2-.5 0-.8-.2-1.1-.5-.2-.2-.3-.6-.3-.9 0-.5.1-.8.4-1.1.2-.3.5-.4.9-.4s.7.1 1 .4c.2.3.3.7.3 1.2h-1.8c0 .2.1.4.2.5.1.1.3.2.4.2.1 0 .2 0 .3-.1 0 0 .1-.1.1-.2zm3.1.8V38h2.8v.6h-2v.8h1.9v.6h-1.9v1h2.1v.6l-2.9.2m5.5 0v-.4c-.1.1-.2.3-.4.3-.3.2-.7.2-1 0-.1-.1-.3-.2-.3-.3-.1-.1-.1-.3-.1-.6v-1.7h.7v2c0 .1.1.2.1.2.1 0 .2.1.3.1.2 0 .4-.1.5-.4 0-.1.1-.3.1-.7v-1.2h.7v2.7H37m2.2 0h-.7v-2.7h.7v.4c.1-.2.2-.3.3-.4.1-.1.2-.1.3-.1.2 0 .3 0 .5.1l-.2.6c-.1-.1-.2-.1-.3-.1-.1 0-.2 0-.3.1-.1.1-.1.2-.2.3s-.1.5-.1.9v.9m2.1-1.4c0 .3.1.5.2.6.1.1.3.2.5.2s.4-.1.5-.2c.1-.1.2-.4.2-.6 0-.3-.1-.5-.2-.6-.1-.1-.3-.2-.5-.2s-.4.1-.5.2c-.1.2-.2.4-.2.6zm-.7 0c0-.2.1-.5.2-.7.1-.2.3-.4.5-.5.2-.1.5-.2.7-.2.4 0 .7.1 1 .4s.4.6.4 1-.1.8-.4 1c-.3.3-.6.4-1 .4-.2 0-.5-.1-.7-.2-.2-.1-.4-.3-.5-.5-.2-.1-.2-.4-.2-.7zm5.9-1.7v1.1h.4c.3 0 .5 0 .6-.1.2-.1.3-.3.3-.5 0-.1 0-.2-.1-.3-.1-.1-.2-.1-.3-.2h-.9zm-.8 3.1V38h1.2c.5 0 .8 0 .9.1.2.1.4.2.5.4.1.2.2.4.2.7 0 .2 0 .4-.1.6-.1.1-.2.3-.3.4-.1.1-.3.2-.4.2-.3 0-.5.1-.8.1h-.5v1.4h-.7zm5.2-1.3c-.1 0-.3.1-.4.1-.2 0-.3.1-.4.1-.1.1-.1.2-.1.3 0 .1 0 .2.1.3.1.1.2.1.3.1.1 0 .3 0 .4-.1l.2-.2v-.6zm-1-.6-.6-.1c.1-.3.2-.5.4-.6.2-.1.4-.2.8-.2.3 0 .6 0 .7.1.1.1.3.2.3.3.1.1.1.3.1.6v1.3c0 .1.1.2.1.4H51c0-.1 0-.1-.1-.2v-.1c-.1.1-.3.2-.4.3s-.3.1-.4.1c-.3 0-.5-.1-.7-.2-.2-.1-.2-.4-.2-.6 0-.2 0-.3.1-.4l.3-.3c.1-.1.3-.1.6-.2s.6-.1.7-.2v.1c0-.1 0-.2-.1-.3-.1-.1-.2-.1-.4-.1-.1 0-.2 0-.3.1-.1 0-.2.1-.2.2zm2.2-.8h.8l.7 1.9.6-1.9h.7l-1.1 3.1c0 .1-.1.2-.2.4l-.2.2c-.1.1-.2.1-.3.1h-.8l-.1-.6h.3c.2 0 .3 0 .4-.1.1-.1.1-.2.2-.4l-1-2.7m3.4 0h.7v.4c.2-.3.5-.4.8-.4.2 0 .3 0 .5.1l.3.3c.1-.1.2-.3.4-.3.1-.1.3-.1.4-.1.2 0 .4 0 .5.1.1.1.2.2.3.4 0 .1.1.3.1.6v1.7h-.7v-1.6c0-.3 0-.4-.1-.5-.1-.1-.2-.2-.3-.2-.1 0-.2 0-.3.1-.1.1-.2.2-.2.3 0 .1-.1.3-.1.6v1.3h-.7v-2c0-.1-.1-.1-.1-.2-.1 0-.1-.1-.2-.1s-.2 0-.3.1c-.1.1-.2.2-.2.3 0 .1-.1.3-.1.6v1.3h-.7v-2.8m6.5 1.1c0-.2-.1-.4-.2-.5-.1-.1-.2-.2-.4-.2s-.3.1-.4.2c-.1.1-.2.3-.2.5H62zm-.1.8.7.1c-.1.2-.2.5-.4.6-.2.1-.4.2-.7.2-.5 0-.8-.2-1.1-.5-.2-.2-.3-.6-.3-.9 0-.5.1-.8.4-1.1.2-.3.5-.4.9-.4s.7.1 1 .4c.2.3.3.7.3 1.2h-1.8c0 .2.1.4.2.5.1.1.3.2.4.2.1 0 .2 0 .3-.1 0 0 .1-.1.1-.2zm4 .8h-.7v-2c0-.1-.1-.2-.2-.2s-.2-.1-.2-.1c-.1 0-.2 0-.3.1-.1.1-.2.2-.2.3 0 .1-.1.3-.1.6v1.2h-.7V39h.7v.4c.2-.3.5-.5.9-.5.2 0 .3 0 .4.1.1 0 .2.1.3.2.1.1.1.2.1.3v2.3m2.1-2.7v.6h-.5v1.5s0 .1.1.1h.1c.1 0 .2 0 .3-.1l.1.6c-.2.1-.4.1-.6.1-.1 0-.2 0-.3-.1-.1 0-.2-.1-.2-.2-.1-.1-.1-.2-.1-.3v-1.7h-.3V39h.3v-.5l.7-.4v1h.4m.4 1.9.7-.1c0 .1.1.2.2.3.1.1.2.1.4.1s.3 0 .4-.1c.1 0 .1-.1.1-.2s0-.1-.1-.1c0 0-.1-.1-.2-.1-.6-.1-1-.2-1.1-.4-.2-.1-.3-.4-.3-.6 0-.2.1-.4.3-.6.2-.2.5-.2.9-.2s.7.1.8.2c.2.1.3.3.4.5l-.7.1c0-.1-.1-.2-.2-.2-.1-.1-.2-.1-.4-.1s-.3 0-.4.1c-.1 0-.1.1-.1.1 0 .1 0 .1.1.1s.3.1.7.2c.4.1.7.2.8.3.2.1.2.3.2.5 0 .3-.1.5-.3.6-.2.2-.5.3-.9.3s-.7-.1-.9-.2c-.2 0-.3-.2-.4-.5m7-.7-.5-1.4-.5 1.4h1zm1.4 1.5H76l-.4-.8h-1.5l-.3.8H73l1.5-3.8h.8c0 .1 1.5 3.8 1.5 3.8zm1.2 0h-.7v-2.7h.7v.4c.1-.2.2-.3.3-.4.1-.1.2-.1.3-.1.2 0 .3 0 .5.1l-.2.6c-.1-.1-.2-.1-.3-.1-.1 0-.2 0-.3.1-.1.1-.1.2-.2.3 0 .1-.1.5-.1.9v.9m3.1-1.6c0-.2-.1-.4-.2-.5-.1-.1-.2-.2-.4-.2-.1 0-.3.1-.4.2-.1.1-.2.3-.2.5h1.2zm0 .8.7.1c-.1.2-.2.5-.4.6-.2.1-.4.2-.8.2-.5 0-.8-.2-1.1-.5-.2-.2-.3-.6-.3-.9 0-.5.1-.8.4-1.1.2-.3.5-.4.9-.4s.7.1 1 .4c.2.3.3.7.3 1.2H80c0 .2.1.4.2.5.1.1.3.2.4.2.1 0 .2 0 .3-.1.1 0 .2-.1.2-.2zm3-.5c-.1 0-.3.1-.4.1-.2 0-.3.1-.4.1-.1.1-.1.2-.1.3 0 .1 0 .2.1.3s.2.1.3.1c.1 0 .3 0 .4-.1l.2-.2v-.4c-.1 0-.1-.2-.1-.2zm-1-.6-.6-.1c.1-.3.2-.5.4-.6.2-.1.4-.2.8-.2.3 0 .6 0 .7.1.1.1.3.2.3.3.1.1.1.3.1.6v1.3c0 .1.1.2.1.4h-.7c0-.1 0-.1-.1-.2v-.1c-.1.1-.3.2-.4.3s-.3.1-.4.1c-.3 0-.5-.1-.7-.2-.2-.1-.2-.4-.2-.6 0-.2 0-.3.1-.4l.3-.3c.1-.1.3-.1.6-.2s.6-.1.7-.2v.1c0-.1 0-.2-.1-.3-.1-.1-.2-.1-.4-.1-.1 0-.2 0-.3.1-.1 0-.1.1-.2.2zM29 23.3h-4.9c0-.8-.1-1.4-.3-1.6-.3-.4-1.1-.6-2.4-.6-1.3 0-2.1.1-2.6.4-.4.2-.6.8-.6 1.5s.2 1.2.6 1.4c.3.2.6.3 1 .3l1 .1c2.1.1 3.5.2 4 .3 1.7.2 2.9.6 3.7 1.3.6.6 1 1.3 1.1 2.2.1.5.1 1.2.1 1.9 0 1.6-.2 2.7-.5 3.5-.5 1.3-1.8 2.2-3.7 2.6-.8.2-2 .2-3.7.2-2.8 0-4.7-.2-5.8-.5-1.3-.4-2.2-1.2-2.6-2.5-.3-.8-.4-1.9-.4-3.5h4.9v.4c0 .9.2 1.4.7 1.6.3.2.8.3 1.2.3h1.8c.9 0 1.5 0 1.8-.1.5-.2.7-.5.9-.9.1-.2.1-.6.1-.9 0-.9-.3-1.4-.9-1.6-.2-.1-1.3-.2-3.3-.3-1.6-.1-2.7-.2-3.3-.3-1.6-.3-2.7-.9-3.2-1.9-.5-.8-.7-2-.7-3.6 0-1.2.1-2.2.4-3 .3-.7.7-1.3 1.2-1.7.8-.6 1.9-.9 3.2-1 1.2-.1 2.4-.1 3.6-.1 2.1 0 3.5.1 4.4.4 2.1.6 3.2 2.2 3.2 4.8v.9M55.9 27h3.3c1 0 1.7-.1 1.9-.2.3-.2.5-.5.6-1 .1-.3.1-.9.1-1.5 0-.8-.1-1.4-.2-1.9-.2-.6-.6-.9-1.4-1h-4.3V27zm-5.3 9.7V17h9.9c1.4 0 2.4.1 3.1.3 1.6.5 2.7 1.5 3.3 3.1.3.8.4 2.1.4 3.7 0 2-.2 3.4-.5 4.3-.6 1.7-1.9 2.7-3.9 3-.2 0-1.2.1-3 .1h-4.1v5.1c.1.1-5.2.1-5.2.1zm26.9-7.2L75 20.9l-2.4 8.5c0 .1 4.9.1 4.9.1zm1.1 3.8h-7.1l-.9 3.4h-5.5L71 17h8l6 19.7h-5.4l-1-3.4z",
    transform: "translate(496)"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M43.3 19.8c2.1 0 4.1.9 5.4 2.6l1.1-2.4c-1.9-1.8-4.3-2.7-6.9-2.7-4.2 0-7.7 2.5-9.2 6.1h-2.2l-1.3 2.8h2.9V28h-1.4l-1.3 2.8h3.5c1.5 3.5 5 5.9 9.1 5.9 2.1 0 4-.6 5.6-1.7v-3.5c-1.3 1.5-3.2 2.4-5.2 2.4-2.4 0-4.5-1.2-5.8-3.2h7.3l1.3-2.8h-9.7c-.1-.6-.1-1.2 0-1.7H47l1.3-2.8h-11c1.2-2.3 3.5-3.6 6-3.6",
    transform: "translate(496)",
    style: {
      fill: "#f6bc25",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M4 0h92c2.2 0 4 1.8 4 4v52c0 2.2-1.8 4-4 4H4c-2.2 0-4-1.8-4-4V4c0-2.2 1.8-4 4-4z",
    transform: "translate(248 1)",
    style: {
      fill: "#0072ce",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), payment_methods_path6 || (payment_methods_path6 = /*#__PURE__*/react.createElement("path", {
    className: "payment-methods_svg__st1",
    d: "M84.4 34.7h-3.5c-.4 0-.6 0-.8.1-.2.1-.3.3-.3.6s.2.5.4.6c.2.1.4.1.7.1H82c1.1 0 1.8.2 2.2.7l.2.2v-2.3zm0 5.3c-.5.7-1.4 1-2.6 1H78v-1.7h3.7c.4 0 .6 0 .8-.2.1-.1.2-.3.2-.5s-.1-.4-.2-.5c-.1-.1-.3-.2-.7-.2-1.8-.1-4.1.1-4.1-2.5 0-1.2.7-2.4 2.8-2.4h3.9v-1.6h-3.6c-1.1 0-1.9.3-2.4.7v-.7h-5.3c-.8 0-1.8.2-2.3.7v-.7h-9.5v.6c-.8-.5-2-.7-2.6-.7h-6.2v.7c-.6-.6-1.9-.7-2.7-.7h-7L41.2 33l-1.5-1.7H29.2v11.3h10.3l1.7-1.8 1.6 1.8h6.3V40h.6c.8 0 1.8 0 2.7-.4v3h5.2v-2.9h.3c.3 0 .4 0 .4.3v2.6h15.8c1 0 2.1-.3 2.6-.7v.7h5c1 0 2.1-.1 2.8-.5l-.1-2.1zm-7.7-3.2c.4.4.6.9.6 1.7 0 1.7-1.1 2.6-3 2.6h-3.8v-1.7h3.8c.4 0 .6 0 .8-.2.1-.1.2-.3.2-.5s-.1-.4-.2-.5c-.1-.1-.4-.2-.7-.2-1.8-.1-4.1.1-4.1-2.5 0-1.2.7-2.4 2.8-2.4H77v1.7h-3.6c-.4 0-.6 0-.8.1-.2.1-.3.3-.3.6s.2.5.4.6c.2.1.4.1.8.1h1c1-.1 1.7.1 2.2.6zm-17.5-.5c-.3.2-.6.2-1 .2h-2.4v-1.8h2.4c.3 0 .7 0 .9.1.3.1.4.4.4.7s-.1.6-.3.8zm1.2 1c.4.2.8.4 1 .7.3.4.3.8.3 1.5V41h-1.9v-1c0-.5 0-1.2-.3-1.6-.3-.3-.7-.4-1.4-.4H56v3h-1.9v-8.1h4.5c1 0 1.7 0 2.3.4.6.4 1 .9 1 1.8-.2 1.3-1 2-1.5 2.2zm2.4-4.4h6.5v1.7h-4.5v1.5h4.4v1.7h-4.4v1.6h4.5V41h-6.5v-8.1zm-13.1 3.8h-2.5v-2.1h2.5c.7 0 1.2.3 1.2 1s-.4 1.1-1.2 1.1zm-4.4 3.6-3-3.3 3-3.2v6.5zm-7.7-1h-4.8v-1.6h4.3V36h-4.3v-1.5h4.9l2.1 2.4c0 .1-2.2 2.4-2.2 2.4zM53 35.6c0 2.2-1.7 2.7-3.4 2.7h-2.4V41h-3.8L41 38.3 38.6 41h-7.7v-8.1h7.8l2.4 2.7 2.5-2.7h6.2c1.5 0 3.2.5 3.2 2.7zm-31.3-12-1.3-3.2-1.4 3.2h2.7zm29.2-1.3c-.3.2-.6.2-1 .2h-2.4v-1.8H50c.3 0 .7 0 .9.1.3.1.4.4.4.7 0 .4-.2.7-.4.8zm16.8 1.3-1.3-3.2-1.4 3.2h2.7zm-31.3 3.5h-2v-6.3l-2.8 6.3h-1.7L27 20.8v6.3h-3.9l-.7-1.8h-4l-.8 1.8h-2.1L19 19h2.9l3.3 7.7V19h3.2l2.5 5.5 2.3-5.5h3.2v8.1zm7.9 0h-6.5V19h6.5v1.7h-4.5v1.5h4.4v1.7h-4.4v1.6h4.5v1.6zm9.1-5.9c0 1.3-.9 2-1.4 2.2.4.2.8.4 1 .7.3.4.3.8.3 1.5v1.6h-2v-1c0-.5 0-1.2-.3-1.6-.3-.3-.7-.3-1.4-.3h-2.1v2.9h-1.9V19h4.5c1 0 1.7 0 2.3.4.7.4 1 .9 1 1.8zm3.1 5.9h-2V19h2v8.1zm23 0h-2.7L73 21v6.1h-3.9l-.8-1.8h-4l-.7 1.8h-2.3c-.9 0-2.1-.2-2.8-.9-.7-.7-1-1.6-1-3.1 0-1.2.2-2.3 1-3.2.6-.6 1.6-.9 2.9-.9h1.9v1.7h-1.8c-.7 0-1.1.1-1.5.5-.3.3-.6 1-.6 1.8 0 .9.2 1.5.5 1.9.3.3.8.4 1.3.4h.9l2.7-6.4h2.9l3.3 7.6V19h3l3.4 5.6V19h2v8.1zm-64.1 1.6h3.3l.7-1.8h1.7l.7 1.8h6.5v-1.4l.6 1.4h3.4l.6-1.4v1.4h16.2v-2.9h.3c.2 0 .3 0 .3.4v2.6h8.4V28c.7.4 1.7.7 3.1.7h3.5l.8-1.8h1.7l.7 1.8h6.8V27l1 1.7h5.4V17.4h-5.4v1.3l-.8-1.3h-5.5v1.3l-.7-1.3h-7.5c-1.2 0-2.3.2-3.2.7v-.7h-5v.7c-.6-.5-1.3-.7-2.2-.7H32l-1.3 2.9-1.3-2.9h-5.9v1.3l-.7-1.3h-5.1l-2.3 5.4v5.9z",
    transform: "translate(248 1)"
  })), payment_methods_path7 || (payment_methods_path7 = /*#__PURE__*/react.createElement("path", {
    className: "payment-methods_svg__st5",
    d: "M4 0h92c2.2 0 4 1.8 4 4v52c0 2.2-1.8 4-4 4H4c-2.2 0-4-1.8-4-4V4c0-2.2 1.8-4 4-4z",
    transform: "translate(372 1)"
  })), payment_methods_path8 || (payment_methods_path8 = /*#__PURE__*/react.createElement("path", {
    className: "payment-methods_svg__st6",
    d: "M83.7 30c0 11.1-8.9 20-19.9 20-11 0-19.9-9-19.9-20s8.9-20 19.9-20c10.9 0 19.9 8.9 19.9 20",
    transform: "translate(372 1)"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M48.3 42.7c-.6-.7-1.1-1.4-1.5-2.1h7.1c.4-.7.8-1.4 1.1-2.1h-9.4c-.3-.7-.6-1.4-.8-2.1h11c.7-2 1-4.2 1-6.4 0-1.4-.1-2.8-.4-4.2H44.2c.2-.7.3-1.4.6-2.1h11c-.2-.7-.5-1.4-.8-2.1h-9.4c.3-.7.7-1.4 1.1-2.1h7.1l-1.5-2.1h-4c.6-.8 1.3-1.5 2-2.1-3.7-3.3-8.4-5.2-13.4-5.2-11 0-19.9 9-19.9 20 0 11.1 8.9 20 19.9 20 5.2 0 9.8-2 13.4-5.2.7-.7 1.4-1.4 2-2.1h-4",
    transform: "translate(372 1)",
    style: {
      fill: "#06c",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), payment_methods_path9 || (payment_methods_path9 = /*#__PURE__*/react.createElement("path", {
    className: "payment-methods_svg__st5",
    d: "M50 35.4c-.8.2-1.7.3-2.5.3-2.8 0-4.2-1.3-4.2-3.7 0-2.8 1.8-4.9 4.3-4.9 2 0 3.4 1.2 3.4 3 0 .6-.1 1.2-.3 2h-4.9c-.2 1.2.7 1.7 2.2 1.7.9 0 1.7-.2 2.6-.5l-.6 2.1zm-1.3-4.9c0-.2.3-1.5-1.2-1.5-.8 0-1.4.5-1.6 1.5h2.8zm3-.6c0 1 .6 1.8 1.9 2.3 1 .4 1.2.5 1.2.9 0 .5-.5.8-1.5.8-.8 0-1.5-.1-2.3-.3l-.4 1.9c.7.2 1.7.2 2.6.2 2.7 0 3.9-.9 3.9-2.8 0-1.1-.5-1.8-1.8-2.3-1.1-.4-1.2-.5-1.2-.9 0-.5.4-.7 1.2-.7.5 0 1.2 0 1.8.1l.4-1.9c-.7-.1-1.5-.2-2.2-.2-2.6.1-3.6 1.4-3.6 2.9m-9.8 5.7h-2.1v-.9c-.6.7-1.5 1-2.6 1-1.4 0-2.3-.9-2.3-2.3 0-2 1.6-3.2 4.4-3.2.3 0 .6 0 1 .1.1-.3.1-.4.1-.5 0-.6-.4-.8-1.6-.8-.9 0-1.8.1-2.6.4l.4-1.9c1.2-.3 2.1-.4 3-.4 2.1 0 3.3.8 3.3 2.4 0 .4-.1 1.3-.2 1.6-.1.6-.7 3.8-.8 4.5zm-1.8-3.7h-.6c-1.4 0-2.1.4-2.1 1.3 0 .5.3.9.9.9 1-.1 1.8-1 1.8-2.2zm21.6 3.6c-.7.2-1.2.3-1.8.3-1.3 0-2-.7-2-1.8 0-.3.3-1.8.3-2.2.1-.4 1.2-6.4 1.2-6.4h2.5l-.4 2h1.3l-.3 2h-1.3s-.7 3.5-.7 3.8c0 .4.3.6.8.6.3 0 .5 0 .7-.1l-.3 1.8m11-8.4c-1.8 0-3.2.7-4 2l.7-1.9c-1.3-.5-2.2.2-2.9 1.2 0 0-.1.2-.3.3v-1.5h-2.3c-.3 2.6-.9 5.2-1.3 7.7l-.1.6H65c.2-1.3.4-2.4.6-3.2.5-2.3 1.4-3 2.8-2.7-.3.7-.5 1.4-.5 2.3 0 2.1 1.1 3.8 3.9 3.8s4.8-1.5 4.8-4.9c0-2.1-1.4-3.7-3.9-3.7zm-.7 6.6c-.9 0-1.4-.7-1.4-1.8 0-1.3.8-2.8 2-2.8 1 0 1.4.8 1.4 1.7-.1 1.8-.8 2.9-2 2.9zm-38.2 1.9h-2.5l1.5-7.8-3.4 7.8h-2.3l-.4-7.8-1.5 7.8H23l1.9-10.1h3.9l.3 5.7 2.5-5.7h4.2l-2 10.1",
    transform: "translate(372 1)"
  })), payment_methods_path10 || (payment_methods_path10 = /*#__PURE__*/react.createElement("path", {
    className: "payment-methods_svg__st1",
    d: "M50.7 34.8c-.8.2-1.7.3-2.5.3-2.8 0-4.2-1.3-4.2-3.7 0-2.8 1.8-4.9 4.3-4.9 2 0 3.4 1.2 3.4 3 0 .6-.1 1.2-.3 2h-4.9c-.2 1.2.7 1.7 2.2 1.7.9 0 1.7-.2 2.6-.5-.2 0-.6 2.1-.6 2.1zm-1.4-5c0-.2.3-1.5-1.2-1.5-.8 0-1.4.5-1.6 1.5h2.8zm3-.5c0 1 .6 1.8 1.9 2.3 1 .4 1.2.5 1.2.9 0 .5-.5.8-1.5.8-.8 0-1.5-.1-2.3-.3l-.4 1.9c.7.2 1.7.2 2.6.2 2.7 0 3.9-.9 3.9-2.8 0-1.1-.5-1.8-1.8-2.3-1.1-.4-1.2-.5-1.2-.9 0-.5.4-.7 1.2-.7.5 0 1.2 0 1.8.1l.4-1.9c-.7-.1-1.5-.2-2.2-.2-2.6.1-3.6 1.4-3.6 2.9M42.5 35h-2.1v-.9c-.6.7-1.5 1-2.6 1-1.4 0-2.3-.9-2.3-2.3 0-2 1.6-3.2 4.4-3.2.3 0 .6 0 1 .1.1-.3.1-.4.1-.5 0-.6-.4-.8-1.6-.8-.9 0-1.8.1-2.6.4l.4-1.9c1.2-.3 2.1-.4 3-.4 2.1 0 3.3.8 3.3 2.4 0 .4-.1 1.3-.2 1.6-.1.6-.7 3.7-.8 4.5zm-1.8-3.7h-.6c-1.4 0-2.1.4-2.1 1.3 0 .5.3.9.9.9 1-.2 1.8-1 1.8-2.2zm21.6 3.5c-.7.2-1.2.3-1.8.3-1.3 0-2-.7-2-1.8 0-.3.3-1.8.3-2.2.1-.4 1.2-6.4 1.2-6.4h2.5l-.4 2h1.3l-.3 2h-1.3s-.7 3.5-.7 3.8c0 .4.3.6.8.6.3 0 .5 0 .7-.1l-.3 1.8m12.3-4.7c0 1.9-.8 3-2 3-.9 0-1.4-.7-1.4-1.8 0-1.3.8-2.8 2-2.8 1 0 1.4.8 1.4 1.6zm2.6.1c0-2.1-1.4-3.7-3.9-3.7-2.9 0-4.8 2-4.8 4.9 0 2.1 1.1 3.8 3.9 3.8 2.8-.1 4.8-1.6 4.8-5zm-12.7-3.5c-.3 2.6-.9 5.2-1.3 7.7l-.1.6h2.5c.9-5 1.2-6.4 3.1-5.9l.9-2.4c-1.3-.5-2.2.2-2.9 1.2.1-.4.2-.9.2-1.3l-2.4.1m-30 8.3H32l1.5-7.8-3.4 7.8h-2.3l-.4-7.8-1.5 7.8h-2.3l1.9-10.1h3.9l.2 6.3 2.7-6.3h4L34.5 35",
    transform: "translate(372 1)"
  })), payment_methods_path11 || (payment_methods_path11 = /*#__PURE__*/react.createElement("path", {
    className: "payment-methods_svg__st5",
    d: "M4 0h92c2.2 0 4 1.8 4 4v52c0 2.2-1.8 4-4 4H4c-2.2 0-4-1.8-4-4V4c0-2.2 1.8-4 4-4z",
    transform: "translate(124 1)"
  })), payment_methods_path12 || (payment_methods_path12 = /*#__PURE__*/react.createElement("path", {
    className: "payment-methods_svg__st6",
    d: "M56.1 30.5c0 10.8-8.7 19.5-19.5 19.5s-19.5-8.7-19.5-19.5S25.8 11 36.6 11s19.5 8.7 19.5 19.5",
    transform: "translate(124 1)"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M62.8 11c-4.8 0-9.5 1.8-13.1 5.1-.7.6-1.4 1.3-2 2.1h3.9c.5.7 1 1.3 1.5 2.1h-6.9c-.4.7-.8 1.4-1.1 2.1h9.2c.3.7.6 1.4.8 2.1H44.3l-.6 2.1h12c.7 3.4.5 7-.6 10.3H44.3c.2.7.5 1.4.8 2.1h9.2c-.3.7-.7 1.4-1.1 2.1h-6.9c.5.7.9 1.4 1.5 2.1h3.9c-.6.7-1.3 1.4-2 2.1 3.6 3.3 8.3 5.1 13.1 5 10.8 0 19.5-8.7 19.5-19.5 0-11.1-8.7-19.8-19.5-19.8",
    transform: "translate(124 1)",
    style: {
      fill: "#f90",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), payment_methods_path13 || (payment_methods_path13 = /*#__PURE__*/react.createElement("path", {
    className: "payment-methods_svg__st5",
    d: "M32.1 32.6h-.5c-1.2 0-1.8.4-1.8 1.2 0 .5.3.8.8.8.8 0 1.4-.8 1.5-2zm1.5 3.6h-1.8v-.8c-.5.7-1.2 1-2.2 1-1.1 0-1.9-.9-1.9-2.2 0-2 1.4-3.1 3.7-3.1.2 0 .5 0 .9.1.1-.3.1-.4.1-.5 0-.5-.4-.7-1.4-.7-.8 0-1.5.1-2.2.4l.3-1.8c1.1-.3 1.8-.4 2.5-.4 1.8 0 2.8.8 2.8 2.4 0 .4-.1.9-.2 1.6-.2.9-.5 3.4-.6 4zm-6.8 0h-2.1l1.2-7.6-2.7 7.6h-1.4l-.2-7.6-1.3 7.6h-2l1.7-9.9h3l.2 5.5 1.9-5.5h3.4l-1.7 9.9m38.6-3.6h-.5c-1.2 0-1.8.4-1.8 1.2 0 .5.3.8.8.8.9 0 1.5-.8 1.5-2zm1.6 3.6h-1.8v-.8c-.5.7-1.2 1-2.2 1-1.1 0-1.9-.9-1.9-2.2 0-2 1.4-3.1 3.7-3.1.2 0 .5 0 .9.1.1-.3.1-.4.1-.5 0-.5-.4-.7-1.4-.7-.8 0-1.5.1-2.2.4 0-.1.3-1.8.3-1.8 1.1-.3 1.8-.4 2.5-.4 1.8 0 2.8.8 2.8 2.4 0 .4-.1.9-.2 1.6-.2.9-.6 3.4-.6 4zm-24-.1c-.6.2-1 .3-1.5.3-1.1 0-1.7-.6-1.7-1.8 0-.4.2-1.3.3-2.1.1-.8.9-5.5.9-5.5h2.1l-.2 1.2h1.3l-.3 1.9h-1.3c-.2 1.5-.6 3.4-.6 3.7 0 .4.2.6.7.6.2 0 .4 0 .6-.1l-.3 1.8m6.5-.1c-.7.2-1.4.3-2.2.3-2.4 0-3.6-1.2-3.6-3.6 0-2.8 1.6-4.8 3.7-4.8 1.7 0 2.8 1.1 2.8 2.9 0 .6-.1 1.2-.3 2h-4.2c-.1 1.2.6 1.7 1.8 1.7.8 0 1.4-.2 2.2-.5.1 0-.2 2-.2 2zm-1.2-4.8c0-.2.2-1.4-1-1.4-.7 0-1.2.5-1.3 1.4h2.3zm-13.4-.5c0 1 .5 1.7 1.6 2.2.9.4 1 .5 1 .9 0 .5-.4.7-1.2.7-.6 0-1.2-.1-1.9-.3l-.3 1.9c.5.1.9.2 2.2.2 2.2 0 3.3-.9 3.3-2.7 0-1.1-.4-1.8-1.5-2.2-.9-.4-1-.5-1-.9s.4-.7 1-.7c.4 0 1 0 1.5.1l.3-1.9h-1.8c-2.4 0-3.2 1.2-3.2 2.7m24.9-2.5c.6 0 1.1.2 1.9.5l.3-2.1c-.3-.1-1.4-.8-2.3-.8-1.4 0-2.6.7-3.5 1.9-1.2-.4-1.7.4-2.4 1.2l-.5.1c0-.3.1-.5.1-.8h-1.9c-.3 2.5-.7 5-1.1 7.5l-.1.5h2.1c.4-2.3.5-3.8.7-4.8l.8-.4c.1-.4.5-.6 1.2-.6-.1.5-.2 1.1-.2 1.7 0 2.6 1.4 4.3 3.7 4.3.6 0 1.1-.1 1.9-.3l.4-2.3c-.7.3-1.3.5-1.8.5-1.2 0-2-.9-2-2.4 0-2.2 1.1-3.7 2.7-3.7m17.9-1.9-.5 2.9c-.6-.8-1.2-1.3-2-1.3-1.1 0-2 .8-2.7 2-.6-.1-1.2-.3-1.8-.5.1-.7.1-1.1.1-1.2h-1.9c-.3 2.5-.7 5-1.1 7.5l-.1.5h2.1c.3-1.9.5-3.4.7-4.6.7-.7 1.1-1.2 1.8-1.2-.3.8-.5 1.7-.5 2.6 0 2 1 3.3 2.6 3.3.8 0 1.4-.3 2-.9l-.1.7h2l1.6-9.9-2.2.1zm-2.6 8c-.7 0-1.1-.5-1.1-1.6 0-1.6.7-2.7 1.6-2.7.7 0 1.1.6 1.1 1.6 0 1.6-.7 2.7-1.6 2.7z",
    transform: "translate(124 1)"
  })), payment_methods_path14 || (payment_methods_path14 = /*#__PURE__*/react.createElement("path", {
    className: "payment-methods_svg__st1",
    d: "M27.5 35.6h-2.1l1.2-7.6-2.7 7.6h-1.4l-.2-7.6-1.3 7.6h-2l1.7-9.9h3l.1 6.1 2.1-6.1h3.3l-1.7 9.9m5.2-3.6h-.5c-1.2 0-1.8.4-1.8 1.2 0 .5.3.8.8.8.8 0 1.4-.8 1.5-2zm1.5 3.6h-1.8v-.8c-.5.7-1.2 1-2.2 1-1.1 0-1.9-.9-1.9-2.2 0-2 1.4-3.1 3.7-3.1.2 0 .5 0 .9.1.1-.3.1-.5.1-.6 0-.5-.4-.7-1.4-.7-.8 0-1.5.1-2.2.4l.3-1.8c1.1-.3 1.8-.4 2.5-.4 1.8 0 2.8.8 2.8 2.4 0 .4-.1.9-.2 1.6-.1 1-.5 3.5-.6 4.1zM62.6 26l-.3 2.1c-.8-.4-1.3-.5-1.9-.5-1.6 0-2.7 1.5-2.7 3.7 0 1.5.7 2.4 2 2.4.5 0 1.1-.2 1.8-.5l-.4 2.3c-.8.2-1.3.3-1.9.3-2.3 0-3.7-1.6-3.7-4.3 0-3.5 2-6 4.8-6 .9 0 2 .4 2.3.5m3.4 6h-.5c-1.2 0-1.8.4-1.8 1.2 0 .5.3.8.8.8.9 0 1.5-.8 1.5-2zm1.6 3.6h-1.8v-.8c-.5.7-1.2 1-2.2 1-1.2 0-1.9-.9-1.9-2.2 0-2 1.4-3.1 3.7-3.1.2 0 .5 0 .9.1.1-.3.1-.4.1-.5 0-.5-.4-.7-1.4-.7-.8 0-1.5.1-2.2.4l.3-1.8c1.1-.3 1.8-.4 2.5-.4 1.8 0 2.8.8 2.8 2.4 0 .4-.1.9-.2 1.6-.2.9-.6 3.4-.6 4zm-24-.1c-.6.2-1 .3-1.5.3-1.1 0-1.7-.6-1.7-1.8 0-.4.2-1.3.3-2.1.1-.8.9-5.5.9-5.5h2.1l-.2 1.2h1.1l-.3 1.9h-1.1c-.2 1.5-.6 3.4-.6 3.7 0 .4.2.6.7.6.2 0 .4 0 .6-.1l-.3 1.8m6.5-.1c-.7.2-1.4.3-2.2.3-2.4 0-3.6-1.2-3.6-3.6 0-2.8 1.6-4.8 3.7-4.8 1.7 0 2.8 1.1 2.8 2.9 0 .6-.1 1.2-.3 2h-4.2c-.1 1.2.6 1.7 1.8 1.7.8 0 1.4-.2 2.2-.5.1 0-.2 2-.2 2zm-1.2-4.7c0-.2.2-1.4-1-1.4-.7 0-1.2.5-1.3 1.4h2.3zm-13.4-.6c0 1 .5 1.7 1.6 2.2.9.4 1 .5 1 .9 0 .5-.4.7-1.2.7-.6 0-1.3-.1-1.9-.3l-.3 1.9c.5.1.9.2 2.2.2 2.2 0 3.3-.9 3.3-2.7 0-1.1-.4-1.8-1.5-2.2-.9-.4-1-.5-1-.9s.4-.7 1-.7c.4 0 1 0 1.5.1l.3-1.9c-.6-.1-1.2-.1-1.9-.2-2.3.2-3.1 1.4-3.1 2.9m43.3 5.5h-2l.1-.7c-.6.6-1.2.9-2 .9-1.5 0-2.6-1.3-2.6-3.3 0-2.7 1.6-4.9 3.4-4.9.8 0 1.4.3 2 1.1l.5-2.9h2.1l-1.5 9.8zm-3.1-1.8c1 0 1.7-1.1 1.7-2.7 0-1-.4-1.6-1.1-1.6-1 0-1.6 1.1-1.6 2.7-.1 1 .3 1.6 1 1.6zm-6.2-6.2c-.3 2.5-.7 5-1.1 7.5l-.1.5h2.1c.8-4.9.9-5.9 2.1-5.8.2-1 .5-1.9.8-2.3-.9-.2-1.4.3-2 1.3.1-.4.1-.8.1-1.2h-1.9m-17.4 0c-.3 2.5-.7 5-1.1 7.5l-.1.5H53c.8-4.9.9-5.9 2.1-5.8.2-1 .5-1.9.8-2.3-.9-.2-1.4.3-2 1.3.1-.4.1-.8.1-1.2h-1.9",
    transform: "translate(124 1)"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M4 0h92c2.2 0 4 1.8 4 4v52c0 2.2-1.8 4-4 4H4c-2.2 0-4-1.8-4-4V4c0-2.2 1.8-4 4-4z",
    transform: "translate(0 1)",
    style: {
      fill: "#26337a",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "m41.5 39.5 3.1-19.1h4.9l-3.1 19.1h-4.9m22.7-18.6c-1-.4-2.5-.8-4.4-.8-4.9 0-8.3 2.6-8.3 6.3 0 2.7 2.4 4.3 4.3 5.2 1.9.9 2.6 1.5 2.6 2.4 0 1.3-1.5 1.9-2.9 1.9-2 0-3-.3-4.6-1l-.6-.3-.7 4.3c1.1.5 3.3 1 5.5 1 5.2 0 8.5-2.6 8.6-6.5 0-2.2-1.3-3.8-4.1-5.2-1.7-.9-2.8-1.5-2.8-2.4 0-.8.9-1.6 2.8-1.6 1.3 0 2.5.2 3.7.7l.4.2.5-4.2m6.6 11.9c.4-1.1 2-5.3 2-5.3s.4-1.1.7-1.8l.3 1.6s.9 4.6 1.1 5.5h-4.1zm6-12.3H73c-1.2 0-2.1.3-2.6 1.6l-7.3 17.5h5.2s.8-2.4 1-2.9h6.3c.1.7.6 2.9.6 2.9h4.6l-4-19.1zm-39.4 0-4.8 13-.6-2.7c-.9-3-3.7-6.3-6.8-8l4.4 16.7h5.2l7.7-19h-5.1",
    transform: "translate(0 1)",
    style: {
      fill: "#fffffe",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M28.1 20.5h-7.9l-.1.4c6.2 1.6 10.2 5.4 11.9 10l-1.7-8.8c-.3-1.2-1.1-1.6-2.2-1.6",
    transform: "translate(0 1)",
    style: {
      fill: "#ec982d",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};

/* harmony default export */ var payment_methods = (SvgPaymentMethods);
;// CONCATENATED MODULE: ./src/components/globals/footer.js












function footer_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function footer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function footer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            footer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || footer_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function footer_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return footer_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return footer_arrayLikeToArray(o, minLen);
}
var PartnerMap = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(269), __webpack_require__.e(951)]).then(__webpack_require__.bind(__webpack_require__, 42951));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(42951)
            ];
        }
    },
    ssr: false
});
function Footer() {
    var useGlobalState = function() {
        return [
            (0,react.useContext)(app_server_context/* GlobalStateContext */.Pn),
            (0,react.useContext)(app_server_context/* DispatchStateContext */.aW), 
        ];
    };
    var ref = _slicedToArray(useGlobalState(), 2), state = ref[0], dispatch = ref[1];
    var ref1 = (0,react.useState)(false), showPartnerMap = ref1[0], setShowPartnerMap = ref1[1];
    (0,react.useEffect)(function() {
        setTimeout(function() {
            setShowPartnerMap(state.open);
        }, state.open ? 50 : 200);
    }, [
        state
    ]);
    var navigate = [
        {
            title: 'Interessante Links',
            list: [
                {
                    name: 'Planung vor der Reise',
                    href: '/wissenswertes/planung-vor-der-reise'
                },
                {
                    name: 'Sicherheit & Unfallverhalten',
                    href: '/wissenswertes/sicherheit-unfall'
                }
            ]
        },
        {
            title: 'Beliebte Fahrgebiete',
            list: [
                {
                    name: 'Yachtcharter Kroatien',
                    href: '/yachtcharter/kroatien'
                },
                {
                    name: 'Yachtcharter Karibik',
                    href: '/yachtcharter/karibik'
                },
                {
                    name: 'Yachtcharter Ostsee',
                    href: '/yachtcharter/deutschland/ostsee-und-peene'
                },
                {
                    name: 'Yachtcharter Mallorca',
                    href: '/yachtcharter/spanien/mallorca'
                },
                {
                    name: 'Yachtcharter Griechenland',
                    href: '/yachtcharter/griechenland'
                }, 
            ]
        }, 
    ];
    var navigation = {
        legal: [
            {
                name: 'Impressum',
                href: '/impressum'
            },
            {
                name: 'Allgemeine Gesch\xe4ftsbedingungen',
                href: '/agb'
            },
            {
                name: 'Datenschutzerkl\xe4rung',
                href: '/datenschutzerklaerung'
            }, 
        ],
        social: [
            {
                name: 'Facebook',
                href: app_config/* default.social.facebook */.Z.social.facebook,
                icon: function(props) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("svg", footer_objectSpread({
                        fill: "currentColor",
                        viewBox: "0 0 24 24"
                    }, props, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fillRule: "evenodd",
                            d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z",
                            clipRule: "evenodd"
                        })
                    }));
                }
            }, 
        ]
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Questions, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-primary shadow lg:pt-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "max-w-7xl mx-auto py-10 px-6 xl:px-0 text-white",
                            children: [
                                navigate.map(function(v, k) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(disclosure/* Disclosure */.p, {
                                        as: "div",
                                        className: "focus:outline-none lg:hidden",
                                        children: function(param) {
                                            var open = param.open;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                className: "border-b border-gray-100 sm:bg-white focus:outline-none",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(disclosure/* Disclosure.Button */.p.Button, {
                                                        className: "focus:outline-none group relative w-full py-4 flex justify-between items-center text-left",
                                                        children: [
                                                            v.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "lg:text-2xl md:text-xl text-base",
                                                                children: v.title
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(v.icon, {
                                                                className: "lg:w-9 md:w-7 w-6"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "ml-6 flex items-center",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_ChevronDownIcon/* default */.Z, {
                                                                    className: "".concat(open ? '-rotate-180' : 'rotate-0', " h-5 w-5 transform transition-all text-white sm:text-primary"),
                                                                    "aria-hidden": "true"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure.Panel */.p.Panel, {
                                                        as: "div",
                                                        className: "pb-6 md:pr-10 pr-5 text-sm md:text-base lg:font-light transform transition-all",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                            role: "list",
                                                            className: "mt-2 space-y-6",
                                                            children: v.list.map(function(item, k2) {
                                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                                    children: item.showAdac ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        onClick: function() {
                                                                            return item.showAdac ? dispatch({
                                                                                open: true
                                                                            }) : '';
                                                                        },
                                                                        className: "md:text-base text-sm text-white sm:text-primary hover:underline",
                                                                        children: item.name
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(helper_link/* default */.Z, {
                                                                        href: item.href,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            className: "md:text-base text-sm text-white sm:text-primary hover:underline",
                                                                            children: item.name
                                                                        })
                                                                    })
                                                                }, item.name + k2);
                                                            })
                                                        })
                                                    })
                                                ]
                                            });
                                        }
                                    }, v.title + k);
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "lg:grid md:grid-cols-4 md:gap-8 hidden",
                                    children: [
                                        navigate.map(function(v, k3) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    v.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-xl font-semibold uppercase",
                                                        children: v.title
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(v.icon, {
                                                        className: "lg:w-10 w-7 fill-primary"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                        role: "list",
                                                        className: "mt-6 space-y-2",
                                                        children: v.list.map(function(item, k4) {
                                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                                children: item.showAdac ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    onClick: function() {
                                                                        return item.showAdac ? dispatch({
                                                                            open: true
                                                                        }) : '';
                                                                    },
                                                                    className: "text-base hover:underline",
                                                                    children: item.name
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(helper_link/* default */.Z, {
                                                                    href: item.href,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        className: "text-base hover:underline",
                                                                        children: item.name
                                                                    })
                                                                })
                                                            }, item.name + k4);
                                                        })
                                                    }),
                                                    v.social ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex space-x-6 mt-6",
                                                        children: navigation.social.map(function(item, k5) {
                                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("a", {
                                                                href: item.href,
                                                                target: "_blank",
                                                                className: "text-primary",
                                                                rel: "noreferrer",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "sr-only",
                                                                        children: item.name
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(item.icon, {
                                                                        className: "h-6"
                                                                    })
                                                                ]
                                                            }, item.name + k5);
                                                        })
                                                    }) : ''
                                                ]
                                            }, v.title + k3);
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-span-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Newsletter, {})
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "max-w-7xl mx-auto sm:py-10 px-6 xl:px-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-10 md:flex md:items-center md:justify-between",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "grid lg:grid-cols-7 gap-y-8 sm:gap-2 lg:gap-10 w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "lg:col-span-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "",
                                                children: "Bezahlmethoden"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex gap-4 py-4",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(payment_methods, {
                                                    className: "w-full md:w-auto md:max-h-16"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "space-y-1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    role: "list",
                                                    className: "space-y-0 md:space-x-3 lg:space-x-4 md:flex",
                                                    children: navigation.legal.map(function(item, k7) {
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(helper_link/* default */.Z, {
                                                                href: item.href,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    className: "text-sm hover:underline text-primary",
                                                                    children: item.name
                                                                })
                                                            })
                                                        }, item.name + k7);
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "lg:col-span-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "",
                                                children: "In Kooperation mit"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "grid grid-cols-3 gap-4 md:gap-10 lg:gap-4 py-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "relative",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "https://skipper.adac.de",
                                                            target: "_blank",
                                                            rel: "noreferrer",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                                alt: "ADAC Partner",
                                                                title: "ADAC Partner",
                                                                src: "/images/adac.svg",
                                                                layout: "responsive",
                                                                objectFit: "contain",
                                                                height: 300,
                                                                width: 300
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "relative",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "https://www.5-anker.com",
                                                            target: "_blank",
                                                            rel: "noreferrer",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                                alt: "5 Anker",
                                                                title: "5 Anker",
                                                                src: "/images/5anker.svg",
                                                                layout: "responsive",
                                                                objectFit: "contain",
                                                                height: 300,
                                                                width: 300
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "relative",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "https://www.yacht-pool.de",
                                                            target: "_blank",
                                                            rel: "noreferrer",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                                alt: "Checked & Trusted",
                                                                title: "Checked & Trusted",
                                                                src: "/assets/images/yacht-pool-trust-badge.png",
                                                                layout: "responsive",
                                                                objectFit: "contain",
                                                                height: 300,
                                                                width: 300
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "lg:col-span-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex space-x-6 sm:mt-14 text-right justify-end",
                                                children: navigation.social.map(function(item, k6) {
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("a", {
                                                        href: item.href,
                                                        target: "_blank",
                                                        className: "text-primary",
                                                        rel: "noreferrer",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "sr-only",
                                                                children: item.name
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(item.icon, {
                                                                className: "h-8"
                                                            })
                                                        ]
                                                    }, item.name + k6);
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "mt-5 mb-5 sm:mb-0 text-sm md:pt-0 text-right",
                                                children: [
                                                    "Copyright \xa9 2008-",
                                                    new Date().getFullYear(),
                                                    ' ',
                                                    "CharterCheck GmbH"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            state.open && /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerMap, {
                open: showPartnerMap,
                setOpen: function() {
                    return dispatch({
                        open: false
                    });
                }
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/pages/_app.js

















function _app_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _app_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _app_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ReactTooltip = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(735), __webpack_require__.e(697)]).then(__webpack_require__.bind(__webpack_require__, 38735));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38735)
            ];
        }
    },
    ssr: false
});
next_router["default"].events.on('routeChangeStart', (nprogress_nprogress_default()).start);
next_router["default"].events.on('routeChangeError', (nprogress_nprogress_default()).done);
next_router["default"].events.on('routeChangeComplete', (nprogress_nprogress_default()).done);
var DynamicComponentWithNoSSR = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 237).then(__webpack_require__.bind(__webpack_require__, 49666));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49666)
            ];
        }
    },
    ssr: false
});
function uuid() {
    var uuidValue = '';
    var k;
    var randomValue;
    // eslint-disable-next-line no-plusplus
    for(k = 0; k < 32; k++){
        // eslint-disable-next-line no-bitwise
        randomValue = Math.random() * 16 | 0;
        if (k === 8 || k === 12 || k === 16 || k === 20) {
            uuidValue += '-';
        }
        // eslint-disable-next-line no-bitwise,no-mixed-operators,no-nested-ternary
        uuidValue += (k === 12 ? 4 : k === 16 ? randomValue & 3 | 8 : randomValue).toString(16);
    }
    return uuidValue;
}
function App(param) {
    var Component = param.Component, pageProps = param.pageProps, router = param.router;
    (0,react.useEffect)(function() {
        if (!js_cookie/* default.get */.Z.get('cid')) {
            js_cookie/* default.set */.Z.set('cid', uuid(), {
                // expires: 30,
                path: '/',
                httpOnly: false
            });
        }
        var referer = router.query.r || router.query.ref || router.query.referer || router.query.referrer;
        if (!js_cookie/* default.get */.Z.get('ref') && referer) {
            js_cookie/* default.set */.Z.set('ref', referer, {
                expires: 30,
                path: '/',
                httpOnly: false
            });
        } else if (!js_cookie/* default.get */.Z.get('ref')) {
            js_cookie/* default.set */.Z.set('ref', 'br24', {
                expires: 30,
                path: '/',
                httpOnly: false
            });
        }
    }, []);
    var _getLayout;
    var getLayout = (_getLayout = Component.getLayout) !== null && _getLayout !== void 0 ? _getLayout : function(page) {
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(app_server_context/* GlobalStateProvider */.MC, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(head["default"], {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
                page,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactTooltip, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicComponentWithNoSSR, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(script["default"], {
                    id: "analytics",
                    "data-cookiecategory": "analytics",
                    strategy: "afterInteractive",
                    type: "text/plain",
                    children: "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\nnew Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\nj=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n})(window,document,'script','dataLayer','".concat("GTM-T5N7STX", "');")
                })
            ]
        });
    };
    return getLayout(/*#__PURE__*/ (0,jsx_runtime.jsx)(Component, _app_objectSpread({}, pageProps)));
}
/* harmony default export */ var _app = ((0,esm/* appWithTranslation */.Jc)(App));


/***/ }),

/***/ 61284:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 20472:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 73687:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 77663:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={162:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(162);module.exports=r})();

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90638)


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 25675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(28045)


/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(48418)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90387)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(20699)


/***/ }),

/***/ 74865:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
 * @license MIT */

;(function(root, factory) {

  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}

})(this, function() {
  var NProgress = {};

  NProgress.version = '0.2.0';

  var Settings = NProgress.settings = {
    minimum: 0.08,
    easing: 'ease',
    positionUsing: '',
    speed: 200,
    trickle: true,
    trickleRate: 0.02,
    trickleSpeed: 800,
    showSpinner: true,
    barSelector: '[role="bar"]',
    spinnerSelector: '[role="spinner"]',
    parent: 'body',
    template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
  };

  /**
   * Updates configuration.
   *
   *     NProgress.configure({
   *       minimum: 0.1
   *     });
   */
  NProgress.configure = function(options) {
    var key, value;
    for (key in options) {
      value = options[key];
      if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
    }

    return this;
  };

  /**
   * Last number.
   */

  NProgress.status = null;

  /**
   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
   *
   *     NProgress.set(0.4);
   *     NProgress.set(1.0);
   */

  NProgress.set = function(n) {
    var started = NProgress.isStarted();

    n = clamp(n, Settings.minimum, 1);
    NProgress.status = (n === 1 ? null : n);

    var progress = NProgress.render(!started),
        bar      = progress.querySelector(Settings.barSelector),
        speed    = Settings.speed,
        ease     = Settings.easing;

    progress.offsetWidth; /* Repaint */

    queue(function(next) {
      // Set positionUsing if it hasn't already been set
      if (Settings.positionUsing === '') Settings.positionUsing = NProgress.getPositioningCSS();

      // Add transition
      css(bar, barPositionCSS(n, speed, ease));

      if (n === 1) {
        // Fade out
        css(progress, { 
          transition: 'none', 
          opacity: 1 
        });
        progress.offsetWidth; /* Repaint */

        setTimeout(function() {
          css(progress, { 
            transition: 'all ' + speed + 'ms linear', 
            opacity: 0 
          });
          setTimeout(function() {
            NProgress.remove();
            next();
          }, speed);
        }, speed);
      } else {
        setTimeout(next, speed);
      }
    });

    return this;
  };

  NProgress.isStarted = function() {
    return typeof NProgress.status === 'number';
  };

  /**
   * Shows the progress bar.
   * This is the same as setting the status to 0%, except that it doesn't go backwards.
   *
   *     NProgress.start();
   *
   */
  NProgress.start = function() {
    if (!NProgress.status) NProgress.set(0);

    var work = function() {
      setTimeout(function() {
        if (!NProgress.status) return;
        NProgress.trickle();
        work();
      }, Settings.trickleSpeed);
    };

    if (Settings.trickle) work();

    return this;
  };

  /**
   * Hides the progress bar.
   * This is the *sort of* the same as setting the status to 100%, with the
   * difference being `done()` makes some placebo effect of some realistic motion.
   *
   *     NProgress.done();
   *
   * If `true` is passed, it will show the progress bar even if its hidden.
   *
   *     NProgress.done(true);
   */

  NProgress.done = function(force) {
    if (!force && !NProgress.status) return this;

    return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
  };

  /**
   * Increments by a random amount.
   */

  NProgress.inc = function(amount) {
    var n = NProgress.status;

    if (!n) {
      return NProgress.start();
    } else {
      if (typeof amount !== 'number') {
        amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
      }

      n = clamp(n + amount, 0, 0.994);
      return NProgress.set(n);
    }
  };

  NProgress.trickle = function() {
    return NProgress.inc(Math.random() * Settings.trickleRate);
  };

  /**
   * Waits for all supplied jQuery promises and
   * increases the progress as the promises resolve.
   *
   * @param $promise jQUery Promise
   */
  (function() {
    var initial = 0, current = 0;

    NProgress.promise = function($promise) {
      if (!$promise || $promise.state() === "resolved") {
        return this;
      }

      if (current === 0) {
        NProgress.start();
      }

      initial++;
      current++;

      $promise.always(function() {
        current--;
        if (current === 0) {
            initial = 0;
            NProgress.done();
        } else {
            NProgress.set((initial - current) / initial);
        }
      });

      return this;
    };

  })();

  /**
   * (Internal) renders the progress bar markup based on the `template`
   * setting.
   */

  NProgress.render = function(fromStart) {
    if (NProgress.isRendered()) return document.getElementById('nprogress');

    addClass(document.documentElement, 'nprogress-busy');
    
    var progress = document.createElement('div');
    progress.id = 'nprogress';
    progress.innerHTML = Settings.template;

    var bar      = progress.querySelector(Settings.barSelector),
        perc     = fromStart ? '-100' : toBarPerc(NProgress.status || 0),
        parent   = document.querySelector(Settings.parent),
        spinner;
    
    css(bar, {
      transition: 'all 0 linear',
      transform: 'translate3d(' + perc + '%,0,0)'
    });

    if (!Settings.showSpinner) {
      spinner = progress.querySelector(Settings.spinnerSelector);
      spinner && removeElement(spinner);
    }

    if (parent != document.body) {
      addClass(parent, 'nprogress-custom-parent');
    }

    parent.appendChild(progress);
    return progress;
  };

  /**
   * Removes the element. Opposite of render().
   */

  NProgress.remove = function() {
    removeClass(document.documentElement, 'nprogress-busy');
    removeClass(document.querySelector(Settings.parent), 'nprogress-custom-parent');
    var progress = document.getElementById('nprogress');
    progress && removeElement(progress);
  };

  /**
   * Checks if the progress bar is rendered.
   */

  NProgress.isRendered = function() {
    return !!document.getElementById('nprogress');
  };

  /**
   * Determine which positioning CSS rule to use.
   */

  NProgress.getPositioningCSS = function() {
    // Sniff on document.body.style
    var bodyStyle = document.body.style;

    // Sniff prefixes
    var vendorPrefix = ('WebkitTransform' in bodyStyle) ? 'Webkit' :
                       ('MozTransform' in bodyStyle) ? 'Moz' :
                       ('msTransform' in bodyStyle) ? 'ms' :
                       ('OTransform' in bodyStyle) ? 'O' : '';

    if (vendorPrefix + 'Perspective' in bodyStyle) {
      // Modern browsers with 3D support, e.g. Webkit, IE10
      return 'translate3d';
    } else if (vendorPrefix + 'Transform' in bodyStyle) {
      // Browsers without 3D support, e.g. IE9
      return 'translate';
    } else {
      // Browsers without translate() support, e.g. IE7-8
      return 'margin';
    }
  };

  /**
   * Helpers
   */

  function clamp(n, min, max) {
    if (n < min) return min;
    if (n > max) return max;
    return n;
  }

  /**
   * (Internal) converts a percentage (`0..1`) to a bar translateX
   * percentage (`-100%..0%`).
   */

  function toBarPerc(n) {
    return (-1 + n) * 100;
  }


  /**
   * (Internal) returns the correct CSS for changing the bar's
   * position given an n percentage, and speed and ease from Settings
   */

  function barPositionCSS(n, speed, ease) {
    var barCSS;

    if (Settings.positionUsing === 'translate3d') {
      barCSS = { transform: 'translate3d('+toBarPerc(n)+'%,0,0)' };
    } else if (Settings.positionUsing === 'translate') {
      barCSS = { transform: 'translate('+toBarPerc(n)+'%,0)' };
    } else {
      barCSS = { 'margin-left': toBarPerc(n)+'%' };
    }

    barCSS.transition = 'all '+speed+'ms '+ease;

    return barCSS;
  }

  /**
   * (Internal) Queues a function to be executed.
   */

  var queue = (function() {
    var pending = [];
    
    function next() {
      var fn = pending.shift();
      if (fn) {
        fn(next);
      }
    }

    return function(fn) {
      pending.push(fn);
      if (pending.length == 1) next();
    };
  })();

  /**
   * (Internal) Applies css properties to an element, similar to the jQuery 
   * css method.
   *
   * While this helper does assist with vendor prefixed property names, it 
   * does not perform any manipulation of values prior to setting styles.
   */

  var css = (function() {
    var cssPrefixes = [ 'Webkit', 'O', 'Moz', 'ms' ],
        cssProps    = {};

    function camelCase(string) {
      return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function(match, letter) {
        return letter.toUpperCase();
      });
    }

    function getVendorProp(name) {
      var style = document.body.style;
      if (name in style) return name;

      var i = cssPrefixes.length,
          capName = name.charAt(0).toUpperCase() + name.slice(1),
          vendorName;
      while (i--) {
        vendorName = cssPrefixes[i] + capName;
        if (vendorName in style) return vendorName;
      }

      return name;
    }

    function getStyleProp(name) {
      name = camelCase(name);
      return cssProps[name] || (cssProps[name] = getVendorProp(name));
    }

    function applyCss(element, prop, value) {
      prop = getStyleProp(prop);
      element.style[prop] = value;
    }

    return function(element, properties) {
      var args = arguments,
          prop, 
          value;

      if (args.length == 2) {
        for (prop in properties) {
          value = properties[prop];
          if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
        }
      } else {
        applyCss(element, args[1], args[2]);
      }
    }
  })();

  /**
   * (Internal) Determines if an element or space separated list of class names contains a class name.
   */

  function hasClass(element, name) {
    var list = typeof element == 'string' ? element : classList(element);
    return list.indexOf(' ' + name + ' ') >= 0;
  }

  /**
   * (Internal) Adds a class to an element.
   */

  function addClass(element, name) {
    var oldList = classList(element),
        newList = oldList + name;

    if (hasClass(oldList, name)) return; 

    // Trim the opening space.
    element.className = newList.substring(1);
  }

  /**
   * (Internal) Removes a class from an element.
   */

  function removeClass(element, name) {
    var oldList = classList(element),
        newList;

    if (!hasClass(element, name)) return;

    // Replace the class name.
    newList = oldList.replace(' ' + name + ' ', ' ');

    // Trim the opening and closing spaces.
    element.className = newList.substring(1, newList.length - 1);
  }

  /**
   * (Internal) Gets a space separated list of the class names on the element. 
   * The list is wrapped with a single space on each end to facilitate finding 
   * matches within the list.
   */

  function classList(element) {
    return (' ' + (element.className || '') + ' ').replace(/\s+/gi, ' ');
  }

  /**
   * (Internal) Removes an element from the DOM.
   */

  function removeElement(element) {
    element && element.parentNode && element.parentNode.removeChild(element);
  }

  return NProgress;
});



/***/ }),

/***/ 70631:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(24654);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        mapForEach.call(obj, function (value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        setForEach.call(obj, function (value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),

/***/ 18987:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(21414); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),

/***/ 82215:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(21414);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(18987);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),

/***/ 21414:
/***/ (function(module) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),

/***/ 6063:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// eslint-disable-next-line import/no-unresolved
__webpack_require__(65453);


/***/ }),

/***/ 65453:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(64836);

var _registerCSSInterfaceWithDefaultTheme = _interopRequireDefault(__webpack_require__(5135));

(0, _registerCSSInterfaceWithDefaultTheme["default"])();

/***/ }),

/***/ 26729:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var core = {
  white: '#fff',
  gray: '#484848',
  grayLight: '#82888a',
  grayLighter: '#cacccd',
  grayLightest: '#f2f2f2',
  borderMedium: '#c4c4c4',
  border: '#dbdbdb',
  borderLight: '#e4e7e7',
  borderLighter: '#eceeee',
  borderBright: '#f4f5f5',
  primary: '#00a699',
  primaryShade_1: '#33dacd',
  primaryShade_2: '#66e2da',
  primaryShade_3: '#80e8e0',
  primaryShade_4: '#b2f1ec',
  primary_dark: '#008489',
  secondary: '#007a87',
  yellow: '#ffe8bc',
  yellow_dark: '#ffce71'
};
var _default = {
  reactDates: {
    zIndex: 0,
    border: {
      input: {
        border: 0,
        borderTop: 0,
        borderRight: 0,
        borderBottom: '2px solid transparent',
        borderLeft: 0,
        outlineFocused: 0,
        borderFocused: 0,
        borderTopFocused: 0,
        borderLeftFocused: 0,
        borderBottomFocused: "2px solid ".concat(core.primary_dark),
        borderRightFocused: 0,
        borderRadius: 0
      },
      pickerInput: {
        borderWidth: 1,
        borderStyle: 'solid',
        borderRadius: 2
      }
    },
    color: {
      core: core,
      disabled: core.grayLightest,
      background: core.white,
      backgroundDark: '#f2f2f2',
      backgroundFocused: core.white,
      border: 'rgb(219, 219, 219)',
      text: core.gray,
      textDisabled: core.border,
      textFocused: '#007a87',
      placeholderText: '#757575',
      outside: {
        backgroundColor: core.white,
        backgroundColor_active: core.white,
        backgroundColor_hover: core.white,
        color: core.gray,
        color_active: core.gray,
        color_hover: core.gray
      },
      highlighted: {
        backgroundColor: core.yellow,
        backgroundColor_active: core.yellow_dark,
        backgroundColor_hover: core.yellow_dark,
        color: core.gray,
        color_active: core.gray,
        color_hover: core.gray
      },
      minimumNights: {
        backgroundColor: core.white,
        backgroundColor_active: core.white,
        backgroundColor_hover: core.white,
        borderColor: core.borderLighter,
        color: core.grayLighter,
        color_active: core.grayLighter,
        color_hover: core.grayLighter
      },
      hoveredSpan: {
        backgroundColor: core.primaryShade_4,
        backgroundColor_active: core.primaryShade_3,
        backgroundColor_hover: core.primaryShade_4,
        borderColor: core.primaryShade_3,
        borderColor_active: core.primaryShade_3,
        borderColor_hover: core.primaryShade_3,
        color: core.secondary,
        color_active: core.secondary,
        color_hover: core.secondary
      },
      selectedSpan: {
        backgroundColor: core.primaryShade_2,
        backgroundColor_active: core.primaryShade_1,
        backgroundColor_hover: core.primaryShade_1,
        borderColor: core.primaryShade_1,
        borderColor_active: core.primary,
        borderColor_hover: core.primary,
        color: core.white,
        color_active: core.white,
        color_hover: core.white
      },
      selected: {
        backgroundColor: core.primary,
        backgroundColor_active: core.primary,
        backgroundColor_hover: core.primary,
        borderColor: core.primary,
        borderColor_active: core.primary,
        borderColor_hover: core.primary,
        color: core.white,
        color_active: core.white,
        color_hover: core.white
      },
      blocked_calendar: {
        backgroundColor: core.grayLighter,
        backgroundColor_active: core.grayLighter,
        backgroundColor_hover: core.grayLighter,
        borderColor: core.grayLighter,
        borderColor_active: core.grayLighter,
        borderColor_hover: core.grayLighter,
        color: core.grayLight,
        color_active: core.grayLight,
        color_hover: core.grayLight
      },
      blocked_out_of_range: {
        backgroundColor: core.white,
        backgroundColor_active: core.white,
        backgroundColor_hover: core.white,
        borderColor: core.borderLight,
        borderColor_active: core.borderLight,
        borderColor_hover: core.borderLight,
        color: core.grayLighter,
        color_active: core.grayLighter,
        color_hover: core.grayLighter
      }
    },
    spacing: {
      dayPickerHorizontalPadding: 9,
      captionPaddingTop: 22,
      captionPaddingBottom: 37,
      inputPadding: 0,
      displayTextPaddingVertical: undefined,
      displayTextPaddingTop: 11,
      displayTextPaddingBottom: 9,
      displayTextPaddingHorizontal: undefined,
      displayTextPaddingLeft: 11,
      displayTextPaddingRight: 11,
      displayTextPaddingVertical_small: undefined,
      displayTextPaddingTop_small: 7,
      displayTextPaddingBottom_small: 5,
      displayTextPaddingHorizontal_small: undefined,
      displayTextPaddingLeft_small: 7,
      displayTextPaddingRight_small: 7
    },
    sizing: {
      inputWidth: 130,
      inputWidth_small: 97,
      arrowWidth: 24
    },
    noScrollBarOnVerticalScrollable: false,
    font: {
      size: 14,
      captionSize: 18,
      input: {
        size: 19,
        weight: 200,
        lineHeight: '24px',
        size_small: 15,
        lineHeight_small: '18px',
        letterSpacing_small: '0.2px',
        styleDisabled: 'italic'
      }
    }
  }
};
exports["default"] = _default;

/***/ }),

/***/ 5135:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(64836);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = registerCSSInterfaceWithDefaultTheme;

var _reactWithStylesInterfaceCss = _interopRequireDefault(__webpack_require__(25906));

var _registerInterfaceWithDefaultTheme = _interopRequireDefault(__webpack_require__(28874));

function registerCSSInterfaceWithDefaultTheme() {
  (0, _registerInterfaceWithDefaultTheme["default"])(_reactWithStylesInterfaceCss["default"]);
}

/***/ }),

/***/ 28874:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(64836);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = registerInterfaceWithDefaultTheme;

var _ThemedStyleSheet = _interopRequireDefault(__webpack_require__(54202));

var _DefaultTheme = _interopRequireDefault(__webpack_require__(26729));

function registerInterfaceWithDefaultTheme(reactWithStylesInterface) {
  _ThemedStyleSheet["default"].registerInterface(reactWithStylesInterface);

  _ThemedStyleSheet["default"].registerTheme(_DefaultTheme["default"]);
}

/***/ }),

/***/ 69921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 59864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(69921);
} else {}


/***/ }),

/***/ 58232:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

__webpack_unused_export__ = ({
  value: true
});
exports["default"] = void 0;

var _arrayPrototype = _interopRequireDefault(__webpack_require__(16650));

var _globalCache = _interopRequireDefault(__webpack_require__(31884));

var _constants = __webpack_require__(28966);

var _getClassName = _interopRequireDefault(__webpack_require__(66280));

var _separateStyles2 = _interopRequireDefault(__webpack_require__(94333));

/**
 * Function required as part of the react-with-styles interface. Parses the styles provided by
 * react-with-styles to produce class names based on the style name and optionally the namespace if
 * available.
 *
 * stylesObject {Object} The styles object passed to withStyles.
 *
 * Return an object mapping style names to class names.
 */
function create(stylesObject) {
  var stylesToClasses = {};
  var styleNames = Object.keys(stylesObject);
  var sharedState = _globalCache["default"].get(_constants.GLOBAL_CACHE_KEY) || {};
  var _sharedState$namespac = sharedState.namespace,
      namespace = _sharedState$namespac === void 0 ? '' : _sharedState$namespac;
  styleNames.forEach(function (styleName) {
    var className = (0, _getClassName["default"])(namespace, styleName);
    stylesToClasses[styleName] = className;
  });
  return stylesToClasses;
}
/**
 * Process styles to be consumed by a component.
 *
 * stylesArray {Array} Array of the following: values returned by create, plain JavaScript objects
 * representing inline styles, or arrays thereof.
 *
 * Return an object with optional className and style properties to be spread on a component.
 */


function resolve(stylesArray) {
  var flattenedStyles = (0, _arrayPrototype["default"])(stylesArray, Infinity);

  var _separateStyles = (0, _separateStyles2["default"])(flattenedStyles),
      classNames = _separateStyles.classNames,
      hasInlineStyles = _separateStyles.hasInlineStyles,
      inlineStyles = _separateStyles.inlineStyles;

  var specificClassNames = classNames.map(function (name, index) {
    return "".concat(name, " ").concat(name, "_").concat(index + 1);
  });
  var className = specificClassNames.join(' ');
  var result = {
    className: className
  };
  if (hasInlineStyles) result.style = inlineStyles;
  return result;
}

var _default = {
  create: create,
  resolve: resolve
};
exports["default"] = _default;

/***/ }),

/***/ 28966:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.MAX_SPECIFICITY = exports.GLOBAL_CACHE_KEY = void 0;
var GLOBAL_CACHE_KEY = 'reactWithStylesInterfaceCSS';
exports.GLOBAL_CACHE_KEY = GLOBAL_CACHE_KEY;
var MAX_SPECIFICITY = 20;
exports.MAX_SPECIFICITY = MAX_SPECIFICITY;

/***/ }),

/***/ 66280:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getClassName;

/**
 * Construct a class name.
 *
 * namespace {String} Used to construct unique class names.
 * styleName {String} Name identifying the specific style.
 *
 * Return the class name.
 */
function getClassName(namespace, styleName) {
  var namespaceSegment = namespace.length > 0 ? "".concat(namespace, "__") : '';
  return "".concat(namespaceSegment).concat(styleName);
}

/***/ }),

/***/ 94333:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

// This function takes an array of styles and separates them into styles that
// are handled by Aphrodite and inline styles.
function separateStyles(stylesArray) {
  var classNames = []; // Since determining if an Object is empty requires collecting all of its
  // keys, and we want the best performance in this code because we are in the
  // render path, we are going to do a little bookkeeping ourselves.

  var hasInlineStyles = false;
  var inlineStyles = {}; // This is run on potentially every node in the tree when rendering, where
  // performance is critical. Normally we would prefer using `forEach`, but
  // old-fashioned for loops are faster so that's what we have chosen here.

  for (var i = 0; i < stylesArray.length; i++) {
    // eslint-disable-line no-plusplus
    var style = stylesArray[i]; // If this  style is falsy, we just want to disregard it. This allows for
    // syntax like:
    //
    //   css(isFoo && styles.foo)

    if (style) {
      if (typeof style === 'string') {
        classNames.push(style);
      } else {
        Object.assign(inlineStyles, style);
        hasInlineStyles = true;
      }
    }
  }

  return {
    classNames: classNames,
    hasInlineStyles: hasInlineStyles,
    inlineStyles: inlineStyles
  };
}

var _default = separateStyles;
exports["default"] = _default;

/***/ }),

/***/ 25906:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// eslint-disable-next-line import/no-unresolved
module.exports = __webpack_require__(58232)["default"];


/***/ }),

/***/ 54202:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports._getInterface = _getInterface;
exports._getTheme = get;
exports["default"] = void 0;
var styleInterface;
var styleTheme;
var START_MARK = 'react-with-styles.resolve.start';
var END_MARK = 'react-with-styles.resolve.end';
var MEASURE_MARK = "\uD83D\uDC69\u200D\uD83C\uDFA8 [resolve]";

function registerTheme(theme) {
  styleTheme = theme;
}

function registerInterface(interfaceToRegister) {
  styleInterface = interfaceToRegister;
}

function create(makeFromTheme, createWithDirection) {
  var styles = createWithDirection(makeFromTheme(styleTheme));
  return function () {
    return styles;
  };
}

function createLTR(makeFromTheme) {
  return create(makeFromTheme, styleInterface.createLTR || styleInterface.create);
}

function createRTL(makeFromTheme) {
  return create(makeFromTheme, styleInterface.createRTL || styleInterface.create);
}

function get() {
  return styleTheme;
}

function resolve() {
  if (false) {}

  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }

  var result = styleInterface.resolve(styles);

  if (false) {}

  return result;
}

function resolveLTR() {
  for (var _len2 = arguments.length, styles = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    styles[_key2] = arguments[_key2];
  }

  if (styleInterface.resolveLTR) {
    return styleInterface.resolveLTR(styles);
  }

  return resolve(styles);
}

function resolveRTL() {
  for (var _len3 = arguments.length, styles = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    styles[_key3] = arguments[_key3];
  }

  if (styleInterface.resolveRTL) {
    return styleInterface.resolveRTL(styles);
  }

  return resolve(styles);
}

function flush() {
  if (styleInterface.flush) {
    styleInterface.flush();
  }
} // Exported until we deprecate this API completely
// eslint-disable-next-line no-underscore-dangle


function _getInterface() {
  return styleInterface;
} // Exported until we deprecate this API completely


var _default = {
  registerTheme: registerTheme,
  registerInterface: registerInterface,
  create: createLTR,
  createLTR: createLTR,
  createRTL: createRTL,
  get: get,
  resolve: resolveLTR,
  resolveLTR: resolveLTR,
  resolveRTL: resolveRTL,
  flush: flush
};
exports["default"] = _default;

/***/ }),

/***/ 84207:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var process = __webpack_require__(83454);
/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 583:
/***/ (function(module) {



function hash(str) {
  var hash = 5381,
      i    = str.length;

  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }

  /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */
  return hash >>> 0;
}

module.exports = hash;


/***/ }),

/***/ 590:
/***/ (function(__unused_webpack_module, exports, __nccwpck_require__) {



exports.__esModule = true;
exports.computeId = computeId;
exports.computeSelector = computeSelector;

var _stringHash = _interopRequireDefault(__nccwpck_require__(583));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var sanitize = function sanitize(rule) {
  return rule.replace(/\/style/gi, '\\/style');
};

var cache = {};
/**
 * computeId
 *
 * Compute and memoize a jsx id from a basedId and optionally props.
 */

function computeId(baseId, props) {
  if (!props) {
    return "jsx-" + baseId;
  }

  var propsToString = String(props);
  var key = baseId + propsToString;

  if (!cache[key]) {
    cache[key] = "jsx-" + (0, _stringHash["default"])(baseId + "-" + propsToString);
  }

  return cache[key];
}
/**
 * computeSelector
 *
 * Compute and memoize dynamic selectors.
 */


function computeSelector(id, css) {
  var selectoPlaceholderRegexp = /__jsx-style-dynamic-selector/g; // Sanitize SSR-ed CSS.
  // Client side code doesn't need to be sanitized since we use
  // document.createTextNode (dev) and the CSSOM api sheet.insertRule (prod).

  if (typeof window === 'undefined') {
    css = sanitize(css);
  }

  var idcss = id + css;

  if (!cache[idcss]) {
    cache[idcss] = css.replace(selectoPlaceholderRegexp, id);
  }

  return cache[idcss];
}

/***/ }),

/***/ 503:
/***/ (function(__unused_webpack_module, exports) {



exports.__esModule = true;
exports["default"] = void 0;

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*
Based on Glamor's sheet
https://github.com/threepointone/glamor/blob/667b480d31b3721a905021b26e1290ce92ca2879/src/sheet.js
*/
var isProd = typeof process !== 'undefined' && process.env && "production" === 'production';

var isString = function isString(o) {
  return Object.prototype.toString.call(o) === '[object String]';
};

var StyleSheet = /*#__PURE__*/function () {
  function StyleSheet(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        _ref$name = _ref.name,
        name = _ref$name === void 0 ? 'stylesheet' : _ref$name,
        _ref$optimizeForSpeed = _ref.optimizeForSpeed,
        optimizeForSpeed = _ref$optimizeForSpeed === void 0 ? isProd : _ref$optimizeForSpeed,
        _ref$isBrowser = _ref.isBrowser,
        isBrowser = _ref$isBrowser === void 0 ? typeof window !== 'undefined' : _ref$isBrowser;

    invariant(isString(name), '`name` must be a string');
    this._name = name;
    this._deletedRulePlaceholder = "#" + name + "-deleted-rule____{}";
    invariant(typeof optimizeForSpeed === 'boolean', '`optimizeForSpeed` must be a boolean');
    this._optimizeForSpeed = optimizeForSpeed;
    this._isBrowser = isBrowser;
    this._serverSheet = undefined;
    this._tags = [];
    this._injected = false;
    this._rulesCount = 0;
    var node = this._isBrowser && document.querySelector('meta[property="csp-nonce"]');
    this._nonce = node ? node.getAttribute('content') : null;
  }

  var _proto = StyleSheet.prototype;

  _proto.setOptimizeForSpeed = function setOptimizeForSpeed(bool) {
    invariant(typeof bool === 'boolean', '`setOptimizeForSpeed` accepts a boolean');
    invariant(this._rulesCount === 0, 'optimizeForSpeed cannot be when rules have already been inserted');
    this.flush();
    this._optimizeForSpeed = bool;
    this.inject();
  };

  _proto.isOptimizeForSpeed = function isOptimizeForSpeed() {
    return this._optimizeForSpeed;
  };

  _proto.inject = function inject() {
    var _this = this;

    invariant(!this._injected, 'sheet already injected');
    this._injected = true;

    if (this._isBrowser && this._optimizeForSpeed) {
      this._tags[0] = this.makeStyleTag(this._name);
      this._optimizeForSpeed = 'insertRule' in this.getSheet();

      if (!this._optimizeForSpeed) {
        if (!isProd) {
          console.warn('StyleSheet: optimizeForSpeed mode not supported falling back to standard mode.');
        }

        this.flush();
        this._injected = true;
      }

      return;
    }

    this._serverSheet = {
      cssRules: [],
      insertRule: function insertRule(rule, index) {
        if (typeof index === 'number') {
          _this._serverSheet.cssRules[index] = {
            cssText: rule
          };
        } else {
          _this._serverSheet.cssRules.push({
            cssText: rule
          });
        }

        return index;
      },
      deleteRule: function deleteRule(index) {
        _this._serverSheet.cssRules[index] = null;
      }
    };
  };

  _proto.getSheetForTag = function getSheetForTag(tag) {
    if (tag.sheet) {
      return tag.sheet;
    } // this weirdness brought to you by firefox


    for (var i = 0; i < document.styleSheets.length; i++) {
      if (document.styleSheets[i].ownerNode === tag) {
        return document.styleSheets[i];
      }
    }
  };

  _proto.getSheet = function getSheet() {
    return this.getSheetForTag(this._tags[this._tags.length - 1]);
  };

  _proto.insertRule = function insertRule(rule, index) {
    invariant(isString(rule), '`insertRule` accepts only strings');

    if (!this._isBrowser) {
      if (typeof index !== 'number') {
        index = this._serverSheet.cssRules.length;
      }

      this._serverSheet.insertRule(rule, index);

      return this._rulesCount++;
    }

    if (this._optimizeForSpeed) {
      var sheet = this.getSheet();

      if (typeof index !== 'number') {
        index = sheet.cssRules.length;
      } // this weirdness for perf, and chrome's weird bug
      // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule


      try {
        sheet.insertRule(rule, index);
      } catch (error) {
        if (!isProd) {
          console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
        }

        return -1;
      }
    } else {
      var insertionPoint = this._tags[index];

      this._tags.push(this.makeStyleTag(this._name, rule, insertionPoint));
    }

    return this._rulesCount++;
  };

  _proto.replaceRule = function replaceRule(index, rule) {
    if (this._optimizeForSpeed || !this._isBrowser) {
      var sheet = this._isBrowser ? this.getSheet() : this._serverSheet;

      if (!rule.trim()) {
        rule = this._deletedRulePlaceholder;
      }

      if (!sheet.cssRules[index]) {
        // @TBD Should we throw an error?
        return index;
      }

      sheet.deleteRule(index);

      try {
        sheet.insertRule(rule, index);
      } catch (error) {
        if (!isProd) {
          console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
        } // In order to preserve the indices we insert a deleteRulePlaceholder


        sheet.insertRule(this._deletedRulePlaceholder, index);
      }
    } else {
      var tag = this._tags[index];
      invariant(tag, "old rule at index `" + index + "` not found");
      tag.textContent = rule;
    }

    return index;
  };

  _proto.deleteRule = function deleteRule(index) {
    if (!this._isBrowser) {
      this._serverSheet.deleteRule(index);

      return;
    }

    if (this._optimizeForSpeed) {
      this.replaceRule(index, '');
    } else {
      var tag = this._tags[index];
      invariant(tag, "rule at index `" + index + "` not found");
      tag.parentNode.removeChild(tag);
      this._tags[index] = null;
    }
  };

  _proto.flush = function flush() {
    this._injected = false;
    this._rulesCount = 0;

    if (this._isBrowser) {
      this._tags.forEach(function (tag) {
        return tag && tag.parentNode.removeChild(tag);
      });

      this._tags = [];
    } else {
      // simpler on server
      this._serverSheet.cssRules = [];
    }
  };

  _proto.cssRules = function cssRules() {
    var _this2 = this;

    if (!this._isBrowser) {
      return this._serverSheet.cssRules;
    }

    return this._tags.reduce(function (rules, tag) {
      if (tag) {
        rules = rules.concat(Array.prototype.map.call(_this2.getSheetForTag(tag).cssRules, function (rule) {
          return rule.cssText === _this2._deletedRulePlaceholder ? null : rule;
        }));
      } else {
        rules.push(null);
      }

      return rules;
    }, []);
  };

  _proto.makeStyleTag = function makeStyleTag(name, cssString, relativeToTag) {
    if (cssString) {
      invariant(isString(cssString), 'makeStyleTag accepts only strings as second parameter');
    }

    var tag = document.createElement('style');
    if (this._nonce) tag.setAttribute('nonce', this._nonce);
    tag.type = 'text/css';
    tag.setAttribute("data-" + name, '');

    if (cssString) {
      tag.appendChild(document.createTextNode(cssString));
    }

    var head = document.head || document.getElementsByTagName('head')[0];

    if (relativeToTag) {
      head.insertBefore(tag, relativeToTag);
    } else {
      head.appendChild(tag);
    }

    return tag;
  };

  _createClass(StyleSheet, [{
    key: "length",
    get: function get() {
      return this._rulesCount;
    }
  }]);

  return StyleSheet;
}();

exports["default"] = StyleSheet;

function invariant(condition, message) {
  if (!condition) {
    throw new Error("StyleSheet: " + message + ".");
  }
}

/***/ }),

/***/ 449:
/***/ (function(__unused_webpack_module, exports, __nccwpck_require__) {



exports.__esModule = true;
exports["default"] = JSXStyle;

var _react = _interopRequireDefault(__nccwpck_require__(522));

var _stylesheetRegistry = __nccwpck_require__(147);

var _hash = __nccwpck_require__(590);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Opt-into the new `useInsertionEffect` API in React 18, fallback to `useLayoutEffect`.
// https://github.com/reactwg/react-18/discussions/110
var useInsertionEffect = _react["default"].useInsertionEffect || _react["default"].useLayoutEffect;
var defaultRegistry = typeof window !== 'undefined' ? (0, _stylesheetRegistry.createStyleRegistry)() : undefined;

function JSXStyle(props) {
  var registry = defaultRegistry ? defaultRegistry : (0, _stylesheetRegistry.useStyleRegistry)(); // If `registry` does not exist, we do nothing here.

  if (!registry) {
    return null;
  }

  if (typeof window === 'undefined') {
    registry.add(props);
    return null;
  }

  useInsertionEffect(function () {
    registry.add(props);
    return function () {
      registry.remove(props);
    }; // props.children can be string[], will be striped since id is identical
  }, [props.id, String(props.dynamic)]);
  return null;
}

JSXStyle.dynamic = function (info) {
  return info.map(function (tagInfo) {
    var baseId = tagInfo[0];
    var props = tagInfo[1];
    return (0, _hash.computeId)(baseId, props);
  }).join(' ');
};

/***/ }),

/***/ 147:
/***/ (function(__unused_webpack_module, exports, __nccwpck_require__) {



exports.__esModule = true;
exports.createStyleRegistry = createStyleRegistry;
exports.StyleRegistry = StyleRegistry;
exports.useStyleRegistry = useStyleRegistry;
exports.StyleSheetContext = exports.StyleSheetRegistry = void 0;

var _react = _interopRequireWildcard(__nccwpck_require__(522));

var _stylesheet = _interopRequireDefault(__nccwpck_require__(503));

var _hash = __nccwpck_require__(590);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function mapRulesToStyle(cssRules, options) {
  if (options === void 0) {
    options = {};
  }

  return cssRules.map(function (args) {
    var id = args[0];
    var css = args[1];
    return _react["default"].createElement('style', {
      id: "__" + id,
      // Avoid warnings upon render with a key
      key: "__" + id,
      nonce: options.nonce ? options.nonce : undefined,
      dangerouslySetInnerHTML: {
        __html: css
      }
    });
  });
}

var StyleSheetRegistry = /*#__PURE__*/function () {
  function StyleSheetRegistry(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        _ref$styleSheet = _ref.styleSheet,
        styleSheet = _ref$styleSheet === void 0 ? null : _ref$styleSheet,
        _ref$optimizeForSpeed = _ref.optimizeForSpeed,
        optimizeForSpeed = _ref$optimizeForSpeed === void 0 ? false : _ref$optimizeForSpeed,
        _ref$isBrowser = _ref.isBrowser,
        isBrowser = _ref$isBrowser === void 0 ? typeof window !== 'undefined' : _ref$isBrowser;

    this._sheet = styleSheet || new _stylesheet["default"]({
      name: 'styled-jsx',
      optimizeForSpeed: optimizeForSpeed
    });

    this._sheet.inject();

    if (styleSheet && typeof optimizeForSpeed === 'boolean') {
      this._sheet.setOptimizeForSpeed(optimizeForSpeed);

      this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
    }

    this._isBrowser = isBrowser;
    this._fromServer = undefined;
    this._indices = {};
    this._instancesCounts = {};
  }

  var _proto = StyleSheetRegistry.prototype;

  _proto.add = function add(props) {
    var _this = this;

    if (undefined === this._optimizeForSpeed) {
      this._optimizeForSpeed = Array.isArray(props.children);

      this._sheet.setOptimizeForSpeed(this._optimizeForSpeed);

      this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
    }

    if (this._isBrowser && !this._fromServer) {
      this._fromServer = this.selectFromServer();
      this._instancesCounts = Object.keys(this._fromServer).reduce(function (acc, tagName) {
        acc[tagName] = 0;
        return acc;
      }, {});
    }

    var _this$getIdAndRules = this.getIdAndRules(props),
        styleId = _this$getIdAndRules.styleId,
        rules = _this$getIdAndRules.rules; // Deduping: just increase the instances count.


    if (styleId in this._instancesCounts) {
      this._instancesCounts[styleId] += 1;
      return;
    }

    var indices = rules.map(function (rule) {
      return _this._sheet.insertRule(rule);
    }) // Filter out invalid rules
    .filter(function (index) {
      return index !== -1;
    });
    this._indices[styleId] = indices;
    this._instancesCounts[styleId] = 1;
  };

  _proto.remove = function remove(props) {
    var _this2 = this;

    var _this$getIdAndRules2 = this.getIdAndRules(props),
        styleId = _this$getIdAndRules2.styleId;

    invariant(styleId in this._instancesCounts, "styleId: `" + styleId + "` not found");
    this._instancesCounts[styleId] -= 1;

    if (this._instancesCounts[styleId] < 1) {
      var tagFromServer = this._fromServer && this._fromServer[styleId];

      if (tagFromServer) {
        tagFromServer.parentNode.removeChild(tagFromServer);
        delete this._fromServer[styleId];
      } else {
        this._indices[styleId].forEach(function (index) {
          return _this2._sheet.deleteRule(index);
        });

        delete this._indices[styleId];
      }

      delete this._instancesCounts[styleId];
    }
  };

  _proto.update = function update(props, nextProps) {
    this.add(nextProps);
    this.remove(props);
  };

  _proto.flush = function flush() {
    this._sheet.flush();

    this._sheet.inject();

    this._fromServer = undefined;
    this._indices = {};
    this._instancesCounts = {};
  };

  _proto.cssRules = function cssRules() {
    var _this3 = this;

    var fromServer = this._fromServer ? Object.keys(this._fromServer).map(function (styleId) {
      return [styleId, _this3._fromServer[styleId]];
    }) : [];

    var cssRules = this._sheet.cssRules();

    return fromServer.concat(Object.keys(this._indices).map(function (styleId) {
      return [styleId, _this3._indices[styleId].map(function (index) {
        return cssRules[index].cssText;
      }).join(_this3._optimizeForSpeed ? '' : '\n')];
    }) // filter out empty rules
    .filter(function (rule) {
      return Boolean(rule[1]);
    }));
  };

  _proto.styles = function styles(options) {
    return mapRulesToStyle(this.cssRules(), options);
  };

  _proto.getIdAndRules = function getIdAndRules(props) {
    var css = props.children,
        dynamic = props.dynamic,
        id = props.id;

    if (dynamic) {
      var styleId = (0, _hash.computeId)(id, dynamic);
      return {
        styleId: styleId,
        rules: Array.isArray(css) ? css.map(function (rule) {
          return (0, _hash.computeSelector)(styleId, rule);
        }) : [(0, _hash.computeSelector)(styleId, css)]
      };
    }

    return {
      styleId: (0, _hash.computeId)(id),
      rules: Array.isArray(css) ? css : [css]
    };
  }
  /**
   * selectFromServer
   *
   * Collects style tags from the document with id __jsx-XXX
   */
  ;

  _proto.selectFromServer = function selectFromServer() {
    var elements = Array.prototype.slice.call(document.querySelectorAll('[id^="__jsx-"]'));
    return elements.reduce(function (acc, element) {
      var id = element.id.slice(2);
      acc[id] = element;
      return acc;
    }, {});
  };

  return StyleSheetRegistry;
}();

exports.StyleSheetRegistry = StyleSheetRegistry;

function invariant(condition, message) {
  if (!condition) {
    throw new Error("StyleSheetRegistry: " + message + ".");
  }
}

var StyleSheetContext = (0, _react.createContext)(null);
exports.StyleSheetContext = StyleSheetContext;

function createStyleRegistry() {
  return new StyleSheetRegistry();
}

function StyleRegistry(_ref2) {
  var configuredRegistry = _ref2.registry,
      children = _ref2.children;
  var rootRegistry = (0, _react.useContext)(StyleSheetContext);

  var _useState = (0, _react.useState)(function () {
    return rootRegistry || configuredRegistry || createStyleRegistry();
  }),
      registry = _useState[0];

  return _react["default"].createElement(StyleSheetContext.Provider, {
    value: registry
  }, children);
}

function useStyleRegistry() {
  return (0, _react.useContext)(StyleSheetContext);
}

/***/ }),

/***/ 522:
/***/ (function(module) {

module.exports = __webpack_require__(67294);

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __nccwpck_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		var threw = true;
/******/ 		try {
/******/ 			__webpack_modules__[moduleId](module, module.exports, __nccwpck_require__);
/******/ 			threw = false;
/******/ 		} finally {
/******/ 			if(threw) delete __webpack_module_cache__[moduleId];
/******/ 		}
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat */
/******/ 	
/******/ 	if (typeof __nccwpck_require__ !== 'undefined') __nccwpck_require__.ab = __dirname + "/";
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
!function() {
var exports = __webpack_exports__;


exports.__esModule = true;
exports.style = exports.useStyleRegistry = exports.createStyleRegistry = exports.StyleRegistry = void 0;

var _stylesheetRegistry = __nccwpck_require__(147);

exports.StyleRegistry = _stylesheetRegistry.StyleRegistry;
exports.createStyleRegistry = _stylesheetRegistry.createStyleRegistry;
exports.useStyleRegistry = _stylesheetRegistry.useStyleRegistry;

var _style = _interopRequireDefault(__nccwpck_require__(449));

exports.style = _style["default"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
}();
module.exports = __webpack_exports__;
/******/ })()
;

/***/ }),

/***/ 65988:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(84207).style


/***/ }),

/***/ 68217:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/** @license React vundefined
 * use-subscription.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(96086),g=__webpack_require__(67294);
exports.useSubscription=function(a){var c=a.getCurrentValue,d=a.subscribe,b=g.useState(function(){return{getCurrentValue:c,subscribe:d,value:c()}});a=b[0];var f=b[1];b=a.value;if(a.getCurrentValue!==c||a.subscribe!==d)b=c(),f({getCurrentValue:c,subscribe:d,value:b});g.useDebugValue(b);g.useEffect(function(){function b(){if(!a){var b=c();f(function(a){return a.getCurrentValue!==c||a.subscribe!==d||a.value===b?a:e({},a,{value:b})})}}var a=!1,h=d(b);b();return function(){a=!0;h()}},[c,d]);return b};


/***/ }),

/***/ 67161:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(68217);
} else {}


/***/ }),

/***/ 24654:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 64836:
/***/ (function(module) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 21525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var $ArrayPrototype = GetIntrinsic('%Array.prototype%');
var $RangeError = GetIntrinsic('%RangeError%');
var $SyntaxError = GetIntrinsic('%SyntaxError%');
var $TypeError = GetIntrinsic('%TypeError%');

var IsIntegralNumber = __webpack_require__(57312);

var MAX_ARRAY_LENGTH = Math.pow(2, 32) - 1;

var $setProto = GetIntrinsic('%Object.setPrototypeOf%', true) || (
	// eslint-disable-next-line no-proto, no-negated-condition
	[].__proto__ !== $ArrayPrototype
		? null
		: function (O, proto) {
			O.__proto__ = proto; // eslint-disable-line no-proto, no-param-reassign
			return O;
		}
);

// https://www.ecma-international.org/ecma-262/12.0/#sec-arraycreate

module.exports = function ArrayCreate(length) {
	if (!IsIntegralNumber(length) || length < 0) {
		throw new $TypeError('Assertion failed: `length` must be an integer Number >= 0');
	}
	if (length > MAX_ARRAY_LENGTH) {
		throw new $RangeError('length is greater than (2**32 - 1)');
	}
	var proto = arguments.length > 1 ? arguments[1] : $ArrayPrototype;
	var A = []; // steps 3, 5
	if (proto !== $ArrayPrototype) { // step 4
		if (!$setProto) {
			throw new $SyntaxError('ArrayCreate: a `proto` argument that is not `Array.prototype` is not supported in an environment that does not support setting the [[Prototype]]');
		}
		$setProto(A, proto);
	}
	if (length !== 0) { // bypasses the need for step 6
		A.length = length;
	}
	/* step 6, the above as a shortcut for the below
	OrdinaryDefineOwnProperty(A, 'length', {
		'[[Configurable]]': false,
		'[[Enumerable]]': false,
		'[[Value]]': length,
		'[[Writable]]': true
	});
	*/
	return A;
};


/***/ }),

/***/ 9572:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var $species = GetIntrinsic('%Symbol.species%', true);
var $TypeError = GetIntrinsic('%TypeError%');

var ArrayCreate = __webpack_require__(21525);
var Get = __webpack_require__(1391);
var IsArray = __webpack_require__(96975);
var IsConstructor = __webpack_require__(41974);
var IsIntegralNumber = __webpack_require__(57312);
var Type = __webpack_require__(53633);

// https://ecma-international.org/ecma-262/12.0/#sec-arrayspeciescreate

module.exports = function ArraySpeciesCreate(originalArray, length) {
	if (!IsIntegralNumber(length) || length < 0) {
		throw new $TypeError('Assertion failed: length must be an integer >= 0');
	}

	var isArray = IsArray(originalArray);
	if (!isArray) {
		return ArrayCreate(length);
	}

	var C = Get(originalArray, 'constructor');
	// TODO: figure out how to make a cross-realm normal Array, a same-realm Array
	// if (IsConstructor(C)) {
	// 	if C is another realm's Array, C = undefined
	// 	Object.getPrototypeOf(Object.getPrototypeOf(Object.getPrototypeOf(Array))) === null ?
	// }
	if ($species && Type(C) === 'Object') {
		C = Get(C, $species);
		if (C === null) {
			C = void 0;
		}
	}

	if (typeof C === 'undefined') {
		return ArrayCreate(length);
	}
	if (!IsConstructor(C)) {
		throw new $TypeError('C must be a constructor');
	}
	return new C(length); // Construct(C, length);
};



/***/ }),

/***/ 50581:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);
var callBound = __webpack_require__(21924);

var $TypeError = GetIntrinsic('%TypeError%');

var IsArray = __webpack_require__(96975);

var $apply = GetIntrinsic('%Reflect.apply%', true) || callBound('%Function.prototype.apply%');

// https://ecma-international.org/ecma-262/6.0/#sec-call

module.exports = function Call(F, V) {
	var argumentsList = arguments.length > 2 ? arguments[2] : [];
	if (!IsArray(argumentsList)) {
		throw new $TypeError('Assertion failed: optional `argumentsList`, if provided, must be a List');
	}
	return $apply(F, V, argumentsList);
};


/***/ }),

/***/ 14210:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var $TypeError = GetIntrinsic('%TypeError%');

var DefineOwnProperty = __webpack_require__(63682);

var FromPropertyDescriptor = __webpack_require__(18334);
var OrdinaryGetOwnProperty = __webpack_require__(80697);
var IsDataDescriptor = __webpack_require__(13746);
var IsExtensible = __webpack_require__(44914);
var IsPropertyKey = __webpack_require__(14305);
var SameValue = __webpack_require__(40484);
var Type = __webpack_require__(53633);

// https://ecma-international.org/ecma-262/6.0/#sec-createdataproperty

module.exports = function CreateDataProperty(O, P, V) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
	}
	var oldDesc = OrdinaryGetOwnProperty(O, P);
	var extensible = !oldDesc || IsExtensible(O);
	var nonConfigurable = oldDesc && !oldDesc['[[Configurable]]'];
	if (nonConfigurable || !extensible) {
		return false;
	}
	return DefineOwnProperty(
		IsDataDescriptor,
		SameValue,
		FromPropertyDescriptor,
		O,
		P,
		{
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Value]]': V,
			'[[Writable]]': true
		}
	);
};


/***/ }),

/***/ 91146:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var $TypeError = GetIntrinsic('%TypeError%');

var CreateDataProperty = __webpack_require__(14210);
var IsPropertyKey = __webpack_require__(14305);
var Type = __webpack_require__(53633);

// // https://ecma-international.org/ecma-262/6.0/#sec-createdatapropertyorthrow

module.exports = function CreateDataPropertyOrThrow(O, P, V) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
	}
	var success = CreateDataProperty(O, P, V);
	if (!success) {
		throw new $TypeError('unable to create data property');
	}
	return success;
};


/***/ }),

/***/ 43950:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var $TypeError = GetIntrinsic('%TypeError%');

var isPropertyDescriptor = __webpack_require__(2435);
var DefineOwnProperty = __webpack_require__(63682);

var FromPropertyDescriptor = __webpack_require__(18334);
var IsAccessorDescriptor = __webpack_require__(52435);
var IsDataDescriptor = __webpack_require__(13746);
var IsPropertyKey = __webpack_require__(14305);
var SameValue = __webpack_require__(40484);
var ToPropertyDescriptor = __webpack_require__(69916);
var Type = __webpack_require__(53633);

// https://ecma-international.org/ecma-262/6.0/#sec-definepropertyorthrow

module.exports = function DefinePropertyOrThrow(O, P, desc) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}

	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
	}

	var Desc = isPropertyDescriptor({
		Type: Type,
		IsDataDescriptor: IsDataDescriptor,
		IsAccessorDescriptor: IsAccessorDescriptor
	}, desc) ? desc : ToPropertyDescriptor(desc);
	if (!isPropertyDescriptor({
		Type: Type,
		IsDataDescriptor: IsDataDescriptor,
		IsAccessorDescriptor: IsAccessorDescriptor
	}, Desc)) {
		throw new $TypeError('Assertion failed: Desc is not a valid Property Descriptor');
	}

	return DefineOwnProperty(
		IsDataDescriptor,
		SameValue,
		FromPropertyDescriptor,
		O,
		P,
		Desc
	);
};


/***/ }),

/***/ 83069:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var $TypeError = GetIntrinsic('%TypeError%');

var MAX_SAFE_INTEGER = __webpack_require__(11645);

var Call = __webpack_require__(50581);
var CreateDataPropertyOrThrow = __webpack_require__(91146);
var Get = __webpack_require__(1391);
var HasProperty = __webpack_require__(44458);
var IsArray = __webpack_require__(96975);
var LengthOfArrayLike = __webpack_require__(96353);
var ToString = __webpack_require__(96846);

// https://262.ecma-international.org/11.0/#sec-flattenintoarray

// eslint-disable-next-line max-params
module.exports = function FlattenIntoArray(target, source, sourceLen, start, depth) {
	var mapperFunction;
	if (arguments.length > 5) {
		mapperFunction = arguments[5];
	}

	var targetIndex = start;
	var sourceIndex = 0;
	while (sourceIndex < sourceLen) {
		var P = ToString(sourceIndex);
		var exists = HasProperty(source, P);
		if (exists === true) {
			var element = Get(source, P);
			if (typeof mapperFunction !== 'undefined') {
				if (arguments.length <= 6) {
					throw new $TypeError('Assertion failed: thisArg is required when mapperFunction is provided');
				}
				element = Call(mapperFunction, arguments[6], [element, sourceIndex, source]);
			}
			var shouldFlatten = false;
			if (depth > 0) {
				shouldFlatten = IsArray(element);
			}
			if (shouldFlatten) {
				var elementLen = LengthOfArrayLike(element);
				targetIndex = FlattenIntoArray(target, element, elementLen, targetIndex, depth - 1);
			} else {
				if (targetIndex >= MAX_SAFE_INTEGER) {
					throw new $TypeError('index too large');
				}
				CreateDataPropertyOrThrow(target, ToString(targetIndex), element);
				targetIndex += 1;
			}
		}
		sourceIndex += 1;
	}

	return targetIndex;
};


/***/ }),

/***/ 18334:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var assertRecord = __webpack_require__(62188);
var fromPropertyDescriptor = __webpack_require__(17141);

var Type = __webpack_require__(53633);

// https://ecma-international.org/ecma-262/6.0/#sec-frompropertydescriptor

module.exports = function FromPropertyDescriptor(Desc) {
	if (typeof Desc !== 'undefined') {
		assertRecord(Type, 'Property Descriptor', 'Desc', Desc);
	}

	return fromPropertyDescriptor(Desc);
};


/***/ }),

/***/ 1391:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var $TypeError = GetIntrinsic('%TypeError%');

var inspect = __webpack_require__(70631);

var IsPropertyKey = __webpack_require__(14305);
var Type = __webpack_require__(53633);

// https://ecma-international.org/ecma-262/6.0/#sec-get-o-p

module.exports = function Get(O, P) {
	// 7.3.1.1
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}
	// 7.3.1.2
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true, got ' + inspect(P));
	}
	// 7.3.1.3
	return O[P];
};


/***/ }),

/***/ 44458:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var $TypeError = GetIntrinsic('%TypeError%');

var IsPropertyKey = __webpack_require__(14305);
var Type = __webpack_require__(53633);

// https://ecma-international.org/ecma-262/6.0/#sec-hasproperty

module.exports = function HasProperty(O, P) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: `O` must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: `P` must be a Property Key');
	}
	return P in O;
};


/***/ }),

/***/ 52435:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(17642);

var assertRecord = __webpack_require__(62188);

var Type = __webpack_require__(53633);

// https://ecma-international.org/ecma-262/6.0/#sec-isaccessordescriptor

module.exports = function IsAccessorDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return false;
	}

	assertRecord(Type, 'Property Descriptor', 'Desc', Desc);

	if (!has(Desc, '[[Get]]') && !has(Desc, '[[Set]]')) {
		return false;
	}

	return true;
};


/***/ }),

/***/ 96975:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


// https://ecma-international.org/ecma-262/6.0/#sec-isarray
module.exports = __webpack_require__(675);


/***/ }),

/***/ 61787:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


// http://262.ecma-international.org/5.1/#sec-9.11

module.exports = __webpack_require__(95320);


/***/ }),

/***/ 41974:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(14445);

var $construct = GetIntrinsic('%Reflect.construct%', true);

var DefinePropertyOrThrow = __webpack_require__(43950);
try {
	DefinePropertyOrThrow({}, '', { '[[Get]]': function () {} });
} catch (e) {
	// Accessor properties aren't supported
	DefinePropertyOrThrow = null;
}

// https://ecma-international.org/ecma-262/6.0/#sec-isconstructor

if (DefinePropertyOrThrow && $construct) {
	var isConstructorMarker = {};
	var badArrayLike = {};
	DefinePropertyOrThrow(badArrayLike, 'length', {
		'[[Get]]': function () {
			throw isConstructorMarker;
		},
		'[[Enumerable]]': true
	});

	module.exports = function IsConstructor(argument) {
		try {
			// `Reflect.construct` invokes `IsConstructor(target)` before `Get(args, 'length')`:
			$construct(argument, badArrayLike);
		} catch (err) {
			return err === isConstructorMarker;
		}
	};
} else {
	module.exports = function IsConstructor(argument) {
		// unfortunately there's no way to truly check this without try/catch `new argument` in old environments
		return typeof argument === 'function' && !!argument.prototype;
	};
}


/***/ }),

/***/ 13746:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(17642);

var assertRecord = __webpack_require__(62188);

var Type = __webpack_require__(53633);

// https://ecma-international.org/ecma-262/6.0/#sec-isdatadescriptor

module.exports = function IsDataDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return false;
	}

	assertRecord(Type, 'Property Descriptor', 'Desc', Desc);

	if (!has(Desc, '[[Value]]') && !has(Desc, '[[Writable]]')) {
		return false;
	}

	return true;
};


/***/ }),

/***/ 44914:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var $preventExtensions = GetIntrinsic('%Object.preventExtensions%', true);
var $isExtensible = GetIntrinsic('%Object.isExtensible%', true);

var isPrimitive = __webpack_require__(64790);

// https://ecma-international.org/ecma-262/6.0/#sec-isextensible-o

module.exports = $preventExtensions
	? function IsExtensible(obj) {
		return !isPrimitive(obj) && $isExtensible(obj);
	}
	: function IsExtensible(obj) {
		return !isPrimitive(obj);
	};


/***/ }),

/***/ 57312:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var abs = __webpack_require__(54908);
var floor = __webpack_require__(375);
var Type = __webpack_require__(53633);

var $isNaN = __webpack_require__(29086);
var $isFinite = __webpack_require__(22633);

// https://tc39.es/ecma262/#sec-isintegralnumber

module.exports = function IsIntegralNumber(argument) {
	if (Type(argument) !== 'Number' || $isNaN(argument) || !$isFinite(argument)) {
		return false;
	}
	var absValue = abs(argument);
	return floor(absValue) === absValue;
};


/***/ }),

/***/ 14305:
/***/ (function(module) {

"use strict";


// https://ecma-international.org/ecma-262/6.0/#sec-ispropertykey

module.exports = function IsPropertyKey(argument) {
	return typeof argument === 'string' || typeof argument === 'symbol';
};


/***/ }),

/***/ 10840:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var $match = GetIntrinsic('%Symbol.match%', true);

var hasRegExpMatcher = __webpack_require__(98420);

var ToBoolean = __webpack_require__(39731);

// https://ecma-international.org/ecma-262/6.0/#sec-isregexp

module.exports = function IsRegExp(argument) {
	if (!argument || typeof argument !== 'object') {
		return false;
	}
	if ($match) {
		var isRegExp = argument[$match];
		if (typeof isRegExp !== 'undefined') {
			return ToBoolean(isRegExp);
		}
	}
	return hasRegExpMatcher(argument);
};


/***/ }),

/***/ 96353:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var $TypeError = GetIntrinsic('%TypeError%');

var Get = __webpack_require__(1391);
var ToLength = __webpack_require__(88305);
var Type = __webpack_require__(53633);

// https://262.ecma-international.org/11.0/#sec-lengthofarraylike

module.exports = function LengthOfArrayLike(obj) {
	if (Type(obj) !== 'Object') {
		throw new $TypeError('Assertion failed: `obj` must be an Object');
	}
	return ToLength(Get(obj, 'length'));
};

// TODO: use this all over


/***/ }),

/***/ 80697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var $gOPD = __webpack_require__(20882);
var $TypeError = GetIntrinsic('%TypeError%');

var callBound = __webpack_require__(21924);

var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');

var has = __webpack_require__(17642);

var IsArray = __webpack_require__(96975);
var IsPropertyKey = __webpack_require__(14305);
var IsRegExp = __webpack_require__(10840);
var ToPropertyDescriptor = __webpack_require__(69916);
var Type = __webpack_require__(53633);

// https://ecma-international.org/ecma-262/6.0/#sec-ordinarygetownproperty

module.exports = function OrdinaryGetOwnProperty(O, P) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: O must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: P must be a Property Key');
	}
	if (!has(O, P)) {
		return void 0;
	}
	if (!$gOPD) {
		// ES3 / IE 8 fallback
		var arrayLength = IsArray(O) && P === 'length';
		var regexLastIndex = IsRegExp(O) && P === 'lastIndex';
		return {
			'[[Configurable]]': !(arrayLength || regexLastIndex),
			'[[Enumerable]]': $isEnumerable(O, P),
			'[[Value]]': O[P],
			'[[Writable]]': true
		};
	}
	return ToPropertyDescriptor($gOPD(O, P));
};


/***/ }),

/***/ 39619:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(4559);


/***/ }),

/***/ 40484:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__(29086);

// http://262.ecma-international.org/5.1/#sec-9.12

module.exports = function SameValue(x, y) {
	if (x === y) { // 0 === -0, but they are not identical.
		if (x === 0) { return 1 / x === 1 / y; }
		return true;
	}
	return $isNaN(x) && $isNaN(y);
};


/***/ }),

/***/ 39731:
/***/ (function(module) {

"use strict";


// http://262.ecma-international.org/5.1/#sec-9.2

module.exports = function ToBoolean(value) { return !!value; };


/***/ }),

/***/ 751:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var abs = __webpack_require__(54908);
var floor = __webpack_require__(375);
var ToNumber = __webpack_require__(55631);

var $isNaN = __webpack_require__(29086);
var $isFinite = __webpack_require__(22633);
var $sign = __webpack_require__(38111);

// https://262.ecma-international.org/12.0/#sec-tointegerorinfinity

module.exports = function ToIntegerOrInfinity(value) {
	var number = ToNumber(value);
	if ($isNaN(number) || number === 0) { return 0; }
	if (!$isFinite(number)) { return number; }
	return $sign(number) * floor(abs(number));
};


/***/ }),

/***/ 88305:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var MAX_SAFE_INTEGER = __webpack_require__(11645);

var ToIntegerOrInfinity = __webpack_require__(751);

module.exports = function ToLength(argument) {
	var len = ToIntegerOrInfinity(argument);
	if (len <= 0) { return 0; } // includes converting -0 to +0
	if (len > MAX_SAFE_INTEGER) { return MAX_SAFE_INTEGER; }
	return len;
};


/***/ }),

/***/ 55631:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var $TypeError = GetIntrinsic('%TypeError%');
var $Number = GetIntrinsic('%Number%');
var $RegExp = GetIntrinsic('%RegExp%');
var $parseInteger = GetIntrinsic('%parseInt%');

var callBound = __webpack_require__(21924);
var regexTester = __webpack_require__(50823);
var isPrimitive = __webpack_require__(64790);

var $strSlice = callBound('String.prototype.slice');
var isBinary = regexTester(/^0b[01]+$/i);
var isOctal = regexTester(/^0o[0-7]+$/i);
var isInvalidHexLiteral = regexTester(/^[-+]0x[0-9a-f]+$/i);
var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
var nonWSregex = new $RegExp('[' + nonWS + ']', 'g');
var hasNonWS = regexTester(nonWSregex);

// whitespace from: https://es5.github.io/#x15.5.4.20
// implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
var ws = [
	'\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
	'\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
	'\u2029\uFEFF'
].join('');
var trimRegex = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
var $replace = callBound('String.prototype.replace');
var $trim = function (value) {
	return $replace(value, trimRegex, '');
};

var ToPrimitive = __webpack_require__(54607);

// https://ecma-international.org/ecma-262/6.0/#sec-tonumber

module.exports = function ToNumber(argument) {
	var value = isPrimitive(argument) ? argument : ToPrimitive(argument, $Number);
	if (typeof value === 'symbol') {
		throw new $TypeError('Cannot convert a Symbol value to a number');
	}
	if (typeof value === 'bigint') {
		throw new $TypeError('Conversion from \'BigInt\' to \'number\' is not allowed.');
	}
	if (typeof value === 'string') {
		if (isBinary(value)) {
			return ToNumber($parseInteger($strSlice(value, 2), 2));
		} else if (isOctal(value)) {
			return ToNumber($parseInteger($strSlice(value, 2), 8));
		} else if (hasNonWS(value) || isInvalidHexLiteral(value)) {
			return NaN;
		}
		var trimmed = $trim(value);
		if (trimmed !== value) {
			return ToNumber(trimmed);
		}

	}
	return $Number(value);
};


/***/ }),

/***/ 30821:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var $Object = GetIntrinsic('%Object%');

var RequireObjectCoercible = __webpack_require__(39619);

// https://ecma-international.org/ecma-262/6.0/#sec-toobject

module.exports = function ToObject(value) {
	RequireObjectCoercible(value);
	return $Object(value);
};


/***/ }),

/***/ 54607:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var toPrimitive = __webpack_require__(41503);

// https://ecma-international.org/ecma-262/6.0/#sec-toprimitive

module.exports = function ToPrimitive(input) {
	if (arguments.length > 1) {
		return toPrimitive(input, arguments[1]);
	}
	return toPrimitive(input);
};


/***/ }),

/***/ 69916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(17642);

var GetIntrinsic = __webpack_require__(40210);

var $TypeError = GetIntrinsic('%TypeError%');

var Type = __webpack_require__(53633);
var ToBoolean = __webpack_require__(39731);
var IsCallable = __webpack_require__(61787);

// https://262.ecma-international.org/5.1/#sec-8.10.5

module.exports = function ToPropertyDescriptor(Obj) {
	if (Type(Obj) !== 'Object') {
		throw new $TypeError('ToPropertyDescriptor requires an object');
	}

	var desc = {};
	if (has(Obj, 'enumerable')) {
		desc['[[Enumerable]]'] = ToBoolean(Obj.enumerable);
	}
	if (has(Obj, 'configurable')) {
		desc['[[Configurable]]'] = ToBoolean(Obj.configurable);
	}
	if (has(Obj, 'value')) {
		desc['[[Value]]'] = Obj.value;
	}
	if (has(Obj, 'writable')) {
		desc['[[Writable]]'] = ToBoolean(Obj.writable);
	}
	if (has(Obj, 'get')) {
		var getter = Obj.get;
		if (typeof getter !== 'undefined' && !IsCallable(getter)) {
			throw new $TypeError('getter must be a function');
		}
		desc['[[Get]]'] = getter;
	}
	if (has(Obj, 'set')) {
		var setter = Obj.set;
		if (typeof setter !== 'undefined' && !IsCallable(setter)) {
			throw new $TypeError('setter must be a function');
		}
		desc['[[Set]]'] = setter;
	}

	if ((has(desc, '[[Get]]') || has(desc, '[[Set]]')) && (has(desc, '[[Value]]') || has(desc, '[[Writable]]'))) {
		throw new $TypeError('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
	}
	return desc;
};


/***/ }),

/***/ 96846:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var $String = GetIntrinsic('%String%');
var $TypeError = GetIntrinsic('%TypeError%');

// https://ecma-international.org/ecma-262/6.0/#sec-tostring

module.exports = function ToString(argument) {
	if (typeof argument === 'symbol') {
		throw new $TypeError('Cannot convert a Symbol value to a string');
	}
	return $String(argument);
};


/***/ }),

/***/ 53633:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var ES5Type = __webpack_require__(23951);

// https://262.ecma-international.org/11.0/#sec-ecmascript-data-types-and-values

module.exports = function Type(x) {
	if (typeof x === 'symbol') {
		return 'Symbol';
	}
	if (typeof x === 'bigint') {
		return 'BigInt';
	}
	return ES5Type(x);
};


/***/ }),

/***/ 54908:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var $abs = GetIntrinsic('%Math.abs%');

// http://262.ecma-international.org/5.1/#sec-5.2

module.exports = function abs(x) {
	return $abs(x);
};


/***/ }),

/***/ 375:
/***/ (function(module) {

"use strict";


// var modulo = require('./modulo');
var $floor = Math.floor;

// http://262.ecma-international.org/5.1/#sec-5.2

module.exports = function floor(x) {
	// return x - modulo(x, 1);
	return $floor(x);
};


/***/ }),

/***/ 4559:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var $TypeError = GetIntrinsic('%TypeError%');

// http://262.ecma-international.org/5.1/#sec-9.10

module.exports = function CheckObjectCoercible(value, optMessage) {
	if (value == null) {
		throw new $TypeError(optMessage || ('Cannot call method on ' + value));
	}
	return value;
};


/***/ }),

/***/ 23951:
/***/ (function(module) {

"use strict";


// https://262.ecma-international.org/5.1/#sec-8

module.exports = function Type(x) {
	if (x === null) {
		return 'Null';
	}
	if (typeof x === 'undefined') {
		return 'Undefined';
	}
	if (typeof x === 'function' || typeof x === 'object') {
		return 'Object';
	}
	if (typeof x === 'number') {
		return 'Number';
	}
	if (typeof x === 'boolean') {
		return 'Boolean';
	}
	if (typeof x === 'string') {
		return 'String';
	}
};


/***/ }),

/***/ 14445:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


// TODO: remove, semver-major

module.exports = __webpack_require__(40210);


/***/ }),

/***/ 63682:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasPropertyDescriptors = __webpack_require__(31044);

var GetIntrinsic = __webpack_require__(40210);

var $defineProperty = hasPropertyDescriptors() && GetIntrinsic('%Object.defineProperty%', true);

var hasArrayLengthDefineBug = hasPropertyDescriptors.hasArrayLengthDefineBug();

// eslint-disable-next-line global-require
var isArray = hasArrayLengthDefineBug && __webpack_require__(675);

var callBound = __webpack_require__(21924);

var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');

// eslint-disable-next-line max-params
module.exports = function DefineOwnProperty(IsDataDescriptor, SameValue, FromPropertyDescriptor, O, P, desc) {
	if (!$defineProperty) {
		if (!IsDataDescriptor(desc)) {
			// ES3 does not support getters/setters
			return false;
		}
		if (!desc['[[Configurable]]'] || !desc['[[Writable]]']) {
			return false;
		}

		// fallback for ES3
		if (P in O && $isEnumerable(O, P) !== !!desc['[[Enumerable]]']) {
			// a non-enumerable existing property
			return false;
		}

		// property does not exist at all, or exists but is enumerable
		var V = desc['[[Value]]'];
		// eslint-disable-next-line no-param-reassign
		O[P] = V; // will use [[Define]]
		return SameValue(O[P], V);
	}
	if (
		hasArrayLengthDefineBug
		&& P === 'length'
		&& '[[Value]]' in desc
		&& isArray(O)
		&& O.length !== desc['[[Value]]']
	) {
		// eslint-disable-next-line no-param-reassign
		O.length = desc['[[Value]]'];
		return O.length === desc['[[Value]]'];
	}

	$defineProperty(O, P, FromPropertyDescriptor(desc));
	return true;
};


/***/ }),

/***/ 675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var $Array = GetIntrinsic('%Array%');

// eslint-disable-next-line global-require
var toStr = !$Array.isArray && __webpack_require__(21924)('Object.prototype.toString');

module.exports = $Array.isArray || function IsArray(argument) {
	return toStr(argument) === '[object Array]';
};


/***/ }),

/***/ 62188:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var $TypeError = GetIntrinsic('%TypeError%');
var $SyntaxError = GetIntrinsic('%SyntaxError%');

var has = __webpack_require__(17642);

var isMatchRecord = __webpack_require__(64377);

var predicates = {
	// https://262.ecma-international.org/6.0/#sec-property-descriptor-specification-type
	'Property Descriptor': function isPropertyDescriptor(Desc) {
		var allowed = {
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Get]]': true,
			'[[Set]]': true,
			'[[Value]]': true,
			'[[Writable]]': true
		};

		for (var key in Desc) { // eslint-disable-line
			if (has(Desc, key) && !allowed[key]) {
				return false;
			}
		}

		var isData = has(Desc, '[[Value]]');
		var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
		if (isData && IsAccessor) {
			throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
		}
		return true;
	},
	// https://262.ecma-international.org/13.0/#sec-match-records
	'Match Record': isMatchRecord
};

module.exports = function assertRecord(Type, recordType, argumentName, value) {
	var predicate = predicates[recordType];
	if (typeof predicate !== 'function') {
		throw new $SyntaxError('unknown record type: ' + recordType);
	}
	if (Type(value) !== 'Object' || !predicate(value)) {
		throw new $TypeError(argumentName + ' must be a ' + recordType);
	}
};


/***/ }),

/***/ 17141:
/***/ (function(module) {

"use strict";


module.exports = function fromPropertyDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return Desc;
	}
	var obj = {};
	if ('[[Value]]' in Desc) {
		obj.value = Desc['[[Value]]'];
	}
	if ('[[Writable]]' in Desc) {
		obj.writable = !!Desc['[[Writable]]'];
	}
	if ('[[Get]]' in Desc) {
		obj.get = Desc['[[Get]]'];
	}
	if ('[[Set]]' in Desc) {
		obj.set = Desc['[[Set]]'];
	}
	if ('[[Enumerable]]' in Desc) {
		obj.enumerable = !!Desc['[[Enumerable]]'];
	}
	if ('[[Configurable]]' in Desc) {
		obj.configurable = !!Desc['[[Configurable]]'];
	}
	return obj;
};


/***/ }),

/***/ 20882:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),

/***/ 22633:
/***/ (function(module) {

"use strict";


var $isNaN = Number.isNaN || function (a) { return a !== a; };

module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };


/***/ }),

/***/ 64377:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(17642);

// https://262.ecma-international.org/13.0/#sec-match-records

module.exports = function isMatchRecord(record) {
	return (
		has(record, '[[StartIndex]]')
        && has(record, '[[EndIndex]]')
        && record['[[StartIndex]]'] >= 0
        && record['[[EndIndex]]'] >= record['[[StartIndex]]']
        && String(parseInt(record['[[StartIndex]]'], 10)) === String(record['[[StartIndex]]'])
        && String(parseInt(record['[[EndIndex]]'], 10)) === String(record['[[EndIndex]]'])
	);
};


/***/ }),

/***/ 29086:
/***/ (function(module) {

"use strict";


module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),

/***/ 64790:
/***/ (function(module) {

"use strict";


module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};


/***/ }),

/***/ 2435:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var has = __webpack_require__(17642);
var $TypeError = GetIntrinsic('%TypeError%');

module.exports = function IsPropertyDescriptor(ES, Desc) {
	if (ES.Type(Desc) !== 'Object') {
		return false;
	}
	var allowed = {
		'[[Configurable]]': true,
		'[[Enumerable]]': true,
		'[[Get]]': true,
		'[[Set]]': true,
		'[[Value]]': true,
		'[[Writable]]': true
	};

	for (var key in Desc) { // eslint-disable-line no-restricted-syntax
		if (has(Desc, key) && !allowed[key]) {
			return false;
		}
	}

	if (ES.IsDataDescriptor(Desc) && ES.IsAccessorDescriptor(Desc)) {
		throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
	}
	return true;
};


/***/ }),

/***/ 11645:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var $Math = GetIntrinsic('%Math%');
var $Number = GetIntrinsic('%Number%');

module.exports = $Number.MAX_SAFE_INTEGER || $Math.pow(2, 53) - 1;


/***/ }),

/***/ 50823:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(21924);

var $exec = callBound('RegExp.prototype.exec');

module.exports = function regexTester(regex) {
	return function test(s) { return $exec(regex, s) !== null; };
};


/***/ }),

/***/ 38111:
/***/ (function(module) {

"use strict";


module.exports = function sign(number) {
	return number >= 0 ? 1 : -1;
};


/***/ }),

/***/ 30907:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ 83878:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),

/***/ 97326:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ 15671:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 43144:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ 4942:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ 87462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 61120:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ 32531:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _inherits; }
});

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

/***/ }),

/***/ 59199:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

/***/ }),

/***/ 25267:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),

/***/ 91:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 82963:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71002);
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97326);


function _possibleConstructorReturn(self, call) {
  if (call && ((0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(self);
}

/***/ }),

/***/ 97685:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(83878);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(25267);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return (0,arrayWithHoles/* default */.Z)(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || (0,nonIterableRest/* default */.Z)();
}

/***/ }),

/***/ 71002:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),

/***/ 40181:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30907);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ }),

/***/ 6512:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ ke; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_match_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32984);
/* harmony import */ var _utils_render_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12351);
/* harmony import */ var _hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23784);
/* harmony import */ var _hooks_use_id_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19946);
/* harmony import */ var _keyboard_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61363);
/* harmony import */ var _utils_bugs_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64103);
/* harmony import */ var _internal_open_closed_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16567);
/* harmony import */ var _hooks_use_resolve_button_type_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14157);
/* harmony import */ var _utils_owner_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15466);
/* harmony import */ var _hooks_use_event_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73781);
var Q=(o=>(o[o.Open=0]="Open",o[o.Closed=1]="Closed",o))(Q||{}),V=(l=>(l[l.ToggleDisclosure=0]="ToggleDisclosure",l[l.CloseDisclosure=1]="CloseDisclosure",l[l.SetButtonId=2]="SetButtonId",l[l.SetPanelId=3]="SetPanelId",l[l.LinkPanel=4]="LinkPanel",l[l.UnlinkPanel=5]="UnlinkPanel",l))(V||{});let X={[0]:e=>({...e,disclosureState:(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(e.disclosureState,{[0]:1,[1]:0})}),[1]:e=>e.disclosureState===1?e:{...e,disclosureState:1},[4](e){return e.linkedPanel===!0?e:{...e,linkedPanel:!0}},[5](e){return e.linkedPanel===!1?e:{...e,linkedPanel:!1}},[2](e,t){return e.buttonId===t.buttonId?e:{...e,buttonId:t.buttonId}},[3](e,t){return e.panelId===t.panelId?e:{...e,panelId:t.panelId}}},h=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);h.displayName="DisclosureContext";function H(e){let t=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(h);if(t===null){let o=new Error(`<${e} /> is missing a parent <Disclosure /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(o,H),o}return t}let U=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);U.displayName="DisclosureAPIContext";function K(e){let t=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(U);if(t===null){let o=new Error(`<${e} /> is missing a parent <Disclosure /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(o,K),o}return t}let w=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);w.displayName="DisclosurePanelContext";function Y(){return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(w)}function Z(e,t){return (0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(t.type,X,e,t)}let ee=react__WEBPACK_IMPORTED_MODULE_0__.Fragment,te=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .forwardRefWithAs */ .yV)(function(t,o){let{defaultOpen:n=!1,...s}=t,i=`headlessui-disclosure-button-${(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_3__/* .useId */ .M)()}`,l=`headlessui-disclosure-panel-${(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_3__/* .useId */ .M)()}`,u=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),D=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__/* .useSyncRefs */ .T)(o,(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__/* .optionalRef */ .h)(f=>{u.current=f},t.as===void 0||t.as===react__WEBPACK_IMPORTED_MODULE_0__.Fragment)),P=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),m=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),p=(0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(Z,{disclosureState:n?0:1,linkedPanel:!1,buttonRef:m,panelRef:P,buttonId:i,panelId:l}),[{disclosureState:a},c]=p;(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>c({type:2,buttonId:i}),[i,c]),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>c({type:3,panelId:l}),[l,c]);let T=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_5__/* .useEvent */ .z)(f=>{c({type:1});let A=(0,_utils_owner_js__WEBPACK_IMPORTED_MODULE_6__/* .getOwnerDocument */ .r)(u);if(!A)return;let I=(()=>f?f instanceof HTMLElement?f:f.current instanceof HTMLElement?f.current:A.getElementById(i):A.getElementById(i))();I==null||I.focus()}),C=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({close:T}),[T]),r=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:a===0,close:T}),[a,T]),d={ref:D};return react__WEBPACK_IMPORTED_MODULE_0__.createElement(h.Provider,{value:p},react__WEBPACK_IMPORTED_MODULE_0__.createElement(U.Provider,{value:C},react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_7__/* .OpenClosedProvider */ .up,{value:(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(a,{[0]:_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_7__/* .State.Open */ .ZM.Open,[1]:_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_7__/* .State.Closed */ .ZM.Closed})},(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .render */ .sY)({ourProps:d,theirProps:s,slot:r,defaultTag:ee,name:"Disclosure"}))))}),ne="button",le=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .forwardRefWithAs */ .yV)(function(t,o){let[n,s]=H("Disclosure.Button"),i=Y(),l=i===null?!1:i===n.panelId,u=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),D=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__/* .useSyncRefs */ .T)(u,o,l?null:n.buttonRef),P=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_5__/* .useEvent */ .z)(r=>{var d;if(l){if(n.disclosureState===1)return;switch(r.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_8__/* .Keys.Space */ .R.Space:case _keyboard_js__WEBPACK_IMPORTED_MODULE_8__/* .Keys.Enter */ .R.Enter:r.preventDefault(),r.stopPropagation(),s({type:0}),(d=n.buttonRef.current)==null||d.focus();break}}else switch(r.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_8__/* .Keys.Space */ .R.Space:case _keyboard_js__WEBPACK_IMPORTED_MODULE_8__/* .Keys.Enter */ .R.Enter:r.preventDefault(),r.stopPropagation(),s({type:0});break}}),m=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_5__/* .useEvent */ .z)(r=>{switch(r.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_8__/* .Keys.Space */ .R.Space:r.preventDefault();break}}),p=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_5__/* .useEvent */ .z)(r=>{var d;(0,_utils_bugs_js__WEBPACK_IMPORTED_MODULE_9__/* .isDisabledReactIssue7711 */ .P)(r.currentTarget)||t.disabled||(l?(s({type:0}),(d=n.buttonRef.current)==null||d.focus()):s({type:0}))}),a=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:n.disclosureState===0}),[n]),c=(0,_hooks_use_resolve_button_type_js__WEBPACK_IMPORTED_MODULE_10__/* .useResolveButtonType */ .f)(t,u),T=t,C=l?{ref:D,type:c,onKeyDown:P,onClick:p}:{ref:D,id:n.buttonId,type:c,"aria-expanded":t.disabled?void 0:n.disclosureState===0,"aria-controls":n.linkedPanel?n.panelId:void 0,onKeyDown:P,onKeyUp:m,onClick:p};return (0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .render */ .sY)({ourProps:C,theirProps:T,slot:a,defaultTag:ne,name:"Disclosure.Button"})}),oe="div",re=_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .Features.RenderStrategy */ .AN.RenderStrategy|_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .Features.Static */ .AN.Static,se=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .forwardRefWithAs */ .yV)(function(t,o){let[n,s]=H("Disclosure.Panel"),{close:i}=K("Disclosure.Panel"),l=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__/* .useSyncRefs */ .T)(o,n.panelRef,()=>{n.linkedPanel||s({type:4})}),u=(0,_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_7__/* .useOpenClosed */ .oJ)(),D=(()=>u!==null?u===_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_7__/* .State.Open */ .ZM.Open:n.disclosureState===0)();(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>()=>s({type:5}),[s]),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{var a;n.disclosureState===1&&((a=t.unmount)!=null?a:!0)&&s({type:5})},[n.disclosureState,t.unmount,s]);let P=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:n.disclosureState===0,close:i}),[n,i]),m=t,p={ref:l,id:n.panelId};return react__WEBPACK_IMPORTED_MODULE_0__.createElement(w.Provider,{value:n.panelId},(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .render */ .sY)({ourProps:p,theirProps:m,slot:P,defaultTag:oe,features:re,visible:D,name:"Disclosure.Panel"}))}),ke=Object.assign(te,{Button:le,Panel:se});


/***/ }),

/***/ 61363:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ o; }
/* harmony export */ });
var o=(r=>(r.Space=" ",r.Enter="Enter",r.Escape="Escape",r.Backspace="Backspace",r.Delete="Delete",r.ArrowLeft="ArrowLeft",r.ArrowUp="ArrowUp",r.ArrowRight="ArrowRight",r.ArrowDown="ArrowDown",r.Home="Home",r.End="End",r.PageUp="PageUp",r.PageDown="PageDown",r.Tab="Tab",r))(o||{});


/***/ }),

/***/ 86215:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ Tt; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_match_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32984);
/* harmony import */ var _utils_render_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12351);
/* harmony import */ var _hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23784);
/* harmony import */ var _hooks_use_id_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19946);
/* harmony import */ var _keyboard_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(61363);
/* harmony import */ var _utils_bugs_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(64103);
/* harmony import */ var _utils_focus_management_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(84575);
/* harmony import */ var _internal_open_closed_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16567);
/* harmony import */ var _hooks_use_resolve_button_type_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14157);
/* harmony import */ var _hooks_use_outside_click_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(90292);
/* harmony import */ var _utils_owner_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(15466);
/* harmony import */ var _hooks_use_owner_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51074);
/* harmony import */ var _hooks_use_event_listener_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14007);
/* harmony import */ var _internal_hidden_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(46045);
/* harmony import */ var _hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73781);
/* harmony import */ var _hooks_use_tab_direction_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(45662);
var Ae=(c=>(c[c.Open=0]="Open",c[c.Closed=1]="Closed",c))(Ae||{}),Ce=(n=>(n[n.TogglePopover=0]="TogglePopover",n[n.ClosePopover=1]="ClosePopover",n[n.SetButton=2]="SetButton",n[n.SetButtonId=3]="SetButtonId",n[n.SetPanel=4]="SetPanel",n[n.SetPanelId=5]="SetPanelId",n))(Ce||{});let Re={[0]:r=>({...r,popoverState:(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(r.popoverState,{[0]:1,[1]:0})}),[1](r){return r.popoverState===1?r:{...r,popoverState:1}},[2](r,t){return r.button===t.button?r:{...r,button:t.button}},[3](r,t){return r.buttonId===t.buttonId?r:{...r,buttonId:t.buttonId}},[4](r,t){return r.panel===t.panel?r:{...r,panel:t.panel}},[5](r,t){return r.panelId===t.panelId?r:{...r,panelId:t.panelId}}},ee=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);ee.displayName="PopoverContext";function J(r){let t=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ee);if(t===null){let c=new Error(`<${r} /> is missing a parent <Popover /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(c,J),c}return t}let te=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);te.displayName="PopoverAPIContext";function oe(r){let t=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(te);if(t===null){let c=new Error(`<${r} /> is missing a parent <Popover /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(c,oe),c}return t}let re=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);re.displayName="PopoverGroupContext";function ce(){return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(re)}let ne=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);ne.displayName="PopoverPanelContext";function Oe(){return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ne)}function Le(r,t){return (0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(t.type,Re,r,t)}let Fe="div",Ie=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .forwardRefWithAs */ .yV)(function(t,c){var R;let o=`headlessui-popover-button-${(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_3__/* .useId */ .M)()}`,d=`headlessui-popover-panel-${(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_3__/* .useId */ .M)()}`,a=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),n=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__/* .useSyncRefs */ .T)(c,(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__/* .optionalRef */ .h)(e=>{a.current=e})),g=(0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(Le,{popoverState:1,button:null,buttonId:o,panel:null,panelId:d,beforePanelSentinel:(0,react__WEBPACK_IMPORTED_MODULE_0__.createRef)(),afterPanelSentinel:(0,react__WEBPACK_IMPORTED_MODULE_0__.createRef)()}),[{popoverState:m,button:l,panel:v,beforePanelSentinel:p,afterPanelSentinel:B},s]=g,T=(0,_hooks_use_owner_js__WEBPACK_IMPORTED_MODULE_5__/* .useOwnerDocument */ .i)((R=a.current)!=null?R:l);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>s({type:3,buttonId:o}),[o,s]),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>s({type:5,panelId:d}),[d,s]);let f=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{if(!l||!v)return!1;for(let e of document.querySelectorAll("body > *"))if(Number(e==null?void 0:e.contains(l))^Number(e==null?void 0:e.contains(v)))return!0;return!1},[l,v]),P=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({buttonId:o,panelId:d,close:()=>s({type:1})}),[o,d,s]),y=ce(),A=y==null?void 0:y.registerPopover,L=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(()=>{var e;return(e=y==null?void 0:y.isFocusWithinPopoverGroup())!=null?e:(T==null?void 0:T.activeElement)&&((l==null?void 0:l.contains(T.activeElement))||(v==null?void 0:v.contains(T.activeElement)))});(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>A==null?void 0:A(P),[A,P]),(0,_hooks_use_event_listener_js__WEBPACK_IMPORTED_MODULE_7__/* .useEventListener */ .O)(T==null?void 0:T.defaultView,"focus",e=>{var i,S,O,N;m===0&&(L()||!l||!v||(S=(i=p.current)==null?void 0:i.contains)!=null&&S.call(i,e.target)||(N=(O=B.current)==null?void 0:O.contains)!=null&&N.call(O,e.target)||s({type:1}))},!0),(0,_hooks_use_outside_click_js__WEBPACK_IMPORTED_MODULE_8__/* .useOutsideClick */ .O)([l,v],(e,i)=>{s({type:1}),(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_9__/* .isFocusableElement */ .sP)(i,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_9__/* .FocusableMode.Loose */ .tJ.Loose)||(e.preventDefault(),l==null||l.focus())},m===0);let F=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(e=>{s({type:1});let i=(()=>e?e instanceof HTMLElement?e:e.current instanceof HTMLElement?e.current:l:l)();i==null||i.focus()}),D=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({close:F,isPortalled:f}),[F,f]),u=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:m===0,close:F}),[m,F]),E=t,C={ref:n};return react__WEBPACK_IMPORTED_MODULE_0__.createElement(ee.Provider,{value:g},react__WEBPACK_IMPORTED_MODULE_0__.createElement(te.Provider,{value:D},react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_10__/* .OpenClosedProvider */ .up,{value:(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(m,{[0]:_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_10__/* .State.Open */ .ZM.Open,[1]:_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_10__/* .State.Closed */ .ZM.Closed})},(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .render */ .sY)({ourProps:C,theirProps:E,slot:u,defaultTag:Fe,name:"Popover"}))))}),Me="button",Be=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .forwardRefWithAs */ .yV)(function(t,c){let[o,d]=J("Popover.Button"),{isPortalled:a}=oe("Popover.Button"),n=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),g=`headlessui-focus-sentinel-${(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_3__/* .useId */ .M)()}`,m=ce(),l=m==null?void 0:m.closeOthers,v=Oe(),p=v===null?!1:v===o.panelId,B=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__/* .useSyncRefs */ .T)(n,c,p?null:e=>d({type:2,button:e})),s=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__/* .useSyncRefs */ .T)(n,c),T=(0,_hooks_use_owner_js__WEBPACK_IMPORTED_MODULE_5__/* .useOwnerDocument */ .i)(n),f=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(e=>{var i,S,O;if(p){if(o.popoverState===1)return;switch(e.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_11__/* .Keys.Space */ .R.Space:case _keyboard_js__WEBPACK_IMPORTED_MODULE_11__/* .Keys.Enter */ .R.Enter:e.preventDefault(),(S=(i=e.target).click)==null||S.call(i),d({type:1}),(O=o.button)==null||O.focus();break}}else switch(e.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_11__/* .Keys.Space */ .R.Space:case _keyboard_js__WEBPACK_IMPORTED_MODULE_11__/* .Keys.Enter */ .R.Enter:e.preventDefault(),e.stopPropagation(),o.popoverState===1&&(l==null||l(o.buttonId)),d({type:0});break;case _keyboard_js__WEBPACK_IMPORTED_MODULE_11__/* .Keys.Escape */ .R.Escape:if(o.popoverState!==0)return l==null?void 0:l(o.buttonId);if(!n.current||(T==null?void 0:T.activeElement)&&!n.current.contains(T.activeElement))return;e.preventDefault(),e.stopPropagation(),d({type:1});break}}),P=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(e=>{p||e.key===_keyboard_js__WEBPACK_IMPORTED_MODULE_11__/* .Keys.Space */ .R.Space&&e.preventDefault()}),y=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(e=>{var i,S;(0,_utils_bugs_js__WEBPACK_IMPORTED_MODULE_12__/* .isDisabledReactIssue7711 */ .P)(e.currentTarget)||t.disabled||(p?(d({type:1}),(i=o.button)==null||i.focus()):(e.preventDefault(),e.stopPropagation(),o.popoverState===1&&(l==null||l(o.buttonId)),d({type:0}),(S=o.button)==null||S.focus()))}),A=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(e=>{e.preventDefault(),e.stopPropagation()}),L=o.popoverState===0,F=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:L}),[L]),D=(0,_hooks_use_resolve_button_type_js__WEBPACK_IMPORTED_MODULE_13__/* .useResolveButtonType */ .f)(t,n),u=t,E=p?{ref:s,type:D,onKeyDown:f,onClick:y}:{ref:B,id:o.buttonId,type:D,"aria-expanded":t.disabled?void 0:o.popoverState===0,"aria-controls":o.panel?o.panelId:void 0,onKeyDown:f,onKeyUp:P,onClick:y,onMouseDown:A},C=(0,_hooks_use_tab_direction_js__WEBPACK_IMPORTED_MODULE_14__/* .useTabDirection */ .l)(),R=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(()=>{let e=o.panel;if(!e)return;function i(){(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(C.current,{[_hooks_use_tab_direction_js__WEBPACK_IMPORTED_MODULE_14__/* .Direction.Forwards */ .N.Forwards]:()=>(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_9__/* .focusIn */ .jA)(e,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_9__/* .Focus.First */ .TO.First),[_hooks_use_tab_direction_js__WEBPACK_IMPORTED_MODULE_14__/* .Direction.Backwards */ .N.Backwards]:()=>(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_9__/* .focusIn */ .jA)(e,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_9__/* .Focus.Last */ .TO.Last)})}i()});return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .render */ .sY)({ourProps:E,theirProps:u,slot:F,defaultTag:Me,name:"Popover.Button"}),L&&!p&&a&&react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal_hidden_js__WEBPACK_IMPORTED_MODULE_15__/* .Hidden */ ._,{id:g,features:_internal_hidden_js__WEBPACK_IMPORTED_MODULE_15__/* .Features.Focusable */ .A.Focusable,as:"button",type:"button",onFocus:R}))}),he="div",De=_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .Features.RenderStrategy */ .AN.RenderStrategy|_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .Features.Static */ .AN.Static,xe=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .forwardRefWithAs */ .yV)(function(t,c){let[{popoverState:o},d]=J("Popover.Overlay"),a=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__/* .useSyncRefs */ .T)(c),n=`headlessui-popover-overlay-${(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_3__/* .useId */ .M)()}`,g=(0,_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_10__/* .useOpenClosed */ .oJ)(),m=(()=>g!==null?g===_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_10__/* .State.Open */ .ZM.Open:o===0)(),l=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(s=>{if((0,_utils_bugs_js__WEBPACK_IMPORTED_MODULE_12__/* .isDisabledReactIssue7711 */ .P)(s.currentTarget))return s.preventDefault();d({type:1})}),v=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:o===0}),[o]);return (0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .render */ .sY)({ourProps:{ref:a,id:n,"aria-hidden":!0,onClick:l},theirProps:t,slot:v,defaultTag:he,features:De,visible:m,name:"Popover.Overlay"})}),He="div",Ge=_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .Features.RenderStrategy */ .AN.RenderStrategy|_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .Features.Static */ .AN.Static,ke=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .forwardRefWithAs */ .yV)(function(t,c){let{focus:o=!1,...d}=t,[a,n]=J("Popover.Panel"),{close:g,isPortalled:m}=oe("Popover.Panel"),l=`headlessui-focus-sentinel-before-${(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_3__/* .useId */ .M)()}`,v=`headlessui-focus-sentinel-after-${(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_3__/* .useId */ .M)()}`,p=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),B=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__/* .useSyncRefs */ .T)(p,c,u=>{n({type:4,panel:u})}),s=(0,_hooks_use_owner_js__WEBPACK_IMPORTED_MODULE_5__/* .useOwnerDocument */ .i)(p),T=(0,_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_10__/* .useOpenClosed */ .oJ)(),f=(()=>T!==null?T===_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_10__/* .State.Open */ .ZM.Open:a.popoverState===0)(),P=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(u=>{var E;switch(u.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_11__/* .Keys.Escape */ .R.Escape:if(a.popoverState!==0||!p.current||(s==null?void 0:s.activeElement)&&!p.current.contains(s.activeElement))return;u.preventDefault(),u.stopPropagation(),n({type:1}),(E=a.button)==null||E.focus();break}});(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{var u;t.static||a.popoverState===1&&((u=t.unmount)!=null?u:!0)&&n({type:4,panel:null})},[a.popoverState,t.unmount,t.static,n]),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{if(!o||a.popoverState!==0||!p.current)return;let u=s==null?void 0:s.activeElement;p.current.contains(u)||(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_9__/* .focusIn */ .jA)(p.current,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_9__/* .Focus.First */ .TO.First)},[o,p,a.popoverState]);let y=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:a.popoverState===0,close:g}),[a,g]),A={ref:B,id:a.panelId,onKeyDown:P,onBlur:o&&a.popoverState===0?u=>{var C,R,e,i,S;let E=u.relatedTarget;!E||!p.current||(C=p.current)!=null&&C.contains(E)||(n({type:1}),(((e=(R=a.beforePanelSentinel.current)==null?void 0:R.contains)==null?void 0:e.call(R,E))||((S=(i=a.afterPanelSentinel.current)==null?void 0:i.contains)==null?void 0:S.call(i,E)))&&E.focus({preventScroll:!0}))}:void 0,tabIndex:-1},L=(0,_hooks_use_tab_direction_js__WEBPACK_IMPORTED_MODULE_14__/* .useTabDirection */ .l)(),F=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(()=>{let u=p.current;if(!u)return;function E(){(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(L.current,{[_hooks_use_tab_direction_js__WEBPACK_IMPORTED_MODULE_14__/* .Direction.Forwards */ .N.Forwards]:()=>{(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_9__/* .focusIn */ .jA)(u,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_9__/* .Focus.First */ .TO.First)},[_hooks_use_tab_direction_js__WEBPACK_IMPORTED_MODULE_14__/* .Direction.Backwards */ .N.Backwards]:()=>{var C;(C=a.button)==null||C.focus({preventScroll:!0})}})}E()}),D=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(()=>{let u=p.current;if(!u)return;function E(){(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(L.current,{[_hooks_use_tab_direction_js__WEBPACK_IMPORTED_MODULE_14__/* .Direction.Forwards */ .N.Forwards]:()=>{var O,N,le;if(!a.button)return;let C=(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_9__/* .getFocusableElements */ .GO)(),R=C.indexOf(a.button),e=C.slice(0,R+1),S=[...C.slice(R+1),...e];for(let K of S.slice())if(((N=(O=K==null?void 0:K.id)==null?void 0:O.startsWith)==null?void 0:N.call(O,"headlessui-focus-sentinel-"))||((le=a.panel)==null?void 0:le.contains(K))){let ae=S.indexOf(K);ae!==-1&&S.splice(ae,1)}(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_9__/* .focusIn */ .jA)(S,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_9__/* .Focus.First */ .TO.First,!1)},[_hooks_use_tab_direction_js__WEBPACK_IMPORTED_MODULE_14__/* .Direction.Backwards */ .N.Backwards]:()=>(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_9__/* .focusIn */ .jA)(u,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_9__/* .Focus.Last */ .TO.Last)})}E()});return react__WEBPACK_IMPORTED_MODULE_0__.createElement(ne.Provider,{value:a.panelId},f&&m&&react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal_hidden_js__WEBPACK_IMPORTED_MODULE_15__/* .Hidden */ ._,{id:l,ref:a.beforePanelSentinel,features:_internal_hidden_js__WEBPACK_IMPORTED_MODULE_15__/* .Features.Focusable */ .A.Focusable,as:"button",type:"button",onFocus:F}),(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .render */ .sY)({ourProps:A,theirProps:d,slot:y,defaultTag:He,features:Ge,visible:f,name:"Popover.Panel"}),f&&m&&react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal_hidden_js__WEBPACK_IMPORTED_MODULE_15__/* .Hidden */ ._,{id:v,ref:a.afterPanelSentinel,features:_internal_hidden_js__WEBPACK_IMPORTED_MODULE_15__/* .Features.Focusable */ .A.Focusable,as:"button",type:"button",onFocus:D}))}),_e="div",we=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .forwardRefWithAs */ .yV)(function(t,c){let o=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),d=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__/* .useSyncRefs */ .T)(o,c),[a,n]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),g=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(f=>{n(P=>{let y=P.indexOf(f);if(y!==-1){let A=P.slice();return A.splice(y,1),A}return P})}),m=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(f=>(n(P=>[...P,f]),()=>g(f))),l=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(()=>{var y;let f=(0,_utils_owner_js__WEBPACK_IMPORTED_MODULE_16__/* .getOwnerDocument */ .r)(o);if(!f)return!1;let P=f.activeElement;return(y=o.current)!=null&&y.contains(P)?!0:a.some(A=>{var L,F;return((L=f.getElementById(A.buttonId))==null?void 0:L.contains(P))||((F=f.getElementById(A.panelId))==null?void 0:F.contains(P))})}),v=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(f=>{for(let P of a)P.buttonId!==f&&P.close()}),p=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({registerPopover:m,unregisterPopover:g,isFocusWithinPopoverGroup:l,closeOthers:v}),[m,g,l,v]),B=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({}),[]),s=t,T={ref:d};return react__WEBPACK_IMPORTED_MODULE_0__.createElement(re.Provider,{value:p},(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .render */ .sY)({ourProps:T,theirProps:s,slot:B,defaultTag:_e,name:"Popover.Group"}))}),Tt=Object.assign(Ie,{Button:Be,Overlay:xe,Panel:ke,Group:we});


/***/ }),

/***/ 33587:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ We; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/render.js
var render = __webpack_require__(12351);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/internal/open-closed.js
var open_closed = __webpack_require__(16567);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/match.js
var match = __webpack_require__(32984);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/micro-task.js
var micro_task = __webpack_require__(81021);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-id.js
var use_id = __webpack_require__(19946);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-is-mounted.js
var use_is_mounted = __webpack_require__(14879);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-iso-morphic-effect.js
var use_iso_morphic_effect = __webpack_require__(16723);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-latest-value.js
var use_latest_value = __webpack_require__(3855);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-server-handoff-complete.js
var use_server_handoff_complete = __webpack_require__(82180);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-sync-refs.js
var use_sync_refs = __webpack_require__(23784);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/utils/once.js
function l(r){let e={called:!1};return(...t)=>{if(!e.called)return e.called=!0,r(...t)}}

;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/utils/disposables.js
function disposables_o(){let a=[],i=[],n={enqueue(e){i.push(e)},addEventListener(e,t,r,s){return e.addEventListener(t,r,s),n.add(()=>e.removeEventListener(t,r,s))},requestAnimationFrame(...e){let t=requestAnimationFrame(...e);return n.add(()=>cancelAnimationFrame(t))},nextFrame(...e){return n.requestAnimationFrame(()=>n.requestAnimationFrame(...e))},setTimeout(...e){let t=setTimeout(...e);return n.add(()=>clearTimeout(t))},add(e){return a.push(e),()=>{let t=a.indexOf(e);if(t>=0){let[r]=a.splice(t,1);r()}}},dispose(){for(let e of a.splice(0))e()},async workQueue(){for(let e of i.splice(0))await e()}};return n}

;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/components/transitions/utils/transition.js
function f(t,...e){t&&e.length>0&&t.classList.add(...e)}function g(t,...e){t&&e.length>0&&t.classList.remove(...e)}var T=(n=>(n.Ended="ended",n.Cancelled="cancelled",n))(T||{});function c(t,e){let n=disposables_o();if(!t)return n.dispose;let{transitionDuration:d,transitionDelay:a}=getComputedStyle(t),[s,u]=[d,a].map(i=>{let[o=0]=i.split(",").filter(Boolean).map(r=>r.includes("ms")?parseFloat(r):parseFloat(r)*1e3).sort((r,l)=>l-r);return o});if(s+u!==0){let i=[];i.push(n.addEventListener(t,"transitionrun",o=>{o.target===o.currentTarget&&(i.splice(0).forEach(r=>r()),i.push(n.addEventListener(t,"transitionend",r=>{r.target===r.currentTarget&&(e("ended"),i.splice(0).forEach(l=>l()))}),n.addEventListener(t,"transitioncancel",r=>{r.target===r.currentTarget&&(e("cancelled"),i.splice(0).forEach(l=>l()))})))}))}else e("ended");return n.add(()=>e("cancelled")),n.dispose}function C(t,e,n,d){let a=n?"enter":"leave",s=disposables_o(),u=d!==void 0?l(d):()=>{},m=(0,match/* match */.E)(a,{enter:()=>e.enter,leave:()=>e.leave}),i=(0,match/* match */.E)(a,{enter:()=>e.enterTo,leave:()=>e.leaveTo}),o=(0,match/* match */.E)(a,{enter:()=>e.enterFrom,leave:()=>e.leaveFrom});return g(t,...e.enter,...e.enterTo,...e.enterFrom,...e.leave,...e.leaveFrom,...e.leaveTo,...e.entered),f(t,...m,...o),s.nextFrame(()=>{g(t,...o),f(t,...i),c(t,r=>(r==="ended"&&(g(t,...m),f(t,...e.entered)),u(r)))}),s.dispose}

;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/use-disposables.js
function use_disposables_p(){let[e]=(0,react.useState)(disposables_o);return (0,react.useEffect)(()=>()=>e.dispose(),[e]),e}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-event.js
var use_event = __webpack_require__(73781);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/use-transition.js
function use_transition_H({container:u,direction:o,classes:c,events:t,onStart:d,onStop:l}){let f=(0,use_is_mounted/* useIsMounted */.t)(),m=use_disposables_p(),e=(0,use_latest_value/* useLatestValue */.E)(o),b=(0,use_event/* useEvent */.z)(()=>(0,match/* match */.E)(e.current,{enter:()=>t.current.beforeEnter(),leave:()=>t.current.beforeLeave(),idle:()=>{}})),p=(0,use_event/* useEvent */.z)(()=>(0,match/* match */.E)(e.current,{enter:()=>t.current.afterEnter(),leave:()=>t.current.afterLeave(),idle:()=>{}}));(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{let r=disposables_o();m.add(r.dispose);let i=u.current;if(!!i&&e.current!=="idle"&&!!f.current)return r.dispose(),b(),d.current(e.current),r.add(C(i,c.current,e.current==="enter",v=>{r.dispose(),(0,match/* match */.E)(v,{[T.Ended](){p(),l.current(e.current)},[T.Cancelled]:()=>{}})})),r.dispose},[o])}

;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js
function h(e=""){return e.split(" ").filter(n=>n.trim().length>1)}let N=(0,react.createContext)(null);N.displayName="TransitionContext";var ge=(t=>(t.Visible="visible",t.Hidden="hidden",t))(ge||{});function ve(){let e=(0,react.useContext)(N);if(e===null)throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");return e}function Ce(){let e=(0,react.useContext)(L);if(e===null)throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");return e}let L=(0,react.createContext)(null);L.displayName="NestingContext";function w(e){return"children"in e?w(e.children):e.current.filter(({state:n})=>n==="visible").length>0}function Z(e){let n=(0,use_latest_value/* useLatestValue */.E)(e),t=(0,react.useRef)([]),r=(0,use_is_mounted/* useIsMounted */.t)(),s=(0,use_event/* useEvent */.z)((l,o=render/* RenderStrategy.Hidden */.l4.Hidden)=>{let a=t.current.findIndex(({id:u})=>u===l);a!==-1&&((0,match/* match */.E)(o,{[render/* RenderStrategy.Unmount */.l4.Unmount](){t.current.splice(a,1)},[render/* RenderStrategy.Hidden */.l4.Hidden](){t.current[a].state="hidden"}}),(0,micro_task/* microTask */.Y)(()=>{var u;!w(t)&&r.current&&((u=n.current)==null||u.call(n))}))}),g=(0,use_event/* useEvent */.z)(l=>{let o=t.current.find(({id:a})=>a===l);return o?o.state!=="visible"&&(o.state="visible"):t.current.push({id:l,state:"visible"}),()=>s(l,render/* RenderStrategy.Unmount */.l4.Unmount)});return (0,react.useMemo)(()=>({children:t,register:g,unregister:s}),[g,s,t])}function be(){}let Se=["beforeEnter","afterEnter","beforeLeave","afterLeave"];function $(e){var t;let n={};for(let r of Se)n[r]=(t=e[r])!=null?t:be;return n}function Ee(e){let n=(0,react.useRef)($(e));return (0,react.useEffect)(()=>{n.current=$(e)},[e]),n}let xe="div",ee=render/* Features.RenderStrategy */.AN.RenderStrategy,te=(0,render/* forwardRefWithAs */.yV)(function(n,t){let{beforeEnter:r,afterEnter:s,beforeLeave:g,afterLeave:l,enter:o,enterFrom:a,enterTo:u,entered:A,leave:v,leaveFrom:E,leaveTo:x,...y}=n,d=(0,react.useRef)(null),D=(0,use_sync_refs/* useSyncRefs */.T)(d,t),[i,C]=(0,react.useState)("visible"),p=y.unmount?render/* RenderStrategy.Unmount */.l4.Unmount:render/* RenderStrategy.Hidden */.l4.Hidden,{show:b,appear:re,initial:ne}=ve(),{register:H,unregister:P}=Ce(),F=(0,react.useRef)(null),f=(0,use_id/* useId */.M)();(0,react.useEffect)(()=>{if(!!f)return H(f)},[H,f]),(0,react.useEffect)(()=>{if(p===render/* RenderStrategy.Hidden */.l4.Hidden&&!!f){if(b&&i!=="visible"){C("visible");return}(0,match/* match */.E)(i,{["hidden"]:()=>P(f),["visible"]:()=>H(f)})}},[i,f,H,P,b,p]);let ie=(0,use_latest_value/* useLatestValue */.E)({enter:h(o),enterFrom:h(a),enterTo:h(u),entered:h(A),leave:h(v),leaveFrom:h(E),leaveTo:h(x)}),se=Ee({beforeEnter:r,afterEnter:s,beforeLeave:g,afterLeave:l}),O=(0,use_server_handoff_complete/* useServerHandoffComplete */.H)();(0,react.useEffect)(()=>{if(O&&i==="visible"&&d.current===null)throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?")},[d,i,O]);let M=ne&&!re,oe=(()=>!O||M||F.current===b?"idle":b?"enter":"leave")(),_=(0,react.useRef)(!1),B=Z(()=>{_.current||(C("hidden"),P(f))});use_transition_H({container:d,classes:ie,events:se,direction:oe,onStart:(0,use_latest_value/* useLatestValue */.E)(()=>{_.current=!0}),onStop:(0,use_latest_value/* useLatestValue */.E)(ue=>{_.current=!1,ue==="leave"&&!w(B)&&(C("hidden"),P(f))})}),(0,react.useEffect)(()=>{!M||(p===render/* RenderStrategy.Hidden */.l4.Hidden?F.current=null:F.current=b)},[b,M,i]);let le=y,ae={ref:D};return react.createElement(L.Provider,{value:B},react.createElement(open_closed/* OpenClosedProvider */.up,{value:(0,match/* match */.E)(i,{["visible"]:open_closed/* State.Open */.ZM.Open,["hidden"]:open_closed/* State.Closed */.ZM.Closed})},(0,render/* render */.sY)({ourProps:ae,theirProps:le,defaultTag:xe,features:ee,visible:i==="visible",name:"Transition.Child"})))}),G=(0,render/* forwardRefWithAs */.yV)(function(n,t){let{show:r,appear:s=!1,unmount:g,...l}=n,o=(0,react.useRef)(null),a=(0,use_sync_refs/* useSyncRefs */.T)(o,t);(0,use_server_handoff_complete/* useServerHandoffComplete */.H)();let u=(0,open_closed/* useOpenClosed */.oJ)();if(r===void 0&&u!==null&&(r=(0,match/* match */.E)(u,{[open_closed/* State.Open */.ZM.Open]:!0,[open_closed/* State.Closed */.ZM.Closed]:!1})),![!0,!1].includes(r))throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");let[A,v]=(0,react.useState)(r?"visible":"hidden"),E=Z(()=>{v("hidden")}),[x,y]=(0,react.useState)(!0),d=(0,react.useRef)([r]);(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{x!==!1&&d.current[d.current.length-1]!==r&&(d.current.push(r),y(!1))},[d,r]);let D=(0,react.useMemo)(()=>({show:r,appear:s,initial:x}),[r,s,x]);(0,react.useEffect)(()=>{if(r)v("visible");else if(!w(E))v("hidden");else{let C=o.current;if(!C)return;let p=C.getBoundingClientRect();p.x===0&&p.y===0&&p.width===0&&p.height===0&&v("hidden")}},[r,E]);let i={unmount:g};return react.createElement(L.Provider,{value:E},react.createElement(N.Provider,{value:D},(0,render/* render */.sY)({ourProps:{...i,as:react.Fragment,children:react.createElement(te,{ref:a,...i,...l})},theirProps:{},defaultTag:react.Fragment,features:ee,visible:A==="visible",name:"Transition"})))}),ye=(0,render/* forwardRefWithAs */.yV)(function(n,t){let r=(0,react.useContext)(N)!==null,s=(0,open_closed/* useOpenClosed */.oJ)()!==null;return react.createElement(react.Fragment,null,!r&&s?react.createElement(G,{ref:t,...n}):react.createElement(te,{ref:t,...n}))}),We=Object.assign(G,{Child:ye,Root:G});


/***/ }),

/***/ 14007:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ E; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _use_latest_value_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3855);
function E(n,e,a,t){let i=(0,_use_latest_value_js__WEBPACK_IMPORTED_MODULE_1__/* .useLatestValue */ .E)(a);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{n=n!=null?n:window;function r(o){i.current(o)}return n.addEventListener(e,r,t),()=>n.removeEventListener(e,r,t)},[n,e,t])}


/***/ }),

/***/ 73781:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ o; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _use_latest_value_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3855);
let o=function(t){let e=(0,_use_latest_value_js__WEBPACK_IMPORTED_MODULE_1__/* .useLatestValue */ .E)(t);return react__WEBPACK_IMPORTED_MODULE_0__.useCallback((...r)=>e.current(...r),[e])};


/***/ }),

/***/ 19946:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ I; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16723);
/* harmony import */ var _use_server_handoff_complete_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82180);
var u;let l=0;function r(){return++l}let I=(u=react__WEBPACK_IMPORTED_MODULE_0__.useId)!=null?u:function(){let n=(0,_use_server_handoff_complete_js__WEBPACK_IMPORTED_MODULE_1__/* .useServerHandoffComplete */ .H)(),[e,o]=react__WEBPACK_IMPORTED_MODULE_0__.useState(n?r:null);return (0,_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_2__/* .useIsoMorphicEffect */ .e)(()=>{e===null&&o(r())},[e]),e!=null?""+e:void 0};


/***/ }),

/***/ 14879:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ f; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16723);
function f(){let e=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1);return (0,_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_1__/* .useIsoMorphicEffect */ .e)(()=>(e.current=!0,()=>{e.current=!1}),[]),e}


/***/ }),

/***/ 16723:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ t; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
let t=typeof window!="undefined"?react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect:react__WEBPACK_IMPORTED_MODULE_0__.useEffect;


/***/ }),

/***/ 3855:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ s; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16723);
function s(e){let r=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(e);return (0,_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_1__/* .useIsoMorphicEffect */ .e)(()=>{r.current=e},[e]),r}


/***/ }),

/***/ 90292:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ L; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_focus_management_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84575);
/* harmony import */ var _use_window_event_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7815);
function L(f,c,u=!0){let l=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{requestAnimationFrame(()=>{l.current=u})},[u]);function i(t,o){if(!l.current||t.defaultPrevented)return;let E=function r(e){return typeof e=="function"?r(e()):Array.isArray(e)||e instanceof Set?e:[e]}(f),n=o(t);if(n!==null&&!!n.ownerDocument.documentElement.contains(n)){for(let r of E){if(r===null)continue;let e=r instanceof HTMLElement?r:r.current;if(e!=null&&e.contains(n))return}return!(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_1__/* .isFocusableElement */ .sP)(n,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_1__/* .FocusableMode.Loose */ .tJ.Loose)&&n.tabIndex!==-1&&t.preventDefault(),c(t,n)}}(0,_use_window_event_js__WEBPACK_IMPORTED_MODULE_2__/* .useWindowEvent */ .s)("click",t=>i(t,o=>o.target),!0),(0,_use_window_event_js__WEBPACK_IMPORTED_MODULE_2__/* .useWindowEvent */ .s)("blur",t=>i(t,()=>window.document.activeElement instanceof HTMLIFrameElement?window.document.activeElement:null),!0)}


/***/ }),

/***/ 51074:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ n; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_owner_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15466);
function n(...e){return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>(0,_utils_owner_js__WEBPACK_IMPORTED_MODULE_1__/* .getOwnerDocument */ .r)(...e),[...e])}


/***/ }),

/***/ 14157:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ s; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16723);
function i(t){var n;if(t.type)return t.type;let e=(n=t.as)!=null?n:"button";if(typeof e=="string"&&e.toLowerCase()==="button")return"button"}function s(t,e){let[n,u]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(()=>i(t));return (0,_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_1__/* .useIsoMorphicEffect */ .e)(()=>{u(i(t))},[t.type,t.as]),(0,_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_1__/* .useIsoMorphicEffect */ .e)(()=>{n||!e.current||e.current instanceof HTMLButtonElement&&!e.current.hasAttribute("type")&&u("button")},[n,e]),n}


/***/ }),

/***/ 82180:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ a; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
let r={serverHandoffComplete:!1};function a(){let[e,f]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(r.serverHandoffComplete);return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{e!==!0&&f(!0)},[e]),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{r.serverHandoffComplete===!1&&(r.serverHandoffComplete=!0)},[]),e}


/***/ }),

/***/ 23784:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ T; },
/* harmony export */   "T": function() { return /* binding */ y; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _use_event_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73781);
let u=Symbol();function T(t,n=!0){return Object.assign(t,{[u]:n})}function y(...t){let n=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(t);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{n.current=t},[t]);let c=(0,_use_event_js__WEBPACK_IMPORTED_MODULE_1__/* .useEvent */ .z)(e=>{for(let o of n.current)o!=null&&(typeof o=="function"?o(e):o.current=e)});return t.every(e=>e==null||(e==null?void 0:e[u]))?void 0:c}


/***/ }),

/***/ 45662:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ s; },
/* harmony export */   "l": function() { return /* binding */ n; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _use_window_event_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7815);
var s=(r=>(r[r.Forwards=0]="Forwards",r[r.Backwards=1]="Backwards",r))(s||{});function n(){let e=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);return (0,_use_window_event_js__WEBPACK_IMPORTED_MODULE_1__/* .useWindowEvent */ .s)("keydown",o=>{o.key==="Tab"&&(e.current=o.shiftKey?1:0)},!0),e}


/***/ }),

/***/ 7815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ s; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _use_latest_value_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3855);
function s(e,r,n){let o=(0,_use_latest_value_js__WEBPACK_IMPORTED_MODULE_1__/* .useLatestValue */ .E)(r);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{function t(i){o.current(i)}return window.addEventListener(e,t,n),()=>window.removeEventListener(e,t,n)},[e,n])}


/***/ }),

/***/ 46045:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ s; },
/* harmony export */   "_": function() { return /* binding */ h; }
/* harmony export */ });
/* harmony import */ var _utils_render_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12351);
let a="div";var s=(e=>(e[e.None=1]="None",e[e.Focusable=2]="Focusable",e[e.Hidden=4]="Hidden",e))(s||{});let h=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_0__/* .forwardRefWithAs */ .yV)(function(t,o){let{features:e=1,...r}=t,d={ref:o,"aria-hidden":(e&2)===2?!0:void 0,style:{position:"absolute",width:1,height:1,padding:0,margin:-1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap",borderWidth:"0",...(e&4)===4&&(e&2)!==2&&{display:"none"}}};return (0,_utils_render_js__WEBPACK_IMPORTED_MODULE_0__/* .render */ .sY)({ourProps:d,theirProps:r,slot:{},defaultTag:a,name:"Hidden"})});


/***/ }),

/***/ 16567:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "up": function() { return /* binding */ C; },
/* harmony export */   "ZM": function() { return /* binding */ p; },
/* harmony export */   "oJ": function() { return /* binding */ s; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
let o=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);o.displayName="OpenClosedContext";var p=(e=>(e[e.Open=0]="Open",e[e.Closed=1]="Closed",e))(p||{});function s(){return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(o)}function C({value:t,children:n}){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(o.Provider,{value:t},n)}


/***/ }),

/***/ 64103:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ r; }
/* harmony export */ });
function r(n){let e=n.parentElement,l=null;for(;e&&!(e instanceof HTMLFieldSetElement);)e instanceof HTMLLegendElement&&(l=e),e=e.parentElement;let t=(e==null?void 0:e.getAttribute("disabled"))==="";return t&&i(l)?!1:t}function i(n){if(!n)return!1;let e=n.previousElementSibling;for(;e!==null;){if(e instanceof HTMLLegendElement)return!1;e=e.previousElementSibling}return!0}


/***/ }),

/***/ 84575:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TO": function() { return /* binding */ p; },
/* harmony export */   "fE": function() { return /* binding */ L; },
/* harmony export */   "tJ": function() { return /* binding */ b; },
/* harmony export */   "C5": function() { return /* binding */ F; },
/* harmony export */   "jA": function() { return /* binding */ H; },
/* harmony export */   "GO": function() { return /* binding */ T; },
/* harmony export */   "sP": function() { return /* binding */ S; },
/* harmony export */   "z2": function() { return /* binding */ v; }
/* harmony export */ });
/* harmony import */ var _match_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32984);
/* harmony import */ var _owner_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15466);
let f=["[contentEditable=true]","[tabindex]","a[href]","area[href]","button:not([disabled])","iframe","input:not([disabled])","select:not([disabled])","textarea:not([disabled])"].map(e=>`${e}:not([tabindex='-1'])`).join(",");var p=(o=>(o[o.First=1]="First",o[o.Previous=2]="Previous",o[o.Next=4]="Next",o[o.Last=8]="Last",o[o.WrapAround=16]="WrapAround",o[o.NoScroll=32]="NoScroll",o))(p||{}),L=(n=>(n[n.Error=0]="Error",n[n.Overflow=1]="Overflow",n[n.Success=2]="Success",n[n.Underflow=3]="Underflow",n))(L||{}),N=(t=>(t[t.Previous=-1]="Previous",t[t.Next=1]="Next",t))(N||{});function T(e=document.body){return e==null?[]:Array.from(e.querySelectorAll(f))}var b=(t=>(t[t.Strict=0]="Strict",t[t.Loose=1]="Loose",t))(b||{});function S(e,r=0){var t;return e===((t=(0,_owner_js__WEBPACK_IMPORTED_MODULE_0__/* .getOwnerDocument */ .r)(e))==null?void 0:t.body)?!1:(0,_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(r,{[0](){return e.matches(f)},[1](){let l=e;for(;l!==null;){if(l.matches(f))return!0;l=l.parentElement}return!1}})}function F(e){e==null||e.focus({preventScroll:!0})}let M=["textarea","input"].join(",");function h(e){var r,t;return(t=(r=e==null?void 0:e.matches)==null?void 0:r.call(e,M))!=null?t:!1}function v(e,r=t=>t){return e.slice().sort((t,l)=>{let n=r(t),i=r(l);if(n===null||i===null)return 0;let o=n.compareDocumentPosition(i);return o&Node.DOCUMENT_POSITION_FOLLOWING?-1:o&Node.DOCUMENT_POSITION_PRECEDING?1:0})}function H(e,r,t=!0){let l=Array.isArray(e)?e.length>0?e[0].ownerDocument:document:e.ownerDocument,n=Array.isArray(e)?t?v(e):e:T(e),i=l.activeElement,o=(()=>{if(r&5)return 1;if(r&10)return-1;throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last")})(),d=(()=>{if(r&1)return 0;if(r&2)return Math.max(0,n.indexOf(i))-1;if(r&4)return Math.max(0,n.indexOf(i))+1;if(r&8)return n.length-1;throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last")})(),m=r&32?{preventScroll:!0}:{},c=0,s=n.length,u;do{if(c>=s||c+s<=0)return 0;let a=d+c;if(r&16)a=(a+s)%s;else{if(a<0)return 3;if(a>=s)return 1}u=n[a],u==null||u.focus(m),c+=o}while(u!==l.activeElement);return r&6&&h(u)&&u.select(),u.hasAttribute("tabindex")||u.setAttribute("tabindex","0"),2}


/***/ }),

/***/ 32984:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ u; }
/* harmony export */ });
function u(r,n,...a){if(r in n){let e=n[r];return typeof e=="function"?e(...a):e}let t=new Error(`Tried to handle "${r}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map(e=>`"${e}"`).join(", ")}.`);throw Error.captureStackTrace&&Error.captureStackTrace(t,u),t}


/***/ }),

/***/ 81021:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ t; }
/* harmony export */ });
function t(e){typeof queueMicrotask=="function"?queueMicrotask(e):Promise.resolve().then(e).catch(o=>setTimeout(()=>{throw o}))}


/***/ }),

/***/ 15466:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ t; }
/* harmony export */ });
function t(n){return typeof window=="undefined"?null:n instanceof Node?n.ownerDocument:n!=null&&n.hasOwnProperty("current")&&n.current instanceof Node?n.current.ownerDocument:document}


/***/ }),

/***/ 12351:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AN": function() { return /* binding */ x; },
/* harmony export */   "l4": function() { return /* binding */ R; },
/* harmony export */   "oA": function() { return /* binding */ g; },
/* harmony export */   "yV": function() { return /* binding */ H; },
/* harmony export */   "sY": function() { return /* binding */ _; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _match_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32984);
var x=(n=>(n[n.None=0]="None",n[n.RenderStrategy=1]="RenderStrategy",n[n.Static=2]="Static",n))(x||{}),R=(e=>(e[e.Unmount=0]="Unmount",e[e.Hidden=1]="Hidden",e))(R||{});function _({ourProps:r,theirProps:t,slot:e,defaultTag:n,features:a,visible:s=!0,name:l}){let o=y(t,r);if(s)return f(o,e,n,l);let d=a!=null?a:0;if(d&2){let{static:i=!1,...u}=o;if(i)return f(u,e,n,l)}if(d&1){let{unmount:i=!0,...u}=o;return (0,_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(i?0:1,{[0](){return null},[1](){return f({...u,hidden:!0,style:{display:"none"}},e,n,l)}})}return f(o,e,n,l)}function f(r,t={},e,n){let{as:a=e,children:s,refName:l="ref",...o}=m(r,["unmount","static"]),d=r.ref!==void 0?{[l]:r.ref}:{},i=typeof s=="function"?s(t):s;o.className&&typeof o.className=="function"&&(o.className=o.className(t));let u={};if(a===react__WEBPACK_IMPORTED_MODULE_0__.Fragment&&Object.keys(g(o)).length>0){if(!(0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(i)||Array.isArray(i)&&i.length>1)throw new Error(['Passing props on "Fragment"!',"",`The current component <${n} /> is rendering a "Fragment".`,"However we need to passthrough the following props:",Object.keys(o).map(p=>`  - ${p}`).join(`
`),"","You can apply a few solutions:",['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".',"Render a single element as the child so that we can forward the props onto that element."].map(p=>`  - ${p}`).join(`
`)].join(`
`));return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(i,Object.assign({},y(i.props,g(m(o,["ref"]))),u,d))}return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(a,Object.assign({},m(o,["ref"]),a!==react__WEBPACK_IMPORTED_MODULE_0__.Fragment&&d,a!==react__WEBPACK_IMPORTED_MODULE_0__.Fragment&&u),i)}function y(...r){var n;if(r.length===0)return{};if(r.length===1)return r[0];let t={},e={};for(let a of r)for(let s in a)s.startsWith("on")&&typeof a[s]=="function"?((n=e[s])!=null||(e[s]=[]),e[s].push(a[s])):t[s]=a[s];if(t.disabled||t["aria-disabled"])return Object.assign(t,Object.fromEntries(Object.keys(e).map(a=>[a,void 0])));for(let a in e)Object.assign(t,{[a](s,...l){let o=e[a];for(let d of o){if(s.defaultPrevented)return;d(s,...l)}}});return t}function H(r){var t;return Object.assign((0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(r),{displayName:(t=r.displayName)!=null?t:r.name})}function g(r){let t=Object.assign({},r);for(let e in t)t[e]===void 0&&delete t[e];return t}function m(r,t=[]){let e=Object.assign({},r);for(let n of t)n in e&&delete e[n];return e}


/***/ }),

/***/ 61782:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function ChevronDownIcon(props, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19 9l-7 7-7-7"
  }));
}

const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(ChevronDownIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 40169:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function ChevronRightIcon(props, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 5l7 7-7 7"
  }));
}

const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(ChevronRightIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 5506:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function XIcon(props, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 18L18 6M6 6l12 12"
  }));
}

const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(XIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 13342:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function ChevronDownIcon(props, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(ChevronDownIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 31955:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

"use strict";
/*! js-cookie v3.0.1 | MIT */
/* eslint-disable no-var */
function assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (key, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    key = encodeURIComponent(key)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      key + '=' + converter.write(value, key) + stringifiedAttributes)
  }

  function get (key) {
    if (typeof document === 'undefined' || (arguments.length && !key)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);

        if (key === foundKey) {
          break
        }
      } catch (e) {}
    }

    return key ? jar[key] : jar
  }

  return Object.create(
    {
      set: set,
      get: get,
      remove: function (key, attributes) {
        set(
          key,
          '',
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */

/* harmony default export */ __webpack_exports__["Z"] = (api);


/***/ }),

/***/ 87536:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qr": function() { return /* binding */ Controller; },
/* harmony export */   "cI": function() { return /* binding */ useForm; }
/* harmony export */ });
/* unused harmony exports FormProvider, appendErrors, get, set, useController, useFieldArray, useFormContext, useFormState, useWatch */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var isCheckBoxInput = (element) => element.type === 'checkbox';

var isDateObject = (value) => value instanceof Date;

var isNullOrUndefined = (value) => value == null;

const isObjectType = (value) => typeof value === 'object';
var isObject = (value) => !isNullOrUndefined(value) &&
    !Array.isArray(value) &&
    isObjectType(value) &&
    !isDateObject(value);

var getEventValue = (event) => isObject(event) && event.target
    ? isCheckBoxInput(event.target)
        ? event.target.checked
        : event.target.value
    : event;

var getNodeParentName = (name) => name.substring(0, name.search(/\.\d+(\.|$)/)) || name;

var isNameInFieldArray = (names, name) => names.has(getNodeParentName(name));

var compact = (value) => Array.isArray(value) ? value.filter(Boolean) : [];

var isUndefined = (val) => val === undefined;

var get = (obj, path, defaultValue) => {
    if (!path || !isObject(obj)) {
        return defaultValue;
    }
    const result = compact(path.split(/[,[\].]+?/)).reduce((result, key) => isNullOrUndefined(result) ? result : result[key], obj);
    return isUndefined(result) || result === obj
        ? isUndefined(obj[path])
            ? defaultValue
            : obj[path]
        : result;
};

const EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change',
};
const VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all',
};
const INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate',
};

const HookFormContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
const useFormContext = () => react__WEBPACK_IMPORTED_MODULE_0__.useContext(HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useFrom methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
const FormProvider = (props) => {
    const { children, ...data } = props;
    return (React.createElement(HookFormContext.Provider, { value: data }, children));
};

var getProxyFormState = (formState, _proxyFormState, localProxyFormState, isRoot = true) => {
    const result = {};
    for (const key in formState) {
        Object.defineProperty(result, key, {
            get: () => {
                const _key = key;
                if (_proxyFormState[_key] !== VALIDATION_MODE.all) {
                    _proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
                }
                localProxyFormState && (localProxyFormState[_key] = true);
                return formState[_key];
            },
        });
    }
    return result;
};

var isEmptyObject = (value) => isObject(value) && !Object.keys(value).length;

var shouldRenderFormState = (formStateData, _proxyFormState, isRoot) => {
    const { name, ...formState } = formStateData;
    return (isEmptyObject(formState) ||
        Object.keys(formState).length >= Object.keys(_proxyFormState).length ||
        Object.keys(formState).find((key) => _proxyFormState[key] ===
            (!isRoot || VALIDATION_MODE.all)));
};

var convertToArrayPayload = (value) => (Array.isArray(value) ? value : [value]);

var shouldSubscribeByName = (name, signalName, exact) => exact && signalName
    ? name === signalName
    : !name ||
        !signalName ||
        name === signalName ||
        convertToArrayPayload(name).some((currentName) => currentName &&
            (currentName.startsWith(signalName) ||
                signalName.startsWith(currentName)));

function useSubscribe(props) {
    const _props = react__WEBPACK_IMPORTED_MODULE_0__.useRef(props);
    _props.current = props;
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        const tearDown = (subscription) => {
            if (subscription) {
                subscription.unsubscribe();
            }
        };
        const subscription = !props.disabled &&
            _props.current.subject.subscribe({
                next: _props.current.callback,
            });
        return () => tearDown(subscription);
    }, [props.disabled]);
}

/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFormState(props) {
    const methods = useFormContext();
    const { control = methods.control, disabled, name, exact } = props || {};
    const [formState, updateFormState] = react__WEBPACK_IMPORTED_MODULE_0__.useState(control._formState);
    const _localProxyFormState = react__WEBPACK_IMPORTED_MODULE_0__.useRef({
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    });
    const _name = react__WEBPACK_IMPORTED_MODULE_0__.useRef(name);
    const _mounted = react__WEBPACK_IMPORTED_MODULE_0__.useRef(true);
    _name.current = name;
    const callback = react__WEBPACK_IMPORTED_MODULE_0__.useCallback((value) => _mounted.current &&
        shouldSubscribeByName(_name.current, value.name, exact) &&
        shouldRenderFormState(value, _localProxyFormState.current) &&
        updateFormState({
            ...control._formState,
            ...value,
        }), [control, exact]);
    useSubscribe({
        disabled,
        callback,
        subject: control._subjects.state,
    });
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        _mounted.current = true;
        return () => {
            _mounted.current = false;
        };
    }, []);
    return getProxyFormState(formState, control._proxyFormState, _localProxyFormState.current, false);
}

var isString = (value) => typeof value === 'string';

var generateWatchOutput = (names, _names, formValues, isGlobal) => {
    const isArray = Array.isArray(names);
    if (isString(names)) {
        isGlobal && _names.watch.add(names);
        return get(formValues, names);
    }
    if (isArray) {
        return names.map((fieldName) => (isGlobal && _names.watch.add(fieldName),
            get(formValues, fieldName)));
    }
    isGlobal && (_names.watchAll = true);
    return formValues;
};

var isFunction = (value) => typeof value === 'function';

var objectHasFunction = (data) => {
    for (const key in data) {
        if (isFunction(data[key])) {
            return true;
        }
    }
    return false;
};

/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/api/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { watch } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */
function useWatch(props) {
    const methods = useFormContext();
    const { control = methods.control, name, defaultValue, disabled, exact, } = props || {};
    const _name = react__WEBPACK_IMPORTED_MODULE_0__.useRef(name);
    _name.current = name;
    const callback = react__WEBPACK_IMPORTED_MODULE_0__.useCallback((formState) => {
        if (shouldSubscribeByName(_name.current, formState.name, exact)) {
            const fieldValues = generateWatchOutput(_name.current, control._names, formState.values || control._formValues);
            updateValue(isUndefined(_name.current) ||
                (isObject(fieldValues) && !objectHasFunction(fieldValues))
                ? { ...fieldValues }
                : Array.isArray(fieldValues)
                    ? [...fieldValues]
                    : isUndefined(fieldValues)
                        ? defaultValue
                        : fieldValues);
        }
    }, [control, exact, defaultValue]);
    useSubscribe({
        disabled,
        subject: control._subjects.watch,
        callback,
    });
    const [value, updateValue] = react__WEBPACK_IMPORTED_MODULE_0__.useState(isUndefined(defaultValue)
        ? control._getWatch(name)
        : defaultValue);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        control._removeUnmounted();
    });
    return value;
}

/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */
function useController(props) {
    const methods = useFormContext();
    const { name, control = methods.control, shouldUnregister } = props;
    const isArrayField = isNameInFieldArray(control._names.array, name);
    const value = useWatch({
        control,
        name,
        defaultValue: get(control._formValues, name, get(control._defaultValues, name, props.defaultValue)),
        exact: true,
    });
    const formState = useFormState({
        control,
        name,
    });
    const _registerProps = react__WEBPACK_IMPORTED_MODULE_0__.useRef(control.register(name, {
        ...props.rules,
        value,
    }));
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        const updateMounted = (name, value) => {
            const field = get(control._fields, name);
            if (field) {
                field._f.mount = value;
            }
        };
        updateMounted(name, true);
        return () => {
            const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
            (isArrayField
                ? _shouldUnregisterField && !control._stateFlags.action
                : _shouldUnregisterField)
                ? control.unregister(name)
                : updateMounted(name, false);
        };
    }, [name, control, isArrayField, shouldUnregister]);
    return {
        field: {
            name,
            value,
            onChange: react__WEBPACK_IMPORTED_MODULE_0__.useCallback((event) => {
                _registerProps.current.onChange({
                    target: {
                        value: getEventValue(event),
                        name: name,
                    },
                    type: EVENTS.CHANGE,
                });
            }, [name]),
            onBlur: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(() => {
                _registerProps.current.onBlur({
                    target: {
                        value: get(control._formValues, name),
                        name: name,
                    },
                    type: EVENTS.BLUR,
                });
            }, [name, control]),
            ref: react__WEBPACK_IMPORTED_MODULE_0__.useCallback((elm) => {
                const field = get(control._fields, name);
                if (elm && field && elm.focus) {
                    field._f.ref = {
                        focus: () => elm.focus(),
                        select: () => elm.select(),
                        setCustomValidity: (message) => elm.setCustomValidity(message),
                        reportValidity: () => elm.reportValidity(),
                    };
                }
            }, [name, control._fields]),
        },
        formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                get: () => !!get(formState.errors, name),
            },
            isDirty: {
                get: () => !!get(formState.dirtyFields, name),
            },
            isTouched: {
                get: () => !!get(formState.touchedFields, name),
            },
            error: {
                get: () => get(formState.errors, name),
            },
        }),
    };
}

/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */
const Controller = (props) => props.render(useController(props));

var appendErrors = (name, validateAllFieldCriteria, errors, type, message) => validateAllFieldCriteria
    ? {
        ...errors[name],
        types: {
            ...(errors[name] && errors[name].types ? errors[name].types : {}),
            [type]: message || true,
        },
    }
    : {};

var isKey = (value) => /^\w*$/.test(value);

var stringToPath = (input) => compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));

function set(object, path, value) {
    let index = -1;
    const tempPath = isKey(path) ? [path] : stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while (++index < length) {
        const key = tempPath[index];
        let newValue = value;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue =
                isObject(objValue) || Array.isArray(objValue)
                    ? objValue
                    : !isNaN(+tempPath[index + 1])
                        ? []
                        : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}

const focusFieldBy = (fields, callback, fieldsNames) => {
    for (const key of fieldsNames || Object.keys(fields)) {
        const field = get(fields, key);
        if (field) {
            const { _f, ...currentField } = field;
            if (_f && callback(_f.name)) {
                if (_f.ref.focus && isUndefined(_f.ref.focus())) {
                    break;
                }
                else if (_f.refs) {
                    _f.refs[0].focus();
                    break;
                }
            }
            else if (isObject(currentField)) {
                focusFieldBy(currentField, callback);
            }
        }
    }
};

var generateId = () => {
    const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
};

var getFocusFieldName = (name, index, options = {}) => options.shouldFocus || isUndefined(options.shouldFocus)
    ? options.focusName ||
        `${name}.${isUndefined(options.focusIndex) ? index : options.focusIndex}.`
    : '';

var isWatched = (name, _names, isBlurEvent) => !isBlurEvent &&
    (_names.watchAll ||
        _names.watch.has(name) ||
        [..._names.watch].some((watchName) => name.startsWith(watchName) &&
            /^\.\w+/.test(name.slice(watchName.length))));

var updateFieldArrayRootError = (errors, error, name) => {
    const fieldArrayErrors = compact(get(errors, name));
    set(fieldArrayErrors, 'root', error[name]);
    set(errors, name, fieldArrayErrors);
    return errors;
};

var isBoolean = (value) => typeof value === 'boolean';

var isFileInput = (element) => element.type === 'file';

var isMessage = (value) => isString(value) || react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(value);

var isRadioInput = (element) => element.type === 'radio';

var isRegex = (value) => value instanceof RegExp;

const defaultResult = {
    value: false,
    isValid: false,
};
const validResult = { value: true, isValid: true };
var getCheckboxValue = (options) => {
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options
                .filter((option) => option && option.checked && !option.disabled)
                .map((option) => option.value);
            return { value: values, isValid: !!values.length };
        }
        return options[0].checked && !options[0].disabled
            ? // @ts-expect-error expected to work in the browser
                options[0].attributes && !isUndefined(options[0].attributes.value)
                    ? isUndefined(options[0].value) || options[0].value === ''
                        ? validResult
                        : { value: options[0].value, isValid: true }
                    : validResult
            : defaultResult;
    }
    return defaultResult;
};

const defaultReturn = {
    isValid: false,
    value: null,
};
var getRadioValue = (options) => Array.isArray(options)
    ? options.reduce((previous, option) => option && option.checked && !option.disabled
        ? {
            isValid: true,
            value: option.value,
        }
        : previous, defaultReturn)
    : defaultReturn;

function getValidateError(result, ref, type = 'validate') {
    if (isMessage(result) ||
        (Array.isArray(result) && result.every(isMessage)) ||
        (isBoolean(result) && !result)) {
        return {
            type,
            message: isMessage(result) ? result : '',
            ref,
        };
    }
}

var getValueAndMessage = (validationData) => isObject(validationData) && !isRegex(validationData)
    ? validationData
    : {
        value: validationData,
        message: '',
    };

var validateField = async (field, inputValue, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray) => {
    const { ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount, disabled, } = field._f;
    if (!mount || disabled) {
        return {};
    }
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message) => {
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity(isBoolean(message) ? '' : message || ' ');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = isRadioInput(ref);
    const isCheckBox = isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = ((valueAsNumber || isFileInput(ref)) && !ref.value) ||
        inputValue === '' ||
        (Array.isArray(inputValue) && !inputValue.length);
    const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message,
            ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message),
        };
    };
    if (isFieldArray
        ? !Array.isArray(inputValue) || !inputValue.length
        : required &&
            ((!isRadioOrCheckbox && (isEmpty || isNullOrUndefined(inputValue))) ||
                (isBoolean(inputValue) && !inputValue) ||
                (isCheckBox && !getCheckboxValue(refs).isValid) ||
                (isRadio && !getRadioValue(refs).isValid))) {
        const { value, message } = isMessage(required)
            ? { value: !!required, message: required }
            : getValueAndMessage(required);
        if (value) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.required,
                message,
                ref: inputRef,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.required, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = getValueAndMessage(max);
        const minOutput = getValueAndMessage(min);
        if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || +inputValue;
            if (!isNullOrUndefined(maxOutput.value)) {
                exceedMax = valueNumber > maxOutput.value;
            }
            if (!isNullOrUndefined(minOutput.value)) {
                exceedMin = valueNumber < minOutput.value;
            }
        }
        else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            if (isString(maxOutput.value)) {
                exceedMax = valueDate > new Date(maxOutput.value);
            }
            if (isString(minOutput.value)) {
                exceedMin = valueDate < new Date(minOutput.value);
            }
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) &&
        !isEmpty &&
        (isString(inputValue) || (isFieldArray && Array.isArray(inputValue)))) {
        const maxLengthOutput = getValueAndMessage(maxLength);
        const minLengthOutput = getValueAndMessage(minLength);
        const exceedMax = !isNullOrUndefined(maxLengthOutput.value) &&
            inputValue.length > maxLengthOutput.value;
        const exceedMin = !isNullOrUndefined(minLengthOutput.value) &&
            inputValue.length < minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && isString(inputValue)) {
        const { value: patternValue, message } = getValueAndMessage(pattern);
        if (isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.pattern,
                message,
                ref,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if (isFunction(validate)) {
            const result = await validate(inputValue);
            const validateError = getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message),
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        }
        else if (isObject(validate)) {
            let validationResult = {};
            for (const key in validate) {
                if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
                    break;
                }
                const validateError = getValidateError(await validate[key](inputValue), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message),
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) {
                        error[name] = validationResult;
                    }
                }
            }
            if (!isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult,
                };
                if (!validateAllFieldCriteria) {
                    return error;
                }
            }
        }
    }
    setCustomValidity(true);
    return error;
};

function append(data, value) {
    return [...data, ...convertToArrayPayload(value)];
}

var isWeb = typeof window !== 'undefined' &&
    typeof window.HTMLElement !== 'undefined' &&
    typeof document !== 'undefined';

function cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) {
        copy = new Date(data);
    }
    else if (data instanceof Set) {
        copy = new Set(data);
    }
    else if (!(isWeb && (data instanceof Blob || data instanceof FileList)) &&
        (isArray || isObject(data))) {
        copy = isArray ? [] : {};
        for (const key in data) {
            if (isFunction(data[key])) {
                copy = data;
                break;
            }
            copy[key] = cloneObject(data[key]);
        }
    }
    else {
        return data;
    }
    return copy;
}

var fillEmptyArray = (value) => Array.isArray(value) ? value.map(() => undefined) : undefined;

var getValidationModes = (mode) => ({
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onChange,
    isOnAll: mode === VALIDATION_MODE.all,
    isOnTouch: mode === VALIDATION_MODE.onTouched,
});

function insert(data, index, value) {
    return [
        ...data.slice(0, index),
        ...convertToArrayPayload(value),
        ...data.slice(index),
    ];
}

var moveArrayAt = (data, from, to) => {
    if (!Array.isArray(data)) {
        return [];
    }
    if (isUndefined(data[to])) {
        data[to] = undefined;
    }
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};

function prepend(data, value) {
    return [...convertToArrayPayload(value), ...convertToArrayPayload(data)];
}

function removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [...data];
    for (const index of indexes) {
        temp.splice(index - i, 1);
        i++;
    }
    return compact(temp).length ? temp : [];
}
var removeArrayAt = (data, index) => isUndefined(index)
    ? []
    : removeAtIndexes(data, convertToArrayPayload(index).sort((a, b) => a - b));

var swapArrayAt = (data, indexA, indexB) => {
    data[indexA] = [data[indexB], (data[indexB] = data[indexA])][0];
};

function baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while (index < length) {
        object = isUndefined(object) ? index++ : object[updatePath[index++]];
    }
    return object;
}
function isEmptyArray(obj) {
    for (const key in obj) {
        if (!isUndefined(obj[key])) {
            return false;
        }
    }
    return true;
}
function unset(object, path) {
    const updatePath = isKey(path) ? [path] : stringToPath(path);
    const childObject = updatePath.length == 1 ? object : baseGet(object, updatePath);
    const key = updatePath[updatePath.length - 1];
    let previousObjRef;
    if (childObject) {
        delete childObject[key];
    }
    for (let k = 0; k < updatePath.slice(0, -1).length; k++) {
        let index = -1;
        let objectRef;
        const currentPaths = updatePath.slice(0, -(k + 1));
        const currentPathsLength = currentPaths.length - 1;
        if (k > 0) {
            previousObjRef = object;
        }
        while (++index < currentPaths.length) {
            const item = currentPaths[index];
            objectRef = objectRef ? objectRef[item] : object[item];
            if (currentPathsLength === index &&
                ((isObject(objectRef) && isEmptyObject(objectRef)) ||
                    (Array.isArray(objectRef) && isEmptyArray(objectRef)))) {
                previousObjRef ? delete previousObjRef[item] : delete object[item];
            }
            previousObjRef = objectRef;
        }
    }
    return object;
}

var updateAt = (fieldValues, index, value) => {
    fieldValues[index] = value;
    return fieldValues;
};

/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFieldArray(props) {
    const methods = useFormContext();
    const { control = methods.control, name, keyName = 'id', shouldUnregister, } = props;
    const [fields, setFields] = React.useState(control._getFieldArray(name));
    const ids = React.useRef(control._getFieldArray(name).map(generateId));
    const _fieldIds = React.useRef(fields);
    const _name = React.useRef(name);
    const _actioned = React.useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules &&
        control.register(name, props.rules);
    const callback = React.useCallback(({ values, name: fieldArrayName, }) => {
        if (fieldArrayName === _name.current || !fieldArrayName) {
            const fieldValues = get(values, _name.current, []);
            setFields(fieldValues);
            ids.current = fieldValues.map(generateId);
        }
    }, []);
    useSubscribe({
        callback,
        subject: control._subjects.array,
    });
    const updateValues = React.useCallback((updatedFieldArrayValues) => {
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [control, name]);
    const append$1 = (value, options) => {
        const appendValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = append(control._getFieldArray(name), appendValue);
        control._names.focus = getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = append(ids.current, appendValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, append, {
            argA: fillEmptyArray(value),
        });
    };
    const prepend$1 = (value, options) => {
        const prependValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = prepend(control._getFieldArray(name), prependValue);
        control._names.focus = getFocusFieldName(name, 0, options);
        ids.current = prepend(ids.current, prependValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, prepend, {
            argA: fillEmptyArray(value),
        });
    };
    const remove = (index) => {
        const updatedFieldArrayValues = removeArrayAt(control._getFieldArray(name), index);
        ids.current = removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, removeArrayAt, {
            argA: index,
        });
    };
    const insert$1 = (index, value, options) => {
        const insertValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = getFocusFieldName(name, index, options);
        ids.current = insert(ids.current, index, insertValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, insert, {
            argA: index,
            argB: fillEmptyArray(value),
        });
    };
    const swap = (indexA, indexB) => {
        const updatedFieldArrayValues = control._getFieldArray(name);
        swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, swapArrayAt, {
            argA: indexA,
            argB: indexB,
        }, false);
    };
    const move = (from, to) => {
        const updatedFieldArrayValues = control._getFieldArray(name);
        moveArrayAt(updatedFieldArrayValues, from, to);
        moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, moveArrayAt, {
            argA: from,
            argB: to,
        }, false);
    };
    const update = (index, value) => {
        const updateValue = cloneObject(value);
        const updatedFieldArrayValues = updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [...updatedFieldArrayValues].map((item, i) => !item || i === index ? generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([...updatedFieldArrayValues]);
        control._updateFieldArray(name, updatedFieldArrayValues, updateAt, {
            argA: index,
            argB: updateValue,
        }, true, false);
    };
    const replace = (value) => {
        const updatedFieldArrayValues = convertToArrayPayload(cloneObject(value));
        ids.current = updatedFieldArrayValues.map(generateId);
        updateValues([...updatedFieldArrayValues]);
        setFields([...updatedFieldArrayValues]);
        control._updateFieldArray(name, [...updatedFieldArrayValues], (data) => data, {}, true, false);
    };
    React.useEffect(() => {
        control._stateFlags.action = false;
        isWatched(name, control._names) && control._subjects.state.next({});
        if (_actioned.current) {
            if (control._options.resolver) {
                control._executeSchema([name]).then((result) => {
                    const error = get(result.errors, name);
                    const existingError = get(control._formState.errors, name);
                    if (existingError ? !error && existingError.type : error && error.type) {
                        error
                            ? set(control._formState.errors, name, error)
                            : unset(control._formState.errors, name);
                        control._subjects.state.next({
                            errors: control._formState.errors,
                        });
                    }
                });
            }
            else {
                const field = get(control._fields, name);
                const validationModeBeforeSubmit = getValidationModes(control._options.mode);
                if ((!validationModeBeforeSubmit.isOnSubmit ||
                    control._formState.isSubmitted) &&
                    field &&
                    field._f) {
                    validateField(field, get(control._formValues, name), control._options.criteriaMode === VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error) => !isEmptyObject(error) &&
                        control._subjects.state.next({
                            errors: updateFieldArrayRootError(control._formState.errors, error, name),
                        }));
                }
            }
        }
        control._subjects.watch.next({
            name,
            values: control._formValues,
        });
        control._names.focus &&
            focusFieldBy(control._fields, (key) => key.startsWith(control._names.focus));
        control._names.focus = '';
        control._proxyFormState.isValid && control._updateValid();
    }, [fields, name, control]);
    React.useEffect(() => {
        !get(control._formValues, name) && control._updateFieldArray(name);
        return () => {
            (control._options.shouldUnregister || shouldUnregister) &&
                control.unregister(name);
        };
    }, [name, control, keyName, shouldUnregister]);
    return {
        swap: React.useCallback(swap, [updateValues, name, control]),
        move: React.useCallback(move, [updateValues, name, control]),
        prepend: React.useCallback(prepend$1, [updateValues, name, control]),
        append: React.useCallback(append$1, [updateValues, name, control]),
        remove: React.useCallback(remove, [updateValues, name, control]),
        insert: React.useCallback(insert$1, [updateValues, name, control]),
        update: React.useCallback(update, [updateValues, name, control]),
        replace: React.useCallback(replace, [updateValues, name, control]),
        fields: React.useMemo(() => fields.map((field, index) => ({
            ...field,
            [keyName]: ids.current[index] || generateId(),
        })), [fields, keyName]),
    };
}

function createSubject() {
    let _observers = [];
    const next = (value) => {
        for (const observer of _observers) {
            observer.next(value);
        }
    };
    const subscribe = (observer) => {
        _observers.push(observer);
        return {
            unsubscribe: () => {
                _observers = _observers.filter((o) => o !== observer);
            },
        };
    };
    const unsubscribe = () => {
        _observers = [];
    };
    return {
        get observers() {
            return _observers;
        },
        next,
        subscribe,
        unsubscribe,
    };
}

var isPrimitive = (value) => isNullOrUndefined(value) || !isObjectType(value);

function deepEqual(object1, object2) {
    if (isPrimitive(object1) || isPrimitive(object2)) {
        return object1 === object2;
    }
    if (isDateObject(object1) && isDateObject(object2)) {
        return object1.getTime() === object2.getTime();
    }
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (const key of keys1) {
        const val1 = object1[key];
        if (!keys2.includes(key)) {
            return false;
        }
        if (key !== 'ref') {
            const val2 = object2[key];
            if ((isDateObject(val1) && isDateObject(val2)) ||
                (isObject(val1) && isObject(val2)) ||
                (Array.isArray(val1) && Array.isArray(val2))
                ? !deepEqual(val1, val2)
                : val1 !== val2) {
                return false;
            }
        }
    }
    return true;
}

var isHTMLElement = (value) => {
    const owner = value ? value.ownerDocument : 0;
    const ElementClass = owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement;
    return value instanceof ElementClass;
};

var isMultipleSelect = (element) => element.type === `select-multiple`;

var isRadioOrCheckbox = (ref) => isRadioInput(ref) || isCheckBoxInput(ref);

var live = (ref) => isHTMLElement(ref) && ref.isConnected;

function markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject(data[key]) && !objectHasFunction(data[key]))) {
                fields[key] = Array.isArray(data[key]) ? [] : {};
                markFieldsDirty(data[key], fields[key]);
            }
            else if (!isNullOrUndefined(data[key])) {
                fields[key] = true;
            }
        }
    }
    return fields;
}
function getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject(data[key]) && !objectHasFunction(data[key]))) {
                if (isUndefined(formValues) ||
                    isPrimitive(dirtyFieldsFromValues[key])) {
                    dirtyFieldsFromValues[key] = Array.isArray(data[key])
                        ? markFieldsDirty(data[key], [])
                        : { ...markFieldsDirty(data[key]) };
                }
                else {
                    getDirtyFieldsFromDefaultValues(data[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
                }
            }
            else {
                dirtyFieldsFromValues[key] = !deepEqual(data[key], formValues[key]);
            }
        }
    }
    return dirtyFieldsFromValues;
}
var getDirtyFields = (defaultValues, formValues) => getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));

var getFieldValueAs = (value, { valueAsNumber, valueAsDate, setValueAs }) => isUndefined(value)
    ? value
    : valueAsNumber
        ? value === '' || isNullOrUndefined(value)
            ? NaN
            : +value
        : valueAsDate && isString(value)
            ? new Date(value)
            : setValueAs
                ? setValueAs(value)
                : value;

function getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref) => ref.disabled) : ref.disabled) {
        return;
    }
    if (isFileInput(ref)) {
        return ref.files;
    }
    if (isRadioInput(ref)) {
        return getRadioValue(_f.refs).value;
    }
    if (isMultipleSelect(ref)) {
        return [...ref.selectedOptions].map(({ value }) => value);
    }
    if (isCheckBoxInput(ref)) {
        return getCheckboxValue(_f.refs).value;
    }
    return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}

var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) => {
    const fields = {};
    for (const name of fieldsNames) {
        const field = get(_fields, name);
        field && set(fields, name, field._f);
    }
    return {
        criteriaMode,
        names: [...fieldsNames],
        fields,
        shouldUseNativeValidation,
    };
};

var getRuleValue = (rule) => isUndefined(rule)
    ? undefined
    : isRegex(rule)
        ? rule.source
        : isObject(rule)
            ? isRegex(rule.value)
                ? rule.value.source
                : rule.value
            : rule;

var hasValidation = (options) => options.mount &&
    (options.required ||
        options.min ||
        options.max ||
        options.maxLength ||
        options.minLength ||
        options.pattern ||
        options.validate);

function schemaErrorLookup(errors, _fields, name) {
    const error = get(errors, name);
    if (error || isKey(name)) {
        return {
            error,
            name,
        };
    }
    const names = name.split('.');
    while (names.length) {
        const fieldName = names.join('.');
        const field = get(_fields, fieldName);
        const foundError = get(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) {
            return { name };
        }
        if (foundError && foundError.type) {
            return {
                name: fieldName,
                error: foundError,
            };
        }
        names.pop();
    }
    return {
        name,
    };
}

var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) => {
    if (mode.isOnAll) {
        return false;
    }
    else if (!isSubmitted && mode.isOnTouch) {
        return !(isTouched || isBlurEvent);
    }
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
        return !isBlurEvent;
    }
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
        return isBlurEvent;
    }
    return true;
};

var unsetEmptyArray = (ref, name) => !compact(get(ref, name)).length && unset(ref, name);

const defaultOptions = {
    mode: VALIDATION_MODE.onSubmit,
    reValidateMode: VALIDATION_MODE.onChange,
    shouldFocusError: true,
};
function createFormControl(props = {}) {
    let _options = {
        ...defaultOptions,
        ...props,
    };
    let _formState = {
        isDirty: false,
        isValidating: false,
        dirtyFields: {},
        isSubmitted: false,
        submitCount: 0,
        touchedFields: {},
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        errors: {},
    };
    let _fields = {};
    let _defaultValues = cloneObject(_options.defaultValues) || {};
    let _formValues = _options.shouldUnregister
        ? {}
        : cloneObject(_defaultValues);
    let _stateFlags = {
        action: false,
        mount: false,
        watch: false,
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set(),
    };
    let delayErrorCallback;
    let timer = 0;
    let validateFields = {};
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    };
    const _subjects = {
        watch: createSubject(),
        array: createSubject(),
        state: createSubject(),
    };
    const validationModeBeforeSubmit = getValidationModes(_options.mode);
    const validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
    const debounce = (callback) => (wait) => {
        clearTimeout(timer);
        timer = window.setTimeout(callback, wait);
    };
    const _updateValid = async (shouldSkipRender) => {
        let isValid = false;
        if (_proxyFormState.isValid) {
            isValid = _options.resolver
                ? isEmptyObject((await _executeSchema()).errors)
                : await executeBuiltInValidation(_fields, true);
            if (!shouldSkipRender && isValid !== _formState.isValid) {
                _formState.isValid = isValid;
                _subjects.state.next({
                    isValid,
                });
            }
        }
        return isValid;
    };
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true) => {
        if (args && method) {
            _stateFlags.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray(get(_fields, name))) {
                const fieldValues = method(get(_fields, name), args.argA, args.argB);
                shouldSetValues && set(_fields, name, fieldValues);
            }
            if (_proxyFormState.errors &&
                shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.errors, name))) {
                const errors = method(get(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && set(_formState.errors, name, errors);
                unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields &&
                shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.touchedFields, name))) {
                const touchedFields = method(get(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && set(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) {
                _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
            }
            _subjects.state.next({
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid,
            });
        }
        else {
            set(_formValues, name, values);
        }
    };
    const updateErrors = (name, error) => {
        set(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors,
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value, ref) => {
        const field = get(_fields, name);
        if (field) {
            const defaultValue = get(_formValues, name, isUndefined(value) ? get(_defaultValues, name) : value);
            isUndefined(defaultValue) ||
                (ref && ref.defaultChecked) ||
                shouldSkipSetValueAs
                ? set(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f))
                : setFieldValue(name, defaultValue);
            _stateFlags.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender) => {
        let isFieldDirty = false;
        const output = {
            name,
        };
        const isPreviousFieldTouched = get(_formState.touchedFields, name);
        if (_proxyFormState.isDirty) {
            const isPreviousFormDirty = _formState.isDirty;
            _formState.isDirty = output.isDirty = _getDirty();
            isFieldDirty = isPreviousFormDirty !== output.isDirty;
        }
        if (_proxyFormState.dirtyFields && (!isBlurEvent || shouldDirty)) {
            const isPreviousFieldDirty = get(_formState.dirtyFields, name);
            const isCurrentFieldPristine = deepEqual(get(_defaultValues, name), fieldValue);
            isCurrentFieldPristine
                ? unset(_formState.dirtyFields, name)
                : set(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            isFieldDirty =
                isFieldDirty ||
                    isPreviousFieldDirty !== get(_formState.dirtyFields, name);
        }
        if (isBlurEvent && !isPreviousFieldTouched) {
            set(_formState.touchedFields, name, isBlurEvent);
            output.touchedFields = _formState.touchedFields;
            isFieldDirty =
                isFieldDirty ||
                    (_proxyFormState.touchedFields &&
                        isPreviousFieldTouched !== isBlurEvent);
        }
        isFieldDirty && shouldRender && _subjects.state.next(output);
        return isFieldDirty ? output : {};
    };
    const shouldRenderByError = async (name, isValid, error, fieldState) => {
        const previousFieldError = get(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(() => updateErrors(name, error));
            delayErrorCallback(props.delayError);
        }
        else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error
                ? set(_formState.errors, name, error)
                : unset(_formState.errors, name);
        }
        if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) ||
            !isEmptyObject(fieldState) ||
            shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...(shouldUpdateValid ? { isValid } : {}),
                errors: _formState.errors,
                name,
            };
            _formState = {
                ..._formState,
                ...updatedFormState,
            };
            _subjects.state.next(updatedFormState);
        }
        validateFields[name]--;
        if (_proxyFormState.isValidating &&
            !Object.values(validateFields).some((v) => v)) {
            _subjects.state.next({
                isValidating: false,
            });
            validateFields = {};
        }
    };
    const _executeSchema = async (name) => _options.resolver
        ? await _options.resolver({ ..._formValues }, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation))
        : {};
    const executeSchemaAndUpdateState = async (names) => {
        const { errors } = await _executeSchema();
        if (names) {
            for (const name of names) {
                const error = get(errors, name);
                error
                    ? set(_formState.errors, name, error)
                    : unset(_formState.errors, name);
            }
        }
        else {
            _formState.errors = errors;
        }
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true,
    }) => {
        for (const name in fields) {
            const field = fields[name];
            if (field) {
                const { _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const fieldError = await validateField(field, get(_formValues, _f.name), shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation, isFieldArrayRoot);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) {
                            break;
                        }
                    }
                    !shouldOnlyCheckValid &&
                        (get(fieldError, _f.name)
                            ? isFieldArrayRoot
                                ? updateFieldArrayRootError(_formState.errors, fieldError, _f.name)
                                : set(_formState.errors, _f.name, fieldError[_f.name])
                            : unset(_formState.errors, _f.name));
                }
                fieldValue &&
                    (await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context));
            }
        }
        return context.valid;
    };
    const _removeUnmounted = () => {
        for (const name of _names.unMount) {
            const field = get(_fields, name);
            field &&
                (field._f.refs
                    ? field._f.refs.every((ref) => !live(ref))
                    : !live(field._f.ref)) &&
                unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data) => (name && data && set(_formValues, name, data),
        !deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal) => {
        const fieldValues = {
            ...(_stateFlags.mount
                ? _formValues
                : isUndefined(defaultValue)
                    ? _defaultValues
                    : isString(names)
                        ? { [names]: defaultValue }
                        : defaultValue),
        };
        return generateWatchOutput(names, _names, fieldValues, isGlobal);
    };
    const _getFieldArray = (name) => compact(get(_stateFlags.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? get(_defaultValues, name, []) : []));
    const setFieldValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        let fieldValue = value;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled &&
                    set(_formValues, name, getFieldValueAs(value, fieldReference));
                fieldValue =
                    isWeb && isHTMLElement(fieldReference.ref) && isNullOrUndefined(value)
                        ? ''
                        : value;
                if (isMultipleSelect(fieldReference.ref)) {
                    [...fieldReference.ref.options].forEach((selectRef) => (selectRef.selected = fieldValue.includes(selectRef.value)));
                }
                else if (fieldReference.refs) {
                    if (isCheckBoxInput(fieldReference.ref)) {
                        fieldReference.refs.length > 1
                            ? fieldReference.refs.forEach((checkboxRef) => !checkboxRef.disabled &&
                                (checkboxRef.checked = Array.isArray(fieldValue)
                                    ? !!fieldValue.find((data) => data === checkboxRef.value)
                                    : fieldValue === checkboxRef.value))
                            : fieldReference.refs[0] &&
                                (fieldReference.refs[0].checked = !!fieldValue);
                    }
                    else {
                        fieldReference.refs.forEach((radioRef) => (radioRef.checked = radioRef.value === fieldValue));
                    }
                }
                else if (isFileInput(fieldReference.ref)) {
                    fieldReference.ref.value = '';
                }
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) {
                        _subjects.watch.next({
                            name,
                        });
                    }
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) &&
            updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value, options) => {
        for (const fieldKey in value) {
            const fieldValue = value[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = get(_fields, fieldName);
            (_names.array.has(name) ||
                !isPrimitive(fieldValue) ||
                (field && !field._f)) &&
                !isDateObject(fieldValue)
                ? setValues(fieldName, fieldValue, options)
                : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = cloneObject(value);
        set(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name,
                values: _formValues,
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) &&
                options.shouldDirty) {
                _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
                _subjects.state.next({
                    name,
                    dirtyFields: _formState.dirtyFields,
                    isDirty: _getDirty(name, cloneValue),
                });
            }
        }
        else {
            field && !field._f && !isNullOrUndefined(cloneValue)
                ? setValues(name, cloneValue, options)
                : setFieldValue(name, cloneValue, options);
        }
        isWatched(name, _names) && _subjects.state.next({});
        _subjects.watch.next({
            name,
        });
    };
    const onChange = async (event) => {
        const target = event.target;
        let name = target.name;
        const field = get(_fields, name);
        if (field) {
            let error;
            let isValid;
            const fieldValue = target.type
                ? getFieldValue(field._f)
                : getEventValue(event);
            const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
            const shouldSkipValidation = (!hasValidation(field._f) &&
                !_options.resolver &&
                !get(_formState.errors, name) &&
                !field._f.deps) ||
                skipValidation(isBlurEvent, get(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = isWatched(name, _names, isBlurEvent);
            set(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            }
            else if (field._f.onChange) {
                field._f.onChange(event);
            }
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !isEmptyObject(fieldState) || watched;
            !isBlurEvent &&
                _subjects.watch.next({
                    name,
                    type: event.type,
                });
            if (shouldSkipValidation) {
                return (shouldRender &&
                    _subjects.state.next({ name, ...(watched ? {} : fieldState) }));
            }
            !isBlurEvent && watched && _subjects.state.next({});
            validateFields[name] = validateFields[name] ? +1 : 1;
            _subjects.state.next({
                isValidating: true,
            });
            if (_options.resolver) {
                const { errors } = await _executeSchema([name]);
                const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
                const errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                error = errorLookupResult.error;
                name = errorLookupResult.name;
                isValid = isEmptyObject(errors);
            }
            else {
                error = (await validateField(field, get(_formValues, name), shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                isValid = await _updateValid(true);
            }
            field._f.deps &&
                trigger(field._f.deps);
            shouldRenderByError(name, isValid, error, fieldState);
        }
    };
    const trigger = async (name, options = {}) => {
        let isValid;
        let validationResult;
        const fieldNames = convertToArrayPayload(name);
        _subjects.state.next({
            isValidating: true,
        });
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState(isUndefined(name) ? name : fieldNames);
            isValid = isEmptyObject(errors);
            validationResult = name
                ? !fieldNames.some((name) => get(errors, name))
                : isValid;
        }
        else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName) => {
                const field = get(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? { [fieldName]: field } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        }
        else {
            validationResult = isValid = await executeBuiltInValidation(_fields);
        }
        _subjects.state.next({
            ...(!isString(name) ||
                (_proxyFormState.isValid && isValid !== _formState.isValid)
                ? {}
                : { name }),
            ...(_options.resolver ? { isValid } : {}),
            errors: _formState.errors,
            isValidating: false,
        });
        options.shouldFocus &&
            !validationResult &&
            focusFieldBy(_fields, (key) => get(_formState.errors, key), name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames) => {
        const values = {
            ..._defaultValues,
            ...(_stateFlags.mount ? _formValues : {}),
        };
        return isUndefined(fieldNames)
            ? values
            : isString(fieldNames)
                ? get(values, fieldNames)
                : fieldNames.map((name) => get(values, name));
    };
    const getFieldState = (name, formState) => ({
        invalid: !!get((formState || _formState).errors, name),
        isDirty: !!get((formState || _formState).dirtyFields, name),
        isTouched: !!get((formState || _formState).touchedFields, name),
        error: get((formState || _formState).errors, name),
    });
    const clearErrors = (name) => {
        name
            ? convertToArrayPayload(name).forEach((inputName) => unset(_formState.errors, inputName))
            : (_formState.errors = {});
        _subjects.state.next({
            errors: _formState.errors,
        });
    };
    const setError = (name, error, options) => {
        const ref = (get(_fields, name, { _f: {} })._f || {}).ref;
        set(_formState.errors, name, {
            ...error,
            ref,
        });
        _subjects.state.next({
            name,
            errors: _formState.errors,
            isValid: false,
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue) => isFunction(name)
        ? _subjects.watch.subscribe({
            next: (info) => name(_getWatch(undefined, defaultValue), info),
        })
        : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {}) => {
        for (const fieldName of name ? convertToArrayPayload(name) : _names.mount) {
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (get(_fields, fieldName)) {
                if (!options.keepValue) {
                    unset(_fields, fieldName);
                    unset(_formValues, fieldName);
                }
                !options.keepError && unset(_formState.errors, fieldName);
                !options.keepDirty && unset(_formState.dirtyFields, fieldName);
                !options.keepTouched && unset(_formState.touchedFields, fieldName);
                !_options.shouldUnregister &&
                    !options.keepDefaultValue &&
                    unset(_defaultValues, fieldName);
            }
        }
        _subjects.watch.next({});
        _subjects.state.next({
            ..._formState,
            ...(!options.keepDirty ? {} : { isDirty: _getDirty() }),
        });
        !options.keepIsValid && _updateValid();
    };
    const register = (name, options = {}) => {
        let field = get(_fields, name);
        const disabledIsDefined = isBoolean(options.disabled);
        set(_fields, name, {
            _f: {
                ...(field && field._f ? field._f : { ref: { name } }),
                name,
                mount: true,
                ...options,
            },
        });
        _names.mount.add(name);
        field
            ? disabledIsDefined &&
                set(_formValues, name, options.disabled
                    ? undefined
                    : get(_formValues, name, getFieldValue(field._f)))
            : updateValidAndValue(name, true, options.value);
        return {
            ...(disabledIsDefined ? { disabled: options.disabled } : {}),
            ...(_options.shouldUseNativeValidation
                ? {
                    required: !!options.required,
                    min: getRuleValue(options.min),
                    max: getRuleValue(options.max),
                    minLength: getRuleValue(options.minLength),
                    maxLength: getRuleValue(options.maxLength),
                    pattern: getRuleValue(options.pattern),
                }
                : {}),
            name,
            onChange,
            onBlur: onChange,
            ref: (ref) => {
                if (ref) {
                    register(name, options);
                    field = get(_fields, name);
                    const fieldRef = isUndefined(ref.value)
                        ? ref.querySelectorAll
                            ? ref.querySelectorAll('input,select,textarea')[0] || ref
                            : ref
                        : ref;
                    const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox
                        ? refs.find((option) => option === fieldRef)
                        : fieldRef === field._f.ref) {
                        return;
                    }
                    set(_fields, name, {
                        _f: {
                            ...field._f,
                            ...(radioOrCheckbox
                                ? {
                                    refs: [
                                        ...refs.filter(live),
                                        fieldRef,
                                        ...(!!Array.isArray(get(_defaultValues, name))
                                            ? [{}]
                                            : []),
                                    ],
                                    ref: { type: fieldRef.type, name },
                                }
                                : { ref: fieldRef }),
                        },
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                }
                else {
                    field = get(_fields, name, {});
                    if (field._f) {
                        field._f.mount = false;
                    }
                    (_options.shouldUnregister || options.shouldUnregister) &&
                        !(isNameInFieldArray(_names.array, name) && _stateFlags.action) &&
                        _names.unMount.add(name);
                }
            },
        };
    };
    const handleSubmit = (onValid, onInvalid) => async (e) => {
        if (e) {
            e.preventDefault && e.preventDefault();
            e.persist && e.persist();
        }
        let hasNoPromiseError = true;
        let fieldValues = cloneObject(_formValues);
        _subjects.state.next({
            isSubmitting: true,
        });
        try {
            if (_options.resolver) {
                const { errors, values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            }
            else {
                await executeBuiltInValidation(_fields);
            }
            if (isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {},
                    isSubmitting: true,
                });
                await onValid(fieldValues, e);
            }
            else {
                if (onInvalid) {
                    await onInvalid({ ..._formState.errors }, e);
                }
                _options.shouldFocusError &&
                    focusFieldBy(_fields, (key) => get(_formState.errors, key), _names.mount);
            }
        }
        catch (err) {
            hasNoPromiseError = false;
            throw err;
        }
        finally {
            _formState.isSubmitted = true;
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: isEmptyObject(_formState.errors) && hasNoPromiseError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors,
            });
        }
    };
    const resetField = (name, options = {}) => {
        if (get(_fields, name)) {
            if (isUndefined(options.defaultValue)) {
                setValue(name, get(_defaultValues, name));
            }
            else {
                setValue(name, options.defaultValue);
                set(_defaultValues, name, options.defaultValue);
            }
            if (!options.keepTouched) {
                unset(_formState.touchedFields, name);
            }
            if (!options.keepDirty) {
                unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue
                    ? _getDirty(name, get(_defaultValues, name))
                    : _getDirty();
            }
            if (!options.keepError) {
                unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({ ..._formState });
        }
    };
    const reset = (formValues, keepStateOptions = {}) => {
        const updatedValues = formValues || _defaultValues;
        const cloneUpdatedValues = cloneObject(updatedValues);
        const values = formValues && !isEmptyObject(formValues)
            ? cloneUpdatedValues
            : _defaultValues;
        if (!keepStateOptions.keepDefaultValues) {
            _defaultValues = updatedValues;
        }
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                for (const fieldName of _names.mount) {
                    get(_formState.dirtyFields, fieldName)
                        ? set(values, fieldName, get(_formValues, fieldName))
                        : setValue(fieldName, get(values, fieldName));
                }
            }
            else {
                if (isWeb && isUndefined(formValues)) {
                    for (const name of _names.mount) {
                        const field = get(_fields, name);
                        if (field && field._f) {
                            const fieldReference = Array.isArray(field._f.refs)
                                ? field._f.refs[0]
                                : field._f.ref;
                            try {
                                if (isHTMLElement(fieldReference)) {
                                    fieldReference.closest('form').reset();
                                    break;
                                }
                            }
                            catch (_a) { }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister
                ? keepStateOptions.keepDefaultValues
                    ? cloneObject(_defaultValues)
                    : {}
                : cloneUpdatedValues;
            _subjects.array.next({
                values,
            });
            _subjects.watch.next({
                values,
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: '',
        };
        _stateFlags.mount =
            !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
        _stateFlags.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount
                ? _formState.submitCount
                : 0,
            isDirty: keepStateOptions.keepDirty || keepStateOptions.keepDirtyValues
                ? _formState.isDirty
                : !!(keepStateOptions.keepDefaultValues &&
                    !deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted
                ? _formState.isSubmitted
                : false,
            dirtyFields: keepStateOptions.keepDirty || keepStateOptions.keepDirtyValues
                ? _formState.dirtyFields
                : keepStateOptions.keepDefaultValues && formValues
                    ? getDirtyFields(_defaultValues, formValues)
                    : {},
            touchedFields: keepStateOptions.keepTouched
                ? _formState.touchedFields
                : {},
            errors: keepStateOptions.keepErrors
                ? _formState.errors
                : {},
            isSubmitting: false,
            isSubmitSuccessful: false,
        });
    };
    const setFocus = (name, options = {}) => {
        const field = get(_fields, name)._f;
        const fieldRef = field.refs ? field.refs[0] : field.ref;
        fieldRef.focus();
        options.shouldSelect && fieldRef.select();
    };
    return {
        control: {
            register,
            unregister,
            getFieldState,
            _executeSchema,
            _getWatch,
            _getDirty,
            _updateValid,
            _removeUnmounted,
            _updateFieldArray,
            _getFieldArray,
            _subjects,
            _proxyFormState,
            get _fields() {
                return _fields;
            },
            get _formValues() {
                return _formValues;
            },
            get _stateFlags() {
                return _stateFlags;
            },
            set _stateFlags(value) {
                _stateFlags = value;
            },
            get _defaultValues() {
                return _defaultValues;
            },
            get _names() {
                return _names;
            },
            set _names(value) {
                _names = value;
            },
            get _formState() {
                return _formState;
            },
            set _formState(value) {
                _formState = value;
            },
            get _options() {
                return _options;
            },
            set _options(value) {
                _options = {
                    ..._options,
                    ...value,
                };
            },
        },
        trigger,
        register,
        handleSubmit,
        watch,
        setValue,
        getValues,
        reset,
        resetField,
        clearErrors,
        unregister,
        setError,
        setFocus,
        getFieldState,
    };
}

/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useForm(props = {}) {
    const _formControl = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
    const [formState, updateFormState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
        isDirty: false,
        isValidating: false,
        dirtyFields: {},
        isSubmitted: false,
        submitCount: 0,
        touchedFields: {},
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        errors: {},
    });
    if (_formControl.current) {
        _formControl.current.control._options = props;
    }
    else {
        _formControl.current = {
            ...createFormControl(props),
            formState,
        };
    }
    const control = _formControl.current.control;
    const callback = react__WEBPACK_IMPORTED_MODULE_0__.useCallback((value) => {
        if (shouldRenderFormState(value, control._proxyFormState, true)) {
            control._formState = {
                ...control._formState,
                ...value,
            };
            updateFormState({ ...control._formState });
        }
    }, [control]);
    useSubscribe({
        subject: control._subjects.state,
        callback,
    });
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        if (!control._stateFlags.mount) {
            control._proxyFormState.isValid && control._updateValid();
            control._stateFlags.mount = true;
        }
        if (control._stateFlags.watch) {
            control._stateFlags.watch = false;
            control._subjects.state.next({});
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = getProxyFormState(formState, control._proxyFormState);
    return _formControl.current;
}


//# sourceMappingURL=index.esm.mjs.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,179], function() { return __webpack_exec__(49484), __webpack_exec__(98832), __webpack_exec__(81780), __webpack_exec__(90387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);